import { j as We } from "./jsx-runtime-DmTjM30f.js";
import bT, { useRef as wT, useState as Zi, useEffect as Gc, useCallback as kw, Fragment as AT, useContext as xT } from "react";
import { g as I0, U as qg, u as Jf, _ as $r, o as Vc, W as ET, X as xl, Y as _T, Z as Sw, $ as DT, a as TT, D as kT, d as ST, S as CT, c as Jl, F as FT, B as T2, M as OT, b as Xg } from "./index.esm-G8KyR0tM.js";
import { u as RT } from "./useConfiguration-B-lyaBB9.js";
import { r as IT, F as PT } from "./provider-Diwup2pn.js";
import { j as gh, m as Qf, k as Cw, n as Fw, C as Vu, i as BT } from "./utils-D5LKKDAj.js";
import { c as NT } from "./core-BIzkQuc8.js";
import { r as W5 } from "./sentry-CAR5o4wv.js";
import { i as _n } from "./index-wI714H_N.js";
import { ErrorPage as LT } from "./ErrorPage.js";
import { F as Kg } from "./FolioListing-CxYnvVWM.js";
function MT(r, e) {
  for (var t = 0; t < e.length; t++) {
    const n = e[t];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in r)) {
          const a = Object.getOwnPropertyDescriptor(n, i);
          a && Object.defineProperty(r, i, a.get ? a : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }));
}
const Ow = "G", ts = "SVG", Yt = "VIEW", Gt = "TEXT", Pd = "LINK", Bd = "PAGE", Nd = "NOTE", ov = "PATH", sv = "RECT", uv = "LINE", UT = "STOP", lv = "DEFS", cu = "IMAGE", cv = "TSPAN", Ld = "CANVAS", fv = "CIRCLE", hv = "ELLIPSE", dv = "POLYGON", pv = "DOCUMENT", vv = "POLYLINE", $T = "CLIP_PATH", fu = "TEXT_INSTANCE", Rw = "LINEAR_GRADIENT", Iw = "RADIAL_GRADIENT", zT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Canvas: Ld,
  Circle: fv,
  ClipPath: $T,
  Defs: lv,
  Document: pv,
  Ellipse: hv,
  G: Ow,
  Image: cu,
  Line: uv,
  LinearGradient: Rw,
  Link: Pd,
  Note: Nd,
  Page: Bd,
  Path: ov,
  Polygon: dv,
  Polyline: vv,
  RadialGradient: Iw,
  Rect: sv,
  Stop: UT,
  Svg: ts,
  Text: Gt,
  TextInstance: fu,
  Tspan: cv,
  View: Yt
}, Symbol.toStringTag, { value: "Module" }));
var gv = { exports: {} }, V4 = { exports: {} };
typeof Object.create == "function" ? V4.exports = function(e, t) {
  t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : V4.exports = function(e, t) {
  if (t) {
    e.super_ = t;
    var n = function() {
    };
    n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
var jT = V4.exports, mv = { exports: {} }, Tc = typeof Reflect == "object" ? Reflect : null, Jg = Tc && typeof Tc.apply == "function" ? Tc.apply : function(e, t, n) {
  return Function.prototype.apply.call(e, t, n);
}, mh;
Tc && typeof Tc.ownKeys == "function" ? mh = Tc.ownKeys : Object.getOwnPropertySymbols ? mh = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : mh = function(e) {
  return Object.getOwnPropertyNames(e);
};
function WT(r) {
  console && console.warn && console.warn(r);
}
var Pw = Number.isNaN || function(e) {
  return e !== e;
};
function Kr() {
  Kr.init.call(this);
}
mv.exports = Kr;
mv.exports.once = HT;
Kr.EventEmitter = Kr;
Kr.prototype._events = void 0;
Kr.prototype._eventsCount = 0;
Kr.prototype._maxListeners = void 0;
var Qg = 10;
function Md(r) {
  if (typeof r != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
}
Object.defineProperty(Kr, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Qg;
  },
  set: function(r) {
    if (typeof r != "number" || r < 0 || Pw(r))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + r + ".");
    Qg = r;
  }
});
Kr.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Kr.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || Pw(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function Bw(r) {
  return r._maxListeners === void 0 ? Kr.defaultMaxListeners : r._maxListeners;
}
Kr.prototype.getMaxListeners = function() {
  return Bw(this);
};
Kr.prototype.emit = function(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
  var i = e === "error", a = this._events;
  if (a !== void 0)
    i = i && a.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var o;
    if (t.length > 0 && (o = t[0]), o instanceof Error)
      throw o;
    var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw s.context = o, s;
  }
  var c = a[e];
  if (c === void 0)
    return !1;
  if (typeof c == "function")
    Jg(c, this, t);
  else
    for (var h = c.length, d = $w(c, h), n = 0; n < h; ++n)
      Jg(d[n], this, t);
  return !0;
};
function Nw(r, e, t, n) {
  var i, a, o;
  if (Md(t), a = r._events, a === void 0 ? (a = r._events = /* @__PURE__ */ Object.create(null), r._eventsCount = 0) : (a.newListener !== void 0 && (r.emit(
    "newListener",
    e,
    t.listener ? t.listener : t
  ), a = r._events), o = a[e]), o === void 0)
    o = a[e] = t, ++r._eventsCount;
  else if (typeof o == "function" ? o = a[e] = n ? [t, o] : [o, t] : n ? o.unshift(t) : o.push(t), i = Bw(r), i > 0 && o.length > i && !o.warned) {
    o.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = r, s.type = e, s.count = o.length, WT(s);
  }
  return r;
}
Kr.prototype.addListener = function(e, t) {
  return Nw(this, e, t, !1);
};
Kr.prototype.on = Kr.prototype.addListener;
Kr.prototype.prependListener = function(e, t) {
  return Nw(this, e, t, !0);
};
function GT() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Lw(r, e, t) {
  var n = { fired: !1, wrapFn: void 0, target: r, type: e, listener: t }, i = GT.bind(n);
  return i.listener = t, n.wrapFn = i, i;
}
Kr.prototype.once = function(e, t) {
  return Md(t), this.on(e, Lw(this, e, t)), this;
};
Kr.prototype.prependOnceListener = function(e, t) {
  return Md(t), this.prependListener(e, Lw(this, e, t)), this;
};
Kr.prototype.removeListener = function(e, t) {
  var n, i, a, o, s;
  if (Md(t), i = this._events, i === void 0)
    return this;
  if (n = i[e], n === void 0)
    return this;
  if (n === t || n.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || t));
  else if (typeof n != "function") {
    for (a = -1, o = n.length - 1; o >= 0; o--)
      if (n[o] === t || n[o].listener === t) {
        s = n[o].listener, a = o;
        break;
      }
    if (a < 0)
      return this;
    a === 0 ? n.shift() : VT(n, a), n.length === 1 && (i[e] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", e, s || t);
  }
  return this;
};
Kr.prototype.off = Kr.prototype.removeListener;
Kr.prototype.removeAllListeners = function(e) {
  var t, n, i;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var a = Object.keys(n), o;
    for (i = 0; i < a.length; ++i)
      o = a[i], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = n[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (i = t.length - 1; i >= 0; i--)
      this.removeListener(e, t[i]);
  return this;
};
function Mw(r, e, t) {
  var n = r._events;
  if (n === void 0)
    return [];
  var i = n[e];
  return i === void 0 ? [] : typeof i == "function" ? t ? [i.listener || i] : [i] : t ? YT(i) : $w(i, i.length);
}
Kr.prototype.listeners = function(e) {
  return Mw(this, e, !0);
};
Kr.prototype.rawListeners = function(e) {
  return Mw(this, e, !1);
};
Kr.listenerCount = function(r, e) {
  return typeof r.listenerCount == "function" ? r.listenerCount(e) : Uw.call(r, e);
};
Kr.prototype.listenerCount = Uw;
function Uw(r) {
  var e = this._events;
  if (e !== void 0) {
    var t = e[r];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
Kr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? mh(this._events) : [];
};
function $w(r, e) {
  for (var t = new Array(e), n = 0; n < e; ++n)
    t[n] = r[n];
  return t;
}
function VT(r, e) {
  for (; e + 1 < r.length; e++)
    r[e] = r[e + 1];
  r.pop();
}
function YT(r) {
  for (var e = new Array(r.length), t = 0; t < e.length; ++t)
    e[t] = r[t].listener || r[t];
  return e;
}
function HT(r, e) {
  return new Promise(function(t, n) {
    function i(o) {
      r.removeListener(e, a), n(o);
    }
    function a() {
      typeof r.removeListener == "function" && r.removeListener("error", i), t([].slice.call(arguments));
    }
    zw(r, e, a, { once: !0 }), e !== "error" && ZT(r, i, { once: !0 });
  });
}
function ZT(r, e, t) {
  typeof r.on == "function" && zw(r, "error", e, t);
}
function zw(r, e, t, n) {
  if (typeof r.on == "function")
    n.once ? r.once(e, t) : r.on(e, t);
  else if (typeof r.addEventListener == "function")
    r.addEventListener(e, function i(a) {
      n.once && r.removeEventListener(e, i), t(a);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof r);
}
var qT = mv.exports, XT = jT, jw = qT.EventEmitter;
gv.exports = Oi;
gv.exports.default = Oi;
function Oi(r) {
  if (!(this instanceof Oi))
    return new Oi(r);
  jw.call(this), r = r || {}, this.concurrency = r.concurrency || 1 / 0, this.timeout = r.timeout || 0, this.autostart = r.autostart || !1, this.results = r.results || null, this.pending = 0, this.session = 0, this.running = !1, this.jobs = [], this.timers = {};
}
XT(Oi, jw);
var KT = [
  "pop",
  "shift",
  "indexOf",
  "lastIndexOf"
];
KT.forEach(function(r) {
  Oi.prototype[r] = function() {
    return Array.prototype[r].apply(this.jobs, arguments);
  };
});
Oi.prototype.slice = function(r, e) {
  return this.jobs = this.jobs.slice(r, e), this;
};
Oi.prototype.reverse = function() {
  return this.jobs.reverse(), this;
};
var JT = [
  "push",
  "unshift",
  "splice"
];
JT.forEach(function(r) {
  Oi.prototype[r] = function() {
    var e = Array.prototype[r].apply(this.jobs, arguments);
    return this.autostart && this.start(), e;
  };
});
Object.defineProperty(Oi.prototype, "length", {
  get: function() {
    return this.pending + this.jobs.length;
  }
});
Oi.prototype.start = function(r) {
  if (r && ek.call(this, r), this.running = !0, this.pending >= this.concurrency)
    return;
  if (this.jobs.length === 0) {
    this.pending === 0 && Y4.call(this);
    return;
  }
  var e = this, t = this.jobs.shift(), n = !0, i = this.session, a = null, o = !1, s = null, c = t.hasOwnProperty("timeout") ? t.timeout : this.timeout;
  function h(g, x) {
    n && e.session === i && (n = !1, e.pending--, a !== null && (delete e.timers[a], clearTimeout(a)), g ? e.emit("error", g, t) : o === !1 && (s !== null && (e.results[s] = Array.prototype.slice.call(arguments, 1)), e.emit("success", x, t)), e.session === i && (e.pending === 0 && e.jobs.length === 0 ? Y4.call(e) : e.running && e.start()));
  }
  c && (a = setTimeout(function() {
    o = !0, e.listeners("timeout").length > 0 ? e.emit("timeout", h, t) : h();
  }, c), this.timers[a] = a), this.results && (s = this.results.length, this.results[s] = null), this.pending++, e.emit("start", t);
  var d = t(h);
  d && d.then && typeof d.then == "function" && d.then(function(g) {
    return h(null, g);
  }).catch(function(g) {
    return h(g || !0);
  }), this.running && this.jobs.length > 0 && this.start();
};
Oi.prototype.stop = function() {
  this.running = !1;
};
Oi.prototype.end = function(r) {
  QT.call(this), this.jobs.length = 0, this.pending = 0, Y4.call(this, r);
};
function QT() {
  for (var r in this.timers) {
    var e = this.timers[r];
    delete this.timers[r], clearTimeout(e);
  }
}
function ek(r) {
  var e = this;
  this.on("error", t), this.on("end", n);
  function t(i) {
    e.end(i);
  }
  function n(i) {
    e.removeListener("error", t), e.removeListener("end", n), r(i, this.results);
  }
}
function Y4(r) {
  this.session++, this.running = !1, this.emit("end", r);
}
var tk = gv.exports;
const rk = /* @__PURE__ */ I0(tk);
function qr() {
  qr = function() {
    return e;
  };
  var r, e = {}, t = Object.prototype, n = t.hasOwnProperty, i = Object.defineProperty || function(ne, me, fe) {
    ne[me] = fe.value;
  }, a = typeof Symbol == "function" ? Symbol : {}, o = a.iterator || "@@iterator", s = a.asyncIterator || "@@asyncIterator", c = a.toStringTag || "@@toStringTag";
  function h(ne, me, fe) {
    return Object.defineProperty(ne, me, {
      value: fe,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), ne[me];
  }
  try {
    h({}, "");
  } catch {
    h = function(fe, _e, Re) {
      return fe[_e] = Re;
    };
  }
  function d(ne, me, fe, _e) {
    var Re = me && me.prototype instanceof M ? me : M, Ie = Object.create(Re.prototype), W = new H(_e || []);
    return i(Ie, "_invoke", {
      value: ve(ne, fe, W)
    }), Ie;
  }
  function g(ne, me, fe) {
    try {
      return {
        type: "normal",
        arg: ne.call(me, fe)
      };
    } catch (_e) {
      return {
        type: "throw",
        arg: _e
      };
    }
  }
  e.wrap = d;
  var x = "suspendedStart", _ = "suspendedYield", k = "executing", P = "completed", N = {};
  function M() {
  }
  function G() {
  }
  function z() {
  }
  var j = {};
  h(j, o, function() {
    return this;
  });
  var R = Object.getPrototypeOf, te = R && R(R(oe([])));
  te && te !== t && n.call(te, o) && (j = te);
  var J = z.prototype = M.prototype = Object.create(j);
  function K(ne) {
    ["next", "throw", "return"].forEach(function(me) {
      h(ne, me, function(fe) {
        return this._invoke(me, fe);
      });
    });
  }
  function ee(ne, me) {
    function fe(Re, Ie, W, Z) {
      var se = g(ne[Re], ne, Ie);
      if (se.type !== "throw") {
        var ye = se.arg, Fe = ye.value;
        return Fe && qg(Fe) == "object" && n.call(Fe, "__await") ? me.resolve(Fe.__await).then(function(xe) {
          fe("next", xe, W, Z);
        }, function(xe) {
          fe("throw", xe, W, Z);
        }) : me.resolve(Fe).then(function(xe) {
          ye.value = xe, W(ye);
        }, function(xe) {
          return fe("throw", xe, W, Z);
        });
      }
      Z(se.arg);
    }
    var _e;
    i(this, "_invoke", {
      value: function(Ie, W) {
        function Z() {
          return new me(function(se, ye) {
            fe(Ie, W, se, ye);
          });
        }
        return _e = _e ? _e.then(Z, Z) : Z();
      }
    });
  }
  function ve(ne, me, fe) {
    var _e = x;
    return function(Re, Ie) {
      if (_e === k) throw Error("Generator is already running");
      if (_e === P) {
        if (Re === "throw") throw Ie;
        return {
          value: r,
          done: !0
        };
      }
      for (fe.method = Re, fe.arg = Ie; ; ) {
        var W = fe.delegate;
        if (W) {
          var Z = de(W, fe);
          if (Z) {
            if (Z === N) continue;
            return Z;
          }
        }
        if (fe.method === "next") fe.sent = fe._sent = fe.arg;
        else if (fe.method === "throw") {
          if (_e === x) throw _e = P, fe.arg;
          fe.dispatchException(fe.arg);
        } else fe.method === "return" && fe.abrupt("return", fe.arg);
        _e = k;
        var se = g(ne, me, fe);
        if (se.type === "normal") {
          if (_e = fe.done ? P : _, se.arg === N) continue;
          return {
            value: se.arg,
            done: fe.done
          };
        }
        se.type === "throw" && (_e = P, fe.method = "throw", fe.arg = se.arg);
      }
    };
  }
  function de(ne, me) {
    var fe = me.method, _e = ne.iterator[fe];
    if (_e === r) return me.delegate = null, fe === "throw" && ne.iterator.return && (me.method = "return", me.arg = r, de(ne, me), me.method === "throw") || fe !== "return" && (me.method = "throw", me.arg = new TypeError("The iterator does not provide a '" + fe + "' method")), N;
    var Re = g(_e, ne.iterator, me.arg);
    if (Re.type === "throw") return me.method = "throw", me.arg = Re.arg, me.delegate = null, N;
    var Ie = Re.arg;
    return Ie ? Ie.done ? (me[ne.resultName] = Ie.value, me.next = ne.nextLoc, me.method !== "return" && (me.method = "next", me.arg = r), me.delegate = null, N) : Ie : (me.method = "throw", me.arg = new TypeError("iterator result is not an object"), me.delegate = null, N);
  }
  function B(ne) {
    var me = {
      tryLoc: ne[0]
    };
    1 in ne && (me.catchLoc = ne[1]), 2 in ne && (me.finallyLoc = ne[2], me.afterLoc = ne[3]), this.tryEntries.push(me);
  }
  function q(ne) {
    var me = ne.completion || {};
    me.type = "normal", delete me.arg, ne.completion = me;
  }
  function H(ne) {
    this.tryEntries = [{
      tryLoc: "root"
    }], ne.forEach(B, this), this.reset(!0);
  }
  function oe(ne) {
    if (ne || ne === "") {
      var me = ne[o];
      if (me) return me.call(ne);
      if (typeof ne.next == "function") return ne;
      if (!isNaN(ne.length)) {
        var fe = -1, _e = function Re() {
          for (; ++fe < ne.length; ) if (n.call(ne, fe)) return Re.value = ne[fe], Re.done = !1, Re;
          return Re.value = r, Re.done = !0, Re;
        };
        return _e.next = _e;
      }
    }
    throw new TypeError(qg(ne) + " is not iterable");
  }
  return G.prototype = z, i(J, "constructor", {
    value: z,
    configurable: !0
  }), i(z, "constructor", {
    value: G,
    configurable: !0
  }), G.displayName = h(z, c, "GeneratorFunction"), e.isGeneratorFunction = function(ne) {
    var me = typeof ne == "function" && ne.constructor;
    return !!me && (me === G || (me.displayName || me.name) === "GeneratorFunction");
  }, e.mark = function(ne) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(ne, z) : (ne.__proto__ = z, h(ne, c, "GeneratorFunction")), ne.prototype = Object.create(J), ne;
  }, e.awrap = function(ne) {
    return {
      __await: ne
    };
  }, K(ee.prototype), h(ee.prototype, s, function() {
    return this;
  }), e.AsyncIterator = ee, e.async = function(ne, me, fe, _e, Re) {
    Re === void 0 && (Re = Promise);
    var Ie = new ee(d(ne, me, fe, _e), Re);
    return e.isGeneratorFunction(me) ? Ie : Ie.next().then(function(W) {
      return W.done ? W.value : Ie.next();
    });
  }, K(J), h(J, c, "Generator"), h(J, o, function() {
    return this;
  }), h(J, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(ne) {
    var me = Object(ne), fe = [];
    for (var _e in me) fe.push(_e);
    return fe.reverse(), function Re() {
      for (; fe.length; ) {
        var Ie = fe.pop();
        if (Ie in me) return Re.value = Ie, Re.done = !1, Re;
      }
      return Re.done = !0, Re;
    };
  }, e.values = oe, H.prototype = {
    constructor: H,
    reset: function(me) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(q), !me) for (var fe in this) fe.charAt(0) === "t" && n.call(this, fe) && !isNaN(+fe.slice(1)) && (this[fe] = r);
    },
    stop: function() {
      this.done = !0;
      var me = this.tryEntries[0].completion;
      if (me.type === "throw") throw me.arg;
      return this.rval;
    },
    dispatchException: function(me) {
      if (this.done) throw me;
      var fe = this;
      function _e(ye, Fe) {
        return W.type = "throw", W.arg = me, fe.next = ye, Fe && (fe.method = "next", fe.arg = r), !!Fe;
      }
      for (var Re = this.tryEntries.length - 1; Re >= 0; --Re) {
        var Ie = this.tryEntries[Re], W = Ie.completion;
        if (Ie.tryLoc === "root") return _e("end");
        if (Ie.tryLoc <= this.prev) {
          var Z = n.call(Ie, "catchLoc"), se = n.call(Ie, "finallyLoc");
          if (Z && se) {
            if (this.prev < Ie.catchLoc) return _e(Ie.catchLoc, !0);
            if (this.prev < Ie.finallyLoc) return _e(Ie.finallyLoc);
          } else if (Z) {
            if (this.prev < Ie.catchLoc) return _e(Ie.catchLoc, !0);
          } else {
            if (!se) throw Error("try statement without catch or finally");
            if (this.prev < Ie.finallyLoc) return _e(Ie.finallyLoc);
          }
        }
      }
    },
    abrupt: function(me, fe) {
      for (var _e = this.tryEntries.length - 1; _e >= 0; --_e) {
        var Re = this.tryEntries[_e];
        if (Re.tryLoc <= this.prev && n.call(Re, "finallyLoc") && this.prev < Re.finallyLoc) {
          var Ie = Re;
          break;
        }
      }
      Ie && (me === "break" || me === "continue") && Ie.tryLoc <= fe && fe <= Ie.finallyLoc && (Ie = null);
      var W = Ie ? Ie.completion : {};
      return W.type = me, W.arg = fe, Ie ? (this.method = "next", this.next = Ie.finallyLoc, N) : this.complete(W);
    },
    complete: function(me, fe) {
      if (me.type === "throw") throw me.arg;
      return me.type === "break" || me.type === "continue" ? this.next = me.arg : me.type === "return" ? (this.rval = this.arg = me.arg, this.method = "return", this.next = "end") : me.type === "normal" && fe && (this.next = fe), N;
    },
    finish: function(me) {
      for (var fe = this.tryEntries.length - 1; fe >= 0; --fe) {
        var _e = this.tryEntries[fe];
        if (_e.finallyLoc === me) return this.complete(_e.completion, _e.afterLoc), q(_e), N;
      }
    },
    catch: function(me) {
      for (var fe = this.tryEntries.length - 1; fe >= 0; --fe) {
        var _e = this.tryEntries[fe];
        if (_e.tryLoc === me) {
          var Re = _e.completion;
          if (Re.type === "throw") {
            var Ie = Re.arg;
            q(_e);
          }
          return Ie;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(me, fe, _e) {
      return this.delegate = {
        iterator: oe(me),
        resultName: fe,
        nextLoc: _e
      }, this.method === "next" && (this.arg = r), N;
    }
  }, e;
}
function em(r, e, t, n, i, a, o) {
  try {
    var s = r[a](o), c = s.value;
  } catch (h) {
    return void t(h);
  }
  s.done ? e(c) : Promise.resolve(c).then(n, i);
}
function ui(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(n, i) {
      var a = r.apply(e, t);
      function o(c) {
        em(a, n, i, o, s, "next", c);
      }
      function s(c) {
        em(a, n, i, o, s, "throw", c);
      }
      o(void 0);
    });
  };
}
var H4 = { exports: {} };
(function(r, e) {
  var t = typeof self < "u" ? self : Jf, n = function() {
    function a() {
      this.fetch = !1, this.DOMException = t.DOMException;
    }
    return a.prototype = t, new a();
  }();
  (function(a) {
    (function(o) {
      var s = {
        searchParams: "URLSearchParams" in a,
        iterable: "Symbol" in a && "iterator" in Symbol,
        blob: "FileReader" in a && "Blob" in a && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in a,
        arrayBuffer: "ArrayBuffer" in a
      };
      function c(H) {
        return H && DataView.prototype.isPrototypeOf(H);
      }
      if (s.arrayBuffer)
        var h = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], d = ArrayBuffer.isView || function(H) {
          return H && h.indexOf(Object.prototype.toString.call(H)) > -1;
        };
      function g(H) {
        if (typeof H != "string" && (H = String(H)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(H))
          throw new TypeError("Invalid character in header field name");
        return H.toLowerCase();
      }
      function x(H) {
        return typeof H != "string" && (H = String(H)), H;
      }
      function _(H) {
        var oe = {
          next: function() {
            var ne = H.shift();
            return { done: ne === void 0, value: ne };
          }
        };
        return s.iterable && (oe[Symbol.iterator] = function() {
          return oe;
        }), oe;
      }
      function k(H) {
        this.map = {}, H instanceof k ? H.forEach(function(oe, ne) {
          this.append(ne, oe);
        }, this) : Array.isArray(H) ? H.forEach(function(oe) {
          this.append(oe[0], oe[1]);
        }, this) : H && Object.getOwnPropertyNames(H).forEach(function(oe) {
          this.append(oe, H[oe]);
        }, this);
      }
      k.prototype.append = function(H, oe) {
        H = g(H), oe = x(oe);
        var ne = this.map[H];
        this.map[H] = ne ? ne + ", " + oe : oe;
      }, k.prototype.delete = function(H) {
        delete this.map[g(H)];
      }, k.prototype.get = function(H) {
        return H = g(H), this.has(H) ? this.map[H] : null;
      }, k.prototype.has = function(H) {
        return this.map.hasOwnProperty(g(H));
      }, k.prototype.set = function(H, oe) {
        this.map[g(H)] = x(oe);
      }, k.prototype.forEach = function(H, oe) {
        for (var ne in this.map)
          this.map.hasOwnProperty(ne) && H.call(oe, this.map[ne], ne, this);
      }, k.prototype.keys = function() {
        var H = [];
        return this.forEach(function(oe, ne) {
          H.push(ne);
        }), _(H);
      }, k.prototype.values = function() {
        var H = [];
        return this.forEach(function(oe) {
          H.push(oe);
        }), _(H);
      }, k.prototype.entries = function() {
        var H = [];
        return this.forEach(function(oe, ne) {
          H.push([ne, oe]);
        }), _(H);
      }, s.iterable && (k.prototype[Symbol.iterator] = k.prototype.entries);
      function P(H) {
        if (H.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        H.bodyUsed = !0;
      }
      function N(H) {
        return new Promise(function(oe, ne) {
          H.onload = function() {
            oe(H.result);
          }, H.onerror = function() {
            ne(H.error);
          };
        });
      }
      function M(H) {
        var oe = new FileReader(), ne = N(oe);
        return oe.readAsArrayBuffer(H), ne;
      }
      function G(H) {
        var oe = new FileReader(), ne = N(oe);
        return oe.readAsText(H), ne;
      }
      function z(H) {
        for (var oe = new Uint8Array(H), ne = new Array(oe.length), me = 0; me < oe.length; me++)
          ne[me] = String.fromCharCode(oe[me]);
        return ne.join("");
      }
      function j(H) {
        if (H.slice)
          return H.slice(0);
        var oe = new Uint8Array(H.byteLength);
        return oe.set(new Uint8Array(H)), oe.buffer;
      }
      function R() {
        return this.bodyUsed = !1, this._initBody = function(H) {
          this._bodyInit = H, H ? typeof H == "string" ? this._bodyText = H : s.blob && Blob.prototype.isPrototypeOf(H) ? this._bodyBlob = H : s.formData && FormData.prototype.isPrototypeOf(H) ? this._bodyFormData = H : s.searchParams && URLSearchParams.prototype.isPrototypeOf(H) ? this._bodyText = H.toString() : s.arrayBuffer && s.blob && c(H) ? (this._bodyArrayBuffer = j(H.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : s.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(H) || d(H)) ? this._bodyArrayBuffer = j(H) : this._bodyText = H = Object.prototype.toString.call(H) : this._bodyText = "", this.headers.get("content-type") || (typeof H == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : s.searchParams && URLSearchParams.prototype.isPrototypeOf(H) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, s.blob && (this.blob = function() {
          var H = P(this);
          if (H)
            return H;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? P(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(M);
        }), this.text = function() {
          var H = P(this);
          if (H)
            return H;
          if (this._bodyBlob)
            return G(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(z(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, s.formData && (this.formData = function() {
          return this.text().then(ee);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var te = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function J(H) {
        var oe = H.toUpperCase();
        return te.indexOf(oe) > -1 ? oe : H;
      }
      function K(H, oe) {
        oe = oe || {};
        var ne = oe.body;
        if (H instanceof K) {
          if (H.bodyUsed)
            throw new TypeError("Already read");
          this.url = H.url, this.credentials = H.credentials, oe.headers || (this.headers = new k(H.headers)), this.method = H.method, this.mode = H.mode, this.signal = H.signal, !ne && H._bodyInit != null && (ne = H._bodyInit, H.bodyUsed = !0);
        } else
          this.url = String(H);
        if (this.credentials = oe.credentials || this.credentials || "same-origin", (oe.headers || !this.headers) && (this.headers = new k(oe.headers)), this.method = J(oe.method || this.method || "GET"), this.mode = oe.mode || this.mode || null, this.signal = oe.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && ne)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(ne);
      }
      K.prototype.clone = function() {
        return new K(this, { body: this._bodyInit });
      };
      function ee(H) {
        var oe = new FormData();
        return H.trim().split("&").forEach(function(ne) {
          if (ne) {
            var me = ne.split("="), fe = me.shift().replace(/\+/g, " "), _e = me.join("=").replace(/\+/g, " ");
            oe.append(decodeURIComponent(fe), decodeURIComponent(_e));
          }
        }), oe;
      }
      function ve(H) {
        var oe = new k(), ne = H.replace(/\r?\n[\t ]+/g, " ");
        return ne.split(/\r?\n/).forEach(function(me) {
          var fe = me.split(":"), _e = fe.shift().trim();
          if (_e) {
            var Re = fe.join(":").trim();
            oe.append(_e, Re);
          }
        }), oe;
      }
      R.call(K.prototype);
      function de(H, oe) {
        oe || (oe = {}), this.type = "default", this.status = oe.status === void 0 ? 200 : oe.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in oe ? oe.statusText : "OK", this.headers = new k(oe.headers), this.url = oe.url || "", this._initBody(H);
      }
      R.call(de.prototype), de.prototype.clone = function() {
        return new de(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new k(this.headers),
          url: this.url
        });
      }, de.error = function() {
        var H = new de(null, { status: 0, statusText: "" });
        return H.type = "error", H;
      };
      var B = [301, 302, 303, 307, 308];
      de.redirect = function(H, oe) {
        if (B.indexOf(oe) === -1)
          throw new RangeError("Invalid status code");
        return new de(null, { status: oe, headers: { location: H } });
      }, o.DOMException = a.DOMException;
      try {
        new o.DOMException();
      } catch {
        o.DOMException = function(oe, ne) {
          this.message = oe, this.name = ne;
          var me = Error(oe);
          this.stack = me.stack;
        }, o.DOMException.prototype = Object.create(Error.prototype), o.DOMException.prototype.constructor = o.DOMException;
      }
      function q(H, oe) {
        return new Promise(function(ne, me) {
          var fe = new K(H, oe);
          if (fe.signal && fe.signal.aborted)
            return me(new o.DOMException("Aborted", "AbortError"));
          var _e = new XMLHttpRequest();
          function Re() {
            _e.abort();
          }
          _e.onload = function() {
            var Ie = {
              status: _e.status,
              statusText: _e.statusText,
              headers: ve(_e.getAllResponseHeaders() || "")
            };
            Ie.url = "responseURL" in _e ? _e.responseURL : Ie.headers.get("X-Request-URL");
            var W = "response" in _e ? _e.response : _e.responseText;
            ne(new de(W, Ie));
          }, _e.onerror = function() {
            me(new TypeError("Network request failed"));
          }, _e.ontimeout = function() {
            me(new TypeError("Network request failed"));
          }, _e.onabort = function() {
            me(new o.DOMException("Aborted", "AbortError"));
          }, _e.open(fe.method, fe.url, !0), fe.credentials === "include" ? _e.withCredentials = !0 : fe.credentials === "omit" && (_e.withCredentials = !1), "responseType" in _e && s.blob && (_e.responseType = "blob"), fe.headers.forEach(function(Ie, W) {
            _e.setRequestHeader(W, Ie);
          }), fe.signal && (fe.signal.addEventListener("abort", Re), _e.onreadystatechange = function() {
            _e.readyState === 4 && fe.signal.removeEventListener("abort", Re);
          }), _e.send(typeof fe._bodyInit > "u" ? null : fe._bodyInit);
        });
      }
      return q.polyfill = !0, a.fetch || (a.fetch = q, a.Headers = k, a.Request = K, a.Response = de), o.Headers = k, o.Request = K, o.Response = de, o.fetch = q, Object.defineProperty(o, "__esModule", { value: !0 }), o;
    })({});
  })(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
  var i = n;
  e = i.fetch, e.default = i.fetch, e.fetch = i.fetch, e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response, r.exports = e;
})(H4, H4.exports);
var nk = H4.exports;
const Ww = /* @__PURE__ */ I0(nk), ik = {
  utf16le: "utf-16le",
  ucs2: "utf-16le",
  utf16be: "utf-16be"
};
class kn {
  constructor(e) {
    this.buffer = e, this.view = new DataView(e.buffer, e.byteOffset, e.byteLength), this.pos = 0, this.length = this.buffer.length;
  }
  readString(e, t = "ascii") {
    t = ik[t] || t;
    let n = this.readBuffer(e);
    try {
      return new TextDecoder(t).decode(n);
    } catch {
      return n;
    }
  }
  readBuffer(e) {
    return this.buffer.slice(this.pos, this.pos += e);
  }
  readUInt24BE() {
    return (this.readUInt16BE() << 8) + this.readUInt8();
  }
  readUInt24LE() {
    return this.readUInt16LE() + (this.readUInt8() << 16);
  }
  readInt24BE() {
    return (this.readInt16BE() << 8) + this.readUInt8();
  }
  readInt24LE() {
    return this.readUInt16LE() + (this.readInt8() << 16);
  }
}
kn.TYPES = {
  UInt8: 1,
  UInt16: 2,
  UInt24: 3,
  UInt32: 4,
  Int8: 1,
  Int16: 2,
  Int24: 3,
  Int32: 4,
  Float: 4,
  Double: 8
};
for (let r of Object.getOwnPropertyNames(DataView.prototype))
  if (r.slice(0, 3) === "get") {
    let e = r.slice(3).replace("Ui", "UI");
    e === "Float32" ? e = "Float" : e === "Float64" && (e = "Double");
    let t = kn.TYPES[e];
    kn.prototype["read" + e + (t === 1 ? "" : "BE")] = function() {
      const n = this.view[r](this.pos, !1);
      return this.pos += t, n;
    }, t !== 1 && (kn.prototype["read" + e + "LE"] = function() {
      const n = this.view[r](this.pos, !0);
      return this.pos += t, n;
    });
  }
const ak = new TextEncoder(), tm = new Uint8Array(new Uint16Array([4660]).buffer)[0] == 18;
class td {
  constructor(e) {
    this.buffer = e, this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), this.pos = 0;
  }
  writeBuffer(e) {
    this.buffer.set(e, this.pos), this.pos += e.length;
  }
  writeString(e, t = "ascii") {
    let n;
    switch (t) {
      case "utf16le":
      case "utf16-le":
      case "ucs2":
        n = rm(e, tm);
        break;
      case "utf16be":
      case "utf16-be":
        n = rm(e, !tm);
        break;
      case "utf8":
        n = ak.encode(e);
        break;
      case "ascii":
        n = ok(e);
        break;
      default:
        throw new Error(`Unsupported encoding: ${t}`);
    }
    this.writeBuffer(n);
  }
  writeUInt24BE(e) {
    this.buffer[this.pos++] = e >>> 16 & 255, this.buffer[this.pos++] = e >>> 8 & 255, this.buffer[this.pos++] = e & 255;
  }
  writeUInt24LE(e) {
    this.buffer[this.pos++] = e & 255, this.buffer[this.pos++] = e >>> 8 & 255, this.buffer[this.pos++] = e >>> 16 & 255;
  }
  writeInt24BE(e) {
    e >= 0 ? this.writeUInt24BE(e) : this.writeUInt24BE(e + 16777215 + 1);
  }
  writeInt24LE(e) {
    e >= 0 ? this.writeUInt24LE(e) : this.writeUInt24LE(e + 16777215 + 1);
  }
  fill(e, t) {
    if (t < this.buffer.length)
      this.buffer.fill(e, this.pos, this.pos + t), this.pos += t;
    else {
      const n = new Uint8Array(t);
      n.fill(e), this.writeBuffer(n);
    }
  }
}
function rm(r, e) {
  let t = new Uint16Array(r.length);
  for (let n = 0; n < r.length; n++) {
    let i = r.charCodeAt(n);
    e && (i = i >> 8 | (i & 255) << 8), t[n] = i;
  }
  return new Uint8Array(t.buffer);
}
function ok(r) {
  let e = new Uint8Array(r.length);
  for (let t = 0; t < r.length; t++)
    e[t] = r.charCodeAt(t);
  return e;
}
for (let r of Object.getOwnPropertyNames(DataView.prototype))
  if (r.slice(0, 3) === "set") {
    let e = r.slice(3).replace("Ui", "UI");
    e === "Float32" ? e = "Float" : e === "Float64" && (e = "Double");
    let t = kn.TYPES[e];
    td.prototype["write" + e + (t === 1 ? "" : "BE")] = function(n) {
      this.view[r](this.pos, n, !1), this.pos += t;
    }, t !== 1 && (td.prototype["write" + e + "LE"] = function(n) {
      this.view[r](this.pos, n, !0), this.pos += t;
    });
  }
class rs {
  fromBuffer(e) {
    let t = new kn(e);
    return this.decode(t);
  }
  toBuffer(e) {
    let t = this.size(e), n = new Uint8Array(t), i = new td(n);
    return this.encode(i, e), n;
  }
}
class Lr extends rs {
  constructor(e, t = "BE") {
    super(), this.type = e, this.endian = t, this.fn = this.type, this.type[this.type.length - 1] !== "8" && (this.fn += this.endian);
  }
  size() {
    return kn.TYPES[this.type];
  }
  decode(e) {
    return e[`read${this.fn}`]();
  }
  encode(e, t) {
    return e[`write${this.fn}`](t);
  }
}
const kt = new Lr("UInt8"), sk = new Lr("UInt16", "BE"), O = sk;
new Lr("UInt16", "LE");
const uk = new Lr("UInt24", "BE"), Xs = uk;
new Lr("UInt24", "LE");
const lk = new Lr("UInt32", "BE"), Oe = lk;
new Lr("UInt32", "LE");
const rn = new Lr("Int8"), ck = new Lr("Int16", "BE"), lt = ck;
new Lr("Int16", "LE");
new Lr("Int24", "BE");
new Lr("Int24", "LE");
const fk = new Lr("Int32", "BE"), Yu = fk;
new Lr("Int32", "LE");
new Lr("Float", "BE");
new Lr("Float", "LE");
new Lr("Double", "BE");
new Lr("Double", "LE");
class El extends Lr {
  constructor(e, t, n = e >> 1) {
    super(`Int${e}`, t), this._point = 1 << n;
  }
  decode(e) {
    return super.decode(e) / this._point;
  }
  encode(e, t) {
    return super.encode(e, t * this._point | 0);
  }
}
const hk = new El(16, "BE"), dk = hk;
new El(16, "LE");
const pk = new El(32, "BE"), O0 = pk;
new El(32, "LE");
function vo(r, e, t) {
  let n;
  if (typeof r == "number" ? n = r : typeof r == "function" ? n = r.call(t, t) : t && typeof r == "string" ? n = t[r] : e && r instanceof Lr && (n = r.decode(e)), isNaN(n))
    throw new Error("Not a fixed size");
  return n;
}
class yv {
  constructor(e = {}) {
    this.enumerable = !0, this.configurable = !0;
    for (let t in e) {
      const n = e[t];
      this[t] = n;
    }
  }
}
class Te extends rs {
  constructor(e, t, n = "count") {
    super(), this.type = e, this.length = t, this.lengthType = n;
  }
  decode(e, t) {
    let n;
    const { pos: i } = e, a = [];
    let o = t;
    if (this.length != null && (n = vo(this.length, e, t)), this.length instanceof Lr && (Object.defineProperties(a, {
      parent: { value: t },
      _startOffset: { value: i },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: n }
    }), o = a), n == null || this.lengthType === "bytes") {
      const s = n != null ? e.pos + n : t != null && t._length ? t._startOffset + t._length : e.length;
      for (; e.pos < s; )
        a.push(this.type.decode(e, o));
    } else
      for (let s = 0, c = n; s < c; s++)
        a.push(this.type.decode(e, o));
    return a;
  }
  size(e, t, n = !0) {
    if (!e)
      return this.type.size(null, t) * vo(this.length, null, t);
    let i = 0;
    this.length instanceof Lr && (i += this.length.size(), t = { parent: t, pointerSize: 0 });
    for (let a of e)
      i += this.type.size(a, t);
    return t && n && this.length instanceof Lr && (i += t.pointerSize), i;
  }
  encode(e, t, n) {
    let i = n;
    this.length instanceof Lr && (i = {
      pointers: [],
      startOffset: e.pos,
      parent: n
    }, i.pointerOffset = e.pos + this.size(t, i, !1), this.length.encode(e, t.length));
    for (let a of t)
      this.type.encode(e, a, i);
    if (this.length instanceof Lr) {
      let a = 0;
      for (; a < i.pointers.length; ) {
        const o = i.pointers[a++];
        o.type.encode(e, o.val, o.parent);
      }
    }
  }
}
class Hr extends Te {
  decode(e, t) {
    const { pos: n } = e, i = vo(this.length, e, t);
    this.length instanceof Lr && (t = {
      parent: t,
      _startOffset: n,
      _currentOffset: 0,
      _length: i
    });
    const a = new G5(this.type, i, e, t);
    return e.pos += i * this.type.size(null, t), a;
  }
  size(e, t) {
    return e instanceof G5 && (e = e.toArray()), super.size(e, t);
  }
  encode(e, t, n) {
    return t instanceof G5 && (t = t.toArray()), super.encode(e, t, n);
  }
}
class G5 {
  constructor(e, t, n, i) {
    this.type = e, this.length = t, this.stream = n, this.ctx = i, this.base = this.stream.pos, this.items = [];
  }
  get(e) {
    if (!(e < 0 || e >= this.length)) {
      if (this.items[e] == null) {
        const { pos: t } = this.stream;
        this.stream.pos = this.base + this.type.size(null, this.ctx) * e, this.items[e] = this.type.decode(this.stream, this.ctx), this.stream.pos = t;
      }
      return this.items[e];
    }
  }
  toArray() {
    const e = [];
    for (let t = 0, n = this.length; t < n; t++)
      e.push(this.get(t));
    return e;
  }
}
class ka extends rs {
  constructor(e, t = []) {
    super(), this.type = e, this.flags = t;
  }
  decode(e) {
    const t = this.type.decode(e), n = {};
    for (let i = 0; i < this.flags.length; i++) {
      const a = this.flags[i];
      a != null && (n[a] = !!(t & 1 << i));
    }
    return n;
  }
  size() {
    return this.type.size();
  }
  encode(e, t) {
    let n = 0;
    for (let i = 0; i < this.flags.length; i++) {
      const a = this.flags[i];
      a != null && t[a] && (n |= 1 << i);
    }
    return this.type.encode(e, n);
  }
}
class po extends rs {
  constructor(e) {
    super(), this.length = e;
  }
  decode(e, t) {
    const n = vo(this.length, e, t);
    return e.readBuffer(n);
  }
  size(e, t) {
    if (!e)
      return vo(this.length, null, t);
    let n = e.length;
    return this.length instanceof Lr && (n += this.length.size()), n;
  }
  encode(e, t, n) {
    return this.length instanceof Lr && this.length.encode(e, t.length), e.writeBuffer(t);
  }
}
class rd extends rs {
  constructor(e, t = !0) {
    super(), this.type = e, this.condition = t;
  }
  decode(e, t) {
    let { condition: n } = this;
    if (typeof n == "function" && (n = n.call(t, t)), n)
      return this.type.decode(e, t);
  }
  size(e, t) {
    let { condition: n } = this;
    return typeof n == "function" && (n = n.call(t, t)), n ? this.type.size(e, t) : 0;
  }
  encode(e, t, n) {
    let { condition: i } = this;
    if (typeof i == "function" && (i = i.call(n, n)), i)
      return this.type.encode(e, t, n);
  }
}
class o0 extends rs {
  constructor(e, t = 1) {
    super(), this.type = e, this.count = t;
  }
  decode(e, t) {
    e.pos += this.size(null, t);
  }
  size(e, t) {
    const n = vo(this.count, null, t);
    return this.type.size() * n;
  }
  encode(e, t, n) {
    return e.fill(0, this.size(t, n));
  }
}
class Ur extends rs {
  constructor(e, t = "ascii") {
    super(), this.length = e, this.encoding = t;
  }
  decode(e, t) {
    let n, i;
    if (this.length != null)
      n = vo(this.length, e, t);
    else {
      let s;
      for ({ buffer: s, length: n, pos: i } = e; i < n && s[i] !== 0; )
        ++i;
      n = i - e.pos;
    }
    let { encoding: a } = this;
    typeof a == "function" && (a = a.call(t, t) || "ascii");
    const o = e.readString(n, a);
    return this.length == null && e.pos < e.length && e.pos++, o;
  }
  size(e, t) {
    if (!e)
      return vo(this.length, null, t);
    let { encoding: n } = this;
    typeof n == "function" && (n = n.call(t != null ? t.val : void 0, t != null ? t.val : void 0) || "ascii"), n === "utf16be" && (n = "utf16le");
    let i = nm(e, n);
    return this.length instanceof Lr && (i += this.length.size()), this.length == null && i++, i;
  }
  encode(e, t, n) {
    let { encoding: i } = this;
    if (typeof i == "function" && (i = i.call(n != null ? n.val : void 0, n != null ? n.val : void 0) || "ascii"), this.length instanceof Lr && this.length.encode(e, nm(t, i)), e.writeString(t, i), this.length == null)
      return e.writeUInt8(0);
  }
}
function nm(r, e) {
  switch (e) {
    case "ascii":
      return r.length;
    case "utf8":
      let t = 0;
      for (let n = 0; n < r.length; n++) {
        let i = r.charCodeAt(n);
        if (i >= 55296 && i <= 56319 && n < r.length - 1) {
          let a = r.charCodeAt(++n);
          (a & 64512) === 56320 ? i = ((i & 1023) << 10) + (a & 1023) + 65536 : n--;
        }
        i & 4294967168 ? i & 4294965248 ? i & 4294901760 ? i & 4292870144 || (t += 4) : t += 3 : t += 2 : t++;
      }
      return t;
    case "utf16le":
    case "utf16-le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return r.length * 2;
    default:
      throw new Error("Unknown encoding " + e);
  }
}
class Me extends rs {
  constructor(e = {}) {
    super(), this.fields = e;
  }
  decode(e, t, n = 0) {
    const i = this._setup(e, t, n);
    return this._parseFields(e, i, this.fields), this.process != null && this.process.call(i, e), i;
  }
  _setup(e, t, n) {
    const i = {};
    return Object.defineProperties(i, {
      parent: { value: t },
      _startOffset: { value: e.pos },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: n }
    }), i;
  }
  _parseFields(e, t, n) {
    for (let a in n) {
      var i;
      const o = n[a];
      typeof o == "function" ? i = o.call(t, t) : i = o.decode(e, t), i !== void 0 && (i instanceof yv ? Object.defineProperty(t, a, i) : t[a] = i), t._currentOffset = e.pos - t._startOffset;
    }
  }
  size(e, t, n = !0) {
    e == null && (e = {});
    const i = {
      parent: t,
      val: e,
      pointerSize: 0
    };
    this.preEncode != null && this.preEncode.call(e);
    let a = 0;
    for (let o in this.fields) {
      const s = this.fields[o];
      s.size != null && (a += s.size(e[o], i));
    }
    return n && (a += i.pointerSize), a;
  }
  encode(e, t, n) {
    let i;
    this.preEncode != null && this.preEncode.call(t, e);
    const a = {
      pointers: [],
      startOffset: e.pos,
      parent: n,
      val: t,
      pointerSize: 0
    };
    a.pointerOffset = e.pos + this.size(t, a, !1);
    for (let s in this.fields)
      i = this.fields[s], i.encode != null && i.encode(e, t[s], a);
    let o = 0;
    for (; o < a.pointers.length; ) {
      const s = a.pointers[o++];
      s.type.encode(e, s.val, s.parent);
    }
  }
}
const vk = (r, e) => e.reduce((t, n) => t && t[n], r);
class or extends Me {
  constructor(e, t = {}) {
    super(), this.type = e, this.versions = t, typeof e == "string" && (this.versionPath = e.split("."));
  }
  decode(e, t, n = 0) {
    const i = this._setup(e, t, n);
    typeof this.type == "string" ? i.version = vk(t, this.versionPath) : i.version = this.type.decode(e), this.versions.header && this._parseFields(e, i, this.versions.header);
    const a = this.versions[i.version];
    if (a == null)
      throw new Error(`Unknown version ${i.version}`);
    return a instanceof or ? a.decode(e, t) : (this._parseFields(e, i, a), this.process != null && this.process.call(i, e), i);
  }
  size(e, t, n = !0) {
    let i, a;
    if (!e)
      throw new Error("Not a fixed size");
    this.preEncode != null && this.preEncode.call(e);
    const o = {
      parent: t,
      val: e,
      pointerSize: 0
    };
    let s = 0;
    if (typeof this.type != "string" && (s += this.type.size(e.version, o)), this.versions.header)
      for (i in this.versions.header)
        a = this.versions.header[i], a.size != null && (s += a.size(e[i], o));
    const c = this.versions[e.version];
    if (c == null)
      throw new Error(`Unknown version ${e.version}`);
    for (i in c)
      a = c[i], a.size != null && (s += a.size(e[i], o));
    return n && (s += o.pointerSize), s;
  }
  encode(e, t, n) {
    let i, a;
    this.preEncode != null && this.preEncode.call(t, e);
    const o = {
      pointers: [],
      startOffset: e.pos,
      parent: n,
      val: t,
      pointerSize: 0
    };
    if (o.pointerOffset = e.pos + this.size(t, o, !1), typeof this.type != "string" && this.type.encode(e, t.version), this.versions.header)
      for (i in this.versions.header)
        a = this.versions.header[i], a.encode != null && a.encode(e, t[i], o);
    const s = this.versions[t.version];
    for (i in s)
      a = s[i], a.encode != null && a.encode(e, t[i], o);
    let c = 0;
    for (; c < o.pointers.length; ) {
      const h = o.pointers[c++];
      h.type.encode(e, h.val, h.parent);
    }
  }
}
class Se extends rs {
  constructor(e, t, n = {}) {
    if (super(), this.offsetType = e, this.type = t, this.options = n, this.type === "void" && (this.type = null), this.options.type == null && (this.options.type = "local"), this.options.allowNull == null && (this.options.allowNull = !0), this.options.nullValue == null && (this.options.nullValue = 0), this.options.lazy == null && (this.options.lazy = !1), this.options.relativeTo) {
      if (typeof this.options.relativeTo != "function")
        throw new Error("relativeTo option must be a function");
      this.relativeToGetter = n.relativeTo;
    }
  }
  decode(e, t) {
    const n = this.offsetType.decode(e, t);
    if (n === this.options.nullValue && this.options.allowNull)
      return null;
    let i;
    switch (this.options.type) {
      case "local":
        i = t._startOffset;
        break;
      case "immediate":
        i = e.pos - this.offsetType.size();
        break;
      case "parent":
        i = t.parent._startOffset;
        break;
      default:
        for (var a = t; a.parent; )
          a = a.parent;
        i = a._startOffset || 0;
    }
    this.options.relativeTo && (i += this.relativeToGetter(t));
    const o = n + i;
    if (this.type != null) {
      let s = null;
      const c = () => {
        if (s != null)
          return s;
        const { pos: h } = e;
        return e.pos = o, s = this.type.decode(e, t), e.pos = h, s;
      };
      return this.options.lazy ? new yv({
        get: c
      }) : c();
    } else
      return o;
  }
  size(e, t) {
    const n = t;
    switch (this.options.type) {
      case "local":
      case "immediate":
        break;
      case "parent":
        t = t.parent;
        break;
      default:
        for (; t.parent; )
          t = t.parent;
    }
    let { type: i } = this;
    if (i == null) {
      if (!(e instanceof Z4))
        throw new Error("Must be a VoidPointer");
      ({ type: i } = e), e = e.value;
    }
    if (e && t) {
      let a = i.size(e, n);
      t.pointerSize += a;
    }
    return this.offsetType.size();
  }
  encode(e, t, n) {
    let i;
    const a = n;
    if (t == null) {
      this.offsetType.encode(e, this.options.nullValue);
      return;
    }
    switch (this.options.type) {
      case "local":
        i = n.startOffset;
        break;
      case "immediate":
        i = e.pos + this.offsetType.size(t, a);
        break;
      case "parent":
        n = n.parent, i = n.startOffset;
        break;
      default:
        for (i = 0; n.parent; )
          n = n.parent;
    }
    this.options.relativeTo && (i += this.relativeToGetter(a.val)), this.offsetType.encode(e, n.pointerOffset - i);
    let { type: o } = this;
    if (o == null) {
      if (!(t instanceof Z4))
        throw new Error("Must be a VoidPointer");
      ({ type: o } = t), t = t.value;
    }
    return n.pointers.push({
      type: o,
      val: t,
      parent: a
    }), n.pointerOffset += o.size(t, a);
  }
}
class Z4 {
  constructor(e, t) {
    this.type = e, this.value = t;
  }
}
function hi(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function Cn(r, e, t, n) {
  var i = arguments.length, a = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(r, e, t, n);
  else for (var s = r.length - 1; s >= 0; s--) (o = r[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, t, a) : o(e, t)) || a);
  return i > 3 && a && Object.defineProperty(e, t, a), a;
}
var gk = function r(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var n, i, a;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length) return !1;
      for (i = n; i-- !== 0; )
        if (!r(e[i], t[i])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length) return !1;
    for (i = n; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[i])) return !1;
    for (i = n; i-- !== 0; ) {
      var o = a[i];
      if (!r(e[o], t[o])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
};
const im = /* @__PURE__ */ I0(gk);
var z1 = {};
z1.byteLength = bk;
z1.toByteArray = Ak;
z1.fromByteArray = _k;
var eo = [], qi = [], mk = typeof Uint8Array < "u" ? Uint8Array : Array, V5 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Ql = 0, yk = V5.length; Ql < yk; ++Ql)
  eo[Ql] = V5[Ql], qi[V5.charCodeAt(Ql)] = Ql;
qi[45] = 62;
qi[95] = 63;
function Gw(r) {
  var e = r.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var t = r.indexOf("=");
  t === -1 && (t = e);
  var n = t === e ? 0 : 4 - t % 4;
  return [t, n];
}
function bk(r) {
  var e = Gw(r), t = e[0], n = e[1];
  return (t + n) * 3 / 4 - n;
}
function wk(r, e, t) {
  return (e + t) * 3 / 4 - t;
}
function Ak(r) {
  var e, t = Gw(r), n = t[0], i = t[1], a = new mk(wk(r, n, i)), o = 0, s = i > 0 ? n - 4 : n, c;
  for (c = 0; c < s; c += 4)
    e = qi[r.charCodeAt(c)] << 18 | qi[r.charCodeAt(c + 1)] << 12 | qi[r.charCodeAt(c + 2)] << 6 | qi[r.charCodeAt(c + 3)], a[o++] = e >> 16 & 255, a[o++] = e >> 8 & 255, a[o++] = e & 255;
  return i === 2 && (e = qi[r.charCodeAt(c)] << 2 | qi[r.charCodeAt(c + 1)] >> 4, a[o++] = e & 255), i === 1 && (e = qi[r.charCodeAt(c)] << 10 | qi[r.charCodeAt(c + 1)] << 4 | qi[r.charCodeAt(c + 2)] >> 2, a[o++] = e >> 8 & 255, a[o++] = e & 255), a;
}
function xk(r) {
  return eo[r >> 18 & 63] + eo[r >> 12 & 63] + eo[r >> 6 & 63] + eo[r & 63];
}
function Ek(r, e, t) {
  for (var n, i = [], a = e; a < t; a += 3)
    n = (r[a] << 16 & 16711680) + (r[a + 1] << 8 & 65280) + (r[a + 2] & 255), i.push(xk(n));
  return i.join("");
}
function _k(r) {
  for (var e, t = r.length, n = t % 3, i = [], a = 16383, o = 0, s = t - n; o < s; o += a)
    i.push(Ek(r, o, o + a > s ? s : o + a));
  return n === 1 ? (e = r[t - 1], i.push(
    eo[e >> 2] + eo[e << 4 & 63] + "=="
  )) : n === 2 && (e = (r[t - 2] << 8) + r[t - 1], i.push(
    eo[e >> 10] + eo[e >> 4 & 63] + eo[e << 2 & 63] + "="
  )), i.join("");
}
var bv = 0, Vw = -3;
function p1() {
  this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
}
function Dk(r, e) {
  this.source = r, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = e, this.destLen = 0, this.ltree = new p1(), this.dtree = new p1();
}
var Yw = new p1(), Hw = new p1(), wv = new Uint8Array(30), Av = new Uint16Array(30), Zw = new Uint8Array(30), qw = new Uint16Array(30), Tk = new Uint8Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), am = new p1(), Ga = new Uint8Array(320);
function Xw(r, e, t, n) {
  var i, a;
  for (i = 0; i < t; ++i) r[i] = 0;
  for (i = 0; i < 30 - t; ++i) r[i + t] = i / t | 0;
  for (a = n, i = 0; i < 30; ++i)
    e[i] = a, a += 1 << r[i];
}
function kk(r, e) {
  var t;
  for (t = 0; t < 7; ++t) r.table[t] = 0;
  for (r.table[7] = 24, r.table[8] = 152, r.table[9] = 112, t = 0; t < 24; ++t) r.trans[t] = 256 + t;
  for (t = 0; t < 144; ++t) r.trans[24 + t] = t;
  for (t = 0; t < 8; ++t) r.trans[168 + t] = 280 + t;
  for (t = 0; t < 112; ++t) r.trans[176 + t] = 144 + t;
  for (t = 0; t < 5; ++t) e.table[t] = 0;
  for (e.table[5] = 32, t = 0; t < 32; ++t) e.trans[t] = t;
}
var om = new Uint16Array(16);
function Y5(r, e, t, n) {
  var i, a;
  for (i = 0; i < 16; ++i) r.table[i] = 0;
  for (i = 0; i < n; ++i) r.table[e[t + i]]++;
  for (r.table[0] = 0, a = 0, i = 0; i < 16; ++i)
    om[i] = a, a += r.table[i];
  for (i = 0; i < n; ++i)
    e[t + i] && (r.trans[om[e[t + i]]++] = i);
}
function Sk(r) {
  r.bitcount-- || (r.tag = r.source[r.sourceIndex++], r.bitcount = 7);
  var e = r.tag & 1;
  return r.tag >>>= 1, e;
}
function Xa(r, e, t) {
  if (!e)
    return t;
  for (; r.bitcount < 24; )
    r.tag |= r.source[r.sourceIndex++] << r.bitcount, r.bitcount += 8;
  var n = r.tag & 65535 >>> 16 - e;
  return r.tag >>>= e, r.bitcount -= e, n + t;
}
function q4(r, e) {
  for (; r.bitcount < 24; )
    r.tag |= r.source[r.sourceIndex++] << r.bitcount, r.bitcount += 8;
  var t = 0, n = 0, i = 0, a = r.tag;
  do
    n = 2 * n + (a & 1), a >>>= 1, ++i, t += e.table[i], n -= e.table[i];
  while (n >= 0);
  return r.tag = a, r.bitcount -= i, e.trans[t + n];
}
function Ck(r, e, t) {
  var n, i, a, o, s, c;
  for (n = Xa(r, 5, 257), i = Xa(r, 5, 1), a = Xa(r, 4, 4), o = 0; o < 19; ++o) Ga[o] = 0;
  for (o = 0; o < a; ++o) {
    var h = Xa(r, 3, 0);
    Ga[Tk[o]] = h;
  }
  for (Y5(am, Ga, 0, 19), s = 0; s < n + i; ) {
    var d = q4(r, am);
    switch (d) {
      case 16:
        var g = Ga[s - 1];
        for (c = Xa(r, 2, 3); c; --c)
          Ga[s++] = g;
        break;
      case 17:
        for (c = Xa(r, 3, 3); c; --c)
          Ga[s++] = 0;
        break;
      case 18:
        for (c = Xa(r, 7, 11); c; --c)
          Ga[s++] = 0;
        break;
      default:
        Ga[s++] = d;
        break;
    }
  }
  Y5(e, Ga, 0, n), Y5(t, Ga, n, i);
}
function sm(r, e, t) {
  for (; ; ) {
    var n = q4(r, e);
    if (n === 256)
      return bv;
    if (n < 256)
      r.dest[r.destLen++] = n;
    else {
      var i, a, o, s;
      for (n -= 257, i = Xa(r, wv[n], Av[n]), a = q4(r, t), o = r.destLen - Xa(r, Zw[a], qw[a]), s = o; s < o + i; ++s)
        r.dest[r.destLen++] = r.dest[s];
    }
  }
}
function Fk(r) {
  for (var e, t, n; r.bitcount > 8; )
    r.sourceIndex--, r.bitcount -= 8;
  if (e = r.source[r.sourceIndex + 1], e = 256 * e + r.source[r.sourceIndex], t = r.source[r.sourceIndex + 3], t = 256 * t + r.source[r.sourceIndex + 2], e !== (~t & 65535))
    return Vw;
  for (r.sourceIndex += 4, n = e; n; --n)
    r.dest[r.destLen++] = r.source[r.sourceIndex++];
  return r.bitcount = 0, bv;
}
function Ok(r, e) {
  var t = new Dk(r, e), n, i, a;
  do {
    switch (n = Sk(t), i = Xa(t, 2, 0), i) {
      case 0:
        a = Fk(t);
        break;
      case 1:
        a = sm(t, Yw, Hw);
        break;
      case 2:
        Ck(t, t.ltree, t.dtree), a = sm(t, t.ltree, t.dtree);
        break;
      default:
        a = Vw;
    }
    if (a !== bv)
      throw new Error("Data error");
  } while (!n);
  return t.destLen < t.dest.length ? typeof t.dest.slice == "function" ? t.dest.slice(0, t.destLen) : t.dest.subarray(0, t.destLen) : t.dest;
}
kk(Yw, Hw);
Xw(wv, Av, 4, 3);
Xw(Zw, qw, 2, 1);
wv[28] = 0;
Av[28] = 258;
var Kw = Ok;
const Rk = /* @__PURE__ */ I0(Kw), Ik = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, um = (r, e, t) => {
  let n = r[e];
  r[e] = r[t], r[t] = n;
}, Pk = (r) => {
  const e = r.length;
  for (let t = 0; t < e; t += 4)
    um(r, t, t + 3), um(r, t + 1, t + 2);
}, Bk = (r) => {
  Ik && Pk(r);
};
var Nk = {
  swap32LE: Bk
};
const lm = Kw, { swap32LE: Lk } = Nk, xv = 11, cl = 5, Mk = xv - cl, Uk = 65536 >> xv, $k = 1 << Mk, zk = $k - 1, yh = 2, jk = 1 << cl, H5 = jk - 1, Jw = 65536 >> cl, Wk = 1024 >> cl, Gk = Jw + Wk, Vk = Gk, Yk = 32, Hk = Vk + Yk, Zk = 1 << yh;
class qk {
  constructor(e) {
    const t = typeof e.readUInt32BE == "function" && typeof e.slice == "function";
    if (t || e instanceof Uint8Array) {
      let n;
      if (t)
        this.highStart = e.readUInt32LE(0), this.errorValue = e.readUInt32LE(4), n = e.readUInt32LE(8), e = e.slice(12);
      else {
        const i = new DataView(e.buffer);
        this.highStart = i.getUint32(0, !0), this.errorValue = i.getUint32(4, !0), n = i.getUint32(8, !0), e = e.subarray(12);
      }
      e = lm(e, new Uint8Array(n)), e = lm(e, new Uint8Array(n)), Lk(e), this.data = new Uint32Array(e.buffer);
    } else
      ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = e);
  }
  get(e) {
    let t;
    return e < 0 || e > 1114111 ? this.errorValue : e < 55296 || e > 56319 && e <= 65535 ? (t = (this.data[e >> cl] << yh) + (e & H5), this.data[t]) : e <= 65535 ? (t = (this.data[Jw + (e - 55296 >> cl)] << yh) + (e & H5), this.data[t]) : e < this.highStart ? (t = this.data[Hk - Uk + (e >> xv)], t = this.data[t + (e >> cl & zk)], t = (t << yh) + (e & H5), this.data[t]) : this.data[this.data.length - Zk];
  }
}
var Xk = qk;
const Ud = /* @__PURE__ */ I0(Xk);
function hu(r) {
  return r && r.__esModule ? r.default : r;
}
var ns = {};
ns = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const j1 = new Ud(z1.toByteArray("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")), Kk = Math.log2 || ((r) => Math.log(r) / Math.LN2), $d = (r) => Kk(r) + 1 | 0, Jk = $d((/* @__PURE__ */ hu(ns)).categories.length - 1), Qw = $d((/* @__PURE__ */ hu(ns)).combiningClasses.length - 1), Ev = $d((/* @__PURE__ */ hu(ns)).scripts.length - 1), zd = $d((/* @__PURE__ */ hu(ns)).eaw.length - 1), W1 = 10, Qk = Qw + Ev + zd + W1, eS = Ev + zd + W1, tS = zd + W1, rS = W1, nS = (1 << Jk) - 1, iS = (1 << Qw) - 1, aS = (1 << Ev) - 1, oS = (1 << zd) - 1, sS = (1 << W1) - 1;
function fa(r) {
  const e = j1.get(r);
  return (/* @__PURE__ */ hu(ns)).categories[e >> Qk & nS];
}
function e7(r) {
  const e = j1.get(r);
  return (/* @__PURE__ */ hu(ns)).combiningClasses[e >> eS & iS];
}
function _v(r) {
  const e = j1.get(r);
  return (/* @__PURE__ */ hu(ns)).scripts[e >> tS & aS];
}
function uS(r) {
  const e = j1.get(r);
  return (/* @__PURE__ */ hu(ns)).eaw[e >> rS & oS];
}
function lS(r) {
  let e = j1.get(r), t = e & sS;
  if (t === 0) return null;
  if (t <= 50) return t - 1;
  if (t < 480) {
    const n = (t >> 4) - 12, i = (t & 15) + 1;
    return n / i;
  } else if (t < 768) {
    e = (t >> 5) - 14;
    let n = (t & 31) + 2;
    for (; n > 0; )
      e *= 10, n--;
    return e;
  } else {
    e = (t >> 2) - 191;
    let n = (t & 3) + 1;
    for (; n > 0; )
      e *= 60, n--;
    return e;
  }
}
function cS(r) {
  const e = fa(r);
  return e === "Lu" || e === "Ll" || e === "Lt" || e === "Lm" || e === "Lo" || e === "Nl";
}
function X4(r) {
  return fa(r) === "Nd";
}
function fS(r) {
  const e = fa(r);
  return e === "Pc" || e === "Pd" || e === "Pe" || e === "Pf" || e === "Pi" || e === "Po" || e === "Ps";
}
function hS(r) {
  return fa(r) === "Ll";
}
function dS(r) {
  return fa(r) === "Lu";
}
function pS(r) {
  return fa(r) === "Lt";
}
function vS(r) {
  const e = fa(r);
  return e === "Zs" || e === "Zl" || e === "Zp";
}
function gS(r) {
  const e = fa(r);
  return e === "Nd" || e === "No" || e === "Nl" || e === "Lu" || e === "Ll" || e === "Lt" || e === "Lm" || e === "Lo" || e === "Me" || e === "Mc";
}
function Dv(r) {
  const e = fa(r);
  return e === "Mn" || e === "Me" || e === "Mc";
}
var mS = {
  getCategory: fa,
  getCombiningClass: e7,
  getScript: _v,
  getEastAsianWidth: uS,
  getNumericValue: lS,
  isAlphabetic: cS,
  isDigit: X4,
  isPunctuation: fS,
  isLowerCase: hS,
  isUpperCase: dS,
  isTitleCase: pS,
  isWhiteSpace: vS,
  isBaseForm: gS,
  isMark: Dv
}, Z5 = 1, q5 = 0;
class yS {
  constructor(e) {
    this.stateTable = e.stateTable, this.accepting = e.accepting, this.tags = e.tags;
  }
  /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */
  match(e) {
    var t = this;
    return {
      *[Symbol.iterator]() {
        for (var n = Z5, i = null, a = null, o = null, s = 0; s < e.length; s++) {
          var c = e[s];
          o = n, n = t.stateTable[n][c], n === q5 && (i != null && a != null && a >= i && (yield [i, a, t.tags[o]]), n = t.stateTable[Z5][c], i = null), n !== q5 && i == null && (i = s), t.accepting[n] && (a = s), n === q5 && (n = Z5);
        }
        i != null && a != null && a >= i && (yield [i, a, t.tags[n]]);
      }
    };
  }
  /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */
  apply(e, t) {
    for (var [n, i, a] of this.match(e))
      for (var o of a)
        typeof t[o] == "function" && t[o](n, i, e.slice(n, i + 1));
  }
}
var bS = yS;
const t7 = /* @__PURE__ */ I0(bS);
var r7 = { exports: {} };
(function(r) {
  var e = function() {
    function t(x, _) {
      return _ != null && x instanceof _;
    }
    var n;
    try {
      n = Map;
    } catch {
      n = function() {
      };
    }
    var i;
    try {
      i = Set;
    } catch {
      i = function() {
      };
    }
    var a;
    try {
      a = Promise;
    } catch {
      a = function() {
      };
    }
    function o(x, _, k, P, N) {
      typeof _ == "object" && (k = _.depth, P = _.prototype, N = _.includeNonEnumerable, _ = _.circular);
      var M = [], G = [], z = typeof Buffer < "u";
      typeof _ > "u" && (_ = !0), typeof k > "u" && (k = 1 / 0);
      function j(R, te) {
        if (R === null)
          return null;
        if (te === 0)
          return R;
        var J, K;
        if (typeof R != "object")
          return R;
        if (t(R, n))
          J = new n();
        else if (t(R, i))
          J = new i();
        else if (t(R, a))
          J = new a(function(me, fe) {
            R.then(function(_e) {
              me(j(_e, te - 1));
            }, function(_e) {
              fe(j(_e, te - 1));
            });
          });
        else if (o.__isArray(R))
          J = [];
        else if (o.__isRegExp(R))
          J = new RegExp(R.source, g(R)), R.lastIndex && (J.lastIndex = R.lastIndex);
        else if (o.__isDate(R))
          J = new Date(R.getTime());
        else {
          if (z && Buffer.isBuffer(R))
            return Buffer.allocUnsafe ? J = Buffer.allocUnsafe(R.length) : J = new Buffer(R.length), R.copy(J), J;
          t(R, Error) ? J = Object.create(R) : typeof P > "u" ? (K = Object.getPrototypeOf(R), J = Object.create(K)) : (J = Object.create(P), K = P);
        }
        if (_) {
          var ee = M.indexOf(R);
          if (ee != -1)
            return G[ee];
          M.push(R), G.push(J);
        }
        t(R, n) && R.forEach(function(me, fe) {
          var _e = j(fe, te - 1), Re = j(me, te - 1);
          J.set(_e, Re);
        }), t(R, i) && R.forEach(function(me) {
          var fe = j(me, te - 1);
          J.add(fe);
        });
        for (var ve in R) {
          var de;
          K && (de = Object.getOwnPropertyDescriptor(K, ve)), !(de && de.set == null) && (J[ve] = j(R[ve], te - 1));
        }
        if (Object.getOwnPropertySymbols)
          for (var B = Object.getOwnPropertySymbols(R), ve = 0; ve < B.length; ve++) {
            var q = B[ve], H = Object.getOwnPropertyDescriptor(R, q);
            H && !H.enumerable && !N || (J[q] = j(R[q], te - 1), H.enumerable || Object.defineProperty(J, q, {
              enumerable: !1
            }));
          }
        if (N)
          for (var oe = Object.getOwnPropertyNames(R), ve = 0; ve < oe.length; ve++) {
            var ne = oe[ve], H = Object.getOwnPropertyDescriptor(R, ne);
            H && H.enumerable || (J[ne] = j(R[ne], te - 1), Object.defineProperty(J, ne, {
              enumerable: !1
            }));
          }
        return J;
      }
      return j(x, k);
    }
    o.clonePrototype = function(_) {
      if (_ === null)
        return null;
      var k = function() {
      };
      return k.prototype = _, new k();
    };
    function s(x) {
      return Object.prototype.toString.call(x);
    }
    o.__objToStr = s;
    function c(x) {
      return typeof x == "object" && s(x) === "[object Date]";
    }
    o.__isDate = c;
    function h(x) {
      return typeof x == "object" && s(x) === "[object Array]";
    }
    o.__isArray = h;
    function d(x) {
      return typeof x == "object" && s(x) === "[object RegExp]";
    }
    o.__isRegExp = d;
    function g(x) {
      var _ = "";
      return x.global && (_ += "g"), x.ignoreCase && (_ += "i"), x.multiline && (_ += "m"), _;
    }
    return o.__getRegExpFlags = g, o;
  }();
  r.exports && (r.exports = e);
})(r7);
var wS = r7.exports;
const X5 = /* @__PURE__ */ I0(wS);
var Uf = {}, nd = {};
function n7(r) {
  this.buffer = r, this.pos = 0;
}
n7.prototype.read = function(r, e, t) {
  this.pos + t > this.buffer.length && (t = this.buffer.length - this.pos);
  for (var n = 0; n < t; n++)
    r[e + n] = this.buffer[this.pos + n];
  return this.pos += t, t;
};
nd.BrotliInput = n7;
function i7(r) {
  this.buffer = r, this.pos = 0;
}
i7.prototype.write = function(r, e) {
  if (this.pos + e > this.buffer.length)
    throw new Error("Output buffer is not large enough");
  return this.buffer.set(r.subarray(0, e), this.pos), this.pos += e, e;
};
nd.BrotliOutput = i7;
var Hu = 4096, AS = 2 * Hu + 32, a7 = 2 * Hu - 1, xS = new Uint32Array([
  0,
  1,
  3,
  7,
  15,
  31,
  63,
  127,
  255,
  511,
  1023,
  2047,
  4095,
  8191,
  16383,
  32767,
  65535,
  131071,
  262143,
  524287,
  1048575,
  2097151,
  4194303,
  8388607,
  16777215
]);
function _l(r) {
  this.buf_ = new Uint8Array(AS), this.input_ = r, this.reset();
}
_l.READ_SIZE = Hu;
_l.IBUF_MASK = a7;
_l.prototype.reset = function() {
  this.buf_ptr_ = 0, this.val_ = 0, this.pos_ = 0, this.bit_pos_ = 0, this.bit_end_pos_ = 0, this.eos_ = 0, this.readMoreInput();
  for (var r = 0; r < 4; r++)
    this.val_ |= this.buf_[this.pos_] << 8 * r, ++this.pos_;
  return this.bit_end_pos_ > 0;
};
_l.prototype.readMoreInput = function() {
  if (!(this.bit_end_pos_ > 256))
    if (this.eos_) {
      if (this.bit_pos_ > this.bit_end_pos_)
        throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
    } else {
      var r = this.buf_ptr_, e = this.input_.read(this.buf_, r, Hu);
      if (e < 0)
        throw new Error("Unexpected end of input");
      if (e < Hu) {
        this.eos_ = 1;
        for (var t = 0; t < 32; t++)
          this.buf_[r + e + t] = 0;
      }
      if (r === 0) {
        for (var t = 0; t < 32; t++)
          this.buf_[(Hu << 1) + t] = this.buf_[t];
        this.buf_ptr_ = Hu;
      } else
        this.buf_ptr_ = 0;
      this.bit_end_pos_ += e << 3;
    }
};
_l.prototype.fillBitWindow = function() {
  for (; this.bit_pos_ >= 8; )
    this.val_ >>>= 8, this.val_ |= this.buf_[this.pos_ & a7] << 24, ++this.pos_, this.bit_pos_ = this.bit_pos_ - 8 >>> 0, this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
};
_l.prototype.readBits = function(r) {
  32 - this.bit_pos_ < r && this.fillBitWindow();
  var e = this.val_ >>> this.bit_pos_ & xS[r];
  return this.bit_pos_ += r, e;
};
var ES = _l, ws = {}, K5 = {}, J5, cm;
function _S() {
  return cm || (cm = 1, J5 = "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"), J5;
}
var fm;
function DS() {
  if (fm) return K5;
  fm = 1;
  var r = z1;
  return K5.init = function() {
    var e = s7().BrotliDecompressBuffer, t = r.toByteArray(_S());
    return e(t);
  }, K5;
}
var hm;
function o7() {
  if (hm) return ws;
  hm = 1;
  var r = DS();
  return ws.init = function() {
    ws.dictionary = r.init();
  }, ws.offsetsByLength = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
  ]), ws.sizeBitsByLength = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
  ]), ws.minDictionaryWordLength = 4, ws.maxDictionaryWordLength = 24, ws;
}
var id = {};
function bc(r, e) {
  this.bits = r, this.value = e;
}
id.HuffmanCode = bc;
var dc = 15;
function dm(r, e) {
  for (var t = 1 << e - 1; r & t; )
    t >>= 1;
  return (r & t - 1) + t;
}
function pm(r, e, t, n, i) {
  do
    n -= t, r[e + n] = new bc(i.bits, i.value);
  while (n > 0);
}
function TS(r, e, t) {
  for (var n = 1 << e - t; e < dc && (n -= r[e], !(n <= 0)); )
    ++e, n <<= 1;
  return e - t;
}
id.BrotliBuildHuffmanTable = function(r, e, t, n, i) {
  var a = e, o, s, c, h, d, g, x, _, k, P, N, M = new Int32Array(dc + 1), G = new Int32Array(dc + 1);
  for (N = new Int32Array(i), c = 0; c < i; c++)
    M[n[c]]++;
  for (G[1] = 0, s = 1; s < dc; s++)
    G[s + 1] = G[s] + M[s];
  for (c = 0; c < i; c++)
    n[c] !== 0 && (N[G[n[c]]++] = c);
  if (_ = t, k = 1 << _, P = k, G[dc] === 1) {
    for (h = 0; h < P; ++h)
      r[e + h] = new bc(0, N[0] & 65535);
    return P;
  }
  for (h = 0, c = 0, s = 1, d = 2; s <= t; ++s, d <<= 1)
    for (; M[s] > 0; --M[s])
      o = new bc(s & 255, N[c++] & 65535), pm(r, e + h, d, k, o), h = dm(h, s);
  for (x = P - 1, g = -1, s = t + 1, d = 2; s <= dc; ++s, d <<= 1)
    for (; M[s] > 0; --M[s])
      (h & x) !== g && (e += k, _ = TS(M, s, t), k = 1 << _, P += k, g = h & x, r[a + g] = new bc(_ + t & 255, e - a - g & 65535)), o = new bc(s - t & 255, N[c++] & 65535), pm(r, e + (h >> t), d, k, o), h = dm(h, s);
  return P;
};
var Tv = {};
Tv.lookup = new Uint8Array([
  /* CONTEXT_UTF8, last byte. */
  /* ASCII range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  4,
  4,
  0,
  0,
  4,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  8,
  12,
  16,
  12,
  12,
  20,
  12,
  16,
  24,
  28,
  12,
  12,
  32,
  12,
  36,
  12,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  32,
  32,
  24,
  40,
  28,
  12,
  12,
  48,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  24,
  12,
  28,
  12,
  12,
  12,
  56,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  24,
  12,
  28,
  12,
  0,
  /* UTF8 continuation byte range. */
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  /* UTF8 lead byte range. */
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  /* CONTEXT_UTF8 second last byte. */
  /* ASCII range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  1,
  1,
  1,
  1,
  1,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  1,
  1,
  1,
  1,
  0,
  /* UTF8 continuation byte range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  /* UTF8 lead byte range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  /* CONTEXT_SIGNED, second last byte. */
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  7,
  /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
  0,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  56,
  /* CONTEXT_LSB6, last byte. */
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  /* CONTEXT_MSB6, last byte. */
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  6,
  6,
  6,
  6,
  7,
  7,
  7,
  7,
  8,
  8,
  8,
  8,
  9,
  9,
  9,
  9,
  10,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  22,
  22,
  22,
  22,
  23,
  23,
  23,
  23,
  24,
  24,
  24,
  24,
  25,
  25,
  25,
  25,
  26,
  26,
  26,
  26,
  27,
  27,
  27,
  27,
  28,
  28,
  28,
  28,
  29,
  29,
  29,
  29,
  30,
  30,
  30,
  30,
  31,
  31,
  31,
  31,
  32,
  32,
  32,
  32,
  33,
  33,
  33,
  33,
  34,
  34,
  34,
  34,
  35,
  35,
  35,
  35,
  36,
  36,
  36,
  36,
  37,
  37,
  37,
  37,
  38,
  38,
  38,
  38,
  39,
  39,
  39,
  39,
  40,
  40,
  40,
  40,
  41,
  41,
  41,
  41,
  42,
  42,
  42,
  42,
  43,
  43,
  43,
  43,
  44,
  44,
  44,
  44,
  45,
  45,
  45,
  45,
  46,
  46,
  46,
  46,
  47,
  47,
  47,
  47,
  48,
  48,
  48,
  48,
  49,
  49,
  49,
  49,
  50,
  50,
  50,
  50,
  51,
  51,
  51,
  51,
  52,
  52,
  52,
  52,
  53,
  53,
  53,
  53,
  54,
  54,
  54,
  54,
  55,
  55,
  55,
  55,
  56,
  56,
  56,
  56,
  57,
  57,
  57,
  57,
  58,
  58,
  58,
  58,
  59,
  59,
  59,
  59,
  60,
  60,
  60,
  60,
  61,
  61,
  61,
  61,
  62,
  62,
  62,
  62,
  63,
  63,
  63,
  63,
  /* CONTEXT_{M,L}SB6, second last byte, */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0
]);
Tv.lookupOffsets = new Uint16Array([
  /* CONTEXT_LSB6 */
  1024,
  1536,
  /* CONTEXT_MSB6 */
  1280,
  1536,
  /* CONTEXT_UTF8 */
  0,
  256,
  /* CONTEXT_SIGNED */
  768,
  512
]);
var Jc = {};
function Ft(r, e) {
  this.offset = r, this.nbits = e;
}
Jc.kBlockLengthPrefixCode = [
  new Ft(1, 2),
  new Ft(5, 2),
  new Ft(9, 2),
  new Ft(13, 2),
  new Ft(17, 3),
  new Ft(25, 3),
  new Ft(33, 3),
  new Ft(41, 3),
  new Ft(49, 4),
  new Ft(65, 4),
  new Ft(81, 4),
  new Ft(97, 4),
  new Ft(113, 5),
  new Ft(145, 5),
  new Ft(177, 5),
  new Ft(209, 5),
  new Ft(241, 6),
  new Ft(305, 6),
  new Ft(369, 7),
  new Ft(497, 8),
  new Ft(753, 9),
  new Ft(1265, 10),
  new Ft(2289, 11),
  new Ft(4337, 12),
  new Ft(8433, 13),
  new Ft(16625, 24)
];
Jc.kInsertLengthPrefixCode = [
  new Ft(0, 0),
  new Ft(1, 0),
  new Ft(2, 0),
  new Ft(3, 0),
  new Ft(4, 0),
  new Ft(5, 0),
  new Ft(6, 1),
  new Ft(8, 1),
  new Ft(10, 2),
  new Ft(14, 2),
  new Ft(18, 3),
  new Ft(26, 3),
  new Ft(34, 4),
  new Ft(50, 4),
  new Ft(66, 5),
  new Ft(98, 5),
  new Ft(130, 6),
  new Ft(194, 7),
  new Ft(322, 8),
  new Ft(578, 9),
  new Ft(1090, 10),
  new Ft(2114, 12),
  new Ft(6210, 14),
  new Ft(22594, 24)
];
Jc.kCopyLengthPrefixCode = [
  new Ft(2, 0),
  new Ft(3, 0),
  new Ft(4, 0),
  new Ft(5, 0),
  new Ft(6, 0),
  new Ft(7, 0),
  new Ft(8, 0),
  new Ft(9, 0),
  new Ft(10, 1),
  new Ft(12, 1),
  new Ft(14, 2),
  new Ft(18, 2),
  new Ft(22, 3),
  new Ft(30, 3),
  new Ft(38, 4),
  new Ft(54, 4),
  new Ft(70, 5),
  new Ft(102, 5),
  new Ft(134, 6),
  new Ft(198, 7),
  new Ft(326, 8),
  new Ft(582, 9),
  new Ft(1094, 10),
  new Ft(2118, 24)
];
Jc.kInsertRangeLut = [
  0,
  0,
  8,
  8,
  0,
  16,
  8,
  16,
  16
];
Jc.kCopyRangeLut = [
  0,
  8,
  0,
  8,
  16,
  0,
  16,
  8,
  16
];
var $f = {}, vm;
function kS() {
  if (vm) return $f;
  vm = 1;
  var r = o7(), e = 0, t = 1, n = 2, i = 3, a = 4, o = 5, s = 6, c = 7, h = 8, d = 9, g = 10, x = 11, _ = 12, k = 13, P = 14, N = 15, M = 16, G = 17, z = 18, j = 20;
  function R(K, ee, ve) {
    this.prefix = new Uint8Array(K.length), this.transform = ee, this.suffix = new Uint8Array(ve.length);
    for (var de = 0; de < K.length; de++)
      this.prefix[de] = K.charCodeAt(de);
    for (var de = 0; de < ve.length; de++)
      this.suffix[de] = ve.charCodeAt(de);
  }
  var te = [
    new R("", e, ""),
    new R("", e, " "),
    new R(" ", e, " "),
    new R("", _, ""),
    new R("", g, " "),
    new R("", e, " the "),
    new R(" ", e, ""),
    new R("s ", e, " "),
    new R("", e, " of "),
    new R("", g, ""),
    new R("", e, " and "),
    new R("", k, ""),
    new R("", t, ""),
    new R(", ", e, " "),
    new R("", e, ", "),
    new R(" ", g, " "),
    new R("", e, " in "),
    new R("", e, " to "),
    new R("e ", e, " "),
    new R("", e, '"'),
    new R("", e, "."),
    new R("", e, '">'),
    new R("", e, `
`),
    new R("", i, ""),
    new R("", e, "]"),
    new R("", e, " for "),
    new R("", P, ""),
    new R("", n, ""),
    new R("", e, " a "),
    new R("", e, " that "),
    new R(" ", g, ""),
    new R("", e, ". "),
    new R(".", e, ""),
    new R(" ", e, ", "),
    new R("", N, ""),
    new R("", e, " with "),
    new R("", e, "'"),
    new R("", e, " from "),
    new R("", e, " by "),
    new R("", M, ""),
    new R("", G, ""),
    new R(" the ", e, ""),
    new R("", a, ""),
    new R("", e, ". The "),
    new R("", x, ""),
    new R("", e, " on "),
    new R("", e, " as "),
    new R("", e, " is "),
    new R("", c, ""),
    new R("", t, "ing "),
    new R("", e, `
	`),
    new R("", e, ":"),
    new R(" ", e, ". "),
    new R("", e, "ed "),
    new R("", j, ""),
    new R("", z, ""),
    new R("", s, ""),
    new R("", e, "("),
    new R("", g, ", "),
    new R("", h, ""),
    new R("", e, " at "),
    new R("", e, "ly "),
    new R(" the ", e, " of "),
    new R("", o, ""),
    new R("", d, ""),
    new R(" ", g, ", "),
    new R("", g, '"'),
    new R(".", e, "("),
    new R("", x, " "),
    new R("", g, '">'),
    new R("", e, '="'),
    new R(" ", e, "."),
    new R(".com/", e, ""),
    new R(" the ", e, " of the "),
    new R("", g, "'"),
    new R("", e, ". This "),
    new R("", e, ","),
    new R(".", e, " "),
    new R("", g, "("),
    new R("", g, "."),
    new R("", e, " not "),
    new R(" ", e, '="'),
    new R("", e, "er "),
    new R(" ", x, " "),
    new R("", e, "al "),
    new R(" ", x, ""),
    new R("", e, "='"),
    new R("", x, '"'),
    new R("", g, ". "),
    new R(" ", e, "("),
    new R("", e, "ful "),
    new R(" ", g, ". "),
    new R("", e, "ive "),
    new R("", e, "less "),
    new R("", x, "'"),
    new R("", e, "est "),
    new R(" ", g, "."),
    new R("", x, '">'),
    new R(" ", e, "='"),
    new R("", g, ","),
    new R("", e, "ize "),
    new R("", x, "."),
    new R("Â ", e, ""),
    new R(" ", e, ","),
    new R("", g, '="'),
    new R("", x, '="'),
    new R("", e, "ous "),
    new R("", x, ", "),
    new R("", g, "='"),
    new R(" ", g, ","),
    new R(" ", x, '="'),
    new R(" ", x, ", "),
    new R("", x, ","),
    new R("", x, "("),
    new R("", x, ". "),
    new R(" ", x, "."),
    new R("", x, "='"),
    new R(" ", x, ". "),
    new R(" ", g, '="'),
    new R(" ", x, "='"),
    new R(" ", g, "='")
  ];
  $f.kTransforms = te, $f.kNumTransforms = te.length;
  function J(K, ee) {
    return K[ee] < 192 ? (K[ee] >= 97 && K[ee] <= 122 && (K[ee] ^= 32), 1) : K[ee] < 224 ? (K[ee + 1] ^= 32, 2) : (K[ee + 2] ^= 5, 3);
  }
  return $f.transformDictionaryWord = function(K, ee, ve, de, B) {
    var q = te[B].prefix, H = te[B].suffix, oe = te[B].transform, ne = oe < _ ? 0 : oe - (_ - 1), me = 0, fe = ee, _e;
    ne > de && (ne = de);
    for (var Re = 0; Re < q.length; )
      K[ee++] = q[Re++];
    for (ve += ne, de -= ne, oe <= d && (de -= oe), me = 0; me < de; me++)
      K[ee++] = r.dictionary[ve + me];
    if (_e = ee - de, oe === g)
      J(K, _e);
    else if (oe === x)
      for (; de > 0; ) {
        var Ie = J(K, _e);
        _e += Ie, de -= Ie;
      }
    for (var W = 0; W < H.length; )
      K[ee++] = H[W++];
    return ee - fe;
  }, $f;
}
var gm;
function s7() {
  if (gm) return Uf;
  gm = 1;
  var r = nd.BrotliInput, e = nd.BrotliOutput, t = ES, n = o7(), i = id.HuffmanCode, a = id.BrotliBuildHuffmanTable, o = Tv, s = Jc, c = kS(), h = 8, d = 16, g = 256, x = 704, _ = 26, k = 6, P = 2, N = 8, M = 255, G = 1080, z = 18, j = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
  ]), R = 16, te = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
  ]), J = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
  ]), K = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
  ]);
  function ee(be) {
    var he;
    return be.readBits(1) === 0 ? 16 : (he = be.readBits(3), he > 0 ? 17 + he : (he = be.readBits(3), he > 0 ? 8 + he : 17));
  }
  function ve(be) {
    if (be.readBits(1)) {
      var he = be.readBits(3);
      return he === 0 ? 1 : be.readBits(he) + (1 << he);
    }
    return 0;
  }
  function de() {
    this.meta_block_length = 0, this.input_end = 0, this.is_uncompressed = 0, this.is_metadata = !1;
  }
  function B(be) {
    var he = new de(), ke, De, Qe;
    if (he.input_end = be.readBits(1), he.input_end && be.readBits(1))
      return he;
    if (ke = be.readBits(2) + 4, ke === 7) {
      if (he.is_metadata = !0, be.readBits(1) !== 0)
        throw new Error("Invalid reserved bit");
      if (De = be.readBits(2), De === 0)
        return he;
      for (Qe = 0; Qe < De; Qe++) {
        var ct = be.readBits(8);
        if (Qe + 1 === De && De > 1 && ct === 0)
          throw new Error("Invalid size byte");
        he.meta_block_length |= ct << Qe * 8;
      }
    } else
      for (Qe = 0; Qe < ke; ++Qe) {
        var pt = be.readBits(4);
        if (Qe + 1 === ke && ke > 4 && pt === 0)
          throw new Error("Invalid size nibble");
        he.meta_block_length |= pt << Qe * 4;
      }
    return ++he.meta_block_length, !he.input_end && !he.is_metadata && (he.is_uncompressed = be.readBits(1)), he;
  }
  function q(be, he, ke) {
    var De;
    return ke.fillBitWindow(), he += ke.val_ >>> ke.bit_pos_ & M, De = be[he].bits - N, De > 0 && (ke.bit_pos_ += N, he += be[he].value, he += ke.val_ >>> ke.bit_pos_ & (1 << De) - 1), ke.bit_pos_ += be[he].bits, be[he].value;
  }
  function H(be, he, ke, De) {
    for (var Qe = 0, ct = h, pt = 0, _t = 0, S = 32768, b = [], w = 0; w < 32; w++)
      b.push(new i(0, 0));
    for (a(b, 0, 5, be, z); Qe < he && S > 0; ) {
      var T = 0, V;
      if (De.readMoreInput(), De.fillBitWindow(), T += De.val_ >>> De.bit_pos_ & 31, De.bit_pos_ += b[T].bits, V = b[T].value & 255, V < d)
        pt = 0, ke[Qe++] = V, V !== 0 && (ct = V, S -= 32768 >> V);
      else {
        var pe = V - 14, Ee, mt, gt = 0;
        if (V === d && (gt = ct), _t !== gt && (pt = 0, _t = gt), Ee = pt, pt > 0 && (pt -= 2, pt <<= pe), pt += De.readBits(pe) + 3, mt = pt - Ee, Qe + mt > he)
          throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
        for (var St = 0; St < mt; St++)
          ke[Qe + St] = _t;
        Qe += mt, _t !== 0 && (S -= mt << 15 - _t);
      }
    }
    if (S !== 0)
      throw new Error("[ReadHuffmanCodeLengths] space = " + S);
    for (; Qe < he; Qe++)
      ke[Qe] = 0;
  }
  function oe(be, he, ke, De) {
    var Qe = 0, ct, pt = new Uint8Array(be);
    if (De.readMoreInput(), ct = De.readBits(2), ct === 1) {
      for (var _t, S = be - 1, b = 0, w = new Int32Array(4), T = De.readBits(2) + 1; S; )
        S >>= 1, ++b;
      for (_t = 0; _t < T; ++_t)
        w[_t] = De.readBits(b) % be, pt[w[_t]] = 2;
      switch (pt[w[0]] = 1, T) {
        case 1:
          break;
        case 3:
          if (w[0] === w[1] || w[0] === w[2] || w[1] === w[2])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          break;
        case 2:
          if (w[0] === w[1])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          pt[w[1]] = 1;
          break;
        case 4:
          if (w[0] === w[1] || w[0] === w[2] || w[0] === w[3] || w[1] === w[2] || w[1] === w[3] || w[2] === w[3])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          De.readBits(1) ? (pt[w[2]] = 3, pt[w[3]] = 3) : pt[w[0]] = 2;
          break;
      }
    } else {
      var _t, V = new Uint8Array(z), pe = 32, Ee = 0, mt = [
        new i(2, 0),
        new i(2, 4),
        new i(2, 3),
        new i(3, 2),
        new i(2, 0),
        new i(2, 4),
        new i(2, 3),
        new i(4, 1),
        new i(2, 0),
        new i(2, 4),
        new i(2, 3),
        new i(3, 2),
        new i(2, 0),
        new i(2, 4),
        new i(2, 3),
        new i(4, 5)
      ];
      for (_t = ct; _t < z && pe > 0; ++_t) {
        var gt = j[_t], St = 0, Bt;
        De.fillBitWindow(), St += De.val_ >>> De.bit_pos_ & 15, De.bit_pos_ += mt[St].bits, Bt = mt[St].value, V[gt] = Bt, Bt !== 0 && (pe -= 32 >> Bt, ++Ee);
      }
      if (!(Ee === 1 || pe === 0))
        throw new Error("[ReadHuffmanCode] invalid num_codes or space");
      H(V, be, pt, De);
    }
    if (Qe = a(he, ke, N, pt, be), Qe === 0)
      throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return Qe;
  }
  function ne(be, he, ke) {
    var De, Qe;
    return De = q(be, he, ke), Qe = s.kBlockLengthPrefixCode[De].nbits, s.kBlockLengthPrefixCode[De].offset + ke.readBits(Qe);
  }
  function me(be, he, ke) {
    var De;
    return be < R ? (ke += te[be], ke &= 3, De = he[ke] + J[be]) : De = be - R + 1, De;
  }
  function fe(be, he) {
    for (var ke = be[he], De = he; De; --De) be[De] = be[De - 1];
    be[0] = ke;
  }
  function _e(be, he) {
    var ke = new Uint8Array(256), De;
    for (De = 0; De < 256; ++De)
      ke[De] = De;
    for (De = 0; De < he; ++De) {
      var Qe = be[De];
      be[De] = ke[Qe], Qe && fe(ke, Qe);
    }
  }
  function Re(be, he) {
    this.alphabet_size = be, this.num_htrees = he, this.codes = new Array(he + he * K[be + 31 >>> 5]), this.htrees = new Uint32Array(he);
  }
  Re.prototype.decode = function(be) {
    var he, ke, De = 0;
    for (he = 0; he < this.num_htrees; ++he)
      this.htrees[he] = De, ke = oe(this.alphabet_size, this.codes, De, be), De += ke;
  };
  function Ie(be, he) {
    var ke = { num_htrees: null, context_map: null }, De, Qe = 0, ct, pt;
    he.readMoreInput();
    var _t = ke.num_htrees = ve(he) + 1, S = ke.context_map = new Uint8Array(be);
    if (_t <= 1)
      return ke;
    for (De = he.readBits(1), De && (Qe = he.readBits(4) + 1), ct = [], pt = 0; pt < G; pt++)
      ct[pt] = new i(0, 0);
    for (oe(_t + Qe, ct, 0, he), pt = 0; pt < be; ) {
      var b;
      if (he.readMoreInput(), b = q(ct, 0, he), b === 0)
        S[pt] = 0, ++pt;
      else if (b <= Qe)
        for (var w = 1 + (1 << b) + he.readBits(b); --w; ) {
          if (pt >= be)
            throw new Error("[DecodeContextMap] i >= context_map_size");
          S[pt] = 0, ++pt;
        }
      else
        S[pt] = b - Qe, ++pt;
    }
    return he.readBits(1) && _e(S, be), ke;
  }
  function W(be, he, ke, De, Qe, ct, pt) {
    var _t = ke * 2, S = ke, b = q(he, ke * G, pt), w;
    b === 0 ? w = Qe[_t + (ct[S] & 1)] : b === 1 ? w = Qe[_t + (ct[S] - 1 & 1)] + 1 : w = b - 2, w >= be && (w -= be), De[ke] = w, Qe[_t + (ct[S] & 1)] = w, ++ct[S];
  }
  function Z(be, he, ke, De, Qe, ct) {
    var pt = Qe + 1, _t = ke & Qe, S = ct.pos_ & t.IBUF_MASK, b;
    if (he < 8 || ct.bit_pos_ + (he << 3) < ct.bit_end_pos_) {
      for (; he-- > 0; )
        ct.readMoreInput(), De[_t++] = ct.readBits(8), _t === pt && (be.write(De, pt), _t = 0);
      return;
    }
    if (ct.bit_end_pos_ < 32)
      throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
    for (; ct.bit_pos_ < 32; )
      De[_t] = ct.val_ >>> ct.bit_pos_, ct.bit_pos_ += 8, ++_t, --he;
    if (b = ct.bit_end_pos_ - ct.bit_pos_ >> 3, S + b > t.IBUF_MASK) {
      for (var w = t.IBUF_MASK + 1 - S, T = 0; T < w; T++)
        De[_t + T] = ct.buf_[S + T];
      b -= w, _t += w, he -= w, S = 0;
    }
    for (var T = 0; T < b; T++)
      De[_t + T] = ct.buf_[S + T];
    if (_t += b, he -= b, _t >= pt) {
      be.write(De, pt), _t -= pt;
      for (var T = 0; T < _t; T++)
        De[T] = De[pt + T];
    }
    for (; _t + he >= pt; ) {
      if (b = pt - _t, ct.input_.read(De, _t, b) < b)
        throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
      be.write(De, pt), he -= b, _t = 0;
    }
    if (ct.input_.read(De, _t, he) < he)
      throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
    ct.reset();
  }
  function se(be) {
    var he = be.bit_pos_ + 7 & -8, ke = be.readBits(he - be.bit_pos_);
    return ke == 0;
  }
  function ye(be) {
    var he = new r(be), ke = new t(he);
    ee(ke);
    var De = B(ke);
    return De.meta_block_length;
  }
  Uf.BrotliDecompressedSize = ye;
  function Fe(be, he) {
    var ke = new r(be);
    he == null && (he = ye(be));
    var De = new Uint8Array(he), Qe = new e(De);
    return xe(ke, Qe), Qe.pos < Qe.buffer.length && (Qe.buffer = Qe.buffer.subarray(0, Qe.pos)), Qe.buffer;
  }
  Uf.BrotliDecompressBuffer = Fe;
  function xe(be, he) {
    var ke, De = 0, Qe = 0, ct = 0, pt, _t = 0, S, b, w, T, V = [16, 15, 11, 4], pe = 0, Ee = 0, mt = 0, gt = [new Re(0, 0), new Re(0, 0), new Re(0, 0)], St, Bt, yt, P0 = 128 + t.READ_SIZE;
    yt = new t(be), ct = ee(yt), pt = (1 << ct) - 16, S = 1 << ct, b = S - 1, w = new Uint8Array(S + P0 + n.maxDictionaryWordLength), T = S, St = [], Bt = [];
    for (var E0 = 0; E0 < 3 * G; E0++)
      St[E0] = new i(0, 0), Bt[E0] = new i(0, 0);
    for (; !Qe; ) {
      var Er = 0, Ba, B0 = [1 << 28, 1 << 28, 1 << 28], z0 = [0], N0 = [1, 1, 1], On = [0, 1, 0, 1, 0, 1], Pi = [0], j0, gi, dn, da, os = null, Bi = null, on, Rn = null, ss, cr = 0, dr = null, ei = 0, _0 = 0, br = null, _r = 0, W0 = 0, r0 = 0, g0, zn;
      for (ke = 0; ke < 3; ++ke)
        gt[ke].codes = null, gt[ke].htrees = null;
      yt.readMoreInput();
      var jn = B(yt);
      if (Er = jn.meta_block_length, De + Er > he.buffer.length) {
        var L0 = new Uint8Array(De + Er);
        L0.set(he.buffer), he.buffer = L0;
      }
      if (Qe = jn.input_end, Ba = jn.is_uncompressed, jn.is_metadata) {
        for (se(yt); Er > 0; --Er)
          yt.readMoreInput(), yt.readBits(8);
        continue;
      }
      if (Er !== 0) {
        if (Ba) {
          yt.bit_pos_ = yt.bit_pos_ + 7 & -8, Z(
            he,
            Er,
            De,
            w,
            b,
            yt
          ), De += Er;
          continue;
        }
        for (ke = 0; ke < 3; ++ke)
          N0[ke] = ve(yt) + 1, N0[ke] >= 2 && (oe(N0[ke] + 2, St, ke * G, yt), oe(_, Bt, ke * G, yt), B0[ke] = ne(Bt, ke * G, yt), Pi[ke] = 1);
        for (yt.readMoreInput(), j0 = yt.readBits(2), gi = R + (yt.readBits(4) << j0), dn = (1 << j0) - 1, da = gi + (48 << j0), Bi = new Uint8Array(N0[0]), ke = 0; ke < N0[0]; ++ke)
          yt.readMoreInput(), Bi[ke] = yt.readBits(2) << 1;
        var Ni = Ie(N0[0] << k, yt);
        on = Ni.num_htrees, os = Ni.context_map;
        var Na = Ie(N0[2] << P, yt);
        for (ss = Na.num_htrees, Rn = Na.context_map, gt[0] = new Re(g, on), gt[1] = new Re(x, N0[1]), gt[2] = new Re(da, ss), ke = 0; ke < 3; ++ke)
          gt[ke].decode(yt);
        for (dr = 0, br = 0, g0 = Bi[z0[0]], W0 = o.lookupOffsets[g0], r0 = o.lookupOffsets[g0 + 1], zn = gt[1].htrees[0]; Er > 0; ) {
          var pa, Li, Mi, va, Ui, m0, G0, In, rt, bt, $t;
          for (yt.readMoreInput(), B0[1] === 0 && (W(
            N0[1],
            St,
            1,
            z0,
            On,
            Pi,
            yt
          ), B0[1] = ne(Bt, G, yt), zn = gt[1].htrees[z0[1]]), --B0[1], pa = q(gt[1].codes, zn, yt), Li = pa >> 6, Li >= 2 ? (Li -= 2, G0 = -1) : G0 = 0, Mi = s.kInsertRangeLut[Li] + (pa >> 3 & 7), va = s.kCopyRangeLut[Li] + (pa & 7), Ui = s.kInsertLengthPrefixCode[Mi].offset + yt.readBits(s.kInsertLengthPrefixCode[Mi].nbits), m0 = s.kCopyLengthPrefixCode[va].offset + yt.readBits(s.kCopyLengthPrefixCode[va].nbits), Ee = w[De - 1 & b], mt = w[De - 2 & b], bt = 0; bt < Ui; ++bt)
            yt.readMoreInput(), B0[0] === 0 && (W(
              N0[0],
              St,
              0,
              z0,
              On,
              Pi,
              yt
            ), B0[0] = ne(Bt, 0, yt), cr = z0[0] << k, dr = cr, g0 = Bi[z0[0]], W0 = o.lookupOffsets[g0], r0 = o.lookupOffsets[g0 + 1]), rt = o.lookup[W0 + Ee] | o.lookup[r0 + mt], ei = os[dr + rt], --B0[0], mt = Ee, Ee = q(gt[0].codes, gt[0].htrees[ei], yt), w[De & b] = Ee, (De & b) === b && he.write(w, S), ++De;
          if (Er -= Ui, Er <= 0) break;
          if (G0 < 0) {
            var rt;
            if (yt.readMoreInput(), B0[2] === 0 && (W(
              N0[2],
              St,
              2,
              z0,
              On,
              Pi,
              yt
            ), B0[2] = ne(Bt, 2 * G, yt), _0 = z0[2] << P, br = _0), --B0[2], rt = (m0 > 4 ? 3 : m0 - 2) & 255, _r = Rn[br + rt], G0 = q(gt[2].codes, gt[2].htrees[_r], yt), G0 >= gi) {
              var Qt, n0, Nr;
              G0 -= gi, n0 = G0 & dn, G0 >>= j0, Qt = (G0 >> 1) + 1, Nr = (2 + (G0 & 1) << Qt) - 4, G0 = gi + (Nr + yt.readBits(Qt) << j0) + n0;
            }
          }
          if (In = me(G0, V, pe), In < 0)
            throw new Error("[BrotliDecompress] invalid distance");
          if (De < pt && _t !== pt ? _t = De : _t = pt, $t = De & b, In > _t)
            if (m0 >= n.minDictionaryWordLength && m0 <= n.maxDictionaryWordLength) {
              var Nr = n.offsetsByLength[m0], V0 = In - _t - 1, y0 = n.sizeBitsByLength[m0], u0 = (1 << y0) - 1, ie = V0 & u0, re = V0 >> y0;
              if (Nr += ie * m0, re < c.kNumTransforms) {
                var Q = c.transformDictionaryWord(w, $t, Nr, m0, re);
                if ($t += Q, De += Q, Er -= Q, $t >= T) {
                  he.write(w, S);
                  for (var we = 0; we < $t - T; we++)
                    w[we] = w[T + we];
                }
              } else
                throw new Error("Invalid backward reference. pos: " + De + " distance: " + In + " len: " + m0 + " bytes left: " + Er);
            } else
              throw new Error("Invalid backward reference. pos: " + De + " distance: " + In + " len: " + m0 + " bytes left: " + Er);
          else {
            if (G0 > 0 && (V[pe & 3] = In, ++pe), m0 > Er)
              throw new Error("Invalid backward reference. pos: " + De + " distance: " + In + " len: " + m0 + " bytes left: " + Er);
            for (bt = 0; bt < m0; ++bt)
              w[De & b] = w[De - In & b], (De & b) === b && he.write(w, S), ++De, --Er;
          }
          Ee = w[De - 1 & b], mt = w[De - 2 & b];
        }
        De &= 1073741823;
      }
    }
    he.write(w, De & b);
  }
  return Uf.BrotliDecompress = xe, n.init(), Uf;
}
var SS = s7().BrotliDecompressBuffer;
const CS = /* @__PURE__ */ I0(SS);
function G1(r, e, t, n) {
  Object.defineProperty(r, e, { get: t, set: n, enumerable: !0, configurable: !0 });
}
function jd(r) {
  return r && r.__esModule ? r.default : r;
}
var V1 = {};
G1(V1, "logErrors", () => FS);
G1(V1, "registerFormat", () => Qc);
G1(V1, "create", () => v1);
G1(V1, "defaultLanguage", () => ad);
G1(V1, "setDefaultLanguage", () => OS);
let FS = !1, K4 = [];
function Qc(r) {
  K4.push(r);
}
function v1(r, e) {
  for (let t = 0; t < K4.length; t++) {
    let n = K4[t];
    if (n.probe(r)) {
      let i = new n(new kn(r));
      return e ? i.getFont(e) : i;
    }
  }
  throw new Error("Unknown font format");
}
let ad = "en";
function OS(r = "en") {
  ad = r;
}
function Fn(r, e, t) {
  if (t.get) {
    let n = t.get;
    t.get = function() {
      let i = n.call(this);
      return Object.defineProperty(this, e, {
        value: i
      }), i;
    };
  } else if (typeof t.value == "function") {
    let n = t.value;
    return {
      get() {
        let i = /* @__PURE__ */ new Map();
        function a(...o) {
          let s = o.length > 0 ? o[0] : "value";
          if (i.has(s)) return i.get(s);
          let c = n.apply(this, o);
          return i.set(s, c), c;
        }
        return Object.defineProperty(this, e, {
          value: a
        }), a;
      }
    };
  }
}
let RS = new Me({
  firstCode: O,
  entryCount: O,
  idDelta: lt,
  idRangeOffset: O
}), Q5 = new Me({
  startCharCode: Oe,
  endCharCode: Oe,
  glyphID: Oe
}), IS = new Me({
  startUnicodeValue: Xs,
  additionalCount: kt
}), PS = new Me({
  unicodeValue: Xs,
  glyphID: O
}), BS = new Te(IS, Oe), NS = new Te(PS, Oe), LS = new Me({
  varSelector: Xs,
  defaultUVS: new Se(Oe, BS, {
    type: "parent"
  }),
  nonDefaultUVS: new Se(Oe, NS, {
    type: "parent"
  })
}), MS = new or(O, {
  0: {
    length: O,
    language: O,
    codeMap: new Hr(kt, 256)
  },
  2: {
    length: O,
    language: O,
    subHeaderKeys: new Te(O, 256),
    subHeaderCount: (r) => Math.max.apply(Math, r.subHeaderKeys),
    subHeaders: new Hr(RS, "subHeaderCount"),
    glyphIndexArray: new Hr(O, "subHeaderCount")
  },
  4: {
    length: O,
    language: O,
    segCountX2: O,
    segCount: (r) => r.segCountX2 >> 1,
    searchRange: O,
    entrySelector: O,
    rangeShift: O,
    endCode: new Hr(O, "segCount"),
    reservedPad: new o0(O),
    startCode: new Hr(O, "segCount"),
    idDelta: new Hr(lt, "segCount"),
    idRangeOffset: new Hr(O, "segCount"),
    glyphIndexArray: new Hr(O, (r) => (r.length - r._currentOffset) / 2)
  },
  6: {
    length: O,
    language: O,
    firstCode: O,
    entryCount: O,
    glyphIndices: new Hr(O, "entryCount")
  },
  8: {
    reserved: new o0(O),
    length: Oe,
    language: O,
    is32: new Hr(kt, 8192),
    nGroups: Oe,
    groups: new Hr(Q5, "nGroups")
  },
  10: {
    reserved: new o0(O),
    length: Oe,
    language: Oe,
    firstCode: Oe,
    entryCount: Oe,
    glyphIndices: new Hr(O, "numChars")
  },
  12: {
    reserved: new o0(O),
    length: Oe,
    language: Oe,
    nGroups: Oe,
    groups: new Hr(Q5, "nGroups")
  },
  13: {
    reserved: new o0(O),
    length: Oe,
    language: Oe,
    nGroups: Oe,
    groups: new Hr(Q5, "nGroups")
  },
  14: {
    length: Oe,
    numRecords: Oe,
    varSelectors: new Hr(LS, "numRecords")
  }
}), US = new Me({
  platformID: O,
  encodingID: O,
  table: new Se(Oe, MS, {
    type: "parent",
    lazy: !0
  })
});
var $S = new Me({
  version: O,
  numSubtables: O,
  tables: new Te(US, "numSubtables")
}), zS = new Me({
  version: Yu,
  revision: Yu,
  checkSumAdjustment: Oe,
  magicNumber: Oe,
  flags: O,
  unitsPerEm: O,
  created: new Te(Yu, 2),
  modified: new Te(Yu, 2),
  xMin: lt,
  yMin: lt,
  xMax: lt,
  yMax: lt,
  macStyle: new ka(O, [
    "bold",
    "italic",
    "underline",
    "outline",
    "shadow",
    "condensed",
    "extended"
  ]),
  lowestRecPPEM: O,
  fontDirectionHint: lt,
  indexToLocFormat: lt,
  glyphDataFormat: lt
  // 0 for current format
}), jS = new Me({
  version: Yu,
  ascent: lt,
  descent: lt,
  lineGap: lt,
  advanceWidthMax: O,
  minLeftSideBearing: lt,
  minRightSideBearing: lt,
  xMaxExtent: lt,
  caretSlopeRise: lt,
  caretSlopeRun: lt,
  caretOffset: lt,
  reserved: new o0(lt, 4),
  metricDataFormat: lt,
  numberOfMetrics: O
  // Number of advance widths in 'hmtx' table
});
let WS = new Me({
  advance: O,
  bearing: lt
});
var GS = new Me({
  metrics: new Hr(WS, (r) => r.parent.hhea.numberOfMetrics),
  bearings: new Hr(lt, (r) => r.parent.maxp.numGlyphs - r.parent.hhea.numberOfMetrics)
}), VS = new Me({
  version: Yu,
  numGlyphs: O,
  maxPoints: O,
  maxContours: O,
  maxComponentPoints: O,
  maxComponentContours: O,
  maxZones: O,
  maxTwilightPoints: O,
  maxStorage: O,
  maxFunctionDefs: O,
  maxInstructionDefs: O,
  maxStackElements: O,
  maxSizeOfInstructions: O,
  maxComponentElements: O,
  maxComponentDepth: O
  // Maximum levels of recursion; 1 for simple components
});
function u7(r, e, t = 0) {
  return r === 1 && mm[t] ? mm[t] : qS[r][e];
}
const YS = /* @__PURE__ */ new Set([
  "x-mac-roman",
  "x-mac-cyrillic",
  "iso-8859-6",
  "iso-8859-8"
]), HS = {
  "x-mac-croatian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ",
  "x-mac-gaelic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ",
  "x-mac-greek": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­",
  "x-mac-icelandic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-inuit": "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł",
  "x-mac-ce": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
  "x-mac-romanian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-turkish": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
}, ep = /* @__PURE__ */ new Map();
function ZS(r) {
  let e = ep.get(r);
  if (e) return e;
  let t = HS[r];
  if (t) {
    let n = /* @__PURE__ */ new Map();
    for (let i = 0; i < t.length; i++) n.set(t.charCodeAt(i), 128 + i);
    return ep.set(r, n), n;
  }
  if (YS.has(r)) {
    let n = new TextDecoder(r), i = new Uint8Array(128);
    for (let s = 0; s < 128; s++) i[s] = 128 + s;
    let a = /* @__PURE__ */ new Map(), o = n.decode(i);
    for (let s = 0; s < 128; s++) a.set(o.charCodeAt(s), 128 + s);
    return ep.set(r, a), a;
  }
}
const qS = [
  // unicode
  [
    "utf16be",
    "utf16be",
    "utf16be",
    "utf16be",
    "utf16be",
    "utf16be"
  ],
  // macintosh
  // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
  // 0	Roman                 17	Malayalam
  // 1	Japanese	            18	Sinhalese
  // 2	Traditional Chinese	  19	Burmese
  // 3	Korean	              20	Khmer
  // 4	Arabic	              21	Thai
  // 5	Hebrew	              22	Laotian
  // 6	Greek	                23	Georgian
  // 7	Russian	              24	Armenian
  // 8	RSymbol	              25	Simplified Chinese
  // 9	Devanagari	          26	Tibetan
  // 10	Gurmukhi	            27	Mongolian
  // 11	Gujarati	            28	Geez
  // 12	Oriya	                29	Slavic
  // 13	Bengali	              30	Vietnamese
  // 14	Tamil	                31	Sindhi
  // 15	Telugu	              32	(Uninterpreted)
  // 16	Kannada
  [
    "x-mac-roman",
    "shift-jis",
    "big5",
    "euc-kr",
    "iso-8859-6",
    "iso-8859-8",
    "x-mac-greek",
    "x-mac-cyrillic",
    "x-mac-symbol",
    "x-mac-devanagari",
    "x-mac-gurmukhi",
    "x-mac-gujarati",
    "Oriya",
    "Bengali",
    "Tamil",
    "Telugu",
    "Kannada",
    "Malayalam",
    "Sinhalese",
    "Burmese",
    "Khmer",
    "iso-8859-11",
    "Laotian",
    "Georgian",
    "Armenian",
    "hz-gb-2312",
    "Tibetan",
    "Mongolian",
    "Geez",
    "x-mac-ce",
    "Vietnamese",
    "Sindhi"
  ],
  // ISO (deprecated)
  [
    "ascii"
  ],
  // windows
  // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
  [
    "symbol",
    "utf16be",
    "shift-jis",
    "gb18030",
    "big5",
    "x-cp20949",
    "johab",
    null,
    null,
    null,
    "utf16be"
  ]
], mm = {
  15: "x-mac-icelandic",
  17: "x-mac-turkish",
  18: "x-mac-croatian",
  24: "x-mac-ce",
  25: "x-mac-ce",
  26: "x-mac-ce",
  27: "x-mac-ce",
  28: "x-mac-ce",
  30: "x-mac-icelandic",
  37: "x-mac-romanian",
  38: "x-mac-ce",
  39: "x-mac-ce",
  40: "x-mac-ce",
  143: "x-mac-inuit",
  146: "x-mac-gaelic"
}, XS = [
  // unicode
  [],
  {
    0: "en",
    30: "fo",
    60: "ks",
    90: "rw",
    1: "fr",
    31: "fa",
    61: "ku",
    91: "rn",
    2: "de",
    32: "ru",
    62: "sd",
    92: "ny",
    3: "it",
    33: "zh",
    63: "bo",
    93: "mg",
    4: "nl",
    34: "nl-BE",
    64: "ne",
    94: "eo",
    5: "sv",
    35: "ga",
    65: "sa",
    128: "cy",
    6: "es",
    36: "sq",
    66: "mr",
    129: "eu",
    7: "da",
    37: "ro",
    67: "bn",
    130: "ca",
    8: "pt",
    38: "cz",
    68: "as",
    131: "la",
    9: "no",
    39: "sk",
    69: "gu",
    132: "qu",
    10: "he",
    40: "si",
    70: "pa",
    133: "gn",
    11: "ja",
    41: "yi",
    71: "or",
    134: "ay",
    12: "ar",
    42: "sr",
    72: "ml",
    135: "tt",
    13: "fi",
    43: "mk",
    73: "kn",
    136: "ug",
    14: "el",
    44: "bg",
    74: "ta",
    137: "dz",
    15: "is",
    45: "uk",
    75: "te",
    138: "jv",
    16: "mt",
    46: "be",
    76: "si",
    139: "su",
    17: "tr",
    47: "uz",
    77: "my",
    140: "gl",
    18: "hr",
    48: "kk",
    78: "km",
    141: "af",
    19: "zh-Hant",
    49: "az-Cyrl",
    79: "lo",
    142: "br",
    20: "ur",
    50: "az-Arab",
    80: "vi",
    143: "iu",
    21: "hi",
    51: "hy",
    81: "id",
    144: "gd",
    22: "th",
    52: "ka",
    82: "tl",
    145: "gv",
    23: "ko",
    53: "mo",
    83: "ms",
    146: "ga",
    24: "lt",
    54: "ky",
    84: "ms-Arab",
    147: "to",
    25: "pl",
    55: "tg",
    85: "am",
    148: "el-polyton",
    26: "hu",
    56: "tk",
    86: "ti",
    149: "kl",
    27: "es",
    57: "mn-CN",
    87: "om",
    150: "az",
    28: "lv",
    58: "mn",
    88: "so",
    151: "nn",
    29: "se",
    59: "ps",
    89: "sw"
  },
  // ISO (deprecated)
  [],
  {
    1078: "af",
    16393: "en-IN",
    1159: "rw",
    1074: "tn",
    1052: "sq",
    6153: "en-IE",
    1089: "sw",
    1115: "si",
    1156: "gsw",
    8201: "en-JM",
    1111: "kok",
    1051: "sk",
    1118: "am",
    17417: "en-MY",
    1042: "ko",
    1060: "sl",
    5121: "ar-DZ",
    5129: "en-NZ",
    1088: "ky",
    11274: "es-AR",
    15361: "ar-BH",
    13321: "en-PH",
    1108: "lo",
    16394: "es-BO",
    3073: "ar",
    18441: "en-SG",
    1062: "lv",
    13322: "es-CL",
    2049: "ar-IQ",
    7177: "en-ZA",
    1063: "lt",
    9226: "es-CO",
    11265: "ar-JO",
    11273: "en-TT",
    2094: "dsb",
    5130: "es-CR",
    13313: "ar-KW",
    2057: "en-GB",
    1134: "lb",
    7178: "es-DO",
    12289: "ar-LB",
    1033: "en",
    1071: "mk",
    12298: "es-EC",
    4097: "ar-LY",
    12297: "en-ZW",
    2110: "ms-BN",
    17418: "es-SV",
    6145: "ary",
    1061: "et",
    1086: "ms",
    4106: "es-GT",
    8193: "ar-OM",
    1080: "fo",
    1100: "ml",
    18442: "es-HN",
    16385: "ar-QA",
    1124: "fil",
    1082: "mt",
    2058: "es-MX",
    1025: "ar-SA",
    1035: "fi",
    1153: "mi",
    19466: "es-NI",
    10241: "ar-SY",
    2060: "fr-BE",
    1146: "arn",
    6154: "es-PA",
    7169: "aeb",
    3084: "fr-CA",
    1102: "mr",
    15370: "es-PY",
    14337: "ar-AE",
    1036: "fr",
    1148: "moh",
    10250: "es-PE",
    9217: "ar-YE",
    5132: "fr-LU",
    1104: "mn",
    20490: "es-PR",
    1067: "hy",
    6156: "fr-MC",
    2128: "mn-CN",
    3082: "es",
    1101: "as",
    4108: "fr-CH",
    1121: "ne",
    1034: "es",
    2092: "az-Cyrl",
    1122: "fy",
    1044: "nb",
    21514: "es-US",
    1068: "az",
    1110: "gl",
    2068: "nn",
    14346: "es-UY",
    1133: "ba",
    1079: "ka",
    1154: "oc",
    8202: "es-VE",
    1069: "eu",
    3079: "de-AT",
    1096: "or",
    2077: "sv-FI",
    1059: "be",
    1031: "de",
    1123: "ps",
    1053: "sv",
    2117: "bn",
    5127: "de-LI",
    1045: "pl",
    1114: "syr",
    1093: "bn-IN",
    4103: "de-LU",
    1046: "pt",
    1064: "tg",
    8218: "bs-Cyrl",
    2055: "de-CH",
    2070: "pt-PT",
    2143: "tzm",
    5146: "bs",
    1032: "el",
    1094: "pa",
    1097: "ta",
    1150: "br",
    1135: "kl",
    1131: "qu-BO",
    1092: "tt",
    1026: "bg",
    1095: "gu",
    2155: "qu-EC",
    1098: "te",
    1027: "ca",
    1128: "ha",
    3179: "qu",
    1054: "th",
    3076: "zh-HK",
    1037: "he",
    1048: "ro",
    1105: "bo",
    5124: "zh-MO",
    1081: "hi",
    1047: "rm",
    1055: "tr",
    2052: "zh",
    1038: "hu",
    1049: "ru",
    1090: "tk",
    4100: "zh-SG",
    1039: "is",
    9275: "smn",
    1152: "ug",
    1028: "zh-TW",
    1136: "ig",
    4155: "smj-NO",
    1058: "uk",
    1155: "co",
    1057: "id",
    5179: "smj",
    1070: "hsb",
    1050: "hr",
    1117: "iu",
    3131: "se-FI",
    1056: "ur",
    4122: "hr-BA",
    2141: "iu-Latn",
    1083: "se",
    2115: "uz-Cyrl",
    1029: "cs",
    2108: "ga",
    2107: "se-SE",
    1091: "uz",
    1030: "da",
    1076: "xh",
    8251: "sms",
    1066: "vi",
    1164: "prs",
    1077: "zu",
    6203: "sma-NO",
    1106: "cy",
    1125: "dv",
    1040: "it",
    7227: "sms",
    1160: "wo",
    2067: "nl-BE",
    2064: "it-CH",
    1103: "sa",
    1157: "sah",
    1043: "nl",
    1041: "ja",
    7194: "sr-Cyrl-BA",
    1144: "ii",
    3081: "en-AU",
    1099: "kn",
    3098: "sr",
    1130: "yo",
    10249: "en-BZ",
    1087: "kk",
    6170: "sr-Latn-BA",
    4105: "en-CA",
    1107: "km",
    2074: "sr-Latn",
    9225: "en-029",
    1158: "quc",
    1132: "nso"
  }
];
let ym = new Me({
  platformID: O,
  encodingID: O,
  languageID: O,
  nameID: O,
  length: O,
  string: new Se(O, new Ur("length", (r) => u7(r.platformID, r.encodingID, r.languageID)), {
    type: "parent",
    relativeTo: (r) => r.parent.stringOffset,
    allowNull: !1
  })
}), KS = new Me({
  length: O,
  tag: new Se(O, new Ur("length", "utf16be"), {
    type: "parent",
    relativeTo: (r) => r.stringOffset
  })
});
var od = new or(O, {
  0: {
    count: O,
    stringOffset: O,
    records: new Te(ym, "count")
  },
  1: {
    count: O,
    stringOffset: O,
    records: new Te(ym, "count"),
    langTagCount: O,
    langTags: new Te(KS, "langTagCount")
  }
}), JS = od;
const J4 = [
  "copyright",
  "fontFamily",
  "fontSubfamily",
  "uniqueSubfamily",
  "fullName",
  "version",
  "postscriptName",
  "trademark",
  "manufacturer",
  "designer",
  "description",
  "vendorURL",
  "designerURL",
  "license",
  "licenseURL",
  null,
  "preferredFamily",
  "preferredSubfamily",
  "compatibleFull",
  "sampleText",
  "postscriptCIDFontName",
  "wwsFamilyName",
  "wwsSubfamilyName"
];
od.process = function(r) {
  var e = {};
  for (let t of this.records) {
    let n = XS[t.platformID][t.languageID];
    n == null && this.langTags != null && t.languageID >= 32768 && (n = this.langTags[t.languageID - 32768].tag), n == null && (n = t.platformID + "-" + t.languageID);
    let i = t.nameID >= 256 ? "fontFeatures" : J4[t.nameID] || t.nameID;
    e[i] == null && (e[i] = {});
    let a = e[i];
    t.nameID >= 256 && (a = a[t.nameID] || (a[t.nameID] = {})), (typeof t.string == "string" || typeof a[n] != "string") && (a[n] = t.string);
  }
  this.records = e;
};
od.preEncode = function() {
  if (Array.isArray(this.records)) return;
  this.version = 0;
  let r = [];
  for (let e in this.records) {
    let t = this.records[e];
    e !== "fontFeatures" && (r.push({
      platformID: 3,
      encodingID: 1,
      languageID: 1033,
      nameID: J4.indexOf(e),
      length: t.en.length * 2,
      string: t.en
    }), e === "postscriptName" && r.push({
      platformID: 1,
      encodingID: 0,
      languageID: 0,
      nameID: J4.indexOf(e),
      length: t.en.length,
      string: t.en
    }));
  }
  this.records = r, this.count = r.length, this.stringOffset = od.size(this, null, !1);
};
var l7 = new or(O, {
  header: {
    xAvgCharWidth: lt,
    usWeightClass: O,
    usWidthClass: O,
    fsType: new ka(O, [
      null,
      "noEmbedding",
      "viewOnly",
      "editable",
      null,
      null,
      null,
      null,
      "noSubsetting",
      "bitmapOnly"
    ]),
    ySubscriptXSize: lt,
    ySubscriptYSize: lt,
    ySubscriptXOffset: lt,
    ySubscriptYOffset: lt,
    ySuperscriptXSize: lt,
    ySuperscriptYSize: lt,
    ySuperscriptXOffset: lt,
    ySuperscriptYOffset: lt,
    yStrikeoutSize: lt,
    yStrikeoutPosition: lt,
    sFamilyClass: lt,
    panose: new Te(kt, 10),
    ulCharRange: new Te(Oe, 4),
    vendorID: new Ur(4),
    fsSelection: new ka(O, [
      "italic",
      "underscore",
      "negative",
      "outlined",
      "strikeout",
      "bold",
      "regular",
      "useTypoMetrics",
      "wws",
      "oblique"
    ]),
    usFirstCharIndex: O,
    usLastCharIndex: O
    // The maximum Unicode index in this font
  },
  // The Apple version of this table ends here, but the Microsoft one continues on...
  0: {},
  1: {
    typoAscender: lt,
    typoDescender: lt,
    typoLineGap: lt,
    winAscent: O,
    winDescent: O,
    codePageRange: new Te(Oe, 2)
  },
  2: {
    // these should be common with version 1 somehow
    typoAscender: lt,
    typoDescender: lt,
    typoLineGap: lt,
    winAscent: O,
    winDescent: O,
    codePageRange: new Te(Oe, 2),
    xHeight: lt,
    capHeight: lt,
    defaultChar: O,
    breakChar: O,
    maxContent: O
  },
  5: {
    typoAscender: lt,
    typoDescender: lt,
    typoLineGap: lt,
    winAscent: O,
    winDescent: O,
    codePageRange: new Te(Oe, 2),
    xHeight: lt,
    capHeight: lt,
    defaultChar: O,
    breakChar: O,
    maxContent: O,
    usLowerOpticalPointSize: O,
    usUpperOpticalPointSize: O
  }
});
let tp = l7.versions;
tp[3] = tp[4] = tp[2];
var QS = l7, eC = new or(O0, {
  header: {
    italicAngle: O0,
    underlinePosition: lt,
    underlineThickness: lt,
    isFixedPitch: Oe,
    minMemType42: Oe,
    maxMemType42: Oe,
    minMemType1: Oe,
    maxMemType1: Oe
    // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
  },
  1: {},
  2: {
    numberOfGlyphs: O,
    glyphNameIndex: new Te(O, "numberOfGlyphs"),
    names: new Te(new Ur(kt))
  },
  2.5: {
    numberOfGlyphs: O,
    offsets: new Te(kt, "numberOfGlyphs")
  },
  3: {},
  4: {
    map: new Te(Oe, (r) => r.parent.maxp.numGlyphs)
  }
}), tC = new Me({
  controlValues: new Te(lt)
}), rC = new Me({
  instructions: new Te(kt)
});
let kv = new or("head.indexToLocFormat", {
  0: {
    offsets: new Te(O)
  },
  1: {
    offsets: new Te(Oe)
  }
});
kv.process = function() {
  if (this.version === 0 && !this._processed) {
    for (let r = 0; r < this.offsets.length; r++) this.offsets[r] <<= 1;
    this._processed = !0;
  }
};
kv.preEncode = function() {
  if (this.version === 0 && this._processed !== !1) {
    for (let r = 0; r < this.offsets.length; r++) this.offsets[r] >>>= 1;
    this._processed = !1;
  }
};
var nC = kv, iC = new Me({
  controlValueProgram: new Te(kt)
}), aC = new Te(new po());
class to {
  getCFFVersion(e) {
    for (; e && !e.hdrSize; ) e = e.parent;
    return e ? e.version : -1;
  }
  decode(e, t) {
    let i = this.getCFFVersion(t) >= 2 ? e.readUInt32BE() : e.readUInt16BE();
    if (i === 0) return [];
    let a = e.readUInt8(), o;
    if (a === 1) o = kt;
    else if (a === 2) o = O;
    else if (a === 3) o = Xs;
    else if (a === 4) o = Oe;
    else throw new Error(`Bad offset size in CFFIndex: ${a} ${e.pos}`);
    let s = [], c = e.pos + (i + 1) * a - 1, h = o.decode(e);
    for (let d = 0; d < i; d++) {
      let g = o.decode(e);
      if (this.type != null) {
        let x = e.pos;
        e.pos = c + h, t.length = g - h, s.push(this.type.decode(e, t)), e.pos = x;
      } else s.push({
        offset: c + h,
        length: g - h
      });
      h = g;
    }
    return e.pos = c + h, s;
  }
  size(e, t) {
    let n = 2;
    if (e.length === 0) return n;
    let i = this.type || new po(), a = 1;
    for (let s = 0; s < e.length; s++) {
      let c = e[s];
      a += i.size(c, t);
    }
    let o;
    if (a <= 255) o = kt;
    else if (a <= 65535) o = O;
    else if (a <= 16777215) o = Xs;
    else if (a <= 4294967295) o = Oe;
    else throw new Error("Bad offset in CFFIndex");
    return n += 1 + o.size() * (e.length + 1), n += a - 1, n;
  }
  encode(e, t, n) {
    if (e.writeUInt16BE(t.length), t.length === 0) return;
    let i = this.type || new po(), a = [], o = 1;
    for (let c of t) {
      let h = i.size(c, n);
      a.push(h), o += h;
    }
    let s;
    if (o <= 255) s = kt;
    else if (o <= 65535) s = O;
    else if (o <= 16777215) s = Xs;
    else if (o <= 4294967295) s = Oe;
    else throw new Error("Bad offset in CFFIndex");
    e.writeUInt8(s.size()), o = 1, s.encode(e, o);
    for (let c of a)
      o += c, s.encode(e, o);
    for (let c of t) i.encode(e, c, n);
  }
  constructor(e) {
    this.type = e;
  }
}
const zf = 15, bm = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  "E",
  "E-",
  null,
  "-"
], wm = {
  ".": 10,
  E: 11,
  "E-": 12,
  "-": 14
};
class rp {
  static decode(e, t) {
    if (32 <= t && t <= 246) return t - 139;
    if (247 <= t && t <= 250) return (t - 247) * 256 + e.readUInt8() + 108;
    if (251 <= t && t <= 254) return -(t - 251) * 256 - e.readUInt8() - 108;
    if (t === 28) return e.readInt16BE();
    if (t === 29) return e.readInt32BE();
    if (t === 30) {
      let n = "";
      for (; ; ) {
        let i = e.readUInt8(), a = i >> 4;
        if (a === zf) break;
        n += bm[a];
        let o = i & 15;
        if (o === zf) break;
        n += bm[o];
      }
      return parseFloat(n);
    }
    return null;
  }
  static size(e) {
    if (e.forceLarge && (e = 32768), (e | 0) !== e) {
      let t = "" + e;
      return 1 + Math.ceil((t.length + 1) / 2);
    } else return -107 <= e && e <= 107 ? 1 : 108 <= e && e <= 1131 || -1131 <= e && e <= -108 ? 2 : -32768 <= e && e <= 32767 ? 3 : 5;
  }
  static encode(e, t) {
    let n = Number(t);
    if (t.forceLarge)
      return e.writeUInt8(29), e.writeInt32BE(n);
    if ((n | 0) !== n) {
      e.writeUInt8(30);
      let a = "" + n;
      for (let o = 0; o < a.length; o += 2) {
        let s = a[o], c = wm[s] || +s;
        if (o === a.length - 1) var i = zf;
        else {
          let h = a[o + 1];
          var i = wm[h] || +h;
        }
        e.writeUInt8(c << 4 | i & 15);
      }
      if (i !== zf) return e.writeUInt8(zf << 4);
    } else return -107 <= n && n <= 107 ? e.writeUInt8(n + 139) : 108 <= n && n <= 1131 ? (n -= 108, e.writeUInt8((n >> 8) + 247), e.writeUInt8(n & 255)) : -1131 <= n && n <= -108 ? (n = -n - 108, e.writeUInt8((n >> 8) + 251), e.writeUInt8(n & 255)) : -32768 <= n && n <= 32767 ? (e.writeUInt8(28), e.writeInt16BE(n)) : (e.writeUInt8(29), e.writeInt32BE(n));
  }
}
class Wd {
  decodeOperands(e, t, n, i) {
    if (Array.isArray(e)) return i.map((a, o) => this.decodeOperands(e[o], t, n, [
      a
    ]));
    if (e.decode != null) return e.decode(t, n, i);
    switch (e) {
      case "number":
      case "offset":
      case "sid":
        return i[0];
      case "boolean":
        return !!i[0];
      default:
        return i;
    }
  }
  encodeOperands(e, t, n, i) {
    return Array.isArray(e) ? i.map((a, o) => this.encodeOperands(e[o], t, n, a)[0]) : e.encode != null ? e.encode(t, i, n) : typeof i == "number" ? [
      i
    ] : typeof i == "boolean" ? [
      +i
    ] : Array.isArray(i) ? i : [
      i
    ];
  }
  decode(e, t) {
    let n = e.pos + t.length, i = {}, a = [];
    Object.defineProperties(i, {
      parent: {
        value: t
      },
      _startOffset: {
        value: e.pos
      }
    });
    for (let o in this.fields) {
      let s = this.fields[o];
      i[s[1]] = s[3];
    }
    for (; e.pos < n; ) {
      let o = e.readUInt8();
      if (o < 28) {
        o === 12 && (o = o << 8 | e.readUInt8());
        let s = this.fields[o];
        if (!s) throw new Error(`Unknown operator ${o}`);
        let c = this.decodeOperands(s[2], e, i, a);
        c != null && (c instanceof yv ? Object.defineProperty(i, s[1], c) : i[s[1]] = c), a = [];
      } else a.push(rp.decode(e, o));
    }
    return i;
  }
  size(e, t, n = !0) {
    let i = {
      parent: t,
      val: e,
      pointerSize: 0,
      startOffset: t.startOffset || 0
    }, a = 0;
    for (let o in this.fields) {
      let s = this.fields[o], c = e[s[1]];
      if (c == null || im(c, s[3])) continue;
      let h = this.encodeOperands(s[2], null, i, c);
      for (let g of h) a += rp.size(g);
      let d = Array.isArray(s[0]) ? s[0] : [
        s[0]
      ];
      a += d.length;
    }
    return n && (a += i.pointerSize), a;
  }
  encode(e, t, n) {
    let i = {
      pointers: [],
      startOffset: e.pos,
      parent: n,
      val: t,
      pointerSize: 0
    };
    i.pointerOffset = e.pos + this.size(t, i, !1);
    for (let o of this.ops) {
      let s = t[o[1]];
      if (s == null || im(s, o[3])) continue;
      let c = this.encodeOperands(o[2], e, i, s);
      for (let d of c) rp.encode(e, d);
      let h = Array.isArray(o[0]) ? o[0] : [
        o[0]
      ];
      for (let d of h) e.writeUInt8(d);
    }
    let a = 0;
    for (; a < i.pointers.length; ) {
      let o = i.pointers[a++];
      o.type.encode(e, o.val, o.parent);
    }
  }
  constructor(e = []) {
    this.ops = e, this.fields = {};
    for (let t of e) {
      let n = Array.isArray(t[0]) ? t[0][0] << 8 | t[0][1] : t[0];
      this.fields[n] = t;
    }
  }
}
class _a extends Se {
  decode(e, t, n) {
    return this.offsetType = {
      decode: () => n[0]
    }, super.decode(e, t, n);
  }
  encode(e, t, n) {
    if (!e)
      return this.offsetType = {
        size: () => 0
      }, this.size(t, n), [
        new Am(0)
      ];
    let i = null;
    return this.offsetType = {
      encode: (a, o) => i = o
    }, super.encode(e, t, n), [
      new Am(i)
    ];
  }
  constructor(e, t = {}) {
    t.type == null && (t.type = "global"), super(null, e, t);
  }
}
class Am {
  valueOf() {
    return this.val;
  }
  constructor(e) {
    this.val = e, this.forceLarge = !0;
  }
}
class oC {
  static decode(e, t, n) {
    let i = n.pop();
    for (; n.length > i; ) n.pop();
  }
}
var Q4 = new Wd([
  // key       name                    type                                          default
  [
    6,
    "BlueValues",
    "delta",
    null
  ],
  [
    7,
    "OtherBlues",
    "delta",
    null
  ],
  [
    8,
    "FamilyBlues",
    "delta",
    null
  ],
  [
    9,
    "FamilyOtherBlues",
    "delta",
    null
  ],
  [
    [
      12,
      9
    ],
    "BlueScale",
    "number",
    0.039625
  ],
  [
    [
      12,
      10
    ],
    "BlueShift",
    "number",
    7
  ],
  [
    [
      12,
      11
    ],
    "BlueFuzz",
    "number",
    1
  ],
  [
    10,
    "StdHW",
    "number",
    null
  ],
  [
    11,
    "StdVW",
    "number",
    null
  ],
  [
    [
      12,
      12
    ],
    "StemSnapH",
    "delta",
    null
  ],
  [
    [
      12,
      13
    ],
    "StemSnapV",
    "delta",
    null
  ],
  [
    [
      12,
      14
    ],
    "ForceBold",
    "boolean",
    !1
  ],
  [
    [
      12,
      17
    ],
    "LanguageGroup",
    "number",
    0
  ],
  [
    [
      12,
      18
    ],
    "ExpansionFactor",
    "number",
    0.06
  ],
  [
    [
      12,
      19
    ],
    "initialRandomSeed",
    "number",
    0
  ],
  [
    20,
    "defaultWidthX",
    "number",
    0
  ],
  [
    21,
    "nominalWidthX",
    "number",
    0
  ],
  [
    22,
    "vsindex",
    "number",
    0
  ],
  [
    23,
    "blend",
    oC,
    null
  ],
  [
    19,
    "Subrs",
    new _a(new to(), {
      type: "local"
    }),
    null
  ]
]), bh = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
];
let c7 = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
], sC = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], f7 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron"
], uC = [
  ".notdef",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], lC = [
  ".notdef",
  "space",
  "dollaroldstyle",
  "dollarsuperior",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "hyphensuperior",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "centoldstyle",
  "figuredash",
  "hypheninferior",
  "onequarter",
  "onehalf",
  "threequarters",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior"
], h7 = new Me({
  reserved: new o0(O),
  reqFeatureIndex: O,
  featureCount: O,
  featureIndexes: new Te(O, "featureCount")
}), cC = new Me({
  tag: new Ur(4),
  langSys: new Se(O, h7, {
    type: "parent"
  })
}), fC = new Me({
  defaultLangSys: new Se(O, h7),
  count: O,
  langSysRecords: new Te(cC, "count")
}), hC = new Me({
  tag: new Ur(4),
  script: new Se(O, fC, {
    type: "parent"
  })
}), d7 = new Te(hC, O), dC = new Me({
  version: O,
  nameID: O
}), p7 = new Me({
  featureParams: new Se(O, dC),
  lookupCount: O,
  lookupListIndexes: new Te(O, "lookupCount")
}), pC = new Me({
  tag: new Ur(4),
  feature: new Se(O, p7, {
    type: "parent"
  })
}), v7 = new Te(pC, O), vC = new Me({
  markAttachmentType: kt,
  flags: new ka(kt, [
    "rightToLeft",
    "ignoreBaseGlyphs",
    "ignoreLigatures",
    "ignoreMarks",
    "useMarkFilteringSet"
  ])
});
function sd(r) {
  let e = new Me({
    lookupType: O,
    flags: vC,
    subTableCount: O,
    subTables: new Te(new Se(O, r), "subTableCount"),
    markFilteringSet: new rd(O, (t) => t.flags.flags.useMarkFilteringSet)
  });
  return new Hr(new Se(O, e), O);
}
let gC = new Me({
  start: O,
  end: O,
  startCoverageIndex: O
}), Mr = new or(O, {
  1: {
    glyphCount: O,
    glyphs: new Te(O, "glyphCount")
  },
  2: {
    rangeCount: O,
    rangeRecords: new Te(gC, "rangeCount")
  }
}), mC = new Me({
  start: O,
  end: O,
  class: O
}), Ks = new or(O, {
  1: {
    startGlyph: O,
    glyphCount: O,
    classValueArray: new Te(O, "glyphCount")
  },
  2: {
    classRangeCount: O,
    classRangeRecord: new Te(mC, "classRangeCount")
  }
}), Gs = new Me({
  a: O,
  b: O,
  deltaFormat: O
}), Y1 = new Me({
  sequenceIndex: O,
  lookupListIndex: O
}), yC = new Me({
  glyphCount: O,
  lookupCount: O,
  input: new Te(O, (r) => r.glyphCount - 1),
  lookupRecords: new Te(Y1, "lookupCount")
}), bC = new Te(new Se(O, yC), O), wC = new Me({
  glyphCount: O,
  lookupCount: O,
  classes: new Te(O, (r) => r.glyphCount - 1),
  lookupRecords: new Te(Y1, "lookupCount")
}), AC = new Te(new Se(O, wC), O), g7 = new or(O, {
  1: {
    coverage: new Se(O, Mr),
    ruleSetCount: O,
    ruleSets: new Te(new Se(O, bC), "ruleSetCount")
  },
  2: {
    coverage: new Se(O, Mr),
    classDef: new Se(O, Ks),
    classSetCnt: O,
    classSet: new Te(new Se(O, AC), "classSetCnt")
  },
  3: {
    glyphCount: O,
    lookupCount: O,
    coverages: new Te(new Se(O, Mr), "glyphCount"),
    lookupRecords: new Te(Y1, "lookupCount")
  }
}), xC = new Me({
  backtrackGlyphCount: O,
  backtrack: new Te(O, "backtrackGlyphCount"),
  inputGlyphCount: O,
  input: new Te(O, (r) => r.inputGlyphCount - 1),
  lookaheadGlyphCount: O,
  lookahead: new Te(O, "lookaheadGlyphCount"),
  lookupCount: O,
  lookupRecords: new Te(Y1, "lookupCount")
}), xm = new Te(new Se(O, xC), O), m7 = new or(O, {
  1: {
    coverage: new Se(O, Mr),
    chainCount: O,
    chainRuleSets: new Te(new Se(O, xm), "chainCount")
  },
  2: {
    coverage: new Se(O, Mr),
    backtrackClassDef: new Se(O, Ks),
    inputClassDef: new Se(O, Ks),
    lookaheadClassDef: new Se(O, Ks),
    chainCount: O,
    chainClassSet: new Te(new Se(O, xm), "chainCount")
  },
  3: {
    backtrackGlyphCount: O,
    backtrackCoverage: new Te(new Se(O, Mr), "backtrackGlyphCount"),
    inputGlyphCount: O,
    inputCoverage: new Te(new Se(O, Mr), "inputGlyphCount"),
    lookaheadGlyphCount: O,
    lookaheadCoverage: new Te(new Se(O, Mr), "lookaheadGlyphCount"),
    lookupCount: O,
    lookupRecords: new Te(Y1, "lookupCount")
  }
}), e1 = new El(16, "BE", 14), EC = new Me({
  startCoord: e1,
  peakCoord: e1,
  endCoord: e1
}), _C = new Me({
  axisCount: O,
  regionCount: O,
  variationRegions: new Te(new Te(EC, "axisCount"), "regionCount")
}), DC = new Me({
  shortDeltas: new Te(lt, (r) => r.parent.shortDeltaCount),
  regionDeltas: new Te(rn, (r) => r.parent.regionIndexCount - r.parent.shortDeltaCount),
  deltas: (r) => r.shortDeltas.concat(r.regionDeltas)
}), TC = new Me({
  itemCount: O,
  shortDeltaCount: O,
  regionIndexCount: O,
  regionIndexes: new Te(O, "regionIndexCount"),
  deltaSets: new Te(DC, "itemCount")
}), Gd = new Me({
  format: O,
  variationRegionList: new Se(Oe, _C),
  variationDataCount: O,
  itemVariationData: new Te(new Se(Oe, TC), "variationDataCount")
}), kC = new or(O, {
  1: {
    axisIndex: O,
    axisIndex: O,
    filterRangeMinValue: e1,
    filterRangeMaxValue: e1
  }
}), SC = new Me({
  conditionCount: O,
  conditionTable: new Te(new Se(Oe, kC), "conditionCount")
}), CC = new Me({
  featureIndex: O,
  alternateFeatureTable: new Se(Oe, p7, {
    type: "parent"
  })
}), FC = new Me({
  version: O0,
  substitutionCount: O,
  substitutions: new Te(CC, "substitutionCount")
}), OC = new Me({
  conditionSet: new Se(Oe, SC, {
    type: "parent"
  }),
  featureTableSubstitution: new Se(Oe, FC, {
    type: "parent"
  })
}), y7 = new Me({
  majorVersion: O,
  minorVersion: O,
  featureVariationRecordCount: Oe,
  featureVariationRecords: new Te(OC, "featureVariationRecordCount")
});
class b7 {
  decode(e, t, n) {
    return this.predefinedOps[n[0]] ? this.predefinedOps[n[0]] : this.type.decode(e, t, n);
  }
  size(e, t) {
    return this.type.size(e, t);
  }
  encode(e, t, n) {
    let i = this.predefinedOps.indexOf(t);
    return i !== -1 ? i : this.type.encode(e, t, n);
  }
  constructor(e, t) {
    this.predefinedOps = e, this.type = t;
  }
}
class RC extends Lr {
  decode(e) {
    return kt.decode(e) & 127;
  }
  constructor() {
    super("UInt8");
  }
}
let w7 = new Me({
  first: O,
  nLeft: kt
}), IC = new Me({
  first: O,
  nLeft: O
}), PC = new or(new RC(), {
  0: {
    nCodes: kt,
    codes: new Te(kt, "nCodes")
  },
  1: {
    nRanges: kt,
    ranges: new Te(w7, "nRanges")
  }
}), BC = new b7([
  c7,
  sC
], new _a(PC, {
  lazy: !0
}));
class Em extends Te {
  decode(e, t) {
    let n = vo(this.length, e, t), i = 0, a = [];
    for (; i < n; ) {
      let o = this.type.decode(e, t);
      o.offset = i, i += o.nLeft + 1, a.push(o);
    }
    return a;
  }
}
let NC = new or(kt, {
  0: {
    glyphs: new Te(O, (r) => r.parent.CharStrings.length - 1)
  },
  1: {
    ranges: new Em(w7, (r) => r.parent.CharStrings.length - 1)
  },
  2: {
    ranges: new Em(IC, (r) => r.parent.CharStrings.length - 1)
  }
}), LC = new b7([
  f7,
  uC,
  lC
], new _a(NC, {
  lazy: !0
})), MC = new Me({
  first: O,
  fd: kt
}), UC = new Me({
  first: Oe,
  fd: O
}), A7 = new or(kt, {
  0: {
    fds: new Te(kt, (r) => r.parent.CharStrings.length)
  },
  3: {
    nRanges: O,
    ranges: new Te(MC, "nRanges"),
    sentinel: O
  },
  4: {
    nRanges: Oe,
    ranges: new Te(UC, "nRanges"),
    sentinel: Oe
  }
}), np = new _a(Q4);
class x7 {
  decode(e, t, n) {
    return t.length = n[0], np.decode(e, t, [
      n[1]
    ]);
  }
  size(e, t) {
    return [
      Q4.size(e, t, !1),
      np.size(e, t)[0]
    ];
  }
  encode(e, t, n) {
    return [
      Q4.size(t, n, !1),
      np.encode(e, t, n)[0]
    ];
  }
}
let E7 = new Wd([
  // key       name                   type(s)                                 default
  [
    18,
    "Private",
    new x7(),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ]
]), $C = new Wd([
  // key       name                   type(s)                                 default
  [
    [
      12,
      30
    ],
    "ROS",
    [
      "sid",
      "sid",
      "number"
    ],
    null
  ],
  [
    0,
    "version",
    "sid",
    null
  ],
  [
    1,
    "Notice",
    "sid",
    null
  ],
  [
    [
      12,
      0
    ],
    "Copyright",
    "sid",
    null
  ],
  [
    2,
    "FullName",
    "sid",
    null
  ],
  [
    3,
    "FamilyName",
    "sid",
    null
  ],
  [
    4,
    "Weight",
    "sid",
    null
  ],
  [
    [
      12,
      1
    ],
    "isFixedPitch",
    "boolean",
    !1
  ],
  [
    [
      12,
      2
    ],
    "ItalicAngle",
    "number",
    0
  ],
  [
    [
      12,
      3
    ],
    "UnderlinePosition",
    "number",
    -100
  ],
  [
    [
      12,
      4
    ],
    "UnderlineThickness",
    "number",
    50
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ],
  [
    [
      12,
      6
    ],
    "CharstringType",
    "number",
    2
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    13,
    "UniqueID",
    "number",
    null
  ],
  [
    5,
    "FontBBox",
    "array",
    [
      0,
      0,
      0,
      0
    ]
  ],
  [
    [
      12,
      8
    ],
    "StrokeWidth",
    "number",
    0
  ],
  [
    14,
    "XUID",
    "array",
    null
  ],
  [
    15,
    "charset",
    LC,
    f7
  ],
  [
    16,
    "Encoding",
    BC,
    c7
  ],
  [
    17,
    "CharStrings",
    new _a(new to()),
    null
  ],
  [
    18,
    "Private",
    new x7(),
    null
  ],
  [
    [
      12,
      20
    ],
    "SyntheticBase",
    "number",
    null
  ],
  [
    [
      12,
      21
    ],
    "PostScript",
    "sid",
    null
  ],
  [
    [
      12,
      22
    ],
    "BaseFontName",
    "sid",
    null
  ],
  [
    [
      12,
      23
    ],
    "BaseFontBlend",
    "delta",
    null
  ],
  // CID font specific
  [
    [
      12,
      31
    ],
    "CIDFontVersion",
    "number",
    0
  ],
  [
    [
      12,
      32
    ],
    "CIDFontRevision",
    "number",
    0
  ],
  [
    [
      12,
      33
    ],
    "CIDFontType",
    "number",
    0
  ],
  [
    [
      12,
      34
    ],
    "CIDCount",
    "number",
    8720
  ],
  [
    [
      12,
      35
    ],
    "UIDBase",
    "number",
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new _a(A7),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new _a(new to(E7)),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ]
]), zC = new Me({
  length: O,
  itemVariationStore: Gd
}), jC = new Wd([
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    17,
    "CharStrings",
    new _a(new to()),
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new _a(A7),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new _a(new to(E7)),
    null
  ],
  [
    24,
    "vstore",
    new _a(zC),
    null
  ],
  [
    25,
    "maxstack",
    "number",
    193
  ]
]), WC = new or(dk, {
  1: {
    hdrSize: kt,
    offSize: kt,
    nameIndex: new to(new Ur("length")),
    topDictIndex: new to($C),
    stringIndex: new to(new Ur("length")),
    globalSubrIndex: new to()
  },
  2: {
    hdrSize: kt,
    length: O,
    topDict: jC,
    globalSubrIndex: new to()
  }
});
var _7 = WC;
class Sv {
  static decode(e) {
    return new Sv(e);
  }
  decode() {
    this.stream.pos;
    let e = _7.decode(this.stream);
    for (let t in e) {
      let n = e[t];
      this[t] = n;
    }
    if (this.version < 2) {
      if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
      this.topDict = this.topDictIndex[0];
    }
    return this.isCIDFont = this.topDict.ROS != null, this;
  }
  string(e) {
    return this.version >= 2 ? null : e < bh.length ? bh[e] : this.stringIndex[e - bh.length];
  }
  get postscriptName() {
    return this.version < 2 ? this.nameIndex[0] : null;
  }
  get fullName() {
    return this.string(this.topDict.FullName);
  }
  get familyName() {
    return this.string(this.topDict.FamilyName);
  }
  getCharString(e) {
    return this.stream.pos = this.topDict.CharStrings[e].offset, this.stream.readBuffer(this.topDict.CharStrings[e].length);
  }
  getGlyphName(e) {
    if (this.version >= 2 || this.isCIDFont) return null;
    let { charset: t } = this.topDict;
    if (Array.isArray(t)) return t[e];
    if (e === 0) return ".notdef";
    switch (e -= 1, t.version) {
      case 0:
        return this.string(t.glyphs[e]);
      case 1:
      case 2:
        for (let n = 0; n < t.ranges.length; n++) {
          let i = t.ranges[n];
          if (i.offset <= e && e <= i.offset + i.nLeft) return this.string(i.first + (e - i.offset));
        }
        break;
    }
    return null;
  }
  fdForGlyph(e) {
    if (!this.topDict.FDSelect) return null;
    switch (this.topDict.FDSelect.version) {
      case 0:
        return this.topDict.FDSelect.fds[e];
      case 3:
      case 4:
        let { ranges: t } = this.topDict.FDSelect, n = 0, i = t.length - 1;
        for (; n <= i; ) {
          let a = n + i >> 1;
          if (e < t[a].first) i = a - 1;
          else if (a < i && e >= t[a + 1].first) n = a + 1;
          else return t[a].fd;
        }
      default:
        throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
    }
  }
  privateDictForGlyph(e) {
    if (this.topDict.FDSelect) {
      let t = this.fdForGlyph(e);
      return this.topDict.FDArray[t] ? this.topDict.FDArray[t].Private : null;
    }
    return this.version < 2 ? this.topDict.Private : this.topDict.FDArray[0].Private;
  }
  constructor(e) {
    this.stream = e, this.decode();
  }
}
var D7 = Sv;
let GC = new Me({
  glyphIndex: O,
  vertOriginY: lt
});
var VC = new Me({
  majorVersion: O,
  minorVersion: O,
  defaultVertOriginY: lt,
  numVertOriginYMetrics: O,
  metrics: new Te(GC, "numVertOriginYMetrics")
});
let wc = new Me({
  height: kt,
  width: kt,
  horiBearingX: rn,
  horiBearingY: rn,
  horiAdvance: kt,
  vertBearingX: rn,
  vertBearingY: rn,
  vertAdvance: kt
}), k2 = new Me({
  height: kt,
  width: kt,
  bearingX: rn,
  bearingY: rn,
  advance: kt
}), _m = new Me({
  glyph: O,
  xOffset: rn,
  yOffset: rn
});
class Dm {
}
class ip {
}
new or("version", {
  1: {
    metrics: k2,
    data: Dm
  },
  2: {
    metrics: k2,
    data: ip
  },
  // format 3 is deprecated
  // format 4 is not supported by Microsoft
  5: {
    data: ip
  },
  6: {
    metrics: wc,
    data: Dm
  },
  7: {
    metrics: wc,
    data: ip
  },
  8: {
    metrics: k2,
    pad: new o0(kt),
    numComponents: O,
    components: new Te(_m, "numComponents")
  },
  9: {
    metrics: wc,
    pad: new o0(kt),
    numComponents: O,
    components: new Te(_m, "numComponents")
  },
  17: {
    metrics: k2,
    dataLen: Oe,
    data: new po("dataLen")
  },
  18: {
    metrics: wc,
    dataLen: Oe,
    data: new po("dataLen")
  },
  19: {
    dataLen: Oe,
    data: new po("dataLen")
  }
});
let Tm = new Me({
  ascender: rn,
  descender: rn,
  widthMax: kt,
  caretSlopeNumerator: rn,
  caretSlopeDenominator: rn,
  caretOffset: rn,
  minOriginSB: rn,
  minAdvanceSB: rn,
  maxBeforeBL: rn,
  minAfterBL: rn,
  pad: new o0(rn, 2)
}), YC = new Me({
  glyphCode: O,
  offset: O
}), HC = new or(O, {
  header: {
    imageFormat: O,
    imageDataOffset: Oe
  },
  1: {
    offsetArray: new Te(Oe, (r) => r.parent.lastGlyphIndex - r.parent.firstGlyphIndex + 1)
  },
  2: {
    imageSize: Oe,
    bigMetrics: wc
  },
  3: {
    offsetArray: new Te(O, (r) => r.parent.lastGlyphIndex - r.parent.firstGlyphIndex + 1)
  },
  4: {
    numGlyphs: Oe,
    glyphArray: new Te(YC, (r) => r.numGlyphs + 1)
  },
  5: {
    imageSize: Oe,
    bigMetrics: wc,
    numGlyphs: Oe,
    glyphCodeArray: new Te(O, "numGlyphs")
  }
}), ZC = new Me({
  firstGlyphIndex: O,
  lastGlyphIndex: O,
  subtable: new Se(Oe, HC)
}), qC = new Me({
  indexSubTableArray: new Se(Oe, new Te(ZC, 1), {
    type: "parent"
  }),
  indexTablesSize: Oe,
  numberOfIndexSubTables: Oe,
  colorRef: Oe,
  hori: Tm,
  vert: Tm,
  startGlyphIndex: O,
  endGlyphIndex: O,
  ppemX: kt,
  ppemY: kt,
  bitDepth: kt,
  flags: new ka(kt, [
    "horizontal",
    "vertical"
  ])
});
var XC = new Me({
  version: Oe,
  numSizes: Oe,
  sizes: new Te(qC, "numSizes")
});
let KC = new Me({
  ppem: O,
  resolution: O,
  imageOffsets: new Te(new Se(Oe, "void"), (r) => r.parent.parent.maxp.numGlyphs + 1)
});
var JC = new Me({
  version: O,
  flags: new ka(O, [
    "renderOutlines"
  ]),
  numImgTables: Oe,
  imageTables: new Te(new Se(Oe, KC), "numImgTables")
});
let QC = new Me({
  gid: O,
  paletteIndex: O
  // Index value to use in the appropriate palette. This value must
}), eF = new Me({
  gid: O,
  // and is not rendered for color.
  firstLayerIndex: O,
  // There will be numLayers consecutive entries for this base glyph.
  numLayers: O
});
var tF = new Me({
  version: O,
  numBaseGlyphRecords: O,
  baseGlyphRecord: new Se(Oe, new Te(eF, "numBaseGlyphRecords")),
  layerRecords: new Se(Oe, new Te(QC, "numLayerRecords"), {
    lazy: !0
  }),
  numLayerRecords: O
});
let rF = new Me({
  blue: kt,
  green: kt,
  red: kt,
  alpha: kt
});
var nF = new or(O, {
  header: {
    numPaletteEntries: O,
    numPalettes: O,
    numColorRecords: O,
    colorRecords: new Se(Oe, new Te(rF, "numColorRecords")),
    colorRecordIndices: new Te(O, "numPalettes")
  },
  0: {},
  1: {
    offsetPaletteTypeArray: new Se(Oe, new Te(Oe, "numPalettes")),
    offsetPaletteLabelArray: new Se(Oe, new Te(O, "numPalettes")),
    offsetPaletteEntryLabelArray: new Se(Oe, new Te(O, "numPaletteEntries"))
  }
});
let g1 = new or(O, {
  1: {
    coordinate: lt
    // X or Y value, in design units
  },
  2: {
    coordinate: lt,
    referenceGlyph: O,
    baseCoordPoint: O
    // Index of contour point on the referenceGlyph
  },
  3: {
    coordinate: lt,
    deviceTable: new Se(O, Gs)
    // Device table for X or Y value
  }
}), iF = new Me({
  defaultIndex: O,
  baseCoordCount: O,
  baseCoords: new Te(new Se(O, g1), "baseCoordCount")
}), aF = new Me({
  tag: new Ur(4),
  minCoord: new Se(O, g1, {
    type: "parent"
  }),
  maxCoord: new Se(O, g1, {
    type: "parent"
  })
  // May be NULL
}), T7 = new Me({
  minCoord: new Se(O, g1),
  maxCoord: new Se(O, g1),
  featMinMaxCount: O,
  featMinMaxRecords: new Te(aF, "featMinMaxCount")
  // In alphabetical order
}), oF = new Me({
  tag: new Ur(4),
  minMax: new Se(O, T7, {
    type: "parent"
  })
}), sF = new Me({
  baseValues: new Se(O, iF),
  defaultMinMax: new Se(O, T7),
  baseLangSysCount: O,
  baseLangSysRecords: new Te(oF, "baseLangSysCount")
  // in alphabetical order by BaseLangSysTag
}), uF = new Me({
  tag: new Ur(4),
  script: new Se(O, sF, {
    type: "parent"
  })
}), lF = new Te(uF, O), cF = new Te(new Ur(4), O), km = new Me({
  baseTagList: new Se(O, cF),
  baseScriptList: new Se(O, lF)
});
var fF = new or(Oe, {
  header: {
    horizAxis: new Se(O, km),
    vertAxis: new Se(O, km)
    // May be NULL
  },
  65536: {},
  65537: {
    itemVariationStore: new Se(Oe, Gd)
  }
});
let hF = new Te(O, O), dF = new Me({
  coverage: new Se(O, Mr),
  glyphCount: O,
  attachPoints: new Te(new Se(O, hF), "glyphCount")
}), pF = new or(O, {
  1: {
    coordinate: lt
  },
  2: {
    caretValuePoint: O
  },
  3: {
    coordinate: lt,
    deviceTable: new Se(O, Gs)
  }
}), vF = new Te(new Se(O, pF), O), gF = new Me({
  coverage: new Se(O, Mr),
  ligGlyphCount: O,
  ligGlyphs: new Te(new Se(O, vF), "ligGlyphCount")
}), Sm = new Me({
  markSetTableFormat: O,
  markSetCount: O,
  coverage: new Te(new Se(Oe, Mr), "markSetCount")
});
var mF = new or(Oe, {
  header: {
    glyphClassDef: new Se(O, Ks),
    attachList: new Se(O, dF),
    ligCaretList: new Se(O, gF),
    markAttachClassDef: new Se(O, Ks)
  },
  65536: {},
  65538: {
    markGlyphSetsDef: new Se(O, Sm)
  },
  65539: {
    markGlyphSetsDef: new Se(O, Sm),
    itemVariationStore: new Se(Oe, Gd)
  }
});
let ec = new ka(O, [
  "xPlacement",
  "yPlacement",
  "xAdvance",
  "yAdvance",
  "xPlaDevice",
  "yPlaDevice",
  "xAdvDevice",
  "yAdvDevice"
]), yF = {
  xPlacement: lt,
  yPlacement: lt,
  xAdvance: lt,
  yAdvance: lt,
  xPlaDevice: new Se(O, Gs, {
    type: "global",
    relativeTo: (r) => r.rel
  }),
  yPlaDevice: new Se(O, Gs, {
    type: "global",
    relativeTo: (r) => r.rel
  }),
  xAdvDevice: new Se(O, Gs, {
    type: "global",
    relativeTo: (r) => r.rel
  }),
  yAdvDevice: new Se(O, Gs, {
    type: "global",
    relativeTo: (r) => r.rel
  })
};
class Yc {
  buildStruct(e) {
    let t = e;
    for (; !t[this.key] && t.parent; ) t = t.parent;
    if (!t[this.key]) return;
    let n = {};
    n.rel = () => t._startOffset;
    let i = t[this.key];
    for (let a in i) i[a] && (n[a] = yF[a]);
    return new Me(n);
  }
  size(e, t) {
    return this.buildStruct(t).size(e, t);
  }
  decode(e, t) {
    let n = this.buildStruct(t).decode(e, t);
    return delete n.rel, n;
  }
  constructor(e = "valueFormat") {
    this.key = e;
  }
}
let bF = new Me({
  secondGlyph: O,
  value1: new Yc("valueFormat1"),
  value2: new Yc("valueFormat2")
}), wF = new Te(bF, O), AF = new Me({
  value1: new Yc("valueFormat1"),
  value2: new Yc("valueFormat2")
}), m1 = new or(O, {
  1: {
    xCoordinate: lt,
    yCoordinate: lt
  },
  2: {
    xCoordinate: lt,
    yCoordinate: lt,
    anchorPoint: O
  },
  3: {
    xCoordinate: lt,
    yCoordinate: lt,
    xDeviceTable: new Se(O, Gs),
    yDeviceTable: new Se(O, Gs)
  }
}), xF = new Me({
  entryAnchor: new Se(O, m1, {
    type: "parent"
  }),
  exitAnchor: new Se(O, m1, {
    type: "parent"
  })
}), EF = new Me({
  class: O,
  markAnchor: new Se(O, m1, {
    type: "parent"
  })
}), ap = new Te(EF, O), _F = new Te(new Se(O, m1), (r) => r.parent.classCount), Cm = new Te(_F, O), DF = new Te(new Se(O, m1), (r) => r.parent.parent.classCount), TF = new Te(DF, O), kF = new Te(new Se(O, TF), O), y1 = new or("lookupType", {
  1: new or(O, {
    1: {
      coverage: new Se(O, Mr),
      valueFormat: ec,
      value: new Yc()
    },
    2: {
      coverage: new Se(O, Mr),
      valueFormat: ec,
      valueCount: O,
      values: new Hr(new Yc(), "valueCount")
    }
  }),
  2: new or(O, {
    1: {
      coverage: new Se(O, Mr),
      valueFormat1: ec,
      valueFormat2: ec,
      pairSetCount: O,
      pairSets: new Hr(new Se(O, wF), "pairSetCount")
    },
    2: {
      coverage: new Se(O, Mr),
      valueFormat1: ec,
      valueFormat2: ec,
      classDef1: new Se(O, Ks),
      classDef2: new Se(O, Ks),
      class1Count: O,
      class2Count: O,
      classRecords: new Hr(new Hr(AF, "class2Count"), "class1Count")
    }
  }),
  3: {
    format: O,
    coverage: new Se(O, Mr),
    entryExitCount: O,
    entryExitRecords: new Te(xF, "entryExitCount")
  },
  4: {
    format: O,
    markCoverage: new Se(O, Mr),
    baseCoverage: new Se(O, Mr),
    classCount: O,
    markArray: new Se(O, ap),
    baseArray: new Se(O, Cm)
  },
  5: {
    format: O,
    markCoverage: new Se(O, Mr),
    ligatureCoverage: new Se(O, Mr),
    classCount: O,
    markArray: new Se(O, ap),
    ligatureArray: new Se(O, kF)
  },
  6: {
    format: O,
    mark1Coverage: new Se(O, Mr),
    mark2Coverage: new Se(O, Mr),
    classCount: O,
    mark1Array: new Se(O, ap),
    mark2Array: new Se(O, Cm)
  },
  7: g7,
  8: m7,
  9: {
    posFormat: O,
    lookupType: O,
    extension: new Se(Oe, null)
  }
});
y1.versions[9].extension.type = y1;
var SF = new or(Oe, {
  header: {
    scriptList: new Se(O, d7),
    featureList: new Se(O, v7),
    lookupList: new Se(O, new sd(y1))
  },
  65536: {},
  65537: {
    featureVariations: new Se(Oe, y7)
  }
});
let k7 = new Te(O, O), CF = k7, FF = new Me({
  glyph: O,
  compCount: O,
  components: new Te(O, (r) => r.compCount - 1)
}), OF = new Te(new Se(O, FF), O), e3 = new or("lookupType", {
  1: new or(O, {
    1: {
      coverage: new Se(O, Mr),
      deltaGlyphID: lt
    },
    2: {
      coverage: new Se(O, Mr),
      glyphCount: O,
      substitute: new Hr(O, "glyphCount")
    }
  }),
  2: {
    substFormat: O,
    coverage: new Se(O, Mr),
    count: O,
    sequences: new Hr(new Se(O, k7), "count")
  },
  3: {
    substFormat: O,
    coverage: new Se(O, Mr),
    count: O,
    alternateSet: new Hr(new Se(O, CF), "count")
  },
  4: {
    substFormat: O,
    coverage: new Se(O, Mr),
    count: O,
    ligatureSets: new Hr(new Se(O, OF), "count")
  },
  5: g7,
  6: m7,
  7: {
    substFormat: O,
    lookupType: O,
    extension: new Se(Oe, null)
  },
  8: {
    substFormat: O,
    coverage: new Se(O, Mr),
    backtrackCoverage: new Te(new Se(O, Mr), "backtrackGlyphCount"),
    lookaheadGlyphCount: O,
    lookaheadCoverage: new Te(new Se(O, Mr), "lookaheadGlyphCount"),
    glyphCount: O,
    substitutes: new Te(O, "glyphCount")
  }
});
e3.versions[7].extension.type = e3;
var RF = new or(Oe, {
  header: {
    scriptList: new Se(O, d7),
    featureList: new Se(O, v7),
    lookupList: new Se(O, new sd(e3))
  },
  65536: {},
  65537: {
    featureVariations: new Se(Oe, y7)
  }
});
let As = new Te(O, O), IF = new Me({
  shrinkageEnableGSUB: new Se(O, As),
  shrinkageDisableGSUB: new Se(O, As),
  shrinkageEnableGPOS: new Se(O, As),
  shrinkageDisableGPOS: new Se(O, As),
  shrinkageJstfMax: new Se(O, new sd(y1)),
  extensionEnableGSUB: new Se(O, As),
  extensionDisableGSUB: new Se(O, As),
  extensionEnableGPOS: new Se(O, As),
  extensionDisableGPOS: new Se(O, As),
  extensionJstfMax: new Se(O, new sd(y1))
}), S7 = new Te(new Se(O, IF), O), PF = new Me({
  tag: new Ur(4),
  jstfLangSys: new Se(O, S7)
}), BF = new Me({
  extenderGlyphs: new Se(O, new Te(O, O)),
  defaultLangSys: new Se(O, S7),
  langSysCount: O,
  langSysRecords: new Te(PF, "langSysCount")
}), NF = new Me({
  tag: new Ur(4),
  script: new Se(O, BF, {
    type: "parent"
  })
});
var LF = new Me({
  version: Oe,
  scriptCount: O,
  scriptList: new Te(NF, "scriptCount")
});
class MF {
  decode(e, t) {
    switch (this.size(0, t)) {
      case 1:
        return e.readUInt8();
      case 2:
        return e.readUInt16BE();
      case 3:
        return e.readUInt24BE();
      case 4:
        return e.readUInt32BE();
    }
  }
  size(e, t) {
    return vo(this._size, null, t);
  }
  constructor(e) {
    this._size = e;
  }
}
let UF = new Me({
  entry: new MF((r) => ((r.parent.entryFormat & 48) >> 4) + 1),
  outerIndex: (r) => r.entry >> (r.parent.entryFormat & 15) + 1,
  innerIndex: (r) => r.entry & (1 << (r.parent.entryFormat & 15) + 1) - 1
}), op = new Me({
  entryFormat: O,
  mapCount: O,
  mapData: new Te(UF, "mapCount")
});
var $F = new Me({
  majorVersion: O,
  minorVersion: O,
  itemVariationStore: new Se(Oe, Gd),
  advanceWidthMapping: new Se(Oe, op),
  LSBMapping: new Se(Oe, op),
  RSBMapping: new Se(Oe, op)
});
let zF = new Me({
  format: Oe,
  length: Oe,
  offset: Oe
}), jF = new Me({
  reserved: new o0(O, 2),
  cbSignature: Oe,
  signature: new po("cbSignature")
});
var WF = new Me({
  ulVersion: Oe,
  usNumSigs: O,
  usFlag: O,
  signatures: new Te(zF, "usNumSigs"),
  signatureBlocks: new Te(jF, "usNumSigs")
});
let GF = new Me({
  rangeMaxPPEM: O,
  rangeGaspBehavior: new ka(O, [
    "grayscale",
    "gridfit",
    "symmetricSmoothing",
    "symmetricGridfit"
    // only in version 1, for ClearType
  ])
});
var VF = new Me({
  version: O,
  numRanges: O,
  gaspRanges: new Te(GF, "numRanges")
  // Sorted by ppem
});
let YF = new Me({
  pixelSize: kt,
  maximumWidth: kt,
  widths: new Te(kt, (r) => r.parent.parent.maxp.numGlyphs)
});
var HF = new Me({
  version: O,
  numRecords: lt,
  sizeDeviceRecord: Yu,
  records: new Te(YF, "numRecords")
});
let ZF = new Me({
  left: O,
  right: O,
  value: lt
}), Fm = new Me({
  firstGlyph: O,
  nGlyphs: O,
  offsets: new Te(O, "nGlyphs"),
  max: (r) => r.offsets.length && Math.max.apply(Math, r.offsets)
}), qF = new Me({
  off: (r) => r._startOffset - r.parent.parent._startOffset,
  len: (r) => ((r.parent.leftTable.max - r.off) / r.parent.rowWidth + 1) * (r.parent.rowWidth / 2),
  values: new Hr(lt, "len")
}), Om = new or("format", {
  0: {
    nPairs: O,
    searchRange: O,
    entrySelector: O,
    rangeShift: O,
    pairs: new Te(ZF, "nPairs")
  },
  2: {
    rowWidth: O,
    leftTable: new Se(O, Fm, {
      type: "parent"
    }),
    rightTable: new Se(O, Fm, {
      type: "parent"
    }),
    array: new Se(O, qF, {
      type: "parent"
    })
  },
  3: {
    glyphCount: O,
    kernValueCount: kt,
    leftClassCount: kt,
    rightClassCount: kt,
    flags: kt,
    kernValue: new Te(lt, "kernValueCount"),
    leftClass: new Te(kt, "glyphCount"),
    rightClass: new Te(kt, "glyphCount"),
    kernIndex: new Te(kt, (r) => r.leftClassCount * r.rightClassCount)
  }
}), Rm = new or("version", {
  0: {
    subVersion: O,
    length: O,
    format: kt,
    coverage: new ka(kt, [
      "horizontal",
      "minimum",
      "crossStream",
      "override"
      // If set to 1 the value in this table replaces the accumulated value
    ]),
    subtable: Om,
    padding: new o0(kt, (r) => r.length - r._currentOffset)
  },
  1: {
    length: Oe,
    coverage: new ka(kt, [
      null,
      null,
      null,
      null,
      null,
      "variation",
      "crossStream",
      "vertical"
      // Set if table has vertical kerning values
    ]),
    format: kt,
    tupleIndex: O,
    subtable: Om,
    padding: new o0(kt, (r) => r.length - r._currentOffset)
  }
});
var XF = new or(O, {
  0: {
    nTables: O,
    tables: new Te(Rm, "nTables")
  },
  1: {
    reserved: new o0(O),
    nTables: Oe,
    tables: new Te(Rm, "nTables")
  }
}), KF = new Me({
  version: O,
  numGlyphs: O,
  yPels: new Te(kt, "numGlyphs")
}), JF = new Me({
  version: O,
  fontNumber: Oe,
  pitch: O,
  xHeight: O,
  style: O,
  typeFamily: O,
  capHeight: O,
  symbolSet: O,
  typeface: new Ur(16),
  characterComplement: new Ur(8),
  fileName: new Ur(6),
  strokeWeight: new Ur(1),
  widthType: new Ur(1),
  serifStyle: kt,
  reserved: new o0(kt)
});
let QF = new Me({
  bCharSet: kt,
  xRatio: kt,
  yStartRatio: kt,
  yEndRatio: kt
  // Ending y-Ratio value
}), eO = new Me({
  yPelHeight: O,
  yMax: lt,
  yMin: lt
  // Minimum value (in pels) for this yPelHeight
}), tO = new Me({
  recs: O,
  startsz: kt,
  endsz: kt,
  entries: new Te(eO, "recs")
  // The VDMX records
});
var rO = new Me({
  version: O,
  numRecs: O,
  numRatios: O,
  ratioRanges: new Te(QF, "numRatios"),
  offsets: new Te(O, "numRatios"),
  groups: new Te(tO, "numRecs")
  // The actual VDMX groupings
}), nO = new Me({
  version: O,
  ascent: lt,
  descent: lt,
  lineGap: lt,
  advanceHeightMax: lt,
  minTopSideBearing: lt,
  minBottomSideBearing: lt,
  yMaxExtent: lt,
  caretSlopeRise: lt,
  caretSlopeRun: lt,
  caretOffset: lt,
  reserved: new o0(lt, 4),
  metricDataFormat: lt,
  numberOfMetrics: O
  // Number of advance heights in the Vertical Metrics table
});
let iO = new Me({
  advance: O,
  bearing: lt
  // The top sidebearing of the glyph
});
var aO = new Me({
  metrics: new Hr(iO, (r) => r.parent.vhea.numberOfMetrics),
  bearings: new Hr(lt, (r) => r.parent.maxp.numGlyphs - r.parent.vhea.numberOfMetrics)
});
let Im = new El(16, "BE", 14), oO = new Me({
  fromCoord: Im,
  toCoord: Im
}), sO = new Me({
  pairCount: O,
  correspondence: new Te(oO, "pairCount")
});
var uO = new Me({
  version: O0,
  axisCount: Oe,
  segment: new Te(sO, "axisCount")
});
class lO {
  getItem(e) {
    if (this._items[e] == null) {
      let t = this.stream.pos;
      this.stream.pos = this.base + this.type.size(null, this.parent) * e, this._items[e] = this.type.decode(this.stream, this.parent), this.stream.pos = t;
    }
    return this._items[e];
  }
  inspect() {
    return `[UnboundedArray ${this.type.constructor.name}]`;
  }
  constructor(e, t, n) {
    this.type = e, this.stream = t, this.parent = n, this.base = this.stream.pos, this._items = [];
  }
}
class fo extends Te {
  decode(e, t) {
    return new lO(this.type, e, t);
  }
  constructor(e) {
    super(e, 0);
  }
}
let nu = function(r = O) {
  class e {
    decode(s, c) {
      return c = c.parent.parent, this.type.decode(s, c);
    }
    size(s, c) {
      return c = c.parent.parent, this.type.size(s, c);
    }
    encode(s, c, h) {
      return h = h.parent.parent, this.type.encode(s, c, h);
    }
    constructor(s) {
      this.type = s;
    }
  }
  r = new e(r);
  let t = new Me({
    unitSize: O,
    nUnits: O,
    searchRange: O,
    entrySelector: O,
    rangeShift: O
  }), n = new Me({
    lastGlyph: O,
    firstGlyph: O,
    value: r
  }), i = new Me({
    lastGlyph: O,
    firstGlyph: O,
    values: new Se(O, new Te(r, (o) => o.lastGlyph - o.firstGlyph + 1), {
      type: "parent"
    })
  }), a = new Me({
    glyph: O,
    value: r
  });
  return new or(O, {
    0: {
      values: new fo(r)
      // length == number of glyphs maybe?
    },
    2: {
      binarySearchHeader: t,
      segments: new Te(n, (o) => o.binarySearchHeader.nUnits)
    },
    4: {
      binarySearchHeader: t,
      segments: new Te(i, (o) => o.binarySearchHeader.nUnits)
    },
    6: {
      binarySearchHeader: t,
      segments: new Te(a, (o) => o.binarySearchHeader.nUnits)
    },
    8: {
      firstGlyph: O,
      count: O,
      values: new Te(r, "count")
    }
  });
};
function S2(r = {}, e = O) {
  let t = Object.assign({
    newState: O,
    flags: O
  }, r), n = new Me(t), i = new fo(new Te(O, (o) => o.nClasses));
  return new Me({
    nClasses: Oe,
    classTable: new Se(Oe, new nu(e)),
    stateArray: new Se(Oe, i),
    entryTable: new Se(Oe, new fo(n))
  });
}
function cO(r = {}, e = O) {
  let t = new Me({
    version() {
      return 8;
    },
    firstGlyph: O,
    values: new Te(kt, O)
  }), n = Object.assign({
    newStateOffset: O,
    // convert offset to stateArray index
    newState: (s) => (s.newStateOffset - (s.parent.stateArray.base - s.parent._startOffset)) / s.parent.nClasses,
    flags: O
  }, r), i = new Me(n), a = new fo(new Te(kt, (s) => s.nClasses));
  return new Me({
    nClasses: O,
    classTable: new Se(O, t),
    stateArray: new Se(O, a),
    entryTable: new Se(O, new fo(i))
  });
}
let fO = new or("format", {
  0: {
    deltas: new Te(lt, 32)
  },
  1: {
    deltas: new Te(lt, 32),
    mappingData: new nu(O)
  },
  2: {
    standardGlyph: O,
    controlPoints: new Te(O, 32)
  },
  3: {
    standardGlyph: O,
    controlPoints: new Te(O, 32),
    mappingData: new nu(O)
  }
});
var hO = new Me({
  version: O0,
  format: O,
  defaultBaseline: O,
  subtable: fO
});
let dO = new Me({
  setting: O,
  nameIndex: lt,
  name: (r) => r.parent.parent.parent.name.records.fontFeatures[r.nameIndex]
}), pO = new Me({
  feature: O,
  nSettings: O,
  settingTable: new Se(Oe, new Te(dO, "nSettings"), {
    type: "parent"
  }),
  featureFlags: new ka(kt, [
    null,
    null,
    null,
    null,
    null,
    null,
    "hasDefault",
    "exclusive"
  ]),
  defaultSetting: kt,
  nameIndex: lt,
  name: (r) => r.parent.parent.name.records.fontFeatures[r.nameIndex]
});
var vO = new Me({
  version: O0,
  featureNameCount: O,
  reserved1: new o0(O),
  reserved2: new o0(Oe),
  featureNames: new Te(pO, "featureNameCount")
});
let gO = new Me({
  axisTag: new Ur(4),
  minValue: O0,
  defaultValue: O0,
  maxValue: O0,
  flags: O,
  nameID: O,
  name: (r) => r.parent.parent.name.records.fontFeatures[r.nameID]
}), mO = new Me({
  nameID: O,
  name: (r) => r.parent.parent.name.records.fontFeatures[r.nameID],
  flags: O,
  coord: new Te(O0, (r) => r.parent.axisCount),
  postscriptNameID: new rd(O, (r) => r.parent.instanceSize - r._currentOffset > 0)
});
var yO = new Me({
  version: O0,
  offsetToData: O,
  countSizePairs: O,
  axisCount: O,
  axisSize: O,
  instanceCount: O,
  instanceSize: O,
  axis: new Te(gO, "axisCount"),
  instance: new Te(mO, "instanceCount")
});
let bO = new El(16, "BE", 14);
class wO {
  static decode(e, t) {
    return t.flags ? e.readUInt32BE() : e.readUInt16BE() * 2;
  }
}
let AO = new Me({
  version: O,
  reserved: new o0(O),
  axisCount: O,
  globalCoordCount: O,
  globalCoords: new Se(Oe, new Te(new Te(bO, "axisCount"), "globalCoordCount")),
  glyphCount: O,
  flags: O,
  offsetToData: Oe,
  offsets: new Te(new Se(wO, "void", {
    relativeTo: (r) => r.offsetToData,
    allowNull: !1
  }), (r) => r.glyphCount + 1)
});
var xO = AO;
let EO = new Me({
  length: O,
  coverage: O,
  subFeatureFlags: Oe,
  stateTable: new cO()
}), _O = new Me({
  justClass: Oe,
  beforeGrowLimit: O0,
  beforeShrinkLimit: O0,
  afterGrowLimit: O0,
  afterShrinkLimit: O0,
  growFlags: O,
  shrinkFlags: O
}), DO = new Te(_O, Oe), TO = new or("actionType", {
  0: {
    lowerLimit: O0,
    upperLimit: O0,
    order: O,
    glyphs: new Te(O, O)
  },
  1: {
    addGlyph: O
  },
  2: {
    substThreshold: O0,
    addGlyph: O,
    substGlyph: O
  },
  3: {},
  4: {
    variationAxis: Oe,
    minimumLimit: O0,
    noStretchValue: O0,
    maximumLimit: O0
  },
  5: {
    flags: O,
    glyph: O
  }
}), kO = new Me({
  actionClass: O,
  actionType: O,
  actionLength: Oe,
  actionData: TO,
  padding: new o0(kt, (r) => r.actionLength - r._currentOffset)
}), SO = new Te(kO, Oe), CO = new Me({
  lookupTable: new nu(new Se(O, SO))
}), Pm = new Me({
  classTable: new Se(O, EO, {
    type: "parent"
  }),
  wdcOffset: O,
  postCompensationTable: new Se(O, CO, {
    type: "parent"
  }),
  widthDeltaClusters: new nu(new Se(O, DO, {
    type: "parent",
    relativeTo: (r) => r.wdcOffset
  }))
});
var FO = new Me({
  version: Oe,
  format: O,
  horizontal: new Se(O, Pm),
  vertical: new Se(O, Pm)
});
let OO = {
  action: O
}, RO = {
  markIndex: O,
  currentIndex: O
}, IO = {
  currentInsertIndex: O,
  markedInsertIndex: O
}, PO = new Me({
  items: new fo(new Se(Oe, new nu()))
}), BO = new or("type", {
  0: {
    stateTable: new S2()
  },
  1: {
    stateTable: new S2(RO),
    substitutionTable: new Se(Oe, PO)
  },
  2: {
    stateTable: new S2(OO),
    ligatureActions: new Se(Oe, new fo(Oe)),
    components: new Se(Oe, new fo(O)),
    ligatureList: new Se(Oe, new fo(O))
  },
  4: {
    lookupTable: new nu()
  },
  5: {
    stateTable: new S2(IO),
    insertionActions: new Se(Oe, new fo(O))
  }
}), NO = new Me({
  length: Oe,
  coverage: Xs,
  type: kt,
  subFeatureFlags: Oe,
  table: BO,
  padding: new o0(kt, (r) => r.length - r._currentOffset)
}), LO = new Me({
  featureType: O,
  featureSetting: O,
  enableFlags: Oe,
  disableFlags: Oe
}), MO = new Me({
  defaultFlags: Oe,
  chainLength: Oe,
  nFeatureEntries: Oe,
  nSubtables: Oe,
  features: new Te(LO, "nFeatureEntries"),
  subtables: new Te(NO, "nSubtables")
});
var UO = new Me({
  version: O,
  unused: new o0(O),
  nChains: Oe,
  chains: new Te(MO, "nChains")
});
let $O = new Me({
  left: lt,
  top: lt,
  right: lt,
  bottom: lt
});
var zO = new Me({
  version: O0,
  format: O,
  lookupTable: new nu($O)
});
let Xt = {};
var ud = Xt;
Xt.cmap = $S;
Xt.head = zS;
Xt.hhea = jS;
Xt.hmtx = GS;
Xt.maxp = VS;
Xt.name = JS;
Xt["OS/2"] = QS;
Xt.post = eC;
Xt.fpgm = rC;
Xt.loca = nC;
Xt.prep = iC;
Xt["cvt "] = tC;
Xt.glyf = aC;
Xt["CFF "] = D7;
Xt.CFF2 = D7;
Xt.VORG = VC;
Xt.EBLC = XC;
Xt.CBLC = Xt.EBLC;
Xt.sbix = JC;
Xt.COLR = tF;
Xt.CPAL = nF;
Xt.BASE = fF;
Xt.GDEF = mF;
Xt.GPOS = SF;
Xt.GSUB = RF;
Xt.JSTF = LF;
Xt.HVAR = $F;
Xt.DSIG = WF;
Xt.gasp = VF;
Xt.hdmx = HF;
Xt.kern = XF;
Xt.LTSH = KF;
Xt.PCLT = JF;
Xt.VDMX = rO;
Xt.vhea = nO;
Xt.vmtx = aO;
Xt.avar = uO;
Xt.bsln = hO;
Xt.feat = vO;
Xt.fvar = yO;
Xt.gvar = xO;
Xt.just = FO;
Xt.morx = UO;
Xt.opbd = zO;
let jO = new Me({
  tag: new Ur(4),
  checkSum: Oe,
  offset: new Se(Oe, "void", {
    type: "global"
  }),
  length: Oe
}), Cv = new Me({
  tag: new Ur(4),
  numTables: O,
  searchRange: O,
  entrySelector: O,
  rangeShift: O,
  tables: new Te(jO, "numTables")
});
Cv.process = function() {
  let r = {};
  for (let e of this.tables) r[e.tag] = e;
  this.tables = r;
};
Cv.preEncode = function() {
  if (!Array.isArray(this.tables)) {
    let t = [];
    for (let n in this.tables) {
      let i = this.tables[n];
      i && t.push({
        tag: n,
        checkSum: 0,
        offset: new Z4(ud[n], i),
        length: ud[n].size(i)
      });
    }
    this.tables = t;
  }
  this.tag = "true", this.numTables = this.tables.length;
  let r = Math.floor(Math.log(this.numTables) / Math.LN2), e = Math.pow(2, r);
  this.searchRange = e * 16, this.entrySelector = Math.log(e) / Math.LN2, this.rangeShift = this.numTables * 16 - this.searchRange;
};
var C7 = Cv;
function wh(r, e) {
  let t = 0, n = r.length - 1;
  for (; t <= n; ) {
    let i = t + n >> 1, a = e(r[i]);
    if (a < 0) n = i - 1;
    else if (a > 0) t = i + 1;
    else return i;
  }
  return -1;
}
function pc(r, e) {
  let t = [];
  for (; r < e; ) t.push(r++);
  return t;
}
const Vd = new TextDecoder("ascii"), Bm = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Hf = new Uint8Array(256);
for (let r = 0; r < Bm.length; r++) Hf[Bm.charCodeAt(r)] = r;
function Fv(r) {
  let e = r.length * 0.75;
  r[r.length - 1] === "=" && (e--, r[r.length - 2] === "=" && e--);
  let t = new Uint8Array(e), n = 0;
  for (let i = 0, a = r.length; i < a; i += 4) {
    let o = Hf[r.charCodeAt(i)], s = Hf[r.charCodeAt(i + 1)], c = Hf[r.charCodeAt(i + 2)], h = Hf[r.charCodeAt(i + 3)];
    t[n++] = o << 2 | s >> 4, t[n++] = (s & 15) << 4 | c >> 2, t[n++] = (c & 3) << 6 | h & 63;
  }
  return t;
}
class Ov {
  findSubtable(e, t) {
    for (let [n, i] of t) for (let a of e.tables)
      if (a.platformID === n && a.encodingID === i) return a.table;
    return null;
  }
  lookup(e, t) {
    if (this.encoding) e = this.encoding.get(e) || e;
    else if (t) {
      let i = this.getVariationSelector(e, t);
      if (i) return i;
    }
    let n = this.cmap;
    switch (n.version) {
      case 0:
        return n.codeMap.get(e) || 0;
      case 4: {
        let i = 0, a = n.segCount - 1;
        for (; i <= a; ) {
          let o = i + a >> 1;
          if (e < n.startCode.get(o)) a = o - 1;
          else if (e > n.endCode.get(o)) i = o + 1;
          else {
            let s = n.idRangeOffset.get(o), c;
            if (s === 0) c = e + n.idDelta.get(o);
            else {
              let h = s / 2 + (e - n.startCode.get(o)) - (n.segCount - o);
              c = n.glyphIndexArray.get(h) || 0, c !== 0 && (c += n.idDelta.get(o));
            }
            return c & 65535;
          }
        }
        return 0;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return n.glyphIndices.get(e - n.firstCode) || 0;
      case 12:
      case 13: {
        let i = 0, a = n.nGroups - 1;
        for (; i <= a; ) {
          let o = i + a >> 1, s = n.groups.get(o);
          if (e < s.startCharCode) a = o - 1;
          else if (e > s.endCharCode) i = o + 1;
          else
            return n.version === 12 ? s.glyphID + (e - s.startCharCode) : s.glyphID;
        }
        return 0;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${n.version}`);
    }
  }
  getVariationSelector(e, t) {
    if (!this.uvs) return 0;
    let n = this.uvs.varSelectors.toArray(), i = wh(n, (o) => t - o.varSelector), a = n[i];
    return i !== -1 && a.defaultUVS && (i = wh(a.defaultUVS, (o) => e < o.startUnicodeValue ? -1 : e > o.startUnicodeValue + o.additionalCount ? 1 : 0)), i !== -1 && a.nonDefaultUVS && (i = wh(a.nonDefaultUVS, (o) => e - o.unicodeValue), i !== -1) ? a.nonDefaultUVS[i].glyphID : 0;
  }
  getCharacterSet() {
    let e = this.cmap;
    switch (e.version) {
      case 0:
        return pc(0, e.codeMap.length);
      case 4: {
        let t = [], n = e.endCode.toArray();
        for (let i = 0; i < n.length; i++) {
          let a = n[i] + 1, o = e.startCode.get(i);
          t.push(...pc(o, a));
        }
        return t;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return pc(e.firstCode, e.firstCode + e.glyphIndices.length);
      case 12:
      case 13: {
        let t = [];
        for (let n of e.groups.toArray()) t.push(...pc(n.startCharCode, n.endCharCode + 1));
        return t;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${e.version}`);
    }
  }
  codePointsForGlyph(e) {
    let t = this.cmap;
    switch (t.version) {
      case 0: {
        let i = [];
        for (let a = 0; a < 256; a++) t.codeMap.get(a) === e && i.push(a);
        return i;
      }
      case 4: {
        let i = [];
        for (let a = 0; a < t.segCount; a++) {
          let o = t.endCode.get(a), s = t.startCode.get(a), c = t.idRangeOffset.get(a), h = t.idDelta.get(a);
          for (var n = s; n <= o; n++) {
            let d = 0;
            if (c === 0) d = n + h;
            else {
              let g = c / 2 + (n - s) - (t.segCount - a);
              d = t.glyphIndexArray.get(g) || 0, d !== 0 && (d += h);
            }
            d === e && i.push(n);
          }
        }
        return i;
      }
      case 12: {
        let i = [];
        for (let a of t.groups.toArray()) e >= a.glyphID && e <= a.glyphID + (a.endCharCode - a.startCharCode) && i.push(a.startCharCode + (e - a.glyphID));
        return i;
      }
      case 13: {
        let i = [];
        for (let a of t.groups.toArray()) e === a.glyphID && i.push(...pc(a.startCharCode, a.endCharCode + 1));
        return i;
      }
      default:
        throw new Error(`Unknown cmap format ${t.version}`);
    }
  }
  constructor(e) {
    if (this.encoding = null, this.cmap = this.findSubtable(e, [
      // 32-bit subtables
      [
        3,
        10
      ],
      [
        0,
        6
      ],
      [
        0,
        4
      ],
      // 16-bit subtables
      [
        3,
        1
      ],
      [
        0,
        3
      ],
      [
        0,
        2
      ],
      [
        0,
        1
      ],
      [
        0,
        0
      ]
    ]), !this.cmap) for (let t of e.tables) {
      let n = u7(t.platformID, t.encodingID, t.table.language - 1), i = ZS(n);
      i && (this.cmap = t.table, this.encoding = i);
    }
    if (!this.cmap) throw new Error("Could not find a supported cmap table");
    this.uvs = this.findSubtable(e, [
      [
        0,
        5
      ]
    ]), this.uvs && this.uvs.version !== 14 && (this.uvs = null);
  }
}
Cn([
  Fn
], Ov.prototype, "getCharacterSet", null);
Cn([
  Fn
], Ov.prototype, "codePointsForGlyph", null);
class WO {
  process(e, t) {
    for (let n = 0; n < e.length - 1; n++) {
      let i = e[n].id, a = e[n + 1].id;
      t[n].xAdvance += this.getKerning(i, a);
    }
  }
  getKerning(e, t) {
    let n = 0;
    for (let i of this.kern.tables) {
      if (i.coverage.crossStream) continue;
      switch (i.version) {
        case 0:
          if (!i.coverage.horizontal) continue;
          break;
        case 1:
          if (i.coverage.vertical || i.coverage.variation) continue;
          break;
        default:
          throw new Error(`Unsupported kerning table version ${i.version}`);
      }
      let a = 0, o = i.subtable;
      switch (i.format) {
        case 0:
          let s = wh(o.pairs, function(g) {
            return e - g.left || t - g.right;
          });
          s >= 0 && (a = o.pairs[s].value);
          break;
        case 2:
          let c = 0, h = 0;
          e >= o.leftTable.firstGlyph && e < o.leftTable.firstGlyph + o.leftTable.nGlyphs ? c = o.leftTable.offsets[e - o.leftTable.firstGlyph] : c = o.array.off, t >= o.rightTable.firstGlyph && t < o.rightTable.firstGlyph + o.rightTable.nGlyphs && (h = o.rightTable.offsets[t - o.rightTable.firstGlyph]);
          let d = (c + h - o.array.off) / 2;
          a = o.array.values.get(d);
          break;
        case 3:
          if (e >= o.glyphCount || t >= o.glyphCount) return 0;
          a = o.kernValue[o.kernIndex[o.leftClass[e] * o.rightClassCount + o.rightClass[t]]];
          break;
        default:
          throw new Error(`Unsupported kerning sub-table format ${i.format}`);
      }
      i.coverage.override ? n = a : n += a;
    }
    return n;
  }
  constructor(e) {
    this.kern = e.kern;
  }
}
class GO {
  positionGlyphs(e, t) {
    let n = 0, i = 0;
    for (let a = 0; a < e.length; a++)
      e[a].isMark ? i = a : (n !== i && this.positionCluster(e, t, n, i), n = i = a);
    return n !== i && this.positionCluster(e, t, n, i), t;
  }
  positionCluster(e, t, n, i) {
    let a = e[n], o = a.cbox.copy();
    a.codePoints.length > 1 && (o.minX += (a.codePoints.length - 1) * o.width / a.codePoints.length);
    let s = -t[n].xAdvance, c = 0, h = this.font.unitsPerEm / 16;
    for (let d = n + 1; d <= i; d++) {
      let g = e[d], x = g.cbox, _ = t[d], k = this.getCombiningClass(g.codePoints[0]);
      if (k !== "Not_Reordered") {
        switch (_.xOffset = _.yOffset = 0, k) {
          case "Double_Above":
          case "Double_Below":
            _.xOffset += o.minX - x.width / 2 - x.minX;
            break;
          case "Attached_Below_Left":
          case "Below_Left":
          case "Above_Left":
            _.xOffset += o.minX - x.minX;
            break;
          case "Attached_Above_Right":
          case "Below_Right":
          case "Above_Right":
            _.xOffset += o.maxX - x.width - x.minX;
            break;
          default:
            _.xOffset += o.minX + (o.width - x.width) / 2 - x.minX;
        }
        switch (k) {
          case "Double_Below":
          case "Below_Left":
          case "Below":
          case "Below_Right":
          case "Attached_Below_Left":
          case "Attached_Below":
            (k === "Attached_Below_Left" || k === "Attached_Below") && (o.minY += h), _.yOffset = -o.minY - x.maxY, o.minY += x.height;
            break;
          case "Double_Above":
          case "Above_Left":
          case "Above":
          case "Above_Right":
          case "Attached_Above":
          case "Attached_Above_Right":
            (k === "Attached_Above" || k === "Attached_Above_Right") && (o.maxY += h), _.yOffset = o.maxY - x.minY, o.maxY += x.height;
            break;
        }
        _.xAdvance = _.yAdvance = 0, _.xOffset += s, _.yOffset += c;
      } else
        s -= _.xAdvance, c -= _.yAdvance;
    }
  }
  getCombiningClass(e) {
    let t = e7(e);
    if ((e & -256) === 3584) {
      if (t === "Not_Reordered") switch (e) {
        case 3633:
        case 3636:
        case 3637:
        case 3638:
        case 3639:
        case 3655:
        case 3660:
        case 3645:
        case 3662:
          return "Above_Right";
        case 3761:
        case 3764:
        case 3765:
        case 3766:
        case 3767:
        case 3771:
        case 3788:
        case 3789:
          return "Above";
        case 3772:
          return "Below";
      }
      else if (e === 3642) return "Below_Right";
    }
    switch (t) {
      case "CCC10":
      case "CCC11":
      case "CCC12":
      case "CCC13":
      case "CCC14":
      case "CCC15":
      case "CCC16":
      case "CCC17":
      case "CCC18":
      case "CCC20":
      case "CCC22":
        return "Below";
      case "CCC23":
        return "Attached_Above";
      case "CCC24":
        return "Above_Right";
      case "CCC25":
      case "CCC19":
        return "Above_Left";
      case "CCC26":
        return "Above";
      case "CCC21":
        break;
      case "CCC27":
      case "CCC28":
      case "CCC30":
      case "CCC31":
      case "CCC33":
      case "CCC34":
      case "CCC35":
      case "CCC36":
        return "Above";
      case "CCC29":
      case "CCC32":
        return "Below";
      case "CCC103":
        return "Below_Right";
      case "CCC107":
        return "Above_Right";
      case "CCC118":
        return "Below";
      case "CCC122":
        return "Above";
      case "CCC129":
      case "CCC132":
        return "Below";
      case "CCC130":
        return "Above";
    }
    return t;
  }
  constructor(e) {
    this.font = e;
  }
}
class iu {
  /**
  * The width of the bounding box
  * @type {number}
  */
  get width() {
    return this.maxX - this.minX;
  }
  /**
  * The height of the bounding box
  * @type {number}
  */
  get height() {
    return this.maxY - this.minY;
  }
  addPoint(e, t) {
    Math.abs(e) !== 1 / 0 && (e < this.minX && (this.minX = e), e > this.maxX && (this.maxX = e)), Math.abs(t) !== 1 / 0 && (t < this.minY && (this.minY = t), t > this.maxY && (this.maxY = t));
  }
  copy() {
    return new iu(this.minX, this.minY, this.maxX, this.maxY);
  }
  constructor(e = 1 / 0, t = 1 / 0, n = -1 / 0, i = -1 / 0) {
    this.minX = e, this.minY = t, this.maxX = n, this.maxY = i;
  }
}
const Hc = {
  Caucasian_Albanian: "aghb",
  Arabic: "arab",
  Imperial_Aramaic: "armi",
  Armenian: "armn",
  Avestan: "avst",
  Balinese: "bali",
  Bamum: "bamu",
  Bassa_Vah: "bass",
  Batak: "batk",
  Bengali: [
    "bng2",
    "beng"
  ],
  Bopomofo: "bopo",
  Brahmi: "brah",
  Braille: "brai",
  Buginese: "bugi",
  Buhid: "buhd",
  Chakma: "cakm",
  Canadian_Aboriginal: "cans",
  Carian: "cari",
  Cham: "cham",
  Cherokee: "cher",
  Coptic: "copt",
  Cypriot: "cprt",
  Cyrillic: "cyrl",
  Devanagari: [
    "dev2",
    "deva"
  ],
  Deseret: "dsrt",
  Duployan: "dupl",
  Egyptian_Hieroglyphs: "egyp",
  Elbasan: "elba",
  Ethiopic: "ethi",
  Georgian: "geor",
  Glagolitic: "glag",
  Gothic: "goth",
  Grantha: "gran",
  Greek: "grek",
  Gujarati: [
    "gjr2",
    "gujr"
  ],
  Gurmukhi: [
    "gur2",
    "guru"
  ],
  Hangul: "hang",
  Han: "hani",
  Hanunoo: "hano",
  Hebrew: "hebr",
  Hiragana: "hira",
  Pahawh_Hmong: "hmng",
  Katakana_Or_Hiragana: "hrkt",
  Old_Italic: "ital",
  Javanese: "java",
  Kayah_Li: "kali",
  Katakana: "kana",
  Kharoshthi: "khar",
  Khmer: "khmr",
  Khojki: "khoj",
  Kannada: [
    "knd2",
    "knda"
  ],
  Kaithi: "kthi",
  Tai_Tham: "lana",
  Lao: "lao ",
  Latin: "latn",
  Lepcha: "lepc",
  Limbu: "limb",
  Linear_A: "lina",
  Linear_B: "linb",
  Lisu: "lisu",
  Lycian: "lyci",
  Lydian: "lydi",
  Mahajani: "mahj",
  Mandaic: "mand",
  Manichaean: "mani",
  Mende_Kikakui: "mend",
  Meroitic_Cursive: "merc",
  Meroitic_Hieroglyphs: "mero",
  Malayalam: [
    "mlm2",
    "mlym"
  ],
  Modi: "modi",
  Mongolian: "mong",
  Mro: "mroo",
  Meetei_Mayek: "mtei",
  Myanmar: [
    "mym2",
    "mymr"
  ],
  Old_North_Arabian: "narb",
  Nabataean: "nbat",
  Nko: "nko ",
  Ogham: "ogam",
  Ol_Chiki: "olck",
  Old_Turkic: "orkh",
  Oriya: [
    "ory2",
    "orya"
  ],
  Osmanya: "osma",
  Palmyrene: "palm",
  Pau_Cin_Hau: "pauc",
  Old_Permic: "perm",
  Phags_Pa: "phag",
  Inscriptional_Pahlavi: "phli",
  Psalter_Pahlavi: "phlp",
  Phoenician: "phnx",
  Miao: "plrd",
  Inscriptional_Parthian: "prti",
  Rejang: "rjng",
  Runic: "runr",
  Samaritan: "samr",
  Old_South_Arabian: "sarb",
  Saurashtra: "saur",
  Shavian: "shaw",
  Sharada: "shrd",
  Siddham: "sidd",
  Khudawadi: "sind",
  Sinhala: "sinh",
  Sora_Sompeng: "sora",
  Sundanese: "sund",
  Syloti_Nagri: "sylo",
  Syriac: "syrc",
  Tagbanwa: "tagb",
  Takri: "takr",
  Tai_Le: "tale",
  New_Tai_Lue: "talu",
  Tamil: [
    "tml2",
    "taml"
  ],
  Tai_Viet: "tavt",
  Telugu: [
    "tel2",
    "telu"
  ],
  Tifinagh: "tfng",
  Tagalog: "tglg",
  Thaana: "thaa",
  Thai: "thai",
  Tibetan: "tibt",
  Tirhuta: "tirh",
  Ugaritic: "ugar",
  Vai: "vai ",
  Warang_Citi: "wara",
  Old_Persian: "xpeo",
  Cuneiform: "xsux",
  Yi: "yi  ",
  Inherited: "zinh",
  Common: "zyyy",
  Unknown: "zzzz"
}, t3 = {};
for (let r in Hc) {
  let e = Hc[r];
  if (Array.isArray(e)) for (let t of e) t3[t] = r;
  else t3[e] = r;
}
function VO(r) {
  return t3[r];
}
function YO(r) {
  let e = r.length, t = 0;
  for (; t < e; ) {
    let n = r.charCodeAt(t++);
    if (55296 <= n && n <= 56319 && t < e) {
      let a = r.charCodeAt(t);
      56320 <= a && a <= 57343 && (t++, n = ((n & 1023) << 10) + (a & 1023) + 65536);
    }
    let i = _v(n);
    if (i !== "Common" && i !== "Inherited" && i !== "Unknown") return Hc[i];
  }
  return Hc.Unknown;
}
function HO(r) {
  for (let e = 0; e < r.length; e++) {
    let t = r[e], n = _v(t);
    if (n !== "Common" && n !== "Inherited" && n !== "Unknown") return Hc[n];
  }
  return Hc.Unknown;
}
const ZO = {
  arab: !0,
  hebr: !0,
  syrc: !0,
  thaa: !0,
  cprt: !0,
  khar: !0,
  phnx: !0,
  "nko ": !0,
  lydi: !0,
  avst: !0,
  armi: !0,
  phli: !0,
  prti: !0,
  sarb: !0,
  orkh: !0,
  samr: !0,
  mand: !0,
  merc: !0,
  mero: !0,
  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
  mani: !0,
  mend: !0,
  nbat: !0,
  narb: !0,
  palm: !0,
  phlp: !0
  // Psalter Pahlavi
};
function F7(r) {
  return ZO[r] ? "rtl" : "ltr";
}
class qO {
  /**
  * The total advance width of the run.
  * @type {number}
  */
  get advanceWidth() {
    let e = 0;
    for (let t of this.positions) e += t.xAdvance;
    return e;
  }
  /**
  * The total advance height of the run.
  * @type {number}
  */
  get advanceHeight() {
    let e = 0;
    for (let t of this.positions) e += t.yAdvance;
    return e;
  }
  /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */
  get bbox() {
    let e = new iu(), t = 0, n = 0;
    for (let i = 0; i < this.glyphs.length; i++) {
      let a = this.glyphs[i], o = this.positions[i], s = a.bbox;
      e.addPoint(s.minX + t + o.xOffset, s.minY + n + o.yOffset), e.addPoint(s.maxX + t + o.xOffset, s.maxY + n + o.yOffset), t += o.xAdvance, n += o.yAdvance;
    }
    return e;
  }
  constructor(e, t, n, i, a) {
    if (this.glyphs = e, this.positions = null, this.script = n, this.language = i || null, this.direction = a || F7(n), this.features = {}, Array.isArray(t)) for (let o of t) this.features[o] = !0;
    else typeof t == "object" && (this.features = t);
  }
}
class XO {
  constructor(e = 0, t = 0, n = 0, i = 0) {
    this.xAdvance = e, this.yAdvance = t, this.xOffset = n, this.yOffset = i;
  }
}
const Zu = {
  allTypographicFeatures: {
    code: 0,
    exclusive: !1,
    allTypeFeatures: 0
  },
  ligatures: {
    code: 1,
    exclusive: !1,
    requiredLigatures: 0,
    commonLigatures: 2,
    rareLigatures: 4,
    // logos: 6
    rebusPictures: 8,
    diphthongLigatures: 10,
    squaredLigatures: 12,
    abbrevSquaredLigatures: 14,
    symbolLigatures: 16,
    contextualLigatures: 18,
    historicalLigatures: 20
  },
  cursiveConnection: {
    code: 2,
    exclusive: !0,
    unconnected: 0,
    partiallyConnected: 1,
    cursive: 2
  },
  letterCase: {
    code: 3,
    exclusive: !0
  },
  // upperAndLowerCase: 0          # deprecated
  // allCaps: 1                    # deprecated
  // allLowerCase: 2               # deprecated
  // smallCaps: 3                  # deprecated
  // initialCaps: 4                # deprecated
  // initialCapsAndSmallCaps: 5    # deprecated
  verticalSubstitution: {
    code: 4,
    exclusive: !1,
    substituteVerticalForms: 0
  },
  linguisticRearrangement: {
    code: 5,
    exclusive: !1,
    linguisticRearrangement: 0
  },
  numberSpacing: {
    code: 6,
    exclusive: !0,
    monospacedNumbers: 0,
    proportionalNumbers: 1,
    thirdWidthNumbers: 2,
    quarterWidthNumbers: 3
  },
  smartSwash: {
    code: 8,
    exclusive: !1,
    wordInitialSwashes: 0,
    wordFinalSwashes: 2,
    // lineInitialSwashes: 4
    // lineFinalSwashes: 6
    nonFinalSwashes: 8
  },
  diacritics: {
    code: 9,
    exclusive: !0,
    showDiacritics: 0,
    hideDiacritics: 1,
    decomposeDiacritics: 2
  },
  verticalPosition: {
    code: 10,
    exclusive: !0,
    normalPosition: 0,
    superiors: 1,
    inferiors: 2,
    ordinals: 3,
    scientificInferiors: 4
  },
  fractions: {
    code: 11,
    exclusive: !0,
    noFractions: 0,
    verticalFractions: 1,
    diagonalFractions: 2
  },
  overlappingCharacters: {
    code: 13,
    exclusive: !1,
    preventOverlap: 0
  },
  typographicExtras: {
    code: 14,
    exclusive: !1,
    // hyphensToEmDash: 0
    // hyphenToEnDash: 2
    slashedZero: 4
  },
  // formInterrobang: 6
  // smartQuotes: 8
  // periodsToEllipsis: 10
  mathematicalExtras: {
    code: 15,
    exclusive: !1,
    // hyphenToMinus: 0
    // asteristoMultiply: 2
    // slashToDivide: 4
    // inequalityLigatures: 6
    // exponents: 8
    mathematicalGreek: 10
  },
  ornamentSets: {
    code: 16,
    exclusive: !0,
    noOrnaments: 0,
    dingbats: 1,
    piCharacters: 2,
    fleurons: 3,
    decorativeBorders: 4,
    internationalSymbols: 5,
    mathSymbols: 6
  },
  characterAlternatives: {
    code: 17,
    exclusive: !0,
    noAlternates: 0
  },
  // user defined options
  designComplexity: {
    code: 18,
    exclusive: !0,
    designLevel1: 0,
    designLevel2: 1,
    designLevel3: 2,
    designLevel4: 3,
    designLevel5: 4
  },
  styleOptions: {
    code: 19,
    exclusive: !0,
    noStyleOptions: 0,
    displayText: 1,
    engravedText: 2,
    illuminatedCaps: 3,
    titlingCaps: 4,
    tallCaps: 5
  },
  characterShape: {
    code: 20,
    exclusive: !0,
    traditionalCharacters: 0,
    simplifiedCharacters: 1,
    JIS1978Characters: 2,
    JIS1983Characters: 3,
    JIS1990Characters: 4,
    traditionalAltOne: 5,
    traditionalAltTwo: 6,
    traditionalAltThree: 7,
    traditionalAltFour: 8,
    traditionalAltFive: 9,
    expertCharacters: 10,
    JIS2004Characters: 11,
    hojoCharacters: 12,
    NLCCharacters: 13,
    traditionalNamesCharacters: 14
  },
  numberCase: {
    code: 21,
    exclusive: !0,
    lowerCaseNumbers: 0,
    upperCaseNumbers: 1
  },
  textSpacing: {
    code: 22,
    exclusive: !0,
    proportionalText: 0,
    monospacedText: 1,
    halfWidthText: 2,
    thirdWidthText: 3,
    quarterWidthText: 4,
    altProportionalText: 5,
    altHalfWidthText: 6
  },
  transliteration: {
    code: 23,
    exclusive: !0,
    noTransliteration: 0
  },
  // hanjaToHangul: 1
  // hiraganaToKatakana: 2
  // katakanaToHiragana: 3
  // kanaToRomanization: 4
  // romanizationToHiragana: 5
  // romanizationToKatakana: 6
  // hanjaToHangulAltOne: 7
  // hanjaToHangulAltTwo: 8
  // hanjaToHangulAltThree: 9
  annotation: {
    code: 24,
    exclusive: !0,
    noAnnotation: 0,
    boxAnnotation: 1,
    roundedBoxAnnotation: 2,
    circleAnnotation: 3,
    invertedCircleAnnotation: 4,
    parenthesisAnnotation: 5,
    periodAnnotation: 6,
    romanNumeralAnnotation: 7,
    diamondAnnotation: 8,
    invertedBoxAnnotation: 9,
    invertedRoundedBoxAnnotation: 10
  },
  kanaSpacing: {
    code: 25,
    exclusive: !0,
    fullWidthKana: 0,
    proportionalKana: 1
  },
  ideographicSpacing: {
    code: 26,
    exclusive: !0,
    fullWidthIdeographs: 0,
    proportionalIdeographs: 1,
    halfWidthIdeographs: 2
  },
  unicodeDecomposition: {
    code: 27,
    exclusive: !1,
    canonicalComposition: 0,
    compatibilityComposition: 2,
    transcodingComposition: 4
  },
  rubyKana: {
    code: 28,
    exclusive: !1,
    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
    // rubyKana: 1     # deprecated - use rubyKanaOn instead
    rubyKana: 2
  },
  CJKSymbolAlternatives: {
    code: 29,
    exclusive: !0,
    noCJKSymbolAlternatives: 0,
    CJKSymbolAltOne: 1,
    CJKSymbolAltTwo: 2,
    CJKSymbolAltThree: 3,
    CJKSymbolAltFour: 4,
    CJKSymbolAltFive: 5
  },
  ideographicAlternatives: {
    code: 30,
    exclusive: !0,
    noIdeographicAlternatives: 0,
    ideographicAltOne: 1,
    ideographicAltTwo: 2,
    ideographicAltThree: 3,
    ideographicAltFour: 4,
    ideographicAltFive: 5
  },
  CJKVerticalRomanPlacement: {
    code: 31,
    exclusive: !0,
    CJKVerticalRomanCentered: 0,
    CJKVerticalRomanHBaseline: 1
  },
  italicCJKRoman: {
    code: 32,
    exclusive: !1,
    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
    CJKItalicRoman: 2
  },
  caseSensitiveLayout: {
    code: 33,
    exclusive: !1,
    caseSensitiveLayout: 0,
    caseSensitiveSpacing: 2
  },
  alternateKana: {
    code: 34,
    exclusive: !1,
    alternateHorizKana: 0,
    alternateVertKana: 2
  },
  stylisticAlternatives: {
    code: 35,
    exclusive: !1,
    noStylisticAlternates: 0,
    stylisticAltOne: 2,
    stylisticAltTwo: 4,
    stylisticAltThree: 6,
    stylisticAltFour: 8,
    stylisticAltFive: 10,
    stylisticAltSix: 12,
    stylisticAltSeven: 14,
    stylisticAltEight: 16,
    stylisticAltNine: 18,
    stylisticAltTen: 20,
    stylisticAltEleven: 22,
    stylisticAltTwelve: 24,
    stylisticAltThirteen: 26,
    stylisticAltFourteen: 28,
    stylisticAltFifteen: 30,
    stylisticAltSixteen: 32,
    stylisticAltSeventeen: 34,
    stylisticAltEighteen: 36,
    stylisticAltNineteen: 38,
    stylisticAltTwenty: 40
  },
  contextualAlternates: {
    code: 36,
    exclusive: !1,
    contextualAlternates: 0,
    swashAlternates: 2,
    contextualSwashAlternates: 4
  },
  lowerCase: {
    code: 37,
    exclusive: !0,
    defaultLowerCase: 0,
    lowerCaseSmallCaps: 1,
    lowerCasePetiteCaps: 2
  },
  upperCase: {
    code: 38,
    exclusive: !0,
    defaultUpperCase: 0,
    upperCaseSmallCaps: 1,
    upperCasePetiteCaps: 2
  },
  languageTag: {
    code: 39,
    exclusive: !0
  },
  CJKRomanSpacing: {
    code: 103,
    exclusive: !0,
    halfWidthCJKRoman: 0,
    proportionalCJKRoman: 1,
    defaultCJKRoman: 2,
    fullWidthCJKRoman: 3
  }
}, Dt = (r, e) => [
  Zu[r].code,
  Zu[r][e]
], ld = {
  rlig: Dt("ligatures", "requiredLigatures"),
  clig: Dt("ligatures", "contextualLigatures"),
  dlig: Dt("ligatures", "rareLigatures"),
  hlig: Dt("ligatures", "historicalLigatures"),
  liga: Dt("ligatures", "commonLigatures"),
  hist: Dt("ligatures", "historicalLigatures"),
  smcp: Dt("lowerCase", "lowerCaseSmallCaps"),
  pcap: Dt("lowerCase", "lowerCasePetiteCaps"),
  frac: Dt("fractions", "diagonalFractions"),
  dnom: Dt("fractions", "diagonalFractions"),
  numr: Dt("fractions", "diagonalFractions"),
  afrc: Dt("fractions", "verticalFractions"),
  // aalt
  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
  // unic, vatu, vhal, vjmo, vpal, vrt2
  // dist -> trak table?
  // kern, vkrn -> kern table
  // lfbd + opbd + rtbd -> opbd table?
  // mark, mkmk -> acnt table?
  // locl -> languageTag + ltag table
  case: Dt("caseSensitiveLayout", "caseSensitiveLayout"),
  ccmp: Dt("unicodeDecomposition", "canonicalComposition"),
  cpct: Dt("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  valt: Dt("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  swsh: Dt("contextualAlternates", "swashAlternates"),
  cswh: Dt("contextualAlternates", "contextualSwashAlternates"),
  curs: Dt("cursiveConnection", "cursive"),
  c2pc: Dt("upperCase", "upperCasePetiteCaps"),
  c2sc: Dt("upperCase", "upperCaseSmallCaps"),
  init: Dt("smartSwash", "wordInitialSwashes"),
  fin2: Dt("smartSwash", "wordFinalSwashes"),
  medi: Dt("smartSwash", "nonFinalSwashes"),
  med2: Dt("smartSwash", "nonFinalSwashes"),
  fin3: Dt("smartSwash", "wordFinalSwashes"),
  fina: Dt("smartSwash", "wordFinalSwashes"),
  pkna: Dt("kanaSpacing", "proportionalKana"),
  half: Dt("textSpacing", "halfWidthText"),
  halt: Dt("textSpacing", "altHalfWidthText"),
  hkna: Dt("alternateKana", "alternateHorizKana"),
  vkna: Dt("alternateKana", "alternateVertKana"),
  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
  ital: Dt("italicCJKRoman", "CJKItalicRoman"),
  lnum: Dt("numberCase", "upperCaseNumbers"),
  onum: Dt("numberCase", "lowerCaseNumbers"),
  mgrk: Dt("mathematicalExtras", "mathematicalGreek"),
  // nalt: not enough info. what type of annotation?
  // ornm: ditto, which ornament style?
  calt: Dt("contextualAlternates", "contextualAlternates"),
  vrt2: Dt("verticalSubstitution", "substituteVerticalForms"),
  vert: Dt("verticalSubstitution", "substituteVerticalForms"),
  tnum: Dt("numberSpacing", "monospacedNumbers"),
  pnum: Dt("numberSpacing", "proportionalNumbers"),
  sups: Dt("verticalPosition", "superiors"),
  subs: Dt("verticalPosition", "inferiors"),
  ordn: Dt("verticalPosition", "ordinals"),
  pwid: Dt("textSpacing", "proportionalText"),
  hwid: Dt("textSpacing", "halfWidthText"),
  qwid: Dt("textSpacing", "quarterWidthText"),
  twid: Dt("textSpacing", "thirdWidthText"),
  fwid: Dt("textSpacing", "proportionalText"),
  palt: Dt("textSpacing", "altProportionalText"),
  trad: Dt("characterShape", "traditionalCharacters"),
  smpl: Dt("characterShape", "simplifiedCharacters"),
  jp78: Dt("characterShape", "JIS1978Characters"),
  jp83: Dt("characterShape", "JIS1983Characters"),
  jp90: Dt("characterShape", "JIS1990Characters"),
  jp04: Dt("characterShape", "JIS2004Characters"),
  expt: Dt("characterShape", "expertCharacters"),
  hojo: Dt("characterShape", "hojoCharacters"),
  nlck: Dt("characterShape", "NLCCharacters"),
  tnam: Dt("characterShape", "traditionalNamesCharacters"),
  ruby: Dt("rubyKana", "rubyKana"),
  titl: Dt("styleOptions", "titlingCaps"),
  zero: Dt("typographicExtras", "slashedZero"),
  ss01: Dt("stylisticAlternatives", "stylisticAltOne"),
  ss02: Dt("stylisticAlternatives", "stylisticAltTwo"),
  ss03: Dt("stylisticAlternatives", "stylisticAltThree"),
  ss04: Dt("stylisticAlternatives", "stylisticAltFour"),
  ss05: Dt("stylisticAlternatives", "stylisticAltFive"),
  ss06: Dt("stylisticAlternatives", "stylisticAltSix"),
  ss07: Dt("stylisticAlternatives", "stylisticAltSeven"),
  ss08: Dt("stylisticAlternatives", "stylisticAltEight"),
  ss09: Dt("stylisticAlternatives", "stylisticAltNine"),
  ss10: Dt("stylisticAlternatives", "stylisticAltTen"),
  ss11: Dt("stylisticAlternatives", "stylisticAltEleven"),
  ss12: Dt("stylisticAlternatives", "stylisticAltTwelve"),
  ss13: Dt("stylisticAlternatives", "stylisticAltThirteen"),
  ss14: Dt("stylisticAlternatives", "stylisticAltFourteen"),
  ss15: Dt("stylisticAlternatives", "stylisticAltFifteen"),
  ss16: Dt("stylisticAlternatives", "stylisticAltSixteen"),
  ss17: Dt("stylisticAlternatives", "stylisticAltSeventeen"),
  ss18: Dt("stylisticAlternatives", "stylisticAltEighteen"),
  ss19: Dt("stylisticAlternatives", "stylisticAltNineteen"),
  ss20: Dt("stylisticAlternatives", "stylisticAltTwenty")
};
for (let r = 1; r <= 99; r++) ld[`cv${`00${r}`.slice(-2)}`] = [
  Zu.characterAlternatives.code,
  r
];
let qu = {};
for (let r in ld) {
  let e = ld[r];
  qu[e[0]] == null && (qu[e[0]] = {}), qu[e[0]][e[1]] = r;
}
function KO(r) {
  let e = {};
  for (let t in r) {
    let n;
    (n = ld[t]) && (e[n[0]] == null && (e[n[0]] = {}), e[n[0]][n[1]] = r[t]);
  }
  return e;
}
function Nm(r) {
  let [e, t] = r;
  if (isNaN(e)) var n = Zu[e] && Zu[e].code;
  else var n = e;
  if (isNaN(t)) var i = Zu[e] && Zu[e][t];
  else var i = t;
  return [
    n,
    i
  ];
}
function JO(r) {
  let e = {};
  if (Array.isArray(r)) for (let t = 0; t < r.length; t++) {
    let n, i = Nm(r[t]);
    (n = qu[i[0]] && qu[i[0]][i[1]]) && (e[n] = !0);
  }
  else if (typeof r == "object") for (let t in r) {
    let n = r[t];
    for (let i in n) {
      let a, o = Nm([
        t,
        i
      ]);
      n[i] && (a = qu[o[0]] && qu[o[0]][o[1]]) && (e[a] = !0);
    }
  }
  return Object.keys(e);
}
class t1 {
  lookup(e) {
    switch (this.table.version) {
      case 0:
        return this.table.values.getItem(e);
      case 2:
      case 4: {
        let i = 0, a = this.table.binarySearchHeader.nUnits - 1;
        for (; i <= a; ) {
          var t = i + a >> 1, n = this.table.segments[t];
          if (n.firstGlyph === 65535) return null;
          if (e < n.firstGlyph) a = t - 1;
          else if (e > n.lastGlyph) i = t + 1;
          else
            return this.table.version === 2 ? n.value : n.values[e - n.firstGlyph];
        }
        return null;
      }
      case 6: {
        let i = 0, a = this.table.binarySearchHeader.nUnits - 1;
        for (; i <= a; ) {
          var t = i + a >> 1, n = this.table.segments[t];
          if (n.glyph === 65535) return null;
          if (e < n.glyph) a = t - 1;
          else if (e > n.glyph) i = t + 1;
          else return n.value;
        }
        return null;
      }
      case 8:
        return this.table.values[e - this.table.firstGlyph];
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
  }
  glyphsForValue(e) {
    let t = [];
    switch (this.table.version) {
      case 2:
      case 4:
        for (let n of this.table.segments) if (this.table.version === 2 && n.value === e) t.push(...pc(n.firstGlyph, n.lastGlyph + 1));
        else
          for (let i = 0; i < n.values.length; i++) n.values[i] === e && t.push(n.firstGlyph + i);
        break;
      case 6:
        for (let n of this.table.segments) n.value === e && t.push(n.glyph);
        break;
      case 8:
        for (let n = 0; n < this.table.values.length; n++) this.table.values[n] === e && t.push(this.table.firstGlyph + n);
        break;
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
    return t;
  }
  constructor(e) {
    this.table = e;
  }
}
Cn([
  Fn
], t1.prototype, "glyphsForValue", null);
const QO = 0, Lm = 0, Mm = 1, Um = 2, eR = 16384;
class tR {
  process(e, t, n) {
    let i = QO, a = t ? e.length - 1 : 0, o = t ? -1 : 1;
    for (; o === 1 && a <= e.length || o === -1 && a >= -1; ) {
      let s = null, c = Mm, h = !0;
      a === e.length || a === -1 ? c = Lm : (s = e[a], s.id === 65535 ? c = Um : (c = this.lookupTable.lookup(s.id), c == null && (c = Mm)));
      let g = this.stateTable.stateArray.getItem(i)[c], x = this.stateTable.entryTable.getItem(g);
      c !== Lm && c !== Um && (n(s, x, a), h = !(x.flags & eR)), i = x.newState, h && (a += o);
    }
    return e;
  }
  /**
  * Performs a depth-first traversal of the glyph strings
  * represented by the state machine.
  */
  traverse(e, t = 0, n = /* @__PURE__ */ new Set()) {
    if (n.has(t)) return;
    n.add(t);
    let { nClasses: i, stateArray: a, entryTable: o } = this.stateTable, s = a.getItem(t);
    for (let c = 4; c < i; c++) {
      let h = s[c], d = o.getItem(h);
      for (let g of this.lookupTable.glyphsForValue(c))
        e.enter && e.enter(g, d), d.newState !== 0 && this.traverse(e, d.newState, n), e.exit && e.exit(g, d);
    }
  }
  constructor(e) {
    this.stateTable = e, this.lookupTable = new t1(e.classTable);
  }
}
const rR = 32768, nR = 8192, iR = 15, $m = 32768, aR = 32768, oR = 8192, sR = 2147483648, uR = 1073741824, lR = 1073741823, zm = 4194304, cR = 2048, fR = 1024, hR = 992, dR = 31;
class O7 {
  // Processes an array of glyphs and applies the specified features
  // Features should be in the form of {featureType:{featureSetting:boolean}}
  process(e, t = {}) {
    for (let i of this.morx.chains) {
      let a = i.defaultFlags;
      for (let o of i.features) {
        let s;
        (s = t[o.featureType]) && (s[o.featureSetting] ? (a &= o.disableFlags, a |= o.enableFlags) : s[o.featureSetting] === !1 && (a |= ~o.disableFlags, a &= ~o.enableFlags));
      }
      for (let o of i.subtables) o.subFeatureFlags & a && this.processSubtable(o, e);
    }
    let n = e.length - 1;
    for (; n >= 0; )
      e[n].id === 65535 && e.splice(n, 1), n--;
    return e;
  }
  processSubtable(e, t) {
    if (this.subtable = e, this.glyphs = t, this.subtable.type === 4) {
      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
      return;
    }
    this.ligatureStack = [], this.markedGlyph = null, this.firstGlyph = null, this.lastGlyph = null, this.markedIndex = null;
    let n = this.getStateMachine(e), i = this.getProcessor(), a = !!(this.subtable.coverage & zm);
    return n.process(this.glyphs, a, i);
  }
  getStateMachine(e) {
    return new tR(e.table.stateTable);
  }
  getProcessor() {
    switch (this.subtable.type) {
      case 0:
        return this.processIndicRearragement;
      case 1:
        return this.processContextualSubstitution;
      case 2:
        return this.processLigature;
      case 4:
        return this.processNoncontextualSubstitutions;
      case 5:
        return this.processGlyphInsertion;
      default:
        throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
    }
  }
  processIndicRearragement(e, t, n) {
    t.flags & rR && (this.firstGlyph = n), t.flags & nR && (this.lastGlyph = n), pR(this.glyphs, t.flags & iR, this.firstGlyph, this.lastGlyph);
  }
  processContextualSubstitution(e, t, n) {
    let i = this.subtable.table.substitutionTable.items;
    if (t.markIndex !== 65535) {
      let o = i.getItem(t.markIndex), s = new t1(o);
      e = this.glyphs[this.markedGlyph];
      var a = s.lookup(e.id);
      a && (this.glyphs[this.markedGlyph] = this.font.getGlyph(a, e.codePoints));
    }
    if (t.currentIndex !== 65535) {
      let o = i.getItem(t.currentIndex), s = new t1(o);
      e = this.glyphs[n];
      var a = s.lookup(e.id);
      a && (this.glyphs[n] = this.font.getGlyph(a, e.codePoints));
    }
    t.flags & $m && (this.markedGlyph = n);
  }
  processLigature(e, t, n) {
    if (t.flags & aR && this.ligatureStack.push(n), t.flags & oR) {
      let i = this.subtable.table.ligatureActions, a = this.subtable.table.components, o = this.subtable.table.ligatureList, s = t.action, c = !1, h = 0, d = [], g = [];
      for (; !c; ) {
        let x = this.ligatureStack.pop();
        d.unshift(...this.glyphs[x].codePoints);
        let _ = i.getItem(s++);
        c = !!(_ & sR);
        let k = !!(_ & uR), P = (_ & lR) << 2 >> 2;
        P += this.glyphs[x].id;
        let N = a.getItem(P);
        if (h += N, c || k) {
          let M = o.getItem(h);
          this.glyphs[x] = this.font.getGlyph(M, d), g.push(x), h = 0, d = [];
        } else this.glyphs[x] = this.font.getGlyph(65535);
      }
      this.ligatureStack.push(...g);
    }
  }
  processNoncontextualSubstitutions(e, t, n) {
    let i = new t1(e.table.lookupTable);
    for (n = 0; n < t.length; n++) {
      let a = t[n];
      if (a.id !== 65535) {
        let o = i.lookup(a.id);
        o && (t[n] = this.font.getGlyph(o, a.codePoints));
      }
    }
  }
  _insertGlyphs(e, t, n, i) {
    let a = [];
    for (; n--; ) {
      let o = this.subtable.table.insertionActions.getItem(t++);
      a.push(this.font.getGlyph(o));
    }
    i || e++, this.glyphs.splice(e, 0, ...a);
  }
  processGlyphInsertion(e, t, n) {
    if (t.flags & $m && (this.markedIndex = n), t.markedInsertIndex !== 65535) {
      let i = (t.flags & dR) >>> 5, a = !!(t.flags & fR);
      this._insertGlyphs(this.markedIndex, t.markedInsertIndex, i, a);
    }
    if (t.currentInsertIndex !== 65535) {
      let i = (t.flags & hR) >>> 5, a = !!(t.flags & cR);
      this._insertGlyphs(n, t.currentInsertIndex, i, a);
    }
  }
  getSupportedFeatures() {
    let e = [];
    for (let t of this.morx.chains) for (let n of t.features) e.push([
      n.featureType,
      n.featureSetting
    ]);
    return e;
  }
  generateInputs(e) {
    return this.inputCache || this.generateInputCache(), this.inputCache[e] || [];
  }
  generateInputCache() {
    this.inputCache = {};
    for (let e of this.morx.chains) {
      let t = e.defaultFlags;
      for (let n of e.subtables) n.subFeatureFlags & t && this.generateInputsForSubtable(n);
    }
  }
  generateInputsForSubtable(e) {
    if (e.type !== 2) return;
    if (!!(e.coverage & zm)) throw new Error("Reverse subtable, not supported.");
    this.subtable = e, this.ligatureStack = [];
    let n = this.getStateMachine(e), i = this.getProcessor(), a = [], o = [];
    this.glyphs = [], n.traverse({
      enter: (s, c) => {
        let h = this.glyphs;
        o.push({
          glyphs: h.slice(),
          ligatureStack: this.ligatureStack.slice()
        });
        let d = this.font.getGlyph(s);
        a.push(d), h.push(a[a.length - 1]), i(h[h.length - 1], c, h.length - 1);
        let g = 0, x = 0;
        for (let _ = 0; _ < h.length && g <= 1; _++) h[_].id !== 65535 && (g++, x = h[_].id);
        if (g === 1) {
          let _ = a.map((P) => P.id), k = this.inputCache[x];
          k ? k.push(_) : this.inputCache[x] = [
            _
          ];
        }
      },
      exit: () => {
        ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = o.pop()), a.pop();
      }
    });
  }
  constructor(e) {
    this.processIndicRearragement = this.processIndicRearragement.bind(this), this.processContextualSubstitution = this.processContextualSubstitution.bind(this), this.processLigature = this.processLigature.bind(this), this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this), this.processGlyphInsertion = this.processGlyphInsertion.bind(this), this.font = e, this.morx = e.morx, this.inputCache = null;
  }
}
Cn([
  Fn
], O7.prototype, "getStateMachine", null);
function Yn(r, e, t, n = !1, i = !1) {
  let a = r.splice(t[0] - (t[1] - 1), t[1]);
  i && a.reverse();
  let o = r.splice(e[0], e[1], ...a);
  return n && o.reverse(), r.splice(t[0] - (e[1] - 1), 0, ...o), r;
}
function pR(r, e, t, n) {
  switch (e) {
    case 0:
      return r;
    case 1:
      return Yn(r, [
        t,
        1
      ], [
        n,
        0
      ]);
    case 2:
      return Yn(r, [
        t,
        0
      ], [
        n,
        1
      ]);
    case 3:
      return Yn(r, [
        t,
        1
      ], [
        n,
        1
      ]);
    case 4:
      return Yn(r, [
        t,
        2
      ], [
        n,
        0
      ]);
    case 5:
      return Yn(r, [
        t,
        2
      ], [
        n,
        0
      ], !0, !1);
    case 6:
      return Yn(r, [
        t,
        0
      ], [
        n,
        2
      ]);
    case 7:
      return Yn(r, [
        t,
        0
      ], [
        n,
        2
      ], !1, !0);
    case 8:
      return Yn(r, [
        t,
        1
      ], [
        n,
        2
      ]);
    case 9:
      return Yn(r, [
        t,
        1
      ], [
        n,
        2
      ], !1, !0);
    case 10:
      return Yn(r, [
        t,
        2
      ], [
        n,
        1
      ]);
    case 11:
      return Yn(r, [
        t,
        2
      ], [
        n,
        1
      ], !0, !1);
    case 12:
      return Yn(r, [
        t,
        2
      ], [
        n,
        2
      ]);
    case 13:
      return Yn(r, [
        t,
        2
      ], [
        n,
        2
      ], !0, !1);
    case 14:
      return Yn(r, [
        t,
        2
      ], [
        n,
        2
      ], !1, !0);
    case 15:
      return Yn(r, [
        t,
        2
      ], [
        n,
        2
      ], !0, !0);
    default:
      throw new Error(`Unknown verb: ${e}`);
  }
}
class vR {
  substitute(e) {
    e.direction === "rtl" && e.glyphs.reverse(), this.morxProcessor.process(e.glyphs, KO(e.features));
  }
  getAvailableFeatures(e, t) {
    return JO(this.morxProcessor.getSupportedFeatures());
  }
  stringsForGlyph(e) {
    let t = this.morxProcessor.generateInputs(e), n = /* @__PURE__ */ new Set();
    for (let i of t) this._addStrings(i, 0, n, "");
    return n;
  }
  _addStrings(e, t, n, i) {
    let a = this.font._cmapProcessor.codePointsForGlyph(e[t]);
    for (let o of a) {
      let s = i + String.fromCodePoint(o);
      t < e.length - 1 ? this._addStrings(e, t + 1, n, s) : n.add(s);
    }
  }
  constructor(e) {
    this.font = e, this.morxProcessor = new O7(e), this.fallbackPosition = !1;
  }
}
class gR {
  /**
  * Adds the given features to the last stage.
  * Ignores features that have already been applied.
  */
  _addFeatures(e, t) {
    let n = this.stages.length - 1, i = this.stages[n];
    for (let a of e) this.allFeatures[a] == null && (i.push(a), this.allFeatures[a] = n, t && (this.globalFeatures[a] = !0));
  }
  /**
  * Add features to the last stage
  */
  add(e, t = !0) {
    if (this.stages.length === 0 && this.stages.push([]), typeof e == "string" && (e = [
      e
    ]), Array.isArray(e)) this._addFeatures(e, t);
    else if (typeof e == "object")
      this._addFeatures(e.global || [], !0), this._addFeatures(e.local || [], !1);
    else throw new Error("Unsupported argument to ShapingPlan#add");
  }
  /**
  * Add a new stage
  */
  addStage(e, t) {
    typeof e == "function" ? this.stages.push(e, []) : (this.stages.push([]), this.add(e, t));
  }
  setFeatureOverrides(e) {
    if (Array.isArray(e)) this.add(e);
    else if (typeof e == "object") {
      for (let t in e)
        if (e[t]) this.add(t);
        else if (this.allFeatures[t] != null) {
          let n = this.stages[this.allFeatures[t]];
          n.splice(n.indexOf(t), 1), delete this.allFeatures[t], delete this.globalFeatures[t];
        }
    }
  }
  /**
  * Assigns the global features to the given glyphs
  */
  assignGlobalFeatures(e) {
    for (let t of e) for (let n in this.globalFeatures) t.features[n] = !0;
  }
  /**
  * Executes the planned stages using the given OTProcessor
  */
  process(e, t, n) {
    for (let i of this.stages)
      typeof i == "function" ? n || i(this.font, t, this) : i.length > 0 && e.applyFeatures(i, t, n);
  }
  constructor(e, t, n) {
    this.font = e, this.script = t, this.direction = n, this.stages = [], this.globalFeatures = {}, this.allFeatures = {};
  }
}
const mR = [
  "rvrn"
], yR = [
  "ccmp",
  "locl",
  "rlig",
  "mark",
  "mkmk"
], bR = [
  "frac",
  "numr",
  "dnom"
], wR = [
  "calt",
  "clig",
  "liga",
  "rclt",
  "curs",
  "kern"
], AR = {
  ltr: [
    "ltra",
    "ltrm"
  ],
  rtl: [
    "rtla",
    "rtlm"
  ]
};
class au {
  static plan(e, t, n) {
    this.planPreprocessing(e), this.planFeatures(e), this.planPostprocessing(e, n), e.assignGlobalFeatures(t), this.assignFeatures(e, t);
  }
  static planPreprocessing(e) {
    e.add({
      global: [
        ...mR,
        ...AR[e.direction]
      ],
      local: bR
    });
  }
  static planFeatures(e) {
  }
  static planPostprocessing(e, t) {
    e.add([
      ...yR,
      ...wR
    ]), e.setFeatureOverrides(t);
  }
  static assignFeatures(e, t) {
    for (let n = 0; n < t.length; n++) {
      let i = t[n];
      if (i.codePoints[0] === 8260) {
        let a = n, o = n + 1;
        for (; a > 0 && X4(t[a - 1].codePoints[0]); )
          t[a - 1].features.numr = !0, t[a - 1].features.frac = !0, a--;
        for (; o < t.length && X4(t[o].codePoints[0]); )
          t[o].features.dnom = !0, t[o].features.frac = !0, o++;
        i.features.frac = !0, n = o - 1;
      }
    }
  }
}
hi(au, "zeroMarkWidths", "AFTER_GPOS");
const xR = new Ud(Fv("ABABAAAAAACgMQAAAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0=")), jm = [
  "isol",
  "fina",
  "fin2",
  "fin3",
  "medi",
  "med2",
  "init"
], r3 = {
  Non_Joining: 0,
  Left_Joining: 1,
  Right_Joining: 2,
  Dual_Joining: 3,
  Join_Causing: 3,
  ALAPH: 4,
  "DALATH RISH": 5,
  Transparent: 6
}, t0 = "isol", xs = "fina", sp = "fin2", ER = "fin3", C2 = "medi", F2 = "med2", O2 = "init", gr = null, _R = [
  //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
  // State 0: prev was U,  not willing to join.
  [
    [
      gr,
      gr,
      0
    ],
    [
      gr,
      t0,
      2
    ],
    [
      gr,
      t0,
      1
    ],
    [
      gr,
      t0,
      2
    ],
    [
      gr,
      t0,
      1
    ],
    [
      gr,
      t0,
      6
    ]
  ],
  // State 1: prev was R or ISOL/ALAPH,  not willing to join.
  [
    [
      gr,
      gr,
      0
    ],
    [
      gr,
      t0,
      2
    ],
    [
      gr,
      t0,
      1
    ],
    [
      gr,
      t0,
      2
    ],
    [
      gr,
      sp,
      5
    ],
    [
      gr,
      t0,
      6
    ]
  ],
  // State 2: prev was D/L in ISOL form,  willing to join.
  [
    [
      gr,
      gr,
      0
    ],
    [
      gr,
      t0,
      2
    ],
    [
      O2,
      xs,
      1
    ],
    [
      O2,
      xs,
      3
    ],
    [
      O2,
      xs,
      4
    ],
    [
      O2,
      xs,
      6
    ]
  ],
  // State 3: prev was D in FINA form,  willing to join.
  [
    [
      gr,
      gr,
      0
    ],
    [
      gr,
      t0,
      2
    ],
    [
      C2,
      xs,
      1
    ],
    [
      C2,
      xs,
      3
    ],
    [
      C2,
      xs,
      4
    ],
    [
      C2,
      xs,
      6
    ]
  ],
  // State 4: prev was FINA ALAPH,  not willing to join.
  [
    [
      gr,
      gr,
      0
    ],
    [
      gr,
      t0,
      2
    ],
    [
      F2,
      t0,
      1
    ],
    [
      F2,
      t0,
      2
    ],
    [
      F2,
      sp,
      5
    ],
    [
      F2,
      t0,
      6
    ]
  ],
  // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
  [
    [
      gr,
      gr,
      0
    ],
    [
      gr,
      t0,
      2
    ],
    [
      t0,
      t0,
      1
    ],
    [
      t0,
      t0,
      2
    ],
    [
      t0,
      sp,
      5
    ],
    [
      t0,
      t0,
      6
    ]
  ],
  // State 6: prev was DALATH/RISH,  not willing to join.
  [
    [
      gr,
      gr,
      0
    ],
    [
      gr,
      t0,
      2
    ],
    [
      gr,
      t0,
      1
    ],
    [
      gr,
      t0,
      2
    ],
    [
      gr,
      ER,
      5
    ],
    [
      gr,
      t0,
      6
    ]
  ]
];
class Es extends au {
  static planFeatures(e) {
    e.add([
      "ccmp",
      "locl"
    ]);
    for (let t = 0; t < jm.length; t++) {
      let n = jm[t];
      e.addStage(n, !1);
    }
    e.addStage("mset");
  }
  static assignFeatures(e, t) {
    super.assignFeatures(e, t);
    let n = -1, i = 0, a = [];
    for (let s = 0; s < t.length; s++) {
      let c, h;
      var o = t[s];
      let d = DR(o.codePoints[0]);
      if (d === r3.Transparent) {
        a[s] = gr;
        continue;
      }
      [h, c, i] = _R[i][d], h !== gr && n !== -1 && (a[n] = h), a[s] = c, n = s;
    }
    for (let s = 0; s < t.length; s++) {
      let c;
      var o = t[s];
      (c = a[s]) && (o.features[c] = !0);
    }
  }
}
function DR(r) {
  let e = xR.get(r);
  if (e) return e - 1;
  let t = fa(r);
  return t === "Mn" || t === "Me" || t === "Cf" ? r3.Transparent : r3.Non_Joining;
}
class TR {
  reset(e = {}, t = 0) {
    this.options = e, this.flags = e.flags || {}, this.markAttachmentType = e.markAttachmentType || 0, this.index = t;
  }
  get cur() {
    return this.glyphs[this.index] || null;
  }
  shouldIgnore(e) {
    return this.flags.ignoreMarks && e.isMark || this.flags.ignoreBaseGlyphs && e.isBase || this.flags.ignoreLigatures && e.isLigature || this.markAttachmentType && e.isMark && e.markAttachmentType !== this.markAttachmentType;
  }
  move(e) {
    for (this.index += e; 0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]); ) this.index += e;
    return 0 > this.index || this.index >= this.glyphs.length ? null : this.glyphs[this.index];
  }
  next() {
    return this.move(1);
  }
  prev() {
    return this.move(-1);
  }
  peek(e = 1) {
    let t = this.index, n = this.increment(e);
    return this.index = t, n;
  }
  peekIndex(e = 1) {
    let t = this.index;
    this.increment(e);
    let n = this.index;
    return this.index = t, n;
  }
  increment(e = 1) {
    let t = e < 0 ? -1 : 1;
    for (e = Math.abs(e); e--; ) this.move(t);
    return this.glyphs[this.index];
  }
  constructor(e, t) {
    this.glyphs = e, this.reset(t);
  }
}
const kR = [
  "DFLT",
  "dflt",
  "latn"
];
class cd {
  findScript(e) {
    if (this.table.scriptList == null) return null;
    Array.isArray(e) || (e = [
      e
    ]);
    for (let t of e) for (let n of this.table.scriptList)
      if (n.tag === t) return n;
    return null;
  }
  selectScript(e, t, n) {
    let i = !1, a;
    if (!this.script || e !== this.scriptTag) {
      if (a = this.findScript(e), a || (a = this.findScript(kR)), !a) return this.scriptTag;
      this.scriptTag = a.tag, this.script = a.script, this.language = null, this.languageTag = null, i = !0;
    }
    if ((!n || n !== this.direction) && (this.direction = n || F7(e)), t && t.length < 4 && (t += " ".repeat(4 - t.length)), !t || t !== this.languageTag) {
      this.language = null;
      for (let o of this.script.langSysRecords) if (o.tag === t) {
        this.language = o.langSys, this.languageTag = o.tag;
        break;
      }
      this.language || (this.language = this.script.defaultLangSys, this.languageTag = null), i = !0;
    }
    if (i && (this.features = {}, this.language))
      for (let o of this.language.featureIndexes) {
        let s = this.table.featureList[o], c = this.substituteFeatureForVariations(o);
        this.features[s.tag] = c || s.feature;
      }
    return this.scriptTag;
  }
  lookupsForFeatures(e = [], t) {
    let n = [];
    for (let i of e) {
      let a = this.features[i];
      if (a)
        for (let o of a.lookupListIndexes)
          t && t.indexOf(o) !== -1 || n.push({
            feature: i,
            index: o,
            lookup: this.table.lookupList.get(o)
          });
    }
    return n.sort((i, a) => i.index - a.index), n;
  }
  substituteFeatureForVariations(e) {
    if (this.variationsIndex === -1) return null;
    let n = this.table.featureVariations.featureVariationRecords[this.variationsIndex].featureTableSubstitution.substitutions;
    for (let i of n)
      if (i.featureIndex === e) return i.alternateFeatureTable;
    return null;
  }
  findVariationsIndex(e) {
    let t = this.table.featureVariations;
    if (!t) return -1;
    let n = t.featureVariationRecords;
    for (let i = 0; i < n.length; i++) {
      let a = n[i].conditionSet.conditionTable;
      if (this.variationConditionsMatch(a, e)) return i;
    }
    return -1;
  }
  variationConditionsMatch(e, t) {
    return e.every((n) => {
      let i = n.axisIndex < t.length ? t[n.axisIndex] : 0;
      return n.filterRangeMinValue <= i && i <= n.filterRangeMaxValue;
    });
  }
  applyFeatures(e, t, n) {
    let i = this.lookupsForFeatures(e);
    this.applyLookups(i, t, n);
  }
  applyLookups(e, t, n) {
    this.glyphs = t, this.positions = n, this.glyphIterator = new TR(t);
    for (let { feature: i, lookup: a } of e)
      for (this.currentFeature = i, this.glyphIterator.reset(a.flags); this.glyphIterator.index < t.length; ) {
        if (!(i in this.glyphIterator.cur.features)) {
          this.glyphIterator.next();
          continue;
        }
        for (let o of a.subTables)
          if (this.applyLookup(a.lookupType, o)) break;
        this.glyphIterator.next();
      }
  }
  applyLookup(e, t) {
    throw new Error("applyLookup must be implemented by subclasses");
  }
  applyLookupList(e) {
    let t = this.glyphIterator.options, n = this.glyphIterator.index;
    for (let i of e) {
      this.glyphIterator.reset(t, n), this.glyphIterator.increment(i.sequenceIndex);
      let a = this.table.lookupList.get(i.lookupListIndex);
      this.glyphIterator.reset(a.flags, this.glyphIterator.index);
      for (let o of a.subTables)
        if (this.applyLookup(a.lookupType, o)) break;
    }
    return this.glyphIterator.reset(t, n), !0;
  }
  coverageIndex(e, t) {
    switch (t == null && (t = this.glyphIterator.cur.id), e.version) {
      case 1:
        return e.glyphs.indexOf(t);
      case 2:
        for (let n of e.rangeRecords)
          if (n.start <= t && t <= n.end) return n.startCoverageIndex + t - n.start;
        break;
    }
    return -1;
  }
  match(e, t, n, i) {
    let a = this.glyphIterator.index, o = this.glyphIterator.increment(e), s = 0;
    for (; s < t.length && o && n(t[s], o); )
      i && i.push(this.glyphIterator.index), s++, o = this.glyphIterator.next();
    return this.glyphIterator.index = a, s < t.length ? !1 : i || !0;
  }
  sequenceMatches(e, t) {
    return this.match(e, t, (n, i) => n === i.id);
  }
  sequenceMatchIndices(e, t) {
    return this.match(e, t, (n, i) => this.currentFeature in i.features ? n === i.id : !1, []);
  }
  coverageSequenceMatches(e, t) {
    return this.match(e, t, (n, i) => this.coverageIndex(n, i.id) >= 0);
  }
  getClassID(e, t) {
    switch (t.version) {
      case 1:
        let n = e - t.startGlyph;
        if (n >= 0 && n < t.classValueArray.length) return t.classValueArray[n];
        break;
      case 2:
        for (let i of t.classRangeRecord)
          if (i.start <= e && e <= i.end) return i.class;
        break;
    }
    return 0;
  }
  classSequenceMatches(e, t, n) {
    return this.match(e, t, (i, a) => i === this.getClassID(a.id, n));
  }
  applyContext(e) {
    let t, n;
    switch (e.version) {
      case 1:
        if (t = this.coverageIndex(e.coverage), t === -1) return !1;
        n = e.ruleSets[t];
        for (let i of n)
          if (this.sequenceMatches(1, i.input)) return this.applyLookupList(i.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(e.coverage) === -1 || (t = this.getClassID(this.glyphIterator.cur.id, e.classDef), t === -1)) return !1;
        n = e.classSet[t];
        for (let i of n)
          if (this.classSequenceMatches(1, i.classes, e.classDef)) return this.applyLookupList(i.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(0, e.coverages)) return this.applyLookupList(e.lookupRecords);
        break;
    }
    return !1;
  }
  applyChainingContext(e) {
    let t;
    switch (e.version) {
      case 1:
        if (t = this.coverageIndex(e.coverage), t === -1) return !1;
        let n = e.chainRuleSets[t];
        for (let a of n)
          if (this.sequenceMatches(-a.backtrack.length, a.backtrack) && this.sequenceMatches(1, a.input) && this.sequenceMatches(1 + a.input.length, a.lookahead)) return this.applyLookupList(a.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(e.coverage) === -1) return !1;
        t = this.getClassID(this.glyphIterator.cur.id, e.inputClassDef);
        let i = e.chainClassSet[t];
        if (!i) return !1;
        for (let a of i)
          if (this.classSequenceMatches(-a.backtrack.length, a.backtrack, e.backtrackClassDef) && this.classSequenceMatches(1, a.input, e.inputClassDef) && this.classSequenceMatches(1 + a.input.length, a.lookahead, e.lookaheadClassDef)) return this.applyLookupList(a.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(-e.backtrackGlyphCount, e.backtrackCoverage) && this.coverageSequenceMatches(0, e.inputCoverage) && this.coverageSequenceMatches(e.inputGlyphCount, e.lookaheadCoverage)) return this.applyLookupList(e.lookupRecords);
        break;
    }
    return !1;
  }
  constructor(e, t) {
    this.font = e, this.table = t, this.script = null, this.scriptTag = null, this.language = null, this.languageTag = null, this.features = {}, this.lookups = {}, this.variationsIndex = e._variationProcessor ? this.findVariationsIndex(e._variationProcessor.normalizedCoords) : -1, this.selectScript(), this.glyphs = [], this.positions = [], this.ligatureID = 1, this.currentFeature = null;
  }
}
class Sa {
  get id() {
    return this._id;
  }
  set id(e) {
    this._id = e, this.substituted = !0;
    let t = this._font.GDEF;
    if (t && t.glyphClassDef) {
      let n = cd.prototype.getClassID(e, t.glyphClassDef);
      this.isBase = n === 1, this.isLigature = n === 2, this.isMark = n === 3, this.markAttachmentType = t.markAttachClassDef ? cd.prototype.getClassID(e, t.markAttachClassDef) : 0;
    } else
      this.isMark = this.codePoints.length > 0 && this.codePoints.every(Dv), this.isBase = !this.isMark, this.isLigature = this.codePoints.length > 1, this.markAttachmentType = 0;
  }
  copy() {
    return new Sa(this._font, this.id, this.codePoints, this.features);
  }
  constructor(e, t, n = [], i) {
    if (this._font = e, this.codePoints = n, this.id = t, this.features = {}, Array.isArray(i)) for (let a = 0; a < i.length; a++) {
      let o = i[a];
      this.features[o] = !0;
    }
    else typeof i == "object" && Object.assign(this.features, i);
    this.ligatureID = null, this.ligatureComponent = null, this.isLigated = !1, this.cursiveAttachment = null, this.markAttachment = null, this.shaperInfo = null, this.substituted = !1, this.isMultiplied = !1;
  }
}
class R7 extends au {
  static planFeatures(e) {
    e.add([
      "ljmo",
      "vjmo",
      "tjmo"
    ], !1);
  }
  static assignFeatures(e, t) {
    let n = 0, i = 0;
    for (; i < t.length; ) {
      let a, s = t[i].codePoints[0], c = pd(s);
      switch ([a, n] = VR[n][c], a) {
        case zo:
          e.font.hasGlyphForCodePoint(s) || (i = B7(t, i, e.font));
          break;
        case n3:
          i = YR(t, i, e.font);
          break;
        case i3:
          ZR(t, i, e.font);
          break;
        case a3:
          i = qR(t, i, e.font);
          break;
      }
      i++;
    }
  }
}
hi(R7, "zeroMarkWidths", "NONE");
const Zc = 44032, I7 = 55204, SR = I7 - Zc + 1, Yd = 4352, Hd = 4449, fl = 4519, CR = 19, fd = 21, b1 = 28, FR = Yd + CR - 1, OR = Hd + fd - 1, RR = fl + b1 - 1, Wm = 9676, IR = (r) => 4352 <= r && r <= 4447 || 43360 <= r && r <= 43388, PR = (r) => 4448 <= r && r <= 4519 || 55216 <= r && r <= 55238, BR = (r) => 4520 <= r && r <= 4607 || 55243 <= r && r <= 55291, NR = (r) => 12334 <= r && r <= 12335, LR = (r) => Zc <= r && r <= I7, MR = (r) => r - Zc < SR && (r - Zc) % b1 === 0, UR = (r) => Yd <= r && r <= FR, $R = (r) => Hd <= r && r <= OR, zR = (r) => 1 <= r && r <= RR, jR = 0, WR = 1, hd = 2, Rv = 3, dd = 4, P7 = 5, GR = 6;
function pd(r) {
  return IR(r) ? WR : PR(r) ? hd : BR(r) ? Rv : MR(r) ? dd : LR(r) ? P7 : NR(r) ? GR : jR;
}
const ai = 0, zo = 1, n3 = 2, i3 = 4, a3 = 5, VR = [
  //       X                 L                 V                T                  LV                LVT               M
  // State 0: start state
  [
    [
      ai,
      0
    ],
    [
      ai,
      1
    ],
    [
      ai,
      0
    ],
    [
      ai,
      0
    ],
    [
      zo,
      2
    ],
    [
      zo,
      3
    ],
    [
      a3,
      0
    ]
  ],
  // State 1: <L>
  [
    [
      ai,
      0
    ],
    [
      ai,
      1
    ],
    [
      n3,
      2
    ],
    [
      ai,
      0
    ],
    [
      zo,
      2
    ],
    [
      zo,
      3
    ],
    [
      a3,
      0
    ]
  ],
  // State 2: <L,V> or <LV>
  [
    [
      ai,
      0
    ],
    [
      ai,
      1
    ],
    [
      ai,
      0
    ],
    [
      n3,
      3
    ],
    [
      zo,
      2
    ],
    [
      zo,
      3
    ],
    [
      i3,
      0
    ]
  ],
  // State 3: <L,V,T> or <LVT>
  [
    [
      ai,
      0
    ],
    [
      ai,
      1
    ],
    [
      ai,
      0
    ],
    [
      ai,
      0
    ],
    [
      zo,
      2
    ],
    [
      zo,
      3
    ],
    [
      i3,
      0
    ]
  ]
];
function r1(r, e, t) {
  return new Sa(r, r.glyphForCodePoint(e).id, [
    e
  ], t);
}
function B7(r, e, t) {
  let n = r[e], a = n.codePoints[0] - Zc, o = fl + a % b1;
  a = a / b1 | 0;
  let s = Yd + a / fd | 0, c = Hd + a % fd;
  if (!t.hasGlyphForCodePoint(s) || !t.hasGlyphForCodePoint(c) || o !== fl && !t.hasGlyphForCodePoint(o)) return e;
  let h = r1(t, s, n.features);
  h.features.ljmo = !0;
  let d = r1(t, c, n.features);
  d.features.vjmo = !0;
  let g = [
    h,
    d
  ];
  if (o > fl) {
    let x = r1(t, o, n.features);
    x.features.tjmo = !0, g.push(x);
  }
  return r.splice(e, 1, ...g), e + g.length - 1;
}
function YR(r, e, t) {
  let n = r[e], i = r[e].codePoints[0], a = pd(i), o = r[e - 1].codePoints[0], s = pd(o), c, h, d, g;
  if (s === dd && a === Rv)
    c = o, g = n;
  else {
    a === hd ? (h = r[e - 1], d = n) : (h = r[e - 2], d = r[e - 1], g = n);
    let _ = h.codePoints[0], k = d.codePoints[0];
    UR(_) && $R(k) && (c = Zc + ((_ - Yd) * fd + (k - Hd)) * b1);
  }
  let x = g && g.codePoints[0] || fl;
  if (c != null && (x === fl || zR(x))) {
    let _ = c + (x - fl);
    if (t.hasGlyphForCodePoint(_)) {
      let k = s === hd ? 3 : 2;
      return r.splice(e - k + 1, k, r1(t, _, n.features)), e - k + 1;
    }
  }
  return h && (h.features.ljmo = !0), d && (d.features.vjmo = !0), g && (g.features.tjmo = !0), s === dd ? (B7(r, e - 1, t), e + 1) : e;
}
function HR(r) {
  switch (pd(r)) {
    case dd:
    case P7:
      return 1;
    case hd:
      return 2;
    case Rv:
      return 3;
  }
}
function ZR(r, e, t) {
  let n = r[e], i = r[e].codePoints[0];
  if (t.glyphForCodePoint(i).advanceWidth === 0) return;
  let a = r[e - 1].codePoints[0], o = HR(a);
  return r.splice(e, 1), r.splice(e - o, 0, n);
}
function qR(r, e, t) {
  let n = r[e], i = r[e].codePoints[0];
  if (t.hasGlyphForCodePoint(Wm)) {
    let a = r1(t, Wm, n.features), o = t.glyphForCodePoint(i).advanceWidth === 0 ? e : e + 1;
    r.splice(o, 0, a), e++;
  }
  return e;
}
var N7 = {};
N7 = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
var Zd = {};
Zd = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,23,0,0,2,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
const ur = {
  X: 1,
  C: 2,
  V: 4,
  N: 8,
  H: 16,
  ZWNJ: 32,
  ZWJ: 64,
  M: 128,
  SM: 256,
  VD: 512,
  A: 1024,
  Placeholder: 2048,
  Dotted_Circle: 4096,
  RS: 8192,
  Coeng: 16384,
  Repha: 32768,
  Ra: 65536,
  CM: 131072,
  Symbol: 262144
  // Avagraha, etc that take marks (SM,A,VD).
}, jt = {
  Start: 1,
  Ra_To_Become_Reph: 2,
  Pre_M: 4,
  Pre_C: 8,
  Base_C: 16,
  After_Main: 32,
  Above_C: 64,
  Before_Sub: 128,
  Below_C: 256,
  After_Sub: 512,
  Before_Post: 1024,
  Post_C: 2048,
  After_Post: 4096,
  Final_C: 8192,
  SMVD: 16384,
  End: 32768
}, XR = ur.C | ur.Ra | ur.CM | ur.V | ur.Placeholder | ur.Dotted_Circle, L7 = ur.ZWJ | ur.ZWNJ, n1 = ur.H | ur.Coeng, Gm = {
  Default: {
    hasOldSpec: !1,
    virama: 0,
    basePos: "Last",
    rephPos: jt.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Devanagari: {
    hasOldSpec: !0,
    virama: 2381,
    basePos: "Last",
    rephPos: jt.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Bengali: {
    hasOldSpec: !0,
    virama: 2509,
    basePos: "Last",
    rephPos: jt.After_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gurmukhi: {
    hasOldSpec: !0,
    virama: 2637,
    basePos: "Last",
    rephPos: jt.Before_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gujarati: {
    hasOldSpec: !0,
    virama: 2765,
    basePos: "Last",
    rephPos: jt.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Oriya: {
    hasOldSpec: !0,
    virama: 2893,
    basePos: "Last",
    rephPos: jt.After_Main,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Tamil: {
    hasOldSpec: !0,
    virama: 3021,
    basePos: "Last",
    rephPos: jt.After_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Telugu: {
    hasOldSpec: !0,
    virama: 3149,
    basePos: "Last",
    rephPos: jt.After_Post,
    rephMode: "Explicit",
    blwfMode: "Post_Only"
  },
  Kannada: {
    hasOldSpec: !0,
    virama: 3277,
    basePos: "Last",
    rephPos: jt.After_Post,
    rephMode: "Implicit",
    blwfMode: "Post_Only"
  },
  Malayalam: {
    hasOldSpec: !0,
    virama: 3405,
    basePos: "Last",
    rephPos: jt.After_Main,
    rephMode: "Log_Repha",
    blwfMode: "Pre_And_Post"
  },
  // Handled by UniversalShaper
  // Sinhala: {
  //   hasOldSpec: false,
  //   virama: 0x0DCA,
  //   basePos: 'Last_Sinhala',
  //   rephPos: POSITIONS.After_Main,
  //   rephMode: 'Explicit',
  //   blwfMode: 'Pre_And_Post'
  // },
  Khmer: {
    hasOldSpec: !1,
    virama: 6098,
    basePos: "First",
    rephPos: jt.Ra_To_Become_Reph,
    rephMode: "Vis_Repha",
    blwfMode: "Pre_And_Post"
  }
}, KR = {
  // Khmer
  6078: [
    6081,
    6078
  ],
  6079: [
    6081,
    6079
  ],
  6080: [
    6081,
    6080
  ],
  6084: [
    6081,
    6084
  ],
  6085: [
    6081,
    6085
  ]
}, { decompositions: JR } = /* @__PURE__ */ jd(Zd), M7 = new Ud(Fv("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")), QR = new t7(/* @__PURE__ */ jd(N7));
class U0 extends au {
  static planFeatures(e) {
    e.addStage(eI), e.addStage([
      "locl",
      "ccmp"
    ]), e.addStage(rI), e.addStage("nukt"), e.addStage("akhn"), e.addStage("rphf", !1), e.addStage("rkrf"), e.addStage("pref", !1), e.addStage("blwf", !1), e.addStage("abvf", !1), e.addStage("half", !1), e.addStage("pstf", !1), e.addStage("vatu"), e.addStage("cjct"), e.addStage("cfar", !1), e.addStage(nI), e.addStage({
      local: [
        "init"
      ],
      global: [
        "pres",
        "abvs",
        "blws",
        "psts",
        "haln",
        "dist",
        "abvm",
        "blwm",
        "calt",
        "clig"
      ]
    }), e.unicodeScript = VO(e.script), e.indicConfig = Gm[e.unicodeScript] || Gm.Default, e.isOldSpec = e.indicConfig.hasOldSpec && e.script[e.script.length - 1] !== "2";
  }
  static assignFeatures(e, t) {
    for (let n = t.length - 1; n >= 0; n--) {
      let i = t[n].codePoints[0], a = KR[i] || JR[i];
      if (a) {
        let o = a.map((s) => {
          let c = e.font.glyphForCodePoint(s);
          return new Sa(e.font, c.id, [
            s
          ], t[n].features);
        });
        t.splice(n, 1, ...o);
      }
    }
  }
}
hi(U0, "zeroMarkWidths", "NONE");
function o3(r) {
  return M7.get(r.codePoints[0]) >> 8;
}
function U7(r) {
  return 1 << (M7.get(r.codePoints[0]) & 255);
}
class Ah {
  constructor(e, t, n, i) {
    this.category = e, this.position = t, this.syllableType = n, this.syllable = i;
  }
}
function eI(r, e) {
  let t = 0, n = 0;
  for (let [i, a, o] of QR.match(e.map(o3))) {
    if (i > n) {
      ++t;
      for (let s = n; s < i; s++) e[s].shaperInfo = new Ah(ur.X, jt.End, "non_indic_cluster", t);
    }
    ++t;
    for (let s = i; s <= a; s++) e[s].shaperInfo = new Ah(1 << o3(e[s]), U7(e[s]), o[0], t);
    n = a + 1;
  }
  if (n < e.length) {
    ++t;
    for (let i = n; i < e.length; i++) e[i].shaperInfo = new Ah(ur.X, jt.End, "non_indic_cluster", t);
  }
}
function Wu(r) {
  return r.shaperInfo.category & XR;
}
function Qa(r) {
  return r.shaperInfo.category & L7;
}
function No(r) {
  return r.shaperInfo.category & n1;
}
function Go(r, e) {
  for (let n of r) n.features = {
    [e]: !0
  };
  return r[0]._font._layoutEngine.engine.GSUBProcessor.applyFeatures([
    e
  ], r), r.length === 1;
}
function tI(r, e, t) {
  let n = [
    t,
    e,
    t
  ];
  return Go(n.slice(0, 2), "blwf") || Go(n.slice(1, 3), "blwf") ? jt.Below_C : Go(n.slice(0, 2), "pstf") || Go(n.slice(1, 3), "pstf") || Go(n.slice(0, 2), "pref") || Go(n.slice(1, 3), "pref") ? jt.Post_C : jt.Base_C;
}
function rI(r, e, t) {
  let n = t.indicConfig, i = r._layoutEngine.engine.GSUBProcessor.features, a = r.glyphForCodePoint(9676).id, o = r.glyphForCodePoint(n.virama).id;
  if (o) {
    let s = new Sa(r, o, [
      n.virama
    ]);
    for (let c = 0; c < e.length; c++) e[c].shaperInfo.position === jt.Base_C && (e[c].shaperInfo.position = tI(r, e[c].copy(), s));
  }
  for (let s = 0, c = vd(e, 0); s < e.length; s = c, c = vd(e, s)) {
    let { category: h, syllableType: d } = e[s].shaperInfo;
    if (d === "symbol_cluster" || d === "non_indic_cluster") continue;
    if (d === "broken_cluster" && a) {
      let z = new Sa(r, a, [
        9676
      ]);
      z.shaperInfo = new Ah(1 << o3(z), U7(z), e[s].shaperInfo.syllableType, e[s].shaperInfo.syllable);
      let j = s;
      for (; j < c && e[j].shaperInfo.category === ur.Repha; ) j++;
      e.splice(j++, 0, z), c++;
    }
    let g = c, x = s, _ = !1;
    if (n.rephPos !== jt.Ra_To_Become_Reph && i.rphf && s + 3 <= c && (n.rephMode === "Implicit" && !Qa(e[s + 2]) || n.rephMode === "Explicit" && e[s + 2].shaperInfo.category === ur.ZWJ)) {
      let z = [
        e[s].copy(),
        e[s + 1].copy(),
        e[s + 2].copy()
      ];
      if (Go(z.slice(0, 2), "rphf") || n.rephMode === "Explicit" && Go(z, "rphf")) {
        for (x += 2; x < c && Qa(e[x]); ) x++;
        g = s, _ = !0;
      }
    } else if (n.rephMode === "Log_Repha" && e[s].shaperInfo.category === ur.Repha) {
      for (x++; x < c && Qa(e[x]); ) x++;
      g = s, _ = !0;
    }
    switch (n.basePos) {
      case "Last": {
        let z = c, j = !1;
        do {
          let R = e[--z].shaperInfo;
          if (Wu(e[z])) {
            if (R.position !== jt.Below_C && (R.position !== jt.Post_C || j)) {
              g = z;
              break;
            }
            R.position === jt.Below_C && (j = !0), g = z;
          } else if (s < z && R.category === ur.ZWJ && e[z - 1].shaperInfo.category === ur.H) break;
        } while (z > x);
        break;
      }
      case "First":
        g = s;
        for (let z = g + 1; z < c; z++) Wu(e[z]) && (e[z].shaperInfo.position = jt.Below_C);
    }
    _ && g === s && x - g <= 2 && (_ = !1);
    for (let z = s; z < g; z++) {
      let j = e[z].shaperInfo;
      j.position = Math.min(jt.Pre_C, j.position);
    }
    g < c && (e[g].shaperInfo.position = jt.Base_C);
    for (let z = g + 1; z < c; z++) if (e[z].shaperInfo.category === ur.M) {
      for (let j = z + 1; j < c; j++) if (Wu(e[j])) {
        e[j].shaperInfo.position = jt.Final_C;
        break;
      }
      break;
    }
    if (_ && (e[s].shaperInfo.position = jt.Ra_To_Become_Reph), t.isOldSpec) {
      let z = t.unicodeScript !== "Malayalam";
      for (let j = g + 1; j < c; j++) if (e[j].shaperInfo.category === ur.H) {
        let R;
        for (R = c - 1; R > j && !(Wu(e[R]) || z && e[R].shaperInfo.category === ur.H); R--)
          ;
        if (e[R].shaperInfo.category !== ur.H && R > j) {
          let te = e[j];
          e.splice(j, 0, ...e.splice(j + 1, R - j)), e[R] = te;
        }
        break;
      }
    }
    let k = jt.Start;
    for (let z = s; z < c; z++) {
      let j = e[z].shaperInfo;
      if (j.category & (L7 | ur.N | ur.RS | ur.CM | n1 & j.category)) {
        if (j.position = k, j.category === ur.H && j.position === jt.Pre_M) {
          for (let R = z; R > s; R--) if (e[R - 1].shaperInfo.position !== jt.Pre_M) {
            j.position = e[R - 1].shaperInfo.position;
            break;
          }
        }
      } else j.position !== jt.SMVD && (k = j.position);
    }
    let P = g;
    for (let z = g + 1; z < c; z++)
      if (Wu(e[z])) {
        for (let j = P + 1; j < z; j++) e[j].shaperInfo.position < jt.SMVD && (e[j].shaperInfo.position = e[z].shaperInfo.position);
        P = z;
      } else e[z].shaperInfo.category === ur.M && (P = z);
    let N = e.slice(s, c);
    N.sort((z, j) => z.shaperInfo.position - j.shaperInfo.position), e.splice(s, N.length, ...N);
    for (let z = s; z < c; z++) if (e[z].shaperInfo.position === jt.Base_C) {
      g = z;
      break;
    }
    for (let z = s; z < c && e[z].shaperInfo.position === jt.Ra_To_Become_Reph; z++) e[z].features.rphf = !0;
    let M = !t.isOldSpec && n.blwfMode === "Pre_And_Post";
    for (let z = s; z < g; z++)
      e[z].features.half = !0, M && (e[z].features.blwf = !0);
    for (let z = g + 1; z < c; z++)
      e[z].features.abvf = !0, e[z].features.pstf = !0, e[z].features.blwf = !0;
    if (t.isOldSpec && t.unicodeScript === "Devanagari")
      for (let z = s; z + 1 < g; z++) e[z].shaperInfo.category === ur.Ra && e[z + 1].shaperInfo.category === ur.H && (z + 1 === g || e[z + 2].shaperInfo.category === ur.ZWJ) && (e[z].features.blwf = !0, e[z + 1].features.blwf = !0);
    let G = 2;
    if (i.pref && g + G < c)
      for (let z = g + 1; z + G - 1 < c; z++) {
        let j = [
          e[z].copy(),
          e[z + 1].copy()
        ];
        if (Go(j, "pref")) {
          for (let R = 0; R < G; R++) e[z++].features.pref = !0;
          if (i.cfar) for (; z < c; z++) e[z].features.cfar = !0;
          break;
        }
      }
    for (let z = s + 1; z < c; z++) if (Qa(e[z])) {
      let j = e[z].shaperInfo.category === ur.ZWNJ, R = z;
      do
        R--, j && delete e[R].features.half;
      while (R > s && !Wu(e[R]));
    }
  }
}
function nI(r, e, t) {
  let n = t.indicConfig, i = r._layoutEngine.engine.GSUBProcessor.features;
  for (let a = 0, o = vd(e, 0); a < e.length; a = o, o = vd(e, a)) {
    let s = !!i.pref, c = a;
    for (; c < o; c++) if (e[c].shaperInfo.position >= jt.Base_C) {
      if (s && c + 1 < o) {
        for (let h = c + 1; h < o; h++) if (e[h].features.pref) {
          if (!(e[h].substituted && e[h].isLigated && !e[h].isMultiplied)) {
            for (c = h; c < o && No(e[c]); ) c++;
            e[c].shaperInfo.position = jt.BASE_C, s = !1;
          }
          break;
        }
      }
      if (t.unicodeScript === "Malayalam") for (let h = c + 1; h < o; h++) {
        for (; h < o && Qa(e[h]); ) h++;
        if (h === o || !No(e[h])) break;
        for (h++; h < o && Qa(e[h]); ) h++;
        h < o && Wu(e[h]) && e[h].shaperInfo.position === jt.Below_C && (c = h, e[c].shaperInfo.position = jt.Base_C);
      }
      a < c && e[c].shaperInfo.position > jt.Base_C && c--;
      break;
    }
    if (c === o && a < c && e[c - 1].shaperInfo.category === ur.ZWJ && c--, c < o) for (; a < c && e[c].shaperInfo.category & (ur.N | n1); ) c--;
    if (a + 1 < o && a < c) {
      let h = c === o ? c - 2 : c - 1;
      if (t.unicodeScript !== "Malayalam" && t.unicodeScript !== "Tamil") {
        for (; h > a && !(e[h].shaperInfo.category & (ur.M | n1)); ) h--;
        No(e[h]) && e[h].shaperInfo.position !== jt.Pre_M ? h + 1 < o && Qa(e[h + 1]) && h++ : h = a;
      }
      if (a < h && e[h].shaperInfo.position !== jt.Pre_M) {
        for (let d = h; d > a; d--) if (e[d - 1].shaperInfo.position === jt.Pre_M) {
          let g = d - 1;
          g < c && c <= h && c--;
          let x = e[g];
          e.splice(g, 0, ...e.splice(g + 1, h - g)), e[h] = x, h--;
        }
      }
    }
    if (a + 1 < o && e[a].shaperInfo.position === jt.Ra_To_Become_Reph && e[a].shaperInfo.category === ur.Repha !== (e[a].isLigated && !e[a].isMultiplied)) {
      let h, d = n.rephPos, g = !1;
      if (d !== jt.After_Post) {
        for (h = a + 1; h < c && !No(e[h]); ) h++;
        if (h < c && No(e[h]) && (h + 1 < c && Qa(e[h + 1]) && h++, g = !0), !g && d === jt.After_Main) {
          for (h = c; h + 1 < o && e[h + 1].shaperInfo.position <= jt.After_Main; ) h++;
          g = h < o;
        }
        if (!g && d === jt.After_Sub) {
          for (h = c; h + 1 < o && !(e[h + 1].shaperInfo.position & (jt.Post_C | jt.After_Post | jt.SMVD)); ) h++;
          g = h < o;
        }
      }
      if (!g) {
        for (h = a + 1; h < c && !No(e[h]); ) h++;
        h < c && No(e[h]) && (h + 1 < c && Qa(e[h + 1]) && h++, g = !0);
      }
      if (!g) {
        for (h = o - 1; h > a && e[h].shaperInfo.position === jt.SMVD; ) h--;
        if (No(e[h]))
          for (let _ = c + 1; _ < h; _++) e[_].shaperInfo.category === ur.M && h--;
      }
      let x = e[a];
      e.splice(a, 0, ...e.splice(a + 1, h - a)), e[h] = x, a < c && c <= h && c--;
    }
    if (s && c + 1 < o) {
      for (let h = c + 1; h < o; h++) if (e[h].features.pref) {
        if (e[h].isLigated && !e[h].isMultiplied) {
          let d = c;
          if (t.unicodeScript !== "Malayalam" && t.unicodeScript !== "Tamil") {
            for (; d > a && !(e[d - 1].shaperInfo.category & (ur.M | n1)); ) d--;
            if (d > a && e[d - 1].shaperInfo.category === ur.M) {
              let _ = h;
              for (let k = c + 1; k < _; k++) if (e[k].shaperInfo.category === ur.M) {
                d--;
                break;
              }
            }
          }
          d > a && No(e[d - 1]) && d < o && Qa(e[d]) && d++;
          let g = h, x = e[g];
          e.splice(d + 1, 0, ...e.splice(d, g - d)), e[d] = x, d <= c && c < g && c++;
        }
        break;
      }
    }
    e[a].shaperInfo.position === jt.Pre_M && (!a || !/Cf|Mn/.test(fa(e[a - 1].codePoints[0]))) && (e[a].features.init = !0);
  }
}
function vd(r, e) {
  if (e >= r.length) return e;
  let t = r[e].shaperInfo.syllable;
  for (; ++e < r.length && r[e].shaperInfo.syllable === t; ) ;
  return e;
}
const { categories: iI, decompositions: Vm } = /* @__PURE__ */ jd(Zd), aI = new Ud(Fv("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")), oI = new t7(/* @__PURE__ */ jd(Zd));
class ar extends au {
  static planFeatures(e) {
    e.addStage(uI), e.addStage([
      "locl",
      "ccmp",
      "nukt",
      "akhn"
    ]), e.addStage(Hm), e.addStage([
      "rphf"
    ], !1), e.addStage(lI), e.addStage(Hm), e.addStage([
      "pref"
    ]), e.addStage(cI), e.addStage([
      "rkrf",
      "abvf",
      "blwf",
      "half",
      "pstf",
      "vatu",
      "cjct"
    ]), e.addStage(fI), e.addStage([
      "abvs",
      "blws",
      "pres",
      "psts",
      "dist",
      "abvm",
      "blwm"
    ]);
  }
  static assignFeatures(e, t) {
    for (let n = t.length - 1; n >= 0; n--) {
      let i = t[n].codePoints[0];
      if (Vm[i]) {
        let a = Vm[i].map((o) => {
          let s = e.font.glyphForCodePoint(o);
          return new Sa(e.font, s.id, [
            o
          ], t[n].features);
        });
        t.splice(n, 1, ...a);
      }
    }
  }
}
hi(ar, "zeroMarkWidths", "BEFORE_GPOS");
function Ym(r) {
  return aI.get(r.codePoints[0]);
}
class sI {
  constructor(e, t, n) {
    this.category = e, this.syllableType = t, this.syllable = n;
  }
}
function uI(r, e) {
  let t = 0;
  for (let [n, i, a] of oI.match(e.map(Ym))) {
    ++t;
    for (let s = n; s <= i; s++) e[s].shaperInfo = new sI(iI[Ym(e[s])], a[0], t);
    let o = e[n].shaperInfo.category === "R" ? 1 : Math.min(3, i - n);
    for (let s = n; s < n + o; s++) e[s].features.rphf = !0;
  }
}
function Hm(r, e) {
  for (let t of e) t.substituted = !1;
}
function lI(r, e) {
  for (let t of e) t.substituted && t.features.rphf && (t.shaperInfo.category = "R");
}
function cI(r, e) {
  for (let t of e) t.substituted && (t.shaperInfo.category = "VPre");
}
function fI(r, e) {
  let t = r.glyphForCodePoint(9676).id;
  for (let n = 0, i = Zm(e, 0); n < e.length; n = i, i = Zm(e, n)) {
    let a, o, s = e[n].shaperInfo, c = s.syllableType;
    if (!(c !== "virama_terminated_cluster" && c !== "standard_cluster" && c !== "broken_cluster")) {
      if (c === "broken_cluster" && t) {
        let h = new Sa(r, t, [
          9676
        ]);
        for (h.shaperInfo = s, a = n; a < i && e[a].shaperInfo.category === "R"; a++) ;
        e.splice(++a, 0, h), i++;
      }
      if (s.category === "R" && i - n > 1) {
        for (a = n + 1; a < i; a++)
          if (s = e[a].shaperInfo, qm(s) || R2(e[a])) {
            R2(e[a]) && a--, e.splice(n, 0, ...e.splice(n + 1, a - n), e[a]);
            break;
          }
      }
      for (a = n, o = i; a < i; a++)
        s = e[a].shaperInfo, qm(s) || R2(e[a]) ? o = R2(e[a]) ? a + 1 : a : (s.category === "VPre" || s.category === "VMPre") && o < a && e.splice(o, 1, e[a], ...e.splice(o, a - o));
    }
  }
}
function Zm(r, e) {
  if (e >= r.length) return e;
  let t = r[e].shaperInfo.syllable;
  for (; ++e < r.length && r[e].shaperInfo.syllable === t; ) ;
  return e;
}
function R2(r) {
  return r.shaperInfo.category === "H" && !r.isLigated;
}
function qm(r) {
  return r.category === "B" || r.category === "GB";
}
const hI = {
  arab: Es,
  mong: Es,
  syrc: Es,
  "nko ": Es,
  phag: Es,
  mand: Es,
  mani: Es,
  phlp: Es,
  hang: R7,
  bng2: U0,
  beng: U0,
  dev2: U0,
  deva: U0,
  gjr2: U0,
  gujr: U0,
  guru: U0,
  gur2: U0,
  knda: U0,
  knd2: U0,
  mlm2: U0,
  mlym: U0,
  ory2: U0,
  orya: U0,
  taml: U0,
  tml2: U0,
  telu: U0,
  tel2: U0,
  khmr: U0,
  bali: ar,
  batk: ar,
  brah: ar,
  bugi: ar,
  buhd: ar,
  cakm: ar,
  cham: ar,
  dupl: ar,
  egyp: ar,
  gran: ar,
  hano: ar,
  java: ar,
  kthi: ar,
  kali: ar,
  khar: ar,
  khoj: ar,
  sind: ar,
  lepc: ar,
  limb: ar,
  mahj: ar,
  // mand: UniversalShaper, // Mandaic
  // mani: UniversalShaper, // Manichaean
  mtei: ar,
  modi: ar,
  // mong: UniversalShaper, // Mongolian
  // 'nko ': UniversalShaper, // N’Ko
  hmng: ar,
  // phag: UniversalShaper, // Phags-pa
  // phlp: UniversalShaper, // Psalter Pahlavi
  rjng: ar,
  saur: ar,
  shrd: ar,
  sidd: ar,
  sinh: U0,
  sund: ar,
  sylo: ar,
  tglg: ar,
  tagb: ar,
  tale: ar,
  lana: ar,
  tavt: ar,
  takr: ar,
  tibt: ar,
  tfng: ar,
  tirh: ar,
  latn: au,
  DFLT: au
};
function dI(r) {
  Array.isArray(r) || (r = [
    r
  ]);
  for (let e of r) {
    let t = hI[e];
    if (t) return t;
  }
  return au;
}
class pI extends cd {
  applyLookup(e, t) {
    switch (e) {
      case 1: {
        let i = this.coverageIndex(t.coverage);
        if (i === -1) return !1;
        let a = this.glyphIterator.cur;
        switch (t.version) {
          case 1:
            a.id = a.id + t.deltaGlyphID & 65535;
            break;
          case 2:
            a.id = t.substitute.get(i);
            break;
        }
        return !0;
      }
      case 2: {
        let i = this.coverageIndex(t.coverage);
        if (i !== -1) {
          let a = t.sequences.get(i);
          if (a.length === 0)
            return this.glyphs.splice(this.glyphIterator.index, 1), !0;
          this.glyphIterator.cur.id = a[0], this.glyphIterator.cur.ligatureComponent = 0;
          let o = this.glyphIterator.cur.features, s = this.glyphIterator.cur, c = a.slice(1).map((h, d) => {
            let g = new Sa(this.font, h, void 0, o);
            return g.shaperInfo = s.shaperInfo, g.isLigated = s.isLigated, g.ligatureComponent = d + 1, g.substituted = !0, g.isMultiplied = !0, g;
          });
          return this.glyphs.splice(this.glyphIterator.index + 1, 0, ...c), !0;
        }
        return !1;
      }
      case 3: {
        let i = this.coverageIndex(t.coverage);
        if (i !== -1) {
          let a = 0;
          return this.glyphIterator.cur.id = t.alternateSet.get(i)[a], !0;
        }
        return !1;
      }
      case 4: {
        let i = this.coverageIndex(t.coverage);
        if (i === -1) return !1;
        for (let a of t.ligatureSets.get(i)) {
          let o = this.sequenceMatchIndices(1, a.components);
          if (!o) continue;
          let s = this.glyphIterator.cur, c = s.codePoints.slice();
          for (let P of o) c.push(...this.glyphs[P].codePoints);
          let h = new Sa(this.font, a.glyph, c, s.features);
          h.shaperInfo = s.shaperInfo, h.isLigated = !0, h.substituted = !0;
          let d = s.isMark;
          for (let P = 0; P < o.length && d; P++) d = this.glyphs[o[P]].isMark;
          h.ligatureID = d ? null : this.ligatureID++;
          let g = s.ligatureID, x = s.codePoints.length, _ = x, k = this.glyphIterator.index + 1;
          for (let P of o) {
            if (d) k = P;
            else for (; k < P; ) {
              var n = _ - x + Math.min(this.glyphs[k].ligatureComponent || 1, x);
              this.glyphs[k].ligatureID = h.ligatureID, this.glyphs[k].ligatureComponent = n, k++;
            }
            g = this.glyphs[k].ligatureID, x = this.glyphs[k].codePoints.length, _ += x, k++;
          }
          if (g && !d) for (let P = k; P < this.glyphs.length && this.glyphs[P].ligatureID === g; P++) {
            var n = _ - x + Math.min(this.glyphs[P].ligatureComponent || 1, x);
            this.glyphs[P].ligatureComponent = n;
          }
          for (let P = o.length - 1; P >= 0; P--) this.glyphs.splice(o[P], 1);
          return this.glyphs[this.glyphIterator.index] = h, !0;
        }
        return !1;
      }
      case 5:
        return this.applyContext(t);
      case 6:
        return this.applyChainingContext(t);
      case 7:
        return this.applyLookup(t.lookupType, t.extension);
      default:
        throw new Error(`GSUB lookupType ${e} is not supported`);
    }
  }
}
class vI extends cd {
  applyPositionValue(e, t) {
    let n = this.positions[this.glyphIterator.peekIndex(e)];
    t.xAdvance != null && (n.xAdvance += t.xAdvance), t.yAdvance != null && (n.yAdvance += t.yAdvance), t.xPlacement != null && (n.xOffset += t.xPlacement), t.yPlacement != null && (n.yOffset += t.yPlacement);
    let i = this.font._variationProcessor, a = this.font.GDEF && this.font.GDEF.itemVariationStore;
    i && a && (t.xPlaDevice && (n.xOffset += i.getDelta(a, t.xPlaDevice.a, t.xPlaDevice.b)), t.yPlaDevice && (n.yOffset += i.getDelta(a, t.yPlaDevice.a, t.yPlaDevice.b)), t.xAdvDevice && (n.xAdvance += i.getDelta(a, t.xAdvDevice.a, t.xAdvDevice.b)), t.yAdvDevice && (n.yAdvance += i.getDelta(a, t.yAdvDevice.a, t.yAdvDevice.b)));
  }
  applyLookup(e, t) {
    switch (e) {
      case 1: {
        let i = this.coverageIndex(t.coverage);
        if (i === -1) return !1;
        switch (t.version) {
          case 1:
            this.applyPositionValue(0, t.value);
            break;
          case 2:
            this.applyPositionValue(0, t.values.get(i));
            break;
        }
        return !0;
      }
      case 2: {
        let i = this.glyphIterator.peek();
        if (!i) return !1;
        let a = this.coverageIndex(t.coverage);
        if (a === -1) return !1;
        switch (t.version) {
          case 1:
            let o = t.pairSets.get(a);
            for (let h of o) if (h.secondGlyph === i.id)
              return this.applyPositionValue(0, h.value1), this.applyPositionValue(1, h.value2), !0;
            return !1;
          case 2:
            let s = this.getClassID(this.glyphIterator.cur.id, t.classDef1), c = this.getClassID(i.id, t.classDef2);
            if (s === -1 || c === -1) return !1;
            var n = t.classRecords.get(s).get(c);
            return this.applyPositionValue(0, n.value1), this.applyPositionValue(1, n.value2), !0;
        }
      }
      case 3: {
        let i = this.glyphIterator.peekIndex(), a = this.glyphs[i];
        if (!a) return !1;
        let o = t.entryExitRecords[this.coverageIndex(t.coverage)];
        if (!o || !o.exitAnchor) return !1;
        let s = t.entryExitRecords[this.coverageIndex(t.coverage, a.id)];
        if (!s || !s.entryAnchor) return !1;
        let c = this.getAnchor(s.entryAnchor), h = this.getAnchor(o.exitAnchor), d = this.positions[this.glyphIterator.index], g = this.positions[i], x;
        switch (this.direction) {
          case "ltr":
            d.xAdvance = h.x + d.xOffset, x = c.x + g.xOffset, g.xAdvance -= x, g.xOffset -= x;
            break;
          case "rtl":
            x = h.x + d.xOffset, d.xAdvance -= x, d.xOffset -= x, g.xAdvance = c.x + g.xOffset;
            break;
        }
        return this.glyphIterator.flags.rightToLeft ? (this.glyphIterator.cur.cursiveAttachment = i, d.yOffset = c.y - h.y) : (a.cursiveAttachment = this.glyphIterator.index, d.yOffset = h.y - c.y), !0;
      }
      case 4: {
        let i = this.coverageIndex(t.markCoverage);
        if (i === -1) return !1;
        let a = this.glyphIterator.index;
        for (; --a >= 0 && (this.glyphs[a].isMark || this.glyphs[a].ligatureComponent > 0); ) ;
        if (a < 0) return !1;
        let o = this.coverageIndex(t.baseCoverage, this.glyphs[a].id);
        if (o === -1) return !1;
        let s = t.markArray[i], c = t.baseArray[o][s.class];
        return this.applyAnchor(s, c, a), !0;
      }
      case 5: {
        let i = this.coverageIndex(t.markCoverage);
        if (i === -1) return !1;
        let a = this.glyphIterator.index;
        for (; --a >= 0 && this.glyphs[a].isMark; ) ;
        if (a < 0) return !1;
        let o = this.coverageIndex(t.ligatureCoverage, this.glyphs[a].id);
        if (o === -1) return !1;
        let s = t.ligatureArray[o], c = this.glyphIterator.cur, h = this.glyphs[a], d = h.ligatureID && h.ligatureID === c.ligatureID && c.ligatureComponent > 0 ? Math.min(c.ligatureComponent, h.codePoints.length) - 1 : h.codePoints.length - 1, g = t.markArray[i], x = s[d][g.class];
        return this.applyAnchor(g, x, a), !0;
      }
      case 6: {
        let i = this.coverageIndex(t.mark1Coverage);
        if (i === -1) return !1;
        let a = this.glyphIterator.peekIndex(-1), o = this.glyphs[a];
        if (!o || !o.isMark) return !1;
        let s = this.glyphIterator.cur, c = !1;
        if (s.ligatureID === o.ligatureID ? s.ligatureID ? s.ligatureComponent === o.ligatureComponent && (c = !0) : c = !0 : (s.ligatureID && !s.ligatureComponent || o.ligatureID && !o.ligatureComponent) && (c = !0), !c) return !1;
        let h = this.coverageIndex(t.mark2Coverage, o.id);
        if (h === -1) return !1;
        let d = t.mark1Array[i], g = t.mark2Array[h][d.class];
        return this.applyAnchor(d, g, a), !0;
      }
      case 7:
        return this.applyContext(t);
      case 8:
        return this.applyChainingContext(t);
      case 9:
        return this.applyLookup(t.lookupType, t.extension);
      default:
        throw new Error(`Unsupported GPOS table: ${e}`);
    }
  }
  applyAnchor(e, t, n) {
    let i = this.getAnchor(t), a = this.getAnchor(e.markAnchor);
    this.positions[n];
    let o = this.positions[this.glyphIterator.index];
    o.xOffset = i.x - a.x, o.yOffset = i.y - a.y, this.glyphIterator.cur.markAttachment = n;
  }
  getAnchor(e) {
    let t = e.xCoordinate, n = e.yCoordinate, i = this.font._variationProcessor, a = this.font.GDEF && this.font.GDEF.itemVariationStore;
    return i && a && (e.xDeviceTable && (t += i.getDelta(a, e.xDeviceTable.a, e.xDeviceTable.b)), e.yDeviceTable && (n += i.getDelta(a, e.yDeviceTable.a, e.yDeviceTable.b))), {
      x: t,
      y: n
    };
  }
  applyFeatures(e, t, n) {
    super.applyFeatures(e, t, n);
    for (var i = 0; i < this.glyphs.length; i++) this.fixCursiveAttachment(i);
    this.fixMarkAttachment();
  }
  fixCursiveAttachment(e) {
    let t = this.glyphs[e];
    if (t.cursiveAttachment != null) {
      let n = t.cursiveAttachment;
      t.cursiveAttachment = null, this.fixCursiveAttachment(n), this.positions[e].yOffset += this.positions[n].yOffset;
    }
  }
  fixMarkAttachment() {
    for (let e = 0; e < this.glyphs.length; e++) {
      let t = this.glyphs[e];
      if (t.markAttachment != null) {
        let n = t.markAttachment;
        if (this.positions[e].xOffset += this.positions[n].xOffset, this.positions[e].yOffset += this.positions[n].yOffset, this.direction === "ltr") for (let i = n; i < e; i++)
          this.positions[e].xOffset -= this.positions[i].xAdvance, this.positions[e].yOffset -= this.positions[i].yAdvance;
        else for (let i = n + 1; i < e + 1; i++)
          this.positions[e].xOffset += this.positions[i].xAdvance, this.positions[e].yOffset += this.positions[i].yAdvance;
      }
    }
  }
}
class gI {
  setup(e) {
    this.glyphInfos = e.glyphs.map((n) => new Sa(this.font, n.id, [
      ...n.codePoints
    ]));
    let t = null;
    this.GPOSProcessor && (t = this.GPOSProcessor.selectScript(e.script, e.language, e.direction)), this.GSUBProcessor && (t = this.GSUBProcessor.selectScript(e.script, e.language, e.direction)), this.shaper = dI(t), this.plan = new gR(this.font, t, e.direction), this.shaper.plan(this.plan, this.glyphInfos, e.features);
    for (let n in this.plan.allFeatures) e.features[n] = !0;
  }
  substitute(e) {
    this.GSUBProcessor && (this.plan.process(this.GSUBProcessor, this.glyphInfos), e.glyphs = this.glyphInfos.map((t) => this.font.getGlyph(t.id, t.codePoints)));
  }
  position(e) {
    return this.shaper.zeroMarkWidths === "BEFORE_GPOS" && this.zeroMarkAdvances(e.positions), this.GPOSProcessor && this.plan.process(this.GPOSProcessor, this.glyphInfos, e.positions), this.shaper.zeroMarkWidths === "AFTER_GPOS" && this.zeroMarkAdvances(e.positions), e.direction === "rtl" && (e.glyphs.reverse(), e.positions.reverse()), this.GPOSProcessor && this.GPOSProcessor.features;
  }
  zeroMarkAdvances(e) {
    for (let t = 0; t < this.glyphInfos.length; t++) this.glyphInfos[t].isMark && (e[t].xAdvance = 0, e[t].yAdvance = 0);
  }
  cleanup() {
    this.glyphInfos = null, this.plan = null, this.shaper = null;
  }
  getAvailableFeatures(e, t) {
    let n = [];
    return this.GSUBProcessor && (this.GSUBProcessor.selectScript(e, t), n.push(...Object.keys(this.GSUBProcessor.features))), this.GPOSProcessor && (this.GPOSProcessor.selectScript(e, t), n.push(...Object.keys(this.GPOSProcessor.features))), n;
  }
  constructor(e) {
    this.font = e, this.glyphInfos = null, this.plan = null, this.GSUBProcessor = null, this.GPOSProcessor = null, this.fallbackPosition = !0, e.GSUB && (this.GSUBProcessor = new pI(e, e.GSUB)), e.GPOS && (this.GPOSProcessor = new vI(e, e.GPOS));
  }
}
class mI {
  layout(e, t, n, i, a) {
    if (typeof t == "string" && (a = i, i = n, n = t, t = []), typeof e == "string") {
      n == null && (n = YO(e));
      var o = this.font.glyphsForString(e);
    } else {
      if (n == null) {
        let h = [];
        for (let d of e) h.push(...d.codePoints);
        n = HO(h);
      }
      var o = e;
    }
    let s = new qO(o, t, n, i, a);
    return o.length === 0 ? (s.positions = [], s) : (this.engine && this.engine.setup && this.engine.setup(s), this.substitute(s), this.position(s), this.hideDefaultIgnorables(s.glyphs, s.positions), this.engine && this.engine.cleanup && this.engine.cleanup(), s);
  }
  substitute(e) {
    this.engine && this.engine.substitute && this.engine.substitute(e);
  }
  position(e) {
    e.positions = e.glyphs.map((n) => new XO(n.advanceWidth));
    let t = null;
    this.engine && this.engine.position && (t = this.engine.position(e)), !t && (!this.engine || this.engine.fallbackPosition) && (this.unicodeLayoutEngine || (this.unicodeLayoutEngine = new GO(this.font)), this.unicodeLayoutEngine.positionGlyphs(e.glyphs, e.positions)), (!t || !t.kern) && e.features.kern !== !1 && this.font.kern && (this.kernProcessor || (this.kernProcessor = new WO(this.font)), this.kernProcessor.process(e.glyphs, e.positions), e.features.kern = !0);
  }
  hideDefaultIgnorables(e, t) {
    let n = this.font.glyphForCodePoint(32);
    for (let i = 0; i < e.length; i++) this.isDefaultIgnorable(e[i].codePoints[0]) && (e[i] = n, t[i].xAdvance = 0, t[i].yAdvance = 0);
  }
  isDefaultIgnorable(e) {
    let t = e >> 16;
    if (t === 0)
      switch (e >> 8) {
        case 0:
          return e === 173;
        case 3:
          return e === 847;
        case 6:
          return e === 1564;
        case 23:
          return 6068 <= e && e <= 6069;
        case 24:
          return 6155 <= e && e <= 6158;
        case 32:
          return 8203 <= e && e <= 8207 || 8234 <= e && e <= 8238 || 8288 <= e && e <= 8303;
        case 254:
          return 65024 <= e && e <= 65039 || e === 65279;
        case 255:
          return 65520 <= e && e <= 65528;
        default:
          return !1;
      }
    else
      switch (t) {
        case 1:
          return 113824 <= e && e <= 113827 || 119155 <= e && e <= 119162;
        case 14:
          return 917504 <= e && e <= 921599;
        default:
          return !1;
      }
  }
  getAvailableFeatures(e, t) {
    let n = [];
    return this.engine && n.push(...this.engine.getAvailableFeatures(e, t)), this.font.kern && n.indexOf("kern") === -1 && n.push("kern"), n;
  }
  stringsForGlyph(e) {
    let t = /* @__PURE__ */ new Set(), n = this.font._cmapProcessor.codePointsForGlyph(e);
    for (let i of n) t.add(String.fromCodePoint(i));
    if (this.engine && this.engine.stringsForGlyph) for (let i of this.engine.stringsForGlyph(e)) t.add(i);
    return Array.from(t);
  }
  constructor(e) {
    this.font = e, this.unicodeLayoutEngine = null, this.kernProcessor = null, this.font.morx ? this.engine = new vR(this.font) : (this.font.GSUB || this.font.GPOS) && (this.engine = new gI(this.font));
  }
}
const yI = {
  moveTo: "M",
  lineTo: "L",
  quadraticCurveTo: "Q",
  bezierCurveTo: "C",
  closePath: "Z"
};
class ef {
  /**
  * Compiles the path to a JavaScript function that can be applied with
  * a graphics context in order to render the path.
  * @return {string}
  */
  toFunction() {
    return (e) => {
      this.commands.forEach((t) => e[t.command].apply(e, t.args));
    };
  }
  /**
  * Converts the path to an SVG path data string
  * @return {string}
  */
  toSVG() {
    return this.commands.map((t) => {
      let n = t.args.map((i) => Math.round(i * 100) / 100);
      return `${yI[t.command]}${n.join(" ")}`;
    }).join("");
  }
  /**
  * Gets the "control box" of a path.
  * This is like the bounding box, but it includes all points including
  * control points of bezier segments and is much faster to compute than
  * the real bounding box.
  * @type {BBox}
  */
  get cbox() {
    if (!this._cbox) {
      let e = new iu();
      for (let t of this.commands) for (let n = 0; n < t.args.length; n += 2) e.addPoint(t.args[n], t.args[n + 1]);
      this._cbox = Object.freeze(e);
    }
    return this._cbox;
  }
  /**
  * Gets the exact bounding box of the path by evaluating curve segments.
  * Slower to compute than the control box, but more accurate.
  * @type {BBox}
  */
  get bbox() {
    if (this._bbox) return this._bbox;
    let e = new iu(), t = 0, n = 0, i = (G) => Math.pow(1 - G, 3) * _[M] + 3 * Math.pow(1 - G, 2) * G * k[M] + 3 * (1 - G) * Math.pow(G, 2) * P[M] + Math.pow(G, 3) * N[M];
    for (let G of this.commands) switch (G.command) {
      case "moveTo":
      case "lineTo":
        let [z, j] = G.args;
        e.addPoint(z, j), t = z, n = j;
        break;
      case "quadraticCurveTo":
      case "bezierCurveTo":
        if (G.command === "quadraticCurveTo")
          var [a, o, g, x] = G.args, s = t + 2 / 3 * (a - t), c = n + 2 / 3 * (o - n), h = g + 2 / 3 * (a - g), d = x + 2 / 3 * (o - x);
        else var [s, c, h, d, g, x] = G.args;
        e.addPoint(g, x);
        for (var _ = [
          t,
          n
        ], k = [
          s,
          c
        ], P = [
          h,
          d
        ], N = [
          g,
          x
        ], M = 0; M <= 1; M++) {
          let R = 6 * _[M] - 12 * k[M] + 6 * P[M], te = -3 * _[M] + 9 * k[M] - 9 * P[M] + 3 * N[M];
          if (G = 3 * k[M] - 3 * _[M], te === 0) {
            if (R === 0) continue;
            let ve = -G / R;
            0 < ve && ve < 1 && (M === 0 ? e.addPoint(i(ve), e.maxY) : M === 1 && e.addPoint(e.maxX, i(ve)));
            continue;
          }
          let J = Math.pow(R, 2) - 4 * G * te;
          if (J < 0) continue;
          let K = (-R + Math.sqrt(J)) / (2 * te);
          0 < K && K < 1 && (M === 0 ? e.addPoint(i(K), e.maxY) : M === 1 && e.addPoint(e.maxX, i(K)));
          let ee = (-R - Math.sqrt(J)) / (2 * te);
          0 < ee && ee < 1 && (M === 0 ? e.addPoint(i(ee), e.maxY) : M === 1 && e.addPoint(e.maxX, i(ee)));
        }
        t = g, n = x;
        break;
    }
    return this._bbox = Object.freeze(e);
  }
  /**
  * Applies a mapping function to each point in the path.
  * @param {function} fn
  * @return {Path}
  */
  mapPoints(e) {
    let t = new ef();
    for (let n of this.commands) {
      let i = [];
      for (let a = 0; a < n.args.length; a += 2) {
        let [o, s] = e(n.args[a], n.args[a + 1]);
        i.push(o, s);
      }
      t[n.command](...i);
    }
    return t;
  }
  /**
  * Transforms the path by the given matrix.
  */
  transform(e, t, n, i, a, o) {
    return this.mapPoints((s, c) => {
      const h = e * s + n * c + a, d = t * s + i * c + o;
      return [
        h,
        d
      ];
    });
  }
  /**
  * Translates the path by the given offset.
  */
  translate(e, t) {
    return this.transform(1, 0, 0, 1, e, t);
  }
  /**
  * Rotates the path by the given angle (in radians).
  */
  rotate(e) {
    let t = Math.cos(e), n = Math.sin(e);
    return this.transform(t, n, -n, t, 0, 0);
  }
  /**
  * Scales the path.
  */
  scale(e, t = e) {
    return this.transform(e, 0, 0, t, 0, 0);
  }
  constructor() {
    this.commands = [], this._bbox = null, this._cbox = null;
  }
}
for (let r of [
  "moveTo",
  "lineTo",
  "quadraticCurveTo",
  "bezierCurveTo",
  "closePath"
]) ef.prototype[r] = function(...e) {
  return this._bbox = this._cbox = null, this.commands.push({
    command: r,
    args: e
  }), this;
};
var jf = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
class go {
  _getPath() {
    return new ef();
  }
  _getCBox() {
    return this.path.cbox;
  }
  _getBBox() {
    return this.path.bbox;
  }
  _getTableMetrics(e) {
    if (this.id < e.metrics.length) return e.metrics.get(this.id);
    let t = e.metrics.get(e.metrics.length - 1);
    return {
      advance: t ? t.advance : 0,
      bearing: e.bearings.get(this.id - e.metrics.length) || 0
    };
  }
  _getMetrics(e) {
    if (this._metrics) return this._metrics;
    let { advance: t, bearing: n } = this._getTableMetrics(this._font.hmtx);
    if (this._font.vmtx) var { advance: i, bearing: a } = this._getTableMetrics(this._font.vmtx);
    else {
      let o;
      if ((typeof e > "u" || e === null) && ({ cbox: e } = this), (o = this._font["OS/2"]) && o.version > 0)
        var i = Math.abs(o.typoAscender - o.typoDescender), a = o.typoAscender - e.maxY;
      else {
        let { hhea: s } = this._font;
        var i = Math.abs(s.ascent - s.descent), a = s.ascent - e.maxY;
      }
    }
    return this._font._variationProcessor && this._font.HVAR && (t += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR)), this._metrics = {
      advanceWidth: t,
      advanceHeight: i,
      leftBearing: n,
      topBearing: a
    };
  }
  /**
  * The glyph’s control box.
  * This is often the same as the bounding box, but is faster to compute.
  * Because of the way bezier curves are defined, some of the control points
  * can be outside of the bounding box. Where `bbox` takes this into account,
  * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
  * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
  * for a more detailed description.
  *
  * @type {BBox}
  */
  get cbox() {
    return this._getCBox();
  }
  /**
  * The glyph’s bounding box, i.e. the rectangle that encloses the
  * glyph outline as tightly as possible.
  * @type {BBox}
  */
  get bbox() {
    return this._getBBox();
  }
  /**
  * A vector Path object representing the glyph outline.
  * @type {Path}
  */
  get path() {
    return this._getPath();
  }
  /**
  * Returns a path scaled to the given font size.
  * @param {number} size
  * @return {Path}
  */
  getScaledPath(e) {
    let t = 1 / this._font.unitsPerEm * e;
    return this.path.scale(t);
  }
  /**
  * The glyph's advance width.
  * @type {number}
  */
  get advanceWidth() {
    return this._getMetrics().advanceWidth;
  }
  /**
  * The glyph's advance height.
  * @type {number}
  */
  get advanceHeight() {
    return this._getMetrics().advanceHeight;
  }
  get ligatureCaretPositions() {
  }
  _getName() {
    let { post: e } = this._font;
    if (!e) return null;
    switch (e.version) {
      case 1:
        return jf[this.id];
      case 2:
        let t = e.glyphNameIndex[this.id];
        return t < jf.length ? jf[t] : e.names[t - jf.length];
      case 2.5:
        return jf[this.id + e.offsets[this.id]];
      case 4:
        return String.fromCharCode(e.map[this.id]);
    }
  }
  /**
  * The glyph's name
  * @type {string}
  */
  get name() {
    return this._getName();
  }
  /**
  * Renders the glyph to the given graphics context, at the specified font size.
  * @param {CanvasRenderingContext2d} ctx
  * @param {number} size
  */
  render(e, t) {
    e.save();
    let n = 1 / this._font.head.unitsPerEm * t;
    e.scale(n, n), this.path.toFunction()(e), e.fill(), e.restore();
  }
  constructor(e, t, n) {
    this.id = e, this.codePoints = t, this._font = n, this.isMark = this.codePoints.length > 0 && this.codePoints.every(Dv), this.isLigature = this.codePoints.length > 1;
  }
}
Cn([
  Fn
], go.prototype, "cbox", null);
Cn([
  Fn
], go.prototype, "bbox", null);
Cn([
  Fn
], go.prototype, "path", null);
Cn([
  Fn
], go.prototype, "advanceWidth", null);
Cn([
  Fn
], go.prototype, "advanceHeight", null);
Cn([
  Fn
], go.prototype, "name", null);
let Xm = new Me({
  numberOfContours: lt,
  xMin: lt,
  yMin: lt,
  xMax: lt,
  yMax: lt
});
const bI = 1, wI = 2, AI = 4, xI = 8, EI = 16, _I = 32, DI = 1, TI = 8, Km = 32, kI = 64, SI = 128, CI = 256;
class Ea {
  copy() {
    return new Ea(this.onCurve, this.endContour, this.x, this.y);
  }
  constructor(e, t, n = 0, i = 0) {
    this.onCurve = e, this.endContour = t, this.x = n, this.y = i;
  }
}
class FI {
  constructor(e, t, n) {
    this.glyphID = e, this.dx = t, this.dy = n, this.pos = 0, this.scaleX = this.scaleY = 1, this.scale01 = this.scale10 = 0;
  }
}
class qd extends go {
  // Parses just the glyph header and returns the bounding box
  _getCBox(e) {
    if (this._font._variationProcessor && !e) return this.path.cbox;
    let t = this._font._getTableStream("glyf");
    t.pos += this._font.loca.offsets[this.id];
    let n = Xm.decode(t), i = new iu(n.xMin, n.yMin, n.xMax, n.yMax);
    return Object.freeze(i);
  }
  // Parses a single glyph coordinate
  _parseGlyphCoord(e, t, n, i) {
    if (n) {
      var a = e.readUInt8();
      i || (a = -a), a += t;
    } else if (i) var a = t;
    else var a = t + e.readInt16BE();
    return a;
  }
  // Decodes the glyph data into points for simple glyphs,
  // or components for composite glyphs
  _decode() {
    let e = this._font.loca.offsets[this.id], t = this._font.loca.offsets[this.id + 1];
    if (e === t) return null;
    let n = this._font._getTableStream("glyf");
    n.pos += e;
    let i = n.pos, a = Xm.decode(n);
    return a.numberOfContours > 0 ? this._decodeSimple(a, n) : a.numberOfContours < 0 && this._decodeComposite(a, n, i), a;
  }
  _decodeSimple(e, t) {
    e.points = [];
    let n = new Te(O, e.numberOfContours).decode(t);
    e.instructions = new Te(kt, O).decode(t);
    let i = [], a = n[n.length - 1] + 1;
    for (; i.length < a; ) {
      var o = t.readUInt8();
      if (i.push(o), o & xI) {
        let d = t.readUInt8();
        for (let g = 0; g < d; g++) i.push(o);
      }
    }
    for (var s = 0; s < i.length; s++) {
      var o = i[s];
      let g = new Ea(!!(o & bI), n.indexOf(s) >= 0, 0, 0);
      e.points.push(g);
    }
    let c = 0;
    for (var s = 0; s < i.length; s++) {
      var o = i[s];
      e.points[s].x = c = this._parseGlyphCoord(t, c, o & wI, o & EI);
    }
    let h = 0;
    for (var s = 0; s < i.length; s++) {
      var o = i[s];
      e.points[s].y = h = this._parseGlyphCoord(t, h, o & AI, o & _I);
    }
    if (this._font._variationProcessor) {
      let d = e.points.slice();
      d.push(...this._getPhantomPoints(e)), this._font._variationProcessor.transformPoints(this.id, d), e.phantomPoints = d.slice(-4);
    }
  }
  _decodeComposite(e, t, n = 0) {
    e.components = [];
    let i = !1, a = Km;
    for (; a & Km; ) {
      a = t.readUInt16BE();
      let h = t.pos - n, d = t.readUInt16BE();
      if (i || (i = (a & CI) !== 0), a & DI)
        var o = t.readInt16BE(), s = t.readInt16BE();
      else
        var o = t.readInt8(), s = t.readInt8();
      var c = new FI(d, o, s);
      c.pos = h, a & TI ? c.scaleX = c.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824 : a & kI ? (c.scaleX = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, c.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824) : a & SI && (c.scaleX = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, c.scale01 = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, c.scale10 = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, c.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824), e.components.push(c);
    }
    if (this._font._variationProcessor) {
      let h = [];
      for (let d = 0; d < e.components.length; d++) {
        var c = e.components[d];
        h.push(new Ea(!0, !0, c.dx, c.dy));
      }
      h.push(...this._getPhantomPoints(e)), this._font._variationProcessor.transformPoints(this.id, h), e.phantomPoints = h.splice(-4, 4);
      for (let d = 0; d < h.length; d++) {
        let g = h[d];
        e.components[d].dx = g.x, e.components[d].dy = g.y;
      }
    }
    return i;
  }
  _getPhantomPoints(e) {
    let t = this._getCBox(!0);
    this._metrics == null && (this._metrics = go.prototype._getMetrics.call(this, t));
    let { advanceWidth: n, advanceHeight: i, leftBearing: a, topBearing: o } = this._metrics;
    return [
      new Ea(!1, !0, e.xMin - a, 0),
      new Ea(!1, !0, e.xMin - a + n, 0),
      new Ea(!1, !0, 0, e.yMax + o),
      new Ea(!1, !0, 0, e.yMax + o + i)
    ];
  }
  // Decodes font data, resolves composite glyphs, and returns an array of contours
  _getContours() {
    let e = this._decode();
    if (!e) return [];
    let t = [];
    if (e.numberOfContours < 0)
      for (let o of e.components) {
        let s = this._font.getGlyph(o.glyphID)._getContours();
        for (let c = 0; c < s.length; c++) {
          let h = s[c];
          for (let d = 0; d < h.length; d++) {
            let g = h[d], x = g.x * o.scaleX + g.y * o.scale01 + o.dx, _ = g.y * o.scaleY + g.x * o.scale10 + o.dy;
            t.push(new Ea(g.onCurve, g.endContour, x, _));
          }
        }
      }
    else t = e.points || [];
    e.phantomPoints && !this._font.directory.tables.HVAR && (this._metrics.advanceWidth = e.phantomPoints[1].x - e.phantomPoints[0].x, this._metrics.advanceHeight = e.phantomPoints[3].y - e.phantomPoints[2].y, this._metrics.leftBearing = e.xMin - e.phantomPoints[0].x, this._metrics.topBearing = e.phantomPoints[2].y - e.yMax);
    let n = [], i = [];
    for (let o = 0; o < t.length; o++) {
      var a = t[o];
      i.push(a), a.endContour && (n.push(i), i = []);
    }
    return n;
  }
  _getMetrics() {
    if (this._metrics) return this._metrics;
    let e = this._getCBox(!0);
    return super._getMetrics(e), this._font._variationProcessor && !this._font.HVAR && this.path, this._metrics;
  }
  // Converts contours to a Path object that can be rendered
  _getPath() {
    let e = this._getContours(), t = new ef();
    for (let i = 0; i < e.length; i++) {
      let a = e[i], o = a[0], s = a[a.length - 1], c = 0;
      if (o.onCurve) {
        var n = null;
        c = 1;
      } else {
        s.onCurve ? o = s : o = new Ea(!1, !1, (o.x + s.x) / 2, (o.y + s.y) / 2);
        var n = o;
      }
      t.moveTo(o.x, o.y);
      for (let h = c; h < a.length; h++) {
        let d = a[h], g = h === 0 ? o : a[h - 1];
        if (g.onCurve && d.onCurve) t.lineTo(d.x, d.y);
        else if (g.onCurve && !d.onCurve) var n = d;
        else if (!g.onCurve && !d.onCurve) {
          let _ = (g.x + d.x) / 2, k = (g.y + d.y) / 2;
          t.quadraticCurveTo(g.x, g.y, _, k);
          var n = d;
        } else if (!g.onCurve && d.onCurve) {
          t.quadraticCurveTo(n.x, n.y, d.x, d.y);
          var n = null;
        } else throw new Error("Unknown TTF path state");
      }
      n && t.quadraticCurveTo(n.x, n.y, o.x, o.y), t.closePath();
    }
    return t;
  }
  constructor(...e) {
    super(...e), hi(this, "type", "TTF");
  }
}
class OI extends go {
  _getName() {
    return this._font.CFF2 ? super._getName() : this._font["CFF "].getGlyphName(this.id);
  }
  bias(e) {
    return e.length < 1240 ? 107 : e.length < 33900 ? 1131 : 32768;
  }
  _getPath() {
    let e = this._font.CFF2 || this._font["CFF "], { stream: t } = e, n = e.topDict.CharStrings[this.id], i = n.offset + n.length;
    t.pos = n.offset;
    let a = new ef(), o = [], s = [], c = null, h = 0, d = 0, g = 0, x, _, k = !1;
    this._usedGsubrs = x = {}, this._usedSubrs = _ = {};
    let P = e.globalSubrIndex || [], N = this.bias(P), M = e.privateDictForGlyph(this.id) || {}, G = M.Subrs || [], z = this.bias(G), j = e.topDict.vstore && e.topDict.vstore.itemVariationStore, R = M.vsindex, te = this._font._variationProcessor;
    function J() {
      c == null && (c = o.shift() + M.nominalWidthX);
    }
    function K() {
      return o.length % 2 !== 0 && J(), h += o.length >> 1, o.length = 0;
    }
    function ee(de, B) {
      k && a.closePath(), a.moveTo(de, B), k = !0;
    }
    let ve = function() {
      for (; t.pos < i; ) {
        let _e = t.readUInt8();
        if (_e < 32) {
          let Re, Ie, W;
          switch (_e) {
            case 1:
            case 3:
            case 18:
            case 23:
              K();
              break;
            case 4:
              o.length > 1 && J(), g += o.shift(), ee(d, g);
              break;
            case 5:
              for (; o.length >= 2; )
                d += o.shift(), g += o.shift(), a.lineTo(d, g);
              break;
            case 6:
            case 7:
              for (W = _e === 6; o.length >= 1; )
                W ? d += o.shift() : g += o.shift(), a.lineTo(d, g), W = !W;
              break;
            case 8:
              for (; o.length > 0; ) {
                var q = d + o.shift(), H = g + o.shift(), oe = q + o.shift(), ne = H + o.shift();
                d = oe + o.shift(), g = ne + o.shift(), a.bezierCurveTo(q, H, oe, ne, d, g);
              }
              break;
            case 10:
              if (Re = o.pop() + z, Ie = G[Re], Ie) {
                _[Re] = !0;
                var de = t.pos, B = i;
                t.pos = Ie.offset, i = Ie.offset + Ie.length, ve(), t.pos = de, i = B;
              }
              break;
            case 11:
              if (e.version >= 2) break;
              return;
            case 14:
              if (e.version >= 2) break;
              o.length > 0 && J(), k && (a.closePath(), k = !1);
              break;
            case 15:
              if (e.version < 2) throw new Error("vsindex operator not supported in CFF v1");
              R = o.pop();
              break;
            case 16: {
              if (e.version < 2) throw new Error("blend operator not supported in CFF v1");
              if (!te) throw new Error("blend operator in non-variation font");
              let Z = te.getBlendVector(j, R), se = o.pop(), ye = se * Z.length, Fe = o.length - ye, xe = Fe - se;
              for (let be = 0; be < se; be++) {
                let he = o[xe + be];
                for (let ke = 0; ke < Z.length; ke++) he += Z[ke] * o[Fe++];
                o[xe + be] = he;
              }
              for (; ye--; ) o.pop();
              break;
            }
            case 19:
            case 20:
              K(), t.pos += h + 7 >> 3;
              break;
            case 21:
              o.length > 2 && J(), d += o.shift(), g += o.shift(), ee(d, g);
              break;
            case 22:
              o.length > 1 && J(), d += o.shift(), ee(d, g);
              break;
            case 24:
              for (; o.length >= 8; ) {
                var q = d + o.shift(), H = g + o.shift(), oe = q + o.shift(), ne = H + o.shift();
                d = oe + o.shift(), g = ne + o.shift(), a.bezierCurveTo(q, H, oe, ne, d, g);
              }
              d += o.shift(), g += o.shift(), a.lineTo(d, g);
              break;
            case 25:
              for (; o.length >= 8; )
                d += o.shift(), g += o.shift(), a.lineTo(d, g);
              var q = d + o.shift(), H = g + o.shift(), oe = q + o.shift(), ne = H + o.shift();
              d = oe + o.shift(), g = ne + o.shift(), a.bezierCurveTo(q, H, oe, ne, d, g);
              break;
            case 26:
              for (o.length % 2 && (d += o.shift()); o.length >= 4; )
                q = d, H = g + o.shift(), oe = q + o.shift(), ne = H + o.shift(), d = oe, g = ne + o.shift(), a.bezierCurveTo(q, H, oe, ne, d, g);
              break;
            case 27:
              for (o.length % 2 && (g += o.shift()); o.length >= 4; )
                q = d + o.shift(), H = g, oe = q + o.shift(), ne = H + o.shift(), d = oe + o.shift(), g = ne, a.bezierCurveTo(q, H, oe, ne, d, g);
              break;
            case 28:
              o.push(t.readInt16BE());
              break;
            case 29:
              if (Re = o.pop() + N, Ie = P[Re], Ie) {
                x[Re] = !0;
                var de = t.pos, B = i;
                t.pos = Ie.offset, i = Ie.offset + Ie.length, ve(), t.pos = de, i = B;
              }
              break;
            case 30:
            case 31:
              for (W = _e === 31; o.length >= 4; )
                W ? (q = d + o.shift(), H = g, oe = q + o.shift(), ne = H + o.shift(), g = ne + o.shift(), d = oe + (o.length === 1 ? o.shift() : 0)) : (q = d, H = g + o.shift(), oe = q + o.shift(), ne = H + o.shift(), d = oe + o.shift(), g = ne + (o.length === 1 ? o.shift() : 0)), a.bezierCurveTo(q, H, oe, ne, d, g), W = !W;
              break;
            case 12:
              switch (_e = t.readUInt8(), _e) {
                case 3:
                  let Z = o.pop(), se = o.pop();
                  o.push(Z && se ? 1 : 0);
                  break;
                case 4:
                  Z = o.pop(), se = o.pop(), o.push(Z || se ? 1 : 0);
                  break;
                case 5:
                  Z = o.pop(), o.push(Z ? 0 : 1);
                  break;
                case 9:
                  Z = o.pop(), o.push(Math.abs(Z));
                  break;
                case 10:
                  Z = o.pop(), se = o.pop(), o.push(Z + se);
                  break;
                case 11:
                  Z = o.pop(), se = o.pop(), o.push(Z - se);
                  break;
                case 12:
                  Z = o.pop(), se = o.pop(), o.push(Z / se);
                  break;
                case 14:
                  Z = o.pop(), o.push(-Z);
                  break;
                case 15:
                  Z = o.pop(), se = o.pop(), o.push(Z === se ? 1 : 0);
                  break;
                case 18:
                  o.pop();
                  break;
                case 20:
                  let ye = o.pop(), Fe = o.pop();
                  s[Fe] = ye;
                  break;
                case 21:
                  Fe = o.pop(), o.push(s[Fe] || 0);
                  break;
                case 22:
                  let xe = o.pop(), be = o.pop(), he = o.pop(), ke = o.pop();
                  o.push(he <= ke ? xe : be);
                  break;
                case 23:
                  o.push(Math.random());
                  break;
                case 24:
                  Z = o.pop(), se = o.pop(), o.push(Z * se);
                  break;
                case 26:
                  Z = o.pop(), o.push(Math.sqrt(Z));
                  break;
                case 27:
                  Z = o.pop(), o.push(Z, Z);
                  break;
                case 28:
                  Z = o.pop(), se = o.pop(), o.push(se, Z);
                  break;
                case 29:
                  Fe = o.pop(), Fe < 0 ? Fe = 0 : Fe > o.length - 1 && (Fe = o.length - 1), o.push(o[Fe]);
                  break;
                case 30:
                  let De = o.pop(), Qe = o.pop();
                  if (Qe >= 0) for (; Qe > 0; ) {
                    var me = o[De - 1];
                    for (let gt = De - 2; gt >= 0; gt--) o[gt + 1] = o[gt];
                    o[0] = me, Qe--;
                  }
                  else for (; Qe < 0; ) {
                    var me = o[0];
                    for (let St = 0; St <= De; St++) o[St] = o[St + 1];
                    o[De - 1] = me, Qe++;
                  }
                  break;
                case 34:
                  q = d + o.shift(), H = g, oe = q + o.shift(), ne = H + o.shift();
                  let ct = oe + o.shift(), pt = ne, _t = ct + o.shift(), S = pt, b = _t + o.shift(), w = S, T = b + o.shift(), V = w;
                  d = T, g = V, a.bezierCurveTo(q, H, oe, ne, ct, pt), a.bezierCurveTo(_t, S, b, w, T, V);
                  break;
                case 35:
                  let pe = [];
                  for (let gt = 0; gt <= 5; gt++)
                    d += o.shift(), g += o.shift(), pe.push(d, g);
                  a.bezierCurveTo(...pe.slice(0, 6)), a.bezierCurveTo(...pe.slice(6)), o.shift();
                  break;
                case 36:
                  q = d + o.shift(), H = g + o.shift(), oe = q + o.shift(), ne = H + o.shift(), ct = oe + o.shift(), pt = ne, _t = ct + o.shift(), S = pt, b = _t + o.shift(), w = S + o.shift(), T = b + o.shift(), V = w, d = T, g = V, a.bezierCurveTo(q, H, oe, ne, ct, pt), a.bezierCurveTo(_t, S, b, w, T, V);
                  break;
                case 37:
                  let Ee = d, mt = g;
                  pe = [];
                  for (let gt = 0; gt <= 4; gt++)
                    d += o.shift(), g += o.shift(), pe.push(d, g);
                  Math.abs(d - Ee) > Math.abs(g - mt) ? (d += o.shift(), g = mt) : (d = Ee, g += o.shift()), pe.push(d, g), a.bezierCurveTo(...pe.slice(0, 6)), a.bezierCurveTo(...pe.slice(6));
                  break;
                default:
                  throw new Error(`Unknown op: 12 ${_e}`);
              }
              break;
            default:
              throw new Error(`Unknown op: ${_e}`);
          }
        } else if (_e < 247) o.push(_e - 139);
        else if (_e < 251) {
          var fe = t.readUInt8();
          o.push((_e - 247) * 256 + fe + 108);
        } else if (_e < 255) {
          var fe = t.readUInt8();
          o.push(-(_e - 251) * 256 - fe - 108);
        } else o.push(t.readInt32BE() / 65536);
      }
    };
    return ve(), k && a.closePath(), a;
  }
  constructor(...e) {
    super(...e), hi(this, "type", "CFF");
  }
}
let RI = new Me({
  originX: O,
  originY: O,
  type: new Ur(4),
  data: new po((r) => r.parent.buflen - r._currentOffset)
});
class II extends qd {
  /**
  * Returns an object representing a glyph image at the given point size.
  * The object has a data property with a Buffer containing the actual image data,
  * along with the image type, and origin.
  *
  * @param {number} size
  * @return {object}
  */
  getImageForSize(e) {
    for (let o = 0; o < this._font.sbix.imageTables.length; o++) {
      var t = this._font.sbix.imageTables[o];
      if (t.ppem >= e) break;
    }
    let n = t.imageOffsets, i = n[this.id], a = n[this.id + 1];
    return i === a ? null : (this._font.stream.pos = i, RI.decode(this._font.stream, {
      buflen: a - i
    }));
  }
  render(e, t) {
    let n = this.getImageForSize(t);
    if (n != null) {
      let i = t / this._font.unitsPerEm;
      e.image(n.data, {
        height: t,
        x: n.originX,
        y: (this.bbox.minY - n.originY) * i
      });
    }
    this._font.sbix.flags.renderOutlines && super.render(e, t);
  }
  constructor(...e) {
    super(...e), hi(this, "type", "SBIX");
  }
}
class Jm {
  constructor(e, t) {
    this.glyph = e, this.color = t;
  }
}
class PI extends go {
  _getBBox() {
    let e = new iu();
    for (let t = 0; t < this.layers.length; t++) {
      let i = this.layers[t].glyph.bbox;
      e.addPoint(i.minX, i.minY), e.addPoint(i.maxX, i.maxY);
    }
    return e;
  }
  /**
  * Returns an array of objects containing the glyph and color for
  * each layer in the composite color glyph.
  * @type {object[]}
  */
  get layers() {
    let e = this._font.CPAL, t = this._font.COLR, n = 0, i = t.baseGlyphRecord.length - 1;
    for (; n <= i; ) {
      let d = n + i >> 1;
      var a = t.baseGlyphRecord[d];
      if (this.id < a.gid) i = d - 1;
      else if (this.id > a.gid) n = d + 1;
      else {
        var o = a;
        break;
      }
    }
    if (o == null) {
      var s = this._font._getBaseGlyph(this.id), c = {
        red: 0,
        green: 0,
        blue: 0,
        alpha: 255
      };
      return [
        new Jm(s, c)
      ];
    }
    let h = [];
    for (let d = o.firstLayerIndex; d < o.firstLayerIndex + o.numLayers; d++) {
      var a = t.layerRecords[d], c = e.colorRecords[a.paletteIndex], s = this._font._getBaseGlyph(a.gid);
      h.push(new Jm(s, c));
    }
    return h;
  }
  render(e, t) {
    for (let { glyph: n, color: i } of this.layers)
      e.fillColor([
        i.red,
        i.green,
        i.blue
      ], i.alpha / 255 * 100), n.render(e, t);
  }
  constructor(...e) {
    super(...e), hi(this, "type", "COLR");
  }
}
const BI = 32768, NI = 4095, LI = 32768, Qm = 16384, MI = 8192, ey = 4095, ty = 128, ry = 127, UI = 128, $I = 64, zI = 63;
class jI {
  normalizeCoords(e) {
    let t = [];
    for (var n = 0; n < this.font.fvar.axis.length; n++) {
      let i = this.font.fvar.axis[n];
      e[n] < i.defaultValue ? t.push((e[n] - i.defaultValue + Number.EPSILON) / (i.defaultValue - i.minValue + Number.EPSILON)) : t.push((e[n] - i.defaultValue + Number.EPSILON) / (i.maxValue - i.defaultValue + Number.EPSILON));
    }
    if (this.font.avar) for (var n = 0; n < this.font.avar.segment.length; n++) {
      let a = this.font.avar.segment[n];
      for (let o = 0; o < a.correspondence.length; o++) {
        let s = a.correspondence[o];
        if (o >= 1 && t[n] < s.fromCoord) {
          let c = a.correspondence[o - 1];
          t[n] = ((t[n] - c.fromCoord) * (s.toCoord - c.toCoord) + Number.EPSILON) / (s.fromCoord - c.fromCoord + Number.EPSILON) + c.toCoord;
          break;
        }
      }
    }
    return t;
  }
  transformPoints(e, t) {
    if (!this.font.fvar || !this.font.gvar) return;
    let { gvar: n } = this.font;
    if (e >= n.glyphCount) return;
    let i = n.offsets[e];
    if (i === n.offsets[e + 1]) return;
    let { stream: a } = this.font;
    if (a.pos = i, a.pos >= a.length) return;
    let o = a.readUInt16BE(), s = i + a.readUInt16BE();
    if (o & BI) {
      var c = a.pos;
      a.pos = s;
      var h = this.decodePoints();
      s = a.pos, a.pos = c;
    }
    let d = t.map((N) => N.copy());
    o &= NI;
    for (let N = 0; N < o; N++) {
      let M = a.readUInt16BE(), G = a.readUInt16BE();
      if (G & LI) {
        var g = [];
        for (let K = 0; K < n.axisCount; K++) g.push(a.readInt16BE() / 16384);
      } else {
        if ((G & ey) >= n.globalCoordCount) throw new Error("Invalid gvar table");
        var g = n.globalCoords[G & ey];
      }
      if (G & Qm) {
        var x = [];
        for (let K = 0; K < n.axisCount; K++) x.push(a.readInt16BE() / 16384);
        var _ = [];
        for (let K = 0; K < n.axisCount; K++) _.push(a.readInt16BE() / 16384);
      }
      let z = this.tupleFactor(G, g, x, _);
      if (z === 0) {
        s += M;
        continue;
      }
      var c = a.pos;
      if (a.pos = s, G & MI) var k = this.decodePoints();
      else var k = h;
      let R = k.length === 0 ? t.length : k.length, te = this.decodeDeltas(R), J = this.decodeDeltas(R);
      if (k.length === 0) for (let K = 0; K < t.length; K++) {
        var P = t[K];
        P.x += Math.round(te[K] * z), P.y += Math.round(J[K] * z);
      }
      else {
        let K = d.map((ve) => ve.copy()), ee = t.map(() => !1);
        for (let ve = 0; ve < k.length; ve++) {
          let de = k[ve];
          if (de < t.length) {
            let B = K[de];
            ee[de] = !0, B.x += Math.round(te[ve] * z), B.y += Math.round(J[ve] * z);
          }
        }
        this.interpolateMissingDeltas(K, d, ee);
        for (let ve = 0; ve < t.length; ve++) {
          let de = K[ve].x - d[ve].x, B = K[ve].y - d[ve].y;
          t[ve].x += de, t[ve].y += B;
        }
      }
      s += M, a.pos = c;
    }
  }
  decodePoints() {
    let e = this.font.stream, t = e.readUInt8();
    t & ty && (t = (t & ry) << 8 | e.readUInt8());
    let n = new Uint16Array(t), i = 0, a = 0;
    for (; i < t; ) {
      let o = e.readUInt8(), s = (o & ry) + 1, c = o & ty ? e.readUInt16 : e.readUInt8;
      for (let h = 0; h < s && i < t; h++)
        a += c.call(e), n[i++] = a;
    }
    return n;
  }
  decodeDeltas(e) {
    let t = this.font.stream, n = 0, i = new Int16Array(e);
    for (; n < e; ) {
      let a = t.readUInt8(), o = (a & zI) + 1;
      if (a & UI) n += o;
      else {
        let s = a & $I ? t.readInt16BE : t.readInt8;
        for (let c = 0; c < o && n < e; c++) i[n++] = s.call(t);
      }
    }
    return i;
  }
  tupleFactor(e, t, n, i) {
    let a = this.normalizedCoords, { gvar: o } = this.font, s = 1;
    for (let c = 0; c < o.axisCount; c++)
      if (t[c] !== 0) {
        if (a[c] === 0) return 0;
        if (e & Qm) {
          if (a[c] < n[c] || a[c] > i[c]) return 0;
          a[c] < t[c] ? s = s * (a[c] - n[c] + Number.EPSILON) / (t[c] - n[c] + Number.EPSILON) : s = s * (i[c] - a[c] + Number.EPSILON) / (i[c] - t[c] + Number.EPSILON);
        } else {
          if (a[c] < Math.min(0, t[c]) || a[c] > Math.max(0, t[c])) return 0;
          s = (s * a[c] + Number.EPSILON) / (t[c] + Number.EPSILON);
        }
      }
    return s;
  }
  // Interpolates points without delta values.
  // Needed for the Ø and Q glyphs in Skia.
  // Algorithm from Freetype.
  interpolateMissingDeltas(e, t, n) {
    if (e.length === 0) return;
    let i = 0;
    for (; i < e.length; ) {
      let a = i, o = i, s = e[o];
      for (; !s.endContour; ) s = e[++o];
      for (; i <= o && !n[i]; ) i++;
      if (i > o) continue;
      let c = i, h = i;
      for (i++; i <= o; )
        n[i] && (this.deltaInterpolate(h + 1, i - 1, h, i, t, e), h = i), i++;
      h === c ? this.deltaShift(a, o, h, t, e) : (this.deltaInterpolate(h + 1, o, h, c, t, e), c > 0 && this.deltaInterpolate(a, c - 1, h, c, t, e)), i = o + 1;
    }
  }
  deltaInterpolate(e, t, n, i, a, o) {
    if (e > t) return;
    let s = [
      "x",
      "y"
    ];
    for (let h = 0; h < s.length; h++) {
      let d = s[h];
      if (a[n][d] > a[i][d]) {
        var c = n;
        n = i, i = c;
      }
      let g = a[n][d], x = a[i][d], _ = o[n][d], k = o[i][d];
      if (g !== x || _ === k) {
        let P = g === x ? 0 : (k - _) / (x - g);
        for (let N = e; N <= t; N++) {
          let M = a[N][d];
          M <= g ? M += _ - g : M >= x ? M += k - x : M = _ + (M - g) * P, o[N][d] = M;
        }
      }
    }
  }
  deltaShift(e, t, n, i, a) {
    let o = a[n].x - i[n].x, s = a[n].y - i[n].y;
    if (!(o === 0 && s === 0))
      for (let c = e; c <= t; c++) c !== n && (a[c].x += o, a[c].y += s);
  }
  getAdvanceAdjustment(e, t) {
    let n, i;
    if (t.advanceWidthMapping) {
      let a = e;
      a >= t.advanceWidthMapping.mapCount && (a = t.advanceWidthMapping.mapCount - 1), t.advanceWidthMapping.entryFormat, { outerIndex: n, innerIndex: i } = t.advanceWidthMapping.mapData[a];
    } else
      n = 0, i = e;
    return this.getDelta(t.itemVariationStore, n, i);
  }
  // See pseudo code from `Font Variations Overview'
  // in the OpenType specification.
  getDelta(e, t, n) {
    if (t >= e.itemVariationData.length) return 0;
    let i = e.itemVariationData[t];
    if (n >= i.deltaSets.length) return 0;
    let a = i.deltaSets[n], o = this.getBlendVector(e, t), s = 0;
    for (let c = 0; c < i.regionIndexCount; c++) s += a.deltas[c] * o[c];
    return s;
  }
  getBlendVector(e, t) {
    let n = e.itemVariationData[t];
    if (this.blendVectors.has(n)) return this.blendVectors.get(n);
    let i = this.normalizedCoords, a = [];
    for (let o = 0; o < n.regionIndexCount; o++) {
      let s = 1, c = n.regionIndexes[o], h = e.variationRegionList.variationRegions[c];
      for (let d = 0; d < h.length; d++) {
        let g = h[d], x;
        g.startCoord > g.peakCoord || g.peakCoord > g.endCoord || g.startCoord < 0 && g.endCoord > 0 && g.peakCoord !== 0 || g.peakCoord === 0 ? x = 1 : i[d] < g.startCoord || i[d] > g.endCoord ? x = 0 : i[d] === g.peakCoord ? x = 1 : i[d] < g.peakCoord ? x = (i[d] - g.startCoord + Number.EPSILON) / (g.peakCoord - g.startCoord + Number.EPSILON) : x = (g.endCoord - i[d] + Number.EPSILON) / (g.endCoord - g.peakCoord + Number.EPSILON), s *= x;
      }
      a[o] = s;
    }
    return this.blendVectors.set(n, a), a;
  }
  constructor(e, t) {
    this.font = e, this.normalizedCoords = this.normalizeCoords(t), this.blendVectors = /* @__PURE__ */ new Map();
  }
}
Promise.resolve();
class $7 {
  includeGlyph(e) {
    return typeof e == "object" && (e = e.id), this.mapping[e] == null && (this.glyphs.push(e), this.mapping[e] = this.glyphs.length - 1), this.mapping[e];
  }
  constructor(e) {
    this.font = e, this.glyphs = [], this.mapping = {}, this.includeGlyph(0);
  }
}
const WI = 1, GI = 2, VI = 4, YI = 8, HI = 16, ZI = 32;
class ny {
  static size(e) {
    return e >= 0 && e <= 255 ? 1 : 2;
  }
  static encode(e, t) {
    t >= 0 && t <= 255 ? e.writeUInt8(t) : e.writeInt16BE(t);
  }
}
let iy = new Me({
  numberOfContours: lt,
  xMin: lt,
  yMin: lt,
  xMax: lt,
  yMax: lt,
  endPtsOfContours: new Te(O, "numberOfContours"),
  instructions: new Te(kt, O),
  flags: new Te(kt, 0),
  xPoints: new Te(ny, 0),
  yPoints: new Te(ny, 0)
});
class qI {
  encodeSimple(e, t = []) {
    let n = [], i = [], a = [], o = [], s = 0, c = 0, h = 0, d = 0, g = 0;
    for (let M = 0; M < e.commands.length; M++) {
      let G = e.commands[M];
      for (let z = 0; z < G.args.length; z += 2) {
        let j = G.args[z], R = G.args[z + 1], te = 0;
        if (G.command === "quadraticCurveTo" && z === 2) {
          let J = e.commands[M + 1];
          if (J && J.command === "quadraticCurveTo") {
            let K = (c + J.args[0]) / 2, ee = (h + J.args[1]) / 2;
            if (j === K && R === ee) continue;
          }
        }
        G.command === "quadraticCurveTo" && z === 0 || (te |= WI), te = this._encodePoint(j, c, i, te, GI, HI), te = this._encodePoint(R, h, a, te, VI, ZI), te === d && s < 255 ? (o[o.length - 1] |= YI, s++) : (s > 0 && (o.push(s), s = 0), o.push(te), d = te), c = j, h = R, g++;
      }
      G.command === "closePath" && n.push(g - 1);
    }
    e.commands.length > 1 && e.commands[e.commands.length - 1].command !== "closePath" && n.push(g - 1);
    let x = e.bbox, _ = {
      numberOfContours: n.length,
      xMin: x.minX,
      yMin: x.minY,
      xMax: x.maxX,
      yMax: x.maxY,
      endPtsOfContours: n,
      instructions: t,
      flags: o,
      xPoints: i,
      yPoints: a
    }, k = iy.size(_), P = 4 - k % 4, N = new td(k + P);
    return iy.encode(N, _), P !== 0 && N.fill(0, P), N.buffer;
  }
  _encodePoint(e, t, n, i, a, o) {
    let s = e - t;
    return e === t ? i |= o : (-255 <= s && s <= 255 && (i |= a, s < 0 ? s = -s : i |= o), n.push(s)), i;
  }
}
class XI extends $7 {
  _addGlyph(e) {
    let t = this.font.getGlyph(e), n = t._decode(), i = this.font.loca.offsets[e], a = this.font.loca.offsets[e + 1], o = this.font._getTableStream("glyf");
    o.pos += i;
    let s = o.readBuffer(a - i);
    if (n && n.numberOfContours < 0) {
      s = new Uint8Array(s);
      let c = new DataView(s.buffer);
      for (let h of n.components)
        e = this.includeGlyph(h.glyphID), c.setUint16(h.pos, e);
    } else n && this.font._variationProcessor && (s = this.glyphEncoder.encodeSimple(t.path, n.instructions));
    return this.glyf.push(s), this.loca.offsets.push(this.offset), this.hmtx.metrics.push({
      advance: t.advanceWidth,
      bearing: t._getMetrics().leftBearing
    }), this.offset += s.length, this.glyf.length - 1;
  }
  encode() {
    this.glyf = [], this.offset = 0, this.loca = {
      offsets: [],
      version: this.font.loca.version
    }, this.hmtx = {
      metrics: [],
      bearings: []
    };
    let e = 0;
    for (; e < this.glyphs.length; ) this._addGlyph(this.glyphs[e++]);
    let t = X5(this.font.maxp);
    t.numGlyphs = this.glyf.length, this.loca.offsets.push(this.offset);
    let n = X5(this.font.head);
    n.indexToLocFormat = this.loca.version;
    let i = X5(this.font.hhea);
    return i.numberOfMetrics = this.hmtx.metrics.length, C7.toBuffer({
      tables: {
        head: n,
        hhea: i,
        loca: this.loca,
        maxp: t,
        "cvt ": this.font["cvt "],
        prep: this.font.prep,
        glyf: this.glyf,
        hmtx: this.hmtx,
        fpgm: this.font.fpgm
      }
    });
  }
  constructor(e) {
    super(e), this.glyphEncoder = new qI();
  }
}
class KI extends $7 {
  subsetCharstrings() {
    this.charstrings = [];
    let e = {};
    for (let t of this.glyphs) {
      this.charstrings.push(this.cff.getCharString(t));
      let n = this.font.getGlyph(t);
      n.path;
      for (let i in n._usedGsubrs) e[i] = !0;
    }
    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, e);
  }
  subsetSubrs(e, t) {
    let n = [];
    for (let i = 0; i < e.length; i++) {
      let a = e[i];
      t[i] ? (this.cff.stream.pos = a.offset, n.push(this.cff.stream.readBuffer(a.length))) : n.push(new Uint8Array([
        11
      ]));
    }
    return n;
  }
  subsetFontdict(e) {
    e.FDArray = [], e.FDSelect = {
      version: 0,
      fds: []
    };
    let t = {}, n = [], i = {};
    for (let a of this.glyphs) {
      let o = this.cff.fdForGlyph(a);
      if (o == null) continue;
      t[o] || (e.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[o])), n.push({}), i[o] = e.FDArray.length - 1), t[o] = !0, e.FDSelect.fds.push(i[o]);
      let s = this.font.getGlyph(a);
      s.path;
      for (let c in s._usedSubrs) n[i[o]][c] = !0;
    }
    for (let a = 0; a < e.FDArray.length; a++) {
      let o = e.FDArray[a];
      delete o.FontName, o.Private && o.Private.Subrs && (o.Private = Object.assign({}, o.Private), o.Private.Subrs = this.subsetSubrs(o.Private.Subrs, n[a]));
    }
  }
  createCIDFontdict(e) {
    let t = {};
    for (let i of this.glyphs) {
      let a = this.font.getGlyph(i);
      a.path;
      for (let o in a._usedSubrs) t[o] = !0;
    }
    let n = Object.assign({}, this.cff.topDict.Private);
    return this.cff.topDict.Private && this.cff.topDict.Private.Subrs && (n.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, t)), e.FDArray = [
      {
        Private: n
      }
    ], e.FDSelect = {
      version: 3,
      nRanges: 1,
      ranges: [
        {
          first: 0,
          fd: 0
        }
      ],
      sentinel: this.charstrings.length
    };
  }
  addString(e) {
    return e ? (this.strings || (this.strings = []), this.strings.push(e), bh.length + this.strings.length - 1) : null;
  }
  encode() {
    this.subsetCharstrings();
    let e = {
      version: this.charstrings.length > 255 ? 2 : 1,
      ranges: [
        {
          first: 1,
          nLeft: this.charstrings.length - 2
        }
      ]
    }, t = Object.assign({}, this.cff.topDict);
    t.Private = null, t.charset = e, t.Encoding = null, t.CharStrings = this.charstrings;
    for (let i of [
      "version",
      "Notice",
      "Copyright",
      "FullName",
      "FamilyName",
      "Weight",
      "PostScript",
      "BaseFontName",
      "FontName"
    ]) t[i] = this.addString(this.cff.string(t[i]));
    t.ROS = [
      this.addString("Adobe"),
      this.addString("Identity"),
      0
    ], t.CIDCount = this.charstrings.length, this.cff.isCIDFont ? this.subsetFontdict(t) : this.createCIDFontdict(t);
    let n = {
      version: 1,
      hdrSize: this.cff.hdrSize,
      offSize: 4,
      header: this.cff.header,
      nameIndex: [
        this.cff.postscriptName
      ],
      topDictIndex: [
        t
      ],
      stringIndex: this.strings,
      globalSubrIndex: this.gsubrs
    };
    return _7.toBuffer(n);
  }
  constructor(e) {
    if (super(e), this.cff = this.font["CFF "], !this.cff) throw new Error("Not a CFF Font");
  }
}
class $n {
  static probe(e) {
    let t = Vd.decode(e.slice(0, 4));
    return t === "true" || t === "OTTO" || t === "\0\0\0";
  }
  setDefaultLanguage(e = null) {
    this.defaultLanguage = e;
  }
  _getTable(e) {
    if (!(e.tag in this._tables)) try {
      this._tables[e.tag] = this._decodeTable(e);
    } catch {
    }
    return this._tables[e.tag];
  }
  _getTableStream(e) {
    let t = this.directory.tables[e];
    return t ? (this.stream.pos = t.offset, this.stream) : null;
  }
  _decodeDirectory() {
    return this.directory = C7.decode(this.stream, {
      _startOffset: 0
    });
  }
  _decodeTable(e) {
    let t = this.stream.pos, n = this._getTableStream(e.tag), i = ud[e.tag].decode(n, this, e.length);
    return this.stream.pos = t, i;
  }
  /**
  * Gets a string from the font's `name` table
  * `lang` is a BCP-47 language code.
  * @return {string}
  */
  getName(e, t = this.defaultLanguage || ad) {
    let n = this.name && this.name.records[e];
    return n && (n[t] || n[this.defaultLanguage] || n[ad] || n.en || n[Object.keys(n)[0]]) || null;
  }
  /**
  * The unique PostScript name for this font, e.g. "Helvetica-Bold"
  * @type {string}
  */
  get postscriptName() {
    return this.getName("postscriptName");
  }
  /**
  * The font's full name, e.g. "Helvetica Bold"
  * @type {string}
  */
  get fullName() {
    return this.getName("fullName");
  }
  /**
  * The font's family name, e.g. "Helvetica"
  * @type {string}
  */
  get familyName() {
    return this.getName("fontFamily");
  }
  /**
  * The font's sub-family, e.g. "Bold".
  * @type {string}
  */
  get subfamilyName() {
    return this.getName("fontSubfamily");
  }
  /**
  * The font's copyright information
  * @type {string}
  */
  get copyright() {
    return this.getName("copyright");
  }
  /**
  * The font's version number
  * @type {string}
  */
  get version() {
    return this.getName("version");
  }
  /**
  * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
  * @type {number}
  */
  get ascent() {
    return this.hhea.ascent;
  }
  /**
  * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
  * @type {number}
  */
  get descent() {
    return this.hhea.descent;
  }
  /**
  * The amount of space that should be included between lines
  * @type {number}
  */
  get lineGap() {
    return this.hhea.lineGap;
  }
  /**
  * The offset from the normal underline position that should be used
  * @type {number}
  */
  get underlinePosition() {
    return this.post.underlinePosition;
  }
  /**
  * The weight of the underline that should be used
  * @type {number}
  */
  get underlineThickness() {
    return this.post.underlineThickness;
  }
  /**
  * If this is an italic font, the angle the cursor should be drawn at to match the font design
  * @type {number}
  */
  get italicAngle() {
    return this.post.italicAngle;
  }
  /**
  * The height of capital letters above the baseline.
  * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
  * @type {number}
  */
  get capHeight() {
    let e = this["OS/2"];
    return e ? e.capHeight : this.ascent;
  }
  /**
  * The height of lower case letters in the font.
  * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
  * @type {number}
  */
  get xHeight() {
    let e = this["OS/2"];
    return e ? e.xHeight : 0;
  }
  /**
  * The number of glyphs in the font.
  * @type {number}
  */
  get numGlyphs() {
    return this.maxp.numGlyphs;
  }
  /**
  * The size of the font’s internal coordinate grid
  * @type {number}
  */
  get unitsPerEm() {
    return this.head.unitsPerEm;
  }
  /**
  * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
  * @type {BBox}
  */
  get bbox() {
    return Object.freeze(new iu(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
  }
  get _cmapProcessor() {
    return new Ov(this.cmap);
  }
  /**
  * An array of all of the unicode code points supported by the font.
  * @type {number[]}
  */
  get characterSet() {
    return this._cmapProcessor.getCharacterSet();
  }
  /**
  * Returns whether there is glyph in the font for the given unicode code point.
  *
  * @param {number} codePoint
  * @return {boolean}
  */
  hasGlyphForCodePoint(e) {
    return !!this._cmapProcessor.lookup(e);
  }
  /**
  * Maps a single unicode code point to a Glyph object.
  * Does not perform any advanced substitutions (there is no context to do so).
  *
  * @param {number} codePoint
  * @return {Glyph}
  */
  glyphForCodePoint(e) {
    return this.getGlyph(this._cmapProcessor.lookup(e), [
      e
    ]);
  }
  /**
  * Returns an array of Glyph objects for the given string.
  * This is only a one-to-one mapping from characters to glyphs.
  * For most uses, you should use font.layout (described below), which
  * provides a much more advanced mapping supporting AAT and OpenType shaping.
  *
  * @param {string} string
  * @return {Glyph[]}
  */
  glyphsForString(e) {
    let t = [], n = e.length, i = 0, a = -1, o = -1;
    for (; i <= n; ) {
      let s = 0, c = 0;
      if (i < n) {
        if (s = e.charCodeAt(i++), 55296 <= s && s <= 56319 && i < n) {
          let h = e.charCodeAt(i);
          56320 <= h && h <= 57343 && (i++, s = ((s & 1023) << 10) + (h & 1023) + 65536);
        }
        c = 65024 <= s && s <= 65039 || 917760 <= s && s <= 917999 ? 1 : 0;
      } else i++;
      o === 0 && c === 1 ? t.push(this.getGlyph(this._cmapProcessor.lookup(a, s), [
        a,
        s
      ])) : o === 0 && c === 0 && t.push(this.glyphForCodePoint(a)), a = s, o = c;
    }
    return t;
  }
  get _layoutEngine() {
    return new mI(this);
  }
  /**
  * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
  *
  * @param {string} string
  * @param {string[]} [userFeatures]
  * @param {string} [script]
  * @param {string} [language]
  * @param {string} [direction]
  * @return {GlyphRun}
  */
  layout(e, t, n, i, a) {
    return this._layoutEngine.layout(e, t, n, i, a);
  }
  /**
  * Returns an array of strings that map to the given glyph id.
  * @param {number} gid - glyph id
  */
  stringsForGlyph(e) {
    return this._layoutEngine.stringsForGlyph(e);
  }
  /**
  * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
  * (or mapped AAT tags) supported by the font.
  * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
  * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
  *
  * @type {string[]}
  */
  get availableFeatures() {
    return this._layoutEngine.getAvailableFeatures();
  }
  getAvailableFeatures(e, t) {
    return this._layoutEngine.getAvailableFeatures(e, t);
  }
  _getBaseGlyph(e, t = []) {
    return this._glyphs[e] || (this.directory.tables.glyf ? this._glyphs[e] = new qd(e, t, this) : (this.directory.tables["CFF "] || this.directory.tables.CFF2) && (this._glyphs[e] = new OI(e, t, this))), this._glyphs[e] || null;
  }
  /**
  * Returns a glyph object for the given glyph id.
  * You can pass the array of code points this glyph represents for
  * your use later, and it will be stored in the glyph object.
  *
  * @param {number} glyph
  * @param {number[]} characters
  * @return {Glyph}
  */
  getGlyph(e, t = []) {
    return this._glyphs[e] || (this.directory.tables.sbix ? this._glyphs[e] = new II(e, t, this) : this.directory.tables.COLR && this.directory.tables.CPAL ? this._glyphs[e] = new PI(e, t, this) : this._getBaseGlyph(e, t)), this._glyphs[e] || null;
  }
  /**
  * Returns a Subset for this font.
  * @return {Subset}
  */
  createSubset() {
    return this.directory.tables["CFF "] ? new KI(this) : new XI(this);
  }
  /**
  * Returns an object describing the available variation axes
  * that this font supports. Keys are setting tags, and values
  * contain the axis name, range, and default value.
  *
  * @type {object}
  */
  get variationAxes() {
    let e = {};
    if (!this.fvar) return e;
    for (let t of this.fvar.axis) e[t.axisTag.trim()] = {
      name: t.name.en,
      min: t.minValue,
      default: t.defaultValue,
      max: t.maxValue
    };
    return e;
  }
  /**
  * Returns an object describing the named variation instances
  * that the font designer has specified. Keys are variation names
  * and values are the variation settings for this instance.
  *
  * @type {object}
  */
  get namedVariations() {
    let e = {};
    if (!this.fvar) return e;
    for (let t of this.fvar.instance) {
      let n = {};
      for (let i = 0; i < this.fvar.axis.length; i++) {
        let a = this.fvar.axis[i];
        n[a.axisTag.trim()] = t.coord[i];
      }
      e[t.name.en] = n;
    }
    return e;
  }
  /**
  * Returns a new font with the given variation settings applied.
  * Settings can either be an instance name, or an object containing
  * variation tags as specified by the `variationAxes` property.
  *
  * @param {object} settings
  * @return {TTFFont}
  */
  getVariation(e) {
    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
    if (typeof e == "string" && (e = this.namedVariations[e]), typeof e != "object") throw new Error("Variation settings must be either a variation name or settings object.");
    let t = this.fvar.axis.map((a, o) => {
      let s = a.axisTag.trim();
      return s in e ? Math.max(a.minValue, Math.min(a.maxValue, e[s])) : a.defaultValue;
    }), n = new kn(this.stream.buffer);
    n.pos = this._directoryPos;
    let i = new $n(n, t);
    return i._tables = this._tables, i;
  }
  get _variationProcessor() {
    if (!this.fvar) return null;
    let e = this.variationCoords;
    return !e && !this.CFF2 ? null : (e || (e = this.fvar.axis.map((t) => t.defaultValue)), new jI(this, e));
  }
  // Standardized format plugin API
  getFont(e) {
    return this.getVariation(e);
  }
  constructor(e, t = null) {
    hi(this, "type", "TTF"), this.defaultLanguage = null, this.stream = e, this.variationCoords = t, this._directoryPos = this.stream.pos, this._tables = {}, this._glyphs = {}, this._decodeDirectory();
    for (let n in this.directory.tables) {
      let i = this.directory.tables[n];
      ud[n] && i.length > 0 && Object.defineProperty(this, n, {
        get: this._getTable.bind(this, i)
      });
    }
  }
}
Cn([
  Fn
], $n.prototype, "bbox", null);
Cn([
  Fn
], $n.prototype, "_cmapProcessor", null);
Cn([
  Fn
], $n.prototype, "characterSet", null);
Cn([
  Fn
], $n.prototype, "_layoutEngine", null);
Cn([
  Fn
], $n.prototype, "variationAxes", null);
Cn([
  Fn
], $n.prototype, "namedVariations", null);
Cn([
  Fn
], $n.prototype, "_variationProcessor", null);
let JI = new Me({
  tag: new Ur(4),
  offset: new Se(Oe, "void", {
    type: "global"
  }),
  compLength: Oe,
  length: Oe,
  origChecksum: Oe
}), z7 = new Me({
  tag: new Ur(4),
  flavor: Oe,
  length: Oe,
  numTables: O,
  reserved: new o0(O),
  totalSfntSize: Oe,
  majorVersion: O,
  minorVersion: O,
  metaOffset: Oe,
  metaLength: Oe,
  metaOrigLength: Oe,
  privOffset: Oe,
  privLength: Oe,
  tables: new Te(JI, "numTables")
});
z7.process = function() {
  let r = {};
  for (let e of this.tables) r[e.tag] = e;
  this.tables = r;
};
var QI = z7;
class eP extends $n {
  static probe(e) {
    return Vd.decode(e.slice(0, 4)) === "wOFF";
  }
  _decodeDirectory() {
    this.directory = QI.decode(this.stream, {
      _startOffset: 0
    });
  }
  _getTableStream(e) {
    let t = this.directory.tables[e];
    if (t)
      if (this.stream.pos = t.offset, t.compLength < t.length) {
        this.stream.pos += 2;
        let n = new Uint8Array(t.length), i = Rk(this.stream.readBuffer(t.compLength - 2), n);
        return new kn(i);
      } else return this.stream;
    return null;
  }
  constructor(...e) {
    super(...e), hi(this, "type", "WOFF");
  }
}
class tP extends qd {
  _decode() {
    return this._font._transformedGlyphs[this.id];
  }
  _getCBox() {
    return this.path.bbox;
  }
  constructor(...e) {
    super(...e), hi(this, "type", "WOFF2");
  }
}
const ay = {
  decode(r) {
    let e = 0, t = [
      0,
      1,
      2,
      3,
      4
    ];
    for (let n = 0; n < t.length; n++) {
      let i = r.readUInt8();
      if (e & 3758096384) throw new Error("Overflow");
      if (e = e << 7 | i & 127, !(i & 128)) return e;
    }
    throw new Error("Bad base 128 number");
  }
};
let rP = [
  "cmap",
  "head",
  "hhea",
  "hmtx",
  "maxp",
  "name",
  "OS/2",
  "post",
  "cvt ",
  "fpgm",
  "glyf",
  "loca",
  "prep",
  "CFF ",
  "VORG",
  "EBDT",
  "EBLC",
  "gasp",
  "hdmx",
  "kern",
  "LTSH",
  "PCLT",
  "VDMX",
  "vhea",
  "vmtx",
  "BASE",
  "GDEF",
  "GPOS",
  "GSUB",
  "EBSC",
  "JSTF",
  "MATH",
  "CBDT",
  "CBLC",
  "COLR",
  "CPAL",
  "SVG ",
  "sbix",
  "acnt",
  "avar",
  "bdat",
  "bloc",
  "bsln",
  "cvar",
  "fdsc",
  "feat",
  "fmtx",
  "fvar",
  "gvar",
  "hsty",
  "just",
  "lcar",
  "mort",
  "morx",
  "opbd",
  "prop",
  "trak",
  "Zapf",
  "Silf",
  "Glat",
  "Gloc",
  "Feat",
  "Sill"
], nP = new Me({
  flags: kt,
  customTag: new rd(new Ur(4), (r) => (r.flags & 63) === 63),
  tag: (r) => r.customTag || rP[r.flags & 63],
  length: ay,
  transformVersion: (r) => r.flags >>> 6 & 3,
  transformed: (r) => r.tag === "glyf" || r.tag === "loca" ? r.transformVersion === 0 : r.transformVersion !== 0,
  transformLength: new rd(ay, (r) => r.transformed)
}), j7 = new Me({
  tag: new Ur(4),
  flavor: Oe,
  length: Oe,
  numTables: O,
  reserved: new o0(O),
  totalSfntSize: Oe,
  totalCompressedSize: Oe,
  majorVersion: O,
  minorVersion: O,
  metaOffset: Oe,
  metaLength: Oe,
  metaOrigLength: Oe,
  privOffset: Oe,
  privLength: Oe,
  tables: new Te(nP, "numTables")
});
j7.process = function() {
  let r = {};
  for (let e = 0; e < this.tables.length; e++) {
    let t = this.tables[e];
    r[t.tag] = t;
  }
  return this.tables = r;
};
var iP = j7;
class aP extends $n {
  static probe(e) {
    return Vd.decode(e.slice(0, 4)) === "wOF2";
  }
  _decodeDirectory() {
    this.directory = iP.decode(this.stream), this._dataPos = this.stream.pos;
  }
  _decompress() {
    if (!this._decompressed) {
      this.stream.pos = this._dataPos;
      let e = this.stream.readBuffer(this.directory.totalCompressedSize), t = 0;
      for (let i in this.directory.tables) {
        let a = this.directory.tables[i];
        a.offset = t, t += a.transformLength != null ? a.transformLength : a.length;
      }
      let n = CS(e, t);
      if (!n) throw new Error("Error decoding compressed data in WOFF2");
      this.stream = new kn(n), this._decompressed = !0;
    }
  }
  _decodeTable(e) {
    return this._decompress(), super._decodeTable(e);
  }
  // Override this method to get a glyph and return our
  // custom subclass if there is a glyf table.
  _getBaseGlyph(e, t = []) {
    if (!this._glyphs[e])
      return this.directory.tables.glyf && this.directory.tables.glyf.transformed ? (this._transformedGlyphs || this._transformGlyfTable(), this._glyphs[e] = new tP(e, t, this)) : super._getBaseGlyph(e, t);
  }
  _transformGlyfTable() {
    this._decompress(), this.stream.pos = this.directory.tables.glyf.offset;
    let e = oP.decode(this.stream), t = [];
    for (let i = 0; i < e.numGlyphs; i++) {
      let a = {}, o = e.nContours.readInt16BE();
      if (a.numberOfContours = o, o > 0) {
        let s = [], c = 0;
        for (let h = 0; h < o; h++) {
          let d = up(e.nPoints);
          c += d, s.push(c);
        }
        a.points = cP(e.flags, e.glyphs, c);
        for (let h = 0; h < o; h++) a.points[s[h] - 1].endContour = !0;
        var n = up(e.glyphs);
      } else if (o < 0 && qd.prototype._decodeComposite.call({
        _font: this
      }, a, e.composites))
        var n = up(e.glyphs);
      t.push(a);
    }
    this._transformedGlyphs = t;
  }
  constructor(...e) {
    super(...e), hi(this, "type", "WOFF2");
  }
}
class zu {
  decode(e, t) {
    return new kn(this._buf.decode(e, t));
  }
  constructor(e) {
    this.length = e, this._buf = new po(e);
  }
}
let oP = new Me({
  version: Oe,
  numGlyphs: O,
  indexFormat: O,
  nContourStreamSize: Oe,
  nPointsStreamSize: Oe,
  flagStreamSize: Oe,
  glyphStreamSize: Oe,
  compositeStreamSize: Oe,
  bboxStreamSize: Oe,
  instructionStreamSize: Oe,
  nContours: new zu("nContourStreamSize"),
  nPoints: new zu("nPointsStreamSize"),
  flags: new zu("flagStreamSize"),
  glyphs: new zu("glyphStreamSize"),
  composites: new zu("compositeStreamSize"),
  bboxes: new zu("bboxStreamSize"),
  instructions: new zu("instructionStreamSize")
});
const sP = 253, uP = 254, lP = 255, oy = 253;
function up(r) {
  let e = r.readUInt8();
  return e === sP ? r.readUInt16BE() : e === lP ? r.readUInt8() + oy : e === uP ? r.readUInt8() + oy * 2 : e;
}
function Va(r, e) {
  return r & 1 ? e : -e;
}
function cP(r, e, t) {
  let n, i = n = 0, a = [];
  for (let c = 0; c < t; c++) {
    let h = 0, d = 0, g = r.readUInt8(), x = !(g >> 7);
    if (g &= 127, g < 10)
      h = 0, d = Va(g, ((g & 14) << 7) + e.readUInt8());
    else if (g < 20)
      h = Va(g, ((g - 10 & 14) << 7) + e.readUInt8()), d = 0;
    else if (g < 84) {
      var o = g - 20, s = e.readUInt8();
      h = Va(g, 1 + (o & 48) + (s >> 4)), d = Va(g >> 1, 1 + ((o & 12) << 2) + (s & 15));
    } else if (g < 120) {
      var o = g - 84;
      h = Va(g, 1 + (o / 12 << 8) + e.readUInt8()), d = Va(g >> 1, 1 + (o % 12 >> 2 << 8) + e.readUInt8());
    } else if (g < 124) {
      var s = e.readUInt8();
      let k = e.readUInt8();
      h = Va(g, (s << 4) + (k >> 4)), d = Va(g >> 1, ((k & 15) << 8) + e.readUInt8());
    } else
      h = Va(g, e.readUInt16BE()), d = Va(g >> 1, e.readUInt16BE());
    i += h, n += d, a.push(new Ea(x, !1, i, n));
  }
  return a;
}
let fP = new or(Oe, {
  65536: {
    numFonts: Oe,
    offsets: new Te(Oe, "numFonts")
  },
  131072: {
    numFonts: Oe,
    offsets: new Te(Oe, "numFonts"),
    dsigTag: Oe,
    dsigLength: Oe,
    dsigOffset: Oe
  }
});
class hP {
  static probe(e) {
    return Vd.decode(e.slice(0, 4)) === "ttcf";
  }
  getFont(e) {
    for (let t of this.header.offsets) {
      let n = new kn(this.stream.buffer);
      n.pos = t;
      let i = new $n(n);
      if (i.postscriptName === e || i.postscriptName instanceof Uint8Array && e instanceof Uint8Array && i.postscriptName.every((a, o) => e[o] === a)) return i;
    }
    return null;
  }
  get fonts() {
    let e = [];
    for (let t of this.header.offsets) {
      let n = new kn(this.stream.buffer);
      n.pos = t, e.push(new $n(n));
    }
    return e;
  }
  constructor(e) {
    if (hi(this, "type", "TTC"), this.stream = e, e.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
    this.header = fP.decode(e);
  }
}
let dP = new Ur(kt);
new Me({
  len: Oe,
  buf: new po("len")
});
let pP = new Me({
  id: O,
  nameOffset: lt,
  attr: kt,
  dataOffset: Xs,
  handle: Oe
}), vP = new Me({
  name: new Ur(4),
  maxTypeIndex: O,
  refList: new Se(O, new Te(pP, (r) => r.maxTypeIndex + 1), {
    type: "parent"
  })
}), gP = new Me({
  length: O,
  types: new Te(vP, (r) => r.length + 1)
}), mP = new Me({
  reserved: new o0(kt, 24),
  typeList: new Se(O, gP),
  nameListOffset: new Se(O, "void")
}), sy = new Me({
  dataOffset: Oe,
  map: new Se(Oe, mP),
  dataLength: Oe,
  mapLength: Oe
});
class yP {
  static probe(e) {
    let t = new kn(e);
    try {
      var n = sy.decode(t);
    } catch {
      return !1;
    }
    for (let i of n.map.typeList.types)
      if (i.name === "sfnt") return !0;
    return !1;
  }
  getFont(e) {
    if (!this.sfnt) return null;
    for (let t of this.sfnt.refList) {
      let n = this.header.dataOffset + t.dataOffset + 4, i = new kn(this.stream.buffer.slice(n)), a = new $n(i);
      if (a.postscriptName === e || a.postscriptName instanceof Uint8Array && e instanceof Uint8Array && a.postscriptName.every((o, s) => e[s] === o)) return a;
    }
    return null;
  }
  get fonts() {
    let e = [];
    for (let t of this.sfnt.refList) {
      let n = this.header.dataOffset + t.dataOffset + 4, i = new kn(this.stream.buffer.slice(n));
      e.push(new $n(i));
    }
    return e;
  }
  constructor(e) {
    hi(this, "type", "DFont"), this.stream = e, this.header = sy.decode(this.stream);
    for (let t of this.header.map.typeList.types) {
      for (let n of t.refList) n.nameOffset >= 0 ? (this.stream.pos = n.nameOffset + this.header.map.nameListOffset, n.name = dP.decode(this.stream)) : n.name = null;
      t.name === "sfnt" && (this.sfnt = t);
    }
  }
}
Qc($n);
Qc(eP);
Qc(aP);
Qc(hP);
Qc(yP);
var bP = ["src", "fontWeight", "fontStyle"], wP = {
  thin: 100,
  hairline: 100,
  ultralight: 200,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  demibold: 600,
  bold: 700,
  ultrabold: 800,
  extrabold: 800,
  heavy: 900,
  black: 900
}, AP = /* @__PURE__ */ function() {
  var r = ui(/* @__PURE__ */ qr().mark(function e(t, n) {
    var i, a;
    return qr().wrap(function(s) {
      for (; ; ) switch (s.prev = s.next) {
        case 0:
          return s.next = 2, Ww(t, n);
        case 2:
          return i = s.sent, s.next = 5, i.arrayBuffer();
        case 5:
          return a = s.sent, s.abrupt("return", new Uint8Array(a));
        case 7:
        case "end":
          return s.stop();
      }
    }, e);
  }));
  return function(t, n) {
    return r.apply(this, arguments);
  };
}(), xP = function(e) {
  var t = e.split(",")[0], n = t.substring(0, 5) === "data:", i = t.split(";")[1] === "base64";
  return n && i;
}, EP = function(e) {
  return typeof e == "string" ? wP[e] : e;
}, uy = function(e, t) {
  return e.fontWeight - t.fontWeight;
}, _P = /* @__PURE__ */ function() {
  function r(t, n, i, a, o) {
    this.src = t, this.fontFamily = n, this.fontStyle = i || "normal", this.fontWeight = a || 400, this.data = null, this.options = o, this.loadResultPromise = null;
  }
  var e = r.prototype;
  return e._load = /* @__PURE__ */ function() {
    var t = ui(/* @__PURE__ */ qr().mark(function i() {
      var a, o, s, c, h, d, g, x, _;
      return qr().wrap(function(P) {
        for (; ; ) switch (P.prev = P.next) {
          case 0:
            if (a = this.options.postscriptName, !xP(this.src)) {
              P.next = 7;
              break;
            }
            o = this.src.split(",")[1], s = new Uint8Array(atob(o).split("").map(function(N) {
              return N.charCodeAt(0);
            })), this.data = v1(s, a), P.next = 19;
            break;
          case 7:
            return c = this.options, h = c.headers, d = c.body, g = c.method, x = g === void 0 ? "GET" : g, P.next = 11, AP(this.src, {
              method: x,
              body: d,
              headers: h
            });
          case 11:
            _ = P.sent, this.data = v1(_, a), P.next = 19;
            break;
          case 15: {
            P.next = 19;
            break;
          }
          case 18:
            this.data = P.sent;
          case 19:
          case "end":
            return P.stop();
        }
      }, i, this);
    }));
    function n() {
      return t.apply(this, arguments);
    }
    return n;
  }(), e.load = /* @__PURE__ */ function() {
    var t = ui(/* @__PURE__ */ qr().mark(function i() {
      return qr().wrap(function(o) {
        for (; ; ) switch (o.prev = o.next) {
          case 0:
            return this.loadResultPromise === null && (this.loadResultPromise = this._load()), o.abrupt("return", this.loadResultPromise);
          case 2:
          case "end":
            return o.stop();
        }
      }, i, this);
    }));
    function n() {
      return t.apply(this, arguments);
    }
    return n;
  }(), r;
}(), DP = /* @__PURE__ */ function() {
  r.create = function(n) {
    return new r(n);
  };
  function r(t) {
    this.family = t, this.sources = [];
  }
  var e = r.prototype;
  return e.register = function(n) {
    var i = n.src, a = n.fontWeight, o = n.fontStyle, s = Vc(n, bP), c = EP(a);
    this.sources.push(new _P(i, this.family, o, c, s));
  }, e.resolve = function(n) {
    var i = n.fontWeight, a = i === void 0 ? 400 : i, o = n.fontStyle, s = o === void 0 ? "normal" : o, c = this.sources.filter(function(N) {
      return N.fontStyle === s;
    }), h = c.find(function(N) {
      return N.fontWeight === a;
    });
    if (h) return h;
    var d;
    if (a >= 400 && a <= 500) {
      var g = c.filter(function(N) {
        return N.fontWeight <= a;
      }), x = c.filter(function(N) {
        return N.fontWeight > 500;
      }), _ = c.filter(function(N) {
        return N.fontWeight >= a && N.fontWeight < 500;
      });
      d = _[0] || g[g.length - 1] || x[0];
    }
    var k = c.filter(function(N) {
      return N.fontWeight < a;
    }).sort(uy), P = c.filter(function(N) {
      return N.fontWeight > a;
    }).sort(uy);
    if (a < 400 && (d = k[k.length - 1] || P[0]), a > 500 && (d = P[0] || k[k.length - 1]), !d)
      throw new Error("Could not resolve font for " + this.family + ", fontWeight " + a);
    return d;
  }, r;
}(), ly = ["Courier", "Courier-Bold", "Courier-Oblique", "Courier-BoldOblique", "Helvetica", "Helvetica-Bold", "Helvetica-Oblique", "Helvetica-BoldOblique", "Times-Roman", "Times-Bold", "Times-Italic", "Times-BoldItalic"];
function TP() {
  var r = this, e = {}, t = null, n = null;
  this.register = function(i) {
    var a = i.family;
    if (e[a] || (e[a] = DP.create(a)), i.fonts)
      for (var o = 0; o < i.fonts.length; o += 1)
        e[a].register($r({
          family: a
        }, i.fonts[o]));
    else
      e[a].register(i);
  }, this.registerEmojiSource = function(i) {
    var a = i.url, o = i.format, s = o === void 0 ? "png" : o, c = i.builder;
    t = {
      url: a,
      format: s,
      builder: c
    };
  }, this.registerHyphenationCallback = function(i) {
    n = i;
  }, this.getFont = function(i) {
    var a = i.fontFamily, o = ly.includes(a);
    if (o) return null;
    if (!e[a])
      throw new Error("Font family not registered: " + a + ". Please register it calling Font.register() method.");
    return e[a].resolve(i);
  }, this.load = /* @__PURE__ */ function() {
    var i = ui(/* @__PURE__ */ qr().mark(function a(o) {
      var s, c, h;
      return qr().wrap(function(g) {
        for (; ; ) switch (g.prev = g.next) {
          case 0:
            if (s = o.fontFamily, c = ly.includes(s), !c) {
              g.next = 4;
              break;
            }
            return g.abrupt("return");
          case 4:
            return h = r.getFont(o), g.next = 7, h.load();
          case 7:
          case "end":
            return g.stop();
        }
      }, a);
    }));
    return function(a) {
      return i.apply(this, arguments);
    };
  }(), this.reset = function() {
    for (var i = Object.keys(e), a = 0; a < i.length; a += 1) {
      var o = i[a];
      e[o].data = null;
    }
  }, this.clear = function() {
    e = {};
  }, this.getRegisteredFonts = function() {
    return e;
  }, this.getEmojiSource = function() {
    return t;
  }, this.getHyphenationCallback = function() {
    return n;
  }, this.getRegisteredFontFamilies = function() {
    return Object.keys(e);
  };
}
var kP = function(e, t, n) {
  var i;
  if (Math.abs(e) > n.length) return n;
  var a = n.length + e;
  return Object.assign([], n, (i = {}, i[a] = t(n[a]), i));
}, W7 = function(e) {
  return Array.prototype.slice.call(e, 0).reverse();
}, SP = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return /* @__PURE__ */ function() {
    var i = ui(/* @__PURE__ */ qr().mark(function a(o) {
      var s, c, h, d, g, x, _, k = arguments;
      return qr().wrap(function(N) {
        for (; ; ) switch (N.prev = N.next) {
          case 0:
            for (s = o, c = W7(t), h = k.length, d = new Array(h > 1 ? h - 1 : 0), g = 1; g < h; g++)
              d[g - 1] = k[g];
            x = 0;
          case 4:
            if (!(x < c.length)) {
              N.next = 12;
              break;
            }
            return _ = c[x], N.next = 8, _.apply(void 0, [s].concat(d));
          case 8:
            s = N.sent;
          case 9:
            x += 1, N.next = 4;
            break;
          case 12:
            return N.abrupt("return", s);
          case 13:
          case "end":
            return N.stop();
        }
      }, a);
    }));
    return function(a) {
      return i.apply(this, arguments);
    };
  }();
}, CP = function(e) {
  return e && e.replace(/(^|\s)\S/g, function(t) {
    return t.toUpperCase();
  });
}, Xd = function(e) {
  return Array.isArray(e) ? e : [e];
}, fi = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(i) {
    for (var a = i, o = W7(t), s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), h = 1; h < s; h++)
      c[h - 1] = arguments[h];
    for (var d = 0; d < o.length; d += 1) {
      var g = o[d];
      a = g.apply(void 0, [a].concat(c));
    }
    return a;
  };
}, FP = function(e) {
  return e.slice(0, e.length - 1);
}, Kd = function r(e, t) {
  for (var n = t instanceof Array ? [] : {}, i = Object.keys(t), a = 0; a < i.length; a += 1) {
    var o = i[a], s = e[o], c = typeof s;
    c === "function" ? n[o] = s(t[o]) : s && c === "object" ? n[o] = r(s, t[o]) : n[o] = t[o];
  }
  return n;
}, zr = function(e) {
  return e == null;
}, lp = function(e, t, n) {
  if (zr(e)) return n;
  for (var i = Xd(t), a = e, o = 0; o < i.length; o += 1) {
    if (zr(a)) return;
    a = a[i[o]];
  }
  return zr(a) ? n : a;
}, Qo = function(e) {
  return e === "" ? "" : e[e.length - 1];
}, G7 = function(e, t) {
  var n = Object.entries(e);
  return n.reduce(function(i, a, o) {
    var s = a[0], c = a[1];
    return i[s] = t(c, s, o), i;
  }, {});
}, OP = function(e) {
  return /((-)?\d+\.?\d*)%/g.exec(e);
}, ln = function(e) {
  var t = OP(e);
  if (t) {
    var n = parseFloat(t[1], 10), i = n / 100;
    return {
      percent: i,
      value: n
    };
  }
  return null;
}, s3 = function(e, t) {
  var n = Xd(e), i = Object.assign({}, t);
  return n.forEach(function(a) {
    delete i[a];
  }), i;
}, Iv = function(e, t) {
  for (var n = {}, i = 0; i < e.length; i += 1) {
    var a = e[i];
    a in t && (n[a] = t[a]);
  }
  return n;
}, Pv = function(e) {
  return e && e.charAt(0).toUpperCase() + e.slice(1);
}, RP = IP;
function IP(r) {
  var e = 0, t = 0, n = 0, i = 0;
  return r.map(function(a) {
    a = a.slice();
    var o = a[0], s = o.toUpperCase();
    if (o != s)
      switch (a[0] = s, o) {
        case "a":
          a[6] += n, a[7] += i;
          break;
        case "v":
          a[1] += i;
          break;
        case "h":
          a[1] += n;
          break;
        default:
          for (var c = 1; c < a.length; )
            a[c++] += n, a[c++] += i;
      }
    switch (s) {
      case "Z":
        n = e, i = t;
        break;
      case "H":
        n = a[1];
        break;
      case "V":
        i = a[1];
        break;
      case "M":
        n = e = a[1], i = t = a[2];
        break;
      default:
        n = a[a.length - 2], i = a[a.length - 1];
    }
    return a;
  });
}
const PP = /* @__PURE__ */ I0(RP);
var BP = LP, cp = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 }, NP = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
function LP(r) {
  var e = [];
  return r.replace(NP, function(t, n, i) {
    var a = n.toLowerCase();
    for (i = UP(i), a == "m" && i.length > 2 && (e.push([n].concat(i.splice(0, 2))), a = "l", n = n == "m" ? "l" : "L"); ; ) {
      if (i.length == cp[a])
        return i.unshift(n), e.push(i);
      if (i.length < cp[a]) throw new Error("malformed path data");
      e.push([n].concat(i.splice(0, cp[a])));
    }
  }), e;
}
var MP = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function UP(r) {
  var e = r.match(MP);
  return e ? e.map(Number) : [];
}
const $P = /* @__PURE__ */ I0(BP);
var zP = /* @__PURE__ */ function() {
  function r(e, t) {
    var n = [], i = !0, a = !1, o = void 0;
    try {
      for (var s = e[Symbol.iterator](), c; !(i = (c = s.next()).done) && (n.push(c.value), !(t && n.length === t)); i = !0)
        ;
    } catch (h) {
      a = !0, o = h;
    } finally {
      try {
        !i && s.return && s.return();
      } finally {
        if (a) throw o;
      }
    }
    return n;
  }
  return function(e, t) {
    if (Array.isArray(e))
      return e;
    if (Symbol.iterator in Object(e))
      return r(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), i1 = Math.PI * 2, fp = function(e, t, n, i, a, o, s) {
  var c = e.x, h = e.y;
  c *= t, h *= n;
  var d = i * c - a * h, g = a * c + i * h;
  return {
    x: d + o,
    y: g + s
  };
}, jP = function(e, t) {
  var n = t === 1.5707963267948966 ? 0.551915024494 : t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), i = Math.cos(e), a = Math.sin(e), o = Math.cos(e + t), s = Math.sin(e + t);
  return [{
    x: i - a * n,
    y: a + i * n
  }, {
    x: o + s * n,
    y: s - o * n
  }, {
    x: o,
    y: s
  }];
}, cy = function(e, t, n, i) {
  var a = e * i - t * n < 0 ? -1 : 1, o = e * n + t * i;
  return o > 1 && (o = 1), o < -1 && (o = -1), a * Math.acos(o);
}, WP = function(e, t, n, i, a, o, s, c, h, d, g, x) {
  var _ = Math.pow(a, 2), k = Math.pow(o, 2), P = Math.pow(g, 2), N = Math.pow(x, 2), M = _ * k - _ * N - k * P;
  M < 0 && (M = 0), M /= _ * N + k * P, M = Math.sqrt(M) * (s === c ? -1 : 1);
  var G = M * a / o * x, z = M * -o / a * g, j = d * G - h * z + (e + n) / 2, R = h * G + d * z + (t + i) / 2, te = (g - G) / a, J = (x - z) / o, K = (-g - G) / a, ee = (-x - z) / o, ve = cy(1, 0, te, J), de = cy(te, J, K, ee);
  return c === 0 && de > 0 && (de -= i1), c === 1 && de < 0 && (de += i1), [j, R, ve, de];
}, GP = function(e) {
  var t = e.px, n = e.py, i = e.cx, a = e.cy, o = e.rx, s = e.ry, c = e.xAxisRotation, h = c === void 0 ? 0 : c, d = e.largeArcFlag, g = d === void 0 ? 0 : d, x = e.sweepFlag, _ = x === void 0 ? 0 : x, k = [];
  if (o === 0 || s === 0)
    return [];
  var P = Math.sin(h * i1 / 360), N = Math.cos(h * i1 / 360), M = N * (t - i) / 2 + P * (n - a) / 2, G = -P * (t - i) / 2 + N * (n - a) / 2;
  if (M === 0 && G === 0)
    return [];
  o = Math.abs(o), s = Math.abs(s);
  var z = Math.pow(M, 2) / Math.pow(o, 2) + Math.pow(G, 2) / Math.pow(s, 2);
  z > 1 && (o *= Math.sqrt(z), s *= Math.sqrt(z));
  var j = WP(t, n, i, a, o, s, g, _, P, N, M, G), R = zP(j, 4), te = R[0], J = R[1], K = R[2], ee = R[3], ve = Math.abs(ee) / (i1 / 4);
  Math.abs(1 - ve) < 1e-7 && (ve = 1);
  var de = Math.max(Math.ceil(ve), 1);
  ee /= de;
  for (var B = 0; B < de; B++)
    k.push(jP(K, ee)), K += ee;
  return k.map(function(q) {
    var H = fp(q[0], o, s, N, P, te, J), oe = H.x, ne = H.y, me = fp(q[1], o, s, N, P, te, J), fe = me.x, _e = me.y, Re = fp(q[2], o, s, N, P, te, J), Ie = Re.x, W = Re.y;
    return { x1: oe, y1: ne, x2: fe, y2: _e, x: Ie, y: W };
  });
};
function VP(r) {
  for (var e, t = [], n = 0, i = 0, a = 0, o = 0, s = null, c = null, h = 0, d = 0, g = 0, x = r.length; g < x; g++) {
    var _ = r[g], k = _[0];
    switch (k) {
      case "M":
        a = _[1], o = _[2];
        break;
      case "A":
        var P = GP({
          px: h,
          py: d,
          cx: _[6],
          cy: _[7],
          rx: _[1],
          ry: _[2],
          xAxisRotation: _[3],
          largeArcFlag: _[4],
          sweepFlag: _[5]
        });
        if (!P.length) continue;
        for (var N = 0, M; N < P.length; N++)
          M = P[N], _ = ["C", M.x1, M.y1, M.x2, M.y2, M.x, M.y], N < P.length - 1 && t.push(_);
        break;
      case "S":
        var G = h, z = d;
        (e == "C" || e == "S") && (G += G - n, z += z - i), _ = ["C", G, z, _[1], _[2], _[3], _[4]];
        break;
      case "T":
        e == "Q" || e == "T" ? (s = h * 2 - s, c = d * 2 - c) : (s = h, c = d), _ = fy(h, d, s, c, _[1], _[2]);
        break;
      case "Q":
        s = _[1], c = _[2], _ = fy(h, d, _[1], _[2], _[3], _[4]);
        break;
      case "L":
        _ = I2(h, d, _[1], _[2]);
        break;
      case "H":
        _ = I2(h, d, _[1], d);
        break;
      case "V":
        _ = I2(h, d, h, _[1]);
        break;
      case "Z":
        _ = I2(h, d, a, o);
        break;
    }
    e = k, h = _[_.length - 2], d = _[_.length - 1], _.length > 4 ? (n = _[_.length - 4], i = _[_.length - 3]) : (n = h, i = d), t.push(_);
  }
  return t;
}
function I2(r, e, t, n) {
  return ["C", r, e, t, n, t, n];
}
function fy(r, e, t, n, i, a) {
  return [
    "C",
    r / 3 + 2 / 3 * t,
    e / 3 + 2 / 3 * n,
    i / 3 + 2 / 3 * t,
    a / 3 + 2 / 3 * n,
    i,
    a
  ];
}
var V7 = { exports: {} }, YP = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, Y7 = { exports: {} }, HP = function(e) {
  return !e || typeof e == "string" ? !1 : e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && e.constructor.name !== "String");
}, ZP = HP, qP = Array.prototype.concat, XP = Array.prototype.slice, hy = Y7.exports = function(e) {
  for (var t = [], n = 0, i = e.length; n < i; n++) {
    var a = e[n];
    ZP(a) ? t = qP.call(t, XP.call(a)) : t.push(a);
  }
  return t;
};
hy.wrap = function(r) {
  return function() {
    return r(hy(arguments));
  };
};
var KP = Y7.exports, a1 = YP, H1 = KP, H7 = Object.hasOwnProperty, Z7 = /* @__PURE__ */ Object.create(null);
for (var hp in a1)
  H7.call(a1, hp) && (Z7[a1[hp]] = hp);
var Si = V7.exports = {
  to: {},
  get: {}
};
Si.get = function(r) {
  var e = r.substring(0, 3).toLowerCase(), t, n;
  switch (e) {
    case "hsl":
      t = Si.get.hsl(r), n = "hsl";
      break;
    case "hwb":
      t = Si.get.hwb(r), n = "hwb";
      break;
    default:
      t = Si.get.rgb(r), n = "rgb";
      break;
  }
  return t ? { model: n, value: t } : null;
};
Si.get.rgb = function(r) {
  if (!r)
    return null;
  var e = /^#([a-f0-9]{3,4})$/i, t = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, n = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, i = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, a = /^(\w+)$/, o = [0, 0, 0, 1], s, c, h;
  if (s = r.match(t)) {
    for (h = s[2], s = s[1], c = 0; c < 3; c++) {
      var d = c * 2;
      o[c] = parseInt(s.slice(d, d + 2), 16);
    }
    h && (o[3] = parseInt(h, 16) / 255);
  } else if (s = r.match(e)) {
    for (s = s[1], h = s[3], c = 0; c < 3; c++)
      o[c] = parseInt(s[c] + s[c], 16);
    h && (o[3] = parseInt(h + h, 16) / 255);
  } else if (s = r.match(n)) {
    for (c = 0; c < 3; c++)
      o[c] = parseInt(s[c + 1], 0);
    s[4] && (s[5] ? o[3] = parseFloat(s[4]) * 0.01 : o[3] = parseFloat(s[4]));
  } else if (s = r.match(i)) {
    for (c = 0; c < 3; c++)
      o[c] = Math.round(parseFloat(s[c + 1]) * 2.55);
    s[4] && (s[5] ? o[3] = parseFloat(s[4]) * 0.01 : o[3] = parseFloat(s[4]));
  } else return (s = r.match(a)) ? s[1] === "transparent" ? [0, 0, 0, 0] : H7.call(a1, s[1]) ? (o = a1[s[1]], o[3] = 1, o) : null : null;
  for (c = 0; c < 3; c++)
    o[c] = Js(o[c], 0, 255);
  return o[3] = Js(o[3], 0, 1), o;
};
Si.get.hsl = function(r) {
  if (!r)
    return null;
  var e = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, t = r.match(e);
  if (t) {
    var n = parseFloat(t[4]), i = (parseFloat(t[1]) % 360 + 360) % 360, a = Js(parseFloat(t[2]), 0, 100), o = Js(parseFloat(t[3]), 0, 100), s = Js(isNaN(n) ? 1 : n, 0, 1);
    return [i, a, o, s];
  }
  return null;
};
Si.get.hwb = function(r) {
  if (!r)
    return null;
  var e = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, t = r.match(e);
  if (t) {
    var n = parseFloat(t[4]), i = (parseFloat(t[1]) % 360 + 360) % 360, a = Js(parseFloat(t[2]), 0, 100), o = Js(parseFloat(t[3]), 0, 100), s = Js(isNaN(n) ? 1 : n, 0, 1);
    return [i, a, o, s];
  }
  return null;
};
Si.to.hex = function() {
  var r = H1(arguments);
  return "#" + P2(r[0]) + P2(r[1]) + P2(r[2]) + (r[3] < 1 ? P2(Math.round(r[3] * 255)) : "");
};
Si.to.rgb = function() {
  var r = H1(arguments);
  return r.length < 4 || r[3] === 1 ? "rgb(" + Math.round(r[0]) + ", " + Math.round(r[1]) + ", " + Math.round(r[2]) + ")" : "rgba(" + Math.round(r[0]) + ", " + Math.round(r[1]) + ", " + Math.round(r[2]) + ", " + r[3] + ")";
};
Si.to.rgb.percent = function() {
  var r = H1(arguments), e = Math.round(r[0] / 255 * 100), t = Math.round(r[1] / 255 * 100), n = Math.round(r[2] / 255 * 100);
  return r.length < 4 || r[3] === 1 ? "rgb(" + e + "%, " + t + "%, " + n + "%)" : "rgba(" + e + "%, " + t + "%, " + n + "%, " + r[3] + ")";
};
Si.to.hsl = function() {
  var r = H1(arguments);
  return r.length < 4 || r[3] === 1 ? "hsl(" + r[0] + ", " + r[1] + "%, " + r[2] + "%)" : "hsla(" + r[0] + ", " + r[1] + "%, " + r[2] + "%, " + r[3] + ")";
};
Si.to.hwb = function() {
  var r = H1(arguments), e = "";
  return r.length >= 4 && r[3] !== 1 && (e = ", " + r[3]), "hwb(" + r[0] + ", " + r[1] + "%, " + r[2] + "%" + e + ")";
};
Si.to.keyword = function(r) {
  return Z7[r.slice(0, 3)];
};
function Js(r, e, t) {
  return Math.min(Math.max(e, r), t);
}
function P2(r) {
  var e = Math.round(r).toString(16).toUpperCase();
  return e.length < 2 ? "0" + e : e;
}
var JP = V7.exports;
const w1 = /* @__PURE__ */ I0(JP);
var QP = function(e, t) {
  var n, i = (n = t.props) === null || n === void 0 ? void 0 : n.d;
  i && e.path(t.props.d);
}, dy = 4 * ((Math.sqrt(2) - 1) / 3), eB = function(e, t) {
  var n, i, a, o, s, c, h = ((n = t.props) === null || n === void 0 ? void 0 : n.x) || 0, d = ((i = t.props) === null || i === void 0 ? void 0 : i.y) || 0, g = ((a = t.props) === null || a === void 0 ? void 0 : a.rx) || 0, x = ((o = t.props) === null || o === void 0 ? void 0 : o.ry) || 0, _ = ((s = t.props) === null || s === void 0 ? void 0 : s.width) || 0, k = ((c = t.props) === null || c === void 0 ? void 0 : c.height) || 0;
  if (!(!_ || !k)) {
    if (g && x) {
      var P = g * dy, N = x * dy;
      e.moveTo(h + g, d), e.lineTo(h - g + _, d), e.bezierCurveTo(h - g + _ + P, d, h + _, d + x - N, h + _, d + x), e.lineTo(h + _, d + k - x), e.bezierCurveTo(h + _, d + k - x + N, h - g + _ + P, d + k, h - g + _, d + k), e.lineTo(h + g, d + k), e.bezierCurveTo(h + g - P, d + k, h, d + k - x + N, h, d + k - x), e.lineTo(h, d + x), e.bezierCurveTo(h, d + x - N, h + g - P, d, h + g, d);
    } else
      e.moveTo(h, d), e.lineTo(h + _, d), e.lineTo(h + _, d + k), e.lineTo(h, d + k);
    e.closePath();
  }
}, tB = function(e, t) {
  var n = t.props || {}, i = n.x1, a = n.x2, o = n.y1, s = n.y2;
  e.moveTo(i, o), e.lineTo(a, s);
}, rB = function() {
}, py = 4 * ((Math.sqrt(2) - 1) / 3), q7 = function(e, t, n, i, a) {
  t === void 0 && (t = 0), n === void 0 && (n = 0);
  var o = t - i, s = n - a, c = i * py, h = a * py, d = o + i * 2, g = s + a * 2, x = o + i, _ = s + a;
  e.moveTo(o, _), e.bezierCurveTo(o, _ - h, x - c, s, x, s), e.bezierCurveTo(x + c, s, d, _ - h, d, _), e.bezierCurveTo(d, _ + h, x + c, g, x, g), e.bezierCurveTo(x - c, g, o, _ + h, o, _), e.closePath();
}, nB = function(e, t) {
  var n = t.props || {}, i = n.cx, a = n.cy, o = n.rx, s = n.ry;
  q7(e, i, a, o, s);
}, iB = function(e, t) {
  var n, i, a, o = (n = t.props) === null || n === void 0 ? void 0 : n.cx, s = (i = t.props) === null || i === void 0 ? void 0 : i.cy, c = (a = t.props) === null || a === void 0 ? void 0 : a.r;
  q7(e, o, s, c, c);
}, X7 = function(e, t, n, i, a, o) {
  o === void 0 && (o = {});
  var s = 1e3 / e._fontSize, c = e._font.font.unitsPerEm || 1e3, h = 1e3 / c, d = e._font.encodeGlyphs(t), g = n.map(function(x, _) {
    return {
      xAdvance: x.xAdvance * s,
      yAdvance: x.yAdvance * s,
      xOffset: x.xOffset,
      yOffset: x.yOffset,
      advanceWidth: t[_].advanceWidth * h
    };
  });
  return e._glyphs(d, g, i, a, o);
}, aB = function(e, t) {
  var n = t.xAdvance, i = t.attributes, a = i.font, o = i.fontSize, s = i.color, c = i.opacity;
  if (e.fillColor(s), e.fillOpacity(c), a.sbix || a.COLR && a.CPAL) {
    e.save(), e.translate(0, -t.ascent);
    for (var h = 0; h < t.glyphs.length; h += 1) {
      var d = t.positions[h], g = t.glyphs[h];
      e.save(), e.translate(d.xOffset, d.yOffset), g.render(e, o), e.restore(), e.translate(d.xAdvance, d.yAdvance);
    }
    e.restore();
  } else {
    e.font(typeof a.name == "string" ? a.name : a, o);
    try {
      X7(e, t.glyphs, t.positions, 0, 0);
    } catch (x) {
      console.log(x);
    }
  }
  e.translate(n, 0);
}, oB = function(e, t, n, i) {
  var a, o, s, c, h;
  e.save();
  var d = ((a = t.box) === null || a === void 0 ? void 0 : a.x) || 0, g = ((o = t.box) === null || o === void 0 ? void 0 : o.y) || 0, x = (s = t.runs[0]) === null || s === void 0 ? void 0 : s.attributes.font, _ = ((c = t.runs[0]) === null || c === void 0 || (h = c.attributes) === null || h === void 0 ? void 0 : h.scale) || 1, k = t.xAdvance, P = x.ascent * _, N = x.xHeight * _, M = x.descent * _, G = x.capHeight * _, z = d, j = g;
  switch (n) {
    case "middle":
      z = d - k / 2;
      break;
    case "end":
      z = d - k;
      break;
    default:
      z = d;
      break;
  }
  switch (i) {
    case "middle":
    case "central":
      j = g + G / 2;
      break;
    case "hanging":
      j = g + G;
      break;
    case "mathematical":
      j = g + N;
      break;
    case "text-after-edge":
      j = g + M;
      break;
    case "text-before-edge":
      j = g + P;
      break;
    default:
      j = g;
      break;
  }
  e.translate(z, j), t.runs.forEach(function(R) {
    return aB(e, R);
  }), e.restore();
}, sB = function(e, t) {
  t.children.forEach(function(n) {
    return oB(e, n.lines[0], n.props.textAnchor, n.props.dominantBaseline);
  });
}, uB = function(e) {
  for (var t = [], n = 0; n < e.length; n += 2)
    t.push([e[n], e[n + 1]]);
  return t;
}, K7 = function(e) {
  var t = (e || "").trim().replace(/,/g, " ").replace(/(\d)-(\d)/g, "$1 -$2").split(/\s+/);
  return t.length % 2 !== 0 && (t = t.slice(0, -1)), t = t.map(parseFloat), uB(t);
}, lB = function(e, t) {
  t.length > 0 && (e.moveTo(t[0][0], t[0][1]), t.slice(1).forEach(function(n) {
    return e.lineTo(n[0], n[1]);
  }));
}, J7 = function(e, t) {
  var n = K7(t.props.points || "");
  lB(e, n);
}, cB = function(e, t) {
  J7(e, t), e.closePath();
}, fB = function(e, t) {
  if (t.image.data) {
    var n = t.props, i = n.x, a = n.y, o = t.style, s = o.width, c = o.height, h = o.opacity, d = t.box.paddingLeft || 0, g = t.box.paddingLeft || 0;
    if (s === 0 || c === 0) {
      console.warn("Image with src '" + t.props.href + "' skipped due to invalid dimensions");
      return;
    }
    e.save(), e.fillOpacity(h || 1).image(t.image.data, i + g, a + d, {
      width: s,
      height: c
    }), e.restore();
  }
}, B2 = 4 * ((Math.sqrt(2) - 1) / 3), Jd = function(e, t) {
  if (t.style) {
    var n = t.box, i = n.top, a = n.left, o = n.width, s = n.height, c = t.style, h = c.borderTopLeftRadius, d = h === void 0 ? 0 : h, g = c.borderTopRightRadius, x = g === void 0 ? 0 : g, _ = c.borderBottomRightRadius, k = _ === void 0 ? 0 : _, P = c.borderBottomLeftRadius, N = P === void 0 ? 0 : P, M = Math.min(x, 0.5 * o, 0.5 * s), G = M * (1 - B2);
    e.moveTo(a + M, i), e.lineTo(a + o - M, i), e.bezierCurveTo(a + o - G, i, a + o, i + G, a + o, i + M);
    var z = Math.min(k, 0.5 * o, 0.5 * s), j = z * (1 - B2);
    e.lineTo(a + o, i + s - z), e.bezierCurveTo(a + o, i + s - j, a + o - j, i + s, a + o - z, i + s);
    var R = Math.min(N, 0.5 * o, 0.5 * s), te = R * (1 - B2);
    e.lineTo(a + R, i + s), e.bezierCurveTo(a + te, i + s, a, i + s - te, a, i + s - R);
    var J = Math.min(d, 0.5 * o, 0.5 * s), K = J * (1 - B2);
    e.lineTo(a, i + J), e.bezierCurveTo(a, i + K, a + K, i, a + J, i), e.closePath(), e.clip();
  }
}, hB = function(e, t, n) {
  var i = t.operation, a = t.value;
  switch (i) {
    case "scale": {
      var o = a[0], s = a[1];
      e.scale(o, s, {
        origin: n
      });
      break;
    }
    case "rotate": {
      var c = a[0];
      e.rotate(c, {
        origin: n
      });
      break;
    }
    case "translate": {
      var h = a[0], d = a[1], g = d === void 0 ? 0 : d;
      e.translate(h, g, {
        origin: n
      });
      break;
    }
    case "skew": {
      var x = a[0], _ = a[1];
      e.skew(x, _, {
        origin: n
      });
      break;
    }
    case "matrix": {
      e.transform.apply(e, a);
      break;
    }
    default:
      console.error("Transform operation: '" + i + "' doesn't supported");
  }
}, Q7 = function(e, t) {
  var n, i;
  if (t.origin) {
    var a = [t.origin.left, t.origin.top], o = ((n = t.style) === null || n === void 0 ? void 0 : n.transform) || ((i = t.props) === null || i === void 0 ? void 0 : i.transform) || [];
    o.forEach(function(s) {
      hB(e, s, a);
    });
  }
}, Lo, dB = function(e) {
  var t, n = VP(PP($P(((t = e.props) === null || t === void 0 ? void 0 : t.d) || "")));
  if (!n.length) return [0, 0, 0, 0];
  for (var i = [1 / 0, 1 / 0, -1 / 0, -1 / 0], a = 0, o = n.length; a < o; a += 1)
    for (var s = n[a].slice(1), c = 0; c < s.length; c += 2)
      s[c + 0] < i[0] && (i[0] = s[c + 0]), s[c + 1] < i[1] && (i[1] = s[c + 1]), s[c + 0] > i[2] && (i[2] = s[c + 0]), s[c + 1] > i[3] && (i[3] = s[c + 1]);
  return i;
}, pB = function(e) {
  var t, n, i, a = ((t = e.props) === null || t === void 0 ? void 0 : t.r) || 0, o = ((n = e.props) === null || n === void 0 ? void 0 : n.cx) || 0, s = ((i = e.props) === null || i === void 0 ? void 0 : i.cy) || 0;
  return [o - a, s - a, o + a, s + a];
}, vB = function(e) {
  var t, n, i, a, o = ((t = e.props) === null || t === void 0 ? void 0 : t.cx) || 0, s = ((n = e.props) === null || n === void 0 ? void 0 : n.cy) || 0, c = ((i = e.props) === null || i === void 0 ? void 0 : i.rx) || 0, h = ((a = e.props) === null || a === void 0 ? void 0 : a.ry) || 0;
  return [o - c, s - h, o + c, s + h];
}, gB = function(e) {
  var t, n, i, a, o = ((t = e.props) === null || t === void 0 ? void 0 : t.x1) || 0, s = ((n = e.props) === null || n === void 0 ? void 0 : n.y1) || 0, c = ((i = e.props) === null || i === void 0 ? void 0 : i.x2) || 0, h = ((a = e.props) === null || a === void 0 ? void 0 : a.y2) || 0;
  return [Math.min(o, c), Math.min(s, h), Math.max(o, c), Math.max(s, h)];
}, mB = function(e) {
  var t, n, i, a, o = ((t = e.props) === null || t === void 0 ? void 0 : t.x) || 0, s = ((n = e.props) === null || n === void 0 ? void 0 : n.y) || 0, c = ((i = e.props) === null || i === void 0 ? void 0 : i.width) || 0, h = ((a = e.props) === null || a === void 0 ? void 0 : a.height) || 0;
  return [o, s, o + c, s + h];
}, vy = function(e) {
  return Math.max.apply(Math, [-1 / 0].concat(e));
}, gy = function(e) {
  return Math.min.apply(Math, [1 / 0].concat(e));
}, my = function(e) {
  var t, n = K7(((t = e.props) === null || t === void 0 ? void 0 : t.points) || []), i = n.map(function(o) {
    return o[0];
  }), a = n.map(function(o) {
    return o[1];
  });
  return [gy(i), gy(a), vy(i), vy(a)];
}, yB = (Lo = {}, Lo[sv] = mB, Lo[uv] = gB, Lo[ov] = dB, Lo[fv] = pB, Lo[hv] = vB, Lo[dv] = my, Lo[vv] = my, Lo), e9 = function(e) {
  var t = yB[e.type];
  return t ? t(e) : [0, 0, 0, 0];
}, oi, bB = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.strokeWidth) || 0;
  i && e.lineWidth(i);
}, wB = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.stroke) || null;
  i && e.strokeColor(i);
}, AB = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.opacity) || null;
  zr(i) || e.opacity(i);
}, xB = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.fillOpacity) || null;
  zr(i) || e.fillOpacity(i);
}, EB = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.strokeOpacity) || null;
  zr(i) || e.strokeOpacity(i);
}, _B = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.strokeLinejoin) || null;
  i && e.lineJoin(i);
}, DB = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.strokeLinecap) || null;
  i && e.lineCap(i);
}, TB = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.strokeDasharray) || null;
  i && e.dash(i.split(","));
}, kB = function(e) {
  var t, n;
  return ((t = e.props) === null || t === void 0 || (n = t.fill) === null || n === void 0 ? void 0 : n.type) === Rw;
}, SB = function(e) {
  var t, n;
  return ((t = e.props) === null || t === void 0 || (n = t.fill) === null || n === void 0 ? void 0 : n.type) === Iw;
}, CB = function(e, t) {
  var n, i = e9(t), a = ((n = t.props) === null || n === void 0 ? void 0 : n.fill) || null, o = a.props.x1 || 0, s = a.props.y1 || 0, c = a.props.x2 || 1, h = a.props.y2 || 0, d = i[2] - i[0], g = i[3] - i[1], x = i[0], _ = i[1], k = d * o + x, P = g * s + _, N = d * c + x, M = g * h + _, G = e.linearGradient(k, P, N, M);
  a.children.forEach(function(z) {
    G.stop(z.props.offset, z.props.stopColor, z.props.stopOpacity);
  }), e.fill(G);
}, FB = function(e, t) {
  var n, i = e9(t), a = ((n = t.props) === null || n === void 0 ? void 0 : n.fill) || null, o = a.props.cx || 0.5, s = a.props.cy || 0.5, c = a.props.fx || o, h = a.props.fy || s, d = a.props.r || 0.5, g = i[2] - i[0], x = i[3] - i[1], _ = i[0], k = i[1], P = d * g, N = g * o + _, M = x * s + k, G = g * c + _, z = x * h + k, j = e.radialGradient(G, z, 0, N, M, P);
  a.children.forEach(function(R) {
    j.stop(R.props.offset, R.props.stopColor, R.props.stopOpacity);
  }), e.fill(j);
}, OB = function(e, t) {
  var n, i = ((n = t.props) === null || n === void 0 ? void 0 : n.fill) || null;
  i && e.fillColor(i);
}, RB = function(e, t) {
  return kB(t) ? CB(e, t) : SB(t) ? FB(e, t) : OB(e, t);
}, IB = function(e, t) {
  var n = t.props || {};
  n.fill && n.stroke ? e.fillAndStroke(n.fillRule) : n.fill ? e.fill(n.fillRule) : n.stroke ? e.stroke() : (e.save(), e.opacity(0), e.fill(null), e.restore());
}, yy = function() {
}, by = (oi = {}, oi[cv] = yy, oi[fu] = yy, oi[ov] = QP, oi[sv] = eB, oi[uv] = tB, oi[Ow] = rB, oi[Gt] = sB, oi[fv] = iB, oi[cu] = fB, oi[hv] = nB, oi[dv] = cB, oi[vv] = J7, oi), t9 = function(e, t) {
  var n = by[t.type];
  by ? n(e, t) : console.warn("SVG node of type " + t.type + " is not currenty supported");
}, PB = function(e, t) {
  DB(e, t), TB(e, t), _B(e, t), bB(e, t), wB(e, t), RB(e, t), EB(e, t), xB(e, t), AB(e, t), Q7(e, t), t9(e, t), IB(e, t);
}, BB = function(e, t) {
  var n, i = (n = t.props) === null || n === void 0 ? void 0 : n.clipPath;
  if (i) {
    var a = i.children || [];
    a.forEach(function(o) {
      return t9(e, o);
    }), e.clip();
  }
}, NB = function r(e, t) {
  var n = t.children || [];
  n.forEach(function(i) {
    e.save(), BB(e, i), PB(e, i), r(e, i), e.restore();
  });
}, LB = function(e, t) {
  var n = t.box, i = n.width, a = n.height, o = t.props, s = o.viewBox, c = o.preserveAspectRatio, h = c === void 0 ? {} : c, d = h.meetOrSlice, g = d === void 0 ? "meet" : d, x = h.align, _ = x === void 0 ? "xMidYMid" : x;
  if (!(s == null || i == null || a == null)) {
    var k = (s == null ? void 0 : s.minX) || 0, P = (s == null ? void 0 : s.minY) || 0, N = (s == null ? void 0 : s.maxX) || i, M = (s == null ? void 0 : s.maxY) || a, G = N / M, z = i / a, j = i / N, R = a / M;
    if (_ === "none") {
      e.scale(j, R), e.translate(-k, -P);
      return;
    }
    if (G < z && g === "meet" || G >= z && g === "slice")
      switch (e.scale(R, R), _) {
        case "xMinYMin":
        case "xMinYMid":
        case "xMinYMax":
          e.translate(-k, -P);
          break;
        case "xMidYMin":
        case "xMidYMid":
        case "xMidYMax":
          e.translate(-k - (N - i * M / a) / 2, -P);
          break;
        default:
          e.translate(-k - (N - i * M / a), -P);
      }
    else
      switch (e.scale(j, j), _) {
        case "xMinYMin":
        case "xMidYMin":
        case "xMaxYMin":
          e.translate(-k, -P);
          break;
        case "xMinYMid":
        case "xMidYMid":
        case "xMaxYMid":
          e.translate(-k, -P - (M - a * N / i) / 2);
          break;
        default:
          e.translate(-k, -P - (M - a * N / i));
      }
  }
}, MB = function(e, t) {
  var n = t.box, i = n.top, a = n.left, o = t.box.paddingLeft || 0, s = t.box.paddingTop || 0;
  e.translate(a + o, i + s);
}, UB = function(e, t) {
  e.save(), Jd(e, t), MB(e, t), LB(e, t), NB(e, t), e.restore();
}, Bv = function(e) {
  var t = w1.get(e), n = w1.to.hex(t.value.slice(0, 3)), i = t.value[3];
  return {
    value: n,
    opacity: i
  };
}, $B = /^#.+/, zB = function(e) {
  return e.match($B);
}, jB = function(e, t) {
  var n = t.xOffset, i = n === void 0 ? 0 : n, a = t.yOffset, o = a === void 0 ? 0 : a, s = t.width, c = t.height, h = t.image;
  e.translate(-s + i, -c + o), e.image(h, 0, 0, {
    fit: [s, c],
    align: "center",
    valign: "bottom"
  });
}, WB = function(e, t) {
  e.save();
  for (var n = t.attributes.font, i = n.glyphForCodePoint(32), a = n.glyphForCodePoint(65532), o = 0, s = 0; s < t.glyphs.length; s += 1) {
    var c = t.positions[s], h = t.glyphs[s];
    o += c.xAdvance || 0, h.id === a.id && t.attributes.attachment && (e.translate(o, c.yOffset || 0), jB(e, t.attributes.attachment), t.glyphs[s] = i, o = 0);
  }
  e.restore();
}, GB = function(e, t, n) {
  var i = t.attributes, a = i.font, o = i.fontSize, s = i.link, c = Bv(t.attributes.color), h = zr(t.attributes.opacity) ? c.opacity : t.attributes.opacity, d = t.height, g = t.descent, x = t.xAdvance;
  if (n.outlineRuns && e.rect(0, -d, x, d).stroke(), e.fillColor(c.value), e.fillOpacity(h), s && (zB(s) ? e.goTo(0, -d - g, x, d, s.slice(1)) : e.link(0, -d - g, x, d, s)), WB(e, t), a.sbix || a.COLR && a.CPAL) {
    e.save(), e.translate(0, -t.ascent);
    for (var _ = 0; _ < t.glyphs.length; _ += 1) {
      var k = t.positions[_], P = t.glyphs[_];
      e.save(), e.translate(k.xOffset, k.yOffset), P.render(e, o), e.restore(), e.translate(k.xAdvance, k.yAdvance);
    }
    e.restore();
  } else {
    e.font(typeof a.name == "string" ? a.name : a, o);
    try {
      X7(e, t.glyphs, t.positions, 0, 0);
    } catch (N) {
      console.log(N);
    }
  }
  e.translate(x, 0);
}, VB = function(e, t, n) {
  var i = Bv(n);
  e.save(), e.fillOpacity(i.opacity), e.rect(t.x, t.y, t.width, t.height), e.fill(i.value), e.restore();
}, YB = function(e, t) {
  if (e.save(), e.lineWidth(t.rect.height), e.strokeOpacity(t.opacity), /dashed/.test(t.style) ? e.dash(3 * t.rect.height) : /dotted/.test(t.style) && e.dash(t.rect.height), /wavy/.test(t.style)) {
    var n = Math.max(2, t.rect.height), i = 1.1 * n, a = Math.floor(t.rect.width / (2 * i)), o = t.rect.width - a * 2 * i, s = o / a / 2;
    i += s;
    var c = t.rect.y + n, h = t.rect.y - n, d = t.rect.x;
    e.moveTo(t.rect.x, t.rect.y);
    for (var g = 0; g < a; g += 1)
      e.bezierCurveTo(d + i, c, d + i, h, d + 2 * i, t.rect.y), d += 2 * i;
  } else
    e.moveTo(t.rect.x, t.rect.y), e.lineTo(t.rect.x + t.rect.width, t.rect.y), /double/.test(t.style) && (e.moveTo(t.rect.x, t.rect.y + t.rect.height * 2), e.lineTo(t.rect.x + t.rect.width, t.rect.y + t.rect.height * 2));
  e.stroke(t.color), e.restore();
}, HB = function(e, t, n) {
  var i = t.ascent;
  n.outlineLines && e.rect(t.box.x, t.box.y, t.box.width, t.box.height).stroke(), e.save(), e.translate(t.box.x, t.box.y + i);
  for (var a = 0; a < t.runs.length; a += 1) {
    var o = t.runs[a], s = a === t.runs.length - 1;
    if (o.attributes.backgroundColor) {
      var c = s ? t.overflowRight : 0, h = {
        x: 0,
        y: -i,
        height: t.box.height,
        width: o.xAdvance - c
      };
      VB(e, h, o.attributes.backgroundColor);
    }
    GB(e, o, n);
  }
  e.restore(), e.save(), e.translate(t.box.x, t.box.y);
  for (var d = 0; d < t.decorationLines.length; d += 1) {
    var g = t.decorationLines[d];
    YB(e, g);
  }
  e.restore();
}, ZB = function(e, t, n) {
  t.forEach(function(i) {
    HB(e, i, n);
  });
}, qB = function(e, t) {
  var n, i, a = t.box, o = a.top, s = a.left, c = [t.lines], h = ((n = t.box) === null || n === void 0 ? void 0 : n.paddingTop) || 0, d = ((i = t.box) === null || i === void 0 ? void 0 : i.paddingLeft) || 0, g = t.lines[0] ? t.lines[0].box.y : 0, x = t.alignOffset || 0;
  e.save(), e.translate(s + d - x, o + h - g), c.forEach(function(_) {
    ZB(e, _, {});
  }), e.restore();
}, XB = function(e, t) {
  var n, i = t.box, a = i.width, o = i.height, s = ((n = t.props) === null || n === void 0 ? void 0 : n.dpi) || 72, c = s / 72;
  e.addPage({
    size: [a, o],
    margin: 0,
    userUnit: c
  });
}, KB = function(e, t) {
  var n, i, a, o = t.box, s = o.top, c = o.left, h = (t == null || (n = t.children) === null || n === void 0 ? void 0 : n[0].value) || "", d = ((i = t.style) === null || i === void 0 ? void 0 : i.backgroundColor) || null, g = ((a = t.style) === null || a === void 0 ? void 0 : a.borderWidth) || null;
  e.note(c, s, 0, 0, h, {
    color: d,
    borderWidth: g
  });
}, ho = function(e) {
  return !Number.isNaN(parseFloat(e)) && Number.isFinite(e);
}, r9 = function(e, t, n, i, a, o) {
  var s = e / t, c = n / i, h = ln(a), d = ln(o), g = h ? h.percent : 0.5, x = d ? d.percent : 0.5;
  if (s > c) {
    var _ = t, k = _ * c, P = ho(o) ? o : 0, N = ho(a) ? a : (e - k) * g;
    return {
      width: k,
      height: _,
      xOffset: N,
      yOffset: P
    };
  }
  var M = e, G = M / c, z = ho(a) ? a : 0, j = ho(o) ? o : (t - G) * x;
  return {
    width: M,
    height: G,
    yOffset: j,
    xOffset: z
  };
}, n9 = function(e, t, n, i, a, o) {
  var s = n, c = i, h = ln(a), d = ln(o), g = h ? h.percent : 0.5, x = d ? d.percent : 0.5, _ = ho(a) ? a : (e - s) * g, k = ho(o) ? o : (t - c) * x;
  return {
    width: s,
    height: c,
    xOffset: _,
    yOffset: k
  };
}, JB = function(e, t, n, i, a, o) {
  var s = n / i, c = e / t, h = ln(a), d = ln(o), g = h ? h.percent : 0.5, x = d ? d.percent : 0.5;
  if (c > s) {
    var _ = e, k = _ / s, P = ho(a) ? a : 0, N = ho(o) ? o : (t - k) * x;
    return {
      width: _,
      height: k,
      yOffset: N,
      xOffset: P
    };
  }
  var M = t, G = M * s, z = ho(a) ? a : (e - G) * g, j = ho(o) ? o : 0;
  return {
    width: G,
    height: M,
    xOffset: z,
    yOffset: j
  };
}, QB = function(e, t, n, i, a, o) {
  var s = r9(e, t, n, i, a, o), c = n9(e, t, n, i, a, o);
  return s.width < c.width ? s : c;
}, eN = function(e, t, n, i) {
  return {
    width: e,
    height: t,
    xOffset: ln(n) ? 0 : n || 0,
    yOffset: ln(i) ? 0 : i || 0
  };
}, tN = function(e, t, n, i, a, o, s) {
  switch (e === void 0 && (e = "fill"), e) {
    case "contain":
      return r9(t, n, i, a, o, s);
    case "cover":
      return JB(t, n, i, a, o, s);
    case "none":
      return n9(t, n, i, a, o, s);
    case "scale-down":
      return QB(t, n, i, a, o, s);
    default:
      return eN(t, n, o, s);
  }
}, rN = function(e, t, n) {
  var i, a, o, s;
  n === void 0 && (n = {});
  var c = t.box, h = c.left, d = c.top, g = (i = t.style) === null || i === void 0 ? void 0 : i.opacity, x = (a = t.style) === null || a === void 0 ? void 0 : a.objectFit, _ = (o = t.style) === null || o === void 0 ? void 0 : o.objectPositionX, k = (s = t.style) === null || s === void 0 ? void 0 : s.objectPositionY, P = t.box.paddingTop || 0, N = t.box.paddingRight || 0, M = t.box.paddingBottom || 0, G = t.box.paddingLeft || 0, z = n.imageCache || /* @__PURE__ */ new Map(), j = tN(x, t.box.width - G - N, t.box.height - P - M, t.image.width, t.image.height, _, k), R = j.width, te = j.height, J = j.xOffset, K = j.yOffset;
  if (t.image.data)
    if (R !== 0 && te !== 0) {
      var ee = t.image.key, ve = z.get(ee) || e.embedImage(t.image.data);
      ee && z.set(ee, ve);
      var de = zr(g) ? 1 : g;
      e.fillOpacity(de).image(ve, h + G + J, d + P + K, {
        width: R,
        height: te
      });
    } else
      console.warn("Image with src '" + JSON.stringify(t.props.src) + "' skipped due to invalid dimensions");
}, nN = function(e, t, n) {
  e.save(), Jd(e, t), rN(e, t, n), e.restore();
}, iN = "#a1c6e7", aN = "#c4deb9", oN = "#f8cca1", sN = function(e, t) {
  var n = t.box, i = n.left, a = n.top, o = n.width, s = n.height, c = n.paddingLeft, h = c === void 0 ? 0 : c, d = n.paddingTop, g = d === void 0 ? 0 : d, x = n.paddingRight, _ = x === void 0 ? 0 : x, k = n.paddingBottom, P = k === void 0 ? 0 : k, N = n.borderLeftWidth, M = N === void 0 ? 0 : N, G = n.borderTopWidth, z = G === void 0 ? 0 : G, j = n.borderRightWidth, R = j === void 0 ? 0 : j, te = n.borderBottomWidth, J = te === void 0 ? 0 : te;
  e.fillColor(iN).opacity(0.5).rect(i + h + M, a + g + z, o - h - _ - R - M, s - g - P - z - J).fill();
}, uN = function(e, t) {
  var n = t.box, i = n.left, a = n.top, o = n.width, s = n.height, c = n.paddingLeft, h = c === void 0 ? 0 : c, d = n.paddingTop, g = d === void 0 ? 0 : d, x = n.paddingRight, _ = x === void 0 ? 0 : x, k = n.paddingBottom, P = k === void 0 ? 0 : k, N = n.borderLeftWidth, M = N === void 0 ? 0 : N, G = n.borderTopWidth, z = G === void 0 ? 0 : G, j = n.borderRightWidth, R = j === void 0 ? 0 : j, te = n.borderBottomWidth, J = te === void 0 ? 0 : te;
  e.fillColor(aN).opacity(0.5), e.rect(i + h + M, a + z, o - _ - h - M - R, g).fill(), e.rect(i + M, a + z, h, s - z - J).fill(), e.rect(i + o - _ - R, a + z, _, s - z - J).fill(), e.rect(i + h + M, a + s - P - J, o - _ - h - M - R, P).fill();
}, i9 = function(e) {
  var t = e.marginLeft === "auto" ? 0 : e.marginLeft, n = e.marginTop === "auto" ? 0 : e.marginTop, i = e.marginRight === "auto" ? 0 : e.marginRight, a = e.marginBottom === "auto" ? 0 : e.marginBottom;
  return {
    marginLeft: t,
    marginTop: n,
    marginRight: i,
    marginBottom: a
  };
}, lN = function(e, t) {
  var n = t.box, i = n.left, a = n.top, o = n.width, s = n.height, c = i9(t.box), h = c.marginLeft, d = h === void 0 ? 0 : h, g = c.marginTop, x = g === void 0 ? 0 : g, _ = c.marginRight, k = _ === void 0 ? 0 : _, P = c.marginBottom, N = P === void 0 ? 0 : P;
  e.fillColor(oN).opacity(0.5), e.rect(i, a - x, o, x).fill(), e.rect(i - d, a - x, d, s + x + N).fill(), e.rect(i + o, a - x, k, s + x + N).fill(), e.rect(i, a + s, o, N).fill();
}, cN = function(e, t) {
  var n = t.box, i = n.left, a = n.top, o = n.width, s = n.height, c = i9(t.box), h = c.marginLeft, d = h === void 0 ? 0 : h, g = c.marginTop, x = g === void 0 ? 0 : g, _ = c.marginRight, k = _ === void 0 ? 0 : _, P = c.marginBottom, N = P === void 0 ? 0 : P, M = Math.round(o + d + k), G = Math.round(s + x + N);
  e.fontSize(6).opacity(1).fillColor("black").text(M + " x " + G, i - d, Math.max(a - x - 4, 1));
}, fN = function(e, t) {
  t.origin && e.circle(t.origin.left, t.origin.top, 3).fill("red").circle(t.origin.left, t.origin.top, 5).stroke("red");
}, hN = function(e, t) {
  var n;
  (n = t.props) !== null && n !== void 0 && n.debug && (e.save(), sN(e, t), uN(e, t), lN(e, t), cN(e, t), fN(e, t), e.restore());
}, dN = ["dash", "clip", "save", "path", "fill", "font", "text", "rect", "scale", "moveTo", "lineTo", "stroke", "rotate", "circle", "lineCap", "opacity", "ellipse", "polygon", "restore", "lineJoin", "fontSize", "fillColor", "lineWidth", "translate", "miterLimit", "strokeColor", "fillOpacity", "roundedRect", "fillAndStroke", "strokeOpacity", "bezierCurveTo", "quadraticCurveTo", "linearGradient", "radialGradient"], pN = function(e) {
  var t = dN.reduce(function(n, i) {
    var a;
    return $r({}, n, (a = {}, a[i] = function() {
      return e[i].apply(e, arguments), t;
    }, a));
  }, {});
  return t;
}, vN = function(e, t) {
  var n = t.box, i = n.top, a = n.left, o = n.width, s = n.height, c = t.box.paddingTop || 0, h = t.box.paddingLeft || 0, d = t.box.paddingRight || 0, g = t.box.paddingBottom || 0, x = o - h - d, _ = s - c - g;
  (!x || !_) && console.warn("Canvas element has null width or height. Please provide valid values via the `style` prop in order to correctly render it."), e.save().translate(a + h, i + c), t.props.paint && t.props.paint(pN(e), x, _), e.restore();
}, Br = 4 * ((Math.sqrt(2) - 1) / 3), gN = function(e, t, n, i, a) {
  var o = t.top, s = t.left, c = t.width, h = t.height, d = n.borderTopWidth, g = n.borderRightWidth, x = n.borderLeftWidth;
  e.moveTo(s + a, o), e.lineTo(s + c - i, o);
  var _ = i * (1 - Br);
  e.bezierCurveTo(s + c - _, o, s + c, o + _, s + c, o + i);
  var k = o + Math.max(d, i);
  e.lineTo(s + c, k), e.lineTo(s + c - g, k);
  var P = Math.max(i - g, 0), N = Math.max(i - d, 0), M = P * (1 - Br), G = N * (1 - Br);
  e.bezierCurveTo(s + c - g, o + d + G, s + c - g - M, o + d, s + c - g - P, o + d), e.lineTo(s + Math.max(a, x), o + d);
  var z = Math.max(a - x, 0), j = Math.max(a - d, 0), R = z * (1 - Br), te = j * (1 - Br), J = o + Math.max(d, a);
  e.bezierCurveTo(s + x + R, o + d, s + x, o + d + te, s + x, J), e.lineTo(s, J), e.lineTo(s, o + a);
  var K = a * (1 - Br);
  if (e.bezierCurveTo(s, o + K, s + K, o, s + a, o), e.closePath(), e.clip(), g) {
    var ee = -d / g;
    e.moveTo(s + c / 2, ee * (-c / 2) + o), e.lineTo(s + c, o), e.lineTo(s, o), e.lineTo(s, o + h), e.closePath(), e.clip();
  }
  if (x) {
    var ve = -d / x;
    e.moveTo(s + c / 2, ve * (-c / 2) + o), e.lineTo(s, o), e.lineTo(s + c, o), e.lineTo(s + c, o + h), e.closePath(), e.clip();
  }
}, mN = function(e, t, n, i, a) {
  var o = t.top, s = t.left, c = t.width, h = n.borderTopColor, d = n.borderTopWidth, g = n.borderTopStyle, x = n.borderRightWidth, _ = n.borderLeftWidth, k = a * (1 - Br), P = i * (1 - Br);
  e.moveTo(s, o + Math.max(a, d)), e.bezierCurveTo(s, o + k, s + k, o, s + a, o), e.lineTo(s + c - i, o), e.bezierCurveTo(s + c - P, o, s + c, o + P, s + c, o + i), e.strokeColor(h), e.lineWidth(Math.max(x, d, _) * 2), g === "dashed" ? e.dash(d * 2, {
    space: d * 1.2
  }) : g === "dotted" && e.dash(d, {
    space: d * 1.2
  }), e.stroke(), e.undash();
}, yN = function(e, t, n, i, a) {
  var o = t.top, s = t.left, c = t.width, h = t.height, d = n.borderTopWidth, g = n.borderRightWidth, x = n.borderBottomWidth;
  e.moveTo(s + c, o + i), e.lineTo(s + c, o + h - a);
  var _ = a * (1 - Br);
  e.bezierCurveTo(s + c, o + h - _, s + c - _, o + h, s + c - a, o + h);
  var k = s + c - Math.max(g, a);
  e.lineTo(k, o + h), e.lineTo(k, o + h - x);
  var P = Math.max(a - g, 0), N = Math.max(a - x, 0), M = P * (1 - Br), G = N * (1 - Br);
  e.bezierCurveTo(s + c - g - M, o + h - x, s + c - g, o + h - x - G, s + c - g, o + h - Math.max(a, x)), e.lineTo(s + c - g, o + Math.max(i, d));
  var z = Math.max(i - g, 0), j = Math.max(i - d, 0), R = z * (1 - Br), te = j * (1 - Br), J = s + c - Math.max(i, g);
  e.bezierCurveTo(s + c - g, o + d + te, s + c - g - R, o + d, J, o + d), e.lineTo(J, o), e.lineTo(s + c - i, o);
  var K = i * (1 - Br);
  if (e.bezierCurveTo(s + c - K, o, s + c, o + K, s + c, o + i), e.closePath(), e.clip(), d) {
    var ee = -d / g;
    e.moveTo(s + c / 2, ee * (-c / 2) + o), e.lineTo(s + c, o), e.lineTo(s + c, o + h), e.lineTo(s, o + h), e.closePath(), e.clip();
  }
  if (x) {
    var ve = x / g;
    e.moveTo(s + c / 2, ve * (-c / 2) + o + h), e.lineTo(s + c, o + h), e.lineTo(s + c, o), e.lineTo(s, o), e.closePath(), e.clip();
  }
}, bN = function(e, t, n, i, a) {
  var o = t.top, s = t.left, c = t.width, h = t.height, d = n.borderRightColor, g = n.borderRightStyle, x = n.borderRightWidth, _ = n.borderTopWidth, k = n.borderBottomWidth, P = a * (1 - Br), N = i * (1 - Br);
  e.moveTo(s + c - i, o), e.bezierCurveTo(s + c - N, o, s + c, o + N, s + c, o + i), e.lineTo(s + c, o + h - a), e.bezierCurveTo(s + c, o + h - P, s + c - P, o + h, s + c - a, o + h), e.strokeColor(d), e.lineWidth(Math.max(x, _, k) * 2), g === "dashed" ? e.dash(x * 2, {
    space: x * 1.2
  }) : g === "dotted" && e.dash(x, {
    space: x * 1.2
  }), e.stroke(), e.undash();
}, wN = function(e, t, n, i, a) {
  var o = t.top, s = t.left, c = t.width, h = t.height, d = n.borderBottomWidth, g = n.borderRightWidth, x = n.borderLeftWidth;
  e.moveTo(s + c - a, o + h), e.lineTo(s + i, o + h);
  var _ = i * (1 - Br);
  e.bezierCurveTo(s + _, o + h, s, o + h - _, s, o + h - i);
  var k = o + h - Math.max(d, i);
  e.lineTo(s, k), e.lineTo(s + x, k);
  var P = Math.max(i - x, 0), N = Math.max(i - d, 0), M = P * (1 - Br), G = N * (1 - Br);
  e.bezierCurveTo(s + x, o + h - d - G, s + x + M, o + h - d, s + x + P, o + h - d), e.lineTo(s + c - Math.max(a, g), o + h - d);
  var z = Math.max(a - g, 0), j = Math.max(a - d, 0), R = z * (1 - Br), te = j * (1 - Br), J = o + h - Math.max(d, a);
  e.bezierCurveTo(s + c - g - R, o + h - d, s + c - g, o + h - d - te, s + c - g, J), e.lineTo(s + c, J), e.lineTo(s + c, o + h - a);
  var K = a * (1 - Br);
  if (e.bezierCurveTo(s + c, o + h - K, s + c - K, o + h, s + c - a, o + h), e.closePath(), e.clip(), g) {
    var ee = d / g;
    e.moveTo(s + c / 2, ee * (-c / 2) + o + h), e.lineTo(s + c, o + h), e.lineTo(s, o + h), e.lineTo(s, o), e.closePath(), e.clip();
  }
  if (x) {
    var ve = -d / x;
    e.moveTo(s + c / 2, ve * (c / 2) + o + h), e.lineTo(s, o + h), e.lineTo(s + c, o + h), e.lineTo(s + c, o), e.closePath(), e.clip();
  }
}, AN = function(e, t, n, i, a) {
  var o = t.top, s = t.left, c = t.width, h = t.height, d = n.borderBottomColor, g = n.borderBottomStyle, x = n.borderBottomWidth, _ = n.borderRightWidth, k = n.borderLeftWidth, P = i * (1 - Br), N = a * (1 - Br);
  e.moveTo(s + c, o + h - a), e.bezierCurveTo(s + c, o + h - N, s + c - N, o + h, s + c - a, o + h), e.lineTo(s + i, o + h), e.bezierCurveTo(s + P, o + h, s, o + h - P, s, o + h - i), e.strokeColor(d), e.lineWidth(Math.max(x, _, k) * 2), g === "dashed" ? e.dash(x * 2, {
    space: x * 1.2
  }) : g === "dotted" && e.dash(x, {
    space: x * 1.2
  }), e.stroke(), e.undash();
}, xN = function(e, t, n, i, a) {
  var o = t.top, s = t.left, c = t.width, h = t.height, d = n.borderTopWidth, g = n.borderLeftWidth, x = n.borderBottomWidth;
  e.moveTo(s, o + h - i), e.lineTo(s, o + a);
  var _ = a * (1 - Br);
  e.bezierCurveTo(s, o + _, s + _, o, s + a, o);
  var k = s + Math.max(g, a);
  e.lineTo(k, o), e.lineTo(k, o + d);
  var P = Math.max(a - g, 0), N = Math.max(a - d, 0), M = P * (1 - Br), G = N * (1 - Br);
  e.bezierCurveTo(s + g + M, o + d, s + g, o + d + G, s + g, o + Math.max(a, d)), e.lineTo(s + g, o + h - Math.max(i, x));
  var z = Math.max(i - g, 0), j = Math.max(i - x, 0), R = z * (1 - Br), te = j * (1 - Br), J = s + Math.max(i, g);
  e.bezierCurveTo(s + g, o + h - x - te, s + g + R, o + h - x, J, o + h - x), e.lineTo(J, o + h), e.lineTo(s + i, o + h);
  var K = i * (1 - Br);
  if (e.bezierCurveTo(s + K, o + h, s, o + h - K, s, o + h - i), e.closePath(), e.clip(), x) {
    var ee = -x / g;
    e.moveTo(s + c / 2, ee * (c / 2) + o + h), e.lineTo(s, o + h), e.lineTo(s, o), e.lineTo(s + c, o), e.closePath(), e.clip();
  }
  if (x) {
    var ve = -d / g;
    e.moveTo(s + c / 2, ve * (-c / 2) + o), e.lineTo(s, o), e.lineTo(s, o + h), e.lineTo(s + c, o + h), e.closePath(), e.clip();
  }
}, EN = function(e, t, n, i, a) {
  var o = t.top, s = t.left, c = t.height, h = n.borderLeftColor, d = n.borderLeftStyle, g = n.borderLeftWidth, x = n.borderTopWidth, _ = n.borderBottomWidth, k = i * (1 - Br), P = a * (1 - Br);
  e.moveTo(s + i, o + c), e.bezierCurveTo(s + k, o + c, s, o + c - k, s, o + c - i), e.lineTo(s, o + a), e.bezierCurveTo(s, o + P, s + P, o, s + a, o), e.strokeColor(h), e.lineWidth(Math.max(g, x, _) * 2), d === "dashed" ? e.dash(g * 2, {
    space: g * 1.2
  }) : d === "dotted" && e.dash(g, {
    space: g * 1.2
  }), e.stroke(), e.undash();
}, _N = function(e) {
  return e.box && (e.box.borderTopWidth || e.box.borderRightWidth || e.box.borderBottomWidth || e.box.borderLeftWidth);
}, DN = function(e, t) {
  if (_N(t)) {
    var n = t.box, i = n.width, a = n.height, o = n.borderTopWidth, s = n.borderLeftWidth, c = n.borderRightWidth, h = n.borderBottomWidth, d = t.style, g = d.opacity, x = d.borderTopLeftRadius, _ = x === void 0 ? 0 : x, k = d.borderTopRightRadius, P = k === void 0 ? 0 : k, N = d.borderBottomLeftRadius, M = N === void 0 ? 0 : N, G = d.borderBottomRightRadius, z = G === void 0 ? 0 : G, j = d.borderTopColor, R = j === void 0 ? "black" : j, te = d.borderTopStyle, J = te === void 0 ? "solid" : te, K = d.borderLeftColor, ee = K === void 0 ? "black" : K, ve = d.borderLeftStyle, de = ve === void 0 ? "solid" : ve, B = d.borderRightColor, q = B === void 0 ? "black" : B, H = d.borderRightStyle, oe = H === void 0 ? "solid" : H, ne = d.borderBottomColor, me = ne === void 0 ? "black" : ne, fe = d.borderBottomStyle, _e = fe === void 0 ? "solid" : fe, Re = {
      borderTopColor: R,
      borderTopWidth: o,
      borderTopStyle: J,
      borderLeftColor: ee,
      borderLeftWidth: s,
      borderLeftStyle: de,
      borderRightColor: q,
      borderRightWidth: c,
      borderRightStyle: oe,
      borderBottomColor: me,
      borderBottomWidth: h,
      borderBottomStyle: _e,
      borderTopLeftRadius: _,
      borderTopRightRadius: P,
      borderBottomLeftRadius: M,
      borderBottomRightRadius: z
    }, Ie = Math.min(P, 0.5 * i, 0.5 * a), W = Math.min(_, 0.5 * i, 0.5 * a), Z = Math.min(z, 0.5 * i, 0.5 * a), se = Math.min(M, 0.5 * i, 0.5 * a);
    e.save(), e.strokeOpacity(g), o && (e.save(), gN(e, t.box, Re, Ie, W), mN(e, t.box, Re, Ie, W), e.restore()), c && (e.save(), yN(e, t.box, Re, Ie, Z), bN(e, t.box, Re, Ie, Z), e.restore()), h && (e.save(), wN(e, t.box, Re, se, Z), AN(e, t.box, Re, se, Z), e.restore()), s && (e.save(), xN(e, t.box, Re, se, W), EN(e, t.box, Re, se, W), e.restore()), e.restore();
  }
}, TN = function(e, t) {
  var n, i = t.box, a = i.top, o = i.left, s = i.width, c = i.height, h = Bv(t.style.backgroundColor), d = zr((n = t.style) === null || n === void 0 ? void 0 : n.opacity) ? 1 : t.style.opacity, g = Math.min(h.opacity, d);
  e.fillOpacity(g).fillColor(h.value).rect(o, a, s, c).fill();
}, kN = function(e, t) {
  var n, i = !!t.box && !!((n = t.style) !== null && n !== void 0 && n.backgroundColor);
  i && (e.save(), Jd(e, t), TN(e, t), e.restore());
}, SN = function(e) {
  return /^#.+/.test(e);
}, CN = function(e, t) {
  var n = t.props || {}, i = t.box, a = i.top, o = i.left, s = i.width, c = i.height, h = n.src || n.href;
  if (h) {
    var d = SN(h), g = d ? "goTo" : "link", x = d ? h.slice(1) : h;
    e[g](o, a, s, c, x);
  }
}, FN = function(e, t) {
  var n;
  (n = t.props) !== null && n !== void 0 && n.id && e.addNamedDestination(t.props.id, "XYZ", null, t.box.top, null);
}, _s, ON = function(e) {
  return e.type !== Gt && e.type !== ts;
}, RN = function(e, t, n) {
  e.save(), t.box && e.translate(t.box.left, t.box.top);
  var i = t.children || [], a = function(s) {
    return a9(e, s, n);
  };
  i.forEach(a), e.restore();
}, IN = (_s = {}, _s[Gt] = qB, _s[Nd] = KB, _s[cu] = nN, _s[Ld] = vN, _s[ts] = UB, _s[Pd] = CN, _s), a9 = function(e, t, n) {
  var i, a = ((i = t.style) === null || i === void 0 ? void 0 : i.overflow) === "hidden", o = ON(t);
  t.type === Bd && XB(e, t), e.save(), a && Jd(e, t), Q7(e, t), kN(e, t), DN(e, t);
  var s = IN[t.type];
  s && s(e, t, n), o && RN(e, t, n), FN(e, t), hN(e, t), e.restore();
}, PN = function(e) {
  return function(t, n) {
    n && (e.info[t] = n);
  };
}, BN = function(e, t) {
  var n, i, a = PN(e), o = t.props || {}, s = o.title || null, c = o.author || null, h = o.subject || null, d = o.keywords || null, g = (n = o.creator) != null ? n : "react-pdf", x = (i = o.producer) != null ? i : "react-pdf";
  a("Title", s), a("Author", c), a("Subject", h), a("Keywords", d), a("Creator", g), a("Producer", x);
}, NN = function r(e, t, n, i) {
  var a, o = (a = t.props) === null || a === void 0 ? void 0 : a.bookmark;
  if (o) {
    var s = o.title, c = o.parent, h = o.expanded, d = o.zoom, g = o.fit, x = i[c] || e.outline, _ = o.top || t.box.top, k = o.left || t.box.left, P = x.addItem(s, {
      pageNumber: n,
      expanded: h,
      top: _,
      left: k,
      zoom: d,
      fit: g
    });
    i[o.ref] = P;
  }
  t.children && t.children.forEach(function(N) {
    return r(e, N, n, i);
  });
}, LN = function(e, t) {
  var n = {}, i = t.children || [];
  i.forEach(function(a, o) {
    NN(e, a, o, n);
  });
}, MN = function(e, t) {
  var n = t.children || [], i = {
    imageCache: /* @__PURE__ */ new Map()
  };
  return BN(e, t), n.forEach(function(a) {
    return a9(e, a, i);
  }), LN(e, t), e.end(), e;
};
function UN() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var $N = UN;
const zN = /* @__PURE__ */ I0($N);
var xo = {}, Z1 = {};
(function(r) {
  var e = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
  function t(a, o) {
    return Object.prototype.hasOwnProperty.call(a, o);
  }
  r.assign = function(a) {
    for (var o = Array.prototype.slice.call(arguments, 1); o.length; ) {
      var s = o.shift();
      if (s) {
        if (typeof s != "object")
          throw new TypeError(s + "must be non-object");
        for (var c in s)
          t(s, c) && (a[c] = s[c]);
      }
    }
    return a;
  }, r.shrinkBuf = function(a, o) {
    return a.length === o ? a : a.subarray ? a.subarray(0, o) : (a.length = o, a);
  };
  var n = {
    arraySet: function(a, o, s, c, h) {
      if (o.subarray && a.subarray) {
        a.set(o.subarray(s, s + c), h);
        return;
      }
      for (var d = 0; d < c; d++)
        a[h + d] = o[s + d];
    },
    // Join array of chunks to single array.
    flattenChunks: function(a) {
      var o, s, c, h, d, g;
      for (c = 0, o = 0, s = a.length; o < s; o++)
        c += a[o].length;
      for (g = new Uint8Array(c), h = 0, o = 0, s = a.length; o < s; o++)
        d = a[o], g.set(d, h), h += d.length;
      return g;
    }
  }, i = {
    arraySet: function(a, o, s, c, h) {
      for (var d = 0; d < c; d++)
        a[h + d] = o[s + d];
    },
    // Join array of chunks to single array.
    flattenChunks: function(a) {
      return [].concat.apply([], a);
    }
  };
  r.setTyped = function(a) {
    a ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, n)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, i));
  }, r.setTyped(e);
})(Z1);
var tf = {}, jN = Z1, WN = 4, wy = 0, Ay = 1, GN = 2;
function rf(r) {
  for (var e = r.length; --e >= 0; )
    r[e] = 0;
}
var VN = 0, o9 = 1, YN = 2, HN = 3, ZN = 258, Nv = 29, q1 = 256, A1 = q1 + 1 + Nv, kc = 30, Lv = 19, s9 = 2 * A1 + 1, Xu = 15, dp = 16, qN = 7, Mv = 256, u9 = 16, l9 = 17, c9 = 18, u3 = (
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
), xh = (
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
), XN = (
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
), f9 = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], KN = 512, Vo = new Array((A1 + 2) * 2);
rf(Vo);
var o1 = new Array(kc * 2);
rf(o1);
var x1 = new Array(KN);
rf(x1);
var E1 = new Array(ZN - HN + 1);
rf(E1);
var Uv = new Array(Nv);
rf(Uv);
var gd = new Array(kc);
rf(gd);
function pp(r, e, t, n, i) {
  this.static_tree = r, this.extra_bits = e, this.extra_base = t, this.elems = n, this.max_length = i, this.has_stree = r && r.length;
}
var h9, d9, p9;
function vp(r, e) {
  this.dyn_tree = r, this.max_code = 0, this.stat_desc = e;
}
function v9(r) {
  return r < 256 ? x1[r] : x1[256 + (r >>> 7)];
}
function _1(r, e) {
  r.pending_buf[r.pending++] = e & 255, r.pending_buf[r.pending++] = e >>> 8 & 255;
}
function li(r, e, t) {
  r.bi_valid > dp - t ? (r.bi_buf |= e << r.bi_valid & 65535, _1(r, r.bi_buf), r.bi_buf = e >> dp - r.bi_valid, r.bi_valid += t - dp) : (r.bi_buf |= e << r.bi_valid & 65535, r.bi_valid += t);
}
function ro(r, e, t) {
  li(
    r,
    t[e * 2],
    t[e * 2 + 1]
    /*.Len*/
  );
}
function g9(r, e) {
  var t = 0;
  do
    t |= r & 1, r >>>= 1, t <<= 1;
  while (--e > 0);
  return t >>> 1;
}
function JN(r) {
  r.bi_valid === 16 ? (_1(r, r.bi_buf), r.bi_buf = 0, r.bi_valid = 0) : r.bi_valid >= 8 && (r.pending_buf[r.pending++] = r.bi_buf & 255, r.bi_buf >>= 8, r.bi_valid -= 8);
}
function QN(r, e) {
  var t = e.dyn_tree, n = e.max_code, i = e.stat_desc.static_tree, a = e.stat_desc.has_stree, o = e.stat_desc.extra_bits, s = e.stat_desc.extra_base, c = e.stat_desc.max_length, h, d, g, x, _, k, P = 0;
  for (x = 0; x <= Xu; x++)
    r.bl_count[x] = 0;
  for (t[r.heap[r.heap_max] * 2 + 1] = 0, h = r.heap_max + 1; h < s9; h++)
    d = r.heap[h], x = t[t[d * 2 + 1] * 2 + 1] + 1, x > c && (x = c, P++), t[d * 2 + 1] = x, !(d > n) && (r.bl_count[x]++, _ = 0, d >= s && (_ = o[d - s]), k = t[d * 2], r.opt_len += k * (x + _), a && (r.static_len += k * (i[d * 2 + 1] + _)));
  if (P !== 0) {
    do {
      for (x = c - 1; r.bl_count[x] === 0; )
        x--;
      r.bl_count[x]--, r.bl_count[x + 1] += 2, r.bl_count[c]--, P -= 2;
    } while (P > 0);
    for (x = c; x !== 0; x--)
      for (d = r.bl_count[x]; d !== 0; )
        g = r.heap[--h], !(g > n) && (t[g * 2 + 1] !== x && (r.opt_len += (x - t[g * 2 + 1]) * t[g * 2], t[g * 2 + 1] = x), d--);
  }
}
function m9(r, e, t) {
  var n = new Array(Xu + 1), i = 0, a, o;
  for (a = 1; a <= Xu; a++)
    n[a] = i = i + t[a - 1] << 1;
  for (o = 0; o <= e; o++) {
    var s = r[o * 2 + 1];
    s !== 0 && (r[o * 2] = g9(n[s]++, s));
  }
}
function eL() {
  var r, e, t, n, i, a = new Array(Xu + 1);
  for (t = 0, n = 0; n < Nv - 1; n++)
    for (Uv[n] = t, r = 0; r < 1 << u3[n]; r++)
      E1[t++] = n;
  for (E1[t - 1] = n, i = 0, n = 0; n < 16; n++)
    for (gd[n] = i, r = 0; r < 1 << xh[n]; r++)
      x1[i++] = n;
  for (i >>= 7; n < kc; n++)
    for (gd[n] = i << 7, r = 0; r < 1 << xh[n] - 7; r++)
      x1[256 + i++] = n;
  for (e = 0; e <= Xu; e++)
    a[e] = 0;
  for (r = 0; r <= 143; )
    Vo[r * 2 + 1] = 8, r++, a[8]++;
  for (; r <= 255; )
    Vo[r * 2 + 1] = 9, r++, a[9]++;
  for (; r <= 279; )
    Vo[r * 2 + 1] = 7, r++, a[7]++;
  for (; r <= 287; )
    Vo[r * 2 + 1] = 8, r++, a[8]++;
  for (m9(Vo, A1 + 1, a), r = 0; r < kc; r++)
    o1[r * 2 + 1] = 5, o1[r * 2] = g9(r, 5);
  h9 = new pp(Vo, u3, q1 + 1, A1, Xu), d9 = new pp(o1, xh, 0, kc, Xu), p9 = new pp(new Array(0), XN, 0, Lv, qN);
}
function y9(r) {
  var e;
  for (e = 0; e < A1; e++)
    r.dyn_ltree[e * 2] = 0;
  for (e = 0; e < kc; e++)
    r.dyn_dtree[e * 2] = 0;
  for (e = 0; e < Lv; e++)
    r.bl_tree[e * 2] = 0;
  r.dyn_ltree[Mv * 2] = 1, r.opt_len = r.static_len = 0, r.last_lit = r.matches = 0;
}
function b9(r) {
  r.bi_valid > 8 ? _1(r, r.bi_buf) : r.bi_valid > 0 && (r.pending_buf[r.pending++] = r.bi_buf), r.bi_buf = 0, r.bi_valid = 0;
}
function tL(r, e, t, n) {
  b9(r), _1(r, t), _1(r, ~t), jN.arraySet(r.pending_buf, r.window, e, t, r.pending), r.pending += t;
}
function xy(r, e, t, n) {
  var i = e * 2, a = t * 2;
  return r[i] < r[a] || r[i] === r[a] && n[e] <= n[t];
}
function gp(r, e, t) {
  for (var n = r.heap[t], i = t << 1; i <= r.heap_len && (i < r.heap_len && xy(e, r.heap[i + 1], r.heap[i], r.depth) && i++, !xy(e, n, r.heap[i], r.depth)); )
    r.heap[t] = r.heap[i], t = i, i <<= 1;
  r.heap[t] = n;
}
function Ey(r, e, t) {
  var n, i, a = 0, o, s;
  if (r.last_lit !== 0)
    do
      n = r.pending_buf[r.d_buf + a * 2] << 8 | r.pending_buf[r.d_buf + a * 2 + 1], i = r.pending_buf[r.l_buf + a], a++, n === 0 ? ro(r, i, e) : (o = E1[i], ro(r, o + q1 + 1, e), s = u3[o], s !== 0 && (i -= Uv[o], li(r, i, s)), n--, o = v9(n), ro(r, o, t), s = xh[o], s !== 0 && (n -= gd[o], li(r, n, s)));
    while (a < r.last_lit);
  ro(r, Mv, e);
}
function l3(r, e) {
  var t = e.dyn_tree, n = e.stat_desc.static_tree, i = e.stat_desc.has_stree, a = e.stat_desc.elems, o, s, c = -1, h;
  for (r.heap_len = 0, r.heap_max = s9, o = 0; o < a; o++)
    t[o * 2] !== 0 ? (r.heap[++r.heap_len] = c = o, r.depth[o] = 0) : t[o * 2 + 1] = 0;
  for (; r.heap_len < 2; )
    h = r.heap[++r.heap_len] = c < 2 ? ++c : 0, t[h * 2] = 1, r.depth[h] = 0, r.opt_len--, i && (r.static_len -= n[h * 2 + 1]);
  for (e.max_code = c, o = r.heap_len >> 1; o >= 1; o--)
    gp(r, t, o);
  h = a;
  do
    o = r.heap[
      1
      /*SMALLEST*/
    ], r.heap[
      1
      /*SMALLEST*/
    ] = r.heap[r.heap_len--], gp(
      r,
      t,
      1
      /*SMALLEST*/
    ), s = r.heap[
      1
      /*SMALLEST*/
    ], r.heap[--r.heap_max] = o, r.heap[--r.heap_max] = s, t[h * 2] = t[o * 2] + t[s * 2], r.depth[h] = (r.depth[o] >= r.depth[s] ? r.depth[o] : r.depth[s]) + 1, t[o * 2 + 1] = t[s * 2 + 1] = h, r.heap[
      1
      /*SMALLEST*/
    ] = h++, gp(
      r,
      t,
      1
      /*SMALLEST*/
    );
  while (r.heap_len >= 2);
  r.heap[--r.heap_max] = r.heap[
    1
    /*SMALLEST*/
  ], QN(r, e), m9(t, c, r.bl_count);
}
function _y(r, e, t) {
  var n, i = -1, a, o = e[0 * 2 + 1], s = 0, c = 7, h = 4;
  for (o === 0 && (c = 138, h = 3), e[(t + 1) * 2 + 1] = 65535, n = 0; n <= t; n++)
    a = o, o = e[(n + 1) * 2 + 1], !(++s < c && a === o) && (s < h ? r.bl_tree[a * 2] += s : a !== 0 ? (a !== i && r.bl_tree[a * 2]++, r.bl_tree[u9 * 2]++) : s <= 10 ? r.bl_tree[l9 * 2]++ : r.bl_tree[c9 * 2]++, s = 0, i = a, o === 0 ? (c = 138, h = 3) : a === o ? (c = 6, h = 3) : (c = 7, h = 4));
}
function Dy(r, e, t) {
  var n, i = -1, a, o = e[0 * 2 + 1], s = 0, c = 7, h = 4;
  for (o === 0 && (c = 138, h = 3), n = 0; n <= t; n++)
    if (a = o, o = e[(n + 1) * 2 + 1], !(++s < c && a === o)) {
      if (s < h)
        do
          ro(r, a, r.bl_tree);
        while (--s !== 0);
      else a !== 0 ? (a !== i && (ro(r, a, r.bl_tree), s--), ro(r, u9, r.bl_tree), li(r, s - 3, 2)) : s <= 10 ? (ro(r, l9, r.bl_tree), li(r, s - 3, 3)) : (ro(r, c9, r.bl_tree), li(r, s - 11, 7));
      s = 0, i = a, o === 0 ? (c = 138, h = 3) : a === o ? (c = 6, h = 3) : (c = 7, h = 4);
    }
}
function rL(r) {
  var e;
  for (_y(r, r.dyn_ltree, r.l_desc.max_code), _y(r, r.dyn_dtree, r.d_desc.max_code), l3(r, r.bl_desc), e = Lv - 1; e >= 3 && r.bl_tree[f9[e] * 2 + 1] === 0; e--)
    ;
  return r.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
}
function nL(r, e, t, n) {
  var i;
  for (li(r, e - 257, 5), li(r, t - 1, 5), li(r, n - 4, 4), i = 0; i < n; i++)
    li(r, r.bl_tree[f9[i] * 2 + 1], 3);
  Dy(r, r.dyn_ltree, e - 1), Dy(r, r.dyn_dtree, t - 1);
}
function iL(r) {
  var e = 4093624447, t;
  for (t = 0; t <= 31; t++, e >>>= 1)
    if (e & 1 && r.dyn_ltree[t * 2] !== 0)
      return wy;
  if (r.dyn_ltree[9 * 2] !== 0 || r.dyn_ltree[10 * 2] !== 0 || r.dyn_ltree[13 * 2] !== 0)
    return Ay;
  for (t = 32; t < q1; t++)
    if (r.dyn_ltree[t * 2] !== 0)
      return Ay;
  return wy;
}
var Ty = !1;
function aL(r) {
  Ty || (eL(), Ty = !0), r.l_desc = new vp(r.dyn_ltree, h9), r.d_desc = new vp(r.dyn_dtree, d9), r.bl_desc = new vp(r.bl_tree, p9), r.bi_buf = 0, r.bi_valid = 0, y9(r);
}
function w9(r, e, t, n) {
  li(r, (VN << 1) + (n ? 1 : 0), 3), tL(r, e, t);
}
function oL(r) {
  li(r, o9 << 1, 3), ro(r, Mv, Vo), JN(r);
}
function sL(r, e, t, n) {
  var i, a, o = 0;
  r.level > 0 ? (r.strm.data_type === GN && (r.strm.data_type = iL(r)), l3(r, r.l_desc), l3(r, r.d_desc), o = rL(r), i = r.opt_len + 3 + 7 >>> 3, a = r.static_len + 3 + 7 >>> 3, a <= i && (i = a)) : i = a = t + 5, t + 4 <= i && e !== -1 ? w9(r, e, t, n) : r.strategy === WN || a === i ? (li(r, (o9 << 1) + (n ? 1 : 0), 3), Ey(r, Vo, o1)) : (li(r, (YN << 1) + (n ? 1 : 0), 3), nL(r, r.l_desc.max_code + 1, r.d_desc.max_code + 1, o + 1), Ey(r, r.dyn_ltree, r.dyn_dtree)), y9(r), n && b9(r);
}
function uL(r, e, t) {
  return r.pending_buf[r.d_buf + r.last_lit * 2] = e >>> 8 & 255, r.pending_buf[r.d_buf + r.last_lit * 2 + 1] = e & 255, r.pending_buf[r.l_buf + r.last_lit] = t & 255, r.last_lit++, e === 0 ? r.dyn_ltree[t * 2]++ : (r.matches++, e--, r.dyn_ltree[(E1[t] + q1 + 1) * 2]++, r.dyn_dtree[v9(e) * 2]++), r.last_lit === r.lit_bufsize - 1;
}
tf._tr_init = aL;
tf._tr_stored_block = w9;
tf._tr_flush_block = sL;
tf._tr_tally = uL;
tf._tr_align = oL;
function lL(r, e, t, n) {
  for (var i = r & 65535 | 0, a = r >>> 16 & 65535 | 0, o = 0; t !== 0; ) {
    o = t > 2e3 ? 2e3 : t, t -= o;
    do
      i = i + e[n++] | 0, a = a + i | 0;
    while (--o);
    i %= 65521, a %= 65521;
  }
  return i | a << 16 | 0;
}
var A9 = lL;
function cL() {
  for (var r, e = [], t = 0; t < 256; t++) {
    r = t;
    for (var n = 0; n < 8; n++)
      r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
    e[t] = r;
  }
  return e;
}
var fL = cL();
function hL(r, e, t, n) {
  var i = fL, a = n + t;
  r ^= -1;
  for (var o = n; o < a; o++)
    r = r >>> 8 ^ i[(r ^ e[o]) & 255];
  return r ^ -1;
}
var x9 = hL, dL = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, qn = Z1, na = tf, E9 = A9, ks = x9, pL = dL, Dl = 0, vL = 1, gL = 3, Qs = 4, ky = 5, no = 0, Sy = 1, ia = -2, mL = -3, mp = -5, yL = -1, bL = 1, N2 = 2, wL = 3, AL = 4, xL = 0, EL = 2, Qd = 8, _L = 9, DL = 15, TL = 8, kL = 29, SL = 256, c3 = SL + 1 + kL, CL = 30, FL = 19, OL = 2 * c3 + 1, RL = 15, mr = 3, Vs = 258, Da = Vs + mr + 1, IL = 32, e5 = 42, f3 = 69, Eh = 73, _h = 91, Dh = 103, Ku = 113, Zf = 666, nn = 1, X1 = 2, pl = 3, nf = 4, PL = 3;
function Ys(r, e) {
  return r.msg = pL[e], e;
}
function Cy(r) {
  return (r << 1) - (r > 4 ? 9 : 0);
}
function Us(r) {
  for (var e = r.length; --e >= 0; )
    r[e] = 0;
}
function Ss(r) {
  var e = r.state, t = e.pending;
  t > r.avail_out && (t = r.avail_out), t !== 0 && (qn.arraySet(r.output, e.pending_buf, e.pending_out, t, r.next_out), r.next_out += t, e.pending_out += t, r.total_out += t, r.avail_out -= t, e.pending -= t, e.pending === 0 && (e.pending_out = 0));
}
function Dn(r, e) {
  na._tr_flush_block(r, r.block_start >= 0 ? r.block_start : -1, r.strstart - r.block_start, e), r.block_start = r.strstart, Ss(r.strm);
}
function Ir(r, e) {
  r.pending_buf[r.pending++] = e;
}
function Wf(r, e) {
  r.pending_buf[r.pending++] = e >>> 8 & 255, r.pending_buf[r.pending++] = e & 255;
}
function BL(r, e, t, n) {
  var i = r.avail_in;
  return i > n && (i = n), i === 0 ? 0 : (r.avail_in -= i, qn.arraySet(e, r.input, r.next_in, i, t), r.state.wrap === 1 ? r.adler = E9(r.adler, e, i, t) : r.state.wrap === 2 && (r.adler = ks(r.adler, e, i, t)), r.next_in += i, r.total_in += i, i);
}
function _9(r, e) {
  var t = r.max_chain_length, n = r.strstart, i, a, o = r.prev_length, s = r.nice_match, c = r.strstart > r.w_size - Da ? r.strstart - (r.w_size - Da) : 0, h = r.window, d = r.w_mask, g = r.prev, x = r.strstart + Vs, _ = h[n + o - 1], k = h[n + o];
  r.prev_length >= r.good_match && (t >>= 2), s > r.lookahead && (s = r.lookahead);
  do
    if (i = e, !(h[i + o] !== k || h[i + o - 1] !== _ || h[i] !== h[n] || h[++i] !== h[n + 1])) {
      n += 2, i++;
      do
        ;
      while (h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && n < x);
      if (a = Vs - (x - n), n = x - Vs, a > o) {
        if (r.match_start = e, o = a, a >= s)
          break;
        _ = h[n + o - 1], k = h[n + o];
      }
    }
  while ((e = g[e & d]) > c && --t !== 0);
  return o <= r.lookahead ? o : r.lookahead;
}
function vl(r) {
  var e = r.w_size, t, n, i, a, o;
  do {
    if (a = r.window_size - r.lookahead - r.strstart, r.strstart >= e + (e - Da)) {
      qn.arraySet(r.window, r.window, e, e, 0), r.match_start -= e, r.strstart -= e, r.block_start -= e, n = r.hash_size, t = n;
      do
        i = r.head[--t], r.head[t] = i >= e ? i - e : 0;
      while (--n);
      n = e, t = n;
      do
        i = r.prev[--t], r.prev[t] = i >= e ? i - e : 0;
      while (--n);
      a += e;
    }
    if (r.strm.avail_in === 0)
      break;
    if (n = BL(r.strm, r.window, r.strstart + r.lookahead, a), r.lookahead += n, r.lookahead + r.insert >= mr)
      for (o = r.strstart - r.insert, r.ins_h = r.window[o], r.ins_h = (r.ins_h << r.hash_shift ^ r.window[o + 1]) & r.hash_mask; r.insert && (r.ins_h = (r.ins_h << r.hash_shift ^ r.window[o + mr - 1]) & r.hash_mask, r.prev[o & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = o, o++, r.insert--, !(r.lookahead + r.insert < mr)); )
        ;
  } while (r.lookahead < Da && r.strm.avail_in !== 0);
}
function NL(r, e) {
  var t = 65535;
  for (t > r.pending_buf_size - 5 && (t = r.pending_buf_size - 5); ; ) {
    if (r.lookahead <= 1) {
      if (vl(r), r.lookahead === 0 && e === Dl)
        return nn;
      if (r.lookahead === 0)
        break;
    }
    r.strstart += r.lookahead, r.lookahead = 0;
    var n = r.block_start + t;
    if ((r.strstart === 0 || r.strstart >= n) && (r.lookahead = r.strstart - n, r.strstart = n, Dn(r, !1), r.strm.avail_out === 0) || r.strstart - r.block_start >= r.w_size - Da && (Dn(r, !1), r.strm.avail_out === 0))
      return nn;
  }
  return r.insert = 0, e === Qs ? (Dn(r, !0), r.strm.avail_out === 0 ? pl : nf) : (r.strstart > r.block_start && (Dn(r, !1), r.strm.avail_out === 0), nn);
}
function yp(r, e) {
  for (var t, n; ; ) {
    if (r.lookahead < Da) {
      if (vl(r), r.lookahead < Da && e === Dl)
        return nn;
      if (r.lookahead === 0)
        break;
    }
    if (t = 0, r.lookahead >= mr && (r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + mr - 1]) & r.hash_mask, t = r.prev[r.strstart & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = r.strstart), t !== 0 && r.strstart - t <= r.w_size - Da && (r.match_length = _9(r, t)), r.match_length >= mr)
      if (n = na._tr_tally(r, r.strstart - r.match_start, r.match_length - mr), r.lookahead -= r.match_length, r.match_length <= r.max_lazy_match && r.lookahead >= mr) {
        r.match_length--;
        do
          r.strstart++, r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + mr - 1]) & r.hash_mask, t = r.prev[r.strstart & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = r.strstart;
        while (--r.match_length !== 0);
        r.strstart++;
      } else
        r.strstart += r.match_length, r.match_length = 0, r.ins_h = r.window[r.strstart], r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + 1]) & r.hash_mask;
    else
      n = na._tr_tally(r, 0, r.window[r.strstart]), r.lookahead--, r.strstart++;
    if (n && (Dn(r, !1), r.strm.avail_out === 0))
      return nn;
  }
  return r.insert = r.strstart < mr - 1 ? r.strstart : mr - 1, e === Qs ? (Dn(r, !0), r.strm.avail_out === 0 ? pl : nf) : r.last_lit && (Dn(r, !1), r.strm.avail_out === 0) ? nn : X1;
}
function tc(r, e) {
  for (var t, n, i; ; ) {
    if (r.lookahead < Da) {
      if (vl(r), r.lookahead < Da && e === Dl)
        return nn;
      if (r.lookahead === 0)
        break;
    }
    if (t = 0, r.lookahead >= mr && (r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + mr - 1]) & r.hash_mask, t = r.prev[r.strstart & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = r.strstart), r.prev_length = r.match_length, r.prev_match = r.match_start, r.match_length = mr - 1, t !== 0 && r.prev_length < r.max_lazy_match && r.strstart - t <= r.w_size - Da && (r.match_length = _9(r, t), r.match_length <= 5 && (r.strategy === bL || r.match_length === mr && r.strstart - r.match_start > 4096) && (r.match_length = mr - 1)), r.prev_length >= mr && r.match_length <= r.prev_length) {
      i = r.strstart + r.lookahead - mr, n = na._tr_tally(r, r.strstart - 1 - r.prev_match, r.prev_length - mr), r.lookahead -= r.prev_length - 1, r.prev_length -= 2;
      do
        ++r.strstart <= i && (r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + mr - 1]) & r.hash_mask, t = r.prev[r.strstart & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = r.strstart);
      while (--r.prev_length !== 0);
      if (r.match_available = 0, r.match_length = mr - 1, r.strstart++, n && (Dn(r, !1), r.strm.avail_out === 0))
        return nn;
    } else if (r.match_available) {
      if (n = na._tr_tally(r, 0, r.window[r.strstart - 1]), n && Dn(r, !1), r.strstart++, r.lookahead--, r.strm.avail_out === 0)
        return nn;
    } else
      r.match_available = 1, r.strstart++, r.lookahead--;
  }
  return r.match_available && (n = na._tr_tally(r, 0, r.window[r.strstart - 1]), r.match_available = 0), r.insert = r.strstart < mr - 1 ? r.strstart : mr - 1, e === Qs ? (Dn(r, !0), r.strm.avail_out === 0 ? pl : nf) : r.last_lit && (Dn(r, !1), r.strm.avail_out === 0) ? nn : X1;
}
function LL(r, e) {
  for (var t, n, i, a, o = r.window; ; ) {
    if (r.lookahead <= Vs) {
      if (vl(r), r.lookahead <= Vs && e === Dl)
        return nn;
      if (r.lookahead === 0)
        break;
    }
    if (r.match_length = 0, r.lookahead >= mr && r.strstart > 0 && (i = r.strstart - 1, n = o[i], n === o[++i] && n === o[++i] && n === o[++i])) {
      a = r.strstart + Vs;
      do
        ;
      while (n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && i < a);
      r.match_length = Vs - (a - i), r.match_length > r.lookahead && (r.match_length = r.lookahead);
    }
    if (r.match_length >= mr ? (t = na._tr_tally(r, 1, r.match_length - mr), r.lookahead -= r.match_length, r.strstart += r.match_length, r.match_length = 0) : (t = na._tr_tally(r, 0, r.window[r.strstart]), r.lookahead--, r.strstart++), t && (Dn(r, !1), r.strm.avail_out === 0))
      return nn;
  }
  return r.insert = 0, e === Qs ? (Dn(r, !0), r.strm.avail_out === 0 ? pl : nf) : r.last_lit && (Dn(r, !1), r.strm.avail_out === 0) ? nn : X1;
}
function ML(r, e) {
  for (var t; ; ) {
    if (r.lookahead === 0 && (vl(r), r.lookahead === 0)) {
      if (e === Dl)
        return nn;
      break;
    }
    if (r.match_length = 0, t = na._tr_tally(r, 0, r.window[r.strstart]), r.lookahead--, r.strstart++, t && (Dn(r, !1), r.strm.avail_out === 0))
      return nn;
  }
  return r.insert = 0, e === Qs ? (Dn(r, !0), r.strm.avail_out === 0 ? pl : nf) : r.last_lit && (Dn(r, !1), r.strm.avail_out === 0) ? nn : X1;
}
function Ya(r, e, t, n, i) {
  this.good_length = r, this.max_lazy = e, this.nice_length = t, this.max_chain = n, this.func = i;
}
var Ac;
Ac = [
  /*      good lazy nice chain */
  new Ya(0, 0, 0, 0, NL),
  /* 0 store only */
  new Ya(4, 4, 8, 4, yp),
  /* 1 max speed, no lazy matches */
  new Ya(4, 5, 16, 8, yp),
  /* 2 */
  new Ya(4, 6, 32, 32, yp),
  /* 3 */
  new Ya(4, 4, 16, 16, tc),
  /* 4 lazy matches */
  new Ya(8, 16, 32, 32, tc),
  /* 5 */
  new Ya(8, 16, 128, 128, tc),
  /* 6 */
  new Ya(8, 32, 128, 256, tc),
  /* 7 */
  new Ya(32, 128, 258, 1024, tc),
  /* 8 */
  new Ya(32, 258, 258, 4096, tc)
  /* 9 max compression */
];
function UL(r) {
  r.window_size = 2 * r.w_size, Us(r.head), r.max_lazy_match = Ac[r.level].max_lazy, r.good_match = Ac[r.level].good_length, r.nice_match = Ac[r.level].nice_length, r.max_chain_length = Ac[r.level].max_chain, r.strstart = 0, r.block_start = 0, r.lookahead = 0, r.insert = 0, r.match_length = r.prev_length = mr - 1, r.match_available = 0, r.ins_h = 0;
}
function $L() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Qd, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new qn.Buf16(OL * 2), this.dyn_dtree = new qn.Buf16((2 * CL + 1) * 2), this.bl_tree = new qn.Buf16((2 * FL + 1) * 2), Us(this.dyn_ltree), Us(this.dyn_dtree), Us(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new qn.Buf16(RL + 1), this.heap = new qn.Buf16(2 * c3 + 1), Us(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new qn.Buf16(2 * c3 + 1), Us(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
function D9(r) {
  var e;
  return !r || !r.state ? Ys(r, ia) : (r.total_in = r.total_out = 0, r.data_type = EL, e = r.state, e.pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? e5 : Ku, r.adler = e.wrap === 2 ? 0 : 1, e.last_flush = Dl, na._tr_init(e), no);
}
function T9(r) {
  var e = D9(r);
  return e === no && UL(r.state), e;
}
function zL(r, e) {
  return !r || !r.state || r.state.wrap !== 2 ? ia : (r.state.gzhead = e, no);
}
function k9(r, e, t, n, i, a) {
  if (!r)
    return ia;
  var o = 1;
  if (e === yL && (e = 6), n < 0 ? (o = 0, n = -n) : n > 15 && (o = 2, n -= 16), i < 1 || i > _L || t !== Qd || n < 8 || n > 15 || e < 0 || e > 9 || a < 0 || a > AL)
    return Ys(r, ia);
  n === 8 && (n = 9);
  var s = new $L();
  return r.state = s, s.strm = r, s.wrap = o, s.gzhead = null, s.w_bits = n, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + mr - 1) / mr), s.window = new qn.Buf8(s.w_size * 2), s.head = new qn.Buf16(s.hash_size), s.prev = new qn.Buf16(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = s.lit_bufsize * 4, s.pending_buf = new qn.Buf8(s.pending_buf_size), s.d_buf = 1 * s.lit_bufsize, s.l_buf = 3 * s.lit_bufsize, s.level = e, s.strategy = a, s.method = t, T9(r);
}
function jL(r, e) {
  return k9(r, e, Qd, DL, TL, xL);
}
function WL(r, e) {
  var t, n, i, a;
  if (!r || !r.state || e > ky || e < 0)
    return r ? Ys(r, ia) : ia;
  if (n = r.state, !r.output || !r.input && r.avail_in !== 0 || n.status === Zf && e !== Qs)
    return Ys(r, r.avail_out === 0 ? mp : ia);
  if (n.strm = r, t = n.last_flush, n.last_flush = e, n.status === e5)
    if (n.wrap === 2)
      r.adler = 0, Ir(n, 31), Ir(n, 139), Ir(n, 8), n.gzhead ? (Ir(
        n,
        (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)
      ), Ir(n, n.gzhead.time & 255), Ir(n, n.gzhead.time >> 8 & 255), Ir(n, n.gzhead.time >> 16 & 255), Ir(n, n.gzhead.time >> 24 & 255), Ir(n, n.level === 9 ? 2 : n.strategy >= N2 || n.level < 2 ? 4 : 0), Ir(n, n.gzhead.os & 255), n.gzhead.extra && n.gzhead.extra.length && (Ir(n, n.gzhead.extra.length & 255), Ir(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (r.adler = ks(r.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = f3) : (Ir(n, 0), Ir(n, 0), Ir(n, 0), Ir(n, 0), Ir(n, 0), Ir(n, n.level === 9 ? 2 : n.strategy >= N2 || n.level < 2 ? 4 : 0), Ir(n, PL), n.status = Ku);
    else {
      var o = Qd + (n.w_bits - 8 << 4) << 8, s = -1;
      n.strategy >= N2 || n.level < 2 ? s = 0 : n.level < 6 ? s = 1 : n.level === 6 ? s = 2 : s = 3, o |= s << 6, n.strstart !== 0 && (o |= IL), o += 31 - o % 31, n.status = Ku, Wf(n, o), n.strstart !== 0 && (Wf(n, r.adler >>> 16), Wf(n, r.adler & 65535)), r.adler = 1;
    }
  if (n.status === f3)
    if (n.gzhead.extra) {
      for (i = n.pending; n.gzindex < (n.gzhead.extra.length & 65535) && !(n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (r.adler = ks(r.adler, n.pending_buf, n.pending - i, i)), Ss(r), i = n.pending, n.pending === n.pending_buf_size)); )
        Ir(n, n.gzhead.extra[n.gzindex] & 255), n.gzindex++;
      n.gzhead.hcrc && n.pending > i && (r.adler = ks(r.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = Eh);
    } else
      n.status = Eh;
  if (n.status === Eh)
    if (n.gzhead.name) {
      i = n.pending;
      do {
        if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (r.adler = ks(r.adler, n.pending_buf, n.pending - i, i)), Ss(r), i = n.pending, n.pending === n.pending_buf_size)) {
          a = 1;
          break;
        }
        n.gzindex < n.gzhead.name.length ? a = n.gzhead.name.charCodeAt(n.gzindex++) & 255 : a = 0, Ir(n, a);
      } while (a !== 0);
      n.gzhead.hcrc && n.pending > i && (r.adler = ks(r.adler, n.pending_buf, n.pending - i, i)), a === 0 && (n.gzindex = 0, n.status = _h);
    } else
      n.status = _h;
  if (n.status === _h)
    if (n.gzhead.comment) {
      i = n.pending;
      do {
        if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (r.adler = ks(r.adler, n.pending_buf, n.pending - i, i)), Ss(r), i = n.pending, n.pending === n.pending_buf_size)) {
          a = 1;
          break;
        }
        n.gzindex < n.gzhead.comment.length ? a = n.gzhead.comment.charCodeAt(n.gzindex++) & 255 : a = 0, Ir(n, a);
      } while (a !== 0);
      n.gzhead.hcrc && n.pending > i && (r.adler = ks(r.adler, n.pending_buf, n.pending - i, i)), a === 0 && (n.status = Dh);
    } else
      n.status = Dh;
  if (n.status === Dh && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && Ss(r), n.pending + 2 <= n.pending_buf_size && (Ir(n, r.adler & 255), Ir(n, r.adler >> 8 & 255), r.adler = 0, n.status = Ku)) : n.status = Ku), n.pending !== 0) {
    if (Ss(r), r.avail_out === 0)
      return n.last_flush = -1, no;
  } else if (r.avail_in === 0 && Cy(e) <= Cy(t) && e !== Qs)
    return Ys(r, mp);
  if (n.status === Zf && r.avail_in !== 0)
    return Ys(r, mp);
  if (r.avail_in !== 0 || n.lookahead !== 0 || e !== Dl && n.status !== Zf) {
    var c = n.strategy === N2 ? ML(n, e) : n.strategy === wL ? LL(n, e) : Ac[n.level].func(n, e);
    if ((c === pl || c === nf) && (n.status = Zf), c === nn || c === pl)
      return r.avail_out === 0 && (n.last_flush = -1), no;
    if (c === X1 && (e === vL ? na._tr_align(n) : e !== ky && (na._tr_stored_block(n, 0, 0, !1), e === gL && (Us(n.head), n.lookahead === 0 && (n.strstart = 0, n.block_start = 0, n.insert = 0))), Ss(r), r.avail_out === 0))
      return n.last_flush = -1, no;
  }
  return e !== Qs ? no : n.wrap <= 0 ? Sy : (n.wrap === 2 ? (Ir(n, r.adler & 255), Ir(n, r.adler >> 8 & 255), Ir(n, r.adler >> 16 & 255), Ir(n, r.adler >> 24 & 255), Ir(n, r.total_in & 255), Ir(n, r.total_in >> 8 & 255), Ir(n, r.total_in >> 16 & 255), Ir(n, r.total_in >> 24 & 255)) : (Wf(n, r.adler >>> 16), Wf(n, r.adler & 65535)), Ss(r), n.wrap > 0 && (n.wrap = -n.wrap), n.pending !== 0 ? no : Sy);
}
function GL(r) {
  var e;
  return !r || !r.state ? ia : (e = r.state.status, e !== e5 && e !== f3 && e !== Eh && e !== _h && e !== Dh && e !== Ku && e !== Zf ? Ys(r, ia) : (r.state = null, e === Ku ? Ys(r, mL) : no));
}
function VL(r, e) {
  var t = e.length, n, i, a, o, s, c, h, d;
  if (!r || !r.state || (n = r.state, o = n.wrap, o === 2 || o === 1 && n.status !== e5 || n.lookahead))
    return ia;
  for (o === 1 && (r.adler = E9(r.adler, e, t, 0)), n.wrap = 0, t >= n.w_size && (o === 0 && (Us(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), d = new qn.Buf8(n.w_size), qn.arraySet(d, e, t - n.w_size, n.w_size, 0), e = d, t = n.w_size), s = r.avail_in, c = r.next_in, h = r.input, r.avail_in = t, r.next_in = 0, r.input = e, vl(n); n.lookahead >= mr; ) {
    i = n.strstart, a = n.lookahead - (mr - 1);
    do
      n.ins_h = (n.ins_h << n.hash_shift ^ n.window[i + mr - 1]) & n.hash_mask, n.prev[i & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = i, i++;
    while (--a);
    n.strstart = i, n.lookahead = mr - 1, vl(n);
  }
  return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = mr - 1, n.match_available = 0, r.next_in = c, r.input = h, r.avail_in = s, n.wrap = o, no;
}
xo.deflateInit = jL;
xo.deflateInit2 = k9;
xo.deflateReset = T9;
xo.deflateResetKeep = D9;
xo.deflateSetHeader = zL;
xo.deflate = WL;
xo.deflateEnd = GL;
xo.deflateSetDictionary = VL;
xo.deflateInfo = "pako deflate (from Nodeca project)";
var Oa = {}, L2 = 30, YL = 12, HL = function(e, t) {
  var n, i, a, o, s, c, h, d, g, x, _, k, P, N, M, G, z, j, R, te, J, K, ee, ve, de;
  n = e.state, i = e.next_in, ve = e.input, a = i + (e.avail_in - 5), o = e.next_out, de = e.output, s = o - (t - e.avail_out), c = o + (e.avail_out - 257), h = n.dmax, d = n.wsize, g = n.whave, x = n.wnext, _ = n.window, k = n.hold, P = n.bits, N = n.lencode, M = n.distcode, G = (1 << n.lenbits) - 1, z = (1 << n.distbits) - 1;
  e:
    do {
      P < 15 && (k += ve[i++] << P, P += 8, k += ve[i++] << P, P += 8), j = N[k & G];
      n:
        for (; ; ) {
          if (R = j >>> 24, k >>>= R, P -= R, R = j >>> 16 & 255, R === 0)
            de[o++] = j & 65535;
          else if (R & 16) {
            te = j & 65535, R &= 15, R && (P < R && (k += ve[i++] << P, P += 8), te += k & (1 << R) - 1, k >>>= R, P -= R), P < 15 && (k += ve[i++] << P, P += 8, k += ve[i++] << P, P += 8), j = M[k & z];
            t:
              for (; ; ) {
                if (R = j >>> 24, k >>>= R, P -= R, R = j >>> 16 & 255, R & 16) {
                  if (J = j & 65535, R &= 15, P < R && (k += ve[i++] << P, P += 8, P < R && (k += ve[i++] << P, P += 8)), J += k & (1 << R) - 1, J > h) {
                    e.msg = "invalid distance too far back", n.mode = L2;
                    break e;
                  }
                  if (k >>>= R, P -= R, R = o - s, J > R) {
                    if (R = J - R, R > g && n.sane) {
                      e.msg = "invalid distance too far back", n.mode = L2;
                      break e;
                    }
                    if (K = 0, ee = _, x === 0) {
                      if (K += d - R, R < te) {
                        te -= R;
                        do
                          de[o++] = _[K++];
                        while (--R);
                        K = o - J, ee = de;
                      }
                    } else if (x < R) {
                      if (K += d + x - R, R -= x, R < te) {
                        te -= R;
                        do
                          de[o++] = _[K++];
                        while (--R);
                        if (K = 0, x < te) {
                          R = x, te -= R;
                          do
                            de[o++] = _[K++];
                          while (--R);
                          K = o - J, ee = de;
                        }
                      }
                    } else if (K += x - R, R < te) {
                      te -= R;
                      do
                        de[o++] = _[K++];
                      while (--R);
                      K = o - J, ee = de;
                    }
                    for (; te > 2; )
                      de[o++] = ee[K++], de[o++] = ee[K++], de[o++] = ee[K++], te -= 3;
                    te && (de[o++] = ee[K++], te > 1 && (de[o++] = ee[K++]));
                  } else {
                    K = o - J;
                    do
                      de[o++] = de[K++], de[o++] = de[K++], de[o++] = de[K++], te -= 3;
                    while (te > 2);
                    te && (de[o++] = de[K++], te > 1 && (de[o++] = de[K++]));
                  }
                } else if (R & 64) {
                  e.msg = "invalid distance code", n.mode = L2;
                  break e;
                } else {
                  j = M[(j & 65535) + (k & (1 << R) - 1)];
                  continue t;
                }
                break;
              }
          } else if (R & 64)
            if (R & 32) {
              n.mode = YL;
              break e;
            } else {
              e.msg = "invalid literal/length code", n.mode = L2;
              break e;
            }
          else {
            j = N[(j & 65535) + (k & (1 << R) - 1)];
            continue n;
          }
          break;
        }
    } while (i < a && o < c);
  te = P >> 3, i -= te, P -= te << 3, k &= (1 << P) - 1, e.next_in = i, e.next_out = o, e.avail_in = i < a ? 5 + (a - i) : 5 - (i - a), e.avail_out = o < c ? 257 + (c - o) : 257 - (o - c), n.hold = k, n.bits = P;
}, Fy = Z1, rc = 15, Oy = 852, Ry = 592, Iy = 0, bp = 1, Py = 2, ZL = [
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
], qL = [
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
], XL = [
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
], KL = [
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
], JL = function(e, t, n, i, a, o, s, c) {
  var h = c.bits, d = 0, g = 0, x = 0, _ = 0, k = 0, P = 0, N = 0, M = 0, G = 0, z = 0, j, R, te, J, K, ee = null, ve = 0, de, B = new Fy.Buf16(rc + 1), q = new Fy.Buf16(rc + 1), H = null, oe = 0, ne, me, fe;
  for (d = 0; d <= rc; d++)
    B[d] = 0;
  for (g = 0; g < i; g++)
    B[t[n + g]]++;
  for (k = h, _ = rc; _ >= 1 && B[_] === 0; _--)
    ;
  if (k > _ && (k = _), _ === 0)
    return a[o++] = 1 << 24 | 64 << 16 | 0, a[o++] = 1 << 24 | 64 << 16 | 0, c.bits = 1, 0;
  for (x = 1; x < _ && B[x] === 0; x++)
    ;
  for (k < x && (k = x), M = 1, d = 1; d <= rc; d++)
    if (M <<= 1, M -= B[d], M < 0)
      return -1;
  if (M > 0 && (e === Iy || _ !== 1))
    return -1;
  for (q[1] = 0, d = 1; d < rc; d++)
    q[d + 1] = q[d] + B[d];
  for (g = 0; g < i; g++)
    t[n + g] !== 0 && (s[q[t[n + g]]++] = g);
  if (e === Iy ? (ee = H = s, de = 19) : e === bp ? (ee = ZL, ve -= 257, H = qL, oe -= 257, de = 256) : (ee = XL, H = KL, de = -1), z = 0, g = 0, d = x, K = o, P = k, N = 0, te = -1, G = 1 << k, J = G - 1, e === bp && G > Oy || e === Py && G > Ry)
    return 1;
  for (; ; ) {
    ne = d - N, s[g] < de ? (me = 0, fe = s[g]) : s[g] > de ? (me = H[oe + s[g]], fe = ee[ve + s[g]]) : (me = 96, fe = 0), j = 1 << d - N, R = 1 << P, x = R;
    do
      R -= j, a[K + (z >> N) + R] = ne << 24 | me << 16 | fe | 0;
    while (R !== 0);
    for (j = 1 << d - 1; z & j; )
      j >>= 1;
    if (j !== 0 ? (z &= j - 1, z += j) : z = 0, g++, --B[d] === 0) {
      if (d === _)
        break;
      d = t[n + s[g]];
    }
    if (d > k && (z & J) !== te) {
      for (N === 0 && (N = k), K += x, P = d - N, M = 1 << P; P + N < _ && (M -= B[P + N], !(M <= 0)); )
        P++, M <<= 1;
      if (G += 1 << P, e === bp && G > Oy || e === Py && G > Ry)
        return 1;
      te = z & J, a[te] = k << 24 | P << 16 | K - o | 0;
    }
  }
  return z !== 0 && (a[K + z] = d - N << 24 | 64 << 16 | 0), c.bits = k, 0;
}, Ci = Z1, h3 = A9, Ha = x9, QL = HL, s1 = JL, eM = 0, S9 = 1, C9 = 2, By = 4, tM = 5, M2 = 6, gl = 0, rM = 1, nM = 2, la = -2, F9 = -3, O9 = -4, iM = -5, Ny = 8, R9 = 1, Ly = 2, My = 3, Uy = 4, $y = 5, zy = 6, jy = 7, Wy = 8, Gy = 9, Vy = 10, md = 11, Mo = 12, wp = 13, Yy = 14, Ap = 15, Hy = 16, Zy = 17, qy = 18, Xy = 19, U2 = 20, $2 = 21, Ky = 22, Jy = 23, Qy = 24, eb = 25, tb = 26, xp = 27, rb = 28, nb = 29, h0 = 30, I9 = 31, aM = 32, oM = 852, sM = 592, uM = 15, lM = uM;
function ib(r) {
  return (r >>> 24 & 255) + (r >>> 8 & 65280) + ((r & 65280) << 8) + ((r & 255) << 24);
}
function cM() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Ci.Buf16(320), this.work = new Ci.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
function P9(r) {
  var e;
  return !r || !r.state ? la : (e = r.state, r.total_in = r.total_out = e.total = 0, r.msg = "", e.wrap && (r.adler = e.wrap & 1), e.mode = R9, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new Ci.Buf32(oM), e.distcode = e.distdyn = new Ci.Buf32(sM), e.sane = 1, e.back = -1, gl);
}
function B9(r) {
  var e;
  return !r || !r.state ? la : (e = r.state, e.wsize = 0, e.whave = 0, e.wnext = 0, P9(r));
}
function N9(r, e) {
  var t, n;
  return !r || !r.state || (n = r.state, e < 0 ? (t = 0, e = -e) : (t = (e >> 4) + 1, e < 48 && (e &= 15)), e && (e < 8 || e > 15)) ? la : (n.window !== null && n.wbits !== e && (n.window = null), n.wrap = t, n.wbits = e, B9(r));
}
function L9(r, e) {
  var t, n;
  return r ? (n = new cM(), r.state = n, n.window = null, t = N9(r, e), t !== gl && (r.state = null), t) : la;
}
function fM(r) {
  return L9(r, lM);
}
var ab = !0, Ep, _p;
function hM(r) {
  if (ab) {
    var e;
    for (Ep = new Ci.Buf32(512), _p = new Ci.Buf32(32), e = 0; e < 144; )
      r.lens[e++] = 8;
    for (; e < 256; )
      r.lens[e++] = 9;
    for (; e < 280; )
      r.lens[e++] = 7;
    for (; e < 288; )
      r.lens[e++] = 8;
    for (s1(S9, r.lens, 0, 288, Ep, 0, r.work, { bits: 9 }), e = 0; e < 32; )
      r.lens[e++] = 5;
    s1(C9, r.lens, 0, 32, _p, 0, r.work, { bits: 5 }), ab = !1;
  }
  r.lencode = Ep, r.lenbits = 9, r.distcode = _p, r.distbits = 5;
}
function M9(r, e, t, n) {
  var i, a = r.state;
  return a.window === null && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new Ci.Buf8(a.wsize)), n >= a.wsize ? (Ci.arraySet(a.window, e, t - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i = a.wsize - a.wnext, i > n && (i = n), Ci.arraySet(a.window, e, t - n, i, a.wnext), n -= i, n ? (Ci.arraySet(a.window, e, t - n, n, 0), a.wnext = n, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
}
function dM(r, e) {
  var t, n, i, a, o, s, c, h, d, g, x, _, k, P, N = 0, M, G, z, j, R, te, J, K, ee = new Ci.Buf8(4), ve, de, B = (
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
  );
  if (!r || !r.state || !r.output || !r.input && r.avail_in !== 0)
    return la;
  t = r.state, t.mode === Mo && (t.mode = wp), o = r.next_out, i = r.output, c = r.avail_out, a = r.next_in, n = r.input, s = r.avail_in, h = t.hold, d = t.bits, g = s, x = c, K = gl;
  e:
    for (; ; )
      switch (t.mode) {
        case R9:
          if (t.wrap === 0) {
            t.mode = wp;
            break;
          }
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (t.wrap & 2 && h === 35615) {
            t.check = 0, ee[0] = h & 255, ee[1] = h >>> 8 & 255, t.check = Ha(t.check, ee, 2, 0), h = 0, d = 0, t.mode = Ly;
            break;
          }
          if (t.flags = 0, t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((h & 255) << 8) + (h >> 8)) % 31) {
            r.msg = "incorrect header check", t.mode = h0;
            break;
          }
          if ((h & 15) !== Ny) {
            r.msg = "unknown compression method", t.mode = h0;
            break;
          }
          if (h >>>= 4, d -= 4, J = (h & 15) + 8, t.wbits === 0)
            t.wbits = J;
          else if (J > t.wbits) {
            r.msg = "invalid window size", t.mode = h0;
            break;
          }
          t.dmax = 1 << J, r.adler = t.check = 1, t.mode = h & 512 ? Vy : Mo, h = 0, d = 0;
          break;
        case Ly:
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (t.flags = h, (t.flags & 255) !== Ny) {
            r.msg = "unknown compression method", t.mode = h0;
            break;
          }
          if (t.flags & 57344) {
            r.msg = "unknown header flags set", t.mode = h0;
            break;
          }
          t.head && (t.head.text = h >> 8 & 1), t.flags & 512 && (ee[0] = h & 255, ee[1] = h >>> 8 & 255, t.check = Ha(t.check, ee, 2, 0)), h = 0, d = 0, t.mode = My;
        case My:
          for (; d < 32; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          t.head && (t.head.time = h), t.flags & 512 && (ee[0] = h & 255, ee[1] = h >>> 8 & 255, ee[2] = h >>> 16 & 255, ee[3] = h >>> 24 & 255, t.check = Ha(t.check, ee, 4, 0)), h = 0, d = 0, t.mode = Uy;
        case Uy:
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          t.head && (t.head.xflags = h & 255, t.head.os = h >> 8), t.flags & 512 && (ee[0] = h & 255, ee[1] = h >>> 8 & 255, t.check = Ha(t.check, ee, 2, 0)), h = 0, d = 0, t.mode = $y;
        case $y:
          if (t.flags & 1024) {
            for (; d < 16; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            t.length = h, t.head && (t.head.extra_len = h), t.flags & 512 && (ee[0] = h & 255, ee[1] = h >>> 8 & 255, t.check = Ha(t.check, ee, 2, 0)), h = 0, d = 0;
          } else t.head && (t.head.extra = null);
          t.mode = zy;
        case zy:
          if (t.flags & 1024 && (_ = t.length, _ > s && (_ = s), _ && (t.head && (J = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Array(t.head.extra_len)), Ci.arraySet(
            t.head.extra,
            n,
            a,
            // extra field is limited to 65536 bytes
            // - no need for additional size check
            _,
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            J
          )), t.flags & 512 && (t.check = Ha(t.check, n, _, a)), s -= _, a += _, t.length -= _), t.length))
            break e;
          t.length = 0, t.mode = jy;
        case jy:
          if (t.flags & 2048) {
            if (s === 0)
              break e;
            _ = 0;
            do
              J = n[a + _++], t.head && J && t.length < 65536 && (t.head.name += String.fromCharCode(J));
            while (J && _ < s);
            if (t.flags & 512 && (t.check = Ha(t.check, n, _, a)), s -= _, a += _, J)
              break e;
          } else t.head && (t.head.name = null);
          t.length = 0, t.mode = Wy;
        case Wy:
          if (t.flags & 4096) {
            if (s === 0)
              break e;
            _ = 0;
            do
              J = n[a + _++], t.head && J && t.length < 65536 && (t.head.comment += String.fromCharCode(J));
            while (J && _ < s);
            if (t.flags & 512 && (t.check = Ha(t.check, n, _, a)), s -= _, a += _, J)
              break e;
          } else t.head && (t.head.comment = null);
          t.mode = Gy;
        case Gy:
          if (t.flags & 512) {
            for (; d < 16; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            if (h !== (t.check & 65535)) {
              r.msg = "header crc mismatch", t.mode = h0;
              break;
            }
            h = 0, d = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), r.adler = t.check = 0, t.mode = Mo;
          break;
        case Vy:
          for (; d < 32; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          r.adler = t.check = ib(h), h = 0, d = 0, t.mode = md;
        case md:
          if (t.havedict === 0)
            return r.next_out = o, r.avail_out = c, r.next_in = a, r.avail_in = s, t.hold = h, t.bits = d, nM;
          r.adler = t.check = 1, t.mode = Mo;
        case Mo:
          if (e === tM || e === M2)
            break e;
        case wp:
          if (t.last) {
            h >>>= d & 7, d -= d & 7, t.mode = xp;
            break;
          }
          for (; d < 3; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          switch (t.last = h & 1, h >>>= 1, d -= 1, h & 3) {
            case 0:
              t.mode = Yy;
              break;
            case 1:
              if (hM(t), t.mode = U2, e === M2) {
                h >>>= 2, d -= 2;
                break e;
              }
              break;
            case 2:
              t.mode = Zy;
              break;
            case 3:
              r.msg = "invalid block type", t.mode = h0;
          }
          h >>>= 2, d -= 2;
          break;
        case Yy:
          for (h >>>= d & 7, d -= d & 7; d < 32; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if ((h & 65535) !== (h >>> 16 ^ 65535)) {
            r.msg = "invalid stored block lengths", t.mode = h0;
            break;
          }
          if (t.length = h & 65535, h = 0, d = 0, t.mode = Ap, e === M2)
            break e;
        case Ap:
          t.mode = Hy;
        case Hy:
          if (_ = t.length, _) {
            if (_ > s && (_ = s), _ > c && (_ = c), _ === 0)
              break e;
            Ci.arraySet(i, n, a, _, o), s -= _, a += _, c -= _, o += _, t.length -= _;
            break;
          }
          t.mode = Mo;
          break;
        case Zy:
          for (; d < 14; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (t.nlen = (h & 31) + 257, h >>>= 5, d -= 5, t.ndist = (h & 31) + 1, h >>>= 5, d -= 5, t.ncode = (h & 15) + 4, h >>>= 4, d -= 4, t.nlen > 286 || t.ndist > 30) {
            r.msg = "too many length or distance symbols", t.mode = h0;
            break;
          }
          t.have = 0, t.mode = qy;
        case qy:
          for (; t.have < t.ncode; ) {
            for (; d < 3; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            t.lens[B[t.have++]] = h & 7, h >>>= 3, d -= 3;
          }
          for (; t.have < 19; )
            t.lens[B[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, ve = { bits: t.lenbits }, K = s1(eM, t.lens, 0, 19, t.lencode, 0, t.work, ve), t.lenbits = ve.bits, K) {
            r.msg = "invalid code lengths set", t.mode = h0;
            break;
          }
          t.have = 0, t.mode = Xy;
        case Xy:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; N = t.lencode[h & (1 << t.lenbits) - 1], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(M <= d); ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            if (z < 16)
              h >>>= M, d -= M, t.lens[t.have++] = z;
            else {
              if (z === 16) {
                for (de = M + 2; d < de; ) {
                  if (s === 0)
                    break e;
                  s--, h += n[a++] << d, d += 8;
                }
                if (h >>>= M, d -= M, t.have === 0) {
                  r.msg = "invalid bit length repeat", t.mode = h0;
                  break;
                }
                J = t.lens[t.have - 1], _ = 3 + (h & 3), h >>>= 2, d -= 2;
              } else if (z === 17) {
                for (de = M + 3; d < de; ) {
                  if (s === 0)
                    break e;
                  s--, h += n[a++] << d, d += 8;
                }
                h >>>= M, d -= M, J = 0, _ = 3 + (h & 7), h >>>= 3, d -= 3;
              } else {
                for (de = M + 7; d < de; ) {
                  if (s === 0)
                    break e;
                  s--, h += n[a++] << d, d += 8;
                }
                h >>>= M, d -= M, J = 0, _ = 11 + (h & 127), h >>>= 7, d -= 7;
              }
              if (t.have + _ > t.nlen + t.ndist) {
                r.msg = "invalid bit length repeat", t.mode = h0;
                break;
              }
              for (; _--; )
                t.lens[t.have++] = J;
            }
          }
          if (t.mode === h0)
            break;
          if (t.lens[256] === 0) {
            r.msg = "invalid code -- missing end-of-block", t.mode = h0;
            break;
          }
          if (t.lenbits = 9, ve = { bits: t.lenbits }, K = s1(S9, t.lens, 0, t.nlen, t.lencode, 0, t.work, ve), t.lenbits = ve.bits, K) {
            r.msg = "invalid literal/lengths set", t.mode = h0;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, ve = { bits: t.distbits }, K = s1(C9, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, ve), t.distbits = ve.bits, K) {
            r.msg = "invalid distances set", t.mode = h0;
            break;
          }
          if (t.mode = U2, e === M2)
            break e;
        case U2:
          t.mode = $2;
        case $2:
          if (s >= 6 && c >= 258) {
            r.next_out = o, r.avail_out = c, r.next_in = a, r.avail_in = s, t.hold = h, t.bits = d, QL(r, x), o = r.next_out, i = r.output, c = r.avail_out, a = r.next_in, n = r.input, s = r.avail_in, h = t.hold, d = t.bits, t.mode === Mo && (t.back = -1);
            break;
          }
          for (t.back = 0; N = t.lencode[h & (1 << t.lenbits) - 1], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(M <= d); ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (G && !(G & 240)) {
            for (j = M, R = G, te = z; N = t.lencode[te + ((h & (1 << j + R) - 1) >> j)], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(j + M <= d); ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            h >>>= j, d -= j, t.back += j;
          }
          if (h >>>= M, d -= M, t.back += M, t.length = z, G === 0) {
            t.mode = tb;
            break;
          }
          if (G & 32) {
            t.back = -1, t.mode = Mo;
            break;
          }
          if (G & 64) {
            r.msg = "invalid literal/length code", t.mode = h0;
            break;
          }
          t.extra = G & 15, t.mode = Ky;
        case Ky:
          if (t.extra) {
            for (de = t.extra; d < de; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            t.length += h & (1 << t.extra) - 1, h >>>= t.extra, d -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = Jy;
        case Jy:
          for (; N = t.distcode[h & (1 << t.distbits) - 1], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(M <= d); ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (!(G & 240)) {
            for (j = M, R = G, te = z; N = t.distcode[te + ((h & (1 << j + R) - 1) >> j)], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(j + M <= d); ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            h >>>= j, d -= j, t.back += j;
          }
          if (h >>>= M, d -= M, t.back += M, G & 64) {
            r.msg = "invalid distance code", t.mode = h0;
            break;
          }
          t.offset = z, t.extra = G & 15, t.mode = Qy;
        case Qy:
          if (t.extra) {
            for (de = t.extra; d < de; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            t.offset += h & (1 << t.extra) - 1, h >>>= t.extra, d -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            r.msg = "invalid distance too far back", t.mode = h0;
            break;
          }
          t.mode = eb;
        case eb:
          if (c === 0)
            break e;
          if (_ = x - c, t.offset > _) {
            if (_ = t.offset - _, _ > t.whave && t.sane) {
              r.msg = "invalid distance too far back", t.mode = h0;
              break;
            }
            _ > t.wnext ? (_ -= t.wnext, k = t.wsize - _) : k = t.wnext - _, _ > t.length && (_ = t.length), P = t.window;
          } else
            P = i, k = o - t.offset, _ = t.length;
          _ > c && (_ = c), c -= _, t.length -= _;
          do
            i[o++] = P[k++];
          while (--_);
          t.length === 0 && (t.mode = $2);
          break;
        case tb:
          if (c === 0)
            break e;
          i[o++] = t.length, c--, t.mode = $2;
          break;
        case xp:
          if (t.wrap) {
            for (; d < 32; ) {
              if (s === 0)
                break e;
              s--, h |= n[a++] << d, d += 8;
            }
            if (x -= c, r.total_out += x, t.total += x, x && (r.adler = t.check = /*UPDATE(state.check, put - _out, _out);*/
            t.flags ? Ha(t.check, i, x, o - x) : h3(t.check, i, x, o - x)), x = c, (t.flags ? h : ib(h)) !== t.check) {
              r.msg = "incorrect data check", t.mode = h0;
              break;
            }
            h = 0, d = 0;
          }
          t.mode = rb;
        case rb:
          if (t.wrap && t.flags) {
            for (; d < 32; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            if (h !== (t.total & 4294967295)) {
              r.msg = "incorrect length check", t.mode = h0;
              break;
            }
            h = 0, d = 0;
          }
          t.mode = nb;
        case nb:
          K = rM;
          break e;
        case h0:
          K = F9;
          break e;
        case I9:
          return O9;
        case aM:
        default:
          return la;
      }
  return r.next_out = o, r.avail_out = c, r.next_in = a, r.avail_in = s, t.hold = h, t.bits = d, (t.wsize || x !== r.avail_out && t.mode < h0 && (t.mode < xp || e !== By)) && M9(r, r.output, r.next_out, x - r.avail_out), g -= r.avail_in, x -= r.avail_out, r.total_in += g, r.total_out += x, t.total += x, t.wrap && x && (r.adler = t.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  t.flags ? Ha(t.check, i, x, r.next_out - x) : h3(t.check, i, x, r.next_out - x)), r.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === Mo ? 128 : 0) + (t.mode === U2 || t.mode === Ap ? 256 : 0), (g === 0 && x === 0 || e === By) && K === gl && (K = iM), K;
}
function pM(r) {
  if (!r || !r.state)
    return la;
  var e = r.state;
  return e.window && (e.window = null), r.state = null, gl;
}
function vM(r, e) {
  var t;
  return !r || !r.state || (t = r.state, !(t.wrap & 2)) ? la : (t.head = e, e.done = !1, gl);
}
function gM(r, e) {
  var t = e.length, n, i, a;
  return !r || !r.state || (n = r.state, n.wrap !== 0 && n.mode !== md) ? la : n.mode === md && (i = 1, i = h3(i, e, t, 0), i !== n.check) ? F9 : (a = M9(r, e, t, t), a ? (n.mode = I9, O9) : (n.havedict = 1, gl));
}
Oa.inflateReset = B9;
Oa.inflateReset2 = N9;
Oa.inflateResetKeep = P9;
Oa.inflateInit = fM;
Oa.inflateInit2 = L9;
Oa.inflate = dM;
Oa.inflateEnd = pM;
Oa.inflateGetHeader = vM;
Oa.inflateSetDictionary = gM;
Oa.inflateInfo = "pako inflate (from Nodeca project)";
var mM = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const yM = /* @__PURE__ */ I0(mM);
function ou(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = ET(r)) || e) {
    t && (r = t);
    var n = 0;
    return function() {
      return n >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var bM = IT();
const U9 = /* @__PURE__ */ I0(bM);
var D1 = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, io = [], Xi = [], wM = typeof Uint8Array < "u" ? Uint8Array : Array, $v = !1;
function $9() {
  $v = !0;
  for (var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, t = r.length; e < t; ++e)
    io[e] = r[e], Xi[r.charCodeAt(e)] = e;
  Xi[45] = 62, Xi[95] = 63;
}
function AM(r) {
  $v || $9();
  var e, t, n, i, a, o, s = r.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  a = r[s - 2] === "=" ? 2 : r[s - 1] === "=" ? 1 : 0, o = new wM(s * 3 / 4 - a), n = a > 0 ? s - 4 : s;
  var c = 0;
  for (e = 0, t = 0; e < n; e += 4, t += 3)
    i = Xi[r.charCodeAt(e)] << 18 | Xi[r.charCodeAt(e + 1)] << 12 | Xi[r.charCodeAt(e + 2)] << 6 | Xi[r.charCodeAt(e + 3)], o[c++] = i >> 16 & 255, o[c++] = i >> 8 & 255, o[c++] = i & 255;
  return a === 2 ? (i = Xi[r.charCodeAt(e)] << 2 | Xi[r.charCodeAt(e + 1)] >> 4, o[c++] = i & 255) : a === 1 && (i = Xi[r.charCodeAt(e)] << 10 | Xi[r.charCodeAt(e + 1)] << 4 | Xi[r.charCodeAt(e + 2)] >> 2, o[c++] = i >> 8 & 255, o[c++] = i & 255), o;
}
function xM(r) {
  return io[r >> 18 & 63] + io[r >> 12 & 63] + io[r >> 6 & 63] + io[r & 63];
}
function EM(r, e, t) {
  for (var n, i = [], a = e; a < t; a += 3)
    n = (r[a] << 16) + (r[a + 1] << 8) + r[a + 2], i.push(xM(n));
  return i.join("");
}
function ob(r) {
  $v || $9();
  for (var e, t = r.length, n = t % 3, i = "", a = [], o = 16383, s = 0, c = t - n; s < c; s += o)
    a.push(EM(r, s, s + o > c ? c : s + o));
  return n === 1 ? (e = r[t - 1], i += io[e >> 2], i += io[e << 4 & 63], i += "==") : n === 2 && (e = (r[t - 2] << 8) + r[t - 1], i += io[e >> 10], i += io[e >> 4 & 63], i += io[e << 2 & 63], i += "="), a.push(i), a.join("");
}
function t5(r, e, t, n, i) {
  var a, o, s = i * 8 - n - 1, c = (1 << s) - 1, h = c >> 1, d = -7, g = t ? i - 1 : 0, x = t ? -1 : 1, _ = r[e + g];
  for (g += x, a = _ & (1 << -d) - 1, _ >>= -d, d += s; d > 0; a = a * 256 + r[e + g], g += x, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += n; d > 0; o = o * 256 + r[e + g], g += x, d -= 8)
    ;
  if (a === 0)
    a = 1 - h;
  else {
    if (a === c)
      return o ? NaN : (_ ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), a = a - h;
  }
  return (_ ? -1 : 1) * o * Math.pow(2, a - n);
}
function z9(r, e, t, n, i, a) {
  var o, s, c, h = a * 8 - i - 1, d = (1 << h) - 1, g = d >> 1, x = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, _ = n ? 0 : a - 1, k = n ? 1 : -1, P = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + g >= 1 ? e += x / c : e += x * Math.pow(2, 1 - g), e * c >= 2 && (o++, c /= 2), o + g >= d ? (s = 0, o = d) : o + g >= 1 ? (s = (e * c - 1) * Math.pow(2, i), o = o + g) : (s = e * Math.pow(2, g - 1) * Math.pow(2, i), o = 0)); i >= 8; r[t + _] = s & 255, _ += k, s /= 256, i -= 8)
    ;
  for (o = o << i | s, h += i; h > 0; r[t + _] = o & 255, _ += k, o /= 256, h -= 8)
    ;
  r[t + _ - k] |= P * 128;
}
var _M = {}.toString, j9 = Array.isArray || function(r) {
  return _M.call(r) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var DM = 50;
ut.TYPED_ARRAY_SUPPORT = D1.TYPED_ARRAY_SUPPORT !== void 0 ? D1.TYPED_ARRAY_SUPPORT : !0;
function d3() {
  return ut.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Ho(r, e) {
  if (d3() < e)
    throw new RangeError("Invalid typed array length");
  return ut.TYPED_ARRAY_SUPPORT ? (r = new Uint8Array(e), r.__proto__ = ut.prototype) : (r === null && (r = new ut(e)), r.length = e), r;
}
function ut(r, e, t) {
  if (!ut.TYPED_ARRAY_SUPPORT && !(this instanceof ut))
    return new ut(r, e, t);
  if (typeof r == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return zv(this, r);
  }
  return W9(this, r, e, t);
}
ut.poolSize = 8192;
ut._augment = function(r) {
  return r.__proto__ = ut.prototype, r;
};
function W9(r, e, t, n) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? SM(r, e, t, n) : typeof e == "string" ? kM(r, e, t) : CM(r, e);
}
ut.from = function(r, e, t) {
  return W9(null, r, e, t);
};
ut.TYPED_ARRAY_SUPPORT && (ut.prototype.__proto__ = Uint8Array.prototype, ut.__proto__ = Uint8Array);
function G9(r) {
  if (typeof r != "number")
    throw new TypeError('"size" argument must be a number');
  if (r < 0)
    throw new RangeError('"size" argument must not be negative');
}
function TM(r, e, t, n) {
  return G9(e), e <= 0 ? Ho(r, e) : t !== void 0 ? typeof n == "string" ? Ho(r, e).fill(t, n) : Ho(r, e).fill(t) : Ho(r, e);
}
ut.alloc = function(r, e, t) {
  return TM(null, r, e, t);
};
function zv(r, e) {
  if (G9(e), r = Ho(r, e < 0 ? 0 : jv(e) | 0), !ut.TYPED_ARRAY_SUPPORT)
    for (var t = 0; t < e; ++t)
      r[t] = 0;
  return r;
}
ut.allocUnsafe = function(r) {
  return zv(null, r);
};
ut.allocUnsafeSlow = function(r) {
  return zv(null, r);
};
function kM(r, e, t) {
  if ((typeof t != "string" || t === "") && (t = "utf8"), !ut.isEncoding(t))
    throw new TypeError('"encoding" must be a valid string encoding');
  var n = V9(e, t) | 0;
  r = Ho(r, n);
  var i = r.write(e, t);
  return i !== n && (r = r.slice(0, i)), r;
}
function p3(r, e) {
  var t = e.length < 0 ? 0 : jv(e.length) | 0;
  r = Ho(r, t);
  for (var n = 0; n < t; n += 1)
    r[n] = e[n] & 255;
  return r;
}
function SM(r, e, t, n) {
  if (e.byteLength, t < 0 || e.byteLength < t)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < t + (n || 0))
    throw new RangeError("'length' is out of bounds");
  return t === void 0 && n === void 0 ? e = new Uint8Array(e) : n === void 0 ? e = new Uint8Array(e, t) : e = new Uint8Array(e, t, n), ut.TYPED_ARRAY_SUPPORT ? (r = e, r.__proto__ = ut.prototype) : r = p3(r, e), r;
}
function CM(r, e) {
  if (mo(e)) {
    var t = jv(e.length) | 0;
    return r = Ho(r, t), r.length === 0 || e.copy(r, 0, 0, t), r;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || ZM(e.length) ? Ho(r, 0) : p3(r, e);
    if (e.type === "Buffer" && j9(e.data))
      return p3(r, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function jv(r) {
  if (r >= d3())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + d3().toString(16) + " bytes");
  return r | 0;
}
ut.isBuffer = qM;
function mo(r) {
  return !!(r != null && r._isBuffer);
}
ut.compare = function(e, t) {
  if (!mo(e) || !mo(t))
    throw new TypeError("Arguments must be Buffers");
  if (e === t) return 0;
  for (var n = e.length, i = t.length, a = 0, o = Math.min(n, i); a < o; ++a)
    if (e[a] !== t[a]) {
      n = e[a], i = t[a];
      break;
    }
  return n < i ? -1 : i < n ? 1 : 0;
};
ut.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
ut.concat = function(e, t) {
  if (!j9(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return ut.alloc(0);
  var n;
  if (t === void 0)
    for (t = 0, n = 0; n < e.length; ++n)
      t += e[n].length;
  var i = ut.allocUnsafe(t), a = 0;
  for (n = 0; n < e.length; ++n) {
    var o = e[n];
    if (!mo(o))
      throw new TypeError('"list" argument must be an Array of Buffers');
    o.copy(i, a), a += o.length;
  }
  return i;
};
function V9(r, e) {
  if (mo(r))
    return r.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(r) || r instanceof ArrayBuffer))
    return r.byteLength;
  typeof r != "string" && (r = "" + r);
  var t = r.length;
  if (t === 0) return 0;
  for (var n = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return t;
      case "utf8":
      case "utf-8":
      case void 0:
        return yd(r).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t * 2;
      case "hex":
        return t >>> 1;
      case "base64":
        return J9(r).length;
      default:
        if (n) return yd(r).length;
        e = ("" + e).toLowerCase(), n = !0;
    }
}
ut.byteLength = V9;
function FM(r, e, t) {
  var n = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, e >>>= 0, t <= e))
    return "";
  for (r || (r = "utf8"); ; )
    switch (r) {
      case "hex":
        return $M(this, e, t);
      case "utf8":
      case "utf-8":
        return Z9(this, e, t);
      case "ascii":
        return MM(this, e, t);
      case "latin1":
      case "binary":
        return UM(this, e, t);
      case "base64":
        return NM(this, e, t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return zM(this, e, t);
      default:
        if (n) throw new TypeError("Unknown encoding: " + r);
        r = (r + "").toLowerCase(), n = !0;
    }
}
ut.prototype._isBuffer = !0;
function Ju(r, e, t) {
  var n = r[e];
  r[e] = r[t], r[t] = n;
}
ut.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < e; t += 2)
    Ju(this, t, t + 1);
  return this;
};
ut.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < e; t += 4)
    Ju(this, t, t + 3), Ju(this, t + 1, t + 2);
  return this;
};
ut.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < e; t += 8)
    Ju(this, t, t + 7), Ju(this, t + 1, t + 6), Ju(this, t + 2, t + 5), Ju(this, t + 3, t + 4);
  return this;
};
ut.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? Z9(this, 0, e) : FM.apply(this, arguments);
};
ut.prototype.equals = function(e) {
  if (!mo(e)) throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : ut.compare(this, e) === 0;
};
ut.prototype.inspect = function() {
  var e = "", t = DM;
  return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
};
ut.prototype.compare = function(e, t, n, i, a) {
  if (!mo(e))
    throw new TypeError("Argument must be a Buffer");
  if (t === void 0 && (t = 0), n === void 0 && (n = e ? e.length : 0), i === void 0 && (i = 0), a === void 0 && (a = this.length), t < 0 || n > e.length || i < 0 || a > this.length)
    throw new RangeError("out of range index");
  if (i >= a && t >= n)
    return 0;
  if (i >= a)
    return -1;
  if (t >= n)
    return 1;
  if (t >>>= 0, n >>>= 0, i >>>= 0, a >>>= 0, this === e) return 0;
  for (var o = a - i, s = n - t, c = Math.min(o, s), h = this.slice(i, a), d = e.slice(t, n), g = 0; g < c; ++g)
    if (h[g] !== d[g]) {
      o = h[g], s = d[g];
      break;
    }
  return o < s ? -1 : s < o ? 1 : 0;
};
function Y9(r, e, t, n, i) {
  if (r.length === 0) return -1;
  if (typeof t == "string" ? (n = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = i ? 0 : r.length - 1), t < 0 && (t = r.length + t), t >= r.length) {
    if (i) return -1;
    t = r.length - 1;
  } else if (t < 0)
    if (i) t = 0;
    else return -1;
  if (typeof e == "string" && (e = ut.from(e, n)), mo(e))
    return e.length === 0 ? -1 : sb(r, e, t, n, i);
  if (typeof e == "number")
    return e = e & 255, ut.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(r, e, t) : Uint8Array.prototype.lastIndexOf.call(r, e, t) : sb(r, [e], t, n, i);
  throw new TypeError("val must be string, number or Buffer");
}
function sb(r, e, t, n, i) {
  var a = 1, o = r.length, s = e.length;
  if (n !== void 0 && (n = String(n).toLowerCase(), n === "ucs2" || n === "ucs-2" || n === "utf16le" || n === "utf-16le")) {
    if (r.length < 2 || e.length < 2)
      return -1;
    a = 2, o /= 2, s /= 2, t /= 2;
  }
  function c(_, k) {
    return a === 1 ? _[k] : _.readUInt16BE(k * a);
  }
  var h;
  if (i) {
    var d = -1;
    for (h = t; h < o; h++)
      if (c(r, h) === c(e, d === -1 ? 0 : h - d)) {
        if (d === -1 && (d = h), h - d + 1 === s) return d * a;
      } else
        d !== -1 && (h -= h - d), d = -1;
  } else
    for (t + s > o && (t = o - s), h = t; h >= 0; h--) {
      for (var g = !0, x = 0; x < s; x++)
        if (c(r, h + x) !== c(e, x)) {
          g = !1;
          break;
        }
      if (g) return h;
    }
  return -1;
}
ut.prototype.includes = function(e, t, n) {
  return this.indexOf(e, t, n) !== -1;
};
ut.prototype.indexOf = function(e, t, n) {
  return Y9(this, e, t, n, !0);
};
ut.prototype.lastIndexOf = function(e, t, n) {
  return Y9(this, e, t, n, !1);
};
function OM(r, e, t, n) {
  t = Number(t) || 0;
  var i = r.length - t;
  n ? (n = Number(n), n > i && (n = i)) : n = i;
  var a = e.length;
  if (a % 2 !== 0) throw new TypeError("Invalid hex string");
  n > a / 2 && (n = a / 2);
  for (var o = 0; o < n; ++o) {
    var s = parseInt(e.substr(o * 2, 2), 16);
    if (isNaN(s)) return o;
    r[t + o] = s;
  }
  return o;
}
function RM(r, e, t, n) {
  return i5(yd(e, r.length - t), r, t, n);
}
function H9(r, e, t, n) {
  return i5(YM(e), r, t, n);
}
function IM(r, e, t, n) {
  return H9(r, e, t, n);
}
function PM(r, e, t, n) {
  return i5(J9(e), r, t, n);
}
function BM(r, e, t, n) {
  return i5(HM(e, r.length - t), r, t, n);
}
ut.prototype.write = function(e, t, n, i) {
  if (t === void 0)
    i = "utf8", n = this.length, t = 0;
  else if (n === void 0 && typeof t == "string")
    i = t, n = this.length, t = 0;
  else if (isFinite(t))
    t = t | 0, isFinite(n) ? (n = n | 0, i === void 0 && (i = "utf8")) : (i = n, n = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var a = this.length - t;
  if ((n === void 0 || n > a) && (n = a), e.length > 0 && (n < 0 || t < 0) || t > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var o = !1; ; )
    switch (i) {
      case "hex":
        return OM(this, e, t, n);
      case "utf8":
      case "utf-8":
        return RM(this, e, t, n);
      case "ascii":
        return H9(this, e, t, n);
      case "latin1":
      case "binary":
        return IM(this, e, t, n);
      case "base64":
        return PM(this, e, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return BM(this, e, t, n);
      default:
        if (o) throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), o = !0;
    }
};
ut.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function NM(r, e, t) {
  return e === 0 && t === r.length ? ob(r) : ob(r.slice(e, t));
}
function Z9(r, e, t) {
  t = Math.min(r.length, t);
  for (var n = [], i = e; i < t; ) {
    var a = r[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
    if (i + s <= t) {
      var c, h, d, g;
      switch (s) {
        case 1:
          a < 128 && (o = a);
          break;
        case 2:
          c = r[i + 1], (c & 192) === 128 && (g = (a & 31) << 6 | c & 63, g > 127 && (o = g));
          break;
        case 3:
          c = r[i + 1], h = r[i + 2], (c & 192) === 128 && (h & 192) === 128 && (g = (a & 15) << 12 | (c & 63) << 6 | h & 63, g > 2047 && (g < 55296 || g > 57343) && (o = g));
          break;
        case 4:
          c = r[i + 1], h = r[i + 2], d = r[i + 3], (c & 192) === 128 && (h & 192) === 128 && (d & 192) === 128 && (g = (a & 15) << 18 | (c & 63) << 12 | (h & 63) << 6 | d & 63, g > 65535 && g < 1114112 && (o = g));
      }
    }
    o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), n.push(o), i += s;
  }
  return LM(n);
}
var ub = 4096;
function LM(r) {
  var e = r.length;
  if (e <= ub)
    return String.fromCharCode.apply(String, r);
  for (var t = "", n = 0; n < e; )
    t += String.fromCharCode.apply(
      String,
      r.slice(n, n += ub)
    );
  return t;
}
function MM(r, e, t) {
  var n = "";
  t = Math.min(r.length, t);
  for (var i = e; i < t; ++i)
    n += String.fromCharCode(r[i] & 127);
  return n;
}
function UM(r, e, t) {
  var n = "";
  t = Math.min(r.length, t);
  for (var i = e; i < t; ++i)
    n += String.fromCharCode(r[i]);
  return n;
}
function $M(r, e, t) {
  var n = r.length;
  (!e || e < 0) && (e = 0), (!t || t < 0 || t > n) && (t = n);
  for (var i = "", a = e; a < t; ++a)
    i += VM(r[a]);
  return i;
}
function zM(r, e, t) {
  for (var n = r.slice(e, t), i = "", a = 0; a < n.length; a += 2)
    i += String.fromCharCode(n[a] + n[a + 1] * 256);
  return i;
}
ut.prototype.slice = function(e, t) {
  var n = this.length;
  e = ~~e, t = t === void 0 ? n : ~~t, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), t < 0 ? (t += n, t < 0 && (t = 0)) : t > n && (t = n), t < e && (t = e);
  var i;
  if (ut.TYPED_ARRAY_SUPPORT)
    i = this.subarray(e, t), i.__proto__ = ut.prototype;
  else {
    var a = t - e;
    i = new ut(a, void 0);
    for (var o = 0; o < a; ++o)
      i[o] = this[o + e];
  }
  return i;
};
function cn(r, e, t) {
  if (r % 1 !== 0 || r < 0) throw new RangeError("offset is not uint");
  if (r + e > t) throw new RangeError("Trying to access beyond buffer length");
}
ut.prototype.readUIntLE = function(e, t, n) {
  e = e | 0, t = t | 0, n || cn(e, t, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < t && (a *= 256); )
    i += this[e + o] * a;
  return i;
};
ut.prototype.readUIntBE = function(e, t, n) {
  e = e | 0, t = t | 0, n || cn(e, t, this.length);
  for (var i = this[e + --t], a = 1; t > 0 && (a *= 256); )
    i += this[e + --t] * a;
  return i;
};
ut.prototype.readUInt8 = function(e, t) {
  return t || cn(e, 1, this.length), this[e];
};
ut.prototype.readUInt16LE = function(e, t) {
  return t || cn(e, 2, this.length), this[e] | this[e + 1] << 8;
};
ut.prototype.readUInt16BE = function(e, t) {
  return t || cn(e, 2, this.length), this[e] << 8 | this[e + 1];
};
ut.prototype.readUInt32LE = function(e, t) {
  return t || cn(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
ut.prototype.readUInt32BE = function(e, t) {
  return t || cn(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
ut.prototype.readIntLE = function(e, t, n) {
  e = e | 0, t = t | 0, n || cn(e, t, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < t && (a *= 256); )
    i += this[e + o] * a;
  return a *= 128, i >= a && (i -= Math.pow(2, 8 * t)), i;
};
ut.prototype.readIntBE = function(e, t, n) {
  e = e | 0, t = t | 0, n || cn(e, t, this.length);
  for (var i = t, a = 1, o = this[e + --i]; i > 0 && (a *= 256); )
    o += this[e + --i] * a;
  return a *= 128, o >= a && (o -= Math.pow(2, 8 * t)), o;
};
ut.prototype.readInt8 = function(e, t) {
  return t || cn(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
ut.prototype.readInt16LE = function(e, t) {
  t || cn(e, 2, this.length);
  var n = this[e] | this[e + 1] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
ut.prototype.readInt16BE = function(e, t) {
  t || cn(e, 2, this.length);
  var n = this[e + 1] | this[e] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
ut.prototype.readInt32LE = function(e, t) {
  return t || cn(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
ut.prototype.readInt32BE = function(e, t) {
  return t || cn(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
ut.prototype.readFloatLE = function(e, t) {
  return t || cn(e, 4, this.length), t5(this, e, !0, 23, 4);
};
ut.prototype.readFloatBE = function(e, t) {
  return t || cn(e, 4, this.length), t5(this, e, !1, 23, 4);
};
ut.prototype.readDoubleLE = function(e, t) {
  return t || cn(e, 8, this.length), t5(this, e, !0, 52, 8);
};
ut.prototype.readDoubleBE = function(e, t) {
  return t || cn(e, 8, this.length), t5(this, e, !1, 52, 8);
};
function di(r, e, t, n, i, a) {
  if (!mo(r)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > i || e < a) throw new RangeError('"value" argument is out of bounds');
  if (t + n > r.length) throw new RangeError("Index out of range");
}
ut.prototype.writeUIntLE = function(e, t, n, i) {
  if (e = +e, t = t | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    di(this, e, t, n, a, 0);
  }
  var o = 1, s = 0;
  for (this[t] = e & 255; ++s < n && (o *= 256); )
    this[t + s] = e / o & 255;
  return t + n;
};
ut.prototype.writeUIntBE = function(e, t, n, i) {
  if (e = +e, t = t | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    di(this, e, t, n, a, 0);
  }
  var o = n - 1, s = 1;
  for (this[t + o] = e & 255; --o >= 0 && (s *= 256); )
    this[t + o] = e / s & 255;
  return t + n;
};
ut.prototype.writeUInt8 = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 1, 255, 0), ut.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = e & 255, t + 1;
};
function r5(r, e, t, n) {
  e < 0 && (e = 65535 + e + 1);
  for (var i = 0, a = Math.min(r.length - t, 2); i < a; ++i)
    r[t + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> (n ? i : 1 - i) * 8;
}
ut.prototype.writeUInt16LE = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 2, 65535, 0), ut.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : r5(this, e, t, !0), t + 2;
};
ut.prototype.writeUInt16BE = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 2, 65535, 0), ut.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : r5(this, e, t, !1), t + 2;
};
function n5(r, e, t, n) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var i = 0, a = Math.min(r.length - t, 4); i < a; ++i)
    r[t + i] = e >>> (n ? i : 3 - i) * 8 & 255;
}
ut.prototype.writeUInt32LE = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 4, 4294967295, 0), ut.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255) : n5(this, e, t, !0), t + 4;
};
ut.prototype.writeUInt32BE = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 4, 4294967295, 0), ut.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : n5(this, e, t, !1), t + 4;
};
ut.prototype.writeIntLE = function(e, t, n, i) {
  if (e = +e, t = t | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    di(this, e, t, n, a - 1, -a);
  }
  var o = 0, s = 1, c = 0;
  for (this[t] = e & 255; ++o < n && (s *= 256); )
    e < 0 && c === 0 && this[t + o - 1] !== 0 && (c = 1), this[t + o] = (e / s >> 0) - c & 255;
  return t + n;
};
ut.prototype.writeIntBE = function(e, t, n, i) {
  if (e = +e, t = t | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    di(this, e, t, n, a - 1, -a);
  }
  var o = n - 1, s = 1, c = 0;
  for (this[t + o] = e & 255; --o >= 0 && (s *= 256); )
    e < 0 && c === 0 && this[t + o + 1] !== 0 && (c = 1), this[t + o] = (e / s >> 0) - c & 255;
  return t + n;
};
ut.prototype.writeInt8 = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 1, 127, -128), ut.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
};
ut.prototype.writeInt16LE = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 2, 32767, -32768), ut.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : r5(this, e, t, !0), t + 2;
};
ut.prototype.writeInt16BE = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 2, 32767, -32768), ut.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : r5(this, e, t, !1), t + 2;
};
ut.prototype.writeInt32LE = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 4, 2147483647, -2147483648), ut.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : n5(this, e, t, !0), t + 4;
};
ut.prototype.writeInt32BE = function(e, t, n) {
  return e = +e, t = t | 0, n || di(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), ut.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : n5(this, e, t, !1), t + 4;
};
function q9(r, e, t, n, i, a) {
  if (t + n > r.length) throw new RangeError("Index out of range");
  if (t < 0) throw new RangeError("Index out of range");
}
function X9(r, e, t, n, i) {
  return i || q9(r, e, t, 4), z9(r, e, t, n, 23, 4), t + 4;
}
ut.prototype.writeFloatLE = function(e, t, n) {
  return X9(this, e, t, !0, n);
};
ut.prototype.writeFloatBE = function(e, t, n) {
  return X9(this, e, t, !1, n);
};
function K9(r, e, t, n, i) {
  return i || q9(r, e, t, 8), z9(r, e, t, n, 52, 8), t + 8;
}
ut.prototype.writeDoubleLE = function(e, t, n) {
  return K9(this, e, t, !0, n);
};
ut.prototype.writeDoubleBE = function(e, t, n) {
  return K9(this, e, t, !1, n);
};
ut.prototype.copy = function(e, t, n, i) {
  if (n || (n = 0), !i && i !== 0 && (i = this.length), t >= e.length && (t = e.length), t || (t = 0), i > 0 && i < n && (i = n), i === n || e.length === 0 || this.length === 0) return 0;
  if (t < 0)
    throw new RangeError("targetStart out of bounds");
  if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
  if (i < 0) throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), e.length - t < i - n && (i = e.length - t + n);
  var a = i - n, o;
  if (this === e && n < t && t < i)
    for (o = a - 1; o >= 0; --o)
      e[o + t] = this[o + n];
  else if (a < 1e3 || !ut.TYPED_ARRAY_SUPPORT)
    for (o = 0; o < a; ++o)
      e[o + t] = this[o + n];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(n, n + a),
      t
    );
  return a;
};
ut.prototype.fill = function(e, t, n, i) {
  if (typeof e == "string") {
    if (typeof t == "string" ? (i = t, t = 0, n = this.length) : typeof n == "string" && (i = n, n = this.length), e.length === 1) {
      var a = e.charCodeAt(0);
      a < 256 && (e = a);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !ut.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else typeof e == "number" && (e = e & 255);
  if (t < 0 || this.length < t || this.length < n)
    throw new RangeError("Out of range index");
  if (n <= t)
    return this;
  t = t >>> 0, n = n === void 0 ? this.length : n >>> 0, e || (e = 0);
  var o;
  if (typeof e == "number")
    for (o = t; o < n; ++o)
      this[o] = e;
  else {
    var s = mo(e) ? e : yd(new ut(e, i).toString()), c = s.length;
    for (o = 0; o < n - t; ++o)
      this[o + t] = s[o % c];
  }
  return this;
};
var jM = /[^+\/0-9A-Za-z-_]/g;
function WM(r) {
  if (r = GM(r).replace(jM, ""), r.length < 2) return "";
  for (; r.length % 4 !== 0; )
    r = r + "=";
  return r;
}
function GM(r) {
  return r.trim ? r.trim() : r.replace(/^\s+|\s+$/g, "");
}
function VM(r) {
  return r < 16 ? "0" + r.toString(16) : r.toString(16);
}
function yd(r, e) {
  e = e || 1 / 0;
  for (var t, n = r.length, i = null, a = [], o = 0; o < n; ++o) {
    if (t = r.charCodeAt(o), t > 55295 && t < 57344) {
      if (!i) {
        if (t > 56319) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        } else if (o + 1 === n) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        i = t;
        continue;
      }
      if (t < 56320) {
        (e -= 3) > -1 && a.push(239, 191, 189), i = t;
        continue;
      }
      t = (i - 55296 << 10 | t - 56320) + 65536;
    } else i && (e -= 3) > -1 && a.push(239, 191, 189);
    if (i = null, t < 128) {
      if ((e -= 1) < 0) break;
      a.push(t);
    } else if (t < 2048) {
      if ((e -= 2) < 0) break;
      a.push(
        t >> 6 | 192,
        t & 63 | 128
      );
    } else if (t < 65536) {
      if ((e -= 3) < 0) break;
      a.push(
        t >> 12 | 224,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else if (t < 1114112) {
      if ((e -= 4) < 0) break;
      a.push(
        t >> 18 | 240,
        t >> 12 & 63 | 128,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return a;
}
function YM(r) {
  for (var e = [], t = 0; t < r.length; ++t)
    e.push(r.charCodeAt(t) & 255);
  return e;
}
function HM(r, e) {
  for (var t, n, i, a = [], o = 0; o < r.length && !((e -= 2) < 0); ++o)
    t = r.charCodeAt(o), n = t >> 8, i = t % 256, a.push(i), a.push(n);
  return a;
}
function J9(r) {
  return AM(WM(r));
}
function i5(r, e, t, n) {
  for (var i = 0; i < n && !(i + t >= e.length || i >= r.length); ++i)
    e[i + t] = r[i];
  return i;
}
function ZM(r) {
  return r !== r;
}
function qM(r) {
  return r != null && (!!r._isBuffer || Q9(r) || XM(r));
}
function Q9(r) {
  return !!r.constructor && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
function XM(r) {
  return typeof r.readFloatLE == "function" && typeof r.slice == "function" && Q9(r.slice(0, 0));
}
function eA() {
  throw new Error("setTimeout has not been defined");
}
function tA() {
  throw new Error("clearTimeout has not been defined");
}
var Cs = eA, Fs = tA;
typeof D1.setTimeout == "function" && (Cs = setTimeout);
typeof D1.clearTimeout == "function" && (Fs = clearTimeout);
function rA(r) {
  if (Cs === setTimeout)
    return setTimeout(r, 0);
  if ((Cs === eA || !Cs) && setTimeout)
    return Cs = setTimeout, setTimeout(r, 0);
  try {
    return Cs(r, 0);
  } catch {
    try {
      return Cs.call(null, r, 0);
    } catch {
      return Cs.call(this, r, 0);
    }
  }
}
function KM(r) {
  if (Fs === clearTimeout)
    return clearTimeout(r);
  if ((Fs === tA || !Fs) && clearTimeout)
    return Fs = clearTimeout, clearTimeout(r);
  try {
    return Fs(r);
  } catch {
    try {
      return Fs.call(null, r);
    } catch {
      return Fs.call(this, r);
    }
  }
}
var Zo = [], Sc = !1, Qu, Th = -1;
function JM() {
  !Sc || !Qu || (Sc = !1, Qu.length ? Zo = Qu.concat(Zo) : Th = -1, Zo.length && nA());
}
function nA() {
  if (!Sc) {
    var r = rA(JM);
    Sc = !0;
    for (var e = Zo.length; e; ) {
      for (Qu = Zo, Zo = []; ++Th < e; )
        Qu && Qu[Th].run();
      Th = -1, e = Zo.length;
    }
    Qu = null, Sc = !1, KM(r);
  }
}
function QM(r) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      e[t - 1] = arguments[t];
  Zo.push(new iA(r, e)), Zo.length === 1 && !Sc && rA(nA);
}
function iA(r, e) {
  this.fun = r, this.array = e;
}
iA.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var eU = "browser", tU = "browser", rU = !0, nU = {}, iU = [], aU = "", oU = {}, sU = {}, uU = {};
function Tl() {
}
var lU = Tl, cU = Tl, fU = Tl, hU = Tl, dU = Tl, pU = Tl, vU = Tl;
function gU(r) {
  throw new Error("process.binding is not supported");
}
function mU() {
  return "/";
}
function yU(r) {
  throw new Error("process.chdir is not supported");
}
function bU() {
  return 0;
}
var vc = D1.performance || {}, wU = vc.now || vc.mozNow || vc.msNow || vc.oNow || vc.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function AU(r) {
  var e = wU.call(vc) * 1e-3, t = Math.floor(e), n = Math.floor(e % 1 * 1e9);
  return r && (t = t - r[0], n = n - r[1], n < 0 && (t--, n += 1e9)), [t, n];
}
var xU = /* @__PURE__ */ new Date();
function EU() {
  var r = /* @__PURE__ */ new Date(), e = r - xU;
  return e / 1e3;
}
var _i = {
  nextTick: QM,
  title: eU,
  browser: rU,
  env: nU,
  argv: iU,
  version: aU,
  versions: oU,
  on: lU,
  addListener: cU,
  once: fU,
  off: hU,
  removeListener: dU,
  removeAllListeners: pU,
  emit: vU,
  binding: gU,
  cwd: mU,
  chdir: yU,
  umask: bU,
  hrtime: AU,
  platform: tU,
  release: sU,
  config: uU,
  uptime: EU
}, Wv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _U(r) {
  if (r.__esModule) return r;
  var e = Object.defineProperty({}, "__esModule", { value: !0 });
  return Object.keys(r).forEach(function(t) {
    var n = Object.getOwnPropertyDescriptor(r, t);
    Object.defineProperty(e, t, n.get ? n : {
      enumerable: !0,
      get: function() {
        return r[t];
      }
    });
  }), e;
}
var aA = {}, yo = {}, a5 = {};
a5.byteLength = kU;
a5.toByteArray = CU;
a5.fromByteArray = RU;
var ao = [], Ki = [], DU = typeof Uint8Array < "u" ? Uint8Array : Array, Dp = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var nc = 0, TU = Dp.length; nc < TU; ++nc)
  ao[nc] = Dp[nc], Ki[Dp.charCodeAt(nc)] = nc;
Ki[45] = 62;
Ki[95] = 63;
function oA(r) {
  var e = r.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var t = r.indexOf("=");
  t === -1 && (t = e);
  var n = t === e ? 0 : 4 - t % 4;
  return [t, n];
}
function kU(r) {
  var e = oA(r), t = e[0], n = e[1];
  return (t + n) * 3 / 4 - n;
}
function SU(r, e, t) {
  return (e + t) * 3 / 4 - t;
}
function CU(r) {
  var e, t = oA(r), n = t[0], i = t[1], a = new DU(SU(r, n, i)), o = 0, s = i > 0 ? n - 4 : n, c;
  for (c = 0; c < s; c += 4)
    e = Ki[r.charCodeAt(c)] << 18 | Ki[r.charCodeAt(c + 1)] << 12 | Ki[r.charCodeAt(c + 2)] << 6 | Ki[r.charCodeAt(c + 3)], a[o++] = e >> 16 & 255, a[o++] = e >> 8 & 255, a[o++] = e & 255;
  return i === 2 && (e = Ki[r.charCodeAt(c)] << 2 | Ki[r.charCodeAt(c + 1)] >> 4, a[o++] = e & 255), i === 1 && (e = Ki[r.charCodeAt(c)] << 10 | Ki[r.charCodeAt(c + 1)] << 4 | Ki[r.charCodeAt(c + 2)] >> 2, a[o++] = e >> 8 & 255, a[o++] = e & 255), a;
}
function FU(r) {
  return ao[r >> 18 & 63] + ao[r >> 12 & 63] + ao[r >> 6 & 63] + ao[r & 63];
}
function OU(r, e, t) {
  for (var n, i = [], a = e; a < t; a += 3)
    n = (r[a] << 16 & 16711680) + (r[a + 1] << 8 & 65280) + (r[a + 2] & 255), i.push(FU(n));
  return i.join("");
}
function RU(r) {
  for (var e, t = r.length, n = t % 3, i = [], a = 16383, o = 0, s = t - n; o < s; o += a)
    i.push(OU(r, o, o + a > s ? s : o + a));
  return n === 1 ? (e = r[t - 1], i.push(ao[e >> 2] + ao[e << 4 & 63] + "==")) : n === 2 && (e = (r[t - 2] << 8) + r[t - 1], i.push(ao[e >> 10] + ao[e >> 4 & 63] + ao[e << 2 & 63] + "=")), i.join("");
}
var Gv = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Gv.read = function(r, e, t, n, i) {
  var a, o, s = i * 8 - n - 1, c = (1 << s) - 1, h = c >> 1, d = -7, g = t ? i - 1 : 0, x = t ? -1 : 1, _ = r[e + g];
  for (g += x, a = _ & (1 << -d) - 1, _ >>= -d, d += s; d > 0; a = a * 256 + r[e + g], g += x, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += n; d > 0; o = o * 256 + r[e + g], g += x, d -= 8)
    ;
  if (a === 0)
    a = 1 - h;
  else {
    if (a === c)
      return o ? NaN : (_ ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), a = a - h;
  }
  return (_ ? -1 : 1) * o * Math.pow(2, a - n);
};
Gv.write = function(r, e, t, n, i, a) {
  var o, s, c, h = a * 8 - i - 1, d = (1 << h) - 1, g = d >> 1, x = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, _ = n ? 0 : a - 1, k = n ? 1 : -1, P = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + g >= 1 ? e += x / c : e += x * Math.pow(2, 1 - g), e * c >= 2 && (o++, c /= 2), o + g >= d ? (s = 0, o = d) : o + g >= 1 ? (s = (e * c - 1) * Math.pow(2, i), o = o + g) : (s = e * Math.pow(2, g - 1) * Math.pow(2, i), o = 0)); i >= 8; r[t + _] = s & 255, _ += k, s /= 256, i -= 8)
    ;
  for (o = o << i | s, h += i; h > 0; r[t + _] = o & 255, _ += k, o /= 256, h -= 8)
    ;
  r[t + _ - k] |= P * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(r) {
  var e = a5, t = Gv, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  r.Buffer = s, r.SlowBuffer = G, r.INSPECT_MAX_BYTES = 50;
  var i = 2147483647;
  r.kMaxLength = i, s.TYPED_ARRAY_SUPPORT = a(), !s.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
  function a() {
    try {
      var S = new Uint8Array(1), b = {
        foo: function() {
          return 42;
        }
      };
      return Object.setPrototypeOf(b, Uint8Array.prototype), Object.setPrototypeOf(S, b), S.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(s.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(s.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(S) {
    if (S > i)
      throw new RangeError('The value "' + S + '" is invalid for option "size"');
    var b = new Uint8Array(S);
    return Object.setPrototypeOf(b, s.prototype), b;
  }
  function s(S, b, w) {
    if (typeof S == "number") {
      if (typeof b == "string")
        throw new TypeError('The "string" argument must be of type string. Received type number');
      return g(S);
    }
    return c(S, b, w);
  }
  s.poolSize = 8192;
  function c(S, b, w) {
    if (typeof S == "string")
      return x(S, b);
    if (ArrayBuffer.isView(S))
      return k(S);
    if (S == null)
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof S);
    if (ct(S, ArrayBuffer) || S && ct(S.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ct(S, SharedArrayBuffer) || S && ct(S.buffer, SharedArrayBuffer)))
      return P(S, b, w);
    if (typeof S == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    var T = S.valueOf && S.valueOf();
    if (T != null && T !== S)
      return s.from(T, b, w);
    var V = N(S);
    if (V) return V;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof S[Symbol.toPrimitive] == "function")
      return s.from(S[Symbol.toPrimitive]("string"), b, w);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof S);
  }
  s.from = function(S, b, w) {
    return c(S, b, w);
  }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
  function h(S) {
    if (typeof S != "number")
      throw new TypeError('"size" argument must be of type number');
    if (S < 0)
      throw new RangeError('The value "' + S + '" is invalid for option "size"');
  }
  function d(S, b, w) {
    return h(S), S <= 0 ? o(S) : b !== void 0 ? typeof w == "string" ? o(S).fill(b, w) : o(S).fill(b) : o(S);
  }
  s.alloc = function(S, b, w) {
    return d(S, b, w);
  };
  function g(S) {
    return h(S), o(S < 0 ? 0 : M(S) | 0);
  }
  s.allocUnsafe = function(S) {
    return g(S);
  }, s.allocUnsafeSlow = function(S) {
    return g(S);
  };
  function x(S, b) {
    if ((typeof b != "string" || b === "") && (b = "utf8"), !s.isEncoding(b))
      throw new TypeError("Unknown encoding: " + b);
    var w = z(S, b) | 0, T = o(w), V = T.write(S, b);
    return V !== w && (T = T.slice(0, V)), T;
  }
  function _(S) {
    for (var b = S.length < 0 ? 0 : M(S.length) | 0, w = o(b), T = 0; T < b; T += 1)
      w[T] = S[T] & 255;
    return w;
  }
  function k(S) {
    if (ct(S, Uint8Array)) {
      var b = new Uint8Array(S);
      return P(b.buffer, b.byteOffset, b.byteLength);
    }
    return _(S);
  }
  function P(S, b, w) {
    if (b < 0 || S.byteLength < b)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (S.byteLength < b + (w || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    var T;
    return b === void 0 && w === void 0 ? T = new Uint8Array(S) : w === void 0 ? T = new Uint8Array(S, b) : T = new Uint8Array(S, b, w), Object.setPrototypeOf(T, s.prototype), T;
  }
  function N(S) {
    if (s.isBuffer(S)) {
      var b = M(S.length) | 0, w = o(b);
      return w.length === 0 || S.copy(w, 0, 0, b), w;
    }
    if (S.length !== void 0)
      return typeof S.length != "number" || pt(S.length) ? o(0) : _(S);
    if (S.type === "Buffer" && Array.isArray(S.data))
      return _(S.data);
  }
  function M(S) {
    if (S >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return S | 0;
  }
  function G(S) {
    return +S != S && (S = 0), s.alloc(+S);
  }
  s.isBuffer = function(b) {
    return b != null && b._isBuffer === !0 && b !== s.prototype;
  }, s.compare = function(b, w) {
    if (ct(b, Uint8Array) && (b = s.from(b, b.offset, b.byteLength)), ct(w, Uint8Array) && (w = s.from(w, w.offset, w.byteLength)), !s.isBuffer(b) || !s.isBuffer(w))
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (b === w) return 0;
    for (var T = b.length, V = w.length, pe = 0, Ee = Math.min(T, V); pe < Ee; ++pe)
      if (b[pe] !== w[pe]) {
        T = b[pe], V = w[pe];
        break;
      }
    return T < V ? -1 : V < T ? 1 : 0;
  }, s.isEncoding = function(b) {
    switch (String(b).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, s.concat = function(b, w) {
    if (!Array.isArray(b))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (b.length === 0)
      return s.alloc(0);
    var T;
    if (w === void 0)
      for (w = 0, T = 0; T < b.length; ++T)
        w += b[T].length;
    var V = s.allocUnsafe(w), pe = 0;
    for (T = 0; T < b.length; ++T) {
      var Ee = b[T];
      if (ct(Ee, Uint8Array))
        pe + Ee.length > V.length ? s.from(Ee).copy(V, pe) : Uint8Array.prototype.set.call(V, Ee, pe);
      else if (s.isBuffer(Ee))
        Ee.copy(V, pe);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      pe += Ee.length;
    }
    return V;
  };
  function z(S, b) {
    if (s.isBuffer(S))
      return S.length;
    if (ArrayBuffer.isView(S) || ct(S, ArrayBuffer))
      return S.byteLength;
    if (typeof S != "string")
      throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof S);
    var w = S.length, T = arguments.length > 2 && arguments[2] === !0;
    if (!T && w === 0) return 0;
    for (var V = !1; ; )
      switch (b) {
        case "ascii":
        case "latin1":
        case "binary":
          return w;
        case "utf8":
        case "utf-8":
          return be(S).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return w * 2;
        case "hex":
          return w >>> 1;
        case "base64":
          return De(S).length;
        default:
          if (V)
            return T ? -1 : be(S).length;
          b = ("" + b).toLowerCase(), V = !0;
      }
  }
  s.byteLength = z;
  function j(S, b, w) {
    var T = !1;
    if ((b === void 0 || b < 0) && (b = 0), b > this.length || ((w === void 0 || w > this.length) && (w = this.length), w <= 0) || (w >>>= 0, b >>>= 0, w <= b))
      return "";
    for (S || (S = "utf8"); ; )
      switch (S) {
        case "hex":
          return _e(this, b, w);
        case "utf8":
        case "utf-8":
          return H(this, b, w);
        case "ascii":
          return me(this, b, w);
        case "latin1":
        case "binary":
          return fe(this, b, w);
        case "base64":
          return q(this, b, w);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Re(this, b, w);
        default:
          if (T) throw new TypeError("Unknown encoding: " + S);
          S = (S + "").toLowerCase(), T = !0;
      }
  }
  s.prototype._isBuffer = !0;
  function R(S, b, w) {
    var T = S[b];
    S[b] = S[w], S[w] = T;
  }
  s.prototype.swap16 = function() {
    var b = this.length;
    if (b % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var w = 0; w < b; w += 2)
      R(this, w, w + 1);
    return this;
  }, s.prototype.swap32 = function() {
    var b = this.length;
    if (b % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var w = 0; w < b; w += 4)
      R(this, w, w + 3), R(this, w + 1, w + 2);
    return this;
  }, s.prototype.swap64 = function() {
    var b = this.length;
    if (b % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var w = 0; w < b; w += 8)
      R(this, w, w + 7), R(this, w + 1, w + 6), R(this, w + 2, w + 5), R(this, w + 3, w + 4);
    return this;
  }, s.prototype.toString = function() {
    var b = this.length;
    return b === 0 ? "" : arguments.length === 0 ? H(this, 0, b) : j.apply(this, arguments);
  }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(b) {
    if (!s.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    return this === b ? !0 : s.compare(this, b) === 0;
  }, s.prototype.inspect = function() {
    var b = "", w = r.INSPECT_MAX_BYTES;
    return b = this.toString("hex", 0, w).replace(/(.{2})/g, "$1 ").trim(), this.length > w && (b += " ... "), "<Buffer " + b + ">";
  }, n && (s.prototype[n] = s.prototype.inspect), s.prototype.compare = function(b, w, T, V, pe) {
    if (ct(b, Uint8Array) && (b = s.from(b, b.offset, b.byteLength)), !s.isBuffer(b))
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof b);
    if (w === void 0 && (w = 0), T === void 0 && (T = b ? b.length : 0), V === void 0 && (V = 0), pe === void 0 && (pe = this.length), w < 0 || T > b.length || V < 0 || pe > this.length)
      throw new RangeError("out of range index");
    if (V >= pe && w >= T)
      return 0;
    if (V >= pe)
      return -1;
    if (w >= T)
      return 1;
    if (w >>>= 0, T >>>= 0, V >>>= 0, pe >>>= 0, this === b) return 0;
    for (var Ee = pe - V, mt = T - w, gt = Math.min(Ee, mt), St = this.slice(V, pe), Bt = b.slice(w, T), yt = 0; yt < gt; ++yt)
      if (St[yt] !== Bt[yt]) {
        Ee = St[yt], mt = Bt[yt];
        break;
      }
    return Ee < mt ? -1 : mt < Ee ? 1 : 0;
  };
  function te(S, b, w, T, V) {
    if (S.length === 0) return -1;
    if (typeof w == "string" ? (T = w, w = 0) : w > 2147483647 ? w = 2147483647 : w < -2147483648 && (w = -2147483648), w = +w, pt(w) && (w = V ? 0 : S.length - 1), w < 0 && (w = S.length + w), w >= S.length) {
      if (V) return -1;
      w = S.length - 1;
    } else if (w < 0)
      if (V) w = 0;
      else return -1;
    if (typeof b == "string" && (b = s.from(b, T)), s.isBuffer(b))
      return b.length === 0 ? -1 : J(S, b, w, T, V);
    if (typeof b == "number")
      return b = b & 255, typeof Uint8Array.prototype.indexOf == "function" ? V ? Uint8Array.prototype.indexOf.call(S, b, w) : Uint8Array.prototype.lastIndexOf.call(S, b, w) : J(S, [b], w, T, V);
    throw new TypeError("val must be string, number or Buffer");
  }
  function J(S, b, w, T, V) {
    var pe = 1, Ee = S.length, mt = b.length;
    if (T !== void 0 && (T = String(T).toLowerCase(), T === "ucs2" || T === "ucs-2" || T === "utf16le" || T === "utf-16le")) {
      if (S.length < 2 || b.length < 2)
        return -1;
      pe = 2, Ee /= 2, mt /= 2, w /= 2;
    }
    function gt(E0, Er) {
      return pe === 1 ? E0[Er] : E0.readUInt16BE(Er * pe);
    }
    var St;
    if (V) {
      var Bt = -1;
      for (St = w; St < Ee; St++)
        if (gt(S, St) === gt(b, Bt === -1 ? 0 : St - Bt)) {
          if (Bt === -1 && (Bt = St), St - Bt + 1 === mt) return Bt * pe;
        } else
          Bt !== -1 && (St -= St - Bt), Bt = -1;
    } else
      for (w + mt > Ee && (w = Ee - mt), St = w; St >= 0; St--) {
        for (var yt = !0, P0 = 0; P0 < mt; P0++)
          if (gt(S, St + P0) !== gt(b, P0)) {
            yt = !1;
            break;
          }
        if (yt) return St;
      }
    return -1;
  }
  s.prototype.includes = function(b, w, T) {
    return this.indexOf(b, w, T) !== -1;
  }, s.prototype.indexOf = function(b, w, T) {
    return te(this, b, w, T, !0);
  }, s.prototype.lastIndexOf = function(b, w, T) {
    return te(this, b, w, T, !1);
  };
  function K(S, b, w, T) {
    w = Number(w) || 0;
    var V = S.length - w;
    T ? (T = Number(T), T > V && (T = V)) : T = V;
    var pe = b.length;
    T > pe / 2 && (T = pe / 2);
    for (var Ee = 0; Ee < T; ++Ee) {
      var mt = parseInt(b.substr(Ee * 2, 2), 16);
      if (pt(mt)) return Ee;
      S[w + Ee] = mt;
    }
    return Ee;
  }
  function ee(S, b, w, T) {
    return Qe(be(b, S.length - w), S, w, T);
  }
  function ve(S, b, w, T) {
    return Qe(he(b), S, w, T);
  }
  function de(S, b, w, T) {
    return Qe(De(b), S, w, T);
  }
  function B(S, b, w, T) {
    return Qe(ke(b, S.length - w), S, w, T);
  }
  s.prototype.write = function(b, w, T, V) {
    if (w === void 0)
      V = "utf8", T = this.length, w = 0;
    else if (T === void 0 && typeof w == "string")
      V = w, T = this.length, w = 0;
    else if (isFinite(w))
      w = w >>> 0, isFinite(T) ? (T = T >>> 0, V === void 0 && (V = "utf8")) : (V = T, T = void 0);
    else
      throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var pe = this.length - w;
    if ((T === void 0 || T > pe) && (T = pe), b.length > 0 && (T < 0 || w < 0) || w > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    V || (V = "utf8");
    for (var Ee = !1; ; )
      switch (V) {
        case "hex":
          return K(this, b, w, T);
        case "utf8":
        case "utf-8":
          return ee(this, b, w, T);
        case "ascii":
        case "latin1":
        case "binary":
          return ve(this, b, w, T);
        case "base64":
          return de(this, b, w, T);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return B(this, b, w, T);
        default:
          if (Ee) throw new TypeError("Unknown encoding: " + V);
          V = ("" + V).toLowerCase(), Ee = !0;
      }
  }, s.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function q(S, b, w) {
    return b === 0 && w === S.length ? e.fromByteArray(S) : e.fromByteArray(S.slice(b, w));
  }
  function H(S, b, w) {
    w = Math.min(S.length, w);
    for (var T = [], V = b; V < w; ) {
      var pe = S[V], Ee = null, mt = pe > 239 ? 4 : pe > 223 ? 3 : pe > 191 ? 2 : 1;
      if (V + mt <= w) {
        var gt, St, Bt, yt;
        switch (mt) {
          case 1:
            pe < 128 && (Ee = pe);
            break;
          case 2:
            gt = S[V + 1], (gt & 192) === 128 && (yt = (pe & 31) << 6 | gt & 63, yt > 127 && (Ee = yt));
            break;
          case 3:
            gt = S[V + 1], St = S[V + 2], (gt & 192) === 128 && (St & 192) === 128 && (yt = (pe & 15) << 12 | (gt & 63) << 6 | St & 63, yt > 2047 && (yt < 55296 || yt > 57343) && (Ee = yt));
            break;
          case 4:
            gt = S[V + 1], St = S[V + 2], Bt = S[V + 3], (gt & 192) === 128 && (St & 192) === 128 && (Bt & 192) === 128 && (yt = (pe & 15) << 18 | (gt & 63) << 12 | (St & 63) << 6 | Bt & 63, yt > 65535 && yt < 1114112 && (Ee = yt));
        }
      }
      Ee === null ? (Ee = 65533, mt = 1) : Ee > 65535 && (Ee -= 65536, T.push(Ee >>> 10 & 1023 | 55296), Ee = 56320 | Ee & 1023), T.push(Ee), V += mt;
    }
    return ne(T);
  }
  var oe = 4096;
  function ne(S) {
    var b = S.length;
    if (b <= oe)
      return String.fromCharCode.apply(String, S);
    for (var w = "", T = 0; T < b; )
      w += String.fromCharCode.apply(String, S.slice(T, T += oe));
    return w;
  }
  function me(S, b, w) {
    var T = "";
    w = Math.min(S.length, w);
    for (var V = b; V < w; ++V)
      T += String.fromCharCode(S[V] & 127);
    return T;
  }
  function fe(S, b, w) {
    var T = "";
    w = Math.min(S.length, w);
    for (var V = b; V < w; ++V)
      T += String.fromCharCode(S[V]);
    return T;
  }
  function _e(S, b, w) {
    var T = S.length;
    (!b || b < 0) && (b = 0), (!w || w < 0 || w > T) && (w = T);
    for (var V = "", pe = b; pe < w; ++pe)
      V += _t[S[pe]];
    return V;
  }
  function Re(S, b, w) {
    for (var T = S.slice(b, w), V = "", pe = 0; pe < T.length - 1; pe += 2)
      V += String.fromCharCode(T[pe] + T[pe + 1] * 256);
    return V;
  }
  s.prototype.slice = function(b, w) {
    var T = this.length;
    b = ~~b, w = w === void 0 ? T : ~~w, b < 0 ? (b += T, b < 0 && (b = 0)) : b > T && (b = T), w < 0 ? (w += T, w < 0 && (w = 0)) : w > T && (w = T), w < b && (w = b);
    var V = this.subarray(b, w);
    return Object.setPrototypeOf(V, s.prototype), V;
  };
  function Ie(S, b, w) {
    if (S % 1 !== 0 || S < 0) throw new RangeError("offset is not uint");
    if (S + b > w) throw new RangeError("Trying to access beyond buffer length");
  }
  s.prototype.readUintLE = s.prototype.readUIntLE = function(b, w, T) {
    b = b >>> 0, w = w >>> 0, T || Ie(b, w, this.length);
    for (var V = this[b], pe = 1, Ee = 0; ++Ee < w && (pe *= 256); )
      V += this[b + Ee] * pe;
    return V;
  }, s.prototype.readUintBE = s.prototype.readUIntBE = function(b, w, T) {
    b = b >>> 0, w = w >>> 0, T || Ie(b, w, this.length);
    for (var V = this[b + --w], pe = 1; w > 0 && (pe *= 256); )
      V += this[b + --w] * pe;
    return V;
  }, s.prototype.readUint8 = s.prototype.readUInt8 = function(b, w) {
    return b = b >>> 0, w || Ie(b, 1, this.length), this[b];
  }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 2, this.length), this[b] | this[b + 1] << 8;
  }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 2, this.length), this[b] << 8 | this[b + 1];
  }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), (this[b] | this[b + 1] << 8 | this[b + 2] << 16) + this[b + 3] * 16777216;
  }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), this[b] * 16777216 + (this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3]);
  }, s.prototype.readIntLE = function(b, w, T) {
    b = b >>> 0, w = w >>> 0, T || Ie(b, w, this.length);
    for (var V = this[b], pe = 1, Ee = 0; ++Ee < w && (pe *= 256); )
      V += this[b + Ee] * pe;
    return pe *= 128, V >= pe && (V -= Math.pow(2, 8 * w)), V;
  }, s.prototype.readIntBE = function(b, w, T) {
    b = b >>> 0, w = w >>> 0, T || Ie(b, w, this.length);
    for (var V = w, pe = 1, Ee = this[b + --V]; V > 0 && (pe *= 256); )
      Ee += this[b + --V] * pe;
    return pe *= 128, Ee >= pe && (Ee -= Math.pow(2, 8 * w)), Ee;
  }, s.prototype.readInt8 = function(b, w) {
    return b = b >>> 0, w || Ie(b, 1, this.length), this[b] & 128 ? (255 - this[b] + 1) * -1 : this[b];
  }, s.prototype.readInt16LE = function(b, w) {
    b = b >>> 0, w || Ie(b, 2, this.length);
    var T = this[b] | this[b + 1] << 8;
    return T & 32768 ? T | 4294901760 : T;
  }, s.prototype.readInt16BE = function(b, w) {
    b = b >>> 0, w || Ie(b, 2, this.length);
    var T = this[b + 1] | this[b] << 8;
    return T & 32768 ? T | 4294901760 : T;
  }, s.prototype.readInt32LE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), this[b] | this[b + 1] << 8 | this[b + 2] << 16 | this[b + 3] << 24;
  }, s.prototype.readInt32BE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), this[b] << 24 | this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3];
  }, s.prototype.readFloatLE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), t.read(this, b, !0, 23, 4);
  }, s.prototype.readFloatBE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), t.read(this, b, !1, 23, 4);
  }, s.prototype.readDoubleLE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 8, this.length), t.read(this, b, !0, 52, 8);
  }, s.prototype.readDoubleBE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 8, this.length), t.read(this, b, !1, 52, 8);
  };
  function W(S, b, w, T, V, pe) {
    if (!s.isBuffer(S)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (b > V || b < pe) throw new RangeError('"value" argument is out of bounds');
    if (w + T > S.length) throw new RangeError("Index out of range");
  }
  s.prototype.writeUintLE = s.prototype.writeUIntLE = function(b, w, T, V) {
    if (b = +b, w = w >>> 0, T = T >>> 0, !V) {
      var pe = Math.pow(2, 8 * T) - 1;
      W(this, b, w, T, pe, 0);
    }
    var Ee = 1, mt = 0;
    for (this[w] = b & 255; ++mt < T && (Ee *= 256); )
      this[w + mt] = b / Ee & 255;
    return w + T;
  }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(b, w, T, V) {
    if (b = +b, w = w >>> 0, T = T >>> 0, !V) {
      var pe = Math.pow(2, 8 * T) - 1;
      W(this, b, w, T, pe, 0);
    }
    var Ee = T - 1, mt = 1;
    for (this[w + Ee] = b & 255; --Ee >= 0 && (mt *= 256); )
      this[w + Ee] = b / mt & 255;
    return w + T;
  }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 1, 255, 0), this[w] = b & 255, w + 1;
  }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 2, 65535, 0), this[w] = b & 255, this[w + 1] = b >>> 8, w + 2;
  }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 2, 65535, 0), this[w] = b >>> 8, this[w + 1] = b & 255, w + 2;
  }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 4, 4294967295, 0), this[w + 3] = b >>> 24, this[w + 2] = b >>> 16, this[w + 1] = b >>> 8, this[w] = b & 255, w + 4;
  }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 4, 4294967295, 0), this[w] = b >>> 24, this[w + 1] = b >>> 16, this[w + 2] = b >>> 8, this[w + 3] = b & 255, w + 4;
  }, s.prototype.writeIntLE = function(b, w, T, V) {
    if (b = +b, w = w >>> 0, !V) {
      var pe = Math.pow(2, 8 * T - 1);
      W(this, b, w, T, pe - 1, -pe);
    }
    var Ee = 0, mt = 1, gt = 0;
    for (this[w] = b & 255; ++Ee < T && (mt *= 256); )
      b < 0 && gt === 0 && this[w + Ee - 1] !== 0 && (gt = 1), this[w + Ee] = (b / mt >> 0) - gt & 255;
    return w + T;
  }, s.prototype.writeIntBE = function(b, w, T, V) {
    if (b = +b, w = w >>> 0, !V) {
      var pe = Math.pow(2, 8 * T - 1);
      W(this, b, w, T, pe - 1, -pe);
    }
    var Ee = T - 1, mt = 1, gt = 0;
    for (this[w + Ee] = b & 255; --Ee >= 0 && (mt *= 256); )
      b < 0 && gt === 0 && this[w + Ee + 1] !== 0 && (gt = 1), this[w + Ee] = (b / mt >> 0) - gt & 255;
    return w + T;
  }, s.prototype.writeInt8 = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 1, 127, -128), b < 0 && (b = 255 + b + 1), this[w] = b & 255, w + 1;
  }, s.prototype.writeInt16LE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 2, 32767, -32768), this[w] = b & 255, this[w + 1] = b >>> 8, w + 2;
  }, s.prototype.writeInt16BE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 2, 32767, -32768), this[w] = b >>> 8, this[w + 1] = b & 255, w + 2;
  }, s.prototype.writeInt32LE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 4, 2147483647, -2147483648), this[w] = b & 255, this[w + 1] = b >>> 8, this[w + 2] = b >>> 16, this[w + 3] = b >>> 24, w + 4;
  }, s.prototype.writeInt32BE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 4, 2147483647, -2147483648), b < 0 && (b = 4294967295 + b + 1), this[w] = b >>> 24, this[w + 1] = b >>> 16, this[w + 2] = b >>> 8, this[w + 3] = b & 255, w + 4;
  };
  function Z(S, b, w, T, V, pe) {
    if (w + T > S.length) throw new RangeError("Index out of range");
    if (w < 0) throw new RangeError("Index out of range");
  }
  function se(S, b, w, T, V) {
    return b = +b, w = w >>> 0, V || Z(S, b, w, 4), t.write(S, b, w, T, 23, 4), w + 4;
  }
  s.prototype.writeFloatLE = function(b, w, T) {
    return se(this, b, w, !0, T);
  }, s.prototype.writeFloatBE = function(b, w, T) {
    return se(this, b, w, !1, T);
  };
  function ye(S, b, w, T, V) {
    return b = +b, w = w >>> 0, V || Z(S, b, w, 8), t.write(S, b, w, T, 52, 8), w + 8;
  }
  s.prototype.writeDoubleLE = function(b, w, T) {
    return ye(this, b, w, !0, T);
  }, s.prototype.writeDoubleBE = function(b, w, T) {
    return ye(this, b, w, !1, T);
  }, s.prototype.copy = function(b, w, T, V) {
    if (!s.isBuffer(b)) throw new TypeError("argument should be a Buffer");
    if (T || (T = 0), !V && V !== 0 && (V = this.length), w >= b.length && (w = b.length), w || (w = 0), V > 0 && V < T && (V = T), V === T || b.length === 0 || this.length === 0) return 0;
    if (w < 0)
      throw new RangeError("targetStart out of bounds");
    if (T < 0 || T >= this.length) throw new RangeError("Index out of range");
    if (V < 0) throw new RangeError("sourceEnd out of bounds");
    V > this.length && (V = this.length), b.length - w < V - T && (V = b.length - w + T);
    var pe = V - T;
    return this === b && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(w, T, V) : Uint8Array.prototype.set.call(b, this.subarray(T, V), w), pe;
  }, s.prototype.fill = function(b, w, T, V) {
    if (typeof b == "string") {
      if (typeof w == "string" ? (V = w, w = 0, T = this.length) : typeof T == "string" && (V = T, T = this.length), V !== void 0 && typeof V != "string")
        throw new TypeError("encoding must be a string");
      if (typeof V == "string" && !s.isEncoding(V))
        throw new TypeError("Unknown encoding: " + V);
      if (b.length === 1) {
        var pe = b.charCodeAt(0);
        (V === "utf8" && pe < 128 || V === "latin1") && (b = pe);
      }
    } else typeof b == "number" ? b = b & 255 : typeof b == "boolean" && (b = Number(b));
    if (w < 0 || this.length < w || this.length < T)
      throw new RangeError("Out of range index");
    if (T <= w)
      return this;
    w = w >>> 0, T = T === void 0 ? this.length : T >>> 0, b || (b = 0);
    var Ee;
    if (typeof b == "number")
      for (Ee = w; Ee < T; ++Ee)
        this[Ee] = b;
    else {
      var mt = s.isBuffer(b) ? b : s.from(b, V), gt = mt.length;
      if (gt === 0)
        throw new TypeError('The value "' + b + '" is invalid for argument "value"');
      for (Ee = 0; Ee < T - w; ++Ee)
        this[Ee + w] = mt[Ee % gt];
    }
    return this;
  };
  var Fe = /[^+/0-9A-Za-z-_]/g;
  function xe(S) {
    if (S = S.split("=")[0], S = S.trim().replace(Fe, ""), S.length < 2) return "";
    for (; S.length % 4 !== 0; )
      S = S + "=";
    return S;
  }
  function be(S, b) {
    b = b || 1 / 0;
    for (var w, T = S.length, V = null, pe = [], Ee = 0; Ee < T; ++Ee) {
      if (w = S.charCodeAt(Ee), w > 55295 && w < 57344) {
        if (!V) {
          if (w > 56319) {
            (b -= 3) > -1 && pe.push(239, 191, 189);
            continue;
          } else if (Ee + 1 === T) {
            (b -= 3) > -1 && pe.push(239, 191, 189);
            continue;
          }
          V = w;
          continue;
        }
        if (w < 56320) {
          (b -= 3) > -1 && pe.push(239, 191, 189), V = w;
          continue;
        }
        w = (V - 55296 << 10 | w - 56320) + 65536;
      } else V && (b -= 3) > -1 && pe.push(239, 191, 189);
      if (V = null, w < 128) {
        if ((b -= 1) < 0) break;
        pe.push(w);
      } else if (w < 2048) {
        if ((b -= 2) < 0) break;
        pe.push(w >> 6 | 192, w & 63 | 128);
      } else if (w < 65536) {
        if ((b -= 3) < 0) break;
        pe.push(w >> 12 | 224, w >> 6 & 63 | 128, w & 63 | 128);
      } else if (w < 1114112) {
        if ((b -= 4) < 0) break;
        pe.push(w >> 18 | 240, w >> 12 & 63 | 128, w >> 6 & 63 | 128, w & 63 | 128);
      } else
        throw new Error("Invalid code point");
    }
    return pe;
  }
  function he(S) {
    for (var b = [], w = 0; w < S.length; ++w)
      b.push(S.charCodeAt(w) & 255);
    return b;
  }
  function ke(S, b) {
    for (var w, T, V, pe = [], Ee = 0; Ee < S.length && !((b -= 2) < 0); ++Ee)
      w = S.charCodeAt(Ee), T = w >> 8, V = w % 256, pe.push(V), pe.push(T);
    return pe;
  }
  function De(S) {
    return e.toByteArray(xe(S));
  }
  function Qe(S, b, w, T) {
    for (var V = 0; V < T && !(V + w >= b.length || V >= S.length); ++V)
      b[V + w] = S[V];
    return V;
  }
  function ct(S, b) {
    return S instanceof b || S != null && S.constructor != null && S.constructor.name != null && S.constructor.name === b.name;
  }
  function pt(S) {
    return S !== S;
  }
  var _t = function() {
    for (var S = "0123456789abcdef", b = new Array(256), w = 0; w < 16; ++w)
      for (var T = w * 16, V = 0; V < 16; ++V)
        b[T + V] = S[w] + S[V];
    return b;
  }();
})(yo);
var K1 = { exports: {} }, Cc = typeof Reflect == "object" ? Reflect : null, lb = Cc && typeof Cc.apply == "function" ? Cc.apply : function(e, t, n) {
  return Function.prototype.apply.call(e, t, n);
}, kh;
Cc && typeof Cc.ownKeys == "function" ? kh = Cc.ownKeys : Object.getOwnPropertySymbols ? kh = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : kh = function(e) {
  return Object.getOwnPropertyNames(e);
};
function IU(r) {
  console && console.warn && console.warn(r);
}
var sA = Number.isNaN || function(e) {
  return e !== e;
};
function Jr() {
  Jr.init.call(this);
}
K1.exports = Jr;
K1.exports.once = LU;
Jr.EventEmitter = Jr;
Jr.prototype._events = void 0;
Jr.prototype._eventsCount = 0;
Jr.prototype._maxListeners = void 0;
var cb = 10;
function o5(r) {
  if (typeof r != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
}
Object.defineProperty(Jr, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return cb;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || sA(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    cb = e;
  }
});
Jr.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Jr.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || sA(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function uA(r) {
  return r._maxListeners === void 0 ? Jr.defaultMaxListeners : r._maxListeners;
}
Jr.prototype.getMaxListeners = function() {
  return uA(this);
};
Jr.prototype.emit = function(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t.push(arguments[n]);
  var i = e === "error", a = this._events;
  if (a !== void 0) i = i && a.error === void 0;
  else if (!i) return !1;
  if (i) {
    var o;
    if (t.length > 0 && (o = t[0]), o instanceof Error)
      throw o;
    var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw s.context = o, s;
  }
  var c = a[e];
  if (c === void 0) return !1;
  if (typeof c == "function")
    lb(c, this, t);
  else
    for (var h = c.length, d = dA(c, h), n = 0; n < h; ++n)
      lb(d[n], this, t);
  return !0;
};
function lA(r, e, t, n) {
  var i, a, o;
  if (o5(t), a = r._events, a === void 0 ? (a = r._events = /* @__PURE__ */ Object.create(null), r._eventsCount = 0) : (a.newListener !== void 0 && (r.emit("newListener", e, t.listener ? t.listener : t), a = r._events), o = a[e]), o === void 0)
    o = a[e] = t, ++r._eventsCount;
  else if (typeof o == "function" ? o = a[e] = n ? [t, o] : [o, t] : n ? o.unshift(t) : o.push(t), i = uA(r), i > 0 && o.length > i && !o.warned) {
    o.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = r, s.type = e, s.count = o.length, IU(s);
  }
  return r;
}
Jr.prototype.addListener = function(e, t) {
  return lA(this, e, t, !1);
};
Jr.prototype.on = Jr.prototype.addListener;
Jr.prototype.prependListener = function(e, t) {
  return lA(this, e, t, !0);
};
function PU() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function cA(r, e, t) {
  var n = {
    fired: !1,
    wrapFn: void 0,
    target: r,
    type: e,
    listener: t
  }, i = PU.bind(n);
  return i.listener = t, n.wrapFn = i, i;
}
Jr.prototype.once = function(e, t) {
  return o5(t), this.on(e, cA(this, e, t)), this;
};
Jr.prototype.prependOnceListener = function(e, t) {
  return o5(t), this.prependListener(e, cA(this, e, t)), this;
};
Jr.prototype.removeListener = function(e, t) {
  var n, i, a, o, s;
  if (o5(t), i = this._events, i === void 0) return this;
  if (n = i[e], n === void 0) return this;
  if (n === t || n.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || t));
  else if (typeof n != "function") {
    for (a = -1, o = n.length - 1; o >= 0; o--)
      if (n[o] === t || n[o].listener === t) {
        s = n[o].listener, a = o;
        break;
      }
    if (a < 0) return this;
    a === 0 ? n.shift() : BU(n, a), n.length === 1 && (i[e] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", e, s || t);
  }
  return this;
};
Jr.prototype.off = Jr.prototype.removeListener;
Jr.prototype.removeAllListeners = function(e) {
  var t, n, i;
  if (n = this._events, n === void 0) return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var a = Object.keys(n), o;
    for (i = 0; i < a.length; ++i)
      o = a[i], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = n[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (i = t.length - 1; i >= 0; i--)
      this.removeListener(e, t[i]);
  return this;
};
function fA(r, e, t) {
  var n = r._events;
  if (n === void 0) return [];
  var i = n[e];
  return i === void 0 ? [] : typeof i == "function" ? t ? [i.listener || i] : [i] : t ? NU(i) : dA(i, i.length);
}
Jr.prototype.listeners = function(e) {
  return fA(this, e, !0);
};
Jr.prototype.rawListeners = function(e) {
  return fA(this, e, !1);
};
Jr.listenerCount = function(r, e) {
  return typeof r.listenerCount == "function" ? r.listenerCount(e) : hA.call(r, e);
};
Jr.prototype.listenerCount = hA;
function hA(r) {
  var e = this._events;
  if (e !== void 0) {
    var t = e[r];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
Jr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? kh(this._events) : [];
};
function dA(r, e) {
  for (var t = new Array(e), n = 0; n < e; ++n)
    t[n] = r[n];
  return t;
}
function BU(r, e) {
  for (; e + 1 < r.length; e++)
    r[e] = r[e + 1];
  r.pop();
}
function NU(r) {
  for (var e = new Array(r.length), t = 0; t < e.length; ++t)
    e[t] = r[t].listener || r[t];
  return e;
}
function LU(r, e) {
  return new Promise(function(t, n) {
    function i(o) {
      r.removeListener(e, a), n(o);
    }
    function a() {
      typeof r.removeListener == "function" && r.removeListener("error", i), t([].slice.call(arguments));
    }
    pA(r, e, a, {
      once: !0
    }), e !== "error" && MU(r, i, {
      once: !0
    });
  });
}
function MU(r, e, t) {
  typeof r.on == "function" && pA(r, "error", e, t);
}
function pA(r, e, t, n) {
  if (typeof r.on == "function")
    n.once ? r.once(e, t) : r.on(e, t);
  else if (typeof r.addEventListener == "function")
    r.addEventListener(e, function i(a) {
      n.once && r.removeEventListener(e, i), t(a);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof r);
}
var af = K1.exports, Kn = {}, vA = {}, gA = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, t = Symbol("test"), n = Object(t);
  if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var i = 42;
  e[t] = i;
  for (t in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var a = Object.getOwnPropertySymbols(e);
  if (a.length !== 1 || a[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var o = Object.getOwnPropertyDescriptor(e, t);
    if (o.value !== i || o.enumerable !== !0)
      return !1;
  }
  return !0;
}, fb = typeof Symbol < "u" && Symbol, UU = gA, $U = function() {
  return typeof fb != "function" || typeof Symbol != "function" || typeof fb("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : UU();
}, zU = "Function.prototype.bind called on incompatible ", Tp = Array.prototype.slice, jU = Object.prototype.toString, WU = "[object Function]", GU = function(e) {
  var t = this;
  if (typeof t != "function" || jU.call(t) !== WU)
    throw new TypeError(zU + t);
  for (var n = Tp.call(arguments, 1), i, a = function() {
    if (this instanceof i) {
      var g = t.apply(this, n.concat(Tp.call(arguments)));
      return Object(g) === g ? g : this;
    } else
      return t.apply(e, n.concat(Tp.call(arguments)));
  }, o = Math.max(0, t.length - n.length), s = [], c = 0; c < o; c++)
    s.push("$" + c);
  if (i = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(a), t.prototype) {
    var h = function() {
    };
    h.prototype = t.prototype, i.prototype = new h(), h.prototype = null;
  }
  return i;
}, VU = GU, Vv = Function.prototype.bind || VU, YU = Vv, HU = YU.call(Function.call, Object.prototype.hasOwnProperty), Ar, T1 = SyntaxError, mA = Function, Fc = TypeError, kp = function(e) {
  try {
    return mA('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, hl = Object.getOwnPropertyDescriptor;
if (hl)
  try {
    hl({}, "");
  } catch {
    hl = null;
  }
var Sp = function() {
  throw new Fc();
}, ZU = hl ? function() {
  try {
    return arguments.callee, Sp;
  } catch {
    try {
      return hl(arguments, "callee").get;
    } catch {
      return Sp;
    }
  }
}() : Sp, ic = $U(), Bs = Object.getPrototypeOf || function(r) {
  return r.__proto__;
}, gc = {}, qU = typeof Uint8Array > "u" ? Ar : Bs(Uint8Array), Oc = {
  "%AggregateError%": typeof AggregateError > "u" ? Ar : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? Ar : ArrayBuffer,
  "%ArrayIteratorPrototype%": ic ? Bs([][Symbol.iterator]()) : Ar,
  "%AsyncFromSyncIteratorPrototype%": Ar,
  "%AsyncFunction%": gc,
  "%AsyncGenerator%": gc,
  "%AsyncGeneratorFunction%": gc,
  "%AsyncIteratorPrototype%": gc,
  "%Atomics%": typeof Atomics > "u" ? Ar : Atomics,
  "%BigInt%": typeof BigInt > "u" ? Ar : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? Ar : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? Ar : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? Ar : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? Ar : FinalizationRegistry,
  "%Function%": mA,
  "%GeneratorFunction%": gc,
  "%Int8Array%": typeof Int8Array > "u" ? Ar : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? Ar : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? Ar : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": ic ? Bs(Bs([][Symbol.iterator]())) : Ar,
  "%JSON%": typeof JSON == "object" ? JSON : Ar,
  "%Map%": typeof Map > "u" ? Ar : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !ic ? Ar : Bs((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? Ar : Promise,
  "%Proxy%": typeof Proxy > "u" ? Ar : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? Ar : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? Ar : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !ic ? Ar : Bs((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? Ar : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": ic ? Bs(""[Symbol.iterator]()) : Ar,
  "%Symbol%": ic ? Symbol : Ar,
  "%SyntaxError%": T1,
  "%ThrowTypeError%": ZU,
  "%TypedArray%": qU,
  "%TypeError%": Fc,
  "%Uint8Array%": typeof Uint8Array > "u" ? Ar : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? Ar : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? Ar : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? Ar : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? Ar : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? Ar : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? Ar : WeakSet
}, XU = function r(e) {
  var t;
  if (e === "%AsyncFunction%")
    t = kp("async function () {}");
  else if (e === "%GeneratorFunction%")
    t = kp("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    t = kp("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = r("%AsyncGeneratorFunction%");
    n && (t = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var i = r("%AsyncGenerator%");
    i && (t = Bs(i.prototype));
  }
  return Oc[e] = t, t;
}, hb = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, s5 = Vv, bd = HU, KU = s5.call(Function.call, Array.prototype.concat), JU = s5.call(Function.apply, Array.prototype.splice), db = s5.call(Function.call, String.prototype.replace), wd = s5.call(Function.call, String.prototype.slice), QU = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, e$ = /\\(\\)?/g, t$ = function(e) {
  var t = wd(e, 0, 1), n = wd(e, -1);
  if (t === "%" && n !== "%")
    throw new T1("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && t !== "%")
    throw new T1("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return db(e, QU, function(a, o, s, c) {
    i[i.length] = s ? db(c, e$, "$1") : o || a;
  }), i;
}, r$ = function(e, t) {
  var n = e, i;
  if (bd(hb, n) && (i = hb[n], n = "%" + i[0] + "%"), bd(Oc, n)) {
    var a = Oc[n];
    if (a === gc && (a = XU(n)), typeof a > "u" && !t)
      throw new Fc("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: n,
      value: a
    };
  }
  throw new T1("intrinsic " + e + " does not exist!");
}, Yv = function(e, t) {
  if (typeof e != "string" || e.length === 0)
    throw new Fc("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof t != "boolean")
    throw new Fc('"allowMissing" argument must be a boolean');
  var n = t$(e), i = n.length > 0 ? n[0] : "", a = r$("%" + i + "%", t), o = a.name, s = a.value, c = !1, h = a.alias;
  h && (i = h[0], JU(n, KU([0, 1], h)));
  for (var d = 1, g = !0; d < n.length; d += 1) {
    var x = n[d], _ = wd(x, 0, 1), k = wd(x, -1);
    if ((_ === '"' || _ === "'" || _ === "`" || k === '"' || k === "'" || k === "`") && _ !== k)
      throw new T1("property names with quotes must have matching quotes");
    if ((x === "constructor" || !g) && (c = !0), i += "." + x, o = "%" + i + "%", bd(Oc, o))
      s = Oc[o];
    else if (s != null) {
      if (!(x in s)) {
        if (!t)
          throw new Fc("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (hl && d + 1 >= n.length) {
        var P = hl(s, x);
        g = !!P, g && "get" in P && !("originalValue" in P.get) ? s = P.get : s = s[x];
      } else
        g = bd(s, x), s = s[x];
      g && !c && (Oc[o] = s);
    }
  }
  return s;
}, u5 = { exports: {} };
(function(r) {
  var e = Vv, t = Yv, n = t("%Function.prototype.apply%"), i = t("%Function.prototype.call%"), a = t("%Reflect.apply%", !0) || e.call(i, n), o = t("%Object.getOwnPropertyDescriptor%", !0), s = t("%Object.defineProperty%", !0), c = t("%Math.max%");
  if (s)
    try {
      s({}, "a", {
        value: 1
      });
    } catch {
      s = null;
    }
  r.exports = function(g) {
    var x = a(e, i, arguments);
    if (o && s) {
      var _ = o(x, "length");
      _.configurable && s(x, "length", {
        value: 1 + c(0, g.length - (arguments.length - 1))
      });
    }
    return x;
  };
  var h = function() {
    return a(e, n, arguments);
  };
  s ? s(r.exports, "apply", {
    value: h
  }) : r.exports.apply = h;
})(u5);
var yA = Yv, bA = u5.exports, n$ = bA(yA("String.prototype.indexOf")), Hv = function(e, t) {
  var n = yA(e, !!t);
  return typeof n == "function" && n$(e, ".prototype.") > -1 ? bA(n) : n;
}, i$ = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol", a$ = Hv, v3 = a$("Object.prototype.toString"), l5 = function(e) {
  return i$ && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : v3(e) === "[object Arguments]";
}, wA = function(e) {
  return l5(e) ? !0 : e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && v3(e) !== "[object Array]" && v3(e.callee) === "[object Function]";
}, o$ = function() {
  return l5(arguments);
}();
l5.isLegacyArguments = wA;
var s$ = o$ ? l5 : wA, u$ = gA, Zv = function() {
  return u$() && !!Symbol.toStringTag;
}, l$ = Object.prototype.toString, c$ = Function.prototype.toString, f$ = /^\s*(?:function)?\*/, AA = Zv(), Cp = Object.getPrototypeOf, h$ = function() {
  if (!AA)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, Fp, d$ = function(e) {
  if (typeof e != "function")
    return !1;
  if (f$.test(c$.call(e)))
    return !0;
  if (!AA) {
    var t = l$.call(e);
    return t === "[object GeneratorFunction]";
  }
  if (!Cp)
    return !1;
  if (typeof Fp > "u") {
    var n = h$();
    Fp = n ? Cp(n) : !1;
  }
  return Cp(e) === Fp;
}, p$ = Object.prototype.hasOwnProperty, v$ = Object.prototype.toString, xA = function(e, t, n) {
  if (v$.call(t) !== "[object Function]")
    throw new TypeError("iterator must be a function");
  var i = e.length;
  if (i === +i)
    for (var a = 0; a < i; a++)
      t.call(n, e[a], a, e);
  else
    for (var o in e)
      p$.call(e, o) && t.call(n, e[o], o, e);
}, Op = ["BigInt64Array", "BigUint64Array", "Float32Array", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray"], g$ = typeof globalThis > "u" ? Wv : globalThis, EA = function() {
  for (var e = [], t = 0; t < Op.length; t++)
    typeof g$[Op[t]] == "function" && (e[e.length] = Op[t]);
  return e;
}, m$ = Yv, Sh = m$("%Object.getOwnPropertyDescriptor%", !0);
if (Sh)
  try {
    Sh([], "length");
  } catch {
    Sh = null;
  }
var _A = Sh, DA = xA, y$ = EA, qv = Hv, b$ = qv("Object.prototype.toString"), TA = Zv(), w$ = typeof globalThis > "u" ? Wv : globalThis, kA = y$(), A$ = qv("Array.prototype.indexOf", !0) || function(e, t) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n] === t)
      return n;
  return -1;
}, x$ = qv("String.prototype.slice"), SA = {}, Ch = _A, Rp = Object.getPrototypeOf;
TA && Ch && Rp && DA(kA, function(r) {
  var e = new w$[r]();
  if (Symbol.toStringTag in e) {
    var t = Rp(e), n = Ch(t, Symbol.toStringTag);
    if (!n) {
      var i = Rp(t);
      n = Ch(i, Symbol.toStringTag);
    }
    SA[r] = n.get;
  }
});
var E$ = function(e) {
  var t = !1;
  return DA(SA, function(n, i) {
    if (!t)
      try {
        t = n.call(e) === i;
      } catch {
      }
  }), t;
}, CA = function(e) {
  if (!e || typeof e != "object")
    return !1;
  if (!TA || !(Symbol.toStringTag in e)) {
    var t = x$(b$(e), 8, -1);
    return A$(kA, t) > -1;
  }
  return Ch ? E$(e) : !1;
}, FA = xA, _$ = EA, OA = Hv, D$ = OA("Object.prototype.toString"), RA = Zv(), pb = typeof globalThis > "u" ? Wv : globalThis, T$ = _$(), k$ = OA("String.prototype.slice"), IA = {}, Ip = _A, Pp = Object.getPrototypeOf;
RA && Ip && Pp && FA(T$, function(r) {
  if (typeof pb[r] == "function") {
    var e = new pb[r]();
    if (Symbol.toStringTag in e) {
      var t = Pp(e), n = Ip(t, Symbol.toStringTag);
      if (!n) {
        var i = Pp(t);
        n = Ip(i, Symbol.toStringTag);
      }
      IA[r] = n.get;
    }
  }
});
var S$ = function(e) {
  var t = !1;
  return FA(IA, function(n, i) {
    if (!t)
      try {
        var a = n.call(e);
        a === i && (t = a);
      } catch {
      }
  }), t;
}, C$ = CA, F$ = function(e) {
  return C$(e) ? !RA || !(Symbol.toStringTag in e) ? k$(D$(e), 8, -1) : S$(e) : !1;
};
(function(r) {
  var e = s$, t = d$, n = F$, i = CA;
  function a(T) {
    return T.call.bind(T);
  }
  var o = typeof BigInt < "u", s = typeof Symbol < "u", c = a(Object.prototype.toString), h = a(Number.prototype.valueOf), d = a(String.prototype.valueOf), g = a(Boolean.prototype.valueOf);
  if (o)
    var x = a(BigInt.prototype.valueOf);
  if (s)
    var _ = a(Symbol.prototype.valueOf);
  function k(T, V) {
    if (typeof T != "object")
      return !1;
    try {
      return V(T), !0;
    } catch {
      return !1;
    }
  }
  r.isArgumentsObject = e, r.isGeneratorFunction = t, r.isTypedArray = i;
  function P(T) {
    return typeof Promise < "u" && T instanceof Promise || T !== null && typeof T == "object" && typeof T.then == "function" && typeof T.catch == "function";
  }
  r.isPromise = P;
  function N(T) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(T) : i(T) || Z(T);
  }
  r.isArrayBufferView = N;
  function M(T) {
    return n(T) === "Uint8Array";
  }
  r.isUint8Array = M;
  function G(T) {
    return n(T) === "Uint8ClampedArray";
  }
  r.isUint8ClampedArray = G;
  function z(T) {
    return n(T) === "Uint16Array";
  }
  r.isUint16Array = z;
  function j(T) {
    return n(T) === "Uint32Array";
  }
  r.isUint32Array = j;
  function R(T) {
    return n(T) === "Int8Array";
  }
  r.isInt8Array = R;
  function te(T) {
    return n(T) === "Int16Array";
  }
  r.isInt16Array = te;
  function J(T) {
    return n(T) === "Int32Array";
  }
  r.isInt32Array = J;
  function K(T) {
    return n(T) === "Float32Array";
  }
  r.isFloat32Array = K;
  function ee(T) {
    return n(T) === "Float64Array";
  }
  r.isFloat64Array = ee;
  function ve(T) {
    return n(T) === "BigInt64Array";
  }
  r.isBigInt64Array = ve;
  function de(T) {
    return n(T) === "BigUint64Array";
  }
  r.isBigUint64Array = de;
  function B(T) {
    return c(T) === "[object Map]";
  }
  B.working = typeof Map < "u" && B(/* @__PURE__ */ new Map());
  function q(T) {
    return typeof Map > "u" ? !1 : B.working ? B(T) : T instanceof Map;
  }
  r.isMap = q;
  function H(T) {
    return c(T) === "[object Set]";
  }
  H.working = typeof Set < "u" && H(/* @__PURE__ */ new Set());
  function oe(T) {
    return typeof Set > "u" ? !1 : H.working ? H(T) : T instanceof Set;
  }
  r.isSet = oe;
  function ne(T) {
    return c(T) === "[object WeakMap]";
  }
  ne.working = typeof WeakMap < "u" && ne(/* @__PURE__ */ new WeakMap());
  function me(T) {
    return typeof WeakMap > "u" ? !1 : ne.working ? ne(T) : T instanceof WeakMap;
  }
  r.isWeakMap = me;
  function fe(T) {
    return c(T) === "[object WeakSet]";
  }
  fe.working = typeof WeakSet < "u" && fe(/* @__PURE__ */ new WeakSet());
  function _e(T) {
    return fe(T);
  }
  r.isWeakSet = _e;
  function Re(T) {
    return c(T) === "[object ArrayBuffer]";
  }
  Re.working = typeof ArrayBuffer < "u" && Re(new ArrayBuffer());
  function Ie(T) {
    return typeof ArrayBuffer > "u" ? !1 : Re.working ? Re(T) : T instanceof ArrayBuffer;
  }
  r.isArrayBuffer = Ie;
  function W(T) {
    return c(T) === "[object DataView]";
  }
  W.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && W(new DataView(new ArrayBuffer(1), 0, 1));
  function Z(T) {
    return typeof DataView > "u" ? !1 : W.working ? W(T) : T instanceof DataView;
  }
  r.isDataView = Z;
  var se = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function ye(T) {
    return c(T) === "[object SharedArrayBuffer]";
  }
  function Fe(T) {
    return typeof se > "u" ? !1 : (typeof ye.working > "u" && (ye.working = ye(new se())), ye.working ? ye(T) : T instanceof se);
  }
  r.isSharedArrayBuffer = Fe;
  function xe(T) {
    return c(T) === "[object AsyncFunction]";
  }
  r.isAsyncFunction = xe;
  function be(T) {
    return c(T) === "[object Map Iterator]";
  }
  r.isMapIterator = be;
  function he(T) {
    return c(T) === "[object Set Iterator]";
  }
  r.isSetIterator = he;
  function ke(T) {
    return c(T) === "[object Generator]";
  }
  r.isGeneratorObject = ke;
  function De(T) {
    return c(T) === "[object WebAssembly.Module]";
  }
  r.isWebAssemblyCompiledModule = De;
  function Qe(T) {
    return k(T, h);
  }
  r.isNumberObject = Qe;
  function ct(T) {
    return k(T, d);
  }
  r.isStringObject = ct;
  function pt(T) {
    return k(T, g);
  }
  r.isBooleanObject = pt;
  function _t(T) {
    return o && k(T, x);
  }
  r.isBigIntObject = _t;
  function S(T) {
    return s && k(T, _);
  }
  r.isSymbolObject = S;
  function b(T) {
    return Qe(T) || ct(T) || pt(T) || _t(T) || S(T);
  }
  r.isBoxedPrimitive = b;
  function w(T) {
    return typeof Uint8Array < "u" && (Ie(T) || Fe(T));
  }
  r.isAnyArrayBuffer = w, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(T) {
    Object.defineProperty(r, T, {
      enumerable: !1,
      value: function() {
        throw new Error(T + " is not supported in userland");
      }
    });
  });
})(vA);
var O$ = function(e) {
  return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
}, g3 = { exports: {} };
typeof Object.create == "function" ? g3.exports = function(e, t) {
  t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : g3.exports = function(e, t) {
  if (t) {
    e.super_ = t;
    var n = function() {
    };
    n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
(function(r) {
  var e = Object.getOwnPropertyDescriptors || function(Z) {
    for (var se = Object.keys(Z), ye = {}, Fe = 0; Fe < se.length; Fe++)
      ye[se[Fe]] = Object.getOwnPropertyDescriptor(Z, se[Fe]);
    return ye;
  }, t = /%[sdj%]/g;
  r.format = function(W) {
    if (!R(W)) {
      for (var Z = [], se = 0; se < arguments.length; se++)
        Z.push(o(arguments[se]));
      return Z.join(" ");
    }
    for (var se = 1, ye = arguments, Fe = ye.length, xe = String(W).replace(t, function(he) {
      if (he === "%%") return "%";
      if (se >= Fe) return he;
      switch (he) {
        case "%s":
          return String(ye[se++]);
        case "%d":
          return Number(ye[se++]);
        case "%j":
          try {
            return JSON.stringify(ye[se++]);
          } catch {
            return "[Circular]";
          }
        default:
          return he;
      }
    }), be = ye[se]; se < Fe; be = ye[++se])
      G(be) || !ee(be) ? xe += " " + be : xe += " " + o(be);
    return xe;
  }, r.deprecate = function(W, Z) {
    if (typeof _i < "u" && _i.noDeprecation === !0)
      return W;
    if (typeof _i > "u")
      return function() {
        return r.deprecate(W, Z).apply(this, arguments);
      };
    var se = !1;
    function ye() {
      return se || (console.error(Z), se = !0), W.apply(this, arguments);
    }
    return ye;
  };
  var n = {}, i = /^$/;
  if (_i.env.NODE_DEBUG) {
    var a = _i.env.NODE_DEBUG;
    a = a.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = new RegExp("^" + a + "$", "i");
  }
  r.debuglog = function(W) {
    if (W = W.toUpperCase(), !n[W])
      if (i.test(W)) {
        var Z = _i.pid;
        n[W] = function() {
          var se = r.format.apply(r, arguments);
          console.error("%s %d: %s", W, Z, se);
        };
      } else
        n[W] = function() {
        };
    return n[W];
  };
  function o(W, Z) {
    var se = {
      seen: [],
      stylize: c
    };
    return arguments.length >= 3 && (se.depth = arguments[2]), arguments.length >= 4 && (se.colors = arguments[3]), M(Z) ? se.showHidden = Z : Z && r._extend(se, Z), J(se.showHidden) && (se.showHidden = !1), J(se.depth) && (se.depth = 2), J(se.colors) && (se.colors = !1), J(se.customInspect) && (se.customInspect = !0), se.colors && (se.stylize = s), d(se, W, se.depth);
  }
  r.inspect = o, o.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, o.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function s(W, Z) {
    var se = o.styles[Z];
    return se ? "\x1B[" + o.colors[se][0] + "m" + W + "\x1B[" + o.colors[se][1] + "m" : W;
  }
  function c(W, Z) {
    return W;
  }
  function h(W) {
    var Z = {};
    return W.forEach(function(se, ye) {
      Z[se] = !0;
    }), Z;
  }
  function d(W, Z, se) {
    if (W.customInspect && Z && B(Z.inspect) && // Filter out the util module, it's inspect function is special
    Z.inspect !== r.inspect && // Also filter out any prototype objects using the circular check.
    !(Z.constructor && Z.constructor.prototype === Z)) {
      var ye = Z.inspect(se, W);
      return R(ye) || (ye = d(W, ye, se)), ye;
    }
    var Fe = g(W, Z);
    if (Fe)
      return Fe;
    var xe = Object.keys(Z), be = h(xe);
    if (W.showHidden && (xe = Object.getOwnPropertyNames(Z)), de(Z) && (xe.indexOf("message") >= 0 || xe.indexOf("description") >= 0))
      return x(Z);
    if (xe.length === 0) {
      if (B(Z)) {
        var he = Z.name ? ": " + Z.name : "";
        return W.stylize("[Function" + he + "]", "special");
      }
      if (K(Z))
        return W.stylize(RegExp.prototype.toString.call(Z), "regexp");
      if (ve(Z))
        return W.stylize(Date.prototype.toString.call(Z), "date");
      if (de(Z))
        return x(Z);
    }
    var ke = "", De = !1, Qe = ["{", "}"];
    if (N(Z) && (De = !0, Qe = ["[", "]"]), B(Z)) {
      var ct = Z.name ? ": " + Z.name : "";
      ke = " [Function" + ct + "]";
    }
    if (K(Z) && (ke = " " + RegExp.prototype.toString.call(Z)), ve(Z) && (ke = " " + Date.prototype.toUTCString.call(Z)), de(Z) && (ke = " " + x(Z)), xe.length === 0 && (!De || Z.length == 0))
      return Qe[0] + ke + Qe[1];
    if (se < 0)
      return K(Z) ? W.stylize(RegExp.prototype.toString.call(Z), "regexp") : W.stylize("[Object]", "special");
    W.seen.push(Z);
    var pt;
    return De ? pt = _(W, Z, se, be, xe) : pt = xe.map(function(_t) {
      return k(W, Z, se, be, _t, De);
    }), W.seen.pop(), P(pt, ke, Qe);
  }
  function g(W, Z) {
    if (J(Z)) return W.stylize("undefined", "undefined");
    if (R(Z)) {
      var se = "'" + JSON.stringify(Z).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return W.stylize(se, "string");
    }
    if (j(Z)) return W.stylize("" + Z, "number");
    if (M(Z)) return W.stylize("" + Z, "boolean");
    if (G(Z)) return W.stylize("null", "null");
  }
  function x(W) {
    return "[" + Error.prototype.toString.call(W) + "]";
  }
  function _(W, Z, se, ye, Fe) {
    for (var xe = [], be = 0, he = Z.length; be < he; ++be)
      fe(Z, String(be)) ? xe.push(k(W, Z, se, ye, String(be), !0)) : xe.push("");
    return Fe.forEach(function(ke) {
      ke.match(/^\d+$/) || xe.push(k(W, Z, se, ye, ke, !0));
    }), xe;
  }
  function k(W, Z, se, ye, Fe, xe) {
    var be, he, ke;
    if (ke = Object.getOwnPropertyDescriptor(Z, Fe) || {
      value: Z[Fe]
    }, ke.get ? ke.set ? he = W.stylize("[Getter/Setter]", "special") : he = W.stylize("[Getter]", "special") : ke.set && (he = W.stylize("[Setter]", "special")), fe(ye, Fe) || (be = "[" + Fe + "]"), he || (W.seen.indexOf(ke.value) < 0 ? (G(se) ? he = d(W, ke.value, null) : he = d(W, ke.value, se - 1), he.indexOf(`
`) > -1 && (xe ? he = he.split(`
`).map(function(De) {
      return "  " + De;
    }).join(`
`).substr(2) : he = `
` + he.split(`
`).map(function(De) {
      return "   " + De;
    }).join(`
`))) : he = W.stylize("[Circular]", "special")), J(be)) {
      if (xe && Fe.match(/^\d+$/))
        return he;
      be = JSON.stringify("" + Fe), be.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (be = be.substr(1, be.length - 2), be = W.stylize(be, "name")) : (be = be.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), be = W.stylize(be, "string"));
    }
    return be + ": " + he;
  }
  function P(W, Z, se) {
    var ye = W.reduce(function(Fe, xe) {
      return xe.indexOf(`
`) >= 0, Fe + xe.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return ye > 60 ? se[0] + (Z === "" ? "" : Z + `
 `) + " " + W.join(`,
  `) + " " + se[1] : se[0] + Z + " " + W.join(", ") + " " + se[1];
  }
  r.types = vA;
  function N(W) {
    return Array.isArray(W);
  }
  r.isArray = N;
  function M(W) {
    return typeof W == "boolean";
  }
  r.isBoolean = M;
  function G(W) {
    return W === null;
  }
  r.isNull = G;
  function z(W) {
    return W == null;
  }
  r.isNullOrUndefined = z;
  function j(W) {
    return typeof W == "number";
  }
  r.isNumber = j;
  function R(W) {
    return typeof W == "string";
  }
  r.isString = R;
  function te(W) {
    return typeof W == "symbol";
  }
  r.isSymbol = te;
  function J(W) {
    return W === void 0;
  }
  r.isUndefined = J;
  function K(W) {
    return ee(W) && H(W) === "[object RegExp]";
  }
  r.isRegExp = K, r.types.isRegExp = K;
  function ee(W) {
    return typeof W == "object" && W !== null;
  }
  r.isObject = ee;
  function ve(W) {
    return ee(W) && H(W) === "[object Date]";
  }
  r.isDate = ve, r.types.isDate = ve;
  function de(W) {
    return ee(W) && (H(W) === "[object Error]" || W instanceof Error);
  }
  r.isError = de, r.types.isNativeError = de;
  function B(W) {
    return typeof W == "function";
  }
  r.isFunction = B;
  function q(W) {
    return W === null || typeof W == "boolean" || typeof W == "number" || typeof W == "string" || typeof W == "symbol" || // ES6 symbol
    typeof W > "u";
  }
  r.isPrimitive = q, r.isBuffer = O$;
  function H(W) {
    return Object.prototype.toString.call(W);
  }
  function oe(W) {
    return W < 10 ? "0" + W.toString(10) : W.toString(10);
  }
  var ne = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function me() {
    var W = /* @__PURE__ */ new Date(), Z = [oe(W.getHours()), oe(W.getMinutes()), oe(W.getSeconds())].join(":");
    return [W.getDate(), ne[W.getMonth()], Z].join(" ");
  }
  r.log = function() {
    console.log("%s - %s", me(), r.format.apply(r, arguments));
  }, r.inherits = g3.exports, r._extend = function(W, Z) {
    if (!Z || !ee(Z)) return W;
    for (var se = Object.keys(Z), ye = se.length; ye--; )
      W[se[ye]] = Z[se[ye]];
    return W;
  };
  function fe(W, Z) {
    return Object.prototype.hasOwnProperty.call(W, Z);
  }
  var _e = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  r.promisify = function(Z) {
    if (typeof Z != "function") throw new TypeError('The "original" argument must be of type Function');
    if (_e && Z[_e]) {
      var se = Z[_e];
      if (typeof se != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(se, _e, {
        value: se,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), se;
    }
    function se() {
      for (var ye, Fe, xe = new Promise(function(ke, De) {
        ye = ke, Fe = De;
      }), be = [], he = 0; he < arguments.length; he++)
        be.push(arguments[he]);
      be.push(function(ke, De) {
        ke ? Fe(ke) : ye(De);
      });
      try {
        Z.apply(this, be);
      } catch (ke) {
        Fe(ke);
      }
      return xe;
    }
    return Object.setPrototypeOf(se, Object.getPrototypeOf(Z)), _e && Object.defineProperty(se, _e, {
      value: se,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(se, e(Z));
  }, r.promisify.custom = _e;
  function Re(W, Z) {
    if (!W) {
      var se = new Error("Promise was rejected with a falsy value");
      se.reason = W, W = se;
    }
    return Z(W);
  }
  function Ie(W) {
    if (typeof W != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function Z() {
      for (var se = [], ye = 0; ye < arguments.length; ye++)
        se.push(arguments[ye]);
      var Fe = se.pop();
      if (typeof Fe != "function")
        throw new TypeError("The last argument must be of type Function");
      var xe = this, be = function() {
        return Fe.apply(xe, arguments);
      };
      W.apply(this, se).then(function(he) {
        _i.nextTick(be.bind(null, null, he));
      }, function(he) {
        _i.nextTick(Re.bind(null, he, be));
      });
    }
    return Object.setPrototypeOf(Z, Object.getPrototypeOf(W)), Object.defineProperties(Z, e(W)), Z;
  }
  r.callbackify = Ie;
})(Kn);
var Ii = { exports: {} }, $0 = Ii.exports = {}, Ka, Ja;
function m3() {
  throw new Error("setTimeout has not been defined");
}
function y3() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Ka = setTimeout : Ka = m3;
  } catch {
    Ka = m3;
  }
  try {
    typeof clearTimeout == "function" ? Ja = clearTimeout : Ja = y3;
  } catch {
    Ja = y3;
  }
})();
function PA(r) {
  if (Ka === setTimeout)
    return setTimeout(r, 0);
  if ((Ka === m3 || !Ka) && setTimeout)
    return Ka = setTimeout, setTimeout(r, 0);
  try {
    return Ka(r, 0);
  } catch {
    try {
      return Ka.call(null, r, 0);
    } catch {
      return Ka.call(this, r, 0);
    }
  }
}
function R$(r) {
  if (Ja === clearTimeout)
    return clearTimeout(r);
  if ((Ja === y3 || !Ja) && clearTimeout)
    return Ja = clearTimeout, clearTimeout(r);
  try {
    return Ja(r);
  } catch {
    try {
      return Ja.call(null, r);
    } catch {
      return Ja.call(this, r);
    }
  }
}
var qo = [], Rc = !1, el, Fh = -1;
function I$() {
  !Rc || !el || (Rc = !1, el.length ? qo = el.concat(qo) : Fh = -1, qo.length && BA());
}
function BA() {
  if (!Rc) {
    var r = PA(I$);
    Rc = !0;
    for (var e = qo.length; e; ) {
      for (el = qo, qo = []; ++Fh < e; )
        el && el[Fh].run();
      Fh = -1, e = qo.length;
    }
    el = null, Rc = !1, R$(r);
  }
}
$0.nextTick = function(r) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      e[t - 1] = arguments[t];
  qo.push(new NA(r, e)), qo.length === 1 && !Rc && PA(BA);
};
function NA(r, e) {
  this.fun = r, this.array = e;
}
NA.prototype.run = function() {
  this.fun.apply(null, this.array);
};
$0.title = "browser";
$0.browser = !0;
$0.env = {};
$0.argv = [];
$0.version = "";
$0.versions = {};
function is() {
}
$0.on = is;
$0.addListener = is;
$0.once = is;
$0.off = is;
$0.removeListener = is;
$0.removeAllListeners = is;
$0.emit = is;
$0.prependListener = is;
$0.prependOnceListener = is;
$0.listeners = function(r) {
  return [];
};
$0.binding = function(r) {
  throw new Error("process.binding is not supported");
};
$0.cwd = function() {
  return "/";
};
$0.chdir = function(r) {
  throw new Error("process.chdir is not supported");
};
$0.umask = function() {
  return 0;
};
function kl() {
  this.head = null, this.tail = null, this.length = 0;
}
kl.prototype.push = function(r) {
  var e = { data: r, next: null };
  this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
};
kl.prototype.unshift = function(r) {
  var e = { data: r, next: this.head };
  this.length === 0 && (this.tail = e), this.head = e, ++this.length;
};
kl.prototype.shift = function() {
  if (this.length !== 0) {
    var r = this.head.data;
    return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, r;
  }
};
kl.prototype.clear = function() {
  this.head = this.tail = null, this.length = 0;
};
kl.prototype.join = function(r) {
  if (this.length === 0) return "";
  for (var e = this.head, t = "" + e.data; e = e.next; )
    t += r + e.data;
  return t;
};
kl.prototype.concat = function(r) {
  if (this.length === 0) return yo.Buffer.alloc(0);
  if (this.length === 1) return this.head.data;
  for (var e = yo.Buffer.allocUnsafe(r >>> 0), t = this.head, n = 0; t; )
    t.data.copy(e, n), n += t.data.length, t = t.next;
  return e;
};
var b3 = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(r, e) {
  var t = yo, n = t.Buffer;
  function i(o, s) {
    for (var c in o)
      s[c] = o[c];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? r.exports = t : (i(t, e), e.Buffer = a);
  function a(o, s, c) {
    return n(o, s, c);
  }
  a.prototype = Object.create(n.prototype), i(n, a), a.from = function(o, s, c) {
    if (typeof o == "number")
      throw new TypeError("Argument must not be a number");
    return n(o, s, c);
  }, a.alloc = function(o, s, c) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    var h = n(o);
    return s !== void 0 ? typeof c == "string" ? h.fill(s, c) : h.fill(s) : h.fill(0), h;
  }, a.allocUnsafe = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return n(o);
  }, a.allocUnsafeSlow = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return t.SlowBuffer(o);
  };
})(b3, b3.exports);
var Xv = b3.exports.Buffer, vb = Xv.isEncoding || function(r) {
  switch (r = "" + r, r && r.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function P$(r) {
  if (!r) return "utf8";
  for (var e; ; )
    switch (r) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return r;
      default:
        if (e) return;
        r = ("" + r).toLowerCase(), e = !0;
    }
}
function B$(r) {
  var e = P$(r);
  if (typeof e != "string" && (Xv.isEncoding === vb || !vb(r))) throw new Error("Unknown encoding: " + r);
  return e || r;
}
var LA = J1;
function J1(r) {
  this.encoding = B$(r);
  var e;
  switch (this.encoding) {
    case "utf16le":
      this.text = z$, this.end = j$, e = 4;
      break;
    case "utf8":
      this.fillLast = M$, e = 4;
      break;
    case "base64":
      this.text = W$, this.end = G$, e = 3;
      break;
    default:
      this.write = V$, this.end = Y$;
      return;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Xv.allocUnsafe(e);
}
J1.prototype.write = function(r) {
  if (r.length === 0) return "";
  var e, t;
  if (this.lastNeed) {
    if (e = this.fillLast(r), e === void 0) return "";
    t = this.lastNeed, this.lastNeed = 0;
  } else
    t = 0;
  return t < r.length ? e ? e + this.text(r, t) : this.text(r, t) : e || "";
};
J1.prototype.end = $$;
J1.prototype.text = U$;
J1.prototype.fillLast = function(r) {
  if (this.lastNeed <= r.length)
    return r.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  r.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, r.length), this.lastNeed -= r.length;
};
function Bp(r) {
  return r <= 127 ? 0 : r >> 5 === 6 ? 2 : r >> 4 === 14 ? 3 : r >> 3 === 30 ? 4 : r >> 6 === 2 ? -1 : -2;
}
function N$(r, e, t) {
  var n = e.length - 1;
  if (n < t) return 0;
  var i = Bp(e[n]);
  return i >= 0 ? (i > 0 && (r.lastNeed = i - 1), i) : --n < t || i === -2 ? 0 : (i = Bp(e[n]), i >= 0 ? (i > 0 && (r.lastNeed = i - 2), i) : --n < t || i === -2 ? 0 : (i = Bp(e[n]), i >= 0 ? (i > 0 && (i === 2 ? i = 0 : r.lastNeed = i - 3), i) : 0));
}
function L$(r, e, t) {
  if ((e[0] & 192) !== 128)
    return r.lastNeed = 0, "�";
  if (r.lastNeed > 1 && e.length > 1) {
    if ((e[1] & 192) !== 128)
      return r.lastNeed = 1, "�";
    if (r.lastNeed > 2 && e.length > 2 && (e[2] & 192) !== 128)
      return r.lastNeed = 2, "�";
  }
}
function M$(r) {
  var e = this.lastTotal - this.lastNeed, t = L$(this, r);
  if (t !== void 0) return t;
  if (this.lastNeed <= r.length)
    return r.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  r.copy(this.lastChar, e, 0, r.length), this.lastNeed -= r.length;
}
function U$(r, e) {
  var t = N$(this, r, e);
  if (!this.lastNeed) return r.toString("utf8", e);
  this.lastTotal = t;
  var n = r.length - (t - this.lastNeed);
  return r.copy(this.lastChar, 0, n), r.toString("utf8", e, n);
}
function $$(r) {
  var e = r && r.length ? this.write(r) : "";
  return this.lastNeed ? e + "�" : e;
}
function z$(r, e) {
  if ((r.length - e) % 2 === 0) {
    var t = r.toString("utf16le", e);
    if (t) {
      var n = t.charCodeAt(t.length - 1);
      if (n >= 55296 && n <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = r[r.length - 2], this.lastChar[1] = r[r.length - 1], t.slice(0, -1);
    }
    return t;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = r[r.length - 1], r.toString("utf16le", e, r.length - 1);
}
function j$(r) {
  var e = r && r.length ? this.write(r) : "";
  if (this.lastNeed) {
    var t = this.lastTotal - this.lastNeed;
    return e + this.lastChar.toString("utf16le", 0, t);
  }
  return e;
}
function W$(r, e) {
  var t = (r.length - e) % 3;
  return t === 0 ? r.toString("base64", e) : (this.lastNeed = 3 - t, this.lastTotal = 3, t === 1 ? this.lastChar[0] = r[r.length - 1] : (this.lastChar[0] = r[r.length - 2], this.lastChar[1] = r[r.length - 1]), r.toString("base64", e, r.length - t));
}
function G$(r) {
  var e = r && r.length ? this.write(r) : "";
  return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
}
function V$(r) {
  return r.toString(this.encoding);
}
function Y$(r) {
  return r && r.length ? this.write(r) : "";
}
x0.ReadableState = MA;
var Zr = Kn.debuglog("stream");
Kn.inherits(x0, af);
function H$(r, e, t) {
  if (typeof r.prependListener == "function")
    return r.prependListener(e, t);
  !r._events || !r._events[e] ? r.on(e, t) : Array.isArray(r._events[e]) ? r._events[e].unshift(t) : r._events[e] = [t, r._events[e]];
}
function Z$(r, e) {
  return r.listeners(e).length;
}
function MA(r, e) {
  r = r || {}, this.objectMode = !!r.objectMode, e instanceof Ri && (this.objectMode = this.objectMode || !!r.readableObjectMode);
  var t = r.highWaterMark, n = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = t || t === 0 ? t : n, this.highWaterMark = ~~this.highWaterMark, this.buffer = new kl(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.defaultEncoding = r.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, r.encoding && (this.decoder = new LA(r.encoding), this.encoding = r.encoding);
}
function x0(r) {
  if (!(this instanceof x0)) return new x0(r);
  this._readableState = new MA(r, this), this.readable = !0, r && typeof r.read == "function" && (this._read = r.read), af.call(this);
}
x0.prototype.push = function(r, e) {
  var t = this._readableState;
  return !t.objectMode && typeof r == "string" && (e = e || t.defaultEncoding, e !== t.encoding && (r = ut.from(r, e), e = "")), UA(this, t, r, e, !1);
};
x0.prototype.unshift = function(r) {
  var e = this._readableState;
  return UA(this, e, r, "", !0);
};
x0.prototype.isPaused = function() {
  return this._readableState.flowing === !1;
};
function UA(r, e, t, n, i) {
  var a = K$(e, t);
  if (a)
    r.emit("error", a);
  else if (t === null)
    e.reading = !1, J$(r, e);
  else if (e.objectMode || t && t.length > 0)
    if (e.ended && !i) {
      var o = new Error("stream.push() after EOF");
      r.emit("error", o);
    } else if (e.endEmitted && i) {
      var s = new Error("stream.unshift() after end event");
      r.emit("error", s);
    } else {
      var c;
      e.decoder && !i && !n && (t = e.decoder.write(t), c = !e.objectMode && t.length === 0), i || (e.reading = !1), c || (e.flowing && e.length === 0 && !e.sync ? (r.emit("data", t), r.read(0)) : (e.length += e.objectMode ? 1 : t.length, i ? e.buffer.unshift(t) : e.buffer.push(t), e.needReadable && c5(r))), Q$(r, e);
    }
  else i || (e.reading = !1);
  return q$(e);
}
function q$(r) {
  return !r.ended && (r.needReadable || r.length < r.highWaterMark || r.length === 0);
}
x0.prototype.setEncoding = function(r) {
  return this._readableState.decoder = new LA(r), this._readableState.encoding = r, this;
};
var gb = 8388608;
function X$(r) {
  return r >= gb ? r = gb : (r--, r |= r >>> 1, r |= r >>> 2, r |= r >>> 4, r |= r >>> 8, r |= r >>> 16, r++), r;
}
function mb(r, e) {
  return r <= 0 || e.length === 0 && e.ended ? 0 : e.objectMode ? 1 : r !== r ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (r > e.highWaterMark && (e.highWaterMark = X$(r)), r <= e.length ? r : e.ended ? e.length : (e.needReadable = !0, 0));
}
x0.prototype.read = function(r) {
  Zr("read", r), r = parseInt(r, 10);
  var e = this._readableState, t = r;
  if (r !== 0 && (e.emittedReadable = !1), r === 0 && e.needReadable && (e.length >= e.highWaterMark || e.ended))
    return Zr("read: emitReadable", e.length, e.ended), e.length === 0 && e.ended ? Np(this) : c5(this), null;
  if (r = mb(r, e), r === 0 && e.ended)
    return e.length === 0 && Np(this), null;
  var n = e.needReadable;
  Zr("need readable", n), (e.length === 0 || e.length - r < e.highWaterMark) && (n = !0, Zr("length less than watermark", n)), e.ended || e.reading ? (n = !1, Zr("reading or ended", n)) : n && (Zr("do read"), e.reading = !0, e.sync = !0, e.length === 0 && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (r = mb(t, e)));
  var i;
  return r > 0 ? i = $A(r, e) : i = null, i === null ? (e.needReadable = !0, r = 0) : e.length -= r, e.length === 0 && (e.ended || (e.needReadable = !0), t !== r && e.ended && Np(this)), i !== null && this.emit("data", i), i;
};
function K$(r, e) {
  var t = null;
  return !ut.isBuffer(e) && typeof e != "string" && e !== null && e !== void 0 && !r.objectMode && (t = new TypeError("Invalid non-string/buffer chunk")), t;
}
function J$(r, e) {
  if (!e.ended) {
    if (e.decoder) {
      var t = e.decoder.end();
      t && t.length && (e.buffer.push(t), e.length += e.objectMode ? 1 : t.length);
    }
    e.ended = !0, c5(r);
  }
}
function c5(r) {
  var e = r._readableState;
  e.needReadable = !1, e.emittedReadable || (Zr("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? Ii.exports.nextTick(yb, r) : yb(r));
}
function yb(r) {
  Zr("emit readable"), r.emit("readable"), Kv(r);
}
function Q$(r, e) {
  e.readingMore || (e.readingMore = !0, Ii.exports.nextTick(ez, r, e));
}
function ez(r, e) {
  for (var t = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (Zr("maybeReadMore read 0"), r.read(0), t !== e.length); )
    t = e.length;
  e.readingMore = !1;
}
x0.prototype._read = function(r) {
  this.emit("error", new Error("not implemented"));
};
x0.prototype.pipe = function(r, e) {
  var t = this, n = this._readableState;
  switch (n.pipesCount) {
    case 0:
      n.pipes = r;
      break;
    case 1:
      n.pipes = [n.pipes, r];
      break;
    default:
      n.pipes.push(r);
      break;
  }
  n.pipesCount += 1, Zr("pipe count=%d opts=%j", n.pipesCount, e);
  var i = !e || e.end !== !1, a = i ? s : d;
  n.endEmitted ? Ii.exports.nextTick(a) : t.once("end", a), r.on("unpipe", o);
  function o(M) {
    Zr("onunpipe"), M === t && d();
  }
  function s() {
    Zr("onend"), r.end();
  }
  var c = tz(t);
  r.on("drain", c);
  var h = !1;
  function d() {
    Zr("cleanup"), r.removeListener("close", k), r.removeListener("finish", P), r.removeListener("drain", c), r.removeListener("error", _), r.removeListener("unpipe", o), t.removeListener("end", s), t.removeListener("end", d), t.removeListener("data", x), h = !0, n.awaitDrain && (!r._writableState || r._writableState.needDrain) && c();
  }
  var g = !1;
  t.on("data", x);
  function x(M) {
    Zr("ondata"), g = !1;
    var G = r.write(M);
    G === !1 && !g && ((n.pipesCount === 1 && n.pipes === r || n.pipesCount > 1 && zA(n.pipes, r) !== -1) && !h && (Zr("false write response, pause", t._readableState.awaitDrain), t._readableState.awaitDrain++, g = !0), t.pause());
  }
  function _(M) {
    Zr("onerror", M), N(), r.removeListener("error", _), Z$(r, "error") === 0 && r.emit("error", M);
  }
  H$(r, "error", _);
  function k() {
    r.removeListener("finish", P), N();
  }
  r.once("close", k);
  function P() {
    Zr("onfinish"), r.removeListener("close", k), N();
  }
  r.once("finish", P);
  function N() {
    Zr("unpipe"), t.unpipe(r);
  }
  return r.emit("pipe", t), n.flowing || (Zr("pipe resume"), t.resume()), r;
};
function tz(r) {
  return function() {
    var e = r._readableState;
    Zr("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, e.awaitDrain === 0 && r.listeners("data").length && (e.flowing = !0, Kv(r));
  };
}
x0.prototype.unpipe = function(r) {
  var e = this._readableState;
  if (e.pipesCount === 0) return this;
  if (e.pipesCount === 1)
    return r && r !== e.pipes ? this : (r || (r = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, r && r.emit("unpipe", this), this);
  if (!r) {
    var t = e.pipes, n = e.pipesCount;
    e.pipes = null, e.pipesCount = 0, e.flowing = !1;
    for (var i = 0; i < n; i++)
      t[i].emit("unpipe", this);
    return this;
  }
  var a = zA(e.pipes, r);
  return a === -1 ? this : (e.pipes.splice(a, 1), e.pipesCount -= 1, e.pipesCount === 1 && (e.pipes = e.pipes[0]), r.emit("unpipe", this), this);
};
x0.prototype.on = function(r, e) {
  var t = af.prototype.on.call(this, r, e);
  if (r === "data")
    this._readableState.flowing !== !1 && this.resume();
  else if (r === "readable") {
    var n = this._readableState;
    !n.endEmitted && !n.readableListening && (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && c5(this) : Ii.exports.nextTick(rz, this));
  }
  return t;
};
x0.prototype.addListener = x0.prototype.on;
function rz(r) {
  Zr("readable nexttick read 0"), r.read(0);
}
x0.prototype.resume = function() {
  var r = this._readableState;
  return r.flowing || (Zr("resume"), r.flowing = !0, nz(this, r)), this;
};
function nz(r, e) {
  e.resumeScheduled || (e.resumeScheduled = !0, Ii.exports.nextTick(iz, r, e));
}
function iz(r, e) {
  e.reading || (Zr("resume read 0"), r.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, r.emit("resume"), Kv(r), e.flowing && !e.reading && r.read(0);
}
x0.prototype.pause = function() {
  return Zr("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (Zr("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
};
function Kv(r) {
  var e = r._readableState;
  for (Zr("flow", e.flowing); e.flowing && r.read() !== null; )
    ;
}
x0.prototype.wrap = function(r) {
  var e = this._readableState, t = !1, n = this;
  r.on("end", function() {
    if (Zr("wrapped end"), e.decoder && !e.ended) {
      var o = e.decoder.end();
      o && o.length && n.push(o);
    }
    n.push(null);
  }), r.on("data", function(o) {
    if (Zr("wrapped data"), e.decoder && (o = e.decoder.write(o)), !(e.objectMode && o == null) && !(!e.objectMode && (!o || !o.length))) {
      var s = n.push(o);
      s || (t = !0, r.pause());
    }
  });
  for (var i in r)
    this[i] === void 0 && typeof r[i] == "function" && (this[i] = /* @__PURE__ */ function(o) {
      return function() {
        return r[o].apply(r, arguments);
      };
    }(i));
  var a = ["error", "close", "destroy", "pause", "resume"];
  return lz(a, function(o) {
    r.on(o, n.emit.bind(n, o));
  }), n._read = function(o) {
    Zr("wrapped _read", o), t && (t = !1, r.resume());
  }, n;
};
x0._fromList = $A;
function $A(r, e) {
  if (e.length === 0) return null;
  var t;
  return e.objectMode ? t = e.buffer.shift() : !r || r >= e.length ? (e.decoder ? t = e.buffer.join("") : e.buffer.length === 1 ? t = e.buffer.head.data : t = e.buffer.concat(e.length), e.buffer.clear()) : t = az(r, e.buffer, e.decoder), t;
}
function az(r, e, t) {
  var n;
  return r < e.head.data.length ? (n = e.head.data.slice(0, r), e.head.data = e.head.data.slice(r)) : r === e.head.data.length ? n = e.shift() : n = t ? oz(r, e) : sz(r, e), n;
}
function oz(r, e) {
  var t = e.head, n = 1, i = t.data;
  for (r -= i.length; t = t.next; ) {
    var a = t.data, o = r > a.length ? a.length : r;
    if (o === a.length ? i += a : i += a.slice(0, r), r -= o, r === 0) {
      o === a.length ? (++n, t.next ? e.head = t.next : e.head = e.tail = null) : (e.head = t, t.data = a.slice(o));
      break;
    }
    ++n;
  }
  return e.length -= n, i;
}
function sz(r, e) {
  var t = ut.allocUnsafe(r), n = e.head, i = 1;
  for (n.data.copy(t), r -= n.data.length; n = n.next; ) {
    var a = n.data, o = r > a.length ? a.length : r;
    if (a.copy(t, t.length - r, 0, o), r -= o, r === 0) {
      o === a.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = a.slice(o));
      break;
    }
    ++i;
  }
  return e.length -= i, t;
}
function Np(r) {
  var e = r._readableState;
  if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
  e.endEmitted || (e.ended = !0, Ii.exports.nextTick(uz, e, r));
}
function uz(r, e) {
  !r.endEmitted && r.length === 0 && (r.endEmitted = !0, e.readable = !1, e.emit("end"));
}
function lz(r, e) {
  for (var t = 0, n = r.length; t < n; t++)
    e(r[t], t);
}
function zA(r, e) {
  for (var t = 0, n = r.length; t < n; t++)
    if (r[t] === e) return t;
  return -1;
}
Sn.WritableState = Jv;
Kn.inherits(Sn, K1.exports.EventEmitter);
function cz() {
}
function fz(r, e, t) {
  this.chunk = r, this.encoding = e, this.callback = t, this.next = null;
}
function Jv(r, e) {
  Object.defineProperty(this, "buffer", {
    get: Kn.deprecate(function() {
      return this.getBuffer();
    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
  }), r = r || {}, this.objectMode = !!r.objectMode, e instanceof Ri && (this.objectMode = this.objectMode || !!r.writableObjectMode);
  var t = r.highWaterMark, n = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = t || t === 0 ? t : n, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
  var i = r.decodeStrings === !1;
  this.decodeStrings = !i, this.defaultEncoding = r.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(a) {
    yz(e, a);
  }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new VA(this);
}
Jv.prototype.getBuffer = function() {
  for (var e = this.bufferedRequest, t = []; e; )
    t.push(e), e = e.next;
  return t;
};
function Sn(r) {
  if (!(this instanceof Sn) && !(this instanceof Ri)) return new Sn(r);
  this._writableState = new Jv(r, this), this.writable = !0, r && (typeof r.write == "function" && (this._write = r.write), typeof r.writev == "function" && (this._writev = r.writev)), K1.exports.EventEmitter.call(this);
}
Sn.prototype.pipe = function() {
  this.emit("error", new Error("Cannot pipe, not readable"));
};
function hz(r, e) {
  var t = new Error("write after end");
  r.emit("error", t), Ii.exports.nextTick(e, t);
}
function dz(r, e, t, n) {
  var i = !0, a = !1;
  return t === null ? a = new TypeError("May not write null values to stream") : !yo.Buffer.isBuffer(t) && typeof t != "string" && t !== void 0 && !e.objectMode && (a = new TypeError("Invalid non-string/buffer chunk")), a && (r.emit("error", a), Ii.exports.nextTick(n, a), i = !1), i;
}
Sn.prototype.write = function(r, e, t) {
  var n = this._writableState, i = !1;
  return typeof e == "function" && (t = e, e = null), yo.Buffer.isBuffer(r) ? e = "buffer" : e || (e = n.defaultEncoding), typeof t != "function" && (t = cz), n.ended ? hz(this, t) : dz(this, n, r, t) && (n.pendingcb++, i = vz(this, n, r, e, t)), i;
};
Sn.prototype.cork = function() {
  var r = this._writableState;
  r.corked++;
};
Sn.prototype.uncork = function() {
  var r = this._writableState;
  r.corked && (r.corked--, !r.writing && !r.corked && !r.finished && !r.bufferProcessing && r.bufferedRequest && jA(this, r));
};
Sn.prototype.setDefaultEncoding = function(e) {
  if (typeof e == "string" && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
  return this._writableState.defaultEncoding = e, this;
};
function pz(r, e, t) {
  return !r.objectMode && r.decodeStrings !== !1 && typeof e == "string" && (e = yo.Buffer.from(e, t)), e;
}
function vz(r, e, t, n, i) {
  t = pz(e, t, n), yo.Buffer.isBuffer(t) && (n = "buffer");
  var a = e.objectMode ? 1 : t.length;
  e.length += a;
  var o = e.length < e.highWaterMark;
  if (o || (e.needDrain = !0), e.writing || e.corked) {
    var s = e.lastBufferedRequest;
    e.lastBufferedRequest = new fz(t, n, i), s ? s.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
  } else
    w3(r, e, !1, a, t, n, i);
  return o;
}
function w3(r, e, t, n, i, a, o) {
  e.writelen = n, e.writecb = o, e.writing = !0, e.sync = !0, t ? r._writev(i, e.onwrite) : r._write(i, a, e.onwrite), e.sync = !1;
}
function gz(r, e, t, n, i) {
  --e.pendingcb, t ? Ii.exports.nextTick(i, n) : i(n), r._writableState.errorEmitted = !0, r.emit("error", n);
}
function mz(r) {
  r.writing = !1, r.writecb = null, r.length -= r.writelen, r.writelen = 0;
}
function yz(r, e) {
  var t = r._writableState, n = t.sync, i = t.writecb;
  if (mz(t), e) gz(r, t, n, e, i);
  else {
    var a = WA(t);
    !a && !t.corked && !t.bufferProcessing && t.bufferedRequest && jA(r, t), n ? Ii.exports.nextTick(bb, r, t, a, i) : bb(r, t, a, i);
  }
}
function bb(r, e, t, n) {
  t || bz(r, e), e.pendingcb--, n(), GA(r, e);
}
function bz(r, e) {
  e.length === 0 && e.needDrain && (e.needDrain = !1, r.emit("drain"));
}
function jA(r, e) {
  e.bufferProcessing = !0;
  var t = e.bufferedRequest;
  if (r._writev && t && t.next) {
    var n = e.bufferedRequestCount, i = new Array(n), a = e.corkedRequestsFree;
    a.entry = t;
    for (var o = 0; t; )
      i[o] = t, t = t.next, o += 1;
    w3(r, e, !0, e.length, i, "", a.finish), e.pendingcb++, e.lastBufferedRequest = null, a.next ? (e.corkedRequestsFree = a.next, a.next = null) : e.corkedRequestsFree = new VA(e);
  } else {
    for (; t; ) {
      var s = t.chunk, c = t.encoding, h = t.callback, d = e.objectMode ? 1 : s.length;
      if (w3(r, e, !1, d, s, c, h), t = t.next, e.writing)
        break;
    }
    t === null && (e.lastBufferedRequest = null);
  }
  e.bufferedRequestCount = 0, e.bufferedRequest = t, e.bufferProcessing = !1;
}
Sn.prototype._write = function(r, e, t) {
  t(new Error("not implemented"));
};
Sn.prototype._writev = null;
Sn.prototype.end = function(r, e, t) {
  var n = this._writableState;
  typeof r == "function" ? (t = r, r = null, e = null) : typeof e == "function" && (t = e, e = null), r != null && this.write(r, e), n.corked && (n.corked = 1, this.uncork()), !n.ending && !n.finished && wz(this, n, t);
};
function WA(r) {
  return r.ending && r.length === 0 && r.bufferedRequest === null && !r.finished && !r.writing;
}
function wb(r, e) {
  e.prefinished || (e.prefinished = !0, r.emit("prefinish"));
}
function GA(r, e) {
  var t = WA(e);
  return t && (e.pendingcb === 0 ? (wb(r, e), e.finished = !0, r.emit("finish")) : wb(r, e)), t;
}
function wz(r, e, t) {
  e.ending = !0, GA(r, e), t && (e.finished ? Ii.exports.nextTick(t) : r.once("finish", t)), e.ended = !0, r.writable = !1;
}
function VA(r) {
  var e = this;
  this.next = null, this.entry = null, this.finish = function(t) {
    var n = e.entry;
    for (e.entry = null; n; ) {
      var i = n.callback;
      r.pendingcb--, i(t), n = n.next;
    }
    r.corkedRequestsFree ? r.corkedRequestsFree.next = e : r.corkedRequestsFree = e;
  };
}
Kn.inherits(Ri, x0);
var Ab = Object.keys(Sn.prototype);
for (var Lp = 0; Lp < Ab.length; Lp++) {
  var Mp = Ab[Lp];
  Ri.prototype[Mp] || (Ri.prototype[Mp] = Sn.prototype[Mp]);
}
function Ri(r) {
  if (!(this instanceof Ri)) return new Ri(r);
  x0.call(this, r), Sn.call(this, r), r && r.readable === !1 && (this.readable = !1), r && r.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, r && r.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", Az);
}
function Az() {
  this.allowHalfOpen || this._writableState.ended || Ii.exports.nextTick(xz, this);
}
function xz(r) {
  r.end();
}
Kn.inherits(Ca, Ri);
function Ez(r) {
  this.afterTransform = function(e, t) {
    return _z(r, e, t);
  }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null, this.writeencoding = null;
}
function _z(r, e, t) {
  var n = r._transformState;
  n.transforming = !1;
  var i = n.writecb;
  if (!i) return r.emit("error", new Error("no writecb in Transform class"));
  n.writechunk = null, n.writecb = null, t != null && r.push(t), i(e);
  var a = r._readableState;
  a.reading = !1, (a.needReadable || a.length < a.highWaterMark) && r._read(a.highWaterMark);
}
function Ca(r) {
  if (!(this instanceof Ca)) return new Ca(r);
  Ri.call(this, r), this._transformState = new Ez(this);
  var e = this;
  this._readableState.needReadable = !0, this._readableState.sync = !1, r && (typeof r.transform == "function" && (this._transform = r.transform), typeof r.flush == "function" && (this._flush = r.flush)), this.once("prefinish", function() {
    typeof this._flush == "function" ? this._flush(function(t) {
      xb(e, t);
    }) : xb(e);
  });
}
Ca.prototype.push = function(r, e) {
  return this._transformState.needTransform = !1, Ri.prototype.push.call(this, r, e);
};
Ca.prototype._transform = function(r, e, t) {
  throw new Error("Not implemented");
};
Ca.prototype._write = function(r, e, t) {
  var n = this._transformState;
  if (n.writecb = t, n.writechunk = r, n.writeencoding = e, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
Ca.prototype._read = function(r) {
  var e = this._transformState;
  e.writechunk !== null && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
function xb(r, e) {
  if (e) return r.emit("error", e);
  var t = r._writableState, n = r._transformState;
  if (t.length) throw new Error("Calling transform done when ws.length != 0");
  if (n.transforming) throw new Error("Calling transform done when still transforming");
  return r.push(null);
}
Kn.inherits(qc, Ca);
function qc(r) {
  if (!(this instanceof qc)) return new qc(r);
  Ca.call(this, r);
}
qc.prototype._transform = function(r, e, t) {
  t(null, r);
};
Kn.inherits(Fa, af);
Fa.Readable = x0;
Fa.Writable = Sn;
Fa.Duplex = Ri;
Fa.Transform = Ca;
Fa.PassThrough = qc;
Fa.Stream = Fa;
function Fa() {
  af.call(this);
}
Fa.prototype.pipe = function(r, e) {
  var t = this;
  function n(d) {
    r.writable && r.write(d) === !1 && t.pause && t.pause();
  }
  t.on("data", n);
  function i() {
    t.readable && t.resume && t.resume();
  }
  r.on("drain", i), !r._isStdio && (!e || e.end !== !1) && (t.on("end", o), t.on("close", s));
  var a = !1;
  function o() {
    a || (a = !0, r.end());
  }
  function s() {
    a || (a = !0, typeof r.destroy == "function" && r.destroy());
  }
  function c(d) {
    if (h(), af.listenerCount(this, "error") === 0)
      throw d;
  }
  t.on("error", c), r.on("error", c);
  function h() {
    t.removeListener("data", n), r.removeListener("drain", i), t.removeListener("end", o), t.removeListener("close", s), t.removeListener("error", c), r.removeListener("error", c), t.removeListener("end", h), t.removeListener("close", h), r.removeListener("close", h);
  }
  return t.on("end", h), t.on("close", h), r.on("close", h), r.emit("pipe", t), r;
};
var Dz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Fa,
  Readable: x0,
  Writable: Sn,
  Duplex: Ri,
  Transform: Ca,
  PassThrough: qc,
  Stream: Fa
}), Tz = /* @__PURE__ */ _U(Dz), YA = {}, Q1 = { exports: {} }, Qv = {};
function Ic(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ic = function(t) {
    return typeof t;
  } : Ic = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ic(r);
}
function kz(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Sz(r, e) {
  return e && (Ic(e) === "object" || typeof e == "function") ? e : Cz(r);
}
function Cz(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function A3(r) {
  return A3 = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, A3(r);
}
function Fz(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), e && x3(r, e);
}
function x3(r, e) {
  return x3 = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, x3(r, e);
}
var HA = {}, Pc, Up;
function e2(r, e, t) {
  t || (t = Error);
  function n(a, o, s) {
    return typeof e == "string" ? e : e(a, o, s);
  }
  var i = /* @__PURE__ */ function(a) {
    Fz(o, a);
    function o(s, c, h) {
      var d;
      return kz(this, o), d = Sz(this, A3(o).call(this, n(s, c, h))), d.code = r, d;
    }
    return o;
  }(t);
  HA[r] = i;
}
function Eb(r, e) {
  if (Array.isArray(r)) {
    var t = r.length;
    return r = r.map(function(n) {
      return String(n);
    }), t > 2 ? "one of ".concat(e, " ").concat(r.slice(0, t - 1).join(", "), ", or ") + r[t - 1] : t === 2 ? "one of ".concat(e, " ").concat(r[0], " or ").concat(r[1]) : "of ".concat(e, " ").concat(r[0]);
  } else
    return "of ".concat(e, " ").concat(String(r));
}
function Oz(r, e, t) {
  return r.substr(0, e.length) === e;
}
function Rz(r, e, t) {
  return (t === void 0 || t > r.length) && (t = r.length), r.substring(t - e.length, t) === e;
}
function Iz(r, e, t) {
  return typeof t != "number" && (t = 0), t + e.length > r.length ? !1 : r.indexOf(e, t) !== -1;
}
e2("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
e2("ERR_INVALID_ARG_TYPE", function(r, e, t) {
  Pc === void 0 && (Pc = Q1.exports), Pc(typeof r == "string", "'name' must be a string");
  var n;
  typeof e == "string" && Oz(e, "not ") ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be";
  var i;
  if (Rz(r, " argument"))
    i = "The ".concat(r, " ").concat(n, " ").concat(Eb(e, "type"));
  else {
    var a = Iz(r, ".") ? "property" : "argument";
    i = 'The "'.concat(r, '" ').concat(a, " ").concat(n, " ").concat(Eb(e, "type"));
  }
  return i += ". Received type ".concat(Ic(t)), i;
}, TypeError);
e2("ERR_INVALID_ARG_VALUE", function(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
  Up === void 0 && (Up = Kn);
  var n = Up.inspect(e);
  return n.length > 128 && (n = "".concat(n.slice(0, 128), "...")), "The argument '".concat(r, "' ").concat(t, ". Received ").concat(n);
}, TypeError);
e2("ERR_INVALID_RETURN_VALUE", function(r, e, t) {
  var n;
  return t && t.constructor && t.constructor.name ? n = "instance of ".concat(t.constructor.name) : n = "type ".concat(Ic(t)), "Expected ".concat(r, ' to be returned from the "').concat(e, '"') + " function but got ".concat(n, ".");
}, TypeError);
e2("ERR_MISSING_ARGS", function() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  Pc === void 0 && (Pc = Q1.exports), Pc(e.length > 0, "At least one arg needs to be specified");
  var n = "The ", i = e.length;
  switch (e = e.map(function(a) {
    return '"'.concat(a, '"');
  }), i) {
    case 1:
      n += "".concat(e[0], " argument");
      break;
    case 2:
      n += "".concat(e[0], " and ").concat(e[1], " arguments");
      break;
    default:
      n += e.slice(0, i - 1).join(", "), n += ", and ".concat(e[i - 1], " arguments");
      break;
  }
  return "".concat(n, " must be specified");
}, TypeError);
Qv.codes = HA;
function Pz(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {}, n = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    }))), n.forEach(function(i) {
      Bz(r, i, t[i]);
    });
  }
  return r;
}
function Bz(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function Nz(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Lz(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function Mz(r, e, t) {
  return e && Lz(r.prototype, e), r;
}
function ac(r, e) {
  return e && (ta(e) === "object" || typeof e == "function") ? e : E3(r);
}
function E3(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Uz(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), e && k1(r, e);
}
function _3(r) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _3 = function(n) {
    if (n === null || !zz(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(n)) return e.get(n);
      e.set(n, i);
    }
    function i() {
      return Oh(n, arguments, $s(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), k1(i, n);
  }, _3(r);
}
function $z() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Oh(r, e, t) {
  return $z() ? Oh = Reflect.construct : Oh = function(i, a, o) {
    var s = [null];
    s.push.apply(s, a);
    var c = Function.bind.apply(i, s), h = new c();
    return o && k1(h, o.prototype), h;
  }, Oh.apply(null, arguments);
}
function zz(r) {
  return Function.toString.call(r).indexOf("[native code]") !== -1;
}
function k1(r, e) {
  return k1 = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, k1(r, e);
}
function $s(r) {
  return $s = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, $s(r);
}
function ta(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ta = function(t) {
    return typeof t;
  } : ta = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ta(r);
}
var jz = Kn, D3 = jz.inspect, Wz = Qv, Gz = Wz.codes.ERR_INVALID_ARG_TYPE;
function _b(r, e, t) {
  return (t === void 0 || t > r.length) && (t = r.length), r.substring(t - e.length, t) === e;
}
function Vz(r, e) {
  if (e = Math.floor(e), r.length == 0 || e == 0) return "";
  var t = r.length * e;
  for (e = Math.floor(Math.log(e) / Math.log(2)); e; )
    r += r, e--;
  return r += r.substring(0, t - r.length), r;
}
var jo = "", $p = "", zp = "", Hn = "", tl = {
  deepStrictEqual: "Expected values to be strictly deep-equal:",
  strictEqual: "Expected values to be strictly equal:",
  strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
  deepEqual: "Expected values to be loosely deep-equal:",
  equal: "Expected values to be loosely equal:",
  notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
  notStrictEqual: 'Expected "actual" to be strictly unequal to:',
  notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
  notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
  notEqual: 'Expected "actual" to be loosely unequal to:',
  notIdentical: "Values identical but not reference-equal:"
}, Yz = 10;
function Db(r) {
  var e = Object.keys(r), t = Object.create(Object.getPrototypeOf(r));
  return e.forEach(function(n) {
    t[n] = r[n];
  }), Object.defineProperty(t, "message", {
    value: r.message
  }), t;
}
function u1(r) {
  return D3(r, {
    compact: !1,
    customInspect: !1,
    depth: 1e3,
    maxArrayLength: 1 / 0,
    // Assert compares only enumerable properties (with a few exceptions).
    showHidden: !1,
    // Having a long line as error is better than wrapping the line for
    // comparison for now.
    // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
    // have meta information about the inspected properties (i.e., know where
    // in what line the property starts and ends).
    breakLength: 1 / 0,
    // Assert does not detect proxies currently.
    showProxy: !1,
    sorted: !0,
    // Inspect getters as we also check them when comparing entries.
    getters: !0
  });
}
function Hz(r, e, t) {
  var n = "", i = "", a = 0, o = "", s = !1, c = u1(r), h = c.split(`
`), d = u1(e).split(`
`), g = 0, x = "";
  if (t === "strictEqual" && ta(r) === "object" && ta(e) === "object" && r !== null && e !== null && (t = "strictEqualObject"), h.length === 1 && d.length === 1 && h[0] !== d[0]) {
    var _ = h[0].length + d[0].length;
    if (_ <= Yz) {
      if ((ta(r) !== "object" || r === null) && (ta(e) !== "object" || e === null) && (r !== 0 || e !== 0))
        return "".concat(tl[t], `

`) + "".concat(h[0], " !== ").concat(d[0], `
`);
    } else if (t !== "strictEqualObject") {
      var k = 80;
      if (_ < k) {
        for (; h[0][g] === d[0][g]; )
          g++;
        g > 2 && (x = `
  `.concat(Vz(" ", g), "^"), g = 0);
      }
    }
  }
  for (var P = h[h.length - 1], N = d[d.length - 1]; P === N && (g++ < 2 ? o = `
  `.concat(P).concat(o) : n = P, h.pop(), d.pop(), !(h.length === 0 || d.length === 0)); )
    P = h[h.length - 1], N = d[d.length - 1];
  var M = Math.max(h.length, d.length);
  if (M === 0) {
    var G = c.split(`
`);
    if (G.length > 30)
      for (G[26] = "".concat(jo, "...").concat(Hn); G.length > 27; )
        G.pop();
    return "".concat(tl.notIdentical, `

`).concat(G.join(`
`), `
`);
  }
  g > 3 && (o = `
`.concat(jo, "...").concat(Hn).concat(o), s = !0), n !== "" && (o = `
  `.concat(n).concat(o), n = "");
  var z = 0, j = tl[t] + `
`.concat($p, "+ actual").concat(Hn, " ").concat(zp, "- expected").concat(Hn), R = " ".concat(jo, "...").concat(Hn, " Lines skipped");
  for (g = 0; g < M; g++) {
    var te = g - a;
    if (h.length < g + 1)
      te > 1 && g > 2 && (te > 4 ? (i += `
`.concat(jo, "...").concat(Hn), s = !0) : te > 3 && (i += `
  `.concat(d[g - 2]), z++), i += `
  `.concat(d[g - 1]), z++), a = g, n += `
`.concat(zp, "-").concat(Hn, " ").concat(d[g]), z++;
    else if (d.length < g + 1)
      te > 1 && g > 2 && (te > 4 ? (i += `
`.concat(jo, "...").concat(Hn), s = !0) : te > 3 && (i += `
  `.concat(h[g - 2]), z++), i += `
  `.concat(h[g - 1]), z++), a = g, i += `
`.concat($p, "+").concat(Hn, " ").concat(h[g]), z++;
    else {
      var J = d[g], K = h[g], ee = K !== J && (!_b(K, ",") || K.slice(0, -1) !== J);
      ee && _b(J, ",") && J.slice(0, -1) === K && (ee = !1, K += ","), ee ? (te > 1 && g > 2 && (te > 4 ? (i += `
`.concat(jo, "...").concat(Hn), s = !0) : te > 3 && (i += `
  `.concat(h[g - 2]), z++), i += `
  `.concat(h[g - 1]), z++), a = g, i += `
`.concat($p, "+").concat(Hn, " ").concat(K), n += `
`.concat(zp, "-").concat(Hn, " ").concat(J), z += 2) : (i += n, n = "", (te === 1 || g === 0) && (i += `
  `.concat(K), z++));
    }
    if (z > 20 && g < M - 2)
      return "".concat(j).concat(R, `
`).concat(i, `
`).concat(jo, "...").concat(Hn).concat(n, `
`) + "".concat(jo, "...").concat(Hn);
  }
  return "".concat(j).concat(s ? R : "", `
`).concat(i).concat(n).concat(o).concat(x);
}
var Zz = /* @__PURE__ */ function(r) {
  Uz(e, r);
  function e(t) {
    var n;
    if (Nz(this, e), ta(t) !== "object" || t === null)
      throw new Gz("options", "Object", t);
    var i = t.message, a = t.operator, o = t.stackStartFn, s = t.actual, c = t.expected, h = Error.stackTraceLimit;
    if (Error.stackTraceLimit = 0, i != null)
      n = ac(this, $s(e).call(this, String(i)));
    else if (ta(s) === "object" && s !== null && ta(c) === "object" && c !== null && "stack" in s && s instanceof Error && "stack" in c && c instanceof Error && (s = Db(s), c = Db(c)), a === "deepStrictEqual" || a === "strictEqual")
      n = ac(this, $s(e).call(this, Hz(s, c, a)));
    else if (a === "notDeepStrictEqual" || a === "notStrictEqual") {
      var d = tl[a], g = u1(s).split(`
`);
      if (a === "notStrictEqual" && ta(s) === "object" && s !== null && (d = tl.notStrictEqualObject), g.length > 30)
        for (g[26] = "".concat(jo, "...").concat(Hn); g.length > 27; )
          g.pop();
      g.length === 1 ? n = ac(this, $s(e).call(this, "".concat(d, " ").concat(g[0]))) : n = ac(this, $s(e).call(this, "".concat(d, `

`).concat(g.join(`
`), `
`)));
    } else {
      var x = u1(s), _ = "", k = tl[a];
      a === "notDeepEqual" || a === "notEqual" ? (x = "".concat(tl[a], `

`).concat(x), x.length > 1024 && (x = "".concat(x.slice(0, 1021), "..."))) : (_ = "".concat(u1(c)), x.length > 512 && (x = "".concat(x.slice(0, 509), "...")), _.length > 512 && (_ = "".concat(_.slice(0, 509), "...")), a === "deepEqual" || a === "equal" ? x = "".concat(k, `

`).concat(x, `

should equal

`) : _ = " ".concat(a, " ").concat(_)), n = ac(this, $s(e).call(this, "".concat(x).concat(_)));
    }
    return Error.stackTraceLimit = h, n.generatedMessage = !i, Object.defineProperty(E3(n), "name", {
      value: "AssertionError [ERR_ASSERTION]",
      enumerable: !1,
      writable: !0,
      configurable: !0
    }), n.code = "ERR_ASSERTION", n.actual = s, n.expected = c, n.operator = a, Error.captureStackTrace && Error.captureStackTrace(E3(n), o), n.stack, n.name = "AssertionError", ac(n);
  }
  return Mz(e, [{
    key: "toString",
    value: function() {
      return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
    }
  }, {
    key: D3.custom,
    value: function(n, i) {
      return D3(this, Pz({}, i, {
        customInspect: !1,
        depth: 0
      }));
    }
  }]), e;
}(_3(Error)), qz = Zz;
function ZA(r, e) {
  if (r == null)
    throw new TypeError("Cannot convert first argument to object");
  for (var t = Object(r), n = 1; n < arguments.length; n++) {
    var i = arguments[n];
    if (i != null)
      for (var a = Object.keys(Object(i)), o = 0, s = a.length; o < s; o++) {
        var c = a[o], h = Object.getOwnPropertyDescriptor(i, c);
        h !== void 0 && h.enumerable && (t[c] = i[c]);
      }
  }
  return t;
}
function Xz() {
  Object.assign || Object.defineProperty(Object, "assign", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: ZA
  });
}
var Kz = {
  assign: ZA,
  polyfill: Xz
}, Tb = Object.prototype.toString, qA = function(e) {
  var t = Tb.call(e), n = t === "[object Arguments]";
  return n || (n = t !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && Tb.call(e.callee) === "[object Function]"), n;
}, XA;
if (!Object.keys) {
  var z2 = Object.prototype.hasOwnProperty, kb = Object.prototype.toString, Jz = qA, Sb = Object.prototype.propertyIsEnumerable, Qz = !Sb.call({
    toString: null
  }, "toString"), ej = Sb.call(function() {
  }, "prototype"), j2 = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"], jp = function(e) {
    var t = e.constructor;
    return t && t.prototype === e;
  }, tj = {
    $applicationCache: !0,
    $console: !0,
    $external: !0,
    $frame: !0,
    $frameElement: !0,
    $frames: !0,
    $innerHeight: !0,
    $innerWidth: !0,
    $onmozfullscreenchange: !0,
    $onmozfullscreenerror: !0,
    $outerHeight: !0,
    $outerWidth: !0,
    $pageXOffset: !0,
    $pageYOffset: !0,
    $parent: !0,
    $scrollLeft: !0,
    $scrollTop: !0,
    $scrollX: !0,
    $scrollY: !0,
    $self: !0,
    $webkitIndexedDB: !0,
    $webkitStorageInfo: !0,
    $window: !0
  }, rj = function() {
    if (typeof window > "u")
      return !1;
    for (var r in window)
      try {
        if (!tj["$" + r] && z2.call(window, r) && window[r] !== null && typeof window[r] == "object")
          try {
            jp(window[r]);
          } catch {
            return !0;
          }
      } catch {
        return !0;
      }
    return !1;
  }(), nj = function(e) {
    if (typeof window > "u" || !rj)
      return jp(e);
    try {
      return jp(e);
    } catch {
      return !1;
    }
  };
  XA = function(e) {
    var t = e !== null && typeof e == "object", n = kb.call(e) === "[object Function]", i = Jz(e), a = t && kb.call(e) === "[object String]", o = [];
    if (!t && !n && !i)
      throw new TypeError("Object.keys called on a non-object");
    var s = ej && n;
    if (a && e.length > 0 && !z2.call(e, 0))
      for (var c = 0; c < e.length; ++c)
        o.push(String(c));
    if (i && e.length > 0)
      for (var h = 0; h < e.length; ++h)
        o.push(String(h));
    else
      for (var d in e)
        !(s && d === "prototype") && z2.call(e, d) && o.push(String(d));
    if (Qz)
      for (var g = nj(e), x = 0; x < j2.length; ++x)
        !(g && j2[x] === "constructor") && z2.call(e, j2[x]) && o.push(j2[x]);
    return o;
  };
}
var ij = XA, aj = Array.prototype.slice, oj = qA, Cb = Object.keys, Rh = Cb ? function(e) {
  return Cb(e);
} : ij, Fb = Object.keys;
Rh.shim = function() {
  if (Object.keys) {
    var e = function() {
      var t = Object.keys(arguments);
      return t && t.length === arguments.length;
    }(1, 2);
    e || (Object.keys = function(n) {
      return oj(n) ? Fb(aj.call(n)) : Fb(n);
    });
  } else
    Object.keys = Rh;
  return Object.keys || Rh;
};
var sj = Rh, uj = sj, lj = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", cj = Object.prototype.toString, fj = Array.prototype.concat, eg = Object.defineProperty, hj = function(e) {
  return typeof e == "function" && cj.call(e) === "[object Function]";
}, dj = function() {
  var e = {};
  try {
    eg(e, "x", {
      enumerable: !1,
      value: e
    });
    for (var t in e)
      return !1;
    return e.x === e;
  } catch {
    return !1;
  }
}, KA = eg && dj(), pj = function(e, t, n, i) {
  t in e && (!hj(i) || !i()) || (KA ? eg(e, t, {
    configurable: !0,
    enumerable: !1,
    value: n,
    writable: !0
  }) : e[t] = n);
}, JA = function(e, t) {
  var n = arguments.length > 2 ? arguments[2] : {}, i = uj(t);
  lj && (i = fj.call(i, Object.getOwnPropertySymbols(t)));
  for (var a = 0; a < i.length; a += 1)
    pj(e, i[a], t[i[a]], n[i[a]]);
};
JA.supportsDescriptors = !!KA;
var f5 = JA, Ob = function(e) {
  return e !== e;
}, QA = function(e, t) {
  return e === 0 && t === 0 ? 1 / e === 1 / t : !!(e === t || Ob(e) && Ob(t));
}, vj = QA, ex = function() {
  return typeof Object.is == "function" ? Object.is : vj;
}, gj = ex, mj = f5, yj = function() {
  var e = gj();
  return mj(Object, {
    is: e
  }, {
    is: function() {
      return Object.is !== e;
    }
  }), e;
}, bj = f5, wj = u5.exports, Aj = QA, tx = ex, xj = yj, rx = wj(tx(), Object);
bj(rx, {
  getPolyfill: tx,
  implementation: Aj,
  shim: xj
});
var nx = rx, ix = function(e) {
  return e !== e;
}, Ej = ix, ax = function() {
  return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : Ej;
}, _j = f5, Dj = ax, Tj = function() {
  var e = Dj();
  return _j(Number, {
    isNaN: e
  }, {
    isNaN: function() {
      return Number.isNaN !== e;
    }
  }), e;
}, kj = u5.exports, Sj = f5, Cj = ix, ox = ax, Fj = Tj, sx = kj(ox(), Number);
Sj(sx, {
  getPolyfill: ox,
  implementation: Cj,
  shim: Fj
});
var Oj = sx;
function Rb(r, e) {
  return Pj(r) || Ij(r, e) || Rj();
}
function Rj() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function Ij(r, e) {
  var t = [], n = !0, i = !1, a = void 0;
  try {
    for (var o = r[Symbol.iterator](), s; !(n = (s = o.next()).done) && (t.push(s.value), !(e && t.length === e)); n = !0)
      ;
  } catch (c) {
    i = !0, a = c;
  } finally {
    try {
      !n && o.return != null && o.return();
    } finally {
      if (i) throw a;
    }
  }
  return t;
}
function Pj(r) {
  if (Array.isArray(r)) return r;
}
function Ti(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ti = function(t) {
    return typeof t;
  } : Ti = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ti(r);
}
var Bj = /a/g.flags !== void 0, Ad = function(e) {
  var t = [];
  return e.forEach(function(n) {
    return t.push(n);
  }), t;
}, Ib = function(e) {
  var t = [];
  return e.forEach(function(n, i) {
    return t.push([i, n]);
  }), t;
}, ux = Object.is ? Object.is : nx, Ih = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
  return [];
}, T3 = Number.isNaN ? Number.isNaN : Oj;
function tg(r) {
  return r.call.bind(r);
}
var qf = tg(Object.prototype.hasOwnProperty), Ph = tg(Object.prototype.propertyIsEnumerable), Pb = tg(Object.prototype.toString), Jn = Kn.types, Nj = Jn.isAnyArrayBuffer, Lj = Jn.isArrayBufferView, Bb = Jn.isDate, W2 = Jn.isMap, Nb = Jn.isRegExp, G2 = Jn.isSet, Mj = Jn.isNativeError, Uj = Jn.isBoxedPrimitive, Lb = Jn.isNumberObject, Mb = Jn.isStringObject, Ub = Jn.isBooleanObject, $b = Jn.isBigIntObject, $j = Jn.isSymbolObject, zj = Jn.isFloat32Array, jj = Jn.isFloat64Array;
function Wj(r) {
  if (r.length === 0 || r.length > 10) return !0;
  for (var e = 0; e < r.length; e++) {
    var t = r.charCodeAt(e);
    if (t < 48 || t > 57) return !0;
  }
  return r.length === 10 && r >= Math.pow(2, 32);
}
function V2(r) {
  return Object.keys(r).filter(Wj).concat(Ih(r).filter(Object.prototype.propertyIsEnumerable.bind(r)));
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function lx(r, e) {
  if (r === e)
    return 0;
  for (var t = r.length, n = e.length, i = 0, a = Math.min(t, n); i < a; ++i)
    if (r[i] !== e[i]) {
      t = r[i], n = e[i];
      break;
    }
  return t < n ? -1 : n < t ? 1 : 0;
}
var Gj = !0, Vj = !1, k3 = 0, rg = 1, cx = 2, fx = 3;
function Yj(r, e) {
  return Bj ? r.source === e.source && r.flags === e.flags : RegExp.prototype.toString.call(r) === RegExp.prototype.toString.call(e);
}
function Hj(r, e) {
  if (r.byteLength !== e.byteLength)
    return !1;
  for (var t = 0; t < r.byteLength; t++)
    if (r[t] !== e[t])
      return !1;
  return !0;
}
function Zj(r, e) {
  return r.byteLength !== e.byteLength ? !1 : lx(new Uint8Array(r.buffer, r.byteOffset, r.byteLength), new Uint8Array(e.buffer, e.byteOffset, e.byteLength)) === 0;
}
function qj(r, e) {
  return r.byteLength === e.byteLength && lx(new Uint8Array(r), new Uint8Array(e)) === 0;
}
function Xj(r, e) {
  return Lb(r) ? Lb(e) && ux(Number.prototype.valueOf.call(r), Number.prototype.valueOf.call(e)) : Mb(r) ? Mb(e) && String.prototype.valueOf.call(r) === String.prototype.valueOf.call(e) : Ub(r) ? Ub(e) && Boolean.prototype.valueOf.call(r) === Boolean.prototype.valueOf.call(e) : $b(r) ? $b(e) && BigInt.prototype.valueOf.call(r) === BigInt.prototype.valueOf.call(e) : $j(e) && Symbol.prototype.valueOf.call(r) === Symbol.prototype.valueOf.call(e);
}
function aa(r, e, t, n) {
  if (r === e)
    return r !== 0 ? !0 : t ? ux(r, e) : !0;
  if (t) {
    if (Ti(r) !== "object")
      return typeof r == "number" && T3(r) && T3(e);
    if (Ti(e) !== "object" || r === null || e === null || Object.getPrototypeOf(r) !== Object.getPrototypeOf(e))
      return !1;
  } else {
    if (r === null || Ti(r) !== "object")
      return e === null || Ti(e) !== "object" ? r == e : !1;
    if (e === null || Ti(e) !== "object")
      return !1;
  }
  var i = Pb(r), a = Pb(e);
  if (i !== a)
    return !1;
  if (Array.isArray(r)) {
    if (r.length !== e.length)
      return !1;
    var o = V2(r), s = V2(e);
    return o.length !== s.length ? !1 : Gf(r, e, t, n, rg, o);
  }
  if (i === "[object Object]" && (!W2(r) && W2(e) || !G2(r) && G2(e)))
    return !1;
  if (Bb(r)) {
    if (!Bb(e) || Date.prototype.getTime.call(r) !== Date.prototype.getTime.call(e))
      return !1;
  } else if (Nb(r)) {
    if (!Nb(e) || !Yj(r, e))
      return !1;
  } else if (Mj(r) || r instanceof Error) {
    if (r.message !== e.message || r.name !== e.name)
      return !1;
  } else if (Lj(r)) {
    if (!t && (zj(r) || jj(r))) {
      if (!Hj(r, e))
        return !1;
    } else if (!Zj(r, e))
      return !1;
    var c = V2(r), h = V2(e);
    return c.length !== h.length ? !1 : Gf(r, e, t, n, k3, c);
  } else {
    if (G2(r))
      return !G2(e) || r.size !== e.size ? !1 : Gf(r, e, t, n, cx);
    if (W2(r))
      return !W2(e) || r.size !== e.size ? !1 : Gf(r, e, t, n, fx);
    if (Nj(r)) {
      if (!qj(r, e))
        return !1;
    } else if (Uj(r) && !Xj(r, e))
      return !1;
  }
  return Gf(r, e, t, n, k3);
}
function zb(r, e) {
  return e.filter(function(t) {
    return Ph(r, t);
  });
}
function Gf(r, e, t, n, i, a) {
  if (arguments.length === 5) {
    a = Object.keys(r);
    var o = Object.keys(e);
    if (a.length !== o.length)
      return !1;
  }
  for (var s = 0; s < a.length; s++)
    if (!qf(e, a[s]))
      return !1;
  if (t && arguments.length === 5) {
    var c = Ih(r);
    if (c.length !== 0) {
      var h = 0;
      for (s = 0; s < c.length; s++) {
        var d = c[s];
        if (Ph(r, d)) {
          if (!Ph(e, d))
            return !1;
          a.push(d), h++;
        } else if (Ph(e, d))
          return !1;
      }
      var g = Ih(e);
      if (c.length !== g.length && zb(e, g).length !== h)
        return !1;
    } else {
      var x = Ih(e);
      if (x.length !== 0 && zb(e, x).length !== 0)
        return !1;
    }
  }
  if (a.length === 0 && (i === k3 || i === rg && r.length === 0 || r.size === 0))
    return !0;
  if (n === void 0)
    n = {
      val1: /* @__PURE__ */ new Map(),
      val2: /* @__PURE__ */ new Map(),
      position: 0
    };
  else {
    var _ = n.val1.get(r);
    if (_ !== void 0) {
      var k = n.val2.get(e);
      if (k !== void 0)
        return _ === k;
    }
    n.position++;
  }
  n.val1.set(r, n.position), n.val2.set(e, n.position);
  var P = tW(r, e, t, a, n, i);
  return n.val1.delete(r), n.val2.delete(e), P;
}
function jb(r, e, t, n) {
  for (var i = Ad(r), a = 0; a < i.length; a++) {
    var o = i[a];
    if (aa(e, o, t, n))
      return r.delete(o), !0;
  }
  return !1;
}
function hx(r) {
  switch (Ti(r)) {
    case "undefined":
      return null;
    case "object":
      return;
    case "symbol":
      return !1;
    case "string":
      r = +r;
    case "number":
      if (T3(r))
        return !1;
  }
  return !0;
}
function Kj(r, e, t) {
  var n = hx(t);
  return n ?? (e.has(n) && !r.has(n));
}
function Jj(r, e, t, n, i) {
  var a = hx(t);
  if (a != null)
    return a;
  var o = e.get(a);
  return o === void 0 && !e.has(a) || !aa(n, o, !1, i) ? !1 : !r.has(a) && aa(n, o, !1, i);
}
function Qj(r, e, t, n) {
  for (var i = null, a = Ad(r), o = 0; o < a.length; o++) {
    var s = a[o];
    if (Ti(s) === "object" && s !== null)
      i === null && (i = /* @__PURE__ */ new Set()), i.add(s);
    else if (!e.has(s)) {
      if (t || !Kj(r, e, s))
        return !1;
      i === null && (i = /* @__PURE__ */ new Set()), i.add(s);
    }
  }
  if (i !== null) {
    for (var c = Ad(e), h = 0; h < c.length; h++) {
      var d = c[h];
      if (Ti(d) === "object" && d !== null) {
        if (!jb(i, d, t, n)) return !1;
      } else if (!t && !r.has(d) && !jb(i, d, t, n))
        return !1;
    }
    return i.size === 0;
  }
  return !0;
}
function Wb(r, e, t, n, i, a) {
  for (var o = Ad(r), s = 0; s < o.length; s++) {
    var c = o[s];
    if (aa(t, c, i, a) && aa(n, e.get(c), i, a))
      return r.delete(c), !0;
  }
  return !1;
}
function eW(r, e, t, n) {
  for (var i = null, a = Ib(r), o = 0; o < a.length; o++) {
    var s = Rb(a[o], 2), c = s[0], h = s[1];
    if (Ti(c) === "object" && c !== null)
      i === null && (i = /* @__PURE__ */ new Set()), i.add(c);
    else {
      var d = e.get(c);
      if (d === void 0 && !e.has(c) || !aa(h, d, t, n)) {
        if (t || !Jj(r, e, c, h, n)) return !1;
        i === null && (i = /* @__PURE__ */ new Set()), i.add(c);
      }
    }
  }
  if (i !== null) {
    for (var g = Ib(e), x = 0; x < g.length; x++) {
      var _ = Rb(g[x], 2), c = _[0], k = _[1];
      if (Ti(c) === "object" && c !== null) {
        if (!Wb(i, r, c, k, t, n)) return !1;
      } else if (!t && (!r.has(c) || !aa(r.get(c), k, !1, n)) && !Wb(i, r, c, k, !1, n))
        return !1;
    }
    return i.size === 0;
  }
  return !0;
}
function tW(r, e, t, n, i, a) {
  var o = 0;
  if (a === cx) {
    if (!Qj(r, e, t, i))
      return !1;
  } else if (a === fx) {
    if (!eW(r, e, t, i))
      return !1;
  } else if (a === rg)
    for (; o < r.length; o++)
      if (qf(r, o)) {
        if (!qf(e, o) || !aa(r[o], e[o], t, i))
          return !1;
      } else {
        if (qf(e, o))
          return !1;
        for (var s = Object.keys(r); o < s.length; o++) {
          var c = s[o];
          if (!qf(e, c) || !aa(r[c], e[c], t, i))
            return !1;
        }
        return s.length === Object.keys(e).length;
      }
  for (o = 0; o < n.length; o++) {
    var h = n[o];
    if (!aa(r[h], e[h], t, i))
      return !1;
  }
  return !0;
}
function rW(r, e) {
  return aa(r, e, Vj);
}
function nW(r, e) {
  return aa(r, e, Gj);
}
var iW = {
  isDeepEqual: rW,
  isDeepStrictEqual: nW
};
function eu(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? eu = function(t) {
    return typeof t;
  } : eu = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, eu(r);
}
function aW(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var oW = Qv, t2 = oW.codes, Gb = t2.ERR_AMBIGUOUS_ARGUMENT, S1 = t2.ERR_INVALID_ARG_TYPE, sW = t2.ERR_INVALID_ARG_VALUE, uW = t2.ERR_INVALID_RETURN_VALUE, du = t2.ERR_MISSING_ARGS, Sl = qz, lW = Kn, cW = lW.inspect, dx = Kn.types, fW = dx.isPromise, S3 = dx.isRegExp, hW = Object.assign ? Object.assign : Kz.assign, px = Object.is ? Object.is : nx, su, h5;
function r2() {
  var r = iW;
  su = r.isDeepEqual, h5 = r.isDeepStrictEqual;
}
var Vb = !1, p0 = Q1.exports = ng, d5 = {};
function Ra(r) {
  throw r.message instanceof Error ? r.message : new Sl(r);
}
function vx(r, e, t, n, i) {
  var a = arguments.length, o;
  if (a === 0)
    o = "Failed";
  else if (a === 1)
    t = r, r = void 0;
  else {
    if (Vb === !1) {
      Vb = !0;
      var s = console.warn.bind(console);
      s("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
    }
    a === 2 && (n = "!=");
  }
  if (t instanceof Error) throw t;
  var c = {
    actual: r,
    expected: e,
    operator: n === void 0 ? "fail" : n,
    stackStartFn: i || vx
  };
  t !== void 0 && (c.message = t);
  var h = new Sl(c);
  throw o && (h.message = o, h.generatedMessage = !0), h;
}
p0.fail = vx;
p0.AssertionError = Sl;
function gx(r, e, t, n) {
  if (!t) {
    var i = !1;
    if (e === 0)
      i = !0, n = "No value argument passed to `assert.ok()`";
    else if (n instanceof Error)
      throw n;
    var a = new Sl({
      actual: t,
      expected: !0,
      message: n,
      operator: "==",
      stackStartFn: r
    });
    throw a.generatedMessage = i, a;
  }
}
function ng() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  gx.apply(void 0, [ng, e.length].concat(e));
}
p0.ok = ng;
p0.equal = function r(e, t, n) {
  if (arguments.length < 2)
    throw new du("actual", "expected");
  e != t && Ra({
    actual: e,
    expected: t,
    message: n,
    operator: "==",
    stackStartFn: r
  });
};
p0.notEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new du("actual", "expected");
  e == t && Ra({
    actual: e,
    expected: t,
    message: n,
    operator: "!=",
    stackStartFn: r
  });
};
p0.deepEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new du("actual", "expected");
  su === void 0 && r2(), su(e, t) || Ra({
    actual: e,
    expected: t,
    message: n,
    operator: "deepEqual",
    stackStartFn: r
  });
};
p0.notDeepEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new du("actual", "expected");
  su === void 0 && r2(), su(e, t) && Ra({
    actual: e,
    expected: t,
    message: n,
    operator: "notDeepEqual",
    stackStartFn: r
  });
};
p0.deepStrictEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new du("actual", "expected");
  su === void 0 && r2(), h5(e, t) || Ra({
    actual: e,
    expected: t,
    message: n,
    operator: "deepStrictEqual",
    stackStartFn: r
  });
};
p0.notDeepStrictEqual = mx;
function mx(r, e, t) {
  if (arguments.length < 2)
    throw new du("actual", "expected");
  su === void 0 && r2(), h5(r, e) && Ra({
    actual: r,
    expected: e,
    message: t,
    operator: "notDeepStrictEqual",
    stackStartFn: mx
  });
}
p0.strictEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new du("actual", "expected");
  px(e, t) || Ra({
    actual: e,
    expected: t,
    message: n,
    operator: "strictEqual",
    stackStartFn: r
  });
};
p0.notStrictEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new du("actual", "expected");
  px(e, t) && Ra({
    actual: e,
    expected: t,
    message: n,
    operator: "notStrictEqual",
    stackStartFn: r
  });
};
var Yb = function r(e, t, n) {
  var i = this;
  aW(this, r), t.forEach(function(a) {
    a in e && (n !== void 0 && typeof n[a] == "string" && S3(e[a]) && e[a].test(n[a]) ? i[a] = n[a] : i[a] = e[a]);
  });
};
function dW(r, e, t, n, i, a) {
  if (!(t in r) || !h5(r[t], e[t])) {
    if (!n) {
      var o = new Yb(r, i), s = new Yb(e, i, r), c = new Sl({
        actual: o,
        expected: s,
        operator: "deepStrictEqual",
        stackStartFn: a
      });
      throw c.actual = r, c.expected = e, c.operator = a.name, c;
    }
    Ra({
      actual: r,
      expected: e,
      message: n,
      operator: a.name,
      stackStartFn: a
    });
  }
}
function yx(r, e, t, n) {
  if (typeof e != "function") {
    if (S3(e)) return e.test(r);
    if (arguments.length === 2)
      throw new S1("expected", ["Function", "RegExp"], e);
    if (eu(r) !== "object" || r === null) {
      var i = new Sl({
        actual: r,
        expected: e,
        message: t,
        operator: "deepStrictEqual",
        stackStartFn: n
      });
      throw i.operator = n.name, i;
    }
    var a = Object.keys(e);
    if (e instanceof Error)
      a.push("name", "message");
    else if (a.length === 0)
      throw new sW("error", e, "may not be an empty object");
    return su === void 0 && r2(), a.forEach(function(o) {
      typeof r[o] == "string" && S3(e[o]) && e[o].test(r[o]) || dW(r, e, o, t, a, n);
    }), !0;
  }
  return e.prototype !== void 0 && r instanceof e ? !0 : Error.isPrototypeOf(e) ? !1 : e.call({}, r) === !0;
}
function bx(r) {
  if (typeof r != "function")
    throw new S1("fn", "Function", r);
  try {
    r();
  } catch (e) {
    return e;
  }
  return d5;
}
function Hb(r) {
  return fW(r) || r !== null && eu(r) === "object" && typeof r.then == "function" && typeof r.catch == "function";
}
function wx(r) {
  return Promise.resolve().then(function() {
    var e;
    if (typeof r == "function") {
      if (e = r(), !Hb(e))
        throw new uW("instance of Promise", "promiseFn", e);
    } else if (Hb(r))
      e = r;
    else
      throw new S1("promiseFn", ["Function", "Promise"], r);
    return Promise.resolve().then(function() {
      return e;
    }).then(function() {
      return d5;
    }).catch(function(t) {
      return t;
    });
  });
}
function Ax(r, e, t, n) {
  if (typeof t == "string") {
    if (arguments.length === 4)
      throw new S1("error", ["Object", "Error", "Function", "RegExp"], t);
    if (eu(e) === "object" && e !== null) {
      if (e.message === t)
        throw new Gb("error/message", 'The error message "'.concat(e.message, '" is identical to the message.'));
    } else if (e === t)
      throw new Gb("error/message", 'The error "'.concat(e, '" is identical to the message.'));
    n = t, t = void 0;
  } else if (t != null && eu(t) !== "object" && typeof t != "function")
    throw new S1("error", ["Object", "Error", "Function", "RegExp"], t);
  if (e === d5) {
    var i = "";
    t && t.name && (i += " (".concat(t.name, ")")), i += n ? ": ".concat(n) : ".";
    var a = r.name === "rejects" ? "rejection" : "exception";
    Ra({
      actual: void 0,
      expected: t,
      operator: r.name,
      message: "Missing expected ".concat(a).concat(i),
      stackStartFn: r
    });
  }
  if (t && !yx(e, t, n, r))
    throw e;
}
function xx(r, e, t, n) {
  if (e !== d5) {
    if (typeof t == "string" && (n = t, t = void 0), !t || yx(e, t)) {
      var i = n ? ": ".concat(n) : ".", a = r.name === "doesNotReject" ? "rejection" : "exception";
      Ra({
        actual: e,
        expected: t,
        operator: r.name,
        message: "Got unwanted ".concat(a).concat(i, `
`) + 'Actual message: "'.concat(e && e.message, '"'),
        stackStartFn: r
      });
    }
    throw e;
  }
}
p0.throws = function r(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  Ax.apply(void 0, [r, bx(e)].concat(n));
};
p0.rejects = function r(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return wx(e).then(function(a) {
    return Ax.apply(void 0, [r, a].concat(n));
  });
};
p0.doesNotThrow = function r(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  xx.apply(void 0, [r, bx(e)].concat(n));
};
p0.doesNotReject = function r(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return wx(e).then(function(a) {
    return xx.apply(void 0, [r, a].concat(n));
  });
};
p0.ifError = function r(e) {
  if (e != null) {
    var t = "ifError got unwanted exception: ";
    eu(e) === "object" && typeof e.message == "string" ? e.message.length === 0 && e.constructor ? t += e.constructor.name : t += e.message : t += cW(e);
    var n = new Sl({
      actual: e,
      expected: null,
      operator: "ifError",
      message: t,
      stackStartFn: r
    }), i = e.stack;
    if (typeof i == "string") {
      var a = i.split(`
`);
      a.shift();
      for (var o = n.stack.split(`
`), s = 0; s < a.length; s++) {
        var c = o.indexOf(a[s]);
        if (c !== -1) {
          o = o.slice(0, c);
          break;
        }
      }
      n.stack = "".concat(o.join(`
`), `
`).concat(a.join(`
`));
    }
    throw n;
  }
};
function Ex() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  gx.apply(void 0, [Ex, e.length].concat(e));
}
p0.strict = hW(Ex, p0, {
  equal: p0.strictEqual,
  deepEqual: p0.deepStrictEqual,
  notEqual: p0.notStrictEqual,
  notDeepEqual: p0.notDeepStrictEqual
});
p0.strict.strict = p0.strict;
function pW() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var vW = pW, Eo = {}, n2 = {};
(function(r) {
  var e = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
  function t(a, o) {
    return Object.prototype.hasOwnProperty.call(a, o);
  }
  r.assign = function(a) {
    for (var o = Array.prototype.slice.call(arguments, 1); o.length; ) {
      var s = o.shift();
      if (s) {
        if (typeof s != "object")
          throw new TypeError(s + "must be non-object");
        for (var c in s)
          t(s, c) && (a[c] = s[c]);
      }
    }
    return a;
  }, r.shrinkBuf = function(a, o) {
    return a.length === o ? a : a.subarray ? a.subarray(0, o) : (a.length = o, a);
  };
  var n = {
    arraySet: function(o, s, c, h, d) {
      if (s.subarray && o.subarray) {
        o.set(s.subarray(c, c + h), d);
        return;
      }
      for (var g = 0; g < h; g++)
        o[d + g] = s[c + g];
    },
    // Join array of chunks to single array.
    flattenChunks: function(o) {
      var s, c, h, d, g, x;
      for (h = 0, s = 0, c = o.length; s < c; s++)
        h += o[s].length;
      for (x = new Uint8Array(h), d = 0, s = 0, c = o.length; s < c; s++)
        g = o[s], x.set(g, d), d += g.length;
      return x;
    }
  }, i = {
    arraySet: function(o, s, c, h, d) {
      for (var g = 0; g < h; g++)
        o[d + g] = s[c + g];
    },
    // Join array of chunks to single array.
    flattenChunks: function(o) {
      return [].concat.apply([], o);
    }
  };
  r.setTyped = function(a) {
    a ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, n)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, i));
  }, r.setTyped(e);
})(n2);
var of = {}, gW = n2, mW = 4, Zb = 0, qb = 1, yW = 2;
function sf(r) {
  for (var e = r.length; --e >= 0; )
    r[e] = 0;
}
var bW = 0, _x = 1, wW = 2, AW = 3, xW = 258, ig = 29, i2 = 256, C1 = i2 + 1 + ig, Bc = 30, ag = 19, Dx = 2 * C1 + 1, rl = 15, Wp = 16, EW = 7, og = 256, Tx = 16, kx = 17, Sx = 18, C3 = (
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
), Bh = (
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
), _W = (
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
), Cx = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], DW = 512, Yo = new Array((C1 + 2) * 2);
sf(Yo);
var l1 = new Array(Bc * 2);
sf(l1);
var F1 = new Array(DW);
sf(F1);
var O1 = new Array(xW - AW + 1);
sf(O1);
var sg = new Array(ig);
sf(sg);
var xd = new Array(Bc);
sf(xd);
function Gp(r, e, t, n, i) {
  this.static_tree = r, this.extra_bits = e, this.extra_base = t, this.elems = n, this.max_length = i, this.has_stree = r && r.length;
}
var Fx, Ox, Rx;
function Vp(r, e) {
  this.dyn_tree = r, this.max_code = 0, this.stat_desc = e;
}
function Ix(r) {
  return r < 256 ? F1[r] : F1[256 + (r >>> 7)];
}
function R1(r, e) {
  r.pending_buf[r.pending++] = e & 255, r.pending_buf[r.pending++] = e >>> 8 & 255;
}
function ci(r, e, t) {
  r.bi_valid > Wp - t ? (r.bi_buf |= e << r.bi_valid & 65535, R1(r, r.bi_buf), r.bi_buf = e >> Wp - r.bi_valid, r.bi_valid += t - Wp) : (r.bi_buf |= e << r.bi_valid & 65535, r.bi_valid += t);
}
function oo(r, e, t) {
  ci(
    r,
    t[e * 2],
    t[e * 2 + 1]
    /*.Len*/
  );
}
function Px(r, e) {
  var t = 0;
  do
    t |= r & 1, r >>>= 1, t <<= 1;
  while (--e > 0);
  return t >>> 1;
}
function TW(r) {
  r.bi_valid === 16 ? (R1(r, r.bi_buf), r.bi_buf = 0, r.bi_valid = 0) : r.bi_valid >= 8 && (r.pending_buf[r.pending++] = r.bi_buf & 255, r.bi_buf >>= 8, r.bi_valid -= 8);
}
function kW(r, e) {
  var t = e.dyn_tree, n = e.max_code, i = e.stat_desc.static_tree, a = e.stat_desc.has_stree, o = e.stat_desc.extra_bits, s = e.stat_desc.extra_base, c = e.stat_desc.max_length, h, d, g, x, _, k, P = 0;
  for (x = 0; x <= rl; x++)
    r.bl_count[x] = 0;
  for (t[r.heap[r.heap_max] * 2 + 1] = 0, h = r.heap_max + 1; h < Dx; h++)
    d = r.heap[h], x = t[t[d * 2 + 1] * 2 + 1] + 1, x > c && (x = c, P++), t[d * 2 + 1] = x, !(d > n) && (r.bl_count[x]++, _ = 0, d >= s && (_ = o[d - s]), k = t[d * 2], r.opt_len += k * (x + _), a && (r.static_len += k * (i[d * 2 + 1] + _)));
  if (P !== 0) {
    do {
      for (x = c - 1; r.bl_count[x] === 0; )
        x--;
      r.bl_count[x]--, r.bl_count[x + 1] += 2, r.bl_count[c]--, P -= 2;
    } while (P > 0);
    for (x = c; x !== 0; x--)
      for (d = r.bl_count[x]; d !== 0; )
        g = r.heap[--h], !(g > n) && (t[g * 2 + 1] !== x && (r.opt_len += (x - t[g * 2 + 1]) * t[g * 2], t[g * 2 + 1] = x), d--);
  }
}
function Bx(r, e, t) {
  var n = new Array(rl + 1), i = 0, a, o;
  for (a = 1; a <= rl; a++)
    n[a] = i = i + t[a - 1] << 1;
  for (o = 0; o <= e; o++) {
    var s = r[o * 2 + 1];
    s !== 0 && (r[o * 2] = Px(n[s]++, s));
  }
}
function SW() {
  var r, e, t, n, i, a = new Array(rl + 1);
  for (t = 0, n = 0; n < ig - 1; n++)
    for (sg[n] = t, r = 0; r < 1 << C3[n]; r++)
      O1[t++] = n;
  for (O1[t - 1] = n, i = 0, n = 0; n < 16; n++)
    for (xd[n] = i, r = 0; r < 1 << Bh[n]; r++)
      F1[i++] = n;
  for (i >>= 7; n < Bc; n++)
    for (xd[n] = i << 7, r = 0; r < 1 << Bh[n] - 7; r++)
      F1[256 + i++] = n;
  for (e = 0; e <= rl; e++)
    a[e] = 0;
  for (r = 0; r <= 143; )
    Yo[r * 2 + 1] = 8, r++, a[8]++;
  for (; r <= 255; )
    Yo[r * 2 + 1] = 9, r++, a[9]++;
  for (; r <= 279; )
    Yo[r * 2 + 1] = 7, r++, a[7]++;
  for (; r <= 287; )
    Yo[r * 2 + 1] = 8, r++, a[8]++;
  for (Bx(Yo, C1 + 1, a), r = 0; r < Bc; r++)
    l1[r * 2 + 1] = 5, l1[r * 2] = Px(r, 5);
  Fx = new Gp(Yo, C3, i2 + 1, C1, rl), Ox = new Gp(l1, Bh, 0, Bc, rl), Rx = new Gp(new Array(0), _W, 0, ag, EW);
}
function Nx(r) {
  var e;
  for (e = 0; e < C1; e++)
    r.dyn_ltree[e * 2] = 0;
  for (e = 0; e < Bc; e++)
    r.dyn_dtree[e * 2] = 0;
  for (e = 0; e < ag; e++)
    r.bl_tree[e * 2] = 0;
  r.dyn_ltree[og * 2] = 1, r.opt_len = r.static_len = 0, r.last_lit = r.matches = 0;
}
function Lx(r) {
  r.bi_valid > 8 ? R1(r, r.bi_buf) : r.bi_valid > 0 && (r.pending_buf[r.pending++] = r.bi_buf), r.bi_buf = 0, r.bi_valid = 0;
}
function CW(r, e, t, n) {
  Lx(r), R1(r, t), R1(r, ~t), gW.arraySet(r.pending_buf, r.window, e, t, r.pending), r.pending += t;
}
function Xb(r, e, t, n) {
  var i = e * 2, a = t * 2;
  return r[i] < r[a] || r[i] === r[a] && n[e] <= n[t];
}
function Yp(r, e, t) {
  for (var n = r.heap[t], i = t << 1; i <= r.heap_len && (i < r.heap_len && Xb(e, r.heap[i + 1], r.heap[i], r.depth) && i++, !Xb(e, n, r.heap[i], r.depth)); )
    r.heap[t] = r.heap[i], t = i, i <<= 1;
  r.heap[t] = n;
}
function Kb(r, e, t) {
  var n, i, a = 0, o, s;
  if (r.last_lit !== 0)
    do
      n = r.pending_buf[r.d_buf + a * 2] << 8 | r.pending_buf[r.d_buf + a * 2 + 1], i = r.pending_buf[r.l_buf + a], a++, n === 0 ? oo(r, i, e) : (o = O1[i], oo(r, o + i2 + 1, e), s = C3[o], s !== 0 && (i -= sg[o], ci(r, i, s)), n--, o = Ix(n), oo(r, o, t), s = Bh[o], s !== 0 && (n -= xd[o], ci(r, n, s)));
    while (a < r.last_lit);
  oo(r, og, e);
}
function F3(r, e) {
  var t = e.dyn_tree, n = e.stat_desc.static_tree, i = e.stat_desc.has_stree, a = e.stat_desc.elems, o, s, c = -1, h;
  for (r.heap_len = 0, r.heap_max = Dx, o = 0; o < a; o++)
    t[o * 2] !== 0 ? (r.heap[++r.heap_len] = c = o, r.depth[o] = 0) : t[o * 2 + 1] = 0;
  for (; r.heap_len < 2; )
    h = r.heap[++r.heap_len] = c < 2 ? ++c : 0, t[h * 2] = 1, r.depth[h] = 0, r.opt_len--, i && (r.static_len -= n[h * 2 + 1]);
  for (e.max_code = c, o = r.heap_len >> 1; o >= 1; o--)
    Yp(r, t, o);
  h = a;
  do
    o = r.heap[
      1
      /*SMALLEST*/
    ], r.heap[
      1
      /*SMALLEST*/
    ] = r.heap[r.heap_len--], Yp(
      r,
      t,
      1
      /*SMALLEST*/
    ), s = r.heap[
      1
      /*SMALLEST*/
    ], r.heap[--r.heap_max] = o, r.heap[--r.heap_max] = s, t[h * 2] = t[o * 2] + t[s * 2], r.depth[h] = (r.depth[o] >= r.depth[s] ? r.depth[o] : r.depth[s]) + 1, t[o * 2 + 1] = t[s * 2 + 1] = h, r.heap[
      1
      /*SMALLEST*/
    ] = h++, Yp(
      r,
      t,
      1
      /*SMALLEST*/
    );
  while (r.heap_len >= 2);
  r.heap[--r.heap_max] = r.heap[
    1
    /*SMALLEST*/
  ], kW(r, e), Bx(t, c, r.bl_count);
}
function Jb(r, e, t) {
  var n, i = -1, a, o = e[0 * 2 + 1], s = 0, c = 7, h = 4;
  for (o === 0 && (c = 138, h = 3), e[(t + 1) * 2 + 1] = 65535, n = 0; n <= t; n++)
    a = o, o = e[(n + 1) * 2 + 1], !(++s < c && a === o) && (s < h ? r.bl_tree[a * 2] += s : a !== 0 ? (a !== i && r.bl_tree[a * 2]++, r.bl_tree[Tx * 2]++) : s <= 10 ? r.bl_tree[kx * 2]++ : r.bl_tree[Sx * 2]++, s = 0, i = a, o === 0 ? (c = 138, h = 3) : a === o ? (c = 6, h = 3) : (c = 7, h = 4));
}
function Qb(r, e, t) {
  var n, i = -1, a, o = e[0 * 2 + 1], s = 0, c = 7, h = 4;
  for (o === 0 && (c = 138, h = 3), n = 0; n <= t; n++)
    if (a = o, o = e[(n + 1) * 2 + 1], !(++s < c && a === o)) {
      if (s < h)
        do
          oo(r, a, r.bl_tree);
        while (--s !== 0);
      else a !== 0 ? (a !== i && (oo(r, a, r.bl_tree), s--), oo(r, Tx, r.bl_tree), ci(r, s - 3, 2)) : s <= 10 ? (oo(r, kx, r.bl_tree), ci(r, s - 3, 3)) : (oo(r, Sx, r.bl_tree), ci(r, s - 11, 7));
      s = 0, i = a, o === 0 ? (c = 138, h = 3) : a === o ? (c = 6, h = 3) : (c = 7, h = 4);
    }
}
function FW(r) {
  var e;
  for (Jb(r, r.dyn_ltree, r.l_desc.max_code), Jb(r, r.dyn_dtree, r.d_desc.max_code), F3(r, r.bl_desc), e = ag - 1; e >= 3 && r.bl_tree[Cx[e] * 2 + 1] === 0; e--)
    ;
  return r.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
}
function OW(r, e, t, n) {
  var i;
  for (ci(r, e - 257, 5), ci(r, t - 1, 5), ci(r, n - 4, 4), i = 0; i < n; i++)
    ci(
      r,
      r.bl_tree[Cx[i] * 2 + 1],
      3
    );
  Qb(r, r.dyn_ltree, e - 1), Qb(r, r.dyn_dtree, t - 1);
}
function RW(r) {
  var e = 4093624447, t;
  for (t = 0; t <= 31; t++, e >>>= 1)
    if (e & 1 && r.dyn_ltree[t * 2] !== 0)
      return Zb;
  if (r.dyn_ltree[9 * 2] !== 0 || r.dyn_ltree[10 * 2] !== 0 || r.dyn_ltree[13 * 2] !== 0)
    return qb;
  for (t = 32; t < i2; t++)
    if (r.dyn_ltree[t * 2] !== 0)
      return qb;
  return Zb;
}
var e6 = !1;
function IW(r) {
  e6 || (SW(), e6 = !0), r.l_desc = new Vp(r.dyn_ltree, Fx), r.d_desc = new Vp(r.dyn_dtree, Ox), r.bl_desc = new Vp(r.bl_tree, Rx), r.bi_buf = 0, r.bi_valid = 0, Nx(r);
}
function Mx(r, e, t, n) {
  ci(r, (bW << 1) + (n ? 1 : 0), 3), CW(r, e, t);
}
function PW(r) {
  ci(r, _x << 1, 3), oo(r, og, Yo), TW(r);
}
function BW(r, e, t, n) {
  var i, a, o = 0;
  r.level > 0 ? (r.strm.data_type === yW && (r.strm.data_type = RW(r)), F3(r, r.l_desc), F3(r, r.d_desc), o = FW(r), i = r.opt_len + 3 + 7 >>> 3, a = r.static_len + 3 + 7 >>> 3, a <= i && (i = a)) : i = a = t + 5, t + 4 <= i && e !== -1 ? Mx(r, e, t, n) : r.strategy === mW || a === i ? (ci(r, (_x << 1) + (n ? 1 : 0), 3), Kb(r, Yo, l1)) : (ci(r, (wW << 1) + (n ? 1 : 0), 3), OW(r, r.l_desc.max_code + 1, r.d_desc.max_code + 1, o + 1), Kb(r, r.dyn_ltree, r.dyn_dtree)), Nx(r), n && Lx(r);
}
function NW(r, e, t) {
  return r.pending_buf[r.d_buf + r.last_lit * 2] = e >>> 8 & 255, r.pending_buf[r.d_buf + r.last_lit * 2 + 1] = e & 255, r.pending_buf[r.l_buf + r.last_lit] = t & 255, r.last_lit++, e === 0 ? r.dyn_ltree[t * 2]++ : (r.matches++, e--, r.dyn_ltree[(O1[t] + i2 + 1) * 2]++, r.dyn_dtree[Ix(e) * 2]++), r.last_lit === r.lit_bufsize - 1;
}
of._tr_init = IW;
of._tr_stored_block = Mx;
of._tr_flush_block = BW;
of._tr_tally = NW;
of._tr_align = PW;
function LW(r, e, t, n) {
  for (var i = r & 65535 | 0, a = r >>> 16 & 65535 | 0, o = 0; t !== 0; ) {
    o = t > 2e3 ? 2e3 : t, t -= o;
    do
      i = i + e[n++] | 0, a = a + i | 0;
    while (--o);
    i %= 65521, a %= 65521;
  }
  return i | a << 16 | 0;
}
var Ux = LW;
function MW() {
  for (var r, e = [], t = 0; t < 256; t++) {
    r = t;
    for (var n = 0; n < 8; n++)
      r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
    e[t] = r;
  }
  return e;
}
var UW = MW();
function $W(r, e, t, n) {
  var i = UW, a = n + t;
  r ^= -1;
  for (var o = n; o < a; o++)
    r = r >>> 8 ^ i[(r ^ e[o]) & 255];
  return r ^ -1;
}
var $x = $W, zW = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, Xn = n2, oa = of, zx = Ux, Os = $x, jW = zW, Cl = 0, WW = 1, GW = 3, tu = 4, t6 = 5, so = 0, r6 = 1, sa = -2, VW = -3, Hp = -5, YW = -1, HW = 1, Y2 = 2, ZW = 3, qW = 4, XW = 0, KW = 2, p5 = 8, JW = 9, QW = 15, eG = 8, tG = 29, rG = 256, O3 = rG + 1 + tG, nG = 30, iG = 19, aG = 2 * O3 + 1, oG = 15, yr = 3, Hs = 258, Ta = Hs + yr + 1, sG = 32, v5 = 42, R3 = 69, Nh = 73, Lh = 91, Mh = 103, nl = 113, Xf = 666, an = 1, a2 = 2, ml = 3, uf = 4, uG = 3;
function Zs(r, e) {
  return r.msg = jW[e], e;
}
function n6(r) {
  return (r << 1) - (r > 4 ? 9 : 0);
}
function zs(r) {
  for (var e = r.length; --e >= 0; )
    r[e] = 0;
}
function Rs(r) {
  var e = r.state, t = e.pending;
  t > r.avail_out && (t = r.avail_out), t !== 0 && (Xn.arraySet(r.output, e.pending_buf, e.pending_out, t, r.next_out), r.next_out += t, e.pending_out += t, r.total_out += t, r.avail_out -= t, e.pending -= t, e.pending === 0 && (e.pending_out = 0));
}
function Tn(r, e) {
  oa._tr_flush_block(r, r.block_start >= 0 ? r.block_start : -1, r.strstart - r.block_start, e), r.block_start = r.strstart, Rs(r.strm);
}
function Pr(r, e) {
  r.pending_buf[r.pending++] = e;
}
function Vf(r, e) {
  r.pending_buf[r.pending++] = e >>> 8 & 255, r.pending_buf[r.pending++] = e & 255;
}
function lG(r, e, t, n) {
  var i = r.avail_in;
  return i > n && (i = n), i === 0 ? 0 : (r.avail_in -= i, Xn.arraySet(e, r.input, r.next_in, i, t), r.state.wrap === 1 ? r.adler = zx(r.adler, e, i, t) : r.state.wrap === 2 && (r.adler = Os(r.adler, e, i, t)), r.next_in += i, r.total_in += i, i);
}
function jx(r, e) {
  var t = r.max_chain_length, n = r.strstart, i, a, o = r.prev_length, s = r.nice_match, c = r.strstart > r.w_size - Ta ? r.strstart - (r.w_size - Ta) : 0, h = r.window, d = r.w_mask, g = r.prev, x = r.strstart + Hs, _ = h[n + o - 1], k = h[n + o];
  r.prev_length >= r.good_match && (t >>= 2), s > r.lookahead && (s = r.lookahead);
  do
    if (i = e, !(h[i + o] !== k || h[i + o - 1] !== _ || h[i] !== h[n] || h[++i] !== h[n + 1])) {
      n += 2, i++;
      do
        ;
      while (h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && h[++n] === h[++i] && n < x);
      if (a = Hs - (x - n), n = x - Hs, a > o) {
        if (r.match_start = e, o = a, a >= s)
          break;
        _ = h[n + o - 1], k = h[n + o];
      }
    }
  while ((e = g[e & d]) > c && --t !== 0);
  return o <= r.lookahead ? o : r.lookahead;
}
function yl(r) {
  var e = r.w_size, t, n, i, a, o;
  do {
    if (a = r.window_size - r.lookahead - r.strstart, r.strstart >= e + (e - Ta)) {
      Xn.arraySet(r.window, r.window, e, e, 0), r.match_start -= e, r.strstart -= e, r.block_start -= e, n = r.hash_size, t = n;
      do
        i = r.head[--t], r.head[t] = i >= e ? i - e : 0;
      while (--n);
      n = e, t = n;
      do
        i = r.prev[--t], r.prev[t] = i >= e ? i - e : 0;
      while (--n);
      a += e;
    }
    if (r.strm.avail_in === 0)
      break;
    if (n = lG(r.strm, r.window, r.strstart + r.lookahead, a), r.lookahead += n, r.lookahead + r.insert >= yr)
      for (o = r.strstart - r.insert, r.ins_h = r.window[o], r.ins_h = (r.ins_h << r.hash_shift ^ r.window[o + 1]) & r.hash_mask; r.insert && (r.ins_h = (r.ins_h << r.hash_shift ^ r.window[o + yr - 1]) & r.hash_mask, r.prev[o & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = o, o++, r.insert--, !(r.lookahead + r.insert < yr)); )
        ;
  } while (r.lookahead < Ta && r.strm.avail_in !== 0);
}
function cG(r, e) {
  var t = 65535;
  for (t > r.pending_buf_size - 5 && (t = r.pending_buf_size - 5); ; ) {
    if (r.lookahead <= 1) {
      if (yl(r), r.lookahead === 0 && e === Cl)
        return an;
      if (r.lookahead === 0)
        break;
    }
    r.strstart += r.lookahead, r.lookahead = 0;
    var n = r.block_start + t;
    if ((r.strstart === 0 || r.strstart >= n) && (r.lookahead = r.strstart - n, r.strstart = n, Tn(r, !1), r.strm.avail_out === 0) || r.strstart - r.block_start >= r.w_size - Ta && (Tn(r, !1), r.strm.avail_out === 0))
      return an;
  }
  return r.insert = 0, e === tu ? (Tn(r, !0), r.strm.avail_out === 0 ? ml : uf) : (r.strstart > r.block_start && (Tn(r, !1), r.strm.avail_out === 0), an);
}
function Zp(r, e) {
  for (var t, n; ; ) {
    if (r.lookahead < Ta) {
      if (yl(r), r.lookahead < Ta && e === Cl)
        return an;
      if (r.lookahead === 0)
        break;
    }
    if (t = 0, r.lookahead >= yr && (r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + yr - 1]) & r.hash_mask, t = r.prev[r.strstart & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = r.strstart), t !== 0 && r.strstart - t <= r.w_size - Ta && (r.match_length = jx(r, t)), r.match_length >= yr)
      if (n = oa._tr_tally(r, r.strstart - r.match_start, r.match_length - yr), r.lookahead -= r.match_length, r.match_length <= r.max_lazy_match && r.lookahead >= yr) {
        r.match_length--;
        do
          r.strstart++, r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + yr - 1]) & r.hash_mask, t = r.prev[r.strstart & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = r.strstart;
        while (--r.match_length !== 0);
        r.strstart++;
      } else
        r.strstart += r.match_length, r.match_length = 0, r.ins_h = r.window[r.strstart], r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + 1]) & r.hash_mask;
    else
      n = oa._tr_tally(r, 0, r.window[r.strstart]), r.lookahead--, r.strstart++;
    if (n && (Tn(r, !1), r.strm.avail_out === 0))
      return an;
  }
  return r.insert = r.strstart < yr - 1 ? r.strstart : yr - 1, e === tu ? (Tn(r, !0), r.strm.avail_out === 0 ? ml : uf) : r.last_lit && (Tn(r, !1), r.strm.avail_out === 0) ? an : a2;
}
function oc(r, e) {
  for (var t, n, i; ; ) {
    if (r.lookahead < Ta) {
      if (yl(r), r.lookahead < Ta && e === Cl)
        return an;
      if (r.lookahead === 0)
        break;
    }
    if (t = 0, r.lookahead >= yr && (r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + yr - 1]) & r.hash_mask, t = r.prev[r.strstart & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = r.strstart), r.prev_length = r.match_length, r.prev_match = r.match_start, r.match_length = yr - 1, t !== 0 && r.prev_length < r.max_lazy_match && r.strstart - t <= r.w_size - Ta && (r.match_length = jx(r, t), r.match_length <= 5 && (r.strategy === HW || r.match_length === yr && r.strstart - r.match_start > 4096) && (r.match_length = yr - 1)), r.prev_length >= yr && r.match_length <= r.prev_length) {
      i = r.strstart + r.lookahead - yr, n = oa._tr_tally(r, r.strstart - 1 - r.prev_match, r.prev_length - yr), r.lookahead -= r.prev_length - 1, r.prev_length -= 2;
      do
        ++r.strstart <= i && (r.ins_h = (r.ins_h << r.hash_shift ^ r.window[r.strstart + yr - 1]) & r.hash_mask, t = r.prev[r.strstart & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = r.strstart);
      while (--r.prev_length !== 0);
      if (r.match_available = 0, r.match_length = yr - 1, r.strstart++, n && (Tn(r, !1), r.strm.avail_out === 0))
        return an;
    } else if (r.match_available) {
      if (n = oa._tr_tally(r, 0, r.window[r.strstart - 1]), n && Tn(r, !1), r.strstart++, r.lookahead--, r.strm.avail_out === 0)
        return an;
    } else
      r.match_available = 1, r.strstart++, r.lookahead--;
  }
  return r.match_available && (n = oa._tr_tally(r, 0, r.window[r.strstart - 1]), r.match_available = 0), r.insert = r.strstart < yr - 1 ? r.strstart : yr - 1, e === tu ? (Tn(r, !0), r.strm.avail_out === 0 ? ml : uf) : r.last_lit && (Tn(r, !1), r.strm.avail_out === 0) ? an : a2;
}
function fG(r, e) {
  for (var t, n, i, a, o = r.window; ; ) {
    if (r.lookahead <= Hs) {
      if (yl(r), r.lookahead <= Hs && e === Cl)
        return an;
      if (r.lookahead === 0)
        break;
    }
    if (r.match_length = 0, r.lookahead >= yr && r.strstart > 0 && (i = r.strstart - 1, n = o[i], n === o[++i] && n === o[++i] && n === o[++i])) {
      a = r.strstart + Hs;
      do
        ;
      while (n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && i < a);
      r.match_length = Hs - (a - i), r.match_length > r.lookahead && (r.match_length = r.lookahead);
    }
    if (r.match_length >= yr ? (t = oa._tr_tally(r, 1, r.match_length - yr), r.lookahead -= r.match_length, r.strstart += r.match_length, r.match_length = 0) : (t = oa._tr_tally(r, 0, r.window[r.strstart]), r.lookahead--, r.strstart++), t && (Tn(r, !1), r.strm.avail_out === 0))
      return an;
  }
  return r.insert = 0, e === tu ? (Tn(r, !0), r.strm.avail_out === 0 ? ml : uf) : r.last_lit && (Tn(r, !1), r.strm.avail_out === 0) ? an : a2;
}
function hG(r, e) {
  for (var t; ; ) {
    if (r.lookahead === 0 && (yl(r), r.lookahead === 0)) {
      if (e === Cl)
        return an;
      break;
    }
    if (r.match_length = 0, t = oa._tr_tally(r, 0, r.window[r.strstart]), r.lookahead--, r.strstart++, t && (Tn(r, !1), r.strm.avail_out === 0))
      return an;
  }
  return r.insert = 0, e === tu ? (Tn(r, !0), r.strm.avail_out === 0 ? ml : uf) : r.last_lit && (Tn(r, !1), r.strm.avail_out === 0) ? an : a2;
}
function Za(r, e, t, n, i) {
  this.good_length = r, this.max_lazy = e, this.nice_length = t, this.max_chain = n, this.func = i;
}
var xc;
xc = [
  /*      good lazy nice chain */
  new Za(0, 0, 0, 0, cG),
  /* 0 store only */
  new Za(4, 4, 8, 4, Zp),
  /* 1 max speed, no lazy matches */
  new Za(4, 5, 16, 8, Zp),
  /* 2 */
  new Za(4, 6, 32, 32, Zp),
  /* 3 */
  new Za(4, 4, 16, 16, oc),
  /* 4 lazy matches */
  new Za(8, 16, 32, 32, oc),
  /* 5 */
  new Za(8, 16, 128, 128, oc),
  /* 6 */
  new Za(8, 32, 128, 256, oc),
  /* 7 */
  new Za(32, 128, 258, 1024, oc),
  /* 8 */
  new Za(32, 258, 258, 4096, oc)
  /* 9 max compression */
];
function dG(r) {
  r.window_size = 2 * r.w_size, zs(r.head), r.max_lazy_match = xc[r.level].max_lazy, r.good_match = xc[r.level].good_length, r.nice_match = xc[r.level].nice_length, r.max_chain_length = xc[r.level].max_chain, r.strstart = 0, r.block_start = 0, r.lookahead = 0, r.insert = 0, r.match_length = r.prev_length = yr - 1, r.match_available = 0, r.ins_h = 0;
}
function pG() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = p5, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Xn.Buf16(aG * 2), this.dyn_dtree = new Xn.Buf16((2 * nG + 1) * 2), this.bl_tree = new Xn.Buf16((2 * iG + 1) * 2), zs(this.dyn_ltree), zs(this.dyn_dtree), zs(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Xn.Buf16(oG + 1), this.heap = new Xn.Buf16(2 * O3 + 1), zs(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Xn.Buf16(2 * O3 + 1), zs(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
function Wx(r) {
  var e;
  return !r || !r.state ? Zs(r, sa) : (r.total_in = r.total_out = 0, r.data_type = KW, e = r.state, e.pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? v5 : nl, r.adler = e.wrap === 2 ? 0 : 1, e.last_flush = Cl, oa._tr_init(e), so);
}
function Gx(r) {
  var e = Wx(r);
  return e === so && dG(r.state), e;
}
function vG(r, e) {
  return !r || !r.state || r.state.wrap !== 2 ? sa : (r.state.gzhead = e, so);
}
function Vx(r, e, t, n, i, a) {
  if (!r)
    return sa;
  var o = 1;
  if (e === YW && (e = 6), n < 0 ? (o = 0, n = -n) : n > 15 && (o = 2, n -= 16), i < 1 || i > JW || t !== p5 || n < 8 || n > 15 || e < 0 || e > 9 || a < 0 || a > qW)
    return Zs(r, sa);
  n === 8 && (n = 9);
  var s = new pG();
  return r.state = s, s.strm = r, s.wrap = o, s.gzhead = null, s.w_bits = n, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + yr - 1) / yr), s.window = new Xn.Buf8(s.w_size * 2), s.head = new Xn.Buf16(s.hash_size), s.prev = new Xn.Buf16(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = s.lit_bufsize * 4, s.pending_buf = new Xn.Buf8(s.pending_buf_size), s.d_buf = 1 * s.lit_bufsize, s.l_buf = 3 * s.lit_bufsize, s.level = e, s.strategy = a, s.method = t, Gx(r);
}
function gG(r, e) {
  return Vx(r, e, p5, QW, eG, XW);
}
function mG(r, e) {
  var t, n, i, a;
  if (!r || !r.state || e > t6 || e < 0)
    return r ? Zs(r, sa) : sa;
  if (n = r.state, !r.output || !r.input && r.avail_in !== 0 || n.status === Xf && e !== tu)
    return Zs(r, r.avail_out === 0 ? Hp : sa);
  if (n.strm = r, t = n.last_flush, n.last_flush = e, n.status === v5)
    if (n.wrap === 2)
      r.adler = 0, Pr(n, 31), Pr(n, 139), Pr(n, 8), n.gzhead ? (Pr(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), Pr(n, n.gzhead.time & 255), Pr(n, n.gzhead.time >> 8 & 255), Pr(n, n.gzhead.time >> 16 & 255), Pr(n, n.gzhead.time >> 24 & 255), Pr(n, n.level === 9 ? 2 : n.strategy >= Y2 || n.level < 2 ? 4 : 0), Pr(n, n.gzhead.os & 255), n.gzhead.extra && n.gzhead.extra.length && (Pr(n, n.gzhead.extra.length & 255), Pr(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (r.adler = Os(r.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = R3) : (Pr(n, 0), Pr(n, 0), Pr(n, 0), Pr(n, 0), Pr(n, 0), Pr(n, n.level === 9 ? 2 : n.strategy >= Y2 || n.level < 2 ? 4 : 0), Pr(n, uG), n.status = nl);
    else {
      var o = p5 + (n.w_bits - 8 << 4) << 8, s = -1;
      n.strategy >= Y2 || n.level < 2 ? s = 0 : n.level < 6 ? s = 1 : n.level === 6 ? s = 2 : s = 3, o |= s << 6, n.strstart !== 0 && (o |= sG), o += 31 - o % 31, n.status = nl, Vf(n, o), n.strstart !== 0 && (Vf(n, r.adler >>> 16), Vf(n, r.adler & 65535)), r.adler = 1;
    }
  if (n.status === R3)
    if (n.gzhead.extra) {
      for (i = n.pending; n.gzindex < (n.gzhead.extra.length & 65535) && !(n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (r.adler = Os(r.adler, n.pending_buf, n.pending - i, i)), Rs(r), i = n.pending, n.pending === n.pending_buf_size)); )
        Pr(n, n.gzhead.extra[n.gzindex] & 255), n.gzindex++;
      n.gzhead.hcrc && n.pending > i && (r.adler = Os(r.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = Nh);
    } else
      n.status = Nh;
  if (n.status === Nh)
    if (n.gzhead.name) {
      i = n.pending;
      do {
        if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (r.adler = Os(r.adler, n.pending_buf, n.pending - i, i)), Rs(r), i = n.pending, n.pending === n.pending_buf_size)) {
          a = 1;
          break;
        }
        n.gzindex < n.gzhead.name.length ? a = n.gzhead.name.charCodeAt(n.gzindex++) & 255 : a = 0, Pr(n, a);
      } while (a !== 0);
      n.gzhead.hcrc && n.pending > i && (r.adler = Os(r.adler, n.pending_buf, n.pending - i, i)), a === 0 && (n.gzindex = 0, n.status = Lh);
    } else
      n.status = Lh;
  if (n.status === Lh)
    if (n.gzhead.comment) {
      i = n.pending;
      do {
        if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (r.adler = Os(r.adler, n.pending_buf, n.pending - i, i)), Rs(r), i = n.pending, n.pending === n.pending_buf_size)) {
          a = 1;
          break;
        }
        n.gzindex < n.gzhead.comment.length ? a = n.gzhead.comment.charCodeAt(n.gzindex++) & 255 : a = 0, Pr(n, a);
      } while (a !== 0);
      n.gzhead.hcrc && n.pending > i && (r.adler = Os(r.adler, n.pending_buf, n.pending - i, i)), a === 0 && (n.status = Mh);
    } else
      n.status = Mh;
  if (n.status === Mh && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && Rs(r), n.pending + 2 <= n.pending_buf_size && (Pr(n, r.adler & 255), Pr(n, r.adler >> 8 & 255), r.adler = 0, n.status = nl)) : n.status = nl), n.pending !== 0) {
    if (Rs(r), r.avail_out === 0)
      return n.last_flush = -1, so;
  } else if (r.avail_in === 0 && n6(e) <= n6(t) && e !== tu)
    return Zs(r, Hp);
  if (n.status === Xf && r.avail_in !== 0)
    return Zs(r, Hp);
  if (r.avail_in !== 0 || n.lookahead !== 0 || e !== Cl && n.status !== Xf) {
    var c = n.strategy === Y2 ? hG(n, e) : n.strategy === ZW ? fG(n, e) : xc[n.level].func(n, e);
    if ((c === ml || c === uf) && (n.status = Xf), c === an || c === ml)
      return r.avail_out === 0 && (n.last_flush = -1), so;
    if (c === a2 && (e === WW ? oa._tr_align(n) : e !== t6 && (oa._tr_stored_block(n, 0, 0, !1), e === GW && (zs(n.head), n.lookahead === 0 && (n.strstart = 0, n.block_start = 0, n.insert = 0))), Rs(r), r.avail_out === 0))
      return n.last_flush = -1, so;
  }
  return e !== tu ? so : n.wrap <= 0 ? r6 : (n.wrap === 2 ? (Pr(n, r.adler & 255), Pr(n, r.adler >> 8 & 255), Pr(n, r.adler >> 16 & 255), Pr(n, r.adler >> 24 & 255), Pr(n, r.total_in & 255), Pr(n, r.total_in >> 8 & 255), Pr(n, r.total_in >> 16 & 255), Pr(n, r.total_in >> 24 & 255)) : (Vf(n, r.adler >>> 16), Vf(n, r.adler & 65535)), Rs(r), n.wrap > 0 && (n.wrap = -n.wrap), n.pending !== 0 ? so : r6);
}
function yG(r) {
  var e;
  return !r || !r.state ? sa : (e = r.state.status, e !== v5 && e !== R3 && e !== Nh && e !== Lh && e !== Mh && e !== nl && e !== Xf ? Zs(r, sa) : (r.state = null, e === nl ? Zs(r, VW) : so));
}
function bG(r, e) {
  var t = e.length, n, i, a, o, s, c, h, d;
  if (!r || !r.state || (n = r.state, o = n.wrap, o === 2 || o === 1 && n.status !== v5 || n.lookahead))
    return sa;
  for (o === 1 && (r.adler = zx(r.adler, e, t, 0)), n.wrap = 0, t >= n.w_size && (o === 0 && (zs(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), d = new Xn.Buf8(n.w_size), Xn.arraySet(d, e, t - n.w_size, n.w_size, 0), e = d, t = n.w_size), s = r.avail_in, c = r.next_in, h = r.input, r.avail_in = t, r.next_in = 0, r.input = e, yl(n); n.lookahead >= yr; ) {
    i = n.strstart, a = n.lookahead - (yr - 1);
    do
      n.ins_h = (n.ins_h << n.hash_shift ^ n.window[i + yr - 1]) & n.hash_mask, n.prev[i & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = i, i++;
    while (--a);
    n.strstart = i, n.lookahead = yr - 1, yl(n);
  }
  return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = yr - 1, n.match_available = 0, r.next_in = c, r.input = h, r.avail_in = s, n.wrap = o, so;
}
Eo.deflateInit = gG;
Eo.deflateInit2 = Vx;
Eo.deflateReset = Gx;
Eo.deflateResetKeep = Wx;
Eo.deflateSetHeader = vG;
Eo.deflate = mG;
Eo.deflateEnd = yG;
Eo.deflateSetDictionary = bG;
Eo.deflateInfo = "pako deflate (from Nodeca project)";
var Ia = {}, H2 = 30, wG = 12, AG = function(e, t) {
  var n, i, a, o, s, c, h, d, g, x, _, k, P, N, M, G, z, j, R, te, J, K, ee, ve, de;
  n = e.state, i = e.next_in, ve = e.input, a = i + (e.avail_in - 5), o = e.next_out, de = e.output, s = o - (t - e.avail_out), c = o + (e.avail_out - 257), h = n.dmax, d = n.wsize, g = n.whave, x = n.wnext, _ = n.window, k = n.hold, P = n.bits, N = n.lencode, M = n.distcode, G = (1 << n.lenbits) - 1, z = (1 << n.distbits) - 1;
  e: do {
    P < 15 && (k += ve[i++] << P, P += 8, k += ve[i++] << P, P += 8), j = N[k & G];
    n: for (; ; ) {
      if (R = j >>> 24, k >>>= R, P -= R, R = j >>> 16 & 255, R === 0)
        de[o++] = j & 65535;
      else if (R & 16) {
        te = j & 65535, R &= 15, R && (P < R && (k += ve[i++] << P, P += 8), te += k & (1 << R) - 1, k >>>= R, P -= R), P < 15 && (k += ve[i++] << P, P += 8, k += ve[i++] << P, P += 8), j = M[k & z];
        t: for (; ; ) {
          if (R = j >>> 24, k >>>= R, P -= R, R = j >>> 16 & 255, R & 16) {
            if (J = j & 65535, R &= 15, P < R && (k += ve[i++] << P, P += 8, P < R && (k += ve[i++] << P, P += 8)), J += k & (1 << R) - 1, J > h) {
              e.msg = "invalid distance too far back", n.mode = H2;
              break e;
            }
            if (k >>>= R, P -= R, R = o - s, J > R) {
              if (R = J - R, R > g && n.sane) {
                e.msg = "invalid distance too far back", n.mode = H2;
                break e;
              }
              if (K = 0, ee = _, x === 0) {
                if (K += d - R, R < te) {
                  te -= R;
                  do
                    de[o++] = _[K++];
                  while (--R);
                  K = o - J, ee = de;
                }
              } else if (x < R) {
                if (K += d + x - R, R -= x, R < te) {
                  te -= R;
                  do
                    de[o++] = _[K++];
                  while (--R);
                  if (K = 0, x < te) {
                    R = x, te -= R;
                    do
                      de[o++] = _[K++];
                    while (--R);
                    K = o - J, ee = de;
                  }
                }
              } else if (K += x - R, R < te) {
                te -= R;
                do
                  de[o++] = _[K++];
                while (--R);
                K = o - J, ee = de;
              }
              for (; te > 2; )
                de[o++] = ee[K++], de[o++] = ee[K++], de[o++] = ee[K++], te -= 3;
              te && (de[o++] = ee[K++], te > 1 && (de[o++] = ee[K++]));
            } else {
              K = o - J;
              do
                de[o++] = de[K++], de[o++] = de[K++], de[o++] = de[K++], te -= 3;
              while (te > 2);
              te && (de[o++] = de[K++], te > 1 && (de[o++] = de[K++]));
            }
          } else if (R & 64) {
            e.msg = "invalid distance code", n.mode = H2;
            break e;
          } else {
            j = M[(j & 65535) + (k & (1 << R) - 1)];
            continue t;
          }
          break;
        }
      } else if (R & 64)
        if (R & 32) {
          n.mode = wG;
          break e;
        } else {
          e.msg = "invalid literal/length code", n.mode = H2;
          break e;
        }
      else {
        j = N[(j & 65535) + (k & (1 << R) - 1)];
        continue n;
      }
      break;
    }
  } while (i < a && o < c);
  te = P >> 3, i -= te, P -= te << 3, k &= (1 << P) - 1, e.next_in = i, e.next_out = o, e.avail_in = i < a ? 5 + (a - i) : 5 - (i - a), e.avail_out = o < c ? 257 + (c - o) : 257 - (o - c), n.hold = k, n.bits = P;
}, i6 = n2, sc = 15, a6 = 852, o6 = 592, s6 = 0, qp = 1, u6 = 2, xG = [
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
], EG = [
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
], _G = [
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
], DG = [
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
], TG = function(e, t, n, i, a, o, s, c) {
  var h = c.bits, d = 0, g = 0, x = 0, _ = 0, k = 0, P = 0, N = 0, M = 0, G = 0, z = 0, j, R, te, J, K, ee = null, ve = 0, de, B = new i6.Buf16(sc + 1), q = new i6.Buf16(sc + 1), H = null, oe = 0, ne, me, fe;
  for (d = 0; d <= sc; d++)
    B[d] = 0;
  for (g = 0; g < i; g++)
    B[t[n + g]]++;
  for (k = h, _ = sc; _ >= 1 && B[_] === 0; _--)
    ;
  if (k > _ && (k = _), _ === 0)
    return a[o++] = 1 << 24 | 64 << 16 | 0, a[o++] = 1 << 24 | 64 << 16 | 0, c.bits = 1, 0;
  for (x = 1; x < _ && B[x] === 0; x++)
    ;
  for (k < x && (k = x), M = 1, d = 1; d <= sc; d++)
    if (M <<= 1, M -= B[d], M < 0)
      return -1;
  if (M > 0 && (e === s6 || _ !== 1))
    return -1;
  for (q[1] = 0, d = 1; d < sc; d++)
    q[d + 1] = q[d] + B[d];
  for (g = 0; g < i; g++)
    t[n + g] !== 0 && (s[q[t[n + g]]++] = g);
  if (e === s6 ? (ee = H = s, de = 19) : e === qp ? (ee = xG, ve -= 257, H = EG, oe -= 257, de = 256) : (ee = _G, H = DG, de = -1), z = 0, g = 0, d = x, K = o, P = k, N = 0, te = -1, G = 1 << k, J = G - 1, e === qp && G > a6 || e === u6 && G > o6)
    return 1;
  for (; ; ) {
    ne = d - N, s[g] < de ? (me = 0, fe = s[g]) : s[g] > de ? (me = H[oe + s[g]], fe = ee[ve + s[g]]) : (me = 96, fe = 0), j = 1 << d - N, R = 1 << P, x = R;
    do
      R -= j, a[K + (z >> N) + R] = ne << 24 | me << 16 | fe | 0;
    while (R !== 0);
    for (j = 1 << d - 1; z & j; )
      j >>= 1;
    if (j !== 0 ? (z &= j - 1, z += j) : z = 0, g++, --B[d] === 0) {
      if (d === _)
        break;
      d = t[n + s[g]];
    }
    if (d > k && (z & J) !== te) {
      for (N === 0 && (N = k), K += x, P = d - N, M = 1 << P; P + N < _ && (M -= B[P + N], !(M <= 0)); )
        P++, M <<= 1;
      if (G += 1 << P, e === qp && G > a6 || e === u6 && G > o6)
        return 1;
      te = z & J, a[te] = k << 24 | P << 16 | K - o | 0;
    }
  }
  return z !== 0 && (a[K + z] = d - N << 24 | 64 << 16 | 0), c.bits = k, 0;
}, Fi = n2, I3 = Ux, qa = $x, kG = AG, c1 = TG, SG = 0, Yx = 1, Hx = 2, l6 = 4, CG = 5, Z2 = 6, bl = 0, FG = 1, OG = 2, ca = -2, Zx = -3, qx = -4, RG = -5, c6 = 8, Xx = 1, f6 = 2, h6 = 3, d6 = 4, p6 = 5, v6 = 6, g6 = 7, m6 = 8, y6 = 9, b6 = 10, Ed = 11, Uo = 12, Xp = 13, w6 = 14, Kp = 15, A6 = 16, x6 = 17, E6 = 18, _6 = 19, q2 = 20, X2 = 21, D6 = 22, T6 = 23, k6 = 24, S6 = 25, C6 = 26, Jp = 27, F6 = 28, O6 = 29, d0 = 30, Kx = 31, IG = 32, PG = 852, BG = 592, NG = 15, LG = NG;
function R6(r) {
  return (r >>> 24 & 255) + (r >>> 8 & 65280) + ((r & 65280) << 8) + ((r & 255) << 24);
}
function MG() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Fi.Buf16(320), this.work = new Fi.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
function Jx(r) {
  var e;
  return !r || !r.state ? ca : (e = r.state, r.total_in = r.total_out = e.total = 0, r.msg = "", e.wrap && (r.adler = e.wrap & 1), e.mode = Xx, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new Fi.Buf32(PG), e.distcode = e.distdyn = new Fi.Buf32(BG), e.sane = 1, e.back = -1, bl);
}
function Qx(r) {
  var e;
  return !r || !r.state ? ca : (e = r.state, e.wsize = 0, e.whave = 0, e.wnext = 0, Jx(r));
}
function eE(r, e) {
  var t, n;
  return !r || !r.state || (n = r.state, e < 0 ? (t = 0, e = -e) : (t = (e >> 4) + 1, e < 48 && (e &= 15)), e && (e < 8 || e > 15)) ? ca : (n.window !== null && n.wbits !== e && (n.window = null), n.wrap = t, n.wbits = e, Qx(r));
}
function tE(r, e) {
  var t, n;
  return r ? (n = new MG(), r.state = n, n.window = null, t = eE(r, e), t !== bl && (r.state = null), t) : ca;
}
function UG(r) {
  return tE(r, LG);
}
var I6 = !0, Qp, e4;
function $G(r) {
  if (I6) {
    var e;
    for (Qp = new Fi.Buf32(512), e4 = new Fi.Buf32(32), e = 0; e < 144; )
      r.lens[e++] = 8;
    for (; e < 256; )
      r.lens[e++] = 9;
    for (; e < 280; )
      r.lens[e++] = 7;
    for (; e < 288; )
      r.lens[e++] = 8;
    for (c1(Yx, r.lens, 0, 288, Qp, 0, r.work, {
      bits: 9
    }), e = 0; e < 32; )
      r.lens[e++] = 5;
    c1(Hx, r.lens, 0, 32, e4, 0, r.work, {
      bits: 5
    }), I6 = !1;
  }
  r.lencode = Qp, r.lenbits = 9, r.distcode = e4, r.distbits = 5;
}
function rE(r, e, t, n) {
  var i, a = r.state;
  return a.window === null && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new Fi.Buf8(a.wsize)), n >= a.wsize ? (Fi.arraySet(a.window, e, t - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i = a.wsize - a.wnext, i > n && (i = n), Fi.arraySet(a.window, e, t - n, i, a.wnext), n -= i, n ? (Fi.arraySet(a.window, e, t - n, n, 0), a.wnext = n, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
}
function zG(r, e) {
  var t, n, i, a, o, s, c, h, d, g, x, _, k, P, N = 0, M, G, z, j, R, te, J, K, ee = new Fi.Buf8(4), ve, de, B = (
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
  );
  if (!r || !r.state || !r.output || !r.input && r.avail_in !== 0)
    return ca;
  t = r.state, t.mode === Uo && (t.mode = Xp), o = r.next_out, i = r.output, c = r.avail_out, a = r.next_in, n = r.input, s = r.avail_in, h = t.hold, d = t.bits, g = s, x = c, K = bl;
  e:
    for (; ; )
      switch (t.mode) {
        case Xx:
          if (t.wrap === 0) {
            t.mode = Xp;
            break;
          }
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (t.wrap & 2 && h === 35615) {
            t.check = 0, ee[0] = h & 255, ee[1] = h >>> 8 & 255, t.check = qa(t.check, ee, 2, 0), h = 0, d = 0, t.mode = f6;
            break;
          }
          if (t.flags = 0, t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((h & 255) << 8) + (h >> 8)) % 31) {
            r.msg = "incorrect header check", t.mode = d0;
            break;
          }
          if ((h & 15) !== c6) {
            r.msg = "unknown compression method", t.mode = d0;
            break;
          }
          if (h >>>= 4, d -= 4, J = (h & 15) + 8, t.wbits === 0)
            t.wbits = J;
          else if (J > t.wbits) {
            r.msg = "invalid window size", t.mode = d0;
            break;
          }
          t.dmax = 1 << J, r.adler = t.check = 1, t.mode = h & 512 ? b6 : Uo, h = 0, d = 0;
          break;
        case f6:
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (t.flags = h, (t.flags & 255) !== c6) {
            r.msg = "unknown compression method", t.mode = d0;
            break;
          }
          if (t.flags & 57344) {
            r.msg = "unknown header flags set", t.mode = d0;
            break;
          }
          t.head && (t.head.text = h >> 8 & 1), t.flags & 512 && (ee[0] = h & 255, ee[1] = h >>> 8 & 255, t.check = qa(t.check, ee, 2, 0)), h = 0, d = 0, t.mode = h6;
        case h6:
          for (; d < 32; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          t.head && (t.head.time = h), t.flags & 512 && (ee[0] = h & 255, ee[1] = h >>> 8 & 255, ee[2] = h >>> 16 & 255, ee[3] = h >>> 24 & 255, t.check = qa(t.check, ee, 4, 0)), h = 0, d = 0, t.mode = d6;
        case d6:
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          t.head && (t.head.xflags = h & 255, t.head.os = h >> 8), t.flags & 512 && (ee[0] = h & 255, ee[1] = h >>> 8 & 255, t.check = qa(t.check, ee, 2, 0)), h = 0, d = 0, t.mode = p6;
        case p6:
          if (t.flags & 1024) {
            for (; d < 16; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            t.length = h, t.head && (t.head.extra_len = h), t.flags & 512 && (ee[0] = h & 255, ee[1] = h >>> 8 & 255, t.check = qa(t.check, ee, 2, 0)), h = 0, d = 0;
          } else t.head && (t.head.extra = null);
          t.mode = v6;
        case v6:
          if (t.flags & 1024 && (_ = t.length, _ > s && (_ = s), _ && (t.head && (J = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Array(t.head.extra_len)), Fi.arraySet(
            t.head.extra,
            n,
            a,
            // extra field is limited to 65536 bytes
            // - no need for additional size check
            _,
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            J
          )), t.flags & 512 && (t.check = qa(t.check, n, _, a)), s -= _, a += _, t.length -= _), t.length))
            break e;
          t.length = 0, t.mode = g6;
        case g6:
          if (t.flags & 2048) {
            if (s === 0)
              break e;
            _ = 0;
            do
              J = n[a + _++], t.head && J && t.length < 65536 && (t.head.name += String.fromCharCode(J));
            while (J && _ < s);
            if (t.flags & 512 && (t.check = qa(t.check, n, _, a)), s -= _, a += _, J)
              break e;
          } else t.head && (t.head.name = null);
          t.length = 0, t.mode = m6;
        case m6:
          if (t.flags & 4096) {
            if (s === 0)
              break e;
            _ = 0;
            do
              J = n[a + _++], t.head && J && t.length < 65536 && (t.head.comment += String.fromCharCode(J));
            while (J && _ < s);
            if (t.flags & 512 && (t.check = qa(t.check, n, _, a)), s -= _, a += _, J)
              break e;
          } else t.head && (t.head.comment = null);
          t.mode = y6;
        case y6:
          if (t.flags & 512) {
            for (; d < 16; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            if (h !== (t.check & 65535)) {
              r.msg = "header crc mismatch", t.mode = d0;
              break;
            }
            h = 0, d = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), r.adler = t.check = 0, t.mode = Uo;
          break;
        case b6:
          for (; d < 32; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          r.adler = t.check = R6(h), h = 0, d = 0, t.mode = Ed;
        case Ed:
          if (t.havedict === 0)
            return r.next_out = o, r.avail_out = c, r.next_in = a, r.avail_in = s, t.hold = h, t.bits = d, OG;
          r.adler = t.check = 1, t.mode = Uo;
        case Uo:
          if (e === CG || e === Z2)
            break e;
        case Xp:
          if (t.last) {
            h >>>= d & 7, d -= d & 7, t.mode = Jp;
            break;
          }
          for (; d < 3; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          switch (t.last = h & 1, h >>>= 1, d -= 1, h & 3) {
            case 0:
              t.mode = w6;
              break;
            case 1:
              if ($G(t), t.mode = q2, e === Z2) {
                h >>>= 2, d -= 2;
                break e;
              }
              break;
            case 2:
              t.mode = x6;
              break;
            case 3:
              r.msg = "invalid block type", t.mode = d0;
          }
          h >>>= 2, d -= 2;
          break;
        case w6:
          for (h >>>= d & 7, d -= d & 7; d < 32; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if ((h & 65535) !== (h >>> 16 ^ 65535)) {
            r.msg = "invalid stored block lengths", t.mode = d0;
            break;
          }
          if (t.length = h & 65535, h = 0, d = 0, t.mode = Kp, e === Z2)
            break e;
        case Kp:
          t.mode = A6;
        case A6:
          if (_ = t.length, _) {
            if (_ > s && (_ = s), _ > c && (_ = c), _ === 0)
              break e;
            Fi.arraySet(i, n, a, _, o), s -= _, a += _, c -= _, o += _, t.length -= _;
            break;
          }
          t.mode = Uo;
          break;
        case x6:
          for (; d < 14; ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (t.nlen = (h & 31) + 257, h >>>= 5, d -= 5, t.ndist = (h & 31) + 1, h >>>= 5, d -= 5, t.ncode = (h & 15) + 4, h >>>= 4, d -= 4, t.nlen > 286 || t.ndist > 30) {
            r.msg = "too many length or distance symbols", t.mode = d0;
            break;
          }
          t.have = 0, t.mode = E6;
        case E6:
          for (; t.have < t.ncode; ) {
            for (; d < 3; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            t.lens[B[t.have++]] = h & 7, h >>>= 3, d -= 3;
          }
          for (; t.have < 19; )
            t.lens[B[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, ve = {
            bits: t.lenbits
          }, K = c1(SG, t.lens, 0, 19, t.lencode, 0, t.work, ve), t.lenbits = ve.bits, K) {
            r.msg = "invalid code lengths set", t.mode = d0;
            break;
          }
          t.have = 0, t.mode = _6;
        case _6:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; N = t.lencode[h & (1 << t.lenbits) - 1], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(M <= d); ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            if (z < 16)
              h >>>= M, d -= M, t.lens[t.have++] = z;
            else {
              if (z === 16) {
                for (de = M + 2; d < de; ) {
                  if (s === 0)
                    break e;
                  s--, h += n[a++] << d, d += 8;
                }
                if (h >>>= M, d -= M, t.have === 0) {
                  r.msg = "invalid bit length repeat", t.mode = d0;
                  break;
                }
                J = t.lens[t.have - 1], _ = 3 + (h & 3), h >>>= 2, d -= 2;
              } else if (z === 17) {
                for (de = M + 3; d < de; ) {
                  if (s === 0)
                    break e;
                  s--, h += n[a++] << d, d += 8;
                }
                h >>>= M, d -= M, J = 0, _ = 3 + (h & 7), h >>>= 3, d -= 3;
              } else {
                for (de = M + 7; d < de; ) {
                  if (s === 0)
                    break e;
                  s--, h += n[a++] << d, d += 8;
                }
                h >>>= M, d -= M, J = 0, _ = 11 + (h & 127), h >>>= 7, d -= 7;
              }
              if (t.have + _ > t.nlen + t.ndist) {
                r.msg = "invalid bit length repeat", t.mode = d0;
                break;
              }
              for (; _--; )
                t.lens[t.have++] = J;
            }
          }
          if (t.mode === d0)
            break;
          if (t.lens[256] === 0) {
            r.msg = "invalid code -- missing end-of-block", t.mode = d0;
            break;
          }
          if (t.lenbits = 9, ve = {
            bits: t.lenbits
          }, K = c1(Yx, t.lens, 0, t.nlen, t.lencode, 0, t.work, ve), t.lenbits = ve.bits, K) {
            r.msg = "invalid literal/lengths set", t.mode = d0;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, ve = {
            bits: t.distbits
          }, K = c1(Hx, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, ve), t.distbits = ve.bits, K) {
            r.msg = "invalid distances set", t.mode = d0;
            break;
          }
          if (t.mode = q2, e === Z2)
            break e;
        case q2:
          t.mode = X2;
        case X2:
          if (s >= 6 && c >= 258) {
            r.next_out = o, r.avail_out = c, r.next_in = a, r.avail_in = s, t.hold = h, t.bits = d, kG(r, x), o = r.next_out, i = r.output, c = r.avail_out, a = r.next_in, n = r.input, s = r.avail_in, h = t.hold, d = t.bits, t.mode === Uo && (t.back = -1);
            break;
          }
          for (t.back = 0; N = t.lencode[h & (1 << t.lenbits) - 1], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(M <= d); ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (G && !(G & 240)) {
            for (j = M, R = G, te = z; N = t.lencode[te + ((h & (1 << j + R) - 1) >> j)], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(j + M <= d); ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            h >>>= j, d -= j, t.back += j;
          }
          if (h >>>= M, d -= M, t.back += M, t.length = z, G === 0) {
            t.mode = C6;
            break;
          }
          if (G & 32) {
            t.back = -1, t.mode = Uo;
            break;
          }
          if (G & 64) {
            r.msg = "invalid literal/length code", t.mode = d0;
            break;
          }
          t.extra = G & 15, t.mode = D6;
        case D6:
          if (t.extra) {
            for (de = t.extra; d < de; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            t.length += h & (1 << t.extra) - 1, h >>>= t.extra, d -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = T6;
        case T6:
          for (; N = t.distcode[h & (1 << t.distbits) - 1], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(M <= d); ) {
            if (s === 0)
              break e;
            s--, h += n[a++] << d, d += 8;
          }
          if (!(G & 240)) {
            for (j = M, R = G, te = z; N = t.distcode[te + ((h & (1 << j + R) - 1) >> j)], M = N >>> 24, G = N >>> 16 & 255, z = N & 65535, !(j + M <= d); ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            h >>>= j, d -= j, t.back += j;
          }
          if (h >>>= M, d -= M, t.back += M, G & 64) {
            r.msg = "invalid distance code", t.mode = d0;
            break;
          }
          t.offset = z, t.extra = G & 15, t.mode = k6;
        case k6:
          if (t.extra) {
            for (de = t.extra; d < de; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            t.offset += h & (1 << t.extra) - 1, h >>>= t.extra, d -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            r.msg = "invalid distance too far back", t.mode = d0;
            break;
          }
          t.mode = S6;
        case S6:
          if (c === 0)
            break e;
          if (_ = x - c, t.offset > _) {
            if (_ = t.offset - _, _ > t.whave && t.sane) {
              r.msg = "invalid distance too far back", t.mode = d0;
              break;
            }
            _ > t.wnext ? (_ -= t.wnext, k = t.wsize - _) : k = t.wnext - _, _ > t.length && (_ = t.length), P = t.window;
          } else
            P = i, k = o - t.offset, _ = t.length;
          _ > c && (_ = c), c -= _, t.length -= _;
          do
            i[o++] = P[k++];
          while (--_);
          t.length === 0 && (t.mode = X2);
          break;
        case C6:
          if (c === 0)
            break e;
          i[o++] = t.length, c--, t.mode = X2;
          break;
        case Jp:
          if (t.wrap) {
            for (; d < 32; ) {
              if (s === 0)
                break e;
              s--, h |= n[a++] << d, d += 8;
            }
            if (x -= c, r.total_out += x, t.total += x, x && (r.adler = t.check = /*UPDATE(state.check, put - _out, _out);*/
            t.flags ? qa(t.check, i, x, o - x) : I3(t.check, i, x, o - x)), x = c, (t.flags ? h : R6(h)) !== t.check) {
              r.msg = "incorrect data check", t.mode = d0;
              break;
            }
            h = 0, d = 0;
          }
          t.mode = F6;
        case F6:
          if (t.wrap && t.flags) {
            for (; d < 32; ) {
              if (s === 0)
                break e;
              s--, h += n[a++] << d, d += 8;
            }
            if (h !== (t.total & 4294967295)) {
              r.msg = "incorrect length check", t.mode = d0;
              break;
            }
            h = 0, d = 0;
          }
          t.mode = O6;
        case O6:
          K = FG;
          break e;
        case d0:
          K = Zx;
          break e;
        case Kx:
          return qx;
        case IG:
        default:
          return ca;
      }
  return r.next_out = o, r.avail_out = c, r.next_in = a, r.avail_in = s, t.hold = h, t.bits = d, (t.wsize || x !== r.avail_out && t.mode < d0 && (t.mode < Jp || e !== l6)) && rE(r, r.output, r.next_out, x - r.avail_out), g -= r.avail_in, x -= r.avail_out, r.total_in += g, r.total_out += x, t.total += x, t.wrap && x && (r.adler = t.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  t.flags ? qa(t.check, i, x, r.next_out - x) : I3(t.check, i, x, r.next_out - x)), r.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === Uo ? 128 : 0) + (t.mode === q2 || t.mode === Kp ? 256 : 0), (g === 0 && x === 0 || e === l6) && K === bl && (K = RG), K;
}
function jG(r) {
  if (!r || !r.state)
    return ca;
  var e = r.state;
  return e.window && (e.window = null), r.state = null, bl;
}
function WG(r, e) {
  var t;
  return !r || !r.state || (t = r.state, !(t.wrap & 2)) ? ca : (t.head = e, e.done = !1, bl);
}
function GG(r, e) {
  var t = e.length, n, i, a;
  return !r || !r.state || (n = r.state, n.wrap !== 0 && n.mode !== Ed) ? ca : n.mode === Ed && (i = 1, i = I3(i, e, t, 0), i !== n.check) ? Zx : (a = rE(r, e, t, t), a ? (n.mode = Kx, qx) : (n.havedict = 1, bl));
}
Ia.inflateReset = Qx;
Ia.inflateReset2 = eE;
Ia.inflateResetKeep = Jx;
Ia.inflateInit = UG;
Ia.inflateInit2 = tE;
Ia.inflate = zG;
Ia.inflateEnd = jG;
Ia.inflateGetHeader = WG;
Ia.inflateSetDictionary = GG;
Ia.inflateInfo = "pako inflate (from Nodeca project)";
var VG = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
(function(r) {
  var e = Q1.exports, t = vW, n = Eo, i = Ia, a = VG;
  for (var o in a)
    r[o] = a[o];
  r.NONE = 0, r.DEFLATE = 1, r.INFLATE = 2, r.GZIP = 3, r.GUNZIP = 4, r.DEFLATERAW = 5, r.INFLATERAW = 6, r.UNZIP = 7;
  var s = 31, c = 139;
  function h(d) {
    if (typeof d != "number" || d < r.DEFLATE || d > r.UNZIP)
      throw new TypeError("Bad argument");
    this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = d, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
  }
  h.prototype.close = function() {
    if (this.write_in_progress) {
      this.pending_close = !0;
      return;
    }
    this.pending_close = !1, e(this.init_done, "close before init"), e(this.mode <= r.UNZIP), this.mode === r.DEFLATE || this.mode === r.GZIP || this.mode === r.DEFLATERAW ? n.deflateEnd(this.strm) : (this.mode === r.INFLATE || this.mode === r.GUNZIP || this.mode === r.INFLATERAW || this.mode === r.UNZIP) && i.inflateEnd(this.strm), this.mode = r.NONE, this.dictionary = null;
  }, h.prototype.write = function(d, g, x, _, k, P, N) {
    return this._write(!0, d, g, x, _, k, P, N);
  }, h.prototype.writeSync = function(d, g, x, _, k, P, N) {
    return this._write(!1, d, g, x, _, k, P, N);
  }, h.prototype._write = function(d, g, x, _, k, P, N, M) {
    if (e.equal(arguments.length, 8), e(this.init_done, "write before init"), e(this.mode !== r.NONE, "already finalized"), e.equal(!1, this.write_in_progress, "write already in progress"), e.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, e.equal(!1, g === void 0, "must provide flush value"), this.write_in_progress = !0, g !== r.Z_NO_FLUSH && g !== r.Z_PARTIAL_FLUSH && g !== r.Z_SYNC_FLUSH && g !== r.Z_FULL_FLUSH && g !== r.Z_FINISH && g !== r.Z_BLOCK)
      throw new Error("Invalid flush value");
    if (x == null && (x = ut.alloc(0), k = 0, _ = 0), this.strm.avail_in = k, this.strm.input = x, this.strm.next_in = _, this.strm.avail_out = M, this.strm.output = P, this.strm.next_out = N, this.flush = g, !d)
      return this._process(), this._checkError() ? this._afterSync() : void 0;
    var G = this;
    return _i.nextTick(function() {
      G._process(), G._after();
    }), this;
  }, h.prototype._afterSync = function() {
    var d = this.strm.avail_out, g = this.strm.avail_in;
    return this.write_in_progress = !1, [g, d];
  }, h.prototype._process = function() {
    var d = null;
    switch (this.mode) {
      case r.DEFLATE:
      case r.GZIP:
      case r.DEFLATERAW:
        this.err = n.deflate(this.strm, this.flush);
        break;
      case r.UNZIP:
        switch (this.strm.avail_in > 0 && (d = this.strm.next_in), this.gzip_id_bytes_read) {
          case 0:
            if (d === null)
              break;
            if (this.strm.input[d] === s) {
              if (this.gzip_id_bytes_read = 1, d++, this.strm.avail_in === 1)
                break;
            } else {
              this.mode = r.INFLATE;
              break;
            }
          case 1:
            if (d === null)
              break;
            this.strm.input[d] === c ? (this.gzip_id_bytes_read = 2, this.mode = r.GUNZIP) : this.mode = r.INFLATE;
            break;
          default:
            throw new Error("invalid number of gzip magic number bytes read");
        }
      case r.INFLATE:
      case r.GUNZIP:
      case r.INFLATERAW:
        for (this.err = i.inflate(
          this.strm,
          this.flush
          // If data was encoded with dictionary
        ), this.err === r.Z_NEED_DICT && this.dictionary && (this.err = i.inflateSetDictionary(this.strm, this.dictionary), this.err === r.Z_OK ? this.err = i.inflate(this.strm, this.flush) : this.err === r.Z_DATA_ERROR && (this.err = r.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === r.GUNZIP && this.err === r.Z_STREAM_END && this.strm.next_in[0] !== 0; )
          this.reset(), this.err = i.inflate(this.strm, this.flush);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
  }, h.prototype._checkError = function() {
    switch (this.err) {
      case r.Z_OK:
      case r.Z_BUF_ERROR:
        if (this.strm.avail_out !== 0 && this.flush === r.Z_FINISH)
          return this._error("unexpected end of file"), !1;
        break;
      case r.Z_STREAM_END:
        break;
      case r.Z_NEED_DICT:
        return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
      default:
        return this._error("Zlib error"), !1;
    }
    return !0;
  }, h.prototype._after = function() {
    if (this._checkError()) {
      var d = this.strm.avail_out, g = this.strm.avail_in;
      this.write_in_progress = !1, this.callback(g, d), this.pending_close && this.close();
    }
  }, h.prototype._error = function(d) {
    this.strm.msg && (d = this.strm.msg), this.onerror(
      d,
      this.err
      // no hope of rescue.
    ), this.write_in_progress = !1, this.pending_close && this.close();
  }, h.prototype.init = function(d, g, x, _, k) {
    e(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), e(d >= 8 && d <= 15, "invalid windowBits"), e(g >= -1 && g <= 9, "invalid compression level"), e(x >= 1 && x <= 9, "invalid memlevel"), e(_ === r.Z_FILTERED || _ === r.Z_HUFFMAN_ONLY || _ === r.Z_RLE || _ === r.Z_FIXED || _ === r.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(g, d, x, _, k), this._setDictionary();
  }, h.prototype.params = function() {
    throw new Error("deflateParams Not supported");
  }, h.prototype.reset = function() {
    this._reset(), this._setDictionary();
  }, h.prototype._init = function(d, g, x, _, k) {
    switch (this.level = d, this.windowBits = g, this.memLevel = x, this.strategy = _, this.flush = r.Z_NO_FLUSH, this.err = r.Z_OK, (this.mode === r.GZIP || this.mode === r.GUNZIP) && (this.windowBits += 16), this.mode === r.UNZIP && (this.windowBits += 32), (this.mode === r.DEFLATERAW || this.mode === r.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new t(), this.mode) {
      case r.DEFLATE:
      case r.GZIP:
      case r.DEFLATERAW:
        this.err = n.deflateInit2(this.strm, this.level, r.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
        break;
      case r.INFLATE:
      case r.GUNZIP:
      case r.INFLATERAW:
      case r.UNZIP:
        this.err = i.inflateInit2(this.strm, this.windowBits);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
    this.err !== r.Z_OK && this._error("Init error"), this.dictionary = k, this.write_in_progress = !1, this.init_done = !0;
  }, h.prototype._setDictionary = function() {
    if (this.dictionary != null) {
      switch (this.err = r.Z_OK, this.mode) {
        case r.DEFLATE:
        case r.DEFLATERAW:
          this.err = n.deflateSetDictionary(this.strm, this.dictionary);
          break;
      }
      this.err !== r.Z_OK && this._error("Failed to set dictionary");
    }
  }, h.prototype._reset = function() {
    switch (this.err = r.Z_OK, this.mode) {
      case r.DEFLATE:
      case r.DEFLATERAW:
      case r.GZIP:
        this.err = n.deflateReset(this.strm);
        break;
      case r.INFLATE:
      case r.INFLATERAW:
      case r.GUNZIP:
        this.err = i.inflateReset(this.strm);
        break;
    }
    this.err !== r.Z_OK && this._error("Failed to reset stream");
  }, r.Zlib = h;
})(YA);
(function(r) {
  var e = yo.Buffer, t = Tz.Transform, n = YA, i = Kn, a = Q1.exports.ok, o = yo.kMaxLength, s = "Cannot create final Buffer. It would be larger than 0x" + o.toString(16) + " bytes";
  n.Z_MIN_WINDOWBITS = 8, n.Z_MAX_WINDOWBITS = 15, n.Z_DEFAULT_WINDOWBITS = 15, n.Z_MIN_CHUNK = 64, n.Z_MAX_CHUNK = 1 / 0, n.Z_DEFAULT_CHUNK = 16 * 1024, n.Z_MIN_MEMLEVEL = 1, n.Z_MAX_MEMLEVEL = 9, n.Z_DEFAULT_MEMLEVEL = 8, n.Z_MIN_LEVEL = -1, n.Z_MAX_LEVEL = 9, n.Z_DEFAULT_LEVEL = n.Z_DEFAULT_COMPRESSION;
  for (var c = Object.keys(n), h = 0; h < c.length; h++) {
    var d = c[h];
    d.match(/^Z/) && Object.defineProperty(r, d, {
      enumerable: !0,
      value: n[d],
      writable: !1
    });
  }
  for (var g = {
    Z_OK: n.Z_OK,
    Z_STREAM_END: n.Z_STREAM_END,
    Z_NEED_DICT: n.Z_NEED_DICT,
    Z_ERRNO: n.Z_ERRNO,
    Z_STREAM_ERROR: n.Z_STREAM_ERROR,
    Z_DATA_ERROR: n.Z_DATA_ERROR,
    Z_MEM_ERROR: n.Z_MEM_ERROR,
    Z_BUF_ERROR: n.Z_BUF_ERROR,
    Z_VERSION_ERROR: n.Z_VERSION_ERROR
  }, x = Object.keys(g), _ = 0; _ < x.length; _++) {
    var k = x[_];
    g[g[k]] = k;
  }
  Object.defineProperty(r, "codes", {
    enumerable: !0,
    value: Object.freeze(g),
    writable: !1
  }), r.Deflate = M, r.Inflate = G, r.Gzip = z, r.Gunzip = j, r.DeflateRaw = R, r.InflateRaw = te, r.Unzip = J, r.createDeflate = function(B) {
    return new M(B);
  }, r.createInflate = function(B) {
    return new G(B);
  }, r.createDeflateRaw = function(B) {
    return new R(B);
  }, r.createInflateRaw = function(B) {
    return new te(B);
  }, r.createGzip = function(B) {
    return new z(B);
  }, r.createGunzip = function(B) {
    return new j(B);
  }, r.createUnzip = function(B) {
    return new J(B);
  }, r.deflate = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new M(q), B, H);
  }, r.deflateSync = function(B, q) {
    return N(new M(q), B);
  }, r.gzip = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new z(q), B, H);
  }, r.gzipSync = function(B, q) {
    return N(new z(q), B);
  }, r.deflateRaw = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new R(q), B, H);
  }, r.deflateRawSync = function(B, q) {
    return N(new R(q), B);
  }, r.unzip = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new J(q), B, H);
  }, r.unzipSync = function(B, q) {
    return N(new J(q), B);
  }, r.inflate = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new G(q), B, H);
  }, r.inflateSync = function(B, q) {
    return N(new G(q), B);
  }, r.gunzip = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new j(q), B, H);
  }, r.gunzipSync = function(B, q) {
    return N(new j(q), B);
  }, r.inflateRaw = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new te(q), B, H);
  }, r.inflateRawSync = function(B, q) {
    return N(new te(q), B);
  };
  function P(B, q, H) {
    var oe = [], ne = 0;
    B.on("error", fe), B.on("end", _e), B.end(q), me();
    function me() {
      for (var Re; (Re = B.read()) !== null; )
        oe.push(Re), ne += Re.length;
      B.once("readable", me);
    }
    function fe(Re) {
      B.removeListener("end", _e), B.removeListener("readable", me), H(Re);
    }
    function _e() {
      var Re, Ie = null;
      ne >= o ? Ie = new RangeError(s) : Re = e.concat(oe, ne), oe = [], B.close(), H(Ie, Re);
    }
  }
  function N(B, q) {
    if (typeof q == "string" && (q = e.from(q)), !e.isBuffer(q)) throw new TypeError("Not a string or buffer");
    var H = B._finishFlushFlag;
    return B._processChunk(q, H);
  }
  function M(B) {
    if (!(this instanceof M)) return new M(B);
    ee.call(this, B, n.DEFLATE);
  }
  function G(B) {
    if (!(this instanceof G)) return new G(B);
    ee.call(this, B, n.INFLATE);
  }
  function z(B) {
    if (!(this instanceof z)) return new z(B);
    ee.call(this, B, n.GZIP);
  }
  function j(B) {
    if (!(this instanceof j)) return new j(B);
    ee.call(this, B, n.GUNZIP);
  }
  function R(B) {
    if (!(this instanceof R)) return new R(B);
    ee.call(this, B, n.DEFLATERAW);
  }
  function te(B) {
    if (!(this instanceof te)) return new te(B);
    ee.call(this, B, n.INFLATERAW);
  }
  function J(B) {
    if (!(this instanceof J)) return new J(B);
    ee.call(this, B, n.UNZIP);
  }
  function K(B) {
    return B === n.Z_NO_FLUSH || B === n.Z_PARTIAL_FLUSH || B === n.Z_SYNC_FLUSH || B === n.Z_FULL_FLUSH || B === n.Z_FINISH || B === n.Z_BLOCK;
  }
  function ee(B, q) {
    var H = this;
    if (this._opts = B = B || {}, this._chunkSize = B.chunkSize || r.Z_DEFAULT_CHUNK, t.call(this, B), B.flush && !K(B.flush))
      throw new Error("Invalid flush flag: " + B.flush);
    if (B.finishFlush && !K(B.finishFlush))
      throw new Error("Invalid flush flag: " + B.finishFlush);
    if (this._flushFlag = B.flush || n.Z_NO_FLUSH, this._finishFlushFlag = typeof B.finishFlush < "u" ? B.finishFlush : n.Z_FINISH, B.chunkSize && (B.chunkSize < r.Z_MIN_CHUNK || B.chunkSize > r.Z_MAX_CHUNK))
      throw new Error("Invalid chunk size: " + B.chunkSize);
    if (B.windowBits && (B.windowBits < r.Z_MIN_WINDOWBITS || B.windowBits > r.Z_MAX_WINDOWBITS))
      throw new Error("Invalid windowBits: " + B.windowBits);
    if (B.level && (B.level < r.Z_MIN_LEVEL || B.level > r.Z_MAX_LEVEL))
      throw new Error("Invalid compression level: " + B.level);
    if (B.memLevel && (B.memLevel < r.Z_MIN_MEMLEVEL || B.memLevel > r.Z_MAX_MEMLEVEL))
      throw new Error("Invalid memLevel: " + B.memLevel);
    if (B.strategy && B.strategy != r.Z_FILTERED && B.strategy != r.Z_HUFFMAN_ONLY && B.strategy != r.Z_RLE && B.strategy != r.Z_FIXED && B.strategy != r.Z_DEFAULT_STRATEGY)
      throw new Error("Invalid strategy: " + B.strategy);
    if (B.dictionary && !e.isBuffer(B.dictionary))
      throw new Error("Invalid dictionary: it should be a Buffer instance");
    this._handle = new n.Zlib(q);
    var oe = this;
    this._hadError = !1, this._handle.onerror = function(fe, _e) {
      ve(oe), oe._hadError = !0;
      var Re = new Error(fe);
      Re.errno = _e, Re.code = r.codes[_e], oe.emit("error", Re);
    };
    var ne = r.Z_DEFAULT_COMPRESSION;
    typeof B.level == "number" && (ne = B.level);
    var me = r.Z_DEFAULT_STRATEGY;
    typeof B.strategy == "number" && (me = B.strategy), this._handle.init(B.windowBits || r.Z_DEFAULT_WINDOWBITS, ne, B.memLevel || r.Z_DEFAULT_MEMLEVEL, me, B.dictionary), this._buffer = e.allocUnsafe(this._chunkSize), this._offset = 0, this._level = ne, this._strategy = me, this.once("end", this.close), Object.defineProperty(this, "_closed", {
      get: function() {
        return !H._handle;
      },
      configurable: !0,
      enumerable: !0
    });
  }
  i.inherits(ee, t), ee.prototype.params = function(B, q, H) {
    if (B < r.Z_MIN_LEVEL || B > r.Z_MAX_LEVEL)
      throw new RangeError("Invalid compression level: " + B);
    if (q != r.Z_FILTERED && q != r.Z_HUFFMAN_ONLY && q != r.Z_RLE && q != r.Z_FIXED && q != r.Z_DEFAULT_STRATEGY)
      throw new TypeError("Invalid strategy: " + q);
    if (this._level !== B || this._strategy !== q) {
      var oe = this;
      this.flush(n.Z_SYNC_FLUSH, function() {
        a(oe._handle, "zlib binding closed"), oe._handle.params(B, q), oe._hadError || (oe._level = B, oe._strategy = q, H && H());
      });
    } else
      _i.nextTick(H);
  }, ee.prototype.reset = function() {
    return a(this._handle, "zlib binding closed"), this._handle.reset();
  }, ee.prototype._flush = function(B) {
    this._transform(e.alloc(0), "", B);
  }, ee.prototype.flush = function(B, q) {
    var H = this, oe = this._writableState;
    (typeof B == "function" || B === void 0 && !q) && (q = B, B = n.Z_FULL_FLUSH), oe.ended ? q && _i.nextTick(q) : oe.ending ? q && this.once("end", q) : oe.needDrain ? q && this.once("drain", function() {
      return H.flush(B, q);
    }) : (this._flushFlag = B, this.write(e.alloc(0), "", q));
  }, ee.prototype.close = function(B) {
    ve(this, B), _i.nextTick(de, this);
  };
  function ve(B, q) {
    q && _i.nextTick(q), B._handle && (B._handle.close(), B._handle = null);
  }
  function de(B) {
    B.emit("close");
  }
  ee.prototype._transform = function(B, q, H) {
    var oe, ne = this._writableState, me = ne.ending || ne.ended, fe = me && (!B || ne.length === B.length);
    if (B !== null && !e.isBuffer(B)) return H(new Error("invalid input"));
    if (!this._handle) return H(new Error("zlib binding closed"));
    fe ? oe = this._finishFlushFlag : (oe = this._flushFlag, B.length >= ne.length && (this._flushFlag = this._opts.flush || n.Z_NO_FLUSH)), this._processChunk(B, oe, H);
  }, ee.prototype._processChunk = function(B, q, H) {
    var oe = B && B.length, ne = this._chunkSize - this._offset, me = 0, fe = this, _e = typeof H == "function";
    if (!_e) {
      var Re = [], Ie = 0, W;
      this.on("error", function(xe) {
        W = xe;
      }), a(this._handle, "zlib binding closed");
      do
        var Z = this._handle.writeSync(
          q,
          B,
          // in
          me,
          // in_off
          oe,
          // in_len
          this._buffer,
          // out
          this._offset,
          //out_off
          ne
        );
      while (!this._hadError && Fe(Z[0], Z[1]));
      if (this._hadError)
        throw W;
      if (Ie >= o)
        throw ve(this), new RangeError(s);
      var se = e.concat(Re, Ie);
      return ve(this), se;
    }
    a(this._handle, "zlib binding closed");
    var ye = this._handle.write(
      q,
      B,
      // in
      me,
      // in_off
      oe,
      // in_len
      this._buffer,
      // out
      this._offset,
      //out_off
      ne
    );
    ye.buffer = B, ye.callback = Fe;
    function Fe(xe, be) {
      if (this && (this.buffer = null, this.callback = null), !fe._hadError) {
        var he = ne - be;
        if (a(he >= 0, "have should not go down"), he > 0) {
          var ke = fe._buffer.slice(fe._offset, fe._offset + he);
          fe._offset += he, _e ? fe.push(ke) : (Re.push(ke), Ie += ke.length);
        }
        if ((be === 0 || fe._offset >= fe._chunkSize) && (ne = fe._chunkSize, fe._offset = 0, fe._buffer = e.allocUnsafe(fe._chunkSize)), be === 0) {
          if (me += oe - xe, oe = xe, !_e) return !0;
          var De = fe._handle.write(q, B, me, oe, fe._buffer, fe._offset, fe._chunkSize);
          De.callback = Fe, De.buffer = B;
          return;
        }
        if (!_e) return !1;
        H();
      }
    }
  }, i.inherits(M, ee), i.inherits(G, ee), i.inherits(z, ee), i.inherits(j, ee), i.inherits(R, ee), i.inherits(te, ee), i.inherits(J, ee);
})(aA);
var I1 = /* @__PURE__ */ function() {
  r.decode = function(n, i) {
    throw new Error("PNG.decode not available in browser build");
  }, r.load = function(n) {
    throw new Error("PNG.load not available in browser build");
  };
  function r(t) {
    var n;
    for (this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.text = {}; ; ) {
      var i = this.readUInt32(), a = "";
      for (n = 0; n < 4; n++)
        a += String.fromCharCode(this.data[this.pos++]);
      switch (a) {
        case "IHDR":
          this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
          break;
        case "PLTE":
          this.palette = this.read(i);
          break;
        case "IDAT":
          for (n = 0; n < i; n++)
            this.imgData.push(this.data[this.pos++]);
          break;
        case "tRNS":
          switch (this.transparency = {}, this.colorType) {
            case 3:
              this.transparency.indexed = this.read(i);
              var o = 255 - this.transparency.indexed.length;
              if (o > 0)
                for (n = 0; n < o; n++)
                  this.transparency.indexed.push(255);
              break;
            case 0:
              this.transparency.grayscale = this.read(i)[0];
              break;
            case 2:
              this.transparency.rgb = this.read(i);
              break;
          }
          break;
        case "tEXt":
          var s = this.read(i), c = s.indexOf(0), h = String.fromCharCode.apply(String, s.slice(0, c));
          this.text[h] = String.fromCharCode.apply(String, s.slice(c + 1));
          break;
        case "IEND":
          switch (this.colorType) {
            case 0:
            case 3:
            case 4:
              this.colors = 1;
              break;
            case 2:
            case 6:
              this.colors = 3;
              break;
          }
          this.hasAlphaChannel = [4, 6].includes(this.colorType);
          var d = this.colors + (this.hasAlphaChannel ? 1 : 0);
          switch (this.pixelBitlength = this.bits * d, this.colors) {
            case 1:
              this.colorSpace = "DeviceGray";
              break;
            case 3:
              this.colorSpace = "DeviceRGB";
              break;
          }
          this.imgData = ut.from(this.imgData);
          return;
        default:
          this.pos += i;
      }
      if (this.pos += 4, this.pos > this.data.length)
        throw new Error("Incomplete or corrupt PNG file");
    }
  }
  var e = r.prototype;
  return e.read = function(n) {
    for (var i = new Array(n), a = 0; a < n; a++)
      i[a] = this.data[this.pos++];
    return i;
  }, e.readUInt32 = function() {
    var n = this.data[this.pos++] << 24, i = this.data[this.pos++] << 16, a = this.data[this.pos++] << 8, o = this.data[this.pos++];
    return n | i | a | o;
  }, e.readUInt16 = function() {
    var n = this.data[this.pos++] << 8, i = this.data[this.pos++];
    return n | i;
  }, e.decodePixels = function(n) {
    var i = this;
    return aA.inflate(this.imgData, function(a, o) {
      if (a) throw a;
      var s = 0, c = i.width, h = i.height, d = i.pixelBitlength / 8, g = ut.alloc(c * h * d);
      function x(_, k, P, N, M) {
        M === void 0 && (M = !1);
        for (var G = Math.ceil((c - _) / P), z = Math.ceil((h - k) / N), j = d * G, R = M ? g : ut.alloc(j * z), te = 0, J = 0; te < z && s < o.length; ) {
          var K, ee, ve, de, B;
          switch (o[s++]) {
            case 0:
              for (ve = 0; ve < j; ve++)
                R[J++] = o[s++];
              break;
            case 1:
              for (ve = 0; ve < j; ve++)
                K = o[s++], de = ve < d ? 0 : R[J - d], R[J++] = (K + de) % 256;
              break;
            case 2:
              for (ve = 0; ve < j; ve++)
                K = o[s++], ee = (ve - ve % d) / d, B = te && R[(te - 1) * j + ee * d + ve % d], R[J++] = (B + K) % 256;
              break;
            case 3:
              for (ve = 0; ve < j; ve++)
                K = o[s++], ee = (ve - ve % d) / d, de = ve < d ? 0 : R[J - d], B = te && R[(te - 1) * j + ee * d + ve % d], R[J++] = (K + Math.floor((de + B) / 2)) % 256;
              break;
            case 4:
              for (ve = 0; ve < j; ve++) {
                var q, H;
                K = o[s++], ee = (ve - ve % d) / d, de = ve < d ? 0 : R[J - d], te === 0 ? B = H = 0 : (B = R[(te - 1) * j + ee * d + ve % d], H = ee && R[(te - 1) * j + (ee - 1) * d + ve % d]);
                var oe = de + B - H, ne = Math.abs(oe - de), me = Math.abs(oe - B), fe = Math.abs(oe - H);
                ne <= me && ne <= fe ? q = de : me <= fe ? q = B : q = H, R[J++] = (K + q) % 256;
              }
              break;
            default:
              throw new Error("Invalid filter algorithm: " + o[s - 1]);
          }
          if (!M) {
            var _e = ((k + te * N) * c + _) * d, Re = te * j;
            for (ve = 0; ve < G; ve++) {
              for (var Ie = 0; Ie < d; Ie++)
                g[_e++] = R[Re++];
              _e += (P - 1) * d;
            }
          }
          te++;
        }
      }
      return i.interlaceMethod === 1 ? (x(0, 0, 8, 8), x(4, 0, 8, 8), x(0, 4, 4, 8), x(2, 0, 4, 4), x(0, 2, 2, 4), x(1, 0, 2, 2), x(0, 1, 1, 2)) : x(0, 0, 1, 1, !0), n(g);
    });
  }, e.decodePalette = function() {
    for (var n = this.palette, i = n.length, a = this.transparency.indexed || [], o = ut.alloc(a.length + i), s = 0, c = 0, h = 0; h < i; h += 3) {
      var d;
      o[s++] = n[h], o[s++] = n[h + 1], o[s++] = n[h + 2], o[s++] = (d = a[c++]) != null ? d : 255;
    }
    return o;
  }, e.copyToImageData = function(n, i) {
    var a, o, s = this.colors, c = null, h = this.hasAlphaChannel;
    this.palette.length && (c = this._decodedPalette || (this._decodedPalette = this.decodePalette()), s = 4, h = !0);
    var d = n.data || n, g = d.length, x = c || i, _ = a = 0;
    if (s === 1)
      for (; _ < g; ) {
        o = c ? i[_ / 4] * 4 : a;
        var k = x[o++];
        d[_++] = k, d[_++] = k, d[_++] = k, d[_++] = h ? x[o++] : 255, a = o;
      }
    else
      for (; _ < g; )
        o = c ? i[_ / 4] * 4 : a, d[_++] = x[o++], d[_++] = x[o++], d[_++] = x[o++], d[_++] = h ? x[o++] : 255, a = o;
  }, e.decode = function(n) {
    var i = this, a = ut.alloc(this.width * this.height * 4);
    return this.decodePixels(function(o) {
      return i.copyToImageData(a, o), n(a);
    });
  }, r;
}(), P1 = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, uo = [], Ji = [], YG = typeof Uint8Array < "u" ? Uint8Array : Array, ug = !1;
function nE() {
  ug = !0;
  for (var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, t = r.length; e < t; ++e)
    uo[e] = r[e], Ji[r.charCodeAt(e)] = e;
  Ji[45] = 62, Ji[95] = 63;
}
function HG(r) {
  ug || nE();
  var e, t, n, i, a, o, s = r.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  a = r[s - 2] === "=" ? 2 : r[s - 1] === "=" ? 1 : 0, o = new YG(s * 3 / 4 - a), n = a > 0 ? s - 4 : s;
  var c = 0;
  for (e = 0, t = 0; e < n; e += 4, t += 3)
    i = Ji[r.charCodeAt(e)] << 18 | Ji[r.charCodeAt(e + 1)] << 12 | Ji[r.charCodeAt(e + 2)] << 6 | Ji[r.charCodeAt(e + 3)], o[c++] = i >> 16 & 255, o[c++] = i >> 8 & 255, o[c++] = i & 255;
  return a === 2 ? (i = Ji[r.charCodeAt(e)] << 2 | Ji[r.charCodeAt(e + 1)] >> 4, o[c++] = i & 255) : a === 1 && (i = Ji[r.charCodeAt(e)] << 10 | Ji[r.charCodeAt(e + 1)] << 4 | Ji[r.charCodeAt(e + 2)] >> 2, o[c++] = i >> 8 & 255, o[c++] = i & 255), o;
}
function ZG(r) {
  return uo[r >> 18 & 63] + uo[r >> 12 & 63] + uo[r >> 6 & 63] + uo[r & 63];
}
function qG(r, e, t) {
  for (var n, i = [], a = e; a < t; a += 3)
    n = (r[a] << 16) + (r[a + 1] << 8) + r[a + 2], i.push(ZG(n));
  return i.join("");
}
function P6(r) {
  ug || nE();
  for (var e, t = r.length, n = t % 3, i = "", a = [], o = 16383, s = 0, c = t - n; s < c; s += o)
    a.push(qG(r, s, s + o > c ? c : s + o));
  return n === 1 ? (e = r[t - 1], i += uo[e >> 2], i += uo[e << 4 & 63], i += "==") : n === 2 && (e = (r[t - 2] << 8) + r[t - 1], i += uo[e >> 10], i += uo[e >> 4 & 63], i += uo[e << 2 & 63], i += "="), a.push(i), a.join("");
}
function g5(r, e, t, n, i) {
  var a, o, s = i * 8 - n - 1, c = (1 << s) - 1, h = c >> 1, d = -7, g = t ? i - 1 : 0, x = t ? -1 : 1, _ = r[e + g];
  for (g += x, a = _ & (1 << -d) - 1, _ >>= -d, d += s; d > 0; a = a * 256 + r[e + g], g += x, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += n; d > 0; o = o * 256 + r[e + g], g += x, d -= 8)
    ;
  if (a === 0)
    a = 1 - h;
  else {
    if (a === c)
      return o ? NaN : (_ ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), a = a - h;
  }
  return (_ ? -1 : 1) * o * Math.pow(2, a - n);
}
function iE(r, e, t, n, i, a) {
  var o, s, c, h = a * 8 - i - 1, d = (1 << h) - 1, g = d >> 1, x = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, _ = n ? 0 : a - 1, k = n ? 1 : -1, P = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + g >= 1 ? e += x / c : e += x * Math.pow(2, 1 - g), e * c >= 2 && (o++, c /= 2), o + g >= d ? (s = 0, o = d) : o + g >= 1 ? (s = (e * c - 1) * Math.pow(2, i), o = o + g) : (s = e * Math.pow(2, g - 1) * Math.pow(2, i), o = 0)); i >= 8; r[t + _] = s & 255, _ += k, s /= 256, i -= 8)
    ;
  for (o = o << i | s, h += i; h > 0; r[t + _] = o & 255, _ += k, o /= 256, h -= 8)
    ;
  r[t + _ - k] |= P * 128;
}
var XG = {}.toString, aE = Array.isArray || function(r) {
  return XG.call(r) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var KG = 50;
tt.TYPED_ARRAY_SUPPORT = P1.TYPED_ARRAY_SUPPORT !== void 0 ? P1.TYPED_ARRAY_SUPPORT : !0;
function P3() {
  return tt.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Xo(r, e) {
  if (P3() < e)
    throw new RangeError("Invalid typed array length");
  return tt.TYPED_ARRAY_SUPPORT ? (r = new Uint8Array(e), r.__proto__ = tt.prototype) : (r === null && (r = new tt(e)), r.length = e), r;
}
function tt(r, e, t) {
  if (!tt.TYPED_ARRAY_SUPPORT && !(this instanceof tt))
    return new tt(r, e, t);
  if (typeof r == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return lg(this, r);
  }
  return oE(this, r, e, t);
}
tt.poolSize = 8192;
tt._augment = function(r) {
  return r.__proto__ = tt.prototype, r;
};
function oE(r, e, t, n) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? eV(r, e, t, n) : typeof e == "string" ? QG(r, e, t) : tV(r, e);
}
tt.from = function(r, e, t) {
  return oE(null, r, e, t);
};
tt.TYPED_ARRAY_SUPPORT && (tt.prototype.__proto__ = Uint8Array.prototype, tt.__proto__ = Uint8Array);
function sE(r) {
  if (typeof r != "number")
    throw new TypeError('"size" argument must be a number');
  if (r < 0)
    throw new RangeError('"size" argument must not be negative');
}
function JG(r, e, t, n) {
  return sE(e), e <= 0 ? Xo(r, e) : t !== void 0 ? typeof n == "string" ? Xo(r, e).fill(t, n) : Xo(r, e).fill(t) : Xo(r, e);
}
tt.alloc = function(r, e, t) {
  return JG(null, r, e, t);
};
function lg(r, e) {
  if (sE(e), r = Xo(r, e < 0 ? 0 : cg(e) | 0), !tt.TYPED_ARRAY_SUPPORT)
    for (var t = 0; t < e; ++t)
      r[t] = 0;
  return r;
}
tt.allocUnsafe = function(r) {
  return lg(null, r);
};
tt.allocUnsafeSlow = function(r) {
  return lg(null, r);
};
function QG(r, e, t) {
  if ((typeof t != "string" || t === "") && (t = "utf8"), !tt.isEncoding(t))
    throw new TypeError('"encoding" must be a valid string encoding');
  var n = uE(e, t) | 0;
  r = Xo(r, n);
  var i = r.write(e, t);
  return i !== n && (r = r.slice(0, i)), r;
}
function B3(r, e) {
  var t = e.length < 0 ? 0 : cg(e.length) | 0;
  r = Xo(r, t);
  for (var n = 0; n < t; n += 1)
    r[n] = e[n] & 255;
  return r;
}
function eV(r, e, t, n) {
  if (e.byteLength, t < 0 || e.byteLength < t)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < t + (n || 0))
    throw new RangeError("'length' is out of bounds");
  return t === void 0 && n === void 0 ? e = new Uint8Array(e) : n === void 0 ? e = new Uint8Array(e, t) : e = new Uint8Array(e, t, n), tt.TYPED_ARRAY_SUPPORT ? (r = e, r.__proto__ = tt.prototype) : r = B3(r, e), r;
}
function tV(r, e) {
  if (bo(e)) {
    var t = cg(e.length) | 0;
    return r = Xo(r, t), r.length === 0 || e.copy(r, 0, 0, t), r;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || wV(e.length) ? Xo(r, 0) : B3(r, e);
    if (e.type === "Buffer" && aE(e.data))
      return B3(r, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function cg(r) {
  if (r >= P3())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + P3().toString(16) + " bytes");
  return r | 0;
}
tt.isBuffer = AV;
function bo(r) {
  return !!(r != null && r._isBuffer);
}
tt.compare = function(e, t) {
  if (!bo(e) || !bo(t))
    throw new TypeError("Arguments must be Buffers");
  if (e === t) return 0;
  for (var n = e.length, i = t.length, a = 0, o = Math.min(n, i); a < o; ++a)
    if (e[a] !== t[a]) {
      n = e[a], i = t[a];
      break;
    }
  return n < i ? -1 : i < n ? 1 : 0;
};
tt.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
tt.concat = function(e, t) {
  if (!aE(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return tt.alloc(0);
  var n;
  if (t === void 0)
    for (t = 0, n = 0; n < e.length; ++n)
      t += e[n].length;
  var i = tt.allocUnsafe(t), a = 0;
  for (n = 0; n < e.length; ++n) {
    var o = e[n];
    if (!bo(o))
      throw new TypeError('"list" argument must be an Array of Buffers');
    o.copy(i, a), a += o.length;
  }
  return i;
};
function uE(r, e) {
  if (bo(r))
    return r.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(r) || r instanceof ArrayBuffer))
    return r.byteLength;
  typeof r != "string" && (r = "" + r);
  var t = r.length;
  if (t === 0) return 0;
  for (var n = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return t;
      case "utf8":
      case "utf-8":
      case void 0:
        return _d(r).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t * 2;
      case "hex":
        return t >>> 1;
      case "base64":
        return vE(r).length;
      default:
        if (n) return _d(r).length;
        e = ("" + e).toLowerCase(), n = !0;
    }
}
tt.byteLength = uE;
function rV(r, e, t) {
  var n = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, e >>>= 0, t <= e))
    return "";
  for (r || (r = "utf8"); ; )
    switch (r) {
      case "hex":
        return hV(this, e, t);
      case "utf8":
      case "utf-8":
        return fE(this, e, t);
      case "ascii":
        return cV(this, e, t);
      case "latin1":
      case "binary":
        return fV(this, e, t);
      case "base64":
        return uV(this, e, t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return dV(this, e, t);
      default:
        if (n) throw new TypeError("Unknown encoding: " + r);
        r = (r + "").toLowerCase(), n = !0;
    }
}
tt.prototype._isBuffer = !0;
function il(r, e, t) {
  var n = r[e];
  r[e] = r[t], r[t] = n;
}
tt.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < e; t += 2)
    il(this, t, t + 1);
  return this;
};
tt.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < e; t += 4)
    il(this, t, t + 3), il(this, t + 1, t + 2);
  return this;
};
tt.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < e; t += 8)
    il(this, t, t + 7), il(this, t + 1, t + 6), il(this, t + 2, t + 5), il(this, t + 3, t + 4);
  return this;
};
tt.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? fE(this, 0, e) : rV.apply(this, arguments);
};
tt.prototype.equals = function(e) {
  if (!bo(e)) throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : tt.compare(this, e) === 0;
};
tt.prototype.inspect = function() {
  var e = "", t = KG;
  return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
};
tt.prototype.compare = function(e, t, n, i, a) {
  if (!bo(e))
    throw new TypeError("Argument must be a Buffer");
  if (t === void 0 && (t = 0), n === void 0 && (n = e ? e.length : 0), i === void 0 && (i = 0), a === void 0 && (a = this.length), t < 0 || n > e.length || i < 0 || a > this.length)
    throw new RangeError("out of range index");
  if (i >= a && t >= n)
    return 0;
  if (i >= a)
    return -1;
  if (t >= n)
    return 1;
  if (t >>>= 0, n >>>= 0, i >>>= 0, a >>>= 0, this === e) return 0;
  for (var o = a - i, s = n - t, c = Math.min(o, s), h = this.slice(i, a), d = e.slice(t, n), g = 0; g < c; ++g)
    if (h[g] !== d[g]) {
      o = h[g], s = d[g];
      break;
    }
  return o < s ? -1 : s < o ? 1 : 0;
};
function lE(r, e, t, n, i) {
  if (r.length === 0) return -1;
  if (typeof t == "string" ? (n = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = i ? 0 : r.length - 1), t < 0 && (t = r.length + t), t >= r.length) {
    if (i) return -1;
    t = r.length - 1;
  } else if (t < 0)
    if (i) t = 0;
    else return -1;
  if (typeof e == "string" && (e = tt.from(e, n)), bo(e))
    return e.length === 0 ? -1 : B6(r, e, t, n, i);
  if (typeof e == "number")
    return e = e & 255, tt.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(r, e, t) : Uint8Array.prototype.lastIndexOf.call(r, e, t) : B6(r, [e], t, n, i);
  throw new TypeError("val must be string, number or Buffer");
}
function B6(r, e, t, n, i) {
  var a = 1, o = r.length, s = e.length;
  if (n !== void 0 && (n = String(n).toLowerCase(), n === "ucs2" || n === "ucs-2" || n === "utf16le" || n === "utf-16le")) {
    if (r.length < 2 || e.length < 2)
      return -1;
    a = 2, o /= 2, s /= 2, t /= 2;
  }
  function c(_, k) {
    return a === 1 ? _[k] : _.readUInt16BE(k * a);
  }
  var h;
  if (i) {
    var d = -1;
    for (h = t; h < o; h++)
      if (c(r, h) === c(e, d === -1 ? 0 : h - d)) {
        if (d === -1 && (d = h), h - d + 1 === s) return d * a;
      } else
        d !== -1 && (h -= h - d), d = -1;
  } else
    for (t + s > o && (t = o - s), h = t; h >= 0; h--) {
      for (var g = !0, x = 0; x < s; x++)
        if (c(r, h + x) !== c(e, x)) {
          g = !1;
          break;
        }
      if (g) return h;
    }
  return -1;
}
tt.prototype.includes = function(e, t, n) {
  return this.indexOf(e, t, n) !== -1;
};
tt.prototype.indexOf = function(e, t, n) {
  return lE(this, e, t, n, !0);
};
tt.prototype.lastIndexOf = function(e, t, n) {
  return lE(this, e, t, n, !1);
};
function nV(r, e, t, n) {
  t = Number(t) || 0;
  var i = r.length - t;
  n ? (n = Number(n), n > i && (n = i)) : n = i;
  var a = e.length;
  if (a % 2 !== 0) throw new TypeError("Invalid hex string");
  n > a / 2 && (n = a / 2);
  for (var o = 0; o < n; ++o) {
    var s = parseInt(e.substr(o * 2, 2), 16);
    if (isNaN(s)) return o;
    r[t + o] = s;
  }
  return o;
}
function iV(r, e, t, n) {
  return b5(_d(e, r.length - t), r, t, n);
}
function cE(r, e, t, n) {
  return b5(yV(e), r, t, n);
}
function aV(r, e, t, n) {
  return cE(r, e, t, n);
}
function oV(r, e, t, n) {
  return b5(vE(e), r, t, n);
}
function sV(r, e, t, n) {
  return b5(bV(e, r.length - t), r, t, n);
}
tt.prototype.write = function(e, t, n, i) {
  if (t === void 0)
    i = "utf8", n = this.length, t = 0;
  else if (n === void 0 && typeof t == "string")
    i = t, n = this.length, t = 0;
  else if (isFinite(t))
    t = t | 0, isFinite(n) ? (n = n | 0, i === void 0 && (i = "utf8")) : (i = n, n = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var a = this.length - t;
  if ((n === void 0 || n > a) && (n = a), e.length > 0 && (n < 0 || t < 0) || t > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var o = !1; ; )
    switch (i) {
      case "hex":
        return nV(this, e, t, n);
      case "utf8":
      case "utf-8":
        return iV(this, e, t, n);
      case "ascii":
        return cE(this, e, t, n);
      case "latin1":
      case "binary":
        return aV(this, e, t, n);
      case "base64":
        return oV(this, e, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return sV(this, e, t, n);
      default:
        if (o) throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), o = !0;
    }
};
tt.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function uV(r, e, t) {
  return e === 0 && t === r.length ? P6(r) : P6(r.slice(e, t));
}
function fE(r, e, t) {
  t = Math.min(r.length, t);
  for (var n = [], i = e; i < t; ) {
    var a = r[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
    if (i + s <= t) {
      var c, h, d, g;
      switch (s) {
        case 1:
          a < 128 && (o = a);
          break;
        case 2:
          c = r[i + 1], (c & 192) === 128 && (g = (a & 31) << 6 | c & 63, g > 127 && (o = g));
          break;
        case 3:
          c = r[i + 1], h = r[i + 2], (c & 192) === 128 && (h & 192) === 128 && (g = (a & 15) << 12 | (c & 63) << 6 | h & 63, g > 2047 && (g < 55296 || g > 57343) && (o = g));
          break;
        case 4:
          c = r[i + 1], h = r[i + 2], d = r[i + 3], (c & 192) === 128 && (h & 192) === 128 && (d & 192) === 128 && (g = (a & 15) << 18 | (c & 63) << 12 | (h & 63) << 6 | d & 63, g > 65535 && g < 1114112 && (o = g));
      }
    }
    o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), n.push(o), i += s;
  }
  return lV(n);
}
var N6 = 4096;
function lV(r) {
  var e = r.length;
  if (e <= N6)
    return String.fromCharCode.apply(String, r);
  for (var t = "", n = 0; n < e; )
    t += String.fromCharCode.apply(
      String,
      r.slice(n, n += N6)
    );
  return t;
}
function cV(r, e, t) {
  var n = "";
  t = Math.min(r.length, t);
  for (var i = e; i < t; ++i)
    n += String.fromCharCode(r[i] & 127);
  return n;
}
function fV(r, e, t) {
  var n = "";
  t = Math.min(r.length, t);
  for (var i = e; i < t; ++i)
    n += String.fromCharCode(r[i]);
  return n;
}
function hV(r, e, t) {
  var n = r.length;
  (!e || e < 0) && (e = 0), (!t || t < 0 || t > n) && (t = n);
  for (var i = "", a = e; a < t; ++a)
    i += mV(r[a]);
  return i;
}
function dV(r, e, t) {
  for (var n = r.slice(e, t), i = "", a = 0; a < n.length; a += 2)
    i += String.fromCharCode(n[a] + n[a + 1] * 256);
  return i;
}
tt.prototype.slice = function(e, t) {
  var n = this.length;
  e = ~~e, t = t === void 0 ? n : ~~t, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), t < 0 ? (t += n, t < 0 && (t = 0)) : t > n && (t = n), t < e && (t = e);
  var i;
  if (tt.TYPED_ARRAY_SUPPORT)
    i = this.subarray(e, t), i.__proto__ = tt.prototype;
  else {
    var a = t - e;
    i = new tt(a, void 0);
    for (var o = 0; o < a; ++o)
      i[o] = this[o + e];
  }
  return i;
};
function fn(r, e, t) {
  if (r % 1 !== 0 || r < 0) throw new RangeError("offset is not uint");
  if (r + e > t) throw new RangeError("Trying to access beyond buffer length");
}
tt.prototype.readUIntLE = function(e, t, n) {
  e = e | 0, t = t | 0, n || fn(e, t, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < t && (a *= 256); )
    i += this[e + o] * a;
  return i;
};
tt.prototype.readUIntBE = function(e, t, n) {
  e = e | 0, t = t | 0, n || fn(e, t, this.length);
  for (var i = this[e + --t], a = 1; t > 0 && (a *= 256); )
    i += this[e + --t] * a;
  return i;
};
tt.prototype.readUInt8 = function(e, t) {
  return t || fn(e, 1, this.length), this[e];
};
tt.prototype.readUInt16LE = function(e, t) {
  return t || fn(e, 2, this.length), this[e] | this[e + 1] << 8;
};
tt.prototype.readUInt16BE = function(e, t) {
  return t || fn(e, 2, this.length), this[e] << 8 | this[e + 1];
};
tt.prototype.readUInt32LE = function(e, t) {
  return t || fn(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
tt.prototype.readUInt32BE = function(e, t) {
  return t || fn(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
tt.prototype.readIntLE = function(e, t, n) {
  e = e | 0, t = t | 0, n || fn(e, t, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < t && (a *= 256); )
    i += this[e + o] * a;
  return a *= 128, i >= a && (i -= Math.pow(2, 8 * t)), i;
};
tt.prototype.readIntBE = function(e, t, n) {
  e = e | 0, t = t | 0, n || fn(e, t, this.length);
  for (var i = t, a = 1, o = this[e + --i]; i > 0 && (a *= 256); )
    o += this[e + --i] * a;
  return a *= 128, o >= a && (o -= Math.pow(2, 8 * t)), o;
};
tt.prototype.readInt8 = function(e, t) {
  return t || fn(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
tt.prototype.readInt16LE = function(e, t) {
  t || fn(e, 2, this.length);
  var n = this[e] | this[e + 1] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
tt.prototype.readInt16BE = function(e, t) {
  t || fn(e, 2, this.length);
  var n = this[e + 1] | this[e] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
tt.prototype.readInt32LE = function(e, t) {
  return t || fn(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
tt.prototype.readInt32BE = function(e, t) {
  return t || fn(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
tt.prototype.readFloatLE = function(e, t) {
  return t || fn(e, 4, this.length), g5(this, e, !0, 23, 4);
};
tt.prototype.readFloatBE = function(e, t) {
  return t || fn(e, 4, this.length), g5(this, e, !1, 23, 4);
};
tt.prototype.readDoubleLE = function(e, t) {
  return t || fn(e, 8, this.length), g5(this, e, !0, 52, 8);
};
tt.prototype.readDoubleBE = function(e, t) {
  return t || fn(e, 8, this.length), g5(this, e, !1, 52, 8);
};
function pi(r, e, t, n, i, a) {
  if (!bo(r)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > i || e < a) throw new RangeError('"value" argument is out of bounds');
  if (t + n > r.length) throw new RangeError("Index out of range");
}
tt.prototype.writeUIntLE = function(e, t, n, i) {
  if (e = +e, t = t | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    pi(this, e, t, n, a, 0);
  }
  var o = 1, s = 0;
  for (this[t] = e & 255; ++s < n && (o *= 256); )
    this[t + s] = e / o & 255;
  return t + n;
};
tt.prototype.writeUIntBE = function(e, t, n, i) {
  if (e = +e, t = t | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    pi(this, e, t, n, a, 0);
  }
  var o = n - 1, s = 1;
  for (this[t + o] = e & 255; --o >= 0 && (s *= 256); )
    this[t + o] = e / s & 255;
  return t + n;
};
tt.prototype.writeUInt8 = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 1, 255, 0), tt.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = e & 255, t + 1;
};
function m5(r, e, t, n) {
  e < 0 && (e = 65535 + e + 1);
  for (var i = 0, a = Math.min(r.length - t, 2); i < a; ++i)
    r[t + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> (n ? i : 1 - i) * 8;
}
tt.prototype.writeUInt16LE = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 2, 65535, 0), tt.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : m5(this, e, t, !0), t + 2;
};
tt.prototype.writeUInt16BE = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 2, 65535, 0), tt.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : m5(this, e, t, !1), t + 2;
};
function y5(r, e, t, n) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var i = 0, a = Math.min(r.length - t, 4); i < a; ++i)
    r[t + i] = e >>> (n ? i : 3 - i) * 8 & 255;
}
tt.prototype.writeUInt32LE = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 4, 4294967295, 0), tt.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255) : y5(this, e, t, !0), t + 4;
};
tt.prototype.writeUInt32BE = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 4, 4294967295, 0), tt.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : y5(this, e, t, !1), t + 4;
};
tt.prototype.writeIntLE = function(e, t, n, i) {
  if (e = +e, t = t | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    pi(this, e, t, n, a - 1, -a);
  }
  var o = 0, s = 1, c = 0;
  for (this[t] = e & 255; ++o < n && (s *= 256); )
    e < 0 && c === 0 && this[t + o - 1] !== 0 && (c = 1), this[t + o] = (e / s >> 0) - c & 255;
  return t + n;
};
tt.prototype.writeIntBE = function(e, t, n, i) {
  if (e = +e, t = t | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    pi(this, e, t, n, a - 1, -a);
  }
  var o = n - 1, s = 1, c = 0;
  for (this[t + o] = e & 255; --o >= 0 && (s *= 256); )
    e < 0 && c === 0 && this[t + o + 1] !== 0 && (c = 1), this[t + o] = (e / s >> 0) - c & 255;
  return t + n;
};
tt.prototype.writeInt8 = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 1, 127, -128), tt.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
};
tt.prototype.writeInt16LE = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 2, 32767, -32768), tt.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : m5(this, e, t, !0), t + 2;
};
tt.prototype.writeInt16BE = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 2, 32767, -32768), tt.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : m5(this, e, t, !1), t + 2;
};
tt.prototype.writeInt32LE = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 4, 2147483647, -2147483648), tt.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : y5(this, e, t, !0), t + 4;
};
tt.prototype.writeInt32BE = function(e, t, n) {
  return e = +e, t = t | 0, n || pi(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), tt.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : y5(this, e, t, !1), t + 4;
};
function hE(r, e, t, n, i, a) {
  if (t + n > r.length) throw new RangeError("Index out of range");
  if (t < 0) throw new RangeError("Index out of range");
}
function dE(r, e, t, n, i) {
  return i || hE(r, e, t, 4), iE(r, e, t, n, 23, 4), t + 4;
}
tt.prototype.writeFloatLE = function(e, t, n) {
  return dE(this, e, t, !0, n);
};
tt.prototype.writeFloatBE = function(e, t, n) {
  return dE(this, e, t, !1, n);
};
function pE(r, e, t, n, i) {
  return i || hE(r, e, t, 8), iE(r, e, t, n, 52, 8), t + 8;
}
tt.prototype.writeDoubleLE = function(e, t, n) {
  return pE(this, e, t, !0, n);
};
tt.prototype.writeDoubleBE = function(e, t, n) {
  return pE(this, e, t, !1, n);
};
tt.prototype.copy = function(e, t, n, i) {
  if (n || (n = 0), !i && i !== 0 && (i = this.length), t >= e.length && (t = e.length), t || (t = 0), i > 0 && i < n && (i = n), i === n || e.length === 0 || this.length === 0) return 0;
  if (t < 0)
    throw new RangeError("targetStart out of bounds");
  if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
  if (i < 0) throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), e.length - t < i - n && (i = e.length - t + n);
  var a = i - n, o;
  if (this === e && n < t && t < i)
    for (o = a - 1; o >= 0; --o)
      e[o + t] = this[o + n];
  else if (a < 1e3 || !tt.TYPED_ARRAY_SUPPORT)
    for (o = 0; o < a; ++o)
      e[o + t] = this[o + n];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(n, n + a),
      t
    );
  return a;
};
tt.prototype.fill = function(e, t, n, i) {
  if (typeof e == "string") {
    if (typeof t == "string" ? (i = t, t = 0, n = this.length) : typeof n == "string" && (i = n, n = this.length), e.length === 1) {
      var a = e.charCodeAt(0);
      a < 256 && (e = a);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !tt.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else typeof e == "number" && (e = e & 255);
  if (t < 0 || this.length < t || this.length < n)
    throw new RangeError("Out of range index");
  if (n <= t)
    return this;
  t = t >>> 0, n = n === void 0 ? this.length : n >>> 0, e || (e = 0);
  var o;
  if (typeof e == "number")
    for (o = t; o < n; ++o)
      this[o] = e;
  else {
    var s = bo(e) ? e : _d(new tt(e, i).toString()), c = s.length;
    for (o = 0; o < n - t; ++o)
      this[o + t] = s[o % c];
  }
  return this;
};
var pV = /[^+\/0-9A-Za-z-_]/g;
function vV(r) {
  if (r = gV(r).replace(pV, ""), r.length < 2) return "";
  for (; r.length % 4 !== 0; )
    r = r + "=";
  return r;
}
function gV(r) {
  return r.trim ? r.trim() : r.replace(/^\s+|\s+$/g, "");
}
function mV(r) {
  return r < 16 ? "0" + r.toString(16) : r.toString(16);
}
function _d(r, e) {
  e = e || 1 / 0;
  for (var t, n = r.length, i = null, a = [], o = 0; o < n; ++o) {
    if (t = r.charCodeAt(o), t > 55295 && t < 57344) {
      if (!i) {
        if (t > 56319) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        } else if (o + 1 === n) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        i = t;
        continue;
      }
      if (t < 56320) {
        (e -= 3) > -1 && a.push(239, 191, 189), i = t;
        continue;
      }
      t = (i - 55296 << 10 | t - 56320) + 65536;
    } else i && (e -= 3) > -1 && a.push(239, 191, 189);
    if (i = null, t < 128) {
      if ((e -= 1) < 0) break;
      a.push(t);
    } else if (t < 2048) {
      if ((e -= 2) < 0) break;
      a.push(
        t >> 6 | 192,
        t & 63 | 128
      );
    } else if (t < 65536) {
      if ((e -= 3) < 0) break;
      a.push(
        t >> 12 | 224,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else if (t < 1114112) {
      if ((e -= 4) < 0) break;
      a.push(
        t >> 18 | 240,
        t >> 12 & 63 | 128,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return a;
}
function yV(r) {
  for (var e = [], t = 0; t < r.length; ++t)
    e.push(r.charCodeAt(t) & 255);
  return e;
}
function bV(r, e) {
  for (var t, n, i, a = [], o = 0; o < r.length && !((e -= 2) < 0); ++o)
    t = r.charCodeAt(o), n = t >> 8, i = t % 256, a.push(i), a.push(n);
  return a;
}
function vE(r) {
  return HG(vV(r));
}
function b5(r, e, t, n) {
  for (var i = 0; i < n && !(i + t >= e.length || i >= r.length); ++i)
    e[i + t] = r[i];
  return i;
}
function wV(r) {
  return r !== r;
}
function AV(r) {
  return r != null && (!!r._isBuffer || gE(r) || xV(r));
}
function gE(r) {
  return !!r.constructor && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
function xV(r) {
  return typeof r.readFloatLE == "function" && typeof r.slice == "function" && gE(r.slice(0, 0));
}
var wl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function EV(r) {
  if (r.__esModule) return r;
  var e = Object.defineProperty({}, "__esModule", { value: !0 });
  return Object.keys(r).forEach(function(t) {
    var n = Object.getOwnPropertyDescriptor(r, t);
    Object.defineProperty(e, t, n.get ? n : {
      enumerable: !0,
      get: function() {
        return r[t];
      }
    });
  }), e;
}
var Dd = { exports: {} }, lf = {};
function mE() {
  throw new Error("setTimeout has not been defined");
}
function yE() {
  throw new Error("clearTimeout has not been defined");
}
var Is = mE, Ps = yE;
typeof P1.setTimeout == "function" && (Is = setTimeout);
typeof P1.clearTimeout == "function" && (Ps = clearTimeout);
function bE(r) {
  if (Is === setTimeout)
    return setTimeout(r, 0);
  if ((Is === mE || !Is) && setTimeout)
    return Is = setTimeout, setTimeout(r, 0);
  try {
    return Is(r, 0);
  } catch {
    try {
      return Is.call(null, r, 0);
    } catch {
      return Is.call(this, r, 0);
    }
  }
}
function _V(r) {
  if (Ps === clearTimeout)
    return clearTimeout(r);
  if ((Ps === yE || !Ps) && clearTimeout)
    return Ps = clearTimeout, clearTimeout(r);
  try {
    return Ps(r);
  } catch {
    try {
      return Ps.call(null, r);
    } catch {
      return Ps.call(this, r);
    }
  }
}
var Ko = [], Nc = !1, al, Uh = -1;
function DV() {
  !Nc || !al || (Nc = !1, al.length ? Ko = al.concat(Ko) : Uh = -1, Ko.length && wE());
}
function wE() {
  if (!Nc) {
    var r = bE(DV);
    Nc = !0;
    for (var e = Ko.length; e; ) {
      for (al = Ko, Ko = []; ++Uh < e; )
        al && al[Uh].run();
      Uh = -1, e = Ko.length;
    }
    al = null, Nc = !1, _V(r);
  }
}
function TV(r) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      e[t - 1] = arguments[t];
  Ko.push(new AE(r, e)), Ko.length === 1 && !Nc && bE(wE);
}
function AE(r, e) {
  this.fun = r, this.array = e;
}
AE.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var kV = "browser", SV = "browser", CV = !0, FV = {}, OV = [], RV = "", IV = {}, PV = {}, BV = {};
function Fl() {
}
var NV = Fl, LV = Fl, MV = Fl, UV = Fl, $V = Fl, zV = Fl, jV = Fl;
function WV(r) {
  throw new Error("process.binding is not supported");
}
function GV() {
  return "/";
}
function VV(r) {
  throw new Error("process.chdir is not supported");
}
function YV() {
  return 0;
}
var mc = P1.performance || {}, HV = mc.now || mc.mozNow || mc.msNow || mc.oNow || mc.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function ZV(r) {
  var e = HV.call(mc) * 1e-3, t = Math.floor(e), n = Math.floor(e % 1 * 1e9);
  return r && (t = t - r[0], n = n - r[1], n < 0 && (t--, n += 1e9)), [t, n];
}
var qV = /* @__PURE__ */ new Date();
function XV() {
  var r = /* @__PURE__ */ new Date(), e = r - qV;
  return e / 1e3;
}
var ir = {
  nextTick: TV,
  title: kV,
  browser: CV,
  env: FV,
  argv: OV,
  version: RV,
  versions: IV,
  on: NV,
  addListener: LV,
  once: MV,
  off: UV,
  removeListener: $V,
  removeAllListeners: zV,
  emit: jV,
  binding: WV,
  cwd: GV,
  chdir: VV,
  umask: YV,
  hrtime: ZV,
  platform: SV,
  release: PV,
  config: BV,
  uptime: XV
}, w5 = { exports: {} }, Lc = typeof Reflect == "object" ? Reflect : null, L6 = Lc && typeof Lc.apply == "function" ? Lc.apply : function(e, t, n) {
  return Function.prototype.apply.call(e, t, n);
}, $h;
Lc && typeof Lc.ownKeys == "function" ? $h = Lc.ownKeys : Object.getOwnPropertySymbols ? $h = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : $h = function(e) {
  return Object.getOwnPropertyNames(e);
};
function KV(r) {
  console && console.warn && console.warn(r);
}
var xE = Number.isNaN || function(e) {
  return e !== e;
};
function Qr() {
  Qr.init.call(this);
}
w5.exports = Qr;
w5.exports.once = tY;
Qr.EventEmitter = Qr;
Qr.prototype._events = void 0;
Qr.prototype._eventsCount = 0;
Qr.prototype._maxListeners = void 0;
var M6 = 10;
function A5(r) {
  if (typeof r != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
}
Object.defineProperty(Qr, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return M6;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || xE(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    M6 = e;
  }
});
Qr.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Qr.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || xE(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function EE(r) {
  return r._maxListeners === void 0 ? Qr.defaultMaxListeners : r._maxListeners;
}
Qr.prototype.getMaxListeners = function() {
  return EE(this);
};
Qr.prototype.emit = function(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
  var i = e === "error", a = this._events;
  if (a !== void 0) i = i && a.error === void 0;
  else if (!i) return !1;
  if (i) {
    var o;
    if (t.length > 0 && (o = t[0]), o instanceof Error)
      throw o;
    var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw s.context = o, s;
  }
  var c = a[e];
  if (c === void 0) return !1;
  if (typeof c == "function")
    L6(c, this, t);
  else
    for (var h = c.length, d = SE(c, h), n = 0; n < h; ++n) L6(d[n], this, t);
  return !0;
};
function _E(r, e, t, n) {
  var i, a, o;
  if (A5(t), a = r._events, a === void 0 ? (a = r._events = /* @__PURE__ */ Object.create(null), r._eventsCount = 0) : (a.newListener !== void 0 && (r.emit("newListener", e, t.listener ? t.listener : t), a = r._events), o = a[e]), o === void 0)
    o = a[e] = t, ++r._eventsCount;
  else if (typeof o == "function" ? o = a[e] = n ? [t, o] : [o, t] : n ? o.unshift(t) : o.push(t), i = EE(r), i > 0 && o.length > i && !o.warned) {
    o.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = r, s.type = e, s.count = o.length, KV(s);
  }
  return r;
}
Qr.prototype.addListener = function(e, t) {
  return _E(this, e, t, !1);
};
Qr.prototype.on = Qr.prototype.addListener;
Qr.prototype.prependListener = function(e, t) {
  return _E(this, e, t, !0);
};
function JV() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function DE(r, e, t) {
  var n = {
    fired: !1,
    wrapFn: void 0,
    target: r,
    type: e,
    listener: t
  }, i = JV.bind(n);
  return i.listener = t, n.wrapFn = i, i;
}
Qr.prototype.once = function(e, t) {
  return A5(t), this.on(e, DE(this, e, t)), this;
};
Qr.prototype.prependOnceListener = function(e, t) {
  return A5(t), this.prependListener(e, DE(this, e, t)), this;
};
Qr.prototype.removeListener = function(e, t) {
  var n, i, a, o, s;
  if (A5(t), i = this._events, i === void 0) return this;
  if (n = i[e], n === void 0) return this;
  if (n === t || n.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || t));
  else if (typeof n != "function") {
    for (a = -1, o = n.length - 1; o >= 0; o--)
      if (n[o] === t || n[o].listener === t) {
        s = n[o].listener, a = o;
        break;
      }
    if (a < 0) return this;
    a === 0 ? n.shift() : QV(n, a), n.length === 1 && (i[e] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", e, s || t);
  }
  return this;
};
Qr.prototype.off = Qr.prototype.removeListener;
Qr.prototype.removeAllListeners = function(e) {
  var t, n, i;
  if (n = this._events, n === void 0) return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var a = Object.keys(n), o;
    for (i = 0; i < a.length; ++i)
      o = a[i], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = n[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (i = t.length - 1; i >= 0; i--)
      this.removeListener(e, t[i]);
  return this;
};
function TE(r, e, t) {
  var n = r._events;
  if (n === void 0) return [];
  var i = n[e];
  return i === void 0 ? [] : typeof i == "function" ? t ? [i.listener || i] : [i] : t ? eY(i) : SE(i, i.length);
}
Qr.prototype.listeners = function(e) {
  return TE(this, e, !0);
};
Qr.prototype.rawListeners = function(e) {
  return TE(this, e, !1);
};
Qr.listenerCount = function(r, e) {
  return typeof r.listenerCount == "function" ? r.listenerCount(e) : kE.call(r, e);
};
Qr.prototype.listenerCount = kE;
function kE(r) {
  var e = this._events;
  if (e !== void 0) {
    var t = e[r];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
Qr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? $h(this._events) : [];
};
function SE(r, e) {
  for (var t = new Array(e), n = 0; n < e; ++n) t[n] = r[n];
  return t;
}
function QV(r, e) {
  for (; e + 1 < r.length; e++) r[e] = r[e + 1];
  r.pop();
}
function eY(r) {
  for (var e = new Array(r.length), t = 0; t < e.length; ++t)
    e[t] = r[t].listener || r[t];
  return e;
}
function tY(r, e) {
  return new Promise(function(t, n) {
    function i(o) {
      r.removeListener(e, a), n(o);
    }
    function a() {
      typeof r.removeListener == "function" && r.removeListener("error", i), t([].slice.call(arguments));
    }
    CE(r, e, a, {
      once: !0
    }), e !== "error" && rY(r, i, {
      once: !0
    });
  });
}
function rY(r, e, t) {
  typeof r.on == "function" && CE(r, "error", e, t);
}
function CE(r, e, t, n) {
  if (typeof r.on == "function")
    n.once ? r.once(e, t) : r.on(e, t);
  else if (typeof r.addEventListener == "function")
    r.addEventListener(e, function i(a) {
      n.once && r.removeEventListener(e, i), t(a);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof r);
}
var FE = w5.exports.EventEmitter, Al = {}, x5 = {};
x5.byteLength = aY;
x5.toByteArray = sY;
x5.fromByteArray = cY;
var lo = [], Qi = [], nY = typeof Uint8Array < "u" ? Uint8Array : Array, t4 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var uc = 0, iY = t4.length; uc < iY; ++uc)
  lo[uc] = t4[uc], Qi[t4.charCodeAt(uc)] = uc;
Qi[45] = 62;
Qi[95] = 63;
function OE(r) {
  var e = r.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var t = r.indexOf("=");
  t === -1 && (t = e);
  var n = t === e ? 0 : 4 - t % 4;
  return [t, n];
}
function aY(r) {
  var e = OE(r), t = e[0], n = e[1];
  return (t + n) * 3 / 4 - n;
}
function oY(r, e, t) {
  return (e + t) * 3 / 4 - t;
}
function sY(r) {
  var e, t = OE(r), n = t[0], i = t[1], a = new nY(oY(r, n, i)), o = 0, s = i > 0 ? n - 4 : n, c;
  for (c = 0; c < s; c += 4)
    e = Qi[r.charCodeAt(c)] << 18 | Qi[r.charCodeAt(c + 1)] << 12 | Qi[r.charCodeAt(c + 2)] << 6 | Qi[r.charCodeAt(c + 3)], a[o++] = e >> 16 & 255, a[o++] = e >> 8 & 255, a[o++] = e & 255;
  return i === 2 && (e = Qi[r.charCodeAt(c)] << 2 | Qi[r.charCodeAt(c + 1)] >> 4, a[o++] = e & 255), i === 1 && (e = Qi[r.charCodeAt(c)] << 10 | Qi[r.charCodeAt(c + 1)] << 4 | Qi[r.charCodeAt(c + 2)] >> 2, a[o++] = e >> 8 & 255, a[o++] = e & 255), a;
}
function uY(r) {
  return lo[r >> 18 & 63] + lo[r >> 12 & 63] + lo[r >> 6 & 63] + lo[r & 63];
}
function lY(r, e, t) {
  for (var n, i = [], a = e; a < t; a += 3)
    n = (r[a] << 16 & 16711680) + (r[a + 1] << 8 & 65280) + (r[a + 2] & 255), i.push(uY(n));
  return i.join("");
}
function cY(r) {
  for (var e, t = r.length, n = t % 3, i = [], a = 16383, o = 0, s = t - n; o < s; o += a)
    i.push(lY(r, o, o + a > s ? s : o + a));
  return n === 1 ? (e = r[t - 1], i.push(lo[e >> 2] + lo[e << 4 & 63] + "==")) : n === 2 && (e = (r[t - 2] << 8) + r[t - 1], i.push(lo[e >> 10] + lo[e >> 4 & 63] + lo[e << 2 & 63] + "=")), i.join("");
}
var fg = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
fg.read = function(r, e, t, n, i) {
  var a, o, s = i * 8 - n - 1, c = (1 << s) - 1, h = c >> 1, d = -7, g = t ? i - 1 : 0, x = t ? -1 : 1, _ = r[e + g];
  for (g += x, a = _ & (1 << -d) - 1, _ >>= -d, d += s; d > 0; a = a * 256 + r[e + g], g += x, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += n; d > 0; o = o * 256 + r[e + g], g += x, d -= 8)
    ;
  if (a === 0)
    a = 1 - h;
  else {
    if (a === c)
      return o ? NaN : (_ ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), a = a - h;
  }
  return (_ ? -1 : 1) * o * Math.pow(2, a - n);
};
fg.write = function(r, e, t, n, i, a) {
  var o, s, c, h = a * 8 - i - 1, d = (1 << h) - 1, g = d >> 1, x = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, _ = n ? 0 : a - 1, k = n ? 1 : -1, P = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + g >= 1 ? e += x / c : e += x * Math.pow(2, 1 - g), e * c >= 2 && (o++, c /= 2), o + g >= d ? (s = 0, o = d) : o + g >= 1 ? (s = (e * c - 1) * Math.pow(2, i), o = o + g) : (s = e * Math.pow(2, g - 1) * Math.pow(2, i), o = 0)); i >= 8; r[t + _] = s & 255, _ += k, s /= 256, i -= 8)
    ;
  for (o = o << i | s, h += i; h > 0; r[t + _] = o & 255, _ += k, o /= 256, h -= 8)
    ;
  r[t + _ - k] |= P * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(r) {
  var e = x5, t = fg, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  r.Buffer = s, r.SlowBuffer = G, r.INSPECT_MAX_BYTES = 50;
  var i = 2147483647;
  r.kMaxLength = i, s.TYPED_ARRAY_SUPPORT = a(), !s.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
  function a() {
    try {
      var S = new Uint8Array(1), b = {
        foo: function() {
          return 42;
        }
      };
      return Object.setPrototypeOf(b, Uint8Array.prototype), Object.setPrototypeOf(S, b), S.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(s.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(s.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(S) {
    if (S > i)
      throw new RangeError('The value "' + S + '" is invalid for option "size"');
    var b = new Uint8Array(S);
    return Object.setPrototypeOf(b, s.prototype), b;
  }
  function s(S, b, w) {
    if (typeof S == "number") {
      if (typeof b == "string")
        throw new TypeError('The "string" argument must be of type string. Received type number');
      return g(S);
    }
    return c(S, b, w);
  }
  s.poolSize = 8192;
  function c(S, b, w) {
    if (typeof S == "string")
      return x(S, b);
    if (ArrayBuffer.isView(S))
      return k(S);
    if (S == null)
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof S);
    if (ct(S, ArrayBuffer) || S && ct(S.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ct(S, SharedArrayBuffer) || S && ct(S.buffer, SharedArrayBuffer)))
      return P(S, b, w);
    if (typeof S == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    var T = S.valueOf && S.valueOf();
    if (T != null && T !== S)
      return s.from(T, b, w);
    var V = N(S);
    if (V) return V;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof S[Symbol.toPrimitive] == "function")
      return s.from(S[Symbol.toPrimitive]("string"), b, w);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof S);
  }
  s.from = function(S, b, w) {
    return c(S, b, w);
  }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
  function h(S) {
    if (typeof S != "number")
      throw new TypeError('"size" argument must be of type number');
    if (S < 0)
      throw new RangeError('The value "' + S + '" is invalid for option "size"');
  }
  function d(S, b, w) {
    return h(S), S <= 0 ? o(S) : b !== void 0 ? typeof w == "string" ? o(S).fill(b, w) : o(S).fill(b) : o(S);
  }
  s.alloc = function(S, b, w) {
    return d(S, b, w);
  };
  function g(S) {
    return h(S), o(S < 0 ? 0 : M(S) | 0);
  }
  s.allocUnsafe = function(S) {
    return g(S);
  }, s.allocUnsafeSlow = function(S) {
    return g(S);
  };
  function x(S, b) {
    if ((typeof b != "string" || b === "") && (b = "utf8"), !s.isEncoding(b))
      throw new TypeError("Unknown encoding: " + b);
    var w = z(S, b) | 0, T = o(w), V = T.write(S, b);
    return V !== w && (T = T.slice(0, V)), T;
  }
  function _(S) {
    for (var b = S.length < 0 ? 0 : M(S.length) | 0, w = o(b), T = 0; T < b; T += 1)
      w[T] = S[T] & 255;
    return w;
  }
  function k(S) {
    if (ct(S, Uint8Array)) {
      var b = new Uint8Array(S);
      return P(b.buffer, b.byteOffset, b.byteLength);
    }
    return _(S);
  }
  function P(S, b, w) {
    if (b < 0 || S.byteLength < b)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (S.byteLength < b + (w || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    var T;
    return b === void 0 && w === void 0 ? T = new Uint8Array(S) : w === void 0 ? T = new Uint8Array(S, b) : T = new Uint8Array(S, b, w), Object.setPrototypeOf(T, s.prototype), T;
  }
  function N(S) {
    if (s.isBuffer(S)) {
      var b = M(S.length) | 0, w = o(b);
      return w.length === 0 || S.copy(w, 0, 0, b), w;
    }
    if (S.length !== void 0)
      return typeof S.length != "number" || pt(S.length) ? o(0) : _(S);
    if (S.type === "Buffer" && Array.isArray(S.data))
      return _(S.data);
  }
  function M(S) {
    if (S >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return S | 0;
  }
  function G(S) {
    return +S != S && (S = 0), s.alloc(+S);
  }
  s.isBuffer = function(b) {
    return b != null && b._isBuffer === !0 && b !== s.prototype;
  }, s.compare = function(b, w) {
    if (ct(b, Uint8Array) && (b = s.from(b, b.offset, b.byteLength)), ct(w, Uint8Array) && (w = s.from(w, w.offset, w.byteLength)), !s.isBuffer(b) || !s.isBuffer(w))
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (b === w) return 0;
    for (var T = b.length, V = w.length, pe = 0, Ee = Math.min(T, V); pe < Ee; ++pe)
      if (b[pe] !== w[pe]) {
        T = b[pe], V = w[pe];
        break;
      }
    return T < V ? -1 : V < T ? 1 : 0;
  }, s.isEncoding = function(b) {
    switch (String(b).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, s.concat = function(b, w) {
    if (!Array.isArray(b))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (b.length === 0)
      return s.alloc(0);
    var T;
    if (w === void 0)
      for (w = 0, T = 0; T < b.length; ++T)
        w += b[T].length;
    var V = s.allocUnsafe(w), pe = 0;
    for (T = 0; T < b.length; ++T) {
      var Ee = b[T];
      if (ct(Ee, Uint8Array))
        pe + Ee.length > V.length ? s.from(Ee).copy(V, pe) : Uint8Array.prototype.set.call(V, Ee, pe);
      else if (s.isBuffer(Ee))
        Ee.copy(V, pe);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      pe += Ee.length;
    }
    return V;
  };
  function z(S, b) {
    if (s.isBuffer(S))
      return S.length;
    if (ArrayBuffer.isView(S) || ct(S, ArrayBuffer))
      return S.byteLength;
    if (typeof S != "string")
      throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof S);
    var w = S.length, T = arguments.length > 2 && arguments[2] === !0;
    if (!T && w === 0) return 0;
    for (var V = !1; ; )
      switch (b) {
        case "ascii":
        case "latin1":
        case "binary":
          return w;
        case "utf8":
        case "utf-8":
          return be(S).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return w * 2;
        case "hex":
          return w >>> 1;
        case "base64":
          return De(S).length;
        default:
          if (V)
            return T ? -1 : be(S).length;
          b = ("" + b).toLowerCase(), V = !0;
      }
  }
  s.byteLength = z;
  function j(S, b, w) {
    var T = !1;
    if ((b === void 0 || b < 0) && (b = 0), b > this.length || ((w === void 0 || w > this.length) && (w = this.length), w <= 0) || (w >>>= 0, b >>>= 0, w <= b))
      return "";
    for (S || (S = "utf8"); ; )
      switch (S) {
        case "hex":
          return _e(this, b, w);
        case "utf8":
        case "utf-8":
          return H(this, b, w);
        case "ascii":
          return me(this, b, w);
        case "latin1":
        case "binary":
          return fe(this, b, w);
        case "base64":
          return q(this, b, w);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Re(this, b, w);
        default:
          if (T) throw new TypeError("Unknown encoding: " + S);
          S = (S + "").toLowerCase(), T = !0;
      }
  }
  s.prototype._isBuffer = !0;
  function R(S, b, w) {
    var T = S[b];
    S[b] = S[w], S[w] = T;
  }
  s.prototype.swap16 = function() {
    var b = this.length;
    if (b % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var w = 0; w < b; w += 2)
      R(this, w, w + 1);
    return this;
  }, s.prototype.swap32 = function() {
    var b = this.length;
    if (b % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var w = 0; w < b; w += 4)
      R(this, w, w + 3), R(this, w + 1, w + 2);
    return this;
  }, s.prototype.swap64 = function() {
    var b = this.length;
    if (b % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var w = 0; w < b; w += 8)
      R(this, w, w + 7), R(this, w + 1, w + 6), R(this, w + 2, w + 5), R(this, w + 3, w + 4);
    return this;
  }, s.prototype.toString = function() {
    var b = this.length;
    return b === 0 ? "" : arguments.length === 0 ? H(this, 0, b) : j.apply(this, arguments);
  }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(b) {
    if (!s.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    return this === b ? !0 : s.compare(this, b) === 0;
  }, s.prototype.inspect = function() {
    var b = "", w = r.INSPECT_MAX_BYTES;
    return b = this.toString("hex", 0, w).replace(/(.{2})/g, "$1 ").trim(), this.length > w && (b += " ... "), "<Buffer " + b + ">";
  }, n && (s.prototype[n] = s.prototype.inspect), s.prototype.compare = function(b, w, T, V, pe) {
    if (ct(b, Uint8Array) && (b = s.from(b, b.offset, b.byteLength)), !s.isBuffer(b))
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof b);
    if (w === void 0 && (w = 0), T === void 0 && (T = b ? b.length : 0), V === void 0 && (V = 0), pe === void 0 && (pe = this.length), w < 0 || T > b.length || V < 0 || pe > this.length)
      throw new RangeError("out of range index");
    if (V >= pe && w >= T)
      return 0;
    if (V >= pe)
      return -1;
    if (w >= T)
      return 1;
    if (w >>>= 0, T >>>= 0, V >>>= 0, pe >>>= 0, this === b) return 0;
    for (var Ee = pe - V, mt = T - w, gt = Math.min(Ee, mt), St = this.slice(V, pe), Bt = b.slice(w, T), yt = 0; yt < gt; ++yt)
      if (St[yt] !== Bt[yt]) {
        Ee = St[yt], mt = Bt[yt];
        break;
      }
    return Ee < mt ? -1 : mt < Ee ? 1 : 0;
  };
  function te(S, b, w, T, V) {
    if (S.length === 0) return -1;
    if (typeof w == "string" ? (T = w, w = 0) : w > 2147483647 ? w = 2147483647 : w < -2147483648 && (w = -2147483648), w = +w, pt(w) && (w = V ? 0 : S.length - 1), w < 0 && (w = S.length + w), w >= S.length) {
      if (V) return -1;
      w = S.length - 1;
    } else if (w < 0)
      if (V) w = 0;
      else return -1;
    if (typeof b == "string" && (b = s.from(b, T)), s.isBuffer(b))
      return b.length === 0 ? -1 : J(S, b, w, T, V);
    if (typeof b == "number")
      return b = b & 255, typeof Uint8Array.prototype.indexOf == "function" ? V ? Uint8Array.prototype.indexOf.call(S, b, w) : Uint8Array.prototype.lastIndexOf.call(S, b, w) : J(S, [b], w, T, V);
    throw new TypeError("val must be string, number or Buffer");
  }
  function J(S, b, w, T, V) {
    var pe = 1, Ee = S.length, mt = b.length;
    if (T !== void 0 && (T = String(T).toLowerCase(), T === "ucs2" || T === "ucs-2" || T === "utf16le" || T === "utf-16le")) {
      if (S.length < 2 || b.length < 2)
        return -1;
      pe = 2, Ee /= 2, mt /= 2, w /= 2;
    }
    function gt(E0, Er) {
      return pe === 1 ? E0[Er] : E0.readUInt16BE(Er * pe);
    }
    var St;
    if (V) {
      var Bt = -1;
      for (St = w; St < Ee; St++)
        if (gt(S, St) === gt(b, Bt === -1 ? 0 : St - Bt)) {
          if (Bt === -1 && (Bt = St), St - Bt + 1 === mt) return Bt * pe;
        } else
          Bt !== -1 && (St -= St - Bt), Bt = -1;
    } else
      for (w + mt > Ee && (w = Ee - mt), St = w; St >= 0; St--) {
        for (var yt = !0, P0 = 0; P0 < mt; P0++)
          if (gt(S, St + P0) !== gt(b, P0)) {
            yt = !1;
            break;
          }
        if (yt) return St;
      }
    return -1;
  }
  s.prototype.includes = function(b, w, T) {
    return this.indexOf(b, w, T) !== -1;
  }, s.prototype.indexOf = function(b, w, T) {
    return te(this, b, w, T, !0);
  }, s.prototype.lastIndexOf = function(b, w, T) {
    return te(this, b, w, T, !1);
  };
  function K(S, b, w, T) {
    w = Number(w) || 0;
    var V = S.length - w;
    T ? (T = Number(T), T > V && (T = V)) : T = V;
    var pe = b.length;
    T > pe / 2 && (T = pe / 2);
    for (var Ee = 0; Ee < T; ++Ee) {
      var mt = parseInt(b.substr(Ee * 2, 2), 16);
      if (pt(mt)) return Ee;
      S[w + Ee] = mt;
    }
    return Ee;
  }
  function ee(S, b, w, T) {
    return Qe(be(b, S.length - w), S, w, T);
  }
  function ve(S, b, w, T) {
    return Qe(he(b), S, w, T);
  }
  function de(S, b, w, T) {
    return Qe(De(b), S, w, T);
  }
  function B(S, b, w, T) {
    return Qe(ke(b, S.length - w), S, w, T);
  }
  s.prototype.write = function(b, w, T, V) {
    if (w === void 0)
      V = "utf8", T = this.length, w = 0;
    else if (T === void 0 && typeof w == "string")
      V = w, T = this.length, w = 0;
    else if (isFinite(w))
      w = w >>> 0, isFinite(T) ? (T = T >>> 0, V === void 0 && (V = "utf8")) : (V = T, T = void 0);
    else
      throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var pe = this.length - w;
    if ((T === void 0 || T > pe) && (T = pe), b.length > 0 && (T < 0 || w < 0) || w > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    V || (V = "utf8");
    for (var Ee = !1; ; )
      switch (V) {
        case "hex":
          return K(this, b, w, T);
        case "utf8":
        case "utf-8":
          return ee(this, b, w, T);
        case "ascii":
        case "latin1":
        case "binary":
          return ve(this, b, w, T);
        case "base64":
          return de(this, b, w, T);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return B(this, b, w, T);
        default:
          if (Ee) throw new TypeError("Unknown encoding: " + V);
          V = ("" + V).toLowerCase(), Ee = !0;
      }
  }, s.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function q(S, b, w) {
    return b === 0 && w === S.length ? e.fromByteArray(S) : e.fromByteArray(S.slice(b, w));
  }
  function H(S, b, w) {
    w = Math.min(S.length, w);
    for (var T = [], V = b; V < w; ) {
      var pe = S[V], Ee = null, mt = pe > 239 ? 4 : pe > 223 ? 3 : pe > 191 ? 2 : 1;
      if (V + mt <= w) {
        var gt, St, Bt, yt;
        switch (mt) {
          case 1:
            pe < 128 && (Ee = pe);
            break;
          case 2:
            gt = S[V + 1], (gt & 192) === 128 && (yt = (pe & 31) << 6 | gt & 63, yt > 127 && (Ee = yt));
            break;
          case 3:
            gt = S[V + 1], St = S[V + 2], (gt & 192) === 128 && (St & 192) === 128 && (yt = (pe & 15) << 12 | (gt & 63) << 6 | St & 63, yt > 2047 && (yt < 55296 || yt > 57343) && (Ee = yt));
            break;
          case 4:
            gt = S[V + 1], St = S[V + 2], Bt = S[V + 3], (gt & 192) === 128 && (St & 192) === 128 && (Bt & 192) === 128 && (yt = (pe & 15) << 18 | (gt & 63) << 12 | (St & 63) << 6 | Bt & 63, yt > 65535 && yt < 1114112 && (Ee = yt));
        }
      }
      Ee === null ? (Ee = 65533, mt = 1) : Ee > 65535 && (Ee -= 65536, T.push(Ee >>> 10 & 1023 | 55296), Ee = 56320 | Ee & 1023), T.push(Ee), V += mt;
    }
    return ne(T);
  }
  var oe = 4096;
  function ne(S) {
    var b = S.length;
    if (b <= oe)
      return String.fromCharCode.apply(String, S);
    for (var w = "", T = 0; T < b; )
      w += String.fromCharCode.apply(String, S.slice(T, T += oe));
    return w;
  }
  function me(S, b, w) {
    var T = "";
    w = Math.min(S.length, w);
    for (var V = b; V < w; ++V)
      T += String.fromCharCode(S[V] & 127);
    return T;
  }
  function fe(S, b, w) {
    var T = "";
    w = Math.min(S.length, w);
    for (var V = b; V < w; ++V)
      T += String.fromCharCode(S[V]);
    return T;
  }
  function _e(S, b, w) {
    var T = S.length;
    (!b || b < 0) && (b = 0), (!w || w < 0 || w > T) && (w = T);
    for (var V = "", pe = b; pe < w; ++pe)
      V += _t[S[pe]];
    return V;
  }
  function Re(S, b, w) {
    for (var T = S.slice(b, w), V = "", pe = 0; pe < T.length - 1; pe += 2)
      V += String.fromCharCode(T[pe] + T[pe + 1] * 256);
    return V;
  }
  s.prototype.slice = function(b, w) {
    var T = this.length;
    b = ~~b, w = w === void 0 ? T : ~~w, b < 0 ? (b += T, b < 0 && (b = 0)) : b > T && (b = T), w < 0 ? (w += T, w < 0 && (w = 0)) : w > T && (w = T), w < b && (w = b);
    var V = this.subarray(b, w);
    return Object.setPrototypeOf(V, s.prototype), V;
  };
  function Ie(S, b, w) {
    if (S % 1 !== 0 || S < 0) throw new RangeError("offset is not uint");
    if (S + b > w) throw new RangeError("Trying to access beyond buffer length");
  }
  s.prototype.readUintLE = s.prototype.readUIntLE = function(b, w, T) {
    b = b >>> 0, w = w >>> 0, T || Ie(b, w, this.length);
    for (var V = this[b], pe = 1, Ee = 0; ++Ee < w && (pe *= 256); )
      V += this[b + Ee] * pe;
    return V;
  }, s.prototype.readUintBE = s.prototype.readUIntBE = function(b, w, T) {
    b = b >>> 0, w = w >>> 0, T || Ie(b, w, this.length);
    for (var V = this[b + --w], pe = 1; w > 0 && (pe *= 256); )
      V += this[b + --w] * pe;
    return V;
  }, s.prototype.readUint8 = s.prototype.readUInt8 = function(b, w) {
    return b = b >>> 0, w || Ie(b, 1, this.length), this[b];
  }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 2, this.length), this[b] | this[b + 1] << 8;
  }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 2, this.length), this[b] << 8 | this[b + 1];
  }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), (this[b] | this[b + 1] << 8 | this[b + 2] << 16) + this[b + 3] * 16777216;
  }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), this[b] * 16777216 + (this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3]);
  }, s.prototype.readIntLE = function(b, w, T) {
    b = b >>> 0, w = w >>> 0, T || Ie(b, w, this.length);
    for (var V = this[b], pe = 1, Ee = 0; ++Ee < w && (pe *= 256); )
      V += this[b + Ee] * pe;
    return pe *= 128, V >= pe && (V -= Math.pow(2, 8 * w)), V;
  }, s.prototype.readIntBE = function(b, w, T) {
    b = b >>> 0, w = w >>> 0, T || Ie(b, w, this.length);
    for (var V = w, pe = 1, Ee = this[b + --V]; V > 0 && (pe *= 256); )
      Ee += this[b + --V] * pe;
    return pe *= 128, Ee >= pe && (Ee -= Math.pow(2, 8 * w)), Ee;
  }, s.prototype.readInt8 = function(b, w) {
    return b = b >>> 0, w || Ie(b, 1, this.length), this[b] & 128 ? (255 - this[b] + 1) * -1 : this[b];
  }, s.prototype.readInt16LE = function(b, w) {
    b = b >>> 0, w || Ie(b, 2, this.length);
    var T = this[b] | this[b + 1] << 8;
    return T & 32768 ? T | 4294901760 : T;
  }, s.prototype.readInt16BE = function(b, w) {
    b = b >>> 0, w || Ie(b, 2, this.length);
    var T = this[b + 1] | this[b] << 8;
    return T & 32768 ? T | 4294901760 : T;
  }, s.prototype.readInt32LE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), this[b] | this[b + 1] << 8 | this[b + 2] << 16 | this[b + 3] << 24;
  }, s.prototype.readInt32BE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), this[b] << 24 | this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3];
  }, s.prototype.readFloatLE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), t.read(this, b, !0, 23, 4);
  }, s.prototype.readFloatBE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 4, this.length), t.read(this, b, !1, 23, 4);
  }, s.prototype.readDoubleLE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 8, this.length), t.read(this, b, !0, 52, 8);
  }, s.prototype.readDoubleBE = function(b, w) {
    return b = b >>> 0, w || Ie(b, 8, this.length), t.read(this, b, !1, 52, 8);
  };
  function W(S, b, w, T, V, pe) {
    if (!s.isBuffer(S)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (b > V || b < pe) throw new RangeError('"value" argument is out of bounds');
    if (w + T > S.length) throw new RangeError("Index out of range");
  }
  s.prototype.writeUintLE = s.prototype.writeUIntLE = function(b, w, T, V) {
    if (b = +b, w = w >>> 0, T = T >>> 0, !V) {
      var pe = Math.pow(2, 8 * T) - 1;
      W(this, b, w, T, pe, 0);
    }
    var Ee = 1, mt = 0;
    for (this[w] = b & 255; ++mt < T && (Ee *= 256); )
      this[w + mt] = b / Ee & 255;
    return w + T;
  }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(b, w, T, V) {
    if (b = +b, w = w >>> 0, T = T >>> 0, !V) {
      var pe = Math.pow(2, 8 * T) - 1;
      W(this, b, w, T, pe, 0);
    }
    var Ee = T - 1, mt = 1;
    for (this[w + Ee] = b & 255; --Ee >= 0 && (mt *= 256); )
      this[w + Ee] = b / mt & 255;
    return w + T;
  }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 1, 255, 0), this[w] = b & 255, w + 1;
  }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 2, 65535, 0), this[w] = b & 255, this[w + 1] = b >>> 8, w + 2;
  }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 2, 65535, 0), this[w] = b >>> 8, this[w + 1] = b & 255, w + 2;
  }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 4, 4294967295, 0), this[w + 3] = b >>> 24, this[w + 2] = b >>> 16, this[w + 1] = b >>> 8, this[w] = b & 255, w + 4;
  }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 4, 4294967295, 0), this[w] = b >>> 24, this[w + 1] = b >>> 16, this[w + 2] = b >>> 8, this[w + 3] = b & 255, w + 4;
  }, s.prototype.writeIntLE = function(b, w, T, V) {
    if (b = +b, w = w >>> 0, !V) {
      var pe = Math.pow(2, 8 * T - 1);
      W(this, b, w, T, pe - 1, -pe);
    }
    var Ee = 0, mt = 1, gt = 0;
    for (this[w] = b & 255; ++Ee < T && (mt *= 256); )
      b < 0 && gt === 0 && this[w + Ee - 1] !== 0 && (gt = 1), this[w + Ee] = (b / mt >> 0) - gt & 255;
    return w + T;
  }, s.prototype.writeIntBE = function(b, w, T, V) {
    if (b = +b, w = w >>> 0, !V) {
      var pe = Math.pow(2, 8 * T - 1);
      W(this, b, w, T, pe - 1, -pe);
    }
    var Ee = T - 1, mt = 1, gt = 0;
    for (this[w + Ee] = b & 255; --Ee >= 0 && (mt *= 256); )
      b < 0 && gt === 0 && this[w + Ee + 1] !== 0 && (gt = 1), this[w + Ee] = (b / mt >> 0) - gt & 255;
    return w + T;
  }, s.prototype.writeInt8 = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 1, 127, -128), b < 0 && (b = 255 + b + 1), this[w] = b & 255, w + 1;
  }, s.prototype.writeInt16LE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 2, 32767, -32768), this[w] = b & 255, this[w + 1] = b >>> 8, w + 2;
  }, s.prototype.writeInt16BE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 2, 32767, -32768), this[w] = b >>> 8, this[w + 1] = b & 255, w + 2;
  }, s.prototype.writeInt32LE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 4, 2147483647, -2147483648), this[w] = b & 255, this[w + 1] = b >>> 8, this[w + 2] = b >>> 16, this[w + 3] = b >>> 24, w + 4;
  }, s.prototype.writeInt32BE = function(b, w, T) {
    return b = +b, w = w >>> 0, T || W(this, b, w, 4, 2147483647, -2147483648), b < 0 && (b = 4294967295 + b + 1), this[w] = b >>> 24, this[w + 1] = b >>> 16, this[w + 2] = b >>> 8, this[w + 3] = b & 255, w + 4;
  };
  function Z(S, b, w, T, V, pe) {
    if (w + T > S.length) throw new RangeError("Index out of range");
    if (w < 0) throw new RangeError("Index out of range");
  }
  function se(S, b, w, T, V) {
    return b = +b, w = w >>> 0, V || Z(S, b, w, 4), t.write(S, b, w, T, 23, 4), w + 4;
  }
  s.prototype.writeFloatLE = function(b, w, T) {
    return se(this, b, w, !0, T);
  }, s.prototype.writeFloatBE = function(b, w, T) {
    return se(this, b, w, !1, T);
  };
  function ye(S, b, w, T, V) {
    return b = +b, w = w >>> 0, V || Z(S, b, w, 8), t.write(S, b, w, T, 52, 8), w + 8;
  }
  s.prototype.writeDoubleLE = function(b, w, T) {
    return ye(this, b, w, !0, T);
  }, s.prototype.writeDoubleBE = function(b, w, T) {
    return ye(this, b, w, !1, T);
  }, s.prototype.copy = function(b, w, T, V) {
    if (!s.isBuffer(b)) throw new TypeError("argument should be a Buffer");
    if (T || (T = 0), !V && V !== 0 && (V = this.length), w >= b.length && (w = b.length), w || (w = 0), V > 0 && V < T && (V = T), V === T || b.length === 0 || this.length === 0) return 0;
    if (w < 0)
      throw new RangeError("targetStart out of bounds");
    if (T < 0 || T >= this.length) throw new RangeError("Index out of range");
    if (V < 0) throw new RangeError("sourceEnd out of bounds");
    V > this.length && (V = this.length), b.length - w < V - T && (V = b.length - w + T);
    var pe = V - T;
    return this === b && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(w, T, V) : Uint8Array.prototype.set.call(b, this.subarray(T, V), w), pe;
  }, s.prototype.fill = function(b, w, T, V) {
    if (typeof b == "string") {
      if (typeof w == "string" ? (V = w, w = 0, T = this.length) : typeof T == "string" && (V = T, T = this.length), V !== void 0 && typeof V != "string")
        throw new TypeError("encoding must be a string");
      if (typeof V == "string" && !s.isEncoding(V))
        throw new TypeError("Unknown encoding: " + V);
      if (b.length === 1) {
        var pe = b.charCodeAt(0);
        (V === "utf8" && pe < 128 || V === "latin1") && (b = pe);
      }
    } else typeof b == "number" ? b = b & 255 : typeof b == "boolean" && (b = Number(b));
    if (w < 0 || this.length < w || this.length < T)
      throw new RangeError("Out of range index");
    if (T <= w)
      return this;
    w = w >>> 0, T = T === void 0 ? this.length : T >>> 0, b || (b = 0);
    var Ee;
    if (typeof b == "number")
      for (Ee = w; Ee < T; ++Ee)
        this[Ee] = b;
    else {
      var mt = s.isBuffer(b) ? b : s.from(b, V), gt = mt.length;
      if (gt === 0)
        throw new TypeError('The value "' + b + '" is invalid for argument "value"');
      for (Ee = 0; Ee < T - w; ++Ee)
        this[Ee + w] = mt[Ee % gt];
    }
    return this;
  };
  var Fe = /[^+/0-9A-Za-z-_]/g;
  function xe(S) {
    if (S = S.split("=")[0], S = S.trim().replace(Fe, ""), S.length < 2) return "";
    for (; S.length % 4 !== 0; )
      S = S + "=";
    return S;
  }
  function be(S, b) {
    b = b || 1 / 0;
    for (var w, T = S.length, V = null, pe = [], Ee = 0; Ee < T; ++Ee) {
      if (w = S.charCodeAt(Ee), w > 55295 && w < 57344) {
        if (!V) {
          if (w > 56319) {
            (b -= 3) > -1 && pe.push(239, 191, 189);
            continue;
          } else if (Ee + 1 === T) {
            (b -= 3) > -1 && pe.push(239, 191, 189);
            continue;
          }
          V = w;
          continue;
        }
        if (w < 56320) {
          (b -= 3) > -1 && pe.push(239, 191, 189), V = w;
          continue;
        }
        w = (V - 55296 << 10 | w - 56320) + 65536;
      } else V && (b -= 3) > -1 && pe.push(239, 191, 189);
      if (V = null, w < 128) {
        if ((b -= 1) < 0) break;
        pe.push(w);
      } else if (w < 2048) {
        if ((b -= 2) < 0) break;
        pe.push(w >> 6 | 192, w & 63 | 128);
      } else if (w < 65536) {
        if ((b -= 3) < 0) break;
        pe.push(w >> 12 | 224, w >> 6 & 63 | 128, w & 63 | 128);
      } else if (w < 1114112) {
        if ((b -= 4) < 0) break;
        pe.push(w >> 18 | 240, w >> 12 & 63 | 128, w >> 6 & 63 | 128, w & 63 | 128);
      } else
        throw new Error("Invalid code point");
    }
    return pe;
  }
  function he(S) {
    for (var b = [], w = 0; w < S.length; ++w)
      b.push(S.charCodeAt(w) & 255);
    return b;
  }
  function ke(S, b) {
    for (var w, T, V, pe = [], Ee = 0; Ee < S.length && !((b -= 2) < 0); ++Ee)
      w = S.charCodeAt(Ee), T = w >> 8, V = w % 256, pe.push(V), pe.push(T);
    return pe;
  }
  function De(S) {
    return e.toByteArray(xe(S));
  }
  function Qe(S, b, w, T) {
    for (var V = 0; V < T && !(V + w >= b.length || V >= S.length); ++V)
      b[V + w] = S[V];
    return V;
  }
  function ct(S, b) {
    return S instanceof b || S != null && S.constructor != null && S.constructor.name != null && S.constructor.name === b.name;
  }
  function pt(S) {
    return S !== S;
  }
  var _t = function() {
    for (var S = "0123456789abcdef", b = new Array(256), w = 0; w < 16; ++w)
      for (var T = w * 16, V = 0; V < 16; ++V)
        b[T + V] = S[w] + S[V];
    return b;
  }();
})(Al);
var fY = {}, hY = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: fY
}), RE = /* @__PURE__ */ EV(hY);
function U6(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function dY(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? U6(Object(t), !0).forEach(function(n) {
      pY(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : U6(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function pY(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function vY(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function gY(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function mY(r, e, t) {
  return e && gY(r.prototype, e), r;
}
var yY = Al, zh = yY.Buffer, bY = RE, N3 = bY.inspect, wY = N3 && N3.custom || "inspect";
function AY(r, e, t) {
  zh.prototype.copy.call(r, e, t);
}
var xY = /* @__PURE__ */ function() {
  function r() {
    vY(this, r), this.head = null, this.tail = null, this.length = 0;
  }
  return mY(r, [{
    key: "push",
    value: function(t) {
      var n = {
        data: t,
        next: null
      };
      this.length > 0 ? this.tail.next = n : this.head = n, this.tail = n, ++this.length;
    }
  }, {
    key: "unshift",
    value: function(t) {
      var n = {
        data: t,
        next: this.head
      };
      this.length === 0 && (this.tail = n), this.head = n, ++this.length;
    }
  }, {
    key: "shift",
    value: function() {
      if (this.length !== 0) {
        var t = this.head.data;
        return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
      }
    }
  }, {
    key: "clear",
    value: function() {
      this.head = this.tail = null, this.length = 0;
    }
  }, {
    key: "join",
    value: function(t) {
      if (this.length === 0) return "";
      for (var n = this.head, i = "" + n.data; n = n.next; )
        i += t + n.data;
      return i;
    }
  }, {
    key: "concat",
    value: function(t) {
      if (this.length === 0) return zh.alloc(0);
      for (var n = zh.allocUnsafe(t >>> 0), i = this.head, a = 0; i; )
        AY(i.data, n, a), a += i.data.length, i = i.next;
      return n;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function(t, n) {
      var i;
      return t < this.head.data.length ? (i = this.head.data.slice(0, t), this.head.data = this.head.data.slice(t)) : t === this.head.data.length ? i = this.shift() : i = n ? this._getString(t) : this._getBuffer(t), i;
    }
  }, {
    key: "first",
    value: function() {
      return this.head.data;
    }
    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function(t) {
      var n = this.head, i = 1, a = n.data;
      for (t -= a.length; n = n.next; ) {
        var o = n.data, s = t > o.length ? o.length : t;
        if (s === o.length ? a += o : a += o.slice(0, t), t -= s, t === 0) {
          s === o.length ? (++i, n.next ? this.head = n.next : this.head = this.tail = null) : (this.head = n, n.data = o.slice(s));
          break;
        }
        ++i;
      }
      return this.length -= i, a;
    }
    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function(t) {
      var n = zh.allocUnsafe(t), i = this.head, a = 1;
      for (i.data.copy(n), t -= i.data.length; i = i.next; ) {
        var o = i.data, s = t > o.length ? o.length : t;
        if (o.copy(n, n.length - t, 0, s), t -= s, t === 0) {
          s === o.length ? (++a, i.next ? this.head = i.next : this.head = this.tail = null) : (this.head = i, i.data = o.slice(s));
          break;
        }
        ++a;
      }
      return this.length -= a, n;
    }
    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: wY,
    value: function(t, n) {
      return N3(this, dY({}, n, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: !1
      }));
    }
  }]), r;
}();
function EY(r, e) {
  var t = this, n = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
  return n || i ? (e ? e(r) : r && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, ir.nextTick(L3, this, r)) : ir.nextTick(L3, this, r)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(r || null, function(a) {
    !e && a ? t._writableState ? t._writableState.errorEmitted ? ir.nextTick(jh, t) : (t._writableState.errorEmitted = !0, ir.nextTick($6, t, a)) : ir.nextTick($6, t, a) : e ? (ir.nextTick(jh, t), e(a)) : ir.nextTick(jh, t);
  }), this);
}
function $6(r, e) {
  L3(r, e), jh(r);
}
function jh(r) {
  r._writableState && !r._writableState.emitClose || r._readableState && !r._readableState.emitClose || r.emit("close");
}
function _Y() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function L3(r, e) {
  r.emit("error", e);
}
function DY(r, e) {
  var t = r._readableState, n = r._writableState;
  t && t.autoDestroy || n && n.autoDestroy ? r.destroy(e) : r.emit("error", e);
}
var IE = {
  destroy: EY,
  undestroy: _Y,
  errorOrDestroy: DY
}, Ol = {};
function TY(r, e) {
  r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.__proto__ = e;
}
var PE = {};
function ha(r, e, t) {
  t || (t = Error);
  function n(a, o, s) {
    return typeof e == "string" ? e : e(a, o, s);
  }
  var i = /* @__PURE__ */ function(a) {
    TY(o, a);
    function o(s, c, h) {
      return a.call(this, n(s, c, h)) || this;
    }
    return o;
  }(t);
  i.prototype.name = t.name, i.prototype.code = r, PE[r] = i;
}
function z6(r, e) {
  if (Array.isArray(r)) {
    var t = r.length;
    return r = r.map(function(n) {
      return String(n);
    }), t > 2 ? "one of ".concat(e, " ").concat(r.slice(0, t - 1).join(", "), ", or ") + r[t - 1] : t === 2 ? "one of ".concat(e, " ").concat(r[0], " or ").concat(r[1]) : "of ".concat(e, " ").concat(r[0]);
  } else
    return "of ".concat(e, " ").concat(String(r));
}
function kY(r, e, t) {
  return r.substr(0, e.length) === e;
}
function SY(r, e, t) {
  return (t === void 0 || t > r.length) && (t = r.length), r.substring(t - e.length, t) === e;
}
function CY(r, e, t) {
  return typeof t != "number" && (t = 0), t + e.length > r.length ? !1 : r.indexOf(e, t) !== -1;
}
ha("ERR_INVALID_OPT_VALUE", function(r, e) {
  return 'The value "' + e + '" is invalid for option "' + r + '"';
}, TypeError);
ha("ERR_INVALID_ARG_TYPE", function(r, e, t) {
  var n;
  typeof e == "string" && kY(e, "not ") ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be";
  var i;
  if (SY(r, " argument"))
    i = "The ".concat(r, " ").concat(n, " ").concat(z6(e, "type"));
  else {
    var a = CY(r, ".") ? "property" : "argument";
    i = 'The "'.concat(r, '" ').concat(a, " ").concat(n, " ").concat(z6(e, "type"));
  }
  return i += ". Received type ".concat(typeof t), i;
}, TypeError);
ha("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
ha("ERR_METHOD_NOT_IMPLEMENTED", function(r) {
  return "The " + r + " method is not implemented";
});
ha("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
ha("ERR_STREAM_DESTROYED", function(r) {
  return "Cannot call " + r + " after a stream was destroyed";
});
ha("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
ha("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
ha("ERR_STREAM_WRITE_AFTER_END", "write after end");
ha("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
ha("ERR_UNKNOWN_ENCODING", function(r) {
  return "Unknown encoding: " + r;
}, TypeError);
ha("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
Ol.codes = PE;
var FY = Ol.codes.ERR_INVALID_OPT_VALUE;
function OY(r, e, t) {
  return r.highWaterMark != null ? r.highWaterMark : e ? r[t] : null;
}
function RY(r, e, t, n) {
  var i = OY(e, n, t);
  if (i != null) {
    if (!(isFinite(i) && Math.floor(i) === i) || i < 0) {
      var a = n ? t : "highWaterMark";
      throw new FY(a, i);
    }
    return Math.floor(i);
  }
  return r.objectMode ? 16 : 16 * 1024;
}
var BE = {
  getHighWaterMark: RY
}, uu = { exports: {} };
typeof Object.create == "function" ? uu.exports = function(e, t) {
  t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : uu.exports = function(e, t) {
  if (t) {
    e.super_ = t;
    var n = function() {
    };
    n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
var hg = {}, M3 = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(r, e) {
  var t = Al, n = t.Buffer;
  function i(o, s) {
    for (var c in o)
      s[c] = o[c];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? r.exports = t : (i(t, e), e.Buffer = a);
  function a(o, s, c) {
    return n(o, s, c);
  }
  a.prototype = Object.create(n.prototype), i(n, a), a.from = function(o, s, c) {
    if (typeof o == "number")
      throw new TypeError("Argument must not be a number");
    return n(o, s, c);
  }, a.alloc = function(o, s, c) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    var h = n(o);
    return s !== void 0 ? typeof c == "string" ? h.fill(s, c) : h.fill(s) : h.fill(0), h;
  }, a.allocUnsafe = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return n(o);
  }, a.allocUnsafeSlow = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return t.SlowBuffer(o);
  };
})(M3, M3.exports);
var dg = M3.exports.Buffer, j6 = dg.isEncoding || function(r) {
  switch (r = "" + r, r && r.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function IY(r) {
  if (!r) return "utf8";
  for (var e; ; )
    switch (r) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return r;
      default:
        if (e) return;
        r = ("" + r).toLowerCase(), e = !0;
    }
}
function PY(r) {
  var e = IY(r);
  if (typeof e != "string" && (dg.isEncoding === j6 || !j6(r))) throw new Error("Unknown encoding: " + r);
  return e || r;
}
hg.StringDecoder = o2;
function o2(r) {
  this.encoding = PY(r);
  var e;
  switch (this.encoding) {
    case "utf16le":
      this.text = $Y, this.end = zY, e = 4;
      break;
    case "utf8":
      this.fillLast = LY, e = 4;
      break;
    case "base64":
      this.text = jY, this.end = WY, e = 3;
      break;
    default:
      this.write = GY, this.end = VY;
      return;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = dg.allocUnsafe(e);
}
o2.prototype.write = function(r) {
  if (r.length === 0) return "";
  var e, t;
  if (this.lastNeed) {
    if (e = this.fillLast(r), e === void 0) return "";
    t = this.lastNeed, this.lastNeed = 0;
  } else
    t = 0;
  return t < r.length ? e ? e + this.text(r, t) : this.text(r, t) : e || "";
};
o2.prototype.end = UY;
o2.prototype.text = MY;
o2.prototype.fillLast = function(r) {
  if (this.lastNeed <= r.length)
    return r.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  r.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, r.length), this.lastNeed -= r.length;
};
function r4(r) {
  return r <= 127 ? 0 : r >> 5 === 6 ? 2 : r >> 4 === 14 ? 3 : r >> 3 === 30 ? 4 : r >> 6 === 2 ? -1 : -2;
}
function BY(r, e, t) {
  var n = e.length - 1;
  if (n < t) return 0;
  var i = r4(e[n]);
  return i >= 0 ? (i > 0 && (r.lastNeed = i - 1), i) : --n < t || i === -2 ? 0 : (i = r4(e[n]), i >= 0 ? (i > 0 && (r.lastNeed = i - 2), i) : --n < t || i === -2 ? 0 : (i = r4(e[n]), i >= 0 ? (i > 0 && (i === 2 ? i = 0 : r.lastNeed = i - 3), i) : 0));
}
function NY(r, e, t) {
  if ((e[0] & 192) !== 128)
    return r.lastNeed = 0, "�";
  if (r.lastNeed > 1 && e.length > 1) {
    if ((e[1] & 192) !== 128)
      return r.lastNeed = 1, "�";
    if (r.lastNeed > 2 && e.length > 2 && (e[2] & 192) !== 128)
      return r.lastNeed = 2, "�";
  }
}
function LY(r) {
  var e = this.lastTotal - this.lastNeed, t = NY(this, r);
  if (t !== void 0) return t;
  if (this.lastNeed <= r.length)
    return r.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  r.copy(this.lastChar, e, 0, r.length), this.lastNeed -= r.length;
}
function MY(r, e) {
  var t = BY(this, r, e);
  if (!this.lastNeed) return r.toString("utf8", e);
  this.lastTotal = t;
  var n = r.length - (t - this.lastNeed);
  return r.copy(this.lastChar, 0, n), r.toString("utf8", e, n);
}
function UY(r) {
  var e = r && r.length ? this.write(r) : "";
  return this.lastNeed ? e + "�" : e;
}
function $Y(r, e) {
  if ((r.length - e) % 2 === 0) {
    var t = r.toString("utf16le", e);
    if (t) {
      var n = t.charCodeAt(t.length - 1);
      if (n >= 55296 && n <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = r[r.length - 2], this.lastChar[1] = r[r.length - 1], t.slice(0, -1);
    }
    return t;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = r[r.length - 1], r.toString("utf16le", e, r.length - 1);
}
function zY(r) {
  var e = r && r.length ? this.write(r) : "";
  if (this.lastNeed) {
    var t = this.lastTotal - this.lastNeed;
    return e + this.lastChar.toString("utf16le", 0, t);
  }
  return e;
}
function jY(r, e) {
  var t = (r.length - e) % 3;
  return t === 0 ? r.toString("base64", e) : (this.lastNeed = 3 - t, this.lastTotal = 3, t === 1 ? this.lastChar[0] = r[r.length - 1] : (this.lastChar[0] = r[r.length - 2], this.lastChar[1] = r[r.length - 1]), r.toString("base64", e, r.length - t));
}
function WY(r) {
  var e = r && r.length ? this.write(r) : "";
  return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
}
function GY(r) {
  return r.toString(this.encoding);
}
function VY(r) {
  return r && r.length ? this.write(r) : "";
}
var W6 = Ol.codes.ERR_STREAM_PREMATURE_CLOSE;
function YY(r) {
  var e = !1;
  return function() {
    if (!e) {
      e = !0;
      for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++)
        n[i] = arguments[i];
      r.apply(this, n);
    }
  };
}
function HY() {
}
function ZY(r) {
  return r.setHeader && typeof r.abort == "function";
}
function NE(r, e, t) {
  if (typeof e == "function") return NE(r, null, e);
  e || (e = {}), t = YY(t || HY);
  var n = e.readable || e.readable !== !1 && r.readable, i = e.writable || e.writable !== !1 && r.writable, a = function() {
    r.writable || s();
  }, o = r._writableState && r._writableState.finished, s = function() {
    i = !1, o = !0, n || t.call(r);
  }, c = r._readableState && r._readableState.endEmitted, h = function() {
    n = !1, c = !0, i || t.call(r);
  }, d = function(k) {
    t.call(r, k);
  }, g = function() {
    var k;
    if (n && !c)
      return (!r._readableState || !r._readableState.ended) && (k = new W6()), t.call(r, k);
    if (i && !o)
      return (!r._writableState || !r._writableState.ended) && (k = new W6()), t.call(r, k);
  }, x = function() {
    r.req.on("finish", s);
  };
  return ZY(r) ? (r.on("complete", s), r.on("abort", g), r.req ? x() : r.on("request", x)) : i && !r._writableState && (r.on("end", a), r.on("close", a)), r.on("end", h), r.on("finish", s), e.error !== !1 && r.on("error", d), r.on("close", g), function() {
    r.removeListener("complete", s), r.removeListener("abort", g), r.removeListener("request", x), r.req && r.req.removeListener("finish", s), r.removeListener("end", a), r.removeListener("close", a), r.removeListener("finish", s), r.removeListener("end", h), r.removeListener("error", d), r.removeListener("close", g);
  };
}
var pg = NE, K2;
function Ns(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
var qY = pg, Ls = Symbol("lastResolve"), Gu = Symbol("lastReject"), f1 = Symbol("error"), Td = Symbol("ended"), ol = Symbol("lastPromise"), vg = Symbol("handlePromise"), sl = Symbol("stream");
function qs(r, e) {
  return {
    value: r,
    done: e
  };
}
function XY(r) {
  var e = r[Ls];
  if (e !== null) {
    var t = r[sl].read();
    t !== null && (r[ol] = null, r[Ls] = null, r[Gu] = null, e(qs(t, !1)));
  }
}
function KY(r) {
  ir.nextTick(XY, r);
}
function JY(r, e) {
  return function(t, n) {
    r.then(function() {
      if (e[Td]) {
        t(qs(void 0, !0));
        return;
      }
      e[vg](t, n);
    }, n);
  };
}
var QY = Object.getPrototypeOf(function() {
}), eH = Object.setPrototypeOf((K2 = {
  get stream() {
    return this[sl];
  },
  next: function() {
    var e = this, t = this[f1];
    if (t !== null)
      return Promise.reject(t);
    if (this[Td])
      return Promise.resolve(qs(void 0, !0));
    if (this[sl].destroyed)
      return new Promise(function(o, s) {
        ir.nextTick(function() {
          e[f1] ? s(e[f1]) : o(qs(void 0, !0));
        });
      });
    var n = this[ol], i;
    if (n)
      i = new Promise(JY(n, this));
    else {
      var a = this[sl].read();
      if (a !== null)
        return Promise.resolve(qs(a, !1));
      i = new Promise(this[vg]);
    }
    return this[ol] = i, i;
  }
}, Ns(K2, Symbol.asyncIterator, function() {
  return this;
}), Ns(K2, "return", function() {
  var e = this;
  return new Promise(function(t, n) {
    e[sl].destroy(null, function(i) {
      if (i) {
        n(i);
        return;
      }
      t(qs(void 0, !0));
    });
  });
}), K2), QY), tH = function(e) {
  var t, n = Object.create(eH, (t = {}, Ns(t, sl, {
    value: e,
    writable: !0
  }), Ns(t, Ls, {
    value: null,
    writable: !0
  }), Ns(t, Gu, {
    value: null,
    writable: !0
  }), Ns(t, f1, {
    value: null,
    writable: !0
  }), Ns(t, Td, {
    value: e._readableState.endEmitted,
    writable: !0
  }), Ns(t, vg, {
    value: function(a, o) {
      var s = n[sl].read();
      s ? (n[ol] = null, n[Ls] = null, n[Gu] = null, a(qs(s, !1))) : (n[Ls] = a, n[Gu] = o);
    },
    writable: !0
  }), t));
  return n[ol] = null, qY(e, function(i) {
    if (i && i.code !== "ERR_STREAM_PREMATURE_CLOSE") {
      var a = n[Gu];
      a !== null && (n[ol] = null, n[Ls] = null, n[Gu] = null, a(i)), n[f1] = i;
      return;
    }
    var o = n[Ls];
    o !== null && (n[ol] = null, n[Ls] = null, n[Gu] = null, o(qs(void 0, !0))), n[Td] = !0;
  }), e.on("readable", KY.bind(null, n)), n;
}, rH = tH, nH = function() {
  throw new Error("Readable.from is not available in the browser");
}, gg = lf;
gg.Readable = Sr;
Sr.ReadableState = ME;
w5.exports.EventEmitter;
var LE = function(e, t) {
  return e.listeners(t).length;
}, s2 = FE, E5 = Al.Buffer, iH = wl.Uint8Array || function() {
};
function aH(r) {
  return E5.from(r);
}
function oH(r) {
  return E5.isBuffer(r) || r instanceof iH;
}
var n4 = RE, lr;
n4 && n4.debuglog ? lr = n4.debuglog("stream") : lr = function() {
};
var sH = xY, mg = IE, uH = BE, lH = uH.getHighWaterMark, _5 = Ol.codes, cH = _5.ERR_INVALID_ARG_TYPE, fH = _5.ERR_STREAM_PUSH_AFTER_EOF, hH = _5.ERR_METHOD_NOT_IMPLEMENTED, dH = _5.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Mc, i4, a4;
uu.exports(Sr, s2);
var h1 = mg.errorOrDestroy, o4 = ["error", "close", "destroy", "pause", "resume"];
function pH(r, e, t) {
  if (typeof r.prependListener == "function") return r.prependListener(e, t);
  !r._events || !r._events[e] ? r.on(e, t) : Array.isArray(r._events[e]) ? r._events[e].unshift(t) : r._events[e] = [t, r._events[e]];
}
function ME(r, e, t) {
  r = r || {}, typeof t != "boolean" && (t = e instanceof gg.Duplex), this.objectMode = !!r.objectMode, t && (this.objectMode = this.objectMode || !!r.readableObjectMode), this.highWaterMark = lH(this, r, "readableHighWaterMark", t), this.buffer = new sH(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = r.emitClose !== !1, this.autoDestroy = !!r.autoDestroy, this.destroyed = !1, this.defaultEncoding = r.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, r.encoding && (Mc || (Mc = hg.StringDecoder), this.decoder = new Mc(r.encoding), this.encoding = r.encoding);
}
function Sr(r) {
  if (!(this instanceof Sr)) return new Sr(r);
  var e = this instanceof gg.Duplex;
  this._readableState = new ME(r, this, e), this.readable = !0, r && (typeof r.read == "function" && (this._read = r.read), typeof r.destroy == "function" && (this._destroy = r.destroy)), s2.call(this);
}
Object.defineProperty(Sr.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState === void 0 ? !1 : this._readableState.destroyed;
  },
  set: function(e) {
    this._readableState && (this._readableState.destroyed = e);
  }
});
Sr.prototype.destroy = mg.destroy;
Sr.prototype._undestroy = mg.undestroy;
Sr.prototype._destroy = function(r, e) {
  e(r);
};
Sr.prototype.push = function(r, e) {
  var t = this._readableState, n;
  return t.objectMode ? n = !0 : typeof r == "string" && (e = e || t.defaultEncoding, e !== t.encoding && (r = E5.from(r, e), e = ""), n = !0), UE(this, r, e, !1, n);
};
Sr.prototype.unshift = function(r) {
  return UE(this, r, null, !0, !1);
};
function UE(r, e, t, n, i) {
  lr("readableAddChunk", e);
  var a = r._readableState;
  if (e === null)
    a.reading = !1, mH(r, a);
  else {
    var o;
    if (i || (o = vH(a, e)), o)
      h1(r, o);
    else if (a.objectMode || e && e.length > 0)
      if (typeof e != "string" && !a.objectMode && Object.getPrototypeOf(e) !== E5.prototype && (e = aH(e)), n)
        a.endEmitted ? h1(r, new dH()) : s4(r, a, e, !0);
      else if (a.ended)
        h1(r, new fH());
      else {
        if (a.destroyed)
          return !1;
        a.reading = !1, a.decoder && !t ? (e = a.decoder.write(e), a.objectMode || e.length !== 0 ? s4(r, a, e, !1) : U3(r, a)) : s4(r, a, e, !1);
      }
    else n || (a.reading = !1, U3(r, a));
  }
  return !a.ended && (a.length < a.highWaterMark || a.length === 0);
}
function s4(r, e, t, n) {
  e.flowing && e.length === 0 && !e.sync ? (e.awaitDrain = 0, r.emit("data", t)) : (e.length += e.objectMode ? 1 : t.length, n ? e.buffer.unshift(t) : e.buffer.push(t), e.needReadable && D5(r)), U3(r, e);
}
function vH(r, e) {
  var t;
  return !oH(e) && typeof e != "string" && e !== void 0 && !r.objectMode && (t = new cH("chunk", ["string", "Buffer", "Uint8Array"], e)), t;
}
Sr.prototype.isPaused = function() {
  return this._readableState.flowing === !1;
};
Sr.prototype.setEncoding = function(r) {
  Mc || (Mc = hg.StringDecoder);
  var e = new Mc(r);
  this._readableState.decoder = e, this._readableState.encoding = this._readableState.decoder.encoding;
  for (var t = this._readableState.buffer.head, n = ""; t !== null; )
    n += e.write(t.data), t = t.next;
  return this._readableState.buffer.clear(), n !== "" && this._readableState.buffer.push(n), this._readableState.length = n.length, this;
};
var G6 = 1073741824;
function gH(r) {
  return r >= G6 ? r = G6 : (r--, r |= r >>> 1, r |= r >>> 2, r |= r >>> 4, r |= r >>> 8, r |= r >>> 16, r++), r;
}
function V6(r, e) {
  return r <= 0 || e.length === 0 && e.ended ? 0 : e.objectMode ? 1 : r !== r ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (r > e.highWaterMark && (e.highWaterMark = gH(r)), r <= e.length ? r : e.ended ? e.length : (e.needReadable = !0, 0));
}
Sr.prototype.read = function(r) {
  lr("read", r), r = parseInt(r, 10);
  var e = this._readableState, t = r;
  if (r !== 0 && (e.emittedReadable = !1), r === 0 && e.needReadable && ((e.highWaterMark !== 0 ? e.length >= e.highWaterMark : e.length > 0) || e.ended))
    return lr("read: emitReadable", e.length, e.ended), e.length === 0 && e.ended ? u4(this) : D5(this), null;
  if (r = V6(r, e), r === 0 && e.ended)
    return e.length === 0 && u4(this), null;
  var n = e.needReadable;
  lr("need readable", n), (e.length === 0 || e.length - r < e.highWaterMark) && (n = !0, lr("length less than watermark", n)), e.ended || e.reading ? (n = !1, lr("reading or ended", n)) : n && (lr("do read"), e.reading = !0, e.sync = !0, e.length === 0 && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (r = V6(t, e)));
  var i;
  return r > 0 ? i = jE(r, e) : i = null, i === null ? (e.needReadable = e.length <= e.highWaterMark, r = 0) : (e.length -= r, e.awaitDrain = 0), e.length === 0 && (e.ended || (e.needReadable = !0), t !== r && e.ended && u4(this)), i !== null && this.emit("data", i), i;
};
function mH(r, e) {
  if (lr("onEofChunk"), !e.ended) {
    if (e.decoder) {
      var t = e.decoder.end();
      t && t.length && (e.buffer.push(t), e.length += e.objectMode ? 1 : t.length);
    }
    e.ended = !0, e.sync ? D5(r) : (e.needReadable = !1, e.emittedReadable || (e.emittedReadable = !0, $E(r)));
  }
}
function D5(r) {
  var e = r._readableState;
  lr("emitReadable", e.needReadable, e.emittedReadable), e.needReadable = !1, e.emittedReadable || (lr("emitReadable", e.flowing), e.emittedReadable = !0, ir.nextTick($E, r));
}
function $E(r) {
  var e = r._readableState;
  lr("emitReadable_", e.destroyed, e.length, e.ended), !e.destroyed && (e.length || e.ended) && (r.emit("readable"), e.emittedReadable = !1), e.needReadable = !e.flowing && !e.ended && e.length <= e.highWaterMark, yg(r);
}
function U3(r, e) {
  e.readingMore || (e.readingMore = !0, ir.nextTick(yH, r, e));
}
function yH(r, e) {
  for (; !e.reading && !e.ended && (e.length < e.highWaterMark || e.flowing && e.length === 0); ) {
    var t = e.length;
    if (lr("maybeReadMore read 0"), r.read(0), t === e.length)
      break;
  }
  e.readingMore = !1;
}
Sr.prototype._read = function(r) {
  h1(this, new hH("_read()"));
};
Sr.prototype.pipe = function(r, e) {
  var t = this, n = this._readableState;
  switch (n.pipesCount) {
    case 0:
      n.pipes = r;
      break;
    case 1:
      n.pipes = [n.pipes, r];
      break;
    default:
      n.pipes.push(r);
      break;
  }
  n.pipesCount += 1, lr("pipe count=%d opts=%j", n.pipesCount, e);
  var i = (!e || e.end !== !1) && r !== ir.stdout && r !== ir.stderr, a = i ? s : P;
  n.endEmitted ? ir.nextTick(a) : t.once("end", a), r.on("unpipe", o);
  function o(N, M) {
    lr("onunpipe"), N === t && M && M.hasUnpiped === !1 && (M.hasUnpiped = !0, d());
  }
  function s() {
    lr("onend"), r.end();
  }
  var c = bH(t);
  r.on("drain", c);
  var h = !1;
  function d() {
    lr("cleanup"), r.removeListener("close", _), r.removeListener("finish", k), r.removeListener("drain", c), r.removeListener("error", x), r.removeListener("unpipe", o), t.removeListener("end", s), t.removeListener("end", P), t.removeListener("data", g), h = !0, n.awaitDrain && (!r._writableState || r._writableState.needDrain) && c();
  }
  t.on("data", g);
  function g(N) {
    lr("ondata");
    var M = r.write(N);
    lr("dest.write", M), M === !1 && ((n.pipesCount === 1 && n.pipes === r || n.pipesCount > 1 && WE(n.pipes, r) !== -1) && !h && (lr("false write response, pause", n.awaitDrain), n.awaitDrain++), t.pause());
  }
  function x(N) {
    lr("onerror", N), P(), r.removeListener("error", x), LE(r, "error") === 0 && h1(r, N);
  }
  pH(r, "error", x);
  function _() {
    r.removeListener("finish", k), P();
  }
  r.once("close", _);
  function k() {
    lr("onfinish"), r.removeListener("close", _), P();
  }
  r.once("finish", k);
  function P() {
    lr("unpipe"), t.unpipe(r);
  }
  return r.emit("pipe", t), n.flowing || (lr("pipe resume"), t.resume()), r;
};
function bH(r) {
  return function() {
    var t = r._readableState;
    lr("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, t.awaitDrain === 0 && LE(r, "data") && (t.flowing = !0, yg(r));
  };
}
Sr.prototype.unpipe = function(r) {
  var e = this._readableState, t = {
    hasUnpiped: !1
  };
  if (e.pipesCount === 0) return this;
  if (e.pipesCount === 1)
    return r && r !== e.pipes ? this : (r || (r = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, r && r.emit("unpipe", this, t), this);
  if (!r) {
    var n = e.pipes, i = e.pipesCount;
    e.pipes = null, e.pipesCount = 0, e.flowing = !1;
    for (var a = 0; a < i; a++)
      n[a].emit("unpipe", this, {
        hasUnpiped: !1
      });
    return this;
  }
  var o = WE(e.pipes, r);
  return o === -1 ? this : (e.pipes.splice(o, 1), e.pipesCount -= 1, e.pipesCount === 1 && (e.pipes = e.pipes[0]), r.emit("unpipe", this, t), this);
};
Sr.prototype.on = function(r, e) {
  var t = s2.prototype.on.call(this, r, e), n = this._readableState;
  return r === "data" ? (n.readableListening = this.listenerCount("readable") > 0, n.flowing !== !1 && this.resume()) : r === "readable" && !n.endEmitted && !n.readableListening && (n.readableListening = n.needReadable = !0, n.flowing = !1, n.emittedReadable = !1, lr("on readable", n.length, n.reading), n.length ? D5(this) : n.reading || ir.nextTick(wH, this)), t;
};
Sr.prototype.addListener = Sr.prototype.on;
Sr.prototype.removeListener = function(r, e) {
  var t = s2.prototype.removeListener.call(this, r, e);
  return r === "readable" && ir.nextTick(zE, this), t;
};
Sr.prototype.removeAllListeners = function(r) {
  var e = s2.prototype.removeAllListeners.apply(this, arguments);
  return (r === "readable" || r === void 0) && ir.nextTick(zE, this), e;
};
function zE(r) {
  var e = r._readableState;
  e.readableListening = r.listenerCount("readable") > 0, e.resumeScheduled && !e.paused ? e.flowing = !0 : r.listenerCount("data") > 0 && r.resume();
}
function wH(r) {
  lr("readable nexttick read 0"), r.read(0);
}
Sr.prototype.resume = function() {
  var r = this._readableState;
  return r.flowing || (lr("resume"), r.flowing = !r.readableListening, AH(this, r)), r.paused = !1, this;
};
function AH(r, e) {
  e.resumeScheduled || (e.resumeScheduled = !0, ir.nextTick(xH, r, e));
}
function xH(r, e) {
  lr("resume", e.reading), e.reading || r.read(0), e.resumeScheduled = !1, r.emit("resume"), yg(r), e.flowing && !e.reading && r.read(0);
}
Sr.prototype.pause = function() {
  return lr("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (lr("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
};
function yg(r) {
  var e = r._readableState;
  for (lr("flow", e.flowing); e.flowing && r.read() !== null; )
    ;
}
Sr.prototype.wrap = function(r) {
  var e = this, t = this._readableState, n = !1;
  r.on("end", function() {
    if (lr("wrapped end"), t.decoder && !t.ended) {
      var o = t.decoder.end();
      o && o.length && e.push(o);
    }
    e.push(null);
  }), r.on("data", function(o) {
    if (lr("wrapped data"), t.decoder && (o = t.decoder.write(o)), !(t.objectMode && o == null) && !(!t.objectMode && (!o || !o.length))) {
      var s = e.push(o);
      s || (n = !0, r.pause());
    }
  });
  for (var i in r)
    this[i] === void 0 && typeof r[i] == "function" && (this[i] = /* @__PURE__ */ function(s) {
      return function() {
        return r[s].apply(r, arguments);
      };
    }(i));
  for (var a = 0; a < o4.length; a++)
    r.on(o4[a], this.emit.bind(this, o4[a]));
  return this._read = function(o) {
    lr("wrapped _read", o), n && (n = !1, r.resume());
  }, this;
};
typeof Symbol == "function" && (Sr.prototype[Symbol.asyncIterator] = function() {
  return i4 === void 0 && (i4 = rH), i4(this);
});
Object.defineProperty(Sr.prototype, "readableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Sr.prototype, "readableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Sr.prototype, "readableFlowing", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.flowing;
  },
  set: function(e) {
    this._readableState && (this._readableState.flowing = e);
  }
});
Sr._fromList = jE;
Object.defineProperty(Sr.prototype, "readableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.length;
  }
});
function jE(r, e) {
  if (e.length === 0) return null;
  var t;
  return e.objectMode ? t = e.buffer.shift() : !r || r >= e.length ? (e.decoder ? t = e.buffer.join("") : e.buffer.length === 1 ? t = e.buffer.first() : t = e.buffer.concat(e.length), e.buffer.clear()) : t = e.buffer.consume(r, e.decoder), t;
}
function u4(r) {
  var e = r._readableState;
  lr("endReadable", e.endEmitted), e.endEmitted || (e.ended = !0, ir.nextTick(EH, e, r));
}
function EH(r, e) {
  if (lr("endReadableNT", r.endEmitted, r.length), !r.endEmitted && r.length === 0 && (r.endEmitted = !0, e.readable = !1, e.emit("end"), r.autoDestroy)) {
    var t = e._writableState;
    (!t || t.autoDestroy && t.finished) && e.destroy();
  }
}
typeof Symbol == "function" && (Sr.from = function(r, e) {
  return a4 === void 0 && (a4 = nH), a4(Sr, r, e);
});
function WE(r, e) {
  for (var t = 0, n = r.length; t < n; t++)
    if (r[t] === e) return t;
  return -1;
}
var _H = DH;
function DH(r, e) {
  if (l4("noDeprecation"))
    return r;
  var t = !1;
  function n() {
    if (!t) {
      if (l4("throwDeprecation"))
        throw new Error(e);
      l4("traceDeprecation") ? console.trace(e) : console.warn(e), t = !0;
    }
    return r.apply(this, arguments);
  }
  return n;
}
function l4(r) {
  try {
    if (!wl.localStorage) return !1;
  } catch {
    return !1;
  }
  var e = wl.localStorage[r];
  return e == null ? !1 : String(e).toLowerCase() === "true";
}
var bg = lf;
bg.Writable = R0;
function GE(r) {
  var e = this;
  this.next = null, this.entry = null, this.finish = function() {
    JH(e, r);
  };
}
R0.WritableState = u2;
var TH = {
  deprecate: _H
}, VE = FE, T5 = Al.Buffer, kH = wl.Uint8Array || function() {
};
function SH(r) {
  return T5.from(r);
}
function CH(r) {
  return T5.isBuffer(r) || r instanceof kH;
}
var wg = IE, FH = BE, OH = FH.getHighWaterMark, pu = Ol.codes, RH = pu.ERR_INVALID_ARG_TYPE, IH = pu.ERR_METHOD_NOT_IMPLEMENTED, PH = pu.ERR_MULTIPLE_CALLBACK, BH = pu.ERR_STREAM_CANNOT_PIPE, NH = pu.ERR_STREAM_DESTROYED, LH = pu.ERR_STREAM_NULL_VALUES, MH = pu.ERR_STREAM_WRITE_AFTER_END, UH = pu.ERR_UNKNOWN_ENCODING, Xc = wg.errorOrDestroy;
uu.exports(R0, VE);
function $H() {
}
function u2(r, e, t) {
  r = r || {}, typeof t != "boolean" && (t = e instanceof bg.Duplex), this.objectMode = !!r.objectMode, t && (this.objectMode = this.objectMode || !!r.writableObjectMode), this.highWaterMark = OH(this, r, "writableHighWaterMark", t), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
  var n = r.decodeStrings === !1;
  this.decodeStrings = !n, this.defaultEncoding = r.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(i) {
    HH(e, i);
  }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = r.emitClose !== !1, this.autoDestroy = !!r.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new GE(this);
}
u2.prototype.getBuffer = function() {
  for (var e = this.bufferedRequest, t = []; e; )
    t.push(e), e = e.next;
  return t;
};
(function() {
  try {
    Object.defineProperty(u2.prototype, "buffer", {
      get: TH.deprecate(function() {
        return this.getBuffer();
      }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
    });
  } catch {
  }
})();
var Wh;
typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Wh = Function.prototype[Symbol.hasInstance], Object.defineProperty(R0, Symbol.hasInstance, {
  value: function(e) {
    return Wh.call(this, e) ? !0 : this !== R0 ? !1 : e && e._writableState instanceof u2;
  }
})) : Wh = function(e) {
  return e instanceof this;
};
function R0(r) {
  var e = this instanceof bg.Duplex;
  if (!e && !Wh.call(R0, this)) return new R0(r);
  this._writableState = new u2(r, this, e), this.writable = !0, r && (typeof r.write == "function" && (this._write = r.write), typeof r.writev == "function" && (this._writev = r.writev), typeof r.destroy == "function" && (this._destroy = r.destroy), typeof r.final == "function" && (this._final = r.final)), VE.call(this);
}
R0.prototype.pipe = function() {
  Xc(this, new BH());
};
function zH(r, e) {
  var t = new MH();
  Xc(r, t), ir.nextTick(e, t);
}
function jH(r, e, t, n) {
  var i;
  return t === null ? i = new LH() : typeof t != "string" && !e.objectMode && (i = new RH("chunk", ["string", "Buffer"], t)), i ? (Xc(r, i), ir.nextTick(n, i), !1) : !0;
}
R0.prototype.write = function(r, e, t) {
  var n = this._writableState, i = !1, a = !n.objectMode && CH(r);
  return a && !T5.isBuffer(r) && (r = SH(r)), typeof e == "function" && (t = e, e = null), a ? e = "buffer" : e || (e = n.defaultEncoding), typeof t != "function" && (t = $H), n.ending ? zH(this, t) : (a || jH(this, n, r, t)) && (n.pendingcb++, i = GH(this, n, a, r, e, t)), i;
};
R0.prototype.cork = function() {
  this._writableState.corked++;
};
R0.prototype.uncork = function() {
  var r = this._writableState;
  r.corked && (r.corked--, !r.writing && !r.corked && !r.bufferProcessing && r.bufferedRequest && YE(this, r));
};
R0.prototype.setDefaultEncoding = function(e) {
  if (typeof e == "string" && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new UH(e);
  return this._writableState.defaultEncoding = e, this;
};
Object.defineProperty(R0.prototype, "writableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function WH(r, e, t) {
  return !r.objectMode && r.decodeStrings !== !1 && typeof e == "string" && (e = T5.from(e, t)), e;
}
Object.defineProperty(R0.prototype, "writableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.highWaterMark;
  }
});
function GH(r, e, t, n, i, a) {
  if (!t) {
    var o = WH(e, n, i);
    n !== o && (t = !0, i = "buffer", n = o);
  }
  var s = e.objectMode ? 1 : n.length;
  e.length += s;
  var c = e.length < e.highWaterMark;
  if (c || (e.needDrain = !0), e.writing || e.corked) {
    var h = e.lastBufferedRequest;
    e.lastBufferedRequest = {
      chunk: n,
      encoding: i,
      isBuf: t,
      callback: a,
      next: null
    }, h ? h.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
  } else
    $3(r, e, !1, s, n, i, a);
  return c;
}
function $3(r, e, t, n, i, a, o) {
  e.writelen = n, e.writecb = o, e.writing = !0, e.sync = !0, e.destroyed ? e.onwrite(new NH("write")) : t ? r._writev(i, e.onwrite) : r._write(i, a, e.onwrite), e.sync = !1;
}
function VH(r, e, t, n, i) {
  --e.pendingcb, t ? (ir.nextTick(i, n), ir.nextTick(B1, r, e), r._writableState.errorEmitted = !0, Xc(r, n)) : (i(n), r._writableState.errorEmitted = !0, Xc(r, n), B1(r, e));
}
function YH(r) {
  r.writing = !1, r.writecb = null, r.length -= r.writelen, r.writelen = 0;
}
function HH(r, e) {
  var t = r._writableState, n = t.sync, i = t.writecb;
  if (typeof i != "function") throw new PH();
  if (YH(t), e) VH(r, t, n, e, i);
  else {
    var a = HE(t) || r.destroyed;
    !a && !t.corked && !t.bufferProcessing && t.bufferedRequest && YE(r, t), n ? ir.nextTick(Y6, r, t, a, i) : Y6(r, t, a, i);
  }
}
function Y6(r, e, t, n) {
  t || ZH(r, e), e.pendingcb--, n(), B1(r, e);
}
function ZH(r, e) {
  e.length === 0 && e.needDrain && (e.needDrain = !1, r.emit("drain"));
}
function YE(r, e) {
  e.bufferProcessing = !0;
  var t = e.bufferedRequest;
  if (r._writev && t && t.next) {
    var n = e.bufferedRequestCount, i = new Array(n), a = e.corkedRequestsFree;
    a.entry = t;
    for (var o = 0, s = !0; t; )
      i[o] = t, t.isBuf || (s = !1), t = t.next, o += 1;
    i.allBuffers = s, $3(r, e, !0, e.length, i, "", a.finish), e.pendingcb++, e.lastBufferedRequest = null, a.next ? (e.corkedRequestsFree = a.next, a.next = null) : e.corkedRequestsFree = new GE(e), e.bufferedRequestCount = 0;
  } else {
    for (; t; ) {
      var c = t.chunk, h = t.encoding, d = t.callback, g = e.objectMode ? 1 : c.length;
      if ($3(r, e, !1, g, c, h, d), t = t.next, e.bufferedRequestCount--, e.writing)
        break;
    }
    t === null && (e.lastBufferedRequest = null);
  }
  e.bufferedRequest = t, e.bufferProcessing = !1;
}
R0.prototype._write = function(r, e, t) {
  t(new IH("_write()"));
};
R0.prototype._writev = null;
R0.prototype.end = function(r, e, t) {
  var n = this._writableState;
  return typeof r == "function" ? (t = r, r = null, e = null) : typeof e == "function" && (t = e, e = null), r != null && this.write(r, e), n.corked && (n.corked = 1, this.uncork()), n.ending || KH(this, n, t), this;
};
Object.defineProperty(R0.prototype, "writableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.length;
  }
});
function HE(r) {
  return r.ending && r.length === 0 && r.bufferedRequest === null && !r.finished && !r.writing;
}
function qH(r, e) {
  r._final(function(t) {
    e.pendingcb--, t && Xc(r, t), e.prefinished = !0, r.emit("prefinish"), B1(r, e);
  });
}
function XH(r, e) {
  !e.prefinished && !e.finalCalled && (typeof r._final == "function" && !e.destroyed ? (e.pendingcb++, e.finalCalled = !0, ir.nextTick(qH, r, e)) : (e.prefinished = !0, r.emit("prefinish")));
}
function B1(r, e) {
  var t = HE(e);
  if (t && (XH(r, e), e.pendingcb === 0 && (e.finished = !0, r.emit("finish"), e.autoDestroy))) {
    var n = r._readableState;
    (!n || n.autoDestroy && n.endEmitted) && r.destroy();
  }
  return t;
}
function KH(r, e, t) {
  e.ending = !0, B1(r, e), t && (e.finished ? ir.nextTick(t) : r.once("finish", t)), e.ended = !0, r.writable = !1;
}
function JH(r, e, t) {
  var n = r.entry;
  for (r.entry = null; n; ) {
    var i = n.callback;
    e.pendingcb--, i(t), n = n.next;
  }
  e.corkedRequestsFree.next = r;
}
Object.defineProperty(R0.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState === void 0 ? !1 : this._writableState.destroyed;
  },
  set: function(e) {
    this._writableState && (this._writableState.destroyed = e);
  }
});
R0.prototype.destroy = wg.destroy;
R0.prototype._undestroy = wg.undestroy;
R0.prototype._destroy = function(r, e) {
  e(r);
};
var QH = Object.keys || function(r) {
  var e = [];
  for (var t in r)
    e.push(t);
  return e;
}, Kc = lf;
Kc.Duplex = wo;
uu.exports(wo, Kc.Readable);
for (var H6 = QH(Kc.Writable.prototype), c4 = 0; c4 < H6.length; c4++) {
  var f4 = H6[c4];
  wo.prototype[f4] || (wo.prototype[f4] = Kc.Writable.prototype[f4]);
}
function wo(r) {
  if (!(this instanceof wo)) return new wo(r);
  Kc.Readable.call(this, r), Kc.Writable.call(this, r), this.allowHalfOpen = !0, r && (r.readable === !1 && (this.readable = !1), r.writable === !1 && (this.writable = !1), r.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", eZ)));
}
Object.defineProperty(wo.prototype, "writableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(wo.prototype, "writableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(wo.prototype, "writableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.length;
  }
});
function eZ() {
  this._writableState.ended || ir.nextTick(tZ, this);
}
function tZ(r) {
  r.end();
}
Object.defineProperty(wo.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function(e) {
    this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = e, this._writableState.destroyed = e);
  }
});
var l2 = lf;
l2.Transform = es;
var k5 = Ol.codes, rZ = k5.ERR_METHOD_NOT_IMPLEMENTED, nZ = k5.ERR_MULTIPLE_CALLBACK, iZ = k5.ERR_TRANSFORM_ALREADY_TRANSFORMING, aZ = k5.ERR_TRANSFORM_WITH_LENGTH_0;
uu.exports(es, l2.Duplex);
function oZ(r, e) {
  var t = this._transformState;
  t.transforming = !1;
  var n = t.writecb;
  if (n === null)
    return this.emit("error", new nZ());
  t.writechunk = null, t.writecb = null, e != null && this.push(e), n(r);
  var i = this._readableState;
  i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
}
function es(r) {
  if (!(this instanceof es)) return new es(r);
  l2.Duplex.call(this, r), this._transformState = {
    afterTransform: oZ.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, r && (typeof r.transform == "function" && (this._transform = r.transform), typeof r.flush == "function" && (this._flush = r.flush)), this.on("prefinish", sZ);
}
function sZ() {
  var r = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(e, t) {
    Z6(r, e, t);
  }) : Z6(this, null, null);
}
es.prototype.push = function(r, e) {
  return this._transformState.needTransform = !1, l2.Duplex.prototype.push.call(this, r, e);
};
es.prototype._transform = function(r, e, t) {
  t(new rZ("_transform()"));
};
es.prototype._write = function(r, e, t) {
  var n = this._transformState;
  if (n.writecb = t, n.writechunk = r, n.writeencoding = e, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
es.prototype._read = function(r) {
  var e = this._transformState;
  e.writechunk !== null && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
es.prototype._destroy = function(r, e) {
  l2.Duplex.prototype._destroy.call(this, r, function(t) {
    e(t);
  });
};
function Z6(r, e, t) {
  if (e) return r.emit("error", e);
  if (t != null && r.push(t), r._writableState.length) throw new aZ();
  if (r._transformState.transforming) throw new iZ();
  return r.push(null);
}
var ZE = lf;
ZE.PassThrough = N1;
uu.exports(N1, ZE.Transform);
function N1(r) {
  if (!(this instanceof N1)) return new N1(r);
  Transform.call(this, r);
}
N1.prototype._transform = function(r, e, t) {
  t(null, r);
};
var h4;
function uZ(r) {
  var e = !1;
  return function() {
    e || (e = !0, r.apply(void 0, arguments));
  };
}
var qE = Ol.codes, lZ = qE.ERR_MISSING_ARGS, cZ = qE.ERR_STREAM_DESTROYED;
function q6(r) {
  if (r) throw r;
}
function fZ(r) {
  return r.setHeader && typeof r.abort == "function";
}
function hZ(r, e, t, n) {
  n = uZ(n);
  var i = !1;
  r.on("close", function() {
    i = !0;
  }), h4 === void 0 && (h4 = pg), h4(r, {
    readable: e,
    writable: t
  }, function(o) {
    if (o) return n(o);
    i = !0, n();
  });
  var a = !1;
  return function(o) {
    if (!i && !a) {
      if (a = !0, fZ(r)) return r.abort();
      if (typeof r.destroy == "function") return r.destroy();
      n(o || new cZ("pipe"));
    }
  };
}
function X6(r) {
  r();
}
function dZ(r, e) {
  return r.pipe(e);
}
function pZ(r) {
  return !r.length || typeof r[r.length - 1] != "function" ? q6 : r.pop();
}
function vZ() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  var n = pZ(e);
  if (Array.isArray(e[0]) && (e = e[0]), e.length < 2)
    throw new lZ("streams");
  var i, a = e.map(function(o, s) {
    var c = s < e.length - 1, h = s > 0;
    return hZ(o, c, h, function(d) {
      i || (i = d), d && a.forEach(X6), !c && (a.forEach(X6), n(i));
    });
  });
  return e.reduce(dZ);
}
var gZ = vZ;
(function(r, e) {
  var t = lf;
  e = r.exports = t.Readable, e.Stream = t.Readable, e.Readable = t.Readable, e.Writable = t.Writable, e.Duplex = t.Duplex, e.Transform = t.Transform, e.PassThrough = t.PassThrough, e.finished = pg, e.pipeline = gZ;
})(Dd, Dd.exports);
var XE = Dd.exports, Ec = {}, KE = {}, c2 = { exports: {} }, Ag = {}, Rl = {}, JE = {}, QE = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, t = Symbol("test"), n = Object(t);
  if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var i = 42;
  e[t] = i;
  for (t in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var a = Object.getOwnPropertySymbols(e);
  if (a.length !== 1 || a[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var o = Object.getOwnPropertyDescriptor(e, t);
    if (o.value !== i || o.enumerable !== !0)
      return !1;
  }
  return !0;
}, K6 = typeof Symbol < "u" && Symbol, mZ = QE, yZ = function() {
  return typeof K6 != "function" || typeof Symbol != "function" || typeof K6("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : mZ();
}, bZ = "Function.prototype.bind called on incompatible ", d4 = Array.prototype.slice, wZ = Object.prototype.toString, AZ = "[object Function]", xZ = function(e) {
  var t = this;
  if (typeof t != "function" || wZ.call(t) !== AZ)
    throw new TypeError(bZ + t);
  for (var n = d4.call(arguments, 1), i, a = function() {
    if (this instanceof i) {
      var g = t.apply(this, n.concat(d4.call(arguments)));
      return Object(g) === g ? g : this;
    } else
      return t.apply(e, n.concat(d4.call(arguments)));
  }, o = Math.max(0, t.length - n.length), s = [], c = 0; c < o; c++)
    s.push("$" + c);
  if (i = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(a), t.prototype) {
    var h = function() {
    };
    h.prototype = t.prototype, i.prototype = new h(), h.prototype = null;
  }
  return i;
}, EZ = xZ, xg = Function.prototype.bind || EZ, _Z = xg, DZ = _Z.call(Function.call, Object.prototype.hasOwnProperty), xr, L1 = SyntaxError, e_ = Function, Uc = TypeError, p4 = function(e) {
  try {
    return e_('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, dl = Object.getOwnPropertyDescriptor;
if (dl)
  try {
    dl({}, "");
  } catch {
    dl = null;
  }
var v4 = function() {
  throw new Uc();
}, TZ = dl ? function() {
  try {
    return arguments.callee, v4;
  } catch {
    try {
      return dl(arguments, "callee").get;
    } catch {
      return v4;
    }
  }
}() : v4, lc = yZ(), Ms = Object.getPrototypeOf || function(r) {
  return r.__proto__;
}, yc = {}, kZ = typeof Uint8Array > "u" ? xr : Ms(Uint8Array), $c = {
  "%AggregateError%": typeof AggregateError > "u" ? xr : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? xr : ArrayBuffer,
  "%ArrayIteratorPrototype%": lc ? Ms([][Symbol.iterator]()) : xr,
  "%AsyncFromSyncIteratorPrototype%": xr,
  "%AsyncFunction%": yc,
  "%AsyncGenerator%": yc,
  "%AsyncGeneratorFunction%": yc,
  "%AsyncIteratorPrototype%": yc,
  "%Atomics%": typeof Atomics > "u" ? xr : Atomics,
  "%BigInt%": typeof BigInt > "u" ? xr : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? xr : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? xr : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? xr : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? xr : FinalizationRegistry,
  "%Function%": e_,
  "%GeneratorFunction%": yc,
  "%Int8Array%": typeof Int8Array > "u" ? xr : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? xr : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? xr : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": lc ? Ms(Ms([][Symbol.iterator]())) : xr,
  "%JSON%": typeof JSON == "object" ? JSON : xr,
  "%Map%": typeof Map > "u" ? xr : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !lc ? xr : Ms((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? xr : Promise,
  "%Proxy%": typeof Proxy > "u" ? xr : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? xr : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? xr : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !lc ? xr : Ms((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? xr : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": lc ? Ms(""[Symbol.iterator]()) : xr,
  "%Symbol%": lc ? Symbol : xr,
  "%SyntaxError%": L1,
  "%ThrowTypeError%": TZ,
  "%TypedArray%": kZ,
  "%TypeError%": Uc,
  "%Uint8Array%": typeof Uint8Array > "u" ? xr : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? xr : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? xr : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? xr : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? xr : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? xr : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? xr : WeakSet
}, SZ = function r(e) {
  var t;
  if (e === "%AsyncFunction%")
    t = p4("async function () {}");
  else if (e === "%GeneratorFunction%")
    t = p4("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    t = p4("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = r("%AsyncGeneratorFunction%");
    n && (t = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var i = r("%AsyncGenerator%");
    i && (t = Ms(i.prototype));
  }
  return $c[e] = t, t;
}, J6 = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, S5 = xg, kd = DZ, CZ = S5.call(Function.call, Array.prototype.concat), FZ = S5.call(Function.apply, Array.prototype.splice), Q6 = S5.call(Function.call, String.prototype.replace), Sd = S5.call(Function.call, String.prototype.slice), OZ = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, RZ = /\\(\\)?/g, IZ = function(e) {
  var t = Sd(e, 0, 1), n = Sd(e, -1);
  if (t === "%" && n !== "%")
    throw new L1("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && t !== "%")
    throw new L1("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return Q6(e, OZ, function(a, o, s, c) {
    i[i.length] = s ? Q6(c, RZ, "$1") : o || a;
  }), i;
}, PZ = function(e, t) {
  var n = e, i;
  if (kd(J6, n) && (i = J6[n], n = "%" + i[0] + "%"), kd($c, n)) {
    var a = $c[n];
    if (a === yc && (a = SZ(n)), typeof a > "u" && !t)
      throw new Uc("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: n,
      value: a
    };
  }
  throw new L1("intrinsic " + e + " does not exist!");
}, Eg = function(e, t) {
  if (typeof e != "string" || e.length === 0)
    throw new Uc("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof t != "boolean")
    throw new Uc('"allowMissing" argument must be a boolean');
  var n = IZ(e), i = n.length > 0 ? n[0] : "", a = PZ("%" + i + "%", t), o = a.name, s = a.value, c = !1, h = a.alias;
  h && (i = h[0], FZ(n, CZ([0, 1], h)));
  for (var d = 1, g = !0; d < n.length; d += 1) {
    var x = n[d], _ = Sd(x, 0, 1), k = Sd(x, -1);
    if ((_ === '"' || _ === "'" || _ === "`" || k === '"' || k === "'" || k === "`") && _ !== k)
      throw new L1("property names with quotes must have matching quotes");
    if ((x === "constructor" || !g) && (c = !0), i += "." + x, o = "%" + i + "%", kd($c, o))
      s = $c[o];
    else if (s != null) {
      if (!(x in s)) {
        if (!t)
          throw new Uc("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (dl && d + 1 >= n.length) {
        var P = dl(s, x);
        g = !!P, g && "get" in P && !("originalValue" in P.get) ? s = P.get : s = s[x];
      } else
        g = kd(s, x), s = s[x];
      g && !c && ($c[o] = s);
    }
  }
  return s;
}, C5 = { exports: {} };
(function(r) {
  var e = xg, t = Eg, n = t("%Function.prototype.apply%"), i = t("%Function.prototype.call%"), a = t("%Reflect.apply%", !0) || e.call(i, n), o = t("%Object.getOwnPropertyDescriptor%", !0), s = t("%Object.defineProperty%", !0), c = t("%Math.max%");
  if (s)
    try {
      s({}, "a", {
        value: 1
      });
    } catch {
      s = null;
    }
  r.exports = function(g) {
    var x = a(e, i, arguments);
    if (o && s) {
      var _ = o(x, "length");
      _.configurable && s(x, "length", {
        value: 1 + c(0, g.length - (arguments.length - 1))
      });
    }
    return x;
  };
  var h = function() {
    return a(e, n, arguments);
  };
  s ? s(r.exports, "apply", {
    value: h
  }) : r.exports.apply = h;
})(C5);
var t_ = Eg, r_ = C5.exports, BZ = r_(t_("String.prototype.indexOf")), _g = function(e, t) {
  var n = t_(e, !!t);
  return typeof n == "function" && BZ(e, ".prototype.") > -1 ? r_(n) : n;
}, NZ = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol", LZ = _g, z3 = LZ("Object.prototype.toString"), F5 = function(e) {
  return NZ && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : z3(e) === "[object Arguments]";
}, n_ = function(e) {
  return F5(e) ? !0 : e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && z3(e) !== "[object Array]" && z3(e.callee) === "[object Function]";
}, MZ = function() {
  return F5(arguments);
}();
F5.isLegacyArguments = n_;
var UZ = MZ ? F5 : n_, $Z = QE, Dg = function() {
  return $Z() && !!Symbol.toStringTag;
}, zZ = Object.prototype.toString, jZ = Function.prototype.toString, WZ = /^\s*(?:function)?\*/, i_ = Dg(), g4 = Object.getPrototypeOf, GZ = function() {
  if (!i_)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, m4, VZ = function(e) {
  if (typeof e != "function")
    return !1;
  if (WZ.test(jZ.call(e)))
    return !0;
  if (!i_) {
    var t = zZ.call(e);
    return t === "[object GeneratorFunction]";
  }
  if (!g4)
    return !1;
  if (typeof m4 > "u") {
    var n = GZ();
    m4 = n ? g4(n) : !1;
  }
  return g4(e) === m4;
}, YZ = Object.prototype.hasOwnProperty, HZ = Object.prototype.toString, a_ = function(e, t, n) {
  if (HZ.call(t) !== "[object Function]")
    throw new TypeError("iterator must be a function");
  var i = e.length;
  if (i === +i)
    for (var a = 0; a < i; a++)
      t.call(n, e[a], a, e);
  else
    for (var o in e)
      YZ.call(e, o) && t.call(n, e[o], o, e);
}, y4 = ["BigInt64Array", "BigUint64Array", "Float32Array", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray"], ZZ = typeof globalThis > "u" ? wl : globalThis, o_ = function() {
  for (var e = [], t = 0; t < y4.length; t++)
    typeof ZZ[y4[t]] == "function" && (e[e.length] = y4[t]);
  return e;
}, qZ = Eg, Gh = qZ("%Object.getOwnPropertyDescriptor%", !0);
if (Gh)
  try {
    Gh([], "length");
  } catch {
    Gh = null;
  }
var s_ = Gh, u_ = a_, XZ = o_, Tg = _g, KZ = Tg("Object.prototype.toString"), l_ = Dg(), JZ = typeof globalThis > "u" ? wl : globalThis, c_ = XZ(), QZ = Tg("Array.prototype.indexOf", !0) || function(e, t) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n] === t)
      return n;
  return -1;
}, eq = Tg("String.prototype.slice"), f_ = {}, Vh = s_, b4 = Object.getPrototypeOf;
l_ && Vh && b4 && u_(c_, function(r) {
  var e = new JZ[r]();
  if (Symbol.toStringTag in e) {
    var t = b4(e), n = Vh(t, Symbol.toStringTag);
    if (!n) {
      var i = b4(t);
      n = Vh(i, Symbol.toStringTag);
    }
    f_[r] = n.get;
  }
});
var tq = function(e) {
  var t = !1;
  return u_(f_, function(n, i) {
    if (!t)
      try {
        t = n.call(e) === i;
      } catch {
      }
  }), t;
}, h_ = function(e) {
  if (!e || typeof e != "object")
    return !1;
  if (!l_ || !(Symbol.toStringTag in e)) {
    var t = eq(KZ(e), 8, -1);
    return QZ(c_, t) > -1;
  }
  return Vh ? tq(e) : !1;
}, d_ = a_, rq = o_, p_ = _g, nq = p_("Object.prototype.toString"), v_ = Dg(), e8 = typeof globalThis > "u" ? wl : globalThis, iq = rq(), aq = p_("String.prototype.slice"), g_ = {}, w4 = s_, A4 = Object.getPrototypeOf;
v_ && w4 && A4 && d_(iq, function(r) {
  if (typeof e8[r] == "function") {
    var e = new e8[r]();
    if (Symbol.toStringTag in e) {
      var t = A4(e), n = w4(t, Symbol.toStringTag);
      if (!n) {
        var i = A4(t);
        n = w4(i, Symbol.toStringTag);
      }
      g_[r] = n.get;
    }
  }
});
var oq = function(e) {
  var t = !1;
  return d_(g_, function(n, i) {
    if (!t)
      try {
        var a = n.call(e);
        a === i && (t = a);
      } catch {
      }
  }), t;
}, sq = h_, uq = function(e) {
  return sq(e) ? !v_ || !(Symbol.toStringTag in e) ? aq(nq(e), 8, -1) : oq(e) : !1;
};
(function(r) {
  var e = UZ, t = VZ, n = uq, i = h_;
  function a(T) {
    return T.call.bind(T);
  }
  var o = typeof BigInt < "u", s = typeof Symbol < "u", c = a(Object.prototype.toString), h = a(Number.prototype.valueOf), d = a(String.prototype.valueOf), g = a(Boolean.prototype.valueOf);
  if (o)
    var x = a(BigInt.prototype.valueOf);
  if (s)
    var _ = a(Symbol.prototype.valueOf);
  function k(T, V) {
    if (typeof T != "object")
      return !1;
    try {
      return V(T), !0;
    } catch {
      return !1;
    }
  }
  r.isArgumentsObject = e, r.isGeneratorFunction = t, r.isTypedArray = i;
  function P(T) {
    return typeof Promise < "u" && T instanceof Promise || T !== null && typeof T == "object" && typeof T.then == "function" && typeof T.catch == "function";
  }
  r.isPromise = P;
  function N(T) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(T) : i(T) || Z(T);
  }
  r.isArrayBufferView = N;
  function M(T) {
    return n(T) === "Uint8Array";
  }
  r.isUint8Array = M;
  function G(T) {
    return n(T) === "Uint8ClampedArray";
  }
  r.isUint8ClampedArray = G;
  function z(T) {
    return n(T) === "Uint16Array";
  }
  r.isUint16Array = z;
  function j(T) {
    return n(T) === "Uint32Array";
  }
  r.isUint32Array = j;
  function R(T) {
    return n(T) === "Int8Array";
  }
  r.isInt8Array = R;
  function te(T) {
    return n(T) === "Int16Array";
  }
  r.isInt16Array = te;
  function J(T) {
    return n(T) === "Int32Array";
  }
  r.isInt32Array = J;
  function K(T) {
    return n(T) === "Float32Array";
  }
  r.isFloat32Array = K;
  function ee(T) {
    return n(T) === "Float64Array";
  }
  r.isFloat64Array = ee;
  function ve(T) {
    return n(T) === "BigInt64Array";
  }
  r.isBigInt64Array = ve;
  function de(T) {
    return n(T) === "BigUint64Array";
  }
  r.isBigUint64Array = de;
  function B(T) {
    return c(T) === "[object Map]";
  }
  B.working = typeof Map < "u" && B(/* @__PURE__ */ new Map());
  function q(T) {
    return typeof Map > "u" ? !1 : B.working ? B(T) : T instanceof Map;
  }
  r.isMap = q;
  function H(T) {
    return c(T) === "[object Set]";
  }
  H.working = typeof Set < "u" && H(/* @__PURE__ */ new Set());
  function oe(T) {
    return typeof Set > "u" ? !1 : H.working ? H(T) : T instanceof Set;
  }
  r.isSet = oe;
  function ne(T) {
    return c(T) === "[object WeakMap]";
  }
  ne.working = typeof WeakMap < "u" && ne(/* @__PURE__ */ new WeakMap());
  function me(T) {
    return typeof WeakMap > "u" ? !1 : ne.working ? ne(T) : T instanceof WeakMap;
  }
  r.isWeakMap = me;
  function fe(T) {
    return c(T) === "[object WeakSet]";
  }
  fe.working = typeof WeakSet < "u" && fe(/* @__PURE__ */ new WeakSet());
  function _e(T) {
    return fe(T);
  }
  r.isWeakSet = _e;
  function Re(T) {
    return c(T) === "[object ArrayBuffer]";
  }
  Re.working = typeof ArrayBuffer < "u" && Re(new ArrayBuffer());
  function Ie(T) {
    return typeof ArrayBuffer > "u" ? !1 : Re.working ? Re(T) : T instanceof ArrayBuffer;
  }
  r.isArrayBuffer = Ie;
  function W(T) {
    return c(T) === "[object DataView]";
  }
  W.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && W(new DataView(new ArrayBuffer(1), 0, 1));
  function Z(T) {
    return typeof DataView > "u" ? !1 : W.working ? W(T) : T instanceof DataView;
  }
  r.isDataView = Z;
  var se = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function ye(T) {
    return c(T) === "[object SharedArrayBuffer]";
  }
  function Fe(T) {
    return typeof se > "u" ? !1 : (typeof ye.working > "u" && (ye.working = ye(new se())), ye.working ? ye(T) : T instanceof se);
  }
  r.isSharedArrayBuffer = Fe;
  function xe(T) {
    return c(T) === "[object AsyncFunction]";
  }
  r.isAsyncFunction = xe;
  function be(T) {
    return c(T) === "[object Map Iterator]";
  }
  r.isMapIterator = be;
  function he(T) {
    return c(T) === "[object Set Iterator]";
  }
  r.isSetIterator = he;
  function ke(T) {
    return c(T) === "[object Generator]";
  }
  r.isGeneratorObject = ke;
  function De(T) {
    return c(T) === "[object WebAssembly.Module]";
  }
  r.isWebAssemblyCompiledModule = De;
  function Qe(T) {
    return k(T, h);
  }
  r.isNumberObject = Qe;
  function ct(T) {
    return k(T, d);
  }
  r.isStringObject = ct;
  function pt(T) {
    return k(T, g);
  }
  r.isBooleanObject = pt;
  function _t(T) {
    return o && k(T, x);
  }
  r.isBigIntObject = _t;
  function S(T) {
    return s && k(T, _);
  }
  r.isSymbolObject = S;
  function b(T) {
    return Qe(T) || ct(T) || pt(T) || _t(T) || S(T);
  }
  r.isBoxedPrimitive = b;
  function w(T) {
    return typeof Uint8Array < "u" && (Ie(T) || Fe(T));
  }
  r.isAnyArrayBuffer = w, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(T) {
    Object.defineProperty(r, T, {
      enumerable: !1,
      value: function() {
        throw new Error(T + " is not supported in userland");
      }
    });
  });
})(JE);
var lq = function(e) {
  return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
};
(function(r) {
  var e = Object.getOwnPropertyDescriptors || function(Z) {
    for (var se = Object.keys(Z), ye = {}, Fe = 0; Fe < se.length; Fe++)
      ye[se[Fe]] = Object.getOwnPropertyDescriptor(Z, se[Fe]);
    return ye;
  }, t = /%[sdj%]/g;
  r.format = function(W) {
    if (!R(W)) {
      for (var Z = [], se = 0; se < arguments.length; se++)
        Z.push(o(arguments[se]));
      return Z.join(" ");
    }
    for (var se = 1, ye = arguments, Fe = ye.length, xe = String(W).replace(t, function(he) {
      if (he === "%%") return "%";
      if (se >= Fe) return he;
      switch (he) {
        case "%s":
          return String(ye[se++]);
        case "%d":
          return Number(ye[se++]);
        case "%j":
          try {
            return JSON.stringify(ye[se++]);
          } catch {
            return "[Circular]";
          }
        default:
          return he;
      }
    }), be = ye[se]; se < Fe; be = ye[++se])
      G(be) || !ee(be) ? xe += " " + be : xe += " " + o(be);
    return xe;
  }, r.deprecate = function(W, Z) {
    if (typeof ir < "u" && ir.noDeprecation === !0)
      return W;
    if (typeof ir > "u")
      return function() {
        return r.deprecate(W, Z).apply(this, arguments);
      };
    var se = !1;
    function ye() {
      return se || (console.error(Z), se = !0), W.apply(this, arguments);
    }
    return ye;
  };
  var n = {}, i = /^$/;
  if (ir.env.NODE_DEBUG) {
    var a = ir.env.NODE_DEBUG;
    a = a.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = new RegExp("^" + a + "$", "i");
  }
  r.debuglog = function(W) {
    if (W = W.toUpperCase(), !n[W])
      if (i.test(W)) {
        var Z = ir.pid;
        n[W] = function() {
          var se = r.format.apply(r, arguments);
          console.error("%s %d: %s", W, Z, se);
        };
      } else
        n[W] = function() {
        };
    return n[W];
  };
  function o(W, Z) {
    var se = {
      seen: [],
      stylize: c
    };
    return arguments.length >= 3 && (se.depth = arguments[2]), arguments.length >= 4 && (se.colors = arguments[3]), M(Z) ? se.showHidden = Z : Z && r._extend(se, Z), J(se.showHidden) && (se.showHidden = !1), J(se.depth) && (se.depth = 2), J(se.colors) && (se.colors = !1), J(se.customInspect) && (se.customInspect = !0), se.colors && (se.stylize = s), d(se, W, se.depth);
  }
  r.inspect = o, o.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, o.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function s(W, Z) {
    var se = o.styles[Z];
    return se ? "\x1B[" + o.colors[se][0] + "m" + W + "\x1B[" + o.colors[se][1] + "m" : W;
  }
  function c(W, Z) {
    return W;
  }
  function h(W) {
    var Z = {};
    return W.forEach(function(se, ye) {
      Z[se] = !0;
    }), Z;
  }
  function d(W, Z, se) {
    if (W.customInspect && Z && B(Z.inspect) && // Filter out the util module, it's inspect function is special
    Z.inspect !== r.inspect && // Also filter out any prototype objects using the circular check.
    !(Z.constructor && Z.constructor.prototype === Z)) {
      var ye = Z.inspect(se, W);
      return R(ye) || (ye = d(W, ye, se)), ye;
    }
    var Fe = g(W, Z);
    if (Fe)
      return Fe;
    var xe = Object.keys(Z), be = h(xe);
    if (W.showHidden && (xe = Object.getOwnPropertyNames(Z)), de(Z) && (xe.indexOf("message") >= 0 || xe.indexOf("description") >= 0))
      return x(Z);
    if (xe.length === 0) {
      if (B(Z)) {
        var he = Z.name ? ": " + Z.name : "";
        return W.stylize("[Function" + he + "]", "special");
      }
      if (K(Z))
        return W.stylize(RegExp.prototype.toString.call(Z), "regexp");
      if (ve(Z))
        return W.stylize(Date.prototype.toString.call(Z), "date");
      if (de(Z))
        return x(Z);
    }
    var ke = "", De = !1, Qe = ["{", "}"];
    if (N(Z) && (De = !0, Qe = ["[", "]"]), B(Z)) {
      var ct = Z.name ? ": " + Z.name : "";
      ke = " [Function" + ct + "]";
    }
    if (K(Z) && (ke = " " + RegExp.prototype.toString.call(Z)), ve(Z) && (ke = " " + Date.prototype.toUTCString.call(Z)), de(Z) && (ke = " " + x(Z)), xe.length === 0 && (!De || Z.length == 0))
      return Qe[0] + ke + Qe[1];
    if (se < 0)
      return K(Z) ? W.stylize(RegExp.prototype.toString.call(Z), "regexp") : W.stylize("[Object]", "special");
    W.seen.push(Z);
    var pt;
    return De ? pt = _(W, Z, se, be, xe) : pt = xe.map(function(_t) {
      return k(W, Z, se, be, _t, De);
    }), W.seen.pop(), P(pt, ke, Qe);
  }
  function g(W, Z) {
    if (J(Z)) return W.stylize("undefined", "undefined");
    if (R(Z)) {
      var se = "'" + JSON.stringify(Z).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return W.stylize(se, "string");
    }
    if (j(Z)) return W.stylize("" + Z, "number");
    if (M(Z)) return W.stylize("" + Z, "boolean");
    if (G(Z)) return W.stylize("null", "null");
  }
  function x(W) {
    return "[" + Error.prototype.toString.call(W) + "]";
  }
  function _(W, Z, se, ye, Fe) {
    for (var xe = [], be = 0, he = Z.length; be < he; ++be)
      fe(Z, String(be)) ? xe.push(k(W, Z, se, ye, String(be), !0)) : xe.push("");
    return Fe.forEach(function(ke) {
      ke.match(/^\d+$/) || xe.push(k(W, Z, se, ye, ke, !0));
    }), xe;
  }
  function k(W, Z, se, ye, Fe, xe) {
    var be, he, ke;
    if (ke = Object.getOwnPropertyDescriptor(Z, Fe) || {
      value: Z[Fe]
    }, ke.get ? ke.set ? he = W.stylize("[Getter/Setter]", "special") : he = W.stylize("[Getter]", "special") : ke.set && (he = W.stylize("[Setter]", "special")), fe(ye, Fe) || (be = "[" + Fe + "]"), he || (W.seen.indexOf(ke.value) < 0 ? (G(se) ? he = d(W, ke.value, null) : he = d(W, ke.value, se - 1), he.indexOf(`
`) > -1 && (xe ? he = he.split(`
`).map(function(De) {
      return "  " + De;
    }).join(`
`).substr(2) : he = `
` + he.split(`
`).map(function(De) {
      return "   " + De;
    }).join(`
`))) : he = W.stylize("[Circular]", "special")), J(be)) {
      if (xe && Fe.match(/^\d+$/))
        return he;
      be = JSON.stringify("" + Fe), be.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (be = be.substr(1, be.length - 2), be = W.stylize(be, "name")) : (be = be.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), be = W.stylize(be, "string"));
    }
    return be + ": " + he;
  }
  function P(W, Z, se) {
    var ye = W.reduce(function(Fe, xe) {
      return xe.indexOf(`
`) >= 0, Fe + xe.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return ye > 60 ? se[0] + (Z === "" ? "" : Z + `
 `) + " " + W.join(`,
  `) + " " + se[1] : se[0] + Z + " " + W.join(", ") + " " + se[1];
  }
  r.types = JE;
  function N(W) {
    return Array.isArray(W);
  }
  r.isArray = N;
  function M(W) {
    return typeof W == "boolean";
  }
  r.isBoolean = M;
  function G(W) {
    return W === null;
  }
  r.isNull = G;
  function z(W) {
    return W == null;
  }
  r.isNullOrUndefined = z;
  function j(W) {
    return typeof W == "number";
  }
  r.isNumber = j;
  function R(W) {
    return typeof W == "string";
  }
  r.isString = R;
  function te(W) {
    return typeof W == "symbol";
  }
  r.isSymbol = te;
  function J(W) {
    return W === void 0;
  }
  r.isUndefined = J;
  function K(W) {
    return ee(W) && H(W) === "[object RegExp]";
  }
  r.isRegExp = K, r.types.isRegExp = K;
  function ee(W) {
    return typeof W == "object" && W !== null;
  }
  r.isObject = ee;
  function ve(W) {
    return ee(W) && H(W) === "[object Date]";
  }
  r.isDate = ve, r.types.isDate = ve;
  function de(W) {
    return ee(W) && (H(W) === "[object Error]" || W instanceof Error);
  }
  r.isError = de, r.types.isNativeError = de;
  function B(W) {
    return typeof W == "function";
  }
  r.isFunction = B;
  function q(W) {
    return W === null || typeof W == "boolean" || typeof W == "number" || typeof W == "string" || typeof W == "symbol" || // ES6 symbol
    typeof W > "u";
  }
  r.isPrimitive = q, r.isBuffer = lq;
  function H(W) {
    return Object.prototype.toString.call(W);
  }
  function oe(W) {
    return W < 10 ? "0" + W.toString(10) : W.toString(10);
  }
  var ne = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function me() {
    var W = /* @__PURE__ */ new Date(), Z = [oe(W.getHours()), oe(W.getMinutes()), oe(W.getSeconds())].join(":");
    return [W.getDate(), ne[W.getMonth()], Z].join(" ");
  }
  r.log = function() {
    console.log("%s - %s", me(), r.format.apply(r, arguments));
  }, r.inherits = uu.exports, r._extend = function(W, Z) {
    if (!Z || !ee(Z)) return W;
    for (var se = Object.keys(Z), ye = se.length; ye--; )
      W[se[ye]] = Z[se[ye]];
    return W;
  };
  function fe(W, Z) {
    return Object.prototype.hasOwnProperty.call(W, Z);
  }
  var _e = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  r.promisify = function(Z) {
    if (typeof Z != "function") throw new TypeError('The "original" argument must be of type Function');
    if (_e && Z[_e]) {
      var se = Z[_e];
      if (typeof se != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(se, _e, {
        value: se,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), se;
    }
    function se() {
      for (var ye, Fe, xe = new Promise(function(ke, De) {
        ye = ke, Fe = De;
      }), be = [], he = 0; he < arguments.length; he++)
        be.push(arguments[he]);
      be.push(function(ke, De) {
        ke ? Fe(ke) : ye(De);
      });
      try {
        Z.apply(this, be);
      } catch (ke) {
        Fe(ke);
      }
      return xe;
    }
    return Object.setPrototypeOf(se, Object.getPrototypeOf(Z)), _e && Object.defineProperty(se, _e, {
      value: se,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(se, e(Z));
  }, r.promisify.custom = _e;
  function Re(W, Z) {
    if (!W) {
      var se = new Error("Promise was rejected with a falsy value");
      se.reason = W, W = se;
    }
    return Z(W);
  }
  function Ie(W) {
    if (typeof W != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function Z() {
      for (var se = [], ye = 0; ye < arguments.length; ye++)
        se.push(arguments[ye]);
      var Fe = se.pop();
      if (typeof Fe != "function")
        throw new TypeError("The last argument must be of type Function");
      var xe = this, be = function() {
        return Fe.apply(xe, arguments);
      };
      W.apply(this, se).then(function(he) {
        ir.nextTick(be.bind(null, null, he));
      }, function(he) {
        ir.nextTick(Re.bind(null, he, be));
      });
    }
    return Object.setPrototypeOf(Z, Object.getPrototypeOf(W)), Object.defineProperties(Z, e(W)), Z;
  }
  r.callbackify = Ie;
})(Rl);
function zc(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? zc = function(t) {
    return typeof t;
  } : zc = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zc(r);
}
function cq(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function fq(r, e) {
  return e && (zc(e) === "object" || typeof e == "function") ? e : hq(r);
}
function hq(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function j3(r) {
  return j3 = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, j3(r);
}
function dq(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), e && W3(r, e);
}
function W3(r, e) {
  return W3 = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, W3(r, e);
}
var m_ = {}, jc, x4;
function f2(r, e, t) {
  t || (t = Error);
  function n(a, o, s) {
    return typeof e == "string" ? e : e(a, o, s);
  }
  var i = /* @__PURE__ */ function(a) {
    dq(o, a);
    function o(s, c, h) {
      var d;
      return cq(this, o), d = fq(this, j3(o).call(this, n(s, c, h))), d.code = r, d;
    }
    return o;
  }(t);
  m_[r] = i;
}
function t8(r, e) {
  if (Array.isArray(r)) {
    var t = r.length;
    return r = r.map(function(n) {
      return String(n);
    }), t > 2 ? "one of ".concat(e, " ").concat(r.slice(0, t - 1).join(", "), ", or ") + r[t - 1] : t === 2 ? "one of ".concat(e, " ").concat(r[0], " or ").concat(r[1]) : "of ".concat(e, " ").concat(r[0]);
  } else
    return "of ".concat(e, " ").concat(String(r));
}
function pq(r, e, t) {
  return r.substr(0, e.length) === e;
}
function vq(r, e, t) {
  return (t === void 0 || t > r.length) && (t = r.length), r.substring(t - e.length, t) === e;
}
function gq(r, e, t) {
  return typeof t != "number" && (t = 0), t + e.length > r.length ? !1 : r.indexOf(e, t) !== -1;
}
f2("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
f2("ERR_INVALID_ARG_TYPE", function(r, e, t) {
  jc === void 0 && (jc = c2.exports), jc(typeof r == "string", "'name' must be a string");
  var n;
  typeof e == "string" && pq(e, "not ") ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be";
  var i;
  if (vq(r, " argument"))
    i = "The ".concat(r, " ").concat(n, " ").concat(t8(e, "type"));
  else {
    var a = gq(r, ".") ? "property" : "argument";
    i = 'The "'.concat(r, '" ').concat(a, " ").concat(n, " ").concat(t8(e, "type"));
  }
  return i += ". Received type ".concat(zc(t)), i;
}, TypeError);
f2("ERR_INVALID_ARG_VALUE", function(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
  x4 === void 0 && (x4 = Rl);
  var n = x4.inspect(e);
  return n.length > 128 && (n = "".concat(n.slice(0, 128), "...")), "The argument '".concat(r, "' ").concat(t, ". Received ").concat(n);
}, TypeError);
f2("ERR_INVALID_RETURN_VALUE", function(r, e, t) {
  var n;
  return t && t.constructor && t.constructor.name ? n = "instance of ".concat(t.constructor.name) : n = "type ".concat(zc(t)), "Expected ".concat(r, ' to be returned from the "').concat(e, '"') + " function but got ".concat(n, ".");
}, TypeError);
f2("ERR_MISSING_ARGS", function() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  jc === void 0 && (jc = c2.exports), jc(e.length > 0, "At least one arg needs to be specified");
  var n = "The ", i = e.length;
  switch (e = e.map(function(a) {
    return '"'.concat(a, '"');
  }), i) {
    case 1:
      n += "".concat(e[0], " argument");
      break;
    case 2:
      n += "".concat(e[0], " and ").concat(e[1], " arguments");
      break;
    default:
      n += e.slice(0, i - 1).join(", "), n += ", and ".concat(e[i - 1], " arguments");
      break;
  }
  return "".concat(n, " must be specified");
}, TypeError);
Ag.codes = m_;
function mq(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {}, n = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    }))), n.forEach(function(i) {
      yq(r, i, t[i]);
    });
  }
  return r;
}
function yq(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function bq(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function wq(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function Aq(r, e, t) {
  return e && wq(r.prototype, e), r;
}
function cc(r, e) {
  return e && (ra(e) === "object" || typeof e == "function") ? e : G3(r);
}
function G3(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function xq(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), e && M1(r, e);
}
function V3(r) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return V3 = function(n) {
    if (n === null || !_q(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(n)) return e.get(n);
      e.set(n, i);
    }
    function i() {
      return Yh(n, arguments, js(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), M1(i, n);
  }, V3(r);
}
function Eq() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Yh(r, e, t) {
  return Eq() ? Yh = Reflect.construct : Yh = function(i, a, o) {
    var s = [null];
    s.push.apply(s, a);
    var c = Function.bind.apply(i, s), h = new c();
    return o && M1(h, o.prototype), h;
  }, Yh.apply(null, arguments);
}
function _q(r) {
  return Function.toString.call(r).indexOf("[native code]") !== -1;
}
function M1(r, e) {
  return M1 = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, M1(r, e);
}
function js(r) {
  return js = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, js(r);
}
function ra(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ra = function(t) {
    return typeof t;
  } : ra = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ra(r);
}
var Dq = Rl, Y3 = Dq.inspect, Tq = Ag, kq = Tq.codes.ERR_INVALID_ARG_TYPE;
function r8(r, e, t) {
  return (t === void 0 || t > r.length) && (t = r.length), r.substring(t - e.length, t) === e;
}
function Sq(r, e) {
  if (e = Math.floor(e), r.length == 0 || e == 0) return "";
  var t = r.length * e;
  for (e = Math.floor(Math.log(e) / Math.log(2)); e; )
    r += r, e--;
  return r += r.substring(0, t - r.length), r;
}
var Wo = "", E4 = "", _4 = "", Zn = "", ul = {
  deepStrictEqual: "Expected values to be strictly deep-equal:",
  strictEqual: "Expected values to be strictly equal:",
  strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
  deepEqual: "Expected values to be loosely deep-equal:",
  equal: "Expected values to be loosely equal:",
  notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
  notStrictEqual: 'Expected "actual" to be strictly unequal to:',
  notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
  notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
  notEqual: 'Expected "actual" to be loosely unequal to:',
  notIdentical: "Values identical but not reference-equal:"
}, Cq = 10;
function n8(r) {
  var e = Object.keys(r), t = Object.create(Object.getPrototypeOf(r));
  return e.forEach(function(n) {
    t[n] = r[n];
  }), Object.defineProperty(t, "message", {
    value: r.message
  }), t;
}
function d1(r) {
  return Y3(r, {
    compact: !1,
    customInspect: !1,
    depth: 1e3,
    maxArrayLength: 1 / 0,
    // Assert compares only enumerable properties (with a few exceptions).
    showHidden: !1,
    // Having a long line as error is better than wrapping the line for
    // comparison for now.
    // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
    // have meta information about the inspected properties (i.e., know where
    // in what line the property starts and ends).
    breakLength: 1 / 0,
    // Assert does not detect proxies currently.
    showProxy: !1,
    sorted: !0,
    // Inspect getters as we also check them when comparing entries.
    getters: !0
  });
}
function Fq(r, e, t) {
  var n = "", i = "", a = 0, o = "", s = !1, c = d1(r), h = c.split(`
`), d = d1(e).split(`
`), g = 0, x = "";
  if (t === "strictEqual" && ra(r) === "object" && ra(e) === "object" && r !== null && e !== null && (t = "strictEqualObject"), h.length === 1 && d.length === 1 && h[0] !== d[0]) {
    var _ = h[0].length + d[0].length;
    if (_ <= Cq) {
      if ((ra(r) !== "object" || r === null) && (ra(e) !== "object" || e === null) && (r !== 0 || e !== 0))
        return "".concat(ul[t], `

`) + "".concat(h[0], " !== ").concat(d[0], `
`);
    } else if (t !== "strictEqualObject") {
      var k = 80;
      if (_ < k) {
        for (; h[0][g] === d[0][g]; )
          g++;
        g > 2 && (x = `
  `.concat(Sq(" ", g), "^"), g = 0);
      }
    }
  }
  for (var P = h[h.length - 1], N = d[d.length - 1]; P === N && (g++ < 2 ? o = `
  `.concat(P).concat(o) : n = P, h.pop(), d.pop(), !(h.length === 0 || d.length === 0)); )
    P = h[h.length - 1], N = d[d.length - 1];
  var M = Math.max(h.length, d.length);
  if (M === 0) {
    var G = c.split(`
`);
    if (G.length > 30)
      for (G[26] = "".concat(Wo, "...").concat(Zn); G.length > 27; )
        G.pop();
    return "".concat(ul.notIdentical, `

`).concat(G.join(`
`), `
`);
  }
  g > 3 && (o = `
`.concat(Wo, "...").concat(Zn).concat(o), s = !0), n !== "" && (o = `
  `.concat(n).concat(o), n = "");
  var z = 0, j = ul[t] + `
`.concat(E4, "+ actual").concat(Zn, " ").concat(_4, "- expected").concat(Zn), R = " ".concat(Wo, "...").concat(Zn, " Lines skipped");
  for (g = 0; g < M; g++) {
    var te = g - a;
    if (h.length < g + 1)
      te > 1 && g > 2 && (te > 4 ? (i += `
`.concat(Wo, "...").concat(Zn), s = !0) : te > 3 && (i += `
  `.concat(d[g - 2]), z++), i += `
  `.concat(d[g - 1]), z++), a = g, n += `
`.concat(_4, "-").concat(Zn, " ").concat(d[g]), z++;
    else if (d.length < g + 1)
      te > 1 && g > 2 && (te > 4 ? (i += `
`.concat(Wo, "...").concat(Zn), s = !0) : te > 3 && (i += `
  `.concat(h[g - 2]), z++), i += `
  `.concat(h[g - 1]), z++), a = g, i += `
`.concat(E4, "+").concat(Zn, " ").concat(h[g]), z++;
    else {
      var J = d[g], K = h[g], ee = K !== J && (!r8(K, ",") || K.slice(0, -1) !== J);
      ee && r8(J, ",") && J.slice(0, -1) === K && (ee = !1, K += ","), ee ? (te > 1 && g > 2 && (te > 4 ? (i += `
`.concat(Wo, "...").concat(Zn), s = !0) : te > 3 && (i += `
  `.concat(h[g - 2]), z++), i += `
  `.concat(h[g - 1]), z++), a = g, i += `
`.concat(E4, "+").concat(Zn, " ").concat(K), n += `
`.concat(_4, "-").concat(Zn, " ").concat(J), z += 2) : (i += n, n = "", (te === 1 || g === 0) && (i += `
  `.concat(K), z++));
    }
    if (z > 20 && g < M - 2)
      return "".concat(j).concat(R, `
`).concat(i, `
`).concat(Wo, "...").concat(Zn).concat(n, `
`) + "".concat(Wo, "...").concat(Zn);
  }
  return "".concat(j).concat(s ? R : "", `
`).concat(i).concat(n).concat(o).concat(x);
}
var Oq = /* @__PURE__ */ function(r) {
  xq(e, r);
  function e(t) {
    var n;
    if (bq(this, e), ra(t) !== "object" || t === null)
      throw new kq("options", "Object", t);
    var i = t.message, a = t.operator, o = t.stackStartFn, s = t.actual, c = t.expected, h = Error.stackTraceLimit;
    if (Error.stackTraceLimit = 0, i != null)
      n = cc(this, js(e).call(this, String(i)));
    else if (ra(s) === "object" && s !== null && ra(c) === "object" && c !== null && "stack" in s && s instanceof Error && "stack" in c && c instanceof Error && (s = n8(s), c = n8(c)), a === "deepStrictEqual" || a === "strictEqual")
      n = cc(this, js(e).call(this, Fq(s, c, a)));
    else if (a === "notDeepStrictEqual" || a === "notStrictEqual") {
      var d = ul[a], g = d1(s).split(`
`);
      if (a === "notStrictEqual" && ra(s) === "object" && s !== null && (d = ul.notStrictEqualObject), g.length > 30)
        for (g[26] = "".concat(Wo, "...").concat(Zn); g.length > 27; )
          g.pop();
      g.length === 1 ? n = cc(this, js(e).call(this, "".concat(d, " ").concat(g[0]))) : n = cc(this, js(e).call(this, "".concat(d, `

`).concat(g.join(`
`), `
`)));
    } else {
      var x = d1(s), _ = "", k = ul[a];
      a === "notDeepEqual" || a === "notEqual" ? (x = "".concat(ul[a], `

`).concat(x), x.length > 1024 && (x = "".concat(x.slice(0, 1021), "..."))) : (_ = "".concat(d1(c)), x.length > 512 && (x = "".concat(x.slice(0, 509), "...")), _.length > 512 && (_ = "".concat(_.slice(0, 509), "...")), a === "deepEqual" || a === "equal" ? x = "".concat(k, `

`).concat(x, `

should equal

`) : _ = " ".concat(a, " ").concat(_)), n = cc(this, js(e).call(this, "".concat(x).concat(_)));
    }
    return Error.stackTraceLimit = h, n.generatedMessage = !i, Object.defineProperty(G3(n), "name", {
      value: "AssertionError [ERR_ASSERTION]",
      enumerable: !1,
      writable: !0,
      configurable: !0
    }), n.code = "ERR_ASSERTION", n.actual = s, n.expected = c, n.operator = a, Error.captureStackTrace && Error.captureStackTrace(G3(n), o), n.stack, n.name = "AssertionError", cc(n);
  }
  return Aq(e, [{
    key: "toString",
    value: function() {
      return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
    }
  }, {
    key: Y3.custom,
    value: function(n, i) {
      return Y3(this, mq({}, i, {
        customInspect: !1,
        depth: 0
      }));
    }
  }]), e;
}(V3(Error)), Rq = Oq;
function y_(r, e) {
  if (r == null)
    throw new TypeError("Cannot convert first argument to object");
  for (var t = Object(r), n = 1; n < arguments.length; n++) {
    var i = arguments[n];
    if (i != null)
      for (var a = Object.keys(Object(i)), o = 0, s = a.length; o < s; o++) {
        var c = a[o], h = Object.getOwnPropertyDescriptor(i, c);
        h !== void 0 && h.enumerable && (t[c] = i[c]);
      }
  }
  return t;
}
function Iq() {
  Object.assign || Object.defineProperty(Object, "assign", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: y_
  });
}
var Pq = {
  assign: y_,
  polyfill: Iq
}, i8 = Object.prototype.toString, b_ = function(e) {
  var t = i8.call(e), n = t === "[object Arguments]";
  return n || (n = t !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && i8.call(e.callee) === "[object Function]"), n;
}, w_;
if (!Object.keys) {
  var J2 = Object.prototype.hasOwnProperty, a8 = Object.prototype.toString, Bq = b_, o8 = Object.prototype.propertyIsEnumerable, Nq = !o8.call({
    toString: null
  }, "toString"), Lq = o8.call(function() {
  }, "prototype"), Q2 = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"], D4 = function(e) {
    var t = e.constructor;
    return t && t.prototype === e;
  }, Mq = {
    $applicationCache: !0,
    $console: !0,
    $external: !0,
    $frame: !0,
    $frameElement: !0,
    $frames: !0,
    $innerHeight: !0,
    $innerWidth: !0,
    $onmozfullscreenchange: !0,
    $onmozfullscreenerror: !0,
    $outerHeight: !0,
    $outerWidth: !0,
    $pageXOffset: !0,
    $pageYOffset: !0,
    $parent: !0,
    $scrollLeft: !0,
    $scrollTop: !0,
    $scrollX: !0,
    $scrollY: !0,
    $self: !0,
    $webkitIndexedDB: !0,
    $webkitStorageInfo: !0,
    $window: !0
  }, Uq = function() {
    if (typeof window > "u")
      return !1;
    for (var r in window)
      try {
        if (!Mq["$" + r] && J2.call(window, r) && window[r] !== null && typeof window[r] == "object")
          try {
            D4(window[r]);
          } catch {
            return !0;
          }
      } catch {
        return !0;
      }
    return !1;
  }(), $q = function(e) {
    if (typeof window > "u" || !Uq)
      return D4(e);
    try {
      return D4(e);
    } catch {
      return !1;
    }
  };
  w_ = function(e) {
    var t = e !== null && typeof e == "object", n = a8.call(e) === "[object Function]", i = Bq(e), a = t && a8.call(e) === "[object String]", o = [];
    if (!t && !n && !i)
      throw new TypeError("Object.keys called on a non-object");
    var s = Lq && n;
    if (a && e.length > 0 && !J2.call(e, 0))
      for (var c = 0; c < e.length; ++c)
        o.push(String(c));
    if (i && e.length > 0)
      for (var h = 0; h < e.length; ++h)
        o.push(String(h));
    else
      for (var d in e)
        !(s && d === "prototype") && J2.call(e, d) && o.push(String(d));
    if (Nq)
      for (var g = $q(e), x = 0; x < Q2.length; ++x)
        !(g && Q2[x] === "constructor") && J2.call(e, Q2[x]) && o.push(Q2[x]);
    return o;
  };
}
var zq = w_, jq = Array.prototype.slice, Wq = b_, s8 = Object.keys, Hh = s8 ? function(e) {
  return s8(e);
} : zq, u8 = Object.keys;
Hh.shim = function() {
  if (Object.keys) {
    var e = function() {
      var t = Object.keys(arguments);
      return t && t.length === arguments.length;
    }(1, 2);
    e || (Object.keys = function(n) {
      return Wq(n) ? u8(jq.call(n)) : u8(n);
    });
  } else
    Object.keys = Hh;
  return Object.keys || Hh;
};
var Gq = Hh, Vq = Gq, Yq = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", Hq = Object.prototype.toString, Zq = Array.prototype.concat, kg = Object.defineProperty, qq = function(e) {
  return typeof e == "function" && Hq.call(e) === "[object Function]";
}, Xq = function() {
  var e = {};
  try {
    kg(e, "x", {
      enumerable: !1,
      value: e
    });
    for (var t in e)
      return !1;
    return e.x === e;
  } catch {
    return !1;
  }
}, A_ = kg && Xq(), Kq = function(e, t, n, i) {
  t in e && (!qq(i) || !i()) || (A_ ? kg(e, t, {
    configurable: !0,
    enumerable: !1,
    value: n,
    writable: !0
  }) : e[t] = n);
}, x_ = function(e, t) {
  var n = arguments.length > 2 ? arguments[2] : {}, i = Vq(t);
  Yq && (i = Zq.call(i, Object.getOwnPropertySymbols(t)));
  for (var a = 0; a < i.length; a += 1)
    Kq(e, i[a], t[i[a]], n[i[a]]);
};
x_.supportsDescriptors = !!A_;
var O5 = x_, l8 = function(e) {
  return e !== e;
}, E_ = function(e, t) {
  return e === 0 && t === 0 ? 1 / e === 1 / t : !!(e === t || l8(e) && l8(t));
}, Jq = E_, __ = function() {
  return typeof Object.is == "function" ? Object.is : Jq;
}, Qq = __, eX = O5, tX = function() {
  var e = Qq();
  return eX(Object, {
    is: e
  }, {
    is: function() {
      return Object.is !== e;
    }
  }), e;
}, rX = O5, nX = C5.exports, iX = E_, D_ = __, aX = tX, T_ = nX(D_(), Object);
rX(T_, {
  getPolyfill: D_,
  implementation: iX,
  shim: aX
});
var k_ = T_, S_ = function(e) {
  return e !== e;
}, oX = S_, C_ = function() {
  return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : oX;
}, sX = O5, uX = C_, lX = function() {
  var e = uX();
  return sX(Number, {
    isNaN: e
  }, {
    isNaN: function() {
      return Number.isNaN !== e;
    }
  }), e;
}, cX = C5.exports, fX = O5, hX = S_, F_ = C_, dX = lX, O_ = cX(F_(), Number);
fX(O_, {
  getPolyfill: F_,
  implementation: hX,
  shim: dX
});
var pX = O_;
function c8(r, e) {
  return mX(r) || gX(r, e) || vX();
}
function vX() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function gX(r, e) {
  var t = [], n = !0, i = !1, a = void 0;
  try {
    for (var o = r[Symbol.iterator](), s; !(n = (s = o.next()).done) && (t.push(s.value), !(e && t.length === e)); n = !0)
      ;
  } catch (c) {
    i = !0, a = c;
  } finally {
    try {
      !n && o.return != null && o.return();
    } finally {
      if (i) throw a;
    }
  }
  return t;
}
function mX(r) {
  if (Array.isArray(r)) return r;
}
function ki(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ki = function(t) {
    return typeof t;
  } : ki = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ki(r);
}
var yX = /a/g.flags !== void 0, Cd = function(e) {
  var t = [];
  return e.forEach(function(n) {
    return t.push(n);
  }), t;
}, f8 = function(e) {
  var t = [];
  return e.forEach(function(n, i) {
    return t.push([i, n]);
  }), t;
}, R_ = Object.is ? Object.is : k_, Zh = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
  return [];
}, H3 = Number.isNaN ? Number.isNaN : pX;
function Sg(r) {
  return r.call.bind(r);
}
var Kf = Sg(Object.prototype.hasOwnProperty), qh = Sg(Object.prototype.propertyIsEnumerable), h8 = Sg(Object.prototype.toString), Qn = Rl.types, bX = Qn.isAnyArrayBuffer, wX = Qn.isArrayBufferView, d8 = Qn.isDate, eh = Qn.isMap, p8 = Qn.isRegExp, th = Qn.isSet, AX = Qn.isNativeError, xX = Qn.isBoxedPrimitive, v8 = Qn.isNumberObject, g8 = Qn.isStringObject, m8 = Qn.isBooleanObject, y8 = Qn.isBigIntObject, EX = Qn.isSymbolObject, _X = Qn.isFloat32Array, DX = Qn.isFloat64Array;
function TX(r) {
  if (r.length === 0 || r.length > 10) return !0;
  for (var e = 0; e < r.length; e++) {
    var t = r.charCodeAt(e);
    if (t < 48 || t > 57) return !0;
  }
  return r.length === 10 && r >= Math.pow(2, 32);
}
function rh(r) {
  return Object.keys(r).filter(TX).concat(Zh(r).filter(Object.prototype.propertyIsEnumerable.bind(r)));
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function I_(r, e) {
  if (r === e)
    return 0;
  for (var t = r.length, n = e.length, i = 0, a = Math.min(t, n); i < a; ++i)
    if (r[i] !== e[i]) {
      t = r[i], n = e[i];
      break;
    }
  return t < n ? -1 : n < t ? 1 : 0;
}
var kX = !0, SX = !1, Z3 = 0, Cg = 1, P_ = 2, B_ = 3;
function CX(r, e) {
  return yX ? r.source === e.source && r.flags === e.flags : RegExp.prototype.toString.call(r) === RegExp.prototype.toString.call(e);
}
function FX(r, e) {
  if (r.byteLength !== e.byteLength)
    return !1;
  for (var t = 0; t < r.byteLength; t++)
    if (r[t] !== e[t])
      return !1;
  return !0;
}
function OX(r, e) {
  return r.byteLength !== e.byteLength ? !1 : I_(new Uint8Array(r.buffer, r.byteOffset, r.byteLength), new Uint8Array(e.buffer, e.byteOffset, e.byteLength)) === 0;
}
function RX(r, e) {
  return r.byteLength === e.byteLength && I_(new Uint8Array(r), new Uint8Array(e)) === 0;
}
function IX(r, e) {
  return v8(r) ? v8(e) && R_(Number.prototype.valueOf.call(r), Number.prototype.valueOf.call(e)) : g8(r) ? g8(e) && String.prototype.valueOf.call(r) === String.prototype.valueOf.call(e) : m8(r) ? m8(e) && Boolean.prototype.valueOf.call(r) === Boolean.prototype.valueOf.call(e) : y8(r) ? y8(e) && BigInt.prototype.valueOf.call(r) === BigInt.prototype.valueOf.call(e) : EX(e) && Symbol.prototype.valueOf.call(r) === Symbol.prototype.valueOf.call(e);
}
function ua(r, e, t, n) {
  if (r === e)
    return r !== 0 ? !0 : t ? R_(r, e) : !0;
  if (t) {
    if (ki(r) !== "object")
      return typeof r == "number" && H3(r) && H3(e);
    if (ki(e) !== "object" || r === null || e === null || Object.getPrototypeOf(r) !== Object.getPrototypeOf(e))
      return !1;
  } else {
    if (r === null || ki(r) !== "object")
      return e === null || ki(e) !== "object" ? r == e : !1;
    if (e === null || ki(e) !== "object")
      return !1;
  }
  var i = h8(r), a = h8(e);
  if (i !== a)
    return !1;
  if (Array.isArray(r)) {
    if (r.length !== e.length)
      return !1;
    var o = rh(r), s = rh(e);
    return o.length !== s.length ? !1 : Yf(r, e, t, n, Cg, o);
  }
  if (i === "[object Object]" && (!eh(r) && eh(e) || !th(r) && th(e)))
    return !1;
  if (d8(r)) {
    if (!d8(e) || Date.prototype.getTime.call(r) !== Date.prototype.getTime.call(e))
      return !1;
  } else if (p8(r)) {
    if (!p8(e) || !CX(r, e))
      return !1;
  } else if (AX(r) || r instanceof Error) {
    if (r.message !== e.message || r.name !== e.name)
      return !1;
  } else if (wX(r)) {
    if (!t && (_X(r) || DX(r))) {
      if (!FX(r, e))
        return !1;
    } else if (!OX(r, e))
      return !1;
    var c = rh(r), h = rh(e);
    return c.length !== h.length ? !1 : Yf(r, e, t, n, Z3, c);
  } else {
    if (th(r))
      return !th(e) || r.size !== e.size ? !1 : Yf(r, e, t, n, P_);
    if (eh(r))
      return !eh(e) || r.size !== e.size ? !1 : Yf(r, e, t, n, B_);
    if (bX(r)) {
      if (!RX(r, e))
        return !1;
    } else if (xX(r) && !IX(r, e))
      return !1;
  }
  return Yf(r, e, t, n, Z3);
}
function b8(r, e) {
  return e.filter(function(t) {
    return qh(r, t);
  });
}
function Yf(r, e, t, n, i, a) {
  if (arguments.length === 5) {
    a = Object.keys(r);
    var o = Object.keys(e);
    if (a.length !== o.length)
      return !1;
  }
  for (var s = 0; s < a.length; s++)
    if (!Kf(e, a[s]))
      return !1;
  if (t && arguments.length === 5) {
    var c = Zh(r);
    if (c.length !== 0) {
      var h = 0;
      for (s = 0; s < c.length; s++) {
        var d = c[s];
        if (qh(r, d)) {
          if (!qh(e, d))
            return !1;
          a.push(d), h++;
        } else if (qh(e, d))
          return !1;
      }
      var g = Zh(e);
      if (c.length !== g.length && b8(e, g).length !== h)
        return !1;
    } else {
      var x = Zh(e);
      if (x.length !== 0 && b8(e, x).length !== 0)
        return !1;
    }
  }
  if (a.length === 0 && (i === Z3 || i === Cg && r.length === 0 || r.size === 0))
    return !0;
  if (n === void 0)
    n = {
      val1: /* @__PURE__ */ new Map(),
      val2: /* @__PURE__ */ new Map(),
      position: 0
    };
  else {
    var _ = n.val1.get(r);
    if (_ !== void 0) {
      var k = n.val2.get(e);
      if (k !== void 0)
        return _ === k;
    }
    n.position++;
  }
  n.val1.set(r, n.position), n.val2.set(e, n.position);
  var P = MX(r, e, t, a, n, i);
  return n.val1.delete(r), n.val2.delete(e), P;
}
function w8(r, e, t, n) {
  for (var i = Cd(r), a = 0; a < i.length; a++) {
    var o = i[a];
    if (ua(e, o, t, n))
      return r.delete(o), !0;
  }
  return !1;
}
function N_(r) {
  switch (ki(r)) {
    case "undefined":
      return null;
    case "object":
      return;
    case "symbol":
      return !1;
    case "string":
      r = +r;
    case "number":
      if (H3(r))
        return !1;
  }
  return !0;
}
function PX(r, e, t) {
  var n = N_(t);
  return n ?? (e.has(n) && !r.has(n));
}
function BX(r, e, t, n, i) {
  var a = N_(t);
  if (a != null)
    return a;
  var o = e.get(a);
  return o === void 0 && !e.has(a) || !ua(n, o, !1, i) ? !1 : !r.has(a) && ua(n, o, !1, i);
}
function NX(r, e, t, n) {
  for (var i = null, a = Cd(r), o = 0; o < a.length; o++) {
    var s = a[o];
    if (ki(s) === "object" && s !== null)
      i === null && (i = /* @__PURE__ */ new Set()), i.add(s);
    else if (!e.has(s)) {
      if (t || !PX(r, e, s))
        return !1;
      i === null && (i = /* @__PURE__ */ new Set()), i.add(s);
    }
  }
  if (i !== null) {
    for (var c = Cd(e), h = 0; h < c.length; h++) {
      var d = c[h];
      if (ki(d) === "object" && d !== null) {
        if (!w8(i, d, t, n)) return !1;
      } else if (!t && !r.has(d) && !w8(i, d, t, n))
        return !1;
    }
    return i.size === 0;
  }
  return !0;
}
function A8(r, e, t, n, i, a) {
  for (var o = Cd(r), s = 0; s < o.length; s++) {
    var c = o[s];
    if (ua(t, c, i, a) && ua(n, e.get(c), i, a))
      return r.delete(c), !0;
  }
  return !1;
}
function LX(r, e, t, n) {
  for (var i = null, a = f8(r), o = 0; o < a.length; o++) {
    var s = c8(a[o], 2), c = s[0], h = s[1];
    if (ki(c) === "object" && c !== null)
      i === null && (i = /* @__PURE__ */ new Set()), i.add(c);
    else {
      var d = e.get(c);
      if (d === void 0 && !e.has(c) || !ua(h, d, t, n)) {
        if (t || !BX(r, e, c, h, n)) return !1;
        i === null && (i = /* @__PURE__ */ new Set()), i.add(c);
      }
    }
  }
  if (i !== null) {
    for (var g = f8(e), x = 0; x < g.length; x++) {
      var _ = c8(g[x], 2), c = _[0], k = _[1];
      if (ki(c) === "object" && c !== null) {
        if (!A8(i, r, c, k, t, n)) return !1;
      } else if (!t && (!r.has(c) || !ua(r.get(c), k, !1, n)) && !A8(i, r, c, k, !1, n))
        return !1;
    }
    return i.size === 0;
  }
  return !0;
}
function MX(r, e, t, n, i, a) {
  var o = 0;
  if (a === P_) {
    if (!NX(r, e, t, i))
      return !1;
  } else if (a === B_) {
    if (!LX(r, e, t, i))
      return !1;
  } else if (a === Cg)
    for (; o < r.length; o++)
      if (Kf(r, o)) {
        if (!Kf(e, o) || !ua(r[o], e[o], t, i))
          return !1;
      } else {
        if (Kf(e, o))
          return !1;
        for (var s = Object.keys(r); o < s.length; o++) {
          var c = s[o];
          if (!Kf(e, c) || !ua(r[c], e[c], t, i))
            return !1;
        }
        return s.length === Object.keys(e).length;
      }
  for (o = 0; o < n.length; o++) {
    var h = n[o];
    if (!ua(r[h], e[h], t, i))
      return !1;
  }
  return !0;
}
function UX(r, e) {
  return ua(r, e, SX);
}
function $X(r, e) {
  return ua(r, e, kX);
}
var zX = {
  isDeepEqual: UX,
  isDeepStrictEqual: $X
};
function ru(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ru = function(t) {
    return typeof t;
  } : ru = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ru(r);
}
function jX(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var WX = Ag, h2 = WX.codes, x8 = h2.ERR_AMBIGUOUS_ARGUMENT, U1 = h2.ERR_INVALID_ARG_TYPE, GX = h2.ERR_INVALID_ARG_VALUE, VX = h2.ERR_INVALID_RETURN_VALUE, vu = h2.ERR_MISSING_ARGS, Il = Rq, YX = Rl, HX = YX.inspect, L_ = Rl.types, ZX = L_.isPromise, q3 = L_.isRegExp, qX = Object.assign ? Object.assign : Pq.assign, M_ = Object.is ? Object.is : k_, lu, R5;
function d2() {
  var r = zX;
  lu = r.isDeepEqual, R5 = r.isDeepStrictEqual;
}
var E8 = !1, v0 = c2.exports = Fg, I5 = {};
function Pa(r) {
  throw r.message instanceof Error ? r.message : new Il(r);
}
function U_(r, e, t, n, i) {
  var a = arguments.length, o;
  if (a === 0)
    o = "Failed";
  else if (a === 1)
    t = r, r = void 0;
  else {
    if (E8 === !1) {
      E8 = !0;
      var s = console.warn.bind(console);
      s("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
    }
    a === 2 && (n = "!=");
  }
  if (t instanceof Error) throw t;
  var c = {
    actual: r,
    expected: e,
    operator: n === void 0 ? "fail" : n,
    stackStartFn: i || U_
  };
  t !== void 0 && (c.message = t);
  var h = new Il(c);
  throw o && (h.message = o, h.generatedMessage = !0), h;
}
v0.fail = U_;
v0.AssertionError = Il;
function $_(r, e, t, n) {
  if (!t) {
    var i = !1;
    if (e === 0)
      i = !0, n = "No value argument passed to `assert.ok()`";
    else if (n instanceof Error)
      throw n;
    var a = new Il({
      actual: t,
      expected: !0,
      message: n,
      operator: "==",
      stackStartFn: r
    });
    throw a.generatedMessage = i, a;
  }
}
function Fg() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  $_.apply(void 0, [Fg, e.length].concat(e));
}
v0.ok = Fg;
v0.equal = function r(e, t, n) {
  if (arguments.length < 2)
    throw new vu("actual", "expected");
  e != t && Pa({
    actual: e,
    expected: t,
    message: n,
    operator: "==",
    stackStartFn: r
  });
};
v0.notEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new vu("actual", "expected");
  e == t && Pa({
    actual: e,
    expected: t,
    message: n,
    operator: "!=",
    stackStartFn: r
  });
};
v0.deepEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new vu("actual", "expected");
  lu === void 0 && d2(), lu(e, t) || Pa({
    actual: e,
    expected: t,
    message: n,
    operator: "deepEqual",
    stackStartFn: r
  });
};
v0.notDeepEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new vu("actual", "expected");
  lu === void 0 && d2(), lu(e, t) && Pa({
    actual: e,
    expected: t,
    message: n,
    operator: "notDeepEqual",
    stackStartFn: r
  });
};
v0.deepStrictEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new vu("actual", "expected");
  lu === void 0 && d2(), R5(e, t) || Pa({
    actual: e,
    expected: t,
    message: n,
    operator: "deepStrictEqual",
    stackStartFn: r
  });
};
v0.notDeepStrictEqual = z_;
function z_(r, e, t) {
  if (arguments.length < 2)
    throw new vu("actual", "expected");
  lu === void 0 && d2(), R5(r, e) && Pa({
    actual: r,
    expected: e,
    message: t,
    operator: "notDeepStrictEqual",
    stackStartFn: z_
  });
}
v0.strictEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new vu("actual", "expected");
  M_(e, t) || Pa({
    actual: e,
    expected: t,
    message: n,
    operator: "strictEqual",
    stackStartFn: r
  });
};
v0.notStrictEqual = function r(e, t, n) {
  if (arguments.length < 2)
    throw new vu("actual", "expected");
  M_(e, t) && Pa({
    actual: e,
    expected: t,
    message: n,
    operator: "notStrictEqual",
    stackStartFn: r
  });
};
var _8 = function r(e, t, n) {
  var i = this;
  jX(this, r), t.forEach(function(a) {
    a in e && (n !== void 0 && typeof n[a] == "string" && q3(e[a]) && e[a].test(n[a]) ? i[a] = n[a] : i[a] = e[a]);
  });
};
function XX(r, e, t, n, i, a) {
  if (!(t in r) || !R5(r[t], e[t])) {
    if (!n) {
      var o = new _8(r, i), s = new _8(e, i, r), c = new Il({
        actual: o,
        expected: s,
        operator: "deepStrictEqual",
        stackStartFn: a
      });
      throw c.actual = r, c.expected = e, c.operator = a.name, c;
    }
    Pa({
      actual: r,
      expected: e,
      message: n,
      operator: a.name,
      stackStartFn: a
    });
  }
}
function j_(r, e, t, n) {
  if (typeof e != "function") {
    if (q3(e)) return e.test(r);
    if (arguments.length === 2)
      throw new U1("expected", ["Function", "RegExp"], e);
    if (ru(r) !== "object" || r === null) {
      var i = new Il({
        actual: r,
        expected: e,
        message: t,
        operator: "deepStrictEqual",
        stackStartFn: n
      });
      throw i.operator = n.name, i;
    }
    var a = Object.keys(e);
    if (e instanceof Error)
      a.push("name", "message");
    else if (a.length === 0)
      throw new GX("error", e, "may not be an empty object");
    return lu === void 0 && d2(), a.forEach(function(o) {
      typeof r[o] == "string" && q3(e[o]) && e[o].test(r[o]) || XX(r, e, o, t, a, n);
    }), !0;
  }
  return e.prototype !== void 0 && r instanceof e ? !0 : Error.isPrototypeOf(e) ? !1 : e.call({}, r) === !0;
}
function W_(r) {
  if (typeof r != "function")
    throw new U1("fn", "Function", r);
  try {
    r();
  } catch (e) {
    return e;
  }
  return I5;
}
function D8(r) {
  return ZX(r) || r !== null && ru(r) === "object" && typeof r.then == "function" && typeof r.catch == "function";
}
function G_(r) {
  return Promise.resolve().then(function() {
    var e;
    if (typeof r == "function") {
      if (e = r(), !D8(e))
        throw new VX("instance of Promise", "promiseFn", e);
    } else if (D8(r))
      e = r;
    else
      throw new U1("promiseFn", ["Function", "Promise"], r);
    return Promise.resolve().then(function() {
      return e;
    }).then(function() {
      return I5;
    }).catch(function(t) {
      return t;
    });
  });
}
function V_(r, e, t, n) {
  if (typeof t == "string") {
    if (arguments.length === 4)
      throw new U1("error", ["Object", "Error", "Function", "RegExp"], t);
    if (ru(e) === "object" && e !== null) {
      if (e.message === t)
        throw new x8("error/message", 'The error message "'.concat(e.message, '" is identical to the message.'));
    } else if (e === t)
      throw new x8("error/message", 'The error "'.concat(e, '" is identical to the message.'));
    n = t, t = void 0;
  } else if (t != null && ru(t) !== "object" && typeof t != "function")
    throw new U1("error", ["Object", "Error", "Function", "RegExp"], t);
  if (e === I5) {
    var i = "";
    t && t.name && (i += " (".concat(t.name, ")")), i += n ? ": ".concat(n) : ".";
    var a = r.name === "rejects" ? "rejection" : "exception";
    Pa({
      actual: void 0,
      expected: t,
      operator: r.name,
      message: "Missing expected ".concat(a).concat(i),
      stackStartFn: r
    });
  }
  if (t && !j_(e, t, n, r))
    throw e;
}
function Y_(r, e, t, n) {
  if (e !== I5) {
    if (typeof t == "string" && (n = t, t = void 0), !t || j_(e, t)) {
      var i = n ? ": ".concat(n) : ".", a = r.name === "doesNotReject" ? "rejection" : "exception";
      Pa({
        actual: e,
        expected: t,
        operator: r.name,
        message: "Got unwanted ".concat(a).concat(i, `
`) + 'Actual message: "'.concat(e && e.message, '"'),
        stackStartFn: r
      });
    }
    throw e;
  }
}
v0.throws = function r(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  V_.apply(void 0, [r, W_(e)].concat(n));
};
v0.rejects = function r(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return G_(e).then(function(a) {
    return V_.apply(void 0, [r, a].concat(n));
  });
};
v0.doesNotThrow = function r(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  Y_.apply(void 0, [r, W_(e)].concat(n));
};
v0.doesNotReject = function r(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return G_(e).then(function(a) {
    return Y_.apply(void 0, [r, a].concat(n));
  });
};
v0.ifError = function r(e) {
  if (e != null) {
    var t = "ifError got unwanted exception: ";
    ru(e) === "object" && typeof e.message == "string" ? e.message.length === 0 && e.constructor ? t += e.constructor.name : t += e.message : t += HX(e);
    var n = new Il({
      actual: e,
      expected: null,
      operator: "ifError",
      message: t,
      stackStartFn: r
    }), i = e.stack;
    if (typeof i == "string") {
      var a = i.split(`
`);
      a.shift();
      for (var o = n.stack.split(`
`), s = 0; s < a.length; s++) {
        var c = o.indexOf(a[s]);
        if (c !== -1) {
          o = o.slice(0, c);
          break;
        }
      }
      n.stack = "".concat(o.join(`
`), `
`).concat(a.join(`
`));
    }
    throw n;
  }
};
function H_() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  $_.apply(void 0, [H_, e.length].concat(e));
}
v0.strict = qX(H_, v0, {
  equal: v0.strictEqual,
  deepEqual: v0.deepStrictEqual,
  notEqual: v0.notStrictEqual,
  notDeepEqual: v0.notDeepStrictEqual
});
v0.strict.strict = v0.strict;
(function(r) {
  var e = c2.exports, t = zN, n = xo, i = Oa, a = yM;
  for (var o in a)
    r[o] = a[o];
  r.NONE = 0, r.DEFLATE = 1, r.INFLATE = 2, r.GZIP = 3, r.GUNZIP = 4, r.DEFLATERAW = 5, r.INFLATERAW = 6, r.UNZIP = 7;
  var s = 31, c = 139;
  function h(d) {
    if (typeof d != "number" || d < r.DEFLATE || d > r.UNZIP)
      throw new TypeError("Bad argument");
    this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = d, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
  }
  h.prototype.close = function() {
    if (this.write_in_progress) {
      this.pending_close = !0;
      return;
    }
    this.pending_close = !1, e(this.init_done, "close before init"), e(this.mode <= r.UNZIP), this.mode === r.DEFLATE || this.mode === r.GZIP || this.mode === r.DEFLATERAW ? n.deflateEnd(this.strm) : (this.mode === r.INFLATE || this.mode === r.GUNZIP || this.mode === r.INFLATERAW || this.mode === r.UNZIP) && i.inflateEnd(this.strm), this.mode = r.NONE, this.dictionary = null;
  }, h.prototype.write = function(d, g, x, _, k, P, N) {
    return this._write(!0, d, g, x, _, k, P, N);
  }, h.prototype.writeSync = function(d, g, x, _, k, P, N) {
    return this._write(!1, d, g, x, _, k, P, N);
  }, h.prototype._write = function(d, g, x, _, k, P, N, M) {
    if (e.equal(arguments.length, 8), e(this.init_done, "write before init"), e(this.mode !== r.NONE, "already finalized"), e.equal(!1, this.write_in_progress, "write already in progress"), e.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, e.equal(!1, g === void 0, "must provide flush value"), this.write_in_progress = !0, g !== r.Z_NO_FLUSH && g !== r.Z_PARTIAL_FLUSH && g !== r.Z_SYNC_FLUSH && g !== r.Z_FULL_FLUSH && g !== r.Z_FINISH && g !== r.Z_BLOCK)
      throw new Error("Invalid flush value");
    if (x == null && (x = tt.alloc(0), k = 0, _ = 0), this.strm.avail_in = k, this.strm.input = x, this.strm.next_in = _, this.strm.avail_out = M, this.strm.output = P, this.strm.next_out = N, this.flush = g, !d)
      return this._process(), this._checkError() ? this._afterSync() : void 0;
    var G = this;
    return ir.nextTick(function() {
      G._process(), G._after();
    }), this;
  }, h.prototype._afterSync = function() {
    var d = this.strm.avail_out, g = this.strm.avail_in;
    return this.write_in_progress = !1, [g, d];
  }, h.prototype._process = function() {
    var d = null;
    switch (this.mode) {
      case r.DEFLATE:
      case r.GZIP:
      case r.DEFLATERAW:
        this.err = n.deflate(this.strm, this.flush);
        break;
      case r.UNZIP:
        switch (this.strm.avail_in > 0 && (d = this.strm.next_in), this.gzip_id_bytes_read) {
          case 0:
            if (d === null)
              break;
            if (this.strm.input[d] === s) {
              if (this.gzip_id_bytes_read = 1, d++, this.strm.avail_in === 1)
                break;
            } else {
              this.mode = r.INFLATE;
              break;
            }
          case 1:
            if (d === null)
              break;
            this.strm.input[d] === c ? (this.gzip_id_bytes_read = 2, this.mode = r.GUNZIP) : this.mode = r.INFLATE;
            break;
          default:
            throw new Error("invalid number of gzip magic number bytes read");
        }
      case r.INFLATE:
      case r.GUNZIP:
      case r.INFLATERAW:
        for (this.err = i.inflate(
          this.strm,
          this.flush
          // If data was encoded with dictionary
        ), this.err === r.Z_NEED_DICT && this.dictionary && (this.err = i.inflateSetDictionary(this.strm, this.dictionary), this.err === r.Z_OK ? this.err = i.inflate(this.strm, this.flush) : this.err === r.Z_DATA_ERROR && (this.err = r.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === r.GUNZIP && this.err === r.Z_STREAM_END && this.strm.next_in[0] !== 0; )
          this.reset(), this.err = i.inflate(this.strm, this.flush);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
  }, h.prototype._checkError = function() {
    switch (this.err) {
      case r.Z_OK:
      case r.Z_BUF_ERROR:
        if (this.strm.avail_out !== 0 && this.flush === r.Z_FINISH)
          return this._error("unexpected end of file"), !1;
        break;
      case r.Z_STREAM_END:
        break;
      case r.Z_NEED_DICT:
        return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
      default:
        return this._error("Zlib error"), !1;
    }
    return !0;
  }, h.prototype._after = function() {
    if (this._checkError()) {
      var d = this.strm.avail_out, g = this.strm.avail_in;
      this.write_in_progress = !1, this.callback(g, d), this.pending_close && this.close();
    }
  }, h.prototype._error = function(d) {
    this.strm.msg && (d = this.strm.msg), this.onerror(
      d,
      this.err
      // no hope of rescue.
    ), this.write_in_progress = !1, this.pending_close && this.close();
  }, h.prototype.init = function(d, g, x, _, k) {
    e(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), e(d >= 8 && d <= 15, "invalid windowBits"), e(g >= -1 && g <= 9, "invalid compression level"), e(x >= 1 && x <= 9, "invalid memlevel"), e(_ === r.Z_FILTERED || _ === r.Z_HUFFMAN_ONLY || _ === r.Z_RLE || _ === r.Z_FIXED || _ === r.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(g, d, x, _, k), this._setDictionary();
  }, h.prototype.params = function() {
    throw new Error("deflateParams Not supported");
  }, h.prototype.reset = function() {
    this._reset(), this._setDictionary();
  }, h.prototype._init = function(d, g, x, _, k) {
    switch (this.level = d, this.windowBits = g, this.memLevel = x, this.strategy = _, this.flush = r.Z_NO_FLUSH, this.err = r.Z_OK, (this.mode === r.GZIP || this.mode === r.GUNZIP) && (this.windowBits += 16), this.mode === r.UNZIP && (this.windowBits += 32), (this.mode === r.DEFLATERAW || this.mode === r.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new t(), this.mode) {
      case r.DEFLATE:
      case r.GZIP:
      case r.DEFLATERAW:
        this.err = n.deflateInit2(this.strm, this.level, r.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
        break;
      case r.INFLATE:
      case r.GUNZIP:
      case r.INFLATERAW:
      case r.UNZIP:
        this.err = i.inflateInit2(this.strm, this.windowBits);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
    this.err !== r.Z_OK && this._error("Init error"), this.dictionary = k, this.write_in_progress = !1, this.init_done = !0;
  }, h.prototype._setDictionary = function() {
    if (this.dictionary != null) {
      switch (this.err = r.Z_OK, this.mode) {
        case r.DEFLATE:
        case r.DEFLATERAW:
          this.err = n.deflateSetDictionary(this.strm, this.dictionary);
          break;
      }
      this.err !== r.Z_OK && this._error("Failed to set dictionary");
    }
  }, h.prototype._reset = function() {
    switch (this.err = r.Z_OK, this.mode) {
      case r.DEFLATE:
      case r.DEFLATERAW:
      case r.GZIP:
        this.err = n.deflateReset(this.strm);
        break;
      case r.INFLATE:
      case r.INFLATERAW:
      case r.GUNZIP:
        this.err = i.inflateReset(this.strm);
        break;
    }
    this.err !== r.Z_OK && this._error("Failed to reset stream");
  }, r.Zlib = h;
})(KE);
(function(r) {
  var e = Al.Buffer, t = Dd.exports.Transform, n = KE, i = Rl, a = c2.exports.ok, o = Al.kMaxLength, s = "Cannot create final Buffer. It would be larger than 0x" + o.toString(16) + " bytes";
  n.Z_MIN_WINDOWBITS = 8, n.Z_MAX_WINDOWBITS = 15, n.Z_DEFAULT_WINDOWBITS = 15, n.Z_MIN_CHUNK = 64, n.Z_MAX_CHUNK = 1 / 0, n.Z_DEFAULT_CHUNK = 16 * 1024, n.Z_MIN_MEMLEVEL = 1, n.Z_MAX_MEMLEVEL = 9, n.Z_DEFAULT_MEMLEVEL = 8, n.Z_MIN_LEVEL = -1, n.Z_MAX_LEVEL = 9, n.Z_DEFAULT_LEVEL = n.Z_DEFAULT_COMPRESSION;
  for (var c = Object.keys(n), h = 0; h < c.length; h++) {
    var d = c[h];
    d.match(/^Z/) && Object.defineProperty(r, d, {
      enumerable: !0,
      value: n[d],
      writable: !1
    });
  }
  for (var g = {
    Z_OK: n.Z_OK,
    Z_STREAM_END: n.Z_STREAM_END,
    Z_NEED_DICT: n.Z_NEED_DICT,
    Z_ERRNO: n.Z_ERRNO,
    Z_STREAM_ERROR: n.Z_STREAM_ERROR,
    Z_DATA_ERROR: n.Z_DATA_ERROR,
    Z_MEM_ERROR: n.Z_MEM_ERROR,
    Z_BUF_ERROR: n.Z_BUF_ERROR,
    Z_VERSION_ERROR: n.Z_VERSION_ERROR
  }, x = Object.keys(g), _ = 0; _ < x.length; _++) {
    var k = x[_];
    g[g[k]] = k;
  }
  Object.defineProperty(r, "codes", {
    enumerable: !0,
    value: Object.freeze(g),
    writable: !1
  }), r.Deflate = M, r.Inflate = G, r.Gzip = z, r.Gunzip = j, r.DeflateRaw = R, r.InflateRaw = te, r.Unzip = J, r.createDeflate = function(B) {
    return new M(B);
  }, r.createInflate = function(B) {
    return new G(B);
  }, r.createDeflateRaw = function(B) {
    return new R(B);
  }, r.createInflateRaw = function(B) {
    return new te(B);
  }, r.createGzip = function(B) {
    return new z(B);
  }, r.createGunzip = function(B) {
    return new j(B);
  }, r.createUnzip = function(B) {
    return new J(B);
  }, r.deflate = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new M(q), B, H);
  }, r.deflateSync = function(B, q) {
    return N(new M(q), B);
  }, r.gzip = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new z(q), B, H);
  }, r.gzipSync = function(B, q) {
    return N(new z(q), B);
  }, r.deflateRaw = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new R(q), B, H);
  }, r.deflateRawSync = function(B, q) {
    return N(new R(q), B);
  }, r.unzip = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new J(q), B, H);
  }, r.unzipSync = function(B, q) {
    return N(new J(q), B);
  }, r.inflate = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new G(q), B, H);
  }, r.inflateSync = function(B, q) {
    return N(new G(q), B);
  }, r.gunzip = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new j(q), B, H);
  }, r.gunzipSync = function(B, q) {
    return N(new j(q), B);
  }, r.inflateRaw = function(B, q, H) {
    return typeof q == "function" && (H = q, q = {}), P(new te(q), B, H);
  }, r.inflateRawSync = function(B, q) {
    return N(new te(q), B);
  };
  function P(B, q, H) {
    var oe = [], ne = 0;
    B.on("error", fe), B.on("end", _e), B.end(q), me();
    function me() {
      for (var Re; (Re = B.read()) !== null; )
        oe.push(Re), ne += Re.length;
      B.once("readable", me);
    }
    function fe(Re) {
      B.removeListener("end", _e), B.removeListener("readable", me), H(Re);
    }
    function _e() {
      var Re, Ie = null;
      ne >= o ? Ie = new RangeError(s) : Re = e.concat(oe, ne), oe = [], B.close(), H(Ie, Re);
    }
  }
  function N(B, q) {
    if (typeof q == "string" && (q = e.from(q)), !e.isBuffer(q)) throw new TypeError("Not a string or buffer");
    var H = B._finishFlushFlag;
    return B._processChunk(q, H);
  }
  function M(B) {
    if (!(this instanceof M)) return new M(B);
    ee.call(this, B, n.DEFLATE);
  }
  function G(B) {
    if (!(this instanceof G)) return new G(B);
    ee.call(this, B, n.INFLATE);
  }
  function z(B) {
    if (!(this instanceof z)) return new z(B);
    ee.call(this, B, n.GZIP);
  }
  function j(B) {
    if (!(this instanceof j)) return new j(B);
    ee.call(this, B, n.GUNZIP);
  }
  function R(B) {
    if (!(this instanceof R)) return new R(B);
    ee.call(this, B, n.DEFLATERAW);
  }
  function te(B) {
    if (!(this instanceof te)) return new te(B);
    ee.call(this, B, n.INFLATERAW);
  }
  function J(B) {
    if (!(this instanceof J)) return new J(B);
    ee.call(this, B, n.UNZIP);
  }
  function K(B) {
    return B === n.Z_NO_FLUSH || B === n.Z_PARTIAL_FLUSH || B === n.Z_SYNC_FLUSH || B === n.Z_FULL_FLUSH || B === n.Z_FINISH || B === n.Z_BLOCK;
  }
  function ee(B, q) {
    var H = this;
    if (this._opts = B = B || {}, this._chunkSize = B.chunkSize || r.Z_DEFAULT_CHUNK, t.call(this, B), B.flush && !K(B.flush))
      throw new Error("Invalid flush flag: " + B.flush);
    if (B.finishFlush && !K(B.finishFlush))
      throw new Error("Invalid flush flag: " + B.finishFlush);
    if (this._flushFlag = B.flush || n.Z_NO_FLUSH, this._finishFlushFlag = typeof B.finishFlush < "u" ? B.finishFlush : n.Z_FINISH, B.chunkSize && (B.chunkSize < r.Z_MIN_CHUNK || B.chunkSize > r.Z_MAX_CHUNK))
      throw new Error("Invalid chunk size: " + B.chunkSize);
    if (B.windowBits && (B.windowBits < r.Z_MIN_WINDOWBITS || B.windowBits > r.Z_MAX_WINDOWBITS))
      throw new Error("Invalid windowBits: " + B.windowBits);
    if (B.level && (B.level < r.Z_MIN_LEVEL || B.level > r.Z_MAX_LEVEL))
      throw new Error("Invalid compression level: " + B.level);
    if (B.memLevel && (B.memLevel < r.Z_MIN_MEMLEVEL || B.memLevel > r.Z_MAX_MEMLEVEL))
      throw new Error("Invalid memLevel: " + B.memLevel);
    if (B.strategy && B.strategy != r.Z_FILTERED && B.strategy != r.Z_HUFFMAN_ONLY && B.strategy != r.Z_RLE && B.strategy != r.Z_FIXED && B.strategy != r.Z_DEFAULT_STRATEGY)
      throw new Error("Invalid strategy: " + B.strategy);
    if (B.dictionary && !e.isBuffer(B.dictionary))
      throw new Error("Invalid dictionary: it should be a Buffer instance");
    this._handle = new n.Zlib(q);
    var oe = this;
    this._hadError = !1, this._handle.onerror = function(fe, _e) {
      ve(oe), oe._hadError = !0;
      var Re = new Error(fe);
      Re.errno = _e, Re.code = r.codes[_e], oe.emit("error", Re);
    };
    var ne = r.Z_DEFAULT_COMPRESSION;
    typeof B.level == "number" && (ne = B.level);
    var me = r.Z_DEFAULT_STRATEGY;
    typeof B.strategy == "number" && (me = B.strategy), this._handle.init(B.windowBits || r.Z_DEFAULT_WINDOWBITS, ne, B.memLevel || r.Z_DEFAULT_MEMLEVEL, me, B.dictionary), this._buffer = e.allocUnsafe(this._chunkSize), this._offset = 0, this._level = ne, this._strategy = me, this.once("end", this.close), Object.defineProperty(this, "_closed", {
      get: function() {
        return !H._handle;
      },
      configurable: !0,
      enumerable: !0
    });
  }
  i.inherits(ee, t), ee.prototype.params = function(B, q, H) {
    if (B < r.Z_MIN_LEVEL || B > r.Z_MAX_LEVEL)
      throw new RangeError("Invalid compression level: " + B);
    if (q != r.Z_FILTERED && q != r.Z_HUFFMAN_ONLY && q != r.Z_RLE && q != r.Z_FIXED && q != r.Z_DEFAULT_STRATEGY)
      throw new TypeError("Invalid strategy: " + q);
    if (this._level !== B || this._strategy !== q) {
      var oe = this;
      this.flush(n.Z_SYNC_FLUSH, function() {
        a(oe._handle, "zlib binding closed"), oe._handle.params(B, q), oe._hadError || (oe._level = B, oe._strategy = q, H && H());
      });
    } else
      ir.nextTick(H);
  }, ee.prototype.reset = function() {
    return a(this._handle, "zlib binding closed"), this._handle.reset();
  }, ee.prototype._flush = function(B) {
    this._transform(e.alloc(0), "", B);
  }, ee.prototype.flush = function(B, q) {
    var H = this, oe = this._writableState;
    (typeof B == "function" || B === void 0 && !q) && (q = B, B = n.Z_FULL_FLUSH), oe.ended ? q && ir.nextTick(q) : oe.ending ? q && this.once("end", q) : oe.needDrain ? q && this.once("drain", function() {
      return H.flush(B, q);
    }) : (this._flushFlag = B, this.write(e.alloc(0), "", q));
  }, ee.prototype.close = function(B) {
    ve(this, B), ir.nextTick(de, this);
  };
  function ve(B, q) {
    q && ir.nextTick(q), B._handle && (B._handle.close(), B._handle = null);
  }
  function de(B) {
    B.emit("close");
  }
  ee.prototype._transform = function(B, q, H) {
    var oe, ne = this._writableState, me = ne.ending || ne.ended, fe = me && (!B || ne.length === B.length);
    if (B !== null && !e.isBuffer(B)) return H(new Error("invalid input"));
    if (!this._handle) return H(new Error("zlib binding closed"));
    fe ? oe = this._finishFlushFlag : (oe = this._flushFlag, B.length >= ne.length && (this._flushFlag = this._opts.flush || n.Z_NO_FLUSH)), this._processChunk(B, oe, H);
  }, ee.prototype._processChunk = function(B, q, H) {
    var oe = B && B.length, ne = this._chunkSize - this._offset, me = 0, fe = this, _e = typeof H == "function";
    if (!_e) {
      var Re = [], Ie = 0, W;
      this.on("error", function(xe) {
        W = xe;
      }), a(this._handle, "zlib binding closed");
      do
        var Z = this._handle.writeSync(
          q,
          B,
          // in
          me,
          // in_off
          oe,
          // in_len
          this._buffer,
          // out
          this._offset,
          //out_off
          ne
        );
      while (!this._hadError && Fe(Z[0], Z[1]));
      if (this._hadError)
        throw W;
      if (Ie >= o)
        throw ve(this), new RangeError(s);
      var se = e.concat(Re, Ie);
      return ve(this), se;
    }
    a(this._handle, "zlib binding closed");
    var ye = this._handle.write(
      q,
      B,
      // in
      me,
      // in_off
      oe,
      // in_len
      this._buffer,
      // out
      this._offset,
      //out_off
      ne
    );
    ye.buffer = B, ye.callback = Fe;
    function Fe(xe, be) {
      if (this && (this.buffer = null, this.callback = null), !fe._hadError) {
        var he = ne - be;
        if (a(he >= 0, "have should not go down"), he > 0) {
          var ke = fe._buffer.slice(fe._offset, fe._offset + he);
          fe._offset += he, _e ? fe.push(ke) : (Re.push(ke), Ie += ke.length);
        }
        if ((be === 0 || fe._offset >= fe._chunkSize) && (ne = fe._chunkSize, fe._offset = 0, fe._buffer = e.allocUnsafe(fe._chunkSize)), be === 0) {
          if (me += oe - xe, oe = xe, !_e) return !0;
          var De = fe._handle.write(q, B, me, oe, fe._buffer, fe._offset, fe._chunkSize);
          De.callback = Fe, De.buffer = B;
          return;
        }
        if (!_e) return !1;
        H();
      }
    }
  }, i.inherits(M, ee), i.inherits(G, ee), i.inherits(z, ee), i.inherits(j, ee), i.inherits(R, ee), i.inherits(te, ee), i.inherits(J, ee);
})(Ec);
var Z_ = /* @__PURE__ */ function(r) {
  xl(e, r);
  function e(n, i, a) {
    var o;
    return o = r.call(this, {
      decodeStrings: !1
    }) || this, o.finalize = o.finalize.bind(_T(o)), o.document = n, o.id = i, a == null && (a = {}), o.data = a, o.gen = 0, o.deflate = null, o.compress = o.document.compress && !o.data.Filter, o.uncompressedLength = 0, o.chunks = [], o;
  }
  var t = e.prototype;
  return t.initDeflate = function() {
    var i = this;
    return this.data.Filter = "FlateDecode", this.deflate = Ec.createDeflate(), this.deflate.on("data", function(a) {
      return i.chunks.push(a), i.data.Length += a.length;
    }), this.deflate.on("end", this.finalize);
  }, t._write = function(i, a, o) {
    return i instanceof Uint8Array || (i = tt.from(i + `
`, "binary")), this.uncompressedLength += i.length, this.data.Length == null && (this.data.Length = 0), this.compress ? (this.deflate || this.initDeflate(), this.deflate.write(i)) : (this.chunks.push(i), this.data.Length += i.length), o();
  }, t.end = function() {
    return r.prototype.end.apply(this, arguments), this.deflate ? this.deflate.end() : this.finalize();
  }, t.finalize = function() {
    if (this.offset = this.document._offset, this.document._write(this.id + " " + this.gen + " obj"), this.document._write(si.convert(this.data)), this.chunks.length) {
      this.document._write("stream");
      for (var i = 0, a = Array.from(this.chunks); i < a.length; i++) {
        var o = a[i];
        this.document._write(o);
      }
      this.chunks.length = 0, this.document._write(`
endstream`);
    }
    return this.document._write("endobj"), this.document._refEnd(this);
  }, t.toString = function() {
    return this.id + " " + this.gen + " R";
  }, e;
}(XE.Writable), KX = /* @__PURE__ */ function() {
  function r(t) {
    t === void 0 && (t = {}), this._items = {}, this.limits = typeof t.limits == "boolean" ? t.limits : !0;
  }
  var e = r.prototype;
  return e.add = function(n, i) {
    return this._items[n] = i;
  }, e.get = function(n) {
    return this._items[n];
  }, e.toString = function() {
    var n = this, i = Object.keys(this._items).sort(function(g, x) {
      return n._compareKeys(g, x);
    }), a = ["<<"];
    if (this.limits && i.length > 1) {
      var o = i[0], s = i[i.length - 1];
      a.push("  /Limits " + si.convert([this._dataForKey(o), this._dataForKey(s)]));
    }
    a.push("  /" + this._keysName() + " [");
    for (var c = ou(i), h; !(h = c()).done; ) {
      var d = h.value;
      a.push("    " + si.convert(this._dataForKey(d)) + " " + si.convert(this._items[d]));
    }
    return a.push("]"), a.push(">>"), a.join(`
`);
  }, e._compareKeys = function() {
    throw new Error("Must be implemented by subclasses");
  }, e._keysName = function() {
    throw new Error("Must be implemented by subclasses");
  }, e._dataForKey = function() {
    throw new Error("Must be implemented by subclasses");
  }, r;
}(), Xh = /* @__PURE__ */ function(r) {
  xl(e, r);
  function e() {
    return r.apply(this, arguments) || this;
  }
  var t = e.prototype;
  return t._compareKeys = function(i, a) {
    return i.localeCompare(a);
  }, t._keysName = function() {
    return "Names";
  }, t._dataForKey = function(i) {
    return new String(i);
  }, e;
}(KX), JX = /[\n\r\t\b\f\(\)\\]/g, QX = {
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t",
  "\b": "\\b",
  "\f": "\\f",
  "\\": "\\\\",
  "(": "\\(",
  ")": "\\)"
}, fc = function(e, t) {
  return (Array(t + 1).join("0") + e).slice(-t);
}, eK = function(e) {
  var t = e.length;
  if (t & 1)
    throw new Error("Buffer length must be even");
  for (var n = 0, i = t - 1; n < i; n += 2) {
    var a = e[n];
    e[n] = e[n + 1], e[n + 1] = a;
  }
  return e;
}, tK = /* @__PURE__ */ function() {
  function r() {
  }
  return r.convert = function(t) {
    if (typeof t == "string")
      return "/" + t;
    if (t instanceof String) {
      for (var n = t, i = !1, a = 0, o = n.length; a < o; a++)
        if (n.charCodeAt(a) > 127) {
          i = !0;
          break;
        }
      return i && (n = eK(tt.from("\uFEFF" + n, "utf16le")).toString("binary")), n = n.replace(JX, function(g) {
        return QX[g];
      }), "(" + n + ")";
    }
    if (tt.isBuffer(t))
      return "<" + t.toString("hex") + ">";
    if (t instanceof Z_ || t instanceof Xh)
      return t.toString();
    if (t instanceof Date)
      return "(D:" + fc(t.getUTCFullYear(), 4) + fc(t.getUTCMonth() + 1, 2) + fc(t.getUTCDate(), 2) + fc(t.getUTCHours(), 2) + fc(t.getUTCMinutes(), 2) + fc(t.getUTCSeconds(), 2) + "Z)";
    if (Array.isArray(t)) {
      var s = Array.from(t).map(function(g) {
        return r.convert(g);
      }).join(" ");
      return "[" + s + "]";
    }
    if ({}.toString.call(t) === "[object Object]") {
      var c = ["<<"];
      for (var h in t) {
        var d = t[h];
        c.push("/" + h + " " + r.convert(d));
      }
      return c.push(">>"), c.join(`
`);
    }
    return typeof t == "number" ? r.number(t) : "" + t;
  }, r.number = function(t) {
    if (t > -1e21 && t < 1e21)
      return Math.round(t * 1e6) / 1e6;
    throw new Error("unsupported number: " + t);
  }, r;
}(), si = tK, rK = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
}, nK = {
  "4A0": [4767.87, 6740.79],
  "2A0": [3370.39, 4767.87],
  A0: [2383.94, 3370.39],
  A1: [1683.78, 2383.94],
  A2: [1190.55, 1683.78],
  A3: [841.89, 1190.55],
  A4: [595.28, 841.89],
  A5: [419.53, 595.28],
  A6: [297.64, 419.53],
  A7: [209.76, 297.64],
  A8: [147.4, 209.76],
  A9: [104.88, 147.4],
  A10: [73.7, 104.88],
  B0: [2834.65, 4008.19],
  B1: [2004.09, 2834.65],
  B2: [1417.32, 2004.09],
  B3: [1000.63, 1417.32],
  B4: [708.66, 1000.63],
  B5: [498.9, 708.66],
  B6: [354.33, 498.9],
  B7: [249.45, 354.33],
  B8: [175.75, 249.45],
  B9: [124.72, 175.75],
  B10: [87.87, 124.72],
  C0: [2599.37, 3676.54],
  C1: [1836.85, 2599.37],
  C2: [1298.27, 1836.85],
  C3: [918.43, 1298.27],
  C4: [649.13, 918.43],
  C5: [459.21, 649.13],
  C6: [323.15, 459.21],
  C7: [229.61, 323.15],
  C8: [161.57, 229.61],
  C9: [113.39, 161.57],
  C10: [79.37, 113.39],
  RA0: [2437.8, 3458.27],
  RA1: [1729.13, 2437.8],
  RA2: [1218.9, 1729.13],
  RA3: [864.57, 1218.9],
  RA4: [609.45, 864.57],
  SRA0: [2551.18, 3628.35],
  SRA1: [1814.17, 2551.18],
  SRA2: [1275.59, 1814.17],
  SRA3: [907.09, 1275.59],
  SRA4: [637.8, 907.09],
  EXECUTIVE: [521.86, 756],
  FOLIO: [612, 936],
  LEGAL: [612, 1008],
  LETTER: [612, 792],
  TABLOID: [792, 1224]
}, iK = /* @__PURE__ */ function() {
  function r(t, n) {
    n === void 0 && (n = {}), this.document = t, this.size = n.size || "letter", this.layout = n.layout || "portrait", this.userUnit = n.userUnit || 1, this.margins = rK;
    var i = Array.isArray(this.size) ? this.size : nK[this.size.toUpperCase()];
    this.width = i[this.layout === "portrait" ? 0 : 1], this.height = i[this.layout === "portrait" ? 1 : 0], this.content = this.document.ref(), this.resources = this.document.ref({
      ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"]
    }), this.dictionary = this.document.ref({
      Type: "Page",
      Parent: this.document._root.data.Pages,
      MediaBox: [0, 0, this.width, this.height],
      Contents: this.content,
      Resources: this.resources,
      UserUnit: this.userUnit
    });
  }
  var e = r.prototype;
  return e.maxY = function() {
    return this.height;
  }, e.write = function(n) {
    return this.content.write(n);
  }, e.end = function() {
    return this.dictionary.end(), this.resources.end(), this.content.end();
  }, Sw(r, [{
    key: "fonts",
    get: function() {
      var n = this.resources.data;
      return n.Font != null ? n.Font : n.Font = {};
    }
  }, {
    key: "xobjects",
    get: function() {
      var n = this.resources.data;
      return n.XObject != null ? n.XObject : n.XObject = {};
    }
  }, {
    key: "ext_gstates",
    get: function() {
      var n = this.resources.data;
      return n.ExtGState != null ? n.ExtGState : n.ExtGState = {};
    }
  }, {
    key: "patterns",
    get: function() {
      var n = this.resources.data;
      return n.Pattern != null ? n.Pattern : n.Pattern = {};
    }
  }, {
    key: "colorSpaces",
    get: function() {
      var n = this.resources.data;
      return n.ColorSpace || (n.ColorSpace = {});
    }
  }, {
    key: "annotations",
    get: function() {
      var n = this.dictionary.data;
      return n.Annots != null ? n.Annots : n.Annots = [];
    }
  }, {
    key: "structParentTreeKey",
    get: function() {
      var n = this.dictionary.data;
      return n.StructParents != null ? n.StructParents : n.StructParents = this.document.createStructParentTreeNextKey();
    }
  }]), r;
}(), aK = function(e) {
  for (var t = [], n = 0; n < e.sigBytes; n++)
    t.push(e.words[Math.floor(n / 4)] >> 8 * (3 - n % 4) & 255);
  return tt.from(t);
}, oK = /* @__PURE__ */ function() {
  function r() {
  }
  return r.generateFileID = function(t) {
    t === void 0 && (t = {});
    var n = t.CreationDate.getTime() + `
`;
    for (var i in t)
      t.hasOwnProperty(i) && (n += i + ": " + t[i].valueOf() + `
`);
    return aK(U9(n));
  }, r;
}(), sK = si.number, Og = /* @__PURE__ */ function() {
  function r(t) {
    this.doc = t, this.stops = [], this.embedded = !1, this.transform = [1, 0, 0, 1, 0, 0];
  }
  var e = r.prototype;
  return e.stop = function(n, i, a) {
    if (a == null && (a = 1), i = this.doc._normalizeColor(i), this.stops.length === 0)
      if (i.length === 3)
        this._colorSpace = "DeviceRGB";
      else if (i.length === 4)
        this._colorSpace = "DeviceCMYK";
      else if (i.length === 1)
        this._colorSpace = "DeviceGray";
      else
        throw new Error("Unknown color space");
    else if (this._colorSpace === "DeviceRGB" && i.length !== 3 || this._colorSpace === "DeviceCMYK" && i.length !== 4 || this._colorSpace === "DeviceGray" && i.length !== 1)
      throw new Error("All gradient stops must use the same color space");
    return a = Math.max(0, Math.min(1, a)), this.stops.push([n, i, a]), this;
  }, e.setTransform = function(n, i, a, o, s, c) {
    return this.transform = [n, i, a, o, s, c], this;
  }, e.embed = function(n) {
    var i, a = this.stops.length;
    if (a !== 0) {
      this.embedded = !0, this.matrix = n;
      var o = this.stops[a - 1];
      o[0] < 1 && this.stops.push([1, o[1], o[2]]);
      for (var s = [], c = [], h = [], d = 0; d < a - 1; d++)
        c.push(0, 1), d + 2 !== a && s.push(this.stops[d + 1][0]), i = this.doc.ref({
          FunctionType: 2,
          Domain: [0, 1],
          C0: this.stops[d + 0][1],
          C1: this.stops[d + 1][1],
          N: 1
        }), h.push(i), i.end();
      a === 1 ? i = h[0] : (i = this.doc.ref({
        FunctionType: 3,
        // stitching function
        Domain: [0, 1],
        Functions: h,
        Bounds: s,
        Encode: c
      }), i.end()), this.id = "Sh" + ++this.doc._gradCount;
      var g = this.shader(i);
      g.end();
      var x = this.doc.ref({
        Type: "Pattern",
        PatternType: 2,
        Shading: g,
        Matrix: this.matrix.map(sK)
      });
      if (x.end(), this.stops.some(function(R) {
        return R[2] < 1;
      })) {
        var _ = this.opacityGradient();
        _._colorSpace = "DeviceGray";
        for (var k = ou(this.stops), P; !(P = k()).done; ) {
          var N = P.value;
          _.stop(N[0], [N[2]]);
        }
        _ = _.embed(this.matrix);
        var M = [0, 0, this.doc.page.width, this.doc.page.height], G = this.doc.ref({
          Type: "XObject",
          Subtype: "Form",
          FormType: 1,
          BBox: M,
          Group: {
            Type: "Group",
            S: "Transparency",
            CS: "DeviceGray"
          },
          Resources: {
            ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
            Pattern: {
              Sh1: _
            }
          }
        });
        G.write("/Pattern cs /Sh1 scn"), G.end(M.join(" ") + " re f");
        var z = this.doc.ref({
          Type: "ExtGState",
          SMask: {
            Type: "Mask",
            S: "Luminosity",
            G
          }
        });
        z.end();
        var j = this.doc.ref({
          Type: "Pattern",
          PatternType: 1,
          PaintType: 1,
          TilingType: 2,
          BBox: M,
          XStep: M[2],
          YStep: M[3],
          Resources: {
            ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
            Pattern: {
              Sh1: x
            },
            ExtGState: {
              Gs1: z
            }
          }
        });
        j.write("/Gs1 gs /Pattern cs /Sh1 scn"), j.end(M.join(" ") + " re f"), this.doc.page.patterns[this.id] = j;
      } else
        this.doc.page.patterns[this.id] = x;
      return x;
    }
  }, e.apply = function(n) {
    var i = this.doc._ctm, a = i[0], o = i[1], s = i[2], c = i[3], h = i[4], d = i[5], g = this.transform, x = g[0], _ = g[1], k = g[2], P = g[3], N = g[4], M = g[5], G = [a * x + s * _, o * x + c * _, a * k + s * P, o * k + c * P, a * N + s * M + h, o * N + c * M + d];
    return (!this.embedded || G.join(" ") !== this.matrix.join(" ")) && this.embed(G), this.doc.addContent("/" + this.id + " " + n);
  }, r;
}(), uK = /* @__PURE__ */ function(r) {
  xl(e, r);
  function e(n, i, a, o, s) {
    var c;
    return c = r.call(this, n) || this, c.x1 = i, c.y1 = a, c.x2 = o, c.y2 = s, c;
  }
  var t = e.prototype;
  return t.shader = function(i) {
    return this.doc.ref({
      ShadingType: 2,
      ColorSpace: this._colorSpace,
      Coords: [this.x1, this.y1, this.x2, this.y2],
      Function: i,
      Extend: [!0, !0]
    });
  }, t.opacityGradient = function() {
    return new e(this.doc, this.x1, this.y1, this.x2, this.y2);
  }, e;
}(Og), lK = /* @__PURE__ */ function(r) {
  xl(e, r);
  function e(n, i, a, o, s, c, h) {
    var d;
    return d = r.call(this, n) || this, d.doc = n, d.x1 = i, d.y1 = a, d.r1 = o, d.x2 = s, d.y2 = c, d.r2 = h, d;
  }
  var t = e.prototype;
  return t.shader = function(i) {
    return this.doc.ref({
      ShadingType: 3,
      ColorSpace: this._colorSpace,
      Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
      Function: i,
      Extend: [!0, !0]
    });
  }, t.opacityGradient = function() {
    return new e(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
  }, e;
}(Og), Rg = {
  PDFGradient: Og,
  PDFLinearGradient: uK,
  PDFRadialGradient: lK
}, T8 = Rg.PDFGradient, cK = Rg.PDFLinearGradient, fK = Rg.PDFRadialGradient, hK = {
  initColor: function() {
    return this._opacityRegistry = {}, this._opacityCount = 0, this._gradCount = 0;
  },
  _normalizeColor: function(e) {
    if (e instanceof T8)
      return e;
    var t;
    if (typeof e == "string")
      if (e.charAt(0) === "#") {
        e.length === 4 && (e = e.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3"));
        var n = parseInt(e.slice(1), 16);
        e = [n >> 16, n >> 8 & 255, n & 255];
      } else k8[e] && (e = k8[e]);
    return Array.isArray(e) ? (e.length === 3 ? e = function() {
      for (var i = [], a = 0, o = Array.from(e); a < o.length; a++)
        t = o[a], i.push(t / 255);
      return i;
    }() : e.length === 4 && (e = function() {
      for (var i = [], a = 0, o = Array.from(e); a < o.length; a++)
        t = o[a], i.push(t / 100);
      return i;
    }()), e) : null;
  },
  _setColor: function(e, t) {
    if (e = this._normalizeColor(e), !e)
      return !1;
    var n = t ? "SCN" : "scn";
    if (e instanceof T8)
      this._setColorSpace("Pattern", t), e.apply(n);
    else {
      var i = e.length === 4 ? "DeviceCMYK" : "DeviceRGB";
      this._setColorSpace(i, t), e = e.join(" "), this.addContent(e + " " + n);
    }
    return !0;
  },
  _setColorSpace: function(e, t) {
    var n = t ? "CS" : "cs";
    return this.addContent("/" + e + " " + n);
  },
  fillColor: function(e, t) {
    var n = this._setColor(e, !1);
    return n && this.fillOpacity(t), this._fillColor = [e, t], this;
  },
  strokeColor: function(e, t) {
    var n = this._setColor(e, !0);
    return n && this.strokeOpacity(t), this;
  },
  opacity: function(e) {
    return this._doOpacity(e, e), this;
  },
  fillOpacity: function(e) {
    return this._doOpacity(e, null), this;
  },
  strokeOpacity: function(e) {
    return this._doOpacity(null, e), this;
  },
  _doOpacity: function(e, t) {
    var n, i;
    if (!(e == null && t == null)) {
      e != null && (e = Math.max(0, Math.min(1, e))), t != null && (t = Math.max(0, Math.min(1, t)));
      var a = e + "_" + t;
      if (this._opacityRegistry[a]) {
        var o = Array.from(this._opacityRegistry[a]);
        n = o[0], i = o[1];
      } else {
        n = {
          Type: "ExtGState"
        }, e != null && (n.ca = e), t != null && (n.CA = t), n = this.ref(n), n.end();
        var s = ++this._opacityCount;
        i = "Gs" + s, this._opacityRegistry[a] = [n, i];
      }
      return this.page.ext_gstates[i] = n, this.addContent("/" + i + " gs");
    }
  },
  linearGradient: function(e, t, n, i) {
    return new cK(this, e, t, n, i);
  },
  radialGradient: function(e, t, n, i, a, o) {
    return new fK(this, e, t, n, i, a, o);
  }
}, k8 = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  grey: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, Lt, Mt, hr, kr, _c, Dc;
Lt = Mt = hr = kr = _c = Dc = 0;
var q_ = {
  M: 2,
  m: 2,
  Z: 0,
  z: 0,
  L: 2,
  l: 2,
  H: 1,
  h: 1,
  V: 1,
  v: 1,
  C: 6,
  c: 6,
  S: 4,
  s: 4,
  Q: 4,
  q: 4,
  T: 2,
  t: 2,
  A: 7,
  a: 7
}, dK = function(e) {
  return e in q_;
}, pK = function(e) {
  var t = e.codePointAt(0);
  return t === 32 || t === 9 || t === 13 || t === 10;
}, vK = function(e) {
  var t = e.codePointAt(0);
  return t == null ? !1 : 48 <= t && t <= 57;
}, T4 = function(e, t) {
  for (var n = t, i = "", a = (
    /** @type {ReadNumberState} */
    "none"
  ); n < e.length; n += 1) {
    var o = e[n];
    if (o === "+" || o === "-") {
      if (a === "none") {
        a = "sign", i += o;
        continue;
      }
      if (a === "e") {
        a = "exponent_sign", i += o;
        continue;
      }
    }
    if (vK(o)) {
      if (a === "none" || a === "sign" || a === "whole") {
        a = "whole", i += o;
        continue;
      }
      if (a === "decimal_point" || a === "decimal") {
        a = "decimal", i += o;
        continue;
      }
      if (a === "e" || a === "exponent_sign" || a === "exponent") {
        a = "exponent", i += o;
        continue;
      }
    }
    if (o === "." && (a === "none" || a === "sign" || a === "whole")) {
      a = "decimal_point", i += o;
      continue;
    }
    if ((o === "E" || o === "e") && (a === "whole" || a === "decimal_point" || a === "decimal")) {
      a = "e", i += o;
      continue;
    }
    break;
  }
  var s = Number.parseFloat(i);
  return Number.isNaN(s) ? [t, null] : [n - 1, s];
}, gK = function(e) {
  for (var t = [], n = null, i = (
    /** @type {number[]} */
    []
  ), a = 0, o = !1, s = !1, c = 0; c < e.length; c += 1) {
    var h = e.charAt(c);
    if (!pK(h)) {
      if (o && h === ",") {
        if (s)
          break;
        s = !0;
        continue;
      }
      if (dK(h)) {
        if (s)
          return t;
        if (n == null) {
          if (h !== "M" && h !== "m")
            return t;
        } else if (i.length !== 0)
          return t;
        n = h, i = [], a = q_[n], o = !1, a === 0 && t.push({
          command: n,
          args: i
        });
        continue;
      }
      if (n == null)
        return t;
      var d = c, g = null;
      if (n === "A" || n === "a") {
        var x = i.length;
        if ((x === 0 || x === 1) && h !== "+" && h !== "-") {
          var _ = T4(e, c);
          d = _[0], g = _[1];
        }
        if (x === 2 || x === 5 || x === 6) {
          var k = T4(e, c);
          d = k[0], g = k[1];
        }
        (x === 3 || x === 4) && (h === "0" && (g = 0), h === "1" && (g = 1));
      } else {
        var P = T4(e, c);
        d = P[0], g = P[1];
      }
      if (g == null)
        return t;
      i.push(g), o = !0, s = !1, c = d, i.length === a && (t.push({
        command: n,
        args: i
      }), n === "M" && (n = "L"), n === "m" && (n = "l"), i = []);
    }
  }
  return t;
}, mK = function(e, t) {
  Lt = Mt = hr = kr = _c = Dc = 0;
  for (var n = 0; n < e.length; n++) {
    var i = e[n], a = i.command, o = i.args;
    typeof S8[a] == "function" && S8[a](t, o);
  }
}, S8 = {
  M: function(e, t) {
    return Lt = t[0], Mt = t[1], hr = kr = null, _c = Lt, Dc = Mt, e.moveTo(Lt, Mt);
  },
  m: function(e, t) {
    return Lt += t[0], Mt += t[1], hr = kr = null, _c = Lt, Dc = Mt, e.moveTo(Lt, Mt);
  },
  C: function(e, t) {
    return Lt = t[4], Mt = t[5], hr = t[2], kr = t[3], e.bezierCurveTo.apply(e, t);
  },
  c: function(e, t) {
    return e.bezierCurveTo(t[0] + Lt, t[1] + Mt, t[2] + Lt, t[3] + Mt, t[4] + Lt, t[5] + Mt), hr = Lt + t[2], kr = Mt + t[3], Lt += t[4], Mt += t[5];
  },
  S: function(e, t) {
    return hr === null && (hr = Lt, kr = Mt), e.bezierCurveTo(Lt - (hr - Lt), Mt - (kr - Mt), t[0], t[1], t[2], t[3]), hr = t[0], kr = t[1], Lt = t[2], Mt = t[3];
  },
  s: function(e, t) {
    return hr === null && (hr = Lt, kr = Mt), e.bezierCurveTo(Lt - (hr - Lt), Mt - (kr - Mt), Lt + t[0], Mt + t[1], Lt + t[2], Mt + t[3]), hr = Lt + t[0], kr = Mt + t[1], Lt += t[2], Mt += t[3];
  },
  Q: function(e, t) {
    return hr = t[0], kr = t[1], Lt = t[2], Mt = t[3], e.quadraticCurveTo(t[0], t[1], Lt, Mt);
  },
  q: function(e, t) {
    return e.quadraticCurveTo(t[0] + Lt, t[1] + Mt, t[2] + Lt, t[3] + Mt), hr = Lt + t[0], kr = Mt + t[1], Lt += t[2], Mt += t[3];
  },
  T: function(e, t) {
    return hr === null ? (hr = Lt, kr = Mt) : (hr = Lt - (hr - Lt), kr = Mt - (kr - Mt)), e.quadraticCurveTo(hr, kr, t[0], t[1]), hr = Lt - (hr - Lt), kr = Mt - (kr - Mt), Lt = t[0], Mt = t[1];
  },
  t: function(e, t) {
    return hr === null ? (hr = Lt, kr = Mt) : (hr = Lt - (hr - Lt), kr = Mt - (kr - Mt)), e.quadraticCurveTo(hr, kr, Lt + t[0], Mt + t[1]), Lt += t[0], Mt += t[1];
  },
  A: function(e, t) {
    return C8(e, Lt, Mt, t), Lt = t[5], Mt = t[6];
  },
  a: function(e, t) {
    return t[5] += Lt, t[6] += Mt, C8(e, Lt, Mt, t), Lt = t[5], Mt = t[6];
  },
  L: function(e, t) {
    return Lt = t[0], Mt = t[1], hr = kr = null, e.lineTo(Lt, Mt);
  },
  l: function(e, t) {
    return Lt += t[0], Mt += t[1], hr = kr = null, e.lineTo(Lt, Mt);
  },
  H: function(e, t) {
    return Lt = t[0], hr = kr = null, e.lineTo(Lt, Mt);
  },
  h: function(e, t) {
    return Lt += t[0], hr = kr = null, e.lineTo(Lt, Mt);
  },
  V: function(e, t) {
    return Mt = t[0], hr = kr = null, e.lineTo(Lt, Mt);
  },
  v: function(e, t) {
    return Mt += t[0], hr = kr = null, e.lineTo(Lt, Mt);
  },
  Z: function(e) {
    return e.closePath(), Lt = _c, Mt = Dc;
  },
  z: function(e) {
    return e.closePath(), Lt = _c, Mt = Dc;
  }
}, C8 = function(e, t, n, i) {
  for (var a = i[0], o = i[1], s = i[2], c = i[3], h = i[4], d = i[5], g = i[6], x = yK(d, g, a, o, c, h, s, t, n), _ = ou(x), k; !(k = _()).done; ) {
    var P = k.value, N = bK.apply(void 0, P);
    e.bezierCurveTo.apply(e, N);
  }
}, yK = function(e, t, n, i, a, o, s, c, h) {
  var d = s * (Math.PI / 180), g = Math.sin(d), x = Math.cos(d);
  n = Math.abs(n), i = Math.abs(i), hr = x * (c - e) * 0.5 + g * (h - t) * 0.5, kr = x * (h - t) * 0.5 - g * (c - e) * 0.5;
  var _ = hr * hr / (n * n) + kr * kr / (i * i);
  _ > 1 && (_ = Math.sqrt(_), n *= _, i *= _);
  var k = x / n, P = g / n, N = -g / i, M = x / i, G = k * c + P * h, z = N * c + M * h, j = k * e + P * t, R = N * e + M * t, te = (j - G) * (j - G) + (R - z) * (R - z), J = 1 / te - 0.25;
  J < 0 && (J = 0);
  var K = Math.sqrt(J);
  o === a && (K = -K);
  var ee = 0.5 * (G + j) - K * (R - z), ve = 0.5 * (z + R) + K * (j - G), de = Math.atan2(z - ve, G - ee), B = Math.atan2(R - ve, j - ee), q = B - de;
  q < 0 && o === 1 ? q += 2 * Math.PI : q > 0 && o === 0 && (q -= 2 * Math.PI);
  for (var H = Math.ceil(Math.abs(q / (Math.PI * 0.5 + 1e-3))), oe = [], ne = 0; ne < H; ne++) {
    var me = de + ne * q / H, fe = de + (ne + 1) * q / H;
    oe[ne] = [ee, ve, me, fe, n, i, g, x];
  }
  return oe;
}, bK = function(e, t, n, i, a, o, s, c) {
  var h = c * a, d = -s * o, g = s * a, x = c * o, _ = 0.5 * (i - n), k = 8 / 3 * Math.sin(_ * 0.5) * Math.sin(_ * 0.5) / Math.sin(_), P = e + Math.cos(n) - k * Math.sin(n), N = t + Math.sin(n) + k * Math.cos(n), M = e + Math.cos(i), G = t + Math.sin(i), z = M + k * Math.sin(i), j = G - k * Math.cos(i);
  return [h * P + d * N, g * P + x * N, h * z + d * j, g * z + x * j, h * M + d * G, g * M + x * G];
}, wK = /* @__PURE__ */ function() {
  function r() {
  }
  return r.apply = function(t, n) {
    var i = gK(n);
    mK(i, t);
  }, r;
}(), K0 = si.number, nh = 4 * ((Math.sqrt(2) - 1) / 3), AK = {
  initVector: function() {
    return this._ctm = [1, 0, 0, 1, 0, 0], this._ctmStack = [];
  },
  save: function() {
    return this._ctmStack.push(this._ctm.slice()), this.addContent("q");
  },
  restore: function() {
    return this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0], this.addContent("Q");
  },
  closePath: function() {
    return this.addContent("h");
  },
  lineWidth: function(e) {
    return this.addContent(K0(e) + " w");
  },
  _CAP_STYLES: {
    BUTT: 0,
    ROUND: 1,
    SQUARE: 2
  },
  lineCap: function(e) {
    return typeof e == "string" && (e = this._CAP_STYLES[e.toUpperCase()]), this.addContent(e + " J");
  },
  _JOIN_STYLES: {
    MITER: 0,
    ROUND: 1,
    BEVEL: 2
  },
  lineJoin: function(e) {
    return typeof e == "string" && (e = this._JOIN_STYLES[e.toUpperCase()]), this.addContent(e + " j");
  },
  miterLimit: function(e) {
    return this.addContent(K0(e) + " M");
  },
  dash: function(e, t) {
    var n;
    if (t == null && (t = {}), e == null)
      return this;
    if (Array.isArray(e))
      return e = Array.from(e).map(function(a) {
        return si.number(a);
      }).join(" "), n = t.phase || 0, this.addContent("[" + e + "] " + si.number(n) + " d");
    var i = t.space != null ? t.space : e;
    return n = t.phase || 0, this.addContent("[" + si.number(e) + " " + si.number(i) + "] " + si.number(n) + " d");
  },
  undash: function() {
    return this.addContent("[] 0 d");
  },
  moveTo: function(e, t) {
    return this.addContent(K0(e) + " " + K0(t) + " m");
  },
  lineTo: function(e, t) {
    return this.addContent(K0(e) + " " + K0(t) + " l");
  },
  bezierCurveTo: function(e, t, n, i, a, o) {
    return this.addContent(K0(e) + " " + K0(t) + " " + K0(n) + " " + K0(i) + " " + K0(a) + " " + K0(o) + " c");
  },
  quadraticCurveTo: function(e, t, n, i) {
    return this.addContent(K0(e) + " " + K0(t) + " " + K0(n) + " " + K0(i) + " v");
  },
  rect: function(e, t, n, i) {
    return this.addContent(K0(e) + " " + K0(t) + " " + K0(n) + " " + K0(i) + " re");
  },
  roundedRect: function(e, t, n, i, a) {
    a == null && (a = 0), a = Math.min(a, 0.5 * n, 0.5 * i);
    var o = a * (1 - nh);
    return this.moveTo(e + a, t), this.lineTo(e + n - a, t), this.bezierCurveTo(e + n - o, t, e + n, t + o, e + n, t + a), this.lineTo(e + n, t + i - a), this.bezierCurveTo(e + n, t + i - o, e + n - o, t + i, e + n - a, t + i), this.lineTo(e + a, t + i), this.bezierCurveTo(e + o, t + i, e, t + i - o, e, t + i - a), this.lineTo(e, t + a), this.bezierCurveTo(e, t + o, e + o, t, e + a, t), this.closePath();
  },
  ellipse: function(e, t, n, i) {
    i == null && (i = n), e -= n, t -= i;
    var a = n * nh, o = i * nh, s = e + n * 2, c = t + i * 2, h = e + n, d = t + i;
    return this.moveTo(e, d), this.bezierCurveTo(e, d - o, h - a, t, h, t), this.bezierCurveTo(h + a, t, s, d - o, s, d), this.bezierCurveTo(s, d + o, h + a, c, h, c), this.bezierCurveTo(h - a, c, e, d + o, e, d), this.closePath();
  },
  circle: function(e, t, n) {
    return this.ellipse(e, t, n);
  },
  arc: function(e, t, n, i, a, o) {
    o == null && (o = !1);
    var s = 2 * Math.PI, c = 0.5 * Math.PI, h = a - i;
    if (Math.abs(h) > s)
      h = s;
    else if (h !== 0 && o !== h < 0) {
      var d = o ? -1 : 1;
      h = d * s + h;
    }
    var g = Math.ceil(Math.abs(h) / c), x = h / g, _ = x / c * nh * n, k = i, P = -Math.sin(k) * _, N = Math.cos(k) * _, M = e + Math.cos(k) * n, G = t + Math.sin(k) * n;
    this.moveTo(M, G);
    for (var z = 0, j = g, R = 0 <= j; R ? z < j : z > j; R ? z++ : z--) {
      var te = M + P, J = G + N;
      k += x, M = e + Math.cos(k) * n, G = t + Math.sin(k) * n, P = -Math.sin(k) * _, N = Math.cos(k) * _;
      var K = M - P, ee = G - N;
      this.bezierCurveTo(te, J, K, ee, M, G);
    }
    return this;
  },
  polygon: function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    this.moveTo.apply(this, Array.from(t.shift() || []));
    for (var i = 0, a = Array.from(t); i < a.length; i++) {
      var o = a[i];
      this.lineTo.apply(this, Array.from(o || []));
    }
    return this.closePath();
  },
  path: function(e) {
    return wK.apply(this, e), this;
  },
  _windingRule: function(e) {
    return /even-?odd/.test(e) ? "*" : "";
  },
  fill: function(e, t) {
    return /(even-?odd)|(non-?zero)/.test(e) && (t = e, e = null), e && this.fillColor(e), this.addContent("f" + this._windingRule(t));
  },
  stroke: function(e) {
    return e && this.strokeColor(e), this.addContent("S");
  },
  fillAndStroke: function(e, t, n) {
    t == null && (t = e);
    var i = /(even-?odd)|(non-?zero)/;
    return i.test(e) && (n = e, e = null), i.test(t) && (n = t, t = e), e && (this.fillColor(e), this.strokeColor(t)), this.addContent("B" + this._windingRule(n));
  },
  clip: function(e) {
    return this.addContent("W" + this._windingRule(e) + " n");
  },
  transform: function(e, t, n, i, a, o) {
    var s = this._ctm, c = Array.from(s), h = c[0], d = c[1], g = c[2], x = c[3], _ = c[4], k = c[5];
    s[0] = h * e + g * t, s[1] = d * e + x * t, s[2] = h * n + g * i, s[3] = d * n + x * i, s[4] = h * a + g * o + _, s[5] = d * a + x * o + k;
    var P = [e, t, n, i, a, o].map(function(N) {
      return si.number(N);
    }).join(" ");
    return this.addContent(P + " cm");
  },
  translate: function(e, t) {
    return this.transform(1, 0, 0, 1, e, t);
  },
  rotate: function(e, t) {
    t === void 0 && (t = {});
    var n = e * Math.PI / 180, i = Math.cos(n), a = Math.sin(n), o = 0, s = 0;
    if (t.origin != null) {
      var c = Array.from(t.origin);
      o = c[0], s = c[1];
      var h = o * i - s * a, d = o * a + s * i;
      o -= h, s -= d;
    }
    return this.transform(i, a, -a, i, o, s);
  },
  scale: function(e, t, n) {
    n === void 0 && (n = {}), t == null && (t = e), typeof t == "object" && (n = t, t = e);
    var i = 0, a = 0;
    if (n.origin != null) {
      var o = Array.from(n.origin);
      i = o[0], a = o[1], i -= e * i, a -= t * a;
    }
    return this.transform(e, 0, 0, t, i, a);
  },
  skew: function(e, t, n) {
    e === void 0 && (e = 0), t === void 0 && (t = 0);
    var i = e * Math.PI / 180, a = t * Math.PI / 180, o = Math.tan(i), s = Math.tan(a), c = 0, h = 0;
    if (n.origin != null) {
      var d = Array.from(n.origin);
      c = d[0], h = d[1];
      var g = c + o * h, x = h + s * c;
      c -= g, h -= x;
    }
    return this.transform(1, s, o, 1, c, h);
  }
}, xK = function(e, t, n) {
  for (var i = [], a = t + 1, o = e; o < a; o++)
    i.push(o);
  return i;
}, F8 = {
  402: 131,
  8211: 150,
  8212: 151,
  8216: 145,
  8217: 146,
  8218: 130,
  8220: 147,
  8221: 148,
  8222: 132,
  8224: 134,
  8225: 135,
  8226: 149,
  8230: 133,
  8364: 128,
  8240: 137,
  8249: 139,
  8250: 155,
  710: 136,
  8482: 153,
  338: 140,
  339: 156,
  732: 152,
  352: 138,
  353: 154,
  376: 159,
  381: 142,
  382: 158
}, O8 = `.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef

space         exclam         quotedbl       numbersign
dollar        percent        ampersand      quotesingle
parenleft     parenright     asterisk       plus
comma         hyphen         period         slash
zero          one            two            three
four          five           six            seven
eight         nine           colon          semicolon
less          equal          greater        question

at            A              B              C
D             E              F              G
H             I              J              K
L             M              N              O
P             Q              R              S
T             U              V              W
X             Y              Z              bracketleft
backslash     bracketright   asciicircum    underscore

grave         a              b              c
d             e              f              g
h             i              j              k
l             m              n              o
p             q              r              s
t             u              v              w
x             y              z              braceleft
bar           braceright     asciitilde     .notdef

Euro          .notdef        quotesinglbase florin
quotedblbase  ellipsis       dagger         daggerdbl
circumflex    perthousand    Scaron         guilsinglleft
OE            .notdef        Zcaron         .notdef
.notdef       quoteleft      quoteright     quotedblleft
quotedblright bullet         endash         emdash
tilde         trademark      scaron         guilsinglright
oe            .notdef        zcaron         ydieresis

space         exclamdown     cent           sterling
currency      yen            brokenbar      section
dieresis      copyright      ordfeminine    guillemotleft
logicalnot    hyphen         registered     macron
degree        plusminus      twosuperior    threesuperior
acute         mu             paragraph      periodcentered
cedilla       onesuperior    ordmasculine   guillemotright
onequarter    onehalf        threequarters  questiondown

Agrave        Aacute         Acircumflex    Atilde
Adieresis     Aring          AE             Ccedilla
Egrave        Eacute         Ecircumflex    Edieresis
Igrave        Iacute         Icircumflex    Idieresis
Eth           Ntilde         Ograve         Oacute
Ocircumflex   Otilde         Odieresis      multiply
Oslash        Ugrave         Uacute         Ucircumflex
Udieresis     Yacute         Thorn          germandbls

agrave        aacute         acircumflex    atilde
adieresis     aring          ae             ccedilla
egrave        eacute         ecircumflex    edieresis
igrave        iacute         icircumflex    idieresis
eth           ntilde         ograve         oacute
ocircumflex   otilde         odieresis      divide
oslash        ugrave         uacute         ucircumflex
udieresis     yacute         thorn          ydieresis`.split(/\s+/);
function EK(r) {
  for (var e = {
    attributes: {},
    glyphWidths: {},
    kernPairs: {}
  }, t = "", n = ou(r.split(`
`)), i; !(i = n()).done; ) {
    var a = i.value, o, s;
    if (o = a.match(/^Start(\w+)/)) {
      t = o[1];
      continue;
    } else if (o = a.match(/^End(\w+)/)) {
      t = "";
      continue;
    }
    switch (t) {
      case "FontMetrics":
        o = a.match(/(^\w+)\s+(.*)/);
        var c = o[1], h = o[2];
        (s = e.attributes[c]) ? (Array.isArray(s) || (s = e.attributes[c] = [s]), s.push(h)) : e.attributes[c] = h;
        break;
      case "CharMetrics":
        if (!/^CH?\s/.test(a))
          continue;
        var d = a.match(/\bN\s+(\.?\w+)\s*;/)[1];
        e.glyphWidths[d] = +a.match(/\bWX\s+(\d+)\s*;/)[1];
        break;
      case "KernPairs":
        o = a.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/), o && (e.kernPairs[o[1] + o[2]] = parseInt(o[3]));
        break;
    }
  }
  return e;
}
var _K = /* @__PURE__ */ function() {
  r.open = function(n) {
    throw new Error("AFMFont.open not available on browser build");
  }, r.fromJson = function(n) {
    return new r(n);
  };
  function r(t) {
    var n = this;
    typeof t == "string" ? (this.contents = t, this.parse()) : (this.attributes = t.attributes, this.glyphWidths = t.glyphWidths, this.kernPairs = t.kernPairs), this.charWidths = xK(0, 255).map(function(i) {
      return n.glyphWidths[O8[i]];
    }), this.bbox = Array.from(this.attributes.FontBBox.split(/\s+/)).map(function(i) {
      return +i;
    }), this.ascender = +(this.attributes.Ascender || 0), this.descender = +(this.attributes.Descender || 0), this.xHeight = +(this.attributes.XHeight || 0), this.capHeight = +(this.attributes.CapHeight || 0), this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
  }
  var e = r.prototype;
  return e.parse = function() {
    var n = EK(this.contents);
    this.attributes = n.attributes, this.glyphWidths = n.glyphWidths, this.kernPairs = n.kernPairs;
  }, e.encodeText = function(n) {
    for (var i = [], a = 0, o = n.length, s = 0 <= o; s ? a < o : a > o; s ? a++ : a--) {
      var c = n.charCodeAt(a);
      c = F8[c] || c, i.push(c.toString(16));
    }
    return i;
  }, e.glyphsForString = function(n) {
    for (var i = [], a = 0, o = n.length, s = 0 <= o; s ? a < o : a > o; s ? a++ : a--) {
      var c = n.charCodeAt(a);
      i.push(this.characterToGlyph(c));
    }
    return i;
  }, e.characterToGlyph = function(n) {
    return O8[F8[n] || n] || ".notdef";
  }, e.widthOfGlyph = function(n) {
    return this.glyphWidths[n] || 0;
  }, e.getKernPair = function(n, i) {
    return this.kernPairs[n + i] || 0;
  }, e.advancesForGlyphs = function(n) {
    for (var i = [], a = 0; a < n.length; a++) {
      var o = n[a], s = n[a + 1];
      i.push(this.widthOfGlyph(o) + this.getKernPair(o, s));
    }
    return i;
  }, r;
}(), DK = [
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:43:52 1997",
      "UniqueID 43052",
      "VMusage 37169 48194"
    ],
    FontName: "Helvetica-Bold",
    FullName: "Helvetica Bold",
    FamilyName: "Helvetica",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-170 -228 1003 962 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "532",
    Ascender: "718",
    Descender: "-207",
    StdHW: "118",
    StdVW: "140"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:45:12 1997",
      "UniqueID 43053",
      "VMusage 14482 68586"
    ],
    FontName: "Helvetica-BoldOblique",
    FullName: "Helvetica Bold Oblique",
    FamilyName: "Helvetica",
    Weight: "Bold",
    ItalicAngle: "-12",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-174 -228 1114 962",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "532",
    Ascender: "718",
    Descender: "-207",
    StdHW: "118",
    StdVW: "140"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:44:31 1997",
      "UniqueID 43055",
      "VMusage 14960 69346"
    ],
    FontName: "Helvetica-Oblique",
    FullName: "Helvetica Oblique",
    FamilyName: "Helvetica",
    Weight: "Medium",
    ItalicAngle: "-12",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-170 -225 1116 931 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "523",
    Ascender: "718",
    Descender: "-207",
    StdHW: "76",
    StdVW: "88"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:38:23 1997",
      "UniqueID 43054",
      "VMusage 37069 48094"
    ],
    FontName: "Helvetica",
    FullName: "Helvetica",
    FamilyName: "Helvetica",
    Weight: "Medium",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-166 -225 1000 931 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "523",
    Ascender: "718",
    Descender: "-207",
    StdHW: "76",
    StdVW: "88"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:52:56 1997",
      "UniqueID 43065",
      "VMusage 41636 52661"
    ],
    FontName: "Times-Bold",
    FullName: "Times Bold",
    FamilyName: "Times",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-168 -218 1000 935 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "676",
    XHeight: "461",
    Ascender: "683",
    Descender: "-217",
    StdHW: "44",
    StdVW: "139"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 13:04:06 1997",
      "UniqueID 43066",
      "VMusage 45874 56899"
    ],
    FontName: "Times-BoldItalic",
    FullName: "Times Bold Italic",
    FamilyName: "Times",
    Weight: "Bold",
    ItalicAngle: "-15",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-200 -218 996 921",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "669",
    XHeight: "462",
    Ascender: "683",
    Descender: "-217",
    StdHW: "42",
    StdVW: "121"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:56:55 1997",
      "UniqueID 43067",
      "VMusage 47727 58752"
    ],
    FontName: "Times-Italic",
    FullName: "Times Italic",
    FamilyName: "Times",
    Weight: "Medium",
    ItalicAngle: "-15.5",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-169 -217 1010 883 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "653",
    XHeight: "441",
    Ascender: "683",
    Descender: "-217",
    StdHW: "32",
    StdVW: "76"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:49:17 1997",
      "UniqueID 43068",
      "VMusage 43909 54934"
    ],
    FontName: "Times-Roman",
    FullName: "Times Roman",
    FamilyName: "Times",
    Weight: "Roman",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-168 -218 1000 898 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "662",
    XHeight: "450",
    Ascender: "683",
    Descender: "-217",
    StdHW: "28",
    StdVW: "84"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Mon Jun 23 16:28:00 1997",
      "UniqueID 43048",
      "VMusage 41139 52164"
    ],
    FontName: "Courier-Bold",
    FullName: "Courier Bold",
    FamilyName: "Courier",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-113 -250 749 801 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "439",
    Ascender: "629",
    Descender: "-157",
    StdHW: "84",
    StdVW: "106"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Mon Jun 23 16:28:46 1997",
      "UniqueID 43049",
      "VMusage 17529 79244"
    ],
    FontName: "Courier-BoldOblique",
    FullName: "Courier Bold Oblique",
    FamilyName: "Courier",
    Weight: "Bold",
    ItalicAngle: "-12",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-57 -250 869 801",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "439",
    Ascender: "629",
    Descender: "-157",
    StdHW: "84",
    StdVW: "106"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 17:37:52 1997",
      "UniqueID 43051",
      "VMusage 16248 75829"
    ],
    FontName: "Courier-Oblique",
    FullName: "Courier Oblique",
    FamilyName: "Courier",
    Weight: "Medium",
    ItalicAngle: "-12",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-27 -250 849 805 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "426",
    Ascender: "629",
    Descender: "-157",
    StdHW: "51",
    StdVW: "51"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 17:27:09 1997",
      "UniqueID 43050",
      "VMusage 39754 50779"
    ],
    FontName: "Courier",
    FullName: "Courier",
    FamilyName: "Courier",
    Weight: "Medium",
    ItalicAngle: "0",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-23 -250 715 805 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "426",
    Ascender: "629",
    Descender: "-157",
    StdHW: "51",
    StdVW: "51"
  }
], TK = {
  space: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  exclam: [
    333,
    333,
    278,
    278,
    333,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  quotedbl: [
    474,
    474,
    355,
    355,
    555,
    555,
    420,
    408,
    600,
    600,
    600,
    600
  ],
  numbersign: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  dollar: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  percent: [
    889,
    889,
    889,
    889,
    1e3,
    833,
    833,
    833,
    600,
    600,
    600,
    600
  ],
  ampersand: [
    722,
    722,
    667,
    667,
    833,
    778,
    778,
    778,
    600,
    600,
    600,
    600
  ],
  quoteright: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  parenleft: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  parenright: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  asterisk: [
    389,
    389,
    389,
    389,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  plus: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  comma: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  hyphen: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  period: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  slash: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  zero: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  one: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  two: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  three: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  four: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  five: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  six: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  seven: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  eight: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  nine: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  colon: [
    333,
    333,
    278,
    278,
    333,
    333,
    333,
    278,
    600,
    600,
    600,
    600
  ],
  semicolon: [
    333,
    333,
    278,
    278,
    333,
    333,
    333,
    278,
    600,
    600,
    600,
    600
  ],
  less: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  equal: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  greater: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  question: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  at: [
    975,
    975,
    1015,
    1015,
    930,
    832,
    920,
    921,
    600,
    600,
    600,
    600
  ],
  A: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  B: [
    722,
    722,
    667,
    667,
    667,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  C: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  D: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  E: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  F: [
    611,
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  G: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  H: [
    722,
    722,
    722,
    722,
    778,
    778,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  I: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  J: [
    556,
    556,
    500,
    500,
    500,
    500,
    444,
    389,
    600,
    600,
    600,
    600
  ],
  K: [
    722,
    722,
    667,
    667,
    778,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  L: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  M: [
    833,
    833,
    833,
    833,
    944,
    889,
    833,
    889,
    600,
    600,
    600,
    600
  ],
  N: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  O: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  P: [
    667,
    667,
    667,
    667,
    611,
    611,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  Q: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  R: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  S: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  T: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  U: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  V: [
    667,
    667,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  W: [
    944,
    944,
    944,
    944,
    1e3,
    889,
    833,
    944,
    600,
    600,
    600,
    600
  ],
  X: [
    667,
    667,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Y: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  Z: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  bracketleft: [
    333,
    333,
    278,
    278,
    333,
    333,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  backslash: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  bracketright: [
    333,
    333,
    278,
    278,
    333,
    333,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  asciicircum: [
    584,
    584,
    469,
    469,
    581,
    570,
    422,
    469,
    600,
    600,
    600,
    600
  ],
  underscore: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  quoteleft: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  a: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  b: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  c: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  d: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  e: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  f: [
    333,
    333,
    278,
    278,
    333,
    333,
    278,
    333,
    600,
    600,
    600,
    600
  ],
  g: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  h: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  i: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  j: [
    278,
    278,
    222,
    222,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  k: [
    556,
    556,
    500,
    500,
    556,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  l: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  m: [
    889,
    889,
    833,
    833,
    833,
    778,
    722,
    778,
    600,
    600,
    600,
    600
  ],
  n: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  o: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  p: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  q: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  r: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  s: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  t: [
    333,
    333,
    278,
    278,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  u: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  v: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  w: [
    778,
    778,
    722,
    722,
    722,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  x: [
    556,
    556,
    500,
    500,
    500,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  y: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  z: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  braceleft: [
    389,
    389,
    334,
    334,
    394,
    348,
    400,
    480,
    600,
    600,
    600,
    600
  ],
  bar: [
    280,
    280,
    260,
    260,
    220,
    220,
    275,
    200,
    600,
    600,
    600,
    600
  ],
  braceright: [
    389,
    389,
    334,
    334,
    394,
    348,
    400,
    480,
    600,
    600,
    600,
    600
  ],
  asciitilde: [
    584,
    584,
    584,
    584,
    520,
    570,
    541,
    541,
    600,
    600,
    600,
    600
  ],
  exclamdown: [
    333,
    333,
    333,
    333,
    333,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  cent: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  sterling: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  fraction: [
    167,
    167,
    167,
    167,
    167,
    167,
    167,
    167,
    600,
    600,
    600,
    600
  ],
  yen: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  florin: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  section: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  currency: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  quotesingle: [
    238,
    238,
    191,
    191,
    278,
    278,
    214,
    180,
    600,
    600,
    600,
    600
  ],
  quotedblleft: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  guillemotleft: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  guilsinglleft: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  guilsinglright: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  fi: [
    611,
    611,
    500,
    500,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  fl: [
    611,
    611,
    500,
    500,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  endash: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  dagger: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  daggerdbl: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  periodcentered: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  paragraph: [
    556,
    556,
    537,
    537,
    540,
    500,
    523,
    453,
    600,
    600,
    600,
    600
  ],
  bullet: [
    350,
    350,
    350,
    350,
    350,
    350,
    350,
    350,
    600,
    600,
    600,
    600
  ],
  quotesinglbase: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  quotedblbase: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  quotedblright: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  guillemotright: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ellipsis: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    889,
    1e3,
    600,
    600,
    600,
    600
  ],
  perthousand: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    600,
    600,
    600,
    600
  ],
  questiondown: [
    611,
    611,
    611,
    611,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  grave: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  acute: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  circumflex: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  tilde: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  macron: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  breve: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  dotaccent: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  dieresis: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ring: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  cedilla: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  hungarumlaut: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ogonek: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  caron: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  emdash: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    889,
    1e3,
    600,
    600,
    600,
    600
  ],
  AE: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    944,
    889,
    889,
    600,
    600,
    600,
    600
  ],
  ordfeminine: [
    370,
    370,
    370,
    370,
    300,
    266,
    276,
    276,
    600,
    600,
    600,
    600
  ],
  Lslash: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Oslash: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  OE: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    944,
    944,
    889,
    600,
    600,
    600,
    600
  ],
  ordmasculine: [
    365,
    365,
    365,
    365,
    330,
    300,
    310,
    310,
    600,
    600,
    600,
    600
  ],
  ae: [
    889,
    889,
    889,
    889,
    722,
    722,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  dotlessi: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  lslash: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  oslash: [
    611,
    611,
    611,
    611,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  oe: [
    944,
    944,
    944,
    944,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  germandbls: [
    611,
    611,
    611,
    611,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Idieresis: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  eacute: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  abreve: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  uhungarumlaut: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ecaron: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Ydieresis: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  divide: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  Yacute: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  Acircumflex: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  aacute: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Ucircumflex: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  yacute: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  scommaaccent: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  ecircumflex: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Uring: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Udieresis: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  aogonek: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Uacute: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  uogonek: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Edieresis: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  Dcroat: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  commaaccent: [
    250,
    250,
    250,
    250,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  copyright: [
    737,
    737,
    737,
    737,
    747,
    747,
    760,
    760,
    600,
    600,
    600,
    600
  ],
  Emacron: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  ccaron: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  aring: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Ncommaaccent: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  lacute: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  agrave: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Tcommaaccent: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Cacute: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  atilde: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Edotaccent: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  scaron: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  scedilla: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  iacute: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  lozenge: [
    494,
    494,
    471,
    471,
    494,
    494,
    471,
    471,
    600,
    600,
    600,
    600
  ],
  Rcaron: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Gcommaaccent: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  ucircumflex: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  acircumflex: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Amacron: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  rcaron: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  ccedilla: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Zdotaccent: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Thorn: [
    667,
    667,
    667,
    667,
    611,
    611,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  Omacron: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Racute: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Sacute: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  dcaron: [
    743,
    743,
    643,
    643,
    672,
    608,
    544,
    588,
    600,
    600,
    600,
    600
  ],
  Umacron: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  uring: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  threesuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  Ograve: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Agrave: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Abreve: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  multiply: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  uacute: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Tcaron: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  partialdiff: [
    494,
    494,
    476,
    476,
    494,
    494,
    476,
    476,
    600,
    600,
    600,
    600
  ],
  ydieresis: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  Nacute: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  icircumflex: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Ecircumflex: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  adieresis: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  edieresis: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  cacute: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  nacute: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  umacron: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Ncaron: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  Iacute: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  plusminus: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  brokenbar: [
    280,
    280,
    260,
    260,
    220,
    220,
    275,
    200,
    600,
    600,
    600,
    600
  ],
  registered: [
    737,
    737,
    737,
    737,
    747,
    747,
    760,
    760,
    600,
    600,
    600,
    600
  ],
  Gbreve: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Idotaccent: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  summation: [
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600
  ],
  Egrave: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  racute: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  omacron: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Zacute: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Zcaron: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  greaterequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  Eth: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Ccedilla: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  lcommaaccent: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  tcaron: [
    389,
    389,
    317,
    317,
    416,
    366,
    300,
    326,
    600,
    600,
    600,
    600
  ],
  eogonek: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Uogonek: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Aacute: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Adieresis: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  egrave: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  zacute: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  iogonek: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Oacute: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  oacute: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  amacron: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  sacute: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  idieresis: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Ocircumflex: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Ugrave: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Delta: [
    612,
    612,
    612,
    612,
    612,
    612,
    612,
    612,
    600,
    600,
    600,
    600
  ],
  thorn: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  twosuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  Odieresis: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  mu: [
    611,
    611,
    556,
    556,
    556,
    576,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  igrave: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  ohungarumlaut: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Eogonek: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  dcroat: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  threequarters: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  Scedilla: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  lcaron: [
    400,
    400,
    299,
    299,
    394,
    382,
    300,
    344,
    600,
    600,
    600,
    600
  ],
  Kcommaaccent: [
    722,
    722,
    667,
    667,
    778,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  Lacute: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  trademark: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    980,
    980,
    600,
    600,
    600,
    600
  ],
  edotaccent: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Igrave: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  Imacron: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  Lcaron: [
    611,
    611,
    556,
    556,
    667,
    611,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  onehalf: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  lessequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  ocircumflex: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ntilde: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Uhungarumlaut: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Eacute: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  emacron: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  gbreve: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  onequarter: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  Scaron: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  Scommaaccent: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  Ohungarumlaut: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  degree: [
    400,
    400,
    400,
    400,
    400,
    400,
    400,
    400,
    600,
    600,
    600,
    600
  ],
  ograve: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Ccaron: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  ugrave: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  radical: [
    549,
    549,
    453,
    453,
    549,
    549,
    453,
    453,
    600,
    600,
    600,
    600
  ],
  Dcaron: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  rcommaaccent: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  Ntilde: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  otilde: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Rcommaaccent: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Lcommaaccent: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Atilde: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Aogonek: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Aring: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Otilde: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  zdotaccent: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  Ecaron: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  Iogonek: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  kcommaaccent: [
    556,
    556,
    500,
    500,
    556,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  minus: [
    584,
    584,
    584,
    584,
    570,
    606,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  Icircumflex: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ncaron: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  tcommaaccent: [
    333,
    333,
    278,
    278,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  logicalnot: [
    584,
    584,
    584,
    584,
    570,
    606,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  odieresis: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  udieresis: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  notequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  gcommaaccent: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  eth: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  zcaron: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  ncommaaccent: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  onesuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  imacron: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Euro: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ]
}, kK = {
  AC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  ATcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  ATcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Au: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Audieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Augrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Av: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Ay: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Ayacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AacuteC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AacuteT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AacuteW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AacuteY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AacuteYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AacuteYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aacuteu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacutev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aacutew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Aacutey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aacuteyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aacuteydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AbreveC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AbreveT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AbreveW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AbreveY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AbreveYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AbreveYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Abreveu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abrevev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Abrevew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Abrevey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Abreveyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Abreveydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AcircumflexC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AcircumflexT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AcircumflexW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AcircumflexY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AcircumflexYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AcircumflexYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Acircumflexu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Acircumflexw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Acircumflexy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Acircumflexyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Acircumflexydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AdieresisC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AdieresisT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AdieresisW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AdieresisY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AdieresisYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AdieresisYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Adieresisu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Adieresisw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Adieresisy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Adieresisyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Adieresisydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AgraveC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AgraveT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AgraveW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AgraveY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AgraveYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AgraveYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Agraveu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agravev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Agravew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Agravey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Agraveyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Agraveydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AmacronC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AmacronT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AmacronW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AmacronY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AmacronYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AmacronYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Amacronu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Amacronw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Amacrony: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Amacronyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Amacronydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AogonekC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AogonekT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AogonekW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AogonekY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AogonekYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AogonekYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aogoneku: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aogonekw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -52
  ],
  Aogoneky: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  Aogonekyacute: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  Aogonekydieresis: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  AringC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AringT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AringW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AringY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AringYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AringYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aringu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aringw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Aringy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aringyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aringydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AtildeC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AtildeT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AtildeW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AtildeY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AtildeYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AtildeYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Atildeu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Atildew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Atildey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Atildeyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Atildeydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  BA: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAacute: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAbreve: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAcircumflex: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAdieresis: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAgrave: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAmacron: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAogonek: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAring: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAtilde: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BU: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUacute: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUcircumflex: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUdieresis: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUgrave: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUhungarumlaut: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUmacron: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUogonek: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUring: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  DA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  DcaronA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DcaronW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DcaronY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcaronYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcaronYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcaroncomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dcaronperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  DcroatA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DcroatW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DcroatY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcroatYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcroatYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcroatcomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dcroatperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  FA: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAacute: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAbreve: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAcircumflex: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAdieresis: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAgrave: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAmacron: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAogonek: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAring: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAtilde: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  Fa: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faacute: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fabreve: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Facircumflex: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fadieresis: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fagrave: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Famacron: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faogonek: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faring: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fatilde: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fcomma: [
    -100,
    -100,
    -150,
    -150,
    -92,
    -129,
    -135,
    -80
  ],
  Fperiod: [
    -100,
    -100,
    -150,
    -150,
    -110,
    -129,
    -135,
    -80
  ],
  JA: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAbreve: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAogonek: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAring: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  Jcomma: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    -25
  ],
  Jperiod: [
    -20,
    -20,
    -30,
    -30,
    -20,
    -10,
    -25
  ],
  Ju: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juacute: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jucircumflex: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Judieresis: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jugrave: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jumacron: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juogonek: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juring: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  KO: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOacute: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOcircumflex: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOdieresis: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOgrave: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOhungarumlaut: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOmacron: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOslash: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOtilde: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  Ke: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Keacute: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kecaron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kecircumflex: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kedieresis: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kedotaccent: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kegrave: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kemacron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Keogonek: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Ko: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Koacute: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kocircumflex: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kodieresis: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kograve: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kohungarumlaut: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Komacron: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Koslash: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kotilde: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Ku: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuacute: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kudieresis: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kugrave: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kumacron: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuogonek: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuring: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Ky: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kyacute: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kydieresis: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  KcommaaccentO: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOacute: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOcircumflex: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOdieresis: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOgrave: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOhungarumlaut: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOmacron: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOslash: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOtilde: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  Kcommaaccente: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccenteacute: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentecaron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentecircumflex: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentedieresis: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentedotaccent: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentegrave: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentemacron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccenteogonek: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccento: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentoacute: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentocircumflex: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentodieresis: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentograve: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentohungarumlaut: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentomacron: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentoslash: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentotilde: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentu: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuacute: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentudieresis: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentugrave: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentumacron: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuogonek: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccenturing: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccenty: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kcommaaccentyacute: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kcommaaccentydieresis: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  LT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Ly: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LacuteT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LacuteW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LacuteY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LacuteYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LacuteYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lacutequotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lacutequoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lacutey: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lacuteyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lacuteydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LcommaaccentT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LcommaaccentW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LcommaaccentY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LcommaaccentYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LcommaaccentYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lcommaaccentquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lcommaaccentquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lcommaaccenty: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lcommaaccentyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lcommaaccentydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LslashT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LslashW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LslashY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LslashYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LslashYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lslashquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lslashquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lslashy: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lslashyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lslashydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  OA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ocomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Operiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OacuteA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OacuteX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Oacutecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Oacuteperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OcircumflexX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ocircumflexcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ocircumflexperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OdieresisX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Odieresiscomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Odieresisperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OgraveA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OgraveX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ogravecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ograveperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OhungarumlautX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ohungarumlautcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ohungarumlautperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OmacronA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OmacronX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Omacroncomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Omacronperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OslashA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OslashW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OslashX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OslashY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OslashYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OslashYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Oslashcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Oslashperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OtildeA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OtildeX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Otildecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Otildeperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  PA: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAacute: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAbreve: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAcircumflex: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAdieresis: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAgrave: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAmacron: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAogonek: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAring: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAtilde: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  Pa: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paacute: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pabreve: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pacircumflex: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Padieresis: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pagrave: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pamacron: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paogonek: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paring: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Patilde: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pcomma: [
    -120,
    -120,
    -180,
    -180,
    -92,
    -129,
    -135,
    -111
  ],
  Pe: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Peacute: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pecaron: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pecircumflex: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pedieresis: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pedotaccent: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pegrave: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pemacron: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Peogonek: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Po: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Poacute: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pocircumflex: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Podieresis: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pograve: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pohungarumlaut: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pomacron: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Poslash: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Potilde: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pperiod: [
    -120,
    -120,
    -180,
    -180,
    -110,
    -129,
    -135,
    -111
  ],
  QU: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUacute: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUcircumflex: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUdieresis: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUgrave: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUhungarumlaut: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUmacron: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUogonek: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUring: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  Qcomma: [
    20,
    20
  ],
  Qperiod: [
    20,
    20,
    0,
    0,
    -20
  ],
  RO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RacuteW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RacuteY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RcaronW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RcaronY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RcommaaccentW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RcommaaccentY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  TA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Ta: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Taacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Taogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Taring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Te: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Teacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -70
  ],
  Tedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Temacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Teogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Thyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  To: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Toacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Todieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Toslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Totilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Trcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Turing: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Ty: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  TcaronA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Tcarona: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronaacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tcaronacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tcaronadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronaogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronaring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaroncolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcaroncomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Tcarone: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaroneacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -30
  ],
  Tcaronedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tcaronedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Tcaronemacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Tcaroneogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronhyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  Tcarono: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronoacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronodieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronoslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronotilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tcaronr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronrcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tcaronu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuring: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Tcarony: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcaronyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcaronydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  TcommaaccentA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Tcommaaccenta: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentaacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tcommaaccentacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tcommaaccentadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentaogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentaring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentcolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcommaaccentcomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Tcommaaccente: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccenteacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -30
  ],
  Tcommaaccentedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tcommaaccentedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Tcommaaccentemacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Tcommaaccenteogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccenthyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  Tcommaaccento: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentoacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentodieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentoslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentotilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tcommaaccentr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentrcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tcommaaccentu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccenturing: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Tcommaaccenty: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcommaaccentyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcommaaccentydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  UA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ucomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UacuteA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uacutecomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uacuteperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UcircumflexA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ucircumflexcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Ucircumflexperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UdieresisA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Udieresiscomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Udieresisperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UgraveA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ugravecomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Ugraveperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UhungarumlautA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uhungarumlautcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uhungarumlautperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UmacronA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Umacroncomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Umacronperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UogonekA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uogonekcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uogonekperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UringA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uringcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uringperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  VA: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAacute: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAbreve: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAcircumflex: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAdieresis: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAgrave: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAmacron: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAogonek: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAring: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAtilde: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VG: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VGbreve: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VGcommaaccent: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VO: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOacute: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOdieresis: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOgrave: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOhungarumlaut: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOmacron: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOslash: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOtilde: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  Va: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vaacute: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vabreve: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vacircumflex: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vadieresis: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vagrave: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vamacron: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vaogonek: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Varing: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vatilde: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vcolon: [
    -40,
    -40,
    -40,
    -40,
    -92,
    -74,
    -65,
    -74
  ],
  Vcomma: [
    -120,
    -120,
    -125,
    -125,
    -129,
    -129,
    -129,
    -129
  ],
  Ve: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Veacute: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vecaron: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -71
  ],
  Vecircumflex: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -71
  ],
  Vedieresis: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Vedotaccent: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vegrave: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Vemacron: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Veogonek: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vhyphen: [
    -80,
    -80,
    -80,
    -80,
    -74,
    -70,
    -55,
    -100
  ],
  Vo: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Voacute: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vocircumflex: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vodieresis: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vograve: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vohungarumlaut: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vomacron: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Voslash: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Votilde: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vperiod: [
    -120,
    -120,
    -125,
    -125,
    -145,
    -129,
    -129,
    -129
  ],
  Vsemicolon: [
    -40,
    -40,
    -40,
    -40,
    -92,
    -74,
    -74,
    -74
  ],
  Vu: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuacute: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vucircumflex: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vudieresis: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vugrave: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuhungarumlaut: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vumacron: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuogonek: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuring: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  WA: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAacute: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAbreve: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAcircumflex: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAdieresis: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAgrave: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAmacron: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAogonek: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAring: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAtilde: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WO: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOacute: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOgrave: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOmacron: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOslash: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOtilde: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  Wa: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waacute: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wabreve: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wacircumflex: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wadieresis: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wagrave: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wamacron: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waogonek: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waring: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Watilde: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wcolon: [
    -10,
    -10,
    0,
    0,
    -55,
    -55,
    -65,
    -37
  ],
  Wcomma: [
    -80,
    -80,
    -80,
    -80,
    -92,
    -74,
    -92,
    -92
  ],
  We: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Weacute: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wecaron: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wecircumflex: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wedieresis: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Wedotaccent: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wegrave: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Wemacron: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Weogonek: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Whyphen: [
    -40,
    -40,
    -40,
    -40,
    -37,
    -50,
    -37,
    -65
  ],
  Wo: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Woacute: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wocircumflex: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wodieresis: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wograve: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wohungarumlaut: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Womacron: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Woslash: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wotilde: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wperiod: [
    -80,
    -80,
    -80,
    -80,
    -92,
    -74,
    -92,
    -92
  ],
  Wsemicolon: [
    -10,
    -10,
    0,
    0,
    -55,
    -55,
    -65,
    -37
  ],
  Wu: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuacute: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wucircumflex: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wudieresis: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wugrave: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuhungarumlaut: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wumacron: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuogonek: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuring: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wy: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  Wyacute: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  Wydieresis: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  YA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Ya: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Yacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yaring: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yatilde: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ycolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ycomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Ye: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yeacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Yedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Yeogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yo: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yomacron: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Ysemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  YacuteA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Yacutea: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacutearing: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteatilde: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yacutecolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yacutecomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Yacutee: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteeacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Yacuteedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteeogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteo: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteomacron: [
    -100,
    -100,
    -70,
    -70,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Yacutesemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yacuteu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  YdieresisA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Ydieresisa: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisaring: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisatilde: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresiscolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ydieresiscomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Ydieresise: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresiseacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Ydieresisedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresisedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresisemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresiseogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresiso: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisomacron: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Ydieresissemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ydieresisu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  ag: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  av: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  ay: [
    -20,
    -20,
    -30,
    -30
  ],
  ayacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aacutew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aacutey: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  abrevew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  abrevey: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  acircumflexw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  acircumflexy: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  adieresisw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  adieresisy: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  agravew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  agravey: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  amacrong: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacrongbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacrongcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacronv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  amacronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  amacrony: [
    -20,
    -20,
    -30,
    -30
  ],
  amacronyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  amacronydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aogonekw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aogoneky: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aringg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aringw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aringy: [
    -20,
    -20,
    -30,
    -30
  ],
  aringyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aringydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  atildew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  atildey: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  bl: [
    -10,
    -10,
    -20,
    -20
  ],
  blacute: [
    -10,
    -10,
    -20,
    -20
  ],
  blcommaaccent: [
    -10,
    -10,
    -20,
    -20
  ],
  blslash: [
    -10,
    -10,
    -20,
    -20
  ],
  bu: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buacute: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bucircumflex: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  budieresis: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bugrave: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bumacron: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buogonek: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buring: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bv: [
    -20,
    -20,
    -20,
    -20,
    -15,
    0,
    0,
    -15
  ],
  by: [
    -20,
    -20,
    -20,
    -20
  ],
  byacute: [
    -20,
    -20,
    -20,
    -20
  ],
  bydieresis: [
    -20,
    -20,
    -20,
    -20
  ],
  ch: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ck: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ckcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cl: [
    -20,
    -20
  ],
  clacute: [
    -20,
    -20
  ],
  clcommaaccent: [
    -20,
    -20
  ],
  clslash: [
    -20,
    -20
  ],
  cy: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteh: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  cacutek: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cacutekcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cacutel: [
    -20,
    -20
  ],
  cacutelacute: [
    -20,
    -20
  ],
  cacutelcommaaccent: [
    -20,
    -20
  ],
  cacutelslash: [
    -20,
    -20
  ],
  cacutey: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronh: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ccaronk: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccaronkcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccaronl: [
    -20,
    -20
  ],
  ccaronlacute: [
    -20,
    -20
  ],
  ccaronlcommaaccent: [
    -20,
    -20
  ],
  ccaronlslash: [
    -20,
    -20
  ],
  ccarony: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillah: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ccedillak: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccedillakcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccedillal: [
    -20,
    -20
  ],
  ccedillalacute: [
    -20,
    -20
  ],
  ccedillalcommaaccent: [
    -20,
    -20
  ],
  ccedillalslash: [
    -20,
    -20
  ],
  ccedillay: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillayacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillaydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  colonspace: [
    -40,
    -40,
    -50,
    -50
  ],
  commaquotedblright: [
    -120,
    -120,
    -100,
    -100,
    -45,
    -95,
    -140,
    -70
  ],
  commaquoteright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  commaspace: [
    -40,
    -40
  ],
  dd: [
    -10,
    -10
  ],
  ddcroat: [
    -10,
    -10
  ],
  dv: [
    -15,
    -15
  ],
  dw: [
    -15,
    -15,
    0,
    0,
    -15
  ],
  dy: [
    -15,
    -15
  ],
  dyacute: [
    -15,
    -15
  ],
  dydieresis: [
    -15,
    -15
  ],
  dcroatd: [
    -10,
    -10
  ],
  dcroatdcroat: [
    -10,
    -10
  ],
  dcroatv: [
    -15,
    -15
  ],
  dcroatw: [
    -15,
    -15,
    0,
    0,
    -15
  ],
  dcroaty: [
    -15,
    -15
  ],
  dcroatyacute: [
    -15,
    -15
  ],
  dcroatydieresis: [
    -15,
    -15
  ],
  ecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacutecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eacuteperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  eacutev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  eacutew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  eacutex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  eacutey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacuteyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacuteydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaroncomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  ecaronperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ecaronv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ecaronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ecaronx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ecarony: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaronyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaronydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  ecircumflexperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ecircumflexv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ecircumflexw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ecircumflexx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ecircumflexy: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresiscomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  edieresisperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  edieresisv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  edieresisw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  edieresisx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  edieresisy: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresisyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresisydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  edotaccentperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  edotaccentv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  edotaccentw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  edotaccentx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  edotaccenty: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egravecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  egraveperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  egravev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  egravew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  egravex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  egravey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egraveyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egraveydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacroncomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  emacronperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  emacronv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  emacronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  emacronx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  emacrony: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacronyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacronydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eogonekperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  eogonekv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  eogonekw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  eogonekx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  eogoneky: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  fcomma: [
    -10,
    -10,
    -30,
    -30,
    -15,
    -10,
    -10
  ],
  fe: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  feacute: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fecaron: [
    -10,
    -10,
    -30,
    -30
  ],
  fecircumflex: [
    -10,
    -10,
    -30,
    -30
  ],
  fedieresis: [
    -10,
    -10,
    -30,
    -30
  ],
  fedotaccent: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fegrave: [
    -10,
    -10,
    -30,
    -30
  ],
  femacron: [
    -10,
    -10,
    -30,
    -30
  ],
  feogonek: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fo: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  foacute: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  focircumflex: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fodieresis: [
    -20,
    -20,
    -30,
    -30,
    -25
  ],
  fograve: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fohungarumlaut: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fomacron: [
    -20,
    -20,
    -30,
    -30,
    -25
  ],
  foslash: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fotilde: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fperiod: [
    -10,
    -10,
    -30,
    -30,
    -15,
    -10,
    -15
  ],
  fquotedblright: [
    30,
    30,
    60,
    60,
    50
  ],
  fquoteright: [
    30,
    30,
    50,
    50,
    55,
    55,
    92,
    55
  ],
  ge: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  geacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  geogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  ggbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  ggcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevee: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveeacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveeogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccente: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccenteacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccenteogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  hy: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  hyacute: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  hydieresis: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  ko: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  koacute: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kocircumflex: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kodieresis: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kograve: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kohungarumlaut: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  komacron: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  koslash: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kotilde: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccento: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentoacute: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentocircumflex: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentodieresis: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentograve: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentohungarumlaut: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentomacron: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentoslash: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentotilde: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  lw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ly: [
    -15,
    -15
  ],
  lyacute: [
    -15,
    -15
  ],
  lydieresis: [
    -15,
    -15
  ],
  lacutew: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lacutey: [
    -15,
    -15
  ],
  lacuteyacute: [
    -15,
    -15
  ],
  lacuteydieresis: [
    -15,
    -15
  ],
  lcommaaccentw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lcommaaccenty: [
    -15,
    -15
  ],
  lcommaaccentyacute: [
    -15,
    -15
  ],
  lcommaaccentydieresis: [
    -15,
    -15
  ],
  lslashw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lslashy: [
    -15,
    -15
  ],
  lslashyacute: [
    -15,
    -15
  ],
  lslashydieresis: [
    -15,
    -15
  ],
  mu: [
    -20,
    -20,
    -10,
    -10
  ],
  muacute: [
    -20,
    -20,
    -10,
    -10
  ],
  mucircumflex: [
    -20,
    -20,
    -10,
    -10
  ],
  mudieresis: [
    -20,
    -20,
    -10,
    -10
  ],
  mugrave: [
    -20,
    -20,
    -10,
    -10
  ],
  muhungarumlaut: [
    -20,
    -20,
    -10,
    -10
  ],
  mumacron: [
    -20,
    -20,
    -10,
    -10
  ],
  muogonek: [
    -20,
    -20,
    -10,
    -10
  ],
  muring: [
    -20,
    -20,
    -10,
    -10
  ],
  my: [
    -30,
    -30,
    -15,
    -15
  ],
  myacute: [
    -30,
    -30,
    -15,
    -15
  ],
  mydieresis: [
    -30,
    -30,
    -15,
    -15
  ],
  nu: [
    -10,
    -10,
    -10,
    -10
  ],
  nuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  nucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  nudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  nugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  nuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  numacron: [
    -10,
    -10,
    -10,
    -10
  ],
  nuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  nuring: [
    -10,
    -10,
    -10,
    -10
  ],
  nv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ny: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteu: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuring: [
    -10,
    -10,
    -10,
    -10
  ],
  nacutev: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  nacutey: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronu: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuring: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ncarony: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentu: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccenturing: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ncommaaccenty: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeu: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuring: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildev: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ntildey: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ov: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ow: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ox: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  oy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacutev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  oacutew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  oacutex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  oacutey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacuteyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacuteydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ocircumflexw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ocircumflexx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ocircumflexy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  odieresisw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  odieresisx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  odieresisy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ogravev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ogravew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ogravex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ogravey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ograveyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ograveydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ohungarumlautw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ohungarumlautx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ohungarumlauty: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  omacronw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  omacronx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  omacrony: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oslashv: [
    -20,
    -20,
    -70,
    -70,
    -10,
    -15,
    -10,
    -15
  ],
  oslashw: [
    -15,
    -15,
    -70,
    -70,
    -10,
    -25,
    0,
    -25
  ],
  oslashx: [
    -30,
    -30,
    -85,
    -85,
    0,
    -10
  ],
  oslashy: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  oslashyacute: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  oslashydieresis: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  otildev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  otildew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  otildex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  otildey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  otildeyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  otildeydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  py: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  pyacute: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  pydieresis: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  periodquotedblright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  periodquoteright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  periodspace: [
    -40,
    -40,
    -60,
    -60
  ],
  quotedblrightspace: [
    -80,
    -80,
    -40,
    -40
  ],
  quoteleftquoteleft: [
    -46,
    -46,
    -57,
    -57,
    -63,
    -74,
    -111,
    -74
  ],
  quoterightd: [
    -80,
    -80,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightdcroat: [
    -80,
    -80,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightl: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlacute: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlcommaaccent: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlslash: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightquoteright: [
    -46,
    -46,
    -57,
    -57,
    -63,
    -74,
    -111,
    -74
  ],
  quoterightr: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightracute: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightrcaron: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightrcommaaccent: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterights: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightsacute: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscaron: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscedilla: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscommaaccent: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightspace: [
    -80,
    -80,
    -70,
    -70,
    -74,
    -74,
    -111,
    -74
  ],
  quoterightv: [
    -20,
    -20,
    0,
    0,
    -20,
    -15,
    -10,
    -50
  ],
  rc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rd: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rdcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rgbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rgcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rhyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  ro: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  roacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  romacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  roslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rs: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rt: [
    20,
    20,
    40,
    40
  ],
  rtcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rv: [
    10,
    10,
    30,
    30,
    -10
  ],
  ry: [
    10,
    10,
    30,
    30
  ],
  ryacute: [
    10,
    10,
    30,
    30
  ],
  rydieresis: [
    10,
    10,
    30,
    30
  ],
  racutec: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutecacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutecomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  racuted: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  racutedcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  racuteg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutegbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutegcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutehyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  racuteo: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  racuteq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutes: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutesacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutet: [
    20,
    20,
    40,
    40
  ],
  racutetcommaaccent: [
    20,
    20,
    40,
    40
  ],
  racutev: [
    10,
    10,
    30,
    30,
    -10
  ],
  racutey: [
    10,
    10,
    30,
    30
  ],
  racuteyacute: [
    10,
    10,
    30,
    30
  ],
  racuteydieresis: [
    10,
    10,
    30,
    30
  ],
  rcaronc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroncacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroncomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rcarond: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcarondcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcarong: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcarongbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcarongcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcaronhyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  rcarono: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rcaronq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcarons: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaront: [
    20,
    20,
    40,
    40
  ],
  rcarontcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rcaronv: [
    10,
    10,
    30,
    30,
    -10
  ],
  rcarony: [
    10,
    10,
    30,
    30
  ],
  rcaronyacute: [
    10,
    10,
    30,
    30
  ],
  rcaronydieresis: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentcacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentcomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rcommaaccentd: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcommaaccentdcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcommaaccentg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccentgbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccentgcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccenthyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  rcommaaccento: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rcommaaccentq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccents: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentt: [
    20,
    20,
    40,
    40
  ],
  rcommaaccenttcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rcommaaccentv: [
    10,
    10,
    30,
    30,
    -10
  ],
  rcommaaccenty: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentyacute: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentydieresis: [
    10,
    10,
    30,
    30
  ],
  sw: [
    -15,
    -15,
    -30,
    -30
  ],
  sacutew: [
    -15,
    -15,
    -30,
    -30
  ],
  scaronw: [
    -15,
    -15,
    -30,
    -30
  ],
  scedillaw: [
    -15,
    -15,
    -30,
    -30
  ],
  scommaaccentw: [
    -15,
    -15,
    -30,
    -30
  ],
  semicolonspace: [
    -40,
    -40,
    -50,
    -50
  ],
  spaceT: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceTcaron: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceTcommaaccent: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceV: [
    -80,
    -80,
    -50,
    -50,
    -45,
    -70,
    -35,
    -50
  ],
  spaceW: [
    -80,
    -80,
    -40,
    -40,
    -30,
    -70,
    -40,
    -30
  ],
  spaceY: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spaceYacute: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spaceYdieresis: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spacequotedblleft: [
    -80,
    -80,
    -30,
    -30
  ],
  spacequoteleft: [
    -60,
    -60,
    -60,
    -60
  ],
  va: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vaacute: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vabreve: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vacircumflex: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vadieresis: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vagrave: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vamacron: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vaogonek: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  varing: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vatilde: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vcomma: [
    -80,
    -80,
    -80,
    -80,
    -55,
    -37,
    -74,
    -65
  ],
  vo: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  voacute: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vocircumflex: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vodieresis: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vograve: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vohungarumlaut: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vomacron: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  voslash: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  votilde: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vperiod: [
    -80,
    -80,
    -80,
    -80,
    -70,
    -37,
    -74,
    -65
  ],
  wcomma: [
    -40,
    -40,
    -60,
    -60,
    -55,
    -37,
    -74,
    -65
  ],
  wo: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  woacute: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wocircumflex: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wodieresis: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wograve: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wohungarumlaut: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  womacron: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  woslash: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wotilde: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wperiod: [
    -40,
    -40,
    -60,
    -60,
    -70,
    -37,
    -74,
    -65
  ],
  xe: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xeacute: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xecaron: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xecircumflex: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xedieresis: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xedotaccent: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xegrave: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xemacron: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xeogonek: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  ya: [
    -30,
    -30,
    -20,
    -20
  ],
  yaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  yabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  yacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  yadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  yagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  yamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  yaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  yaring: [
    -30,
    -30,
    -20,
    -20
  ],
  yatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  ycomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  ye: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yeacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yeogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yo: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  yacutea: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  yacutearing: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  yacutecomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  yacutee: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteeacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteeogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteo: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  ydieresisa: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaring: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresiscomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  ydieresise: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiseacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiseogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiso: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  ze: [
    10,
    10,
    -15,
    -15
  ],
  zeacute: [
    10,
    10,
    -15,
    -15
  ],
  zecaron: [
    10,
    10,
    -15,
    -15
  ],
  zecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zegrave: [
    10,
    10,
    -15,
    -15
  ],
  zemacron: [
    10,
    10,
    -15,
    -15
  ],
  zeogonek: [
    10,
    10,
    -15,
    -15
  ],
  zacutee: [
    10,
    10,
    -15,
    -15
  ],
  zacuteeacute: [
    10,
    10,
    -15,
    -15
  ],
  zacuteecaron: [
    10,
    10,
    -15,
    -15
  ],
  zacuteecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zacuteedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zacuteedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zacuteegrave: [
    10,
    10,
    -15,
    -15
  ],
  zacuteemacron: [
    10,
    10,
    -15,
    -15
  ],
  zacuteeogonek: [
    10,
    10,
    -15,
    -15
  ],
  zcarone: [
    10,
    10,
    -15,
    -15
  ],
  zcaroneacute: [
    10,
    10,
    -15,
    -15
  ],
  zcaronecaron: [
    10,
    10,
    -15,
    -15
  ],
  zcaronecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zcaronedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zcaronedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zcaronegrave: [
    10,
    10,
    -15,
    -15
  ],
  zcaronemacron: [
    10,
    10,
    -15,
    -15
  ],
  zcaroneogonek: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccente: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccenteacute: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentecaron: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentegrave: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentemacron: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccenteogonek: [
    10,
    10,
    -15,
    -15
  ],
  Bcomma: [
    0,
    0,
    -20,
    -20
  ],
  Bperiod: [
    0,
    0,
    -20,
    -20
  ],
  Ccomma: [
    0,
    0,
    -30,
    -30
  ],
  Cperiod: [
    0,
    0,
    -30,
    -30
  ],
  Cacutecomma: [
    0,
    0,
    -30,
    -30
  ],
  Cacuteperiod: [
    0,
    0,
    -30,
    -30
  ],
  Ccaroncomma: [
    0,
    0,
    -30,
    -30
  ],
  Ccaronperiod: [
    0,
    0,
    -30,
    -30
  ],
  Ccedillacomma: [
    0,
    0,
    -30,
    -30
  ],
  Ccedillaperiod: [
    0,
    0,
    -30,
    -30
  ],
  Fe: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Feacute: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fecaron: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fecircumflex: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fedieresis: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fedotaccent: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fegrave: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Femacron: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Feogonek: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fo: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Foacute: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Focircumflex: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fodieresis: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fograve: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fohungarumlaut: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fomacron: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Foslash: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fotilde: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fr: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Fracute: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Frcaron: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Frcommaaccent: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Ja: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaacute: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jabreve: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jacircumflex: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jadieresis: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jagrave: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jamacron: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaogonek: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaring: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jatilde: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  LcaronT: [
    0,
    0,
    -110,
    -110
  ],
  LcaronTcaron: [
    0,
    0,
    -110,
    -110
  ],
  LcaronTcommaaccent: [
    0,
    0,
    -110,
    -110
  ],
  LcaronV: [
    0,
    0,
    -110,
    -110
  ],
  LcaronW: [
    0,
    0,
    -70,
    -70
  ],
  LcaronY: [
    0,
    0,
    -140,
    -140
  ],
  LcaronYacute: [
    0,
    0,
    -140,
    -140
  ],
  LcaronYdieresis: [
    0,
    0,
    -140,
    -140
  ],
  Lcaronquotedblright: [
    0,
    0,
    -140,
    -140
  ],
  Lcaronquoteright: [
    0,
    0,
    -160,
    -160,
    0,
    0,
    0,
    -92
  ],
  Lcarony: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Lcaronyacute: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Lcaronydieresis: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Scomma: [
    0,
    0,
    -20,
    -20
  ],
  Speriod: [
    0,
    0,
    -20,
    -20
  ],
  Sacutecomma: [
    0,
    0,
    -20,
    -20
  ],
  Sacuteperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scaroncomma: [
    0,
    0,
    -20,
    -20
  ],
  Scaronperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scedillacomma: [
    0,
    0,
    -20,
    -20
  ],
  Scedillaperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scommaaccentcomma: [
    0,
    0,
    -20,
    -20
  ],
  Scommaaccentperiod: [
    0,
    0,
    -20,
    -20
  ],
  Trcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronrcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentrcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Yhyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Yi: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacutehyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Yacutei: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacuteiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacuteiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresishyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Ydieresisi: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresisiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresisiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  bb: [
    0,
    0,
    -10,
    -10,
    -10,
    -10
  ],
  bcomma: [
    0,
    0,
    -40,
    -40
  ],
  bperiod: [
    0,
    0,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  ccomma: [
    0,
    0,
    -15,
    -15
  ],
  cacutecomma: [
    0,
    0,
    -15,
    -15
  ],
  ccaroncomma: [
    0,
    0,
    -15,
    -15
  ],
  ccedillacomma: [
    0,
    0,
    -15,
    -15
  ],
  fa: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faacute: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fabreve: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  facircumflex: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fadieresis: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fagrave: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  famacron: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faogonek: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faring: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fatilde: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fdotlessi: [
    0,
    0,
    -28,
    -28,
    -35,
    -30,
    -60,
    -50
  ],
  gr: [
    0,
    0,
    -10,
    -10
  ],
  gracute: [
    0,
    0,
    -10,
    -10
  ],
  grcaron: [
    0,
    0,
    -10,
    -10
  ],
  grcommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  gbrever: [
    0,
    0,
    -10,
    -10
  ],
  gbreveracute: [
    0,
    0,
    -10,
    -10
  ],
  gbrevercaron: [
    0,
    0,
    -10,
    -10
  ],
  gbrevercommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentr: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentracute: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentrcaron: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentrcommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  ke: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  keacute: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kecaron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kecircumflex: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kedieresis: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kedotaccent: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kegrave: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kemacron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  keogonek: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccente: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccenteacute: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentecaron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentecircumflex: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentedieresis: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentedotaccent: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentegrave: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentemacron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccenteogonek: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  ocomma: [
    0,
    0,
    -40,
    -40
  ],
  operiod: [
    0,
    0,
    -40,
    -40
  ],
  oacutecomma: [
    0,
    0,
    -40,
    -40
  ],
  oacuteperiod: [
    0,
    0,
    -40,
    -40
  ],
  ocircumflexcomma: [
    0,
    0,
    -40,
    -40
  ],
  ocircumflexperiod: [
    0,
    0,
    -40,
    -40
  ],
  odieresiscomma: [
    0,
    0,
    -40,
    -40
  ],
  odieresisperiod: [
    0,
    0,
    -40,
    -40
  ],
  ogravecomma: [
    0,
    0,
    -40,
    -40
  ],
  ograveperiod: [
    0,
    0,
    -40,
    -40
  ],
  ohungarumlautcomma: [
    0,
    0,
    -40,
    -40
  ],
  ohungarumlautperiod: [
    0,
    0,
    -40,
    -40
  ],
  omacroncomma: [
    0,
    0,
    -40,
    -40
  ],
  omacronperiod: [
    0,
    0,
    -40,
    -40
  ],
  oslasha: [
    0,
    0,
    -55,
    -55
  ],
  oslashaacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashabreve: [
    0,
    0,
    -55,
    -55
  ],
  oslashacircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashadieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashagrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashamacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashaogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslasharing: [
    0,
    0,
    -55,
    -55
  ],
  oslashatilde: [
    0,
    0,
    -55,
    -55
  ],
  oslashb: [
    0,
    0,
    -55,
    -55
  ],
  oslashc: [
    0,
    0,
    -55,
    -55
  ],
  oslashcacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashccaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashccedilla: [
    0,
    0,
    -55,
    -55
  ],
  oslashcomma: [
    0,
    0,
    -95,
    -95
  ],
  oslashd: [
    0,
    0,
    -55,
    -55
  ],
  oslashdcroat: [
    0,
    0,
    -55,
    -55
  ],
  oslashe: [
    0,
    0,
    -55,
    -55
  ],
  oslasheacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashecaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashecircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashedieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashedotaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashegrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashemacron: [
    0,
    0,
    -55,
    -55
  ],
  oslasheogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashf: [
    0,
    0,
    -55,
    -55
  ],
  oslashg: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashgbreve: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashgcommaaccent: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashh: [
    0,
    0,
    -55,
    -55
  ],
  oslashi: [
    0,
    0,
    -55,
    -55
  ],
  oslashiacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashicircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashidieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashigrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashimacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashiogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashj: [
    0,
    0,
    -55,
    -55
  ],
  oslashk: [
    0,
    0,
    -55,
    -55
  ],
  oslashkcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashl: [
    0,
    0,
    -55,
    -55
  ],
  oslashlacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashlcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashlslash: [
    0,
    0,
    -55,
    -55
  ],
  oslashm: [
    0,
    0,
    -55,
    -55
  ],
  oslashn: [
    0,
    0,
    -55,
    -55
  ],
  oslashnacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashncaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashncommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashntilde: [
    0,
    0,
    -55,
    -55
  ],
  oslasho: [
    0,
    0,
    -55,
    -55
  ],
  oslashoacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashocircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashodieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashograve: [
    0,
    0,
    -55,
    -55
  ],
  oslashohungarumlaut: [
    0,
    0,
    -55,
    -55
  ],
  oslashomacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashoslash: [
    0,
    0,
    -55,
    -55
  ],
  oslashotilde: [
    0,
    0,
    -55,
    -55
  ],
  oslashp: [
    0,
    0,
    -55,
    -55
  ],
  oslashperiod: [
    0,
    0,
    -95,
    -95
  ],
  oslashq: [
    0,
    0,
    -55,
    -55
  ],
  oslashr: [
    0,
    0,
    -55,
    -55
  ],
  oslashracute: [
    0,
    0,
    -55,
    -55
  ],
  oslashrcaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashrcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashs: [
    0,
    0,
    -55,
    -55
  ],
  oslashsacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashscaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashscedilla: [
    0,
    0,
    -55,
    -55
  ],
  oslashscommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslasht: [
    0,
    0,
    -55,
    -55
  ],
  oslashtcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashu: [
    0,
    0,
    -55,
    -55
  ],
  oslashuacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashucircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashudieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashugrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashuhungarumlaut: [
    0,
    0,
    -55,
    -55
  ],
  oslashumacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashuogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashuring: [
    0,
    0,
    -55,
    -55
  ],
  oslashz: [
    0,
    0,
    -55,
    -55
  ],
  oslashzacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashzcaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashzdotaccent: [
    0,
    0,
    -55,
    -55
  ],
  otildecomma: [
    0,
    0,
    -40,
    -40
  ],
  otildeperiod: [
    0,
    0,
    -40,
    -40
  ],
  pcomma: [
    0,
    0,
    -35,
    -35
  ],
  pperiod: [
    0,
    0,
    -35,
    -35
  ],
  ra: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  radieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ragrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ramacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ratilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcolon: [
    0,
    0,
    30,
    30
  ],
  ri: [
    0,
    0,
    15,
    15
  ],
  riacute: [
    0,
    0,
    15,
    15
  ],
  ricircumflex: [
    0,
    0,
    15,
    15
  ],
  ridieresis: [
    0,
    0,
    15,
    15
  ],
  rigrave: [
    0,
    0,
    15,
    15
  ],
  rimacron: [
    0,
    0,
    15,
    15
  ],
  riogonek: [
    0,
    0,
    15,
    15
  ],
  rk: [
    0,
    0,
    15,
    15
  ],
  rkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rl: [
    0,
    0,
    15,
    15
  ],
  rlacute: [
    0,
    0,
    15,
    15
  ],
  rlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rlslash: [
    0,
    0,
    15,
    15
  ],
  rm: [
    0,
    0,
    25,
    25
  ],
  rn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rsemicolon: [
    0,
    0,
    30,
    30
  ],
  ru: [
    0,
    0,
    15,
    15
  ],
  ruacute: [
    0,
    0,
    15,
    15
  ],
  rucircumflex: [
    0,
    0,
    15,
    15
  ],
  rudieresis: [
    0,
    0,
    15,
    15
  ],
  rugrave: [
    0,
    0,
    15,
    15
  ],
  ruhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rumacron: [
    0,
    0,
    15,
    15
  ],
  ruogonek: [
    0,
    0,
    15,
    15
  ],
  ruring: [
    0,
    0,
    15,
    15
  ],
  racutea: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racutearing: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racutecolon: [
    0,
    0,
    30,
    30
  ],
  racutei: [
    0,
    0,
    15,
    15
  ],
  racuteiacute: [
    0,
    0,
    15,
    15
  ],
  racuteicircumflex: [
    0,
    0,
    15,
    15
  ],
  racuteidieresis: [
    0,
    0,
    15,
    15
  ],
  racuteigrave: [
    0,
    0,
    15,
    15
  ],
  racuteimacron: [
    0,
    0,
    15,
    15
  ],
  racuteiogonek: [
    0,
    0,
    15,
    15
  ],
  racutek: [
    0,
    0,
    15,
    15
  ],
  racutekcommaaccent: [
    0,
    0,
    15,
    15
  ],
  racutel: [
    0,
    0,
    15,
    15
  ],
  racutelacute: [
    0,
    0,
    15,
    15
  ],
  racutelcommaaccent: [
    0,
    0,
    15,
    15
  ],
  racutelslash: [
    0,
    0,
    15,
    15
  ],
  racutem: [
    0,
    0,
    25,
    25
  ],
  racuten: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutenacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutencaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutencommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutentilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutep: [
    0,
    0,
    30,
    30,
    -10
  ],
  racutesemicolon: [
    0,
    0,
    30,
    30
  ],
  racuteu: [
    0,
    0,
    15,
    15
  ],
  racuteuacute: [
    0,
    0,
    15,
    15
  ],
  racuteucircumflex: [
    0,
    0,
    15,
    15
  ],
  racuteudieresis: [
    0,
    0,
    15,
    15
  ],
  racuteugrave: [
    0,
    0,
    15,
    15
  ],
  racuteuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  racuteumacron: [
    0,
    0,
    15,
    15
  ],
  racuteuogonek: [
    0,
    0,
    15,
    15
  ],
  racuteuring: [
    0,
    0,
    15,
    15
  ],
  rcarona: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaroncolon: [
    0,
    0,
    30,
    30
  ],
  rcaroni: [
    0,
    0,
    15,
    15
  ],
  rcaroniacute: [
    0,
    0,
    15,
    15
  ],
  rcaronicircumflex: [
    0,
    0,
    15,
    15
  ],
  rcaronidieresis: [
    0,
    0,
    15,
    15
  ],
  rcaronigrave: [
    0,
    0,
    15,
    15
  ],
  rcaronimacron: [
    0,
    0,
    15,
    15
  ],
  rcaroniogonek: [
    0,
    0,
    15,
    15
  ],
  rcaronk: [
    0,
    0,
    15,
    15
  ],
  rcaronkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcaronl: [
    0,
    0,
    15,
    15
  ],
  rcaronlacute: [
    0,
    0,
    15,
    15
  ],
  rcaronlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcaronlslash: [
    0,
    0,
    15,
    15
  ],
  rcaronm: [
    0,
    0,
    25,
    25
  ],
  rcaronn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rcaronsemicolon: [
    0,
    0,
    30,
    30
  ],
  rcaronu: [
    0,
    0,
    15,
    15
  ],
  rcaronuacute: [
    0,
    0,
    15,
    15
  ],
  rcaronucircumflex: [
    0,
    0,
    15,
    15
  ],
  rcaronudieresis: [
    0,
    0,
    15,
    15
  ],
  rcaronugrave: [
    0,
    0,
    15,
    15
  ],
  rcaronuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rcaronumacron: [
    0,
    0,
    15,
    15
  ],
  rcaronuogonek: [
    0,
    0,
    15,
    15
  ],
  rcaronuring: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenta: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentcolon: [
    0,
    0,
    30,
    30
  ],
  rcommaaccenti: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentiacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenticircumflex: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentidieresis: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentigrave: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentimacron: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentiogonek: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentk: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentl: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlslash: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentm: [
    0,
    0,
    25,
    25
  ],
  rcommaaccentn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rcommaaccentsemicolon: [
    0,
    0,
    30,
    30
  ],
  rcommaaccentu: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentucircumflex: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentudieresis: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentugrave: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentumacron: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuogonek: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenturing: [
    0,
    0,
    15,
    15
  ],
  scomma: [
    0,
    0,
    -15,
    -15
  ],
  speriod: [
    0,
    0,
    -15,
    -15
  ],
  sacutecomma: [
    0,
    0,
    -15,
    -15
  ],
  sacuteperiod: [
    0,
    0,
    -15,
    -15
  ],
  scaroncomma: [
    0,
    0,
    -15,
    -15
  ],
  scaronperiod: [
    0,
    0,
    -15,
    -15
  ],
  scedillacomma: [
    0,
    0,
    -15,
    -15
  ],
  scedillaperiod: [
    0,
    0,
    -15,
    -15
  ],
  scommaaccentcomma: [
    0,
    0,
    -15,
    -15
  ],
  scommaaccentperiod: [
    0,
    0,
    -15,
    -15
  ],
  ve: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  veacute: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vecaron: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vecircumflex: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vedieresis: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vedotaccent: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vegrave: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vemacron: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  veogonek: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  wa: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waacute: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wabreve: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wacircumflex: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wadieresis: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wagrave: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wamacron: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waogonek: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waring: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  watilde: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  we: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  weacute: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wecaron: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wecircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wedieresis: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wedotaccent: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wegrave: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wemacron: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  weogonek: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  zo: [
    0,
    0,
    -15,
    -15
  ],
  zoacute: [
    0,
    0,
    -15,
    -15
  ],
  zocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zograve: [
    0,
    0,
    -15,
    -15
  ],
  zohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zomacron: [
    0,
    0,
    -15,
    -15
  ],
  zoslash: [
    0,
    0,
    -15,
    -15
  ],
  zotilde: [
    0,
    0,
    -15,
    -15
  ],
  zacuteo: [
    0,
    0,
    -15,
    -15
  ],
  zacuteoacute: [
    0,
    0,
    -15,
    -15
  ],
  zacuteocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zacuteodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zacuteograve: [
    0,
    0,
    -15,
    -15
  ],
  zacuteohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zacuteomacron: [
    0,
    0,
    -15,
    -15
  ],
  zacuteoslash: [
    0,
    0,
    -15,
    -15
  ],
  zacuteotilde: [
    0,
    0,
    -15,
    -15
  ],
  zcarono: [
    0,
    0,
    -15,
    -15
  ],
  zcaronoacute: [
    0,
    0,
    -15,
    -15
  ],
  zcaronocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zcaronodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zcaronograve: [
    0,
    0,
    -15,
    -15
  ],
  zcaronohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zcaronomacron: [
    0,
    0,
    -15,
    -15
  ],
  zcaronoslash: [
    0,
    0,
    -15,
    -15
  ],
  zcaronotilde: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccento: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentoacute: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentograve: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentomacron: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentoslash: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentotilde: [
    0,
    0,
    -15,
    -15
  ],
  Ap: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aacutep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aacutequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Abrevep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Abrevequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Acircumflexp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Acircumflexquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Adieresisp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Adieresisquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Agravep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Agravequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Amacronp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Amacronquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aogonekp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aogonekquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aringp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aringquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Atildep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Atildequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Je: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jeacute: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jecaron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jecircumflex: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jedieresis: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jedotaccent: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jegrave: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jemacron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jeogonek: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jo: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Joacute: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jocircumflex: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jodieresis: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jograve: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Johungarumlaut: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jomacron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Joslash: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jotilde: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  NA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  Ti: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroni: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroniacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroniogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccenti: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccentiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccentiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Vi: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Viacute: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Vicircumflex: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vidieresis: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vigrave: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vimacron: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Viogonek: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Wi: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  Wiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  Wiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  fi: [
    0,
    0,
    0,
    0,
    -25,
    0,
    -20,
    -20
  ],
  gperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  gbreveperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  gcommaaccentperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  iv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  iacutev: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  icircumflexv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  idieresisv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  igravev: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  imacronv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  iogonekv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  ky: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kyacute: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kydieresis: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccenty: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccentyacute: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccentydieresis: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  quotedblleftA: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAacute: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAbreve: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAcircumflex: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAdieresis: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAgrave: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAmacron: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAogonek: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAring: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAtilde: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftA: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAacute: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAbreve: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAcircumflex: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAdieresis: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAgrave: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAmacron: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAogonek: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAring: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAtilde: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  re: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  reacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  recaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  recircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  redieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  redotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  regrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  remacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  reogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutee: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteeacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteeogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcarone: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroneacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroneogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccente: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccenteacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccenteogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  spaceA: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAacute: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAbreve: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAcircumflex: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAdieresis: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAgrave: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAmacron: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAogonek: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAring: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAtilde: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  Fi: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fiacute: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Ficircumflex: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fidieresis: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Figrave: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fimacron: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fiogonek: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  eb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  eacuteb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ecaronb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ecircumflexb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  edieresisb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  edotaccentb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  egraveb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  emacronb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  eogonekb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ff: [
    0,
    0,
    0,
    0,
    0,
    -18,
    -18,
    -25
  ],
  quoterightt: [
    0,
    0,
    0,
    0,
    0,
    -37,
    -30,
    -18
  ],
  quoterighttcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    -37,
    -30,
    -18
  ],
  Yicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  eg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacuteg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacutegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacutegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egraveg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egravegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egravegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  fiogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    -20
  ],
  gcomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevecomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentcomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  og: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacuteg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacutegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacutegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ograveg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogravegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogravegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildeg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  fiacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -20
  ],
  ga: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  garing: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbrevea: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbrevearing: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccenta: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaring: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ]
}, SK = {
  attributes: DK,
  glyphWidths: TK,
  kernPairs: kK
}, CK = function(e) {
  return [e.FontName, {
    attributes: e,
    glyphWidths: {},
    kernPairs: {}
  }];
}, FK = function(e) {
  var t = e.attributes, n = e.glyphWidths, i = e.kernPairs, a = t.map(CK);
  return Object.keys(n).forEach(function(o) {
    n[o].forEach(function(s, c) {
      s && (a[c][1].glyphWidths[o] = s);
    });
  }), Object.keys(i).forEach(function(o) {
    i[o].forEach(function(s, c) {
      s && (a[c][1].kernPairs[o] = s);
    });
  }), Object.fromEntries(a);
}, R8 = FK(SK), OK = function(e) {
  return /* @__PURE__ */ function(t) {
    xl(n, t);
    function n(a, o, s) {
      var c;
      return c = t.call(this) || this, c.document = a, c.name = o, c.id = s, c.font = _K.fromJson(R8[c.name]), c.ascender = c.font.ascender, c.descender = c.font.descender, c.bbox = c.font.bbox, c.lineGap = c.font.lineGap, c;
    }
    var i = n.prototype;
    return i.embed = function() {
      return this.dictionary.data = {
        Type: "Font",
        BaseFont: this.name,
        Subtype: "Type1",
        Encoding: "WinAnsiEncoding"
      }, this.dictionary.end();
    }, i.encode = function(o) {
      for (var s = this.font.encodeText(o), c = this.font.glyphsForString("" + o), h = this.font.advancesForGlyphs(c), d = [], g = 0; g < c.length; g++) {
        var x = c[g];
        d.push({
          xAdvance: h[g],
          yAdvance: 0,
          xOffset: 0,
          yOffset: 0,
          advanceWidth: this.font.widthOfGlyph(x)
        });
      }
      return [s, d];
    }, i.encodeGlyphs = function(o) {
      for (var s = [], c = 0, h = Array.from(o); c < h.length; c++) {
        var d = h[c];
        s.push(("00" + d.id.toString(16)).slice(-2));
      }
      return s;
    }, i.widthOfString = function(o, s) {
      for (var c = this.font.glyphsForString("" + o), h = this.font.advancesForGlyphs(c), d = 0, g = 0, x = Array.from(h); g < x.length; g++) {
        var _ = x[g];
        d += _;
      }
      var k = s / 1e3;
      return d * k;
    }, n.isStandardFont = function(o) {
      return o in R8;
    }, n;
  }(e);
}, k4 = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var i = Array.from(t).map(function(a) {
    return ("0000" + a.toString(16)).slice(-4);
  });
  return i.join("");
}, RK = function(e) {
  return /* @__PURE__ */ function(t) {
    xl(n, t);
    function n(a, o, s) {
      var c;
      return c = t.call(this) || this, c.document = a, c.font = o, c.id = s, c.subset = c.font.createSubset(), c.unicode = [[0]], c.widths = [c.font.getGlyph(0).advanceWidth], c.name = c.font.postscriptName, c.scale = 1e3 / c.font.unitsPerEm, c.ascender = c.font.ascent * c.scale, c.descender = c.font.descent * c.scale, c.xHeight = c.font.xHeight * c.scale, c.capHeight = c.font.capHeight * c.scale, c.lineGap = c.font.lineGap * c.scale, c.bbox = c.font.bbox, c.layoutCache = /* @__PURE__ */ Object.create(null), c;
    }
    var i = n.prototype;
    return i.layoutRun = function(o, s) {
      for (var c = this.font.layout(o, s), h = 0; h < c.positions.length; h++) {
        var d = c.positions[h];
        for (var g in d)
          d[g] *= this.scale;
        d.advanceWidth = c.glyphs[h].advanceWidth * this.scale;
      }
      return c;
    }, i.layoutCached = function(o) {
      var s;
      if (s = this.layoutCache[o])
        return s;
      var c = this.layoutRun(o);
      return this.layoutCache[o] = c, c;
    }, i.layout = function(o, s, c) {
      if (c == null && (c = !1), s)
        return this.layoutRun(o, s);
      for (var h = c ? null : [], d = c ? null : [], g = 0, x = 0, _ = 0; _ <= o.length; ) {
        var k;
        if (_ === o.length && x < _ || (k = o.charAt(_), [" ", "	"].includes(k))) {
          var P = this.layoutCached(o.slice(x, ++_));
          c || (h.push.apply(h, Array.from(P.glyphs || [])), d.push.apply(d, Array.from(P.positions || []))), g += P.advanceWidth, x = _;
        } else
          _++;
      }
      return {
        glyphs: h,
        positions: d,
        advanceWidth: g
      };
    }, i.encode = function(o, s) {
      for (var c = this.layout(o, s), h = c.glyphs, d = c.positions, g = [], x = 0; x < h.length; x++) {
        var _ = h[x], k = this.subset.includeGlyph(_.id);
        g.push(("0000" + k.toString(16)).slice(-4)), this.widths[k] == null && (this.widths[k] = _.advanceWidth * this.scale), this.unicode[k] == null && (this.unicode[k] = this.font._cmapProcessor.codePointsForGlyph(_.id));
      }
      return [g, d];
    }, i.encodeGlyphs = function(o) {
      for (var s = [], c = 0; c < o.length; c++) {
        var h = o[c], d = this.subset.includeGlyph(h.id);
        s.push(("0000" + d.toString(16)).slice(-4)), this.widths[d] == null && (this.widths[d] = h.advanceWidth * this.scale), this.unicode[d] == null && (this.unicode[d] = this.font._cmapProcessor.codePointsForGlyph(h.id));
      }
      return s;
    }, i.widthOfString = function(o, s, c) {
      var h = this.layout(o, c, !0).advanceWidth, d = s / 1e3;
      return h * d;
    }, i.embed = function() {
      var o = this.subset.cff != null, s = this.document.ref();
      o && (s.data.Subtype = "CIDFontType0C"), s.end(this.subset.encode());
      var c = ((this.font["OS/2"] != null ? this.font["OS/2"].sFamilyClass : void 0) || 0) >> 8, h = 0;
      this.font.post.isFixedPitch && (h |= 1), 1 <= c && c <= 7 && (h |= 2), h |= 4, c === 10 && (h |= 8), this.font.head.macStyle.italic && (h |= 64);
      var d = [0, 1, 2, 3, 4, 5].map(function(P) {
        return String.fromCharCode(Math.random() * 26 + 65);
      }).join(""), g = d + "+" + this.font.postscriptName, x = this.font.bbox, _ = this.document.ref({
        Type: "FontDescriptor",
        FontName: g,
        Flags: h,
        FontBBox: [x.minX * this.scale, x.minY * this.scale, x.maxX * this.scale, x.maxY * this.scale],
        ItalicAngle: this.font.italicAngle,
        Ascent: this.ascender,
        Descent: this.descender,
        CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
        XHeight: (this.font.xHeight || 0) * this.scale,
        StemV: 0
      });
      o ? _.data.FontFile3 = s : _.data.FontFile2 = s, _.end();
      var k = this.document.ref({
        Type: "Font",
        Subtype: o ? "CIDFontType0" : "CIDFontType2",
        BaseFont: g,
        CIDSystemInfo: {
          Registry: new String("Adobe"),
          Ordering: new String("Identity"),
          Supplement: 0
        },
        FontDescriptor: _,
        W: [0, this.widths]
      });
      return k.end(), this.dictionary.data = {
        Type: "Font",
        Subtype: "Type0",
        BaseFont: g,
        Encoding: "Identity-H",
        DescendantFonts: [k],
        ToUnicode: this.toUnicodeCmap()
      }, this.dictionary.end();
    }, i.toUnicodeCmap = function() {
      for (var o = this.document.ref(), s = [], c = 0, h = Array.from(this.unicode); c < h.length; c++)
        for (var d = h[c], g = [], x = 0, _ = Array.from(d); x < _.length; x++) {
          var k = _[x];
          k > 65535 && (k -= 65536, g.push(k4(k >>> 10 & 1023 | 55296)), k = 56320 | k & 1023), g.push(k4(k)), s.push("<" + g.join(" ") + ">");
        }
      return o.end(`  /CIDInit /ProcSet findresource begin
  12 dict begin
  begincmap
  /CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
  >> def
  /CMapName /Adobe-Identity-UCS def
  /CMapType 2 def
  1 begincodespacerange
  <0000><ffff>
  endcodespacerange
  1 beginbfrange
  <0000> <` + k4(s.length - 1) + "> [" + s.join(" ") + `]
  endbfrange
  endcmap
  CMapName currentdict /CMap defineresource pop
  end
  end  `), o;
    }, n;
  }(e);
}, P5 = /* @__PURE__ */ function() {
  function r() {
  }
  r.open = function(n, i, a, o) {
    var s;
    if (typeof i == "string") {
      if (I8.isStandardFont(i))
        return new I8(n, i, o);
      throw new Error("Can't open " + i + " in browser build");
    } else i instanceof Uint8Array ? s = v1(i, a) : i instanceof ArrayBuffer ? s = v1(new Uint8Array(i), a) : typeof i == "object" && (s = i);
    if (s == null)
      throw new Error("Not a supported font format or standard PDF font.");
    return new IK(n, s, o);
  };
  var e = r.prototype;
  return e.encode = function() {
    throw new Error("Must be implemented by subclasses");
  }, e.widthOfString = function() {
    throw new Error("Must be implemented by subclasses");
  }, e.ref = function() {
    return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
  }, e.finalize = function() {
    if (!(this.embedded || this.dictionary == null))
      return this.embed(), this.embedded = !0;
  }, e.embed = function() {
    throw new Error("Must be implemented by subclasses");
  }, e.lineHeight = function(n, i) {
    i == null && (i = !1);
    var a = i ? this.lineGap : 0;
    return (this.ascender + a - this.descender) / 1e3 * n;
  }, r;
}(), I8 = OK(P5), IK = RK(P5), PK = {
  initFonts: function() {
    return this._fontFamilies = {}, this._fontCount = 0, this._fontSize = 12, this._font = null, this._registeredFonts = {}, this.font("Helvetica");
  },
  font: function(e, t, n) {
    var i, a;
    if (typeof t == "number" && (n = t, t = null), typeof e == "string" && this._registeredFonts[e]) {
      i = e;
      var o = this._registeredFonts[e];
      e = o.src, t = o.family;
    } else
      i = t || e, typeof i != "string" && (i = null);
    if (n != null && this.fontSize(n), a = this._fontFamilies[i])
      return this._font = a, this;
    var s = "F" + ++this._fontCount;
    return this._font = P5.open(this, e, t, s), (a = this._fontFamilies[this._font.name]) ? (this._font = a, this) : (i && (this._fontFamilies[i] = this._font), this._font.name && (this._fontFamilies[this._font.name] = this._font), this);
  },
  fontSize: function(e) {
    return this._fontSize = e, this;
  },
  currentLineHeight: function(e) {
    return e == null && (e = !1), this._font.lineHeight(this._fontSize, e);
  },
  registerFont: function(e, t, n) {
    return this._registeredFonts[e] = {
      src: t,
      family: n
    }, this;
  }
}, Ds = si.number, BK = {
  initText: function() {
    return this._line = this._line.bind(this), this.x = 0, this.y = 0, this._lineGap = 0;
  },
  _text: function(e, t, n, i, a) {
    var o = this;
    i = this._initOptions(t, n, i), e = e == null ? "" : "" + e, i.wordSpacing && (e = e.replace(/\s{2,}/g, " "));
    for (var s = function() {
      i.structParent && i.structParent.add(o.struct(i.structType || "P", [o.markStructureContent(i.structType || "P")]));
    }, c = ou(e.split(`
`)), h; !(h = c()).done; ) {
      var d = h.value;
      s(), a(d, i);
    }
    return this;
  },
  text: function(e, t, n, i) {
    return this._text(e, t, n, i, this._line);
  },
  widthOfString: function(e, t) {
    return t === void 0 && (t = {}), this._font.widthOfString(e, this._fontSize, t.features) + (t.characterSpacing || 0) * (e.length - 1);
  },
  _initOptions: function(e, t, n) {
    e === void 0 && (e = {}), n === void 0 && (n = {}), typeof e == "object" && (n = e, e = null);
    var i = Object.assign({}, n);
    if (this._textOptions)
      for (var a in this._textOptions) {
        var o = this._textOptions[a];
        a !== "continued" && i[a] === void 0 && (i[a] = o);
      }
    return e != null && (this.x = e), t != null && (this.y = t), i.lineBreak !== !1 && (i.width == null && (i.width = this.page.width - this.x - this.page.margins.right), i.width = Math.max(i.width, 0)), i.columns || (i.columns = 0), i.columnGap == null && (i.columnGap = 18), i;
  },
  _line: function(e, t) {
    return t === void 0 && (t = {}), this._fragment(e, this.x, this.y, t), this.x += this.widthOfString(e);
  },
  _fragment: function(e, t, n, i) {
    if (e = ("" + e).replace(/\n/g, ""), e.length !== 0) {
      var a = this._font.encode(e, i.features), o = a[0], s = a[1], c = this._font.ascender / 1e3 * this._fontSize;
      this._glyphs(o, s, t, n + c, i);
    }
  },
  _glyphs: function(e, t, n, i, a) {
    var o = this, s = [], c = this._fontSize / 1e3, h, d = 0, g = !1;
    this.save(), this.transform(1, 0, 0, -1, 0, this.page.height), i = this.page.height - i, this.page.fonts[this._font.id] == null && (this.page.fonts[this._font.id] = this._font.ref()), this.addContent("BT"), this.addContent("1 0 0 1 " + Ds(n) + " " + Ds(i) + " Tm"), this.addContent("/" + this._font.id + " " + Ds(this._fontSize) + " Tf");
    var x = a.fill && a.stroke ? 2 : a.stroke ? 1 : 0;
    x && this.addContent(x + " Tr");
    var _ = function(M) {
      if (d < M) {
        var G = e.slice(d, M).join(""), z = t[M - 1].xAdvance - t[M - 1].advanceWidth;
        s.push("<" + G + "> " + Ds(-z));
      }
      return d = M;
    }, k = function(M) {
      if (_(M), s.length > 0)
        return o.addContent("[" + s.join(" ") + "] TJ"), s.length = 0;
    };
    for (h = 0; h < t.length; h++) {
      var P = t[h];
      P.xOffset || P.yOffset ? (k(h), this.addContent("1 0 0 1 " + Ds(n + P.xOffset * c) + " " + Ds(i + P.yOffset * c) + " Tm"), k(h + 1), g = !0) : (g && (this.addContent("1 0 0 1 " + Ds(n) + " " + Ds(i) + " Tm"), g = !1), P.xAdvance - P.advanceWidth !== 0 && _(h + 1)), n += P.xAdvance * c;
    }
    return k(h), this.addContent("ET"), this.restore();
  }
}, P8 = [65472, 65473, 65474, 65475, 65477, 65478, 65479, 65480, 65481, 65482, 65483, 65484, 65485, 65486, 65487], NK = /* @__PURE__ */ function() {
  function r(t, n) {
    var i;
    if (this.data = t, this.label = n, this.data.readUInt16BE(0) !== 65496)
      throw "SOI not found in JPEG";
    for (var a = 2; a < this.data.length && (i = this.data.readUInt16BE(a), a += 2, !Array.from(P8).includes(i)); )
      a += this.data.readUInt16BE(a);
    if (!Array.from(P8).includes(i))
      throw "Invalid JPEG.";
    a += 2, this.bits = this.data[a++], this.height = this.data.readUInt16BE(a), a += 2, this.width = this.data.readUInt16BE(a), a += 2;
    var o = this.data[a++];
    this.colorSpace = function() {
      switch (o) {
        case 1:
          return "DeviceGray";
        case 3:
          return "DeviceRGB";
        case 4:
          return "DeviceCMYK";
      }
    }(), this.obj = null;
  }
  var e = r.prototype;
  return e.embed = function(n) {
    this.obj || (this.obj = n.ref({
      Type: "XObject",
      Subtype: "Image",
      BitsPerComponent: this.bits,
      Width: this.width,
      Height: this.height,
      ColorSpace: this.colorSpace,
      Filter: "DCTDecode"
    }), this.colorSpace === "DeviceCMYK" && (this.obj.data.Decode = [1, 0, 1, 0, 1, 0, 1, 0]), this.obj.end(this.data), this.data = null);
  }, r;
}(), LK = /* @__PURE__ */ function() {
  function r(t, n) {
    this.label = n, this.image = new I1(t), this.width = this.image.width, this.height = this.image.height, this.imgData = this.image.imgData, this.obj = null;
  }
  var e = r.prototype;
  return e.embed = function(n) {
    var i = !1;
    if (this.document = n, !this.obj) {
      var a = this.image.hasAlphaChannel, o = this.image.interlaceMethod === 1;
      if (this.obj = this.document.ref({
        Type: "XObject",
        Subtype: "Image",
        BitsPerComponent: a ? 8 : this.image.bits,
        Width: this.width,
        Height: this.height,
        Filter: "FlateDecode"
      }), !a) {
        var s = this.document.ref({
          Predictor: o ? 1 : 15,
          Colors: this.image.colors,
          BitsPerComponent: this.image.bits,
          Columns: this.width
        });
        this.obj.data.DecodeParms = s, s.end();
      }
      if (this.image.palette.length === 0)
        this.obj.data.ColorSpace = this.image.colorSpace;
      else {
        var c = this.document.ref();
        c.end(tt.from(this.image.palette)), this.obj.data.ColorSpace = ["Indexed", "DeviceRGB", this.image.palette.length / 3 - 1, c];
      }
      if (this.image.transparency.grayscale != null) {
        var h = this.image.transparency.grayscale;
        this.obj.data.Mask = [h, h];
      } else if (this.image.transparency.rgb) {
        for (var d = this.image.transparency.rgb, g = [], x = ou(d), _; !(_ = x()).done; ) {
          var k = _.value;
          g.push(k, k);
        }
        this.obj.data.Mask = g;
      } else {
        if (this.image.transparency.indexed)
          return i = !0, this.loadIndexedAlphaChannel();
        if (a)
          return i = !0, this.splitAlphaChannel();
      }
      if (o && !i)
        return this.decodeData();
      this.finalize();
    }
  }, e.finalize = function() {
    if (this.alphaChannel) {
      var n = this.document.ref({
        Type: "XObject",
        Subtype: "Image",
        Height: this.height,
        Width: this.width,
        BitsPerComponent: 8,
        Filter: "FlateDecode",
        ColorSpace: "DeviceGray",
        Decode: [0, 1]
      });
      n.end(this.alphaChannel), this.obj.data.SMask = n;
    }
    this.obj.end(this.imgData), this.image = null, this.imgData = null;
  }, e.splitAlphaChannel = function() {
    var n = this;
    return this.image.decodePixels(function(i) {
      for (var a, o, s = n.image.colors, c = n.width * n.height, h = tt.alloc(c * s), d = tt.alloc(c), g = o = a = 0, x = i.length, _ = n.image.bits === 16 ? 1 : 0; g < x; ) {
        for (var k = 0; k < s; k++)
          h[o++] = i[g++], g += _;
        d[a++] = i[g++], g += _;
      }
      return n.imgData = Ec.deflateSync(h), n.alphaChannel = Ec.deflateSync(d), n.finalize();
    });
  }, e.loadIndexedAlphaChannel = function() {
    var n = this, i = this.image.transparency.indexed;
    return this.image.decodePixels(function(a) {
      for (var o = tt.alloc(n.width * n.height), s = 0, c = 0, h = a.length; c < h; c++)
        o[s++] = i[a[c]];
      return n.alphaChannel = Ec.deflateSync(o), n.finalize();
    });
  }, e.decodeData = function() {
    var n = this;
    this.image.decodePixels(function(i) {
      n.imgData = Ec.deflateSync(i), n.finalize();
    });
  }, r;
}(), B8 = /* @__PURE__ */ function() {
  function r() {
  }
  return r.open = function(t, n) {
    var i;
    if (tt.isBuffer(t))
      i = t;
    else if (t instanceof ArrayBuffer)
      i = tt.from(new Uint8Array(t));
    else {
      var a = /^data:.+;base64,(.*)$/.exec(t);
      a && (i = tt.from(a[1], "base64"));
    }
    if (i[0] === 255 && i[1] === 216)
      return new NK(i, n);
    if (i[0] === 137 && i.toString("ascii", 1, 4) === "PNG")
      return new LK(i, n);
    throw new Error("Unknown image format.");
  }, r;
}(), MK = {
  initImages: function() {
    this._imageRegistry = {}, this._imageCount = 0;
  },
  embedImage: function(e) {
    var t;
    return typeof e == "string" && (t = this._imageRegistry[e]), t || (e.width && e.height ? t = e : t = this.openImage(e)), t.obj || t.embed(this), t;
  },
  image: function(e, t, n, i) {
    i === void 0 && (i = {});
    var a, o, s, c, h, d;
    typeof t == "object" && (i = t, t = null);
    var g = e instanceof B8 ? e : this.embedImage(e);
    t = (h = t ?? i.x) != null ? h : this.x, n = (d = n ?? i.y) != null ? d : this.y, this.page.xobjects[g.label] == null && (this.page.xobjects[g.label] = g.obj);
    var x = i.width || g.width, _ = i.height || g.height;
    if (i.width && !i.height) {
      var k = x / g.width;
      x = g.width * k, _ = g.height * k;
    } else if (i.height && !i.width) {
      var P = _ / g.height;
      x = g.width * P, _ = g.height * P;
    } else if (i.scale)
      x = g.width * i.scale, _ = g.height * i.scale;
    else if (i.fit) {
      var N = Array.from(i.fit);
      s = N[0], a = N[1], o = s / a, c = g.width / g.height, c > o ? (x = s, _ = s / c) : (_ = a, x = a * c);
    }
    return this.y === n && (this.y += _), this.save(), this.transform(x, 0, 0, -_, t, n + _), this.addContent("/" + g.label + " Do"), this.restore(), this;
  },
  openImage: function(e) {
    var t;
    return typeof e == "string" && (t = this._imageRegistry[e]), t || (t = B8.open(e, "I" + ++this._imageCount), typeof e == "string" && (this._imageRegistry[e] = t)), t;
  }
}, UK = {
  annotate: function(e, t, n, i, a) {
    a.Type = "Annot", a.Rect = this._convertRect(e, t, n, i), a.Border = [0, 0, 0], a.Subtype === "Link" && typeof a.F > "u" && (a.F = 4), a.Subtype !== "Link" && a.C == null && (a.C = this._normalizeColor(a.color || [0, 0, 0])), delete a.color, typeof a.Dest == "string" && (a.Dest = new String(a.Dest));
    for (var o in a) {
      var s = a[o];
      a[o[0].toUpperCase() + o.slice(1)] = s;
    }
    var c = this.ref(a);
    return this.page.annotations.push(c), c.end(), this;
  },
  note: function(e, t, n, i, a, o) {
    return o === void 0 && (o = {}), o.Subtype = "Text", o.Contents = new String(a), o.Name = "Comment", o.color == null && (o.color = [243, 223, 92]), o.Border = [0, 0, o.borderWidth || 0], delete o.borderWidth, this.annotate(e, t, n, i, o);
  },
  goTo: function(e, t, n, i, a, o) {
    return o === void 0 && (o = {}), o.Subtype = "Link", o.A = this.ref({
      S: "GoTo",
      D: new String(a)
    }), o.A.end(), this.annotate(e, t, n, i, o);
  },
  link: function(e, t, n, i, a, o) {
    if (o === void 0 && (o = {}), o.Subtype = "Link", typeof a == "number") {
      var s = this._root.data.Pages.data;
      if (a >= 0 && a < s.Kids.length)
        o.A = this.ref({
          S: "GoTo",
          D: [s.Kids[a], "XYZ", null, null, null]
        }), o.A.end();
      else
        throw new Error("The document has no page " + a);
    } else
      o.A = this.ref({
        S: "URI",
        URI: new String(a)
      }), o.A.end();
    return this.annotate(e, t, n, i, o);
  },
  _markup: function(e, t, n, i, a) {
    a === void 0 && (a = {});
    var o = this._convertRect(e, t, n, i), s = o[0], c = o[1], h = o[2], d = o[3];
    return a.QuadPoints = [s, d, h, d, s, c, h, c], a.Contents = new String(), this.annotate(e, t, n, i, a);
  },
  highlight: function(e, t, n, i, a) {
    return a === void 0 && (a = {}), a.Subtype = "Highlight", a.color == null && (a.color = [241, 238, 148]), this._markup(e, t, n, i, a);
  },
  fileAnnotation: function(e, t, n, i, a, o) {
    a === void 0 && (a = {}), o === void 0 && (o = {});
    var s = this.file(a.src, Object.assign({
      hidden: !0
    }, a));
    return o.Subtype = "FileAttachment", o.FS = s, o.Contents ? o.Contents = new String(o.Contents) : s.data.Desc && (o.Contents = s.data.Desc), this.annotate(e, t, n, i, o);
  },
  _convertRect: function(e, t, n, i) {
    var a = t;
    t += i;
    var o = e + n, s = this._ctm, c = s[0], h = s[1], d = s[2], g = s[3], x = s[4], _ = s[5];
    return e = c * e + d * t + x, t = h * e + g * t + _, o = c * o + d * a + x, a = h * o + g * a + _, [e, t, o, a];
  }
}, N8 = {
  top: 0,
  left: 0,
  zoom: 0,
  fit: !1,
  pageNumber: null,
  expanded: !1
}, $K = /* @__PURE__ */ function() {
  function r(t, n, i, a, o) {
    if (o === void 0 && (o = N8), this.document = t, this.options = o, this.outlineData = {}, a !== null) {
      var s = a.data.MediaBox[2], c = a.data.MediaBox[3], h = c - (o.top || 0), d = s - (o.left || 0), g = o.zoom || 0;
      this.outlineData.Dest = o.fit ? [a, "Fit"] : [a, "XYZ", d, h, g];
    }
    n !== null && (this.outlineData.Parent = n), i !== null && (this.outlineData.Title = new String(i)), this.dictionary = this.document.ref(this.outlineData), this.children = [];
  }
  var e = r.prototype;
  return e.addItem = function(n, i) {
    i === void 0 && (i = N8);
    var a = this.document._root.data.Pages.data.Kids, o = i.pageNumber !== null ? a[i.pageNumber] : this.document.page.dictionary, s = new r(this.document, this.dictionary, n, o, i);
    return this.children.push(s), s;
  }, e.endOutline = function() {
    if (this.children.length > 0) {
      this.options.expanded && (this.outlineData.Count = this.children.length);
      var n = this.children[0], i = this.children[this.children.length - 1];
      this.outlineData.First = n.dictionary, this.outlineData.Last = i.dictionary;
      for (var a = 0, o = this.children.length; a < o; a++) {
        var s = this.children[a];
        a > 0 && (s.outlineData.Prev = this.children[a - 1].dictionary), a < this.children.length - 1 && (s.outlineData.Next = this.children[a + 1].dictionary), s.endOutline();
      }
    }
    return this.dictionary.end();
  }, r;
}(), zK = {
  initOutline: function() {
    this.outline = new $K(this, null, null, null);
  },
  endOutline: function() {
    this.outline.endOutline(), this.outline.children.length > 0 && (this._root.data.Outlines = this.outline.dictionary, this._root.data.PageMode = this._root.data.PageMode || "UseOutlines");
  }
}, L8 = {
  readOnly: 1,
  required: 2,
  noExport: 4,
  multiline: 4096,
  password: 8192,
  toggleToOffButton: 16384,
  radioButton: 32768,
  pushButton: 65536,
  combo: 131072,
  edit: 262144,
  sort: 524288,
  multiSelect: 2097152,
  noSpell: 4194304
}, M8 = {
  left: 0,
  center: 1,
  right: 2
}, U8 = {
  value: "V",
  defaultValue: "DV"
}, $8 = {
  zip: "0",
  zipPlus4: "1",
  zip4: "1",
  phone: "2",
  ssn: "3"
}, z8 = {
  number: {
    nDec: 0,
    sepComma: !1,
    negStyle: "MinusBlack",
    currency: "",
    currencyPrepend: !0
  },
  percent: {
    nDec: 0,
    sepComma: !1
  }
}, jK = {
  /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */
  initForm: function() {
    if (!this._font)
      throw new Error("Must set a font before calling initForm method");
    this._acroform = {
      fonts: {},
      defaultFont: this._font.name
    }, this._acroform.fonts[this._font.id] = this._font.ref();
    var e = {
      Fields: [],
      NeedAppearances: !0,
      DA: new String("/" + this._font.id + " 0 Tf 0 g"),
      DR: {
        Font: {}
      }
    };
    e.DR.Font[this._font.id] = this._font.ref();
    var t = this.ref(e);
    return this._root.data.AcroForm = t, this;
  },
  /**
   * Called automatically by document.js
   */
  endAcroForm: function() {
    var e = this;
    if (this._root.data.AcroForm) {
      if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont)
        throw new Error("No fonts specified for PDF form");
      var t = this._root.data.AcroForm.data.DR.Font;
      Object.keys(this._acroform.fonts).forEach(function(n) {
        t[n] = e._acroform.fonts[n];
      }), this._root.data.AcroForm.data.Fields.forEach(function(n) {
        e._endChild(n);
      }), this._root.data.AcroForm.end();
    }
    return this;
  },
  _endChild: function(e) {
    var t = this;
    return Array.isArray(e.data.Kids) && (e.data.Kids.forEach(function(n) {
      t._endChild(n);
    }), e.end()), this;
  },
  /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */
  formField: function(e, t) {
    t === void 0 && (t = {});
    var n = this._fieldDict(e, null, t), i = this.ref(n);
    return this._addToParent(i), i;
  },
  /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */
  formAnnotation: function(e, t, n, i, a, o, s) {
    s === void 0 && (s = {});
    var c = this._fieldDict(e, t, s);
    c.Subtype = "Widget", c.F === void 0 && (c.F = 4), this.annotate(n, i, a, o, c);
    var h = this.page.annotations[this.page.annotations.length - 1];
    return this._addToParent(h);
  },
  formText: function(e, t, n, i, a, o) {
    return o === void 0 && (o = {}), this.formAnnotation(e, "text", t, n, i, a, o);
  },
  formPushButton: function(e, t, n, i, a, o) {
    return o === void 0 && (o = {}), this.formAnnotation(e, "pushButton", t, n, i, a, o);
  },
  formCombo: function(e, t, n, i, a, o) {
    return o === void 0 && (o = {}), this.formAnnotation(e, "combo", t, n, i, a, o);
  },
  formList: function(e, t, n, i, a, o) {
    return o === void 0 && (o = {}), this.formAnnotation(e, "list", t, n, i, a, o);
  },
  formRadioButton: function(e, t, n, i, a, o) {
    return o === void 0 && (o = {}), this.formAnnotation(e, "radioButton", t, n, i, a, o);
  },
  formCheckbox: function(e, t, n, i, a, o) {
    return o === void 0 && (o = {}), this.formAnnotation(e, "checkbox", t, n, i, a, o);
  },
  _addToParent: function(e) {
    var t = e.data.Parent;
    return t ? (t.data.Kids || (t.data.Kids = []), t.data.Kids.push(e)) : this._root.data.AcroForm.data.Fields.push(e), this;
  },
  _fieldDict: function(e, t, n) {
    if (n === void 0 && (n = {}), !this._acroform)
      throw new Error("Call document.initForms() method before adding form elements to document");
    var i = Object.assign({}, n);
    return t !== null && (i = this._resolveType(t, n)), i = this._resolveFlags(i), i = this._resolveJustify(i), i = this._resolveFont(i), i = this._resolveStrings(i), i = this._resolveColors(i), i = this._resolveFormat(i), i.T = new String(e), i.parent && (i.Parent = i.parent, delete i.parent), i;
  },
  _resolveType: function(e, t) {
    if (e === "text")
      t.FT = "Tx";
    else if (e === "pushButton")
      t.FT = "Btn", t.pushButton = !0;
    else if (e === "radioButton")
      t.FT = "Btn", t.radioButton = !0;
    else if (e === "checkbox")
      t.FT = "Btn";
    else if (e === "combo")
      t.FT = "Ch", t.combo = !0;
    else if (e === "list")
      t.FT = "Ch";
    else
      throw new Error("Invalid form annotation type '" + e + "'");
    return t;
  },
  _resolveFormat: function(e) {
    var t = e.format;
    if (t && t.type) {
      var n, i, a = "";
      if ($8[t.type] !== void 0)
        n = "AFSpecial_Keystroke", i = "AFSpecial_Format", a = $8[t.type];
      else {
        var o = t.type.charAt(0).toUpperCase() + t.type.slice(1);
        if (n = "AF" + o + "_Keystroke", i = "AF" + o + "_Format", t.type === "date")
          n += "Ex", a = String(t.param);
        else if (t.type === "time")
          a = String(t.param);
        else if (t.type === "number") {
          var s = Object.assign({}, z8.number, t);
          a = String([String(s.nDec), s.sepComma ? "0" : "1", '"' + s.negStyle + '"', "null", '"' + s.currency + '"', String(s.currencyPrepend)].join(","));
        } else if (t.type === "percent") {
          var c = Object.assign({}, z8.percent, t);
          a = String([String(c.nDec), c.sepComma ? "0" : "1"].join(","));
        }
      }
      e.AA = e.AA ? e.AA : {}, e.AA.K = {
        S: "JavaScript",
        JS: new String(n + "(" + a + ");")
      }, e.AA.F = {
        S: "JavaScript",
        JS: new String(i + "(" + a + ");")
      };
    }
    return delete e.format, e;
  },
  _resolveColors: function(e) {
    var t = this._normalizeColor(e.backgroundColor);
    return t && (e.MK || (e.MK = {}), e.MK.BG = t), t = this._normalizeColor(e.borderColor), t && (e.MK || (e.MK = {}), e.MK.BC = t), delete e.backgroundColor, delete e.borderColor, e;
  },
  _resolveFlags: function(e) {
    var t = 0;
    return Object.keys(e).forEach(function(n) {
      L8[n] && (t |= L8[n], delete e[n]);
    }), t !== 0 && (e.Ff = e.Ff ? e.Ff : 0, e.Ff |= t), e;
  },
  _resolveJustify: function(e) {
    var t = 0;
    return e.align !== void 0 && (typeof M8[e.align] == "number" && (t = M8[e.align]), delete e.align), t !== 0 && (e.Q = t), e;
  },
  _resolveFont: function(e) {
    if (this._acroform.fonts[this._font.id] === null && (this._acroform.fonts[this._font.id] = this._font.ref()), this._acroform.defaultFont !== this._font.name) {
      e.DR = {
        Font: {}
      };
      var t = e.fontSize || 0;
      e.DR.Font[this._font.id] = this._font.ref(), e.DA = new String("/" + this._font.id + " " + t + " Tf 0 g");
    }
    return e;
  },
  _resolveStrings: function(e) {
    var t = [];
    function n(i) {
      if (Array.isArray(i))
        for (var a = 0; a < i.length; a++)
          typeof i[a] == "string" ? t.push(new String(i[a])) : t.push(i[a]);
    }
    return n(e.Opt), e.select && (n(e.select), delete e.select), t.length && (e.Opt = t), Object.keys(U8).forEach(function(i) {
      e[i] !== void 0 && (e[U8[i]] = e[i], delete e[i]);
    }), ["V", "DV"].forEach(function(i) {
      typeof e[i] == "string" && (e[i] = new String(e[i]));
    }), e.MK && e.MK.CA && (e.MK.CA = new String(e.MK.CA)), e.label && (e.MK = e.MK ? e.MK : {}, e.MK.CA = new String(e.label), delete e.label), e;
  }
}, WK = {
  /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   * @returns filespec reference
   */
  file: function(e, t) {
    t === void 0 && (t = {}), t.name = t.name || e;
    var n = {
      Type: "EmbeddedFile",
      Params: {}
    }, i;
    if (!e)
      throw new Error("No src specified");
    if (tt.isBuffer(e))
      i = e;
    else if (e instanceof ArrayBuffer)
      i = tt.from(new Uint8Array(e));
    else {
      var a;
      if (a = /^data:(.*);base64,(.*)$/.exec(e))
        a[1] && (n.Subtype = a[1].replace("/", "#2F")), i = tt.from(a[2], "base64");
      else
        throw new Error("Could not find file " + e);
    }
    t.creationDate instanceof Date && (n.Params.CreationDate = t.creationDate), t.modifiedDate instanceof Date && (n.Params.ModDate = t.modifiedDate), t.type && (n.Subtype = t.type.replace("/", "#2F"));
    var o = U9(NT.lib.WordArray.create(new Uint8Array(i)));
    n.Params.CheckSum = new String(o), n.Params.Size = i.byteLength;
    var s;
    this._fileRegistry || (this._fileRegistry = {});
    var c = this._fileRegistry[t.name];
    c && GK(n, c) ? s = c.ref : (s = this.ref(n), s.end(i), this._fileRegistry[t.name] = $r({}, n, {
      ref: s
    }));
    var h = {
      Type: "Filespec",
      F: new String(t.name),
      EF: {
        F: s
      },
      UF: new String(t.name)
    };
    t.description && (h.Desc = new String(t.description));
    var d = this.ref(h);
    return d.end(), t.hidden || this.addNamedEmbeddedFile(t.name, d), d;
  }
};
function GK(r, e) {
  return r.Subtype === e.Subtype && r.Params.CheckSum.toString() === e.Params.CheckSum.toString() && r.Params.Size === e.Params.Size && r.Params.CreationDate === e.Params.CreationDate && r.Params.ModDate === e.Params.ModDate;
}
var j8 = function(e) {
  return e[0].toUpperCase() + e.slice(1);
}, X_ = /* @__PURE__ */ function(r) {
  xl(e, r);
  function e(n) {
    var i;
    switch (n === void 0 && (n = {}), i = r.call(this) || this, i.options = n, n.pdfVersion) {
      case "1.4":
        i.version = 1.4;
        break;
      case "1.5":
        i.version = 1.5;
        break;
      case "1.6":
        i.version = 1.6;
        break;
      case "1.7":
      case "1.7ext3":
        i.version = 1.7;
        break;
      default:
        i.version = 1.3;
        break;
    }
    i.compress = i.options.compress != null ? i.options.compress : !0, i._pageBuffer = [], i._pageBufferStart = 0, i._offsets = [], i._waiting = 0, i._ended = !1, i._offset = 0;
    var a = i.ref({
      Type: "Pages",
      Count: 0,
      Kids: []
    }), o = i.ref({
      Dests: new Xh()
    });
    if (i._root = i.ref({
      Type: "Catalog",
      Pages: a,
      Names: o
    }), i.options.lang && (i._root.data.Lang = new String(i.options.lang)), i.options.pageLayout && (i._root.data.PageLayout = j8(i.options.pageLayout)), i.options.pageMode && (i._root.data.PageMode = j8(i.options.pageMode)), i.page = null, i.initColor(), i.initVector(), i.initFonts(), i.initText(), i.initImages(), i.initOutline(), i.info = {
      Producer: "PDFKit",
      Creator: "PDFKit",
      CreationDate: /* @__PURE__ */ new Date()
    }, i.options.info)
      for (var s in i.options.info) {
        var c = i.options.info[s];
        i.info[s] = c;
      }
    return i.options.displayTitle && (i._root.data.ViewerPreferences = i.ref({
      DisplayDocTitle: !0
    })), i._id = oK.generateFileID(i.info), i._write("%PDF-" + i.version), i._write("%ÿÿÿÿ"), i.options.autoFirstPage !== !1 && i.addPage(), i;
  }
  var t = e.prototype;
  return t.addPage = function(i) {
    i == null && (i = this.options), this.options.bufferPages || this.flushPages(), this.page = new iK(this, i), this._pageBuffer.push(this.page);
    var a = this._root.data.Pages.data;
    return a.Kids.push(this.page.dictionary), a.Count++, this._ctm = [1, 0, 0, 1, 0, 0], this.transform(1, 0, 0, -1, 0, this.page.height), this;
  }, t.flushPages = function() {
    var i = this._pageBuffer;
    this._pageBuffer = [], this._pageBufferStart += i.length;
    for (var a = 0, o = Array.from(i); a < o.length; a++) {
      var s = o[a];
      s.end();
    }
  }, t.addNamedDestination = function(i) {
    for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++)
      o[s - 1] = arguments[s];
    o.length === 0 && (o = ["XYZ", null, null, null]), o[0] === "XYZ" && o[2] !== null && (o[2] = this.page.height - o[2]), o.unshift(this.page.dictionary), this._root.data.Names.data.Dests.add(i, o);
  }, t.addNamedEmbeddedFile = function(i, a) {
    this._root.data.Names.data.EmbeddedFiles || (this._root.data.Names.data.EmbeddedFiles = new Xh({
      limits: !1
    })), this._root.data.Names.data.EmbeddedFiles.add(i, a);
  }, t.addNamedJavaScript = function(i, a) {
    this._root.data.Names.data.JavaScript || (this._root.data.Names.data.JavaScript = new Xh());
    var o = {
      JS: new String(a),
      S: "JavaScript"
    };
    this._root.data.Names.data.JavaScript.add(i, o);
  }, t.ref = function(i) {
    var a = new Z_(this, this._offsets.length + 1, i);
    return this._offsets.push(null), this._waiting++, a;
  }, t._read = function() {
  }, t._write = function(i) {
    return tt.isBuffer(i) || (i = tt.from(i + `
`, "binary")), this.push(i), this._offset += i.length;
  }, t.addContent = function(i) {
    return this.page.write(i), this;
  }, t._refEnd = function(i) {
    if (this._offsets[i.id - 1] = i.offset, --this._waiting === 0 && this._ended)
      return this._finalize(), this._ended = !1;
  }, t.end = function() {
    this.flushPages(), this._info = this.ref();
    for (var i in this.info) {
      var a = this.info[i];
      typeof a == "string" && (a = new String(a));
      var o = this.ref(a);
      o.end(), this._info.data[i] = o;
    }
    this._info.end();
    for (var s in this._fontFamilies) {
      var c = this._fontFamilies[s];
      c.finalize();
    }
    if (this.endOutline(), this._root.end(), this._root.data.Pages.end(), this._root.data.Names.end(), this.endAcroForm(), this._root.data.ViewerPreferences && this._root.data.ViewerPreferences.end(), this._waiting === 0)
      return this._finalize();
    this._ended = !0;
  }, t._finalize = function() {
    var i = this._offset;
    this._write("xref"), this._write("0 " + (this._offsets.length + 1)), this._write("0000000000 65535 f ");
    for (var a = 0, o = Array.from(this._offsets); a < o.length; a++) {
      var s = o[a];
      s = ("0000000000" + s).slice(-10), this._write(s + " 00000 n ");
    }
    var c = {
      Size: this._offsets.length + 1,
      Root: this._root,
      Info: this._info,
      ID: [this._id, this._id]
    };
    return this._write("trailer"), this._write(si.convert(c)), this._write("startxref"), this._write("" + i), this._write("%%EOF"), this.push(null);
  }, t.toString = function() {
    return "[object PDFDocument]";
  }, e;
}(XE.Readable), as = function(e) {
  Object.assign(X_.prototype, e);
};
as(hK);
as(AK);
as(PK);
as(BK);
as(MK);
as(UK);
as(zK);
as(jK);
as(WK);
var S4 = 40, C4 = 41, ih = 39, F4 = 34, O4 = 92, hc = 47, R4 = 44, I4 = 58, ah = 42, VK = 117, YK = 85, HK = 43, ZK = /^[a-f0-9?-]+$/i, qK = function(r) {
  for (var e = [], t = r, n, i, a, o, s, c, h, d, g = 0, x = t.charCodeAt(g), _ = t.length, k = [{ nodes: e }], P = 0, N, M = "", G = "", z = ""; g < _; )
    if (x <= 32) {
      n = g;
      do
        n += 1, x = t.charCodeAt(n);
      while (x <= 32);
      o = t.slice(g, n), a = e[e.length - 1], x === C4 && P ? z = o : a && a.type === "div" ? (a.after = o, a.sourceEndIndex += o.length) : x === R4 || x === I4 || x === hc && t.charCodeAt(n + 1) !== ah && (!N || N && N.type === "function" && N.value !== "calc") ? G = o : e.push({
        type: "space",
        sourceIndex: g,
        sourceEndIndex: n,
        value: o
      }), g = n;
    } else if (x === ih || x === F4) {
      n = g, i = x === ih ? "'" : '"', o = {
        type: "string",
        sourceIndex: g,
        quote: i
      };
      do
        if (s = !1, n = t.indexOf(i, n + 1), ~n)
          for (c = n; t.charCodeAt(c - 1) === O4; )
            c -= 1, s = !s;
        else
          t += i, n = t.length - 1, o.unclosed = !0;
      while (s);
      o.value = t.slice(g + 1, n), o.sourceEndIndex = o.unclosed ? n : n + 1, e.push(o), g = n + 1, x = t.charCodeAt(g);
    } else if (x === hc && t.charCodeAt(g + 1) === ah)
      n = t.indexOf("*/", g), o = {
        type: "comment",
        sourceIndex: g,
        sourceEndIndex: n + 2
      }, n === -1 && (o.unclosed = !0, n = t.length, o.sourceEndIndex = n), o.value = t.slice(g + 2, n), e.push(o), g = n + 2, x = t.charCodeAt(g);
    else if ((x === hc || x === ah) && N && N.type === "function" && N.value === "calc")
      o = t[g], e.push({
        type: "word",
        sourceIndex: g - G.length,
        sourceEndIndex: g + o.length,
        value: o
      }), g += 1, x = t.charCodeAt(g);
    else if (x === hc || x === R4 || x === I4)
      o = t[g], e.push({
        type: "div",
        sourceIndex: g - G.length,
        sourceEndIndex: g + o.length,
        value: o,
        before: G,
        after: ""
      }), G = "", g += 1, x = t.charCodeAt(g);
    else if (S4 === x) {
      n = g;
      do
        n += 1, x = t.charCodeAt(n);
      while (x <= 32);
      if (d = g, o = {
        type: "function",
        sourceIndex: g - M.length,
        value: M,
        before: t.slice(d + 1, n)
      }, g = n, M === "url" && x !== ih && x !== F4) {
        n -= 1;
        do
          if (s = !1, n = t.indexOf(")", n + 1), ~n)
            for (c = n; t.charCodeAt(c - 1) === O4; )
              c -= 1, s = !s;
          else
            t += ")", n = t.length - 1, o.unclosed = !0;
        while (s);
        h = n;
        do
          h -= 1, x = t.charCodeAt(h);
        while (x <= 32);
        d < h ? (g !== h + 1 ? o.nodes = [
          {
            type: "word",
            sourceIndex: g,
            sourceEndIndex: h + 1,
            value: t.slice(g, h + 1)
          }
        ] : o.nodes = [], o.unclosed && h + 1 !== n ? (o.after = "", o.nodes.push({
          type: "space",
          sourceIndex: h + 1,
          sourceEndIndex: n,
          value: t.slice(h + 1, n)
        })) : (o.after = t.slice(h + 1, n), o.sourceEndIndex = n)) : (o.after = "", o.nodes = []), g = n + 1, o.sourceEndIndex = o.unclosed ? n : g, x = t.charCodeAt(g), e.push(o);
      } else
        P += 1, o.after = "", o.sourceEndIndex = g + 1, e.push(o), k.push(o), e = o.nodes = [], N = o;
      M = "";
    } else if (C4 === x && P)
      g += 1, x = t.charCodeAt(g), N.after = z, N.sourceEndIndex += z.length, z = "", P -= 1, k[k.length - 1].sourceEndIndex = g, k.pop(), N = k[P], e = N.nodes;
    else {
      n = g;
      do
        x === O4 && (n += 1), n += 1, x = t.charCodeAt(n);
      while (n < _ && !(x <= 32 || x === ih || x === F4 || x === R4 || x === I4 || x === hc || x === S4 || x === ah && N && N.type === "function" && N.value === "calc" || x === hc && N.type === "function" && N.value === "calc" || x === C4 && P));
      o = t.slice(g, n), S4 === x ? M = o : (VK === o.charCodeAt(0) || YK === o.charCodeAt(0)) && HK === o.charCodeAt(1) && ZK.test(o.slice(2)) ? e.push({
        type: "unicode-range",
        sourceIndex: g,
        sourceEndIndex: n,
        value: o
      }) : e.push({
        type: "word",
        sourceIndex: g,
        sourceEndIndex: n,
        value: o
      }), g = n;
    }
  for (g = k.length - 1; g; g -= 1)
    k[g].unclosed = !0, k[g].sourceEndIndex = t.length;
  return k[0].nodes;
};
const XK = /* @__PURE__ */ I0(qK);
var Kh = 45, Jh = 43, X3 = 46, KK = 101, JK = 69;
function QK(r) {
  var e = r.charCodeAt(0), t;
  if (e === Jh || e === Kh) {
    if (t = r.charCodeAt(1), t >= 48 && t <= 57)
      return !0;
    var n = r.charCodeAt(2);
    return t === X3 && n >= 48 && n <= 57;
  }
  return e === X3 ? (t = r.charCodeAt(1), t >= 48 && t <= 57) : e >= 48 && e <= 57;
}
var eJ = function(r) {
  var e = 0, t = r.length, n, i, a;
  if (t === 0 || !QK(r))
    return !1;
  for (n = r.charCodeAt(e), (n === Jh || n === Kh) && e++; e < t && (n = r.charCodeAt(e), !(n < 48 || n > 57)); )
    e += 1;
  if (n = r.charCodeAt(e), i = r.charCodeAt(e + 1), n === X3 && i >= 48 && i <= 57)
    for (e += 2; e < t && (n = r.charCodeAt(e), !(n < 48 || n > 57)); )
      e += 1;
  if (n = r.charCodeAt(e), i = r.charCodeAt(e + 1), a = r.charCodeAt(e + 2), (n === KK || n === JK) && (i >= 48 && i <= 57 || (i === Jh || i === Kh) && a >= 48 && a <= 57))
    for (e += i === Jh || i === Kh ? 3 : 2; e < t && (n = r.charCodeAt(e), !(n < 48 || n > 57)); )
      e += 1;
  return {
    number: r.slice(0, e),
    unit: r.slice(e)
  };
};
const tJ = /* @__PURE__ */ I0(eJ);
var rJ = function(r, e, t) {
  if (r == null)
    return [0, 0, 0];
  var n = (1 - Math.abs(2 * t - 1)) * e, i = r / 60, a = n * (1 - Math.abs(i % 2 - 1));
  i = Math.floor(i);
  var o, s, c;
  i === 0 ? (o = n, s = a, c = 0) : i === 1 ? (o = a, s = n, c = 0) : i === 2 ? (o = 0, s = n, c = a) : i === 3 ? (o = 0, s = a, c = n) : i === 4 ? (o = a, s = 0, c = n) : i === 5 && (o = n, s = 0, c = a);
  var h = t - n / 2;
  return o += h, s += h, c += h, [
    Math.abs(Math.round(o * 255)),
    Math.abs(Math.round(s * 255)),
    Math.abs(Math.round(c * 255))
  ];
}, nJ = rJ, iJ = nJ;
function K3(r, e) {
  return r > e ? e : r;
}
function J3(r, e) {
  return r < e ? e : r;
}
function aJ(r) {
  for (r = K3(r, 1e7), r = J3(r, -1e7); r < 0; )
    r += 360;
  for (; r > 359; )
    r -= 360;
  return r;
}
function oJ(r, e, t) {
  r = aJ(r), e = J3(K3(e, 100), 0), t = J3(K3(t, 100), 0), e /= 100, t /= 100;
  var n = iJ(r, e, t);
  return "#" + n.map(function(i) {
    return (256 + i).toString(16).substr(-2);
  }).join("");
}
var sJ = oJ;
const uJ = /* @__PURE__ */ I0(sJ);
function lJ(r) {
  this.value = r, this.match = function(e) {
    return this.value >= e.height;
  };
}
function cJ(r) {
  this.value = r, this.match = function(e) {
    return this.value < e.height;
  };
}
function fJ(r) {
  this.value = r, this.match = function(e) {
    return this.value >= e.width;
  };
}
function hJ(r) {
  this.value = r, this.match = function(e) {
    return this.value < e.width;
  };
}
function dJ(r) {
  this.value = r, this.match = function(e) {
    return this.value === e.orientation;
  };
}
var pJ = function(e, t) {
  switch (e) {
    case "max-height":
      return new lJ(t);
    case "min-height":
      return new cJ(t);
    case "max-width":
      return new fJ(t);
    case "min-width":
      return new hJ(t);
    case "orientation":
      return new dJ(t);
    default:
      throw new Error(t);
  }
};
function vJ(r, e) {
  this.left = r, this.right = e, this.match = function(t) {
    return r.match(t) && e.match(t);
  };
}
function gJ(r, e) {
  this.left = r, this.right = e, this.match = function(t) {
    return r.match(t) || e.match(t);
  };
}
var mJ = function(e, t, n) {
  switch (e) {
    case "and":
      return new vJ(t, n);
    case ",":
      return new gJ(t, n);
    default:
      throw new Error(value);
  }
}, yJ = pJ, bJ = mJ, W8 = /[0-9]/, P4 = /[a-z|\-]/i, wJ = /\s/, K_ = /:/, AJ = /,/, xJ = /and$/, EJ = /@/;
function _J(r) {
  for (var e = 0, t = []; e < r.length; ) {
    var n = r[e];
    if (EJ.test(n))
      for (n = r[++e]; P4.test(n) && n !== void 0; )
        n = r[++e];
    if (wJ.test(n) || n === ")" || n === "(") {
      e++;
      continue;
    }
    if (K_.test(n) || AJ.test(n)) {
      e++, t.push({ type: "operator", value: n });
      continue;
    }
    if (W8.test(n)) {
      for (var i = ""; W8.test(n); )
        i += n, n = r[++e];
      t.push({ type: "number", value: i });
      continue;
    }
    if (P4.test(n)) {
      for (var i = ""; P4.test(n) && n !== void 0; )
        i += n, n = r[++e];
      xJ.test(i) ? t.push({ type: "operator", value: i }) : t.push({ type: "literal", value: i });
      continue;
    }
    throw new TypeError(
      "Tokenizer: I dont know what this character is: " + n
    );
  }
  return t;
}
function DJ(r) {
  for (var e = [], t = []; r.length > 0; ) {
    var n = r.shift();
    if (n.type === "number" || n.type === "literal") {
      e.push(n);
      continue;
    }
    if (n.type === "operator") {
      if (K_.test(n.value)) {
        n = { type: "query", key: e.pop(), value: r.shift() }, e.push(n);
        continue;
      }
      for (; t.length > 0; )
        e.unshift(t.pop());
      t.push(n);
    }
  }
  for (; t.length > 0; )
    e.unshift(t.pop());
  function i() {
    var a = e.shift();
    if (a.type === "number")
      return parseInt(a.value);
    if (a.type === "literal")
      return a.value;
    if (a.type === "operator") {
      var o = i(), s = i();
      return bJ(a.value, o, s);
    }
    if (a.type === "query") {
      var o = a.key.value, s = a.value.value;
      return yJ(o, s);
    }
  }
  return i();
}
var TJ = {
  parse: function(r) {
    var e = _J(r), t = DJ(e);
    return t;
  }
}, kJ = TJ, SJ = function(r, e) {
  var t = {};
  return Object.keys(r).forEach(function(n) {
    kJ.parse(n).match(e) && Object.assign(t, r[n]);
  }), t;
};
const CJ = /* @__PURE__ */ I0(SJ);
var FJ = [1, 1, 0], OJ = [1, 1, "auto"], RJ = function(e, t) {
  var n = FJ, i = [];
  t === "auto" ? n = OJ : i = ("" + t).split(" ");
  var a = i[0] || n[0], o = i[1] || n[1], s = i[2] || n[2];
  return {
    flexGrow: a,
    flexShrink: o,
    flexBasis: s
  };
}, IJ = "px,in,mm,cm,pt,%,vw,vh", B4 = function(e, t) {
  console.error(`
    @react-pdf/stylesheet parsing error:

    ` + e + ": " + t + `,
    ` + " ".repeat(e.length + 2) + `^
    Unsupported ` + e + ` value format
  `);
}, gu = function(e) {
  var t = e === void 0 ? {} : e, n = t.expandsTo, i = t.maxValues, a = i === void 0 ? 1 : i, o = t.autoSupported, s = o === void 0 ? !1 : o;
  return function(c, h) {
    for (var d, g = XK("" + h), x = [], _ = 0; _ < g.length; _++) {
      var k = g[_];
      if (k.type === "function" || k.type === "string" || k.type === "div")
        return B4(c, h), {};
      if (k.type === "word")
        if (k.value === "auto" && s)
          x.push(k.value);
        else {
          var P = tJ(k.value);
          if (P && IJ.includes(P.unit))
            x.push(k.value);
          else
            return B4(c, h), {};
        }
    }
    if (x.length > a)
      return B4(c, h), {};
    var N = x[0];
    if (n) {
      var M = x[1] || x[0], G = x[2] || x[0], z = x[3] || x[1] || x[0];
      return n({
        first: N,
        second: M,
        third: G,
        fourth: z
      });
    }
    return d = {}, d[c] = N, d;
  };
}, PJ = gu({
  expandsTo: function(e) {
    var t = e.first, n = e.second, i = e.third, a = e.fourth;
    return {
      marginTop: t,
      marginRight: n,
      marginBottom: i,
      marginLeft: a
    };
  },
  maxValues: 4,
  autoSupported: !0
}), BJ = gu({
  expandsTo: function(e) {
    var t = e.first, n = e.second;
    return {
      marginTop: t,
      marginBottom: n
    };
  },
  maxValues: 2,
  autoSupported: !0
}), NJ = gu({
  expandsTo: function(e) {
    var t = e.first, n = e.second;
    return {
      marginRight: t,
      marginLeft: n
    };
  },
  maxValues: 2,
  autoSupported: !0
}), oh = gu({
  autoSupported: !0
}), LJ = /(-?\d+(\.\d+)?(px|in|mm|cm|pt|vw|vh|px)?)\s(\S+)\s(.+)/, MJ = function(e) {
  return e.match(LJ) || [];
}, $o = function(e, t) {
  var n = MJ("" + t);
  if (n) {
    var i = n[5] || t, a = n[4] || t, o = n[1] || t;
    if (e.match(/(Top|Right|Bottom|Left)$/)) {
      var s;
      return s = {}, s[e + "Color"] = i, s[e + "Style"] = a, s[e + "Width"] = o, s;
    }
    return e.match(/Color$/) ? {
      borderTopColor: i,
      borderRightColor: i,
      borderBottomColor: i,
      borderLeftColor: i
    } : e.match(/Style$/) ? {
      borderTopStyle: a,
      borderRightStyle: a,
      borderBottomStyle: a,
      borderLeftStyle: a
    } : e.match(/Width$/) ? {
      borderTopWidth: o,
      borderRightWidth: o,
      borderBottomWidth: o,
      borderLeftWidth: o
    } : e.match(/Radius$/) ? {
      borderTopLeftRadius: t,
      borderTopRightRadius: t,
      borderBottomRightRadius: t,
      borderBottomLeftRadius: t
    } : {
      borderTopColor: i,
      borderTopStyle: a,
      borderTopWidth: o,
      borderRightColor: i,
      borderRightStyle: a,
      borderRightWidth: o,
      borderBottomColor: i,
      borderBottomStyle: a,
      borderBottomWidth: o,
      borderLeftColor: i,
      borderLeftStyle: a,
      borderLeftWidth: o
    };
  }
  return t;
}, UJ = gu({
  expandsTo: function(e) {
    var t = e.first, n = e.second, i = e.third, a = e.fourth;
    return {
      paddingTop: t,
      paddingRight: n,
      paddingBottom: i,
      paddingLeft: a
    };
  },
  maxValues: 4
}), $J = gu({
  expandsTo: function(e) {
    var t = e.first, n = e.second;
    return {
      paddingTop: t,
      paddingBottom: n
    };
  },
  maxValues: 2
}), zJ = gu({
  expandsTo: function(e) {
    var t = e.first, n = e.second;
    return {
      paddingRight: t,
      paddingLeft: n
    };
  },
  maxValues: 2
}), sh = gu(), jJ = function(e, t) {
  var n = ("" + t).split(" ");
  return {
    objectPositionX: (n == null ? void 0 : n[0]) || t,
    objectPositionY: (n == null ? void 0 : n[1]) || t
  };
}, G8 = {
  top: !0,
  bottom: !0
}, WJ = function(e, t) {
  return G8[e] ? 1 : G8[t] ? -1 : 0;
}, GJ = function(e) {
  if (!e || e.length === 0) return ["center", "center"];
  var t = e.length === 1 ? [e[0], "center"] : e;
  return t.sort(WJ);
}, VJ = function(e, t) {
  var n = ("" + t).split(" "), i = GJ(n);
  return {
    transformOriginX: i[0],
    transformOriginY: i[1]
  };
}, YJ = function(e, t) {
  var n = ("" + t).split(" ");
  return {
    rowGap: (n == null ? void 0 : n[0]) || t,
    columnGap: (n == null ? void 0 : n[1]) || t
  };
}, V8 = {
  flex: RJ,
  gap: YJ,
  margin: PJ,
  marginHorizontal: NJ,
  marginVertical: BJ,
  marginTop: oh,
  marginRight: oh,
  marginBottom: oh,
  marginLeft: oh,
  padding: UJ,
  paddingHorizontal: zJ,
  paddingVertical: $J,
  paddingTop: sh,
  paddingRight: sh,
  paddingBottom: sh,
  paddingLeft: sh,
  border: $o,
  borderTop: $o,
  borderRight: $o,
  borderBottom: $o,
  borderLeft: $o,
  borderColor: $o,
  borderRadius: $o,
  borderStyle: $o,
  borderWidth: $o,
  objectPosition: jJ,
  transformOrigin: VJ
}, HJ = function(e, t) {
  var n;
  return V8[e] ? V8[e](e, t) : (n = {}, n[e] = t, n);
}, ZJ = function(e) {
  if (!e) return e;
  for (var t = Object.keys(e), n = {}, i = 0; i < t.length; i += 1)
    for (var a = t[i], o = e[a], s = HJ(a, o), c = Object.keys(s), h = 0; h < c.length; h += 1) {
      var d = c[h], g = s[d];
      n[d] = g;
    }
  return n;
}, qJ = function(e) {
  return e.filter(Boolean);
}, XJ = function(e) {
  return e.reduce(function(t, n) {
    var i = Array.isArray(n) ? Ig(n) : n;
    return Object.keys(i).forEach(function(a) {
      i[a] !== null && i[a] !== void 0 && (t[a] = i[a]);
    }), t;
  }, {});
}, Ig = fi(XJ, qJ, Xd), KJ = function(e) {
  var t = /^(-?\d*\.?\d+)(in|mm|cm|pt|vh|vw|px)?$/g.exec(e);
  return t ? {
    value: parseFloat(t[1], 10),
    unit: t[2] || "pt"
  } : {
    value: e,
    unit: void 0
  };
}, JJ = function(e, t) {
  var n = KJ(t), i = e.dpi || 72, a = 1 / 25.4 * i, o = 1 / 2.54 * i;
  switch (n.unit) {
    case "in":
      return n.value * i;
    case "mm":
      return n.value * a;
    case "cm":
      return n.value * o;
    case "vh":
      return n.value * (e.height / 100);
    case "vw":
      return n.value * (e.width / 100);
    default:
      return n.value;
  }
}, QJ = function(e) {
  return /rgba?/g.test(e);
}, eQ = function(e) {
  return /hsla?/g.test(e);
}, tQ = function(e) {
  var t = w1.get.rgb(e);
  return w1.to.hex(t);
}, rQ = function(e) {
  var t = w1.get.hsl(e).map(Math.round), n = uJ.apply(void 0, t);
  return n.toUpperCase();
}, Qh = function(e) {
  return QJ(e) ? tQ(e) : eQ(e) ? rQ(e) : e;
}, nQ = function(e) {
  var t = e.trim().split(/\) |\)/);
  if (t.length === 1)
    return [[t[0], !0]];
  for (var n = [], i = 0; i < t.length; i += 1) {
    var a = t[i];
    if (a) {
      var o = a.split("("), s = o[0], c = o[1], h = c.indexOf(",") >= 0 ? "," : " ", d = c.split(h).map(function(g) {
        return g.trim();
      });
      n.push({
        operation: s,
        value: d
      });
    }
  }
  return n;
}, uh = function(e) {
  var t = /(-?\d*\.?\d*)(\w*)?/i, n = t.exec(e), i = n[1], a = n[2], o = Number.parseFloat(i);
  return a === "rad" ? o * 180 / Math.PI : o;
}, iQ = function(e) {
  var t = e.operation, n = e.value;
  switch (t) {
    case "scale": {
      var i = n.map(function(c) {
        return Number.parseFloat(c);
      }), a = i[0], o = i[1], s = o === void 0 ? a : o;
      return {
        operation: "scale",
        value: [a, s]
      };
    }
    case "scaleX":
      return {
        operation: "scale",
        value: [Number.parseFloat(n), 1]
      };
    case "scaleY":
      return {
        operation: "scale",
        value: [1, Number.parseFloat(n)]
      };
    case "rotate":
      return {
        operation: "rotate",
        value: [uh(n)]
      };
    case "translate":
      return {
        operation: "translate",
        value: n.map(function(c) {
          return Number.parseFloat(c);
        })
      };
    case "translateX":
      return {
        operation: "translate",
        value: [Number.parseFloat(n), 0]
      };
    case "translateY":
      return {
        operation: "translate",
        value: [0, Number.parseFloat(n)]
      };
    case "skew":
      return {
        operation: "skew",
        value: n.map(uh)
      };
    case "skewX":
      return {
        operation: "skew",
        value: [uh(n), 0]
      };
    case "skewY":
      return {
        operation: "skew",
        value: [0, uh(n)]
      };
    default:
      return {
        operation: t,
        value: n.map(function(c) {
          return Number.parseFloat(c);
        })
      };
  }
}, aQ = function(e) {
  return e.map(function(t) {
    return iQ(t);
  });
}, J_ = function(e) {
  return typeof e != "string" ? e : aQ(nQ(e));
}, N4 = {
  thin: 100,
  hairline: 100,
  ultralight: 200,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  demibold: 600,
  bold: 700,
  ultrabold: 800,
  extrabold: 800,
  heavy: 900,
  black: 900
}, oQ = function(e) {
  if (!e) return N4.normal;
  if (typeof e == "number") return e;
  var t = e.toLowerCase();
  return N4[t] ? N4[t] : e;
}, sQ = function(e) {
  return typeof e == "string" && /^-?\d*\.?\d*$/.test(e);
}, Pg = function(e) {
  return typeof e != "string" ? e : sQ(e) ? parseFloat(e, 10) : e;
}, Q_ = function(e) {
  switch (e) {
    case "top":
    case "left":
      return "0%";
    case "right":
    case "bottom":
      return "100%";
    case "center":
      return "50%";
    default:
      return null;
  }
}, Y8 = function(e) {
  return Q_(e) || Pg(e);
}, H8 = function(e) {
  return Q_(e) || Pg(e);
}, Z8 = {
  transform: J_,
  fontWeight: oQ,
  objectPositionX: Y8,
  objectPositionY: Y8,
  transformOriginX: H8,
  transformOriginY: H8
}, uQ = function(e, t, n) {
  var i = Z8[e] ? Z8[e](t) : t;
  return Qh(JJ(n, Pg(i)));
}, lQ = function(e) {
  return function(t) {
    if (!t) return t;
    for (var n = Object.keys(t), i = {}, a = 0; a < n.length; a += 1) {
      var o = n[a], s = t[o], c = uQ(o, s, e);
      i[o] = c;
    }
    return i;
  };
}, cQ = function(e, t) {
  return Object.keys(t).reduce(function(n, i) {
    var a;
    if (/@media/.test(i)) {
      var o;
      return $r({}, n, CJ((o = {}, o[i] = t[i], o), e));
    }
    return $r({}, n, (a = {}, a[i] = t[i], a));
  }, {});
}, fQ = function(e, t) {
  var n = function(a) {
    return cQ(e, a);
  };
  return fi(lQ(e), ZJ, n, Ig)(t);
}, eD = { exports: {} };
(function(r) {
  (function(e, t) {
    r.exports ? r.exports = t() : e.createHyphenator = t();
  })(Jf, function() {
    var e = !1, t = !1, n = !1, i = "­", a = 5, o = "async", s = "debug", c = "html", h = "hyphenChar", d = "minWordLength", g = typeof Jf == "object" ? Jf : typeof window == "object" ? window : typeof self == "object" ? self : typeof this == "object" ? this : {};
    function x(j) {
      var R = {};
      for (var te in j)
        R[te] = j[te];
      return R;
    }
    function _(j, R, te) {
      return R in j ? j[R] : te;
    }
    function k(j, R) {
      return j.exceptions.reduce(
        function(te, J) {
          return te[J.replace(/\-/g, "")] = J.replace(
            /\-/g,
            R
          ), te;
        },
        {}
      );
    }
    function P(j, R) {
      R = R || {};
      var te = _(
        R,
        o,
        e
      ), J = {}, K = _(R, s, t), ee = {}, ve = _(
        R,
        h,
        i
      ), de = j.patterns.map(G), B = _(
        R,
        d,
        a
      ) >> 0, q = _(R, c, n), H = ve + B;
      if (ee[H] = k(
        j,
        ve
      ), J[H] = x(ee[H]), te && !("Promise" in g))
        throw new Error(
          "Failed to create hyphenator: Could not find global Promise object, needed for hyphenator to work in async mode"
        );
      return function(oe, ne) {
        ne = ne || {};
        var me = _(ne, s, K), fe = _(
          ne,
          h,
          ve
        ), _e = _(ne, d, B) >> 0, Re = fe + _e;
        return ee[Re] || (ee[Re] = k(
          j,
          fe
        )), J[Re] || (J[Re] = x(ee[Re])), z(
          oe,
          de,
          J[Re],
          me,
          fe,
          q,
          _e,
          te
        );
      };
    }
    function N(j, R, te, J) {
      function K() {
        var Re = "";
        H = void 0;
        e: for (; de <= j.length; ) {
          var Ie = j.charAt(de++), W = !!Ie && !/\s|[\!-\@\[-\`\{-\~\u2013-\u203C]/.test(Ie), Z = Ie === "<", se = Ie === ">", ye = Ie === R;
          do {
            if (_e === oe) {
              se && (_e = me);
              break;
            }
            if (ye) {
              H = q, _e = ne;
              break;
            }
            if (W) {
              _e = ne;
              break;
            }
            if (_e === ne) {
              _e = fe, H = H || Re.length >= J && B;
              break;
            }
            H = q, _e = me;
          } while (!1);
          switch (Z && _e !== fe && te && !ve(j.charAt(de)) && (H = q, _e = oe), _e) {
            case oe:
              Re += Ie;
              break;
            case ne:
              Re += Ie;
              break;
            case me:
              Re += Ie;
              break e;
            case fe:
              de--;
              break e;
          }
        }
        return Re || void 0;
      }
      function ee() {
        return H === B;
      }
      var ve = RegExp.prototype.test.bind(/\s/), de = 0, B = 1, q = 2, H, oe = 1, ne = 2, me = 3, fe = 4, _e;
      return [K, ee];
    }
    function M(j, R, te, J) {
      for (var K = new Array(j.length + 1), ee = j.toLocaleLowerCase(), ve = [], de, B = 0, q = K.length; q--; ) K[q] = 0;
      for (; de = R[B++]; )
        for (var H = 0, oe = !1; !oe; ) {
          var ne = ee.indexOf(de.text, H), me = ne > -1 && (de.stickToLeft ? ne === 0 : !0) && (de.stickToRight ? ne + de.text.length === j.length : !0);
          if (me) {
            ve.push(de.pattern + ">" + de.levels.join(""));
            for (var q = 0; q < de.levels.length; q++)
              K[ne + q] = Math.max(
                de.levels[q],
                K[ne + q]
              );
          }
          ne > -1 && de.text.length > 0 ? H = ne + de.text.length + 1 : oe = !0;
        }
      K[0] = K[1] = K[K.length - 1] = K[K.length - 2] = 0;
      for (var fe = "", _e = "", Re = "", q = 0; q < K.length; q++)
        fe += (K[q] % 2 === 1 ? J : "") + j.charAt(q), te && (Re += (K[q] % 2 === 1 ? "-" : "") + j.charAt(q), _e += (K[q] > 0 ? K[q] : "") + j.charAt(q));
      return te && console.log.apply(
        console,
        [j, "->"].concat(ve).concat(["->"]).concat(K).concat(["->", _e]).concat(["->", Re])
      ), fe;
    }
    function G(j) {
      for (var R = 0, te, J = {
        pattern: j,
        text: "",
        levels: [],
        stickToLeft: 0,
        stickToRight: 0
      }, K = { alphabet: 1, level: 2, stickToLeft: 3, stickToRight: 4 }; te = j.charAt(R++); ) {
        var ee = te === ".", ve = !ee && /\d/.test(te), de = ee ? R - 1 === 0 ? K.stickToLeft : K.stickToRight : ve ? K.level : K.alphabet;
        switch (de) {
          case K.alphabet:
            !B && J.levels.push(0), J.text += te;
            break;
          case K.level:
            J.levels.push(parseInt(te));
            break;
          case K.stickToLeft:
            J.stickToLeft = !0;
            break;
          case K.stickToRight:
            J.stickToRight = !0;
            break;
        }
        var B = ve;
      }
      return J;
    }
    function z(j, R, te, J, K, ee, ve, de) {
      function B() {
        Ie = /* @__PURE__ */ new Date() - Ie, Z(H), J && (console.log(
          `----------------
Hyphenation stats: ` + _e + " text chunks processed, " + Re + " words hyphenated"
        ), console.log("Work time: " + W / 1e3), console.log("Wait time: " + (Ie - W) / 1e3), console.log("All time: " + Ie / 1e3));
      }
      var q, H = "", oe, ne = N(j, K, ee, ve), me = ne[0], fe = ne[1], _e = 0, Re = 0, Ie = /* @__PURE__ */ new Date(), W = 0, Z = function() {
      };
      function se() {
        for (var ye = /* @__PURE__ */ new Date(); (!de || /* @__PURE__ */ new Date() - ye < 10) && (oe = me()); )
          q = oe.length ? "$" + oe : "", fe() && (te[q] === void 0 && (te[q] = M(
            oe,
            R,
            J,
            K
          )), oe !== te[q] && Re++, oe = te[q]), H += oe, _e++;
        W += /* @__PURE__ */ new Date() - ye, oe ? setTimeout(se) : B();
      }
      return de ? (setTimeout(se), new Promise(function(ye) {
        Z = ye;
      })) : (se(), H);
    }
    return P;
  });
})(eD);
var hQ = eD.exports, dQ = hQ;
const pQ = /* @__PURE__ */ I0(dQ);
var tD = { exports: {} };
(function(r) {
  (function(e, t) {
    r.exports ? r.exports = t() : e.hyphenationPatternsEnUs = t();
  })(Jf, function() {
    var e = [], t = [], e = [
      " ",
      // just type <return> if you're not using INITEX
      ".ach4",
      ".ad4der",
      ".af1t",
      ".al3t",
      ".am5at",
      ".an5c",
      ".ang4",
      ".ani5m",
      ".ant4",
      ".an3te",
      ".anti5s",
      ".ar5s",
      ".ar4tie",
      ".ar4ty",
      ".as3c",
      ".as1p",
      ".as1s",
      ".aster5",
      ".atom5",
      ".au1d",
      ".av4i",
      ".awn4",
      ".ba4g",
      ".ba5na",
      ".bas4e",
      ".ber4",
      ".be5ra",
      ".be3sm",
      ".be5sto",
      ".bri2",
      ".but4ti",
      ".cam4pe",
      ".can5c",
      ".capa5b",
      ".car5ol",
      ".ca4t",
      ".ce4la",
      ".ch4",
      ".chill5i",
      ".ci2",
      ".cit5r",
      ".co3e",
      ".co4r",
      ".cor5ner",
      ".de4moi",
      ".de3o",
      ".de3ra",
      ".de3ri",
      ".des4c",
      ".dictio5",
      ".do4t",
      ".du4c",
      ".dumb5",
      ".earth5",
      ".eas3i",
      ".eb4",
      ".eer4",
      ".eg2",
      ".el5d",
      ".el3em",
      ".enam3",
      ".en3g",
      ".en3s",
      ".eq5ui5t",
      ".er4ri",
      ".es3",
      ".eu3",
      ".eye5",
      ".fes3",
      ".for5mer",
      ".ga2",
      ".ge2",
      ".gen3t4",
      ".ge5og",
      ".gi5a",
      ".gi4b",
      ".go4r",
      ".hand5i",
      ".han5k",
      ".he2",
      ".hero5i",
      ".hes3",
      ".het3",
      ".hi3b",
      ".hi3er",
      ".hon5ey",
      ".hon3o",
      ".hov5",
      ".id4l",
      ".idol3",
      ".im3m",
      ".im5pin",
      ".in1",
      ".in3ci",
      ".ine2",
      ".in2k",
      ".in3s",
      ".ir5r",
      ".is4i",
      ".ju3r",
      ".la4cy",
      ".la4m",
      ".lat5er",
      ".lath5",
      ".le2",
      ".leg5e",
      ".len4",
      ".lep5",
      ".lev1",
      ".li4g",
      ".lig5a",
      ".li2n",
      ".li3o",
      ".li4t",
      ".mag5a5",
      ".mal5o",
      ".man5a",
      ".mar5ti",
      ".me2",
      ".mer3c",
      ".me5ter",
      ".mis1",
      ".mist5i",
      ".mon3e",
      ".mo3ro",
      ".mu5ta",
      ".muta5b",
      ".ni4c",
      ".od2",
      ".odd5",
      ".of5te",
      ".or5ato",
      ".or3c",
      ".or1d",
      ".or3t",
      ".os3",
      ".os4tl",
      ".oth3",
      ".out3",
      ".ped5al",
      ".pe5te",
      ".pe5tit",
      ".pi4e",
      ".pio5n",
      ".pi2t",
      ".pre3m",
      ".ra4c",
      ".ran4t",
      ".ratio5na",
      ".ree2",
      ".re5mit",
      ".res2",
      ".re5stat",
      ".ri4g",
      ".rit5u",
      ".ro4q",
      ".ros5t",
      ".row5d",
      ".ru4d",
      ".sci3e",
      ".self5",
      ".sell5",
      ".se2n",
      ".se5rie",
      ".sh2",
      ".si2",
      ".sing4",
      ".st4",
      ".sta5bl",
      ".sy2",
      ".ta4",
      ".te4",
      ".ten5an",
      ".th2",
      ".ti2",
      ".til4",
      ".tim5o5",
      ".ting4",
      ".tin5k",
      ".ton4a",
      ".to4p",
      ".top5i",
      ".tou5s",
      ".trib5ut",
      ".un1a",
      ".un3ce",
      ".under5",
      ".un1e",
      ".un5k",
      ".un5o",
      ".un3u",
      ".up3",
      ".ure3",
      ".us5a",
      ".ven4de",
      ".ve5ra",
      ".wil5i",
      ".ye4",
      "4ab.",
      "a5bal",
      "a5ban",
      "abe2",
      "ab5erd",
      "abi5a",
      "ab5it5ab",
      "ab5lat",
      "ab5o5liz",
      "4abr",
      "ab5rog",
      "ab3ul",
      "a4car",
      "ac5ard",
      "ac5aro",
      "a5ceou",
      "ac1er",
      "a5chet",
      "4a2ci",
      "a3cie",
      "ac1in",
      "a3cio",
      "ac5rob",
      "act5if",
      "ac3ul",
      "ac4um",
      "a2d",
      "ad4din",
      "ad5er.",
      "2adi",
      "a3dia",
      "ad3ica",
      "adi4er",
      "a3dio",
      "a3dit",
      "a5diu",
      "ad4le",
      "ad3ow",
      "ad5ran",
      "ad4su",
      "4adu",
      "a3duc",
      "ad5um",
      "ae4r",
      "aeri4e",
      "a2f",
      "aff4",
      "a4gab",
      "aga4n",
      "ag5ell",
      "age4o",
      "4ageu",
      "ag1i",
      "4ag4l",
      "ag1n",
      "a2go",
      "3agog",
      "ag3oni",
      "a5guer",
      "ag5ul",
      "a4gy",
      "a3ha",
      "a3he",
      "ah4l",
      "a3ho",
      "ai2",
      "a5ia",
      "a3ic.",
      "ai5ly",
      "a4i4n",
      "ain5in",
      "ain5o",
      "ait5en",
      "a1j",
      "ak1en",
      "al5ab",
      "al3ad",
      "a4lar",
      "4aldi",
      "2ale",
      "al3end",
      "a4lenti",
      "a5le5o",
      "al1i",
      "al4ia.",
      "ali4e",
      "al5lev",
      "4allic",
      "4alm",
      "a5log.",
      "a4ly.",
      "4alys",
      "5a5lyst",
      "5alyt",
      "3alyz",
      "4ama",
      "am5ab",
      "am3ag",
      "ama5ra",
      "am5asc",
      "a4matis",
      "a4m5ato",
      "am5era",
      "am3ic",
      "am5if",
      "am5ily",
      "am1in",
      "ami4no",
      "a2mo",
      "a5mon",
      "amor5i",
      "amp5en",
      "a2n",
      "an3age",
      "3analy",
      "a3nar",
      "an3arc",
      "anar4i",
      "a3nati",
      "4and",
      "ande4s",
      "an3dis",
      "an1dl",
      "an4dow",
      "a5nee",
      "a3nen",
      "an5est.",
      "a3neu",
      "2ang",
      "ang5ie",
      "an1gl",
      "a4n1ic",
      "a3nies",
      "an3i3f",
      "an4ime",
      "a5nimi",
      "a5nine",
      "an3io",
      "a3nip",
      "an3ish",
      "an3it",
      "a3niu",
      "an4kli",
      "5anniz",
      "ano4",
      "an5ot",
      "anoth5",
      "an2sa",
      "an4sco",
      "an4sn",
      "an2sp",
      "ans3po",
      "an4st",
      "an4sur",
      "antal4",
      "an4tie",
      "4anto",
      "an2tr",
      "an4tw",
      "an3ua",
      "an3ul",
      "a5nur",
      "4ao",
      "apar4",
      "ap5at",
      "ap5ero",
      "a3pher",
      "4aphi",
      "a4pilla",
      "ap5illar",
      "ap3in",
      "ap3ita",
      "a3pitu",
      "a2pl",
      "apoc5",
      "ap5ola",
      "apor5i",
      "apos3t",
      "aps5es",
      "a3pu",
      "aque5",
      "2a2r",
      "ar3act",
      "a5rade",
      "ar5adis",
      "ar3al",
      "a5ramete",
      "aran4g",
      "ara3p",
      "ar4at",
      "a5ratio",
      "ar5ativ",
      "a5rau",
      "ar5av4",
      "araw4",
      "arbal4",
      "ar4chan",
      "ar5dine",
      "ar4dr",
      "ar5eas",
      "a3ree",
      "ar3ent",
      "a5ress",
      "ar4fi",
      "ar4fl",
      "ar1i",
      "ar5ial",
      "ar3ian",
      "a3riet",
      "ar4im",
      "ar5inat",
      "ar3io",
      "ar2iz",
      "ar2mi",
      "ar5o5d",
      "a5roni",
      "a3roo",
      "ar2p",
      "ar3q",
      "arre4",
      "ar4sa",
      "ar2sh",
      "4as.",
      "as4ab",
      "as3ant",
      "ashi4",
      "a5sia.",
      "a3sib",
      "a3sic",
      "5a5si4t",
      "ask3i",
      "as4l",
      "a4soc",
      "as5ph",
      "as4sh",
      "as3ten",
      "as1tr",
      "asur5a",
      "a2ta",
      "at3abl",
      "at5ac",
      "at3alo",
      "at5ap",
      "ate5c",
      "at5ech",
      "at3ego",
      "at3en.",
      "at3era",
      "ater5n",
      "a5terna",
      "at3est",
      "at5ev",
      "4ath",
      "ath5em",
      "a5then",
      "at4ho",
      "ath5om",
      "4ati.",
      "a5tia",
      "at5i5b",
      "at1ic",
      "at3if",
      "ation5ar",
      "at3itu",
      "a4tog",
      "a2tom",
      "at5omiz",
      "a4top",
      "a4tos",
      "a1tr",
      "at5rop",
      "at4sk",
      "at4tag",
      "at5te",
      "at4th",
      "a2tu",
      "at5ua",
      "at5ue",
      "at3ul",
      "at3ura",
      "a2ty",
      "au4b",
      "augh3",
      "au3gu",
      "au4l2",
      "aun5d",
      "au3r",
      "au5sib",
      "aut5en",
      "au1th",
      "a2va",
      "av3ag",
      "a5van",
      "ave4no",
      "av3era",
      "av5ern",
      "av5ery",
      "av1i",
      "avi4er",
      "av3ig",
      "av5oc",
      "a1vor",
      "3away",
      "aw3i",
      "aw4ly",
      "aws4",
      "ax4ic",
      "ax4id",
      "ay5al",
      "aye4",
      "ays4",
      "azi4er",
      "azz5i",
      "5ba.",
      "bad5ger",
      "ba4ge",
      "bal1a",
      "ban5dag",
      "ban4e",
      "ban3i",
      "barbi5",
      "bari4a",
      "bas4si",
      "1bat",
      "ba4z",
      "2b1b",
      "b2be",
      "b3ber",
      "bbi4na",
      "4b1d",
      "4be.",
      "beak4",
      "beat3",
      "4be2d",
      "be3da",
      "be3de",
      "be3di",
      "be3gi",
      "be5gu",
      "1bel",
      "be1li",
      "be3lo",
      "4be5m",
      "be5nig",
      "be5nu",
      "4bes4",
      "be3sp",
      "be5str",
      "3bet",
      "bet5iz",
      "be5tr",
      "be3tw",
      "be3w",
      "be5yo",
      "2bf",
      "4b3h",
      "bi2b",
      "bi4d",
      "3bie",
      "bi5en",
      "bi4er",
      "2b3if",
      "1bil",
      "bi3liz",
      "bina5r4",
      "bin4d",
      "bi5net",
      "bi3ogr",
      "bi5ou",
      "bi2t",
      "3bi3tio",
      "bi3tr",
      "3bit5ua",
      "b5itz",
      "b1j",
      "bk4",
      "b2l2",
      "blath5",
      "b4le.",
      "blen4",
      "5blesp",
      "b3lis",
      "b4lo",
      "blun4t",
      "4b1m",
      "4b3n",
      "bne5g",
      "3bod",
      "bod3i",
      "bo4e",
      "bol3ic",
      "bom4bi",
      "bon4a",
      "bon5at",
      "3boo",
      "5bor.",
      "4b1ora",
      "bor5d",
      "5bore",
      "5bori",
      "5bos4",
      "b5ota",
      "both5",
      "bo4to",
      "bound3",
      "4bp",
      "4brit",
      "broth3",
      "2b5s2",
      "bsor4",
      "2bt",
      "bt4l",
      "b4to",
      "b3tr",
      "buf4fer",
      "bu4ga",
      "bu3li",
      "bumi4",
      "bu4n",
      "bunt4i",
      "bu3re",
      "bus5ie",
      "buss4e",
      "5bust",
      "4buta",
      "3butio",
      "b5uto",
      "b1v",
      "4b5w",
      "5by.",
      "bys4",
      "1ca",
      "cab3in",
      "ca1bl",
      "cach4",
      "ca5den",
      "4cag4",
      "2c5ah",
      "ca3lat",
      "cal4la",
      "call5in",
      "4calo",
      "can5d",
      "can4e",
      "can4ic",
      "can5is",
      "can3iz",
      "can4ty",
      "cany4",
      "ca5per",
      "car5om",
      "cast5er",
      "cas5tig",
      "4casy",
      "ca4th",
      "4cativ",
      "cav5al",
      "c3c",
      "ccha5",
      "cci4a",
      "ccompa5",
      "ccon4",
      "ccou3t",
      "2ce.",
      "4ced.",
      "4ceden",
      "3cei",
      "5cel.",
      "3cell",
      "1cen",
      "3cenc",
      "2cen4e",
      "4ceni",
      "3cent",
      "3cep",
      "ce5ram",
      "4cesa",
      "3cessi",
      "ces5si5b",
      "ces5t",
      "cet4",
      "c5e4ta",
      "cew4",
      "2ch",
      "4ch.",
      "4ch3ab",
      "5chanic",
      "ch5a5nis",
      "che2",
      "cheap3",
      "4ched",
      "che5lo",
      "3chemi",
      "ch5ene",
      "ch3er.",
      "ch3ers",
      "4ch1in",
      "5chine.",
      "ch5iness",
      "5chini",
      "5chio",
      "3chit",
      "chi2z",
      "3cho2",
      "ch4ti",
      "1ci",
      "3cia",
      "ci2a5b",
      "cia5r",
      "ci5c",
      "4cier",
      "5cific.",
      "4cii",
      "ci4la",
      "3cili",
      "2cim",
      "2cin",
      "c4ina",
      "3cinat",
      "cin3em",
      "c1ing",
      "c5ing.",
      "5cino",
      "cion4",
      "4cipe",
      "ci3ph",
      "4cipic",
      "4cista",
      "4cisti",
      "2c1it",
      "cit3iz",
      "5ciz",
      "ck1",
      "ck3i",
      "1c4l4",
      "4clar",
      "c5laratio",
      "5clare",
      "cle4m",
      "4clic",
      "clim4",
      "cly4",
      "c5n",
      "1co",
      "co5ag",
      "coe2",
      "2cog",
      "co4gr",
      "coi4",
      "co3inc",
      "col5i",
      "5colo",
      "col3or",
      "com5er",
      "con4a",
      "c4one",
      "con3g",
      "con5t",
      "co3pa",
      "cop3ic",
      "co4pl",
      "4corb",
      "coro3n",
      "cos4e",
      "cov1",
      "cove4",
      "cow5a",
      "coz5e",
      "co5zi",
      "c1q",
      "cras5t",
      "5crat.",
      "5cratic",
      "cre3at",
      "5cred",
      "4c3reta",
      "cre4v",
      "cri2",
      "cri5f",
      "c4rin",
      "cris4",
      "5criti",
      "cro4pl",
      "crop5o",
      "cros4e",
      "cru4d",
      "4c3s2",
      "2c1t",
      "cta4b",
      "ct5ang",
      "c5tant",
      "c2te",
      "c3ter",
      "c4ticu",
      "ctim3i",
      "ctu4r",
      "c4tw",
      "cud5",
      "c4uf",
      "c4ui",
      "cu5ity",
      "5culi",
      "cul4tis",
      "3cultu",
      "cu2ma",
      "c3ume",
      "cu4mi",
      "3cun",
      "cu3pi",
      "cu5py",
      "cur5a4b",
      "cu5ria",
      "1cus",
      "cuss4i",
      "3c4ut",
      "cu4tie",
      "4c5utiv",
      "4cutr",
      "1cy",
      "cze4",
      "1d2a",
      "5da.",
      "2d3a4b",
      "dach4",
      "4daf",
      "2dag",
      "da2m2",
      "dan3g",
      "dard5",
      "dark5",
      "4dary",
      "3dat",
      "4dativ",
      "4dato",
      "5dav4",
      "dav5e",
      "5day",
      "d1b",
      "d5c",
      "d1d4",
      "2de.",
      "deaf5",
      "deb5it",
      "de4bon",
      "decan4",
      "de4cil",
      "de5com",
      "2d1ed",
      "4dee.",
      "de5if",
      "deli4e",
      "del5i5q",
      "de5lo",
      "d4em",
      "5dem.",
      "3demic",
      "dem5ic.",
      "de5mil",
      "de4mons",
      "demor5",
      "1den",
      "de4nar",
      "de3no",
      "denti5f",
      "de3nu",
      "de1p",
      "de3pa",
      "depi4",
      "de2pu",
      "d3eq",
      "d4erh",
      "5derm",
      "dern5iz",
      "der5s",
      "des2",
      "d2es.",
      "de1sc",
      "de2s5o",
      "des3ti",
      "de3str",
      "de4su",
      "de1t",
      "de2to",
      "de1v",
      "dev3il",
      "4dey",
      "4d1f",
      "d4ga",
      "d3ge4t",
      "dg1i",
      "d2gy",
      "d1h2",
      "5di.",
      "1d4i3a",
      "dia5b",
      "di4cam",
      "d4ice",
      "3dict",
      "3did",
      "5di3en",
      "d1if",
      "di3ge",
      "di4lato",
      "d1in",
      "1dina",
      "3dine.",
      "5dini",
      "di5niz",
      "1dio",
      "dio5g",
      "di4pl",
      "dir2",
      "di1re",
      "dirt5i",
      "dis1",
      "5disi",
      "d4is3t",
      "d2iti",
      "1di1v",
      "d1j",
      "d5k2",
      "4d5la",
      "3dle.",
      "3dled",
      "3dles.",
      "4dless",
      "2d3lo",
      "4d5lu",
      "2dly",
      "d1m",
      "4d1n4",
      "1do",
      "3do.",
      "do5de",
      "5doe",
      "2d5of",
      "d4og",
      "do4la",
      "doli4",
      "do5lor",
      "dom5iz",
      "do3nat",
      "doni4",
      "doo3d",
      "dop4p",
      "d4or",
      "3dos",
      "4d5out",
      "do4v",
      "3dox",
      "d1p",
      "1dr",
      "drag5on",
      "4drai",
      "dre4",
      "drea5r",
      "5dren",
      "dri4b",
      "dril4",
      "dro4p",
      "4drow",
      "5drupli",
      "4dry",
      "2d1s2",
      "ds4p",
      "d4sw",
      "d4sy",
      "d2th",
      "1du",
      "d1u1a",
      "du2c",
      "d1uca",
      "duc5er",
      "4duct.",
      "4ducts",
      "du5el",
      "du4g",
      "d3ule",
      "dum4be",
      "du4n",
      "4dup",
      "du4pe",
      "d1v",
      "d1w",
      "d2y",
      "5dyn",
      "dy4se",
      "dys5p",
      "e1a4b",
      "e3act",
      "ead1",
      "ead5ie",
      "ea4ge",
      "ea5ger",
      "ea4l",
      "eal5er",
      "eal3ou",
      "eam3er",
      "e5and",
      "ear3a",
      "ear4c",
      "ear5es",
      "ear4ic",
      "ear4il",
      "ear5k",
      "ear2t",
      "eart3e",
      "ea5sp",
      "e3ass",
      "east3",
      "ea2t",
      "eat5en",
      "eath3i",
      "e5atif",
      "e4a3tu",
      "ea2v",
      "eav3en",
      "eav5i",
      "eav5o",
      "2e1b",
      "e4bel.",
      "e4bels",
      "e4ben",
      "e4bit",
      "e3br",
      "e4cad",
      "ecan5c",
      "ecca5",
      "e1ce",
      "ec5essa",
      "ec2i",
      "e4cib",
      "ec5ificat",
      "ec5ifie",
      "ec5ify",
      "ec3im",
      "eci4t",
      "e5cite",
      "e4clam",
      "e4clus",
      "e2col",
      "e4comm",
      "e4compe",
      "e4conc",
      "e2cor",
      "ec3ora",
      "eco5ro",
      "e1cr",
      "e4crem",
      "ec4tan",
      "ec4te",
      "e1cu",
      "e4cul",
      "ec3ula",
      "2e2da",
      "4ed3d",
      "e4d1er",
      "ede4s",
      "4edi",
      "e3dia",
      "ed3ib",
      "ed3ica",
      "ed3im",
      "ed1it",
      "edi5z",
      "4edo",
      "e4dol",
      "edon2",
      "e4dri",
      "e4dul",
      "ed5ulo",
      "ee2c",
      "eed3i",
      "ee2f",
      "eel3i",
      "ee4ly",
      "ee2m",
      "ee4na",
      "ee4p1",
      "ee2s4",
      "eest4",
      "ee4ty",
      "e5ex",
      "e1f",
      "e4f3ere",
      "1eff",
      "e4fic",
      "5efici",
      "efil4",
      "e3fine",
      "ef5i5nite",
      "3efit",
      "efor5es",
      "e4fuse.",
      "4egal",
      "eger4",
      "eg5ib",
      "eg4ic",
      "eg5ing",
      "e5git5",
      "eg5n",
      "e4go.",
      "e4gos",
      "eg1ul",
      "e5gur",
      "5egy",
      "e1h4",
      "eher4",
      "ei2",
      "e5ic",
      "ei5d",
      "eig2",
      "ei5gl",
      "e3imb",
      "e3inf",
      "e1ing",
      "e5inst",
      "eir4d",
      "eit3e",
      "ei3th",
      "e5ity",
      "e1j",
      "e4jud",
      "ej5udi",
      "eki4n",
      "ek4la",
      "e1la",
      "e4la.",
      "e4lac",
      "elan4d",
      "el5ativ",
      "e4law",
      "elaxa4",
      "e3lea",
      "el5ebra",
      "5elec",
      "e4led",
      "el3ega",
      "e5len",
      "e4l1er",
      "e1les",
      "el2f",
      "el2i",
      "e3libe",
      "e4l5ic.",
      "el3ica",
      "e3lier",
      "el5igib",
      "e5lim",
      "e4l3ing",
      "e3lio",
      "e2lis",
      "el5ish",
      "e3liv3",
      "4ella",
      "el4lab",
      "ello4",
      "e5loc",
      "el5og",
      "el3op.",
      "el2sh",
      "el4ta",
      "e5lud",
      "el5ug",
      "e4mac",
      "e4mag",
      "e5man",
      "em5ana",
      "em5b",
      "e1me",
      "e2mel",
      "e4met",
      "em3ica",
      "emi4e",
      "em5igra",
      "em1in2",
      "em5ine",
      "em3i3ni",
      "e4mis",
      "em5ish",
      "e5miss",
      "em3iz",
      "5emniz",
      "emo4g",
      "emoni5o",
      "em3pi",
      "e4mul",
      "em5ula",
      "emu3n",
      "e3my",
      "en5amo",
      "e4nant",
      "ench4er",
      "en3dic",
      "e5nea",
      "e5nee",
      "en3em",
      "en5ero",
      "en5esi",
      "en5est",
      "en3etr",
      "e3new",
      "en5ics",
      "e5nie",
      "e5nil",
      "e3nio",
      "en3ish",
      "en3it",
      "e5niu",
      "5eniz",
      "4enn",
      "4eno",
      "eno4g",
      "e4nos",
      "en3ov",
      "en4sw",
      "ent5age",
      "4enthes",
      "en3ua",
      "en5uf",
      "e3ny.",
      "4en3z",
      "e5of",
      "eo2g",
      "e4oi4",
      "e3ol",
      "eop3ar",
      "e1or",
      "eo3re",
      "eo5rol",
      "eos4",
      "e4ot",
      "eo4to",
      "e5out",
      "e5ow",
      "e2pa",
      "e3pai",
      "ep5anc",
      "e5pel",
      "e3pent",
      "ep5etitio",
      "ephe4",
      "e4pli",
      "e1po",
      "e4prec",
      "ep5reca",
      "e4pred",
      "ep3reh",
      "e3pro",
      "e4prob",
      "ep4sh",
      "ep5ti5b",
      "e4put",
      "ep5uta",
      "e1q",
      "equi3l",
      "e4q3ui3s",
      "er1a",
      "era4b",
      "4erand",
      "er3ar",
      "4erati.",
      "2erb",
      "er4bl",
      "er3ch",
      "er4che",
      "2ere.",
      "e3real",
      "ere5co",
      "ere3in",
      "er5el.",
      "er3emo",
      "er5ena",
      "er5ence",
      "4erene",
      "er3ent",
      "ere4q",
      "er5ess",
      "er3est",
      "eret4",
      "er1h",
      "er1i",
      "e1ria4",
      "5erick",
      "e3rien",
      "eri4er",
      "er3ine",
      "e1rio",
      "4erit",
      "er4iu",
      "eri4v",
      "e4riva",
      "er3m4",
      "er4nis",
      "4ernit",
      "5erniz",
      "er3no",
      "2ero",
      "er5ob",
      "e5roc",
      "ero4r",
      "er1ou",
      "er1s",
      "er3set",
      "ert3er",
      "4ertl",
      "er3tw",
      "4eru",
      "eru4t",
      "5erwau",
      "e1s4a",
      "e4sage.",
      "e4sages",
      "es2c",
      "e2sca",
      "es5can",
      "e3scr",
      "es5cu",
      "e1s2e",
      "e2sec",
      "es5ecr",
      "es5enc",
      "e4sert.",
      "e4serts",
      "e4serva",
      "4esh",
      "e3sha",
      "esh5en",
      "e1si",
      "e2sic",
      "e2sid",
      "es5iden",
      "es5igna",
      "e2s5im",
      "es4i4n",
      "esis4te",
      "esi4u",
      "e5skin",
      "es4mi",
      "e2sol",
      "es3olu",
      "e2son",
      "es5ona",
      "e1sp",
      "es3per",
      "es5pira",
      "es4pre",
      "2ess",
      "es4si4b",
      "estan4",
      "es3tig",
      "es5tim",
      "4es2to",
      "e3ston",
      "2estr",
      "e5stro",
      "estruc5",
      "e2sur",
      "es5urr",
      "es4w",
      "eta4b",
      "eten4d",
      "e3teo",
      "ethod3",
      "et1ic",
      "e5tide",
      "etin4",
      "eti4no",
      "e5tir",
      "e5titio",
      "et5itiv",
      "4etn",
      "et5ona",
      "e3tra",
      "e3tre",
      "et3ric",
      "et5rif",
      "et3rog",
      "et5ros",
      "et3ua",
      "et5ym",
      "et5z",
      "4eu",
      "e5un",
      "e3up",
      "eu3ro",
      "eus4",
      "eute4",
      "euti5l",
      "eu5tr",
      "eva2p5",
      "e2vas",
      "ev5ast",
      "e5vea",
      "ev3ell",
      "evel3o",
      "e5veng",
      "even4i",
      "ev1er",
      "e5verb",
      "e1vi",
      "ev3id",
      "evi4l",
      "e4vin",
      "evi4v",
      "e5voc",
      "e5vu",
      "e1wa",
      "e4wag",
      "e5wee",
      "e3wh",
      "ewil5",
      "ew3ing",
      "e3wit",
      "1exp",
      "5eyc",
      "5eye.",
      "eys4",
      "1fa",
      "fa3bl",
      "fab3r",
      "fa4ce",
      "4fag",
      "fain4",
      "fall5e",
      "4fa4ma",
      "fam5is",
      "5far",
      "far5th",
      "fa3ta",
      "fa3the",
      "4fato",
      "fault5",
      "4f5b",
      "4fd",
      "4fe.",
      "feas4",
      "feath3",
      "fe4b",
      "4feca",
      "5fect",
      "2fed",
      "fe3li",
      "fe4mo",
      "fen2d",
      "fend5e",
      "fer1",
      "5ferr",
      "fev4",
      "4f1f",
      "f4fes",
      "f4fie",
      "f5fin.",
      "f2f5is",
      "f4fly",
      "f2fy",
      "4fh",
      "1fi",
      "fi3a",
      "2f3ic.",
      "4f3ical",
      "f3ican",
      "4ficate",
      "f3icen",
      "fi3cer",
      "fic4i",
      "5ficia",
      "5ficie",
      "4fics",
      "fi3cu",
      "fi5del",
      "fight5",
      "fil5i",
      "fill5in",
      "4fily",
      "2fin",
      "5fina",
      "fin2d5",
      "fi2ne",
      "f1in3g",
      "fin4n",
      "fis4ti",
      "f4l2",
      "f5less",
      "flin4",
      "flo3re",
      "f2ly5",
      "4fm",
      "4fn",
      "1fo",
      "5fon",
      "fon4de",
      "fon4t",
      "fo2r",
      "fo5rat",
      "for5ay",
      "fore5t",
      "for4i",
      "fort5a",
      "fos5",
      "4f5p",
      "fra4t",
      "f5rea",
      "fres5c",
      "fri2",
      "fril4",
      "frol5",
      "2f3s",
      "2ft",
      "f4to",
      "f2ty",
      "3fu",
      "fu5el",
      "4fug",
      "fu4min",
      "fu5ne",
      "fu3ri",
      "fusi4",
      "fus4s",
      "4futa",
      "1fy",
      "1ga",
      "gaf4",
      "5gal.",
      "3gali",
      "ga3lo",
      "2gam",
      "ga5met",
      "g5amo",
      "gan5is",
      "ga3niz",
      "gani5za",
      "4gano",
      "gar5n4",
      "gass4",
      "gath3",
      "4gativ",
      "4gaz",
      "g3b",
      "gd4",
      "2ge.",
      "2ged",
      "geez4",
      "gel4in",
      "ge5lis",
      "ge5liz",
      "4gely",
      "1gen",
      "ge4nat",
      "ge5niz",
      "4geno",
      "4geny",
      "1geo",
      "ge3om",
      "g4ery",
      "5gesi",
      "geth5",
      "4geto",
      "ge4ty",
      "ge4v",
      "4g1g2",
      "g2ge",
      "g3ger",
      "gglu5",
      "ggo4",
      "gh3in",
      "gh5out",
      "gh4to",
      "5gi.",
      "1gi4a",
      "gia5r",
      "g1ic",
      "5gicia",
      "g4ico",
      "gien5",
      "5gies.",
      "gil4",
      "g3imen",
      "3g4in.",
      "gin5ge",
      "5g4ins",
      "5gio",
      "3gir",
      "gir4l",
      "g3isl",
      "gi4u",
      "5giv",
      "3giz",
      "gl2",
      "gla4",
      "glad5i",
      "5glas",
      "1gle",
      "gli4b",
      "g3lig",
      "3glo",
      "glo3r",
      "g1m",
      "g4my",
      "gn4a",
      "g4na.",
      "gnet4t",
      "g1ni",
      "g2nin",
      "g4nio",
      "g1no",
      "g4non",
      "1go",
      "3go.",
      "gob5",
      "5goe",
      "3g4o4g",
      "go3is",
      "gon2",
      "4g3o3na",
      "gondo5",
      "go3ni",
      "5goo",
      "go5riz",
      "gor5ou",
      "5gos.",
      "gov1",
      "g3p",
      "1gr",
      "4grada",
      "g4rai",
      "gran2",
      "5graph.",
      "g5rapher",
      "5graphic",
      "4graphy",
      "4gray",
      "gre4n",
      "4gress.",
      "4grit",
      "g4ro",
      "gruf4",
      "gs2",
      "g5ste",
      "gth3",
      "gu4a",
      "3guard",
      "2gue",
      "5gui5t",
      "3gun",
      "3gus",
      "4gu4t",
      "g3w",
      "1gy",
      "2g5y3n",
      "gy5ra",
      "h3ab4l",
      "hach4",
      "hae4m",
      "hae4t",
      "h5agu",
      "ha3la",
      "hala3m",
      "ha4m",
      "han4ci",
      "han4cy",
      "5hand.",
      "han4g",
      "hang5er",
      "hang5o",
      "h5a5niz",
      "han4k",
      "han4te",
      "hap3l",
      "hap5t",
      "ha3ran",
      "ha5ras",
      "har2d",
      "hard3e",
      "har4le",
      "harp5en",
      "har5ter",
      "has5s",
      "haun4",
      "5haz",
      "haz3a",
      "h1b",
      "1head",
      "3hear",
      "he4can",
      "h5ecat",
      "h4ed",
      "he5do5",
      "he3l4i",
      "hel4lis",
      "hel4ly",
      "h5elo",
      "hem4p",
      "he2n",
      "hena4",
      "hen5at",
      "heo5r",
      "hep5",
      "h4era",
      "hera3p",
      "her4ba",
      "here5a",
      "h3ern",
      "h5erou",
      "h3ery",
      "h1es",
      "he2s5p",
      "he4t",
      "het4ed",
      "heu4",
      "h1f",
      "h1h",
      "hi5an",
      "hi4co",
      "high5",
      "h4il2",
      "himer4",
      "h4ina",
      "hion4e",
      "hi4p",
      "hir4l",
      "hi3ro",
      "hir4p",
      "hir4r",
      "his3el",
      "his4s",
      "hith5er",
      "hi2v",
      "4hk",
      "4h1l4",
      "hlan4",
      "h2lo",
      "hlo3ri",
      "4h1m",
      "hmet4",
      "2h1n",
      "h5odiz",
      "h5ods",
      "ho4g",
      "hoge4",
      "hol5ar",
      "3hol4e",
      "ho4ma",
      "home3",
      "hon4a",
      "ho5ny",
      "3hood",
      "hoon4",
      "hor5at",
      "ho5ris",
      "hort3e",
      "ho5ru",
      "hos4e",
      "ho5sen",
      "hos1p",
      "1hous",
      "house3",
      "hov5el",
      "4h5p",
      "4hr4",
      "hree5",
      "hro5niz",
      "hro3po",
      "4h1s2",
      "h4sh",
      "h4tar",
      "ht1en",
      "ht5es",
      "h4ty",
      "hu4g",
      "hu4min",
      "hun5ke",
      "hun4t",
      "hus3t4",
      "hu4t",
      "h1w",
      "h4wart",
      "hy3pe",
      "hy3ph",
      "hy2s",
      "2i1a",
      "i2al",
      "iam4",
      "iam5ete",
      "i2an",
      "4ianc",
      "ian3i",
      "4ian4t",
      "ia5pe",
      "iass4",
      "i4ativ",
      "ia4tric",
      "i4atu",
      "ibe4",
      "ib3era",
      "ib5ert",
      "ib5ia",
      "ib3in",
      "ib5it.",
      "ib5ite",
      "i1bl",
      "ib3li",
      "i5bo",
      "i1br",
      "i2b5ri",
      "i5bun",
      "4icam",
      "5icap",
      "4icar",
      "i4car.",
      "i4cara",
      "icas5",
      "i4cay",
      "iccu4",
      "4iceo",
      "4ich",
      "2ici",
      "i5cid",
      "ic5ina",
      "i2cip",
      "ic3ipa",
      "i4cly",
      "i2c5oc",
      "4i1cr",
      "5icra",
      "i4cry",
      "ic4te",
      "ictu2",
      "ic4t3ua",
      "ic3ula",
      "ic4um",
      "ic5uo",
      "i3cur",
      "2id",
      "i4dai",
      "id5anc",
      "id5d",
      "ide3al",
      "ide4s",
      "i2di",
      "id5ian",
      "idi4ar",
      "i5die",
      "id3io",
      "idi5ou",
      "id1it",
      "id5iu",
      "i3dle",
      "i4dom",
      "id3ow",
      "i4dr",
      "i2du",
      "id5uo",
      "2ie4",
      "ied4e",
      "5ie5ga",
      "ield3",
      "ien5a4",
      "ien4e",
      "i5enn",
      "i3enti",
      "i1er.",
      "i3esc",
      "i1est",
      "i3et",
      "4if.",
      "if5ero",
      "iff5en",
      "if4fr",
      "4ific.",
      "i3fie",
      "i3fl",
      "4ift",
      "2ig",
      "iga5b",
      "ig3era",
      "ight3i",
      "4igi",
      "i3gib",
      "ig3il",
      "ig3in",
      "ig3it",
      "i4g4l",
      "i2go",
      "ig3or",
      "ig5ot",
      "i5gre",
      "igu5i",
      "ig1ur",
      "i3h",
      "4i5i4",
      "i3j",
      "4ik",
      "i1la",
      "il3a4b",
      "i4lade",
      "i2l5am",
      "ila5ra",
      "i3leg",
      "il1er",
      "ilev4",
      "il5f",
      "il1i",
      "il3ia",
      "il2ib",
      "il3io",
      "il4ist",
      "2ilit",
      "il2iz",
      "ill5ab",
      "4iln",
      "il3oq",
      "il4ty",
      "il5ur",
      "il3v",
      "i4mag",
      "im3age",
      "ima5ry",
      "imenta5r",
      "4imet",
      "im1i",
      "im5ida",
      "imi5le",
      "i5mini",
      "4imit",
      "im4ni",
      "i3mon",
      "i2mu",
      "im3ula",
      "2in.",
      "i4n3au",
      "4inav",
      "incel4",
      "in3cer",
      "4ind",
      "in5dling",
      "2ine",
      "i3nee",
      "iner4ar",
      "i5ness",
      "4inga",
      "4inge",
      "in5gen",
      "4ingi",
      "in5gling",
      "4ingo",
      "4ingu",
      "2ini",
      "i5ni.",
      "i4nia",
      "in3io",
      "in1is",
      "i5nite.",
      "5initio",
      "in3ity",
      "4ink",
      "4inl",
      "2inn",
      "2i1no",
      "i4no4c",
      "ino4s",
      "i4not",
      "2ins",
      "in3se",
      "insur5a",
      "2int.",
      "2in4th",
      "in1u",
      "i5nus",
      "4iny",
      "2io",
      "4io.",
      "ioge4",
      "io2gr",
      "i1ol",
      "io4m",
      "ion3at",
      "ion4ery",
      "ion3i",
      "io5ph",
      "ior3i",
      "i4os",
      "io5th",
      "i5oti",
      "io4to",
      "i4our",
      "2ip",
      "ipe4",
      "iphras4",
      "ip3i",
      "ip4ic",
      "ip4re4",
      "ip3ul",
      "i3qua",
      "iq5uef",
      "iq3uid",
      "iq3ui3t",
      "4ir",
      "i1ra",
      "ira4b",
      "i4rac",
      "ird5e",
      "ire4de",
      "i4ref",
      "i4rel4",
      "i4res",
      "ir5gi",
      "ir1i",
      "iri5de",
      "ir4is",
      "iri3tu",
      "5i5r2iz",
      "ir4min",
      "iro4g",
      "5iron.",
      "ir5ul",
      "2is.",
      "is5ag",
      "is3ar",
      "isas5",
      "2is1c",
      "is3ch",
      "4ise",
      "is3er",
      "3isf",
      "is5han",
      "is3hon",
      "ish5op",
      "is3ib",
      "isi4d",
      "i5sis",
      "is5itiv",
      "4is4k",
      "islan4",
      "4isms",
      "i2so",
      "iso5mer",
      "is1p",
      "is2pi",
      "is4py",
      "4is1s",
      "is4sal",
      "issen4",
      "is4ses",
      "is4ta.",
      "is1te",
      "is1ti",
      "ist4ly",
      "4istral",
      "i2su",
      "is5us",
      "4ita.",
      "ita4bi",
      "i4tag",
      "4ita5m",
      "i3tan",
      "i3tat",
      "2ite",
      "it3era",
      "i5teri",
      "it4es",
      "2ith",
      "i1ti",
      "4itia",
      "4i2tic",
      "it3ica",
      "5i5tick",
      "it3ig",
      "it5ill",
      "i2tim",
      "2itio",
      "4itis",
      "i4tism",
      "i2t5o5m",
      "4iton",
      "i4tram",
      "it5ry",
      "4itt",
      "it3uat",
      "i5tud",
      "it3ul",
      "4itz.",
      "i1u",
      "2iv",
      "iv3ell",
      "iv3en.",
      "i4v3er.",
      "i4vers.",
      "iv5il.",
      "iv5io",
      "iv1it",
      "i5vore",
      "iv3o3ro",
      "i4v3ot",
      "4i5w",
      "ix4o",
      "4iy",
      "4izar",
      "izi4",
      "5izont",
      "5ja",
      "jac4q",
      "ja4p",
      "1je",
      "jer5s",
      "4jestie",
      "4jesty",
      "jew3",
      "jo4p",
      "5judg",
      "3ka.",
      "k3ab",
      "k5ag",
      "kais4",
      "kal4",
      "k1b",
      "k2ed",
      "1kee",
      "ke4g",
      "ke5li",
      "k3en4d",
      "k1er",
      "kes4",
      "k3est.",
      "ke4ty",
      "k3f",
      "kh4",
      "k1i",
      "5ki.",
      "5k2ic",
      "k4ill",
      "kilo5",
      "k4im",
      "k4in.",
      "kin4de",
      "k5iness",
      "kin4g",
      "ki4p",
      "kis4",
      "k5ish",
      "kk4",
      "k1l",
      "4kley",
      "4kly",
      "k1m",
      "k5nes",
      "1k2no",
      "ko5r",
      "kosh4",
      "k3ou",
      "kro5n",
      "4k1s2",
      "k4sc",
      "ks4l",
      "k4sy",
      "k5t",
      "k1w",
      "lab3ic",
      "l4abo",
      "laci4",
      "l4ade",
      "la3dy",
      "lag4n",
      "lam3o",
      "3land",
      "lan4dl",
      "lan5et",
      "lan4te",
      "lar4g",
      "lar3i",
      "las4e",
      "la5tan",
      "4lateli",
      "4lativ",
      "4lav",
      "la4v4a",
      "2l1b",
      "lbin4",
      "4l1c2",
      "lce4",
      "l3ci",
      "2ld",
      "l2de",
      "ld4ere",
      "ld4eri",
      "ldi4",
      "ld5is",
      "l3dr",
      "l4dri",
      "le2a",
      "le4bi",
      "left5",
      "5leg.",
      "5legg",
      "le4mat",
      "lem5atic",
      "4len.",
      "3lenc",
      "5lene.",
      "1lent",
      "le3ph",
      "le4pr",
      "lera5b",
      "ler4e",
      "3lerg",
      "3l4eri",
      "l4ero",
      "les2",
      "le5sco",
      "5lesq",
      "3less",
      "5less.",
      "l3eva",
      "lev4er.",
      "lev4era",
      "lev4ers",
      "3ley",
      "4leye",
      "2lf",
      "l5fr",
      "4l1g4",
      "l5ga",
      "lgar3",
      "l4ges",
      "lgo3",
      "2l3h",
      "li4ag",
      "li2am",
      "liar5iz",
      "li4as",
      "li4ato",
      "li5bi",
      "5licio",
      "li4cor",
      "4lics",
      "4lict.",
      "l4icu",
      "l3icy",
      "l3ida",
      "lid5er",
      "3lidi",
      "lif3er",
      "l4iff",
      "li4fl",
      "5ligate",
      "3ligh",
      "li4gra",
      "3lik",
      "4l4i4l",
      "lim4bl",
      "lim3i",
      "li4mo",
      "l4im4p",
      "l4ina",
      "1l4ine",
      "lin3ea",
      "lin3i",
      "link5er",
      "li5og",
      "4l4iq",
      "lis4p",
      "l1it",
      "l2it.",
      "5litica",
      "l5i5tics",
      "liv3er",
      "l1iz",
      "4lj",
      "lka3",
      "l3kal",
      "lka4t",
      "l1l",
      "l4law",
      "l2le",
      "l5lea",
      "l3lec",
      "l3leg",
      "l3lel",
      "l3le4n",
      "l3le4t",
      "ll2i",
      "l2lin4",
      "l5lina",
      "ll4o",
      "lloqui5",
      "ll5out",
      "l5low",
      "2lm",
      "l5met",
      "lm3ing",
      "l4mod",
      "lmon4",
      "2l1n2",
      "3lo.",
      "lob5al",
      "lo4ci",
      "4lof",
      "3logic",
      "l5ogo",
      "3logu",
      "lom3er",
      "5long",
      "lon4i",
      "l3o3niz",
      "lood5",
      "5lope.",
      "lop3i",
      "l3opm",
      "lora4",
      "lo4rato",
      "lo5rie",
      "lor5ou",
      "5los.",
      "los5et",
      "5losophiz",
      "5losophy",
      "los4t",
      "lo4ta",
      "loun5d",
      "2lout",
      "4lov",
      "2lp",
      "lpa5b",
      "l3pha",
      "l5phi",
      "lp5ing",
      "l3pit",
      "l4pl",
      "l5pr",
      "4l1r",
      "2l1s2",
      "l4sc",
      "l2se",
      "l4sie",
      "4lt",
      "lt5ag",
      "ltane5",
      "l1te",
      "lten4",
      "ltera4",
      "lth3i",
      "l5ties.",
      "ltis4",
      "l1tr",
      "ltu2",
      "ltur3a",
      "lu5a",
      "lu3br",
      "luch4",
      "lu3ci",
      "lu3en",
      "luf4",
      "lu5id",
      "lu4ma",
      "5lumi",
      "l5umn.",
      "5lumnia",
      "lu3o",
      "luo3r",
      "4lup",
      "luss4",
      "lus3te",
      "1lut",
      "l5ven",
      "l5vet4",
      "2l1w",
      "1ly",
      "4lya",
      "4lyb",
      "ly5me",
      "ly3no",
      "2lys4",
      "l5yse",
      "1ma",
      "2mab",
      "ma2ca",
      "ma5chine",
      "ma4cl",
      "mag5in",
      "5magn",
      "2mah",
      "maid5",
      "4mald",
      "ma3lig",
      "ma5lin",
      "mal4li",
      "mal4ty",
      "5mania",
      "man5is",
      "man3iz",
      "4map",
      "ma5rine.",
      "ma5riz",
      "mar4ly",
      "mar3v",
      "ma5sce",
      "mas4e",
      "mas1t",
      "5mate",
      "math3",
      "ma3tis",
      "4matiza",
      "4m1b",
      "mba4t5",
      "m5bil",
      "m4b3ing",
      "mbi4v",
      "4m5c",
      "4me.",
      "2med",
      "4med.",
      "5media",
      "me3die",
      "m5e5dy",
      "me2g",
      "mel5on",
      "mel4t",
      "me2m",
      "mem1o3",
      "1men",
      "men4a",
      "men5ac",
      "men4de",
      "4mene",
      "men4i",
      "mens4",
      "mensu5",
      "3ment",
      "men4te",
      "me5on",
      "m5ersa",
      "2mes",
      "3mesti",
      "me4ta",
      "met3al",
      "me1te",
      "me5thi",
      "m4etr",
      "5metric",
      "me5trie",
      "me3try",
      "me4v",
      "4m1f",
      "2mh",
      "5mi.",
      "mi3a",
      "mid4a",
      "mid4g",
      "mig4",
      "3milia",
      "m5i5lie",
      "m4ill",
      "min4a",
      "3mind",
      "m5inee",
      "m4ingl",
      "min5gli",
      "m5ingly",
      "min4t",
      "m4inu",
      "miot4",
      "m2is",
      "mis4er.",
      "mis5l",
      "mis4ti",
      "m5istry",
      "4mith",
      "m2iz",
      "4mk",
      "4m1l",
      "m1m",
      "mma5ry",
      "4m1n",
      "mn4a",
      "m4nin",
      "mn4o",
      "1mo",
      "4mocr",
      "5mocratiz",
      "mo2d1",
      "mo4go",
      "mois2",
      "moi5se",
      "4mok",
      "mo5lest",
      "mo3me",
      "mon5et",
      "mon5ge",
      "moni3a",
      "mon4ism",
      "mon4ist",
      "mo3niz",
      "monol4",
      "mo3ny.",
      "mo2r",
      "4mora.",
      "mos2",
      "mo5sey",
      "mo3sp",
      "moth3",
      "m5ouf",
      "3mous",
      "mo2v",
      "4m1p",
      "mpara5",
      "mpa5rab",
      "mpar5i",
      "m3pet",
      "mphas4",
      "m2pi",
      "mpi4a",
      "mp5ies",
      "m4p1in",
      "m5pir",
      "mp5is",
      "mpo3ri",
      "mpos5ite",
      "m4pous",
      "mpov5",
      "mp4tr",
      "m2py",
      "4m3r",
      "4m1s2",
      "m4sh",
      "m5si",
      "4mt",
      "1mu",
      "mula5r4",
      "5mult",
      "multi3",
      "3mum",
      "mun2",
      "4mup",
      "mu4u",
      "4mw",
      "1na",
      "2n1a2b",
      "n4abu",
      "4nac.",
      "na4ca",
      "n5act",
      "nag5er.",
      "nak4",
      "na4li",
      "na5lia",
      "4nalt",
      "na5mit",
      "n2an",
      "nanci4",
      "nan4it",
      "nank4",
      "nar3c",
      "4nare",
      "nar3i",
      "nar4l",
      "n5arm",
      "n4as",
      "nas4c",
      "nas5ti",
      "n2at",
      "na3tal",
      "nato5miz",
      "n2au",
      "nau3se",
      "3naut",
      "nav4e",
      "4n1b4",
      "ncar5",
      "n4ces.",
      "n3cha",
      "n5cheo",
      "n5chil",
      "n3chis",
      "nc1in",
      "nc4it",
      "ncour5a",
      "n1cr",
      "n1cu",
      "n4dai",
      "n5dan",
      "n1de",
      "nd5est.",
      "ndi4b",
      "n5d2if",
      "n1dit",
      "n3diz",
      "n5duc",
      "ndu4r",
      "nd2we",
      "2ne.",
      "n3ear",
      "ne2b",
      "neb3u",
      "ne2c",
      "5neck",
      "2ned",
      "ne4gat",
      "neg5ativ",
      "5nege",
      "ne4la",
      "nel5iz",
      "ne5mi",
      "ne4mo",
      "1nen",
      "4nene",
      "3neo",
      "ne4po",
      "ne2q",
      "n1er",
      "nera5b",
      "n4erar",
      "n2ere",
      "n4er5i",
      "ner4r",
      "1nes",
      "2nes.",
      "4nesp",
      "2nest",
      "4nesw",
      "3netic",
      "ne4v",
      "n5eve",
      "ne4w",
      "n3f",
      "n4gab",
      "n3gel",
      "nge4n4e",
      "n5gere",
      "n3geri",
      "ng5ha",
      "n3gib",
      "ng1in",
      "n5git",
      "n4gla",
      "ngov4",
      "ng5sh",
      "n1gu",
      "n4gum",
      "n2gy",
      "4n1h4",
      "nha4",
      "nhab3",
      "nhe4",
      "3n4ia",
      "ni3an",
      "ni4ap",
      "ni3ba",
      "ni4bl",
      "ni4d",
      "ni5di",
      "ni4er",
      "ni2fi",
      "ni5ficat",
      "n5igr",
      "nik4",
      "n1im",
      "ni3miz",
      "n1in",
      "5nine.",
      "nin4g",
      "ni4o",
      "5nis.",
      "nis4ta",
      "n2it",
      "n4ith",
      "3nitio",
      "n3itor",
      "ni3tr",
      "n1j",
      "4nk2",
      "n5kero",
      "n3ket",
      "nk3in",
      "n1kl",
      "4n1l",
      "n5m",
      "nme4",
      "nmet4",
      "4n1n2",
      "nne4",
      "nni3al",
      "nni4v",
      "nob4l",
      "no3ble",
      "n5ocl",
      "4n3o2d",
      "3noe",
      "4nog",
      "noge4",
      "nois5i",
      "no5l4i",
      "5nologis",
      "3nomic",
      "n5o5miz",
      "no4mo",
      "no3my",
      "no4n",
      "non4ag",
      "non5i",
      "n5oniz",
      "4nop",
      "5nop5o5li",
      "nor5ab",
      "no4rary",
      "4nosc",
      "nos4e",
      "nos5t",
      "no5ta",
      "1nou",
      "3noun",
      "nov3el3",
      "nowl3",
      "n1p4",
      "npi4",
      "npre4c",
      "n1q",
      "n1r",
      "nru4",
      "2n1s2",
      "ns5ab",
      "nsati4",
      "ns4c",
      "n2se",
      "n4s3es",
      "nsid1",
      "nsig4",
      "n2sl",
      "ns3m",
      "n4soc",
      "ns4pe",
      "n5spi",
      "nsta5bl",
      "n1t",
      "nta4b",
      "nter3s",
      "nt2i",
      "n5tib",
      "nti4er",
      "nti2f",
      "n3tine",
      "n4t3ing",
      "nti4p",
      "ntrol5li",
      "nt4s",
      "ntu3me",
      "nu1a",
      "nu4d",
      "nu5en",
      "nuf4fe",
      "n3uin",
      "3nu3it",
      "n4um",
      "nu1me",
      "n5umi",
      "3nu4n",
      "n3uo",
      "nu3tr",
      "n1v2",
      "n1w4",
      "nym4",
      "nyp4",
      "4nz",
      "n3za",
      "4oa",
      "oad3",
      "o5a5les",
      "oard3",
      "oas4e",
      "oast5e",
      "oat5i",
      "ob3a3b",
      "o5bar",
      "obe4l",
      "o1bi",
      "o2bin",
      "ob5ing",
      "o3br",
      "ob3ul",
      "o1ce",
      "och4",
      "o3chet",
      "ocif3",
      "o4cil",
      "o4clam",
      "o4cod",
      "oc3rac",
      "oc5ratiz",
      "ocre3",
      "5ocrit",
      "octor5a",
      "oc3ula",
      "o5cure",
      "od5ded",
      "od3ic",
      "odi3o",
      "o2do4",
      "odor3",
      "od5uct.",
      "od5ucts",
      "o4el",
      "o5eng",
      "o3er",
      "oe4ta",
      "o3ev",
      "o2fi",
      "of5ite",
      "ofit4t",
      "o2g5a5r",
      "og5ativ",
      "o4gato",
      "o1ge",
      "o5gene",
      "o5geo",
      "o4ger",
      "o3gie",
      "1o1gis",
      "og3it",
      "o4gl",
      "o5g2ly",
      "3ogniz",
      "o4gro",
      "ogu5i",
      "1ogy",
      "2ogyn",
      "o1h2",
      "ohab5",
      "oi2",
      "oic3es",
      "oi3der",
      "oiff4",
      "oig4",
      "oi5let",
      "o3ing",
      "oint5er",
      "o5ism",
      "oi5son",
      "oist5en",
      "oi3ter",
      "o5j",
      "2ok",
      "o3ken",
      "ok5ie",
      "o1la",
      "o4lan",
      "olass4",
      "ol2d",
      "old1e",
      "ol3er",
      "o3lesc",
      "o3let",
      "ol4fi",
      "ol2i",
      "o3lia",
      "o3lice",
      "ol5id.",
      "o3li4f",
      "o5lil",
      "ol3ing",
      "o5lio",
      "o5lis.",
      "ol3ish",
      "o5lite",
      "o5litio",
      "o5liv",
      "olli4e",
      "ol5ogiz",
      "olo4r",
      "ol5pl",
      "ol2t",
      "ol3ub",
      "ol3ume",
      "ol3un",
      "o5lus",
      "ol2v",
      "o2ly",
      "om5ah",
      "oma5l",
      "om5atiz",
      "om2be",
      "om4bl",
      "o2me",
      "om3ena",
      "om5erse",
      "o4met",
      "om5etry",
      "o3mia",
      "om3ic.",
      "om3ica",
      "o5mid",
      "om1in",
      "o5mini",
      "5ommend",
      "omo4ge",
      "o4mon",
      "om3pi",
      "ompro5",
      "o2n",
      "on1a",
      "on4ac",
      "o3nan",
      "on1c",
      "3oncil",
      "2ond",
      "on5do",
      "o3nen",
      "on5est",
      "on4gu",
      "on1ic",
      "o3nio",
      "on1is",
      "o5niu",
      "on3key",
      "on4odi",
      "on3omy",
      "on3s",
      "onspi4",
      "onspir5a",
      "onsu4",
      "onten4",
      "on3t4i",
      "ontif5",
      "on5um",
      "onva5",
      "oo2",
      "ood5e",
      "ood5i",
      "oo4k",
      "oop3i",
      "o3ord",
      "oost5",
      "o2pa",
      "ope5d",
      "op1er",
      "3opera",
      "4operag",
      "2oph",
      "o5phan",
      "o5pher",
      "op3ing",
      "o3pit",
      "o5pon",
      "o4posi",
      "o1pr",
      "op1u",
      "opy5",
      "o1q",
      "o1ra",
      "o5ra.",
      "o4r3ag",
      "or5aliz",
      "or5ange",
      "ore5a",
      "o5real",
      "or3ei",
      "ore5sh",
      "or5est.",
      "orew4",
      "or4gu",
      "4o5ria",
      "or3ica",
      "o5ril",
      "or1in",
      "o1rio",
      "or3ity",
      "o3riu",
      "or2mi",
      "orn2e",
      "o5rof",
      "or3oug",
      "or5pe",
      "3orrh",
      "or4se",
      "ors5en",
      "orst4",
      "or3thi",
      "or3thy",
      "or4ty",
      "o5rum",
      "o1ry",
      "os3al",
      "os2c",
      "os4ce",
      "o3scop",
      "4oscopi",
      "o5scr",
      "os4i4e",
      "os5itiv",
      "os3ito",
      "os3ity",
      "osi4u",
      "os4l",
      "o2so",
      "os4pa",
      "os4po",
      "os2ta",
      "o5stati",
      "os5til",
      "os5tit",
      "o4tan",
      "otele4g",
      "ot3er.",
      "ot5ers",
      "o4tes",
      "4oth",
      "oth5esi",
      "oth3i4",
      "ot3ic.",
      "ot5ica",
      "o3tice",
      "o3tif",
      "o3tis",
      "oto5s",
      "ou2",
      "ou3bl",
      "ouch5i",
      "ou5et",
      "ou4l",
      "ounc5er",
      "oun2d",
      "ou5v",
      "ov4en",
      "over4ne",
      "over3s",
      "ov4ert",
      "o3vis",
      "oviti4",
      "o5v4ol",
      "ow3der",
      "ow3el",
      "ow5est",
      "ow1i",
      "own5i",
      "o4wo",
      "oy1a",
      "1pa",
      "pa4ca",
      "pa4ce",
      "pac4t",
      "p4ad",
      "5pagan",
      "p3agat",
      "p4ai",
      "pain4",
      "p4al",
      "pan4a",
      "pan3el",
      "pan4ty",
      "pa3ny",
      "pa1p",
      "pa4pu",
      "para5bl",
      "par5age",
      "par5di",
      "3pare",
      "par5el",
      "p4a4ri",
      "par4is",
      "pa2te",
      "pa5ter",
      "5pathic",
      "pa5thy",
      "pa4tric",
      "pav4",
      "3pay",
      "4p1b",
      "pd4",
      "4pe.",
      "3pe4a",
      "pear4l",
      "pe2c",
      "2p2ed",
      "3pede",
      "3pedi",
      "pedia4",
      "ped4ic",
      "p4ee",
      "pee4d",
      "pek4",
      "pe4la",
      "peli4e",
      "pe4nan",
      "p4enc",
      "pen4th",
      "pe5on",
      "p4era.",
      "pera5bl",
      "p4erag",
      "p4eri",
      "peri5st",
      "per4mal",
      "perme5",
      "p4ern",
      "per3o",
      "per3ti",
      "pe5ru",
      "per1v",
      "pe2t",
      "pe5ten",
      "pe5tiz",
      "4pf",
      "4pg",
      "4ph.",
      "phar5i",
      "phe3no",
      "ph4er",
      "ph4es.",
      "ph1ic",
      "5phie",
      "ph5ing",
      "5phisti",
      "3phiz",
      "ph2l",
      "3phob",
      "3phone",
      "5phoni",
      "pho4r",
      "4phs",
      "ph3t",
      "5phu",
      "1phy",
      "pi3a",
      "pian4",
      "pi4cie",
      "pi4cy",
      "p4id",
      "p5ida",
      "pi3de",
      "5pidi",
      "3piec",
      "pi3en",
      "pi4grap",
      "pi3lo",
      "pi2n",
      "p4in.",
      "pind4",
      "p4ino",
      "3pi1o",
      "pion4",
      "p3ith",
      "pi5tha",
      "pi2tu",
      "2p3k2",
      "1p2l2",
      "3plan",
      "plas5t",
      "pli3a",
      "pli5er",
      "4plig",
      "pli4n",
      "ploi4",
      "plu4m",
      "plum4b",
      "4p1m",
      "2p3n",
      "po4c",
      "5pod.",
      "po5em",
      "po3et5",
      "5po4g",
      "poin2",
      "5point",
      "poly5t",
      "po4ni",
      "po4p",
      "1p4or",
      "po4ry",
      "1pos",
      "pos1s",
      "p4ot",
      "po4ta",
      "5poun",
      "4p1p",
      "ppa5ra",
      "p2pe",
      "p4ped",
      "p5pel",
      "p3pen",
      "p3per",
      "p3pet",
      "ppo5site",
      "pr2",
      "pray4e",
      "5preci",
      "pre5co",
      "pre3em",
      "pref5ac",
      "pre4la",
      "pre3r",
      "p3rese",
      "3press",
      "pre5ten",
      "pre3v",
      "5pri4e",
      "prin4t3",
      "pri4s",
      "pris3o",
      "p3roca",
      "prof5it",
      "pro3l",
      "pros3e",
      "pro1t",
      "2p1s2",
      "p2se",
      "ps4h",
      "p4sib",
      "2p1t",
      "pt5a4b",
      "p2te",
      "p2th",
      "pti3m",
      "ptu4r",
      "p4tw",
      "pub3",
      "pue4",
      "puf4",
      "pul3c",
      "pu4m",
      "pu2n",
      "pur4r",
      "5pus",
      "pu2t",
      "5pute",
      "put3er",
      "pu3tr",
      "put4ted",
      "put4tin",
      "p3w",
      "qu2",
      "qua5v",
      "2que.",
      "3quer",
      "3quet",
      "2rab",
      "ra3bi",
      "rach4e",
      "r5acl",
      "raf5fi",
      "raf4t",
      "r2ai",
      "ra4lo",
      "ram3et",
      "r2ami",
      "rane5o",
      "ran4ge",
      "r4ani",
      "ra5no",
      "rap3er",
      "3raphy",
      "rar5c",
      "rare4",
      "rar5ef",
      "4raril",
      "r2as",
      "ration4",
      "rau4t",
      "ra5vai",
      "rav3el",
      "ra5zie",
      "r1b",
      "r4bab",
      "r4bag",
      "rbi2",
      "rbi4f",
      "r2bin",
      "r5bine",
      "rb5ing.",
      "rb4o",
      "r1c",
      "r2ce",
      "rcen4",
      "r3cha",
      "rch4er",
      "r4ci4b",
      "rc4it",
      "rcum3",
      "r4dal",
      "rd2i",
      "rdi4a",
      "rdi4er",
      "rdin4",
      "rd3ing",
      "2re.",
      "re1al",
      "re3an",
      "re5arr",
      "5reav",
      "re4aw",
      "r5ebrat",
      "rec5oll",
      "rec5ompe",
      "re4cre",
      "2r2ed",
      "re1de",
      "re3dis",
      "red5it",
      "re4fac",
      "re2fe",
      "re5fer.",
      "re3fi",
      "re4fy",
      "reg3is",
      "re5it",
      "re1li",
      "re5lu",
      "r4en4ta",
      "ren4te",
      "re1o",
      "re5pin",
      "re4posi",
      "re1pu",
      "r1er4",
      "r4eri",
      "rero4",
      "re5ru",
      "r4es.",
      "re4spi",
      "ress5ib",
      "res2t",
      "re5stal",
      "re3str",
      "re4ter",
      "re4ti4z",
      "re3tri",
      "reu2",
      "re5uti",
      "rev2",
      "re4val",
      "rev3el",
      "r5ev5er.",
      "re5vers",
      "re5vert",
      "re5vil",
      "rev5olu",
      "re4wh",
      "r1f",
      "rfu4",
      "r4fy",
      "rg2",
      "rg3er",
      "r3get",
      "r3gic",
      "rgi4n",
      "rg3ing",
      "r5gis",
      "r5git",
      "r1gl",
      "rgo4n",
      "r3gu",
      "rh4",
      "4rh.",
      "4rhal",
      "ri3a",
      "ria4b",
      "ri4ag",
      "r4ib",
      "rib3a",
      "ric5as",
      "r4ice",
      "4rici",
      "5ricid",
      "ri4cie",
      "r4ico",
      "rid5er",
      "ri3enc",
      "ri3ent",
      "ri1er",
      "ri5et",
      "rig5an",
      "5rigi",
      "ril3iz",
      "5riman",
      "rim5i",
      "3rimo",
      "rim4pe",
      "r2ina",
      "5rina.",
      "rin4d",
      "rin4e",
      "rin4g",
      "ri1o",
      "5riph",
      "riph5e",
      "ri2pl",
      "rip5lic",
      "r4iq",
      "r2is",
      "r4is.",
      "ris4c",
      "r3ish",
      "ris4p",
      "ri3ta3b",
      "r5ited.",
      "rit5er.",
      "rit5ers",
      "rit3ic",
      "ri2tu",
      "rit5ur",
      "riv5el",
      "riv3et",
      "riv3i",
      "r3j",
      "r3ket",
      "rk4le",
      "rk4lin",
      "r1l",
      "rle4",
      "r2led",
      "r4lig",
      "r4lis",
      "rl5ish",
      "r3lo4",
      "r1m",
      "rma5c",
      "r2me",
      "r3men",
      "rm5ers",
      "rm3ing",
      "r4ming.",
      "r4mio",
      "r3mit",
      "r4my",
      "r4nar",
      "r3nel",
      "r4ner",
      "r5net",
      "r3ney",
      "r5nic",
      "r1nis4",
      "r3nit",
      "r3niv",
      "rno4",
      "r4nou",
      "r3nu",
      "rob3l",
      "r2oc",
      "ro3cr",
      "ro4e",
      "ro1fe",
      "ro5fil",
      "rok2",
      "ro5ker",
      "5role.",
      "rom5ete",
      "rom4i",
      "rom4p",
      "ron4al",
      "ron4e",
      "ro5n4is",
      "ron4ta",
      "1room",
      "5root",
      "ro3pel",
      "rop3ic",
      "ror3i",
      "ro5ro",
      "ros5per",
      "ros4s",
      "ro4the",
      "ro4ty",
      "ro4va",
      "rov5el",
      "rox5",
      "r1p",
      "r4pea",
      "r5pent",
      "rp5er.",
      "r3pet",
      "rp4h4",
      "rp3ing",
      "r3po",
      "r1r4",
      "rre4c",
      "rre4f",
      "r4reo",
      "rre4st",
      "rri4o",
      "rri4v",
      "rron4",
      "rros4",
      "rrys4",
      "4rs2",
      "r1sa",
      "rsa5ti",
      "rs4c",
      "r2se",
      "r3sec",
      "rse4cr",
      "rs5er.",
      "rs3es",
      "rse5v2",
      "r1sh",
      "r5sha",
      "r1si",
      "r4si4b",
      "rson3",
      "r1sp",
      "r5sw",
      "rtach4",
      "r4tag",
      "r3teb",
      "rten4d",
      "rte5o",
      "r1ti",
      "rt5ib",
      "rti4d",
      "r4tier",
      "r3tig",
      "rtil3i",
      "rtil4l",
      "r4tily",
      "r4tist",
      "r4tiv",
      "r3tri",
      "rtroph4",
      "rt4sh",
      "ru3a",
      "ru3e4l",
      "ru3en",
      "ru4gl",
      "ru3in",
      "rum3pl",
      "ru2n",
      "runk5",
      "run4ty",
      "r5usc",
      "ruti5n",
      "rv4e",
      "rvel4i",
      "r3ven",
      "rv5er.",
      "r5vest",
      "r3vey",
      "r3vic",
      "rvi4v",
      "r3vo",
      "r1w",
      "ry4c",
      "5rynge",
      "ry3t",
      "sa2",
      "2s1ab",
      "5sack",
      "sac3ri",
      "s3act",
      "5sai",
      "salar4",
      "sal4m",
      "sa5lo",
      "sal4t",
      "3sanc",
      "san4de",
      "s1ap",
      "sa5ta",
      "5sa3tio",
      "sat3u",
      "sau4",
      "sa5vor",
      "5saw",
      "4s5b",
      "scan4t5",
      "sca4p",
      "scav5",
      "s4ced",
      "4scei",
      "s4ces",
      "sch2",
      "s4cho",
      "3s4cie",
      "5scin4d",
      "scle5",
      "s4cli",
      "scof4",
      "4scopy",
      "scour5a",
      "s1cu",
      "4s5d",
      "4se.",
      "se4a",
      "seas4",
      "sea5w",
      "se2c3o",
      "3sect",
      "4s4ed",
      "se4d4e",
      "s5edl",
      "se2g",
      "seg3r",
      "5sei",
      "se1le",
      "5self",
      "5selv",
      "4seme",
      "se4mol",
      "sen5at",
      "4senc",
      "sen4d",
      "s5ened",
      "sen5g",
      "s5enin",
      "4sentd",
      "4sentl",
      "sep3a3",
      "4s1er.",
      "s4erl",
      "ser4o",
      "4servo",
      "s1e4s",
      "se5sh",
      "ses5t",
      "5se5um",
      "5sev",
      "sev3en",
      "sew4i",
      "5sex",
      "4s3f",
      "2s3g",
      "s2h",
      "2sh.",
      "sh1er",
      "5shev",
      "sh1in",
      "sh3io",
      "3ship",
      "shiv5",
      "sho4",
      "sh5old",
      "shon3",
      "shor4",
      "short5",
      "4shw",
      "si1b",
      "s5icc",
      "3side.",
      "5sides",
      "5sidi",
      "si5diz",
      "4signa",
      "sil4e",
      "4sily",
      "2s1in",
      "s2ina",
      "5sine.",
      "s3ing",
      "1sio",
      "5sion",
      "sion5a",
      "si2r",
      "sir5a",
      "1sis",
      "3sitio",
      "5siu",
      "1siv",
      "5siz",
      "sk2",
      "4ske",
      "s3ket",
      "sk5ine",
      "sk5ing",
      "s1l2",
      "s3lat",
      "s2le",
      "slith5",
      "2s1m",
      "s3ma",
      "small3",
      "sman3",
      "smel4",
      "s5men",
      "5smith",
      "smol5d4",
      "s1n4",
      "1so",
      "so4ce",
      "soft3",
      "so4lab",
      "sol3d2",
      "so3lic",
      "5solv",
      "3som",
      "3s4on.",
      "sona4",
      "son4g",
      "s4op",
      "5sophic",
      "s5ophiz",
      "s5ophy",
      "sor5c",
      "sor5d",
      "4sov",
      "so5vi",
      "2spa",
      "5spai",
      "spa4n",
      "spen4d",
      "2s5peo",
      "2sper",
      "s2phe",
      "3spher",
      "spho5",
      "spil4",
      "sp5ing",
      "4spio",
      "s4ply",
      "s4pon",
      "spor4",
      "4spot",
      "squal4l",
      "s1r",
      "2ss",
      "s1sa",
      "ssas3",
      "s2s5c",
      "s3sel",
      "s5seng",
      "s4ses.",
      "s5set",
      "s1si",
      "s4sie",
      "ssi4er",
      "ss5ily",
      "s4sl",
      "ss4li",
      "s4sn",
      "sspend4",
      "ss2t",
      "ssur5a",
      "ss5w",
      "2st.",
      "s2tag",
      "s2tal",
      "stam4i",
      "5stand",
      "s4ta4p",
      "5stat.",
      "s4ted",
      "stern5i",
      "s5tero",
      "ste2w",
      "stew5a",
      "s3the",
      "st2i",
      "s4ti.",
      "s5tia",
      "s1tic",
      "5stick",
      "s4tie",
      "s3tif",
      "st3ing",
      "5stir",
      "s1tle",
      "5stock",
      "stom3a",
      "5stone",
      "s4top",
      "3store",
      "st4r",
      "s4trad",
      "5stratu",
      "s4tray",
      "s4trid",
      "4stry",
      "4st3w",
      "s2ty",
      "1su",
      "su1al",
      "su4b3",
      "su2g3",
      "su5is",
      "suit3",
      "s4ul",
      "su2m",
      "sum3i",
      "su2n",
      "su2r",
      "4sv",
      "sw2",
      "4swo",
      "s4y",
      "4syc",
      "3syl",
      "syn5o",
      "sy5rin",
      "1ta",
      "3ta.",
      "2tab",
      "ta5bles",
      "5taboliz",
      "4taci",
      "ta5do",
      "4taf4",
      "tai5lo",
      "ta2l",
      "ta5la",
      "tal5en",
      "tal3i",
      "4talk",
      "tal4lis",
      "ta5log",
      "ta5mo",
      "tan4de",
      "tanta3",
      "ta5per",
      "ta5pl",
      "tar4a",
      "4tarc",
      "4tare",
      "ta3riz",
      "tas4e",
      "ta5sy",
      "4tatic",
      "ta4tur",
      "taun4",
      "tav4",
      "2taw",
      "tax4is",
      "2t1b",
      "4tc",
      "t4ch",
      "tch5et",
      "4t1d",
      "4te.",
      "tead4i",
      "4teat",
      "tece4",
      "5tect",
      "2t1ed",
      "te5di",
      "1tee",
      "teg4",
      "te5ger",
      "te5gi",
      "3tel.",
      "teli4",
      "5tels",
      "te2ma2",
      "tem3at",
      "3tenan",
      "3tenc",
      "3tend",
      "4tenes",
      "1tent",
      "ten4tag",
      "1teo",
      "te4p",
      "te5pe",
      "ter3c",
      "5ter3d",
      "1teri",
      "ter5ies",
      "ter3is",
      "teri5za",
      "5ternit",
      "ter5v",
      "4tes.",
      "4tess",
      "t3ess.",
      "teth5e",
      "3teu",
      "3tex",
      "4tey",
      "2t1f",
      "4t1g",
      "2th.",
      "than4",
      "th2e",
      "4thea",
      "th3eas",
      "the5at",
      "the3is",
      "3thet",
      "th5ic.",
      "th5ica",
      "4thil",
      "5think",
      "4thl",
      "th5ode",
      "5thodic",
      "4thoo",
      "thor5it",
      "tho5riz",
      "2ths",
      "1tia",
      "ti4ab",
      "ti4ato",
      "2ti2b",
      "4tick",
      "t4ico",
      "t4ic1u",
      "5tidi",
      "3tien",
      "tif2",
      "ti5fy",
      "2tig",
      "5tigu",
      "till5in",
      "1tim",
      "4timp",
      "tim5ul",
      "2t1in",
      "t2ina",
      "3tine.",
      "3tini",
      "1tio",
      "ti5oc",
      "tion5ee",
      "5tiq",
      "ti3sa",
      "3tise",
      "tis4m",
      "ti5so",
      "tis4p",
      "5tistica",
      "ti3tl",
      "ti4u",
      "1tiv",
      "tiv4a",
      "1tiz",
      "ti3za",
      "ti3zen",
      "2tl",
      "t5la",
      "tlan4",
      "3tle.",
      "3tled",
      "3tles.",
      "t5let.",
      "t5lo",
      "4t1m",
      "tme4",
      "2t1n2",
      "1to",
      "to3b",
      "to5crat",
      "4todo",
      "2tof",
      "to2gr",
      "to5ic",
      "to2ma",
      "tom4b",
      "to3my",
      "ton4ali",
      "to3nat",
      "4tono",
      "4tony",
      "to2ra",
      "to3rie",
      "tor5iz",
      "tos2",
      "5tour",
      "4tout",
      "to3war",
      "4t1p",
      "1tra",
      "tra3b",
      "tra5ch",
      "traci4",
      "trac4it",
      "trac4te",
      "tras4",
      "tra5ven",
      "trav5es5",
      "tre5f",
      "tre4m",
      "trem5i",
      "5tria",
      "tri5ces",
      "5tricia",
      "4trics",
      "2trim",
      "tri4v",
      "tro5mi",
      "tron5i",
      "4trony",
      "tro5phe",
      "tro3sp",
      "tro3v",
      "tru5i",
      "trus4",
      "4t1s2",
      "t4sc",
      "tsh4",
      "t4sw",
      "4t3t2",
      "t4tes",
      "t5to",
      "ttu4",
      "1tu",
      "tu1a",
      "tu3ar",
      "tu4bi",
      "tud2",
      "4tue",
      "4tuf4",
      "5tu3i",
      "3tum",
      "tu4nis",
      "2t3up.",
      "3ture",
      "5turi",
      "tur3is",
      "tur5o",
      "tu5ry",
      "3tus",
      "4tv",
      "tw4",
      "4t1wa",
      "twis4",
      "4two",
      "1ty",
      "4tya",
      "2tyl",
      "type3",
      "ty5ph",
      "4tz",
      "tz4e",
      "4uab",
      "uac4",
      "ua5na",
      "uan4i",
      "uar5ant",
      "uar2d",
      "uar3i",
      "uar3t",
      "u1at",
      "uav4",
      "ub4e",
      "u4bel",
      "u3ber",
      "u4bero",
      "u1b4i",
      "u4b5ing",
      "u3ble.",
      "u3ca",
      "uci4b",
      "uc4it",
      "ucle3",
      "u3cr",
      "u3cu",
      "u4cy",
      "ud5d",
      "ud3er",
      "ud5est",
      "udev4",
      "u1dic",
      "ud3ied",
      "ud3ies",
      "ud5is",
      "u5dit",
      "u4don",
      "ud4si",
      "u4du",
      "u4ene",
      "uens4",
      "uen4te",
      "uer4il",
      "3ufa",
      "u3fl",
      "ugh3en",
      "ug5in",
      "2ui2",
      "uil5iz",
      "ui4n",
      "u1ing",
      "uir4m",
      "uita4",
      "uiv3",
      "uiv4er.",
      "u5j",
      "4uk",
      "u1la",
      "ula5b",
      "u5lati",
      "ulch4",
      "5ulche",
      "ul3der",
      "ul4e",
      "u1len",
      "ul4gi",
      "ul2i",
      "u5lia",
      "ul3ing",
      "ul5ish",
      "ul4lar",
      "ul4li4b",
      "ul4lis",
      "4ul3m",
      "u1l4o",
      "4uls",
      "uls5es",
      "ul1ti",
      "ultra3",
      "4ultu",
      "u3lu",
      "ul5ul",
      "ul5v",
      "um5ab",
      "um4bi",
      "um4bly",
      "u1mi",
      "u4m3ing",
      "umor5o",
      "um2p",
      "unat4",
      "u2ne",
      "un4er",
      "u1ni",
      "un4im",
      "u2nin",
      "un5ish",
      "uni3v",
      "un3s4",
      "un4sw",
      "unt3ab",
      "un4ter.",
      "un4tes",
      "unu4",
      "un5y",
      "un5z",
      "u4ors",
      "u5os",
      "u1ou",
      "u1pe",
      "uper5s",
      "u5pia",
      "up3ing",
      "u3pl",
      "up3p",
      "upport5",
      "upt5ib",
      "uptu4",
      "u1ra",
      "4ura.",
      "u4rag",
      "u4ras",
      "ur4be",
      "urc4",
      "ur1d",
      "ure5at",
      "ur4fer",
      "ur4fr",
      "u3rif",
      "uri4fic",
      "ur1in",
      "u3rio",
      "u1rit",
      "ur3iz",
      "ur2l",
      "url5ing.",
      "ur4no",
      "uros4",
      "ur4pe",
      "ur4pi",
      "urs5er",
      "ur5tes",
      "ur3the",
      "urti4",
      "ur4tie",
      "u3ru",
      "2us",
      "u5sad",
      "u5san",
      "us4ap",
      "usc2",
      "us3ci",
      "use5a",
      "u5sia",
      "u3sic",
      "us4lin",
      "us1p",
      "us5sl",
      "us5tere",
      "us1tr",
      "u2su",
      "usur4",
      "uta4b",
      "u3tat",
      "4ute.",
      "4utel",
      "4uten",
      "uten4i",
      "4u1t2i",
      "uti5liz",
      "u3tine",
      "ut3ing",
      "ution5a",
      "u4tis",
      "5u5tiz",
      "u4t1l",
      "ut5of",
      "uto5g",
      "uto5matic",
      "u5ton",
      "u4tou",
      "uts4",
      "u3u",
      "uu4m",
      "u1v2",
      "uxu3",
      "uz4e",
      "1va",
      "5va.",
      "2v1a4b",
      "vac5il",
      "vac3u",
      "vag4",
      "va4ge",
      "va5lie",
      "val5o",
      "val1u",
      "va5mo",
      "va5niz",
      "va5pi",
      "var5ied",
      "3vat",
      "4ve.",
      "4ved",
      "veg3",
      "v3el.",
      "vel3li",
      "ve4lo",
      "v4ely",
      "ven3om",
      "v5enue",
      "v4erd",
      "5vere.",
      "v4erel",
      "v3eren",
      "ver5enc",
      "v4eres",
      "ver3ie",
      "vermi4n",
      "3verse",
      "ver3th",
      "v4e2s",
      "4ves.",
      "ves4te",
      "ve4te",
      "vet3er",
      "ve4ty",
      "vi5ali",
      "5vian",
      "5vide.",
      "5vided",
      "4v3iden",
      "5vides",
      "5vidi",
      "v3if",
      "vi5gn",
      "vik4",
      "2vil",
      "5vilit",
      "v3i3liz",
      "v1in",
      "4vi4na",
      "v2inc",
      "vin5d",
      "4ving",
      "vio3l",
      "v3io4r",
      "vi1ou",
      "vi4p",
      "vi5ro",
      "vis3it",
      "vi3so",
      "vi3su",
      "4viti",
      "vit3r",
      "4vity",
      "3viv",
      "5vo.",
      "voi4",
      "3vok",
      "vo4la",
      "v5ole",
      "5volt",
      "3volv",
      "vom5i",
      "vor5ab",
      "vori4",
      "vo4ry",
      "vo4ta",
      "4votee",
      "4vv4",
      "v4y",
      "w5abl",
      "2wac",
      "wa5ger",
      "wag5o",
      "wait5",
      "w5al.",
      "wam4",
      "war4t",
      "was4t",
      "wa1te",
      "wa5ver",
      "w1b",
      "wea5rie",
      "weath3",
      "wed4n",
      "weet3",
      "wee5v",
      "wel4l",
      "w1er",
      "west3",
      "w3ev",
      "whi4",
      "wi2",
      "wil2",
      "will5in",
      "win4de",
      "win4g",
      "wir4",
      "3wise",
      "with3",
      "wiz5",
      "w4k",
      "wl4es",
      "wl3in",
      "w4no",
      "1wo2",
      "wom1",
      "wo5ven",
      "w5p",
      "wra4",
      "wri4",
      "writa4",
      "w3sh",
      "ws4l",
      "ws4pe",
      "w5s4t",
      "4wt",
      "wy4",
      "x1a",
      "xac5e",
      "x4ago",
      "xam3",
      "x4ap",
      "xas5",
      "x3c2",
      "x1e",
      "xe4cuto",
      "x2ed",
      "xer4i",
      "xe5ro",
      "x1h",
      "xhi2",
      "xhil5",
      "xhu4",
      "x3i",
      "xi5a",
      "xi5c",
      "xi5di",
      "x4ime",
      "xi5miz",
      "x3o",
      "x4ob",
      "x3p",
      "xpan4d",
      "xpecto5",
      "xpe3d",
      "x1t2",
      "x3ti",
      "x1u",
      "xu3a",
      "xx4",
      "y5ac",
      "3yar4",
      "y5at",
      "y1b",
      "y1c",
      "y2ce",
      "yc5er",
      "y3ch",
      "ych4e",
      "ycom4",
      "ycot4",
      "y1d",
      "y5ee",
      "y1er",
      "y4erf",
      "yes4",
      "ye4t",
      "y5gi",
      "4y3h",
      "y1i",
      "y3la",
      "ylla5bl",
      "y3lo",
      "y5lu",
      "ymbol5",
      "yme4",
      "ympa3",
      "yn3chr",
      "yn5d",
      "yn5g",
      "yn5ic",
      "5ynx",
      "y1o4",
      "yo5d",
      "y4o5g",
      "yom4",
      "yo5net",
      "y4ons",
      "y4os",
      "y4ped",
      "yper5",
      "yp3i",
      "y3po",
      "y4poc",
      "yp2ta",
      "y5pu",
      "yra5m",
      "yr5ia",
      "y3ro",
      "yr4r",
      "ys4c",
      "y3s2e",
      "ys3ica",
      "ys3io",
      "3ysis",
      "y4so",
      "yss4",
      "ys1t",
      "ys3ta",
      "ysur4",
      "y3thin",
      "yt3ic",
      "y1w",
      "za1",
      "z5a2b",
      "zar2",
      "4zb",
      "2ze",
      "ze4n",
      "ze4p",
      "z1er",
      "ze3ro",
      "zet4",
      "2z1i",
      "z4il",
      "z4is",
      "5zl",
      "4zm",
      "1zo",
      "zo4m",
      "zo5ol",
      "zte4",
      "4z1z2",
      "z4zy",
      // hyphen.tex patterns end here, and additional patterns begin:
      ".con5gr",
      ".de5riva",
      ".dri5v4",
      ".eth1y6l1",
      ".eu4ler",
      ".ev2",
      ".ever5si5b",
      ".ga4s1om1",
      ".ge4ome",
      ".ge5ot1",
      ".he3mo1",
      ".he3p6a",
      ".he3roe",
      ".in5u2t",
      ".kil2n3i",
      ".ko6r1te1",
      ".le6ices",
      ".me4ga1l",
      ".met4ala",
      ".mim5i2c1",
      ".mi1s4ers",
      ".ne6o3f",
      ".noe1th",
      ".non1e2m",
      ".poly1s",
      ".post1am",
      ".pre1am",
      ".rav5en1o",
      ".semi5",
      ".sem4ic",
      ".semid6",
      ".semip4",
      ".semir4",
      ".sem6is4",
      ".semiv4",
      ".sph6in1",
      ".spin1o",
      ".ta5pes1tr",
      ".te3legr",
      ".to6pog",
      ".to2q",
      ".un3at5t",
      ".un5err5",
      ".vi2c3ar",
      ".we2b1l",
      ".re1e4c",
      "a5bolic",
      "a2cabl",
      "af6fish",
      "am1en3ta5b",
      "anal6ys",
      "ano5a2c",
      "ans5gr",
      "ans3v",
      "anti1d",
      "an3ti1n2",
      "anti1re",
      "a4pe5able",
      "ar3che5t",
      "ar2range",
      "as5ymptot",
      "ath3er1o1s",
      "at6tes.",
      "augh4tl",
      "au5li5f",
      "av3iou",
      "back2er.",
      "ba6r1onie",
      "ba1thy",
      "bbi4t",
      "be2vie",
      "bi5d2if",
      "bil2lab",
      "bio5m",
      "bi1orb",
      "bio1rh",
      "b1i3tive",
      "blan2d1",
      "blin2d1",
      "blon2d2",
      "bor1no5",
      "bo2t1u1l",
      "brus4q",
      "bus6i2er",
      "bus6i2es",
      "buss4ing",
      "but2ed.",
      "but4ted",
      "cad5e1m",
      "cat1a1s2",
      "4chs.",
      "chs3hu",
      "chie5vo",
      "cig3a3r",
      "cin2q",
      "cle4ar",
      "co6ph1o3n",
      "cous2ti",
      "cri3tie",
      "croc1o1d",
      "cro5e2co",
      "c2tro3me6c",
      "1cu2r1ance",
      "2d3alone",
      "data1b",
      "dd5a5b",
      "d2d5ib",
      "de4als.",
      "de5clar1",
      "de2c5lina",
      "de3fin3iti",
      "de2mos",
      "des3ic",
      "de2tic",
      "dic1aid",
      "dif5fra",
      "3di1methy",
      "di2ren",
      "di2rer",
      "2d1lead",
      "2d1li2e",
      "3do5word",
      "dren1a5l",
      "drif2t1a",
      "d1ri3pleg5",
      "drom3e5d",
      "d3tab",
      "du2al.",
      "du1op1o1l",
      "ea4n3ies",
      "e3chas",
      "edg1l",
      "ed1uling",
      "eli2t1is",
      "e1loa",
      "en1dix",
      "eo3grap",
      "1e6p3i3neph1",
      "e2r3i4an.",
      "e3spac6i",
      "eth1y6l1ene",
      "5eu2clid1",
      "feb1rua",
      "fermi1o",
      "3fich",
      "fit5ted.",
      "fla1g6el",
      "flow2er.",
      "3fluor",
      "gen2cy.",
      "ge3o1d",
      "ght1we",
      "g1lead",
      "get2ic.",
      "4g1lish",
      "5glo5bin",
      "1g2nac",
      "gnet1ism",
      "gno5mo",
      "g2n1or.",
      "g2noresp",
      "2g1o4n3i1za",
      "graph5er.",
      "griev1",
      "g1utan",
      "hair1s",
      "ha2p3ar5r",
      "hatch1",
      "hex2a3",
      "hite3sid",
      "h3i5pel1a4",
      "hnau3z",
      "ho6r1ic.",
      "h2t1eou",
      "hypo1tha",
      "id4ios",
      "ifac1et",
      "ign4it",
      "ignit1er",
      "i4jk",
      "im3ped3a",
      "infra1s2",
      "i5nitely.",
      "irre6v3oc",
      "i1tesima",
      "ith5i2l",
      "itin5er5ar",
      "janu3a",
      "japan1e2s",
      "je1re1m",
      "1ke6ling",
      "1ki5netic",
      "1kovian",
      "k3sha",
      "la4c3i5e",
      "lai6n3ess",
      "lar5ce1n",
      "l3chai",
      "l3chil6d1",
      "lead6er.",
      "lea4s1a",
      "1lec3ta6b",
      "le3g6en2dre",
      "1le1noid",
      "lith1o5g",
      "ll1fl",
      "l2l3ish",
      "l5mo3nell",
      "lo1bot1o1",
      "lo2ges.",
      "load4ed.",
      "load6er.",
      "l3tea",
      "lth5i2ly",
      "lue1p",
      "1lunk3er",
      "1lum5bia.",
      "3lyg1a1mi",
      "ly5styr",
      "ma1la1p",
      "m2an.",
      "man3u1sc",
      "mar1gin1",
      "medi2c",
      "med3i3cin",
      "medio6c1",
      "me3gran3",
      "m2en.",
      "3mi3da5b",
      "3milita",
      "mil2l1ag",
      "mil5li5li",
      "mi6n3is.",
      "mi1n2ut1er",
      "mi1n2ut1est",
      "m3ma1b",
      "5maph1ro1",
      "5moc1ra1t",
      "mo5e2las",
      "mol1e5c",
      "mon4ey1l",
      "mono3ch",
      "mo4no1en",
      "moro6n5is",
      "mono1s6",
      "moth4et2",
      "m1ou3sin",
      "m5shack2",
      "mu2dro",
      "mul2ti5u",
      "n3ar4chs.",
      "n3ch2es1t",
      "ne3back",
      "2ne1ski",
      "n1dieck",
      "nd3thr",
      "nfi6n3ites",
      "4n5i4an.",
      "nge5nes",
      "ng1ho",
      "ng1spr",
      "nk3rup",
      "n5less",
      "5noc3er1os",
      "nom1a6l",
      "nom5e1no",
      "n1o1mist",
      "non1eq",
      "non1i4so",
      "5nop1oly.",
      "no1vemb",
      "ns5ceiv",
      "ns4moo",
      "ntre1p",
      "obli2g1",
      "o3chas",
      "odel3li",
      "odit1ic",
      "oerst2",
      "oke1st",
      "o3les3ter",
      "oli3gop1o1",
      "o1lo3n4om",
      "o3mecha6",
      "onom1ic",
      "o3norma",
      "o3no2t1o3n",
      "o3nou",
      "op1ism.",
      "or4tho3ni4t",
      "orth1ri",
      "or5tively",
      "o4s3pher",
      "o5test1er",
      "o5tes3tor",
      "oth3e1o1s",
      "ou3ba3do",
      "o6v3i4an.",
      "oxi6d1ic",
      "pal6mat",
      "parag6ra4",
      "par4a1le",
      "param4",
      "para3me",
      "pee2v1",
      "phi2l3ant",
      "phi5lat1e3l",
      "pi2c1a3d",
      "pli2c1ab",
      "pli5nar",
      "poin3ca",
      "1pole.",
      "poly1e",
      "po3lyph1ono",
      "1prema3c",
      "pre1neu",
      "pres2pli",
      "pro2cess",
      "proc3i3ty.",
      "pro2g1e",
      "3pseu2d",
      "pseu3d6o3d2",
      "pseu3d6o3f2",
      "pto3mat4",
      "p5trol3",
      "pu5bes5c",
      "quain2t1e",
      "qu6a3si3",
      "quasir6",
      "quasis6",
      "quin5tes5s",
      "qui3v4ar",
      "r1abolic",
      "3rab1o1loi",
      "ra3chu",
      "r3a3dig",
      "radi1o6g",
      "r2amen",
      "3ra4m5e1triz",
      "ra3mou",
      "ra5n2has",
      "ra1or",
      "r3bin1ge",
      "re2c3i1pr",
      "rec5t6ang",
      "re4t1ribu",
      "r3ial.",
      "riv1o1l",
      "6rk.",
      "rk1ho",
      "r1krau",
      "6rks.",
      "r5le5qu",
      "ro1bot1",
      "ro5e2las",
      "ro5epide1",
      "ro3mesh",
      "ro1tron",
      "r3pau5li",
      "rse1rad1i",
      "r1thou",
      "r1treu",
      "r1veil",
      "rz1sc",
      "sales3c",
      "sales5w",
      "5sa3par5il",
      "sca6p1er",
      "sca2t1ol",
      "s4chitz",
      "schro1ding1",
      "1sci2utt",
      "scrap4er.",
      "scy4th1",
      "sem1a1ph",
      "se3mes1t",
      "se1mi6t5ic",
      "sep3temb",
      "shoe1st",
      "sid2ed.",
      "side5st",
      "side5sw",
      "si5resid",
      "sky1sc",
      "3slova1kia",
      "3s2og1a1my",
      "so2lute",
      "3s2pace",
      "1s2pacin",
      "spe3cio",
      "spher1o",
      "spi2c1il",
      "spokes5w",
      "sports3c",
      "sports3w",
      "s3qui3to",
      "s2s1a3chu1",
      "ss3hat",
      "s2s3i4an.",
      "s5sign5a3b",
      "1s2tamp",
      "s2t1ant5shi",
      "star3tli",
      "sta1ti",
      "st5b",
      "1stor1ab",
      "strat1a1g",
      "strib5ut",
      "st5scr",
      "stu1pi4d1",
      "styl1is",
      "su2per1e6",
      "1sync",
      "1syth3i2",
      "swimm6",
      "5tab1o1lism",
      "ta3gon.",
      "talk1a5",
      "t1a1min",
      "t6ap6ath",
      "5tar2rh",
      "tch1c",
      "tch3i1er",
      "t1cr",
      "teach4er.",
      "tele2g",
      "tele1r6o",
      "3ter1gei",
      "ter2ic.",
      "t3ess2es",
      "tha4l1am",
      "tho3don",
      "th1o5gen1i",
      "tho1k2er",
      "thy4l1an",
      "thy3sc",
      "2t3i4an.",
      "ti2n3o1m",
      "t1li2er",
      "tolo2gy",
      "tot3ic",
      "trai3tor1",
      "tra1vers",
      "travers3a3b",
      "treach1e",
      "tr4ial.",
      "3tro1le1um",
      "trof4ic.",
      "tro3fit",
      "tro1p2is",
      "3trop1o5les",
      "3trop1o5lis",
      "t1ro1pol3it",
      "tsch3ie",
      "ttrib1ut1",
      "turn3ar",
      "t1wh",
      "ty2p5al",
      "ua3drati",
      "uad1ratu",
      "u5do3ny",
      "uea1m",
      "u2r1al.",
      "uri4al.",
      "us2er.",
      "v1ativ",
      "v1oir5du1",
      "va6guer",
      "vaude3v",
      "1verely.",
      "v1er1eig",
      "ves1tite",
      "vi1vip3a3r",
      "voice1p",
      "waste3w6a2",
      "wave1g4",
      "w3c",
      "week1n",
      "wide5sp",
      "wo4k1en",
      "wrap3aro",
      "writ6er.",
      "x1q",
      "xquis3",
      "y5che3d",
      "ym5e5try",
      "y1stro",
      "yes5ter1y",
      "z3ian.",
      "z3o1phr",
      "z2z3w",
      // end of additional patterns.
      ""
    ], t = [
      "as-so-ciate",
      "as-so-ciates",
      "dec-li-na-tion",
      "oblig-a-tory",
      "phil-an-thropic",
      "present",
      "presents",
      "project",
      "projects",
      "reci-procity",
      "re-cog-ni-zance",
      "ref-or-ma-tion",
      "ret-ri-bu-tion",
      "ta-ble",
      ""
    ];
    return {
      patterns: e,
      exceptions: t
    };
  });
})(tD);
var vQ = tD.exports;
const gQ = /* @__PURE__ */ I0(vQ);
var mQ = function(e) {
  var t = 0, n = "", i = [];
  return e.forEach(function(a) {
    n += a.string, i.push({
      start: t,
      end: t + a.string.length,
      attributes: a.attributes || {}
    }), t += a.string.length;
  }), {
    string: n,
    runs: i
  };
}, yQ = function(e) {
  return [e];
}, bQ = function(e, t) {
  return e === void 0 && (e = {}), t === void 0 && (t = {}), function(n) {
    for (var i, a, o = [], s = [], c = t.hyphenationCallback || ((i = (a = e).wordHyphenation) === null || i === void 0 ? void 0 : i.call(a, t)) || yQ, h = 0; h < n.runs.length; h += 1) {
      for (var d = "", g = n.runs[h], x = n.string.slice(g.start, g.end).split(/([ ]+)/g).filter(Boolean), _ = 0; _ < x.length; _ += 1) {
        var k = x[_], P = c(k);
        o.push.apply(o, P), d += P.join("");
      }
      s.push({
        string: d,
        attributes: g.attributes
      });
    }
    return $r({}, mQ(s), {
      syllables: o
    });
  };
}, wQ = function(e) {
  return Object.assign({}, e);
}, rD = function(e, t) {
  var n = Object.assign({}, e, {
    height: t
  }), i = Object.assign({}, e, {
    y: e.y + t,
    height: e.height - t
  });
  return [n, i];
}, AQ = function(e, t) {
  var n = rD(t, e), i = n[1];
  return i;
}, xQ = function(e) {
  return e.reduce(function(t, n) {
    return t + n.box.height;
  }, 0);
}, EQ = function(e) {
  var t, n = e.attributes || {}, i = n.fontSize || 12, a = (t = n.font) === null || t === void 0 ? void 0 : t.unitsPerEm;
  return a ? i / a : 0;
}, cf = function(e) {
  var t;
  return ((t = e.attributes) === null || t === void 0 ? void 0 : t.scale) || EQ(e);
}, q8 = function(e, t) {
  if (!t) return 0;
  var n = t.glyphIndices || [], i = n[e];
  return n.slice(0, e).filter(function(a) {
    return a === i;
  }).length;
}, Bg = function(e) {
  var t;
  return ((t = e.attributes) === null || t === void 0 ? void 0 : t.font) || null;
}, X8 = function(e, t, n, i) {
  if (!i) return [];
  if (e === t) return [];
  if (e === 0 && t === i.codePoints.length) return [i];
  var a = i.codePoints.slice(e, t), o = String.fromCodePoint.apply(String, a);
  return n ? n.layout(o).glyphs : [i];
}, Fd = function(e, t) {
  var n, i = t == null || (n = t.glyphIndices) === null || n === void 0 ? void 0 : n[e];
  return zr(i) ? e : i;
}, nD = function(e) {
  var t = e[0];
  return e.map(function(n) {
    return n - t;
  });
}, $1 = function(e, t, n) {
  var i, a, o = cf(n), s = Bg(n), c = Fd(e, n), h = Fd(t, n), d = (i = n.glyphs) === null || i === void 0 ? void 0 : i[c], g = (a = n.glyphs) === null || a === void 0 ? void 0 : a[h], x = q8(e, n), _ = x > 0 ? X8(x, 1 / 0, s, d) : [], k = q8(t, n), P = X8(0, k, s, g), N = c + Math.min(1, x), M = (n.glyphs || []).slice(N, h), G = function(J) {
    return {
      xAdvance: J.advanceWidth * o
    };
  }, z = _.map(G), j = (n.positions || []).slice(N, h), R = P.map(G);
  return Object.assign({}, n, {
    start: n.start + e,
    end: Math.min(n.end, n.start + t),
    glyphIndices: nD((n.glyphIndices || []).slice(e, t)),
    glyphs: [_, M, P].flat(),
    positions: [z, j, R].flat()
  });
}, Q3 = function(e, t) {
  return t ? t.findIndex(function(n) {
    return n.start <= e && e < n.end;
  }) : -1;
}, iD = function(e, t, n) {
  var i = Q3(e, n), a = Math.max(Q3(t - 1, n), i);
  return n.slice(i, a + 1);
}, _Q = function(e, t) {
  var n = t.start - e, i = t.end - e;
  return Object.assign({}, t, {
    start: n,
    end: i
  });
}, DQ = function(e, t, n) {
  var i = function(s) {
    return $1(e - s.start, t - s.start, s);
  }, a = function(s) {
    return $1(0, t - s.start, s);
  };
  return n.map(function(o, s) {
    var c = o, h = s === 0, d = !h && s === n.length - 1;
    return h && (c = i(o)), d && (c = a(o)), _Q(e, c);
  });
}, Wc = function(e, t, n) {
  if (n.string.length === 0) return n;
  var i = n.string.slice(e, t), a = iD(e, t, n.runs), o = DQ(e, t, a);
  return Object.assign({}, n, {
    string: i,
    runs: o
  });
}, TQ = function(e) {
  return e.search(/\S/g);
}, kQ = function(e) {
  var t = e.match(/\S/g);
  return t ? e.lastIndexOf(t[t.length - 1]) : -1;
}, SQ = function(e) {
  var t = TQ(e.string), n = kQ(e.string);
  return Wc(t, n + 1, e);
}, CQ = function() {
  return {
    start: 0,
    end: 0,
    glyphIndices: [],
    glyphs: [],
    positions: [],
    attributes: {}
  };
}, aD = function(e) {
  return typeof e == "number";
}, FQ = function(e, t) {
  var n = Qo(t), i = zr(n) ? 0 : n + 1, a = Array(e).fill(i);
  return t.concat(a);
}, oD = function(e, t) {
  return t && e ? t.glyphForCodePoint(e) : null;
}, OQ = function(e, t) {
  var n, i = ((n = e.codePoints) === null || n === void 0 ? void 0 : n.length) || 0, a = t.end + i, o = t.glyphs.concat(e), s = FQ(i, t.glyphIndices);
  if (!t.positions) return Object.assign({}, t, {
    end: a,
    glyphs: o,
    glyphIndices: s
  });
  var c = t.positions.concat({
    xAdvance: e.advanceWidth * cf(t)
  });
  return Object.assign({}, t, {
    end: a,
    glyphs: o,
    glyphIndices: s,
    positions: c
  });
}, sD = function(e, t) {
  if (!e) return t;
  var n = Bg(t), i = aD(e) ? oD(e, n) : e;
  return OQ(i, t);
}, uD = function(e) {
  return String.fromCodePoint.apply(String, e);
}, lD = function(e, t) {
  var n = (e == null ? void 0 : e.codePoints) || [], i = uD(n), a = t.string + i, o = t.runs.slice(0, -1), s = Qo(t.runs) || CQ(), c = o.concat(sD(e, s));
  return Object.assign({}, t, {
    string: a,
    runs: c
  });
}, cD = 8230, RQ = String.fromCharCode(cD), IQ = function(e) {
  if (!e.encode) return cD;
  var t = e.encode(RQ), n = t[0];
  return parseInt(n[0], 16);
}, K8 = function(e) {
  var t, n, i, a = ((t = Qo(e)) === null || t === void 0 ? void 0 : t.runs) || [], o = (n = Qo(a)) === null || n === void 0 || (i = n.attributes) === null || i === void 0 ? void 0 : i.font;
  if (o) {
    var s, c = e.length - 1, h = IQ(o), d = o.glyphForCodePoint(h), g = lD(d, SQ(e[c]));
    return Object.assign([], e, (s = {}, s[c] = g, s));
  }
  return e;
}, fD = function(e, t) {
  var n = Object.assign({}, t.attributes);
  return delete n[e], Object.assign({}, t, {
    attributes: n
  });
}, B5 = function(e) {
  var t, n, i, a, o = ((t = e.attributes) === null || t === void 0 || (n = t.attachment) === null || n === void 0 ? void 0 : n.height) || 0, s = ((i = e.attributes) === null || i === void 0 || (a = i.font) === null || a === void 0 ? void 0 : a.ascent) || 0;
  return Math.max(o, s * cf(e));
}, hD = function(e) {
  var t, n, i = ((t = e.attributes) === null || t === void 0 || (n = t.font) === null || n === void 0 ? void 0 : n.descent) || 0;
  return cf(e) * i;
}, PQ = function(e) {
  var t, n;
  return (((t = e.attributes) === null || t === void 0 || (n = t.font) === null || n === void 0 ? void 0 : n.lineGap) || 0) * cf(e);
}, dD = function(e) {
  var t, n = (t = e.attributes) === null || t === void 0 ? void 0 : t.lineHeight;
  return n || PQ(e) + B5(e) - hD(e);
}, pD = function(e) {
  var t = function(i, a) {
    return Math.max(i, dD(a));
  };
  return e.runs.reduce(t, 0);
}, BQ = function(e, t) {
  var n = Math.max(e.x, t.x), i = Math.min(e.x + e.width, t.x + t.width), a = Math.max(e.y, t.y), o = Math.min(e.y + e.height, t.y + t.height);
  return i >= n && o >= a;
}, NQ = ["excludeRects"], LQ = function(e, t) {
  if (!BQ(t, e)) return [e];
  var n = t.x, i = t.x + t.width, a = e.x, o = e.x + e.width, s = Object.assign({}, e, {
    width: n - a
  }), c = Object.assign({}, e, {
    x: i,
    width: o - i
  });
  return [s, c].filter(function(h) {
    return h.width > 0;
  });
}, MQ = function(e, t) {
  for (var n = [e], i = function() {
    var s = t[a];
    n = n.reduce(function(c, h) {
      var d = LQ(h, s);
      return c.concat(d);
    }, []);
  }, a = 0; a < t.length; a += 1)
    i();
  return n;
}, UQ = function(e, t) {
  var n = e.excludeRects, i = Vc(e, NQ);
  if (!n) return [i];
  for (var a = [], o = Math.max.apply(Math, n.map(function(x) {
    return x.y + x.height;
  })), s = i; s.y < o; ) {
    var c = rD(s, t), h = c[0], d = c[1], g = MQ(h, n);
    s = d, a.push.apply(a, g);
  }
  return [].concat(a, [s]);
}, $Q = "￼", zQ = function(e) {
  var t = !e.string.includes($Q);
  if (!t) return e;
  var n = e.runs.map(function(i) {
    return fD("attachment", i);
  });
  return Object.assign({}, e, {
    runs: n
  });
}, jQ = function(e, t, n) {
  var i = e.shift(), a = i.y;
  return t.map(function(o, s) {
    var c, h, d = s === 0 ? n : 0, g = ((c = o.runs) === null || c === void 0 || (h = c[0]) === null || h === void 0 ? void 0 : h.attributes) || {}, x = Math.max(pD(o), g.lineHeight);
    a + x > i.y + i.height && e.length > 0 && (i = e.shift(), a = i.y);
    var _ = Object.assign({}, o);
    return delete _.syllables, _.box = {
      x: i.x + d,
      y: a,
      width: i.width - d,
      height: x
    }, a += x, zQ(_);
  });
}, WQ = function(e, t) {
  return function(n, i) {
    var a, o, s, c = pD(i), h = ((a = i.runs) === null || a === void 0 || (o = a[0]) === null || o === void 0 || (s = o.attributes) === null || s === void 0 ? void 0 : s.indent) || 0, d = UQ(n, c), g = d.map(function(_) {
      return _.width;
    });
    g[0] -= h;
    var x = e.linebreaker(t)(i, g);
    return jQ(d, x, h);
  };
}, GQ = function(e, t) {
  for (var n = [], i = 0, a = 0; a < t.length; a += 1) {
    var o = t[a];
    if (i += o.box.height, i < e)
      n.push(o);
    else
      break;
  }
  return n;
}, VQ = function(e, t, n) {
  return function(i) {
    for (var a = [], o = [].concat(i), s = WQ(e, t), c = zr(n.maxLines) ? 1 / 0 : n.maxLines, h = n.truncateMode === "ellipsis", d = c, g = wQ(n), x = o.shift(); d > 0 && x; ) {
      var _ = s(g, x), k = _.slice(0, d), P = xQ(k), N = h && _.length !== k.length;
      if (d -= k.length, g.height >= P)
        a.push(N ? K8(k) : k), g = AQ(P, g), x = o.shift();
      else {
        a.push(K8(GQ(g.height, k)));
        break;
      }
    }
    return a;
  };
}, YQ = 123, HQ = function(e) {
  return e === void 0 && (e = []), e.reduce(function(t, n) {
    var i = (n == null ? void 0 : n.codePoints) || [YQ];
    if (t.length === 0) return i.map(function() {
      return 0;
    });
    var a = t[t.length - 1], o = i.map(function() {
      return a + 1;
    });
    return [].concat(t, o);
  }, []);
}, ZQ = function(e) {
  var t;
  return ((t = e.attributes) === null || t === void 0 ? void 0 : t.characterSpacing) || 0;
}, qQ = function(e, t) {
  var n = cf(e), i = ZQ(e);
  return t.map(function(a, o) {
    var s = o === t.length, c = s ? 0 : i;
    return Object.assign({}, a, {
      xAdvance: a.xAdvance * n + c,
      yAdvance: a.yAdvance * n,
      xOffset: a.xOffset * n,
      yOffset: a.yOffset * n
    });
  });
}, XQ = function(e) {
  return function(t) {
    var n = t.start, i = t.end, a = t.attributes, o = a === void 0 ? {} : a, s = o.font;
    if (!s) return $r({}, t, {
      glyphs: [],
      glyphIndices: [],
      positions: []
    });
    var c = e.slice(n, i), h = s.layout(c), d = qQ(t, h.positions), g = HQ(h.glyphs);
    return $r({}, t, {
      positions: d,
      glyphIndices: g,
      glyphs: h.glyphs
    });
  };
}, KQ = function() {
  return function(e) {
    var t = e.runs.map(XQ(e.string));
    return Object.assign({}, e, {
      runs: t
    });
  };
}, JQ = function(e) {
  var t, n, i;
  if (!e.positions) return e;
  var a = ((t = e.attributes) === null || t === void 0 || (n = t.font) === null || n === void 0 ? void 0 : n.unitsPerEm) || 0, o = (((i = e.attributes) === null || i === void 0 ? void 0 : i.yOffset) || 0) * a, s = e.positions.map(function(c) {
    return Object.assign({}, c, {
      yOffset: o
    });
  });
  return Object.assign({}, e, {
    positions: s
  });
}, QQ = function() {
  return function(e) {
    var t = e.runs.map(JQ);
    return Object.assign({}, e, {
      runs: t
    });
  };
}, eee = function(e) {
  return e.sort(function(t, n) {
    return t.start - n.start || t.end - n.end;
  });
}, J8 = function(e) {
  return e.start === e.end;
}, tee = function(e, t) {
  return e[1] - t[1] || e[3] - t[3];
}, ree = function(e) {
  var t = e.reduce(function(n, i, a) {
    return n.concat([["start", i.start, i.attributes, a], ["end", i.end, i.attributes, a]]);
  }, []);
  return t.sort(tee);
}, nee = function(e) {
  return e.reduce(function(t, n) {
    var i = Object.assign({}, t.attributes, n.attributes);
    return Object.assign({}, n, {
      attributes: i
    });
  }, {});
}, iee = function(e) {
  var t = e.reduce(function(n, i) {
    return n[i.start] || (n[i.start] = []), n[i.start].push(i), n;
  }, {});
  return Object.values(t);
}, aee = function(e) {
  return iee(e).map(nee);
}, oee = function(e) {
  for (var t = [], n = ree(e), i = -1, a = {}, o = [], s = 0; s < n.length; s += 1) {
    var c = n[s], h = c[0], d = c[1], g = c[2];
    if (i !== -1 && i < d && t.push({
      start: i,
      end: d,
      attributes: a
    }), h === "start")
      o.push(g), a = Object.assign({}, a, g);
    else {
      a = {};
      for (var x = 0; x < o.length; x += 1)
        o[x] === g ? o.splice(x--, 1) : a = Object.assign({}, a, o[x]);
    }
    i = d;
  }
  return t;
}, see = function(e) {
  e === void 0 && (e = []);
  var t = aee(e.filter(function(i) {
    return J8(i);
  })), n = oee(e.filter(function(i) {
    return !J8(i);
  }));
  return eee(t.concat(n));
}, vD = function() {
  return {
    string: "",
    runs: []
  };
}, uee = function(e) {
  var t = e.runs.map(function(n) {
    return fD("font", n);
  });
  return Object.assign({}, e, {
    runs: t
  });
}, lee = function(e, t) {
  return function(n) {
    if (zr(n)) return vD();
    var i = n.string, a = e.fontSubstitution, o = e.scriptItemizer, s = uee(n), c = s.runs, h = a(t)(n), d = h.runs, g = o(t)(n), x = g.runs, _ = d.concat(x).concat(c);
    return {
      string: i,
      runs: see(_)
    };
  };
}, cee = function(e) {
  var t = e.runs;
  return t.length === 0 ? 0 : t[0].start;
}, fee = function(e) {
  var t = e.runs;
  return t.length === 0 ? 0 : Qo(t).end;
}, hee = function(e) {
  return fee(e) - cee(e);
}, dee = function() {
  return function(e) {
    for (var t = [], n = 0, i = e.string.indexOf(`
`) + 1; i > 0; )
      t.push(Wc(n, i, e)), n = i, i = e.string.indexOf(`
`, i) + 1;
    return n === 0 ? t.push(e) : n < e.string.length && t.push(Wc(n, hee(e), e)), t;
  };
}, gD = function(e) {
  return e.reduce(function(t, n) {
    return t + (n.xAdvance || 0);
  }, 0);
}, Ng = function(e) {
  return gD(e.positions || []);
}, Lg = function(e) {
  var t = function(i, a) {
    return i + Ng(a);
  };
  return e.runs.reduce(t, 0);
}, pee = 32, Mg = function(e) {
  var t = (e == null ? void 0 : e.codePoints) || [];
  return t.includes(pee);
}, vee = function(e) {
  var t = e.glyphs || [], n = e.positions || [], i = t.findIndex(function(a) {
    return !Mg(a);
  });
  return n.slice(0, i);
}, gee = function(e) {
  var t = vee(e);
  return t.reduce(function(n, i) {
    return n + (i.xAdvance || 0);
  }, 0);
}, mee = function(e) {
  var t = e.runs || [];
  return gee(t[0]);
}, Q8 = function(e) {
  return [].concat(e).reverse();
}, yee = function(e) {
  var t = Q8(e.glyphs || []), n = Q8(e.positions || []), i = t.findIndex(function(a) {
    return !Mg(a);
  });
  return n.slice(0, i);
}, bee = function(e) {
  var t = yee(e);
  return t.reduce(function(n, i) {
    return n + (i.xAdvance || 0);
  }, 0);
}, wee = function(e) {
  var t = e.runs || [];
  return bee(Qo(t));
}, Aee = function(e) {
  return $1(0, e.end - e.start - 1, e);
}, xee = function(e) {
  var t = FP(e.string), n = kP(-1, Aee, e.runs);
  return Object.assign({}, e, {
    string: t,
    runs: n
  });
}, Eee = {
  center: 0.5,
  right: 1
}, _ee = function(e) {
  return Qo(e.string) === `
` ? xee(e) : e;
}, Dee = function(e) {
  return mee(e) + (e.overflowLeft || 0);
}, Tee = function(e) {
  return wee(e) + (e.overflowRight || 0);
}, kee = function(e) {
  var t = Dee(e), n = Tee(e), i = e.box.x - t, a = e.box.width + t + n, o = Object.assign({}, e.box, {
    x: i,
    width: a
  });
  return Object.assign({}, e, {
    box: o,
    overflowLeft: t,
    overflowRight: n
  });
}, See = function(e, t, n) {
  return function(i) {
    var a = Lg(i), o = Eee[n] || 0, s = Math.max(0, i.box.width - a), c = n === "justify" || a > i.box.width, h = i.box.x + s * o, d = Object.assign({}, i.box, {
      x: h
    }), g = Object.assign({}, i, {
      box: d
    });
    return c ? e.justification(t)(g) : g;
  };
}, Cee = function(e) {
  var t = 0, n = 0, i = 0, a = 0, o = e.runs.map(function(s) {
    var c = dD(s), h = B5(s), d = hD(s), g = Ng(s);
    return i = Math.max(i, c), t = Math.max(t, h), n = Math.max(n, d), a += g, Object.assign({}, s, {
      height: c,
      ascent: h,
      descent: d,
      xAdvance: g
    });
  });
  return Object.assign({}, e, {
    runs: o,
    height: i,
    ascent: t,
    descent: n,
    xAdvance: a
  });
}, Fee = function(e, t) {
  return e === void 0 && (e = {}), function(n, i, a) {
    var o, s, c = i === a.length - 1, h = ((o = n.runs) === null || o === void 0 || (s = o[0]) === null || s === void 0 ? void 0 : s.attributes) || {}, d = c ? h.alignLastLine : h.align;
    return fi(Cee, e.textDecoration(t), See(e, t, d), kee, _ee)(n);
  };
}, Oee = function(e, t) {
  return function(n) {
    var i = Fee(e, t);
    return n.map(function(a) {
      return a.map(i);
    });
  };
}, Ree = 65532, Iee = function(e) {
  return e.codePoints.includes(Ree);
}, Pee = function(e) {
  var t;
  if (!e.positions) return e;
  var n = e.glyphs || [], i = ((t = e.attributes) === null || t === void 0 ? void 0 : t.attachment) || {}, a = e.positions.map(function(o, s) {
    var c = n[s];
    return i && i.width && Iee(c) ? Object.assign({}, o, {
      xAdvance: i.width
    }) : Object.assign({}, o);
  });
  return Object.assign({}, e, {
    positions: a
  });
}, Bee = function() {
  return function(e) {
    var t = e.runs.map(Pee);
    return Object.assign({}, e, {
      runs: t
    });
  };
}, Nee = function(e) {
  return {
    align: e.align || "left",
    alignLastLine: e.alignLastLine || (e.align === "justify" ? "left" : e.align || "left"),
    attachment: e.attachment || null,
    backgroundColor: e.backgroundColor || null,
    bidiLevel: e.bidiLevel || null,
    bullet: e.bullet || null,
    characterSpacing: e.characterSpacing || 0,
    color: e.color || "black",
    features: e.features || [],
    fill: e.fill !== !1,
    font: e.font || null,
    fontSize: e.fontSize || 12,
    hangingPunctuation: e.hangingPunctuation || !1,
    hyphenationFactor: e.hyphenationFactor || 0,
    indent: e.indent || 0,
    justificationFactor: e.justificationFactor || 1,
    lineHeight: e.lineHeight || null,
    lineSpacing: e.lineSpacing || 0,
    link: e.link || null,
    marginLeft: e.marginLeft || e.margin || 0,
    marginRight: e.marginRight || e.margin || 0,
    opacity: e.opacity,
    paddingTop: e.paddingTop || e.padding || 0,
    paragraphSpacing: e.paragraphSpacing || 0,
    underline: e.underline || !1,
    underlineColor: e.underlineColor || e.color || "black",
    underlineStyle: e.underlineStyle || "solid",
    script: e.script || null,
    shrinkFactor: e.shrinkFactor || 0,
    strike: e.strike || !1,
    strikeColor: e.strikeColor || e.color || "black",
    strikeStyle: e.strikeStyle || "solid",
    stroke: e.stroke || !1,
    verticalAlign: e.verticalAlign || null,
    wordSpacing: e.wordSpacing || 0,
    yOffset: e.yOffset || 0
  };
}, Lee = function(e) {
  var t = Nee(e.attributes);
  return Object.assign({}, e, {
    attributes: t
  });
}, Mee = function() {
  return function(e) {
    var t = e.string || "", n = (e.runs || []).map(Lee);
    return {
      string: t,
      runs: n
    };
  };
}, Uee = function() {
  return function(e) {
    return e.runs.forEach(function(t) {
      var n = t.attributes, i = n.verticalAlign;
      i === "sub" ? n.yOffset = -0.2 : i === "super" && (n.yOffset = 0.4);
    }), e;
  };
}, mD = function(e) {
  return function(t, n, i) {
    i === void 0 && (i = {});
    var a = fi(QQ(), Bee(), KQ(), Uee(), bQ(e, i)), o = function(c) {
      return c.map(a);
    };
    return fi(Oee(e, i), VQ(e, i, n), o, dee(), lee(e, i), Mee())(t);
  };
}, ew = 1e4, $ee = function(e, t, n) {
  for (var i = null, a = 1 / 0, o = {
    width: 0,
    stretch: 0,
    shrink: 0
  }, s = t[Math.min(n, t.length - 1)], c = function(N) {
    return o.width < s ? o.stretch - N.stretch > 0 ? (s - o.width) / o.stretch : ew : o.width > s ? o.shrink - N.shrink > 0 ? (s - o.width) / o.shrink : ew : 0;
  }, h = 0; h < e.length; h += 1) {
    var d = e[h];
    if (d.type === "box" ? o.width += d.width : d.type === "glue" && (o.width += d.width, o.stretch += d.stretch, o.shrink += d.shrink), o.width - o.shrink > s) {
      if (i === null) {
        for (var g = h === 0 ? h + 1 : h; g < e.length && (e[g].type === "glue" || e[g].type === "penalty"); )
          g++;
        i = g - 1;
      }
      break;
    }
    if (d.type === "penalty" || d.type === "glue") {
      var x = c(d), _ = d.type === "penalty" ? d.penalty : 0, k = 100 * Math.pow(Math.abs(x), 3) + _;
      a >= k && (i = h, a = k);
    }
  }
  return o.width - o.shrink > s ? i : null;
}, zee = function(e, t) {
  for (var n = 0, i = 0, a = e, o = [{
    position: 0
  }]; a.length > 0; ) {
    var s = $ee(a, t, i);
    s !== null ? (n += s, o.push({
      position: n
    }), a = a.slice(s + 1, a.length), n++, i++) : a = [];
  }
  return o;
}, jee = /* @__PURE__ */ function() {
  function r(t) {
    this.prev = null, this.next = null, this.data = t;
  }
  var e = r.prototype;
  return e.toString = function() {
    return this.data.toString();
  }, r;
}(), ed = /* @__PURE__ */ function() {
  function r() {
    this.head = null, this.tail = null, this.listSize = 0;
  }
  var e = r.prototype;
  return e.isLinked = function(n) {
    return !(n && n.prev === null && n.next === null && this.tail !== n && this.head !== n || this.isEmpty());
  }, e.size = function() {
    return this.listSize;
  }, e.isEmpty = function() {
    return this.listSize === 0;
  }, e.first = function() {
    return this.head;
  }, e.last = function() {
    return this.last;
  }, e.toString = function() {
    return this.toArray().toString();
  }, e.toArray = function() {
    for (var n = this.head, i = []; n !== null; )
      i.push(n), n = n.next;
    return i;
  }, e.forEach = function(n) {
    for (var i = this.head; i !== null; )
      n(i), i = i.next;
  }, e.contains = function(n) {
    var i = this.head;
    if (!this.isLinked(n))
      return !1;
    for (; i !== null; ) {
      if (i === n)
        return !0;
      i = i.next;
    }
    return !1;
  }, e.at = function(n) {
    var i = this.head, a = 0;
    if (n >= this.listLength || n < 0)
      return null;
    for (; i !== null; ) {
      if (n === a)
        return i;
      i = i.next, a += 1;
    }
    return null;
  }, e.insertAfter = function(n, i) {
    return this.isLinked(n) ? (i.prev = n, i.next = n.next, n.next === null ? this.tail = i : n.next.prev = i, n.next = i, this.listSize += 1, this) : this;
  }, e.insertBefore = function(n, i) {
    return this.isLinked(n) ? (i.prev = n.prev, i.next = n, n.prev === null ? this.head = i : n.prev.next = i, n.prev = i, this.listSize += 1, this) : this;
  }, e.push = function(n) {
    return this.head === null ? this.unshift(n) : this.insertAfter(this.tail, n), this;
  }, e.unshift = function(n) {
    return this.head === null ? (this.head = n, this.tail = n, n.prev = null, n.next = null, this.listSize += 1) : this.insertBefore(this.head, n), this;
  }, e.remove = function(n) {
    return this.isLinked(n) ? (n.prev === null ? this.head = n.next : n.prev.next = n.next, n.next === null ? this.tail = n.prev : n.next.prev = n.prev, this.listSize -= 1, this) : this;
  }, e.pop = function() {
    var n = this.tail;
    return this.tail.prev.next = null, this.tail = this.tail.prev, this.listSize -= 1, n.prev = null, n.next = null, n;
  }, e.shift = function() {
    var n = this.head;
    return this.head.next.prev = null, this.head = this.head.next, this.listSize -= 1, n.prev = null, n.next = null, n;
  }, r;
}();
ed.Node = jee;
/**
 * @preserve Knuth and Plass line breaking algorithm in JavaScript
 *
 * Licensed under the new BSD License.
 * Copyright 2009-2010, Bram Stein
 * All rights reserved.
 */
var Di = function r(e, t, n) {
  var i = {
    demerits: {
      line: n && n.demerits && n.demerits.line || 10,
      flagged: n && n.demerits && n.demerits.flagged || 100,
      fitness: n && n.demerits && n.demerits.fitness || 3e3
    },
    tolerance: n && n.tolerance || 3
  }, a = new ed(), o = {
    width: 0,
    stretch: 0,
    shrink: 0
  }, s = t, c = [], h = {
    data: {
      demerits: 1 / 0
    }
  };
  function d(k, P, N, M, G, z, j) {
    return {
      position: k,
      demerits: P,
      ratio: N,
      line: M,
      fitnessClass: G,
      totals: z || {
        width: 0,
        stretch: 0,
        shrink: 0
      },
      previous: j
    };
  }
  function g(k, P, N, M) {
    var G = o.width - N.totals.width, z = 0, j = 0, R = M < s.length ? s[M - 1] : s[s.length - 1];
    return e[P].type === "penalty" && (G += e[P].width), G < R ? (z = o.stretch - N.totals.stretch, z > 0 ? (R - G) / z : r.infinity) : G > R ? (j = o.shrink - N.totals.shrink, j > 0 ? (R - G) / j : r.infinity) : 0;
  }
  function x(k) {
    for (var P = {
      width: o.width,
      stretch: o.stretch,
      shrink: o.shrink
    }, N = k; N < e.length; N += 1)
      if (e[N].type === "glue")
        P.width += e[N].width, P.stretch += e[N].stretch, P.shrink += e[N].shrink;
      else if (e[N].type === "box" || e[N].type === "penalty" && e[N].penalty === -r.infinity && N > k)
        break;
    return P;
  }
  function _(k, P, N) {
    for (var M = a.first(), G = null, z = 0, j = 0, R = [], te, J = 0, K, ee = 0, ve, de, B; M !== null; ) {
      for (R = [{
        demerits: 1 / 0
      }, {
        demerits: 1 / 0
      }, {
        demerits: 1 / 0
      }, {
        demerits: 1 / 0
      }]; M !== null && (G = M.next, J = M.data.line + 1, z = g(M.data.position, P, M.data, J), (z < -1 || k.type === "penalty" && k.penalty === -r.infinity) && a.remove(M), z >= -1 && z <= i.tolerance && (te = 100 * Math.pow(Math.abs(z), 3), k.type === "penalty" && k.penalty >= 0 ? j = Math.pow(i.demerits.line + te, 2) + Math.pow(k.penalty, 2) : k.type === "penalty" && k.penalty !== -r.infinity ? j = Math.pow(i.demerits.line + te, 2) - Math.pow(k.penalty, 2) : j = Math.pow(i.demerits.line + te, 2), k.type === "penalty" && N[M.data.position].type === "penalty" && (j += i.demerits.flagged * k.flagged * N[M.data.position].flagged), z < -0.5 ? ee = 0 : z <= 0.5 ? ee = 1 : z <= 1 ? ee = 2 : ee = 3, Math.abs(ee - M.data.fitnessClass) > 1 && (j += i.demerits.fitness), j += M.data.demerits, j < R[ee].demerits && (R[ee] = {
        active: M,
        demerits: j,
        ratio: z
      })), M = G, !(M !== null && M.data.line >= J)); )
        ;
      for (K = x(P), ve = 0; ve < R.length; ve += 1)
        de = R[ve], de.demerits < 1 / 0 && (B = new ed.Node(d(P, de.demerits, de.ratio, de.active.data.line + 1, ve, K, de.active)), M !== null ? a.insertBefore(M, B) : a.push(B));
    }
  }
  if (a.push(new ed.Node(d(0, 0, 0, 0, 0, void 0, null))), e.forEach(function(k, P, N) {
    k.type === "box" ? o.width += k.width : k.type === "glue" ? (P > 0 && N[P - 1].type === "box" && _(k, P, N), o.width += k.width, o.stretch += k.stretch, o.shrink += k.shrink) : k.type === "penalty" && k.penalty !== r.infinity && _(k, P, N);
  }), a.size() !== 0) {
    for (a.forEach(function(k) {
      k.data.demerits < h.data.demerits && (h = k);
    }); h !== null; )
      c.push({
        position: h.data.position,
        ratio: h.data.ratio
      }), h = h.data.previous;
    return c.reverse();
  }
  return [];
};
Di.infinity = 1e4;
Di.glue = function(r, e, t, n) {
  return {
    type: "glue",
    value: e,
    width: r,
    stretch: t,
    shrink: n
  };
};
Di.box = function(r, e, t) {
  return t === void 0 && (t = !1), {
    type: "box",
    width: r,
    value: e,
    hyphenated: t
  };
};
Di.penalty = function(r, e, t) {
  return {
    type: "penalty",
    width: r,
    penalty: e,
    flagged: t
  };
};
var Wee = function(e, t) {
  var n = t.start + e, i = t.end + e;
  return Object.assign({}, t, {
    start: n,
    end: i
  });
}, Gee = function(e) {
  return e.end - e.start;
}, Vee = function(e, t) {
  var n = e.end + Gee(t), i = (e.glyphs || []).concat(t.glyphs || []), a = (e.positions || []).concat(t.positions || []), o = Object.assign({}, e.attributes, t.attributes), s = e.glyphIndices || [], c = Qo(s) || 0, h = (t.glyphIndices || []).map(function(g) {
    return g + c + 1;
  }), d = nD(s.concat(h));
  return Object.assign({}, e, {
    end: n,
    glyphs: i,
    positions: a,
    attributes: o,
    glyphIndices: d
  });
}, Yee = function(e, t, n) {
  if (!t) return n;
  var i = $1(0, e, n), a = $1(e, 1 / 0, n);
  return Vee(sD(t, i), a);
}, Hee = function(e, t, n) {
  var i = Bg(n), a = aD(t) ? oD(t, i) : t;
  return Yee(e, a, n);
}, Zee = function(e, t) {
  return Q3(e, t.runs);
}, qee = function(e, t, n) {
  var i = Zee(e, n);
  if (i === -1) return lD(t, n);
  var a = t.codePoints || [], o = n.string.slice(0, e) + uD(a) + n.string.slice(e), s = n.runs.map(function(c, h) {
    return h === i ? Hee(e - c.start, t, c) : h > i ? Wee(a.length, c) : c;
  });
  return Object.assign({}, n, {
    string: o,
    runs: s
  });
}, Xee = function(e, t, n) {
  var i = n.start || 0, a = Math.max(0, Fd(e - i, n)), o = Math.max(0, Fd(t - i, n)), s = (n.positions || []).slice(a, o);
  return gD(s);
}, Kee = function(e, t, n) {
  var i = iD(e, t, n.runs);
  return i.reduce(function(a, o) {
    return a + Xee(e, t, o);
  }, 0);
}, Jee = 45, Qee = 5, ete = 50, lh = {
  width: 3,
  stretch: 6,
  shrink: 9
}, tte = function(e, t, n) {
  var i = 0, a = null, o = n.reduce(function(s, c) {
    var h = t[c.position], d = t[c.position - 1];
    if (c.position === t.length - 1) return s;
    var g;
    return h.type === "penalty" ? (a = d.value.end, g = Wc(i, a, e), g = qee(g.length, Jee, g)) : (a = h.value.end, g = Wc(i, a, e)), i = a, [].concat(s, [g]);
  }, []);
  return o.push(Wc(i, e.string.length, e)), o;
}, rte = function(e, t, n) {
  var i = t.align, a = 0, o = 5, s = e.syllables, c = n.hyphenationPenalty || (i === "justify" ? 100 : 600), h = s.reduce(function(d, g, x) {
    var _ = Kee(a, a + g.length, e);
    if (g.trim() === "") {
      var k = _ * lh.width / lh.stretch, P = _ * lh.width / lh.shrink, N = {
        start: a,
        end: a + g.length
      };
      d.push(Di.glue(_, N, k, P));
    } else {
      var M = s[x + 1] !== " ", G = {
        start: a,
        end: a + g.length
      };
      d.push(Di.box(_, G, M)), s[x + 1] && M && d.push(Di.penalty(o, c, 1));
    }
    return a += g.length, d;
  }, []);
  return h.push(Di.glue(0, null, Di.infinity, 0)), h.push(Di.penalty(0, -Di.infinity, 1)), h;
}, nte = function(e) {
  var t, n;
  return ((t = e.runs) === null || t === void 0 || (n = t[0]) === null || n === void 0 ? void 0 : n.attributes) || {};
}, yD = function(e) {
  return function(t, n) {
    for (var i = e.tolerance || 4, a = nte(t), o = rte(t, a, e), s = Di(o, n, {
      tolerance: i
    }); s.length === 0 && i < ete; )
      i += Qee, s = Di(o, n, {
        tolerance: i
      });
    return (s.length === 0 || s.length === 1 && s[0].position === 0) && (s = zee(o, n)), tte(t, o, s.slice(1));
  };
}, bD = 1, wD = 2, ite = {
  before: 0.5,
  after: 0.5,
  priority: bD,
  unconstrained: !1
}, ate = {
  before: 0.14453125,
  // 37/256
  after: 0.14453125,
  priority: wD,
  unconstrained: !1
}, ote = {
  before: -0.04296875,
  // -11/256
  after: -0.04296875,
  priority: bD,
  unconstrained: !1
}, ste = {
  before: -0.04296875,
  after: -0.04296875,
  priority: wD,
  unconstrained: !1
}, ute = function(e, t) {
  var n = t.expandCharFactor || {}, i = t.shrinkCharFactor || {};
  return e === "GROW" ? Object.assign({}, ate, n) : Object.assign({}, ste, i);
}, lte = function(e, t) {
  var n = t.expandWhitespaceFactor || {}, i = t.shrinkWhitespaceFactor || {};
  return e === "GROW" ? Object.assign({}, ite, n) : Object.assign({}, ote, i);
}, cte = function(e, t) {
  return function(n) {
    for (var i = ute(e, t), a = lte(e, t), o = [], s = 0; s < n.length; s += 1) {
      var c = void 0, h = n[s];
      Mg(h) ? (c = Object.assign({}, a), s === n.length - 1 && (c.before = 0, s > 0 && (o[s - 1].after = 0))) : h.isMark && s > 0 ? (c = Object.assign({}, o[s - 1]), c.before = 0, o[s - 1].after = 0) : c = Object.assign({}, i), o.push(c);
    }
    return o;
  };
}, fte = function(e, t, n) {
  var i = e > 0 ? "GROW" : "SHRINK", a = cte(i, n), o = t.runs.reduce(function(s, c) {
    return s.concat(a(c.glyphs));
  }, []);
  return o[0].before = 0, o[o.length - 1].after = 0, o;
}, tw = 0, L4 = 3, hte = function(e, t) {
  for (var n = 0, i = [], a = [], o = tw; o <= L4; o += 1)
    i[o] = a[o] = 0;
  for (var s = 0; s < t.length; s += 1) {
    var c = t[s], h = c.before + c.after;
    n += h, i[c.priority] += h, c.unconstrained && (a[c.priority] += h);
  }
  var d = -1, g = 0, x = e, _;
  for (_ = tw; _ <= L4; _ += 1) {
    var k = i[_];
    if (k !== 0) {
      if (d === -1 && (d = _, g = k), Math.abs(x) <= Math.abs(k)) {
        i[_] = x / k, a[_] = 0, x = 0;
        break;
      }
      if (i[_] = 1, x -= k, a[_] !== 0) {
        a[_] = x / a[_], x = 0;
        break;
      }
    }
  }
  for (var P = _ + 1; P <= L4; P += 1)
    i[P] = 0, a[P] = 0;
  x > 0 && d > -1 && (i[d] = (g + (e - n)) / g);
  for (var N = [], M = 0; M < t.length; M += 1) {
    var G = t[M], z = t[M + 1], j = G.after * i[G.priority];
    z && (j += z.before * i[z.priority]), G.unconstrained && (j += G.after * a[G.priority], z && (j += z.before * a[z.priority])), N.push(j);
  }
  return N;
}, dte = function(e, t) {
  for (var n = 0, i = ou(t.runs), a; !(a = i()).done; )
    for (var o = a.value, s = ou(o.positions), c; !(c = s()).done; ) {
      var h = c.value;
      h.xAdvance += e[n++];
    }
  return t;
}, AD = function(e) {
  return function(t) {
    var n = t.box.width - Lg(t);
    if (n !== 0) {
      var i = fte(n, t, e), a = hte(n, i);
      return dte(a, t);
    }
  };
}, rw = function(e) {
  var t = function(i, a) {
    return Math.max(i, B5(a));
  };
  return e.runs.reduce(t, 0);
}, pte = 12, xD = function() {
  return function(e) {
    var t = e.overflowLeft || 0, n = e.overflowRight || 0, i = Lg(e) - n;
    e.decorationLines = [];
    for (var a = 0; a < e.runs.length; a += 1) {
      var o = e.runs[a], s = Math.min(i - t, Ng(o)), c = Math.max(0.5, Math.floor(o.attributes.fontSize / pte));
      if (o.attributes.underline) {
        var h = {
          x: t,
          y: rw(e) + c * 2,
          width: s,
          height: c
        }, d = {
          rect: h,
          opacity: o.attributes.opacity,
          color: o.attributes.underlineColor || "black",
          style: o.attributes.underlineStyle || "solid"
        };
        e.decorationLines.push(d);
      }
      if (o.attributes.strike) {
        var g = rw(e) - B5(o) / 3, x = {
          x: t,
          y: g,
          width: s,
          height: c
        }, _ = {
          rect: x,
          opacity: o.attributes.opacity,
          color: o.attributes.strikeColor || "black",
          style: o.attributes.strikeStyle || "solid"
        };
        e.decorationLines.push(_);
      }
      t += s;
    }
    return e;
  };
}, vte = ["Common", "Inherited", "Unknown"], ED = function() {
  return function(e) {
    var t = e.string, n = "Unknown", i = 0, a = 0, o = [];
    if (!t) return vD();
    for (var s = 0; s < t.length; s += 1) {
      var c = t[s], h = c.codePointAt(), d = mS.getScript(h);
      d !== n && !vte.includes(d) && (n !== "Unknown" && o.push({
        start: i,
        end: a,
        attributes: {
          script: n
        }
      }), i = a, n = d), a += c.length;
    }
    return i < t.length && o.push({
      start: i,
      end: t.length,
      attributes: {
        script: n
      }
    }), {
      string: t,
      runs: o
    };
  };
}, _D = "­", gte = pQ(gQ), mte = function(e) {
  return e.split(_D);
}, ch = {}, yte = function(e) {
  var t = e.includes(_D) ? e : gte(e);
  return mte(t);
}, DD = function() {
  return function(e) {
    var t = "_" + e;
    return zr(e) ? [] : (ch[t] || (ch[t] = yte(e)), ch[t]);
  };
};
const bte = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC08\uDC26](?:\u200D\u2B1B)?|[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
var nw = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, co = [], ea = [], wte = typeof Uint8Array < "u" ? Uint8Array : Array, Ug = !1;
function TD() {
  Ug = !0;
  for (var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, t = r.length; e < t; ++e)
    co[e] = r[e], ea[r.charCodeAt(e)] = e;
  ea[45] = 62, ea[95] = 63;
}
function Ate(r) {
  Ug || TD();
  var e, t, n, i, a, o, s = r.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  a = r[s - 2] === "=" ? 2 : r[s - 1] === "=" ? 1 : 0, o = new wte(s * 3 / 4 - a), n = a > 0 ? s - 4 : s;
  var c = 0;
  for (e = 0, t = 0; e < n; e += 4, t += 3)
    i = ea[r.charCodeAt(e)] << 18 | ea[r.charCodeAt(e + 1)] << 12 | ea[r.charCodeAt(e + 2)] << 6 | ea[r.charCodeAt(e + 3)], o[c++] = i >> 16 & 255, o[c++] = i >> 8 & 255, o[c++] = i & 255;
  return a === 2 ? (i = ea[r.charCodeAt(e)] << 2 | ea[r.charCodeAt(e + 1)] >> 4, o[c++] = i & 255) : a === 1 && (i = ea[r.charCodeAt(e)] << 10 | ea[r.charCodeAt(e + 1)] << 4 | ea[r.charCodeAt(e + 2)] >> 2, o[c++] = i >> 8 & 255, o[c++] = i & 255), o;
}
function xte(r) {
  return co[r >> 18 & 63] + co[r >> 12 & 63] + co[r >> 6 & 63] + co[r & 63];
}
function Ete(r, e, t) {
  for (var n, i = [], a = e; a < t; a += 3)
    n = (r[a] << 16) + (r[a + 1] << 8) + r[a + 2], i.push(xte(n));
  return i.join("");
}
function iw(r) {
  Ug || TD();
  for (var e, t = r.length, n = t % 3, i = "", a = [], o = 16383, s = 0, c = t - n; s < c; s += o)
    a.push(Ete(r, s, s + o > c ? c : s + o));
  return n === 1 ? (e = r[t - 1], i += co[e >> 2], i += co[e << 4 & 63], i += "==") : n === 2 && (e = (r[t - 2] << 8) + r[t - 1], i += co[e >> 10], i += co[e >> 4 & 63], i += co[e << 2 & 63], i += "="), a.push(i), a.join("");
}
function N5(r, e, t, n, i) {
  var a, o, s = i * 8 - n - 1, c = (1 << s) - 1, h = c >> 1, d = -7, g = t ? i - 1 : 0, x = t ? -1 : 1, _ = r[e + g];
  for (g += x, a = _ & (1 << -d) - 1, _ >>= -d, d += s; d > 0; a = a * 256 + r[e + g], g += x, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += n; d > 0; o = o * 256 + r[e + g], g += x, d -= 8)
    ;
  if (a === 0)
    a = 1 - h;
  else {
    if (a === c)
      return o ? NaN : (_ ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), a = a - h;
  }
  return (_ ? -1 : 1) * o * Math.pow(2, a - n);
}
function kD(r, e, t, n, i, a) {
  var o, s, c, h = a * 8 - i - 1, d = (1 << h) - 1, g = d >> 1, x = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, _ = n ? 0 : a - 1, k = n ? 1 : -1, P = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + g >= 1 ? e += x / c : e += x * Math.pow(2, 1 - g), e * c >= 2 && (o++, c /= 2), o + g >= d ? (s = 0, o = d) : o + g >= 1 ? (s = (e * c - 1) * Math.pow(2, i), o = o + g) : (s = e * Math.pow(2, g - 1) * Math.pow(2, i), o = 0)); i >= 8; r[t + _] = s & 255, _ += k, s /= 256, i -= 8)
    ;
  for (o = o << i | s, h += i; h > 0; r[t + _] = o & 255, _ += k, o /= 256, h -= 8)
    ;
  r[t + _ - k] |= P * 128;
}
var _te = {}.toString, SD = Array.isArray || function(r) {
  return _te.call(r) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var Dte = 50;
ht.TYPED_ARRAY_SUPPORT = nw.TYPED_ARRAY_SUPPORT !== void 0 ? nw.TYPED_ARRAY_SUPPORT : !0;
function ev() {
  return ht.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Jo(r, e) {
  if (ev() < e)
    throw new RangeError("Invalid typed array length");
  return ht.TYPED_ARRAY_SUPPORT ? (r = new Uint8Array(e), r.__proto__ = ht.prototype) : (r === null && (r = new ht(e)), r.length = e), r;
}
function ht(r, e, t) {
  if (!ht.TYPED_ARRAY_SUPPORT && !(this instanceof ht))
    return new ht(r, e, t);
  if (typeof r == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return $g(this, r);
  }
  return CD(this, r, e, t);
}
ht.poolSize = 8192;
ht._augment = function(r) {
  return r.__proto__ = ht.prototype, r;
};
function CD(r, e, t, n) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? Ste(r, e, t, n) : typeof e == "string" ? kte(r, e, t) : Cte(r, e);
}
ht.from = function(r, e, t) {
  return CD(null, r, e, t);
};
ht.TYPED_ARRAY_SUPPORT && (ht.prototype.__proto__ = Uint8Array.prototype, ht.__proto__ = Uint8Array);
function FD(r) {
  if (typeof r != "number")
    throw new TypeError('"size" argument must be a number');
  if (r < 0)
    throw new RangeError('"size" argument must not be negative');
}
function Tte(r, e, t, n) {
  return FD(e), e <= 0 ? Jo(r, e) : t !== void 0 ? typeof n == "string" ? Jo(r, e).fill(t, n) : Jo(r, e).fill(t) : Jo(r, e);
}
ht.alloc = function(r, e, t) {
  return Tte(null, r, e, t);
};
function $g(r, e) {
  if (FD(e), r = Jo(r, e < 0 ? 0 : zg(e) | 0), !ht.TYPED_ARRAY_SUPPORT)
    for (var t = 0; t < e; ++t)
      r[t] = 0;
  return r;
}
ht.allocUnsafe = function(r) {
  return $g(null, r);
};
ht.allocUnsafeSlow = function(r) {
  return $g(null, r);
};
function kte(r, e, t) {
  if ((typeof t != "string" || t === "") && (t = "utf8"), !ht.isEncoding(t))
    throw new TypeError('"encoding" must be a valid string encoding');
  var n = OD(e, t) | 0;
  r = Jo(r, n);
  var i = r.write(e, t);
  return i !== n && (r = r.slice(0, i)), r;
}
function tv(r, e) {
  var t = e.length < 0 ? 0 : zg(e.length) | 0;
  r = Jo(r, t);
  for (var n = 0; n < t; n += 1)
    r[n] = e[n] & 255;
  return r;
}
function Ste(r, e, t, n) {
  if (e.byteLength, t < 0 || e.byteLength < t)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < t + (n || 0))
    throw new RangeError("'length' is out of bounds");
  return t === void 0 && n === void 0 ? e = new Uint8Array(e) : n === void 0 ? e = new Uint8Array(e, t) : e = new Uint8Array(e, t, n), ht.TYPED_ARRAY_SUPPORT ? (r = e, r.__proto__ = ht.prototype) : r = tv(r, e), r;
}
function Cte(r, e) {
  if (Ao(e)) {
    var t = zg(e.length) | 0;
    return r = Jo(r, t), r.length === 0 || e.copy(r, 0, 0, t), r;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || Zte(e.length) ? Jo(r, 0) : tv(r, e);
    if (e.type === "Buffer" && SD(e.data))
      return tv(r, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function zg(r) {
  if (r >= ev())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + ev().toString(16) + " bytes");
  return r | 0;
}
ht.isBuffer = qte;
function Ao(r) {
  return !!(r != null && r._isBuffer);
}
ht.compare = function(e, t) {
  if (!Ao(e) || !Ao(t))
    throw new TypeError("Arguments must be Buffers");
  if (e === t) return 0;
  for (var n = e.length, i = t.length, a = 0, o = Math.min(n, i); a < o; ++a)
    if (e[a] !== t[a]) {
      n = e[a], i = t[a];
      break;
    }
  return n < i ? -1 : i < n ? 1 : 0;
};
ht.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
ht.concat = function(e, t) {
  if (!SD(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return ht.alloc(0);
  var n;
  if (t === void 0)
    for (t = 0, n = 0; n < e.length; ++n)
      t += e[n].length;
  var i = ht.allocUnsafe(t), a = 0;
  for (n = 0; n < e.length; ++n) {
    var o = e[n];
    if (!Ao(o))
      throw new TypeError('"list" argument must be an Array of Buffers');
    o.copy(i, a), a += o.length;
  }
  return i;
};
function OD(r, e) {
  if (Ao(r))
    return r.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(r) || r instanceof ArrayBuffer))
    return r.byteLength;
  typeof r != "string" && (r = "" + r);
  var t = r.length;
  if (t === 0) return 0;
  for (var n = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return t;
      case "utf8":
      case "utf-8":
      case void 0:
        return Od(r).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t * 2;
      case "hex":
        return t >>> 1;
      case "base64":
        return MD(r).length;
      default:
        if (n) return Od(r).length;
        e = ("" + e).toLowerCase(), n = !0;
    }
}
ht.byteLength = OD;
function Fte(r, e, t) {
  var n = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, e >>>= 0, t <= e))
    return "";
  for (r || (r = "utf8"); ; )
    switch (r) {
      case "hex":
        return $te(this, e, t);
      case "utf8":
      case "utf-8":
        return PD(this, e, t);
      case "ascii":
        return Mte(this, e, t);
      case "latin1":
      case "binary":
        return Ute(this, e, t);
      case "base64":
        return Nte(this, e, t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return zte(this, e, t);
      default:
        if (n) throw new TypeError("Unknown encoding: " + r);
        r = (r + "").toLowerCase(), n = !0;
    }
}
ht.prototype._isBuffer = !0;
function ll(r, e, t) {
  var n = r[e];
  r[e] = r[t], r[t] = n;
}
ht.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < e; t += 2)
    ll(this, t, t + 1);
  return this;
};
ht.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < e; t += 4)
    ll(this, t, t + 3), ll(this, t + 1, t + 2);
  return this;
};
ht.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < e; t += 8)
    ll(this, t, t + 7), ll(this, t + 1, t + 6), ll(this, t + 2, t + 5), ll(this, t + 3, t + 4);
  return this;
};
ht.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? PD(this, 0, e) : Fte.apply(this, arguments);
};
ht.prototype.equals = function(e) {
  if (!Ao(e)) throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : ht.compare(this, e) === 0;
};
ht.prototype.inspect = function() {
  var e = "", t = Dte;
  return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
};
ht.prototype.compare = function(e, t, n, i, a) {
  if (!Ao(e))
    throw new TypeError("Argument must be a Buffer");
  if (t === void 0 && (t = 0), n === void 0 && (n = e ? e.length : 0), i === void 0 && (i = 0), a === void 0 && (a = this.length), t < 0 || n > e.length || i < 0 || a > this.length)
    throw new RangeError("out of range index");
  if (i >= a && t >= n)
    return 0;
  if (i >= a)
    return -1;
  if (t >= n)
    return 1;
  if (t >>>= 0, n >>>= 0, i >>>= 0, a >>>= 0, this === e) return 0;
  for (var o = a - i, s = n - t, c = Math.min(o, s), h = this.slice(i, a), d = e.slice(t, n), g = 0; g < c; ++g)
    if (h[g] !== d[g]) {
      o = h[g], s = d[g];
      break;
    }
  return o < s ? -1 : s < o ? 1 : 0;
};
function RD(r, e, t, n, i) {
  if (r.length === 0) return -1;
  if (typeof t == "string" ? (n = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = i ? 0 : r.length - 1), t < 0 && (t = r.length + t), t >= r.length) {
    if (i) return -1;
    t = r.length - 1;
  } else if (t < 0)
    if (i) t = 0;
    else return -1;
  if (typeof e == "string" && (e = ht.from(e, n)), Ao(e))
    return e.length === 0 ? -1 : aw(r, e, t, n, i);
  if (typeof e == "number")
    return e = e & 255, ht.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(r, e, t) : Uint8Array.prototype.lastIndexOf.call(r, e, t) : aw(r, [e], t, n, i);
  throw new TypeError("val must be string, number or Buffer");
}
function aw(r, e, t, n, i) {
  var a = 1, o = r.length, s = e.length;
  if (n !== void 0 && (n = String(n).toLowerCase(), n === "ucs2" || n === "ucs-2" || n === "utf16le" || n === "utf-16le")) {
    if (r.length < 2 || e.length < 2)
      return -1;
    a = 2, o /= 2, s /= 2, t /= 2;
  }
  function c(_, k) {
    return a === 1 ? _[k] : _.readUInt16BE(k * a);
  }
  var h;
  if (i) {
    var d = -1;
    for (h = t; h < o; h++)
      if (c(r, h) === c(e, d === -1 ? 0 : h - d)) {
        if (d === -1 && (d = h), h - d + 1 === s) return d * a;
      } else
        d !== -1 && (h -= h - d), d = -1;
  } else
    for (t + s > o && (t = o - s), h = t; h >= 0; h--) {
      for (var g = !0, x = 0; x < s; x++)
        if (c(r, h + x) !== c(e, x)) {
          g = !1;
          break;
        }
      if (g) return h;
    }
  return -1;
}
ht.prototype.includes = function(e, t, n) {
  return this.indexOf(e, t, n) !== -1;
};
ht.prototype.indexOf = function(e, t, n) {
  return RD(this, e, t, n, !0);
};
ht.prototype.lastIndexOf = function(e, t, n) {
  return RD(this, e, t, n, !1);
};
function Ote(r, e, t, n) {
  t = Number(t) || 0;
  var i = r.length - t;
  n ? (n = Number(n), n > i && (n = i)) : n = i;
  var a = e.length;
  if (a % 2 !== 0) throw new TypeError("Invalid hex string");
  n > a / 2 && (n = a / 2);
  for (var o = 0; o < n; ++o) {
    var s = parseInt(e.substr(o * 2, 2), 16);
    if (isNaN(s)) return o;
    r[t + o] = s;
  }
  return o;
}
function Rte(r, e, t, n) {
  return U5(Od(e, r.length - t), r, t, n);
}
function ID(r, e, t, n) {
  return U5(Yte(e), r, t, n);
}
function Ite(r, e, t, n) {
  return ID(r, e, t, n);
}
function Pte(r, e, t, n) {
  return U5(MD(e), r, t, n);
}
function Bte(r, e, t, n) {
  return U5(Hte(e, r.length - t), r, t, n);
}
ht.prototype.write = function(e, t, n, i) {
  if (t === void 0)
    i = "utf8", n = this.length, t = 0;
  else if (n === void 0 && typeof t == "string")
    i = t, n = this.length, t = 0;
  else if (isFinite(t))
    t = t | 0, isFinite(n) ? (n = n | 0, i === void 0 && (i = "utf8")) : (i = n, n = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var a = this.length - t;
  if ((n === void 0 || n > a) && (n = a), e.length > 0 && (n < 0 || t < 0) || t > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var o = !1; ; )
    switch (i) {
      case "hex":
        return Ote(this, e, t, n);
      case "utf8":
      case "utf-8":
        return Rte(this, e, t, n);
      case "ascii":
        return ID(this, e, t, n);
      case "latin1":
      case "binary":
        return Ite(this, e, t, n);
      case "base64":
        return Pte(this, e, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return Bte(this, e, t, n);
      default:
        if (o) throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), o = !0;
    }
};
ht.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function Nte(r, e, t) {
  return e === 0 && t === r.length ? iw(r) : iw(r.slice(e, t));
}
function PD(r, e, t) {
  t = Math.min(r.length, t);
  for (var n = [], i = e; i < t; ) {
    var a = r[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
    if (i + s <= t) {
      var c, h, d, g;
      switch (s) {
        case 1:
          a < 128 && (o = a);
          break;
        case 2:
          c = r[i + 1], (c & 192) === 128 && (g = (a & 31) << 6 | c & 63, g > 127 && (o = g));
          break;
        case 3:
          c = r[i + 1], h = r[i + 2], (c & 192) === 128 && (h & 192) === 128 && (g = (a & 15) << 12 | (c & 63) << 6 | h & 63, g > 2047 && (g < 55296 || g > 57343) && (o = g));
          break;
        case 4:
          c = r[i + 1], h = r[i + 2], d = r[i + 3], (c & 192) === 128 && (h & 192) === 128 && (d & 192) === 128 && (g = (a & 15) << 18 | (c & 63) << 12 | (h & 63) << 6 | d & 63, g > 65535 && g < 1114112 && (o = g));
      }
    }
    o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), n.push(o), i += s;
  }
  return Lte(n);
}
var ow = 4096;
function Lte(r) {
  var e = r.length;
  if (e <= ow)
    return String.fromCharCode.apply(String, r);
  for (var t = "", n = 0; n < e; )
    t += String.fromCharCode.apply(
      String,
      r.slice(n, n += ow)
    );
  return t;
}
function Mte(r, e, t) {
  var n = "";
  t = Math.min(r.length, t);
  for (var i = e; i < t; ++i)
    n += String.fromCharCode(r[i] & 127);
  return n;
}
function Ute(r, e, t) {
  var n = "";
  t = Math.min(r.length, t);
  for (var i = e; i < t; ++i)
    n += String.fromCharCode(r[i]);
  return n;
}
function $te(r, e, t) {
  var n = r.length;
  (!e || e < 0) && (e = 0), (!t || t < 0 || t > n) && (t = n);
  for (var i = "", a = e; a < t; ++a)
    i += Vte(r[a]);
  return i;
}
function zte(r, e, t) {
  for (var n = r.slice(e, t), i = "", a = 0; a < n.length; a += 2)
    i += String.fromCharCode(n[a] + n[a + 1] * 256);
  return i;
}
ht.prototype.slice = function(e, t) {
  var n = this.length;
  e = ~~e, t = t === void 0 ? n : ~~t, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), t < 0 ? (t += n, t < 0 && (t = 0)) : t > n && (t = n), t < e && (t = e);
  var i;
  if (ht.TYPED_ARRAY_SUPPORT)
    i = this.subarray(e, t), i.__proto__ = ht.prototype;
  else {
    var a = t - e;
    i = new ht(a, void 0);
    for (var o = 0; o < a; ++o)
      i[o] = this[o + e];
  }
  return i;
};
function hn(r, e, t) {
  if (r % 1 !== 0 || r < 0) throw new RangeError("offset is not uint");
  if (r + e > t) throw new RangeError("Trying to access beyond buffer length");
}
ht.prototype.readUIntLE = function(e, t, n) {
  e = e | 0, t = t | 0, n || hn(e, t, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < t && (a *= 256); )
    i += this[e + o] * a;
  return i;
};
ht.prototype.readUIntBE = function(e, t, n) {
  e = e | 0, t = t | 0, n || hn(e, t, this.length);
  for (var i = this[e + --t], a = 1; t > 0 && (a *= 256); )
    i += this[e + --t] * a;
  return i;
};
ht.prototype.readUInt8 = function(e, t) {
  return t || hn(e, 1, this.length), this[e];
};
ht.prototype.readUInt16LE = function(e, t) {
  return t || hn(e, 2, this.length), this[e] | this[e + 1] << 8;
};
ht.prototype.readUInt16BE = function(e, t) {
  return t || hn(e, 2, this.length), this[e] << 8 | this[e + 1];
};
ht.prototype.readUInt32LE = function(e, t) {
  return t || hn(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
ht.prototype.readUInt32BE = function(e, t) {
  return t || hn(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
ht.prototype.readIntLE = function(e, t, n) {
  e = e | 0, t = t | 0, n || hn(e, t, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < t && (a *= 256); )
    i += this[e + o] * a;
  return a *= 128, i >= a && (i -= Math.pow(2, 8 * t)), i;
};
ht.prototype.readIntBE = function(e, t, n) {
  e = e | 0, t = t | 0, n || hn(e, t, this.length);
  for (var i = t, a = 1, o = this[e + --i]; i > 0 && (a *= 256); )
    o += this[e + --i] * a;
  return a *= 128, o >= a && (o -= Math.pow(2, 8 * t)), o;
};
ht.prototype.readInt8 = function(e, t) {
  return t || hn(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
ht.prototype.readInt16LE = function(e, t) {
  t || hn(e, 2, this.length);
  var n = this[e] | this[e + 1] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
ht.prototype.readInt16BE = function(e, t) {
  t || hn(e, 2, this.length);
  var n = this[e + 1] | this[e] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
ht.prototype.readInt32LE = function(e, t) {
  return t || hn(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
ht.prototype.readInt32BE = function(e, t) {
  return t || hn(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
ht.prototype.readFloatLE = function(e, t) {
  return t || hn(e, 4, this.length), N5(this, e, !0, 23, 4);
};
ht.prototype.readFloatBE = function(e, t) {
  return t || hn(e, 4, this.length), N5(this, e, !1, 23, 4);
};
ht.prototype.readDoubleLE = function(e, t) {
  return t || hn(e, 8, this.length), N5(this, e, !0, 52, 8);
};
ht.prototype.readDoubleBE = function(e, t) {
  return t || hn(e, 8, this.length), N5(this, e, !1, 52, 8);
};
function vi(r, e, t, n, i, a) {
  if (!Ao(r)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > i || e < a) throw new RangeError('"value" argument is out of bounds');
  if (t + n > r.length) throw new RangeError("Index out of range");
}
ht.prototype.writeUIntLE = function(e, t, n, i) {
  if (e = +e, t = t | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    vi(this, e, t, n, a, 0);
  }
  var o = 1, s = 0;
  for (this[t] = e & 255; ++s < n && (o *= 256); )
    this[t + s] = e / o & 255;
  return t + n;
};
ht.prototype.writeUIntBE = function(e, t, n, i) {
  if (e = +e, t = t | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    vi(this, e, t, n, a, 0);
  }
  var o = n - 1, s = 1;
  for (this[t + o] = e & 255; --o >= 0 && (s *= 256); )
    this[t + o] = e / s & 255;
  return t + n;
};
ht.prototype.writeUInt8 = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 1, 255, 0), ht.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = e & 255, t + 1;
};
function L5(r, e, t, n) {
  e < 0 && (e = 65535 + e + 1);
  for (var i = 0, a = Math.min(r.length - t, 2); i < a; ++i)
    r[t + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> (n ? i : 1 - i) * 8;
}
ht.prototype.writeUInt16LE = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 2, 65535, 0), ht.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : L5(this, e, t, !0), t + 2;
};
ht.prototype.writeUInt16BE = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 2, 65535, 0), ht.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : L5(this, e, t, !1), t + 2;
};
function M5(r, e, t, n) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var i = 0, a = Math.min(r.length - t, 4); i < a; ++i)
    r[t + i] = e >>> (n ? i : 3 - i) * 8 & 255;
}
ht.prototype.writeUInt32LE = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 4, 4294967295, 0), ht.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255) : M5(this, e, t, !0), t + 4;
};
ht.prototype.writeUInt32BE = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 4, 4294967295, 0), ht.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : M5(this, e, t, !1), t + 4;
};
ht.prototype.writeIntLE = function(e, t, n, i) {
  if (e = +e, t = t | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    vi(this, e, t, n, a - 1, -a);
  }
  var o = 0, s = 1, c = 0;
  for (this[t] = e & 255; ++o < n && (s *= 256); )
    e < 0 && c === 0 && this[t + o - 1] !== 0 && (c = 1), this[t + o] = (e / s >> 0) - c & 255;
  return t + n;
};
ht.prototype.writeIntBE = function(e, t, n, i) {
  if (e = +e, t = t | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    vi(this, e, t, n, a - 1, -a);
  }
  var o = n - 1, s = 1, c = 0;
  for (this[t + o] = e & 255; --o >= 0 && (s *= 256); )
    e < 0 && c === 0 && this[t + o + 1] !== 0 && (c = 1), this[t + o] = (e / s >> 0) - c & 255;
  return t + n;
};
ht.prototype.writeInt8 = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 1, 127, -128), ht.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
};
ht.prototype.writeInt16LE = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 2, 32767, -32768), ht.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : L5(this, e, t, !0), t + 2;
};
ht.prototype.writeInt16BE = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 2, 32767, -32768), ht.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : L5(this, e, t, !1), t + 2;
};
ht.prototype.writeInt32LE = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 4, 2147483647, -2147483648), ht.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : M5(this, e, t, !0), t + 4;
};
ht.prototype.writeInt32BE = function(e, t, n) {
  return e = +e, t = t | 0, n || vi(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), ht.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : M5(this, e, t, !1), t + 4;
};
function BD(r, e, t, n, i, a) {
  if (t + n > r.length) throw new RangeError("Index out of range");
  if (t < 0) throw new RangeError("Index out of range");
}
function ND(r, e, t, n, i) {
  return i || BD(r, e, t, 4), kD(r, e, t, n, 23, 4), t + 4;
}
ht.prototype.writeFloatLE = function(e, t, n) {
  return ND(this, e, t, !0, n);
};
ht.prototype.writeFloatBE = function(e, t, n) {
  return ND(this, e, t, !1, n);
};
function LD(r, e, t, n, i) {
  return i || BD(r, e, t, 8), kD(r, e, t, n, 52, 8), t + 8;
}
ht.prototype.writeDoubleLE = function(e, t, n) {
  return LD(this, e, t, !0, n);
};
ht.prototype.writeDoubleBE = function(e, t, n) {
  return LD(this, e, t, !1, n);
};
ht.prototype.copy = function(e, t, n, i) {
  if (n || (n = 0), !i && i !== 0 && (i = this.length), t >= e.length && (t = e.length), t || (t = 0), i > 0 && i < n && (i = n), i === n || e.length === 0 || this.length === 0) return 0;
  if (t < 0)
    throw new RangeError("targetStart out of bounds");
  if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
  if (i < 0) throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), e.length - t < i - n && (i = e.length - t + n);
  var a = i - n, o;
  if (this === e && n < t && t < i)
    for (o = a - 1; o >= 0; --o)
      e[o + t] = this[o + n];
  else if (a < 1e3 || !ht.TYPED_ARRAY_SUPPORT)
    for (o = 0; o < a; ++o)
      e[o + t] = this[o + n];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(n, n + a),
      t
    );
  return a;
};
ht.prototype.fill = function(e, t, n, i) {
  if (typeof e == "string") {
    if (typeof t == "string" ? (i = t, t = 0, n = this.length) : typeof n == "string" && (i = n, n = this.length), e.length === 1) {
      var a = e.charCodeAt(0);
      a < 256 && (e = a);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !ht.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else typeof e == "number" && (e = e & 255);
  if (t < 0 || this.length < t || this.length < n)
    throw new RangeError("Out of range index");
  if (n <= t)
    return this;
  t = t >>> 0, n = n === void 0 ? this.length : n >>> 0, e || (e = 0);
  var o;
  if (typeof e == "number")
    for (o = t; o < n; ++o)
      this[o] = e;
  else {
    var s = Ao(e) ? e : Od(new ht(e, i).toString()), c = s.length;
    for (o = 0; o < n - t; ++o)
      this[o + t] = s[o % c];
  }
  return this;
};
var jte = /[^+\/0-9A-Za-z-_]/g;
function Wte(r) {
  if (r = Gte(r).replace(jte, ""), r.length < 2) return "";
  for (; r.length % 4 !== 0; )
    r = r + "=";
  return r;
}
function Gte(r) {
  return r.trim ? r.trim() : r.replace(/^\s+|\s+$/g, "");
}
function Vte(r) {
  return r < 16 ? "0" + r.toString(16) : r.toString(16);
}
function Od(r, e) {
  e = e || 1 / 0;
  for (var t, n = r.length, i = null, a = [], o = 0; o < n; ++o) {
    if (t = r.charCodeAt(o), t > 55295 && t < 57344) {
      if (!i) {
        if (t > 56319) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        } else if (o + 1 === n) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        i = t;
        continue;
      }
      if (t < 56320) {
        (e -= 3) > -1 && a.push(239, 191, 189), i = t;
        continue;
      }
      t = (i - 55296 << 10 | t - 56320) + 65536;
    } else i && (e -= 3) > -1 && a.push(239, 191, 189);
    if (i = null, t < 128) {
      if ((e -= 1) < 0) break;
      a.push(t);
    } else if (t < 2048) {
      if ((e -= 2) < 0) break;
      a.push(
        t >> 6 | 192,
        t & 63 | 128
      );
    } else if (t < 65536) {
      if ((e -= 3) < 0) break;
      a.push(
        t >> 12 | 224,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else if (t < 1114112) {
      if ((e -= 4) < 0) break;
      a.push(
        t >> 18 | 240,
        t >> 12 & 63 | 128,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return a;
}
function Yte(r) {
  for (var e = [], t = 0; t < r.length; ++t)
    e.push(r.charCodeAt(t) & 255);
  return e;
}
function Hte(r, e) {
  for (var t, n, i, a = [], o = 0; o < r.length && !((e -= 2) < 0); ++o)
    t = r.charCodeAt(o), n = t >> 8, i = t % 256, a.push(i), a.push(n);
  return a;
}
function MD(r) {
  return Ate(Wte(r));
}
function U5(r, e, t, n) {
  for (var i = 0; i < n && !(i + t >= e.length || i >= r.length); ++i)
    e[i + t] = r[i];
  return i;
}
function Zte(r) {
  return r !== r;
}
function qte(r) {
  return r != null && (!!r._isBuffer || UD(r) || Xte(r));
}
function UD(r) {
  return !!r.constructor && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
function Xte(r) {
  return typeof r.readFloatLE == "function" && typeof r.slice == "function" && UD(r.slice(0, 0));
}
I1.isValid = function(r) {
  try {
    return !!new I1(r);
  } catch {
    return !1;
  }
};
var Rd = [65472, 65473, 65474, 65475, 65477, 65478, 65479, 65480, 65481, 65482, 65483, 65484, 65485, 65486, 65487], jg = function(e) {
  if (this.data = null, this.width = null, this.height = null, this.data = e, e.readUInt16BE(0) !== 65496)
    throw new Error("SOI not found in JPEG");
  for (var t, n = 2; n < e.length && (t = e.readUInt16BE(n), n += 2, !Rd.includes(t)); )
    n += e.readUInt16BE(n);
  if (!Rd.includes(t))
    throw new Error("Invalid JPEG.");
  n += 3, this.height = e.readUInt16BE(n), n += 2, this.width = e.readUInt16BE(n);
};
jg.isValid = function(r) {
  if (!r || !ht.isBuffer(r) || r.readUInt16BE(0) !== 65496)
    return !1;
  for (var e, t = 2; t < r.length && (e = r.readUInt16BE(t), t += 2, !Rd.includes(e)); )
    t += r.readUInt16BE(t);
  return !!Rd.includes(e);
};
var Kte = function(e) {
  var t = e === void 0 ? {} : e, n = t.limit, i = n === void 0 ? 100 : n, a = {}, o = [];
  return {
    get: function(c) {
      return a[c];
    },
    set: function(c, h) {
      o.push(c), o.length > i && delete a[o.shift()], a[c] = h;
    },
    reset: function() {
      a = {}, o = [];
    },
    length: function() {
      return o.length;
    }
  };
}, M4 = Kte({
  limit: 30
}), Jte = /* @__PURE__ */ function() {
  var r = ui(/* @__PURE__ */ qr().mark(function e(t, n) {
    var i, a;
    return qr().wrap(function(s) {
      for (; ; ) switch (s.prev = s.next) {
        case 0:
          return s.next = 2, Ww(t, n);
        case 2:
          return i = s.sent, s.next = 5, i.buffer ? i.buffer() : i.arrayBuffer();
        case 5:
          return a = s.sent, s.abrupt("return", a.constructor.name === "Buffer" ? a : ht.from(a));
        case 7:
        case "end":
          return s.stop();
      }
    }, e);
  }));
  return function(t, n) {
    return r.apply(this, arguments);
  };
}(), Qte = function(e) {
  var t = e.toLowerCase();
  return t === "jpg" || t === "jpeg" || t === "png";
}, ere = function(e) {
  var t;
  return jg.isValid(e) ? t = "jpg" : I1.isValid(e) && (t = "png"), t;
}, tre = function(e) {
  var t = e.uri;
  return /^data:image\/[a-zA-Z]*;base64,[^"]*/g.test(t);
};
function $5(r, e) {
  switch (e.toLowerCase()) {
    case "jpg":
    case "jpeg":
      return new jg(r);
    case "png":
      return new I1(r);
    default:
      return null;
  }
}
var rre = function(e) {
  var t = e.uri, n = /^data:image\/([a-zA-Z]*);base64,([^"]*)/g.exec(t), i = n[1], a = n[2];
  if (!Qte(i))
    throw new Error("Base64 image invalid format: " + i);
  return new Promise(function(o) {
    return o($5(ht.from(a, "base64"), i));
  });
}, nre = function(e) {
  if (e.data && e.format)
    return new Promise(function(t) {
      return t($5(e.data, e.format));
    });
  throw new Error("Invalid data given for local file: " + JSON.stringify(e));
}, ire = function(e) {
  var t = ere(e);
  return t ? new Promise(function(n) {
    return n($5(e, t));
  }) : Promise.resolve();
}, are = function(e) {
  var t = e[0] === 137 && e[1] === 80 && e[2] === 78 && e[3] === 71 && e[4] === 13 && e[5] === 10 && e[6] === 26 && e[7] === 10, n = e[0] === 255 && e[1] === 216 && e[2] === 255, i = "";
  if (t)
    i = "png";
  else if (n)
    i = "jpg";
  else
    throw new Error("Not valid image extension");
  return i;
}, ore = /* @__PURE__ */ function() {
  var r = ui(/* @__PURE__ */ qr().mark(function e(t) {
    var n, i, a, o, s, c, h;
    return qr().wrap(function(g) {
      for (; ; ) switch (g.prev = g.next) {
        case 0:
          n = t.uri, i = t.body, a = t.headers, o = t.method, s = o === void 0 ? "GET" : o;
          {
            g.next = 7;
            break;
          }
        case 4:
          g.t0 = g.sent, g.next = 10;
          break;
        case 7:
          return g.next = 9, Jte(n, {
            body: i,
            headers: a,
            method: s
          });
        case 9:
          g.t0 = g.sent;
        case 10:
          return c = g.t0, h = are(c), g.abrupt("return", $5(c, h));
        case 13:
        case "end":
          return g.stop();
      }
    }, e);
  }));
  return function(t) {
    return r.apply(this, arguments);
  };
}(), $D = function(e, t) {
  var n = t === void 0 ? {} : t, i = n.cache, a = i === void 0 ? !0 : i, o, s = e.data ? e.data.toString() : e.uri;
  if (ht.isBuffer(e))
    o = ire(e);
  else {
    if (a && M4.get(s))
      return M4.get(s);
    tre(e) ? o = rre(e) : typeof e == "object" && e.data ? o = nre(e) : o = ore(e);
  }
  if (!o)
    throw new Error("Cannot resolve image");
  return a && M4.set(s, o), o;
}, Rt = {};
Rt.ALIGN_AUTO = 0;
Rt.ALIGN_FLEX_START = 1;
Rt.ALIGN_CENTER = 2;
Rt.ALIGN_FLEX_END = 3;
Rt.ALIGN_STRETCH = 4;
Rt.ALIGN_BASELINE = 5;
Rt.ALIGN_SPACE_BETWEEN = 6;
Rt.ALIGN_SPACE_AROUND = 7;
Rt.DIMENSION_WIDTH = 0;
Rt.DIMENSION_HEIGHT = 1;
Rt.DIRECTION_INHERIT = 0;
Rt.DIRECTION_LTR = 1;
Rt.DIRECTION_RTL = 2;
Rt.DISPLAY_FLEX = 0;
Rt.DISPLAY_NONE = 1;
Rt.EDGE_LEFT = 0;
Rt.EDGE_TOP = 1;
Rt.EDGE_RIGHT = 2;
Rt.EDGE_BOTTOM = 3;
Rt.EDGE_START = 4;
Rt.EDGE_END = 5;
Rt.EDGE_HORIZONTAL = 6;
Rt.EDGE_VERTICAL = 7;
Rt.EDGE_ALL = 8;
Rt.EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS = 0;
Rt.EXPERIMENTAL_FEATURE_ABSOLUTE_PERCENTAGE_AGAINST_PADDING_EDGE = 1;
Rt.EXPERIMENTAL_FEATURE_FIX_ABSOLUTE_TRAILING_COLUMN_MARGIN = 2;
Rt.FLEX_DIRECTION_COLUMN = 0;
Rt.FLEX_DIRECTION_COLUMN_REVERSE = 1;
Rt.FLEX_DIRECTION_ROW = 2;
Rt.FLEX_DIRECTION_ROW_REVERSE = 3;
Rt.GUTTER_COLUMN = 0;
Rt.GUTTER_ROW = 1;
Rt.GUTTER_ALL = 2;
Rt.JUSTIFY_FLEX_START = 0;
Rt.JUSTIFY_CENTER = 1;
Rt.JUSTIFY_FLEX_END = 2;
Rt.JUSTIFY_SPACE_BETWEEN = 3;
Rt.JUSTIFY_SPACE_AROUND = 4;
Rt.JUSTIFY_SPACE_EVENLY = 5;
Rt.LOG_LEVEL_ERROR = 0;
Rt.LOG_LEVEL_WARN = 1;
Rt.LOG_LEVEL_INFO = 2;
Rt.LOG_LEVEL_DEBUG = 3;
Rt.LOG_LEVEL_VERBOSE = 4;
Rt.LOG_LEVEL_FATAL = 5;
Rt.MEASURE_MODE_UNDEFINED = 0;
Rt.MEASURE_MODE_EXACTLY = 1;
Rt.MEASURE_MODE_AT_MOST = 2;
Rt.NODE_TYPE_DEFAULT = 0;
Rt.NODE_TYPE_TEXT = 1;
Rt.OVERFLOW_VISIBLE = 0;
Rt.OVERFLOW_HIDDEN = 1;
Rt.OVERFLOW_SCROLL = 2;
Rt.POSITION_TYPE_STATIC = 0;
Rt.POSITION_TYPE_RELATIVE = 1;
Rt.POSITION_TYPE_ABSOLUTE = 2;
Rt.PRINT_OPTIONS_LAYOUT = 1;
Rt.PRINT_OPTIONS_STYLE = 2;
Rt.PRINT_OPTIONS_CHILDREN = 4;
Rt.UNIT_UNDEFINED = 0;
Rt.UNIT_POINT = 1;
Rt.UNIT_PERCENT = 2;
Rt.UNIT_AUTO = 3;
Rt.WRAP_NO_WRAP = 0;
Rt.WRAP_WRAP = 1;
Rt.WRAP_WRAP_REVERSE = 2;
var Ts = Rt, sre = function(e) {
  function t(o, s, c) {
    var h = o[s];
    o[s] = function() {
      for (var d = arguments.length, g = new Array(d), x = 0; x < d; x++)
        g[x] = arguments[x];
      return c.call.apply(c, [this, h].concat(g));
    };
  }
  for (var n = function() {
    var s, c = a[i], h = (s = {}, s[Ts.UNIT_POINT] = e.Node.prototype[c], s[Ts.UNIT_PERCENT] = e.Node.prototype[c + "Percent"], s[Ts.UNIT_AUTO] = e.Node.prototype[c + "Auto"], s);
    t(e.Node.prototype, c, function(d) {
      for (var g, x, _ = arguments.length, k = new Array(_ > 1 ? _ - 1 : 0), P = 1; P < _; P++)
        k[P - 1] = arguments[P];
      var N = k.pop(), M, G;
      if (N === "auto") M = Ts.UNIT_AUTO, G = void 0;
      else if (typeof N == "object") M = N.unit, G = N.valueOf();
      else if (M = typeof N == "string" && N.endsWith("%") ? Ts.UNIT_PERCENT : Ts.UNIT_POINT, G = parseFloat(N), !Number.isNaN(N) && Number.isNaN(G)) throw new Error("Invalid value " + N + " for " + c);
      if (!h[M]) throw new Error('Failed to execute "' + c + `": Unsupported unit '` + N + "'");
      return G !== void 0 ? (g = h[M]).call.apply(g, [this].concat(k, [G])) : (x = h[M]).call.apply(x, [this].concat(k));
    });
  }, i = 0, a = ["setPosition", "setMargin", "setFlexBasis", "setWidth", "setHeight", "setMinWidth", "setMinHeight", "setMaxWidth", "setMaxHeight", "setPadding"]; i < a.length; i++)
    n();
  return t(e.Node.prototype, "setMeasureFunc", function(o, s) {
    return s ? o.call(this, (c = s, e.MeasureCallback.implement({
      measure: function() {
        var d = c.apply(void 0, arguments), g = d.width, x = d.height;
        return {
          width: g ?? NaN,
          height: x ?? NaN
        };
      }
    }))) : this.unsetMeasureFunc();
    var c;
  }), t(e.Node.prototype, "setDirtiedFunc", function(o, s) {
    var c;
    o.call(this, (c = s, e.DirtiedCallback.implement({
      dirtied: c
    })));
  }), t(e.Config.prototype, "free", function() {
    e.Config.destroy(this);
  }), t(e.Node, "create", function(o, s) {
    return s ? e.Node.createWithConfig(s) : e.Node.createDefault();
  }), t(e.Node.prototype, "free", function() {
    e.Node.destroy(this);
  }), t(e.Node.prototype, "freeRecursive", function() {
    for (var o = 0, s = this.getChildCount(); o < s; ++o) this.getChild(0).freeRecursive();
    this.free();
  }), t(e.Node.prototype, "calculateLayout", function(o, s, c, h) {
    return s === void 0 && (s = NaN), c === void 0 && (c = NaN), h === void 0 && (h = Ts.DIRECTION_LTR), o.call(this, s, c, h);
  }), $r({
    Config: e.Config,
    Node: e.Node
  }, Ts);
}, U4, ure = (U4 = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0, function(r) {
  r === void 0 && (r = {});
  var e, t, n;
  e || (e = r !== void 0 ? r : {}), e.ready = new Promise(function(ie, re) {
    t = ie, n = re;
  });
  var i = Object.assign({}, e), a = "";
  typeof document < "u" && document.currentScript && (a = document.currentScript.src), U4 && (a = U4), a = a.indexOf("blob:") !== 0 ? a.substr(0, a.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "";
  var o, s = e.print || console.log.bind(console), c = e.printErr || console.warn.bind(console);
  function h() {
  }
  function d(ie) {
    this.exports = function(re) {
      for (var Q, we = new Uint8Array(123), Ge = 25; Ge >= 0; --Ge) we[48 + Ge] = 52 + Ge, we[65 + Ge] = Ge, we[97 + Ge] = 26 + Ge;
      function Ue(a0, Zt, Dr) {
        for (var b0, je, Cr = 0, f = Zt, Ke = Dr.length, _o = Zt + (3 * Ke >> 2) - (Dr[Ke - 2] == "=") - (Dr[Ke - 1] == "="); Cr < Ke; Cr += 4) b0 = we[Dr.charCodeAt(Cr + 1)], je = we[Dr.charCodeAt(Cr + 2)], a0[f++] = we[Dr.charCodeAt(Cr)] << 2 | b0 >> 4, f < _o && (a0[f++] = b0 << 4 | je >> 2), f < _o && (a0[f++] = je << 6 | we[Dr.charCodeAt(Cr + 3)]);
      }
      we[43] = 62, we[47] = 63;
      var at = new ArrayBuffer(16), ft = new Int32Array(at), et = new Float32Array(at), Et = new Float64Array(at);
      function qe(a0) {
        return ft[a0];
      }
      function ze(a0, Zt) {
        ft[a0] = Zt;
      }
      function Pt() {
        return Et[0];
      }
      function fr(a0) {
        Et[0] = a0;
      }
      function Ut() {
        throw new Error("abort");
      }
      function Ht(a0) {
        et[2] = a0;
      }
      function Tt() {
        return et[2];
      }
      return function(a0) {
        var Zt = a0.a, Dr = Zt.a, b0 = Dr.buffer;
        Dr.grow = function(u) {
          u |= 0;
          var l = 0 | zt(), p = l + u | 0;
          if (l < p && p < 65536) {
            var m = new ArrayBuffer(pr(p, 65536));
            new Int8Array(m).set(je), je = new Int8Array(m), Cr = new Int16Array(m), f = new Int32Array(m), Ke = new Uint8Array(m), _o = new Uint16Array(m), Bl = new Uint32Array(m), Y = new Float32Array(m), Fr = new Float64Array(m), b0 = m, Dr.buffer = b0, Q = Ke;
          }
          return l;
        };
        var je = new Int8Array(b0), Cr = new Int16Array(b0), f = new Int32Array(b0), Ke = new Uint8Array(b0), _o = new Uint16Array(b0), Bl = new Uint32Array(b0), Y = new Float32Array(b0), Fr = new Float64Array(b0), pr = Math.imul, E = Math.fround, jr = Math.abs, Pn = Math.clz32, La = Math.min, Nl = Math.max, ot = Zt.b, Y0 = Zt.c, $i = Zt.d, zi = Zt.e, ji = Zt.f, Do = Zt.g, us = Zt.h, Ma = Zt.i, Ll = Zt.j, ls = Zt.k, cs = Zt.l, ff = Zt.m, hf = Zt.n, df = Zt.o, Ml = Zt.p, mu = Zt.q, yu = Zt.r, Ul = Zt.s, v2 = Zt.t, fs = Zt.u, pf = Zt.v, bu = Zt.w, ti = Zt.x, wu = Zt.y, hs = Zt.z, Wi = Zt.A, vf = Zt.B, ds = Zt.C, g2 = Zt.D, nt = 73632, sr = 0;
        function Au(u, l, p, m, D, F, U, $, X, Pe, ce, Ce, ge, Ne) {
          var ue, le = E(0), Ae = E(0), Le = 0, $e = 0, He = 0, Je = E(0), st = E(0), dt = E(0), vt = 0, At = 0, Ot = 0, Vt = E(0), rr = E(0), Jt = E(0), Xr = 0, Wr = E(0), c0 = 0, i0 = E(0), e0 = E(0), Gr = 0, f0 = 0, q0 = 0, en = 0, C0 = 0, tn = E(0), bn = 0, wn = E(0), Mn = 0, Vn = 0, X0 = 0, Vi = 0, Yi = E(0), An = 0, ya = 0, Wa = 0, xn = 0, ba = E(0), Ro = 0, wa = 0, Aa = 0, Hi = E(0), Io = E(0), Pu = 0, Un = E(0), Po = E(0), Bu = E(0), Ai = 0, Bo = 0, xi = E(0), Nu = 0, Lu = E(0), _2 = E(0), Xl = E(0), xa = E(0), Kl = 0, Mu = 0, Nf = 0, Lf = 0, Uu = 0, Mf = 0, D2 = 0, y = 0, v = 0, A = E(0), C = E(0);
          nt = ue = nt - 384 | 0;
          e: {
            n: {
              t: {
                if (!D || l == l) {
                  if (!F || p == p) {
                    if (f[(Le = (X ? 0 : 4) + ce | 0) >> 2] = f[Le >> 2] + 1, Nu = (0 | m) <= 1 ? 1 : m, bn = (Le = 3 & f[u + 24 >> 2]) || Nu, je[u + 300 | 0] = 252 & Ke[u + 300 | 0] | 3 & bn, Le = u + 252 | 0, m = ((0 | bn) != 1) << 3, st = er(u, Ro = (0 | bn) == 2 ? 3 : 2, U), Y[Le + m >> 2] = st, $e = Le, Le = ((0 | bn) == 1) << 3, rr = wr(u, Ro, U), Y[$e + Le >> 2] = rr, Vt = er(u, 0, U), Y[u + 256 >> 2] = Vt, Je = wr(u, 0, U), Y[u + 264 >> 2] = Je, v = (He = u + 268 | 0) + m | 0, A = Kt(u, Ro), Y[v >> 2] = A, v = Le + He | 0, A = nr(u, Ro), Y[v >> 2] = A, le = Kt(u, 0), Y[u + 272 >> 2] = le, dt = nr(u, 0), Y[u + 280 >> 2] = dt, v = ($e = m) + (m = u + 284 | 0) | 0, A = Or(u, Ro, U), Y[v >> 2] = A, v = m + Le | 0, A = Rr(u, Ro, U), Y[v >> 2] = A, Ae = Or(u, 0, U), Y[u + 288 >> 2] = Ae, Wr = Rr(u, 0, U), Y[u + 296 >> 2] = Wr, st = E(st + rr), rr = E(Vt + Je), m = f[u + 8 >> 2]) {
                      if (Vt = E(E(E(Y[u + 284 >> 2] + Y[u + 292 >> 2]) + Y[u + 268 >> 2]) + Y[u + 276 >> 2]), p = E(F ? p - rr : NaN), le = E(E(Ae + Wr) + le), (l = Ae = E(D ? l - st : NaN)) == l && (l = (l = E(Ae - Vt)) == l ? tr(l, E(0)) : E(0)), st = E(le + dt), le = p, p == p && (le = (le = E(p - st)) == le ? tr(le, E(0)) : E(0)), !((0 | D) != 1 | (0 | F) != 1)) {
                        l = (m = (l = Tr(u, 2, Ae, U)) != l) | (le = E(E(Or(u, 2, U) + Kt(u, 2)) + E(Rr(u, 2, U) + nr(u, 2)))) != le ? m ? le : l : tr(l, le), Y[u + 516 >> 2] = l, l = (m = (l = Tr(u, 0, p, $)) != l) | (p = E(E(Or(u, 0, U) + Kt(u, 0)) + E(Rr(u, 0, U) + nr(u, 0)))) != p ? m ? p : l : tr(l, p), Y[u + 520 >> 2] = l;
                        break e;
                      }
                      16 & Ke[u + 4 | 0] ? xt[0 | m](ue + 24 | 0, u, l, D, le, F, 0) : xt[0 | m](ue + 24 | 0, u, l, D, le, F), f[ce + 20 >> 2] = f[ce + 20 >> 2] + 1, f[24 + (m = (Ne << 2) + ce | 0) >> 2] = f[m + 24 >> 2] + 1, l = E(Vt + Y[ue + 24 >> 2]), l = (m = (l = Tr(u, 2, D ? (0 | D) == 2 ? l : Ae : l, U)) != l) | (le = E(E(Or(u, 2, U) + Kt(u, 2)) + E(Rr(u, 2, U) + nr(u, 2)))) != le ? m ? le : l : tr(l, le), Y[u + 516 >> 2] = l, l = E(st + Y[ue + 28 >> 2]), l = (m = (l = Tr(u, 0, F ? (0 | F) == 2 ? l : p : l, $)) != l) | (p = E(E(Or(u, 0, U) + Kt(u, 0)) + E(Rr(u, 0, U) + nr(u, 0)))) != p ? m ? p : l : tr(l, p), Y[u + 520 >> 2] = l;
                      break e;
                    }
                    if ((0 | (m = f[u + 556 >> 2])) == (0 | (Ne = f[u + 560 >> 2]))) {
                      rr = E(p - rr), l = (m = (l = Tr(u, 2, E(-3 & D ? l - st : E(E(Y[u + 284 >> 2] + Y[u + 292 >> 2]) + Y[u + 268 >> 2]) + Y[u + 276 >> 2]), U)) != l) | (p = E(E(Or(u, 2, U) + Kt(u, 2)) + E(Rr(u, 2, U) + nr(u, 2)))) != p ? m ? p : l : tr(l, p), Y[u + 516 >> 2] = l, l = (m = (l = Tr(u, 0, -3 & F ? rr : E(E(E(Ae + Wr) + le) + dt), $)) != l) | (p = E(E(Or(u, 0, U) + Kt(u, 0)) + E(Rr(u, 0, U) + nr(u, 0)))) != p ? m ? p : l : tr(l, p), Y[u + 520 >> 2] = l;
                      break e;
                    }
                    if (!(X || (Ae = E(l - st), le = E(p - rr), !((0 | D) == 2 & Ae <= E(0) | !(!(le <= E(0)) | (0 | F) != 2) & le == le) & ((0 | D) != 1 | (0 | F) != 1)))) {
                      l = (m = (l = Tr(u, 2, Ae == Ae ? (0 | D) == 2 && Ae < E(0) ? E(0) : Ae : E(0), U)) != l) | (p = E(E(Or(u, 2, U) + Kt(u, 2)) + E(Rr(u, 2, U) + nr(u, 2)))) != p ? m ? p : l : tr(l, p), Y[u + 516 >> 2] = l, l = (m = (l = Tr(u, 0, le != le || (0 | F) == 2 && le < E(0) ? E(0) : le, $)) != l) | (p = E(E(Or(u, 0, U) + Kt(u, 0)) + E(Rr(u, 0, U) + nr(u, 0)))) != p ? m ? p : l : tr(l, p), Y[u + 520 >> 2] = l;
                      break e;
                    }
                    for (Vi = (q0 = Ne - m | 0) >> 2; Le = f[m >> 2], f[Le + 552 >> 2] != (0 | u) && (He = f[u + 568 >> 2], Le = jl(f[He >> 2], Ke[He + 8 | 0], Le, u, At, 0), f[m >> 2] = Le, f[Le + 552 >> 2] = u), At = At + 1 | 0, (0 | Ne) != (0 | (m = m + 4 | 0)); ) ;
                    je[u + 300 | 0] = 251 & Ke[u + 300 | 0], At = 3, m = (Pu = f[u + 24 >> 2]) >>> 2 & 3;
                    r: {
                      i: {
                        a: {
                          if ((0 | bn) == 2) {
                            Ne = 0;
                            o: switch (m - 2 | 0) {
                              case 0:
                                break r;
                              case 1:
                                break o;
                              default:
                                break a;
                            }
                            At = 2;
                            break r;
                          }
                          if (At = 2, Ne = 0, m >>> 0 > 1) break i;
                        }
                        Ne = At;
                      }
                      At = m;
                    }
                    Lu = E(l - st), Yi = E(E(Or(u, At, U) + Kt(u, At)) + E(Rr(u, At, U) + nr(u, At))), Wr = E(Or(u, Ne, U) + Kt(u, Ne)), wn = E(Wr + E(Rr(u, Ne, U) + nr(u, Ne))), Je = pn(u, 0, Lu, (Mn = At >>> 0 > 1) ? Yi : wn, U), i0 = pn(u, 1, _2 = E(p - rr), Mn ? wn : Yi, $), e0 = Mn ? i0 : Je, rr = Mn ? Je : i0, An = f[u + 560 >> 2], Le = f[u + 556 >> 2];
                    r: if ((0 | (c0 = Mn ? D : F)) == 1) {
                      if ((0 | Le) == (0 | An)) break t;
                      for (m = 0, He = Le; ; ) {
                        $e = m;
                        i: if (xf(m = f[He >> 2])) {
                          if (vt = 0, $e || !($e = f[m + 552 >> 2])) break r;
                          a: {
                            if (!((p = Y[m + 32 >> 2]) == p || (le = E(0), (p = Y[m + 28 >> 2]) > E(0))) || (le = p, p == p)) {
                              if (E(jr(le)) < E(9999999747378752e-20)) break r;
                              if (!$e) {
                                p = E(0);
                                break a;
                              }
                            }
                            if ((p = Y[m + 36 >> 2]) != p) {
                              if (je[m + 4 | 0] < 0) {
                                p = E(1);
                                break a;
                              }
                              if (p = E(0), !((l = Y[m + 28 >> 2]) < E(0))) break a;
                              p = E(-l);
                            }
                            if (p != p) break i;
                          }
                          if (E(jr(p)) < E(9999999747378752e-20)) break r;
                        } else m = $e;
                        if (vt = m, (0 | An) == (0 | (He = He + 4 | 0))) break;
                      }
                    }
                    if ((0 | Le) == (0 | An)) break t;
                    for (en = (0 | bn) <= 1 ? 1 : bn, ya = (Wa = Je != Je) | (0 | D) != 1, xn = i0 == i0, wa = Je == Je, le = E(0); ; ) {
                      mi(Ot = f[Le >> 2]);
                      r: if (4194304 & (He = f[Ot + 24 >> 2])) {
                        if (Gi(Ot, 0), He = 1 | (m = Ke[Ot + 4 | 0]), je[Ot + 4 | 0] = He, !(4 & m)) break r;
                        je[Ot + 4 | 0] = 251 & He;
                      } else if (X && (bf(Ot, (m = 3 & He) || en, rr, e0, Je), He = f[Ot + 24 >> 2]), (196608 & He) != 131072) {
                        if ((0 | vt) != (0 | Ot)) {
                          $e = (Aa = f[u + 24 >> 2]) >>> 2 & 3;
                          i: {
                            a: if ((0 | bn) == 2) {
                              m = 3;
                              o: switch ($e - 2 | 0) {
                                case 0:
                                  break i;
                                case 1:
                                  break o;
                                default:
                                  break a;
                              }
                              m = 2;
                              break i;
                            }
                            m = $e;
                          }
                          Ae = (Vn = m >>> 0 > 1) ? Je : i0, p = E(0), l = Y[Ot + 40 >> 2];
                          i: {
                            a: {
                              o: if ((0 | ($e = f[Ot + 40 >> 2])) != 2139156720) {
                                if ((0 | $e) == 2140081935) break a;
                                Xr = 4276;
                                s: {
                                  if ((0 | $e) != 2141891242) {
                                    if (l == l) break s;
                                    Xr = 4268;
                                  }
                                  p = Y[Xr >> 2];
                                  u: {
                                    l: switch (0 | ($e = f[Xr + 4 >> 2])) {
                                      case 0:
                                      case 3:
                                        break l;
                                      default:
                                        break u;
                                    }
                                    if (l = E(NaN), !(Y[Ot + 28 >> 2] > E(0))) break i;
                                    $e = (Xr = je[Ot + 4 | 0] < 0) ? 3 : 1, ze(2, C0 = Xr ? 2143289344 : 0), p = Tt();
                                  }
                                  switch (l = E(NaN), $e - 1 | 0) {
                                    case 0:
                                      break a;
                                    case 1:
                                      break o;
                                    default:
                                      break i;
                                  }
                                }
                                if (ze(2, 536870912 + (-1073741825 & $e) | 0), p = Tt(), !(1073741824 & $e)) break a;
                              }
                              l = E(E(Ae * p) * E(0.009999999776482582));
                              break i;
                            }
                            l = p;
                          }
                          p = Y[Ot + 572 >> 2], $e = 0;
                          i: {
                            switch (0 | (f0 = f[Ot + 576 >> 2])) {
                              case 0:
                              case 3:
                                break i;
                            }
                            if ((0 | f0) != 1 | (st = Y[Ot + 572 >> 2]) != st) $e = 1, (0 | f0) != 2 | st != st || ($e = 0, p < E(0) || ($e = wa));
                            else {
                              if (p < E(0)) break i;
                              $e = 1;
                            }
                          }
                          st = Y[Ot + 580 >> 2], Xr = 0;
                          i: {
                            switch (0 | (Gr = f[Ot + 584 >> 2])) {
                              case 0:
                              case 3:
                                break i;
                            }
                            if ((0 | Gr) != 1 | (dt = Y[Ot + 580 >> 2]) != dt) Xr = 1, (0 | Gr) != 2 | dt != dt || (Xr = 0, st < E(0) || (Xr = xn));
                            else {
                              if (st < E(0)) break i;
                              Xr = 1;
                            }
                          }
                          i: {
                            a: if (l != l | Ae != Ae)
                              if ($e & Vn) {
                                switch (Ae = E(E(Or(Ot, 2, Je) + Kt(Ot, 2)) + E(Rr(Ot, 2, Je) + nr(Ot, 2))), l = E(NaN), f0 - 1 | 0) {
                                  case 1:
                                    p = E(E(Je * p) * E(0.009999999776482582));
                                  case 0:
                                    if (Ae <= (l = p)) break a;
                                }
                                if (!(l == l | Ae == Ae)) {
                                  p = l;
                                  break a;
                                }
                                if (l < Ae) {
                                  p = Ae;
                                  break a;
                                }
                                p = l != l ? Ae : l;
                              } else if (Vn | 1 ^ Xr) {
                                if (f[ue + 360 >> 2] = 2143289344, f[ue + 24 >> 2] = 2143289344, C0 = 0, f[ue + 356 >> 2] = 0, f[ue + 352 >> 2] = 0, dt = E(er(Ot, 2, Je) + wr(Ot, 2, Je)), Vt = er(Ot, 0, Je), Jt = wr(Ot, 0, Je), Ae = E(NaN), X0 = 0, l = E(NaN), $e) {
                                  o: {
                                    s: switch (f0 - 1 | 0) {
                                      case 0:
                                        l = p;
                                        break o;
                                      case 1:
                                        break s;
                                      default:
                                        break o;
                                    }
                                    l = E(E(Je * p) * E(0.009999999776482582));
                                  }
                                  f[ue + 356 >> 2] = 1, l = E(dt + l), Y[ue + 24 >> 2] = l, X0 = 1;
                                }
                                if (Vt = E(Vt + Jt), Xr) {
                                  p = E(NaN);
                                  o: {
                                    s: switch (Gr - 1 | 0) {
                                      case 0:
                                        p = st;
                                        break o;
                                      case 1:
                                        break s;
                                      default:
                                        break o;
                                    }
                                    p = E(E(i0 * st) * E(0.009999999776482582));
                                  }
                                  f[ue + 352 >> 2] = 1, Ae = E(Vt + p), Y[ue + 360 >> 2] = Ae, C0 = 1;
                                }
                                f0 = m >>> 0 < 2;
                                o: {
                                  s: {
                                    u: {
                                      if (!(!Vn & (0 | (Gr = 3145728 & Aa)) == 2097152)) {
                                        if (Wa | (0 | Gr) == 2097152) break s;
                                        if (l != l) break u;
                                        break s;
                                      }
                                      if (Wa | l == l) break o;
                                    }
                                    X0 = 2, f[ue + 356 >> 2] = 2, Y[ue + 24 >> 2] = Je, l = Je;
                                  }
                                  s: {
                                    if (!(!f0 & (0 | Gr) == 2097152)) {
                                      if ((0 | Gr) == 2097152 | i0 != i0) break o;
                                      if (Ae != Ae) break s;
                                      break o;
                                    }
                                    if (Ae == Ae | i0 != i0) break o;
                                  }
                                  C0 = 2, f[ue + 352 >> 2] = 2, Y[ue + 360 >> 2] = i0, Ae = i0;
                                }
                                o: if (!(Gr = (p = Y[Ot + 224 >> 2]) != p)) {
                                  if (Vn | (0 | X0) != 1) {
                                    if (f0 | (0 | C0) != 1) break o;
                                    f[ue + 356 >> 2] = 1, Y[ue + 24 >> 2] = E(E(Ae - Vt) * p) + dt;
                                  } else f[ue + 352 >> 2] = 1, Y[ue + 360 >> 2] = Vt + E(E(l - dt) / p);
                                  C0 = 1, X0 = 1;
                                }
                                (0 | (He = (He = He >>> 13 & 7) || Aa >>> 10 & 7)) == 5 | (0 | X0) == 1 | Vn | $e | ya | (0 | He) != 4 || (f[ue + 356 >> 2] = 1, Y[ue + 24 >> 2] = Je, Gr || (C0 = 1, f[ue + 352 >> 2] = 1, Y[ue + 360 >> 2] = E(Je - dt) / p)), f0 | (0 | F) != 1 | i0 != i0 | Xr | (0 | He) != 4 | (0 | C0) == 1 || (f[ue + 352 >> 2] = 1, Y[ue + 360 >> 2] = i0, Gr || (f[ue + 356 >> 2] = 1, Y[ue + 24 >> 2] = E(i0 - Vt) * p)), za(Ot, 2, Je, Je, ue + 356 | 0, ue + 24 | 0), za(Ot, 0, i0, Je, ue + 352 | 0, ue + 360 | 0), H0(Ot, Y[ue + 24 >> 2], Y[ue + 360 >> 2], bn, f[ue + 356 >> 2], f[ue + 352 >> 2], Je, i0, 0, 5, Pe, ce, Ce, ge), p = (He = (l = Y[516 + (Ot + (f[4252 + (m << 2) >> 2] << 2) | 0) >> 2]) != l) | (p = E(E(Or(Ot, m, Je) + Kt(Ot, m)) + E(Rr(Ot, m, Je) + nr(Ot, m)))) != p ? He ? p : l : tr(l, p);
                              } else {
                                switch (l = E(E(Or(Ot, 0, Je) + Kt(Ot, 0)) + E(Rr(Ot, 0, Je) + nr(Ot, 0))), p = E(NaN), Gr - 1 | 0) {
                                  case 1:
                                    st = E(E(i0 * st) * E(0.009999999776482582));
                                  case 0:
                                    if (l <= (p = st)) break a;
                                }
                                if (p != p & l != l) break a;
                                if (l > p) {
                                  p = l;
                                  break a;
                                }
                                p = p != p ? l : p;
                              }
                            else {
                              if (p = Y[Ot + 308 >> 2], (!Ke[f[Ot + 568 >> 2] + 20 | 0] | f[Ot + 304 >> 2] == (0 | ge)) & p == p) break i;
                              if (!((p = E(E(Or(Ot, m, Je) + Kt(Ot, m)) + E(Rr(Ot, m, Je) + nr(Ot, m)))) <= l) & l < p) break a;
                              p = l;
                            }
                            Y[Ot + 308 >> 2] = p;
                          }
                          f[Ot + 304 >> 2] = ge;
                        } else f[vt + 308 >> 2] = 0, f[vt + 304 >> 2] = ge, p = E(0);
                        le = E(le + E(p + E(er(Ot, At, Je) + wr(Ot, At, Je))));
                      }
                      if ((0 | An) == (0 | (Le = Le + 4 | 0))) break;
                    }
                    break n;
                  }
                  f[ue >> 2] = 3023, vn(u, ue), un(), Ut();
                }
                f[ue + 16 >> 2] = 3105, vn(u, ue + 16 | 0), un(), Ut();
              }
              le = E(0);
            }
            l = E(le + E(0)), Un = Mn ? $ : U, Hi = Mn ? U : $, q0 >>> 0 >= 5 && (l = E(E($a(u, At, e0) * E(Vi - 1 >>> 0)) + l)), m = l > rr, An = 786432 & Pu, xn = (0 | c0) == 2 && An && m ? 1 : c0, Mu = (Wa = (0 | (Ot = Mn ? F : D)) == 1) & (1 ^ X), Mn = At >>> 0 < 2, Nf = -3 & Ot, Aa = u + 208 | 0, Gr = 4220 + (F = Ne << 2) | 0, Lf = Wa & !An, Uu = (0 | Ot) != 1 | X, Vn = 4220 + (Le = At << 2) | 0, wa = Le + 4252 | 0, Mf = (X0 = e0 == e0) << 1, f0 = F + 4252 | 0, D2 = !c0 | !m, Pu = ue + 52 | 0, Xl = $a(u, Ne, e0), He = 0, m = 0, C0 = 0;
            n: {
              for (; ; ) {
                if (Xr = m, k0(ue + 24 | 0, 0, 44), (0 | (m = f[u + 560 >> 2])) != (0 | (F = f[u + 556 >> 2]))) {
                  if ((0 | (m = m - F | 0)) < 0) break n;
                  Le = ma(ue + 360 | 0, m >> 2, 0, Pu), m = f[ue + 44 >> 2], F = f[ue + 48 >> 2] - m | 0, F = T0(f[ue + 364 >> 2] - F | 0, m, F), m = f[ue + 44 >> 2], f[ue + 364 >> 2] = m, f[ue + 44 >> 2] = F, $e = f[ue + 368 >> 2], vt = f[ue + 372 >> 2], F = f[ue + 48 >> 2], f[ue + 368 >> 2] = F, c0 = f[ue + 52 >> 2], f[ue + 48 >> 2] = $e, f[ue + 52 >> 2] = vt, f[ue + 372 >> 2] = c0, f[Le >> 2] = m, (0 | m) != (0 | F) && (f[ue + 368 >> 2] = F + (3 + (m - F | 0) & -4)), m && l0(m);
                }
                F = (vt = f[u + 24 >> 2]) >>> 2 & 3;
                t: {
                  r: if ((0 | ((m = 3 & vt) || Nu)) == 2) {
                    m = 3;
                    i: switch (F - 2 | 0) {
                      case 0:
                        break t;
                      case 1:
                        break i;
                      default:
                        break r;
                    }
                    m = 2;
                    break t;
                  }
                  m = F;
                }
                le = $a(u, m, Je);
                t: if (!((Le = He) >>> 0 >= ($e = f[u + 560 >> 2]) - (F = f[u + 556 >> 2]) >> 2 >>> 0)) for (c0 = 786432 & vt, p = E(0); ; ) {
                  if ($e - F >> 2 >>> 0 <= Le >>> 0) break n;
                  if (vt = f[(Le << 2) + F >> 2], !(4194304 & (q0 = f[vt + 24 >> 2]) | (196608 & q0) == 131072)) {
                    if (f[vt + 548 >> 2] = Xr, l = er(vt, m, Je), Ae = wr(vt, m, Je), F = f[ue + 24 >> 2], st = (0 | Le) == (0 | He) ? E(0) : le, l = E(l + Ae), dt = Tr(vt, m, Ae = Y[vt + 308 >> 2], Hi), F && !(!(E(st + E(l + E(p + dt))) > rr) | !c0)) break t;
                    if (f[ue + 24 >> 2] = F + 1, st = E(st + E(l + dt)), Y[ue + 28 >> 2] = st + Y[ue + 28 >> 2], xf(vt)) {
                      r: if (f[vt + 552 >> 2]) {
                        if ((l = Y[vt + 32 >> 2]) != l && (l = (l = Y[vt + 28 >> 2]) > E(0) ? l : E(0)), Y[ue + 32 >> 2] = l + Y[ue + 32 >> 2], (l = Y[vt + 36 >> 2]) == l) break r;
                        if (je[vt + 4 | 0] < 0) {
                          l = E(1);
                          break r;
                        }
                        if (l = E(0), !((dt = Y[vt + 28 >> 2]) < E(0))) break r;
                        l = E(-dt);
                      } else l = E(0), Y[ue + 32 >> 2] = Y[ue + 32 >> 2] + E(0);
                      Y[ue + 36 >> 2] = Y[ue + 36 >> 2] - E(l * Ae);
                    }
                    if ((0 | (F = f[ue + 48 >> 2])) == f[ue + 52 >> 2]) {
                      if (($e = 1 + (q0 = (F = F - f[ue + 44 >> 2] | 0) >> 2) | 0) >>> 0 >= 1073741824) break n;
                      en = F >>> 1 | 0, q0 = ma(ue + 360 | 0, F >>> 0 >= 2147483644 ? 1073741823 : $e >>> 0 < en >>> 0 ? en : $e, q0, Pu), f[f[ue + 368 >> 2] >> 2] = vt, f[ue + 368 >> 2] = f[ue + 368 >> 2] + 4, F = f[ue + 44 >> 2], $e = f[ue + 48 >> 2] - F | 0, $e = T0(f[ue + 364 >> 2] - $e | 0, F, $e), F = f[ue + 44 >> 2], f[ue + 364 >> 2] = F, f[ue + 44 >> 2] = $e, vt = f[ue + 368 >> 2], en = f[ue + 372 >> 2], $e = f[ue + 48 >> 2], f[ue + 368 >> 2] = $e, ya = f[ue + 52 >> 2], f[ue + 48 >> 2] = vt, f[ue + 52 >> 2] = en, f[ue + 372 >> 2] = ya, f[q0 >> 2] = F, (0 | F) != (0 | $e) && (f[ue + 368 >> 2] = $e + (3 + (F - $e | 0) & -4)), F && l0(F);
                    } else f[F >> 2] = vt, f[ue + 48 >> 2] = F + 4;
                    F = f[u + 556 >> 2], $e = f[u + 560 >> 2], p = E(p + st);
                  }
                  if (!((Le = Le + 1 | 0) >>> 0 < $e - F >> 2 >>> 0)) break;
                }
                !((Jt = Y[ue + 32 >> 2]) > E(0)) | !(Jt < E(1)) || (f[ue + 32 >> 2] = 1065353216, Jt = E(1)), !((tn = Y[ue + 36 >> 2]) > E(0)) | !(tn < E(1)) || (f[ue + 36 >> 2] = 1065353216, tn = E(1)), f[ue + 40 >> 2] = Le, Vt = Y[ue + 28 >> 2], c0 = f[ue + 24 >> 2], C0 && l0(C0), st = Y[ue + 56 >> 2], q0 = f[ue + 48 >> 2], C0 = f[ue + 44 >> 2];
                t: {
                  r: {
                    i: {
                      if ((0 | xn) != 1) {
                        p = E(0), l = Y[Aa >> 2];
                        a: {
                          o: {
                            s: if ((0 | (m = f[Aa >> 2])) != 2139156720) {
                              if ((0 | m) == 2140081935) break o;
                              F = 4276;
                              u: {
                                if ((0 | m) != 2141891242) {
                                  if (l == l) break u;
                                  F = 4268;
                                }
                                switch (p = Y[F >> 2], l = E(NaN), f[F + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break o;
                                  case 1:
                                    break s;
                                  default:
                                    break a;
                                }
                              }
                              if (ze(2, 536870912 + (-1073741825 & m) | 0), p = Tt(), !(1073741824 & m)) break o;
                            }
                            l = E(E(p * U) * E(0.009999999776482582));
                            break a;
                          }
                          l = p;
                        }
                        p = E(0), le = Y[u + 216 >> 2];
                        a: {
                          o: {
                            s: if ((0 | (m = f[u + 216 >> 2])) != 2139156720) {
                              if ((0 | m) == 2140081935) break o;
                              F = 4276;
                              u: {
                                if ((0 | m) != 2141891242) {
                                  if (le == le) break u;
                                  F = 4268;
                                }
                                switch (p = Y[F >> 2], le = E(NaN), f[F + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break o;
                                  case 1:
                                    break s;
                                  default:
                                    break a;
                                }
                              }
                              if (ze(2, 536870912 + (-1073741825 & m) | 0), p = Tt(), !(1073741824 & m)) break o;
                            }
                            le = E(E(p * U) * E(0.009999999776482582));
                            break a;
                          }
                          le = p;
                        }
                        p = E(0), Ae = Y[u + 212 >> 2];
                        a: {
                          o: {
                            s: if ((0 | (m = f[u + 212 >> 2])) != 2139156720) {
                              if ((0 | m) == 2140081935) break o;
                              F = 4276;
                              u: {
                                if ((0 | m) != 2141891242) {
                                  if (Ae == Ae) break u;
                                  F = 4268;
                                }
                                switch (p = Y[F >> 2], dt = E(NaN), f[F + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break o;
                                  case 1:
                                    break s;
                                  default:
                                    break a;
                                }
                              }
                              if (ze(2, 536870912 + (-1073741825 & m) | 0), p = Tt(), !(1073741824 & m)) break o;
                            }
                            dt = E(E(p * $) * E(0.009999999776482582));
                            break a;
                          }
                          dt = p;
                        }
                        p = E(0), Ae = Y[u + 220 >> 2];
                        a: {
                          o: {
                            s: if ((0 | (m = f[u + 220 >> 2])) != 2139156720) {
                              if ((0 | m) == 2140081935) break o;
                              F = 4276;
                              u: {
                                if ((0 | m) != 2141891242) {
                                  if (Ae == Ae) break u;
                                  F = 4268;
                                }
                                switch (p = Y[F >> 2], Ae = E(NaN), f[F + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break o;
                                  case 1:
                                    break s;
                                  default:
                                    break a;
                                }
                              }
                              if (ze(2, 536870912 + (-1073741825 & m) | 0), p = Tt(), !(1073741824 & m)) break o;
                            }
                            Ae = E(E(p * $) * E(0.009999999776482582));
                            break a;
                          }
                          Ae = p;
                        }
                        if ((p = E(((m = At >>> 0 > 1) ? l : dt) - Yi)) == p & p > Vt || (p = E((m ? le : Ae) - Yi)) == p & p < Vt) break i;
                        if (!Ke[f[u + 568 >> 2] + 11 | 0]) {
                          if (p = Vt, !f[u + 552 >> 2] | Jt == E(0)) break r;
                          a: {
                            if ((l = Y[u + 32 >> 2]) != l) {
                              if (!((p = Y[u + 28 >> 2]) > E(0))) break a;
                            } else p = l;
                            if (p != p) {
                              p = rr;
                              break r;
                            }
                            l = Y[u + 32 >> 2];
                          }
                          if (l != l && (p = Vt, !((l = Y[u + 28 >> 2]) > E(0))) || (p = rr, l != E(0))) break r;
                          p = Vt;
                          break r;
                        }
                      }
                      p = rr;
                    }
                    if (p == p) {
                      st = E(p - Vt);
                      break t;
                    }
                  }
                  Vt < E(0) && (st = E(-Vt));
                }
                if (rr = p, !Mu) {
                  if ((0 | C0) != (0 | q0)) {
                    for (Ae = E(0), F = C0; ; ) {
                      p = Tr(m = f[F >> 2], At, Vt = Y[m + 308 >> 2], Hi);
                      t: if (st < E(0)) {
                        if ((vt = f[m + 552 >> 2]) ? (le = Y[m + 36 >> 2]) != le && (je[m + 4 | 0] < 0 ? le = E(1) : (le = E(0), (l = Y[m + 28 >> 2]) < E(0) && (le = E(-l)))) : le = E(0), !((l = E(p * E(-le))) > E(0) | l < E(0)) || (le = E(E(E(st / tn) * l) + p)) != le | (l = ($e = (l = Tr(m, At, le, rr)) != l) | (dt = E(E(Or(m, At, Je) + Kt(m, At)) + E(Rr(m, At, Je) + nr(m, At)))) != dt ? $e ? dt : l : tr(l, dt)) != l | l == le) break t;
                        l = E(l - p), vt ? (p = Y[m + 36 >> 2]) != p && (je[m + 4 | 0] < 0 ? p = E(1) : (p = E(0), (le = Y[m + 28 >> 2]) < E(0) && (p = E(-le)))) : p = E(0), Ae = E(Ae + l), tn = E(E(p * Vt) + tn);
                      } else !(st > E(0)) | !f[m + 552 >> 2] || ((le = Y[m + 32 >> 2]) == le || (le = Y[m + 28 >> 2]) > E(0)) && le < E(0) | le > E(0) && ((dt = E(E(E(st / Jt) * le) + p)) != dt | (l = ($e = (l = Tr(m, At, dt, rr)) != l) | (Vt = E(E(Or(m, At, Je) + Kt(m, At)) + E(Rr(m, At, Je) + nr(m, At)))) != Vt ? $e ? Vt : l : tr(l, Vt)) != l | l == dt || (Jt = E(Jt - le), Ae = E(Ae + E(l - p))));
                      if ((0 | q0) == (0 | (F = F + 4 | 0))) break;
                    }
                    for (Vt = E(st - Ae), Po = E(Vt / tn), Bu = E(Vt / Jt), Bo = !(en = Wa & (!(12 & Ke[u + 26 | 0]) | D2)), ya = f[f0 >> 2], dt = E(0), $e = C0; ; ) {
                      p = Tr(F = f[$e >> 2], At, Y[F + 308 >> 2], Hi);
                      t: {
                        if (Vt < E(0)) {
                          if (f[F + 552 >> 2] ? (l = Y[F + 36 >> 2]) != l && (je[F + 4 | 0] < 0 ? l = E(1) : (l = E(0), (le = Y[F + 28 >> 2]) < E(0) && (l = E(-le)))) : l = E(0), le = p, (l = E(p * E(-l))) == E(0)) break t;
                          l = tn == E(0) ? E(p + l) : E(E(Po * l) + p);
                        } else {
                          if (le = p, !(Vt > E(0)) | !f[F + 552 >> 2] || (l = Y[F + 32 >> 2]) != l && !((l = Y[F + 28 >> 2]) > E(0)) || !(l < E(0) | l > E(0))) break t;
                          l = E(E(Bu * l) + p);
                        }
                        le = (m = (l = Tr(F, At, l, rr)) != l) | (le = E(E(Or(F, At, Je) + Kt(F, At)) + E(Rr(F, At, Je) + nr(F, At)))) != le ? m ? le : l : tr(l, le);
                      }
                      if (l = er(F, At, Je), Ae = wr(F, At, Je), Jt = er(F, Ne, Je), xi = wr(F, Ne, Je), Ae = E(l + Ae), xa = E(le + Ae), Y[ue + 352 >> 2] = xa, f[ue + 344 >> 2] = 1, Jt = E(Jt + xi), (l = Y[F + 224 >> 2]) != l) {
                        l = Y[572 + (vt = F + (ya << 3) | 0) >> 2];
                        t: {
                          r: {
                            i: {
                              a: {
                                o: {
                                  s: {
                                    u: {
                                      l: {
                                        if (X0) {
                                          Ae = Y[vt + 572 >> 2];
                                          f: {
                                            c: {
                                              h: {
                                                switch (0 | (m = f[vt + 576 >> 2])) {
                                                  case 0:
                                                  case 3:
                                                    break h;
                                                }
                                                if (!((0 | m) != 1 | l != l)) {
                                                  if (!(en & Ae < E(0))) break f;
                                                  break c;
                                                }
                                                if (!(Bo | !(Ae < E(0)) | (0 | m) != 2 | l != l)) break c;
                                                break f;
                                              }
                                              if (!en) break f;
                                            }
                                            if ((vt = f[F + 24 >> 2] >>> 13 & 7) || (vt = f[u + 24 >> 2] >>> 10 & 7), (0 | vt) == 4 && (sn(ue + 24 | 0, F, Ne), f[ue + 28 >> 2] != 3 && (mn(ue + 360 | 0, F, Ne), f[ue + 364 >> 2] != 3))) break l;
                                          }
                                          l = Ae;
                                        } else Ae = Y[vt + 572 >> 2], m = f[vt + 576 >> 2];
                                        switch (0 | m) {
                                          case 0:
                                          case 3:
                                            break s;
                                          default:
                                            break u;
                                        }
                                      }
                                      f[ue + 348 >> 2] = 1;
                                      break r;
                                    }
                                    if (!((0 | m) != 1 | l != l)) {
                                      if ((l = Ae) < E(0)) break s;
                                      break i;
                                    }
                                    if ((0 | m) != 2 | l != l) break o;
                                    if (e0 == e0 && !(Ae < E(0))) break a;
                                  }
                                  f[ue + 348 >> 2] = Mf;
                                  break r;
                                }
                                l = E(NaN);
                                o: switch (m - 1 | 0) {
                                  case 1:
                                    break a;
                                  case 0:
                                    break o;
                                  default:
                                    break i;
                                }
                                l = Ae;
                                break i;
                              }
                              l = E(E(e0 * Ae) * E(0.009999999776482582));
                            }
                            l = E(Jt + l), Y[ue + 356 >> 2] = l, f[ue + 348 >> 2] = (Wa | (0 | m) != 2) & l == l;
                            break t;
                          }
                          Y[ue + 356 >> 2] = e0;
                        }
                        l = Ae;
                      } else f[ue + 348 >> 2] = 1, Ae = E(xa - Ae), Y[ue + 356 >> 2] = Jt + E(Mn ? Ae * l : Ae / l), Ae = Y[572 + (vt = F + (ya << 3) | 0) >> 2], m = f[vt + 576 >> 2], l = Y[vt + 572 >> 2];
                      za(F, At, rr, Je, ue + 344 | 0, ue + 352 | 0), za(F, Ne, e0, Je, ue + 348 | 0, ue + 356 | 0);
                      t: {
                        r: {
                          i: {
                            switch (0 | m) {
                              case 0:
                              case 3:
                                break i;
                            }
                            if (!((0 | m) != 1 | l != l)) {
                              if (Ae < E(0)) break i;
                              break r;
                            }
                            if ((0 | m) != 2 | l != l) break r;
                            if (!(Ae < E(0)) && (vt = 0, X0)) break t;
                          }
                          if (vt = 0, (m = f[F + 24 >> 2] >>> 13 & 7) || (m = f[u + 24 >> 2] >>> 10 & 7), (0 | m) != 4 || (sn(ue + 24 | 0, F, Ne), f[ue + 28 >> 2] == 3)) break t;
                          mn(ue + 360 | 0, F, Ne), vt = f[ue + 364 >> 2] != 3;
                          break t;
                        }
                        vt = 0;
                      }
                      l = Y[ue + 352 >> 2], Ae = Y[ue + 356 >> 2], Jt = (m = At >>> 0 > 1) ? l : Ae, l = m ? Ae : l, Ai = f[ue + 344 >> 2], Kl = f[ue + 348 >> 2], y = m ? Ai : Kl, Ai = m ? Kl : Ai, m = (1 ^ vt) & X, H0(F, Jt, l, 3 & Ke[u + 300 | 0], y, Ai, Je, i0, m, m ? 4 : 7, Pe, ce, Ce, ge), dt = E(dt + E(le - p));
                      t: {
                        if (4 & (m = Ke[u + 300 | 0])) vt = 251 & m;
                        else if (vt = 251 & m, m = 0, !(4 & Ke[F + 300 | 0])) break t;
                        m = 4;
                      }
                      if (je[u + 300 | 0] = m | vt, (0 | q0) == (0 | ($e = $e + 4 | 0))) break;
                    }
                  } else dt = E(0);
                  st = E(st - dt);
                }
                m = Ke[u + 300 | 0], je[u + 300 | 0] = 251 & m | (st < E(0) ? 4 : 4 & m), Ae = E(Or(u, At, U) + Kt(u, At)), Po = E(Rr(u, At, U) + nr(u, At)), Vt = $a(u, At, U);
                t: if (!(st > E(0)) | (0 | xn) != 2) dt = st;
                else {
                  dt = E(0), p = E(0);
                  r: {
                    i: {
                      m = Aa + (f[wa >> 2] << 2) | 0, l = Y[m >> 2];
                      a: {
                        if (!(F = (0 | (m = f[m >> 2])) == 2139156720)) {
                          if ($e = (0 | m) == 2140081935) break i;
                          if ((vt = (0 | m) == 2141891242) | l != l) break t;
                          if ($e) break i;
                          if (vt) break t;
                          if (ze(2, 536870912 + (-1073741825 & m) | 0), p = Tt(), !(1073741824 & m)) break a;
                        }
                        p = E(E(Hi * p) * E(0.009999999776482582));
                      }
                      if (p != p) break t;
                      p = E(0);
                      a: if (!F) {
                        if ((0 | m) == 2140081935) break i;
                        F = 4276;
                        o: {
                          if ((0 | m) != 2141891242) {
                            if (l == l) break o;
                            F = 4268;
                          }
                          switch (p = Y[F >> 2], le = E(NaN), f[F + 4 >> 2] - 1 | 0) {
                            case 0:
                              break i;
                            case 1:
                              break a;
                            default:
                              break r;
                          }
                        }
                        if (ze(2, 536870912 + (-1073741825 & m) | 0), p = Tt(), !(1073741824 & m)) break i;
                      }
                      le = E(E(Hi * p) * E(0.009999999776482582));
                      break r;
                    }
                    le = p;
                  }
                  if ((l = E(E(E(le - Ae) - Po) - E(rr - st))) != l) break t;
                  dt = tr(l, E(0));
                }
                t: {
                  if (!(vt = Le >>> 0 <= He >>> 0)) {
                    for (q0 = f[u + 556 >> 2], en = (m = f[u + 560 >> 2] - q0 >> 2) >>> 0 < He >>> 0 ? He : m, $e = 0, m = He; ; ) {
                      if ((0 | m) == (0 | en)) break n;
                      if (F = f[q0 + (m << 2) >> 2], (196608 & f[F + 24 >> 2]) != 131072 && (sn(ya = ue + 24 | 0, F, At), Bo = f[ue + 28 >> 2], mn(ya, F, At), $e = (((0 | Bo) == 3) + $e | 0) + (f[ue + 28 >> 2] == 3) | 0), (0 | Le) == (0 | (m = m + 1 | 0))) break;
                    }
                    if (Jt = E(0), p = Vt, $e) break t;
                  }
                  Jt = E(0), $e = 0, p = Vt;
                  r: switch ((f[u + 24 >> 2] >>> 4 & 7) - 1 | 0) {
                    case 0:
                      Jt = E(dt * E(0.5));
                      break t;
                    case 1:
                      Jt = dt;
                      break t;
                    case 2:
                      if (c0 >>> 0 < 2) break t;
                      p = E(Vt + E((A = E(0), C = tr(dt, E(0)), ((v = dt != dt) ? A : C) / E(c0 - 1 >>> 0))));
                      break t;
                    case 4:
                      Jt = E(dt / E(c0 + 1 >>> 0)), p = E(Vt + Jt);
                      break t;
                    case 3:
                      break r;
                    default:
                      break t;
                  }
                  Jt = E(E(dt * E(0.5)) / E(c0 >>> 0)), p = E(E(Jt + Jt) + Vt);
                }
                if (l = E(Ae + Jt), st = E(0), c0 = Ef(u), vt) p = E(0);
                else {
                  for (q0 = Le - 1 | 0, Bu = E(dt / E(0 | $e)), Ae = E(0), le = E(0), m = He; ; ) {
                    if (F = f[u + 556 >> 2], f[u + 560 >> 2] - F >> 2 >>> 0 <= m >>> 0) break n;
                    D0(ue + 24 | 0, $e = (F = f[F + (m << 2) >> 2]) + 228 | 0, 320), p = E(p - ((0 | m) == (0 | q0) ? Vt : E(0)));
                    t: if (!(4194304 & (en = f[F + 24 >> 2]))) {
                      r: {
                        if ((196608 & en) == 131072) {
                          if (!Ln(F, At)) break r;
                          if (!X) break t;
                          dt = ga(F, At, rr), tn = Kt(u, At), xi = er(F, At, Je), Y[$e + (f[Vn >> 2] << 2) >> 2] = xi + E(dt + tn);
                          break t;
                        }
                        if (sn(ue + 360 | 0, F, At), l = E(l + (f[ue + 364 >> 2] == 3 ? Bu : E(-0))), X && (en = $e, $e = f[Vn >> 2] << 2, Y[en + $e >> 2] = l + Y[$e + (ue + 24 | 0) >> 2]), mn(ue + 360 | 0, F, At), l = E(l + (f[ue + 364 >> 2] == 3 ? Bu : E(-0))), !Uu) {
                          l = E(l + E(E(p + E(er(F, At, Je) + wr(F, At, Je))) + Y[ue + 104 >> 2])), st = e0;
                          break t;
                        }
                        if (l = E(l + E(p + E(Y[($e = F + 516 | 0) + (f[wa >> 2] << 2) >> 2] + E(er(F, At, Je) + wr(F, At, Je))))), c0) {
                          if (dt = Eu(F), tn = er(F, 0, Je), dt = E(dt + tn), tn = E(E(Y[F + 520 >> 2] + E(er(F, 0, Je) + wr(F, 0, Je))) - dt), Ae = (F = Ae != Ae) | dt != dt ? F ? dt : Ae : tr(Ae, dt), !((F = le != le) | tn != tn)) {
                            le = tr(le, tn);
                            break t;
                          }
                          le = F ? tn : le;
                          break t;
                        }
                        if (!((dt = E(Y[$e + (f[f0 >> 2] << 2) >> 2] + E(er(F, Ne, Je) + wr(F, Ne, Je)))) != dt | (F = st != st))) {
                          st = tr(st, dt);
                          break t;
                        }
                        st = F ? dt : st;
                        break t;
                      }
                      X && (F = f[Vn >> 2] << 2, dt = Y[F + (ue + 24 | 0) >> 2], v = F + $e | 0, A = E(Jt + E(dt + Kt(u, At))), Y[v >> 2] = A);
                    }
                    if ((0 | Le) == (0 | (m = m + 1 | 0))) break;
                  }
                  p = E(le + Ae);
                }
                if (Ae = c0 ? p : st, dt = e0, Nf || (p = (m = (p = Tr(u, Ne, E(wn + Ae), Un)) != p) | (le = E(E(Or(u, Ne, U) + Kt(u, Ne)) + E(Rr(u, Ne, U) + nr(u, Ne)))) != le ? m ? le : p : tr(p, le), dt = E(p - wn)), p = (m = (p = Tr(u, Ne, E(wn + (Lf ? e0 : Ae)), Un)) != p) | (le = E(E(Or(u, Ne, U) + Kt(u, Ne)) + E(Rr(u, Ne, U) + nr(u, Ne)))) != le ? m ? le : p : tr(p, le), le = E(p - wn), !(vt | !X)) for (; ; ) {
                  if (m = f[u + 556 >> 2], f[u + 560 >> 2] - m >> 2 >>> 0 <= He >>> 0) break n;
                  m = f[m + (He << 2) >> 2];
                  t: if (!(4194304 & (F = f[m + 24 >> 2]))) if ((196608 & F) != 131072) {
                    (F = F >>> 13 & 7) || (F = f[u + 24 >> 2] >>> 10 & 7);
                    r: {
                      i: {
                        if ((0 | F) != 5) {
                          if ((0 | F) == 4 && (sn(ue + 24 | 0, m, Ne), F = 4, f[ue + 28 >> 2] != 3)) {
                            if (mn(ue + 360 | 0, m, Ne), $e = f[f0 >> 2], f[ue + 364 >> 2] == 3) break i;
                            Ae = Y[572 + ($e = m + ($e << 3) | 0) >> 2];
                            a: {
                              switch (0 | (F = f[$e + 576 >> 2])) {
                                case 0:
                                case 3:
                                  break a;
                              }
                              if (!((0 | F) != 1 | (st = Y[$e + 572 >> 2]) != st)) {
                                if (p = Wr, Ae < E(0)) break a;
                                break r;
                              }
                              if (p = Wr, X0 & !(Ae < E(0)) | (0 | F) != 2 | st != st) break r;
                            }
                            Ae = Y[516 + (m + (f[wa >> 2] << 2) | 0) >> 2], p = (p = Y[m + 224 >> 2]) == p ? E(E(er(m, Ne, Je) + wr(m, Ne, Je)) + E(Mn ? Ae * p : Ae / p)) : le, Y[ue + 360 >> 2] = p, v = ue, A = E(Ae + E(er(m, At, Je) + wr(m, At, Je))), Y[v + 24 >> 2] = A, f[ue + 356 >> 2] = 1, f[ue + 352 >> 2] = 1, za(m, At, rr, Je, ue + 356 | 0, ue + 24 | 0), za(m, Ne, e0, Je, ue + 352 | 0, ue + 360 | 0), Ae = Y[ue + 360 >> 2], st = Y[ue + 24 >> 2], p = (F = At >>> 0 > 1) ? Ae : st, H0(m, Ae = F ? st : Ae, p, bn, !((F = (0 | An) != 0 & (896 & f[u + 24 >> 2]) != 512) & Mn | Ae != Ae), (Mn | !F) & p == p, Je, i0, 1, 2, Pe, ce, Ce, ge), p = Wr;
                            break r;
                          }
                        } else F = 8 & f[u + 24 >> 2] ? 5 : 1;
                        $e = f[f0 >> 2];
                      }
                      if (p = Y[516 + (($e << 2) + m | 0) >> 2], Ae = er(m, Ne, Je), st = wr(m, Ne, Je), sn(ue + 24 | 0, m, Ne), Ae = E(dt - E(p + E(Ae + st))), f[ue + 28 >> 2] != 3 || (mn(ue + 360 | 0, m, Ne), f[ue + 364 >> 2] != 3)) {
                        if (mn(ue + 24 | 0, m, Ne), p = Wr, f[ue + 28 >> 2] != 3) if (sn(ue + 24 | 0, m, Ne), f[ue + 28 >> 2] != 3) {
                          switch (F - 1 | 0) {
                            case 1:
                              p = E(Wr + E(Ae * E(0.5)));
                              break r;
                            case 0:
                              break r;
                          }
                          p = E(Wr + Ae);
                        } else p = E(Wr + (A = E(0), C = tr(Ae, E(0)), (v = Ae != Ae) ? A : C));
                      } else p = E(Ae * E(0.5)), p = E(Wr + (A = E(0), C = tr(p, E(0)), (v = p != p) ? A : C));
                    }
                    m = m + (f[Gr >> 2] << 2) | 0, Y[m + 228 >> 2] = p + E(ba + Y[m + 228 >> 2]);
                  } else {
                    if (F = f[Gr >> 2], Ln(m, Ne) && (p = E(E(ga(m, Ne, e0) + Kt(u, Ne)) + er(m, Ne, Je)), Y[228 + (m + (F << 2) | 0) >> 2] = p, p == p)) break t;
                    v = m + (F << 2) | 0, A = E(Kt(u, Ne) + er(m, Ne, Je)), Y[v + 228 >> 2] = A;
                  }
                  if ((0 | (He = He + 1 | 0)) == (0 | Le)) break;
                }
                if (p = E((Xr ? Xl : E(0)) + le), Io = (m = Io != Io) | (l = E(Po + l)) != l ? m ? l : Io : tr(Io, l), ba = E(ba + p), m = Xr + 1 | 0, He = Le, !(Le >>> 0 < Vi >>> 0)) break;
              }
              t: if (X && (An || Ef(u))) {
                Ae = E(0);
                r: {
                  i: if (e0 == e0) {
                    l = E(e0 - ba);
                    a: switch ((f[u + 24 >> 2] >>> 7 & 7) - 2 | 0) {
                      case 0:
                        Wr = E(Wr + E(l * E(0.5)));
                        break i;
                      case 2:
                        if (!(e0 > ba)) break i;
                        Ae = E(l / E(m >>> 0));
                        break i;
                      case 5:
                        if (e0 > ba) {
                          if (Wr = E(Wr + E(l / E(m << 1 >>> 0))), m >>> 0 < 2) break i;
                          Ae = E(l / E(m >>> 0));
                          break r;
                        }
                        Wr = E(Wr + E(l * E(0.5)));
                        break i;
                      case 4:
                        if (!(e0 > ba) | m >>> 0 < 2) break i;
                        Ae = E(l / E(Xr >>> 0));
                        break r;
                      case 1:
                        break a;
                      default:
                        break i;
                    }
                    Wr = E(Wr + l);
                  }
                  if (!m) break t;
                }
                for ($e = 0, m = 0, F = 0; ; ) {
                  if (st = E(0), p = E(0), l = E(0), le = E(0), Le = m, m >>> 0 < Vi >>> 0) {
                    r: {
                      for (; ; ) {
                        if (F = f[u + 556 >> 2], f[u + 560 >> 2] - F >> 2 >>> 0 <= Le >>> 0) break n;
                        if (He = f[F + (Le << 2) >> 2], !(4194304 & (vt = f[He + 24 >> 2]) | (196608 & vt) == 131072)) {
                          if (F = Le, f[He + 548 >> 2] != (0 | $e)) break r;
                          (l = Y[516 + (He + (f[f0 >> 2] << 2) | 0) >> 2]) >= E(0) && (p = (F = p != p) | (l = E(l + E(er(He, Ne, Je) + wr(He, Ne, Je)))) != l ? F ? l : p : tr(p, l)), (F = vt >>> 13 & 7) || (F = f[u + 24 >> 2] >>> 10 & 7), !(8 & Ke[u + 24 | 0]) | (0 | F) != 5 || (l = Eu(He), dt = er(He, 0, Je), l = E(l + dt), dt = E(E(Y[He + 520 >> 2] + E(er(He, 0, Je) + wr(He, 0, Je))) - l), F = p != p, le = (He = le != le) | l != l ? He ? l : le : tr(le, l), st = (He = st != st) | dt != dt ? He ? dt : st : tr(st, dt), p = F | (l = E(le + st)) != l ? F ? l : p : tr(p, l));
                        }
                        if ((0 | Vi) == (0 | (Le = Le + 1 | 0))) break;
                      }
                      F = Vi;
                    }
                    l = p;
                  }
                  if (dt = E(Wr + ($e ? Xl : E(0))), p = E(Ae + l), Wr = E(dt + p), m >>> 0 < F >>> 0) for (Vt = E(dt + le); ; ) {
                    if (Le = f[u + 556 >> 2], f[u + 560 >> 2] - Le >> 2 >>> 0 <= m >>> 0) break n;
                    He = f[Le + (m << 2) >> 2];
                    r: if (!(4194304 & (Le = f[He + 24 >> 2]) | (196608 & Le) == 131072)) {
                      (Le = Le >>> 13 & 7) || (Le = f[u + 24 >> 2] >>> 10 & 7);
                      i: {
                        a: switch (Le - 1 | 0) {
                          case 4:
                            if (8 & Ke[u + 24 | 0]) break i;
                          case 0:
                            l = er(He, Ne, Je), Y[228 + (He + (f[Gr >> 2] << 2) | 0) >> 2] = dt + l;
                            break r;
                          case 2:
                            l = wr(He, Ne, Je), Y[(Le = He + 228 | 0) + (f[Gr >> 2] << 2) >> 2] = E(Wr - l) - Y[288 + (Le + (f[f0 >> 2] << 2) | 0) >> 2];
                            break r;
                          case 1:
                            Y[(Le = He + 228 | 0) + (f[Gr >> 2] << 2) >> 2] = dt + E(E(p - Y[288 + (Le + (f[f0 >> 2] << 2) | 0) >> 2]) * E(0.5));
                            break r;
                          case 3:
                            break a;
                          default:
                            break r;
                        }
                        l = er(He, Ne, Je), Y[228 + (He + (f[Gr >> 2] << 2) | 0) >> 2] = dt + l, vt = He + (f[f0 >> 2] << 3) | 0, l = Y[(Le = vt) + 572 >> 2];
                        a: {
                          switch (0 | (Le = f[Le + 576 >> 2])) {
                            case 0:
                            case 3:
                              break a;
                          }
                          if (!((0 | Le) != 1 | (le = Y[vt + 572 >> 2]) != le)) {
                            if (l < E(0)) break a;
                            break r;
                          }
                          if (X0 & !(l < E(0)) | (0 | Le) != 2 | le != le) break r;
                        }
                        At >>> 0 >= 2 ? (st = p, l = Y[He + 516 >> 2], le = E(l + E(er(He, At, Je) + wr(He, At, Je)))) : (st = E(Y[He + 520 >> 2] + E(er(He, Ne, Je) + wr(He, Ne, Je))), l = Y[He + 516 >> 2], le = p);
                        a: {
                          o: {
                            if (!(le != le | l != l)) {
                              if (E(jr(E(le - l))) < E(9999999747378752e-20)) break o;
                              break a;
                            }
                            if (le == le | l == l) break a;
                          }
                          if (!((Le = (l = Y[He + 520 >> 2]) != l) | st != st)) {
                            if (!(E(jr(E(st - l))) < E(9999999747378752e-20))) break a;
                            break r;
                          }
                          if (st != st && Le) break r;
                        }
                        H0(He, le, st, bn, 1, 1, Je, i0, 1, 3, Pe, ce, Ce, ge);
                        break r;
                      }
                      v = He, A = E(E(Vt - Eu(He)) + ga(He, 0, e0)), Y[v + 232 >> 2] = A;
                    }
                    if ((0 | F) == (0 | (m = m + 1 | 0))) break;
                  }
                  if (Le = (0 | $e) != (0 | Xr), $e = $e + 1 | 0, m = F, !Le) break;
                }
              }
              $e = u + 516 | 0, l = (m = (l = Tr(u, 2, Lu, U)) != l) | (p = E(E(Or(u, 2, U) + Kt(u, 2)) + E(Rr(u, 2, U) + nr(u, 2)))) != p ? m ? p : l : tr(l, p), Y[$e >> 2] = l, l = (m = (l = Tr(u, 0, _2, $)) != l) | (p = E(E(Or(u, 0, U) + Kt(u, 0)) + E(Rr(u, 0, U) + nr(u, 0)))) != p ? m ? p : l : tr(l, p), Y[u + 520 >> 2] = l;
              t: {
                r: if (xn && (0 | (m = f[u + 24 >> 2] >>> 20 & 3)) == 2 | (0 | xn) != 2) {
                  if ((0 | xn) != 2 | (0 | m) != 2) break t;
                  l = (m = (l = (m = (p = E(Yi + rr)) != p) | (l = Tr(u, At, Io, Hi)) != l ? m ? l : p : Cu(p, l)) != l) | Yi != Yi ? m ? Yi : l : tr(l, Yi);
                } else {
                  if (!((m = (l = Tr(u, At, Io, Hi)) != l) | (p = E(E(Or(u, At, U) + Kt(u, At)) + E(Rr(u, At, U) + nr(u, At)))) != p)) {
                    l = tr(l, p);
                    break r;
                  }
                  l = m ? p : l;
                }
                Y[$e + (f[wa >> 2] << 2) >> 2] = l;
              }
              t: {
                r: if (Ot && (F = (0 | Ot) != 2) | (0 | (m = f[u + 24 >> 2] >>> 20 & 3)) == 2) {
                  if (F | (0 | m) != 2) break t;
                  l = (m = (l = (m = (p = E(wn + e0)) != p) | (l = Tr(u, Ne, E(wn + ba), Un)) != l ? m ? l : p : Cu(p, l)) != l) | wn != wn ? m ? wn : l : tr(l, wn);
                } else {
                  if (!((m = (l = Tr(u, Ne, E(wn + ba), Un)) != l) | (p = E(E(Or(u, Ne, U) + Kt(u, Ne)) + E(Rr(u, Ne, U) + nr(u, Ne)))) != p)) {
                    l = tr(l, p);
                    break r;
                  }
                  l = m ? p : l;
                }
                Y[$e + (f[f0 >> 2] << 2) >> 2] = l;
              }
              if (X) {
                if (m = f[u + 560 >> 2], He = f[u + 556 >> 2], (786432 & f[u + 24 >> 2]) == 524288) {
                  for (F = Vi >>> 0 <= 1 ? 1 : Vi, X = m - He >> 2, m = 0; Le = 0, Le = m >>> 0 < X >>> 0 ? f[(m << 2) + He >> 2] : Le, (196608 & f[Le + 24 >> 2]) != 131072 && (vt = (Le = Le + 228 | 0) + (f[Gr >> 2] << 2) | 0, Xr = f[f0 >> 2] << 2, Y[vt >> 2] = E(Y[Xr + $e >> 2] - Y[vt >> 2]) - Y[288 + (Le + Xr | 0) >> 2]), (0 | F) != (0 | (m = m + 1 | 0)); ) ;
                  He = f[u + 556 >> 2], m = f[u + 560 >> 2];
                }
                if ((0 | m) != (0 | He)) for (Xr = (0 | (At >>> 0 > 1 ? xn : D)) != 0; ; ) {
                  X = f[He >> 2];
                  t: if ((4390912 & f[X + 24 >> 2]) == 131072) {
                    p = Je, rr = i0, Ke[f[u + 568 >> 2] + 21 | 0] && (rr = Y[u + 520 >> 2], p = Y[u + 516 >> 2]), D = f[u + 24 >> 2] >>> 2 & 3;
                    r: {
                      i: {
                        if ((0 | bn) == 2) {
                          F = 0, Le = 3;
                          a: switch (D - 2 | 0) {
                            case 0:
                              break r;
                            case 1:
                              break a;
                            default:
                              break i;
                          }
                          Le = 2;
                          break r;
                        }
                        if (F = 0, !(D >>> 0 <= 1)) {
                          Le = D;
                          break r;
                        }
                      }
                      Le = D, F = Ro;
                    }
                    $ = E(er(X, 2, p) + wr(X, 2, p)), Ae = er(X, 0, p), st = wr(X, 0, p), l = Y[X + 572 >> 2];
                    r: {
                      i: {
                        switch (0 | (D = f[X + 576 >> 2])) {
                          case 0:
                          case 3:
                            break i;
                        }
                        a: {
                          if (!((0 | D) != 1 | (U = Y[X + 572 >> 2]) != U)) {
                            if (le = l, !(l < E(0))) break a;
                            break i;
                          }
                          o: {
                            if ((0 | D) != 2 | U != U) {
                              le = E(NaN);
                              s: switch (D - 1 | 0) {
                                case 1:
                                  break o;
                                case 0:
                                  break s;
                                default:
                                  break a;
                              }
                              le = l;
                              break a;
                            }
                            if (p != p | l < E(0)) break i;
                          }
                          le = E(E(p * l) * E(0.009999999776482582));
                        }
                        le = E($ + le);
                        break r;
                      }
                      le = E(NaN), Ln(X, 2) && ms(X, 2) && (le = (D = (l = Tr(X, 2, E(E(Y[u + 516 >> 2] - E(Kt(u, 2) + nr(u, 2))) - E(ga(X, 2, p) + vs(X, 2, p))), p)) != l) | (U = E(E(Or(X, 2, p) + Kt(X, 2)) + E(Rr(X, 2, p) + nr(X, 2)))) != U ? D ? U : l : tr(l, U));
                    }
                    st = E(Ae + st);
                    r: {
                      i: {
                        a: {
                          o: {
                            s: {
                              u: {
                                l: {
                                  vt = le != le, U = Y[X + 580 >> 2];
                                  f: {
                                    c: {
                                      switch (0 | (D = f[X + 584 >> 2])) {
                                        case 0:
                                        case 3:
                                          break c;
                                      }
                                      h: {
                                        if (!((0 | D) != 1 | (l = Y[X + 580 >> 2]) != l)) {
                                          if (!((l = U) < E(0))) break h;
                                          break c;
                                        }
                                        v: {
                                          if ((0 | D) != 2 | l != l) {
                                            l = E(NaN);
                                            g: switch (D - 1 | 0) {
                                              case 1:
                                                break v;
                                              case 0:
                                                break g;
                                              default:
                                                break h;
                                            }
                                            l = U;
                                            break h;
                                          }
                                          if (rr != rr | U < E(0)) break c;
                                        }
                                        l = E(E(rr * U) * E(0.009999999776482582));
                                      }
                                      l = E(st + l);
                                      break f;
                                    }
                                    if (!Ln(X, 0) || !ms(X, 0)) {
                                      if (l = E(NaN), le == le) break l;
                                      break a;
                                    }
                                    l = (D = (l = Tr(X, 0, E(E(Y[u + 520 >> 2] - E(Kt(u, 0) + nr(u, 0))) - E(ga(X, 0, rr) + vs(X, 0, rr))), rr)) != l) | (U = E(E(Or(X, 0, p) + Kt(X, 0)) + E(Rr(X, 0, p) + nr(X, 0)))) != U ? D ? U : l : tr(l, U);
                                  }
                                  if ((0 | vt) == (l != l | 0) || (Ae = Y[X + 224 >> 2]) != Ae) break s;
                                  if (le != le) {
                                    le = E(E(E(l - st) * Ae) + $);
                                    break s;
                                  }
                                  if (l == l) break s;
                                  break u;
                                }
                                if ((Ae = Y[X + 224 >> 2]) != Ae) break o;
                              }
                              l = E(st + E(E(le - $) / Ae));
                            }
                            if (le != le) break a;
                            if (l == l) break r;
                          }
                          D = 0;
                          break i;
                        }
                        D = 1;
                      }
                      vt = p > E(0), c0 = D & Xr & Le >>> 0 < 2, D ^= 1, H0(X, U = c0 && vt ? p : le, l, bn, c0 && vt ? 2 : D, l == l, U, l, 0, 6, Pe, ce, Ce, ge), le = E(Y[X + 516 >> 2] + Rf(X, 2, p)), l = E(Y[X + 520 >> 2] + Rf(X, 0, p));
                    }
                    H0(X, le, l, bn, 1, 1, le, l, 1, 1, Pe, ce, Ce, ge), $ = (D = Le >>> 0 < 2) ? p : rr, vt = f[u + 568 >> 2], U = Ke[vt + 22 | 0] ? $ : p;
                    r: {
                      if (!ms(X, Le) || Ln(X, Le))
                        if (Ln(X, Le) | (112 & f[u + 24 >> 2]) != 16)
                          if (Ln(X, Le) | (112 & f[u + 24 >> 2]) != 32) {
                            if (!Ke[vt + 21 | 0] || !Ln(X, Le)) break r;
                            l = Y[$e + (f[4252 + (Le << 2) >> 2] << 2) >> 2], l = E(E(ga(X, Le, l) + Kt(u, Le)) + er(X, Le, l));
                          } else D = f[4252 + (Le << 2) >> 2] << 2, l = E(Y[D + $e >> 2] - Y[516 + (D + X | 0) >> 2]);
                        else D = f[4252 + (Le << 2) >> 2] << 2, l = E(E(Y[D + $e >> 2] - Y[516 + (D + X | 0) >> 2]) * E(0.5));
                      else c0 = f[4252 + (Le << 2) >> 2] << 2, l = E(E(E(E(Y[c0 + $e >> 2] - Y[516 + (X + c0 | 0) >> 2]) - nr(u, Le)) - wr(X, Le, U)) - vs(X, Le, D ? rr : p));
                      Y[228 + (X + (f[4220 + (Le << 2) >> 2] << 2) | 0) >> 2] = l;
                    }
                    r: if (!ms(X, F) || Ln(X, F))
                      if (Ln(X, F) || ((D = f[X + 24 >> 2] >>> 13 & 7) || (D = f[u + 24 >> 2] >>> 10 & 7), (0 | D) != 2)) {
                        i: if (!Ln(X, F)) {
                          Le = f[X + 24 >> 2] >>> 13 & 7, D = f[u + 24 >> 2];
                          a: {
                            if (!((0 | (Le = Le || D >>> 10 & 7)) != 5 | 8 & D)) {
                              if ((786432 & D) == 524288) break a;
                              break i;
                            }
                            if (((786432 & D) == 524288 | 0) == ((0 | Le) == 3 | 0)) break i;
                          }
                          D = f[4252 + (F << 2) >> 2] << 2, l = E(Y[D + $e >> 2] - Y[516 + (D + X | 0) >> 2]);
                          break r;
                        }
                        if (!Ke[vt + 21 | 0] || !Ln(X, F)) break t;
                        l = Y[$e + (f[4252 + (F << 2) >> 2] << 2) >> 2], l = E(E(ga(X, F, l) + Kt(u, F)) + er(X, F, l));
                      } else D = f[4252 + (F << 2) >> 2] << 2, l = E(E(Y[D + $e >> 2] - Y[516 + (D + X | 0) >> 2]) * E(0.5));
                    else D = f[4252 + (F << 2) >> 2] << 2, l = E(E(E(E(Y[D + $e >> 2] - Y[516 + (D + X | 0) >> 2]) - nr(u, F)) - wr(X, F, U)) - vs(X, F, $));
                    Y[228 + (X + (f[4220 + (F << 2) >> 2] << 2) | 0) >> 2] = l;
                  }
                  if ((0 | (He = He + 4 | 0)) == (0 | m)) break;
                }
                if (1 & (Ne | At)) for (F = 1 & Ne, X = 1 & At, Pe = Vi >>> 0 <= 1 ? 1 : Vi, ce = 4236 + (Ne << 2) | 0, Ce = 4236 + (At << 2) | 0, ge = f[u + 556 >> 2], Ne = f[u + 560 >> 2] - ge >> 2, m = 0; ; ) {
                  if ((0 | m) == (0 | Ne)) break n;
                  if (u = f[ge + (m << 2) >> 2], 64 & Ke[u + 26 | 0] || (X && (D = u + 228 | 0, Le = f[wa >> 2] << 2, Y[D + (f[Ce >> 2] << 2) >> 2] = E(Y[Le + $e >> 2] - Y[288 + (D + Le | 0) >> 2]) - Y[D + (f[Vn >> 2] << 2) >> 2]), F && (u = u + 228 | 0, D = f[f0 >> 2] << 2, Y[u + (f[ce >> 2] << 2) >> 2] = E(Y[D + $e >> 2] - Y[288 + (u + D | 0) >> 2]) - Y[u + (f[Gr >> 2] << 2) >> 2])), (0 | Pe) == (0 | (m = m + 1 | 0))) break;
                }
              }
              if (!C0) break e;
              l0(C0);
              break e;
            }
            Do(), Ut();
          }
          nt = ue + 384 | 0;
        }
        function gf() {
          var u = 0, l = 0;
          ji(6952, 6953, 6954, 0, 4284, 17, 4287, 0, 4287, 0, 2528, 4289, 18), u = Ze(8), f[u >> 2] = 8, f[u + 4 >> 2] = 1, ot(6952, 2873, 6, 4304, 4328, 19, 0 | u, 1), ji(6956, 6957, 6958, 6952, 4284, 20, 4284, 21, 4284, 22, 2e3, 4289, 23), u = Ze(4), f[u >> 2] = 24, ot(6956, 2358, 2, 4336, 4344, 25, 0 | u, 0), $i(6952, 1397, 2, 4348, 4356, 26, 27), $i(6952, 2978, 3, 4436, 4448, 28, 29), ji(6976, 6977, 6978, 0, 4284, 30, 4287, 0, 4287, 0, 2544, 4289, 31), u = Ze(8), f[u >> 2] = 8, f[u + 4 >> 2] = 1, ot(6976, 3244, 2, 4456, 4344, 32, 0 | u, 1), ji(6979, 6980, 6981, 6976, 4284, 33, 4284, 34, 4284, 35, 2023, 4289, 36), u = Ze(4), f[u >> 2] = 37, ot(6979, 2358, 2, 4464, 4344, 38, 0 | u, 0), $i(6976, 1397, 2, 4472, 4356, 39, 40), $i(6976, 2978, 3, 4436, 4448, 28, 41), ji(6982, 6983, 6984, 0, 4284, 42, 4287, 0, 4287, 0, 2812, 4289, 43), Ml(6982, 1, 4520, 4284, 44, 45), $i(6982, 2866, 1, 4520, 4284, 44, 45), $i(6982, 1128, 2, 4524, 4344, 46, 47), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 48, ot(6982, 3185, 4, 4544, 4560, 49, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 50, ot(6982, 1980, 3, 4568, 4580, 51, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 52, ot(6982, 1951, 3, 4588, 4600, 53, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 54, ot(6982, 1799, 3, 4588, 4600, 53, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 55, ot(6982, 3215, 3, 4608, 4448, 56, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 57, ot(6982, 1925, 2, 4620, 4356, 58, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 59, ot(6982, 1784, 2, 4620, 4356, 58, 0 | u, 0), cs(6985, 1270, 4628, 60, 4289, 61), wi(1731, 0), wi(1611, 8), wi(2144, 16), wi(2454, 24), wi(2560, 32), wi(1617, 40), ls(6985), cs(6955, 2849, 4628, 62, 4289, 63), w2(2560, 0), w2(1617, 8), ls(6955), cs(6986, 2860, 4628, 64, 4289, 65), u = Ze(4), f[u >> 2] = 8, l = Ze(4), f[l >> 2] = 8, Ma(6986, 2854, 7018, 4630, 66, 0 | u, 7018, 4634, 67, 0 | l), u = Ze(4), f[u >> 2] = 0, l = Ze(4), f[l >> 2] = 0, Ma(6986, 1606, 7011, 4356, 68, 0 | u, 7011, 4600, 69, 0 | l), ls(6986), ji(6987, 6988, 6989, 0, 4284, 70, 4287, 0, 4287, 0, 2973, 4289, 71), Ml(6987, 1, 4640, 4284, 72, 73), $i(6987, 1592, 1, 4640, 4284, 72, 73), $i(6987, 2802, 2, 4644, 4356, 74, 75), $i(6987, 1128, 2, 4652, 4344, 76, 77), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 78, ot(6987, 1752, 2, 4652, 4344, 79, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 80, ot(6987, 2956, 3, 4660, 4600, 81, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 82, ot(6987, 2881, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 84, ot(6987, 2334, 4, 4688, 4704, 85, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 86, ot(6987, 1484, 4, 4688, 4704, 85, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 87, ot(6987, 1355, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 88, ot(6987, 1817, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 89, ot(6987, 2823, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 90, ot(6987, 2378, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 91, ot(6987, 2163, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 92, ot(6987, 1319, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 93, ot(6987, 2412, 4, 4688, 4704, 85, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 94, ot(6987, 1503, 4, 4688, 4704, 85, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 95, ot(6987, 2235, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 96, ot(6987, 1219, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 97, ot(6987, 1136, 3, 4672, 4600, 83, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 98, ot(6987, 1158, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 100, ot(6987, 1845, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 101, ot(6987, 1464, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 102, ot(6987, 2218, 2, 4652, 4344, 79, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 103, ot(6987, 1195, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 104, ot(6987, 2500, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 105, ot(6987, 2590, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 106, ot(6987, 1539, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 107, ot(6987, 2249, 2, 4652, 4344, 79, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 108, ot(6987, 1650, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 109, ot(6987, 1427, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 110, ot(6987, 2204, 2, 4652, 4344, 79, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 111, ot(6987, 2608, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 112, ot(6987, 1555, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 113, ot(6987, 1670, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 114, ot(6987, 1444, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 115, ot(6987, 2566, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 116, ot(6987, 1520, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 117, ot(6987, 1624, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 118, ot(6987, 1407, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 119, ot(6987, 2304, 3, 4712, 4634, 99, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 120, ot(6987, 2092, 4, 4688, 4704, 85, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 121, ot(6987, 2718, 4, 4688, 4704, 85, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 122, ot(6987, 1574, 4, 4688, 4704, 85, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 123, ot(6987, 2187, 4, 4688, 4704, 85, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 124, ot(6987, 2897, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 126, ot(6987, 2346, 3, 4732, 4448, 127, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 128, ot(6987, 1371, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 129, ot(6987, 1831, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 130, ot(6987, 2836, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 131, ot(6987, 2395, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 132, ot(6987, 2175, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 133, ot(6987, 1337, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 134, ot(6987, 2422, 3, 4732, 4448, 127, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 135, ot(6987, 1858, 2, 4744, 4356, 136, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 137, ot(6987, 1207, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 139, ot(6987, 2514, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 140, ot(6987, 2599, 2, 4744, 4356, 136, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 141, ot(6987, 1660, 2, 4744, 4356, 136, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 142, ot(6987, 2620, 2, 4744, 4356, 136, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 143, ot(6987, 1683, 2, 4744, 4356, 136, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 144, ot(6987, 2578, 2, 4744, 4356, 136, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 145, ot(6987, 1637, 2, 4744, 4356, 136, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 146, ot(6987, 2319, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 147, ot(6987, 2102, 3, 4760, 4772, 148, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 149, ot(6987, 1231, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 150, ot(6987, 1147, 2, 4724, 4356, 125, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 151, ot(6987, 2729, 3, 4732, 4448, 127, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 152, ot(6987, 2194, 3, 4780, 4792, 153, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 154, ot(6987, 2985, 4, 4800, 4560, 155, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 156, ot(6987, 3006, 3, 4816, 4600, 157, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 158, ot(6987, 1292, 2, 4828, 4356, 159, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 160, ot(6987, 1387, 2, 4836, 4356, 161, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 162, ot(6987, 2997, 3, 4844, 4448, 163, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 164, ot(6987, 2913, 2, 4856, 4356, 165, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 166, ot(6987, 2933, 3, 4864, 4600, 167, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 168, ot(6987, 3308, 3, 4876, 4600, 169, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 170, ot(6987, 3306, 2, 4652, 4344, 79, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 171, ot(6987, 3325, 3, 4888, 4600, 172, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 173, ot(6987, 3323, 2, 4652, 4344, 79, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 174, ot(6987, 1118, 2, 4652, 4344, 79, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 175, ot(6987, 1110, 2, 4900, 4356, 176, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 177, ot(6987, 1243, 5, 4912, 4932, 178, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 179, ot(6987, 1736, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 180, ot(6987, 1714, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 181, ot(6987, 2148, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 182, ot(6987, 2461, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 183, ot(6987, 2632, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 184, ot(6987, 1696, 2, 4752, 4630, 138, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 185, ot(6987, 1259, 2, 4940, 4356, 186, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 187, ot(6987, 2432, 3, 4760, 4772, 148, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 188, ot(6987, 2112, 3, 4760, 4772, 148, 0 | u, 0), u = Ze(8), f[u + 4 >> 2] = 0, f[u >> 2] = 189, ot(6987, 2740, 3, 4760, 4772, 148, 0 | u, 0);
        }
        function xu(u, l, p, m, D, F, U) {
          var $, X, Pe, ce = 0, Ce = 0, ge = 0, Ne = 0, ue = 0, le = 0, Ae = 0, Le = 0, $e = 0, He = 0, Je = 0, st = 0, dt = 0, vt = 0, At = 0, Ot = 0, Vt = 0;
          nt = $ = nt - 80 | 0, f[$ + 76 >> 2] = l, Pe = $ + 55 | 0, X = $ + 56 | 0;
          e: {
            n: {
              t: {
                r: {
                  i: for (; ; ) {
                    if (ge = l, (2147483647 ^ Le) < (0 | ce)) break r;
                    Le = ce + Le | 0;
                    a: {
                      o: {
                        s: {
                          if (Ce = Ke[0 | (ce = ge)]) for (; ; ) {
                            u: {
                              l: if (l = 255 & Ce) {
                                if ((0 | l) != 37) break u;
                                for (Ce = ce; ; ) {
                                  if (Ke[Ce + 1 | 0] != 37) {
                                    l = Ce;
                                    break l;
                                  }
                                  if (ce = ce + 1 | 0, Ne = Ke[Ce + 2 | 0], Ce = l = Ce + 2 | 0, (0 | Ne) != 37) break;
                                }
                              } else l = ce;
                              if ((0 | (ce = ce - ge | 0)) > (0 | (At = 2147483647 ^ Le))) break r;
                              if (u && S0(u, ge, ce), ce) continue i;
                              f[$ + 76 >> 2] = l, ce = l + 1 | 0, He = -1, !yn(Ce = je[l + 1 | 0]) | Ke[l + 2 | 0] != 36 || (He = Ce - 48 | 0, st = 1, ce = l + 3 | 0), f[$ + 76 >> 2] = ce, Ae = 0;
                              l: if ((l = (Ce = je[0 | ce]) - 32 | 0) >>> 0 > 31) Ne = ce;
                              else if (Ne = ce, 75913 & (l = 1 << l)) for (; ; ) {
                                if (Ne = ce + 1 | 0, f[$ + 76 >> 2] = Ne, Ae |= l, (l = (Ce = je[ce + 1 | 0]) - 32 | 0) >>> 0 >= 32) break l;
                                if (ce = Ne, !(75913 & (l = 1 << l))) break;
                              }
                              l: if ((0 | Ce) != 42) {
                                if ((0 | ($e = ys($ + 76 | 0))) < 0) break r;
                                Ce = f[$ + 76 >> 2];
                              } else {
                                if (!yn(l = je[Ne + 1 | 0]) | Ke[Ne + 2 | 0] != 36) {
                                  if (st) break s;
                                  if (Ce = Ne + 1 | 0, !u) {
                                    f[$ + 76 >> 2] = Ce, st = 0, $e = 0;
                                    break l;
                                  }
                                  l = f[p >> 2], f[p >> 2] = l + 4, st = 0, $e = f[l >> 2];
                                } else f[((l << 2) + D | 0) - 192 >> 2] = 10, Ce = Ne + 3 | 0, st = 1, $e = f[((je[Ne + 1 | 0] << 3) + m | 0) - 384 >> 2];
                                if (f[$ + 76 >> 2] = Ce, (0 | $e) >= 0) break l;
                                $e = 0 - $e | 0, Ae |= 8192;
                              }
                              if (ce = 0, le = -1, Ke[0 | Ce] == 46)
                                if (Ke[Ce + 1 | 0] != 42) f[$ + 76 >> 2] = Ce + 1, le = ys($ + 76 | 0), l = f[$ + 76 >> 2], Je = 1;
                                else {
                                  if (!yn(l = je[Ce + 2 | 0]) | Ke[Ce + 3 | 0] != 36) {
                                    if (st) break s;
                                    l = Ce + 2 | 0, le = 0, u && (Ce = f[p >> 2], f[p >> 2] = Ce + 4, le = f[Ce >> 2]);
                                  } else f[((l << 2) + D | 0) - 192 >> 2] = 10, l = Ce + 4 | 0, le = f[((je[Ce + 2 | 0] << 3) + m | 0) - 384 >> 2];
                                  f[$ + 76 >> 2] = l, Je = (-1 ^ le) >>> 31 | 0;
                                }
                              else l = Ce, Je = 0;
                              for (; ; ) {
                                if (ue = ce, Ne = 28, dt = l, (ce = je[0 | l]) - 123 >>> 0 < 4294967238) break t;
                                if (l = dt + 1 | 0, !((ce = Ke[4895 + (ce + pr(ue, 58) | 0) | 0]) - 1 >>> 0 < 8)) break;
                              }
                              f[$ + 76 >> 2] = l;
                              l: {
                                f: {
                                  if ((0 | ce) != 27) {
                                    if (!ce) break t;
                                    if ((0 | He) >= 0) {
                                      f[(He << 2) + D >> 2] = ce, Ce = f[4 + (ce = (He << 3) + m | 0) >> 2], f[$ + 64 >> 2] = f[ce >> 2], f[$ + 68 >> 2] = Ce;
                                      break f;
                                    }
                                    if (!u) break a;
                                    $l($ - -64 | 0, ce, p, U);
                                    break l;
                                  }
                                  if ((0 | He) >= 0) break t;
                                }
                                if (ce = 0, !u) continue i;
                              }
                              Ce = -65537 & Ae, Ae = 8192 & Ae ? Ce : Ae, He = 0, vt = 1166, Ne = X;
                              l: {
                                f: {
                                  c: {
                                    h: {
                                      v: {
                                        g: {
                                          m: {
                                            d: {
                                              y: {
                                                b: {
                                                  p: {
                                                    A: {
                                                      x: {
                                                        w: {
                                                          E: {
                                                            switch (ce = je[0 | dt], (ce = ue && (15 & ce) == 3 ? -33 & ce : ce) - 88 | 0) {
                                                              case 11:
                                                                break l;
                                                              case 9:
                                                              case 13:
                                                              case 14:
                                                              case 15:
                                                                break f;
                                                              case 27:
                                                                break m;
                                                              case 12:
                                                              case 17:
                                                                break b;
                                                              case 23:
                                                                break p;
                                                              case 0:
                                                              case 32:
                                                                break A;
                                                              case 24:
                                                                break x;
                                                              case 22:
                                                                break w;
                                                              case 29:
                                                                break E;
                                                              case 1:
                                                              case 2:
                                                              case 3:
                                                              case 4:
                                                              case 5:
                                                              case 6:
                                                              case 7:
                                                              case 8:
                                                              case 10:
                                                              case 16:
                                                              case 18:
                                                              case 19:
                                                              case 20:
                                                              case 21:
                                                              case 25:
                                                              case 26:
                                                              case 28:
                                                              case 30:
                                                              case 31:
                                                                break o;
                                                            }
                                                            switch (ce - 65 | 0) {
                                                              case 0:
                                                              case 4:
                                                              case 5:
                                                              case 6:
                                                                break f;
                                                              case 2:
                                                                break v;
                                                              case 1:
                                                              case 3:
                                                                break o;
                                                            }
                                                            if ((0 | ce) == 83) break g;
                                                            break o;
                                                          }
                                                          Ce = f[$ + 64 >> 2], ue = f[$ + 68 >> 2], ce = 1166;
                                                          break y;
                                                        }
                                                        ce = 0;
                                                        w: switch (255 & ue) {
                                                          case 0:
                                                          case 1:
                                                          case 6:
                                                            f[f[$ + 64 >> 2] >> 2] = Le;
                                                            continue i;
                                                          case 2:
                                                            ge = f[$ + 64 >> 2], f[ge >> 2] = Le, f[ge + 4 >> 2] = Le >> 31;
                                                            continue i;
                                                          case 3:
                                                            Cr[f[$ + 64 >> 2] >> 1] = Le;
                                                            continue i;
                                                          case 4:
                                                            je[f[$ + 64 >> 2]] = Le;
                                                            continue i;
                                                          case 7:
                                                            break w;
                                                          default:
                                                            continue i;
                                                        }
                                                        ge = f[$ + 64 >> 2], f[ge >> 2] = Le, f[ge + 4 >> 2] = Le >> 31;
                                                        continue i;
                                                      }
                                                      le = le >>> 0 <= 8 ? 8 : le, Ae |= 8, ce = 120;
                                                    }
                                                    if (ge = X, (Ce = f[$ + 64 >> 2]) | (ue = f[$ + 68 >> 2])) for (Ot = 32 & ce; je[0 | (ge = ge - 1 | 0)] = Ot | Ke[5424 + (15 & Ce) | 0], Vt = !ue & Ce >>> 0 > 15 | (0 | ue) != 0, dt = ue, ue = ue >>> 4 | 0, Ce = (15 & dt) << 28 | Ce >>> 4, Vt; ) ;
                                                    if (!(8 & Ae) | !(f[$ + 64 >> 2] | f[$ + 68 >> 2])) break d;
                                                    vt = 1166 + (ce >>> 4 | 0) | 0, He = 2;
                                                    break d;
                                                  }
                                                  if (ce = X, ue = ge = f[$ + 68 >> 2], ge | (Ce = f[$ + 64 >> 2])) for (; je[0 | (ce = ce - 1 | 0)] = 7 & Ce | 48, dt = !ue & Ce >>> 0 > 7 | (0 | ue) != 0, ue = (ge = ue) >>> 3 | 0, Ce = (7 & ge) << 29 | Ce >>> 3, dt; ) ;
                                                  if (ge = ce, !(8 & Ae)) break d;
                                                  le = (0 | (ce = X - ge | 0)) < (0 | le) ? le : ce + 1 | 0;
                                                  break d;
                                                }
                                                Ce = f[$ + 64 >> 2], ue = ce = f[$ + 68 >> 2], (0 | ce) < 0 ? (ue = ge = 0 - (ue + ((0 | Ce) != 0) | 0) | 0, Ce = 0 - Ce | 0, f[$ + 64 >> 2] = Ce, f[$ + 68 >> 2] = ge, He = 1, ce = 1166) : 2048 & Ae ? (He = 1, ce = 1167) : ce = (He = 1 & Ae) ? 1168 : 1166;
                                              }
                                              vt = ce, ge = gn(Ce, ue, X);
                                            }
                                            if ((0 | le) < 0 && Je) break r;
                                            if (Ae = Je ? -65537 & Ae : Ae, !(((ce = f[$ + 64 >> 2]) | (Ce = f[$ + 68 >> 2])) != 0 | le)) {
                                              ge = X, le = 0;
                                              break o;
                                            }
                                            le = (0 | (ce = !(ce | Ce) + (X - ge | 0) | 0)) < (0 | le) ? le : ce;
                                            break o;
                                          }
                                          Ae = 0, Ne = (0 | (ue = Je = le >>> 0 >= 2147483647 ? 2147483647 : le)) != 0;
                                          m: {
                                            d: {
                                              y: {
                                                b: {
                                                  p: if (!(!(3 & (ce = ge = (ce = f[$ + 64 >> 2]) || 4208)) | !ue)) for (; ; ) {
                                                    if (!(Ae = Ke[0 | ce])) break b;
                                                    if (Ne = (0 | (ue = ue - 1 | 0)) != 0, !(3 & (ce = ce + 1 | 0))) break p;
                                                    if (!ue) break;
                                                  }
                                                  if (!Ne) break d;
                                                  p: {
                                                    if (!(!Ke[0 | ce] | ue >>> 0 < 4)) for (; ; ) {
                                                      if ((-1 ^ (Ne = f[ce >> 2])) & Ne - 16843009 & -2139062144) break p;
                                                      if (ce = ce + 4 | 0, !((ue = ue - 4 | 0) >>> 0 > 3)) break;
                                                    }
                                                    if (!ue) break d;
                                                  }
                                                  Ne = 0;
                                                  break y;
                                                }
                                                Ne = 1;
                                              }
                                              for (; ; ) if (Ne) {
                                                if (!Ae) break m;
                                                if (ce = ce + 1 | 0, !(ue = ue - 1 | 0)) break d;
                                                Ne = 0;
                                              } else Ae = Ke[0 | ce], Ne = 1;
                                            }
                                            ce = 0;
                                          }
                                          if (Ne = (ce = ce ? ce - ge | 0 : Je) + ge | 0, (0 | le) >= 0) {
                                            Ae = Ce, le = ce;
                                            break o;
                                          }
                                          if (Ae = Ce, le = ce, Ke[0 | Ne]) break r;
                                          break o;
                                        }
                                        if (le) {
                                          Ce = f[$ + 64 >> 2];
                                          break h;
                                        }
                                        ce = 0, M0(u, 32, $e, 0, Ae);
                                        break c;
                                      }
                                      f[$ + 12 >> 2] = 0, f[$ + 8 >> 2] = f[$ + 64 >> 2], Ce = $ + 8 | 0, f[$ + 64 >> 2] = Ce, le = -1;
                                    }
                                    ce = 0;
                                    h: {
                                      for (; ; ) {
                                        if (!(ge = f[Ce >> 2])) break h;
                                        if (!((Ne = (0 | (ge = Tf($ + 4 | 0, ge))) < 0) | ge >>> 0 > le - ce >>> 0)) {
                                          if (Ce = Ce + 4 | 0, le >>> 0 > (ce = ce + ge | 0) >>> 0) continue;
                                          break h;
                                        }
                                        break;
                                      }
                                      if (Ne) break n;
                                    }
                                    if (Ne = 61, (0 | ce) < 0) break t;
                                    if (M0(u, 32, $e, ce, Ae), ce) for (Ne = 0, Ce = f[$ + 64 >> 2]; ; ) {
                                      if (!(ge = f[Ce >> 2]) || (Ne = (ge = Tf($ + 4 | 0, ge)) + Ne | 0) >>> 0 > ce >>> 0) break c;
                                      if (S0(u, $ + 4 | 0, ge), Ce = Ce + 4 | 0, !(ce >>> 0 > Ne >>> 0)) break;
                                    }
                                    else ce = 0;
                                  }
                                  M0(u, 32, $e, ce, 8192 ^ Ae), ce = (0 | ce) < (0 | $e) ? $e : ce;
                                  continue i;
                                }
                                if ((0 | le) < 0 && Je) break r;
                                if (Ne = 61, (0 | (ce = 0 | xt[0 | F](u, Fr[$ + 64 >> 3], $e, le, Ae, ce))) >= 0) continue i;
                                break t;
                              }
                              je[$ + 55 | 0] = f[$ + 64 >> 2], le = 1, ge = Pe, Ae = Ce;
                              break o;
                            }
                            Ce = Ke[ce + 1 | 0], ce = ce + 1 | 0;
                          }
                          if (u) break e;
                          if (!st) break a;
                          for (ce = 1; ; ) {
                            if (u = f[(ce << 2) + D >> 2]) {
                              if ($l((ce << 3) + m | 0, u, p, U), Le = 1, (0 | (ce = ce + 1 | 0)) != 10) continue;
                              break e;
                            }
                            break;
                          }
                          if (Le = 1, ce >>> 0 >= 10) break e;
                          for (; ; ) {
                            if (f[(ce << 2) + D >> 2]) break s;
                            if ((0 | (ce = ce + 1 | 0)) == 10) break;
                          }
                          break e;
                        }
                        Ne = 28;
                        break t;
                      }
                      if ((0 | (le = (0 | le) > (0 | (ue = Ne - ge | 0)) ? le : ue)) > (2147483647 ^ He)) break r;
                      if (Ne = 61, (0 | At) < (0 | (ce = (0 | (Ce = le + He | 0)) < (0 | $e) ? $e : Ce))) break t;
                      M0(u, 32, ce, Ce, Ae), S0(u, vt, He), M0(u, 48, ce, Ce, 65536 ^ Ae), M0(u, 48, le, ue, 0), S0(u, ge, ue), M0(u, 32, ce, Ce, 8192 ^ Ae);
                      continue;
                    }
                    break;
                  }
                  Le = 0;
                  break e;
                }
                Ne = 61;
              }
              f[1761] = Ne;
            }
            Le = -1;
          }
          return nt = $ + 80 | 0, Le;
        }
        function H0(u, l, p, m, D, F, U, $, X, Pe, ce, Ce, ge, Ne) {
          var ue, le = E(0), Ae = 0, Le = 0, $e = 0, He = E(0), Je = 0, st = 0, dt = E(0);
          (f[u + 312 >> 2] != (0 | Ne) && 4 & Ke[u + 4 | 0] || (Je = 0, f[u + 316 >> 2] != (0 | m))) && (f[u + 540 >> 2] = -1082130432, f[u + 544 >> 2] = -1082130432, f[u + 532 >> 2] = 0, f[u + 536 >> 2] = 0, f[u + 524 >> 2] = -1082130432, f[u + 528 >> 2] = -1082130432, f[u + 320 >> 2] = 0, Je = 1), ue = ge + 1 | 0;
          e: {
            n: {
              t: {
                r: if (f[u + 8 >> 2]) {
                  if (He = er(u, 2, U), dt = wr(u, 2, U), le = E(er(u, 0, U) + wr(u, 0, U)), ge = u + 524 | 0, He = E(He + dt), ko(D, l, F, p, f[u + 532 >> 2], Y[ge >> 2], f[u + 536 >> 2], Y[u + 528 >> 2], Y[u + 540 >> 2], Y[u + 544 >> 2], He, le, ce)) break t;
                  if (!(Le = f[u + 320 >> 2])) break r;
                  for (Ae = u + 324 | 0; ; ) {
                    if (ge = Ae + pr($e, 24) | 0, ko(D, l, F, p, f[ge + 8 >> 2], Y[ge >> 2], f[ge + 12 >> 2], Y[ge + 4 >> 2], Y[ge + 16 >> 2], Y[ge + 20 >> 2], He, le, ce)) break t;
                    if ((0 | Le) == (0 | ($e = $e + 1 | 0))) break;
                  }
                } else {
                  if (X) {
                    i: {
                      if (!((le = Y[(ge = u + 524 | 0) >> 2]) != le | l != l)) {
                        if (E(jr(E(le - l))) < E(9999999747378752e-20)) break i;
                        break r;
                      }
                      if (le == le | l == l) break r;
                    }
                    Ae = f[u + 532 >> 2] == (0 | D) && f[u + 536 >> 2] == (0 | F) ? ge : 0, (ge = (le = Y[u + 528 >> 2]) != le) | (Le = p != p) ? ge &= Le : ge = E(jr(E(le - p))) < E(9999999747378752e-20), ge = ge ? Ae : 0;
                    break t;
                  }
                  if (!(st = f[u + 320 >> 2])) break r;
                  for (Le = u + 324 | 0; ; ) {
                    Ae = pr($e, 24);
                    i: {
                      a: {
                        if (!((le = Y[(ge = Ae + Le | 0) >> 2]) != le | l != l)) {
                          if (E(jr(E(le - l))) < E(9999999747378752e-20)) break a;
                          break i;
                        }
                        if (le == le | l == l) break i;
                      }
                      a: {
                        if (!((le = Y[4 + (Ae = Le + Ae | 0) >> 2]) != le | p != p)) {
                          if (E(jr(E(le - p))) < E(9999999747378752e-20)) break a;
                          break i;
                        }
                        if (le == le | p == p) break i;
                      }
                      if (f[Ae + 8 >> 2] == (0 | D) && f[Ae + 12 >> 2] == (0 | F)) break t;
                    }
                    if ((0 | st) == (0 | ($e = $e + 1 | 0))) break;
                  }
                }
                Au(u, l, p, m, D, F, U, $, X, ce, Ce, ue, Ne, Pe), f[u + 316 >> 2] = m;
                break n;
              }
              if (!(!ge | Je)) {
                Y[u + 516 >> 2] = Y[ge + 16 >> 2], Y[u + 520 >> 2] = Y[ge + 20 >> 2], f[(m = (X ? 12 : 16) + Ce | 0) >> 2] = f[m >> 2] + 1, m = 0;
                break e;
              }
              if (Au(u, l, p, m, D, F, U, $, X, ce, Ce, ue, Ne, Pe), f[u + 316 >> 2] = m, m = 1, ge) break e;
            }
            (m = (ge = f[u + 320 >> 2]) + 1 | 0) >>> 0 > Bl[Ce + 8 >> 2] && (f[Ce + 8 >> 2] = m), (0 | ge) == 8 && (f[u + 320 >> 2] = 0, ge = 0), X ? m = u + 524 | 0 : (f[u + 320 >> 2] = ge + 1, m = 324 + (pr(ge, 24) + u | 0) | 0), f[m + 12 >> 2] = F, f[m + 8 >> 2] = D, Y[m + 4 >> 2] = p, Y[m >> 2] = l, Y[m + 16 >> 2] = Y[u + 516 >> 2], Y[m + 20 >> 2] = Y[u + 520 >> 2], m = 1;
          }
          return X && (D = f[u + 520 >> 2], f[u + 244 >> 2] = f[u + 516 >> 2], f[u + 248 >> 2] = D, F = 1 | (D = Ke[u + 4 | 0]), je[u + 4 | 0] = F, 4 & D && (je[u + 4 | 0] = 251 & F)), f[u + 312 >> 2] = Ne, m;
        }
        function To(u) {
          var l = 0, p = 0, m = 0, D = 0, F = 0, U = 0, $ = 0, X = 0, Pe = 0, ce = 0, Ce = 0;
          $ = 8;
          e: if (!((u |= 0) >>> 0 > 4294967239)) {
            n: {
              for (; ; ) {
                if ($ = $ >>> 0 <= 8 ? 8 : $, F = l = f[1731], D = f[1730], (u = u >>> 0 <= 8 ? 8 : u + 3 & -4) >>> 0 <= 127 ? U = (u >>> 3 | 0) - 1 | 0 : (U = 110 + ((u >>> 29 - (m = Pn(u)) ^ 4) - (m << 2) | 0) | 0, u >>> 0 <= 4095 || (U = (m = 71 + ((u >>> 30 - m ^ 2) - (m << 1) | 0) | 0) >>> 0 >= 63 ? 63 : m)), p = 31 & U, (63 & U) >>> 0 >= 32 ? (m = 0, l = l >>> p | 0) : (m = l >>> p | 0, l = ((1 << p) - 1 & l) << 32 - p | D >>> p), l | m) {
                  for (; ; ) {
                    if (D = m, l | m ? (X = 1 + (p = m - 1 | 0) | 0, F = p, p = 63 - (m = (0 | (m = Pn(m ^ (F = (0 | (p = l - 1 | 0)) != -1 ? X : F)))) == 32 ? Pn(l ^ p) + 32 | 0 : m) | 0, sr = 0 - (m >>> 0 > 63) | 0) : (sr = 0, p = 64), p = 31 & (F = p), (63 & F) >>> 0 >= 32 ? (m = 0, l = D >>> p | 0) : (m = D >>> p | 0, l = ((1 << p) - 1 & D) << 32 - p | l >>> p), X = l, (0 | (l = f[5896 + (p = (U = F + U | 0) << 4) >> 2])) == (0 | (F = p + 5888 | 0))) Pe = f[1731], D = 31 & (l = F = 63 & U), l >>> 0 >= 32 ? (l = 0, p = -1 >>> D | 0) : p = (l = -1 >>> D | 0) | (1 << D) - 1 << 32 - D, p &= -2, D = 31 & F, F >>> 0 >= 32 ? (l = p << D, p = 0) : (l = (1 << D) - 1 & p >>> 32 - D | l << D, p <<= D), ce = p, D = l, l = 31 & (p = F = 0 - U & 63), p >>> 0 >= 32 ? (l = -1 << l, p = 0) : l = (p = -1 << l) | (1 << l) - 1 & -1 >>> 32 - l, Ce = -2 & p, p = 31 & F, F >>> 0 >= 32 ? (F = 0, l = l >>> p | 0) : (F = l >>> p | 0, l = ((1 << p) - 1 & l) << 32 - p | Ce >>> p), l |= ce, sr = D | F, f[1730] = f[1730] & l, f[1731] = sr & Pe, l = 1 ^ X;
                    else {
                      if (D = So(l, $, u)) break e;
                      D = f[l + 4 >> 2], f[D + 8 >> 2] = f[l + 8 >> 2], f[f[l + 8 >> 2] + 4 >> 2] = D, f[l + 8 >> 2] = F, D = p + 5892 | 0, f[l + 4 >> 2] = f[D >> 2], f[D >> 2] = l, f[f[l + 4 >> 2] + 8 >> 2] = l, U = U + 1 | 0, l = (1 & m) << 31 | X >>> 1, m = m >>> 1 | 0;
                    }
                    if (!(l | m)) break;
                  }
                  F = f[1731], D = f[1730];
                }
                t: {
                  if (D | F) {
                    p = 63 - ((0 | (m = Pn(F))) == 32 ? Pn(D) + 32 | 0 : m) | 0, m = f[5896 + (l = p << 4) >> 2];
                    r: if (!(!F & D >>> 0 < 1073741824) && (U = 99, (0 | (l = l + 5888 | 0)) != (0 | m))) {
                      for (; ; ) {
                        if (!U) break r;
                        if (D = So(m, $, u)) break e;
                        if (U = U - 1 | 0, (0 | l) == (0 | (m = f[m + 8 >> 2]))) break;
                      }
                      m = l;
                    }
                    if (ri(u + 48 | 0)) break t;
                    if (!m || (0 | (l = 5888 + (p << 4) | 0)) == (0 | m)) break n;
                    for (; ; ) {
                      if (D = So(m, $, u)) break e;
                      if ((0 | l) == (0 | (m = f[m + 8 >> 2]))) break;
                    }
                    break n;
                  }
                  if (!ri(u + 48 | 0)) break n;
                }
                if (D = 0, $ - 1 & $) break e;
                if (!(u >>> 0 <= 4294967239)) break;
              }
              break e;
            }
            D = 0;
          }
          return 0 | D;
        }
        function Tr(u, l, p, m) {
          var D = E(0), F = E(0), U = 0, $ = E(0);
          e: {
            n: {
              t: {
                r: {
                  i: {
                    a: {
                      if (l >>> 0 <= 1) {
                        F = Y[u + 212 >> 2];
                        o: if ((0 | (l = f[u + 212 >> 2])) != 2139156720) {
                          if ((0 | l) == 2140081935) break a;
                          U = 4276;
                          s: {
                            if ((0 | l) != 2141891242) {
                              if (F == F) break s;
                              U = 4268;
                            }
                            switch (D = Y[U >> 2], F = E(NaN), f[U + 4 >> 2] - 1 | 0) {
                              case 0:
                                break a;
                              case 1:
                                break o;
                              default:
                                break i;
                            }
                          }
                          if (ze(2, 536870912 + (-1073741825 & l) | 0), D = Tt(), !(1073741824 & l)) break a;
                        }
                        F = E(E(D * m) * E(0.009999999776482582));
                        break i;
                      }
                      F = Y[u + 208 >> 2];
                      o: {
                        s: {
                          u: if ((0 | (l = f[u + 208 >> 2])) != 2139156720) {
                            if ((0 | l) == 2140081935) break s;
                            U = 4276;
                            l: {
                              if ((0 | l) != 2141891242) {
                                if (F == F) break l;
                                U = 4268;
                              }
                              switch (D = Y[U >> 2], F = E(NaN), f[U + 4 >> 2] - 1 | 0) {
                                case 0:
                                  break s;
                                case 1:
                                  break u;
                                default:
                                  break o;
                              }
                            }
                            if (ze(2, 536870912 + (-1073741825 & l) | 0), D = Tt(), !(1073741824 & l)) break s;
                          }
                          F = E(E(D * m) * E(0.009999999776482582));
                          break o;
                        }
                        F = D;
                      }
                      D = E(0), $ = Y[u + 216 >> 2];
                      o: if ((0 | (u = f[u + 216 >> 2])) != 2139156720) {
                        if ((0 | u) == 2140081935) break t;
                        l = 4276;
                        s: {
                          if ((0 | u) != 2141891242) {
                            if ($ == $) break s;
                            l = 4268;
                          }
                          switch (D = Y[l >> 2], f[l + 4 >> 2] - 1 | 0) {
                            case 1:
                              break o;
                            case 0:
                              break r;
                            default:
                              break n;
                          }
                        }
                        if (ze(2, 536870912 + (-1073741825 & u) | 0), D = Tt(), !(1073741824 & u)) break r;
                      }
                      D = E(E(D * m) * E(0.009999999776482582));
                      break r;
                    }
                    F = D;
                  }
                  D = E(0), $ = Y[u + 220 >> 2];
                  i: if ((0 | (u = f[u + 220 >> 2])) != 2139156720) {
                    if ((0 | u) == 2140081935) break t;
                    l = 4276;
                    a: {
                      if ((0 | u) != 2141891242) {
                        if ($ == $) break a;
                        l = 4268;
                      }
                      switch (D = Y[l >> 2], f[l + 4 >> 2] - 1 | 0) {
                        case 1:
                          break i;
                        case 0:
                          break r;
                        default:
                          break n;
                      }
                    }
                    if (ze(2, 536870912 + (-1073741825 & u) | 0), D = Tt(), !(1073741824 & u)) break r;
                  }
                  D = E(E(D * m) * E(0.009999999776482582));
                }
                if (!(D >= E(0))) break n;
              }
              if (p > D) break e;
            }
            if (!(F >= E(0))) return p;
            D = p < F ? F : p;
          }
          return D;
        }
        function J0(u, l) {
          var p = 0, m = 0;
          for (f[u + 8 >> 2] = 0, f[u + 12 >> 2] = 0, Cr[u + 4 >> 1] = 1, f[u >> 2] = 0, f[u + 16 >> 2] = 0, f[u + 20 >> 2] = 0, f[u + 24 >> 2] = 0, f[u + 36 >> 2] = 2143289344, f[u + 40 >> 2] = 2141891242, f[u + 28 >> 2] = 2143289344, f[u + 32 >> 2] = 2143289344, m = k0(u + 44 | 0, 0, 36); f[m + (p << 2) >> 2] = 2143289344, (0 | (p = p + 1 | 0)) != 9; ) ;
          for (p = 0, m = k0(u + 80 | 0, 0, 36); f[m + (p << 2) >> 2] = 2143289344, (0 | (p = p + 1 | 0)) != 9; ) ;
          for (p = 0, m = k0(u + 116 | 0, 0, 36); f[m + (p << 2) >> 2] = 2143289344, (0 | (p = p + 1 | 0)) != 9; ) ;
          for (p = 0, m = k0(u + 152 | 0, 0, 36); f[m + (p << 2) >> 2] = 2143289344, (0 | (p = p + 1 | 0)) != 9; ) ;
          for (p = 0, f[u + 196 >> 2] = 0, f[(m = u + 188 | 0) >> 2] = 0, f[m + 4 >> 2] = 0; f[m + (p << 2) >> 2] = 2143289344, (0 | (p = p + 1 | 0)) != 3; ) ;
          for (f[u + 24 >> 2] = 4224, f[u + 224 >> 2] = 2143289344, f[u + 216 >> 2] = 2143289344, f[u + 220 >> 2] = 2143289344, f[u + 208 >> 2] = 2143289344, f[u + 212 >> 2] = 2143289344, f[u + 200 >> 2] = 2141891242, f[u + 204 >> 2] = 2141891242, k0(u + 228 | 0, 0, 288), f[u + 244 >> 2] = 2143289344, f[u + 248 >> 2] = 2143289344, k0(u + 252 | 0, 0, 49), f[u + 308 >> 2] = 2143289344, m = u + 516 | 0, p = u + 324 | 0; f[p + 16 >> 2] = -1082130432, f[p + 20 >> 2] = -1082130432, f[p + 8 >> 2] = 0, f[p + 12 >> 2] = 0, f[p >> 2] = -1082130432, f[p + 4 >> 2] = -1082130432, (0 | m) != (0 | (p = p + 24 | 0)); ) ;
          return f[u + 548 >> 2] = 0, f[u + 552 >> 2] = 0, f[u + 516 >> 2] = 2143289344, f[u + 520 >> 2] = 2143289344, f[u + 572 >> 2] = 2143289344, f[u + 576 >> 2] = 0, f[u + 568 >> 2] = l, f[u + 540 >> 2] = -1082130432, f[u + 544 >> 2] = -1082130432, f[u + 532 >> 2] = 0, f[u + 536 >> 2] = 0, f[u + 524 >> 2] = -1082130432, f[u + 528 >> 2] = -1082130432, f[u + 556 >> 2] = 0, f[u + 560 >> 2] = 0, f[u + 564 >> 2] = 0, f[u + 580 >> 2] = 2143289344, f[u + 584 >> 2] = 0, Ke[l + 10 | 0] && (f[u + 24 >> 2] = 4616, je[u + 4 | 0] = 128 | Ke[u + 4 | 0]), u;
        }
        function mi(u) {
          var l, p, m, D, F, U = 0, $ = 0, X = E(0), Pe = E(0), ce = E(0), Ce = 0, ge = 0, Ne = 0, ue = 0;
          for (f[8 + (l = nt - 16 | 0) >> 2] = 0, f[l + 12 >> 2] = 1, p = u + 200 | 0, m = u + 572 | 0, D = u + 208 | 0, F = u + 216 | 0, u = 0; ; ) {
            ue = u, Ne = f[(l + 8 | 0) + (u << 2) >> 2], X = Y[(u = F + (Ce = Ne << 2) | 0) >> 2];
            e: {
              n: {
                t: {
                  r: {
                    i: {
                      if (!(!((ge = (0 | (U = f[u >> 2])) == 2139156720) | (0 | U) == 2140081935 | (0 | U) == 2141891242) & X != X)) {
                        Pe = Y[(u = Ce + D | 0) >> 2];
                        a: {
                          o: {
                            if ((0 | ($ = f[u >> 2])) != 2139156720) {
                              if (ce = E(NaN), u = 3, (0 | $) == 2141891242) break a;
                              if ((0 | $) != 2140081935) break o;
                              ce = E(0), u = 1;
                              break a;
                            }
                            ce = E(0), u = 2;
                            break a;
                          }
                          u = 0, Pe == Pe && (ze(2, 536870912 + (-1073741825 & $) | 0), ce = Tt(), u = 1073741824 & $ ? 2 : 1);
                        }
                        $ = u;
                        a: {
                          o: {
                            if (!ge) {
                              if (Pe = E(NaN), u = 3, (0 | U) == 2141891242) break a;
                              if ((0 | U) != 2140081935) break o;
                              Pe = E(0), u = 1;
                              break a;
                            }
                            Pe = E(0), u = 2;
                            break a;
                          }
                          u = 0, X == X && (ze(2, 536870912 + (-1073741825 & U) | 0), Pe = Tt(), u = 1073741824 & U ? 2 : 1);
                        }
                        if (!((0 | $) != (0 | u) | !(!u | Pe != Pe & ce != ce | E(jr(E(Pe - ce))) < E(9999999747378752e-20)))) {
                          if (u = 0, ge) break i;
                          if ((0 | U) == 2140081935) break n;
                          if ((0 | U) == 2141891242) break t;
                          if (X != X) break r;
                          u = 536870912 + (-1073741825 & U) | 0, U = 1073741824 & U ? 2 : 1;
                          break e;
                        }
                      }
                      if (u = 0, X = Y[(U = Ce + p | 0) >> 2], (0 | (U = f[U >> 2])) != 2139156720) {
                        if ((0 | U) == 2140081935) break n;
                        if ((0 | U) == 2141891242) break t;
                        if (X != X) break r;
                        u = 536870912 + (-1073741825 & U) | 0, U = 1073741824 & U ? 2 : 1;
                        break e;
                      }
                    }
                    U = 2;
                    break e;
                  }
                  u = 2143289344, U = 0;
                  break e;
                }
                u = 2143289344, U = 3;
                break e;
              }
              U = 1;
            }
            if (f[4 + ($ = (Ne << 3) + m | 0) >> 2] = U, f[$ >> 2] = u, u = 1, 1 & ue) break;
          }
        }
        function D0(u, l, p) {
          var m, D = 0, F = 0;
          if (p >>> 0 >= 512) return wu(0 | u, 0 | l, 0 | p), u;
          m = u + p | 0;
          e: if (3 & (u ^ l))
            if (m >>> 0 < 4) p = u;
            else if ((D = m - 4 | 0) >>> 0 < u >>> 0) p = u;
            else for (p = u; je[0 | p] = Ke[0 | l], je[p + 1 | 0] = Ke[l + 1 | 0], je[p + 2 | 0] = Ke[l + 2 | 0], je[p + 3 | 0] = Ke[l + 3 | 0], l = l + 4 | 0, D >>> 0 >= (p = p + 4 | 0) >>> 0; ) ;
          else {
            n: if (3 & u)
              if (p) for (p = u; ; ) {
                if (je[0 | p] = Ke[0 | l], l = l + 1 | 0, !(3 & (p = p + 1 | 0))) break n;
                if (!(p >>> 0 < m >>> 0)) break;
              }
              else p = u;
            else p = u;
            if (!((D = -4 & m) >>> 0 < 64 || (F = D + -64 | 0) >>> 0 < p >>> 0)) for (; f[p >> 2] = f[l >> 2], f[p + 4 >> 2] = f[l + 4 >> 2], f[p + 8 >> 2] = f[l + 8 >> 2], f[p + 12 >> 2] = f[l + 12 >> 2], f[p + 16 >> 2] = f[l + 16 >> 2], f[p + 20 >> 2] = f[l + 20 >> 2], f[p + 24 >> 2] = f[l + 24 >> 2], f[p + 28 >> 2] = f[l + 28 >> 2], f[p + 32 >> 2] = f[l + 32 >> 2], f[p + 36 >> 2] = f[l + 36 >> 2], f[p + 40 >> 2] = f[l + 40 >> 2], f[p + 44 >> 2] = f[l + 44 >> 2], f[p + 48 >> 2] = f[l + 48 >> 2], f[p + 52 >> 2] = f[l + 52 >> 2], f[p + 56 >> 2] = f[l + 56 >> 2], f[p + 60 >> 2] = f[l + 60 >> 2], l = l - -64 | 0, F >>> 0 >= (p = p - -64 | 0) >>> 0; ) ;
            if (p >>> 0 >= D >>> 0) break e;
            for (; f[p >> 2] = f[l >> 2], l = l + 4 | 0, D >>> 0 > (p = p + 4 | 0) >>> 0; ) ;
          }
          if (p >>> 0 < m >>> 0) for (; je[0 | p] = Ke[0 | l], l = l + 1 | 0, (0 | m) != (0 | (p = p + 1 | 0)); ) ;
          return u;
        }
        function pn(u, l, p, m, D) {
          var F, U = E(0), $ = 0, X = E(0), Pe = E(0), ce = 0, Ce = E(0), ge = E(0);
          if (!(F = (X = E(p - m)) != X)) {
            p = E(0), U = Y[208 + ($ = (l << 2) + u | 0) >> 2];
            e: {
              n: {
                t: {
                  r: if ((0 | ($ = f[$ + 208 >> 2])) != 2139156720) {
                    if ((0 | $) == 2140081935) break n;
                    ce = 4276;
                    i: {
                      if ((0 | $) != 2141891242) {
                        if (U == U) break i;
                        ce = 4268;
                      }
                      switch (p = Y[ce >> 2], f[ce + 4 >> 2] - 1 | 0) {
                        case 0:
                          break t;
                        case 1:
                          break r;
                        default:
                          break e;
                      }
                    }
                    if (ze(2, 536870912 + (-1073741825 & $) | 0), p = Tt(), !(1073741824 & $)) break t;
                  }
                  p = E(E(p * D) * E(0.009999999776482582));
                }
                if (p != p) break e;
              }
              Pe = E(p - m);
            }
            p = E(0), U = Y[216 + (u = (l << 2) + u | 0) >> 2];
            e: {
              n: {
                t: {
                  r: if ((0 | (l = f[u + 216 >> 2])) != 2139156720) {
                    if ((0 | l) == 2140081935) break n;
                    u = 4276;
                    i: {
                      if ((0 | l) != 2141891242) {
                        if (U == U) break i;
                        u = 4268;
                      }
                      switch (p = Y[u >> 2], U = E(34028234663852886e22), f[u + 4 >> 2] - 1 | 0) {
                        case 0:
                          break t;
                        case 1:
                          break r;
                        default:
                          break e;
                      }
                    }
                    if (ze(2, 536870912 + (-1073741825 & l) | 0), p = Tt(), !(1073741824 & l)) break t;
                  }
                  p = E(E(p * D) * E(0.009999999776482582));
                }
                if (p != p) {
                  U = E(34028234663852886e22);
                  break e;
                }
              }
              U = E(p - m);
            }
            if (Ce = X, ge = Cu(X, U), !((u = (p = U != U | F ? Ce : ge) != p) | Pe != Pe)) return tr(p, Pe);
            X = u ? Pe : p;
          }
          return X;
        }
        function ko(u, l, p, m, D, F, U, $, X, Pe, ce, Ce, ge) {
          var Ne = E(0), ue = E(0), le = 0, Ae = 0, Le = E(0), $e = E(0), He = E(0), Je = 0, st = 0;
          if (X < E(0) | Pe < E(0)) u = 0;
          else {
            Le = F, $e = l, He = m, ue = $, ge && (ue = $, (Ne = Y[ge + 16 >> 2]) != E(0) && ($e = bi(+l, Je = +Ne, 0, 0), He = bi(+m, Je, 0, 0), Le = bi(+F, Je, 0, 0), ue = bi(+$, Je, 0, 0))), Ne = ue, ge = 0, (0 | u) == (0 | D) && ((st = Le != Le) | (ge = $e != $e) ? ge &= st : ge = E(jr(E(Le - $e))) < E(9999999747378752e-20)), st = ge, (0 | p) == (0 | U) && ((le = Ne != Ne) | (ge = He != He) ? le &= ge : le = E(jr(E(Ne - He))) < E(9999999747378752e-20)), Ae = 1, ge = 1;
            e: if (!st) {
              l = E(l - ce);
              n: if ((0 | u) != 1) {
                if (!((u = (0 | u) != 2) | D)) {
                  if (!(l >= X)) break n;
                  break e;
                }
                if (ge = 0, !(l < F) | u | (0 | D) != 2 | l != l | F != F | X != X || (ge = 1, l >= X)) break e;
              }
              ge = (D = l != l) | (u = X != X) ? u & D : E(jr(E(l - X))) < E(9999999747378752e-20);
            }
            e: if (!le) {
              l = E(m - Ce);
              n: if ((0 | p) != 1) {
                if (!((u = (0 | p) != 2) | U)) {
                  if (!(l >= Pe)) break n;
                  break e;
                }
                if (Ae = 0, !(l < $) | u | (0 | U) != 2 | l != l | $ != $ | Pe != Pe || (Ae = 1, l >= Pe)) break e;
              }
              Ae = (p = l != l) | (u = Pe != Pe) ? u & p : E(jr(E(l - Pe))) < E(9999999747378752e-20);
            }
            u = ge & Ae;
          }
          return u;
        }
        function Ua(u) {
          var l, p, m = 0, D = 0, F = 0, U = 0, $ = 0, X = 0;
          if (fr(+u), $ = 0 | qe(1), F = 0 | qe(0), (0 | (U = $ >>> 20 & 2047)) == 2047) return (u *= 1) / u;
          if (!(m = F << 1) & (0 | (X = $ << 1 | F >>> 31)) == 2145386496 | X >>> 0 < 2145386496) return !m & (0 | X) == 2145386496 ? 0 * u : u;
          if (U) m = 1048575 & $ | 1048576;
          else {
            if (U = 0, D = F << 12, (0 | (m = $ << 12 | F >>> 20)) > 0 | (0 | m) >= 0) for (; U = U - 1 | 0, m = m << 1 | D >>> 31, D <<= 1, (0 | m) > 0 | (0 | m) >= 0; ) ;
            D = 31 & (m = 1 - U | 0), (63 & m) >>> 0 >= 32 ? (m = F << D, F = 0) : (m = (1 << D) - 1 & F >>> 32 - D | $ << D, F <<= D);
          }
          if (D = F, (0 | U) > 1023) {
            for (; ; ) {
              if (!((0 | (F = m + -1048576 | 0)) < 0 || (m = F) | D)) return 0 * u;
              if (m = m << 1 | D >>> 31, D <<= 1, !((0 | (U = U - 1 | 0)) > 1023)) break;
            }
            U = 1023;
          }
          if (!((0 | (F = m + -1048576 | 0)) < 0 || (m = F) | D)) return 0 * u;
          if ((0 | m) == 1048575 | m >>> 0 < 1048575) for (; U = U - 1 | 0, F = m >>> 0 < 524288, X = m << 1 | D >>> 31, D <<= 1, m = X, F; ) ;
          return p = -2147483648 & $, X = m + -1048576 | U << 20, $ = m, l = D, D = 31 & (F = 1 - U | 0), (63 & F) >>> 0 >= 32 ? (m = 0, F = $ >>> D | 0) : (m = $ >>> D | 0, F = ((1 << D) - 1 & $) << 32 - D | l >>> D), ze(0, 0 | ((D = (0 | U) > 0) ? l : F)), ze(1, (D ? X : m) | p), +Pt();
        }
        function ri(u) {
          var l = 0, p = 0, m = 0, D = 0, F = 0;
          if ((p = (m = f[1396]) + (l = u + 7 & -8) | 0) >>> 0 <= m >>> 0 && l || p >>> 0 > zt() << 16 >>> 0 && !(0 | ti(0 | p)) ? (f[1761] = 48, m = -1) : f[1396] = p, (0 | m) != -1) {
            f[12 + (p = (l = u + m | 0) - 16 | 0) >> 2] = 16, f[p >> 2] = 16;
            e: {
              n: {
                if ((0 | (F = (u = f[1728]) ? f[u + 8 >> 2] : 0)) == (0 | m)) {
                  if (D = m - (-2 & f[m - 4 >> 2]) | 0, F = f[D - 4 >> 2], f[u + 8 >> 2] = l, l = -16, !(1 & je[((u = D - (-2 & F) | 0) + f[u >> 2] | 0) - 4 | 0])) break n;
                  l = f[u + 4 >> 2], f[l + 8 >> 2] = f[u + 8 >> 2], f[f[u + 8 >> 2] + 4 >> 2] = l, p = p - u | 0, f[u >> 2] = p;
                  break e;
                }
                f[m + 12 >> 2] = 16, f[m >> 2] = 16, f[m + 8 >> 2] = l, f[m + 4 >> 2] = u, f[1728] = m, l = 16;
              }
              p = p - (u = l + m | 0) | 0, f[u >> 2] = p;
            }
            f[((-4 & p) + u | 0) - 4 >> 2] = 1 | p, (l = f[u >> 2] - 8 | 0) >>> 0 <= 127 ? p = (l >>> 3 | 0) - 1 | 0 : (p = 110 + ((l >>> 29 - (D = Pn(l)) ^ 4) - (D << 2) | 0) | 0, l >>> 0 <= 4095 || (p = (p = 71 + ((l >>> 30 - D ^ 2) - (D << 1) | 0) | 0) >>> 0 >= 63 ? 63 : p)), l = p << 4, f[u + 4 >> 2] = l + 5888, l = l + 5896 | 0, f[u + 8 >> 2] = f[l >> 2], f[l >> 2] = u, f[f[u + 8 >> 2] + 4 >> 2] = u, l = f[1730], D = f[1731], u = 31 & p, (63 & p) >>> 0 >= 32 ? (p = 1 << u, F = 0) : p = (F = 1 << u) - 1 & 1 >>> 32 - u, f[1730] = F | l, f[1731] = p | D;
          }
          return (0 | m) != -1;
        }
        function ps(u, l, p) {
          var m = 0, D = 0, F = 0, U = 0, $ = 0, X = 0, Pe = 0, ce = 0, Ce = 0;
          e: {
            n: {
              t: {
                r: {
                  i: {
                    a: {
                      o: {
                        s: {
                          u: {
                            l: {
                              if (l) {
                                if (!p) break l;
                                break u;
                              }
                              sr = 0, u = (u >>> 0) / (p >>> 0) | 0;
                              break e;
                            }
                            if (!u) break s;
                            break o;
                          }
                          if (!(p - 1 & p)) break a;
                          U = 0 - (F = (Pn(p) + 33 | 0) - Pn(l) | 0) | 0;
                          break r;
                        }
                        sr = 0, u = (l >>> 0) / 0 | 0;
                        break e;
                      }
                      if ((m = 32 - Pn(l) | 0) >>> 0 < 31) break i;
                      break t;
                    }
                    if ((0 | p) == 1) break n;
                    p = 31 & (F = p ? 31 - Pn(p - 1 ^ p) | 0 : 32), (63 & F) >>> 0 >= 32 ? u = l >>> p | 0 : (m = l >>> p | 0, u = ((1 << p) - 1 & l) << 32 - p | u >>> p), sr = m;
                    break e;
                  }
                  F = m + 1 | 0, U = 63 - m | 0;
                }
                if (D = 31 & (m = 63 & F), m >>> 0 >= 32 ? (m = 0, $ = l >>> D | 0) : (m = l >>> D | 0, $ = ((1 << D) - 1 & l) << 32 - D | u >>> D), D = 31 & (U &= 63), U >>> 0 >= 32 ? (l = u << D, u = 0) : (l = (1 << D) - 1 & u >>> 32 - D | l << D, u <<= D), F) for (Ce = (0 | (U = p - 1 | 0)) == -1 ? -1 : 0; X = m << 1 | $ >>> 31, $ = (m = $ << 1 | l >>> 31) - (Pe = p & (D = Ce - (X + (m >>> 0 > U >>> 0) | 0) >> 31)) | 0, m = X - (m >>> 0 < Pe >>> 0) | 0, l = l << 1 | u >>> 31, u = ce | u << 1, ce = 1 & D, F = F - 1 | 0; ) ;
                sr = l << 1 | u >>> 31, u = ce | u << 1;
                break e;
              }
              u = 0, l = 0;
            }
            sr = l;
          }
          return u;
        }
        function $a(u, l, p) {
          var m = E(0), D = E(0);
          e: {
            n: {
              t: {
                if ((-2 & l) == 2) {
                  if ((0 | (l = f[u + 188 >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 | (m = Y[u + 188 >> 2]) == m || (0 | (l = f[u + 196 >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 | (m = Y[u + 196 >> 2]) == m) break t;
                  break n;
                }
                if (!((0 | (l = f[u + 192 >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 | (m = Y[u + 192 >> 2]) == m || (m = Y[u + 196 >> 2], (0 | (l = f[u + 196 >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 || m == m))) break n;
              }
              m = E(0);
              t: {
                r: if ((0 | l) != 2139156720) {
                  if ((0 | l) == 2140081935) break e;
                  u = 4276;
                  i: {
                    if ((0 | l) != 2141891242) {
                      if (ze(2, l), (m = Tt()) == m) break i;
                      u = 4268;
                    }
                    switch (m = Y[u >> 2], D = E(NaN), f[u + 4 >> 2] - 1 | 0) {
                      case 0:
                        break e;
                      case 1:
                        break r;
                      default:
                        break t;
                    }
                  }
                  if (ze(2, 536870912 + (-1073741825 & l) | 0), m = Tt(), !(1073741824 & l)) break e;
                }
                D = E(E(m * p) * E(0.009999999776482582));
              }
              return D;
            }
            m = E(0);
          }
          return m;
        }
        function Gi(u, l) {
          var p, m, D = 0, F = 0, U = 0, $ = 0;
          for (nt = D = nt - 320 | 0, p = k0(D, 0, 288), f[(D = p) + 16 >> 2] = 2143289344, f[D + 20 >> 2] = 2143289344, k0(D + 24 | 0, 0, 49), f[D + 80 >> 2] = 2143289344, U = D + 288 | 0, F = D + 96 | 0; f[(D = F) + 16 >> 2] = -1082130432, f[D + 20 >> 2] = -1082130432, f[D + 8 >> 2] = 0, f[D + 12 >> 2] = 0, f[D >> 2] = -1082130432, f[D + 4 >> 2] = -1082130432, (0 | U) != (0 | (F = D + 24 | 0)); ) ;
          if (f[p + 312 >> 2] = -1082130432, f[p + 316 >> 2] = -1082130432, f[p + 304 >> 2] = 0, f[p + 308 >> 2] = 0, f[p + 296 >> 2] = -1082130432, f[p + 300 >> 2] = -1082130432, f[p + 288 >> 2] = 2143289344, f[p + 292 >> 2] = 2143289344, D0(u + 228 | 0, p, 320), f[u + 244 >> 2] = 0, f[u + 248 >> 2] = 0, je[u + 4 | 0] = 1 | Ke[u + 4 | 0], (0 | (F = f[u + 556 >> 2])) != (0 | (m = f[u + 560 >> 2]))) for (; D = f[F >> 2], f[D + 552 >> 2] != (0 | u) && (U = f[u + 568 >> 2], D = jl(f[U >> 2], Ke[U + 8 | 0], D, u, $, l), f[F >> 2] = D, f[D + 552 >> 2] = u, D = f[F >> 2]), Gi(D, l), $ = $ + 1 | 0, (0 | m) != (0 | (F = F + 4 | 0)); ) ;
          nt = p + 320 | 0;
        }
        function So(u, l, p) {
          var m = 0, D = 0, F = 0, U = 0;
          return (D = ((m = u + 4 | 0) + l | 0) - 1 & 0 - l) + p >>> 0 <= ((l = f[u >> 2]) + u | 0) - 4 >>> 0 ? (F = f[u + 4 >> 2], f[F + 8 >> 2] = f[u + 8 >> 2], f[f[u + 8 >> 2] + 4 >> 2] = F, (0 | m) != (0 | D) && (D = D - m | 0, F = u - (-2 & f[u - 4 >> 2]) | 0, m = D + f[F >> 2] | 0, f[F >> 2] = m, f[(F + (-4 & m) | 0) - 4 >> 2] = m, l = l - D | 0, f[(u = u + D | 0) >> 2] = l), p + 24 >>> 0 <= l >>> 0 ? (l = (l - p | 0) - 8 | 0, f[(m = 8 + (u + p | 0) | 0) >> 2] = l, f[(m + (-4 & l) | 0) - 4 >> 2] = 1 | l, (D = f[m >> 2] - 8 | 0) >>> 0 <= 127 ? l = (D >>> 3 | 0) - 1 | 0 : (l = 110 + ((D >>> 29 - (F = Pn(D)) ^ 4) - (F << 2) | 0) | 0, D >>> 0 <= 4095 || (l = (l = 71 + ((D >>> 30 - F ^ 2) - (F << 1) | 0) | 0) >>> 0 >= 63 ? 63 : l)), D = l << 4, f[m + 4 >> 2] = D + 5888, D = D + 5896 | 0, f[m + 8 >> 2] = f[D >> 2], f[D >> 2] = m, f[f[m + 8 >> 2] + 4 >> 2] = m, D = f[1730], F = f[1731], m = 31 & l, (63 & l) >>> 0 >= 32 ? (l = 1 << m, m = 0) : (l = (U = 1 << m) - 1 & 1 >>> 32 - m, m = U), f[1730] = m | D, f[1731] = l | F, l = p + 8 | 0, f[u >> 2] = l, f[((-4 & l) + u | 0) - 4 >> 2] = l) : f[(u + l | 0) - 4 >> 2] = l, u = u + 4 | 0) : u = 0, u;
        }
        function T0(u, l, p) {
          var m = 0, D = 0;
          e: if ((0 | u) != (0 | l)) {
            if (l - (D = u + p | 0) >>> 0 <= 0 - (p << 1) >>> 0) return D0(u, l, p);
            if (m = 3 & (u ^ l), u >>> 0 < l >>> 0) {
              if (m) m = u;
              else {
                if (3 & u) for (m = u; ; ) {
                  if (!p) break e;
                  if (je[0 | m] = Ke[0 | l], l = l + 1 | 0, p = p - 1 | 0, !(3 & (m = m + 1 | 0))) break;
                }
                else m = u;
                if (!(p >>> 0 <= 3)) for (; f[m >> 2] = f[l >> 2], l = l + 4 | 0, m = m + 4 | 0, (p = p - 4 | 0) >>> 0 > 3; ) ;
              }
              if (p) for (; je[0 | m] = Ke[0 | l], m = m + 1 | 0, l = l + 1 | 0, p = p - 1 | 0; ) ;
            } else {
              if (!m) {
                if (3 & D) for (; ; ) {
                  if (!p) break e;
                  if (je[0 | (m = (p = p - 1 | 0) + u | 0)] = Ke[l + p | 0], !(3 & m)) break;
                }
                if (!(p >>> 0 <= 3)) for (; f[(p = p - 4 | 0) + u >> 2] = f[l + p >> 2], p >>> 0 > 3; ) ;
              }
              if (!p) break e;
              for (; je[(p = p - 1 | 0) + u | 0] = Ke[l + p | 0], p; ) ;
            }
          }
          return u;
        }
        function $l(u, l, p, m) {
          switch (l - 9 | 0) {
            case 0:
              return l = f[p >> 2], f[p >> 2] = l + 4, void (f[u >> 2] = f[l >> 2]);
            case 6:
              return l = f[p >> 2], f[p >> 2] = l + 4, l = Cr[l >> 1], f[u >> 2] = l, void (f[u + 4 >> 2] = l >> 31);
            case 7:
              return l = f[p >> 2], f[p >> 2] = l + 4, f[u >> 2] = _o[l >> 1], void (f[u + 4 >> 2] = 0);
            case 8:
              return l = f[p >> 2], f[p >> 2] = l + 4, l = je[0 | l], f[u >> 2] = l, void (f[u + 4 >> 2] = l >> 31);
            case 9:
              return l = f[p >> 2], f[p >> 2] = l + 4, f[u >> 2] = Ke[0 | l], void (f[u + 4 >> 2] = 0);
            case 16:
              return l = f[p >> 2] + 7 & -8, f[p >> 2] = l + 8, void (Fr[u >> 3] = Fr[l >> 3]);
            case 17:
              xt[0 | m](u, p);
            default:
              return;
            case 1:
            case 4:
            case 14:
              return l = f[p >> 2], f[p >> 2] = l + 4, l = f[l >> 2], f[u >> 2] = l, void (f[u + 4 >> 2] = l >> 31);
            case 2:
            case 5:
            case 11:
            case 15:
              return l = f[p >> 2], f[p >> 2] = l + 4, f[u >> 2] = f[l >> 2], void (f[u + 4 >> 2] = 0);
            case 3:
            case 10:
            case 12:
            case 13:
          }
          l = f[p >> 2] + 7 & -8, f[p >> 2] = l + 8, p = f[l + 4 >> 2], f[u >> 2] = f[l >> 2], f[u + 4 >> 2] = p;
        }
        function zl(u, l, p, m) {
          var D = 0, F = 0, U = 0, $ = 0, X = 0, Pe = 0, ce = 0, Ce = 0, ge = 0, Ne = 0, ue = 0, le = E(0), Ae = E(0), Le = E(0), $e = 0, He = E(0);
          if (l != 0 && (le = Y[u + 248 >> 2], Ae = Y[u + 244 >> 2], Le = Y[u + 232 >> 2], $e = u, He = bi(Ce = +Y[u + 228 >> 2], l, 0, D = (U = 8 & Ke[u + 4 | 0]) >>> 3 | 0), Y[$e + 228 >> 2] = He, $e = u, He = bi(ge = +Le, l, 0, D), Y[$e + 232 >> 2] = He, D = (X = Ua((Ne = +Ae) * l)) != X, F = (Pe = Ua((ue = +le) * l)) != Pe, p = Ce + p, $ = D | ($ = jr(X) < 1e-4) ? D | !$ : !(jr(X + -1) < 1e-4), $e = u, He = E(bi(p + Ne, l, $ & (D = (0 | U) != 0), D & !$) - bi(p, l, 0, D)), Y[$e + 244 >> 2] = He, m = ge + m, F = F | (U = jr(Pe) < 1e-4) ? F | !U : !(jr(Pe + -1) < 1e-4), $e = u, He = E(bi(m + ue, l, D & F, D & !F) - bi(m, l, 0, D)), Y[$e + 248 >> 2] = He, (0 | (D = f[u + 560 >> 2])) != (0 | (F = f[u + 556 >> 2])))) for (F = (D = D - F >> 2) >>> 0 <= 1 ? 1 : D; D = f[u + 556 >> 2], zl(D = f[u + 560 >> 2] - D >> 2 >>> 0 > ce >>> 0 ? f[D + (ce << 2) >> 2] : 0, l, p, m), (0 | F) != (0 | (ce = ce + 1 | 0)); ) ;
        }
        function mf() {
          g2(7004, 3018), ds(7005, 2479, 1, 1, 0), zi(7006, 2139, 1, -128, 127), zi(7007, 2132, 1, -128, 127), zi(7008, 2130, 1, 0, 255), zi(7009, 1286, 2, -32768, 32767), zi(7010, 1277, 2, 0, 65535), zi(7011, 1315, 4, -2147483648, 2147483647), zi(7012, 1306, 4, 0, -1), zi(7013, 2658, 4, -2147483648, 2147483647), zi(7014, 2649, 4, 0, -1), If(7015, 1776, -2147483648, 2147483647), If(7016, 1775, 0, -1), hf(7017, 1769, 4), hf(7018, 2966, 8), df(7019, 2676), df(7020, 3835), Ll(7021, 4, 2663), Ll(7022, 2, 2688), Ll(7023, 4, 2703), vf(7024, 2484), Y0(7025, 0, 3766), Y0(7026, 0, 3868), Y0(7027, 1, 3796), Y0(7028, 2, 3398), Y0(7029, 3, 3429), Y0(7030, 4, 3469), Y0(7031, 5, 3498), Y0(7032, 4, 3905), Y0(7033, 5, 3935), Y0(7026, 0, 3600), Y0(7027, 1, 3567), Y0(7028, 2, 3666), Y0(7029, 3, 3632), Y0(7030, 4, 3733), Y0(7031, 5, 3699), Y0(7034, 6, 3536), Y0(7035, 7, 3974);
        }
        function k0(u, l, p) {
          var m = 0, D = 0, F = 0, U = 0;
          if (p && (je[0 | u] = l, je[(m = u + p | 0) - 1 | 0] = l, !(p >>> 0 < 3 || (je[u + 2 | 0] = l, je[u + 1 | 0] = l, je[m - 3 | 0] = l, je[m - 2 | 0] = l, p >>> 0 < 7 || (je[u + 3 | 0] = l, je[m - 4 | 0] = l, p >>> 0 < 9 || (D = (m = 0 - u & 3) + u | 0, l = pr(255 & l, 16843009), f[D >> 2] = l, f[(p = (m = p - m & -4) + D | 0) - 4 >> 2] = l, m >>> 0 < 9 || (f[D + 8 >> 2] = l, f[D + 4 >> 2] = l, f[p - 8 >> 2] = l, f[p - 12 >> 2] = l, m >>> 0 < 25 || (f[D + 24 >> 2] = l, f[D + 20 >> 2] = l, f[D + 16 >> 2] = l, f[D + 12 >> 2] = l, f[p - 16 >> 2] = l, f[p - 20 >> 2] = l, f[p - 24 >> 2] = l, f[p - 28 >> 2] = l, (p = m - (U = 4 & D | 24) | 0) >>> 0 < 32)))))))) for (m = Yl(l, 0, 1, 1), F = sr, l = D + U | 0; f[l + 24 >> 2] = m, f[l + 28 >> 2] = F, f[l + 16 >> 2] = m, f[l + 20 >> 2] = F, f[l + 8 >> 2] = m, f[l + 12 >> 2] = F, f[l >> 2] = m, f[l + 4 >> 2] = F, l = l + 32 | 0, (p = p - 32 | 0) >>> 0 > 31; ) ;
          return u;
        }
        function l0(u) {
          var l = 0, p = 0, m = 0, D = 0, F = 0;
          (u |= 0) && (p = D = f[(l = u - 4 | 0) >> 2], m = l, (0 | (u = -2 & (F = f[u - 8 >> 2]))) != (0 | F) && (p = f[4 + (m = l - u | 0) >> 2], f[p + 8 >> 2] = f[m + 8 >> 2], f[f[m + 8 >> 2] + 4 >> 2] = p, p = u + D | 0), (0 | (l = f[(u = l + D | 0) >> 2])) != f[(u + l | 0) - 4 >> 2] && (D = f[u + 4 >> 2], f[D + 8 >> 2] = f[u + 8 >> 2], f[f[u + 8 >> 2] + 4 >> 2] = D, p = l + p | 0), f[m >> 2] = p, f[((-4 & p) + m | 0) - 4 >> 2] = 1 | p, (l = f[m >> 2] - 8 | 0) >>> 0 <= 127 ? u = (l >>> 3 | 0) - 1 | 0 : (u = 110 + ((l >>> 29 - (p = Pn(l)) ^ 4) - (p << 2) | 0) | 0, l >>> 0 <= 4095 || (u = (u = 71 + ((l >>> 30 - p ^ 2) - (p << 1) | 0) | 0) >>> 0 >= 63 ? 63 : u)), l = u << 4, f[m + 4 >> 2] = l + 5888, l = l + 5896 | 0, f[m + 8 >> 2] = f[l >> 2], f[l >> 2] = m, f[f[m + 8 >> 2] + 4 >> 2] = m, l = f[1730], p = f[1731], m = 31 & u, (63 & u) >>> 0 >= 32 ? (u = 1 << m, D = 0) : u = (D = 1 << m) - 1 & 1 >>> 32 - m, f[1730] = D | l, f[1731] = u | p);
        }
        function yf(u, l, p, m, D) {
          var F, U = 0, $ = 0;
          if (nt = F = nt - 208 | 0, f[F + 204 >> 2] = p, k0(p = F + 160 | 0, 0, 40), f[F + 200 >> 2] = f[F + 204 >> 2], (0 | xu(0, l, F + 200 | 0, F + 80 | 0, p, m, D)) < 0) D = -1;
          else {
            f[u + 76 >> 2], U = f[u >> 2], f[u + 72 >> 2] <= 0 && (f[u >> 2] = -33 & U);
            e: {
              n: {
                if (f[u + 48 >> 2]) {
                  if (f[u + 16 >> 2]) break n;
                } else f[u + 48 >> 2] = 80, f[u + 28 >> 2] = 0, f[u + 16 >> 2] = 0, f[u + 20 >> 2] = 0, $ = f[u + 44 >> 2], f[u + 44 >> 2] = F;
                if (p = -1, ku(u)) break e;
              }
              p = xu(u, l, F + 200 | 0, F + 80 | 0, F + 160 | 0, m, D);
            }
            $ && (xt[f[u + 36 >> 2]](u, 0, 0), f[u + 48 >> 2] = 0, f[u + 44 >> 2] = $, f[u + 28 >> 2] = 0, l = f[u + 20 >> 2], f[u + 16 >> 2] = 0, f[u + 20 >> 2] = 0, p = l ? p : -1), l = u, u = f[u >> 2], f[l >> 2] = u | 32 & U, D = 32 & u ? -1 : p;
          }
          return nt = F + 208 | 0, D;
        }
        function Eu(u) {
          var l, p = 0, m = E(0), D = 0, F = 0, U = 0, $ = 0, X = E(0), Pe = 0;
          nt = l = nt - 16 | 0;
          e: {
            if (p = f[u + 12 >> 2]) {
              if (X = Y[u + 520 >> 2], m = Y[u + 516 >> 2], (m = 32 & Ke[u + 4 | 0] ? E(xt[0 | p](u, m, X, 0)) : E(xt[0 | p](u, m, X))) == m) break e;
              f[l >> 2] = 3340, vn(u, l), un(), Ut();
            }
            n: {
              t: {
                if ((0 | (U = f[u + 556 >> 2])) != (0 | (p = f[u + 560 >> 2]))) {
                  for (Pe = (p = p - U >> 2) >>> 0 <= 1 ? 1 : p; ; ) {
                    if (F = f[($ << 2) + U >> 2], !f[F + 548 >> 2]) {
                      if ((196608 & (p = f[F + 24 >> 2])) != 131072) {
                        if ((p = p >>> 13 & 7) || (p = f[u + 24 >> 2] >>> 10 & 7), 2 & Ke[F + 4 | 0] | (8 & Ke[u + 24 | 0] ? (0 | p) == 5 : 0)) break t;
                        D = D || F;
                      }
                      if ((0 | Pe) != (0 | ($ = $ + 1 | 0))) continue;
                    }
                    break;
                  }
                  if (D) break n;
                }
                m = Y[u + 520 >> 2];
                break e;
              }
              D = F;
            }
            m = E(Eu(D) + Y[D + 232 >> 2]);
          }
          return nt = l + 16 | 0, m;
        }
        function za(u, l, p, m, D, F) {
          var U = 0, $ = E(0), X = 0, Pe = E(0);
          U = (f[4252 + (l << 2) >> 2] << 2) + u | 0, $ = Y[U + 216 >> 2];
          e: {
            n: {
              t: if ((0 | (U = f[U + 216 >> 2])) != 2139156720) {
                if ((0 | U) == 2140081935) break n;
                X = 4276;
                r: {
                  if ((0 | U) != 2141891242) {
                    if ($ == $) break r;
                    X = 4268;
                  }
                  switch (Pe = Y[X >> 2], $ = E(NaN), f[X + 4 >> 2] - 1 | 0) {
                    case 0:
                      break n;
                    case 1:
                      break t;
                    default:
                      break e;
                  }
                }
                if (ze(2, 536870912 + (-1073741825 & U) | 0), Pe = Tt(), !(1073741824 & U)) break n;
              }
              $ = E(E(Pe * p) * E(0.009999999776482582));
              break e;
            }
            $ = Pe;
          }
          m = E($ + E(er(u, l, m) + wr(u, l, m)));
          e: {
            n: {
              t: switch (f[D >> 2]) {
                case 1:
                case 2:
                  p = Y[F >> 2], m = m != m || p < m ? p : m;
                  break n;
                case 0:
                  break t;
                default:
                  break e;
              }
              if (m != m) break e;
              f[D >> 2] = 2;
            }
            Y[F >> 2] = m;
          }
        }
        function Or(u, l, p) {
          var m, D = E(0), F = E(0), U = E(0);
          u = u + 116 | 0, m = f[4220 + (l << 2) >> 2];
          e: {
            n: {
              t: {
                r: if ((0 | (l = (-2 & l) != 2 ? Z0(u, m, 2140081935) : yi(u, 4, m, 2140081935))) != 2139156720) {
                  if ((0 | l) == 2140081935) break e;
                  u = 4276;
                  i: {
                    if ((0 | l) != 2141891242) {
                      if (ze(2, l), (D = Tt()) == D) break i;
                      u = 4268;
                    }
                    switch (D = Y[u >> 2], F = E(NaN), f[u + 4 >> 2] - 1 | 0) {
                      case 0:
                        break t;
                      case 1:
                        break r;
                      default:
                        break n;
                    }
                  }
                  if (ze(2, 536870912 + (-1073741825 & l) | 0), D = Tt(), !(1073741824 & l)) break t;
                }
                D = E(E(D * p) * E(0.009999999776482582));
              }
              if (D >= E(0)) return D;
              if (F = D, D < E(0)) break e;
            }
            U = F == F ? F : E(0);
          }
          return U;
        }
        function Rr(u, l, p) {
          var m, D = E(0), F = E(0), U = E(0);
          u = u + 116 | 0, m = f[4236 + (l << 2) >> 2];
          e: {
            n: {
              t: {
                r: if ((0 | (l = (-2 & l) != 2 ? Z0(u, m, 2140081935) : yi(u, 5, m, 2140081935))) != 2139156720) {
                  if ((0 | l) == 2140081935) break e;
                  u = 4276;
                  i: {
                    if ((0 | l) != 2141891242) {
                      if (ze(2, l), (D = Tt()) == D) break i;
                      u = 4268;
                    }
                    switch (D = Y[u >> 2], F = E(NaN), f[u + 4 >> 2] - 1 | 0) {
                      case 0:
                        break t;
                      case 1:
                        break r;
                      default:
                        break n;
                    }
                  }
                  if (ze(2, 536870912 + (-1073741825 & l) | 0), D = Tt(), !(1073741824 & l)) break t;
                }
                D = E(E(D * p) * E(0.009999999776482582));
              }
              if (D >= E(0)) return D;
              if (F = D, D < E(0)) break e;
            }
            U = F == F ? F : E(0);
          }
          return U;
        }
        function jl(u, l, p, m, D, F) {
          var U = 0;
          e: {
            if (!u || !(F = 255 & l ? 0 | xt[0 | u](p, m, D, F) : 0 | xt[0 | u](p, m, D))) {
              if (l = D0(F = Ze(588), p, 552), f[l + 564 >> 2] = 0, f[l + 556 >> 2] = 0, f[l + 560 >> 2] = 0, (0 | (D = f[p + 556 >> 2])) != (0 | (m = f[p + 560 >> 2]))) {
                if ((0 | (U = m - D | 0)) < 0) break e;
                for (u = Ze(U), f[l + 556 >> 2] = u, f[l + 564 >> 2] = u + U; f[u >> 2] = f[D >> 2], u = u + 4 | 0, (0 | m) != (0 | (D = D + 4 | 0)); ) ;
                f[l + 560 >> 2] = u;
              }
              u = f[p + 572 >> 2], f[l + 568 >> 2] = f[p + 568 >> 2], f[l + 572 >> 2] = u, f[l + 584 >> 2] = f[p + 584 >> 2], u = f[p + 580 >> 2], f[l + 576 >> 2] = f[p + 576 >> 2], f[l + 580 >> 2] = u, f[l + 552 >> 2] = 0;
            }
            return F;
          }
          Do(), Ut();
        }
        function vn(u, l) {
          var p, m = 0, D = 0;
          nt = p = nt - 16 | 0, f[p + 12 >> 2] = l;
          e: {
            if (u) {
              if (l = f[p + 12 >> 2], m = f[u + 568 >> 2]) {
                if (D = f[m + 4 >> 2], Ke[m + 9 | 0]) {
                  xt[0 | D](m, u, 5, 0, 4215, l);
                  break e;
                }
                xt[0 | D](m, u, 5, 4215, l);
                break e;
              }
            } else l = f[p + 12 >> 2];
            if (Ke[6936]) {
              if (m = f[1733], D = f[m + 4 >> 2], Ke[m + 9 | 0]) {
                xt[0 | D](m, u, 5, 0, 4215, l);
                break e;
              }
            } else m = Ze(28), Cr[m + 20 >> 1] = 0, f[m + 16 >> 2] = 1065353216, Cr[m + 10 >> 1] = 0, Cr[m + 12 >> 1] = 0, f[m >> 2] = 0, f[m + 24 >> 2] = 0, je[m + 9 | 0] = 0, D = 1, f[m + 4 >> 2] = 1, je[m + 22 | 0] = 0, f[1733] = m, je[6936] = 1, f[1732] = f[1732] + 1;
            xt[0 | D](m, u, 5, 4215, l);
          }
          nt = p + 16 | 0;
        }
        function vs(u, l, p) {
          var m, D = E(0), F = E(0);
          u = u + 80 | 0, m = f[4236 + (l << 2) >> 2];
          e: {
            n: {
              t: if ((0 | (l = (-2 & l) != 2 ? Z0(u, m, 2140081935) : yi(u, 5, m, 2140081935))) != 2139156720) {
                if ((0 | l) == 2140081935) break e;
                u = 4276;
                r: {
                  if ((0 | l) != 2141891242) {
                    if (ze(2, l), (D = Tt()) == D) break r;
                    u = 4268;
                  }
                  switch (D = Y[u >> 2], F = E(NaN), f[u + 4 >> 2] - 1 | 0) {
                    case 0:
                      break e;
                    case 1:
                      break t;
                    default:
                      break n;
                  }
                }
                if (ze(2, 536870912 + (-1073741825 & l) | 0), D = Tt(), !(1073741824 & l)) break e;
              }
              F = E(E(D * p) * E(0.009999999776482582));
            }
            return F;
          }
          return D;
        }
        function ga(u, l, p) {
          var m, D = E(0), F = E(0);
          u = u + 80 | 0, m = f[4220 + (l << 2) >> 2];
          e: {
            n: {
              t: if ((0 | (l = (-2 & l) != 2 ? Z0(u, m, 2140081935) : yi(u, 4, m, 2140081935))) != 2139156720) {
                if ((0 | l) == 2140081935) break e;
                u = 4276;
                r: {
                  if ((0 | l) != 2141891242) {
                    if (ze(2, l), (D = Tt()) == D) break r;
                    u = 4268;
                  }
                  switch (D = Y[u >> 2], F = E(NaN), f[u + 4 >> 2] - 1 | 0) {
                    case 0:
                      break e;
                    case 1:
                      break t;
                    default:
                      break n;
                  }
                }
                if (ze(2, 536870912 + (-1073741825 & l) | 0), D = Tt(), !(1073741824 & l)) break e;
              }
              F = E(E(D * p) * E(0.009999999776482582));
            }
            return F;
          }
          return D;
        }
        function yi(u, l, p, m) {
          var D = E(0);
          return D = Y[(l = (l << 2) + u | 0) >> 2], (0 | (l = f[l >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 | D == D || (D = Y[(l = (p << 2) + u | 0) >> 2], (0 | (l = f[l >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 | D == D || (0 | (l = f[u + 24 >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 | (D = Y[u + 24 >> 2]) == D || (D = Y[u + 32 >> 2], ((0 | (u = f[u + 32 >> 2])) == 2139156720 | (0 | u) == 2140081935 | (0 | u) == 2141891242 || (l = m, D == D)) && (l = u))), l;
        }
        function bf(u, l, p, m, D) {
          var F, U = 0, $ = 0, X = E(0);
          U = 2, $ = f[u + 24 >> 2] >>> 2 & 3;
          e: {
            n: {
              t: {
                if (!(!f[u + 552 >> 2] | (0 | l) != 2)) {
                  l = 0, U = 3;
                  r: switch ($ - 2 | 0) {
                    case 0:
                      break e;
                    case 1:
                      break r;
                    default:
                      break t;
                  }
                  U = 2;
                  break e;
                }
                if (l = 0, $ >>> 0 > 1) break n;
              }
              l = U;
            }
            U = $;
          }
          p = Ff(u, U, p), m = Ff(u, l, m), X = er(u, U, D), Y[($ = u + 228 | 0) + (f[4220 + (F = U << 2) >> 2] << 2) >> 2] = p + X, X = wr(u, U, D), Y[$ + (f[F + 4236 >> 2] << 2) >> 2] = p + X, p = er(u, l, D), Y[$ + (f[4220 + (U = l << 2) >> 2] << 2) >> 2] = m + p, p = wr(u, l, D), Y[$ + (f[U + 4236 >> 2] << 2) >> 2] = m + p;
        }
        function wf(u) {
          var l = 0, p = 0, m = 0, D = 0;
          if (u |= 0) {
            if (l = f[u >> 2], (p = f[l + 552 >> 2]) && (Nn(p, l), f[l + 552 >> 2] = 0), (0 | (m = f[l + 560 >> 2])) != (0 | (p = f[l + 556 >> 2]))) for (D = (m = m - p >> 2) >>> 0 <= 1 ? 1 : m, m = 0; f[f[p + (m << 2) >> 2] + 552 >> 2] = 0, (0 | D) != (0 | (m = m + 1 | 0)); ) ;
            f[l + 560 >> 2] = p, Af(l + 556 | 0), (p = f[l + 556 >> 2]) && (f[l + 560 >> 2] = p, l0(p)), l0(l), l = f[u + 8 >> 2], f[u + 8 >> 2] = 0, l && xt[f[f[l >> 2] + 4 >> 2]](l), l = f[u + 4 >> 2], f[u + 4 >> 2] = 0, l && xt[f[f[l >> 2] + 4 >> 2]](l), l0(u);
          }
        }
        function Af(u) {
          var l, p = 0, m = 0, D = 0, F = 0;
          nt = l = nt - 32 | 0, p = f[u >> 2], (m = f[u + 4 >> 2] - p >> 2) >>> 0 >= f[u + 8 >> 2] - p >> 2 >>> 0 || (m = ma(l + 8 | 0, m, m, u + 8 | 0), p = f[u >> 2], D = f[u + 4 >> 2] - p | 0, D = T0(f[m + 4 >> 2] - D | 0, p, D), p = f[u >> 2], f[u >> 2] = D, f[m + 4 >> 2] = p, D = f[u + 4 >> 2], f[u + 4 >> 2] = f[m + 8 >> 2], f[m + 8 >> 2] = D, F = f[u + 8 >> 2], f[u + 8 >> 2] = f[m + 12 >> 2], f[m >> 2] = p, f[m + 12 >> 2] = F, (0 | p) != (0 | D) && (f[m + 8 >> 2] = D + (3 + (p - D | 0) & -4)), p && l0(p)), nt = l + 32 | 0;
        }
        function S0(u, l, p) {
          var m = 0, D = 0, F = 0;
          if (!(32 & Ke[0 | u])) e: {
            m = l;
            n: {
              if (!(u = f[(l = u) + 16 >> 2])) {
                if (ku(l)) break n;
                u = f[l + 16 >> 2];
              }
              if (u - (F = f[l + 20 >> 2]) >>> 0 < p >>> 0) {
                xt[f[l + 36 >> 2]](l, m, p);
                break e;
              }
              t: if (!(f[l + 80 >> 2] < 0)) {
                for (u = p; ; ) {
                  if (D = u, !u) break t;
                  if (Ke[m + (u = D - 1 | 0) | 0] == 10) break;
                }
                if (xt[f[l + 36 >> 2]](l, m, D) >>> 0 < D >>> 0) break n;
                m = m + D | 0, p = p - D | 0, F = f[l + 20 >> 2];
              }
              D0(F, m, p), f[l + 20 >> 2] = f[l + 20 >> 2] + p;
            }
          }
        }
        function gs(u, l, p) {
          var m, D = 0, F = 0;
          nt = m = nt - 16 | 0, D = u + 24 | 0, xt[0 | l](m + 8 | 0, D), F = f[m + 12 >> 2];
          e: if ((f[f[m + 8 >> 2] >> 2] & 7 << F) >> F != (0 | p)) for (xt[0 | l](m + 8 | 0, D), D = l = f[m + 8 >> 2], F = f[l >> 2], l = f[m + 12 >> 2], f[D >> 2] = F & (7 << l ^ -1) | (7 & p) << l; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
          nt = m + 16 | 0;
        }
        function wr(u, l, p) {
          var m, D = E(0);
          u = u + 44 | 0, m = f[4236 + (l << 2) >> 2];
          e: {
            if ((0 | (u = (-2 & l) != 2 ? Z0(u, m, 2140081935) : yi(u, 5, m, 2140081935))) != 2139156720) {
              if ((0 | u) == 2140081935 | (0 | u) == 2141891242) break e;
              if (ze(2, u), (D = Tt()) != D) return E(NaN);
              if (ze(2, 536870912 + (-1073741825 & u) | 0), D = Tt(), !(1073741824 & u)) break e;
            }
            D = E(E(D * p) * E(0.009999999776482582));
          }
          return D;
        }
        function er(u, l, p) {
          var m, D = E(0);
          u = u + 44 | 0, m = f[4220 + (l << 2) >> 2];
          e: {
            if ((0 | (u = (-2 & l) != 2 ? Z0(u, m, 2140081935) : yi(u, 4, m, 2140081935))) != 2139156720) {
              if ((0 | u) == 2140081935 | (0 | u) == 2141891242) break e;
              if (ze(2, u), (D = Tt()) != D) return E(NaN);
              if (ze(2, 536870912 + (-1073741825 & u) | 0), D = Tt(), !(1073741824 & u)) break e;
            }
            D = E(E(D * p) * E(0.009999999776482582));
          }
          return D;
        }
        function Z0(u, l, p) {
          var m = E(0);
          return m = Y[(l = (l << 2) + u | 0) >> 2], (0 | (l = f[l >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 | m == m || (0 | (l = f[u + 28 >> 2])) == 2139156720 | (0 | l) == 2140081935 | (0 | l) == 2141891242 | (m = Y[u + 28 >> 2]) == m || (m = Y[u + 32 >> 2], ((0 | (u = f[u + 32 >> 2])) == 2139156720 | (0 | u) == 2140081935 | (0 | u) == 2141891242 || (l = p, m == m)) && (l = u)), l;
        }
        function nr(u, l) {
          var p, m = E(0);
          return u = u + 152 | 0, p = f[4236 + (l << 2) >> 2], u = (-2 & l) != 2 ? Z0(u, p, 2140081935) : yi(u, 5, p, 2140081935), m = E(0), (0 | u) != 2139156720 && (m = E(0), (0 | u) != 2140081935 && ((0 | u) == 2141891242 || (ze(2, u), (m = Tt()) != m) ? m = E(NaN) : (ze(2, 536870912 + (-1073741825 & u) | 0), m = Tt()))), tr(m, E(0));
        }
        function Kt(u, l) {
          var p, m = E(0);
          return u = u + 152 | 0, p = f[4220 + (l << 2) >> 2], u = (-2 & l) != 2 ? Z0(u, p, 2140081935) : yi(u, 4, p, 2140081935), m = E(0), (0 | u) != 2139156720 && (m = E(0), (0 | u) != 2140081935 && ((0 | u) == 2141891242 || (ze(2, u), (m = Tt()) != m) ? m = E(NaN) : (ze(2, 536870912 + (-1073741825 & u) | 0), m = Tt()))), tr(m, E(0));
        }
        function bi(u, l, p, m) {
          var D, F = 0, U = 0;
          e: if ((D = (F = (F = Ua(u *= l)) < 0 ? F + 1 : F) != F) | !(jr(F) < 1e-4)) {
            if (F == F) {
              if (u -= F, jr(F + -1) < 1e-4) {
                u += 1;
                break e;
              }
            } else u -= F;
            p ? u += 1 : m || (U = 0, D || (U = 1, F > 0.5 || (U = jr(F + -0.5) < 1e-4 ? 1 : 0)), u += U);
          } else u -= F;
          return E(u != u | l != l ? NaN : u / l);
        }
        function xf(u) {
          var l = E(0), p = 0, m = E(0);
          p = 0;
          e: if ((196608 & f[u + 24 >> 2]) != 131072) {
            if (f[u + 552 >> 2]) {
              if (((l = Y[u + 32 >> 2]) == l || (l = Y[u + 28 >> 2]) > E(0)) && (p = 1, l != E(0))) break e;
              (l = Y[u + 36 >> 2]) != l && (je[u + 4 | 0] < 0 ? l = E(1) : (l = E(0), (m = Y[u + 28 >> 2]) < E(0) && (l = E(-m))));
            }
            p = l != E(0);
          }
          return p;
        }
        function Wl(u, l) {
          var p = E(0);
          e: {
            if ((0 | l) != 2139156720) {
              if ((0 | l) != 2140081935) {
                if ((0 | l) != 2141891242) break e;
                return f[u >> 2] = 2143289344, void (f[u + 4 >> 2] = 3);
              }
              return f[u >> 2] = 0, void (f[u + 4 >> 2] = 1);
            }
            return f[u >> 2] = 0, void (f[u + 4 >> 2] = 2);
          }
          if (ze(2, l), (p = Tt()) != p) return f[u >> 2] = 2143289344, void (f[u + 4 >> 2] = 0);
          f[u + 4 >> 2] = 1073741824 & l ? 2 : 1, f[u >> 2] = 536870912 + (-1073741825 & l);
        }
        function Ef(u) {
          var l = 0, p = 0, m = 0;
          e: if (8 & (p = f[u + 24 >> 2]) && (l = 1, (7168 & p) != 5120 && (l = 0, (0 | (m = f[u + 560 >> 2])) != (0 | (p = f[u + 556 >> 2]))))) for (m = (u = m - p >> 2) >>> 0 <= 1 ? 1 : u, u = 0; ; ) {
            if (l = (196608 & (l = f[f[p + (u << 2) >> 2] + 24 >> 2])) != 131072 & (57344 & l) == 40960) break e;
            if ((0 | m) == (0 | (u = u + 1 | 0))) break;
          }
          return l;
        }
        function Wn(u) {
          var l = 0, p = E(0);
          return l = 2143289344, E(jr(u)) == E(1 / 0) | u != u || (l = 2139156720, u < E(10842021724855044e-35) & u > E(-10842021724855044e-35) | u == E(0) || (ze(2, -2147483648 & (Ht(u), qe(2)) | 1602224127), p = Tt(), l = 1073741824 | (Ht(u > E(18446742974197924e3) || u < E(-18446742974197924e3) ? p : u), qe(2) - 536870912))), l;
        }
        function Bn(u) {
          var l = 0, p = E(0);
          return l = 2143289344, E(jr(u)) == E(1 / 0) | u != u || (l = 2140081935, u < E(10842021724855044e-35) & u > E(-10842021724855044e-35) | u == E(0) || (ze(2, -2147483648 & (Ht(u), qe(2)) | 1610612735), p = Tt(), l = 0 | (Ht(u > E(36893485948395848e3) || u < E(-36893485948395848e3) ? p : u), qe(2) - 536870912))), l;
        }
        function m2(u, l) {
          return l ? l = kf(f[l >> 2]) : (Ke[6936] ? l = f[1733] : (l = Ze(28), Cr[l + 20 >> 1] = 0, f[l + 16 >> 2] = 1065353216, Cr[l + 10 >> 1] = 0, Cr[l + 12 >> 1] = 0, f[l >> 2] = 0, f[l + 24 >> 2] = 0, je[l + 9 | 0] = 0, f[l + 4 >> 2] = 1, je[l + 22 | 0] = 0, f[1733] = l, je[6936] = 1, f[1732] = f[1732] + 1), l = kf(l)), f[u + 4 >> 2] = 0, f[u + 8 >> 2] = 0, f[u >> 2] = l, f[l >> 2] = u, u;
        }
        function gn(u, l, p) {
          var m = 0, D = 0, F = 0;
          if (l) for (; u = Yl(m = ps(u, l, 10), D = sr, 246, 0) + u | 0, je[0 | (p = p - 1 | 0)] = 48 | u, F = l >>> 0 > 9, u = m, l = D, F; ) ;
          else m = u;
          if (m) for (; u = (m >>> 0) / 10 | 0, je[0 | (p = p - 1 | 0)] = pr(u, 246) + m | 48, l = m >>> 0 > 9, m = u, l; ) ;
          return p;
        }
        function Nn(u, l) {
          var p = 0, m = 0;
          e: {
            n: if ((0 | (p = f[u + 556 >> 2])) != (0 | (m = f[u + 560 >> 2]))) {
              for (; ; ) {
                if (f[p >> 2] == (0 | l)) break n;
                if ((0 | m) == (0 | (p = p + 4 | 0))) break;
              }
              break e;
            }
            if ((0 | p) != (0 | m)) return T0(p, l = p + 4 | 0, m - l | 0), f[u + 560 >> 2] = m - 4, 1;
          }
          return 0;
        }
        function _f(u, l) {
          var p, m, D = 0;
          if (fr(+u), p = 0 | qe(1), m = 0 | qe(0), (0 | (D = p >>> 20 & 2047)) != 2047) {
            if (!D) return u == 0 ? D = 0 : (u = _f(18446744073709552e3 * u, l), D = f[l >> 2] + -64 | 0), f[l >> 2] = D, u;
            f[l >> 2] = D - 1022, ze(0, 0 | m), ze(1, -2146435073 & p | 1071644672), u = +Pt();
          }
          return u;
        }
        function _u(u, l, p) {
          var m = 0;
          e: if (f[184 + ((m = u + 24 | 0) + (l << 2) | 0) >> 2] != (0 | p)) for (f[184 + ((l << 2) + m | 0) >> 2] = p; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }
        function Du(u, l, p) {
          var m = 0;
          e: if (f[192 + ((m = u + 24 | 0) + (l << 2) | 0) >> 2] != (0 | p)) for (f[192 + ((l << 2) + m | 0) >> 2] = p; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }
        function Co(u, l, p) {
          var m = 0;
          e: if (f[176 + ((m = u + 24 | 0) + (l << 2) | 0) >> 2] != (0 | p)) for (f[176 + ((l << 2) + m | 0) >> 2] = p; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }
        function Tu(u, l) {
          var p = 0, m = 0, D = 0;
          e: if (f[16 + (p = u + 24 | 0) >> 2] != (0 | l)) for (m = 0 | xt[9](p), D = l, f[m + 16 >> 2] = D; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }
        function Df(u, l, p) {
          var m = 0;
          e: if (f[56 + ((m = u + 24 | 0) + (l << 2) | 0) >> 2] != (0 | p)) for (f[56 + ((l << 2) + m | 0) >> 2] = p; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }
        function Gl(u, l, p) {
          var m = 0;
          e: if (f[92 + ((m = u + 24 | 0) + (l << 2) | 0) >> 2] != (0 | p)) for (f[92 + ((l << 2) + m | 0) >> 2] = p; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }
        function Vl(u, l, p) {
          var m = 0;
          e: if (f[20 + ((m = u + 24 | 0) + (l << 2) | 0) >> 2] != (0 | p)) for (f[20 + ((l << 2) + m | 0) >> 2] = p; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }
        function ms(u, l) {
          var p, m = E(0);
          return u = u + 80 | 0, p = f[4236 + (l << 2) >> 2], (0 | (u = (-2 & l) != 2 ? Z0(u, p, 2143289344) : yi(u, 5, p, 2143289344))) == 2139156720 | (0 | u) == 2140081935 | (0 | u) == 2141891242 ? u = 1 : (ze(2, u), u = (m = Tt()) == m), u;
        }
        function Ln(u, l) {
          var p, m = E(0);
          return u = u + 80 | 0, p = f[4220 + (l << 2) >> 2], (0 | (u = (-2 & l) != 2 ? Z0(u, p, 2143289344) : yi(u, 4, p, 2143289344))) == 2139156720 | (0 | u) == 2140081935 | (0 | u) == 2141891242 ? u = 1 : (ze(2, u), u = (m = Tt()) == m), u;
        }
        function Yl(u, l, p, m) {
          var D, F, U, $, X = 0, Pe = 0;
          return $ = pr(X = p >>> 16 | 0, Pe = u >>> 16 | 0), X = (65535 & (Pe = ((U = pr(D = 65535 & p, F = 65535 & u)) >>> 16 | 0) + pr(Pe, D) | 0)) + pr(X, F) | 0, sr = (pr(l, p) + $ | 0) + pr(u, m) + (Pe >>> 16) + (X >>> 16) | 0, 65535 & U | X << 16;
        }
        function Hl(u, l) {
          var p, m, D = 0;
          nt = p = nt - 16 | 0, m = -17 & (D = Ke[u + 4 | 0]), je[u + 4 | 0] = m;
          e: {
            if (l) {
              if (f[u + 560 >> 2] != f[u + 556 >> 2]) break e;
              D = 8 | m;
            } else D &= 231;
            return f[u + 8 >> 2] = l, je[u + 4 | 0] = D, void (nt = p + 16 | 0);
          }
          f[p >> 2] = 4059, vn(u, p), un(), Ut();
        }
        function M0(u, l, p, m, D) {
          var F;
          if (nt = F = nt - 256 | 0, !(73728 & D | (0 | p) <= (0 | m))) {
            if (k0(F, 255 & l, (p = (m = p - m | 0) >>> 0 < 256) ? m : 256), !p) for (; S0(u, F, 256), (m = m - 256 | 0) >>> 0 > 255; ) ;
            S0(u, F, m);
          }
          nt = F + 256 | 0;
        }
        function mn(u, l, p) {
          var m = 0, D = E(0);
          (-2 & p) == 2 && (D = Y[(m = l - -64 | 0) >> 2], (0 | (m = f[m >> 2])) == 2139156720 | (0 | m) == 2140081935 | (0 | m) == 2141891242 | D == D) || (m = f[44 + ((f[4236 + (p << 2) >> 2] << 2) + l | 0) >> 2]), Wl(u, m);
        }
        function sn(u, l, p) {
          var m = 0, D = E(0);
          (-2 & p) == 2 && (0 | (m = f[l + 60 >> 2])) == 2139156720 | (0 | m) == 2140081935 | (0 | m) == 2141891242 | (D = Y[l + 60 >> 2]) == D || (m = f[44 + ((f[4220 + (p << 2) >> 2] << 2) + l | 0) >> 2]), Wl(u, m);
        }
        function ys(u) {
          var l = 0, p = 0, m = 0;
          for (m = f[u >> 2]; yn(p = je[0 | m]); ) m = m + 1 | 0, f[u >> 2] = m, l = l >>> 0 <= 214748364 ? (0 | (p = p - 48 | 0)) > (2147483647 ^ (l = pr(l, 10))) ? -1 : p + l | 0 : -1;
          return l;
        }
        function ma(u, l, p, m) {
          var D = 0;
          f[u + 12 >> 2] = 0, f[u + 16 >> 2] = m;
          e: {
            if (l) {
              if (l >>> 0 >= 1073741824) break e;
              D = Ze(l << 2);
            }
            return f[u >> 2] = D, p = (p << 2) + D | 0, f[u + 8 >> 2] = p, f[u + 12 >> 2] = (l << 2) + D, f[u + 4 >> 2] = p, u;
          }
          bs(), Ut();
        }
        function ku(u) {
          var l = 0;
          return l = f[u + 72 >> 2], f[u + 72 >> 2] = l - 1 | l, 8 & (l = f[u >> 2]) ? (f[u >> 2] = 32 | l, -1) : (f[u + 4 >> 2] = 0, f[u + 8 >> 2] = 0, l = f[u + 44 >> 2], f[u + 28 >> 2] = l, f[u + 20 >> 2] = l, f[u + 16 >> 2] = l + f[u + 48 >> 2], 0);
        }
        function Su(u, l, p, m) {
          l |= 0, p |= 0, m |= 0;
          var D = 0;
          D = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (D = f[D + f[l >> 2] >> 2]), xt[0 | D](l, p, m);
        }
        function y2(u, l, p) {
          l |= 0, p |= 0;
          var m = 0;
          return m = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (m = f[m + f[l >> 2] >> 2]), 0 | xt[0 | m](l, p);
        }
        function Ze(u) {
          var l = 0;
          u = u || 1;
          e: {
            for (; ; ) {
              if (l = To(u)) break e;
              if (!(l = f[2022])) break;
              xt[0 | l]();
            }
            Do(), Ut();
          }
          return l;
        }
        function Fo(u, l, p) {
          l |= 0, p |= 0;
          var m = 0;
          m = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (m = f[m + f[l >> 2] >> 2]), xt[0 | m](l, p);
        }
        function ja(u, l) {
          l |= 0;
          var p = 0;
          return p = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (p = f[p + f[l >> 2] >> 2]), 0 | xt[0 | p](l);
        }
        function tr(u, l) {
          return (2147483647 & (Ht(u), qe(2))) >>> 0 <= 2139095040 ? (2147483647 & (Ht(l), qe(2))) >>> 0 > 2139095040 ? u : E(Nl(u, l)) : l;
        }
        function Cu(u, l) {
          return (2147483647 & (Ht(u), qe(2))) >>> 0 <= 2139095040 ? (2147483647 & (Ht(l), qe(2))) >>> 0 > 2139095040 ? u : E(La(u, l)) : l;
        }
        function b2(u, l) {
          var p;
          return u |= 0, l |= 0, nt = p = nt - 16 | 0, f[p + 8 >> 2] = l, u = 0 | xt[0 | u](p + 8 | 0), us(f[p + 8 >> 2]), nt = p + 16 | 0, 0 | u;
        }
        function Tf(u, l) {
          return u ? ((-128 & l) == 57216 | l >>> 0 <= 127 ? (je[0 | u] = l, u = 1) : (f[1761] = 25, u = -1), u) : 0;
        }
        function w2(u, l) {
          var p, m;
          p = Ze(4), f[p >> 2] = l, m = Ze(4), f[m >> 2] = l, Ma(6955, 0 | u, 7018, 4630, 192, 0 | p, 7018, 4634, 193, 0 | m);
        }
        function wi(u, l) {
          var p, m;
          p = Ze(4), f[p >> 2] = l, m = Ze(4), f[m >> 2] = l, Ma(6985, 0 | u, 7018, 4630, 190, 0 | p, 7018, 4634, 191, 0 | m);
        }
        function kf(u) {
          var l, p;
          return nt = l = nt - 16 | 0, p = J0(Ze(588), u), u || (f[l >> 2] = 2759, vn(0, l), un(), Ut()), nt = l + 16 | 0, p;
        }
        function Zl(u, l) {
          var p = 0;
          1 & je[6964] ? p = f[1740] : (p = 0 | ff(1, 4400), je[6964] = 1, f[1740] = p), fs(0 | p, 0 | u, 0 | l, 0);
        }
        function Sf(u, l) {
          l |= 0;
          var p = 0;
          p = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (p = f[p + f[l >> 2] >> 2]), xt[0 | p](l);
        }
        function A2(u) {
          return f[(u |= 0) >> 2] = 4508, Ke[u + 4 | 0] && Zl(f[u + 8 >> 2], 1758), us(f[u + 8 >> 2]), 0 | u;
        }
        function Cf(u) {
          return f[(u |= 0) >> 2] = 4388, Ke[u + 4 | 0] && Zl(f[u + 8 >> 2], 1758), us(f[u + 8 >> 2]), 0 | u;
        }
        function Ff(u, l, p) {
          return Ln(u, l) ? ga(u, l, p) : ((p = vs(u, l, p)) == p && (p = E(-p)), p);
        }
        function Of(u) {
          var l = 0;
          (u |= 0) && ((l = f[u >> 2]) && l0(l), f[1732] = f[1732] - 1, l0(u));
        }
        function Fu(u, l, p) {
          l |= 0, p = +p, Fr[f[(u |= 0) >> 2] + l >> 3] = p;
        }
        function ql(u, l) {
          return l |= 0, +Fr[f[(u |= 0) >> 2] + l >> 3];
        }
        function Oo(u) {
          (u |= 0) && xt[f[f[u >> 2] + 4 >> 2]](u);
        }
        function x2(u) {
          return u ? (f[1761] = u, -1) : 0;
        }
        function Rf(u, l, p) {
          return E(er(u, l, p) + wr(u, l, p));
        }
        function If(u, l, p, m) {
          bu(0 | u, 0 | l, 8, 0, 0 | p, -1, 0 | m);
        }
        function E2(u, l) {
          l |= 0, xt[f[(u |= 0) >> 2]](l);
        }
        function Ou(u, l, p) {
          return yf(u, l, p, 2, 3);
        }
        function Pf(u) {
          return 0 | xt[0 | (u |= 0)]();
        }
        function w0(u, l) {
          l |= 0, xt[0 | (u |= 0)](l);
        }
        function un() {
          xt[f[1470]](), bs(), Ut();
        }
        function yn(u) {
          return u - 48 >>> 0 < 10;
        }
        function Gn(u) {
          (u |= 0) && l0(u);
        }
        function Q0(u) {
          return 0 | u;
        }
        function Ru(u) {
          je[4 + (u |= 0) | 0] = 1;
        }
        function Bf(u) {
          Ut();
        }
        function Iu() {
          bs(), Ut();
        }
        function bs() {
          Do(), Ut();
        }
        Ue(Q = Ke, 1024, "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"), Ue(Q, 4270, "wH8AAAAAAADAfwMAAABpaQB2AHZp"), Ue(Q, 4304, "KxsAACkbAABpGwAAYxsAAGkbAABjGwAAaWlpZmlmaQBcGwAALBsAAHZpaQAtGwAAcBsAAGlpaQ=="), Ue(Q, 4368, "wwAAAMQAAADF"), Ue(Q, 4388, "wwAAAMYAAADHAAAAXBs="), Ue(Q, 4416, "KxsAAGkbAABjGwAAaRsAAGMbAABwGwAAaxsAAHAbAABpaWlpAAAAAFwbAABBGwAAXBsAAEMbAABEGwAAcBs="), Ue(Q, 4488, "yAAAAMkAAADK"), Ue(Q, 4508, "yAAAAMsAAADHAAAARxsAAFwbAABHGw=="), Ue(Q, 4544, "XBsAAEcbAABjGwAAXRsAAHZpaWlpAAAAXBsAAEcbAABpGwAAdmlpZgAAAABcGwAARxsAAF0bAAB2aWlpAAAAAF0bAABIGwAAYxsAAF0bAABHGwAAaQBkaWkAdmlpZAAATBsAAEwbAABHGwAAXBsAAEwbAABcGwAATBsAAEsbAABcGwAATBsAAGMbAAAAAAAAXBsAAEwbAABjGwAAahsAAHZpaWlkAAAAXBsAAEwbAABqGwAAYxsAAE0bAABKGwAATRsAAGMbAABKGwAATRsAAGobAABNGwAAahsAAE0bAABjGwAAZGlpaQAAAABpGwAATBsAAGMbAABmaWlpAAAAAFwbAABMGwAATBsAAGQbAABcGwAATBsAAEwbAABkGwAATRsAAEwbAABMGwAATBsAAEwbAABkGwAAXRsAAEwbAABcGwAATBsAAF0bAABcGwAATBsAACkbAABcGwAATBsAAEEbAABdGwAATRsAAAAAAABcGwAATBsAAGobAABqGwAAYxsAAHZpaWRkaQAASRsAAE0b"), Ue(Q, 4960, "GQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), Ue(Q, 5041, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), Ue(Q, 5099, "DA=="), Ue(Q, 5111, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), Ue(Q, 5157, "EA=="), Ue(Q, 5169, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), Ue(Q, 5215, "Eg=="), Ue(Q, 5227, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), Ue(Q, 5282, "GgAAABoaGgAAAAAAAAk="), Ue(Q, 5331, "FA=="), Ue(Q, 5343, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), Ue(Q, 5389, "Fg=="), Ue(Q, 5401, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"), Ue(Q, 5476, "0Q=="), Ue(Q, 5516, "//////////8="), Ue(Q, 5584, "oB8BAAAAAAAF"), Ue(Q, 5604, "zA=="), Ue(Q, 5628, "zQAAAM4AAACEGw=="), Ue(Q, 5652, "Ag=="), Ue(Q, 5668, "//////////8="), Ue(Q, 5736, "BQ=="), Ue(Q, 5748, "zw=="), Ue(Q, 5772, "zQAAANAAAACYGwAAAAQ="), Ue(Q, 5796, "AQ=="), Ue(Q, 5812, "/////wo="), Ue(Q, 5880, "0g==");
        var xt = function(u) {
          return u.set = function(l, p) {
            this[l] = p;
          }, u.get = function(l) {
            return this[l];
          }, u;
        }([null, function(u, l, p, m, D) {
          return m |= 0, D |= 0, (p |= 0) && (0 | p) != 5 ? 0 | Ou(5736, m, D) : 0 | Ou(5592, m, D);
        }, function(u, l, p, m, D, F) {
          u |= 0, l = +l, p |= 0, m |= 0, D |= 0, F |= 0;
          var U, $ = 0, X = 0, Pe = 0, ce = 0, Ce = 0, ge = 0, Ne = 0, ue = 0, le = 0, Ae = 0, Le = 0, $e = 0, He = 0, Je = 0, st = 0, dt = 0, vt = 0, At = 0;
          nt = U = nt - 560 | 0, f[U + 44 >> 2] = 0, fr(+l), $ = 0 | qe(1), qe(0), (0 | $) < 0 ? ($e = 1, vt = 1176, fr(+(l = -l)), $ = 0 | qe(1), qe(0)) : 2048 & D ? ($e = 1, vt = 1179) : (vt = ($e = 1 & D) ? 1182 : 1177, At = !$e);
          e: if ((2146435072 & $) != 2146435072) {
            Je = U + 16 | 0;
            n: {
              t: {
                r: {
                  if (l = _f(l, U + 44 | 0), (l += l) != 0) {
                    if ($ = f[U + 44 >> 2], f[U + 44 >> 2] = $ - 1, (0 | (st = 32 | F)) != 97) break r;
                    break n;
                  }
                  if ((0 | (st = 32 | F)) == 97) break n;
                  Ce = f[U + 44 >> 2], ge = (0 | m) < 0 ? 6 : m;
                  break t;
                }
                Ce = $ - 29 | 0, f[U + 44 >> 2] = Ce, l *= 268435456, ge = (0 | m) < 0 ? 6 : m;
              }
              for (X = Ae = (U + 48 | 0) + ((0 | Ce) >= 0 ? 288 : 0) | 0; m = l < 4294967296 & l >= 0 ? ~~l >>> 0 : 0, f[X >> 2] = m, X = X + 4 | 0, (l = 1e9 * (l - +(m >>> 0))) != 0; ) ;
              if ((0 | Ce) <= 0) m = Ce, $ = X, Pe = Ae;
              else for (Pe = Ae, m = Ce; ; ) {
                if (ue = (0 | m) >= 29 ? 29 : m, !(Pe >>> 0 > ($ = X - 4 | 0) >>> 0)) {
                  for (m = 0; ce = f[$ >> 2], dt = m, m = 31 & ue, (63 & ue) >>> 0 >= 32 ? (Ne = ce << m, m = 0) : (Ne = (1 << m) - 1 & ce >>> 32 - m, m = ce << m), ce = Ne + le | 0, ce = Yl(m = ps(dt = dt + m | 0, m >>> 0 > dt >>> 0 ? ce + 1 | 0 : ce, 1e9), sr, -1e9, 0) + dt | 0, f[$ >> 2] = ce, Pe >>> 0 <= ($ = $ - 4 | 0) >>> 0; ) ;
                  m && (f[(Pe = Pe - 4 | 0) >> 2] = m);
                }
                for (; Pe >>> 0 < ($ = X) >>> 0 && !f[(X = $ - 4 | 0) >> 2]; ) ;
                if (m = f[U + 44 >> 2] - ue | 0, f[U + 44 >> 2] = m, X = $, !((0 | m) > 0)) break;
              }
              if ((0 | m) < 0) for (He = 1 + ((ge + 25 >>> 0) / 9 | 0) | 0, le = (0 | st) == 102; ; ) {
                if (Ne = (0 | (m = 0 - m | 0)) >= 9 ? 9 : m, $ >>> 0 <= Pe >>> 0) X = f[Pe >> 2];
                else {
                  for (ue = 1e9 >>> Ne | 0, ce = -1 << Ne ^ -1, m = 0, X = Pe; dt = m, m = f[X >> 2], f[X >> 2] = dt + (m >>> Ne | 0), m = pr(ue, m & ce), (X = X + 4 | 0) >>> 0 < $ >>> 0; ) ;
                  X = f[Pe >> 2], m && (f[$ >> 2] = m, $ = $ + 4 | 0);
                }
                if (m = Ne + f[U + 44 >> 2] | 0, f[U + 44 >> 2] = m, Pe = (!X << 2) + Pe | 0, $ = $ - (X = le ? Ae : Pe) >> 2 > (0 | He) ? X + (He << 2) | 0 : $, !((0 | m) < 0)) break;
              }
              if (m = 0, !($ >>> 0 <= Pe >>> 0 || (m = pr(Ae - Pe >> 2, 9), X = 10, (ce = f[Pe >> 2]) >>> 0 < 10))) for (; m = m + 1 | 0, ce >>> 0 >= (X = pr(X, 10)) >>> 0; ) ;
              if ((0 | (X = (ge - ((0 | st) != 102 ? m : 0) | 0) - ((0 | st) == 103 & (0 | ge) != 0) | 0)) < (pr($ - Ae >> 2, 9) - 9 | 0)) {
                if (Ce = ((((0 | Ce) < 0 ? 4 : 292) + U | 0) + ((ce = (0 | (ue = X + 9216 | 0)) / 9 | 0) << 2) | 0) - 4048 | 0, X = 10, (0 | (Ne = ue + pr(ce, -9) | 0)) <= 7) for (; X = pr(X, 10), (0 | (Ne = Ne + 1 | 0)) != 8; ) ;
                if (!((0 | (ue = f[Ce >> 2])) == (0 | (le = pr(He = (ue >>> 0) / (X >>> 0) | 0, X))) & (0 | (ce = Ce + 4 | 0)) == (0 | $)) && (ue = ue - le | 0, !(1 & He) && (l = 9007199254740992, !(1 & je[Ce - 4 | 0]) | (0 | X) != 1e9 | Pe >>> 0 >= Ce >>> 0) || (l = 9007199254740994), Le = (0 | $) == (0 | ce) ? 1 : 1.5, Le = (ce = X >>> 1 | 0) >>> 0 > ue >>> 0 ? 0.5 : (0 | ce) == (0 | ue) ? Le : 1.5, Ke[0 | vt] != 45 | At || (Le = -Le, l = -l), f[Ce >> 2] = le, l + Le != l)) {
                  if (m = X + le | 0, f[Ce >> 2] = m, m >>> 0 >= 1e9) for (; f[Ce >> 2] = 0, (Ce = Ce - 4 | 0) >>> 0 < Pe >>> 0 && (f[(Pe = Pe - 4 | 0) >> 2] = 0), m = f[Ce >> 2] + 1 | 0, f[Ce >> 2] = m, m >>> 0 > 999999999; ) ;
                  if (m = pr(Ae - Pe >> 2, 9), X = 10, !((ce = f[Pe >> 2]) >>> 0 < 10)) for (; m = m + 1 | 0, ce >>> 0 >= (X = pr(X, 10)) >>> 0; ) ;
                }
                $ = $ >>> 0 > (X = Ce + 4 | 0) >>> 0 ? X : $;
              }
              for (; ce = $, !(ue = $ >>> 0 <= Pe >>> 0) && !f[($ = ce - 4 | 0) >> 2]; ) ;
              if ((0 | st) == 103) {
                if (ge = (($ = (0 | (X = ge || 1)) > (0 | m) & (0 | m) > -5) ? -1 ^ m : -1) + X | 0, F = ($ ? -1 : -2) + F | 0, !(Ce = 8 & D)) {
                  if ($ = -9, !ue && (Ce = f[ce - 4 >> 2]) && (Ne = 10, $ = 0, !((Ce >>> 0) % 10 | 0))) {
                    for (; X = $, $ = $ + 1 | 0, !((Ce >>> 0) % ((Ne = pr(Ne, 10)) >>> 0) | 0); ) ;
                    $ = -1 ^ X;
                  }
                  X = pr(ce - Ae >> 2, 9), (-33 & F) != 70 ? (Ce = 0, ge = (0 | ($ = (0 | ($ = ((m + X | 0) + $ | 0) - 9 | 0)) > 0 ? $ : 0)) > (0 | ge) ? ge : $) : (Ce = 0, ge = (0 | ($ = (0 | ($ = ($ + X | 0) - 9 | 0)) > 0 ? $ : 0)) > (0 | ge) ? ge : $);
                }
              } else Ce = 8 & D;
              if (Ne = -1, (0 | ((ue = Ce | ge) ? 2147483645 : 2147483646)) < (0 | ge)) break e;
              if (le = 1 + (((0 | ue) != 0) + ge | 0) | 0, (0 | (X = -33 & F)) != 70) {
                if ((Je - ($ = gn((($ = m >> 31) ^ m) - $ | 0, 0, Je)) | 0) <= 1) for (; je[0 | ($ = $ - 1 | 0)] = 48, (Je - $ | 0) < 2; ) ;
                if (je[0 | (He = $ - 2 | 0)] = F, je[$ - 1 | 0] = (0 | m) < 0 ? 45 : 43, (0 | ($ = Je - He | 0)) > (2147483647 ^ le)) break e;
              } else {
                if ((2147483647 ^ le) < (0 | m)) break e;
                $ = (0 | m) > 0 ? m : 0;
              }
              if ((0 | (m = $ + le | 0)) > (2147483647 ^ $e)) break e;
              M0(u, 32, p, le = m + $e | 0, D), S0(u, vt, $e), M0(u, 48, p, le, 65536 ^ D);
              t: {
                r: {
                  i: {
                    if ((0 | X) == 70) {
                      for (m = 8 | (F = U + 16 | 0), Ce = 9 | F, Pe = X = Pe >>> 0 > Ae >>> 0 ? Ae : Pe; ; ) {
                        $ = gn(f[Pe >> 2], 0, Ce);
                        a: if ((0 | X) == (0 | Pe)) (0 | $) == (0 | Ce) && (je[U + 24 | 0] = 48, $ = m);
                        else {
                          if (U + 16 >>> 0 >= $ >>> 0) break a;
                          for (; je[0 | ($ = $ - 1 | 0)] = 48, U + 16 >>> 0 < $ >>> 0; ) ;
                        }
                        if (S0(u, $, Ce - $ | 0), !(Ae >>> 0 >= (Pe = Pe + 4 | 0) >>> 0)) break;
                      }
                      if (ue && S0(u, 4206, 1), (0 | ge) <= 0 | Pe >>> 0 >= ce >>> 0) break i;
                      for (; ; ) {
                        if (($ = gn(f[Pe >> 2], 0, Ce)) >>> 0 > U + 16 >>> 0) for (; je[0 | ($ = $ - 1 | 0)] = 48, U + 16 >>> 0 < $ >>> 0; ) ;
                        if (S0(u, $, (0 | ge) >= 9 ? 9 : ge), $ = ge - 9 | 0, ce >>> 0 <= (Pe = Pe + 4 | 0) >>> 0) break r;
                        if (m = (0 | ge) > 9, ge = $, !m) break;
                      }
                      break r;
                    }
                    a: if (!((0 | ge) < 0)) for (Ae = Pe >>> 0 < ce >>> 0 ? ce : Pe + 4 | 0, m = 8 | (F = U + 16 | 0), ce = 9 | F, X = Pe; ; ) {
                      (0 | ce) == (0 | ($ = gn(f[X >> 2], 0, ce))) && (je[U + 24 | 0] = 48, $ = m);
                      o: if ((0 | X) == (0 | Pe)) S0(u, $, 1), $ = $ + 1 | 0, Ce | ge && S0(u, 4206, 1);
                      else {
                        if (U + 16 >>> 0 >= $ >>> 0) break o;
                        for (; je[0 | ($ = $ - 1 | 0)] = 48, U + 16 >>> 0 < $ >>> 0; ) ;
                      }
                      if (S0(u, $, (0 | (F = ce - $ | 0)) > (0 | ge) ? ge : F), ge = ge - F | 0, Ae >>> 0 <= (X = X + 4 | 0) >>> 0) break a;
                      if (!((0 | ge) >= 0)) break;
                    }
                    M0(u, 48, ge + 18 | 0, 18, 0), S0(u, He, Je - He | 0);
                    break t;
                  }
                  $ = ge;
                }
                M0(u, 48, $ + 9 | 0, 9, 0);
              }
              M0(u, 32, p, le, 8192 ^ D), Ne = (0 | p) < (0 | le) ? le : p;
              break e;
            }
            if (Ce = (F << 26 >> 31 & 9) + vt | 0, !(m >>> 0 > 11)) {
              for ($ = 12 - m | 0, Le = 16; Le *= 16, $ = $ - 1 | 0; ) ;
              l = Ke[0 | Ce] != 45 ? l + Le - Le : -(Le + (-l - Le));
            }
            for (Ae = 2 | $e, Pe = 32 & F, (0 | Je) == (0 | ($ = gn((($ = (X = f[U + 44 >> 2]) >> 31) ^ X) - $ | 0, 0, Je))) && (je[U + 15 | 0] = 48, $ = U + 15 | 0), je[0 | (ge = $ - 2 | 0)] = F + 15, je[$ - 1 | 0] = (0 | X) < 0 ? 45 : 43, $ = 8 & D, X = U + 16 | 0; F = X, ce = jr(l) < 2147483648 ? ~~l : -2147483648, je[0 | X] = Pe | Ke[ce + 5424 | 0], !($ | (0 | m) > 0) & (l = 16 * (l - +(0 | ce))) == 0 | ((X = F + 1 | 0) - (U + 16 | 0) | 0) != 1 || (je[F + 1 | 0] = 46, X = F + 2 | 0), l != 0; ) ;
            Ne = -1, (2147483645 - (F = ($ = Je - ge | 0) + Ae | 0) | 0) < (0 | m) || (M0(u, 32, p, F = (m = !m || ((Pe = X - (U + 16 | 0) | 0) - 2 | 0) >= (0 | m) ? Pe = X - (U + 16 | 0) | 0 : m + 2 | 0) + F | 0, D), S0(u, Ce, Ae), M0(u, 48, p, F, 65536 ^ D), S0(u, U + 16 | 0, Pe), M0(u, 48, m - Pe | 0, 0, 0), S0(u, ge, $), M0(u, 32, p, F, 8192 ^ D), Ne = (0 | p) < (0 | F) ? F : p);
          } else M0(u, 32, p, $ = $e + 3 | 0, -65537 & D), S0(u, vt, $e), m = 32 & F, S0(u, l != l ? m ? 2450 : 3390 : m ? 2819 : 3394, 3), M0(u, 32, p, $, 8192 ^ D), Ne = (0 | p) < (0 | $) ? $ : p;
          return nt = U + 560 | 0, 0 | Ne;
        }, function(u, l) {
          u |= 0;
          var p, m, D, F, U, $ = 0, X = 0, Pe = 0, ce = 0, Ce = 0, ge = 0, Ne = 0, ue = 0, le = 0, Ae = 0, Le = 0;
          $ = l |= 0, l = f[l >> 2] + 7 & -8, f[$ >> 2] = l + 16, D = u, ge = f[l >> 2], X = f[l + 4 >> 2], m = u = f[l + 12 >> 2], nt = p = nt - 32 | 0, Ce = u &= 2147483647;
          e: if ((0 | (Pe = u - 1006698496 | 0)) == (0 | (u = u - 1140785152 | 0)) & (l = $ = f[l + 8 >> 2]) >>> 0 < l >>> 0 | u >>> 0 > Pe >>> 0) {
            if (l = (u = $) << 4 | X >>> 28, u = $ = m << 4 | u >>> 28, (0 | (X &= 268435455)) == 134217728 & (0 | ge) != 0 | X >>> 0 > 134217728) {
              u = u + 1073741824 | 0, u = (l = l + 1 | 0) ? u : u + 1 | 0;
              break e;
            }
            if (u = u + 1073741824 | 0, ge | (0 | X) != 134217728) break e;
            u = (l = (X = 1 & l) + l | 0) >>> 0 < X >>> 0 ? u + 1 | 0 : u;
          } else (!l & (0 | Ce) == 2147418112 ? !(X | ge) : Ce >>> 0 < 2147418112) ? (l = 0, u = 2146435072, Ce >>> 0 > 1140785151 || (u = 0, (Ae = Ce >>> 16 | 0) >>> 0 < 15249 || (l = ge, u = X, Ce = Pe = 65535 & m | 65536, le = $, ce = $, 64 & (Ne = Ae - 15233 | 0) ? ($ = l, l = 31 & (Pe = Ne + -64 | 0), (63 & Pe) >>> 0 >= 32 ? (u = $ << l, ce = 0) : (u = (1 << l) - 1 & $ >>> 32 - l | u << l, ce = $ << l), Pe = u, l = 0, u = 0) : Ne && (ue = ce, ce = 31 & Ne, (63 & Ne) >>> 0 >= 32 ? ($ = ue << ce, ce = 0) : ($ = (1 << ce) - 1 & ue >>> 32 - ce | Pe << ce, ce = ue << ce), Pe = $, Le = ce, ue = l, ce = 31 & ($ = 64 - Ne | 0), (63 & $) >>> 0 >= 32 ? ($ = 0, l = u >>> ce | 0) : ($ = u >>> ce | 0, l = ((1 << ce) - 1 & u) << 32 - ce | ue >>> ce), ce = Le | l, Pe |= $, l = 31 & Ne, (63 & Ne) >>> 0 >= 32 ? ($ = ue << l, l = 0) : ($ = (1 << l) - 1 & ue >>> 32 - l | u << l, l = ue << l), u = $), f[p + 16 >> 2] = l, f[p + 20 >> 2] = u, f[p + 24 >> 2] = ce, f[p + 28 >> 2] = Pe, 64 & (l = 15361 - Ae | 0) ? (X = le, u = 31 & (l = l + -64 | 0), (63 & l) >>> 0 >= 32 ? ($ = 0, ge = Ce >>> u | 0) : ($ = Ce >>> u | 0, ge = ((1 << u) - 1 & Ce) << 32 - u | X >>> u), X = $, le = 0, Ce = 0) : l && (Pe = le, $ = 31 & (u = 64 - l | 0), (63 & u) >>> 0 >= 32 ? (u = Pe << $, ce = 0) : (u = (1 << $) - 1 & Pe >>> 32 - $ | Ce << $, ce = Pe << $), Pe = ge, ge = 31 & l, (63 & l) >>> 0 >= 32 ? ($ = 0, Pe = X >>> ge | 0) : ($ = X >>> ge | 0, Pe = ((1 << ge) - 1 & X) << 32 - ge | Pe >>> ge), ge = ce | Pe, X = u | $, Pe = le, $ = 31 & l, (63 & l) >>> 0 >= 32 ? (u = 0, le = Ce >>> $ | 0) : (u = Ce >>> $ | 0, le = ((1 << $) - 1 & Ce) << 32 - $ | Pe >>> $), Ce = u), f[p >> 2] = ge, f[p + 4 >> 2] = X, f[p + 8 >> 2] = le, f[p + 12 >> 2] = Ce, l = f[p + 8 >> 2], u = f[p + 12 >> 2] << 4 | l >>> 28, l <<= 4, $ = f[p >> 2], l |= (Ce = f[p + 4 >> 2]) >>> 28, (0 | (X = 268435455 & Ce)) == 134217728 & (0 | ($ |= (f[p + 16 >> 2] | f[p + 24 >> 2] | f[p + 20 >> 2] | f[p + 28 >> 2]) != 0)) != 0 | X >>> 0 > 134217728 ? u = (l = l + 1 | 0) ? u : u + 1 | 0 : $ | (0 | X) != 134217728 || (u = ($ = l) >>> 0 > (l = l + (1 & l) | 0) >>> 0 ? u + 1 | 0 : u)))) : (l = (u = $) << 4 | X >>> 28, u = 524287 & ($ = m << 4 | u >>> 28) | 2146959360);
          nt = p + 32 | 0, ze(0, 0 | l), ze(1, -2147483648 & m | u), F = D, U = +Pt(), Fr[F >> 3] = U;
        }, Q0, function(u, l) {
          l |= 0, f[4 + (u |= 0) >> 2] = 7, f[u >> 2] = l;
        }, function(u, l) {
          l |= 0, f[4 + (u |= 0) >> 2] = 10, f[u >> 2] = l;
        }, function(u, l) {
          l |= 0, f[4 + (u |= 0) >> 2] = 13, f[u >> 2] = l;
        }, Q0, Q0, Q0, Q0, Q0, Q0, function(u, l, p, m, D, F) {
          var U;
          u |= 0, l |= 0, p = E(p), m |= 0, D = E(D), F |= 0, nt = U = nt - 16 | 0, l = f[f[l >> 2] + 4 >> 2], xt[f[f[l >> 2] + 8 >> 2]](U, l, p, m, D, F), Y[u >> 2] = Fr[U >> 3], Y[u + 4 >> 2] = Fr[U + 8 >> 3], nt = U + 16 | 0;
        }, function(u) {
          u = f[f[(u |= 0) >> 2] + 8 >> 2], xt[f[f[u >> 2] + 8 >> 2]](u);
        }, gf, function(u) {
          return 6952;
        }, Oo, function(u, l, p, m, D, F) {
          u |= 0, l |= 0, p = E(p), m |= 0, D = E(D), F |= 0;
          var U, $ = 0;
          return nt = U = nt - 16 | 0, $ = f[u >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && ($ = f[$ + f[l >> 2] >> 2]), xt[0 | $](U, l, p, m, D, F), u = Ze(16), l = f[U + 12 >> 2], f[u + 8 >> 2] = f[U + 8 >> 2], f[u + 12 >> 2] = l, l = f[U + 4 >> 2], f[u >> 2] = f[U >> 2], f[u + 4 >> 2] = l, nt = U + 16 | 0, 0 | u;
        }, function(u) {
          return 6956;
        }, Q0, Q0, Oo, Ru, E2, b2, function(u) {
          var l;
          return u |= 0, l = Ze(12), je[l + 4 | 0] = 0, f[l + 8 >> 2] = f[u >> 2], f[u >> 2] = 0, f[l >> 2] = 4368, 0 | l;
        }, function(u, l, p) {
          u |= 0, p |= 0;
          var m, D, F = 0, U = 0;
          if (nt = m = nt - 32 | 0, (D = f[(l |= 0) >> 2]) >>> 0 < 2147483632) {
            e: {
              if (D >>> 0 >= 11) U = Ze(F = 1 + (15 | D) | 0), f[m + 16 >> 2] = -2147483648 | F, f[m + 8 >> 2] = U, f[m + 12 >> 2] = D, F = D + U | 0;
              else if (je[m + 19 | 0] = D, F = (U = m + 8 | 0) + D | 0, !D) break e;
              D0(U, l + 4 | 0, D);
            }
            return je[0 | F] = 0, f[m >> 2] = p, xt[0 | u](m + 24 | 0, m + 8 | 0, m), yu(f[m + 24 >> 2]), u = f[m + 24 >> 2], us(0 | u), us(f[m >> 2]), je[m + 19 | 0] < 0 && l0(f[m + 8 >> 2]), nt = m + 32 | 0, 0 | u;
          }
          Do(), Ut();
        }, function(u, l, p) {
          var m, D;
          p |= 0, m = u |= 0, D = 0 | mu(0 | (je[11 + (l |= 0) | 0] < 0 ? f[l >> 2] : l), 6956, f[p >> 2]), f[m >> 2] = D;
        }, function(u) {
          return 6976;
        }, Oo, Sf, function(u) {
          return 6979;
        }, Q0, Q0, Oo, Ru, E2, b2, function(u) {
          var l;
          return u |= 0, l = Ze(12), je[l + 4 | 0] = 0, f[l + 8 >> 2] = f[u >> 2], f[u >> 2] = 0, f[l >> 2] = 4488, 0 | l;
        }, function(u, l, p) {
          var m, D;
          p |= 0, m = u |= 0, D = 0 | mu(0 | (je[11 + (l |= 0) | 0] < 0 ? f[l >> 2] : l), 6979, f[p >> 2]), f[m >> 2] = D;
        }, function(u) {
          return 6982;
        }, Of, Pf, function() {
          var u, l;
          return l = Ze(4), u = Ze(28), Cr[u + 20 >> 1] = 0, f[u + 16 >> 2] = 1065353216, Cr[u + 10 >> 1] = 0, Cr[u + 12 >> 1] = 0, f[u >> 2] = 0, f[u + 24 >> 2] = 0, je[u + 9 | 0] = 0, f[u + 4 >> 2] = 1, je[u + 22 | 0] = 0, f[1732] = f[1732] + 1, f[l >> 2] = u, 0 | l;
        }, w0, Of, function(u, l, p) {
          l |= 0, p |= 0, je[20 + (f[(u |= 0) >> 2] + l | 0) | 0] = p;
        }, Su, function(u, l) {
          u |= 0, l = E(l);
          var p, m = 0, D = 0;
          nt = p = nt - 16 | 0, u = f[u >> 2], l >= E(0) || (f[p >> 2] = 2262, nt = m = nt - 16 | 0, f[m + 12 >> 2] = p, u || (Ke[6936] ? u = f[1733] : (u = Ze(28), Cr[u + 20 >> 1] = 0, f[u + 16 >> 2] = 1065353216, Cr[u + 10 >> 1] = 0, Cr[u + 12 >> 1] = 0, f[u >> 2] = 0, f[u + 24 >> 2] = 0, je[u + 9 | 0] = 0, f[u + 4 >> 2] = 1, je[u + 22 | 0] = 0, f[1733] = u, je[6936] = 1, f[1732] = f[1732] + 1)), D = f[u + 4 >> 2], Ke[u + 9 | 0] ? xt[0 | D](u, 0, 5, 0, 4215, p) : xt[0 | D](u, 0, 5, 4215, p), nt = m + 16 | 0, un(), Ut()), Y[u + 16 >> 2] = l == E(0) ? E(0) : l, nt = p + 16 | 0;
        }, function(u, l, p) {
          u |= 0, l |= 0, p = E(p);
          var m = 0;
          m = f[u >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (m = f[m + f[l >> 2] >> 2]), xt[0 | m](l, p);
        }, function(u, l) {
          l |= 0, je[f[(u |= 0) >> 2] + 11 | 0] = l;
        }, Fo, function(u, l) {
          l |= 0, je[f[(u |= 0) >> 2] + 10 | 0] = l;
        }, function(u, l) {
          return l |= 0, Ke[20 + (f[(u |= 0) >> 2] + l | 0) | 0];
        }, y2, function(u) {
          return Ke[f[(u |= 0) >> 2] + 11 | 0];
        }, ja, function(u) {
          return Ke[f[(u |= 0) >> 2] + 10 | 0];
        }, function() {
          return 0 | k0(Ze(48), 0, 48);
        }, Gn, function() {
          var u;
          return u = Ze(16), f[u >> 2] = 0, f[u + 4 >> 2] = 0, f[u + 8 >> 2] = 0, f[u + 12 >> 2] = 0, 0 | u;
        }, Gn, function() {
          var u;
          return u = Ze(16), f[u + 8 >> 2] = 0, f[u + 12 >> 2] = 0, f[u >> 2] = 0, 0 | u;
        }, Gn, ql, Fu, function(u, l) {
          return l |= 0, f[f[(u |= 0) >> 2] + l >> 2];
        }, function(u, l, p) {
          l |= 0, p |= 0, f[f[(u |= 0) >> 2] + l >> 2] = p;
        }, function(u) {
          return 6987;
        }, wf, Pf, function() {
          return 0 | m2(Ze(12), 0);
        }, function(u, l) {
          return l |= 0, 0 | xt[0 | (u |= 0)](l);
        }, function(u) {
          return u |= 0, 0 | m2(Ze(12), u);
        }, w0, wf, function(u) {
          var l, p = 0, m = 0, D = 0;
          nt = l = nt - 624 | 0, p = f[4 + (u |= 0) >> 2], f[u + 4 >> 2] = 0, p && xt[f[f[p >> 2] + 4 >> 2]](p), p = f[u + 8 >> 2], f[u + 8 >> 2] = 0, p && xt[f[f[p >> 2] + 4 >> 2]](p);
          e: {
            if (u = f[u >> 2], f[u + 560 >> 2] == f[u + 556 >> 2]) {
              if (f[u + 552 >> 2]) break e;
              return Af(u + 556 | 0), D = je[u + 4 | 0], p = J0(l + 32 | 0, f[u + 568 >> 2]), m = f[p + 4 >> 2], f[u >> 2] = f[p >> 2], f[u + 4 >> 2] = m, m = f[p + 20 >> 2], f[u + 16 >> 2] = f[p + 16 >> 2], f[u + 20 >> 2] = m, m = f[p + 12 >> 2], f[u + 8 >> 2] = f[p + 8 >> 2], f[u + 12 >> 2] = m, D0(u + 24 | 0, p + 24 | 0, 204), D0(u + 228 | 0, p + 228 | 0, 328), (m = f[u + 556 >> 2]) && (f[u + 560 >> 2] = m, l0(m)), f[u + 556 >> 2] = f[p + 556 >> 2], f[u + 560 >> 2] = f[p + 560 >> 2], f[u + 564 >> 2] = f[p + 564 >> 2], f[u + 584 >> 2] = f[p + 584 >> 2], m = f[p + 580 >> 2], f[u + 576 >> 2] = f[p + 576 >> 2], f[u + 580 >> 2] = m, m = f[p + 572 >> 2], f[u + 568 >> 2] = f[p + 568 >> 2], f[u + 572 >> 2] = m, (0 | D) < 0 && (je[u + 4 | 0] = 128 | Ke[u + 4 | 0], f[u + 24 >> 2] = -909 & f[u + 24 >> 2] | 520), void (nt = l + 624 | 0);
            }
            f[l + 16 >> 2] = 3252, vn(u, l + 16 | 0), un(), Ut();
          }
          f[l >> 2] = 2046, vn(u, l), un(), Ut();
        }, Sf, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = E(0), D = 0, F = 0, U = E(0), $ = 0, X = 0, Pe = 0, ce = E(0);
          e: {
            X = f[l >> 2], l = f[u >> 2];
            n: if (!(8388607 & (f[X + 24 >> 2] ^ f[l + 24 >> 2]))) {
              ce = Y[X + 40 >> 2], D = f[X + 40 >> 2], m = Y[l + 40 >> 2];
              t: {
                r: {
                  if ((0 | (p = f[l + 40 >> 2])) != 2139156720) {
                    if (U = E(NaN), u = 3, (0 | p) == 2141891242) break t;
                    if ((0 | p) != 2140081935) break r;
                    U = E(0), u = 1;
                    break t;
                  }
                  u = 2;
                  break t;
                }
                u = 0, m == m && (ze(2, 536870912 + (-1073741825 & p) | 0), U = Tt(), u = 1073741824 & p ? 2 : 1);
              }
              t: {
                r: {
                  if ((0 | D) != 2139156720) {
                    if (m = E(NaN), p = 3, (0 | D) == 2141891242) break t;
                    if ((0 | D) != 2140081935) break r;
                    m = E(0), p = 1;
                    break t;
                  }
                  m = E(0), p = 2;
                  break t;
                }
                p = 0, ce == ce && (ze(2, 536870912 + (-1073741825 & D) | 0), m = Tt(), p = 1073741824 & D ? 2 : 1);
              }
              if (!((0 | p) != (0 | u) | !(!u | U != U & m != m | E(jr(E(U - m))) < E(9999999747378752e-20))) && (F = X + 44 | 0, f[(p = l + 44 | 0) >> 2] == f[F >> 2])) {
                u = 0;
                t: {
                  for (; ; ) {
                    if (D = u, (0 | (u = u + 1 | 0)) == 9) break t;
                    if (f[($ = u << 2) + p >> 2] != f[F + $ >> 2]) break;
                  }
                  if (D >>> 0 < 8) break n;
                }
                if (F = X + 80 | 0, f[(p = l + 80 | 0) >> 2] == f[F >> 2]) {
                  u = 0;
                  t: {
                    for (; ; ) {
                      if (D = u, (0 | (u = u + 1 | 0)) == 9) break t;
                      if (f[($ = u << 2) + p >> 2] != f[F + $ >> 2]) break;
                    }
                    if (D >>> 0 < 8) break n;
                  }
                  if (F = X + 116 | 0, f[(p = l + 116 | 0) >> 2] == f[F >> 2]) {
                    u = 0;
                    t: {
                      for (; ; ) {
                        if (D = u, (0 | (u = u + 1 | 0)) == 9) break t;
                        if (f[($ = u << 2) + p >> 2] != f[F + $ >> 2]) break;
                      }
                      if (D >>> 0 < 8) break n;
                    }
                    if (F = X + 152 | 0, f[(p = l + 152 | 0) >> 2] == f[F >> 2]) {
                      u = 0;
                      t: {
                        for (; ; ) {
                          if (D = u, (0 | (u = u + 1 | 0)) == 9) break t;
                          if (f[($ = u << 2) + p >> 2] != f[F + $ >> 2]) break;
                        }
                        if (D >>> 0 < 8) break n;
                      }
                      if (F = X + 188 | 0, f[(p = l + 188 | 0) >> 2] == f[F >> 2]) {
                        u = 0;
                        t: {
                          for (; ; ) {
                            if (D = u, (0 | (u = u + 1 | 0)) == 3) break t;
                            if (f[($ = u << 2) + p >> 2] != f[F + $ >> 2]) break;
                          }
                          if (D >>> 0 < 2) break n;
                        }
                        for ($ = X + 200 | 0, Pe = l + 200 | 0, u = 0, D = 1; p = f[(u <<= 2) + $ >> 2], F = f[u + Pe >> 2], D && (D = 0, u = 1, (0 | p) == (0 | F)); ) ;
                        if ((0 | p) == (0 | F)) {
                          for ($ = X + 208 | 0, Pe = l + 208 | 0, u = 0, D = 1; p = f[(u <<= 2) + $ >> 2], F = f[u + Pe >> 2], D && (D = 0, u = 1, (0 | p) == (0 | F)); ) ;
                          if ((0 | p) == (0 | F)) {
                            for ($ = X + 216 | 0, Pe = l + 216 | 0, u = 0, D = 1; p = f[(u <<= 2) + $ >> 2], F = f[u + Pe >> 2], D && (D = 0, u = 1, (0 | p) == (0 | F)); ) ;
                            if ((0 | p) == (0 | F) && !((0 | (u = (U = Y[X + 28 >> 2]) != U)) == ((m = Y[l + 28 >> 2]) == m | 0) | !(u | m != m) & m != U || ((m = Y[l + 32 >> 2]) == m | 0) == ((U = Y[X + 32 >> 2]) != U | 0) | m == m & m != U || (0 | (u = (U = Y[X + 36 >> 2]) != U)) == ((m = Y[l + 36 >> 2]) == m | 0) | !u & m != U) && (u = 0, (m = Y[l + 224 >> 2]) != m && (u = 1, (U = Y[X + 224 >> 2]) != U) || (U = m) == (m = Y[X + 224 >> 2]) | m != m & u))
                              break e;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            for (D0(l + 24 | 0, X + 24 | 0, 204); ; ) {
              if (4 & (u = Ke[l + 4 | 0])) break e;
              if (je[l + 4 | 0] = 4 | u, (u = f[l + 20 >> 2]) && xt[0 | u](l), f[l + 308 >> 2] = 2143289344, !(l = f[l + 552 >> 2])) break;
            }
          }
        }, Fo, function(u, l) {
          l |= 0;
          var p = 0;
          e: if (u = f[(u |= 0) >> 2], ((p = f[u + 24 >> 2]) >>> 16 & 3) != (0 | l)) for (f[u + 24 >> 2] = -196609 & p | l << 16 & 196608; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, Fo, function(u, l, p) {
          l |= 0, p = +p, Df(f[(u |= 0) >> 2], l, Bn(E(p)));
        }, function(u, l, p, m) {
          l |= 0, p |= 0, m = +m;
          var D = 0;
          D = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (D = f[D + f[l >> 2] >> 2]), xt[0 | D](l, p, m);
        }, function(u, l, p) {
          l |= 0, p = +p, Df(f[(u |= 0) >> 2], l, Wn(E(p)));
        }, function(u, l) {
          l |= 0, gs(f[(u |= 0) >> 2], 5, l);
        }, function(u, l) {
          l |= 0, gs(f[(u |= 0) >> 2], 6, l);
        }, function(u, l) {
          l |= 0, gs(f[(u |= 0) >> 2], 7, l);
        }, function(u, l) {
          l |= 0;
          var p = 0;
          e: if (u = f[(u |= 0) >> 2], ((p = f[u + 24 >> 2]) >>> 2 & 3) != (0 | l)) for (f[u + 24 >> 2] = -13 & p | l << 2 & 12; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l) {
          l |= 0;
          var p = 0;
          e: if (u = f[(u |= 0) >> 2], ((p = f[u + 24 >> 2]) >>> 18 & 3) != (0 | l)) for (f[u + 24 >> 2] = -786433 & p | l << 18 & 786432; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l) {
          l |= 0;
          var p = 0;
          e: if (u = f[(u |= 0) >> 2], ((p = f[u + 24 >> 2]) >>> 4 & 7) != (0 | l)) for (f[u + 24 >> 2] = -113 & p | l << 4 & 112; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l, p) {
          l |= 0, p = +p, Vl(f[(u |= 0) >> 2], l, Bn(E(p)));
        }, function(u, l, p) {
          l |= 0, p = +p, Vl(f[(u |= 0) >> 2], l, Wn(E(p)));
        }, function(u, l) {
          l |= 0, Vl(f[(u |= 0) >> 2], l, 2141891242);
        }, function(u, l) {
          l |= 0;
          var p = 0;
          e: if (u = f[(u |= 0) >> 2], ((p = f[u + 24 >> 2]) >>> 20 & 3) != (0 | l)) for (f[u + 24 >> 2] = -3145729 & p | l << 20 & 3145728; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l) {
          l |= 0;
          var p = 0;
          e: if (u = f[(u |= 0) >> 2], ((p = f[u + 24 >> 2]) >>> 22 & 1) != (0 | l)) for (f[u + 24 >> 2] = -4194305 & p | l << 22 & 4194304; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l) {
          u |= 0, l = +l;
          var p = 0, m = E(0), D = E(0);
          e: if (m = E(l), u = f[u >> 2], !(m == (D = Y[u + 28 >> 2]) | m != m & D != D)) for (Y[u + 28 >> 2] = m; ; ) {
            if (4 & (p = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | p, (p = f[u + 20 >> 2]) && xt[0 | p](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l, p) {
          l |= 0, p = +p;
          var m = 0;
          m = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (m = f[m + f[l >> 2] >> 2]), xt[0 | m](l, p);
        }, function(u, l) {
          l = +l, Tu(f[(u |= 0) >> 2], Bn(E(l)));
        }, function(u, l) {
          l = +l, Tu(f[(u |= 0) >> 2], Wn(E(l)));
        }, function(u) {
          Tu(f[(u |= 0) >> 2], 2141891242);
        }, function(u, l) {
          u |= 0, l = +l;
          var p = 0, m = E(0), D = E(0);
          e: if (m = E(l), u = f[u >> 2], !(m == (D = Y[u + 32 >> 2]) | m != m & D != D)) for (Y[u + 32 >> 2] = m; ; ) {
            if (4 & (p = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | p, (p = f[u + 20 >> 2]) && xt[0 | p](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l) {
          u |= 0, l = +l;
          var p = 0, m = E(0), D = E(0);
          e: if (m = E(l), u = f[u >> 2], !(m == (D = Y[u + 36 >> 2]) | m != m & D != D)) for (Y[u + 36 >> 2] = m; ; ) {
            if (4 & (p = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | p, (p = f[u + 20 >> 2]) && xt[0 | p](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l) {
          l = +l, Co(f[(u |= 0) >> 2], 0, Bn(E(l)));
        }, function(u, l) {
          l = +l, Co(f[(u |= 0) >> 2], 0, Wn(E(l)));
        }, function(u) {
          Co(f[(u |= 0) >> 2], 0, 2141891242);
        }, function(u, l) {
          l = +l, Co(f[(u |= 0) >> 2], 1, Bn(E(l)));
        }, function(u, l) {
          l = +l, Co(f[(u |= 0) >> 2], 1, Wn(E(l)));
        }, function(u) {
          Co(f[(u |= 0) >> 2], 1, 2141891242);
        }, function(u, l) {
          l = +l, _u(f[(u |= 0) >> 2], 0, Bn(E(l)));
        }, function(u, l) {
          l = +l, _u(f[(u |= 0) >> 2], 0, Wn(E(l)));
        }, function(u, l) {
          l = +l, _u(f[(u |= 0) >> 2], 1, Bn(E(l)));
        }, function(u, l) {
          l = +l, _u(f[(u |= 0) >> 2], 1, Wn(E(l)));
        }, function(u, l) {
          l = +l, Du(f[(u |= 0) >> 2], 0, Bn(E(l)));
        }, function(u, l) {
          l = +l, Du(f[(u |= 0) >> 2], 0, Wn(E(l)));
        }, function(u, l) {
          l = +l, Du(f[(u |= 0) >> 2], 1, Bn(E(l)));
        }, function(u, l) {
          l = +l, Du(f[(u |= 0) >> 2], 1, Wn(E(l)));
        }, function(u, l) {
          u |= 0, l = +l;
          var p = 0, m = E(0), D = E(0);
          e: if (m = E(l), u = f[u >> 2], !(m == (D = Y[u + 224 >> 2]) | m != m & D != D)) for (Y[u + 224 >> 2] = m; ; ) {
            if (4 & (p = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | p, (p = f[u + 20 >> 2]) && xt[0 | p](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l, p) {
          l |= 0, p = +p;
          var m = 0;
          e: if (u = f[(u |= 0) >> 2], (0 | f[152 + (l = u + (l << 2) | 0) >> 2]) != (0 | (m = Bn(E(p))))) for (f[l + 152 >> 2] = m; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u, l, p) {
          l |= 0, p = +p, Gl(f[(u |= 0) >> 2], l, Bn(E(p)));
        }, function(u, l, p) {
          l |= 0, p = +p, Gl(f[(u |= 0) >> 2], l, Wn(E(p)));
        }, function(u, l, p) {
          l |= 0, p = +p;
          var m = 0;
          e: if (u = f[(u |= 0) >> 2], (0 | f[188 + (l = u + (l << 2) | 0) >> 2]) != (0 | (m = Bn(E(p))))) for (f[l + 188 >> 2] = m; ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, function(u) {
          return 3 & _o[f[(u |= 0) >> 2] + 26 >> 1];
        }, ja, function(u, l, p) {
          u |= 0, l |= 0, p |= 0;
          var m = 0, D = 0, F = E(0);
          m = 2, l = f[l >> 2] + (p << 2) | 0, F = Y[l + 80 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 80 >> 2])) != 2139156720) {
                if (D = NaN, (0 | l) == 2141891242) {
                  m = 3;
                  break e;
                }
                if ((0 | l) != 2140081935) break n;
                D = 0, m = 1;
                break e;
              }
              break e;
            }
            F == F ? (m = 1073741824 & l ? 2 : 1, ze(2, 536870912 + (-1073741825 & l) | 0), D = +Tt()) : m = 0;
          }
          Fr[u + 8 >> 3] = D, f[u >> 2] = m;
        }, function(u, l, p) {
          l |= 0, p |= 0;
          var m, D = 0;
          return nt = m = nt - 16 | 0, D = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (D = f[D + f[l >> 2] >> 2]), xt[0 | D](m, l, p), u = Ze(16), l = f[m + 12 >> 2], f[u + 8 >> 2] = f[m + 8 >> 2], f[u + 12 >> 2] = l, l = f[m + 4 >> 2], f[u >> 2] = f[m >> 2], f[u + 4 >> 2] = l, nt = m + 16 | 0, 0 | u;
        }, function(u) {
          return f[f[(u |= 0) >> 2] + 24 >> 2] >>> 7 & 7;
        }, function(u) {
          return f[f[(u |= 0) >> 2] + 24 >> 2] >>> 10 & 7;
        }, function(u) {
          return f[f[(u |= 0) >> 2] + 24 >> 2] >>> 13 & 7;
        }, function(u) {
          return f[f[(u |= 0) >> 2] + 24 >> 2] >>> 2 & 3;
        }, function(u) {
          return f[f[(u |= 0) >> 2] + 24 >> 2] >>> 18 & 3;
        }, function(u) {
          return f[f[(u |= 0) >> 2] + 24 >> 2] >>> 4 & 7;
        }, function(u, l, p) {
          u |= 0, l |= 0, p |= 0;
          var m = 0, D = 0, F = E(0);
          m = 2, l = f[l >> 2] + (p << 2) | 0, F = Y[l + 44 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 44 >> 2])) != 2139156720) {
                if (D = NaN, (0 | l) == 2141891242) {
                  m = 3;
                  break e;
                }
                if ((0 | l) != 2140081935) break n;
                D = 0, m = 1;
                break e;
              }
              break e;
            }
            F == F ? (m = 1073741824 & l ? 2 : 1, ze(2, 536870912 + (-1073741825 & l) | 0), D = +Tt()) : m = 0;
          }
          Fr[u + 8 >> 3] = D, f[u >> 2] = m;
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = E(0), D = E(0);
          m = E(NaN), l = f[l >> 2], D = Y[l + 40 >> 2], p = 3, (0 | (l = f[l + 40 >> 2])) != 2141891242 && ((0 | l) != 2140081935 ? (0 | l) != 2139156720 ? (p = 0, D == D && (ze(2, 536870912 + (-1073741825 & l) | 0), m = Tt(), p = 1073741824 & l ? 2 : 1)) : (m = E(0), p = 2) : (m = E(0), p = 1)), f[u >> 2] = p, Fr[u + 8 >> 3] = m;
        }, function(u, l) {
          l |= 0;
          var p, m = 0;
          return nt = p = nt - 16 | 0, m = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (m = f[m + f[l >> 2] >> 2]), xt[0 | m](p, l), u = Ze(16), l = f[p + 12 >> 2], f[u + 8 >> 2] = f[p + 8 >> 2], f[u + 12 >> 2] = l, l = f[p + 4 >> 2], f[u >> 2] = f[p >> 2], f[u + 4 >> 2] = l, nt = p + 16 | 0, 0 | u;
        }, function(u) {
          u |= 0;
          var l = E(0);
          return +((l = Y[f[u >> 2] + 32 >> 2]) == l ? l : E(0));
        }, function(u, l) {
          l |= 0;
          var p = 0;
          return p = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (p = f[p + f[l >> 2] >> 2]), +xt[0 | p](l);
        }, function(u) {
          u |= 0;
          var l = E(0);
          return u = f[u >> 2], (l = Y[u + 36 >> 2]) != l && (l = Ke[f[u + 568 >> 2] + 10 | 0] ? E(1) : E(0)), +l;
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = 0, D = E(0);
          l = f[l >> 2], D = Y[l + 200 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 200 >> 2])) != 2139156720) {
                if (m = NaN, p = 3, (0 | l) == 2141891242) break e;
                if ((0 | l) != 2140081935) break n;
                m = 0, p = 1;
                break e;
              }
              p = 2;
              break e;
            }
            p = 0, D == D && (ze(2, 536870912 + (-1073741825 & l) | 0), m = +Tt(), p = 1073741824 & l ? 2 : 1);
          }
          l = p, Fr[u + 8 >> 3] = m, f[u >> 2] = l;
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = 0, D = E(0);
          l = f[l >> 2], D = Y[l + 204 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 204 >> 2])) != 2139156720) {
                if (m = NaN, p = 3, (0 | l) == 2141891242) break e;
                if ((0 | l) != 2140081935) break n;
                m = 0, p = 1;
                break e;
              }
              p = 2;
              break e;
            }
            p = 0, D == D && (ze(2, 536870912 + (-1073741825 & l) | 0), m = +Tt(), p = 1073741824 & l ? 2 : 1);
          }
          l = p, Fr[u + 8 >> 3] = m, f[u >> 2] = l;
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = 0, D = E(0);
          l = f[l >> 2], D = Y[l + 208 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 208 >> 2])) != 2139156720) {
                if (m = NaN, p = 3, (0 | l) == 2141891242) break e;
                if ((0 | l) != 2140081935) break n;
                m = 0, p = 1;
                break e;
              }
              p = 2;
              break e;
            }
            p = 0, D == D && (ze(2, 536870912 + (-1073741825 & l) | 0), m = +Tt(), p = 1073741824 & l ? 2 : 1);
          }
          l = p, Fr[u + 8 >> 3] = m, f[u >> 2] = l;
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = 0, D = E(0);
          l = f[l >> 2], D = Y[l + 212 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 212 >> 2])) != 2139156720) {
                if (m = NaN, p = 3, (0 | l) == 2141891242) break e;
                if ((0 | l) != 2140081935) break n;
                m = 0, p = 1;
                break e;
              }
              p = 2;
              break e;
            }
            p = 0, D == D && (ze(2, 536870912 + (-1073741825 & l) | 0), m = +Tt(), p = 1073741824 & l ? 2 : 1);
          }
          l = p, Fr[u + 8 >> 3] = m, f[u >> 2] = l;
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = 0, D = E(0);
          l = f[l >> 2], D = Y[l + 216 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 216 >> 2])) != 2139156720) {
                if (m = NaN, p = 3, (0 | l) == 2141891242) break e;
                if ((0 | l) != 2140081935) break n;
                m = 0, p = 1;
                break e;
              }
              p = 2;
              break e;
            }
            p = 0, D == D && (ze(2, 536870912 + (-1073741825 & l) | 0), m = +Tt(), p = 1073741824 & l ? 2 : 1);
          }
          l = p, Fr[u + 8 >> 3] = m, f[u >> 2] = l;
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = 0, D = E(0);
          l = f[l >> 2], D = Y[l + 220 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 220 >> 2])) != 2139156720) {
                if (m = NaN, p = 3, (0 | l) == 2141891242) break e;
                if ((0 | l) != 2140081935) break n;
                m = 0, p = 1;
                break e;
              }
              p = 2;
              break e;
            }
            p = 0, D == D && (ze(2, 536870912 + (-1073741825 & l) | 0), m = +Tt(), p = 1073741824 & l ? 2 : 1);
          }
          l = p, Fr[u + 8 >> 3] = m, f[u >> 2] = l;
        }, function(u) {
          u |= 0;
          var l = E(0);
          return +((l = Y[f[u >> 2] + 224 >> 2]) != l ? E(NaN) : l);
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = 0, m = E(0);
          u = f[u >> 2] + (l << 2) | 0, m = Y[u + 152 >> 2];
          e: {
            if (!((0 | (u = f[u + 152 >> 2])) == 2139156720 | (0 | u) == 2140081935)) {
              if (p = NaN, (0 | u) == 2141891242 | m != m) break e;
              if ((0 | u) != 2139156720) return ze(2, 536870912 + (-1073741825 & u) | 0), +Tt();
            }
            p = 0;
          }
          return +p;
        }, function(u, l, p) {
          l |= 0, p |= 0;
          var m = 0;
          return m = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (m = f[m + f[l >> 2] >> 2]), +xt[0 | m](l, p);
        }, function(u) {
          return f[f[(u |= 0) >> 2] + 24 >> 2] >>> 20 & 3;
        }, function(u) {
          return f[f[(u |= 0) >> 2] + 24 >> 2] >>> 22 & 1;
        }, function(u, l, p) {
          u |= 0, l |= 0, p |= 0;
          var m = 0, D = 0, F = E(0);
          m = 2, l = f[l >> 2] + (p << 2) | 0, F = Y[l + 116 >> 2];
          e: {
            n: {
              if ((0 | (l = f[l + 116 >> 2])) != 2139156720) {
                if (D = NaN, (0 | l) == 2141891242) {
                  m = 3;
                  break e;
                }
                if ((0 | l) != 2140081935) break n;
                D = 0, m = 1;
                break e;
              }
              break e;
            }
            F == F ? (m = 1073741824 & l ? 2 : 1, ze(2, 536870912 + (-1073741825 & l) | 0), D = +Tt()) : m = 0;
          }
          Fr[u + 8 >> 3] = D, f[u >> 2] = m;
        }, function(u, l) {
          u |= 0, l |= 0;
          var p = E(0), m = E(0);
          u = f[u >> 2] + (l << 2) | 0, m = Y[u + 188 >> 2];
          e: {
            if (!((0 | (u = f[u + 188 >> 2])) == 2139156720 | (0 | u) == 2140081935)) {
              if (p = E(NaN), (0 | u) == 2141891242 | m != m) break e;
              if ((0 | u) != 2139156720) return E((ze(2, 536870912 + (-1073741825 & u) | 0), Tt()));
            }
            p = E(0);
          }
          return E(p);
        }, function(u, l, p) {
          l |= 0, p |= 0;
          var m = 0;
          return m = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (m = f[m + f[l >> 2] >> 2]), E(E(xt[0 | m](l, p)));
        }, function(u, l, p) {
          l |= 0, p |= 0;
          var m, D = 0, F = 0, U = 0, $ = 0, X = 0, Pe = 0, ce = 0, Ce = 0, ge = 0;
          nt = m = nt - 80 | 0, u = f[(u |= 0) >> 2];
          e: {
            n: {
              if (X = f[l >> 2], !f[X + 552 >> 2]) {
                if (f[u + 8 >> 2]) break n;
                $ = (l = f[u + 556 >> 2]) + (p << 2) | 0;
                t: if ((D = f[u + 560 >> 2]) >>> 0 < (U = f[(F = u + 564 | 0) >> 2]) >>> 0) {
                  if ((0 | D) == (0 | $)) {
                    f[$ >> 2] = X, f[u + 560 >> 2] = $ + 4;
                    break t;
                  }
                  if (p = D, D >>> 0 > (l = D - 4 | 0) >>> 0) for (; f[p >> 2] = f[l >> 2], p = p + 4 | 0, D >>> 0 > (l = l + 4 | 0) >>> 0; ) ;
                  f[u + 560 >> 2] = p, (0 | (l = $ + 4 | 0)) != (0 | D) && T0(D - (-4 & (l = D - l | 0)) | 0, $, l), f[$ >> 2] = X;
                } else {
                  if ((D = 1 + (D - l >> 2) | 0) >>> 0 >= 1073741824) break e;
                  if (U = (l = U - l | 0) >>> 1 | 0, F = ma(m + 32 | 0, l >>> 0 >= 2147483644 ? 1073741823 : D >>> 0 < U >>> 0 ? U : D, p, F), (0 | (p = f[F + 8 >> 2])) == f[F + 12 >> 2]) if ((l = f[F + 4 >> 2]) >>> 0 > (D = f[F >> 2]) >>> 0) p = T0(Pe = (D = (1 + (l - D >> 2) | 0) / -2 << 2) + l | 0, U = l, l = p - l | 0) + l | 0, f[F + 8 >> 2] = p, f[F + 4 >> 2] = D + f[F + 4 >> 2];
                  else {
                    if (U = ma(m + 56 | 0, l = (0 | p) == (0 | D) ? 1 : p - D >> 1, l >>> 2 | 0, f[F + 16 >> 2]), D = f[U + 8 >> 2], (0 | (l = f[F + 4 >> 2])) != (0 | (p = f[F + 8 >> 2]))) {
                      for (p = (p - l | 0) + D | 0; f[D >> 2] = f[l >> 2], l = l + 4 | 0, (0 | (D = D + 4 | 0)) != (0 | p); ) ;
                      l = f[F + 8 >> 2], D = f[F + 4 >> 2];
                    } else p = D, D = l;
                    Pe = f[F >> 2], f[F >> 2] = f[U >> 2], f[U >> 2] = Pe, f[F + 4 >> 2] = f[U + 4 >> 2], f[U + 4 >> 2] = D, f[F + 8 >> 2] = p, f[U + 8 >> 2] = l, ce = f[F + 12 >> 2], f[F + 12 >> 2] = f[U + 12 >> 2], f[U + 12 >> 2] = ce, (0 | l) != (0 | D) && (f[U + 8 >> 2] = (3 + (D - l | 0) & -4) + l), Pe && (l0(Pe), p = f[F + 8 >> 2]);
                  }
                  f[p >> 2] = X, f[F + 8 >> 2] = f[F + 8 >> 2] + 4, p = $ - (l = f[u + 556 >> 2]) | 0, Ce = F, ge = T0(f[F + 4 >> 2] - p | 0, l, p), f[Ce + 4 >> 2] = ge, D = f[u + 560 >> 2] - $ | 0, $ = T0(f[F + 8 >> 2], $, D), l = f[u + 556 >> 2], f[u + 556 >> 2] = f[F + 4 >> 2], f[F + 4 >> 2] = l, p = f[u + 560 >> 2], f[u + 560 >> 2] = D + $, f[F + 8 >> 2] = p, D = f[u + 564 >> 2], f[u + 564 >> 2] = f[F + 12 >> 2], f[F >> 2] = l, f[F + 12 >> 2] = D, (0 | l) != (0 | p) && (f[F + 8 >> 2] = p + (3 + (l - p | 0) & -4)), l && l0(l);
                }
                for (f[X + 552 >> 2] = u; !(4 & (l = Ke[u + 4 | 0])) && (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, u = f[u + 552 >> 2]); ) ;
                return void (nt = m + 80 | 0);
              }
              f[m + 16 >> 2] = 4006, vn(u, m + 16 | 0), un(), Ut();
            }
            f[m >> 2] = 4139, vn(u, m), un(), Ut();
          }
          Do(), Ut();
        }, Su, function(u, l) {
          l |= 0;
          var p, m = 0, D = 0, F = 0;
          nt = p = nt - 320 | 0, u = f[(u |= 0) >> 2];
          e: if (f[u + 560 >> 2] != f[u + 556 >> 2] && (D = f[l >> 2], l = f[D + 552 >> 2], Nn(u, D))) {
            if ((0 | u) == (0 | l)) {
              for (m = k0(p, 0, 288), f[(l = m) + 16 >> 2] = 2143289344, f[l + 20 >> 2] = 2143289344, k0(l + 24 | 0, 0, 49), f[l + 80 >> 2] = 2143289344, F = l + 288 | 0, l = l + 96 | 0; f[l + 16 >> 2] = -1082130432, f[l + 20 >> 2] = -1082130432, f[l + 8 >> 2] = 0, f[l + 12 >> 2] = 0, f[l >> 2] = -1082130432, f[l + 4 >> 2] = -1082130432, (0 | F) != (0 | (l = l + 24 | 0)); ) ;
              f[m + 312 >> 2] = -1082130432, f[m + 316 >> 2] = -1082130432, f[m + 304 >> 2] = 0, f[m + 308 >> 2] = 0, f[m + 296 >> 2] = -1082130432, f[m + 300 >> 2] = -1082130432, f[m + 288 >> 2] = 2143289344, f[m + 292 >> 2] = 2143289344, D0(D + 228 | 0, m, 320), f[D + 552 >> 2] = 0;
            }
            for (; ; ) {
              if (4 & (l = Ke[u + 4 | 0])) break e;
              if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
            }
          }
          nt = p + 320 | 0;
        }, Fo, function(u) {
          return u = f[(u |= 0) >> 2], f[u + 560 >> 2] - f[u + 556 >> 2] >> 2;
        }, ja, function(u) {
          return (u = f[f[(u |= 0) >> 2] + 552 >> 2]) ? f[u >> 2] : 0;
        }, ja, function(u, l) {
          l |= 0;
          var p, m = 0;
          return p = f[(u |= 0) >> 2], u = f[p + 556 >> 2], f[p + 560 >> 2] - u >> 2 >>> 0 <= l >>> 0 || (u = f[u + (l << 2) >> 2]) && (m = f[u >> 2]), 0 | m;
        }, y2, function(u) {
          return (2 & Ke[f[(u |= 0) >> 2] + 4 | 0]) >>> 1 | 0;
        }, ja, function(u, l) {
          l |= 0;
          var p = 0;
          e: if (u = f[(u |= 0) >> 2], ((2 & (p = Ke[u + 4 | 0])) >>> 1 | 0) != (0 | l)) for (je[u + 4 | 0] = 253 & p | (l ? 2 : 0); ; ) {
            if (4 & (l = Ke[u + 4 | 0])) break e;
            if (je[u + 4 | 0] = 4 | l, (l = f[u + 20 >> 2]) && xt[0 | l](u), f[u + 308 >> 2] = 2143289344, !(u = f[u + 552 >> 2])) break;
          }
        }, Fo, function(u, l) {
          var p;
          l |= 0, p = f[4 + (u |= 0) >> 2], f[u + 4 >> 2] = l, p && xt[f[f[p >> 2] + 4 >> 2]](p), Hl(f[u >> 2], 14);
        }, Fo, function(u) {
          var l;
          l = f[4 + (u |= 0) >> 2], f[u + 4 >> 2] = 0, l && xt[f[f[l >> 2] + 4 >> 2]](l), Hl(f[u >> 2], 0);
        }, function(u, l) {
          var p;
          l |= 0, p = f[8 + (u |= 0) >> 2], f[u + 8 >> 2] = l, p && xt[f[f[p >> 2] + 4 >> 2]](p), f[f[u >> 2] + 20 >> 2] = 15;
        }, Fo, function(u) {
          var l;
          l = f[8 + (u |= 0) >> 2], f[u + 8 >> 2] = 0, l && xt[f[f[l >> 2] + 4 >> 2]](l), f[f[u >> 2] + 20 >> 2] = 0;
        }, function(u) {
          var l, p = 0;
          if (nt = l = nt - 16 | 0, u = f[(u |= 0) >> 2], f[u + 8 >> 2]) {
            for (; !(4 & (p = Ke[u + 4 | 0])) && (je[u + 4 | 0] = 4 | p, (p = f[u + 20 >> 2]) && xt[0 | p](u), f[u + 308 >> 2] = 2143289344, u = f[u + 552 >> 2]); ) ;
            nt = l + 16 | 0;
          } else f[l >> 2] = 1024, vn(u, l), un(), Ut();
        }, function(u) {
          return (4 & Ke[f[(u |= 0) >> 2] + 4 | 0]) >>> 2 | 0;
        }, ja, function(u, l, p, m) {
          u |= 0, l = +l, p = +p, m |= 0;
          var D, F, U = E(0), $ = E(0), X = E(0), Pe = 0, ce = E(0), Ce = 0, ge = E(0);
          nt = F = nt + -64 | 0, D = f[u >> 2], k0(F + 8 | 0, 0, 56), f[1735] = f[1735] + 1, mi(D), X = E(l), $ = Y[D + 572 >> 2];
          e: {
            n: {
              switch (0 | (u = f[D + 576 >> 2])) {
                case 0:
                case 3:
                  break n;
              }
              t: {
                if (!((0 | u) != 1 | (U = Y[D + 572 >> 2]) != U)) {
                  if (!((U = $) < E(0))) break t;
                  break n;
                }
                r: {
                  if ((0 | u) != 2 | U != U) {
                    U = E(NaN);
                    i: switch (u - 1 | 0) {
                      case 1:
                        break r;
                      case 0:
                        break i;
                      default:
                        break t;
                    }
                    U = $;
                    break t;
                  }
                  if (X != X | $ < E(0)) break n;
                }
                U = E(E($ * X) * E(0.009999999776482582));
              }
              ge = E(U + E(er(D, 2, X) + wr(D, 2, X))), Ce = 1;
              break e;
            }
            U = E(0), $ = Y[D + 216 >> 2];
            n: {
              t: {
                r: {
                  i: if ((0 | (u = f[D + 216 >> 2])) != 2139156720) {
                    if ((0 | u) == 2140081935) break n;
                    Ce = 4276;
                    a: {
                      if ((0 | u) != 2141891242) {
                        if ($ == $) break a;
                        Ce = 4268;
                      }
                      switch (U = Y[Ce >> 2], f[Ce + 4 >> 2] - 1 | 0) {
                        case 0:
                          break r;
                        case 1:
                          break i;
                        default:
                          break t;
                      }
                    }
                    if (ze(2, 536870912 + (-1073741825 & u) | 0), U = Tt(), !(1073741824 & u)) break r;
                  }
                  U = E(E(U * X) * E(0.009999999776482582));
                }
                if (U == U) {
                  U = E(0);
                  r: if ((0 | u) != 2139156720) {
                    if ((0 | u) == 2140081935) break n;
                    Pe = 4276;
                    i: {
                      if ((0 | u) != 2141891242) {
                        if ($ == $) break i;
                        Pe = 4268;
                      }
                      switch (U = Y[Pe >> 2], ge = E(NaN), Ce = 2, f[Pe + 4 >> 2] - 1 | 0) {
                        case 1:
                          break r;
                        case 0:
                          break n;
                        default:
                          break e;
                      }
                    }
                    if (ze(2, 536870912 + (-1073741825 & u) | 0), U = Tt(), !(1073741824 & u)) break n;
                  }
                  ge = E(E(U * X) * E(0.009999999776482582)), Ce = 2;
                  break e;
                }
              }
              Ce = X == X, ge = X;
              break e;
            }
            Ce = 2, ge = U;
          }
          ce = E(p), $ = Y[D + 580 >> 2];
          e: {
            n: {
              switch (0 | (u = f[D + 584 >> 2])) {
                case 0:
                case 3:
                  break n;
              }
              t: {
                if (!((0 | u) != 1 | (U = Y[D + 580 >> 2]) != U)) {
                  if (!((U = $) < E(0))) break t;
                  break n;
                }
                r: {
                  if ((0 | u) != 2 | U != U) {
                    U = E(NaN);
                    i: switch (u - 1 | 0) {
                      case 1:
                        break r;
                      case 0:
                        break i;
                      default:
                        break t;
                    }
                    U = $;
                    break t;
                  }
                  if (ce != ce | $ < E(0)) break n;
                }
                U = E(E($ * ce) * E(0.009999999776482582));
              }
              $ = E(U + E(er(D, 0, X) + wr(D, 0, X))), u = 1;
              break e;
            }
            U = E(0), $ = Y[D + 220 >> 2];
            n: {
              t: {
                r: {
                  i: if ((0 | (u = f[D + 220 >> 2])) != 2139156720) {
                    if ((0 | u) == 2140081935) break n;
                    Pe = 4276;
                    a: {
                      if ((0 | u) != 2141891242) {
                        if ($ == $) break a;
                        Pe = 4268;
                      }
                      switch (U = Y[Pe >> 2], f[Pe + 4 >> 2] - 1 | 0) {
                        case 0:
                          break r;
                        case 1:
                          break i;
                        default:
                          break t;
                      }
                    }
                    if (ze(2, 536870912 + (-1073741825 & u) | 0), U = Tt(), !(1073741824 & u)) break r;
                  }
                  U = E(E(U * ce) * E(0.009999999776482582));
                }
                if (U == U) {
                  U = E(0);
                  r: if ((0 | u) != 2139156720) {
                    if ((0 | u) == 2140081935) break n;
                    Pe = 4276;
                    i: {
                      if ((0 | u) != 2141891242) {
                        if ($ == $) break i;
                        Pe = 4268;
                      }
                      switch (U = Y[Pe >> 2], $ = E(NaN), u = 2, f[Pe + 4 >> 2] - 1 | 0) {
                        case 0:
                          break n;
                        case 1:
                          break r;
                        default:
                          break e;
                      }
                    }
                    if (ze(2, 536870912 + (-1073741825 & u) | 0), U = Tt(), !(1073741824 & u)) break n;
                  }
                  $ = E(E(U * ce) * E(0.009999999776482582)), u = 2;
                  break e;
                }
              }
              u = ce == ce, $ = ce;
              break e;
            }
            u = 2, $ = U;
          }
          H0(D, ge, $, m, Ce, u, X, ce, 1, 0, f[D + 568 >> 2], F + 8 | 0, 0, f[1735]) && (bf(D, 3 & Ke[D + 300 | 0], X, ce, X), zl(D, +Y[f[D + 568 >> 2] + 16 >> 2], 0, 0)), nt = F - -64 | 0;
        }, function(u, l, p, m, D) {
          l |= 0, p = +p, m = +m, D |= 0;
          var F = 0;
          F = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (F = f[F + f[l >> 2] >> 2]), xt[0 | F](l, p, m, D);
        }, function(u) {
          return +Y[f[(u |= 0) >> 2] + 228 >> 2];
        }, function(u) {
          return +Y[f[(u |= 0) >> 2] + 236 >> 2];
        }, function(u) {
          return +Y[f[(u |= 0) >> 2] + 232 >> 2];
        }, function(u) {
          return +Y[f[(u |= 0) >> 2] + 240 >> 2];
        }, function(u) {
          return +Y[f[(u |= 0) >> 2] + 244 >> 2];
        }, function(u) {
          return +Y[f[(u |= 0) >> 2] + 248 >> 2];
        }, function(u, l) {
          u |= 0, l = f[(l |= 0) >> 2], Fr[u >> 3] = Y[l + 228 >> 2], Fr[u + 8 >> 3] = Y[l + 236 >> 2], Fr[u + 16 >> 3] = Y[l + 232 >> 2], Fr[u + 24 >> 3] = Y[l + 240 >> 2], Fr[u + 32 >> 3] = Y[l + 244 >> 2], Fr[u + 40 >> 3] = Y[l + 248 >> 2];
        }, function(u, l) {
          l |= 0;
          var p, m = 0;
          return nt = p = nt - 48 | 0, m = f[(u |= 0) >> 2], l = ((u = f[u + 4 >> 2]) >> 1) + l | 0, 1 & u && (m = f[m + f[l >> 2] >> 2]), xt[0 | m](p, l), u = D0(Ze(48), p, 48), nt = p + 48 | 0, 0 | u;
        }, function(u, l) {
          var p;
          if (l |= 0, nt = p = nt - 16 | 0, u = f[(u |= 0) >> 2], (0 | l) < 6) {
            nt = p + 16 | 0;
            e: {
              switch (l - 4 | 0) {
                case 0:
                  if (l = u + 260 | 0, (3 & Ke[u + 300 | 0]) == 2) break e;
                  l = u + 252 | 0;
                  break e;
                case 1:
                  if (l = u + 252 | 0, (3 & Ke[u + 300 | 0]) == 2) break e;
                  l = u + 260 | 0;
                  break e;
              }
              l = 252 + (u + (l << 2) | 0) | 0;
            }
            return +Y[l >> 2];
          }
          f[p >> 2] = 1871, vn(u, p), un(), Ut();
        }, function(u, l) {
          var p;
          if (l |= 0, nt = p = nt - 16 | 0, u = f[(u |= 0) >> 2], (0 | l) < 6) {
            nt = p + 16 | 0;
            e: {
              switch (l - 4 | 0) {
                case 0:
                  if (l = u + 276 | 0, (3 & Ke[u + 300 | 0]) == 2) break e;
                  l = u + 268 | 0;
                  break e;
                case 1:
                  if (l = u + 268 | 0, (3 & Ke[u + 300 | 0]) == 2) break e;
                  l = u + 276 | 0;
                  break e;
              }
              l = 268 + (u + (l << 2) | 0) | 0;
            }
            return +Y[l >> 2];
          }
          f[p >> 2] = 1871, vn(u, p), un(), Ut();
        }, function(u, l) {
          var p;
          if (l |= 0, nt = p = nt - 16 | 0, u = f[(u |= 0) >> 2], (0 | l) < 6) {
            nt = p + 16 | 0;
            e: {
              switch (l - 4 | 0) {
                case 0:
                  if (l = u + 292 | 0, (3 & Ke[u + 300 | 0]) == 2) break e;
                  l = u + 284 | 0;
                  break e;
                case 1:
                  if (l = u + 284 | 0, (3 & Ke[u + 300 | 0]) == 2) break e;
                  l = u + 292 | 0;
                  break e;
              }
              l = 284 + (u + (l << 2) | 0) | 0;
            }
            return +Y[l >> 2];
          }
          f[p >> 2] = 1871, vn(u, p), un(), Ut();
        }, ql, Fu, ql, Fu, mf, Cf, function(u) {
          l0(Cf(u |= 0));
        }, function(u, l, p, m, D, F) {
          var U, $, X;
          u |= 0, l |= 0, p = E(p), m |= 0, D = E(D), F |= 0, nt = U = nt - 48 | 0, X = f[l + 8 >> 2], 1 & je[6972] ? l = f[1742] : (l = 0 | ff(5, 4416), je[6972] = 1, f[1742] = l), f[U + 40 >> 2] = F, Y[U + 32 >> 2] = D, f[U + 24 >> 2] = m, Y[U + 16 >> 2] = p, l = ($ = +v2(0 | l, 0 | X, 2873, U + 12 | 0, U + 16 | 0)) < 4294967296 & $ >= 0 ? ~~$ >>> 0 : 0, m = f[U + 12 >> 2], F = f[l + 4 >> 2], f[u >> 2] = f[l >> 2], f[u + 4 >> 2] = F, F = f[l + 12 >> 2], f[u + 8 >> 2] = f[l + 8 >> 2], f[u + 12 >> 2] = F, Ul(0 | m), nt = U + 48 | 0;
        }, Bf, Iu, A2, function(u) {
          l0(A2(u |= 0));
        }, function(u) {
          Zl(f[8 + (u |= 0) >> 2], 3244);
        }, Bf, function(u) {
          return 0 | Wi(f[60 + (u |= 0) >> 2]);
        }, function(u, l, p) {
          l |= 0, p |= 0;
          var m, D = 0, F = 0, U = 0, $ = 0, X = 0, Pe = 0;
          nt = m = nt - 32 | 0, D = f[28 + (u |= 0) >> 2], f[m + 16 >> 2] = D, F = f[u + 20 >> 2], f[m + 28 >> 2] = p, f[m + 24 >> 2] = l, l = F - D | 0, f[m + 20 >> 2] = l, F = l + p | 0, X = 2, l = m + 16 | 0;
          e: {
            for (; ; ) {
              n: {
                t: {
                  r: {
                    if (!x2(0 | hs(f[u + 60 >> 2], 0 | l, 0 | X, m + 12 | 0))) {
                      if ((0 | (U = f[m + 12 >> 2])) == (0 | F)) break r;
                      if ((0 | U) >= 0) break t;
                      break n;
                    }
                    if ((0 | F) != -1) break n;
                  }
                  l = f[u + 44 >> 2], f[u + 28 >> 2] = l, f[u + 20 >> 2] = l, f[u + 16 >> 2] = l + f[u + 48 >> 2], u = p;
                  break e;
                }
                $ = U - ((Pe = ($ = f[l + 4 >> 2]) >>> 0 < U >>> 0) ? $ : 0) | 0, f[(D = (Pe << 3) + l | 0) >> 2] = $ + f[D >> 2], f[(l = (Pe ? 12 : 4) + l | 0) >> 2] = f[l >> 2] - $, F = F - U | 0, X = X - Pe | 0, l = D;
                continue;
              }
              break;
            }
            f[u + 28 >> 2] = 0, f[u + 16 >> 2] = 0, f[u + 20 >> 2] = 0, f[u >> 2] = 32 | f[u >> 2], u = 0, (0 | X) != 2 && (u = p - f[l + 4 >> 2] | 0);
          }
          return nt = m + 32 | 0, 0 | u;
        }, function(u, l, p, m) {
          var D;
          return l |= 0, p |= 0, m |= 0, nt = D = nt - 16 | 0, u = x2(0 | pf(f[60 + (u |= 0) >> 2], 0 | l, 0 | p, 255 & m, D + 8 | 0)), nt = D + 16 | 0, sr = u ? -1 : f[D + 12 >> 2], 0 | (u ? -1 : f[D + 8 >> 2]);
        }, function(u) {
          return 0;
        }, function(u, l, p, m) {
          return sr = 0, 0;
        }, function(u, l, p) {
          l |= 0, p |= 0;
          var m, D, F = 0, U = 0, $ = 0;
          return m = f[84 + (u |= 0) >> 2], U = f[m >> 2], F = f[m + 4 >> 2], D = f[u + 28 >> 2], ($ = F >>> 0 < ($ = f[u + 20 >> 2] - D | 0) >>> 0 ? F : $) && (D0(U, D, $), U = $ + f[m >> 2] | 0, f[m >> 2] = U, F = f[m + 4 >> 2] - $ | 0, f[m + 4 >> 2] = F), (F = p >>> 0 > F >>> 0 ? F : p) && (D0(U, l, F), U = F + f[m >> 2] | 0, f[m >> 2] = U, f[m + 4 >> 2] = f[m + 4 >> 2] - F), je[0 | U] = 0, l = f[u + 44 >> 2], f[u + 28 >> 2] = l, f[u + 20 >> 2] = l, 0 | p;
        }, Iu]);
        function zt() {
          return b0.byteLength / 65536 | 0;
        }
        return {
          E: function() {
            for (var l = 0, p = 0, m = 0; m = 5888 + (p = l << 4) | 0, f[p + 5892 >> 2] = m, f[p + 5896 >> 2] = m, (0 | (l = l + 1 | 0)) != 64; ) ;
            ri(48), f[1736] = 16, f[1737] = 0, gf(), f[1737] = f[1748], f[1748] = 6944, f[1749] = 194, f[1750] = 0, mf(), f[1750] = f[1748], f[1748] = 6996;
          },
          F: function(l) {
            l |= 0;
            var p, m, D = 0, F = 0, U = 0;
            nt = p = nt - 96 | 0, f[p >> 2] = l, nt = F = nt - 16 | 0, f[F + 12 >> 2] = p, nt = l = nt - 144 | 0, l = D0(l, 5440, 144), D = m = p + 16 | 0, f[l + 44 >> 2] = D, f[l + 20 >> 2] = D, U = (U = -2 - D | 0) >>> 0 >= 2147483647 ? 2147483647 : U, f[l + 48 >> 2] = U, D = D + U | 0, f[l + 28 >> 2] = D, f[l + 16 >> 2] = D, yf(l, 2201, p, 0, 0), U && (D = f[l + 20 >> 2], je[D - ((0 | D) == f[l + 16 >> 2]) | 0] = 0), nt = l + 144 | 0, nt = F + 16 | 0;
            e: {
              if (3 & (l = m)) for (; ; ) {
                if (!Ke[0 | l]) break e;
                if (!(3 & (l = l + 1 | 0))) break;
              }
              for (; D = l, l = l + 4 | 0, !((-1 ^ (F = f[D >> 2])) & F - 16843009 & -2139062144); ) ;
              for (; D = (l = D) + 1 | 0, Ke[0 | l]; ) ;
            }
            return l = (D = To(l = 1 + (l - m | 0) | 0)) ? D0(D, m, l) : 0, nt = p + 96 | 0, 0 | l;
          },
          G: function() {
            var l = 0;
            if (l = f[1748]) for (; xt[f[l >> 2]](), l = f[l + 4 >> 2]; ) ;
          },
          H: To,
          I: xt,
          J: l0,
          K: function(l, p, m, D, F) {
            return p |= 0, m |= 0, D |= 0, F |= 0, 0 | xt[0 | (l |= 0)](p, m, D, F);
          }
        };
      }(re);
    }(ie);
  }
  Object.assign(e, i), i = null, e.wasmBinary && (o = e.wasmBinary), e.noExitRuntime;
  var g = Error;
  o = [], typeof {} != "object" && me("no native wasm support detected");
  var x, _, k, P, N, M, G, z, j, R = !1;
  function te(ie, re, Q) {
    Q = re + Q;
    for (var we = ""; !(re >= Q); ) {
      var Ge = ie[re++];
      if (!Ge) break;
      if (128 & Ge) {
        var Ue = 63 & ie[re++];
        if ((224 & Ge) == 192) we += String.fromCharCode((31 & Ge) << 6 | Ue);
        else {
          var at = 63 & ie[re++];
          65536 > (Ge = (240 & Ge) == 224 ? (15 & Ge) << 12 | Ue << 6 | at : (7 & Ge) << 18 | Ue << 12 | at << 6 | 63 & ie[re++]) ? we += String.fromCharCode(Ge) : (Ge -= 65536, we += String.fromCharCode(55296 | Ge >> 10, 56320 | 1023 & Ge));
        }
      } else we += String.fromCharCode(Ge);
    }
    return we;
  }
  function J() {
    var ie = x.buffer;
    e.HEAP8 = _ = new Int8Array(ie), e.HEAP16 = P = new Int16Array(ie), e.HEAP32 = M = new Int32Array(ie), e.HEAPU8 = k = new Uint8Array(ie), e.HEAPU16 = N = new Uint16Array(ie), e.HEAPU32 = G = new Uint32Array(ie), e.HEAPF32 = z = new Float32Array(ie), e.HEAPF64 = j = new Float64Array(ie);
  }
  var K = e.INITIAL_MEMORY || 16777216;
  65536 <= K || me("INITIAL_MEMORY should be larger than STACK_SIZE, was " + K + "! (STACK_SIZE=65536)"), x = e.wasmMemory ? e.wasmMemory : new function() {
    this.buffer = new ArrayBuffer(K / 65536 * 65536);
  }(), J(), K = x.buffer.byteLength;
  var ee, ve = [], de = [], B = [];
  function q() {
    var ie = e.preRun.shift();
    ve.unshift(ie);
  }
  var H, oe = 0, ne = null;
  function me(ie) {
    throw e.onAbort && e.onAbort(ie), c(ie = "Aborted(" + ie + ")"), R = !0, ie = new g(ie + ". Build with -sASSERTIONS for more info."), n(ie), ie;
  }
  function fe(ie) {
    return ie.startsWith("data:application/octet-stream;base64,");
  }
  if (!fe(H = "yoga-asm.wasm")) {
    var _e = H;
    H = e.locateFile ? e.locateFile(_e, a) : a + _e;
  }
  function Re(ie) {
    for (; 0 < ie.length; ) ie.shift()(e);
  }
  function Ie(ie) {
    if (ie === void 0) return "_unknown";
    var re = (ie = ie.replace(/[^a-zA-Z0-9_]/g, "$")).charCodeAt(0);
    return 48 <= re && 57 >= re ? "_" + ie : ie;
  }
  function W(ie, re) {
    return ie = Ie(ie), function() {
      return re.apply(this, arguments);
    };
  }
  var Z = [{}, {
    value: void 0
  }, {
    value: null
  }, {
    value: !0
  }, {
    value: !1
  }], se = [];
  function ye(ie) {
    var re = Error, Q = W(ie, function(we) {
      this.name = ie, this.message = we, (we = Error(we).stack) !== void 0 && (this.stack = this.toString() + `
` + we.replace(/^Error(:[^\n]*)?\n/, ""));
    });
    return Q.prototype = Object.create(re.prototype), Q.prototype.constructor = Q, Q.prototype.toString = function() {
      return this.message === void 0 ? this.name : this.name + ": " + this.message;
    }, Q;
  }
  var Fe = void 0;
  function xe(ie) {
    throw new Fe(ie);
  }
  var be = function(re) {
    return re || xe("Cannot use deleted val. handle = " + re), Z[re].value;
  }, he = function(re) {
    switch (re) {
      case void 0:
        return 1;
      case null:
        return 2;
      case !0:
        return 3;
      case !1:
        return 4;
      default:
        var Q = se.length ? se.pop() : Z.length;
        return Z[Q] = {
          fa: 1,
          value: re
        }, Q;
    }
  }, ke = void 0, De = void 0;
  function Qe(ie) {
    for (var re = ""; k[ie]; ) re += De[k[ie++]];
    return re;
  }
  var ct = [];
  function pt() {
    for (; ct.length; ) {
      var ie = ct.pop();
      ie.L.Z = !1, ie.delete();
    }
  }
  var _t = void 0, S = {};
  function b(ie, re) {
    for (re === void 0 && xe("ptr should not be undefined"); ie.P; ) re = ie.aa(re), ie = ie.P;
    return re;
  }
  var w = {};
  function T(ie) {
    var re = Qe(ie = n0(ie));
    return y0(ie), re;
  }
  function V(ie, re) {
    var Q = w[ie];
    return Q === void 0 && xe(re + " has unknown type " + T(ie)), Q;
  }
  function pe() {
  }
  var Ee = !1;
  function mt(ie) {
    --ie.count.value, ie.count.value === 0 && (ie.S ? ie.T.V(ie.S) : ie.O.M.V(ie.N));
  }
  function gt(ie, re, Q) {
    return re === Q ? ie : Q.P === void 0 || (ie = gt(ie, re, Q.P)) === null ? null : Q.ma(ie);
  }
  var St = {}, Bt = void 0;
  function yt(ie) {
    throw new Bt(ie);
  }
  function P0(ie, re) {
    return re.O && re.N || yt("makeClassHandle requires ptr and ptrType"), !!re.T != !!re.S && yt("Both smartPtrType and smartPtr must be specified"), re.count = {
      value: 1
    }, E0(Object.create(ie, {
      L: {
        value: re
      }
    }));
  }
  function E0(ie) {
    return typeof FinalizationRegistry > "u" ? (E0 = function(Q) {
      return Q;
    }, ie) : (Ee = new FinalizationRegistry(function(re) {
      mt(re.L);
    }), pe = function(Q) {
      Ee.unregister(Q);
    }, (E0 = function(Q) {
      var we = Q.L;
      return we.S && Ee.register(Q, {
        L: we
      }, Q), Q;
    })(ie));
  }
  var Er = {};
  function Ba(ie) {
    for (; ie.length; ) {
      var re = ie.pop();
      ie.pop()(re);
    }
  }
  function B0(ie) {
    return this.fromWireType(M[ie >> 2]);
  }
  var z0 = {}, N0 = {};
  function On(ie, re, Q) {
    function we(ft) {
      (ft = Q(ft)).length !== ie.length && yt("Mismatched type converter count");
      for (var et = 0; et < ie.length; ++et) j0(ie[et], ft[et]);
    }
    ie.forEach(function(ft) {
      N0[ft] = re;
    });
    var Ge = Array(re.length), Ue = [], at = 0;
    re.forEach(function(ft, et) {
      w.hasOwnProperty(ft) ? Ge[et] = w[ft] : (Ue.push(ft), z0.hasOwnProperty(ft) || (z0[ft] = []), z0[ft].push(function() {
        Ge[et] = w[ft], ++at === Ue.length && we(Ge);
      }));
    }), Ue.length === 0 && we(Ge);
  }
  function Pi(ie) {
    switch (ie) {
      case 1:
        return 0;
      case 2:
        return 1;
      case 4:
        return 2;
      case 8:
        return 3;
      default:
        throw new TypeError("Unknown type size: " + ie);
    }
  }
  function j0(ie, re, Q) {
    if (Q === void 0 && (Q = {}), !("argPackAdvance" in re)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
    var we = re.name;
    if (ie || xe('type "' + we + '" must have a positive integer typeid pointer'), w.hasOwnProperty(ie)) {
      if (Q.ta) return;
      xe("Cannot register type '" + we + "' twice");
    }
    w[ie] = re, delete N0[ie], z0.hasOwnProperty(ie) && (re = z0[ie], delete z0[ie], re.forEach(function(Ge) {
      return Ge();
    }));
  }
  function gi(ie) {
    xe(ie.L.O.M.name + " instance already deleted");
  }
  function dn() {
  }
  function da(ie, re, Q) {
    if (ie[re].R === void 0) {
      var we = ie[re];
      ie[re] = function() {
        return ie[re].R.hasOwnProperty(arguments.length) || xe("Function '" + Q + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + ie[re].R + ")!"), ie[re].R[arguments.length].apply(this, arguments);
      }, ie[re].R = [], ie[re].R[we.Y] = we;
    }
  }
  function os(ie, re, Q, we, Ge, Ue, at, ft) {
    this.name = ie, this.constructor = re, this.W = Q, this.V = we, this.P = Ge, this.oa = Ue, this.aa = at, this.ma = ft, this.ia = [];
  }
  function Bi(ie, re, Q) {
    for (; re !== Q; ) re.aa || xe("Expected null or instance of " + Q.name + ", got an instance of " + re.name), ie = re.aa(ie), re = re.P;
    return ie;
  }
  function on(ie, re) {
    return re === null ? (this.da && xe("null is not a valid " + this.name), 0) : (re.L || xe('Cannot pass "' + r0(re) + '" as a ' + this.name), re.L.N || xe("Cannot pass deleted object as a pointer of type " + this.name), Bi(re.L.N, re.L.O.M, this.M));
  }
  function Rn(ie, re) {
    if (re === null) {
      if (this.da && xe("null is not a valid " + this.name), this.ca) {
        var Q = this.ea();
        return ie !== null && ie.push(this.V, Q), Q;
      }
      return 0;
    }
    if (re.L || xe('Cannot pass "' + r0(re) + '" as a ' + this.name), re.L.N || xe("Cannot pass deleted object as a pointer of type " + this.name), !this.ba && re.L.O.ba && xe("Cannot convert argument of type " + (re.L.T ? re.L.T.name : re.L.O.name) + " to parameter type " + this.name), Q = Bi(re.L.N, re.L.O.M, this.M), this.ca) switch (re.L.S === void 0 && xe("Passing raw pointer to smart pointer is illegal"), this.Aa) {
      case 0:
        re.L.T === this ? Q = re.L.S : xe("Cannot convert argument of type " + (re.L.T ? re.L.T.name : re.L.O.name) + " to parameter type " + this.name);
        break;
      case 1:
        Q = re.L.S;
        break;
      case 2:
        if (re.L.T === this) Q = re.L.S;
        else {
          var we = re.clone();
          Q = this.wa(Q, he(function() {
            we.delete();
          })), ie !== null && ie.push(this.V, Q);
        }
        break;
      default:
        xe("Unsupporting sharing policy");
    }
    return Q;
  }
  function ss(ie, re) {
    return re === null ? (this.da && xe("null is not a valid " + this.name), 0) : (re.L || xe('Cannot pass "' + r0(re) + '" as a ' + this.name), re.L.N || xe("Cannot pass deleted object as a pointer of type " + this.name), re.L.O.ba && xe("Cannot convert argument of type " + re.L.O.name + " to parameter type " + this.name), Bi(re.L.N, re.L.O.M, this.M));
  }
  function cr(ie, re, Q, we) {
    this.name = ie, this.M = re, this.da = Q, this.ba = we, this.ca = !1, this.V = this.wa = this.ea = this.ja = this.Aa = this.va = void 0, re.P !== void 0 ? this.toWireType = Rn : (this.toWireType = we ? on : ss, this.U = null);
  }
  function dr(ie, re) {
    var Q = (ie = Qe(ie)).includes("j") ? /* @__PURE__ */ function(we, Ge) {
      var Ue = [];
      return function() {
        if (Ue.length = 0, Object.assign(Ue, arguments), we.includes("j")) {
          var at = e["dynCall_" + we];
          at = Ue && Ue.length ? at.apply(null, [Ge].concat(Ue)) : at.call(null, Ge);
        } else at = ee.get(Ge).apply(null, Ue);
        return at;
      };
    }(ie, re) : ee.get(re);
    return typeof Q != "function" && xe("unknown function pointer with signature " + ie + ": " + re), Q;
  }
  var ei = void 0;
  function _0(ie, re) {
    var Q = [], we = {};
    throw re.forEach(function Ge(Ue) {
      we[Ue] || w[Ue] || (N0[Ue] ? N0[Ue].forEach(Ge) : (Q.push(Ue), we[Ue] = !0));
    }), new ei(ie + ": " + Q.map(T).join([", "]));
  }
  function br(ie, re, Q, we, Ge) {
    var Ue = re.length;
    2 > Ue && xe("argTypes array size mismatch! Must at least get return value and 'this' types!");
    var at = re[1] !== null && Q !== null, ft = !1;
    for (Q = 1; Q < re.length; ++Q) if (re[Q] !== null && re[Q].U === void 0) {
      ft = !0;
      break;
    }
    var et = re[0].name !== "void", Et = Ue - 2, qe = Array(Et), ze = [], Pt = [];
    return function() {
      if (arguments.length !== Et && xe("function " + ie + " called with " + arguments.length + " arguments, expected " + Et + " args!"), Pt.length = 0, ze.length = at ? 2 : 1, ze[0] = Ge, at) {
        var fr = re[1].toWireType(Pt, this);
        ze[1] = fr;
      }
      for (var Ut = 0; Ut < Et; ++Ut) qe[Ut] = re[Ut + 2].toWireType(Pt, arguments[Ut]), ze.push(qe[Ut]);
      if (Ut = we.apply(null, ze), ft) Ba(Pt);
      else for (var Ht = at ? 1 : 2; Ht < re.length; Ht++) {
        var Tt = Ht === 1 ? fr : qe[Ht - 2];
        re[Ht].U !== null && re[Ht].U(Tt);
      }
      return et ? re[0].fromWireType(Ut) : void 0;
    };
  }
  function _r(ie, re) {
    for (var Q = [], we = 0; we < ie; we++) Q.push(G[re + 4 * we >> 2]);
    return Q;
  }
  function W0(ie) {
    4 < ie && --Z[ie].fa == 0 && (Z[ie] = void 0, se.push(ie));
  }
  function r0(ie) {
    if (ie === null) return "null";
    var re = typeof ie;
    return re === "object" || re === "array" || re === "function" ? ie.toString() : "" + ie;
  }
  function g0(ie, re) {
    switch (re) {
      case 2:
        return function(Q) {
          return this.fromWireType(z[Q >> 2]);
        };
      case 3:
        return function(Q) {
          return this.fromWireType(j[Q >> 3]);
        };
      default:
        throw new TypeError("Unknown float type: " + ie);
    }
  }
  function zn(ie, re, Q) {
    switch (re) {
      case 0:
        return Q ? function(we) {
          return _[we];
        } : function(we) {
          return k[we];
        };
      case 1:
        return Q ? function(we) {
          return P[we >> 1];
        } : function(we) {
          return N[we >> 1];
        };
      case 2:
        return Q ? function(we) {
          return M[we >> 2];
        } : function(we) {
          return G[we >> 2];
        };
      default:
        throw new TypeError("Unknown integer type: " + ie);
    }
  }
  function jn(ie, re) {
    for (var Q = "", we = 0; !(we >= re / 2); ++we) {
      var Ge = P[ie + 2 * we >> 1];
      if (Ge == 0) break;
      Q += String.fromCharCode(Ge);
    }
    return Q;
  }
  function L0(ie, re, Q) {
    if (Q === void 0 && (Q = 2147483647), 2 > Q) return 0;
    var we = re;
    Q = (Q -= 2) < 2 * ie.length ? Q / 2 : ie.length;
    for (var Ge = 0; Ge < Q; ++Ge) P[re >> 1] = ie.charCodeAt(Ge), re += 2;
    return P[re >> 1] = 0, re - we;
  }
  function Ni(ie) {
    return 2 * ie.length;
  }
  function Na(ie, re) {
    for (var Q = 0, we = ""; !(Q >= re / 4); ) {
      var Ge = M[ie + 4 * Q >> 2];
      if (Ge == 0) break;
      ++Q, 65536 <= Ge ? (Ge -= 65536, we += String.fromCharCode(55296 | Ge >> 10, 56320 | 1023 & Ge)) : we += String.fromCharCode(Ge);
    }
    return we;
  }
  function pa(ie, re, Q) {
    if (Q === void 0 && (Q = 2147483647), 4 > Q) return 0;
    var we = re;
    Q = we + Q - 4;
    for (var Ge = 0; Ge < ie.length; ++Ge) {
      var Ue = ie.charCodeAt(Ge);
      if (55296 <= Ue && 57343 >= Ue && (Ue = 65536 + ((1023 & Ue) << 10) | 1023 & ie.charCodeAt(++Ge)), M[re >> 2] = Ue, (re += 4) + 4 > Q) break;
    }
    return M[re >> 2] = 0, re - we;
  }
  function Li(ie) {
    for (var re = 0, Q = 0; Q < ie.length; ++Q) {
      var we = ie.charCodeAt(Q);
      55296 <= we && 57343 >= we && ++Q, re += 4;
    }
    return re;
  }
  var Mi = {};
  function va(ie) {
    var re = Mi[ie];
    return re === void 0 ? Qe(ie) : re;
  }
  var Ui = [], m0 = [], G0 = [null, [], []];
  Fe = e.BindingError = ye("BindingError"), e.count_emval_handles = function() {
    for (var ie = 0, re = 5; re < Z.length; ++re) Z[re] !== void 0 && ++ie;
    return ie;
  }, e.get_first_emval = function() {
    for (var ie = 5; ie < Z.length; ++ie) if (Z[ie] !== void 0) return Z[ie];
    return null;
  }, ke = e.PureVirtualError = ye("PureVirtualError");
  for (var In = Array(256), rt = 0; 256 > rt; ++rt) In[rt] = String.fromCharCode(rt);
  De = In, e.getInheritedInstanceCount = function() {
    return Object.keys(S).length;
  }, e.getLiveInheritedInstances = function() {
    var ie, re = [];
    for (ie in S) S.hasOwnProperty(ie) && re.push(S[ie]);
    return re;
  }, e.flushPendingDeletes = pt, e.setDelayFunction = function(ie) {
    _t = ie, ct.length && _t && _t(pt);
  }, Bt = e.InternalError = ye("InternalError"), dn.prototype.isAliasOf = function(ie) {
    if (!(this instanceof dn && ie instanceof dn)) return !1;
    var re = this.L.O.M, Q = this.L.N, we = ie.L.O.M;
    for (ie = ie.L.N; re.P; ) Q = re.aa(Q), re = re.P;
    for (; we.P; ) ie = we.aa(ie), we = we.P;
    return re === we && Q === ie;
  }, dn.prototype.clone = function() {
    if (this.L.N || gi(this), this.L.$) return this.L.count.value += 1, this;
    var ie = E0, re = Object, Q = re.create, we = Object.getPrototypeOf(this), Ge = this.L;
    return (ie = ie(Q.call(re, we, {
      L: {
        value: {
          count: Ge.count,
          Z: Ge.Z,
          $: Ge.$,
          N: Ge.N,
          O: Ge.O,
          S: Ge.S,
          T: Ge.T
        }
      }
    }))).L.count.value += 1, ie.L.Z = !1, ie;
  }, dn.prototype.delete = function() {
    this.L.N || gi(this), this.L.Z && !this.L.$ && xe("Object already scheduled for deletion"), pe(this), mt(this.L), this.L.$ || (this.L.S = void 0, this.L.N = void 0);
  }, dn.prototype.isDeleted = function() {
    return !this.L.N;
  }, dn.prototype.deleteLater = function() {
    return this.L.N || gi(this), this.L.Z && !this.L.$ && xe("Object already scheduled for deletion"), ct.push(this), ct.length === 1 && _t && _t(pt), this.L.Z = !0, this;
  }, cr.prototype.pa = function(ie) {
    return this.ja && (ie = this.ja(ie)), ie;
  }, cr.prototype.ga = function(ie) {
    this.V && this.V(ie);
  }, cr.prototype.argPackAdvance = 8, cr.prototype.readValueFromPointer = B0, cr.prototype.deleteObject = function(ie) {
    ie !== null && ie.delete();
  }, cr.prototype.fromWireType = function(ie) {
    function re() {
      return this.ca ? P0(this.M.W, {
        O: this.va,
        N: Q,
        T: this,
        S: ie
      }) : P0(this.M.W, {
        O: this,
        N: ie
      });
    }
    var Q = this.pa(ie);
    if (!Q) return this.ga(ie), null;
    var we = function(Ue, at) {
      return at = b(Ue, at), S[at];
    }(this.M, Q);
    if (we !== void 0) return we.L.count.value === 0 ? (we.L.N = Q, we.L.S = ie, we.clone()) : (we = we.clone(), this.ga(ie), we);
    if (we = this.M.oa(Q), !(we = St[we])) return re.call(this);
    we = this.ba ? we.ka : we.pointerType;
    var Ge = gt(Q, this.M, we.M);
    return Ge === null ? re.call(this) : this.ca ? P0(we.M.W, {
      O: we,
      N: Ge,
      T: this,
      S: ie
    }) : P0(we.M.W, {
      O: we,
      N: Ge
    });
  }, ei = e.UnboundTypeError = ye("UnboundTypeError");
  var bt = typeof atob == "function" ? atob : function(ie) {
    var re = "", Q = 0;
    ie = ie.replace(/[^A-Za-z0-9\+\/=]/g, "");
    do {
      var we = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(ie.charAt(Q++)), Ge = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(ie.charAt(Q++)), Ue = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(ie.charAt(Q++)), at = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(ie.charAt(Q++));
      we = we << 2 | Ge >> 4, Ge = (15 & Ge) << 4 | Ue >> 2;
      var ft = (3 & Ue) << 6 | at;
      re += String.fromCharCode(we), Ue !== 64 && (re += String.fromCharCode(Ge)), at !== 64 && (re += String.fromCharCode(ft));
    } while (Q < ie.length);
    return re;
  }, $t = {
    q: function(re, Q, we) {
      re = Qe(re), Q = V(Q, "wrapper"), we = be(we);
      var Ge = [].slice, Ue = Q.M, at = Ue.W, ft = Ue.P.W, et = Ue.P.constructor;
      for (var Et in re = W(re, function() {
        Ue.P.ia.forEach((function(qe) {
          if (this[qe] === ft[qe]) throw new ke("Pure virtual function " + qe + " must be implemented in JavaScript");
        }).bind(this)), Object.defineProperty(this, "__parent", {
          value: at
        }), this.__construct.apply(this, Ge.call(arguments));
      }), at.__construct = function() {
        this === at && xe("Pass correct 'this' to __construct");
        var qe = et.implement.apply(void 0, [this].concat(Ge.call(arguments)));
        pe(qe);
        var ze = qe.L;
        qe.notifyOnDestruction(), ze.$ = !0, Object.defineProperties(this, {
          L: {
            value: ze
          }
        }), E0(this), qe = ze.N, qe = b(Ue, qe), S.hasOwnProperty(qe) ? xe("Tried to register registered instance: " + qe) : S[qe] = this;
      }, at.__destruct = function() {
        this === at && xe("Pass correct 'this' to __destruct"), pe(this);
        var qe = this.L.N;
        qe = b(Ue, qe), S.hasOwnProperty(qe) ? delete S[qe] : xe("Tried to unregister unregistered instance: " + qe);
      }, re.prototype = Object.create(at), we) re.prototype[Et] = we[Et];
      return he(re);
    },
    k: function(re) {
      var Q = Er[re];
      delete Er[re];
      var we = Q.ea, Ge = Q.V, Ue = Q.ha;
      On([re], Ue.map(function(at) {
        return at.sa;
      }).concat(Ue.map(function(at) {
        return at.ya;
      })), function(at) {
        var ft = {};
        return Ue.forEach(function(et, Et) {
          var qe = at[Et], ze = et.qa, Pt = et.ra, fr = at[Et + Ue.length], Ut = et.xa, Ht = et.za;
          ft[et.na] = {
            read: function(a0) {
              return qe.fromWireType(ze(Pt, a0));
            },
            write: function(a0, Zt) {
              var Dr = [];
              Ut(Ht, a0, fr.toWireType(Dr, Zt)), Ba(Dr);
            }
          };
        }), [{
          name: Q.name,
          fromWireType: function(Et) {
            var qe, ze = {};
            for (qe in ft) ze[qe] = ft[qe].read(Et);
            return Ge(Et), ze;
          },
          toWireType: function(Et, qe) {
            for (var ze in ft) if (!(ze in qe)) throw new TypeError('Missing field:  "' + ze + '"');
            var Pt = we();
            for (ze in ft) ft[ze].write(Pt, qe[ze]);
            return Et !== null && Et.push(Ge, Pt), Pt;
          },
          argPackAdvance: 8,
          readValueFromPointer: B0,
          U: Ge
        }];
      });
    },
    w: function() {
    },
    C: function(re, Q, we, Ge, Ue) {
      var at = Pi(we);
      j0(re, {
        name: Q = Qe(Q),
        fromWireType: function(et) {
          return !!et;
        },
        toWireType: function(et, Et) {
          return Et ? Ge : Ue;
        },
        argPackAdvance: 8,
        readValueFromPointer: function(et) {
          if (we === 1) var Et = _;
          else if (we === 2) Et = P;
          else {
            if (we !== 4) throw new TypeError("Unknown boolean type size: " + Q);
            Et = M;
          }
          return this.fromWireType(Et[et >> at]);
        },
        U: null
      });
    },
    f: function(re, Q, we, Ge, Ue, at, ft, et, Et, qe, ze, Pt, fr) {
      ze = Qe(ze), at = dr(Ue, at), et && (et = dr(ft, et)), qe && (qe = dr(Et, qe)), fr = dr(Pt, fr);
      var Ut = Ie(ze);
      (function(Ht, Tt) {
        e.hasOwnProperty(Ht) ? (xe("Cannot register public name '" + Ht + "' twice"), da(e, Ht, Ht), e.hasOwnProperty(void 0) && xe("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"), e[Ht].R[void 0] = Tt) : e[Ht] = Tt;
      })(Ut, function() {
        _0("Cannot construct " + ze + " due to unbound types", [Ge]);
      }), On([re, Q, we], Ge ? [Ge] : [], function(Ht) {
        if (Ht = Ht[0], Ge) var Tt = Ht.M, a0 = Tt.W;
        else a0 = dn.prototype;
        Ht = W(Ut, function() {
          if (Object.getPrototypeOf(this) !== Zt) throw new Fe("Use 'new' to construct " + ze);
          if (Dr.X === void 0) throw new Fe(ze + " has no accessible constructor");
          var je = Dr.X[arguments.length];
          if (je === void 0) throw new Fe("Tried to invoke ctor of " + ze + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(Dr.X).toString() + ") parameters instead!");
          return je.apply(this, arguments);
        });
        var Zt = Object.create(a0, {
          constructor: {
            value: Ht
          }
        });
        Ht.prototype = Zt;
        var Dr = new os(ze, Ht, Zt, fr, Tt, at, et, qe);
        Tt = new cr(ze, Dr, !0, !1), a0 = new cr(ze + "*", Dr, !1, !1);
        var b0 = new cr(ze + " const*", Dr, !1, !0);
        return St[re] = {
          pointerType: a0,
          ka: b0
        }, function(je, Cr) {
          e.hasOwnProperty(je) || yt("Replacing nonexistant public symbol"), e[je] = Cr, e[je].Y = void 0;
        }(Ut, Ht), [Tt, a0, b0];
      });
    },
    d: function(re, Q, we, Ge, Ue, at, ft) {
      var et = _r(we, Ge);
      Q = Qe(Q), at = dr(Ue, at), On([], [re], function(Et) {
        function qe() {
          _0("Cannot call " + ze + " due to unbound types", et);
        }
        var ze = (Et = Et[0]).name + "." + Q;
        Q.startsWith("@@") && (Q = Symbol[Q.substring(2)]);
        var Pt = Et.M.constructor;
        return Pt[Q] === void 0 ? (qe.Y = we - 1, Pt[Q] = qe) : (da(Pt, Q, ze), Pt[Q].R[we - 1] = qe), On([], et, function(fr) {
          return fr = br(ze, [fr[0], null].concat(fr.slice(1)), null, at, ft), Pt[Q].R === void 0 ? (fr.Y = we - 1, Pt[Q] = fr) : Pt[Q].R[we - 1] = fr, [];
        }), [];
      });
    },
    p: function(re, Q, we, Ge, Ue, at) {
      0 < Q || me();
      var ft = _r(Q, we);
      Ue = dr(Ge, Ue), On([], [re], function(et) {
        var Et = "constructor " + (et = et[0]).name;
        if (et.M.X === void 0 && (et.M.X = []), et.M.X[Q - 1] !== void 0) throw new Fe("Cannot register multiple constructors with identical number of parameters (" + (Q - 1) + ") for class '" + et.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
        return et.M.X[Q - 1] = function() {
          _0("Cannot construct " + et.name + " due to unbound types", ft);
        }, On([], ft, function(qe) {
          return qe.splice(1, 0, null), et.M.X[Q - 1] = br(Et, qe, null, Ue, at), [];
        }), [];
      });
    },
    b: function(re, Q, we, Ge, Ue, at, ft, et) {
      var Et = _r(we, Ge);
      Q = Qe(Q), at = dr(Ue, at), On([], [re], function(qe) {
        function ze() {
          _0("Cannot call " + Pt + " due to unbound types", Et);
        }
        var Pt = (qe = qe[0]).name + "." + Q;
        Q.startsWith("@@") && (Q = Symbol[Q.substring(2)]), et && qe.M.ia.push(Q);
        var fr = qe.M.W, Ut = fr[Q];
        return Ut === void 0 || Ut.R === void 0 && Ut.className !== qe.name && Ut.Y === we - 2 ? (ze.Y = we - 2, ze.className = qe.name, fr[Q] = ze) : (da(fr, Q, Pt), fr[Q].R[we - 2] = ze), On([], Et, function(Ht) {
          return Ht = br(Pt, Ht, qe, at, ft), fr[Q].R === void 0 ? (Ht.Y = we - 2, fr[Q] = Ht) : fr[Q].R[we - 2] = Ht, [];
        }), [];
      });
    },
    B: function(re, Q) {
      j0(re, {
        name: Q = Qe(Q),
        fromWireType: function(Ge) {
          var Ue = be(Ge);
          return W0(Ge), Ue;
        },
        toWireType: function(Ge, Ue) {
          return he(Ue);
        },
        argPackAdvance: 8,
        readValueFromPointer: B0,
        U: null
      });
    },
    n: function(re, Q, we) {
      we = Pi(we), j0(re, {
        name: Q = Qe(Q),
        fromWireType: function(Ue) {
          return Ue;
        },
        toWireType: function(Ue, at) {
          return at;
        },
        argPackAdvance: 8,
        readValueFromPointer: g0(Q, we),
        U: null
      });
    },
    e: function(re, Q, we, Ge, Ue) {
      Q = Qe(Q), Ue === -1 && (Ue = 4294967295), Ue = Pi(we);
      var at = function(Et) {
        return Et;
      };
      if (Ge === 0) {
        var ft = 32 - 8 * we;
        at = function(Et) {
          return Et << ft >>> ft;
        };
      }
      we = Q.includes("unsigned") ? function(et, Et) {
        return Et >>> 0;
      } : function(et, Et) {
        return Et;
      }, j0(re, {
        name: Q,
        fromWireType: at,
        toWireType: we,
        argPackAdvance: 8,
        readValueFromPointer: zn(Q, Ue, Ge !== 0),
        U: null
      });
    },
    c: function(re, Q, we) {
      function Ge(at) {
        at >>= 2;
        var ft = G;
        return new Ue(ft.buffer, ft[at + 1], ft[at]);
      }
      var Ue = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][Q];
      j0(re, {
        name: we = Qe(we),
        fromWireType: Ge,
        argPackAdvance: 8,
        readValueFromPointer: Ge
      }, {
        ta: !0
      });
    },
    o: function(re, Q) {
      var we = (Q = Qe(Q)) === "std::string";
      j0(re, {
        name: Q,
        fromWireType: function(Ue) {
          var at = G[Ue >> 2], ft = Ue + 4;
          if (we) for (var et = ft, Et = 0; Et <= at; ++Et) {
            var qe = ft + Et;
            if (Et == at || k[qe] == 0) {
              if (et = et ? te(k, et, qe - et) : "", ze === void 0) var ze = et;
              else ze += "\0", ze += et;
              et = qe + 1;
            }
          }
          else {
            for (ze = Array(at), Et = 0; Et < at; ++Et) ze[Et] = String.fromCharCode(k[ft + Et]);
            ze = ze.join("");
          }
          return y0(Ue), ze;
        },
        toWireType: function(Ue, at) {
          at instanceof ArrayBuffer && (at = new Uint8Array(at));
          var ft, et = typeof at == "string";
          if (et || at instanceof Uint8Array || at instanceof Uint8ClampedArray || at instanceof Int8Array || xe("Cannot pass non-string to std::string"), we && et) {
            var Et = 0;
            for (ft = 0; ft < at.length; ++ft) {
              var qe = at.charCodeAt(ft);
              127 >= qe ? Et++ : 2047 >= qe ? Et += 2 : 55296 <= qe && 57343 >= qe ? (Et += 4, ++ft) : Et += 3;
            }
            ft = Et;
          } else ft = at.length;
          if (qe = (Et = V0(4 + ft + 1)) + 4, G[Et >> 2] = ft, we && et) {
            if (et = qe, qe = ft + 1, ft = k, 0 < qe) {
              qe = et + qe - 1;
              for (var ze = 0; ze < at.length; ++ze) {
                var Pt = at.charCodeAt(ze);
                if (55296 <= Pt && 57343 >= Pt && (Pt = 65536 + ((1023 & Pt) << 10) | 1023 & at.charCodeAt(++ze)), 127 >= Pt) {
                  if (et >= qe) break;
                  ft[et++] = Pt;
                } else {
                  if (2047 >= Pt) {
                    if (et + 1 >= qe) break;
                    ft[et++] = 192 | Pt >> 6;
                  } else {
                    if (65535 >= Pt) {
                      if (et + 2 >= qe) break;
                      ft[et++] = 224 | Pt >> 12;
                    } else {
                      if (et + 3 >= qe) break;
                      ft[et++] = 240 | Pt >> 18, ft[et++] = 128 | Pt >> 12 & 63;
                    }
                    ft[et++] = 128 | Pt >> 6 & 63;
                  }
                  ft[et++] = 128 | 63 & Pt;
                }
              }
              ft[et] = 0;
            }
          } else if (et) for (et = 0; et < ft; ++et) 255 < (ze = at.charCodeAt(et)) && (y0(qe), xe("String has UTF-16 code units that do not fit in 8 bits")), k[qe + et] = ze;
          else for (et = 0; et < ft; ++et) k[qe + et] = at[et];
          return Ue !== null && Ue.push(y0, Et), Et;
        },
        argPackAdvance: 8,
        readValueFromPointer: B0,
        U: function(Ue) {
          y0(Ue);
        }
      });
    },
    j: function(re, Q, we) {
      if (we = Qe(we), Q === 2) var Ge = jn, Ue = L0, at = Ni, ft = function() {
        return N;
      }, et = 1;
      else Q === 4 && (Ge = Na, Ue = pa, at = Li, ft = function() {
        return G;
      }, et = 2);
      j0(re, {
        name: we,
        fromWireType: function(qe) {
          for (var ze, Pt = G[qe >> 2], fr = ft(), Ut = qe + 4, Ht = 0; Ht <= Pt; ++Ht) {
            var Tt = qe + 4 + Ht * Q;
            Ht != Pt && fr[Tt >> et] != 0 || (Ut = Ge(Ut, Tt - Ut), ze === void 0 ? ze = Ut : (ze += "\0", ze += Ut), Ut = Tt + Q);
          }
          return y0(qe), ze;
        },
        toWireType: function(qe, ze) {
          typeof ze != "string" && xe("Cannot pass non-string to C++ string type " + we);
          var Pt = at(ze), fr = V0(4 + Pt + Q);
          return G[fr >> 2] = Pt >> et, Ue(ze, fr + 4, Pt + Q), qe !== null && qe.push(y0, fr), fr;
        },
        argPackAdvance: 8,
        readValueFromPointer: B0,
        U: function(qe) {
          y0(qe);
        }
      });
    },
    l: function(re, Q, we, Ge, Ue, at) {
      Er[re] = {
        name: Qe(Q),
        ea: dr(we, Ge),
        V: dr(Ue, at),
        ha: []
      };
    },
    i: function(re, Q, we, Ge, Ue, at, ft, et, Et, qe) {
      Er[re].ha.push({
        na: Qe(Q),
        sa: we,
        qa: dr(Ge, Ue),
        ra: at,
        ya: ft,
        xa: dr(et, Et),
        za: qe
      });
    },
    D: function(re, Q) {
      j0(re, {
        ua: !0,
        name: Q = Qe(Q),
        argPackAdvance: 0,
        fromWireType: function() {
        },
        toWireType: function() {
        }
      });
    },
    t: function(re, Q, we, Ge, Ue) {
      re = Ui[re], Q = be(Q), we = va(we);
      var at = [];
      return G[Ge >> 2] = he(at), re(Q, we, at, Ue);
    },
    u: function(re, Q, we, Ge) {
      (re = Ui[re])(Q = be(Q), we = va(we), null, Ge);
    },
    h: W0,
    m: function(re, Q) {
      var we = function(ft, et) {
        for (var Et = Array(ft), qe = 0; qe < ft; ++qe) Et[qe] = V(G[et + 4 * qe >> 2], "parameter " + qe);
        return Et;
      }(re, Q), Ge = we[0];
      Q = Ge.name + "_$" + we.slice(1).map(function(ft) {
        return ft.name;
      }).join("_") + "$";
      var Ue = m0[Q];
      if (Ue !== void 0) return Ue;
      var at = Array(re - 1);
      return Ue = function(ft) {
        var et = Ui.length;
        return Ui.push(ft), et;
      }(function(ft, et, Et, qe) {
        for (var ze = 0, Pt = 0; Pt < re - 1; ++Pt) at[Pt] = we[Pt + 1].readValueFromPointer(qe + ze), ze += we[Pt + 1].argPackAdvance;
        for (ft = ft[et].apply(ft, at), Pt = 0; Pt < re - 1; ++Pt) we[Pt + 1].la && we[Pt + 1].la(at[Pt]);
        if (!Ge.ua) return Ge.toWireType(Et, ft);
      }), m0[Q] = Ue;
    },
    r: function(re) {
      4 < re && (Z[re].fa += 1);
    },
    s: function(re) {
      Ba(be(re)), W0(re);
    },
    g: function() {
      me("");
    },
    y: function(re, Q, we) {
      k.copyWithin(re, Q, Q + we);
    },
    x: function(re) {
      var Q = k.length;
      if (2147483648 < (re >>>= 0)) return !1;
      for (var we = 1; 4 >= we; we *= 2) {
        var Ge = Q * (1 + 0.2 / we);
        Ge = Math.min(Ge, re + 100663296);
        var Ue = Math, at = Ue.min;
        Ge = Math.max(re, Ge), Ge += (65536 - Ge % 65536) % 65536;
        e: {
          var ft = x.buffer;
          try {
            x.grow(at.call(Ue, 2147483648, Ge) - ft.byteLength + 65535 >>> 16), J();
            var et = 1;
            break e;
          } catch {
          }
          et = void 0;
        }
        if (et) return !0;
      }
      return !1;
    },
    A: function() {
      return 52;
    },
    v: function() {
      return 70;
    },
    z: function(re, Q, we, Ge) {
      for (var Ue = 0, at = 0; at < we; at++) {
        var ft = G[Q >> 2], et = G[Q + 4 >> 2];
        Q += 8;
        for (var Et = 0; Et < et; Et++) {
          var qe = k[ft + Et], ze = G0[re];
          qe === 0 || qe === 10 ? ((re === 1 ? s : c)(te(ze, 0)), ze.length = 0) : ze.push(qe);
        }
        Ue += et;
      }
      return G[Ge >> 2] = Ue, 0;
    },
    a: x
  }, Qt = function() {
    function ie(Q) {
      e.asm = Q.exports, ee = e.asm.I, de.unshift(e.asm.E), oe--, e.monitorRunDependencies && e.monitorRunDependencies(oe), oe == 0 && ne && (Q = ne, ne = null, Q());
    }
    var re = {
      a: $t
    };
    if (oe++, e.monitorRunDependencies && e.monitorRunDependencies(oe), e.instantiateWasm) try {
      return e.instantiateWasm(re, ie);
    } catch (Q) {
      c("Module.instantiateWasm callback failed with error: " + Q), n(Q);
    }
    return re = function(Q) {
      var we = H;
      try {
        try {
          if (we == H && o) new Uint8Array(o);
          else {
            if (fe(we)) {
              try {
                var Ge = bt(we.slice(37)), Ue = new Uint8Array(Ge.length);
                for (we = 0; we < Ge.length; ++we) Ue[we] = Ge.charCodeAt(we);
                var at = Ue;
              } catch {
                throw Error("Converting base64 string to bytes failed.");
              }
              var ft = at;
            } else ft = void 0;
            if (!ft) throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
          }
        } catch (qe) {
          me(qe);
        }
        var et = new h(), Et = new d(Q);
      } catch (qe) {
        throw Q = qe.toString(), c("failed to compile wasm module: " + Q), (Q.includes("imported Memory") || Q.includes("memory import")) && c("Memory size incompatibility issues may be due to changing INITIAL_MEMORY at runtime to something too large. Use ALLOW_MEMORY_GROWTH to allow any size memory (and also make sure not to set INITIAL_MEMORY at runtime to something smaller than it was at compile time)."), qe;
      }
      return [Et, et];
    }(re), ie(re[0]), e.asm;
  }(), n0 = e.___getTypeName = Qt.F;
  e.__embind_initialize_bindings = Qt.G;
  var Nr, V0 = Qt.H, y0 = Qt.J;
  function u0() {
    function ie() {
      if (!Nr && (Nr = !0, e.calledRun = !0, !R)) {
        if (Re(de), t(e), e.onRuntimeInitialized && e.onRuntimeInitialized(), e.postRun) for (typeof e.postRun == "function" && (e.postRun = [e.postRun]); e.postRun.length; ) {
          var re = e.postRun.shift();
          B.unshift(re);
        }
        Re(B);
      }
    }
    if (!(0 < oe)) {
      if (e.preRun) for (typeof e.preRun == "function" && (e.preRun = [e.preRun]); e.preRun.length; ) q();
      Re(ve), 0 < oe || (e.setStatus ? (e.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          e.setStatus("");
        }, 1), ie();
      }, 1)) : ie());
    }
  }
  if (e.dynCall_jiji = Qt.K, ne = function ie() {
    Nr || u0(), Nr || (ne = ie);
  }, e.preInit) for (typeof e.preInit == "function" && (e.preInit = [e.preInit]); 0 < e.preInit.length; ) e.preInit.pop()();
  return u0(), r;
});
function lre() {
  return sre(ure());
}
var Ct = lre(), zD = function(e) {
  var t = 0, n = "", i = [];
  return e.forEach(function(a) {
    n += a.string, i.push({
      start: t,
      end: t + a.string.length,
      attributes: a.attributes || {}
    }), t += a.string.length;
  }), {
    string: n,
    runs: i
  };
}, jD = function(e, t) {
  switch (t) {
    case "uppercase":
      return e.toUpperCase();
    case "lowercase":
      return e.toLowerCase();
    case "capitalize":
      return CP(e);
    case "upperfirst":
      return Pv(e);
    default:
      return e;
  }
}, cre = /* @__PURE__ */ function() {
  function r(t) {
    this.name = t, this.src = P5.open(null, t);
  }
  var e = r.prototype;
  return e.encode = function(n) {
    return this.src.encode(n);
  }, e.layout = function(n) {
    var i = this, a = this.encode(n), o = a[0], s = a[1];
    return {
      positions: s,
      stringIndices: s.map(function(c, h) {
        return h;
      }),
      glyphs: o.map(function(c, h) {
        var d = i.getGlyph(parseInt(c, 16));
        return d.advanceWidth = s[h].advanceWidth, d;
      })
    };
  }, e.glyphForCodePoint = function(n) {
    var i = this.getGlyph(n);
    return i.advanceWidth = 400, i;
  }, e.getGlyph = function(n) {
    return {
      id: n,
      _font: this.src,
      codePoints: [n],
      isLigature: !1,
      name: this.src.font.characterToGlyph(n)
    };
  }, e.hasGlyphForCodePoint = function(n) {
    return this.src.font.characterToGlyph(n) !== ".notdef";
  }, Sw(r, [{
    key: "ascent",
    get: function() {
      return 900;
    }
    // Based on empirical observation
  }, {
    key: "capHeight",
    get: function() {
      switch (this.name) {
        case "Times-Roman":
        case "Times-Bold":
        case "Times-Italic":
        case "Times-BoldItalic":
          return 650;
        case "Courier":
        case "Courier-Bold":
        case "Courier-Oblique":
        case "Courier-BoldOblique":
          return 550;
        default:
          return 690;
      }
    }
    // Based on empirical observation
  }, {
    key: "xHeight",
    get: function() {
      switch (this.name) {
        case "Times-Roman":
        case "Times-Bold":
        case "Times-Italic":
        case "Times-BoldItalic":
          return 440;
        case "Courier":
        case "Courier-Bold":
        case "Courier-Oblique":
        case "Courier-BoldOblique":
          return 390;
        default:
          return 490;
      }
    }
    // Based on empirical observation
  }, {
    key: "descent",
    get: function() {
      switch (this.name) {
        case "Times-Roman":
        case "Times-Bold":
        case "Times-Italic":
        case "Times-BoldItalic":
          return -220;
        case "Courier":
        case "Courier-Bold":
        case "Courier-Oblique":
        case "Courier-BoldOblique":
          return -230;
        default:
          return -200;
      }
    }
  }, {
    key: "lineGap",
    get: function() {
      return 0;
    }
  }, {
    key: "unitsPerEm",
    get: function() {
      return 1e3;
    }
  }]), r;
}(), $4 = {}, fre = [173], sw = function(e) {
  return e.attributes.fontSize || 12;
}, WD = function(e) {
  if ($4[e]) return $4[e];
  var t = new cre(e);
  return $4[e] = t, t;
}, GD = function() {
  return WD("Helvetica");
}, hre = function(e, t) {
  return !t || !fre.includes(e) && !t.hasGlyphForCodePoint(e) && GD().hasGlyphForCodePoint(e);
}, VD = function() {
  return function(e) {
    for (var t = e.string, n = e.runs, i = null, a = null, o = 0, s = 0, c = [], h = 0; h < n.length; h += 1) {
      var d = n[h], g = typeof d.attributes.font == "string" ? WD(d.attributes.font) : d.attributes.font;
      if (t.length === 0) {
        c.push({
          start: 0,
          end: 0,
          attributes: {
            font: g
          }
        });
        break;
      }
      for (var x = t.slice(d.start, d.end), _ = 0; _ < x.length; _ += 1) {
        var k = x[_], P = k.codePointAt(), N = hre(P, g), M = N ? GD() : g, G = sw(d);
        (M !== i || G !== a || M.unitsPerEm !== i.unitsPerEm) && (i && c.push({
          start: o,
          end: s,
          attributes: {
            font: i,
            scale: a / i.unitsPerEm
          }
        }), i = M, a = G, o = s), s += k.length;
      }
    }
    if (o < t.length) {
      var z = sw(Qo(n));
      c.push({
        start: o,
        end: t.length,
        attributes: {
          font: i,
          scale: z / i.unitsPerEm
        }
      });
    }
    return {
      string: t,
      runs: c
    };
  };
}, dre = function(e) {
  return e.type === fu;
}, pre = {
  linebreaker: yD,
  justification: AD,
  textDecoration: xD,
  scriptItemizer: ED,
  wordHyphenation: DD,
  fontSubstitution: VD
}, vre = mD(pre), gre = function r(e, t) {
  if (!t) return [{
    string: ""
  }];
  for (var n = [], i = t.props, a = i.fill, o = a === void 0 ? "black" : a, s = i.fontFamily, c = s === void 0 ? "Helvetica" : s, h = i.fontWeight, d = i.fontStyle, g = i.fontSize, x = g === void 0 ? 18 : g, _ = i.textDecorationColor, k = i.textDecorationStyle, P = i.textTransform, N = i.opacity, M = t.props.textDecoration, G = e ? e.getFont({
    fontFamily: c,
    fontWeight: h,
    fontStyle: d
  }) : null, z = G ? G.data : c, j = {
    font: z,
    opacity: N,
    fontSize: x,
    color: o,
    underlineStyle: k,
    underline: M === "underline" || M === "underline line-through" || M === "line-through underline",
    underlineColor: _ || o,
    strike: M === "line-through" || M === "underline line-through" || M === "line-through underline",
    strikeStyle: k,
    strikeColor: _ || o
  }, R = 0; R < t.children.length; R += 1) {
    var te = t.children[R];
    dre(te) ? n.push({
      string: jD(te.value, P),
      attributes: j
    }) : te && n.push.apply(n, r(te));
  }
  return n;
}, mre = function(e, t) {
  return zD(gre(e, t));
}, uw = 999999999999, yre = {
  before: -0.5,
  after: -0.5
}, bre = function(e) {
  return function(t) {
    var n, i, a = mre(e, t), o = ((n = t.props) === null || n === void 0 ? void 0 : n.x) || 0, s = ((i = t.props) === null || i === void 0 ? void 0 : i.y) || 0, c = {
      x: o,
      y: s,
      width: uw,
      height: uw
    }, h = t.props.hyphenationCallback || (e == null ? void 0 : e.getHyphenationCallback()) || null, d = {
      hyphenationCallback: h,
      shrinkWhitespaceFactor: yre
    }, g = vre(a, c, d).flat();
    return Object.assign({}, t, {
      lines: g
    });
  };
}, wre = function(e, t) {
  if (!t.children) return t;
  var n = t.children.map(bre(e));
  return Object.assign({}, t, {
    children: n
  });
}, Are = function(e) {
  return e.type === lv;
}, xre = function(e) {
  var t = e.children || [], n = t.find(Are) || {}, i = n.children || [];
  return i.reduce(function(a, o) {
    var s, c = (s = o.props) === null || s === void 0 ? void 0 : s.id;
    return c && (a[c] = o), a;
  }, {});
}, Ere = function(e) {
  return e.type !== lv;
}, _re = function(e) {
  if (!e.children) return e;
  var t = e.children.filter(Ere);
  return Object.assign({}, e, {
    children: t
  });
}, lw = /url\(['"]?#([^'"]+)['"]?\)/, cw = function(e, t) {
  if (t) {
    if (!lw.test(t)) return t;
    var n = t.match(lw);
    return e[n[1]];
  }
}, Dre = function r(e) {
  return function(t) {
    var n, i, a = cw(e, (n = t.props) === null || n === void 0 ? void 0 : n.fill), o = cw(e, (i = t.props) === null || i === void 0 ? void 0 : i.clipPath), s = Object.assign({}, t.props, {
      fill: a,
      clipPath: o
    }), c = t.children ? t.children.map(r(e)) : void 0;
    return Object.assign({}, t, {
      props: s,
      children: c
    });
  };
}, Tre = function(e) {
  if (!e.children) return e;
  var t = xre(e), n = e.children.map(Dre(t));
  return Object.assign({}, e, {
    children: n
  });
}, kre = function(e) {
  return _re(Tre(e));
}, YD = function(e) {
  if (!e) return null;
  var t = e.split(/[,\s]+/).map(parseFloat);
  return t.length !== 4 ? null : {
    minX: t[0],
    minY: t[1],
    maxX: t[2],
    maxY: t[3]
  };
}, Sre = function(e) {
  var t = YD(e.props.viewBox);
  return t ? {
    width: t.maxX,
    height: t.maxY
  } : e.props.width && e.props.height ? {
    width: parseFloat(e.props.width),
    height: parseFloat(e.props.height)
  } : {
    width: 0,
    height: 0
  };
}, Cre = ["x", "y", "clipPath", "clipRule", "opacity", "fill", "fillOpacity", "fillRule", "stroke", "strokeLinecap", "strokeLinejoin", "strokeOpacity", "strokeWidth", "textAnchor", "dominantBaseline", "color", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "opacity", "textDecoration", "lineHeight", "textAlign", "visibility", "wordSpacing"], Fre = function(e) {
  var t = e.props || {};
  return Iv(Cre, t);
}, Ore = function r(e) {
  if (!e.children) return e;
  var t = Fre(e), n = e.children.map(function(i) {
    var a = Object.assign({}, t, i.props || {}), o = Object.assign({}, i, {
      props: a
    });
    return r(o);
  });
  return Object.assign({}, e, {
    children: n
  });
}, Rre = function(e) {
  var t = e.replace(/[\s\r\t\n]+/gm, " ").replace(/^defer\s/, "").split(" "), n = t[0] || "xMidYMid", i = t[1] || "meet";
  return {
    align: n,
    meetOrSlice: i
  };
}, Ire = ["width", "height", "color", "stroke", "strokeWidth", "opacity", "fillOpacity", "strokeOpacity", "fill", "fillRule", "clipPath", "offset", "transform", "strokeLinejoin", "strokeLinecap", "strokeDasharray"], Pre = ["y", "y1", "y2", "height", "cy", "ry"], Bre = ["x", "x1", "x2", "width", "cx", "rx"], Wg = function(e) {
  return function(t) {
    return t.type === e;
  };
}, Nre = Wg(ts), HD = Wg(Gt), Lre = Wg(fu), Mre = function(e) {
  return function(t) {
    return G7(t, function(n, i) {
      var a = ln(n);
      return a && Pre.includes(i) ? a.percent * e.height : a && Bre.includes(i) ? a.percent * e.width : n;
    });
  };
}, z4 = function(e) {
  var t = ln(e);
  return t ? t.percent : parseFloat(e);
}, Ure = function(e) {
  return function(t) {
    var n = Mre(e)(t.props);
    return n = Kd({
      x: parseFloat,
      x1: parseFloat,
      x2: parseFloat,
      y: parseFloat,
      y1: parseFloat,
      y2: parseFloat,
      r: parseFloat,
      rx: parseFloat,
      ry: parseFloat,
      cx: parseFloat,
      cy: parseFloat,
      width: parseFloat,
      height: parseFloat,
      offset: z4,
      fill: Qh,
      opacity: z4,
      stroke: Qh,
      stopOpacity: z4,
      stopColor: Qh,
      transform: J_
    }, n), Object.assign({}, t, {
      props: n
    });
  };
}, $re = function(e) {
  var t = e.style || {}, n = Object.assign({}, t, e.props);
  return Object.assign({}, e, {
    props: n
  });
}, zre = function(e) {
  var t = function(a) {
    return a === "none" ? null : a;
  }, n = G7(e.props, t);
  return Object.assign({}, e, {
    props: n
  });
}, jre = function(e) {
  var t = e.props || {}, n = Iv(Ire, t), i = Object.assign({}, n, e.style || {});
  return Object.assign({}, e, {
    style: i
  });
}, Wre = function(e) {
  var t = Kd({
    width: parseFloat,
    height: parseFloat,
    viewBox: YD,
    preserveAspectRatio: Rre
  }, e.props);
  return Object.assign({}, e, {
    props: t
  });
}, Gre = function(e) {
  return {
    type: cv,
    props: {},
    children: [e]
  };
}, Vre = function(e) {
  if (!HD(e) || !e.children) return e;
  var t = function(a) {
    return Lre(a) ? Gre(a) : a;
  }, n = e.children.map(t);
  return Object.assign({}, e, {
    children: n
  });
}, Yre = function r(e) {
  return function(t) {
    if (HD(t)) return wre(e, t);
    if (!t.children) return t;
    var n = t.children.map(r(e));
    return Object.assign({}, t, {
      children: n
    });
  };
}, Hre = function(e) {
  return fi(Ure(e), Vre, zre, $re);
}, Zre = function r(e) {
  return function(t) {
    if (!t.children) return t;
    var n = fi(r(e), Hre(e)), i = t.children.map(n);
    return Object.assign({}, t, {
      children: i
    });
  };
}, qre = function(e, t) {
  var n = Sre(e);
  return fi(kre, Yre(t), Wre, jre, Ore, Zre(n))(e);
}, Xre = function r(e, t) {
  if (!e.children) return e;
  var n = function(s) {
    return r(s, t);
  }, i = Nre(e) ? qre(e, t) : e, a = i.children.map(n);
  return Object.assign({}, i, {
    children: a
  });
}, fw = function(e) {
  return e.style.zIndex;
}, Kre = function(e) {
  return e.type !== pv && e.type !== ts;
}, Jre = function(e, t) {
  var n = fw(e), i = fw(t);
  return !n && !i ? 0 : n ? i ? i - n : -1 : 1;
}, Qre = function r(e) {
  if (!e.children) return e;
  var t = Kre(e) ? e.children.sort(Jre) : e.children, n = t.map(r);
  return Object.assign({}, e, {
    children: n
  });
}, Ws = {}, ZD = bte(), e0e = function(e) {
  return function() {
    return e.apply(void 0, arguments).then(function(t) {
      return t;
    }, function(t) {
      return t;
    });
  };
}, t0e = function() {
  return e0e($D);
}, r0e = function(e) {
  return e !== "️";
}, hw = function(e) {
  return Array.from(e).filter(r0e).map(function(t) {
    return t.codePointAt(0).toString(16);
  }).join("-");
}, n0e = function(e, t) {
  var n = t.url, i = t.format, a = t.builder;
  return typeof a == "function" ? a(hw(e)) : "" + n + hw(e) + "." + i;
}, dw = function(e, t) {
  if (!t || !t.url && !t.builder) return [];
  var n = [];
  return Array.from(e.matchAll(ZD)).forEach(function(i) {
    var a = i[0];
    if (!Ws[a] || Ws[a].loading) {
      var o = n0e(a, t);
      Ws[a] = {
        loading: !0
      };
      var s = t0e();
      n.push(s({
        uri: o
      }).then(function(c) {
        Ws[a].loading = !1, Ws[a].data = c.data;
      }));
    }
  }), n;
}, i0e = function(e) {
  for (var t = [], n = function() {
    var o = e[i], s = 0;
    Array.from(o.string.matchAll(ZD)).forEach(function(c) {
      var h = c.index, d = c[0], g = o.attributes.fontSize, x = o.string.slice(s, h + c[0].length);
      Ws[d] && Ws[d].data ? t.push({
        string: x.replace(c, "￼"),
        attributes: $r({}, o.attributes, {
          attachment: {
            width: g,
            height: g,
            yOffset: Math.floor(g * 0.1),
            image: Ws[d].data
          }
        })
      }) : t.push({
        string: x.replace(c, "\0"),
        attributes: o.attributes
      }), s = h + d.length;
    }), s < o.string.length && t.push({
      string: o.string.slice(s),
      attributes: o.attributes
    });
  }, i = 0; i < e.length; i += 1)
    n();
  return t;
}, a0e = function(e) {
  var t, n, i;
  return ((t = e.props) === null || t === void 0 ? void 0 : t.src) || ((n = e.props) === null || n === void 0 ? void 0 : n.source) || ((i = e.props) === null || i === void 0 ? void 0 : i.href);
}, o0e = /* @__PURE__ */ function() {
  var r = ui(/* @__PURE__ */ qr().mark(function e(t) {
    var n;
    return qr().wrap(function(a) {
      for (; ; ) switch (a.prev = a.next) {
        case 0:
          if (typeof t != "function") {
            a.next = 6;
            break;
          }
          return a.next = 3, t();
        case 3:
          a.t0 = a.sent, a.next = 9;
          break;
        case 6:
          return a.next = 8, t;
        case 8:
          a.t0 = a.sent;
        case 9:
          return n = a.t0, a.abrupt("return", typeof n == "string" ? {
            uri: n
          } : n);
        case 11:
        case "end":
          return a.stop();
      }
    }, e);
  }));
  return function(t) {
    return r.apply(this, arguments);
  };
}(), s0e = /* @__PURE__ */ function() {
  var r = ui(/* @__PURE__ */ qr().mark(function e(t) {
    var n, i, a;
    return qr().wrap(function(s) {
      for (; ; ) switch (s.prev = s.next) {
        case 0:
          if (n = a0e(t), i = t.props.cache, n) {
            s.next = 5;
            break;
          }
          return console.warn(!1, 'Image should receive either a "src" or "source" prop'), s.abrupt("return");
        case 5:
          return s.prev = 5, s.next = 8, o0e(n);
        case 8:
          if (a = s.sent, a) {
            s.next = 11;
            break;
          }
          throw new Error(`Image's "src" or "source" prop returned ` + a);
        case 11:
          return s.next = 13, $D(a, {
            cache: i
          });
        case 13:
          t.image = s.sent, t.image.key = a.data ? a.data.toString() : a.uri, s.next = 21;
          break;
        case 17:
          s.prev = 17, s.t0 = s.catch(5), t.image = {
            width: 0,
            height: 0,
            key: null
          }, console.warn(s.t0.message);
        case 21:
        case "end":
          return s.stop();
      }
    }, e, null, [[5, 17]]);
  }));
  return function(t) {
    return r.apply(this, arguments);
  };
}(), u0e = function(e) {
  return e.type === cu;
}, l0e = function(e, t) {
  for (var n, i = [], a = ((n = t.children) === null || n === void 0 ? void 0 : n.slice(0)) || [], o = e ? e.getEmojiSource() : null; a.length > 0; ) {
    var s, c = a.shift();
    u0e(c) && i.push(s0e(c)), e && (s = c.style) !== null && s !== void 0 && s.fontFamily && i.push(e.load(c.style)), typeof c == "string" && i.push.apply(i, dw(c, o)), typeof c.value == "string" && i.push.apply(i, dw(c.value, o)), c.children && c.children.forEach(function(h) {
      a.push(h);
    });
  }
  return i;
}, c0e = /* @__PURE__ */ function() {
  var r = ui(/* @__PURE__ */ qr().mark(function e(t, n) {
    var i;
    return qr().wrap(function(o) {
      for (; ; ) switch (o.prev = o.next) {
        case 0:
          return i = l0e(n, t), o.next = 3, Promise.all(i);
        case 3:
          return o.abrupt("return", t);
        case 4:
        case "end":
          return o.stop();
      }
    }, e);
  }));
  return function(t, n) {
    return r.apply(this, arguments);
  };
}(), f0e = function(e) {
  return e.type === Pd;
}, pw = {
  color: "blue",
  textDecoration: "underline"
}, h0e = function(e, t) {
  var n = t.style;
  return f0e(t) && (n = Array.isArray(t.style) ? [pw].concat(t.style) : [pw, t.style]), fQ(e, n);
}, d0e = function r(e) {
  return function(t) {
    var n = h0e(e, t);
    if (!t.children) return Object.assign({}, t, {
      style: n
    });
    var i = t.children.map(r(e));
    return Object.assign({}, t, {
      style: n,
      children: i
    });
  };
}, p0e = function(e) {
  var t, n, i, a, o = ((t = e.props) === null || t === void 0 ? void 0 : t.dpi) || 72, s = ((n = e.box) === null || n === void 0 ? void 0 : n.width) || e.style.width, c = ((i = e.box) === null || i === void 0 ? void 0 : i.height) || e.style.height, h = ((a = e.props) === null || a === void 0 ? void 0 : a.orientation) || "portrait", d = {
    width: s,
    height: c,
    orientation: h,
    dpi: o
  };
  return d0e(d)(e);
}, v0e = function(e) {
  if (!e.children) return e;
  var t = e.children.map(p0e);
  return Object.assign({}, e, {
    children: t
  });
}, vw = function(e) {
  return function(t) {
    var n, i;
    return zr((n = t.style) === null || n === void 0 ? void 0 : n[e]) ? "50%" : (i = t.style) === null || i === void 0 ? void 0 : i[e];
  };
}, g0e = function(e) {
  if (!e.box) return {};
  var t = e.box, n = t.left, i = t.top, a = t.width, o = t.height, s = vw("transformOriginX")(e), c = vw("transformOriginY")(e), h = ln(s), d = ln(c), g = h ? a * h.percent : s, x = d ? o * d.percent : c;
  return {
    left: n + g,
    top: i + x
  };
}, m0e = function r(e) {
  var t = g0e(e), n = Object.assign({}, e, {
    origin: t
  });
  if (!e.children) return n;
  var i = e.children.map(r);
  return Object.assign({}, n, {
    children: i
  });
}, y0e = function(e) {
  if (!e.children) return e;
  var t = e.children.map(m0e);
  return Object.assign({}, e, {
    children: t
  });
}, b0e = function(e) {
  return typeof e == "string" ? {
    title: e,
    fit: !1,
    expanded: !1
  } : e;
}, w0e = function(e) {
  for (var t = 0, n = (e.children || []).slice(0), i = n.map(function(o) {
    return {
      value: o,
      parent: null
    };
  }), a = function() {
    var s, c = i.shift(), h = c.value, d = c.parent;
    if ((s = h.props) !== null && s !== void 0 && s.bookmark) {
      var g, x = b0e(h.props.bookmark), _ = t++, k = $r({
        ref: _,
        parent: (g = d) === null || g === void 0 ? void 0 : g.ref
      }, x);
      h.props.bookmark = k, d = k;
    }
    h.children && h.children.forEach(function(P) {
      i.push({
        value: P,
        parent: d
      });
    });
  }; i.length > 0; )
    a();
  return e;
}, A0e = ["portrait", "landscape"], x0e = function(e) {
  var t, n = ((t = e.props) === null || t === void 0 ? void 0 : t.orientation) || "portrait";
  return A0e.includes(n) ? n : "portrait";
}, E0e = function(e) {
  return x0e(e) === "landscape";
}, _0e = {
  "4A0": [4767.87, 6740.79],
  "2A0": [3370.39, 4767.87],
  A0: [2383.94, 3370.39],
  A1: [1683.78, 2383.94],
  A2: [1190.55, 1683.78],
  A3: [841.89, 1190.55],
  A4: [595.28, 841.89],
  A5: [419.53, 595.28],
  A6: [297.64, 419.53],
  A7: [209.76, 297.64],
  A8: [147.4, 209.76],
  A9: [104.88, 147.4],
  A10: [73.7, 104.88],
  B0: [2834.65, 4008.19],
  B1: [2004.09, 2834.65],
  B2: [1417.32, 2004.09],
  B3: [1000.63, 1417.32],
  B4: [708.66, 1000.63],
  B5: [498.9, 708.66],
  B6: [354.33, 498.9],
  B7: [249.45, 354.33],
  B8: [175.75, 249.45],
  B9: [124.72, 175.75],
  B10: [87.87, 124.72],
  C0: [2599.37, 3676.54],
  C1: [1836.85, 2599.37],
  C2: [1298.27, 1836.85],
  C3: [918.43, 1298.27],
  C4: [649.13, 918.43],
  C5: [459.21, 649.13],
  C6: [323.15, 459.21],
  C7: [229.61, 323.15],
  C8: [161.57, 229.61],
  C9: [113.39, 161.57],
  C10: [79.37, 113.39],
  RA0: [2437.8, 3458.27],
  RA1: [1729.13, 2437.8],
  RA2: [1218.9, 1729.13],
  RA3: [864.57, 1218.9],
  RA4: [609.45, 864.57],
  SRA0: [2551.18, 3628.35],
  SRA1: [1814.17, 2551.18],
  SRA2: [1275.59, 1814.17],
  SRA3: [907.09, 1275.59],
  SRA4: [637.8, 907.09],
  EXECUTIVE: [521.86, 756],
  FOLIO: [612, 936],
  LEGAL: [612, 1008],
  LETTER: [612, 792],
  TABLOID: [792, 1224],
  ID1: [153, 243]
}, Gg = function(e) {
  return {
    width: e[0],
    height: e[1]
  };
}, D0e = function(e) {
  return {
    width: e.height,
    height: e.width
  };
}, T0e = function(e, t) {
  return {
    width: e.width ? e.width * t : e.width,
    height: e.height ? e.height * t : e.height
  };
}, k0e = function(e) {
  return Gg(_0e[e.toUpperCase()]);
}, S0e = function(e) {
  return Gg([e]);
}, C0e = function(e) {
  var t, n, i = ((t = e.props) === null || t === void 0 ? void 0 : t.size) || "A4", a = parseFloat(((n = e.props) === null || n === void 0 ? void 0 : n.dpi) || 72), o = typeof i, s = i;
  return o === "string" ? s = k0e(i) : Array.isArray(i) ? s = Gg(i) : o === "number" && (s = S0e(i)), s = T0e(s, a / 72), E0e(e) ? D0e(s) : s;
}, F0e = function(e) {
  var t = C0e(e), n = Ig(e.style || {});
  return $r({}, e, {
    style: $r({}, n, t)
  });
}, O0e = function(e) {
  if (!e.children) return e;
  var t = e.children.map(F0e);
  return Object.assign({}, e, {
    children: t
  });
}, rv = function(e) {
  var t;
  return ((t = e.props) === null || t === void 0 ? void 0 : t.fixed) === !0;
}, R0e = function(e, t) {
  var n = 0;
  if (!e.lines) return 0;
  for (var i = 0; i < e.lines.length; i += 1) {
    var a = e.lines[i];
    if (n + a.box.height > t) return i;
    n += a.box.height;
  }
  return e.lines.length;
}, I0e = function(e, t) {
  var n = 0;
  if (!e.lines) return n;
  for (var i = 0; i < t; i += 1) {
    var a = e.lines[i];
    if (!a) break;
    n += a.box.height;
  }
  return n;
}, P0e = function(e, t) {
  var n = lp(e, ["box", "top"], 0), i = lp(e, ["props", "widows"], 2), a = lp(e, ["props", "orphans"], 2), o = e.lines.length, s = R0e(e, t - n);
  return s === 0 ? 0 : o < a ? o : s < a || o < a + i ? 0 : o === a + i ? a : o - s < i ? o - i : s;
}, B0e = function(e, t) {
  var n = P0e(e, t), i = I0e(e, n), a = e.box.height - i, o = Object.assign({}, e, {
    box: $r({}, e.box, {
      height: i,
      borderBottomWidth: 0
    }),
    style: $r({}, e.style, {
      marginBottom: 0,
      paddingBottom: 0,
      borderBottomWidth: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }),
    lines: e.lines.slice(0, n)
  }), s = Object.assign({}, e, {
    box: $r({}, e.box, {
      top: 0,
      height: a,
      borderTopWidth: 0
    }),
    style: $r({}, e.style, {
      marginTop: 0,
      paddingTop: 0,
      borderTopWidth: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    }),
    lines: e.lines.slice(n)
  });
  return [o, s];
}, N0e = function(e) {
  var t;
  return ((t = e.box) === null || t === void 0 ? void 0 : t.top) || 0;
}, L0e = function(e) {
  var t;
  return !zr((t = e.style) === null || t === void 0 ? void 0 : t.height);
}, M0e = function(e, t) {
  if (!e) return [null, null];
  var n = N0e(e), i = Object.assign({}, e, {
    box: $r({}, e.box, {
      borderBottomWidth: 0
    }),
    style: $r({}, e.style, {
      marginBottom: 0,
      paddingBottom: 0,
      borderBottomWidth: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    })
  });
  i.style.height = t - n;
  var a = L0e(e) ? e.box.height - (t - n) : null, o = Object.assign({}, e, {
    box: $r({}, e.box, {
      top: 0,
      borderTopWidth: 0
    }),
    style: $r({}, e.style, {
      marginTop: 0,
      paddingTop: 0,
      borderTopWidth: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    })
  });
  return a && (o.style.height = a), [i, o];
}, U0e = [ts, Nd, cu, Ld], qD = function(e) {
  var t;
  return U0e.includes(e.type) ? !1 : zr((t = e.props) === null || t === void 0 ? void 0 : t.wrap) ? !0 : e.props.wrap;
}, fh = function(e, t) {
  var n = e.yogaNode;
  return n ? n.getComputedPadding(t) : null;
}, p2 = function(e) {
  var t = e.style, n = e.box, i = fh(e, Ct.EDGE_TOP) || (n == null ? void 0 : n.paddingTop) || (t == null ? void 0 : t.paddingTop) || (t == null ? void 0 : t.paddingVertical) || (t == null ? void 0 : t.padding) || 0, a = fh(e, Ct.EDGE_RIGHT) || (n == null ? void 0 : n.paddingRight) || (t == null ? void 0 : t.paddingRight) || (t == null ? void 0 : t.paddingHorizontal) || (t == null ? void 0 : t.padding) || 0, o = fh(e, Ct.EDGE_BOTTOM) || (n == null ? void 0 : n.paddingBottom) || (t == null ? void 0 : t.paddingBottom) || (t == null ? void 0 : t.paddingVertical) || (t == null ? void 0 : t.padding) || 0, s = fh(e, Ct.EDGE_LEFT) || (n == null ? void 0 : n.paddingLeft) || (t == null ? void 0 : t.paddingLeft) || (t == null ? void 0 : t.paddingHorizontal) || (t == null ? void 0 : t.padding) || 0;
  return {
    paddingTop: i,
    paddingRight: a,
    paddingBottom: o,
    paddingLeft: s
  };
}, $0e = function(e) {
  var t, n = p2(e), i = n.paddingBottom, a = (t = e.style) === null || t === void 0 ? void 0 : t.height;
  return a - i;
}, z0e = function(e) {
  var t, n = (t = e.style) === null || t === void 0 ? void 0 : t.height, i = p2(e), a = i.paddingTop, o = i.paddingBottom;
  return n - o - a;
}, j0e = ["style", "children"], gw = function(e) {
  return typeof e == "string";
}, W0e = function(e) {
  return typeof e == "number";
}, G0e = function(e) {
  return e && e.type === Symbol.for("react.fragment");
}, V0e = function r(e) {
  if (!e) return [];
  if (gw(e) || W0e(e))
    return [{
      type: fu,
      value: "" + e
    }];
  if (G0e(e))
    return r(e.props.children);
  if (Array.isArray(e))
    return e.reduce(function(d, g) {
      return d.concat(r(g));
    }, []);
  if (!gw(e.type))
    return r(e.type(e.props));
  var t = e.type, n = e.props, i = n.style, a = i === void 0 ? {} : i, o = n.children, s = o === void 0 ? [] : o, c = Vc(n, j0e), h = Xd(s).reduce(function(d, g) {
    return d.concat(r(g));
  }, []);
  return [{
    type: t,
    style: a,
    props: c,
    box: {},
    children: h
  }];
}, Y0e = function(e) {
  var t = 0, n = 1 / 0;
  if (!e || e.length === 0) return 0;
  for (var i = 0; i < e.length; i += 1) {
    var a = e[i];
    n = Math.min(n, a.box.top), t = Math.max(t, a.box.top + a.box.height);
  }
  return t - n;
}, H0e = function(e) {
  var t;
  return ((t = e.props) === null || t === void 0 ? void 0 : t.break) || !1;
}, Z0e = function(e) {
  var t;
  return (t = e.props) === null || t === void 0 ? void 0 : t.minPresenceAhead;
}, q0e = function(e) {
  return function(t) {
    return Math.min(e.box.height, t);
  };
}, X0e = function(e, t) {
  for (var n = 0, i = 0; i < e.length; i += 1) {
    var a = e[i];
    if (a.box) {
      var o = t > a.box.top, s = a.props.presenceAhead || q0e(a);
      a && o && (n += s(t - a.box.top));
    }
  }
  return n;
}, K0e = function(e, t, n) {
  var i = Z0e(e), a = X0e(t, n), o = Y0e(t), s = n < e.box.top + e.box.height, c = qD(e);
  return H0e(e) || !c && s || i < o && a < i;
}, J0e = [
  8232,
  // LINE_SEPARATOR
  8233
  // PARAGRAPH_SEPARATOR
], Q0e = function(e) {
  return J0e.reduce(function(t, n) {
    return e && e.hasGlyphForCodePoint && e.hasGlyphForCodePoint(n) ? t : [].concat(t, [String.fromCharCode(n)]);
  }, []);
}, ene = function(e) {
  return e.map(function(t) {
    var n = Q0e(t.attributes.font), i = new RegExp(n.join("|"));
    return {
      string: t.string.replace(i, ""),
      attributes: t.attributes
    };
  });
}, mw = [ene, i0e], tne = function(e) {
  return e.type === cu;
}, rne = function(e) {
  return e.type === fu;
}, nne = function r(e, t, n, i) {
  var a, o;
  if (i === void 0 && (i = 0), !t) return [{
    string: ""
  }];
  for (var s = [], c = t.style, h = c.color, d = h === void 0 ? "black" : h, g = c.fontFamily, x = g === void 0 ? "Helvetica" : g, _ = c.fontWeight, k = c.fontStyle, P = c.fontSize, N = P === void 0 ? 18 : P, M = c.textAlign, G = M === void 0 ? "left" : M, z = c.lineHeight, j = c.textDecoration, R = c.textDecorationColor, te = c.textDecorationStyle, J = c.textTransform, K = c.letterSpacing, ee = c.textIndent, ve = c.opacity, de = c.verticalAlign, B = {
    fontFamily: x,
    fontWeight: _,
    fontStyle: k
  }, q = e ? e.getFont(B) : null, H = q ? q.data : x, oe = i === 0 ? null : t.style.backgroundColor, ne = {
    font: H,
    color: d,
    opacity: ve,
    fontSize: N,
    backgroundColor: oe,
    align: G,
    indent: ee,
    characterSpacing: K,
    strikeStyle: te,
    underlineStyle: te,
    underline: j === "underline" || j === "underline line-through" || j === "line-through underline",
    strike: j === "line-through" || j === "underline line-through" || j === "line-through underline",
    strikeColor: R || d,
    underlineColor: R || d,
    link: n || ((a = t.props) === null || a === void 0 ? void 0 : a.src) || ((o = t.props) === null || o === void 0 ? void 0 : o.href),
    lineHeight: z ? z * N : null,
    verticalAlign: de
  }, me = 0; me < t.children.length; me += 1) {
    var fe = t.children[me];
    if (tne(fe))
      s.push({
        string: "￼",
        attributes: $r({}, ne, {
          attachment: {
            width: fe.style.width || N,
            height: fe.style.height || N,
            image: fe.image.data
          }
        })
      });
    else if (rne(fe))
      s.push({
        string: jD(fe.value, J),
        attributes: ne
      });
    else if (fe) {
      var _e;
      (_e = s).push.apply(_e, r(e, fe, ne.link, i + 1));
    }
  }
  for (var Re = 0; Re < mw.length; Re += 1) {
    var Ie = mw[Re];
    s = Ie(s);
  }
  return s;
}, ine = function(e, t) {
  var n = nne(e, t);
  return zD(n);
}, ane = {
  linebreaker: yD,
  justification: AD,
  textDecoration: xD,
  scriptItemizer: ED,
  wordHyphenation: DD,
  fontSubstitution: VD
}, one = mD(ane), sne = function(e) {
  var t;
  return (t = e.style) === null || t === void 0 ? void 0 : t.maxLines;
}, une = function(e) {
  var t;
  return (t = e.style) === null || t === void 0 ? void 0 : t.textOverflow;
}, lne = function(e, t, n) {
  var i = sne(n), a = une(n);
  return {
    x: 0,
    y: 0,
    width: e,
    maxLines: i,
    height: t || 1 / 0,
    truncateMode: a
  };
}, cne = function(e, t) {
  return {
    hyphenationPenalty: t.props.hyphenationPenalty,
    shrinkWhitespaceFactor: {
      before: -0.5,
      after: -0.5
    },
    hyphenationCallback: t.props.hyphenationCallback || (e == null ? void 0 : e.getHyphenationCallback()) || null
  };
}, nv = function(e, t, n, i) {
  var a = ine(i, e), o = lne(t, n, e), s = cne(i, e), c = one(a, o, s);
  return c.reduce(function(h, d) {
    return [].concat(h, d);
  }, []);
}, XD = function(e) {
  return function(t) {
    return t.type === e;
  };
}, fne = XD(ts), KD = XD(Gt), hne = function(e) {
  return !fne(e) && !KD(e);
}, dne = function(e) {
  return KD(e) && !e.lines;
}, JD = function r(e, t) {
  if (dne(e)) {
    var n = e.box.width - (e.box.paddingRight + e.box.paddingLeft), i = e.box.height - (e.box.paddingTop + e.box.paddingBottom);
    e.lines = nv(e, n, i, t);
  }
  if (hne(e)) {
    if (!e.children) return e;
    var a = function(c) {
      return r(c, t);
    }, o = e.children.map(a);
    return Object.assign({}, e, {
      children: o
    });
  }
  return e;
}, pne = ["color", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "opacity", "textDecoration", "textTransform", "lineHeight", "textAlign", "visibility", "wordSpacing"], vne = function(e) {
  return e.type === ts;
}, gne = function(e, t, n) {
  switch (e) {
    case "textDecoration":
      return [n, t].filter(function(i) {
        return i && i !== "none";
      }).join(" ");
    default:
      return t;
  }
}, mne = function(e, t) {
  var n = $r({}, e);
  return Object.entries(t).forEach(function(i) {
    var a = i[0], o = i[1];
    n[a] = gne(a, o, e[a]);
  }), n;
}, yne = function(e) {
  return function(t) {
    var n = mne(e, t.style || {});
    return Object.assign({}, t, {
      style: n
    });
  };
}, QD = function r(e) {
  if (vne(e) || !e.children) return e;
  var t = Iv(pne, e.style || {}), n = fi(r, yne(t)), i = e.children.map(n);
  return Object.assign({}, e, {
    children: i
  });
}, hh = function(e, t) {
  var n = e.yogaNode;
  return n ? n.getComputedMargin(t) : null;
}, Vg = function(e) {
  var t = e.style, n = e.box, i = hh(e, Ct.EDGE_TOP) || (n == null ? void 0 : n.marginTop) || (t == null ? void 0 : t.marginTop) || (t == null ? void 0 : t.marginVertical) || (t == null ? void 0 : t.margin) || 0, a = hh(e, Ct.EDGE_RIGHT) || (n == null ? void 0 : n.marginRight) || (t == null ? void 0 : t.marginRight) || (t == null ? void 0 : t.marginHorizontal) || (t == null ? void 0 : t.margin) || 0, o = hh(e, Ct.EDGE_BOTTOM) || (n == null ? void 0 : n.marginBottom) || (t == null ? void 0 : t.marginBottom) || (t == null ? void 0 : t.marginVertical) || (t == null ? void 0 : t.margin) || 0, s = hh(e, Ct.EDGE_LEFT) || (n == null ? void 0 : n.marginLeft) || (t == null ? void 0 : t.marginLeft) || (t == null ? void 0 : t.marginHorizontal) || (t == null ? void 0 : t.margin) || 0;
  return {
    marginTop: i,
    marginRight: a,
    marginBottom: o,
    marginLeft: s
  };
}, bne = function(e) {
  var t = e.yogaNode;
  return {
    top: (t == null ? void 0 : t.getComputedTop()) || 0,
    right: (t == null ? void 0 : t.getComputedRight()) || 0,
    bottom: (t == null ? void 0 : t.getComputedBottom()) || 0,
    left: (t == null ? void 0 : t.getComputedLeft()) || 0
  };
}, wne = {
  width: 0,
  height: 0
}, Ane = function(e) {
  var t = e.yogaNode;
  return t ? {
    width: t.getComputedWidth(),
    height: t.getComputedHeight()
  } : wne;
}, dh = function(e, t) {
  return e ? e.getComputedBorder(t) : 0;
}, xne = function(e) {
  var t = e.yogaNode;
  return {
    borderTopWidth: dh(t, Ct.EDGE_TOP),
    borderRightWidth: dh(t, Ct.EDGE_RIGHT),
    borderBottomWidth: dh(t, Ct.EDGE_BOTTOM),
    borderLeftWidth: dh(t, Ct.EDGE_LEFT)
  };
}, Ene = function(e) {
  return function(t) {
    var n = t.yogaNode;
    return n && n.setDisplay(e === "none" ? Ct.DISPLAY_NONE : Ct.DISPLAY_FLEX), t;
  };
}, _ne = {
  hidden: Ct.OVERFLOW_HIDDEN,
  scroll: Ct.OVERFLOW_SCROLL
}, Dne = function(e) {
  return function(t) {
    var n = t.yogaNode;
    if (!zr(e) && n) {
      var i = _ne[e] || Ct.OVERFLOW_VISIBLE;
      n.setOverflow(i);
    }
    return t;
  };
}, Tne = {
  wrap: Ct.WRAP_WRAP,
  "wrap-reverse": Ct.WRAP_WRAP_REVERSE
}, kne = function(e) {
  return function(t) {
    var n = t.yogaNode;
    if (n) {
      var i = Tne[e] || Ct.WRAP_NO_WRAP;
      n.setFlexWrap(i);
    }
    return t;
  };
}, s0 = function(e, t) {
  return function(n) {
    return function(i) {
      var a = i.yogaNode;
      if (!zr(n) && a) {
        var o = !zr(t), s = "set" + Pv(e), c = s + "Auto", h = s + "Percent", d = ln(n);
        if (d && !a[h])
          throw new Error("You can't pass percentage values to " + e + " property");
        if (d)
          if (o) {
            var g;
            (g = a[h]) === null || g === void 0 || g.call(a, t, d.value);
          } else {
            var x;
            (x = a[h]) === null || x === void 0 || x.call(a, d.value);
          }
        else if (n === "auto")
          if (o) {
            var _;
            (_ = a[c]) === null || _ === void 0 || _.call(a, t);
          } else {
            var k;
            (k = a[c]) === null || k === void 0 || k.call(a);
          }
        else if (o) {
          var P;
          (P = a[s]) === null || P === void 0 || P.call(a, t, n);
        } else {
          var N;
          (N = a[s]) === null || N === void 0 || N.call(a, n);
        }
      }
      return i;
    };
  };
}, Sne = function(e) {
  return function(t) {
    return s0("flexGrow")(e || 0)(t);
  };
}, Cne = s0("flexBasis"), Fne = {
  "flex-start": Ct.ALIGN_FLEX_START,
  center: Ct.ALIGN_CENTER,
  "flex-end": Ct.ALIGN_FLEX_END,
  stretch: Ct.ALIGN_STRETCH,
  baseline: Ct.ALIGN_BASELINE,
  "space-between": Ct.ALIGN_SPACE_BETWEEN,
  "space-around": Ct.ALIGN_SPACE_AROUND
}, Yg = function(e) {
  return function(t) {
    return function(n) {
      var i = n.yogaNode, a = e === "items" ? Ct.ALIGN_STRETCH : Ct.ALIGN_AUTO;
      if (i) {
        var o = Fne[t] || a;
        i["setAlign" + Pv(e)](o);
      }
      return n;
    };
  };
}, One = Yg("self"), Rne = Yg("items"), Ine = function(e) {
  return function(t) {
    return s0("flexShrink")(e || 1)(t);
  };
}, Pne = function(e) {
  return function(t) {
    var n = t.yogaNode;
    return !zr(e) && n && n.setAspectRatio(e), t;
  };
}, Bne = Yg("content"), Nne = function(e) {
  return function(t) {
    var n = t.yogaNode;
    return !zr(e) && n && n.setPositionType(e === "absolute" ? Ct.POSITION_TYPE_ABSOLUTE : Ct.POSITION_TYPE_RELATIVE), t;
  };
}, Lne = {
  row: Ct.FLEX_DIRECTION_ROW,
  "row-reverse": Ct.FLEX_DIRECTION_ROW_REVERSE,
  "column-reverse": Ct.FLEX_DIRECTION_COLUMN_REVERSE
}, Mne = function(e) {
  return function(t) {
    var n = t.yogaNode;
    if (n) {
      var i = Lne[e] || Ct.FLEX_DIRECTION_COLUMN;
      n.setFlexDirection(i);
    }
    return t;
  };
}, Une = {
  center: Ct.JUSTIFY_CENTER,
  "flex-end": Ct.JUSTIFY_FLEX_END,
  "space-between": Ct.JUSTIFY_SPACE_BETWEEN,
  "space-around": Ct.JUSTIFY_SPACE_AROUND,
  "space-evenly": Ct.JUSTIFY_SPACE_EVENLY
}, $ne = function(e) {
  return function(t) {
    var n = t.yogaNode;
    if (!zr(e) && n) {
      var i = Une[e] || Ct.JUSTIFY_FLEX_START;
      n.setJustifyContent(i);
    }
    return t;
  };
}, zne = s0("margin", Ct.EDGE_TOP), jne = s0("margin", Ct.EDGE_RIGHT), Wne = s0("margin", Ct.EDGE_BOTTOM), Gne = s0("margin", Ct.EDGE_LEFT), Vne = s0("padding", Ct.EDGE_TOP), Yne = s0("padding", Ct.EDGE_RIGHT), Hne = s0("padding", Ct.EDGE_BOTTOM), Zne = s0("padding", Ct.EDGE_LEFT), qne = s0("border", Ct.EDGE_TOP), Xne = s0("border", Ct.EDGE_RIGHT), Kne = s0("border", Ct.EDGE_BOTTOM), Jne = s0("border", Ct.EDGE_LEFT), Qne = s0("position", Ct.EDGE_TOP), eie = s0("position", Ct.EDGE_RIGHT), tie = s0("position", Ct.EDGE_BOTTOM), rie = s0("position", Ct.EDGE_LEFT), nie = s0("width"), iie = s0("minWidth"), aie = s0("maxWidth"), oie = s0("height"), sie = s0("minHeight"), uie = s0("maxHeight"), eT = function(e, t) {
  var n = ln(t);
  if (n)
    throw new Error("You can't pass percentage values to " + e + " property");
}, lie = function(e) {
  return function(t) {
    var n = t.yogaNode;
    return !zr(e) && n && (eT("rowGap", e), n.setGap(Ct.GUTTER_ROW, e)), t;
  };
}, cie = function(e) {
  return function(t) {
    var n = t.yogaNode;
    return !zr(e) && n && (eT("columnGap", e), n.setGap(Ct.GUTTER_COLUMN, e)), t;
  };
}, fie = function(e) {
  return e ? (e.maxX - e.minX) / (e.maxY - e.minY) : null;
}, hie = function(e, t) {
  return function(n, i, a, o) {
    var s = fie(t.props.viewBox) || 1;
    return i === Ct.MEASURE_MODE_EXACTLY || i === Ct.MEASURE_MODE_AT_MOST ? {
      width: n,
      height: n / s
    } : o === Ct.MEASURE_MODE_EXACTLY ? {
      width: a * s
    } : {};
  };
}, yw = function(e) {
  return e.lines ? Math.max.apply(Math, [0].concat(e.lines.map(function(t) {
    return t.xAdvance;
  }))) : 0;
}, bw = function(e) {
  return e.lines ? e.lines.reduce(function(t, n) {
    return t + n.box.height;
  }, 0) : -1;
}, die = {
  center: 0.5,
  right: 1
}, pie = function(e, t, n) {
  return function(i, a, o) {
    if (a === Ct.MEASURE_MODE_EXACTLY)
      return t.lines || (t.lines = nv(t, i, o, n)), {
        height: bw(t)
      };
    if (a === Ct.MEASURE_MODE_AT_MOST) {
      var s, c = die[(s = t.style) === null || s === void 0 ? void 0 : s.textAlign] || 0;
      return t.lines || (t.lines = nv(t, i, o, n), t.alignOffset = (i - yw(t)) * c), {
        height: bw(t),
        width: Math.min(i, yw(t))
      };
    }
    return {};
  };
}, vie = function(e) {
  var t;
  return (t = e.image) !== null && t !== void 0 && t.data ? e.image.width / e.image.height : 1;
}, tT = function(e) {
  var t;
  return zr((t = e.box) === null || t === void 0 ? void 0 : t.height);
}, gie = 10, mie = function(e, t) {
  return function(n, i, a, o) {
    var s = vie(t), c = Vg(t), h = p2(e), d = tT(e) ? 1 / 0 : e.box.height - h.paddingTop - h.paddingBottom - c.marginTop - c.marginBottom - gie;
    if (!t.image) return {
      width: 0,
      height: 0
    };
    if (i === Ct.MEASURE_MODE_EXACTLY && o === Ct.MEASURE_MODE_UNDEFINED) {
      var g = n / s;
      return {
        height: Math.min(d, g)
      };
    }
    if (o === Ct.MEASURE_MODE_EXACTLY && (i === Ct.MEASURE_MODE_AT_MOST || i === Ct.MEASURE_MODE_UNDEFINED))
      return {
        width: Math.min(a * s, n)
      };
    if (i === Ct.MEASURE_MODE_EXACTLY && o === Ct.MEASURE_MODE_AT_MOST) {
      var x = n / s;
      return {
        height: Math.min(a, d, x)
      };
    }
    return i === Ct.MEASURE_MODE_AT_MOST && o === Ct.MEASURE_MODE_AT_MOST ? s > 1 ? {
      width: n,
      height: Math.min(n / s, a)
    } : {
      height: a,
      width: Math.min(a * s, n)
    } : {
      height: a,
      width: n
    };
  };
}, yie = 10, ww = function(e) {
  return Math.max.apply(Math, [-1 / 0].concat(e));
}, bie = function() {
  var e = {}, t = [], n = function() {
    return e;
  }, i = function(d, g) {
    return t.push([d, g]);
  }, a = function() {
    return i.apply(void 0, arguments), e;
  }, o = function(d, g, x, _) {
    return i(d, g), i(d + x, g), i(d, g + _), i(d + x, g + _), e;
  }, s = function(d, g, x, _) {
    return _ = _ || x, i(d - x, g - _), i(d + x, g - _), i(d + x, g + _), i(d - x, g + _), e;
  }, c = function() {
    return t.push.apply(t, arguments), e;
  };
  return e.rect = o, e.moveTo = a, e.lineTo = a, e.circle = s, e.polygon = c, e.ellipse = s, e.roundedRect = o, e.text = n, e.path = n, e.lineWidth = n, e.bezierCurveTo = n, e.quadraticCurveTo = n, e.scale = n, e.rotate = n, e.translate = n, e.dash = n, e.clip = n, e.save = n, e.fill = n, e.font = n, e.stroke = n, e.lineCap = n, e.opacity = n, e.restore = n, e.lineJoin = n, e.fontSize = n, e.fillColor = n, e.miterLimit = n, e.strokeColor = n, e.fillOpacity = n, e.strokeOpacity = n, e.linearGradient = n, e.radialGradient = n, e.getWidth = function() {
    return ww(t.map(function(h) {
      return h[0];
    }));
  }, e.getHeight = function() {
    return ww(t.map(function(h) {
      return h[1];
    }));
  }, e;
}, wie = function(e, t) {
  return function() {
    var n = Vg(t), i = p2(e), a = tT(e) ? 1 / 0 : e.box.height - i.paddingTop - i.paddingBottom - n.marginTop - n.marginBottom - yie, o = bie();
    t.props.paint(o);
    var s = o.getWidth(), c = Math.min(a, o.getHeight());
    return {
      height: c,
      width: s
    };
  };
}, rT = Ct.Config.create();
rT.setPointScaleFactor(0);
var Pl = function(e) {
  return function(t) {
    return t.type === e;
  };
}, nT = Pl(ts), iT = Pl(Gt), Aie = Pl(Nd), xie = Pl(Bd), Eie = Pl(cu), _ie = Pl(Ld), Die = Pl(fu), Tie = function(e) {
  var t = xie(e) ? e.box.height : e.style.height;
  return oie(t);
}, kie = function(e) {
  fi(Tie(e), nie(e.style.width), iie(e.style.minWidth), aie(e.style.maxWidth), sie(e.style.minHeight), uie(e.style.maxHeight), zne(e.style.marginTop), jne(e.style.marginRight), Wne(e.style.marginBottom), Gne(e.style.marginLeft), Vne(e.style.paddingTop), Yne(e.style.paddingRight), Hne(e.style.paddingBottom), Zne(e.style.paddingLeft), Nne(e.style.position), Qne(e.style.top), eie(e.style.right), tie(e.style.bottom), rie(e.style.left), qne(e.style.borderTopWidth), Xne(e.style.borderRightWidth), Kne(e.style.borderBottomWidth), Jne(e.style.borderLeftWidth), Ene(e.style.display), Mne(e.style.flexDirection), One(e.style.alignSelf), Bne(e.style.alignContent), Rne(e.style.alignItems), $ne(e.style.justifyContent), kne(e.style.flexWrap), Dne(e.style.overflow), Pne(e.style.aspectRatio), Cne(e.style.flexBasis), Sne(e.style.flexGrow), Ine(e.style.flexShrink), lie(e.style.rowGap), cie(e.style.columnGap))(e);
}, Sie = function(e) {
  return function(t) {
    return e.insertChild(t.yogaNode, e.getChildCount()), t;
  };
}, Cie = function(e, t, n) {
  var i = e.yogaNode;
  return iT(e) && i.setMeasureFunc(pie(t, e, n)), Eie(e) && i.setMeasureFunc(mie(t, e)), _ie(e) && i.setMeasureFunc(wie(t, e)), nT(e) && i.setMeasureFunc(hie(t, e)), e;
}, Fie = function(e) {
  return !iT(e) && !Aie(e) && !nT(e);
}, Oie = function r(e, t) {
  return function(n) {
    var i = Ct.Node.createWithConfig(rT), a = Object.assign({}, n, {
      yogaNode: i
    });
    if (kie(a), Fie(n) && n.children) {
      var o = fi(Sie(i), r(e, t));
      a.children = n.children.map(o);
    }
    return Cie(a, e, t), a;
  };
}, Rie = function(e) {
  return e.yogaNode.calculateLayout(), e;
}, Iie = function r(e) {
  if (Die(e)) return e;
  var t = Object.assign(p2(e), Vg(e), xne(e), bne(e), Ane(e)), n = Object.assign({}, e, {
    box: t
  });
  if (!e.children) return n;
  var i = e.children.map(r);
  return Object.assign({}, n, {
    children: i
  });
}, Pie = function r(e) {
  var t = Object.assign({}, e);
  if (delete t.yogaNode, !e.children) return t;
  var n = e.children.map(r);
  return Object.assign({}, t, {
    children: n
  });
}, Bie = function(e) {
  return e.yogaNode && e.yogaNode.freeRecursive(), e;
}, aT = function(e, t) {
  return zr(e) ? null : fi(Pie, Bie, Iie, Rie, Oie(e, t))(e);
}, Nie = function(e, t) {
  if (!e.children) return e;
  var n = function(o) {
    return aT(o, t);
  }, i = e.children.map(n);
  return Object.assign({}, e, {
    children: i
  });
}, oT = function(e) {
  return e.type === Gt;
}, Lie = 1e-3, iv = function(e, t) {
  return Object.assign({}, t, {
    children: e
  });
}, sT = function(e) {
  var t;
  return ((t = e.box) === null || t === void 0 ? void 0 : t.top) || 0;
}, Mie = function(e) {
  return e.every(rv);
}, uT = function(e) {
  var t;
  return !zr((t = e.props) === null || t === void 0 ? void 0 : t.render);
}, lT = fi(JD, QD, aT), Uie = function(e) {
  console.warn("Node of type " + e.type + " can't wrap between pages and it's bigger than available page height");
}, cT = function(e, t, n) {
  for (var i = [], a = [], o = 0; o < n.length; o += 1) {
    var s = n[o], c = n.slice(o + 1), h = c.filter(rv), d = sT(s), g = s.box.height, x = e <= d, _ = K0e(s, c, e), k = e + Lie < d + g, P = qD(s), N = g <= t;
    if (rv(s)) {
      a.push(s), i.push(s);
      continue;
    }
    if (x) {
      var M = Object.assign({}, s.box, {
        top: s.box.top - e
      }), G = Object.assign({}, s, {
        box: M
      });
      a.push(G);
      continue;
    }
    if (!N && !P) {
      i.push(s), a.push.apply(a, c), Uie(s);
      break;
    }
    if (_) {
      var z = Object.assign({}, s.box, {
        top: s.box.top - e
      }), j = Object.assign({}, s.props, {
        wrap: !0,
        break: !1
      }), R = Object.assign({}, s, {
        box: z,
        props: j
      });
      i.push.apply(i, h), a.push.apply(a, [R].concat(c));
      break;
    }
    if (k) {
      var te = jie(s, e, t), J = te[0], K = te[1];
      if (s.children.length > 0 && J.children.length === 0) {
        var ee = Object.assign({}, s.box, {
          top: s.box.top - e
        }), ve = Object.assign({}, s, {
          box: ee
        });
        i.push.apply(i, h), a.push.apply(a, [ve].concat(c));
        break;
      }
      J && i.push(J), K && a.push(K);
      continue;
    }
    i.push(s);
  }
  return [i, a];
}, $ie = function(e, t, n) {
  var i = n.children || [], a = e - sT(n);
  return cT(a, t, i);
}, zie = function(e, t, n) {
  var i = M0e(e, t), a = i[0], o = i[1], s = $ie(t, n, e), c = s[0], h = s[1];
  return [iv(c, a), iv(h, o)];
}, jie = function(e, t, n) {
  return oT(e) ? B0e(e, t) : zie(e, t, n);
}, Wie = function r(e) {
  var t = e.children || [];
  return uT(e) || t.some(r);
}, Gie = function r(e, t) {
  var n = uT(t), i = function(d) {
    if (d === void 0 && (d = []), n) {
      var g = t.props.render(e);
      return V0e(g).filter(Boolean).map(function(x) {
        return r(e, x);
      });
    }
    return d.map(function(x) {
      return r(e, x);
    });
  }, a = n && oT(t), o = a ? $r({}, t.box, {
    height: 0
  }) : t.box, s = i(t.children), c = n ? null : t.lines;
  return Object.assign({}, t, {
    box: o,
    lines: c,
    children: s
  });
}, fT = function(e, t, n) {
  if (Wie(t)) {
    var i = Gie(e, t);
    return lT(i, n);
  }
  return t;
}, Aw = function(e, t, n) {
  var i = $0e(e), a = z0e(e), o = fT({
    pageNumber: t
  }, e, n), s = e.style.height, c = cT(i, a, o.children), h = c[0], d = c[1], g = function(G) {
    return lT(G, n);
  }, x = $r({}, e.box, {
    height: s
  }), _ = g(Object.assign({}, e, {
    box: x,
    children: h
  }));
  if (d.length === 0 || Mie(d)) return [_, null];
  var k = s3("height", e.box), P = s3("bookmark", e.props), N = g(Object.assign({}, e, {
    props: P,
    box: k,
    children: d
  }));
  return [_, N];
}, Vie = function(e, t, n, i) {
  var a = i.length, o = {
    totalPages: a,
    pageNumber: n + 1,
    subPageNumber: t.subPageNumber + 1,
    subPageTotalPages: t.subPageTotalPages
  };
  return fT(o, t, e);
}, Yie = function(e) {
  return e.map(function(t, n) {
    return $r({}, t, {
      subPageNumber: n,
      subPageTotalPages: e.length
    });
  });
}, Hie = function(e) {
  return s3(["subPageNumber", "subPageTotalPages"], e);
}, Zie = function(e, t, n) {
  var i;
  if (!e) return [];
  if (((i = e.props) === null || i === void 0 ? void 0 : i.wrap) === !1) return [e];
  for (var a = Aw(e, t, n), o = [a[0]], s = a[1]; s !== null; )
    a = Aw(s, t + o.length, n), o.push(a[0]), s = a[1];
  return o;
}, qie = function(e, t) {
  for (var n = [], i = 1, a = 0; a < e.children.length; a += 1) {
    var o = e.children[a], s = Zie(o, i, t);
    s = Yie(s), i += s.length, n = n.concat(s);
  }
  return n = n.map(function() {
    for (var c = arguments.length, h = new Array(c), d = 0; d < c; d++)
      h[d] = arguments[d];
    return Hie(Vie.apply(void 0, [t].concat(h)));
  }), iv(n, e);
}, xw = function(e) {
  return function(t) {
    var n = ln(t);
    return n ? n.percent * e.width : t;
  };
}, Ew = function(e) {
  return function(t) {
    var n = ln(t);
    return n ? n.percent * e.height : t;
  };
}, Xie = function(e) {
  var t = e.style, n = Kd({
    paddingTop: Ew(t),
    paddingLeft: xw(t),
    paddingRight: xw(t),
    paddingBottom: Ew(t)
  }, e.style);
  return Object.assign({}, e, {
    style: n
  });
}, Kie = function(e) {
  if (!e.children) return e;
  var t = e.children.map(Xie);
  return Object.assign({}, e, {
    children: t
  });
}, ph = function(e) {
  return function(t) {
    if (t) {
      var n = ln(t);
      return n ? n.percent * Math.min(e.width, e.height) : t;
    }
  };
}, Jie = function r(e) {
  var t = Kd({
    borderTopLeftRadius: ph(e.box),
    borderTopRightRadius: ph(e.box),
    borderBottomRightRadius: ph(e.box),
    borderBottomLeftRadius: ph(e.box)
  }, e.style || {}), n = Object.assign({}, e, {
    style: t
  });
  if (!e.children) return n;
  var i = e.children.map(r);
  return Object.assign({}, n, {
    children: i
  });
}, Qie = function(e, t) {
  var n = ln(t);
  return n ? n.percent * e : t;
}, eae = function(e) {
  var t, n, i = e.style.height, a = ((t = e.style) === null || t === void 0 ? void 0 : t.paddingTop) || 0, o = ((n = e.style) === null || n === void 0 ? void 0 : n.paddingBottom) || 0;
  return i - a - o;
}, tae = function(e, t) {
  var n, i;
  if (zr((n = e.style) === null || n === void 0 ? void 0 : n.height) || zr((i = t.style) === null || i === void 0 ? void 0 : i.height)) return t;
  var a = eae(e), o = Qie(a, t.style.height), s = Object.assign({}, t.style, {
    height: o
  });
  return Object.assign({}, t, {
    style: s
  });
}, rae = function(e) {
  if (!e.children) return e;
  var t = function(a) {
    return tae(e, a);
  }, n = e.children.map(t);
  return Object.assign({}, e, {
    children: n
  });
}, nae = function(e) {
  if (!e.children) return e;
  var t = e.children.map(rae);
  return Object.assign({}, e, {
    children: t
  });
}, Hg = function(e) {
  return function(t) {
    return t.type === e;
  };
}, iae = Hg(Pd), hT = Hg(Gt), dT = Hg(fu), aae = function(e) {
  var t;
  return !!((t = e.props) !== null && t !== void 0 && t.render);
}, oae = function(e) {
  return hT(e) || dT(e);
}, sae = function(e) {
  var t = e.children || [];
  return t.every(dT) ? !0 : t.every(hT) ? !1 : t.every(oae);
}, uae = function(e) {
  var t = {
    type: Gt,
    props: {},
    style: {},
    box: {},
    children: e.children
  };
  return Object.assign({}, e, {
    children: [t]
  });
}, lae = function(e) {
  return iae(e) ? aae(e) ? Object.assign({}, e, {
    type: Gt
  }) : sae(e) ? uae(e) : e : e;
}, cae = function r(e) {
  if (!e.children) return e;
  var t = fi(lae, r), n = e.children.map(t);
  return Object.assign({}, e, {
    children: n
  });
}, fae = SP(Qre, y0e, qie, JD, Jie, Nie, Xre, c0e, QD, nae, Kie, v0e, cae, w0e, O0e), hae = DT();
const dae = /* @__PURE__ */ I0(hae);
var av = { exports: {} }, j4 = {};
/** @license React v0.17.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _w;
function pae() {
  return _w || (_w = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 });
    var e, t, n, i, a;
    if (typeof window > "u" || typeof MessageChannel != "function") {
      var o = null, s = null, c = function() {
        if (o !== null) try {
          var ye = r.unstable_now();
          o(!0, ye), o = null;
        } catch (Fe) {
          throw setTimeout(c, 0), Fe;
        }
      }, h = Date.now();
      r.unstable_now = function() {
        return Date.now() - h;
      }, e = function(ye) {
        o !== null ? setTimeout(e, 0, ye) : (o = ye, setTimeout(c, 0));
      }, t = function(ye, Fe) {
        s = setTimeout(ye, Fe);
      }, n = function() {
        clearTimeout(s);
      }, i = function() {
        return !1;
      }, a = r.unstable_forceFrameRate = function() {
      };
    } else {
      var d = window.performance, g = window.Date, x = window.setTimeout, _ = window.clearTimeout, k = window.requestAnimationFrame, P = window.cancelAnimationFrame;
      if (typeof console < "u" && (typeof k != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), typeof P != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")), typeof d == "object" && typeof d.now == "function") r.unstable_now = function() {
        return d.now();
      };
      else {
        var N = g.now();
        r.unstable_now = function() {
          return g.now() - N;
        };
      }
      var M = !1, G = null, z = -1, j = 5, R = 0;
      i = function() {
        return r.unstable_now() >= R;
      }, a = function() {
      }, r.unstable_forceFrameRate = function(ye) {
        0 > ye || 125 < ye ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : j = 0 < ye ? Math.floor(1e3 / ye) : 33.33;
      };
      var te = new MessageChannel(), J = te.port2;
      te.port1.onmessage = function() {
        if (G !== null) {
          var ye = r.unstable_now();
          R = ye + j;
          try {
            G(!0, ye) ? J.postMessage(null) : (M = !1, G = null);
          } catch (Fe) {
            throw J.postMessage(null), Fe;
          }
        } else M = !1;
      }, e = function(ye) {
        G = ye, M || (M = !0, J.postMessage(null));
      }, t = function(ye, Fe) {
        z = x(function() {
          ye(r.unstable_now());
        }, Fe);
      }, n = function() {
        _(z), z = -1;
      };
    }
    function K(ye, Fe) {
      var xe = ye.length;
      ye.push(Fe);
      e: for (; ; ) {
        var be = Math.floor((xe - 1) / 2), he = ye[be];
        if (he !== void 0 && 0 < de(he, Fe)) ye[be] = Fe, ye[xe] = he, xe = be;
        else break e;
      }
    }
    function ee(ye) {
      return ye = ye[0], ye === void 0 ? null : ye;
    }
    function ve(ye) {
      var Fe = ye[0];
      if (Fe !== void 0) {
        var xe = ye.pop();
        if (xe !== Fe) {
          ye[0] = xe;
          e: for (var be = 0, he = ye.length; be < he; ) {
            var ke = 2 * (be + 1) - 1, De = ye[ke], Qe = ke + 1, ct = ye[Qe];
            if (De !== void 0 && 0 > de(De, xe)) ct !== void 0 && 0 > de(ct, De) ? (ye[be] = ct, ye[Qe] = xe, be = Qe) : (ye[be] = De, ye[ke] = xe, be = ke);
            else if (ct !== void 0 && 0 > de(ct, xe)) ye[be] = ct, ye[Qe] = xe, be = Qe;
            else break e;
          }
        }
        return Fe;
      }
      return null;
    }
    function de(ye, Fe) {
      var xe = ye.sortIndex - Fe.sortIndex;
      return xe !== 0 ? xe : ye.id - Fe.id;
    }
    var B = [], q = [], H = 1, oe = null, ne = 3, me = !1, fe = !1, _e = !1;
    function Re(ye) {
      for (var Fe = ee(q); Fe !== null; ) {
        if (Fe.callback === null) ve(q);
        else if (Fe.startTime <= ye) ve(q), Fe.sortIndex = Fe.expirationTime, K(B, Fe);
        else break;
        Fe = ee(q);
      }
    }
    function Ie(ye) {
      if (_e = !1, Re(ye), !fe) if (ee(B) !== null) fe = !0, e(W);
      else {
        var Fe = ee(q);
        Fe !== null && t(Ie, Fe.startTime - ye);
      }
    }
    function W(ye, Fe) {
      fe = !1, _e && (_e = !1, n()), me = !0;
      var xe = ne;
      try {
        for (Re(Fe), oe = ee(B); oe !== null && (!(oe.expirationTime > Fe) || ye && !i()); ) {
          var be = oe.callback;
          if (be !== null) {
            oe.callback = null, ne = oe.priorityLevel;
            var he = be(oe.expirationTime <= Fe);
            Fe = r.unstable_now(), typeof he == "function" ? oe.callback = he : oe === ee(B) && ve(B), Re(Fe);
          } else ve(B);
          oe = ee(B);
        }
        if (oe !== null) var ke = !0;
        else {
          var De = ee(q);
          De !== null && t(Ie, De.startTime - Fe), ke = !1;
        }
        return ke;
      } finally {
        oe = null, ne = xe, me = !1;
      }
    }
    function Z(ye) {
      switch (ye) {
        case 1:
          return -1;
        case 2:
          return 250;
        case 5:
          return 1073741823;
        case 4:
          return 1e4;
        default:
          return 5e3;
      }
    }
    var se = a;
    r.unstable_ImmediatePriority = 1, r.unstable_UserBlockingPriority = 2, r.unstable_NormalPriority = 3, r.unstable_IdlePriority = 5, r.unstable_LowPriority = 4, r.unstable_runWithPriority = function(ye, Fe) {
      switch (ye) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          ye = 3;
      }
      var xe = ne;
      ne = ye;
      try {
        return Fe();
      } finally {
        ne = xe;
      }
    }, r.unstable_next = function(ye) {
      switch (ne) {
        case 1:
        case 2:
        case 3:
          var Fe = 3;
          break;
        default:
          Fe = ne;
      }
      var xe = ne;
      ne = Fe;
      try {
        return ye();
      } finally {
        ne = xe;
      }
    }, r.unstable_scheduleCallback = function(ye, Fe, xe) {
      var be = r.unstable_now();
      if (typeof xe == "object" && xe !== null) {
        var he = xe.delay;
        he = typeof he == "number" && 0 < he ? be + he : be, xe = typeof xe.timeout == "number" ? xe.timeout : Z(ye);
      } else xe = Z(ye), he = be;
      return xe = he + xe, ye = { id: H++, callback: Fe, priorityLevel: ye, startTime: he, expirationTime: xe, sortIndex: -1 }, he > be ? (ye.sortIndex = he, K(q, ye), ee(B) === null && ye === ee(q) && (_e ? n() : _e = !0, t(Ie, he - be))) : (ye.sortIndex = xe, K(B, ye), fe || me || (fe = !0, e(W))), ye;
    }, r.unstable_cancelCallback = function(ye) {
      ye.callback = null;
    }, r.unstable_wrapCallback = function(ye) {
      var Fe = ne;
      return function() {
        var xe = ne;
        ne = Fe;
        try {
          return ye.apply(this, arguments);
        } finally {
          ne = xe;
        }
      };
    }, r.unstable_getCurrentPriorityLevel = function() {
      return ne;
    }, r.unstable_shouldYield = function() {
      var ye = r.unstable_now();
      Re(ye);
      var Fe = ee(B);
      return Fe !== oe && oe !== null && Fe !== null && Fe.callback !== null && Fe.startTime <= ye && Fe.expirationTime < oe.expirationTime || i();
    }, r.unstable_requestPaint = se, r.unstable_continueExecution = function() {
      fe || me || (fe = !0, e(W));
    }, r.unstable_pauseExecution = function() {
    }, r.unstable_getFirstCallbackNode = function() {
      return ee(B);
    }, r.unstable_Profiling = null;
  }(j4)), j4;
}
var W4 = {};
/** @license React v0.17.0
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dw;
function vae() {
  return Dw || (Dw = 1, function(r) {
    process.env.NODE_ENV !== "production" && function() {
      Object.defineProperty(r, "__esModule", { value: !0 });
      var e = !1, t = !0, n, i, a, o, s;
      if (
        // If Scheduler runs in a non-DOM environment, it falls back to a naive
        // implementation using setTimeout.
        typeof window > "u" || // Check if MessageChannel is supported, too.
        typeof MessageChannel != "function"
      ) {
        var c = null, h = null, d = function() {
          if (c !== null)
            try {
              var rt = r.unstable_now(), bt = !0;
              c(bt, rt), c = null;
            } catch ($t) {
              throw setTimeout(d, 0), $t;
            }
        }, g = Date.now();
        r.unstable_now = function() {
          return Date.now() - g;
        }, n = function(rt) {
          c !== null ? setTimeout(n, 0, rt) : (c = rt, setTimeout(d, 0));
        }, i = function(rt, bt) {
          h = setTimeout(rt, bt);
        }, a = function() {
          clearTimeout(h);
        }, o = function() {
          return !1;
        }, s = r.unstable_forceFrameRate = function() {
        };
      } else {
        var x = window.performance, _ = window.Date, k = window.setTimeout, P = window.clearTimeout, N = window.requestAnimationFrame, M = window.cancelAnimationFrame;
        if (typeof console < "u" && (typeof N != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), typeof M != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")), typeof x == "object" && typeof x.now == "function")
          r.unstable_now = function() {
            return x.now();
          };
        else {
          var G = _.now();
          r.unstable_now = function() {
            return _.now() - G;
          };
        }
        var z = !1, j = null, R = -1, te = (
          // We won't attempt to align with the vsync. Instead we'll yield multiple
          // times per frame, often enough to keep it responsive even at really
          // high frame rates > 120.
          5
        ), J = 0;
        o = function() {
          return r.unstable_now() >= J;
        }, s = function() {
        }, r.unstable_forceFrameRate = function(rt) {
          if (rt < 0 || rt > 125) {
            console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported");
            return;
          }
          rt > 0 ? te = Math.floor(1e3 / rt) : te = 33.33;
        };
        var K = function() {
          if (j !== null) {
            var rt = r.unstable_now();
            J = rt + te;
            var bt = !0;
            try {
              var $t = j(bt, rt);
              $t ? ve.postMessage(null) : (z = !1, j = null);
            } catch (Qt) {
              throw ve.postMessage(null), Qt;
            }
          } else
            z = !1;
        }, ee = new MessageChannel(), ve = ee.port2;
        ee.port1.onmessage = K, n = function(rt) {
          j = rt, z || (z = !0, ve.postMessage(null));
        }, i = function(rt, bt) {
          R = k(function() {
            rt(r.unstable_now());
          }, bt);
        }, a = function() {
          P(R), R = -1;
        };
      }
      function de(rt, bt) {
        var $t = rt.length;
        rt.push(bt), H(rt, bt, $t);
      }
      function B(rt) {
        var bt = rt[0];
        return bt === void 0 ? null : bt;
      }
      function q(rt) {
        var bt = rt[0];
        if (bt !== void 0) {
          var $t = rt.pop();
          return $t !== bt && (rt[0] = $t, oe(rt, $t, 0)), bt;
        } else
          return null;
      }
      function H(rt, bt, $t) {
        for (var Qt = $t; ; ) {
          var n0 = Math.floor((Qt - 1) / 2), Nr = rt[n0];
          if (Nr !== void 0 && ne(Nr, bt) > 0)
            rt[n0] = bt, rt[Qt] = Nr, Qt = n0;
          else
            return;
        }
      }
      function oe(rt, bt, $t) {
        for (var Qt = $t, n0 = rt.length; Qt < n0; ) {
          var Nr = (Qt + 1) * 2 - 1, V0 = rt[Nr], y0 = Nr + 1, u0 = rt[y0];
          if (V0 !== void 0 && ne(V0, bt) < 0)
            u0 !== void 0 && ne(u0, V0) < 0 ? (rt[Qt] = u0, rt[y0] = bt, Qt = y0) : (rt[Qt] = V0, rt[Nr] = bt, Qt = Nr);
          else if (u0 !== void 0 && ne(u0, bt) < 0)
            rt[Qt] = u0, rt[y0] = bt, Qt = y0;
          else
            return;
        }
      }
      function ne(rt, bt) {
        var $t = rt.sortIndex - bt.sortIndex;
        return $t !== 0 ? $t : rt.id - bt.id;
      }
      var me = 0, fe = 1, _e = 2, Re = 3, Ie = 4, W = 5, Z = 0, se = 0, ye = 4, Fe = (
        // $FlowFixMe Flow doesn't know about SharedArrayBuffer
        typeof SharedArrayBuffer == "function" ? new SharedArrayBuffer(ye * Int32Array.BYTES_PER_ELEMENT) : (
          // $FlowFixMe Flow doesn't know about ArrayBuffer
          typeof ArrayBuffer == "function" ? new ArrayBuffer(ye * Int32Array.BYTES_PER_ELEMENT) : null
        )
      ), xe = Fe !== null ? new Int32Array(Fe) : [], be = 0, he = 1, ke = 2, De = 3;
      xe[be] = me, xe[De] = 0, xe[he] = 0;
      var Qe = 131072, ct = 524288, pt = 0, _t = null, S = null, b = 0, w = 1, T = 2, V = 3, pe = 4, Ee = 5, mt = 6, gt = 7, St = 8;
      function Bt(rt) {
        if (S !== null) {
          var bt = b;
          if (b += rt.length, b + 1 > pt) {
            if (pt *= 2, pt > ct) {
              console.error("Scheduler Profiling: Event log exceeded maximum size. Don't forget to call `stopLoggingProfilingEvents()`."), P0();
              return;
            }
            var $t = new Int32Array(pt * 4);
            $t.set(S), _t = $t.buffer, S = $t;
          }
          S.set(rt, bt);
        }
      }
      function yt() {
        pt = Qe, _t = new ArrayBuffer(pt * 4), S = new Int32Array(_t), b = 0;
      }
      function P0() {
        var rt = _t;
        return pt = 0, _t = null, S = null, b = 0, rt;
      }
      function E0(rt, bt) {
        xe[De]++, S !== null && Bt([w, bt * 1e3, rt.id, rt.priorityLevel]);
      }
      function Er(rt, bt) {
        xe[be] = me, xe[he] = 0, xe[De]--, S !== null && Bt([T, bt * 1e3, rt.id]);
      }
      function Ba(rt, bt) {
        xe[De]--, S !== null && Bt([pe, bt * 1e3, rt.id]);
      }
      function B0(rt, bt) {
        xe[be] = me, xe[he] = 0, xe[De]--, S !== null && Bt([V, bt * 1e3, rt.id]);
      }
      function z0(rt, bt) {
        Z++, xe[be] = rt.priorityLevel, xe[he] = rt.id, xe[ke] = Z, S !== null && Bt([Ee, bt * 1e3, rt.id, Z]);
      }
      function N0(rt, bt) {
        xe[be] = me, xe[he] = 0, xe[ke] = 0, S !== null && Bt([mt, bt * 1e3, rt.id, Z]);
      }
      function On(rt) {
        se++, S !== null && Bt([gt, rt * 1e3, se]);
      }
      function Pi(rt) {
        S !== null && Bt([St, rt * 1e3, se]);
      }
      var j0 = 1073741823, gi = -1, dn = 250, da = 5e3, os = 1e4, Bi = j0, on = [], Rn = [], ss = 1, cr = null, dr = Re, ei = !1, _0 = !1, br = !1;
      function _r(rt) {
        for (var bt = B(Rn); bt !== null; ) {
          if (bt.callback === null)
            q(Rn);
          else if (bt.startTime <= rt)
            q(Rn), bt.sortIndex = bt.expirationTime, de(on, bt), E0(bt, rt), bt.isQueued = !0;
          else
            return;
          bt = B(Rn);
        }
      }
      function W0(rt) {
        if (br = !1, _r(rt), !_0)
          if (B(on) !== null)
            _0 = !0, n(r0);
          else {
            var bt = B(Rn);
            bt !== null && i(W0, bt.startTime - rt);
          }
      }
      function r0(rt, bt) {
        Pi(bt), _0 = !1, br && (br = !1, a()), ei = !0;
        var $t = dr;
        try {
          if (t)
            try {
              return g0(rt, bt);
            } catch (Nr) {
              if (cr !== null) {
                var Qt = r.unstable_now();
                B0(cr, Qt), cr.isQueued = !1;
              }
              throw Nr;
            }
        } finally {
          cr = null, dr = $t, ei = !1;
          {
            var n0 = r.unstable_now();
            On(n0);
          }
        }
      }
      function g0(rt, bt) {
        var $t = bt;
        for (_r($t), cr = B(on); cr !== null && !e && !(cr.expirationTime > $t && (!rt || o())); ) {
          var Qt = cr.callback;
          if (Qt !== null) {
            cr.callback = null, dr = cr.priorityLevel;
            var n0 = cr.expirationTime <= $t;
            z0(cr, $t);
            var Nr = Qt(n0);
            $t = r.unstable_now(), typeof Nr == "function" ? (cr.callback = Nr, N0(cr, $t)) : (Er(cr, $t), cr.isQueued = !1, cr === B(on) && q(on)), _r($t);
          } else
            q(on);
          cr = B(on);
        }
        if (cr !== null)
          return !0;
        var V0 = B(Rn);
        return V0 !== null && i(W0, V0.startTime - $t), !1;
      }
      function zn(rt, bt) {
        switch (rt) {
          case fe:
          case _e:
          case Re:
          case Ie:
          case W:
            break;
          default:
            rt = Re;
        }
        var $t = dr;
        dr = rt;
        try {
          return bt();
        } finally {
          dr = $t;
        }
      }
      function jn(rt) {
        var bt;
        switch (dr) {
          case fe:
          case _e:
          case Re:
            bt = Re;
            break;
          default:
            bt = dr;
            break;
        }
        var $t = dr;
        dr = bt;
        try {
          return rt();
        } finally {
          dr = $t;
        }
      }
      function L0(rt) {
        var bt = dr;
        return function() {
          var $t = dr;
          dr = bt;
          try {
            return rt.apply(this, arguments);
          } finally {
            dr = $t;
          }
        };
      }
      function Ni(rt) {
        switch (rt) {
          case fe:
            return gi;
          case _e:
            return dn;
          case W:
            return Bi;
          case Ie:
            return os;
          case Re:
          default:
            return da;
        }
      }
      function Na(rt, bt, $t) {
        var Qt = r.unstable_now(), n0, Nr;
        if (typeof $t == "object" && $t !== null) {
          var V0 = $t.delay;
          typeof V0 == "number" && V0 > 0 ? n0 = Qt + V0 : n0 = Qt, Nr = typeof $t.timeout == "number" ? $t.timeout : Ni(rt);
        } else
          Nr = Ni(rt), n0 = Qt;
        var y0 = n0 + Nr, u0 = {
          id: ss++,
          callback: bt,
          priorityLevel: rt,
          startTime: n0,
          expirationTime: y0,
          sortIndex: -1
        };
        return u0.isQueued = !1, n0 > Qt ? (u0.sortIndex = n0, de(Rn, u0), B(on) === null && u0 === B(Rn) && (br ? a() : br = !0, i(W0, n0 - Qt))) : (u0.sortIndex = y0, de(on, u0), E0(u0, Qt), u0.isQueued = !0, !_0 && !ei && (_0 = !0, n(r0))), u0;
      }
      function pa() {
      }
      function Li() {
        !_0 && !ei && (_0 = !0, n(r0));
      }
      function Mi() {
        return B(on);
      }
      function va(rt) {
        if (rt.isQueued) {
          var bt = r.unstable_now();
          Ba(rt, bt), rt.isQueued = !1;
        }
        rt.callback = null;
      }
      function Ui() {
        return dr;
      }
      function m0() {
        var rt = r.unstable_now();
        _r(rt);
        var bt = B(on);
        return bt !== cr && cr !== null && bt !== null && bt.callback !== null && bt.startTime <= rt && bt.expirationTime < cr.expirationTime || o();
      }
      var G0 = s, In = {
        startLoggingProfilingEvents: yt,
        stopLoggingProfilingEvents: P0,
        sharedProfilingBuffer: Fe
      };
      r.unstable_ImmediatePriority = fe, r.unstable_UserBlockingPriority = _e, r.unstable_NormalPriority = Re, r.unstable_IdlePriority = W, r.unstable_LowPriority = Ie, r.unstable_runWithPriority = zn, r.unstable_next = jn, r.unstable_scheduleCallback = Na, r.unstable_cancelCallback = va, r.unstable_wrapCallback = L0, r.unstable_getCurrentPriorityLevel = Ui, r.unstable_shouldYield = m0, r.unstable_requestPaint = G0, r.unstable_continueExecution = Li, r.unstable_pauseExecution = pa, r.unstable_getFirstCallbackNode = Mi, r.unstable_Profiling = In;
    }();
  }(W4)), W4;
}
process.env.NODE_ENV === "production" ? av.exports = pae() : av.exports = vae();
var Id = av.exports;
const gae = /* @__PURE__ */ I0(Id), mae = /* @__PURE__ */ MT({
  __proto__: null,
  default: gae
}, [Id]);
function yae(r) {
  if (r.__esModule) return r;
  var e = Object.defineProperty({}, "__esModule", { value: !0 });
  return Object.keys(r).forEach(function(t) {
    var n = Object.getOwnPropertyDescriptor(r, t);
    Object.defineProperty(e, t, n.get ? n : {
      enumerable: !0,
      get: function() {
        return r[t];
      }
    });
  }), e;
}
var pT = { exports: {} }, bae = /* @__PURE__ */ yae(mae);
/** @license React v0.23.0
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(r) {
  r.exports = function e(t) {
    var n = dae, i = bT, a = bae;
    function o(y) {
      for (var v = "https://reactjs.org/docs/error-decoder.html?invariant=" + y, A = 1; A < arguments.length; A++) v += "&args[]=" + encodeURIComponent(arguments[A]);
      return "Minified React error #" + y + "; visit " + v + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var s = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    s.hasOwnProperty("ReactCurrentDispatcher") || (s.ReactCurrentDispatcher = {
      current: null
    }), s.hasOwnProperty("ReactCurrentBatchConfig") || (s.ReactCurrentBatchConfig = {
      suspense: null
    });
    var c = typeof Symbol == "function" && Symbol.for, h = c ? Symbol.for("react.element") : 60103, d = c ? Symbol.for("react.portal") : 60106, g = c ? Symbol.for("react.fragment") : 60107, x = c ? Symbol.for("react.strict_mode") : 60108, _ = c ? Symbol.for("react.profiler") : 60114, k = c ? Symbol.for("react.provider") : 60109, P = c ? Symbol.for("react.context") : 60110, N = c ? Symbol.for("react.concurrent_mode") : 60111, M = c ? Symbol.for("react.forward_ref") : 60112, G = c ? Symbol.for("react.suspense") : 60113, z = c ? Symbol.for("react.suspense_list") : 60120, j = c ? Symbol.for("react.memo") : 60115, R = c ? Symbol.for("react.lazy") : 60116, te = typeof Symbol == "function" && Symbol.iterator;
    function J(y) {
      return y === null || typeof y != "object" ? null : (y = te && y[te] || y["@@iterator"], typeof y == "function" ? y : null);
    }
    function K(y) {
      if (y._status === -1) {
        y._status = 0;
        var v = y._ctor;
        v = v(), y._result = v, v.then(function(A) {
          y._status === 0 && (A = A.default, y._status = 1, y._result = A);
        }, function(A) {
          y._status === 0 && (y._status = 2, y._result = A);
        });
      }
    }
    function ee(y) {
      if (y == null) return null;
      if (typeof y == "function") return y.displayName || y.name || null;
      if (typeof y == "string") return y;
      switch (y) {
        case g:
          return "Fragment";
        case d:
          return "Portal";
        case _:
          return "Profiler";
        case x:
          return "StrictMode";
        case G:
          return "Suspense";
        case z:
          return "SuspenseList";
      }
      if (typeof y == "object") switch (y.$$typeof) {
        case P:
          return "Context.Consumer";
        case k:
          return "Context.Provider";
        case M:
          var v = y.render;
          return v = v.displayName || v.name || "", y.displayName || (v !== "" ? "ForwardRef(" + v + ")" : "ForwardRef");
        case j:
          return ee(y.type);
        case R:
          if (y = y._status === 1 ? y._result : null) return ee(y);
      }
      return null;
    }
    function ve(y) {
      var v = y, A = y;
      if (y.alternate) for (; v.return; ) v = v.return;
      else {
        y = v;
        do
          v = y, v.effectTag & 1026 && (A = v.return), y = v.return;
        while (y);
      }
      return v.tag === 3 ? A : null;
    }
    function de(y) {
      if (ve(y) !== y) throw Error(o(188));
    }
    function B(y) {
      var v = y.alternate;
      if (!v) {
        if (v = ve(y), v === null) throw Error(o(188));
        return v !== y ? null : y;
      }
      for (var A = y, C = v; ; ) {
        var I = A.return;
        if (I === null) break;
        var L = I.alternate;
        if (L === null) {
          if (C = I.return, C !== null) {
            A = C;
            continue;
          }
          break;
        }
        if (I.child === L.child) {
          for (L = I.child; L; ) {
            if (L === A) return de(I), y;
            if (L === C) return de(I), v;
            L = L.sibling;
          }
          throw Error(o(188));
        }
        if (A.return !== C.return) A = I, C = L;
        else {
          for (var ae = !1, it = I.child; it; ) {
            if (it === A) {
              ae = !0, A = I, C = L;
              break;
            }
            if (it === C) {
              ae = !0, C = I, A = L;
              break;
            }
            it = it.sibling;
          }
          if (!ae) {
            for (it = L.child; it; ) {
              if (it === A) {
                ae = !0, A = L, C = I;
                break;
              }
              if (it === C) {
                ae = !0, C = L, A = I;
                break;
              }
              it = it.sibling;
            }
            if (!ae) throw Error(o(189));
          }
        }
        if (A.alternate !== C) throw Error(o(190));
      }
      if (A.tag !== 3) throw Error(o(188));
      return A.stateNode.current === A ? y : v;
    }
    function q(y) {
      if (y = B(y), !y) return null;
      for (var v = y; ; ) {
        if (v.tag === 5 || v.tag === 6) return v;
        if (v.child) v.child.return = v, v = v.child;
        else {
          if (v === y) break;
          for (; !v.sibling; ) {
            if (!v.return || v.return === y) return null;
            v = v.return;
          }
          v.sibling.return = v.return, v = v.sibling;
        }
      }
      return null;
    }
    function H(y) {
      if (y = B(y), !y) return null;
      for (var v = y; ; ) {
        if (v.tag === 5 || v.tag === 6) return v;
        if (v.child && v.tag !== 4) v.child.return = v, v = v.child;
        else {
          if (v === y) break;
          for (; !v.sibling; ) {
            if (!v.return || v.return === y) return null;
            v = v.return;
          }
          v.sibling.return = v.return, v = v.sibling;
        }
      }
      return null;
    }
    var oe = t.getPublicInstance, ne = t.getRootHostContext, me = t.getChildHostContext, fe = t.prepareForCommit, _e = t.resetAfterCommit, Re = t.createInstance, Ie = t.appendInitialChild, W = t.finalizeInitialChildren, Z = t.prepareUpdate, se = t.shouldSetTextContent, ye = t.shouldDeprioritizeSubtree, Fe = t.createTextInstance, xe = t.setTimeout, be = t.clearTimeout, he = t.noTimeout, ke = t.isPrimaryRenderer, De = t.supportsMutation, Qe = t.supportsPersistence, ct = t.supportsHydration, pt = t.appendChild, _t = t.appendChildToContainer, S = t.commitTextUpdate, b = t.commitMount, w = t.commitUpdate, T = t.insertBefore, V = t.insertInContainerBefore, pe = t.removeChild, Ee = t.removeChildFromContainer, mt = t.resetTextContent, gt = t.hideInstance, St = t.hideTextInstance, Bt = t.unhideInstance, yt = t.unhideTextInstance, P0 = t.cloneInstance, E0 = t.createContainerChildSet, Er = t.appendChildToContainerChildSet, Ba = t.finalizeContainerChildren, B0 = t.replaceContainerChildren, z0 = t.cloneHiddenInstance, N0 = t.cloneHiddenTextInstance, On = t.canHydrateInstance, Pi = t.canHydrateTextInstance, j0 = t.isSuspenseInstancePending, gi = t.isSuspenseInstanceFallback, dn = t.getNextHydratableSibling, da = t.getFirstHydratableChild, os = t.hydrateInstance, Bi = t.hydrateTextInstance, on = t.getNextHydratableInstanceAfterSuspenseInstance, Rn = t.commitHydratedContainer, ss = t.commitHydratedSuspenseInstance, cr = /^(.*)[\\\/]/;
    function dr(y) {
      var v = "";
      do {
        e: switch (y.tag) {
          case 3:
          case 4:
          case 6:
          case 7:
          case 10:
          case 9:
            var A = "";
            break e;
          default:
            var C = y._debugOwner, I = y._debugSource, L = ee(y.type);
            A = null, C && (A = ee(C.type)), C = L, L = "", I ? L = " (at " + I.fileName.replace(cr, "") + ":" + I.lineNumber + ")" : A && (L = " (created by " + A + ")"), A = `
    in ` + (C || "Unknown") + L;
        }
        v += A, y = y.return;
      } while (y);
      return v;
    }
    var ei = [], _0 = -1;
    function br(y) {
      0 > _0 || (y.current = ei[_0], ei[_0] = null, _0--);
    }
    function _r(y, v) {
      _0++, ei[_0] = y.current, y.current = v;
    }
    var W0 = {}, r0 = {
      current: W0
    }, g0 = {
      current: !1
    }, zn = W0;
    function jn(y, v) {
      var A = y.type.contextTypes;
      if (!A) return W0;
      var C = y.stateNode;
      if (C && C.__reactInternalMemoizedUnmaskedChildContext === v) return C.__reactInternalMemoizedMaskedChildContext;
      var I = {}, L;
      for (L in A) I[L] = v[L];
      return C && (y = y.stateNode, y.__reactInternalMemoizedUnmaskedChildContext = v, y.__reactInternalMemoizedMaskedChildContext = I), I;
    }
    function L0(y) {
      return y = y.childContextTypes, y != null;
    }
    function Ni(y) {
      br(g0), br(r0);
    }
    function Na(y) {
      br(g0), br(r0);
    }
    function pa(y, v, A) {
      if (r0.current !== W0) throw Error(o(168));
      _r(r0, v), _r(g0, A);
    }
    function Li(y, v, A) {
      var C = y.stateNode;
      if (y = v.childContextTypes, typeof C.getChildContext != "function") return A;
      C = C.getChildContext();
      for (var I in C) if (!(I in y)) throw Error(o(108, ee(v) || "Unknown", I));
      return n({}, A, {}, C);
    }
    function Mi(y) {
      var v = y.stateNode;
      return v = v && v.__reactInternalMemoizedMergedChildContext || W0, zn = r0.current, _r(r0, v), _r(g0, g0.current), !0;
    }
    function va(y, v, A) {
      var C = y.stateNode;
      if (!C) throw Error(o(169));
      A ? (v = Li(y, v, zn), C.__reactInternalMemoizedMergedChildContext = v, br(g0), br(r0), _r(r0, v)) : br(g0), _r(g0, A);
    }
    var Ui = a.unstable_runWithPriority, m0 = a.unstable_scheduleCallback, G0 = a.unstable_cancelCallback, In = a.unstable_shouldYield, rt = a.unstable_requestPaint, bt = a.unstable_now, $t = a.unstable_getCurrentPriorityLevel, Qt = a.unstable_ImmediatePriority, n0 = a.unstable_UserBlockingPriority, Nr = a.unstable_NormalPriority, V0 = a.unstable_LowPriority, y0 = a.unstable_IdlePriority, u0 = {}, ie = rt !== void 0 ? rt : function() {
    }, re = null, Q = null, we = !1, Ge = bt(), Ue = 1e4 > Ge ? bt : function() {
      return bt() - Ge;
    };
    function at() {
      switch ($t()) {
        case Qt:
          return 99;
        case n0:
          return 98;
        case Nr:
          return 97;
        case V0:
          return 96;
        case y0:
          return 95;
        default:
          throw Error(o(332));
      }
    }
    function ft(y) {
      switch (y) {
        case 99:
          return Qt;
        case 98:
          return n0;
        case 97:
          return Nr;
        case 96:
          return V0;
        case 95:
          return y0;
        default:
          throw Error(o(332));
      }
    }
    function et(y, v) {
      return y = ft(y), Ui(y, v);
    }
    function Et(y, v, A) {
      return y = ft(y), m0(y, v, A);
    }
    function qe(y) {
      return re === null ? (re = [y], Q = m0(Qt, Pt)) : re.push(y), u0;
    }
    function ze() {
      if (Q !== null) {
        var y = Q;
        Q = null, G0(y);
      }
      Pt();
    }
    function Pt() {
      if (!we && re !== null) {
        we = !0;
        var y = 0;
        try {
          var v = re;
          et(99, function() {
            for (; y < v.length; y++) {
              var A = v[y];
              do
                A = A(!0);
              while (A !== null);
            }
          }), re = null;
        } catch (A) {
          throw re !== null && (re = re.slice(y + 1)), m0(Qt, ze), A;
        } finally {
          we = !1;
        }
      }
    }
    var fr = 3;
    function Ut(y, v, A) {
      return A /= 10, 1073741821 - (((1073741821 - y + v / 10) / A | 0) + 1) * A;
    }
    function Ht(y, v) {
      return y === v && (y !== 0 || 1 / y === 1 / v) || y !== y && v !== v;
    }
    var Tt = typeof Object.is == "function" ? Object.is : Ht, a0 = Object.prototype.hasOwnProperty;
    function Zt(y, v) {
      if (Tt(y, v)) return !0;
      if (typeof y != "object" || y === null || typeof v != "object" || v === null) return !1;
      var A = Object.keys(y), C = Object.keys(v);
      if (A.length !== C.length) return !1;
      for (C = 0; C < A.length; C++) if (!a0.call(v, A[C]) || !Tt(y[A[C]], v[A[C]])) return !1;
      return !0;
    }
    function Dr(y, v) {
      if (y && y.defaultProps) {
        v = n({}, v), y = y.defaultProps;
        for (var A in y) v[A] === void 0 && (v[A] = y[A]);
      }
      return v;
    }
    var b0 = {
      current: null
    }, je = null, Cr = null, f = null;
    function Ke() {
      f = Cr = je = null;
    }
    function _o(y, v) {
      var A = y.type._context;
      ke ? (_r(b0, A._currentValue), A._currentValue = v) : (_r(b0, A._currentValue2), A._currentValue2 = v);
    }
    function Bl(y) {
      var v = b0.current;
      br(b0), y = y.type._context, ke ? y._currentValue = v : y._currentValue2 = v;
    }
    function Y(y, v) {
      for (; y !== null; ) {
        var A = y.alternate;
        if (y.childExpirationTime < v) y.childExpirationTime = v, A !== null && A.childExpirationTime < v && (A.childExpirationTime = v);
        else if (A !== null && A.childExpirationTime < v) A.childExpirationTime = v;
        else break;
        y = y.return;
      }
    }
    function Fr(y, v) {
      je = y, f = Cr = null, y = y.dependencies, y !== null && y.firstContext !== null && (y.expirationTime >= v && (gn = !0), y.firstContext = null);
    }
    function pr(y, v) {
      if (f !== y && v !== !1 && v !== 0)
        if ((typeof v != "number" || v === 1073741823) && (f = y, v = 1073741823), v = {
          context: y,
          observedBits: v,
          next: null
        }, Cr === null) {
          if (je === null) throw Error(o(308));
          Cr = v, je.dependencies = {
            expirationTime: 0,
            firstContext: v,
            responders: null
          };
        } else Cr = Cr.next = v;
      return ke ? y._currentValue : y._currentValue2;
    }
    var E = !1;
    function jr(y) {
      return {
        baseState: y,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }
    function Pn(y) {
      return {
        baseState: y.baseState,
        firstUpdate: y.firstUpdate,
        lastUpdate: y.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }
    function La(y, v) {
      return {
        expirationTime: y,
        suspenseConfig: v,
        tag: 0,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
      };
    }
    function Nl(y, v) {
      y.lastUpdate === null ? y.firstUpdate = y.lastUpdate = v : (y.lastUpdate.next = v, y.lastUpdate = v);
    }
    function ot(y, v) {
      var A = y.alternate;
      if (A === null) {
        var C = y.updateQueue, I = null;
        C === null && (C = y.updateQueue = jr(y.memoizedState));
      } else C = y.updateQueue, I = A.updateQueue, C === null ? I === null ? (C = y.updateQueue = jr(y.memoizedState), I = A.updateQueue = jr(A.memoizedState)) : C = y.updateQueue = Pn(I) : I === null && (I = A.updateQueue = Pn(C));
      I === null || C === I ? Nl(C, v) : C.lastUpdate === null || I.lastUpdate === null ? (Nl(C, v), Nl(I, v)) : (Nl(C, v), I.lastUpdate = v);
    }
    function Y0(y, v) {
      var A = y.updateQueue;
      A = A === null ? y.updateQueue = jr(y.memoizedState) : $i(y, A), A.lastCapturedUpdate === null ? A.firstCapturedUpdate = A.lastCapturedUpdate = v : (A.lastCapturedUpdate.next = v, A.lastCapturedUpdate = v);
    }
    function $i(y, v) {
      var A = y.alternate;
      return A !== null && v === A.updateQueue && (v = y.updateQueue = Pn(v)), v;
    }
    function zi(y, v, A, C, I, L) {
      switch (A.tag) {
        case 1:
          return y = A.payload, typeof y == "function" ? y.call(L, C, I) : y;
        case 3:
          y.effectTag = y.effectTag & -4097 | 64;
        case 0:
          if (y = A.payload, I = typeof y == "function" ? y.call(L, C, I) : y, I == null) break;
          return n({}, C, I);
        case 2:
          E = !0;
      }
      return C;
    }
    function ji(y, v, A, C, I) {
      E = !1, v = $i(y, v);
      for (var L = v.baseState, ae = null, it = 0, Ye = v.firstUpdate, wt = L; Ye !== null; ) {
        var Nt = Ye.expirationTime;
        Nt < I ? (ae === null && (ae = Ye, L = wt), it < Nt && (it = Nt)) : (en(Nt, Ye.suspenseConfig), wt = zi(y, v, Ye, wt, A, C), Ye.callback !== null && (y.effectTag |= 32, Ye.nextEffect = null, v.lastEffect === null ? v.firstEffect = v.lastEffect = Ye : (v.lastEffect.nextEffect = Ye, v.lastEffect = Ye))), Ye = Ye.next;
      }
      for (Nt = null, Ye = v.firstCapturedUpdate; Ye !== null; ) {
        var En = Ye.expirationTime;
        En < I ? (Nt === null && (Nt = Ye, ae === null && (L = wt)), it < En && (it = En)) : (wt = zi(y, v, Ye, wt, A, C), Ye.callback !== null && (y.effectTag |= 32, Ye.nextEffect = null, v.lastCapturedEffect === null ? v.firstCapturedEffect = v.lastCapturedEffect = Ye : (v.lastCapturedEffect.nextEffect = Ye, v.lastCapturedEffect = Ye))), Ye = Ye.next;
      }
      ae === null && (v.lastUpdate = null), Nt === null ? v.lastCapturedUpdate = null : y.effectTag |= 32, ae === null && Nt === null && (L = wt), v.baseState = L, v.firstUpdate = ae, v.firstCapturedUpdate = Nt, C0(it), y.expirationTime = it, y.memoizedState = wt;
    }
    function Do(y, v, A) {
      v.firstCapturedUpdate !== null && (v.lastUpdate !== null && (v.lastUpdate.next = v.firstCapturedUpdate, v.lastUpdate = v.lastCapturedUpdate), v.firstCapturedUpdate = v.lastCapturedUpdate = null), us(v.firstEffect, A), v.firstEffect = v.lastEffect = null, us(v.firstCapturedEffect, A), v.firstCapturedEffect = v.lastCapturedEffect = null;
    }
    function us(y, v) {
      for (; y !== null; ) {
        var A = y.callback;
        if (A !== null) {
          y.callback = null;
          var C = v;
          if (typeof A != "function") throw Error(o(191, A));
          A.call(C);
        }
        y = y.nextEffect;
      }
    }
    var Ma = s.ReactCurrentBatchConfig, Ll = new i.Component().refs;
    function ls(y, v, A, C) {
      v = y.memoizedState, A = A(C, v), A = A == null ? v : n({}, v, A), y.memoizedState = A, C = y.updateQueue, C !== null && y.expirationTime === 0 && (C.baseState = A);
    }
    var cs = {
      isMounted: function(v) {
        return (v = v._reactInternalFiber) ? ve(v) === v : !1;
      },
      enqueueSetState: function(v, A, C) {
        v = v._reactInternalFiber;
        var I = vt(), L = Ma.suspense;
        I = At(I, v, L), L = La(I, L), L.payload = A, C != null && (L.callback = C), ot(v, L), Ot(v, I);
      },
      enqueueReplaceState: function(v, A, C) {
        v = v._reactInternalFiber;
        var I = vt(), L = Ma.suspense;
        I = At(I, v, L), L = La(I, L), L.tag = 1, L.payload = A, C != null && (L.callback = C), ot(v, L), Ot(v, I);
      },
      enqueueForceUpdate: function(v, A) {
        v = v._reactInternalFiber;
        var C = vt(), I = Ma.suspense;
        C = At(C, v, I), I = La(C, I), I.tag = 2, A != null && (I.callback = A), ot(v, I), Ot(v, C);
      }
    };
    function ff(y, v, A, C, I, L, ae) {
      return y = y.stateNode, typeof y.shouldComponentUpdate == "function" ? y.shouldComponentUpdate(C, L, ae) : v.prototype && v.prototype.isPureReactComponent ? !Zt(A, C) || !Zt(I, L) : !0;
    }
    function hf(y, v, A) {
      var C = !1, I = W0, L = v.contextType;
      return typeof L == "object" && L !== null ? L = pr(L) : (I = L0(v) ? zn : r0.current, C = v.contextTypes, L = (C = C != null) ? jn(y, I) : W0), v = new v(A, L), y.memoizedState = v.state !== null && v.state !== void 0 ? v.state : null, v.updater = cs, y.stateNode = v, v._reactInternalFiber = y, C && (y = y.stateNode, y.__reactInternalMemoizedUnmaskedChildContext = I, y.__reactInternalMemoizedMaskedChildContext = L), v;
    }
    function df(y, v, A, C) {
      y = v.state, typeof v.componentWillReceiveProps == "function" && v.componentWillReceiveProps(A, C), typeof v.UNSAFE_componentWillReceiveProps == "function" && v.UNSAFE_componentWillReceiveProps(A, C), v.state !== y && cs.enqueueReplaceState(v, v.state, null);
    }
    function Ml(y, v, A, C) {
      var I = y.stateNode;
      I.props = A, I.state = y.memoizedState, I.refs = Ll;
      var L = v.contextType;
      typeof L == "object" && L !== null ? I.context = pr(L) : (L = L0(v) ? zn : r0.current, I.context = jn(y, L)), L = y.updateQueue, L !== null && (ji(y, L, A, I, C), I.state = y.memoizedState), L = v.getDerivedStateFromProps, typeof L == "function" && (ls(y, v, L, A), I.state = y.memoizedState), typeof v.getDerivedStateFromProps == "function" || typeof I.getSnapshotBeforeUpdate == "function" || typeof I.UNSAFE_componentWillMount != "function" && typeof I.componentWillMount != "function" || (v = I.state, typeof I.componentWillMount == "function" && I.componentWillMount(), typeof I.UNSAFE_componentWillMount == "function" && I.UNSAFE_componentWillMount(), v !== I.state && cs.enqueueReplaceState(I, I.state, null), L = y.updateQueue, L !== null && (ji(y, L, A, I, C), I.state = y.memoizedState)), typeof I.componentDidMount == "function" && (y.effectTag |= 4);
    }
    var mu = Array.isArray;
    function yu(y, v, A) {
      if (y = A.ref, y !== null && typeof y != "function" && typeof y != "object") {
        if (A._owner) {
          if (A = A._owner, A) {
            if (A.tag !== 1) throw Error(o(309));
            var C = A.stateNode;
          }
          if (!C) throw Error(o(147, y));
          var I = "" + y;
          return v !== null && v.ref !== null && typeof v.ref == "function" && v.ref._stringRef === I ? v.ref : (v = function(ae) {
            var it = C.refs;
            it === Ll && (it = C.refs = {}), ae === null ? delete it[I] : it[I] = ae;
          }, v._stringRef = I, v);
        }
        if (typeof y != "string") throw Error(o(284));
        if (!A._owner) throw Error(o(290, y));
      }
      return y;
    }
    function Ul(y, v) {
      if (y.type !== "textarea") throw Error(o(31, Object.prototype.toString.call(v) === "[object Object]" ? "object with keys {" + Object.keys(v).join(", ") + "}" : v, ""));
    }
    function v2(y) {
      function v(Ve, Be) {
        if (y) {
          var Xe = Ve.lastEffect;
          Xe !== null ? (Xe.nextEffect = Be, Ve.lastEffect = Be) : Ve.firstEffect = Ve.lastEffect = Be, Be.nextEffect = null, Be.effectTag = 8;
        }
      }
      function A(Ve, Be) {
        if (!y) return null;
        for (; Be !== null; ) v(Ve, Be), Be = Be.sibling;
        return null;
      }
      function C(Ve, Be) {
        for (Ve = /* @__PURE__ */ new Map(); Be !== null; ) Be.key !== null ? Ve.set(Be.key, Be) : Ve.set(Be.index, Be), Be = Be.sibling;
        return Ve;
      }
      function I(Ve, Be, Xe) {
        return Ve = Ai(Ve, Be), Ve.index = 0, Ve.sibling = null, Ve;
      }
      function L(Ve, Be, Xe) {
        return Ve.index = Xe, y ? (Xe = Ve.alternate, Xe !== null ? (Xe = Xe.index, Xe < Be ? (Ve.effectTag = 2, Be) : Xe) : (Ve.effectTag = 2, Be)) : Be;
      }
      function ae(Ve) {
        return y && Ve.alternate === null && (Ve.effectTag = 2), Ve;
      }
      function it(Ve, Be, Xe, It) {
        return Be === null || Be.tag !== 6 ? (Be = Nu(Xe, Ve.mode, It), Be.return = Ve, Be) : (Be = I(Be, Xe), Be.return = Ve, Be);
      }
      function Ye(Ve, Be, Xe, It) {
        return Be !== null && Be.elementType === Xe.type ? (It = I(Be, Xe.props), It.ref = yu(Ve, Be, Xe), It.return = Ve, It) : (It = Bo(Xe.type, Xe.key, Xe.props, null, Ve.mode, It), It.ref = yu(Ve, Be, Xe), It.return = Ve, It);
      }
      function wt(Ve, Be, Xe, It) {
        return Be === null || Be.tag !== 4 || Be.stateNode.containerInfo !== Xe.containerInfo || Be.stateNode.implementation !== Xe.implementation ? (Be = Lu(Xe, Ve.mode, It), Be.return = Ve, Be) : (Be = I(Be, Xe.children || []), Be.return = Ve, Be);
      }
      function Nt(Ve, Be, Xe, It, Wt) {
        return Be === null || Be.tag !== 7 ? (Be = xi(Xe, Ve.mode, It, Wt), Be.return = Ve, Be) : (Be = I(Be, Xe), Be.return = Ve, Be);
      }
      function En(Ve, Be, Xe) {
        if (typeof Be == "string" || typeof Be == "number") return Be = Nu("" + Be, Ve.mode, Xe), Be.return = Ve, Be;
        if (typeof Be == "object" && Be !== null) {
          switch (Be.$$typeof) {
            case h:
              return Xe = Bo(Be.type, Be.key, Be.props, null, Ve.mode, Xe), Xe.ref = yu(Ve, null, Be), Xe.return = Ve, Xe;
            case d:
              return Be = Lu(Be, Ve.mode, Xe), Be.return = Ve, Be;
          }
          if (mu(Be) || J(Be)) return Be = xi(Be, Ve.mode, Xe, null), Be.return = Ve, Be;
          Ul(Ve, Be);
        }
        return null;
      }
      function F0(Ve, Be, Xe, It) {
        var Wt = Be !== null ? Be.key : null;
        if (typeof Xe == "string" || typeof Xe == "number") return Wt !== null ? null : it(Ve, Be, "" + Xe, It);
        if (typeof Xe == "object" && Xe !== null) {
          switch (Xe.$$typeof) {
            case h:
              return Xe.key === Wt ? Xe.type === g ? Nt(Ve, Be, Xe.props.children, It, Wt) : Ye(Ve, Be, Xe, It) : null;
            case d:
              return Xe.key === Wt ? wt(Ve, Be, Xe, It) : null;
          }
          if (mu(Xe) || J(Xe)) return Wt !== null ? null : Nt(Ve, Be, Xe, It, null);
          Ul(Ve, Xe);
        }
        return null;
      }
      function ni(Ve, Be, Xe, It, Wt) {
        if (typeof It == "string" || typeof It == "number") return Ve = Ve.get(Xe) || null, it(Be, Ve, "" + It, Wt);
        if (typeof It == "object" && It !== null) {
          switch (It.$$typeof) {
            case h:
              return Ve = Ve.get(It.key === null ? Xe : It.key) || null, It.type === g ? Nt(Be, Ve, It.props.children, Wt, It.key) : Ye(Be, Ve, It, Wt);
            case d:
              return Ve = Ve.get(It.key === null ? Xe : It.key) || null, wt(Be, Ve, It, Wt);
          }
          if (mu(It) || J(It)) return Ve = Ve.get(Xe) || null, Nt(Be, Ve, It, Wt, null);
          Ul(Be, It);
        }
        return null;
      }
      function $u(Ve, Be, Xe, It) {
        for (var Wt = null, Vr = null, qt = Be, Yr = Be = 0, A0 = null; qt !== null && Yr < Xe.length; Yr++) {
          qt.index > Yr ? (A0 = qt, qt = null) : A0 = qt.sibling;
          var vr = F0(Ve, qt, Xe[Yr], It);
          if (vr === null) {
            qt === null && (qt = A0);
            break;
          }
          y && qt && vr.alternate === null && v(Ve, qt), Be = L(vr, Be, Yr), Vr === null ? Wt = vr : Vr.sibling = vr, Vr = vr, qt = A0;
        }
        if (Yr === Xe.length) return A(Ve, qt), Wt;
        if (qt === null) {
          for (; Yr < Xe.length; Yr++) qt = En(Ve, Xe[Yr], It), qt !== null && (Be = L(qt, Be, Yr), Vr === null ? Wt = qt : Vr.sibling = qt, Vr = qt);
          return Wt;
        }
        for (qt = C(Ve, qt); Yr < Xe.length; Yr++) A0 = ni(qt, Ve, Yr, Xe[Yr], It), A0 !== null && (y && A0.alternate !== null && qt.delete(A0.key === null ? Yr : A0.key), Be = L(A0, Be, Yr), Vr === null ? Wt = A0 : Vr.sibling = A0, Vr = A0);
        return y && qt.forEach(function(ii) {
          return v(Ve, ii);
        }), Wt;
      }
      function Ei(Ve, Be, Xe, It) {
        var Wt = J(Xe);
        if (typeof Wt != "function") throw Error(o(150));
        if (Xe = Wt.call(Xe), Xe == null) throw Error(o(151));
        for (var Vr = Wt = null, qt = Be, Yr = Be = 0, A0 = null, vr = Xe.next(); qt !== null && !vr.done; Yr++, vr = Xe.next()) {
          qt.index > Yr ? (A0 = qt, qt = null) : A0 = qt.sibling;
          var ii = F0(Ve, qt, vr.value, It);
          if (ii === null) {
            qt === null && (qt = A0);
            break;
          }
          y && qt && ii.alternate === null && v(Ve, qt), Be = L(ii, Be, Yr), Vr === null ? Wt = ii : Vr.sibling = ii, Vr = ii, qt = A0;
        }
        if (vr.done) return A(Ve, qt), Wt;
        if (qt === null) {
          for (; !vr.done; Yr++, vr = Xe.next()) vr = En(Ve, vr.value, It), vr !== null && (Be = L(vr, Be, Yr), Vr === null ? Wt = vr : Vr.sibling = vr, Vr = vr);
          return Wt;
        }
        for (qt = C(Ve, qt); !vr.done; Yr++, vr = Xe.next()) vr = ni(qt, Ve, Yr, vr.value, It), vr !== null && (y && vr.alternate !== null && qt.delete(vr.key === null ? Yr : vr.key), Be = L(vr, Be, Yr), Vr === null ? Wt = vr : Vr.sibling = vr, Vr = vr);
        return y && qt.forEach(function(yT) {
          return v(Ve, yT);
        }), Wt;
      }
      return function(Ve, Be, Xe, It) {
        var Wt = typeof Xe == "object" && Xe !== null && Xe.type === g && Xe.key === null;
        Wt && (Xe = Xe.props.children);
        var Vr = typeof Xe == "object" && Xe !== null;
        if (Vr) switch (Xe.$$typeof) {
          case h:
            e: {
              for (Vr = Xe.key, Wt = Be; Wt !== null; ) {
                if (Wt.key === Vr)
                  if (Wt.tag === 7 ? Xe.type === g : Wt.elementType === Xe.type) {
                    A(Ve, Wt.sibling), Be = I(Wt, Xe.type === g ? Xe.props.children : Xe.props), Be.ref = yu(Ve, Wt, Xe), Be.return = Ve, Ve = Be;
                    break e;
                  } else {
                    A(Ve, Wt);
                    break;
                  }
                else v(Ve, Wt);
                Wt = Wt.sibling;
              }
              Xe.type === g ? (Be = xi(Xe.props.children, Ve.mode, It, Xe.key), Be.return = Ve, Ve = Be) : (It = Bo(Xe.type, Xe.key, Xe.props, null, Ve.mode, It), It.ref = yu(Ve, Be, Xe), It.return = Ve, Ve = It);
            }
            return ae(Ve);
          case d:
            e: {
              for (Wt = Xe.key; Be !== null; ) {
                if (Be.key === Wt)
                  if (Be.tag === 4 && Be.stateNode.containerInfo === Xe.containerInfo && Be.stateNode.implementation === Xe.implementation) {
                    A(Ve, Be.sibling), Be = I(Be, Xe.children || []), Be.return = Ve, Ve = Be;
                    break e;
                  } else {
                    A(Ve, Be);
                    break;
                  }
                else v(Ve, Be);
                Be = Be.sibling;
              }
              Be = Lu(Xe, Ve.mode, It), Be.return = Ve, Ve = Be;
            }
            return ae(Ve);
        }
        if (typeof Xe == "string" || typeof Xe == "number") return Xe = "" + Xe, Be !== null && Be.tag === 6 ? (A(Ve, Be.sibling), Be = I(Be, Xe), Be.return = Ve, Ve = Be) : (A(Ve, Be), Be = Nu(Xe, Ve.mode, It), Be.return = Ve, Ve = Be), ae(Ve);
        if (mu(Xe)) return $u(Ve, Be, Xe, It);
        if (J(Xe)) return Ei(Ve, Be, Xe, It);
        if (Vr && Ul(Ve, Xe), typeof Xe > "u" && !Wt) switch (Ve.tag) {
          case 1:
          case 0:
            throw Ve = Ve.type, Error(o(152, Ve.displayName || Ve.name || "Component"));
        }
        return A(Ve, Be);
      };
    }
    var fs = v2(!0), pf = v2(!1), bu = {}, ti = {
      current: bu
    }, wu = {
      current: bu
    }, hs = {
      current: bu
    };
    function Wi(y) {
      if (y === bu) throw Error(o(174));
      return y;
    }
    function vf(y, v) {
      _r(hs, v), _r(wu, y), _r(ti, bu), v = ne(v), br(ti), _r(ti, v);
    }
    function ds(y) {
      br(ti), br(wu), br(hs);
    }
    function g2(y) {
      var v = Wi(hs.current), A = Wi(ti.current);
      v = me(A, y.type, v), A !== v && (_r(wu, y), _r(ti, v));
    }
    function nt(y) {
      wu.current === y && (br(ti), br(wu));
    }
    var sr = {
      current: 0
    };
    function Au(y) {
      for (var v = y; v !== null; ) {
        if (v.tag === 13) {
          var A = v.memoizedState;
          if (A !== null && (A = A.dehydrated, A === null || j0(A) || gi(A))) return v;
        } else if (v.tag === 19 && v.memoizedProps.revealOrder !== void 0) {
          if (v.effectTag & 64) return v;
        } else if (v.child !== null) {
          v.child.return = v, v = v.child;
          continue;
        }
        if (v === y) break;
        for (; v.sibling === null; ) {
          if (v.return === null || v.return === y) return null;
          v = v.return;
        }
        v.sibling.return = v.return, v = v.sibling;
      }
      return null;
    }
    function gf(y, v) {
      return {
        responder: y,
        props: v
      };
    }
    var xu = s.ReactCurrentDispatcher, H0 = s.ReactCurrentBatchConfig, To = 0, Tr = null, J0 = null, mi = null, D0 = null, pn = null, ko = null, Ua = 0, ri = null, ps = 0, $a = !1, Gi = null, So = 0;
    function T0() {
      throw Error(o(321));
    }
    function $l(y, v) {
      if (v === null) return !1;
      for (var A = 0; A < v.length && A < y.length; A++) if (!Tt(y[A], v[A])) return !1;
      return !0;
    }
    function zl(y, v, A, C, I, L) {
      if (To = L, Tr = v, mi = y !== null ? y.memoizedState : null, xu.current = mi === null ? wr : er, v = A(C, I), $a) {
        do
          $a = !1, So += 1, mi = y !== null ? y.memoizedState : null, ko = D0, ri = pn = J0 = null, xu.current = er, v = A(C, I);
        while ($a);
        Gi = null, So = 0;
      }
      if (xu.current = gs, y = Tr, y.memoizedState = D0, y.expirationTime = Ua, y.updateQueue = ri, y.effectTag |= ps, y = J0 !== null && J0.next !== null, To = 0, ko = pn = D0 = mi = J0 = Tr = null, Ua = 0, ri = null, ps = 0, y) throw Error(o(300));
      return v;
    }
    function mf() {
      xu.current = gs, To = 0, ko = pn = D0 = mi = J0 = Tr = null, Ua = 0, ri = null, ps = 0, $a = !1, Gi = null, So = 0;
    }
    function k0() {
      var y = {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
      };
      return pn === null ? D0 = pn = y : pn = pn.next = y, pn;
    }
    function l0() {
      if (ko !== null) pn = ko, ko = pn.next, J0 = mi, mi = J0 !== null ? J0.next : null;
      else {
        if (mi === null) throw Error(o(310));
        J0 = mi;
        var y = {
          memoizedState: J0.memoizedState,
          baseState: J0.baseState,
          queue: J0.queue,
          baseUpdate: J0.baseUpdate,
          next: null
        };
        pn = pn === null ? D0 = y : pn.next = y, mi = J0.next;
      }
      return pn;
    }
    function yf(y, v) {
      return typeof v == "function" ? v(y) : v;
    }
    function Eu(y) {
      var v = l0(), A = v.queue;
      if (A === null) throw Error(o(311));
      if (A.lastRenderedReducer = y, 0 < So) {
        var C = A.dispatch;
        if (Gi !== null) {
          var I = Gi.get(A);
          if (I !== void 0) {
            Gi.delete(A);
            var L = v.memoizedState;
            do
              L = y(L, I.action), I = I.next;
            while (I !== null);
            return Tt(L, v.memoizedState) || (gn = !0), v.memoizedState = L, v.baseUpdate === A.last && (v.baseState = L), A.lastRenderedState = L, [L, C];
          }
        }
        return [v.memoizedState, C];
      }
      C = A.last;
      var ae = v.baseUpdate;
      if (L = v.baseState, ae !== null ? (C !== null && (C.next = null), C = ae.next) : C = C !== null ? C.next : null, C !== null) {
        var it = I = null, Ye = C, wt = !1;
        do {
          var Nt = Ye.expirationTime;
          Nt < To ? (wt || (wt = !0, it = ae, I = L), Nt > Ua && (Ua = Nt, C0(Ua))) : (en(Nt, Ye.suspenseConfig), L = Ye.eagerReducer === y ? Ye.eagerState : y(L, Ye.action)), ae = Ye, Ye = Ye.next;
        } while (Ye !== null && Ye !== C);
        wt || (it = ae, I = L), Tt(L, v.memoizedState) || (gn = !0), v.memoizedState = L, v.baseUpdate = it, v.baseState = I, A.lastRenderedState = L;
      }
      return [v.memoizedState, A.dispatch];
    }
    function za(y) {
      var v = k0();
      return typeof y == "function" && (y = y()), v.memoizedState = v.baseState = y, y = v.queue = {
        last: null,
        dispatch: null,
        lastRenderedReducer: yf,
        lastRenderedState: y
      }, y = y.dispatch = S0.bind(null, Tr, y), [v.memoizedState, y];
    }
    function Or(y) {
      return Eu(yf);
    }
    function Rr(y, v, A, C) {
      return y = {
        tag: y,
        create: v,
        destroy: A,
        deps: C,
        next: null
      }, ri === null ? (ri = {
        lastEffect: null
      }, ri.lastEffect = y.next = y) : (v = ri.lastEffect, v === null ? ri.lastEffect = y.next = y : (A = v.next, v.next = y, y.next = A, ri.lastEffect = y)), y;
    }
    function jl(y, v, A, C) {
      var I = k0();
      ps |= y, I.memoizedState = Rr(v, A, void 0, C === void 0 ? null : C);
    }
    function vn(y, v, A, C) {
      var I = l0();
      C = C === void 0 ? null : C;
      var L = void 0;
      if (J0 !== null) {
        var ae = J0.memoizedState;
        if (L = ae.destroy, C !== null && $l(C, ae.deps)) {
          Rr(0, A, L, C);
          return;
        }
      }
      ps |= y, I.memoizedState = Rr(v, A, L, C);
    }
    function vs(y, v) {
      return jl(516, 192, y, v);
    }
    function ga(y, v) {
      return vn(516, 192, y, v);
    }
    function yi(y, v) {
      if (typeof v == "function") return y = y(), v(y), function() {
        v(null);
      };
      if (v != null) return y = y(), v.current = y, function() {
        v.current = null;
      };
    }
    function bf() {
    }
    function wf(y, v) {
      return k0().memoizedState = [y, v === void 0 ? null : v], y;
    }
    function Af(y, v) {
      var A = l0();
      v = v === void 0 ? null : v;
      var C = A.memoizedState;
      return C !== null && v !== null && $l(v, C[1]) ? C[0] : (A.memoizedState = [y, v], y);
    }
    function S0(y, v, A) {
      if (!(25 > So)) throw Error(o(301));
      var C = y.alternate;
      if (y === Tr || C !== null && C === Tr)
        if ($a = !0, y = {
          expirationTime: To,
          suspenseConfig: null,
          action: A,
          eagerReducer: null,
          eagerState: null,
          next: null
        }, Gi === null && (Gi = /* @__PURE__ */ new Map()), A = Gi.get(v), A === void 0) Gi.set(v, y);
        else {
          for (v = A; v.next !== null; ) v = v.next;
          v.next = y;
        }
      else {
        var I = vt(), L = Ma.suspense;
        I = At(I, y, L), L = {
          expirationTime: I,
          suspenseConfig: L,
          action: A,
          eagerReducer: null,
          eagerState: null,
          next: null
        };
        var ae = v.last;
        if (ae === null) L.next = L;
        else {
          var it = ae.next;
          it !== null && (L.next = it), ae.next = L;
        }
        if (v.last = L, y.expirationTime === 0 && (C === null || C.expirationTime === 0) && (C = v.lastRenderedReducer, C !== null)) try {
          var Ye = v.lastRenderedState, wt = C(Ye, A);
          if (L.eagerReducer = C, L.eagerState = wt, Tt(wt, Ye)) return;
        } catch {
        } finally {
        }
        Ot(y, I);
      }
    }
    var gs = {
      readContext: pr,
      useCallback: T0,
      useContext: T0,
      useEffect: T0,
      useImperativeHandle: T0,
      useLayoutEffect: T0,
      useMemo: T0,
      useReducer: T0,
      useRef: T0,
      useState: T0,
      useDebugValue: T0,
      useResponder: T0,
      useDeferredValue: T0,
      useTransition: T0
    }, wr = {
      readContext: pr,
      useCallback: wf,
      useContext: pr,
      useEffect: vs,
      useImperativeHandle: function(v, A, C) {
        return C = C != null ? C.concat([v]) : null, jl(4, 36, yi.bind(null, A, v), C);
      },
      useLayoutEffect: function(v, A) {
        return jl(4, 36, v, A);
      },
      useMemo: function(v, A) {
        var C = k0();
        return A = A === void 0 ? null : A, v = v(), C.memoizedState = [v, A], v;
      },
      useReducer: function(v, A, C) {
        var I = k0();
        return A = C !== void 0 ? C(A) : A, I.memoizedState = I.baseState = A, v = I.queue = {
          last: null,
          dispatch: null,
          lastRenderedReducer: v,
          lastRenderedState: A
        }, v = v.dispatch = S0.bind(null, Tr, v), [I.memoizedState, v];
      },
      useRef: function(v) {
        var A = k0();
        return v = {
          current: v
        }, A.memoizedState = v;
      },
      useState: za,
      useDebugValue: bf,
      useResponder: gf,
      useDeferredValue: function(v, A) {
        var C = za(v), I = C[0], L = C[1];
        return vs(function() {
          a.unstable_next(function() {
            var ae = H0.suspense;
            H0.suspense = A === void 0 ? null : A;
            try {
              L(v);
            } finally {
              H0.suspense = ae;
            }
          });
        }, [v, A]), I;
      },
      useTransition: function(v) {
        var A = za(!1), C = A[0], I = A[1];
        return [wf(function(L) {
          I(!0), a.unstable_next(function() {
            var ae = H0.suspense;
            H0.suspense = v === void 0 ? null : v;
            try {
              I(!1), L();
            } finally {
              H0.suspense = ae;
            }
          });
        }, [v, C]), C];
      }
    }, er = {
      readContext: pr,
      useCallback: Af,
      useContext: pr,
      useEffect: ga,
      useImperativeHandle: function(v, A, C) {
        return C = C != null ? C.concat([v]) : null, vn(4, 36, yi.bind(null, A, v), C);
      },
      useLayoutEffect: function(v, A) {
        return vn(4, 36, v, A);
      },
      useMemo: function(v, A) {
        var C = l0();
        A = A === void 0 ? null : A;
        var I = C.memoizedState;
        return I !== null && A !== null && $l(A, I[1]) ? I[0] : (v = v(), C.memoizedState = [v, A], v);
      },
      useReducer: Eu,
      useRef: function() {
        return l0().memoizedState;
      },
      useState: Or,
      useDebugValue: bf,
      useResponder: gf,
      useDeferredValue: function(v, A) {
        var C = Or(), I = C[0], L = C[1];
        return ga(function() {
          a.unstable_next(function() {
            var ae = H0.suspense;
            H0.suspense = A === void 0 ? null : A;
            try {
              L(v);
            } finally {
              H0.suspense = ae;
            }
          });
        }, [v, A]), I;
      },
      useTransition: function(v) {
        var A = Or(), C = A[0], I = A[1];
        return [Af(function(L) {
          I(!0), a.unstable_next(function() {
            var ae = H0.suspense;
            H0.suspense = v === void 0 ? null : v;
            try {
              I(!1), L();
            } finally {
              H0.suspense = ae;
            }
          });
        }, [v, C]), C];
      }
    }, Z0 = null, nr = null, Kt = !1;
    function bi(y, v) {
      var A = Un(5, null, null, 0);
      A.elementType = "DELETED", A.type = "DELETED", A.stateNode = v, A.return = y, A.effectTag = 8, y.lastEffect !== null ? (y.lastEffect.nextEffect = A, y.lastEffect = A) : y.firstEffect = y.lastEffect = A;
    }
    function xf(y, v) {
      switch (y.tag) {
        case 5:
          return v = On(v, y.type, y.pendingProps), v !== null ? (y.stateNode = v, !0) : !1;
        case 6:
          return v = Pi(v, y.pendingProps), v !== null ? (y.stateNode = v, !0) : !1;
        case 13:
          return !1;
        default:
          return !1;
      }
    }
    function Wl(y) {
      if (Kt) {
        var v = nr;
        if (v) {
          var A = v;
          if (!xf(y, v)) {
            if (v = dn(A), !v || !xf(y, v)) {
              y.effectTag = y.effectTag & -1025 | 2, Kt = !1, Z0 = y;
              return;
            }
            bi(Z0, A);
          }
          Z0 = y, nr = da(v);
        } else y.effectTag = y.effectTag & -1025 | 2, Kt = !1, Z0 = y;
      }
    }
    function Ef(y) {
      for (y = y.return; y !== null && y.tag !== 5 && y.tag !== 3 && y.tag !== 13; ) y = y.return;
      Z0 = y;
    }
    function Wn(y) {
      if (!ct || y !== Z0) return !1;
      if (!Kt) return Ef(y), Kt = !0, !1;
      var v = y.type;
      if (y.tag !== 5 || v !== "head" && v !== "body" && !se(v, y.memoizedProps)) for (v = nr; v; ) bi(y, v), v = dn(v);
      if (Ef(y), y.tag === 13) {
        if (!ct) throw Error(o(316));
        if (y = y.memoizedState, y = y !== null ? y.dehydrated : null, !y) throw Error(o(317));
        nr = on(y);
      } else nr = Z0 ? dn(y.stateNode) : null;
      return !0;
    }
    function Bn() {
      ct && (nr = Z0 = null, Kt = !1);
    }
    var m2 = s.ReactCurrentOwner, gn = !1;
    function Nn(y, v, A, C) {
      v.child = y === null ? pf(v, null, A, C) : fs(v, y.child, A, C);
    }
    function _f(y, v, A, C, I) {
      A = A.render;
      var L = v.ref;
      return Fr(v, I), C = zl(y, v, A, C, L, I), y !== null && !gn ? (v.updateQueue = y.updateQueue, v.effectTag &= -517, y.expirationTime <= I && (y.expirationTime = 0), mn(y, v, I)) : (v.effectTag |= 1, Nn(y, v, C, I), v.child);
    }
    function _u(y, v, A, C, I, L) {
      if (y === null) {
        var ae = A.type;
        return typeof ae == "function" && !Po(ae) && ae.defaultProps === void 0 && A.compare === null && A.defaultProps === void 0 ? (v.tag = 15, v.type = ae, Du(y, v, ae, C, I, L)) : (y = Bo(A.type, null, C, null, v.mode, L), y.ref = v.ref, y.return = v, v.child = y);
      }
      return ae = y.child, I < L && (I = ae.memoizedProps, A = A.compare, A = A !== null ? A : Zt, A(I, C) && y.ref === v.ref) ? mn(y, v, L) : (v.effectTag |= 1, y = Ai(ae, C), y.ref = v.ref, y.return = v, v.child = y);
    }
    function Du(y, v, A, C, I, L) {
      return y !== null && Zt(y.memoizedProps, C) && y.ref === v.ref && (gn = !1, I < L) ? mn(y, v, L) : Tu(y, v, A, C, L);
    }
    function Co(y, v) {
      var A = v.ref;
      (y === null && A !== null || y !== null && y.ref !== A) && (v.effectTag |= 128);
    }
    function Tu(y, v, A, C, I) {
      var L = L0(A) ? zn : r0.current;
      return L = jn(v, L), Fr(v, I), A = zl(y, v, A, C, L, I), y !== null && !gn ? (v.updateQueue = y.updateQueue, v.effectTag &= -517, y.expirationTime <= I && (y.expirationTime = 0), mn(y, v, I)) : (v.effectTag |= 1, Nn(y, v, A, I), v.child);
    }
    function Df(y, v, A, C, I) {
      if (L0(A)) {
        var L = !0;
        Mi(v);
      } else L = !1;
      if (Fr(v, I), v.stateNode === null) y !== null && (y.alternate = null, v.alternate = null, v.effectTag |= 2), hf(v, A, C), Ml(v, A, C, I), C = !0;
      else if (y === null) {
        var ae = v.stateNode, it = v.memoizedProps;
        ae.props = it;
        var Ye = ae.context, wt = A.contextType;
        typeof wt == "object" && wt !== null ? wt = pr(wt) : (wt = L0(A) ? zn : r0.current, wt = jn(v, wt));
        var Nt = A.getDerivedStateFromProps, En = typeof Nt == "function" || typeof ae.getSnapshotBeforeUpdate == "function";
        En || typeof ae.UNSAFE_componentWillReceiveProps != "function" && typeof ae.componentWillReceiveProps != "function" || (it !== C || Ye !== wt) && df(v, ae, C, wt), E = !1;
        var F0 = v.memoizedState;
        Ye = ae.state = F0;
        var ni = v.updateQueue;
        ni !== null && (ji(v, ni, C, ae, I), Ye = v.memoizedState), it !== C || F0 !== Ye || g0.current || E ? (typeof Nt == "function" && (ls(v, A, Nt, C), Ye = v.memoizedState), (it = E || ff(v, A, it, C, F0, Ye, wt)) ? (En || typeof ae.UNSAFE_componentWillMount != "function" && typeof ae.componentWillMount != "function" || (typeof ae.componentWillMount == "function" && ae.componentWillMount(), typeof ae.UNSAFE_componentWillMount == "function" && ae.UNSAFE_componentWillMount()), typeof ae.componentDidMount == "function" && (v.effectTag |= 4)) : (typeof ae.componentDidMount == "function" && (v.effectTag |= 4), v.memoizedProps = C, v.memoizedState = Ye), ae.props = C, ae.state = Ye, ae.context = wt, C = it) : (typeof ae.componentDidMount == "function" && (v.effectTag |= 4), C = !1);
      } else ae = v.stateNode, it = v.memoizedProps, ae.props = v.type === v.elementType ? it : Dr(v.type, it), Ye = ae.context, wt = A.contextType, typeof wt == "object" && wt !== null ? wt = pr(wt) : (wt = L0(A) ? zn : r0.current, wt = jn(v, wt)), Nt = A.getDerivedStateFromProps, (En = typeof Nt == "function" || typeof ae.getSnapshotBeforeUpdate == "function") || typeof ae.UNSAFE_componentWillReceiveProps != "function" && typeof ae.componentWillReceiveProps != "function" || (it !== C || Ye !== wt) && df(v, ae, C, wt), E = !1, Ye = v.memoizedState, F0 = ae.state = Ye, ni = v.updateQueue, ni !== null && (ji(v, ni, C, ae, I), F0 = v.memoizedState), it !== C || Ye !== F0 || g0.current || E ? (typeof Nt == "function" && (ls(v, A, Nt, C), F0 = v.memoizedState), (Nt = E || ff(v, A, it, C, Ye, F0, wt)) ? (En || typeof ae.UNSAFE_componentWillUpdate != "function" && typeof ae.componentWillUpdate != "function" || (typeof ae.componentWillUpdate == "function" && ae.componentWillUpdate(C, F0, wt), typeof ae.UNSAFE_componentWillUpdate == "function" && ae.UNSAFE_componentWillUpdate(C, F0, wt)), typeof ae.componentDidUpdate == "function" && (v.effectTag |= 4), typeof ae.getSnapshotBeforeUpdate == "function" && (v.effectTag |= 256)) : (typeof ae.componentDidUpdate != "function" || it === y.memoizedProps && Ye === y.memoizedState || (v.effectTag |= 4), typeof ae.getSnapshotBeforeUpdate != "function" || it === y.memoizedProps && Ye === y.memoizedState || (v.effectTag |= 256), v.memoizedProps = C, v.memoizedState = F0), ae.props = C, ae.state = F0, ae.context = wt, C = Nt) : (typeof ae.componentDidUpdate != "function" || it === y.memoizedProps && Ye === y.memoizedState || (v.effectTag |= 4), typeof ae.getSnapshotBeforeUpdate != "function" || it === y.memoizedProps && Ye === y.memoizedState || (v.effectTag |= 256), C = !1);
      return Gl(y, v, A, C, L, I);
    }
    function Gl(y, v, A, C, I, L) {
      Co(y, v);
      var ae = (v.effectTag & 64) !== 0;
      if (!C && !ae) return I && va(v, A, !1), mn(y, v, L);
      C = v.stateNode, m2.current = v;
      var it = ae && typeof A.getDerivedStateFromError != "function" ? null : C.render();
      return v.effectTag |= 1, y !== null && ae ? (v.child = fs(v, y.child, null, L), v.child = fs(v, null, it, L)) : Nn(y, v, it, L), v.memoizedState = C.state, I && va(v, A, !0), v.child;
    }
    function Vl(y) {
      var v = y.stateNode;
      v.pendingContext ? pa(y, v.pendingContext, v.pendingContext !== v.context) : v.context && pa(y, v.context, !1), vf(y, v.containerInfo);
    }
    var ms = {
      dehydrated: null,
      retryTime: 0
    };
    function Ln(y, v, A) {
      var C = v.mode, I = v.pendingProps, L = sr.current, ae = !1, it;
      if ((it = (v.effectTag & 64) !== 0) || (it = (L & 2) !== 0 && (y === null || y.memoizedState !== null)), it ? (ae = !0, v.effectTag &= -65) : y !== null && y.memoizedState === null || I.fallback === void 0 || I.unstable_avoidThisFallback === !0 || (L |= 1), _r(sr, L & 1), y === null) {
        if (I.fallback !== void 0 && Wl(v), ae) {
          if (ae = I.fallback, I = xi(null, C, 0, null), I.return = v, !(v.mode & 2)) for (y = v.memoizedState !== null ? v.child.child : v.child, I.child = y; y !== null; ) y.return = I, y = y.sibling;
          return A = xi(ae, C, A, null), A.return = v, I.sibling = A, v.memoizedState = ms, v.child = I, A;
        }
        return C = I.children, v.memoizedState = null, v.child = pf(v, null, C, A);
      }
      if (y.memoizedState !== null) {
        if (y = y.child, C = y.sibling, ae) {
          if (I = I.fallback, A = Ai(y, y.pendingProps), A.return = v, !(v.mode & 2) && (ae = v.memoizedState !== null ? v.child.child : v.child, ae !== y.child)) for (A.child = ae; ae !== null; ) ae.return = A, ae = ae.sibling;
          return C = Ai(C, I, C.expirationTime), C.return = v, A.sibling = C, A.childExpirationTime = 0, v.memoizedState = ms, v.child = A, C;
        }
        return A = fs(v, y.child, I.children, A), v.memoizedState = null, v.child = A;
      }
      if (y = y.child, ae) {
        if (ae = I.fallback, I = xi(null, C, 0, null), I.return = v, I.child = y, y !== null && (y.return = I), !(v.mode & 2)) for (y = v.memoizedState !== null ? v.child.child : v.child, I.child = y; y !== null; ) y.return = I, y = y.sibling;
        return A = xi(ae, C, A, null), A.return = v, I.sibling = A, A.effectTag |= 2, I.childExpirationTime = 0, v.memoizedState = ms, v.child = I, A;
      }
      return v.memoizedState = null, v.child = fs(v, y, I.children, A);
    }
    function Yl(y, v) {
      y.expirationTime < v && (y.expirationTime = v);
      var A = y.alternate;
      A !== null && A.expirationTime < v && (A.expirationTime = v), Y(y.return, v);
    }
    function Hl(y, v, A, C, I, L) {
      var ae = y.memoizedState;
      ae === null ? y.memoizedState = {
        isBackwards: v,
        rendering: null,
        last: C,
        tail: A,
        tailExpiration: 0,
        tailMode: I,
        lastEffect: L
      } : (ae.isBackwards = v, ae.rendering = null, ae.last = C, ae.tail = A, ae.tailExpiration = 0, ae.tailMode = I, ae.lastEffect = L);
    }
    function M0(y, v, A) {
      var C = v.pendingProps, I = C.revealOrder, L = C.tail;
      if (Nn(y, v, C.children, A), C = sr.current, C & 2) C = C & 1 | 2, v.effectTag |= 64;
      else {
        if (y !== null && y.effectTag & 64) e: for (y = v.child; y !== null; ) {
          if (y.tag === 13) y.memoizedState !== null && Yl(y, A);
          else if (y.tag === 19) Yl(y, A);
          else if (y.child !== null) {
            y.child.return = y, y = y.child;
            continue;
          }
          if (y === v) break e;
          for (; y.sibling === null; ) {
            if (y.return === null || y.return === v) break e;
            y = y.return;
          }
          y.sibling.return = y.return, y = y.sibling;
        }
        C &= 1;
      }
      if (_r(sr, C), !(v.mode & 2)) v.memoizedState = null;
      else switch (I) {
        case "forwards":
          for (A = v.child, I = null; A !== null; ) y = A.alternate, y !== null && Au(y) === null && (I = A), A = A.sibling;
          A = I, A === null ? (I = v.child, v.child = null) : (I = A.sibling, A.sibling = null), Hl(v, !1, I, A, L, v.lastEffect);
          break;
        case "backwards":
          for (A = null, I = v.child, v.child = null; I !== null; ) {
            if (y = I.alternate, y !== null && Au(y) === null) {
              v.child = I;
              break;
            }
            y = I.sibling, I.sibling = A, A = I, I = y;
          }
          Hl(v, !0, A, null, L, v.lastEffect);
          break;
        case "together":
          Hl(v, !1, null, null, void 0, v.lastEffect);
          break;
        default:
          v.memoizedState = null;
      }
      return v.child;
    }
    function mn(y, v, A) {
      y !== null && (v.dependencies = y.dependencies);
      var C = v.expirationTime;
      if (C !== 0 && C0(C), v.childExpirationTime < A) return null;
      if (y !== null && v.child !== y.child) throw Error(o(153));
      if (v.child !== null) {
        for (y = v.child, A = Ai(y, y.pendingProps, y.expirationTime), v.child = A, A.return = v; y.sibling !== null; ) y = y.sibling, A = A.sibling = Ai(y, y.pendingProps, y.expirationTime), A.return = v;
        A.sibling = null;
      }
      return v.child;
    }
    function sn(y) {
      y.effectTag |= 4;
    }
    var ys, ma, ku, Su;
    if (De) ys = function(v, A) {
      for (var C = A.child; C !== null; ) {
        if (C.tag === 5 || C.tag === 6) Ie(v, C.stateNode);
        else if (C.tag !== 4 && C.child !== null) {
          C.child.return = C, C = C.child;
          continue;
        }
        if (C === A) break;
        for (; C.sibling === null; ) {
          if (C.return === null || C.return === A) return;
          C = C.return;
        }
        C.sibling.return = C.return, C = C.sibling;
      }
    }, ma = function() {
    }, ku = function(v, A, C, I, L) {
      if (v = v.memoizedProps, v !== I) {
        var ae = A.stateNode, it = Wi(ti.current);
        C = Z(ae, C, v, I, L, it), (A.updateQueue = C) && sn(A);
      }
    }, Su = function(v, A, C, I) {
      C !== I && sn(A);
    };
    else if (Qe) {
      ys = function(v, A, C, I) {
        for (var L = A.child; L !== null; ) {
          if (L.tag === 5) {
            var ae = L.stateNode;
            C && I && (ae = z0(ae, L.type, L.memoizedProps, L)), Ie(v, ae);
          } else if (L.tag === 6) ae = L.stateNode, C && I && (ae = N0(ae, L.memoizedProps, L)), Ie(v, ae);
          else if (L.tag !== 4) {
            if (L.tag === 13 && L.effectTag & 4 && (ae = L.memoizedState !== null)) {
              var it = L.child;
              if (it !== null && (it.child !== null && (it.child.return = it, ys(v, it, !0, ae)), ae = it.sibling, ae !== null)) {
                ae.return = L, L = ae;
                continue;
              }
            }
            if (L.child !== null) {
              L.child.return = L, L = L.child;
              continue;
            }
          }
          if (L === A) break;
          for (; L.sibling === null; ) {
            if (L.return === null || L.return === A) return;
            L = L.return;
          }
          L.sibling.return = L.return, L = L.sibling;
        }
      };
      var y2 = function y(v, A, C, I) {
        for (var L = A.child; L !== null; ) {
          if (L.tag === 5) {
            var ae = L.stateNode;
            C && I && (ae = z0(ae, L.type, L.memoizedProps, L)), Er(v, ae);
          } else if (L.tag === 6) ae = L.stateNode, C && I && (ae = N0(ae, L.memoizedProps, L)), Er(v, ae);
          else if (L.tag !== 4) {
            if (L.tag === 13 && L.effectTag & 4 && (ae = L.memoizedState !== null)) {
              var it = L.child;
              if (it !== null && (it.child !== null && (it.child.return = it, y(v, it, !0, ae)), ae = it.sibling, ae !== null)) {
                ae.return = L, L = ae;
                continue;
              }
            }
            if (L.child !== null) {
              L.child.return = L, L = L.child;
              continue;
            }
          }
          if (L === A) break;
          for (; L.sibling === null; ) {
            if (L.return === null || L.return === A) return;
            L = L.return;
          }
          L.sibling.return = L.return, L = L.sibling;
        }
      };
      ma = function(v) {
        var A = v.stateNode;
        if (v.firstEffect !== null) {
          var C = A.containerInfo, I = E0(C);
          y2(I, v, !1, !1), A.pendingChildren = I, sn(v), Ba(C, I);
        }
      }, ku = function(v, A, C, I, L) {
        var ae = v.stateNode, it = v.memoizedProps;
        if ((v = A.firstEffect === null) && it === I) A.stateNode = ae;
        else {
          var Ye = A.stateNode, wt = Wi(ti.current), Nt = null;
          it !== I && (Nt = Z(Ye, C, it, I, L, wt)), v && Nt === null ? A.stateNode = ae : (ae = P0(ae, Nt, C, it, I, A, v, Ye), W(ae, C, I, L, wt) && sn(A), A.stateNode = ae, v ? sn(A) : ys(ae, A, !1, !1));
        }
      }, Su = function(v, A, C, I) {
        C !== I && (v = Wi(hs.current), C = Wi(ti.current), A.stateNode = Fe(I, v, C, A), sn(A));
      };
    } else ma = function() {
    }, ku = function() {
    }, Su = function() {
    };
    function Ze(y, v) {
      switch (y.tailMode) {
        case "hidden":
          v = y.tail;
          for (var A = null; v !== null; ) v.alternate !== null && (A = v), v = v.sibling;
          A === null ? y.tail = null : A.sibling = null;
          break;
        case "collapsed":
          A = y.tail;
          for (var C = null; A !== null; ) A.alternate !== null && (C = A), A = A.sibling;
          C === null ? v || y.tail === null ? y.tail = null : y.tail.sibling = null : C.sibling = null;
      }
    }
    function Fo(y) {
      switch (y.tag) {
        case 1:
          L0(y.type) && Ni();
          var v = y.effectTag;
          return v & 4096 ? (y.effectTag = v & -4097 | 64, y) : null;
        case 3:
          if (ds(), Na(), v = y.effectTag, v & 64) throw Error(o(285));
          return y.effectTag = v & -4097 | 64, y;
        case 5:
          return nt(y), null;
        case 13:
          return br(sr), v = y.effectTag, v & 4096 ? (y.effectTag = v & -4097 | 64, y) : null;
        case 19:
          return br(sr), null;
        case 4:
          return ds(), null;
        case 10:
          return Bl(y), null;
        default:
          return null;
      }
    }
    function ja(y, v) {
      return {
        value: y,
        source: v,
        stack: dr(v)
      };
    }
    var tr = typeof WeakSet == "function" ? WeakSet : Set;
    function Cu(y, v) {
      var A = v.source, C = v.stack;
      C === null && A !== null && (C = dr(A)), A !== null && ee(A.type), v = v.value, y !== null && y.tag === 1 && ee(y.type);
      try {
        console.error(v);
      } catch (I) {
        setTimeout(function() {
          throw I;
        });
      }
    }
    function b2(y, v) {
      try {
        v.props = y.memoizedProps, v.state = y.memoizedState, v.componentWillUnmount();
      } catch (A) {
        xn(y, A);
      }
    }
    function Tf(y) {
      var v = y.ref;
      if (v !== null) if (typeof v == "function") try {
        v(null);
      } catch (A) {
        xn(y, A);
      }
      else v.current = null;
    }
    function w2(y, v) {
      switch (v.tag) {
        case 0:
        case 11:
        case 15:
          wi(2, 0, v);
          break;
        case 1:
          if (v.effectTag & 256 && y !== null) {
            var A = y.memoizedProps, C = y.memoizedState;
            y = v.stateNode, v = y.getSnapshotBeforeUpdate(v.elementType === v.type ? A : Dr(v.type, A), C), y.__reactInternalSnapshotBeforeUpdate = v;
          }
          break;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(o(163));
      }
    }
    function wi(y, v, A) {
      if (A = A.updateQueue, A = A !== null ? A.lastEffect : null, A !== null) {
        var C = A = A.next;
        do {
          if (C.tag & y) {
            var I = C.destroy;
            C.destroy = void 0, I !== void 0 && I();
          }
          C.tag & v && (I = C.create, C.destroy = I()), C = C.next;
        } while (C !== A);
      }
    }
    function kf(y, v, A) {
      switch (typeof Hi == "function" && Hi(v), v.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if (y = v.updateQueue, y !== null && (y = y.lastEffect, y !== null)) {
            var C = y.next;
            et(97 < A ? 97 : A, function() {
              var I = C;
              do {
                var L = I.destroy;
                if (L !== void 0) {
                  var ae = v;
                  try {
                    L();
                  } catch (it) {
                    xn(ae, it);
                  }
                }
                I = I.next;
              } while (I !== C);
            });
          }
          break;
        case 1:
          Tf(v), A = v.stateNode, typeof A.componentWillUnmount == "function" && b2(v, A);
          break;
        case 5:
          Tf(v);
          break;
        case 4:
          De ? Of(y, v, A) : Qe && A2(v);
      }
    }
    function Zl(y, v, A) {
      for (var C = v; ; ) if (kf(y, C, A), C.child === null || De && C.tag === 4) {
        if (C === v) break;
        for (; C.sibling === null; ) {
          if (C.return === null || C.return === v) return;
          C = C.return;
        }
        C.sibling.return = C.return, C = C.sibling;
      } else C.child.return = C, C = C.child;
    }
    function Sf(y) {
      var v = y.alternate;
      y.return = null, y.child = null, y.memoizedState = null, y.updateQueue = null, y.dependencies = null, y.alternate = null, y.firstEffect = null, y.lastEffect = null, y.pendingProps = null, y.memoizedProps = null, v !== null && Sf(v);
    }
    function A2(y) {
      if (Qe) {
        y = y.stateNode.containerInfo;
        var v = E0(y);
        B0(y, v);
      }
    }
    function Cf(y) {
      return y.tag === 5 || y.tag === 3 || y.tag === 4;
    }
    function Ff(y) {
      if (De) {
        e: {
          for (var v = y.return; v !== null; ) {
            if (Cf(v)) {
              var A = v;
              break e;
            }
            v = v.return;
          }
          throw Error(o(160));
        }
        switch (v = A.stateNode, A.tag) {
          case 5:
            var C = !1;
            break;
          case 3:
            v = v.containerInfo, C = !0;
            break;
          case 4:
            v = v.containerInfo, C = !0;
            break;
          default:
            throw Error(o(161));
        }
        A.effectTag & 16 && (mt(v), A.effectTag &= -17);
        e: n: for (A = y; ; ) {
          for (; A.sibling === null; ) {
            if (A.return === null || Cf(A.return)) {
              A = null;
              break e;
            }
            A = A.return;
          }
          for (A.sibling.return = A.return, A = A.sibling; A.tag !== 5 && A.tag !== 6 && A.tag !== 18; ) {
            if (A.effectTag & 2 || A.child === null || A.tag === 4) continue n;
            A.child.return = A, A = A.child;
          }
          if (!(A.effectTag & 2)) {
            A = A.stateNode;
            break e;
          }
        }
        for (var I = y; ; ) {
          var L = I.tag === 5 || I.tag === 6;
          if (L) L = L ? I.stateNode : I.stateNode.instance, A ? C ? V(v, L, A) : T(v, L, A) : C ? _t(v, L) : pt(v, L);
          else if (I.tag !== 4 && I.child !== null) {
            I.child.return = I, I = I.child;
            continue;
          }
          if (I === y) break;
          for (; I.sibling === null; ) {
            if (I.return === null || I.return === y) return;
            I = I.return;
          }
          I.sibling.return = I.return, I = I.sibling;
        }
      }
    }
    function Of(y, v, A) {
      for (var C = v, I = !1, L, ae; ; ) {
        if (!I) {
          I = C.return;
          e: for (; ; ) {
            if (I === null) throw Error(o(160));
            switch (L = I.stateNode, I.tag) {
              case 5:
                ae = !1;
                break e;
              case 3:
                L = L.containerInfo, ae = !0;
                break e;
              case 4:
                L = L.containerInfo, ae = !0;
                break e;
            }
            I = I.return;
          }
          I = !0;
        }
        if (C.tag === 5 || C.tag === 6) Zl(y, C, A), ae ? Ee(L, C.stateNode) : pe(L, C.stateNode);
        else if (C.tag === 4) {
          if (C.child !== null) {
            L = C.stateNode.containerInfo, ae = !0, C.child.return = C, C = C.child;
            continue;
          }
        } else if (kf(y, C, A), C.child !== null) {
          C.child.return = C, C = C.child;
          continue;
        }
        if (C === v) break;
        for (; C.sibling === null; ) {
          if (C.return === null || C.return === v) return;
          C = C.return, C.tag === 4 && (I = !1);
        }
        C.sibling.return = C.return, C = C.sibling;
      }
    }
    function Fu(y, v) {
      if (De) switch (v.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          wi(4, 8, v);
          break;
        case 1:
          break;
        case 5:
          var A = v.stateNode;
          if (A != null) {
            var C = v.memoizedProps;
            y = y !== null ? y.memoizedProps : C;
            var I = v.type, L = v.updateQueue;
            v.updateQueue = null, L !== null && w(A, L, I, y, C, v);
          }
          break;
        case 6:
          if (v.stateNode === null) throw Error(o(162));
          A = v.memoizedProps, S(v.stateNode, y !== null ? y.memoizedProps : A, A);
          break;
        case 3:
          ct && (v = v.stateNode, v.hydrate && (v.hydrate = !1, Rn(v.containerInfo)));
          break;
        case 12:
          break;
        case 13:
          ql(v), Oo(v);
          break;
        case 19:
          Oo(v);
          break;
        case 17:
          break;
        case 20:
          break;
        case 21:
          break;
        default:
          throw Error(o(163));
      }
      else {
        switch (v.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            wi(4, 8, v);
            return;
          case 12:
            return;
          case 13:
            ql(v), Oo(v);
            return;
          case 19:
            Oo(v);
            return;
          case 3:
            ct && (A = v.stateNode, A.hydrate && (A.hydrate = !1, Rn(A.containerInfo)));
        }
        e: if (Qe) switch (v.tag) {
          case 1:
          case 5:
          case 6:
          case 20:
            break e;
          case 3:
          case 4:
            v = v.stateNode, B0(v.containerInfo, v.pendingChildren);
            break e;
          default:
            throw Error(o(163));
        }
      }
    }
    function ql(y) {
      var v = y;
      if (y.memoizedState === null) var A = !1;
      else A = !0, v = y.child, ce = Ue();
      if (De && v !== null) {
        e: if (y = v, De) for (v = y; ; ) {
          if (v.tag === 5) {
            var C = v.stateNode;
            A ? gt(C) : Bt(v.stateNode, v.memoizedProps);
          } else if (v.tag === 6) C = v.stateNode, A ? St(C) : yt(C, v.memoizedProps);
          else if (v.tag === 13 && v.memoizedState !== null && v.memoizedState.dehydrated === null) {
            C = v.child.sibling, C.return = v, v = C;
            continue;
          } else if (v.child !== null) {
            v.child.return = v, v = v.child;
            continue;
          }
          if (v === y) break e;
          for (; v.sibling === null; ) {
            if (v.return === null || v.return === y) break e;
            v = v.return;
          }
          v.sibling.return = v.return, v = v.sibling;
        }
      }
    }
    function Oo(y) {
      var v = y.updateQueue;
      if (v !== null) {
        y.updateQueue = null;
        var A = y.stateNode;
        A === null && (A = y.stateNode = new tr()), v.forEach(function(C) {
          var I = Ro.bind(null, y, C);
          A.has(C) || (A.add(C), C.then(I, I));
        });
      }
    }
    var x2 = typeof WeakMap == "function" ? WeakMap : Map;
    function Rf(y, v, A) {
      A = La(A, null), A.tag = 3, A.payload = {
        element: null
      };
      var C = v.value;
      return A.callback = function() {
        Ne || (Ne = !0, ue = C), Cu(y, v);
      }, A;
    }
    function If(y, v, A) {
      A = La(A, null), A.tag = 3;
      var C = y.type.getDerivedStateFromError;
      if (typeof C == "function") {
        var I = v.value;
        A.payload = function() {
          return Cu(y, v), C(I);
        };
      }
      var L = y.stateNode;
      return L !== null && typeof L.componentDidCatch == "function" && (A.callback = function() {
        typeof C != "function" && (le === null ? le = /* @__PURE__ */ new Set([this]) : le.add(this), Cu(y, v));
        var ae = v.stack;
        this.componentDidCatch(v.value, {
          componentStack: ae !== null ? ae : ""
        });
      }), A;
    }
    var E2 = Math.ceil, Ou = s.ReactCurrentDispatcher, Pf = s.ReactCurrentOwner, w0 = 0, un = 8, yn = 16, Gn = 32, Q0 = 0, Ru = 1, Bf = 2, Iu = 3, bs = 4, xt = 5, zt = w0, u = null, l = null, p = 0, m = Q0, D = null, F = 1073741823, U = 1073741823, $ = null, X = 0, Pe = !1, ce = 0, Ce = 500, ge = null, Ne = !1, ue = null, le = null, Ae = !1, Le = null, $e = 90, He = null, Je = 0, st = null, dt = 0;
    function vt() {
      return (zt & (yn | Gn)) !== w0 ? 1073741821 - (Ue() / 10 | 0) : dt !== 0 ? dt : dt = 1073741821 - (Ue() / 10 | 0);
    }
    function At(y, v, A) {
      if (v = v.mode, !(v & 2)) return 1073741823;
      var C = at();
      if (!(v & 4)) return C === 99 ? 1073741823 : 1073741822;
      if ((zt & yn) !== w0) return p;
      if (A !== null) y = Ut(y, A.timeoutMs | 0 || 5e3, 250);
      else switch (C) {
        case 99:
          y = 1073741823;
          break;
        case 98:
          y = Ut(y, 150, 100);
          break;
        case 97:
        case 96:
          y = Ut(y, 5e3, 250);
          break;
        case 95:
          y = 2;
          break;
        default:
          throw Error(o(326));
      }
      return u !== null && y === p && --y, y;
    }
    function Ot(y, v) {
      if (50 < Je) throw Je = 0, st = null, Error(o(185));
      if (y = Vt(y, v), y !== null) {
        var A = at();
        v === 1073741823 ? (zt & un) !== w0 && (zt & (yn | Gn)) === w0 ? Wr(y) : (Jt(y), zt === w0 && ze()) : Jt(y), (zt & 4) === w0 || A !== 98 && A !== 99 || (He === null ? He = /* @__PURE__ */ new Map([[y, v]]) : (A = He.get(y), (A === void 0 || A > v) && He.set(y, v)));
      }
    }
    function Vt(y, v) {
      y.expirationTime < v && (y.expirationTime = v);
      var A = y.alternate;
      A !== null && A.expirationTime < v && (A.expirationTime = v);
      var C = y.return, I = null;
      if (C === null && y.tag === 3) I = y.stateNode;
      else for (; C !== null; ) {
        if (A = C.alternate, C.childExpirationTime < v && (C.childExpirationTime = v), A !== null && A.childExpirationTime < v && (A.childExpirationTime = v), C.return === null && C.tag === 3) {
          I = C.stateNode;
          break;
        }
        C = C.return;
      }
      return I !== null && (u === I && (C0(v), m === bs && xa(I, p)), Kl(I, v)), I;
    }
    function rr(y) {
      var v = y.lastExpiredTime;
      return v !== 0 || (v = y.firstPendingTime, !Xl(y, v)) ? v : (v = y.lastPingedTime, y = y.nextKnownPendingLevel, v > y ? v : y);
    }
    function Jt(y) {
      if (y.lastExpiredTime !== 0) y.callbackExpirationTime = 1073741823, y.callbackPriority = 99, y.callbackNode = qe(Wr.bind(null, y));
      else {
        var v = rr(y), A = y.callbackNode;
        if (v === 0) A !== null && (y.callbackNode = null, y.callbackExpirationTime = 0, y.callbackPriority = 90);
        else {
          var C = vt();
          if (v === 1073741823 ? C = 99 : v === 1 || v === 2 ? C = 95 : (C = 10 * (1073741821 - v) - 10 * (1073741821 - C), C = 0 >= C ? 99 : 250 >= C ? 98 : 5250 >= C ? 97 : 95), A !== null) {
            var I = y.callbackPriority;
            if (y.callbackExpirationTime === v && I >= C) return;
            A !== u0 && G0(A);
          }
          y.callbackExpirationTime = v, y.callbackPriority = C, v = v === 1073741823 ? qe(Wr.bind(null, y)) : Et(C, Xr.bind(null, y), {
            timeout: 10 * (1073741821 - v) - Ue()
          }), y.callbackNode = v;
        }
      }
    }
    function Xr(y, v) {
      if (dt = 0, v) return v = vt(), Mu(y, v), Jt(y), null;
      var A = rr(y);
      if (A !== 0) {
        if (v = y.callbackNode, (zt & (yn | Gn)) !== w0) throw Error(o(327));
        if (An(), y === u && A === p || Gr(y, A), l !== null) {
          var C = zt;
          zt |= yn;
          var I = q0();
          do
            try {
              bn();
              break;
            } catch (it) {
              f0(y, it);
            }
          while (!0);
          if (Ke(), zt = C, Ou.current = I, m === Ru) throw v = D, Gr(y, A), xa(y, A), Jt(y), v;
          if (l === null) switch (I = y.finishedWork = y.current.alternate, y.finishedExpirationTime = A, C = m, u = null, C) {
            case Q0:
            case Ru:
              throw Error(o(345));
            case Bf:
              Mu(y, 2 < A ? 2 : A);
              break;
            case Iu:
              if (xa(y, A), C = y.lastSuspendedTime, A === C && (y.nextKnownPendingLevel = Vn(I)), F === 1073741823 && (I = ce + Ce - Ue(), 10 < I)) {
                if (Pe) {
                  var L = y.lastPingedTime;
                  if (L === 0 || L >= A) {
                    y.lastPingedTime = A, Gr(y, A);
                    break;
                  }
                }
                if (L = rr(y), L !== 0 && L !== A) break;
                if (C !== 0 && C !== A) {
                  y.lastPingedTime = C;
                  break;
                }
                y.timeoutHandle = xe(X0.bind(null, y), I);
                break;
              }
              X0(y);
              break;
            case bs:
              if (xa(y, A), C = y.lastSuspendedTime, A === C && (y.nextKnownPendingLevel = Vn(I)), Pe && (I = y.lastPingedTime, I === 0 || I >= A)) {
                y.lastPingedTime = A, Gr(y, A);
                break;
              }
              if (I = rr(y), I !== 0 && I !== A) break;
              if (C !== 0 && C !== A) {
                y.lastPingedTime = C;
                break;
              }
              if (U !== 1073741823 ? C = 10 * (1073741821 - U) - Ue() : F === 1073741823 ? C = 0 : (C = 10 * (1073741821 - F) - 5e3, I = Ue(), A = 10 * (1073741821 - A) - I, C = I - C, 0 > C && (C = 0), C = (120 > C ? 120 : 480 > C ? 480 : 1080 > C ? 1080 : 1920 > C ? 1920 : 3e3 > C ? 3e3 : 4320 > C ? 4320 : 1960 * E2(C / 1960)) - C, A < C && (C = A)), 10 < C) {
                y.timeoutHandle = xe(X0.bind(null, y), C);
                break;
              }
              X0(y);
              break;
            case xt:
              if (F !== 1073741823 && $ !== null) {
                L = F;
                var ae = $;
                if (C = ae.busyMinDurationMs | 0, 0 >= C ? C = 0 : (I = ae.busyDelayMs | 0, L = Ue() - (10 * (1073741821 - L) - (ae.timeoutMs | 0 || 5e3)), C = L <= I ? 0 : I + C - L), 10 < C) {
                  xa(y, A), y.timeoutHandle = xe(X0.bind(null, y), C);
                  break;
                }
              }
              X0(y);
              break;
            default:
              throw Error(o(329));
          }
          if (Jt(y), y.callbackNode === v) return Xr.bind(null, y);
        }
      }
      return null;
    }
    function Wr(y) {
      var v = y.lastExpiredTime;
      if (v = v !== 0 ? v : 1073741823, y.finishedExpirationTime === v) X0(y);
      else {
        if ((zt & (yn | Gn)) !== w0) throw Error(o(327));
        if (An(), y === u && v === p || Gr(y, v), l !== null) {
          var A = zt;
          zt |= yn;
          var C = q0();
          do
            try {
              tn();
              break;
            } catch (I) {
              f0(y, I);
            }
          while (!0);
          if (Ke(), zt = A, Ou.current = C, m === Ru) throw A = D, Gr(y, v), xa(y, v), Jt(y), A;
          if (l !== null) throw Error(o(261));
          y.finishedWork = y.current.alternate, y.finishedExpirationTime = v, u = null, X0(y), Jt(y);
        }
      }
      return null;
    }
    function c0(y, v) {
      Mu(y, v), Jt(y), (zt & (yn | Gn)) === w0 && ze();
    }
    function i0() {
      if (He !== null) {
        var y = He;
        He = null, y.forEach(function(v, A) {
          Mu(A, v), Jt(A);
        }), ze();
      }
    }
    function e0(y, v) {
      if ((zt & (yn | Gn)) !== w0) throw Error(o(187));
      var A = zt;
      zt |= 1;
      try {
        return et(99, y.bind(null, v));
      } finally {
        zt = A, ze();
      }
    }
    function Gr(y, v) {
      y.finishedWork = null, y.finishedExpirationTime = 0;
      var A = y.timeoutHandle;
      if (A !== he && (y.timeoutHandle = he, be(A)), l !== null) for (A = l.return; A !== null; ) {
        var C = A;
        switch (C.tag) {
          case 1:
            var I = C.type.childContextTypes;
            I != null && Ni();
            break;
          case 3:
            ds(), Na();
            break;
          case 5:
            nt(C);
            break;
          case 4:
            ds();
            break;
          case 13:
            br(sr);
            break;
          case 19:
            br(sr);
            break;
          case 10:
            Bl(C);
        }
        A = A.return;
      }
      u = y, l = Ai(y.current, null), p = v, m = Q0, D = null, U = F = 1073741823, $ = null, X = 0, Pe = !1;
    }
    function f0(y, v) {
      do {
        try {
          if (Ke(), mf(), l === null || l.return === null) return m = Ru, D = v, null;
          e: {
            var A = y, C = l.return, I = l, L = v;
            if (v = p, I.effectTag |= 2048, I.firstEffect = I.lastEffect = null, L !== null && typeof L == "object" && typeof L.then == "function") {
              var ae = L, it = (sr.current & 1) !== 0, Ye = C;
              do {
                var wt;
                if (wt = Ye.tag === 13) {
                  var Nt = Ye.memoizedState;
                  if (Nt !== null) wt = Nt.dehydrated !== null;
                  else {
                    var En = Ye.memoizedProps;
                    wt = En.fallback === void 0 ? !1 : En.unstable_avoidThisFallback !== !0 ? !0 : !it;
                  }
                }
                if (wt) {
                  var F0 = Ye.updateQueue;
                  if (F0 === null) {
                    var ni = /* @__PURE__ */ new Set();
                    ni.add(ae), Ye.updateQueue = ni;
                  } else F0.add(ae);
                  if (!(Ye.mode & 2)) {
                    if (Ye.effectTag |= 64, I.effectTag &= -2981, I.tag === 1) if (I.alternate === null) I.tag = 17;
                    else {
                      var $u = La(1073741823, null);
                      $u.tag = 2, ot(I, $u);
                    }
                    I.expirationTime = 1073741823;
                    break e;
                  }
                  L = void 0, I = v;
                  var Ei = A.pingCache;
                  if (Ei === null ? (Ei = A.pingCache = new x2(), L = /* @__PURE__ */ new Set(), Ei.set(ae, L)) : (L = Ei.get(ae), L === void 0 && (L = /* @__PURE__ */ new Set(), Ei.set(ae, L))), !L.has(I)) {
                    L.add(I);
                    var Ve = ba.bind(null, A, ae, I);
                    ae.then(Ve, Ve);
                  }
                  Ye.effectTag |= 4096, Ye.expirationTime = v;
                  break e;
                }
                Ye = Ye.return;
              } while (Ye !== null);
              L = Error((ee(I.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.` + dr(I));
            }
            m !== xt && (m = Bf), L = ja(L, I), Ye = C;
            do {
              switch (Ye.tag) {
                case 3:
                  ae = L, Ye.effectTag |= 4096, Ye.expirationTime = v;
                  var Be = Rf(Ye, ae, v);
                  Y0(Ye, Be);
                  break e;
                case 1:
                  ae = L;
                  var Xe = Ye.type, It = Ye.stateNode;
                  if (!(Ye.effectTag & 64) && (typeof Xe.getDerivedStateFromError == "function" || It !== null && typeof It.componentDidCatch == "function" && (le === null || !le.has(It)))) {
                    Ye.effectTag |= 4096, Ye.expirationTime = v;
                    var Wt = If(Ye, ae, v);
                    Y0(Ye, Wt);
                    break e;
                  }
              }
              Ye = Ye.return;
            } while (Ye !== null);
          }
          l = Mn(l);
        } catch (Vr) {
          v = Vr;
          continue;
        }
        break;
      } while (!0);
    }
    function q0() {
      var y = Ou.current;
      return Ou.current = gs, y === null ? gs : y;
    }
    function en(y, v) {
      y < F && 2 < y && (F = y), v !== null && y < U && 2 < y && (U = y, $ = v);
    }
    function C0(y) {
      y > X && (X = y);
    }
    function tn() {
      for (; l !== null; ) l = wn(l);
    }
    function bn() {
      for (; l !== null && !In(); ) l = wn(l);
    }
    function wn(y) {
      var v = wa(y.alternate, y, p);
      return y.memoizedProps = y.pendingProps, v === null && (v = Mn(y)), Pf.current = null, v;
    }
    function Mn(y) {
      l = y;
      do {
        var v = l.alternate;
        if (y = l.return, l.effectTag & 2048) {
          if (v = Fo(l), v !== null) return v.effectTag &= 2047, v;
          y !== null && (y.firstEffect = y.lastEffect = null, y.effectTag |= 2048);
        } else {
          e: {
            var A = v;
            v = l;
            var C = p, I = v.pendingProps;
            switch (v.tag) {
              case 2:
                break;
              case 16:
                break;
              case 15:
              case 0:
                break;
              case 1:
                L0(v.type) && Ni();
                break;
              case 3:
                ds(), Na(), I = v.stateNode, I.pendingContext && (I.context = I.pendingContext, I.pendingContext = null), (A === null || A.child === null) && Wn(v) && sn(v), ma(v);
                break;
              case 5:
                nt(v);
                var L = Wi(hs.current);
                if (C = v.type, A !== null && v.stateNode != null) ku(A, v, C, I, L), A.ref !== v.ref && (v.effectTag |= 128);
                else if (I) {
                  if (A = Wi(ti.current), Wn(v)) {
                    if (I = v, !ct) throw Error(o(175));
                    A = os(I.stateNode, I.type, I.memoizedProps, L, A, I), I.updateQueue = A, A = A !== null, A && sn(v);
                  } else {
                    var ae = Re(C, I, L, A, v);
                    ys(ae, v, !1, !1), v.stateNode = ae, W(ae, C, I, L, A) && sn(v);
                  }
                  v.ref !== null && (v.effectTag |= 128);
                } else if (v.stateNode === null) throw Error(o(166));
                break;
              case 6:
                if (A && v.stateNode != null) Su(A, v, A.memoizedProps, I);
                else {
                  if (typeof I != "string" && v.stateNode === null) throw Error(o(166));
                  if (A = Wi(hs.current), L = Wi(ti.current), Wn(v)) {
                    if (A = v, !ct) throw Error(o(176));
                    (A = Bi(A.stateNode, A.memoizedProps, A)) && sn(v);
                  } else v.stateNode = Fe(I, A, L, v);
                }
                break;
              case 11:
                break;
              case 13:
                if (br(sr), I = v.memoizedState, v.effectTag & 64) {
                  v.expirationTime = C;
                  break e;
                }
                I = I !== null, L = !1, A === null ? v.memoizedProps.fallback !== void 0 && Wn(v) : (C = A.memoizedState, L = C !== null, I || C === null || (C = A.child.sibling, C !== null && (ae = v.firstEffect, ae !== null ? (v.firstEffect = C, C.nextEffect = ae) : (v.firstEffect = v.lastEffect = C, C.nextEffect = null), C.effectTag = 8))), I && !L && v.mode & 2 && (A === null && v.memoizedProps.unstable_avoidThisFallback !== !0 || sr.current & 1 ? m === Q0 && (m = Iu) : ((m === Q0 || m === Iu) && (m = bs), X !== 0 && u !== null && (xa(u, p), Kl(u, X)))), Qe && I && (v.effectTag |= 4), De && (I || L) && (v.effectTag |= 4);
                break;
              case 7:
                break;
              case 8:
                break;
              case 12:
                break;
              case 4:
                ds(), ma(v);
                break;
              case 10:
                Bl(v);
                break;
              case 9:
                break;
              case 14:
                break;
              case 17:
                L0(v.type) && Ni();
                break;
              case 19:
                if (br(sr), I = v.memoizedState, I === null) break;
                if (L = (v.effectTag & 64) !== 0, ae = I.rendering, ae === null) {
                  if (L) Ze(I, !1);
                  else if (m !== Q0 || A !== null && A.effectTag & 64) for (A = v.child; A !== null; ) {
                    if (ae = Au(A), ae !== null) {
                      for (v.effectTag |= 64, Ze(I, !1), A = ae.updateQueue, A !== null && (v.updateQueue = A, v.effectTag |= 4), I.lastEffect === null && (v.firstEffect = null), v.lastEffect = I.lastEffect, A = C, I = v.child; I !== null; ) L = I, C = A, L.effectTag &= 2, L.nextEffect = null, L.firstEffect = null, L.lastEffect = null, ae = L.alternate, ae === null ? (L.childExpirationTime = 0, L.expirationTime = C, L.child = null, L.memoizedProps = null, L.memoizedState = null, L.updateQueue = null, L.dependencies = null) : (L.childExpirationTime = ae.childExpirationTime, L.expirationTime = ae.expirationTime, L.child = ae.child, L.memoizedProps = ae.memoizedProps, L.memoizedState = ae.memoizedState, L.updateQueue = ae.updateQueue, C = ae.dependencies, L.dependencies = C === null ? null : {
                        expirationTime: C.expirationTime,
                        firstContext: C.firstContext,
                        responders: C.responders
                      }), I = I.sibling;
                      _r(sr, sr.current & 1 | 2), v = v.child;
                      break e;
                    }
                    A = A.sibling;
                  }
                } else {
                  if (!L) if (A = Au(ae), A !== null) {
                    if (v.effectTag |= 64, L = !0, A = A.updateQueue, A !== null && (v.updateQueue = A, v.effectTag |= 4), Ze(I, !0), I.tail === null && I.tailMode === "hidden") {
                      v = v.lastEffect = I.lastEffect, v !== null && (v.nextEffect = null);
                      break;
                    }
                  } else Ue() > I.tailExpiration && 1 < C && (v.effectTag |= 64, L = !0, Ze(I, !1), v.expirationTime = v.childExpirationTime = C - 1);
                  I.isBackwards ? (ae.sibling = v.child, v.child = ae) : (A = I.last, A !== null ? A.sibling = ae : v.child = ae, I.last = ae);
                }
                if (I.tail !== null) {
                  I.tailExpiration === 0 && (I.tailExpiration = Ue() + 500), A = I.tail, I.rendering = A, I.tail = A.sibling, I.lastEffect = v.lastEffect, A.sibling = null, I = sr.current, I = L ? I & 1 | 2 : I & 1, _r(sr, I), v = A;
                  break e;
                }
                break;
              case 20:
                break;
              case 21:
                break;
              default:
                throw Error(o(156, v.tag));
            }
            v = null;
          }
          if (A = l, p === 1 || A.childExpirationTime !== 1) {
            for (I = 0, L = A.child; L !== null; ) C = L.expirationTime, ae = L.childExpirationTime, C > I && (I = C), ae > I && (I = ae), L = L.sibling;
            A.childExpirationTime = I;
          }
          if (v !== null) return v;
          y !== null && !(y.effectTag & 2048) && (y.firstEffect === null && (y.firstEffect = l.firstEffect), l.lastEffect !== null && (y.lastEffect !== null && (y.lastEffect.nextEffect = l.firstEffect), y.lastEffect = l.lastEffect), 1 < l.effectTag && (y.lastEffect !== null ? y.lastEffect.nextEffect = l : y.firstEffect = l, y.lastEffect = l));
        }
        if (v = l.sibling, v !== null) return v;
        l = y;
      } while (l !== null);
      return m === Q0 && (m = xt), null;
    }
    function Vn(y) {
      var v = y.expirationTime;
      return y = y.childExpirationTime, v > y ? v : y;
    }
    function X0(y) {
      var v = at();
      return et(99, Vi.bind(null, y, v)), null;
    }
    function Vi(y, v) {
      if (An(), (zt & (yn | Gn)) !== w0) throw Error(o(327));
      var A = y.finishedWork, C = y.finishedExpirationTime;
      if (A === null) return null;
      if (y.finishedWork = null, y.finishedExpirationTime = 0, A === y.current) throw Error(o(177));
      y.callbackNode = null, y.callbackExpirationTime = 0, y.callbackPriority = 90, y.nextKnownPendingLevel = 0;
      var I = Vn(A);
      if (y.firstPendingTime = I, C <= y.lastSuspendedTime ? y.firstSuspendedTime = y.lastSuspendedTime = y.nextKnownPendingLevel = 0 : C <= y.firstSuspendedTime && (y.firstSuspendedTime = C - 1), C <= y.lastPingedTime && (y.lastPingedTime = 0), C <= y.lastExpiredTime && (y.lastExpiredTime = 0), y === u && (l = u = null, p = 0), 1 < A.effectTag ? A.lastEffect !== null ? (A.lastEffect.nextEffect = A, I = A.firstEffect) : I = A : I = A.firstEffect, I !== null) {
        var L = zt;
        zt |= Gn, Pf.current = null, fe(y.containerInfo), ge = I;
        do
          try {
            Yi();
          } catch (ii) {
            if (ge === null) throw Error(o(330));
            xn(ge, ii), ge = ge.nextEffect;
          }
        while (ge !== null);
        ge = I;
        do
          try {
            for (var ae = y, it = v; ge !== null; ) {
              var Ye = ge.effectTag;
              if (Ye & 16 && De && mt(ge.stateNode), Ye & 128) {
                var wt = ge.alternate;
                if (wt !== null) {
                  var Nt = wt.ref;
                  Nt !== null && (typeof Nt == "function" ? Nt(null) : Nt.current = null);
                }
              }
              switch (Ye & 1038) {
                case 2:
                  Ff(ge), ge.effectTag &= -3;
                  break;
                case 6:
                  Ff(ge), ge.effectTag &= -3, Fu(ge.alternate, ge);
                  break;
                case 1024:
                  ge.effectTag &= -1025;
                  break;
                case 1028:
                  ge.effectTag &= -1025, Fu(ge.alternate, ge);
                  break;
                case 4:
                  Fu(ge.alternate, ge);
                  break;
                case 8:
                  var En = ae, F0 = ge, ni = it;
                  De ? Of(En, F0, ni) : Zl(En, F0, ni), Sf(F0);
              }
              ge = ge.nextEffect;
            }
          } catch (ii) {
            if (ge === null) throw Error(o(330));
            xn(ge, ii), ge = ge.nextEffect;
          }
        while (ge !== null);
        _e(y.containerInfo), y.current = A, ge = I;
        do
          try {
            for (Ye = C; ge !== null; ) {
              var $u = ge.effectTag;
              if ($u & 36) {
                var Ei = ge.alternate;
                switch (wt = ge, Nt = Ye, wt.tag) {
                  case 0:
                  case 11:
                  case 15:
                    wi(16, 32, wt);
                    break;
                  case 1:
                    var Ve = wt.stateNode;
                    if (wt.effectTag & 4) if (Ei === null) Ve.componentDidMount();
                    else {
                      var Be = wt.elementType === wt.type ? Ei.memoizedProps : Dr(wt.type, Ei.memoizedProps);
                      Ve.componentDidUpdate(Be, Ei.memoizedState, Ve.__reactInternalSnapshotBeforeUpdate);
                    }
                    var Xe = wt.updateQueue;
                    Xe !== null && Do(wt, Xe, Ve, Nt);
                    break;
                  case 3:
                    var It = wt.updateQueue;
                    if (It !== null) {
                      if (ae = null, wt.child !== null) switch (wt.child.tag) {
                        case 5:
                          ae = oe(wt.child.stateNode);
                          break;
                        case 1:
                          ae = wt.child.stateNode;
                      }
                      Do(wt, It, ae, Nt);
                    }
                    break;
                  case 5:
                    var Wt = wt.stateNode;
                    Ei === null && wt.effectTag & 4 && b(Wt, wt.type, wt.memoizedProps, wt);
                    break;
                  case 6:
                    break;
                  case 4:
                    break;
                  case 12:
                    break;
                  case 13:
                    if (ct && wt.memoizedState === null) {
                      var Vr = wt.alternate;
                      if (Vr !== null) {
                        var qt = Vr.memoizedState;
                        if (qt !== null) {
                          var Yr = qt.dehydrated;
                          Yr !== null && ss(Yr);
                        }
                      }
                    }
                    break;
                  case 19:
                  case 17:
                  case 20:
                  case 21:
                    break;
                  default:
                    throw Error(o(163));
                }
              }
              if ($u & 128) {
                wt = void 0;
                var A0 = ge.ref;
                if (A0 !== null) {
                  var vr = ge.stateNode;
                  switch (ge.tag) {
                    case 5:
                      wt = oe(vr);
                      break;
                    default:
                      wt = vr;
                  }
                  typeof A0 == "function" ? A0(wt) : A0.current = wt;
                }
              }
              ge = ge.nextEffect;
            }
          } catch (ii) {
            if (ge === null) throw Error(o(330));
            xn(ge, ii), ge = ge.nextEffect;
          }
        while (ge !== null);
        ge = null, ie(), zt = L;
      } else y.current = A;
      if (Ae) Ae = !1, Le = y, $e = v;
      else for (ge = I; ge !== null; ) v = ge.nextEffect, ge.nextEffect = null, ge = v;
      if (v = y.firstPendingTime, v === 0 && (le = null), v === 1073741823 ? y === st ? Je++ : (Je = 0, st = y) : Je = 0, typeof Aa == "function" && Aa(A.stateNode, C), Jt(y), Ne) throw Ne = !1, y = ue, ue = null, y;
      return (zt & un) !== w0 || ze(), null;
    }
    function Yi() {
      for (; ge !== null; ) {
        var y = ge.effectTag;
        y & 256 && w2(ge.alternate, ge), !(y & 512) || Ae || (Ae = !0, Et(97, function() {
          return An(), null;
        })), ge = ge.nextEffect;
      }
    }
    function An() {
      if ($e !== 90) {
        var y = 97 < $e ? 97 : $e;
        return $e = 90, et(y, ya);
      }
    }
    function ya() {
      if (Le === null) return !1;
      var y = Le;
      if (Le = null, (zt & (yn | Gn)) !== w0) throw Error(o(331));
      var v = zt;
      for (zt |= Gn, y = y.current.firstEffect; y !== null; ) {
        try {
          var A = y;
          if (A.effectTag & 512) switch (A.tag) {
            case 0:
            case 11:
            case 15:
              wi(128, 0, A), wi(0, 64, A);
          }
        } catch (C) {
          if (y === null) throw Error(o(330));
          xn(y, C);
        }
        A = y.nextEffect, y.nextEffect = null, y = A;
      }
      return zt = v, ze(), !0;
    }
    function Wa(y, v, A) {
      v = ja(A, v), v = Rf(y, v, 1073741823), ot(y, v), y = Vt(y, 1073741823), y !== null && Jt(y);
    }
    function xn(y, v) {
      if (y.tag === 3) Wa(y, y, v);
      else for (var A = y.return; A !== null; ) {
        if (A.tag === 3) {
          Wa(A, y, v);
          break;
        } else if (A.tag === 1) {
          var C = A.stateNode;
          if (typeof A.type.getDerivedStateFromError == "function" || typeof C.componentDidCatch == "function" && (le === null || !le.has(C))) {
            y = ja(v, y), y = If(A, y, 1073741823), ot(A, y), A = Vt(A, 1073741823), A !== null && Jt(A);
            break;
          }
        }
        A = A.return;
      }
    }
    function ba(y, v, A) {
      var C = y.pingCache;
      C !== null && C.delete(v), u === y && p === A ? m === bs || m === Iu && F === 1073741823 && Ue() - ce < Ce ? Gr(y, p) : Pe = !0 : Xl(y, A) && (v = y.lastPingedTime, v !== 0 && v < A || (y.lastPingedTime = A, y.finishedExpirationTime === A && (y.finishedExpirationTime = 0, y.finishedWork = null), Jt(y)));
    }
    function Ro(y, v) {
      var A = y.stateNode;
      A !== null && A.delete(v), v = 0, v === 0 && (v = vt(), v = At(v, y, null)), y = Vt(y, v), y !== null && Jt(y);
    }
    var wa;
    wa = function(v, A, C) {
      var I = A.expirationTime;
      if (v !== null) {
        var L = A.pendingProps;
        if (v.memoizedProps !== L || g0.current) gn = !0;
        else {
          if (I < C) {
            switch (gn = !1, A.tag) {
              case 3:
                Vl(A), Bn();
                break;
              case 5:
                if (g2(A), A.mode & 4 && C !== 1 && ye(A.type, L)) return A.expirationTime = A.childExpirationTime = 1, null;
                break;
              case 1:
                L0(A.type) && Mi(A);
                break;
              case 4:
                vf(A, A.stateNode.containerInfo);
                break;
              case 10:
                _o(A, A.memoizedProps.value);
                break;
              case 13:
                if (A.memoizedState !== null)
                  return I = A.child.childExpirationTime, I !== 0 && I >= C ? Ln(v, A, C) : (_r(sr, sr.current & 1), A = mn(v, A, C), A !== null ? A.sibling : null);
                _r(sr, sr.current & 1);
                break;
              case 19:
                if (I = A.childExpirationTime >= C, v.effectTag & 64) {
                  if (I) return M0(v, A, C);
                  A.effectTag |= 64;
                }
                if (L = A.memoizedState, L !== null && (L.rendering = null, L.tail = null), _r(sr, sr.current), !I) return null;
            }
            return mn(v, A, C);
          }
          gn = !1;
        }
      } else gn = !1;
      switch (A.expirationTime = 0, A.tag) {
        case 2:
          if (I = A.type, v !== null && (v.alternate = null, A.alternate = null, A.effectTag |= 2), v = A.pendingProps, L = jn(A, r0.current), Fr(A, C), L = zl(null, A, I, v, L, C), A.effectTag |= 1, typeof L == "object" && L !== null && typeof L.render == "function" && L.$$typeof === void 0) {
            if (A.tag = 1, mf(), L0(I)) {
              var ae = !0;
              Mi(A);
            } else ae = !1;
            A.memoizedState = L.state !== null && L.state !== void 0 ? L.state : null;
            var it = I.getDerivedStateFromProps;
            typeof it == "function" && ls(A, I, it, v), L.updater = cs, A.stateNode = L, L._reactInternalFiber = A, Ml(A, I, v, C), A = Gl(null, A, I, !0, ae, C);
          } else A.tag = 0, Nn(null, A, L, C), A = A.child;
          return A;
        case 16:
          if (L = A.elementType, v !== null && (v.alternate = null, A.alternate = null, A.effectTag |= 2), v = A.pendingProps, K(L), L._status !== 1) throw L._result;
          switch (L = L._result, A.type = L, ae = A.tag = Bu(L), v = Dr(L, v), ae) {
            case 0:
              A = Tu(null, A, L, v, C);
              break;
            case 1:
              A = Df(null, A, L, v, C);
              break;
            case 11:
              A = _f(null, A, L, v, C);
              break;
            case 14:
              A = _u(null, A, L, Dr(L.type, v), I, C);
              break;
            default:
              throw Error(o(306, L, ""));
          }
          return A;
        case 0:
          return I = A.type, L = A.pendingProps, L = A.elementType === I ? L : Dr(I, L), Tu(v, A, I, L, C);
        case 1:
          return I = A.type, L = A.pendingProps, L = A.elementType === I ? L : Dr(I, L), Df(v, A, I, L, C);
        case 3:
          if (Vl(A), I = A.updateQueue, I === null) throw Error(o(282));
          if (L = A.memoizedState, L = L !== null ? L.element : null, ji(A, I, A.pendingProps, null, C), I = A.memoizedState.element, I === L) Bn(), A = mn(v, A, C);
          else {
            if ((L = A.stateNode.hydrate) && (ct ? (nr = da(A.stateNode.containerInfo), Z0 = A, L = Kt = !0) : L = !1), L) for (C = pf(A, null, I, C), A.child = C; C; ) C.effectTag = C.effectTag & -3 | 1024, C = C.sibling;
            else Nn(v, A, I, C), Bn();
            A = A.child;
          }
          return A;
        case 5:
          return g2(A), v === null && Wl(A), I = A.type, L = A.pendingProps, ae = v !== null ? v.memoizedProps : null, it = L.children, se(I, L) ? it = null : ae !== null && se(I, ae) && (A.effectTag |= 16), Co(v, A), A.mode & 4 && C !== 1 && ye(I, L) ? (A.expirationTime = A.childExpirationTime = 1, A = null) : (Nn(v, A, it, C), A = A.child), A;
        case 6:
          return v === null && Wl(A), null;
        case 13:
          return Ln(v, A, C);
        case 4:
          return vf(A, A.stateNode.containerInfo), I = A.pendingProps, v === null ? A.child = fs(A, null, I, C) : Nn(v, A, I, C), A.child;
        case 11:
          return I = A.type, L = A.pendingProps, L = A.elementType === I ? L : Dr(I, L), _f(v, A, I, L, C);
        case 7:
          return Nn(v, A, A.pendingProps, C), A.child;
        case 8:
          return Nn(v, A, A.pendingProps.children, C), A.child;
        case 12:
          return Nn(v, A, A.pendingProps.children, C), A.child;
        case 10:
          e: {
            if (I = A.type._context, L = A.pendingProps, it = A.memoizedProps, ae = L.value, _o(A, ae), it !== null) {
              var Ye = it.value;
              if (ae = Tt(Ye, ae) ? 0 : (typeof I._calculateChangedBits == "function" ? I._calculateChangedBits(Ye, ae) : 1073741823) | 0, ae === 0) {
                if (it.children === L.children && !g0.current) {
                  A = mn(v, A, C);
                  break e;
                }
              } else for (Ye = A.child, Ye !== null && (Ye.return = A); Ye !== null; ) {
                var wt = Ye.dependencies;
                if (wt !== null) {
                  it = Ye.child;
                  for (var Nt = wt.firstContext; Nt !== null; ) {
                    if (Nt.context === I && Nt.observedBits & ae) {
                      Ye.tag === 1 && (Nt = La(C, null), Nt.tag = 2, ot(Ye, Nt)), Ye.expirationTime < C && (Ye.expirationTime = C), Nt = Ye.alternate, Nt !== null && Nt.expirationTime < C && (Nt.expirationTime = C), Y(Ye.return, C), wt.expirationTime < C && (wt.expirationTime = C);
                      break;
                    }
                    Nt = Nt.next;
                  }
                } else it = Ye.tag === 10 && Ye.type === A.type ? null : Ye.child;
                if (it !== null) it.return = Ye;
                else for (it = Ye; it !== null; ) {
                  if (it === A) {
                    it = null;
                    break;
                  }
                  if (Ye = it.sibling, Ye !== null) {
                    Ye.return = it.return, it = Ye;
                    break;
                  }
                  it = it.return;
                }
                Ye = it;
              }
            }
            Nn(v, A, L.children, C), A = A.child;
          }
          return A;
        case 9:
          return L = A.type, ae = A.pendingProps, I = ae.children, Fr(A, C), L = pr(L, ae.unstable_observedBits), I = I(L), A.effectTag |= 1, Nn(v, A, I, C), A.child;
        case 14:
          return L = A.type, ae = Dr(L, A.pendingProps), ae = Dr(L.type, ae), _u(v, A, L, ae, I, C);
        case 15:
          return Du(v, A, A.type, A.pendingProps, I, C);
        case 17:
          return I = A.type, L = A.pendingProps, L = A.elementType === I ? L : Dr(I, L), v !== null && (v.alternate = null, A.alternate = null, A.effectTag |= 2), A.tag = 1, L0(I) ? (v = !0, Mi(A)) : v = !1, Fr(A, C), hf(A, I, L), Ml(A, I, L, C), Gl(null, A, I, !0, v, C);
        case 19:
          return M0(v, A, C);
      }
      throw Error(o(156, A.tag));
    };
    var Aa = null, Hi = null;
    function Io(y) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var v = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (v.isDisabled || !v.supportsFiber) return !0;
      try {
        var A = v.inject(y);
        Aa = function(I) {
          try {
            v.onCommitFiberRoot(A, I, void 0, (I.current.effectTag & 64) === 64);
          } catch {
          }
        }, Hi = function(I) {
          try {
            v.onCommitFiberUnmount(A, I);
          } catch {
          }
        };
      } catch {
      }
      return !0;
    }
    function Pu(y, v, A, C) {
      this.tag = y, this.key = A, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = v, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = C, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
    }
    function Un(y, v, A, C) {
      return new Pu(y, v, A, C);
    }
    function Po(y) {
      return y = y.prototype, !(!y || !y.isReactComponent);
    }
    function Bu(y) {
      if (typeof y == "function") return Po(y) ? 1 : 0;
      if (y != null) {
        if (y = y.$$typeof, y === M) return 11;
        if (y === j) return 14;
      }
      return 2;
    }
    function Ai(y, v) {
      var A = y.alternate;
      return A === null ? (A = Un(y.tag, v, y.key, y.mode), A.elementType = y.elementType, A.type = y.type, A.stateNode = y.stateNode, A.alternate = y, y.alternate = A) : (A.pendingProps = v, A.effectTag = 0, A.nextEffect = null, A.firstEffect = null, A.lastEffect = null), A.childExpirationTime = y.childExpirationTime, A.expirationTime = y.expirationTime, A.child = y.child, A.memoizedProps = y.memoizedProps, A.memoizedState = y.memoizedState, A.updateQueue = y.updateQueue, v = y.dependencies, A.dependencies = v === null ? null : {
        expirationTime: v.expirationTime,
        firstContext: v.firstContext,
        responders: v.responders
      }, A.sibling = y.sibling, A.index = y.index, A.ref = y.ref, A;
    }
    function Bo(y, v, A, C, I, L) {
      var ae = 2;
      if (C = y, typeof y == "function") Po(y) && (ae = 1);
      else if (typeof y == "string") ae = 5;
      else e: switch (y) {
        case g:
          return xi(A.children, I, L, v);
        case N:
          ae = 8, I |= 7;
          break;
        case x:
          ae = 8, I |= 1;
          break;
        case _:
          return y = Un(12, A, v, I | 8), y.elementType = _, y.type = _, y.expirationTime = L, y;
        case G:
          return y = Un(13, A, v, I), y.type = G, y.elementType = G, y.expirationTime = L, y;
        case z:
          return y = Un(19, A, v, I), y.elementType = z, y.expirationTime = L, y;
        default:
          if (typeof y == "object" && y !== null) switch (y.$$typeof) {
            case k:
              ae = 10;
              break e;
            case P:
              ae = 9;
              break e;
            case M:
              ae = 11;
              break e;
            case j:
              ae = 14;
              break e;
            case R:
              ae = 16, C = null;
              break e;
          }
          throw Error(o(130, y == null ? y : typeof y, ""));
      }
      return v = Un(ae, A, v, I), v.elementType = y, v.type = C, v.expirationTime = L, v;
    }
    function xi(y, v, A, C) {
      return y = Un(7, y, C, v), y.expirationTime = A, y;
    }
    function Nu(y, v, A) {
      return y = Un(6, y, null, v), y.expirationTime = A, y;
    }
    function Lu(y, v, A) {
      return v = Un(4, y.children !== null ? y.children : [], y.key, v), v.expirationTime = A, v.stateNode = {
        containerInfo: y.containerInfo,
        pendingChildren: null,
        implementation: y.implementation
      }, v;
    }
    function _2(y, v, A) {
      this.tag = v, this.current = null, this.containerInfo = y, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = he, this.pendingContext = this.context = null, this.hydrate = A, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
    }
    function Xl(y, v) {
      var A = y.firstSuspendedTime;
      return y = y.lastSuspendedTime, A !== 0 && A >= v && y <= v;
    }
    function xa(y, v) {
      var A = y.firstSuspendedTime, C = y.lastSuspendedTime;
      A < v && (y.firstSuspendedTime = v), (C > v || A === 0) && (y.lastSuspendedTime = v), v <= y.lastPingedTime && (y.lastPingedTime = 0), v <= y.lastExpiredTime && (y.lastExpiredTime = 0);
    }
    function Kl(y, v) {
      v > y.firstPendingTime && (y.firstPendingTime = v);
      var A = y.firstSuspendedTime;
      A !== 0 && (v >= A ? y.firstSuspendedTime = y.lastSuspendedTime = y.nextKnownPendingLevel = 0 : v >= y.lastSuspendedTime && (y.lastSuspendedTime = v + 1), v > y.nextKnownPendingLevel && (y.nextKnownPendingLevel = v));
    }
    function Mu(y, v) {
      var A = y.lastExpiredTime;
      (A === 0 || A > v) && (y.lastExpiredTime = v);
    }
    function Nf(y) {
      var v = y._reactInternalFiber;
      if (v === void 0)
        throw typeof y.render == "function" ? Error(o(188)) : Error(o(268, Object.keys(y)));
      return y = q(v), y === null ? null : y.stateNode;
    }
    function Lf(y, v) {
      y = y.memoizedState, y !== null && y.dehydrated !== null && y.retryTime < v && (y.retryTime = v);
    }
    function Uu(y, v) {
      Lf(y, v), (y = y.alternate) && Lf(y, v);
    }
    var Mf = {
      createContainer: function(v, A, C) {
        return v = new _2(v, A, C), A = Un(3, null, null, A === 2 ? 7 : A === 1 ? 3 : 0), v.current = A, A.stateNode = v;
      },
      updateContainer: function(v, A, C, I) {
        var L = A.current, ae = vt(), it = Ma.suspense;
        ae = At(ae, L, it);
        e: if (C) {
          C = C._reactInternalFiber;
          n: {
            if (ve(C) !== C || C.tag !== 1) throw Error(o(170));
            var Ye = C;
            do {
              switch (Ye.tag) {
                case 3:
                  Ye = Ye.stateNode.context;
                  break n;
                case 1:
                  if (L0(Ye.type)) {
                    Ye = Ye.stateNode.__reactInternalMemoizedMergedChildContext;
                    break n;
                  }
              }
              Ye = Ye.return;
            } while (Ye !== null);
            throw Error(o(171));
          }
          if (C.tag === 1) {
            var wt = C.type;
            if (L0(wt)) {
              C = Li(C, wt, Ye);
              break e;
            }
          }
          C = Ye;
        } else C = W0;
        return A.context === null ? A.context = C : A.pendingContext = C, A = La(ae, it), A.payload = {
          element: v
        }, I = I === void 0 ? null : I, I !== null && (A.callback = I), ot(L, A), Ot(L, ae), ae;
      },
      batchedEventUpdates: function(v, A) {
        var C = zt;
        zt |= 2;
        try {
          return v(A);
        } finally {
          zt = C, zt === w0 && ze();
        }
      },
      batchedUpdates: function(v, A) {
        var C = zt;
        zt |= 1;
        try {
          return v(A);
        } finally {
          zt = C, zt === w0 && ze();
        }
      },
      unbatchedUpdates: function(v, A) {
        var C = zt;
        zt &= -2, zt |= un;
        try {
          return v(A);
        } finally {
          zt = C, zt === w0 && ze();
        }
      },
      deferredUpdates: function(v) {
        return et(97, v);
      },
      syncUpdates: function(v, A, C, I) {
        return et(99, v.bind(null, A, C, I));
      },
      discreteUpdates: function(v, A, C, I) {
        var L = zt;
        zt |= 4;
        try {
          return et(98, v.bind(null, A, C, I));
        } finally {
          zt = L, zt === w0 && ze();
        }
      },
      flushDiscreteUpdates: function() {
        (zt & (1 | yn | Gn)) === w0 && (i0(), An());
      },
      flushControlled: function(v) {
        var A = zt;
        zt |= 1;
        try {
          et(99, v);
        } finally {
          zt = A, zt === w0 && ze();
        }
      },
      flushSync: e0,
      flushPassiveEffects: An,
      IsThisRendererActing: {
        current: !1
      },
      getPublicRootInstance: function(v) {
        if (v = v.current, !v.child) return null;
        switch (v.child.tag) {
          case 5:
            return oe(v.child.stateNode);
          default:
            return v.child.stateNode;
        }
      },
      attemptSynchronousHydration: function(v) {
        switch (v.tag) {
          case 3:
            var A = v.stateNode;
            A.hydrate && c0(A, A.firstPendingTime);
            break;
          case 13:
            e0(function() {
              return Ot(v, 1073741823);
            }), A = Ut(vt(), 150, 100), Uu(v, A);
        }
      },
      attemptUserBlockingHydration: function(v) {
        if (v.tag === 13) {
          var A = Ut(vt(), 150, 100);
          Ot(v, A), Uu(v, A);
        }
      },
      attemptContinuousHydration: function(v) {
        if (v.tag === 13) {
          vt();
          var A = fr++;
          Ot(v, A), Uu(v, A);
        }
      },
      attemptHydrationAtCurrentPriority: function(v) {
        if (v.tag === 13) {
          var A = vt();
          A = At(A, v, null), Ot(v, A), Uu(v, A);
        }
      },
      findHostInstance: Nf,
      findHostInstanceWithWarning: function(v) {
        return Nf(v);
      },
      findHostInstanceWithNoPortals: function(v) {
        return v = H(v), v === null ? null : v.tag === 20 ? v.stateNode.instance : v.stateNode;
      },
      shouldSuspend: function() {
        return !1;
      },
      injectIntoDevTools: function(v) {
        var A = v.findFiberByHostInstance;
        return Io(n({}, v, {
          overrideHookState: null,
          overrideProps: null,
          setSuspenseHandler: null,
          scheduleUpdate: null,
          currentDispatcherRef: s.ReactCurrentDispatcher,
          findHostInstanceByFiber: function(I) {
            return I = q(I), I === null ? null : I.stateNode;
          },
          findFiberByHostInstance: function(I) {
            return A ? A(I) : null;
          },
          findHostInstancesForRefresh: null,
          scheduleRefresh: null,
          scheduleRoot: null,
          setRefreshHandler: null,
          getCurrentFiber: null
        }));
      }
    };
    r.exports = Mf.default || Mf;
    var D2 = r.exports;
    return r.exports = e, D2;
  };
})(pT);
var wae = pT.exports, Aae = function r(e, t) {
  var n = Object.keys(e), i = Object.keys(t);
  if (n.length !== i.length)
    return !1;
  for (var a = 0; a < n.length; a += 1) {
    var o = n[a];
    if (o === "render" && !e[o] != !t[o])
      return !1;
    if (o !== "children" && e[o] !== t[o]) {
      if (typeof e[o] == "object" && typeof t[o] == "object" && r(e[o], t[o]))
        continue;
      return !1;
    }
    if (o === "children" && (typeof e[o] == "string" || typeof t[o] == "string"))
      return e[o] === t[o];
  }
  return !0;
}, xae = ["style", "children"], Eae = ["style"], Tw = {}, G4 = function(e, t) {
  var n = e.type === "TEXT" || e.type === "LINK" || e.type === "TSPAN", i = t.type === "TEXT_INSTANCE", a = i && !n;
  if (a) {
    console.warn("Invalid '" + t.value + "' string child outside <Text> component");
    return;
  }
  e.children.push(t);
}, _ae = function(e) {
  var t = e.onChange, n = t === void 0 ? function() {
  } : t;
  return wae({
    schedulePassiveEffects: Id.unstable_scheduleCallback,
    cancelPassiveEffects: Id.unstable_cancelCallback,
    supportsMutation: !0,
    isPrimaryRenderer: !1,
    warnsIfNotActing: !1,
    appendInitialChild: G4,
    createInstance: function(a, o) {
      var s = o.style;
      o.children;
      var c = Vc(o, xae);
      return {
        type: a,
        box: {},
        style: s || {},
        props: c || {},
        children: []
      };
    },
    createTextInstance: function(a, o) {
      return {
        type: "TEXT_INSTANCE",
        value: a
      };
    },
    finalizeInitialChildren: function(a, o, s) {
      return !1;
    },
    getPublicInstance: function(a) {
      return a;
    },
    prepareForCommit: function() {
    },
    clearContainer: function() {
    },
    prepareUpdate: function(a, o, s, c) {
      return !Aae(s, c);
    },
    resetAfterCommit: n,
    resetTextContent: function(a) {
    },
    getRootHostContext: function() {
      return Tw;
    },
    getChildHostContext: function() {
      return Tw;
    },
    shouldSetTextContent: function(a, o) {
      return !1;
    },
    now: Date.now,
    useSyncScheduling: !0,
    appendChild: G4,
    appendChildToContainer: function(a, o) {
      a.type === "ROOT" ? a.document = o : G4(a, o);
    },
    insertBefore: function(a, o, s) {
      var c, h = (c = a.children) === null || c === void 0 ? void 0 : c.indexOf(s);
      h !== void 0 && h !== -1 && o && a.children.splice(h, 0, o);
    },
    removeChild: function(a, o) {
      var s, c = (s = a.children) === null || s === void 0 ? void 0 : s.indexOf(o);
      c !== void 0 && c !== -1 && a.children.splice(c, 1);
    },
    removeChildFromContainer: function(a, o) {
      var s, c = (s = a.children) === null || s === void 0 ? void 0 : s.indexOf(o);
      c !== void 0 && c !== -1 && a.children.splice(c, 1);
    },
    commitTextUpdate: function(a, o, s) {
      a.value = s;
    },
    commitUpdate: function(a, o, s, c, h) {
      var d = h.style, g = Vc(h, Eae);
      a.props = g, a.style = d;
    }
  });
}, Dae = "3.1.12", vT = new TP(), vh, ju = {}, Zg = function(e) {
  var t = function() {
    for (var k, P = ((k = ju.change) === null || k === void 0 ? void 0 : k.slice()) || [], N = 0; N < P.length; N += 1) P[N]();
  }, n = {
    type: "ROOT",
    document: null
  };
  vh = vh || _ae({
    onChange: t
  });
  var i = vh.createContainer(n), a = function(k) {
    vh.updateContainer(k, i, null);
  };
  e && a(e);
  var o = /* @__PURE__ */ function() {
    var _ = ui(/* @__PURE__ */ qr().mark(function k(P) {
      var N, M, G, z, j, R, te, J;
      return qr().wrap(function(ee) {
        for (; ; ) switch (ee.prev = ee.next) {
          case 0:
            return P === void 0 && (P = !0), N = n.document.props || {}, M = N.pdfVersion, G = N.language, z = N.pageLayout, j = N.pageMode, R = new X_({
              compress: P,
              pdfVersion: M,
              lang: G,
              displayTitle: !0,
              autoFirstPage: !1,
              pageLayout: z,
              pageMode: j
            }), ee.next = 6, fae(n.document, vT);
          case 6:
            return te = ee.sent, J = MN(R, te), ee.abrupt("return", {
              layout: te,
              fileStream: J
            });
          case 9:
          case "end":
            return ee.stop();
        }
      }, k);
    }));
    return function(P) {
      return _.apply(this, arguments);
    };
  }(), s = function(k) {
    k === void 0 && (k = {}), n.document.props.onRender && n.document.props.onRender(k);
  }, c = /* @__PURE__ */ function() {
    var _ = ui(/* @__PURE__ */ qr().mark(function k() {
      var P, N, M, G;
      return qr().wrap(function(j) {
        for (; ; ) switch (j.prev = j.next) {
          case 0:
            return P = [], j.next = 3, o();
          case 3:
            return N = j.sent, M = N.layout, G = N.fileStream, j.abrupt("return", new Promise(function(R, te) {
              G.on("data", function(J) {
                P.push(J instanceof Uint8Array ? J : new Uint8Array(J));
              }), G.on("end", function() {
                try {
                  var J = new Blob(P, {
                    type: "application/pdf"
                  });
                  s({
                    blob: J,
                    _INTERNAL__LAYOUT__DATA_: M
                  }), R(J);
                } catch (K) {
                  te(K);
                }
              });
            }));
          case 7:
          case "end":
            return j.stop();
        }
      }, k);
    }));
    return function() {
      return _.apply(this, arguments);
    };
  }(), h = /* @__PURE__ */ function() {
    var _ = ui(/* @__PURE__ */ qr().mark(function k() {
      return qr().wrap(function(N) {
        for (; ; ) switch (N.prev = N.next) {
          case 0:
            return s(), N.next = 3, o();
          case 3:
            return N.abrupt("return", N.sent.fileStream);
          case 4:
          case "end":
            return N.stop();
        }
      }, k);
    }));
    return function() {
      return _.apply(this, arguments);
    };
  }(), d = /* @__PURE__ */ function() {
    var _ = ui(/* @__PURE__ */ qr().mark(function k() {
      var P, N, M;
      return qr().wrap(function(z) {
        for (; ; ) switch (z.prev = z.next) {
          case 0:
            return process.env.NODE_ENV === "development" && console.warn("`toString` is deprecated and will be removed in next major release"), P = "", z.next = 4, o(!1);
          case 4:
            return N = z.sent, M = N.fileStream, z.abrupt("return", new Promise(function(j, R) {
              try {
                M.on("data", function(te) {
                  P += te;
                }), M.on("end", function() {
                  s(), j(P);
                });
              } catch (te) {
                R(te);
              }
            }));
          case 7:
          case "end":
            return z.stop();
        }
      }, k);
    }));
    return function() {
      return _.apply(this, arguments);
    };
  }(), g = function(k, P) {
    ju[k] || (ju[k] = []), ju[k].push(P);
  }, x = function(k, P) {
    if (ju[k]) {
      var N = ju[k].indexOf(P);
      N > -1 && ju[k].splice(N, 1);
    }
  };
  return {
    on: g,
    container: n,
    toBlob: c,
    toBuffer: h,
    toString: d,
    removeListener: x,
    updateContainer: a
  };
}, gT = vT, mT = {
  create: function(e) {
    return e;
  }
}, z5 = function(e) {
  var t = e === void 0 ? {} : e, n = t.document, i = wT(null), a = Zi({
    url: null,
    blob: null,
    error: null,
    loading: !!n
  }), o = a[0], s = a[1];
  Gc(function() {
    var h = rk({
      autostart: !0,
      concurrency: 1
    }), d = function() {
      s(function(k) {
        return $r({}, k, {
          loading: !0
        });
      }), h.splice(0, h.length, function() {
        return o.error ? Promise.resolve() : i.current.toBlob();
      });
    }, g = function(k) {
      console.error(k), s(function(P) {
        return $r({}, P, {
          loading: !1,
          error: k
        });
      });
    }, x = function(k) {
      s({
        blob: k,
        error: null,
        loading: !1,
        url: URL.createObjectURL(k)
      });
    };
    return i.current = Zg(), i.current.on("change", d), n && i.current.updateContainer(n), h.on("error", g), h.on("success", x), function() {
      h.end(), i.current.removeListener("change", d);
    };
  }, []), Gc(function() {
    return function() {
      o.url && URL.revokeObjectURL(o.url);
    };
  }, [o.url]);
  var c = kw(function(h) {
    i.current.updateContainer(h);
  }, []);
  return [o, c];
}, Tae = ["title", "style", "className", "children", "innerRef", "showToolbar"], kae = function(e) {
  var t = e.title, n = e.style, i = e.className, a = e.children, o = e.innerRef, s = e.showToolbar, c = s === void 0 ? !0 : s, h = Vc(e, Tae), d = z5(), g = d[0], x = d[1];
  Gc(function() {
    return x(a);
  }, [a]);
  var _ = g.url ? g.url + "#toolbar=" + (c ? 1 : 0) : null;
  return /* @__PURE__ */ We.jsx("iframe", $r({
    src: _,
    title: t,
    ref: o,
    style: n,
    className: i
  }, h));
}, Sae = function(e) {
  var t = e.document, n = e.children, i = z5(), a = i[0], o = i[1];
  return Gc(function() {
    return o(t);
  }, [t]), t ? n(a) : (console.warn("You should pass a valid document to BlobProvider"), null);
}, Cae = function(e) {
  var t = e.style, n = e.children, i = e.className, a = e.document, o = e.fileName, s = o === void 0 ? "document.pdf" : o, c = e.onClick, h = z5(), d = h[0], g = h[1];
  if (Gc(function() {
    return g(a);
  }, [a]), !a)
    return console.warn("You should pass a valid document to PDFDownloadLink"), null;
  var x = function() {
    window.navigator.msSaveBlob && window.navigator.msSaveBlob(d.blob, s);
  }, _ = function(P) {
    x(), typeof c == "function" && c(P, d);
  };
  return /* @__PURE__ */ We.jsx("a", {
    style: t,
    href: d.url,
    download: s,
    className: i,
    onClick: _,
    children: typeof n == "function" ? n(d) : n
  });
}, j5 = function(e) {
  throw new Error(e + " is a Node specific API. You're either using this method in a browser, or your bundler is not loading react-pdf from the appropriate web build.");
}, Fae = function() {
  j5("renderToStream");
}, Oae = function() {
  j5("renderToString");
}, Rae = function() {
  j5("renderToFile");
}, Iae = function() {
  j5("render");
};
$r({
  pdf: Zg,
  usePDF: z5,
  Font: gT,
  version: Dae,
  StyleSheet: mT,
  PDFViewer: kae,
  BlobProvider: Sae,
  PDFDownloadLink: Cae,
  renderToStream: Fae,
  renderToString: Oae,
  renderToFile: Rae,
  render: Iae
}, zT);
function Pae({ investorProfile: r, holdings: e, transactions: t, phone: n, email: i, dematAccount: a, tenant: o }) {
  var M, G, z;
  const s = [];
  (M = e == null ? void 0 : e.folios) == null || M.forEach((j) => {
    j.schemes.forEach((R) => {
      const te = {
        folio_number: j.folio_number,
        ...R
      };
      s.push(te);
    });
  });
  const c = {};
  (z = (G = t == null ? void 0 : t.data) == null ? void 0 : G.columns) == null || z.forEach((j, R) => {
    c[j] = R;
  }), s.forEach((j) => {
    var R, te;
    (te = (R = t == null ? void 0 : t.data) == null ? void 0 : R.rows) == null || te.forEach((J) => {
      J[c.isin] === j.isin && J[c.folio_number] === j.folio_number && (j.transaction ? j.transaction.push(J) : j.transaction = [
        J
      ]);
    });
  }), gT.register({
    family: "Roboto",
    src: "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5Q.ttf"
  });
  const h = mT.create({
    body: {
      fontFamily: "Arial"
    },
    title: {
      border: "none",
      fontWeight: "bold",
      fontSize: 12,
      margin: "0 0 6pt 0",
      color: "#06488a"
    },
    subTitle: {
      border: "none",
      fontSize: 10,
      margin: "0 0 4pt 0"
    },
    page: {
      fontFamily: "Roboto",
      fontSize: 9,
      paddingTop: 30,
      paddingLeft: 20,
      paddingRight: 20,
      lineHeight: 1,
      flexDirection: "column",
      borderCollapse: "collapse",
      width: "100%"
    },
    labelSm: {
      textAlign: "left",
      padding: "1pt 10pt 0 0",
      width: "100px",
      fontSize: "11px",
      color: "#3F567E",
      flexBasis: "45px",
      fontWeight: "bold",
      fontFamily: "Helvetica-Bold"
    },
    label: {
      textAlign: "left",
      padding: "1pt 10pt",
      fontWeight: "bold",
      width: "19%",
      fontSize: 9,
      color: "#797f85"
    },
    HalfColLabel: {
      textAlign: "left",
      padding: "8pt 0pt",
      fontWeight: "bold",
      fontFamily: "Helvetica-Bold",
      color: "#3F567E",
      flexBasis: "40%",
      fontSize: "10px"
    },
    dataSm: {
      padding: "8pt 5pt",
      textAlign: "left",
      color: "#3F567E",
      fontSize: "11px"
    },
    data: {
      padding: "8pt 10pt",
      textAlign: "left"
    },
    row: {
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center"
    },
    tableWrapper: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#8f939c",
      margin: "0 0 10pt 0",
      borderRadius: "4px",
      backgroundColor: "#ffffff"
    },
    tableInnerWrapper: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#babcc0",
      borderBottom: "0px",
      borderRadius: "4px",
      backgroundColor: "#ffffff"
    },
    table: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderBottomColor: "#babcc0"
    },
    tableHeading: {
      fontWeight: "bold"
    },
    tableCell: {
      flexBasis: "33%",
      padding: "10px 12px",
      borderRightWidth: "1px",
      borderRightStyle: "solid",
      borderRightColor: "#babcc0"
    },
    tableCellContent: {
      flexBasis: "33%"
    },
    tableMainBorder: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#babcc0",
      margin: "0 0 10px 0",
      borderRadius: "4px",
      padding: "12px",
      backgroundColor: "#f0f2f7"
    },
    halfCol: {
      flexBasis: "48%"
    },
    HalfColData: {
      padding: "8pt 0pt",
      textAlign: "left",
      color: "#3F567E",
      fontSize: "10px"
    },
    TextSm: {
      color: "#797f85",
      fontSize: 8
    },
    logoSize: {
      height: "auto",
      width: "70pt",
      margin: "0 auto"
    },
    disclaimerText: {
      margin: "16px 0 8px 0",
      paddingTop: "10px",
      color: "#797f85",
      fontSize: 8,
      borderTopWidth: "1px",
      borderTopStyle: "solid",
      borderTopColor: "#babcc0",
      textAlign: "center"
    },
    innerTableHeader: {
      color: "#3F567E",
      fontSize: "10px",
      fontWeight: "bold",
      fontFamily: "Helvetica-Bold"
    },
    innerTableContent: {
      color: "#3F567E",
      fontSize: "10px"
    },
    schemeTitle: {
      backgroundColor: "#9FAABE",
      borderRadius: "4px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#8E98A9",
      padding: "10px 10px",
      marginBottom: "10px"
    }
  });
  function d() {
    return /* @__PURE__ */ We.jsx(Yt, {
      children: /* @__PURE__ */ We.jsxs(Yt, {
        style: [
          {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: "10pt",
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            borderBottomColor: "#babcc0"
          }
        ],
        children: [
          /* @__PURE__ */ We.jsx(Yt, {
            style: {
              margin: "0 6pt 0 0"
            },
            children: /* @__PURE__ */ We.jsx(cu, {
              src: o.logo,
              style: h.logoSize
            })
          }),
          /* @__PURE__ */ We.jsx(Gt, {
            style: {
              fontSize: "13px",
              fontWeight: "bold",
              color: "#061738",
              fontFamily: "Helvetica-Bold"
            },
            children: "Account Statement"
          })
        ]
      })
    });
  }
  function g() {
    return /* @__PURE__ */ We.jsx(Yt, {
      style: h.schemeTitle,
      children: /* @__PURE__ */ We.jsx(Gt, {
        style: [
          {
            justifyContent: "center",
            alignItems: "center",
            color: "#ffffff",
            fontWeight: "bold",
            fontSize: "13px",
            fontFamily: "Helvetica-Bold"
          }
        ],
        children: "Scheme and folio wise investment summary"
      })
    });
  }
  function x() {
    return /* @__PURE__ */ We.jsx(Yt, {
      children: /* @__PURE__ */ We.jsx(Gt, {
        style: h.disclaimerText,
        children: `Please note that this account statement includes mutual fund purchases processed by ${gh(o.name)} only. For any queries please contact ${o.email}`
      })
    });
  }
  function _() {
    return /* @__PURE__ */ We.jsxs(Yt, {
      style: [
        {
          margin: "0 0 8pt 0",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between"
        }
      ],
      children: [
        /* @__PURE__ */ We.jsxs(Yt, {
          style: [
            {
              flexBasis: "50%"
            }
          ],
          children: [
            /* @__PURE__ */ We.jsxs(Yt, {
              style: h.row,
              children: [
                /* @__PURE__ */ We.jsx(Gt, {
                  style: h.labelSm,
                  children: "Name"
                }),
                /* @__PURE__ */ We.jsxs(Gt, {
                  style: h.dataSm,
                  children: [
                    ": ",
                    r == null ? void 0 : r.name
                  ]
                })
              ]
            }),
            /* @__PURE__ */ We.jsxs(Yt, {
              style: h.row,
              children: [
                /* @__PURE__ */ We.jsx(Gt, {
                  style: h.labelSm,
                  children: "PAN"
                }),
                /* @__PURE__ */ We.jsxs(Gt, {
                  style: h.dataSm,
                  children: [
                    ": ",
                    r.pan
                  ]
                })
              ]
            }),
            /* @__PURE__ */ We.jsxs(Yt, {
              style: h.row,
              children: [
                /* @__PURE__ */ We.jsx(Gt, {
                  style: h.labelSm,
                  children: "Phone"
                }),
                /* @__PURE__ */ We.jsxs(Gt, {
                  style: h.dataSm,
                  children: [
                    ": ",
                    (n == null ? void 0 : n.number) || "-"
                  ]
                })
              ]
            }),
            /* @__PURE__ */ We.jsxs(Yt, {
              style: h.row,
              children: [
                /* @__PURE__ */ We.jsx(Gt, {
                  style: h.labelSm,
                  children: "Email"
                }),
                /* @__PURE__ */ We.jsxs(Gt, {
                  style: h.dataSm,
                  children: [
                    ": ",
                    (i == null ? void 0 : i.email) || "-"
                  ]
                })
              ]
            }),
            a && /* @__PURE__ */ We.jsxs(Yt, {
              style: h.row,
              children: [
                /* @__PURE__ */ We.jsx(Gt, {
                  style: h.labelSm,
                  children: "Demat number"
                }),
                /* @__PURE__ */ We.jsxs(Gt, {
                  style: h.dataSm,
                  children: [
                    ": ",
                    a
                  ]
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ We.jsx(Yt, {
          style: [
            {
              flexBasis: "50%"
            }
          ],
          children: /* @__PURE__ */ We.jsxs(Yt, {
            style: [
              h.row,
              {
                justifyContent: "flex-end"
              }
            ],
            children: [
              /* @__PURE__ */ We.jsx(Gt, {
                style: h.labelSm,
                children: "Date"
              }),
              /* @__PURE__ */ We.jsxs(Gt, {
                style: h.dataSm,
                children: [
                  ": ",
                  Qf(/* @__PURE__ */ new Date(), "dd-MMM-yyyy")
                ]
              })
            ]
          })
        })
      ]
    });
  }
  function k(j) {
    return /* @__PURE__ */ We.jsx(AT, {
      children: /* @__PURE__ */ We.jsxs(Yt, {
        style: h.tableMainBorder,
        children: [
          /* @__PURE__ */ We.jsxs(Yt, {
            style: [
              {
                marginBottom: "10px"
              }
            ],
            children: [
              /* @__PURE__ */ We.jsx(Yt, {
                style: h.row,
                children: /* @__PURE__ */ We.jsx(Gt, {
                  style: [
                    {
                      color: "#202428",
                      fontSize: "12px",
                      marginBottom: "10px",
                      fontWeight: "bold",
                      fontFamily: "Helvetica-Bold"
                    }
                  ],
                  children: Cw(j.name)
                })
              }),
              /* @__PURE__ */ We.jsxs(Yt, {
                style: h.row,
                children: [
                  /* @__PURE__ */ We.jsx(Yt, {
                    style: h.halfCol,
                    children: /* @__PURE__ */ We.jsxs(Yt, {
                      style: h.row,
                      children: [
                        /* @__PURE__ */ We.jsx(Gt, {
                          style: h.HalfColLabel,
                          children: "ISIN"
                        }),
                        /* @__PURE__ */ We.jsxs(Gt, {
                          style: h.HalfColData,
                          children: [
                            ": ",
                            j.isin
                          ]
                        })
                      ]
                    })
                  }),
                  /* @__PURE__ */ We.jsx(Yt, {
                    style: h.halfCol,
                    children: /* @__PURE__ */ We.jsxs(Yt, {
                      style: h.row,
                      children: [
                        /* @__PURE__ */ We.jsx(Gt, {
                          style: h.HalfColLabel,
                          children: "Investment type"
                        }),
                        /* @__PURE__ */ We.jsxs(Gt, {
                          style: h.HalfColData,
                          children: [
                            ": ",
                            Fw(j.type)
                          ]
                        })
                      ]
                    })
                  })
                ]
              }),
              /* @__PURE__ */ We.jsxs(Yt, {
                style: h.row,
                children: [
                  /* @__PURE__ */ We.jsx(Yt, {
                    style: h.halfCol,
                    children: /* @__PURE__ */ We.jsxs(Yt, {
                      style: h.row,
                      children: [
                        /* @__PURE__ */ We.jsx(Gt, {
                          style: h.HalfColLabel,
                          children: "Scheme plan"
                        }),
                        /* @__PURE__ */ We.jsxs(Gt, {
                          style: h.HalfColData,
                          children: [
                            ": ",
                            gh(j.plan)
                          ]
                        })
                      ]
                    })
                  }),
                  /* @__PURE__ */ We.jsx(Yt, {
                    style: h.halfCol,
                    children: /* @__PURE__ */ We.jsxs(Yt, {
                      style: h.row,
                      children: [
                        /* @__PURE__ */ We.jsx(Gt, {
                          style: h.HalfColLabel,
                          children: "Folio no"
                        }),
                        /* @__PURE__ */ We.jsxs(Gt, {
                          style: h.HalfColData,
                          children: [
                            ": ",
                            j.folio_number
                          ]
                        })
                      ]
                    })
                  })
                ]
              }),
              /* @__PURE__ */ We.jsxs(Yt, {
                style: h.row,
                children: [
                  /* @__PURE__ */ We.jsx(Yt, {
                    style: h.halfCol,
                    children: /* @__PURE__ */ We.jsxs(Yt, {
                      style: h.row,
                      children: [
                        /* @__PURE__ */ We.jsx(Gt, {
                          style: h.HalfColLabel,
                          children: "Invested amount"
                        }),
                        /* @__PURE__ */ We.jsxs(Gt, {
                          style: h.HalfColData,
                          children: [
                            ": ₹ ",
                            Vu(j.invested_value.amount, 2)
                          ]
                        })
                      ]
                    })
                  }),
                  /* @__PURE__ */ We.jsx(Yt, {
                    style: h.halfCol,
                    children: /* @__PURE__ */ We.jsxs(Yt, {
                      style: h.row,
                      children: [
                        /* @__PURE__ */ We.jsx(Gt, {
                          style: h.HalfColLabel,
                          children: "Current value"
                        }),
                        /* @__PURE__ */ We.jsxs(Gt, {
                          style: h.HalfColData,
                          children: [
                            ": ₹ ",
                            Vu(j.market_value.amount, 2)
                          ]
                        })
                      ]
                    })
                  })
                ]
              }),
              /* @__PURE__ */ We.jsxs(Yt, {
                style: h.row,
                children: [
                  /* @__PURE__ */ We.jsx(Yt, {
                    style: h.halfCol,
                    children: /* @__PURE__ */ We.jsxs(Yt, {
                      style: h.row,
                      children: [
                        /* @__PURE__ */ We.jsx(Gt, {
                          style: h.HalfColLabel,
                          children: "NAV"
                        }),
                        /* @__PURE__ */ We.jsxs(Gt, {
                          style: h.HalfColData,
                          children: [
                            ": ₹ ",
                            Vu(j.nav.value, 2)
                          ]
                        })
                      ]
                    })
                  }),
                  /* @__PURE__ */ We.jsx(Yt, {
                    style: h.halfCol,
                    children: /* @__PURE__ */ We.jsxs(Yt, {
                      style: h.row,
                      children: [
                        /* @__PURE__ */ We.jsx(Gt, {
                          style: h.HalfColLabel,
                          children: "NAV as on"
                        }),
                        /* @__PURE__ */ We.jsxs(Gt, {
                          style: h.HalfColData,
                          children: [
                            ": ",
                            Qf(new Date(j.nav.as_on), "dd-MMM-yyyy")
                          ]
                        })
                      ]
                    })
                  })
                ]
              })
            ]
          }),
          P(j)
        ]
      })
    }, j.folio_number + j.isin);
  }
  function P(j) {
    var R;
    return /* @__PURE__ */ We.jsx(We.Fragment, {
      children: /* @__PURE__ */ We.jsxs(Yt, {
        style: h.tableInnerWrapper,
        children: [
          /* @__PURE__ */ We.jsxs(Yt, {
            style: h.table,
            children: [
              /* @__PURE__ */ We.jsx(Yt, {
                style: h.tableCell,
                children: /* @__PURE__ */ We.jsx(Gt, {
                  style: h.innerTableHeader,
                  children: "Order type"
                })
              }),
              /* @__PURE__ */ We.jsx(Yt, {
                style: h.tableCell,
                children: /* @__PURE__ */ We.jsx(Gt, {
                  style: h.innerTableHeader,
                  children: "Order date"
                })
              }),
              /* @__PURE__ */ We.jsx(Yt, {
                style: h.tableCell,
                children: /* @__PURE__ */ We.jsx(Gt, {
                  style: h.innerTableHeader,
                  children: "Order amount"
                })
              }),
              /* @__PURE__ */ We.jsx(Yt, {
                style: [
                  h.tableCell,
                  {
                    border: "0"
                  }
                ],
                children: /* @__PURE__ */ We.jsx(Gt, {
                  style: h.innerTableHeader,
                  children: "Units"
                })
              })
            ]
          }),
          (R = j.transaction) == null ? void 0 : R.map((te) => N(te))
        ]
      })
    });
  }
  function N(j) {
    return /* @__PURE__ */ We.jsxs(Yt, {
      style: h.table,
      children: [
        /* @__PURE__ */ We.jsx(Yt, {
          style: h.tableCell,
          children: /* @__PURE__ */ We.jsx(Gt, {
            style: h.innerTableContent,
            children: gh(j[c.type])
          })
        }),
        /* @__PURE__ */ We.jsx(Yt, {
          style: h.tableCell,
          children: /* @__PURE__ */ We.jsx(Gt, {
            style: h.innerTableContent,
            children: Qf(new Date(j[c.traded_on]), "dd-MMM-yyyy")
          })
        }),
        /* @__PURE__ */ We.jsx(Yt, {
          style: h.tableCell,
          children: /* @__PURE__ */ We.jsxs(Gt, {
            style: h.innerTableContent,
            children: [
              "₹ ",
              Vu(j[c.amount], 2)
            ]
          })
        }),
        /* @__PURE__ */ We.jsx(Yt, {
          style: [
            h.tableCell,
            {
              border: "0"
            }
          ],
          children: /* @__PURE__ */ We.jsx(Gt, {
            style: h.innerTableContent,
            children: j[c.units] || "-"
          })
        })
      ]
    }, j[c.rta_order_reference]);
  }
  return /* @__PURE__ */ We.jsx(pv, {
    children: /* @__PURE__ */ We.jsxs(Bd, {
      size: "A4",
      style: h.page,
      wrap: !1,
      children: [
        d(),
        _(),
        g(),
        s == null ? void 0 : s.map((j) => k(j)),
        x()
      ]
    })
  });
}
async function Bae(r) {
  const t = await (await fetch(r)).blob(), n = await Nae(t), i = n.naturalHeight, a = n.naturalWidth, o = window.devicePixelRatio * 2, s = document.createElement("canvas");
  s.width = a, s.height = i;
  const c = s.getContext("2d");
  return s.style.width = `${Math.round(a / o)}px`, s.style.height = `${Math.round(i / o)}px`, s.style.margin = "0", s.style.padding = "0", c && (c.scale(o, o), c.drawImage(n, 0, 0, Math.round(a / o), Math.round(i / o))), s.toDataURL("image/png");
}
const Nae = (r) => new Promise((e, t) => {
  const n = window.URL.createObjectURL(r), i = document.createElement("img");
  i.addEventListener("load", () => e(i)), i.addEventListener("error", (a) => t(a)), i.src = n;
});
function Zae({ investorProfile: r, schemes: e, onSchemeAndFolioSelection: t, onSchemeSelection: n, assistedWorkflowPAN: i, isPartner: a }) {
  const [o, s] = Zi([]), [c, h] = Zi(!1), [d, g] = Zi(!1), [x, _] = Zi(!1), [k, P] = Zi("initial"), [N, M] = Zi({
    index: 0,
    isin: null,
    name: null
  }), [G, z] = Zi(null), [j, R] = Zi(!1), [te, J] = Zi(""), [K, ee] = Zi(null), [ve, de] = Zi(null), { fpapi: B } = xT(PT), { tenantConfig: q, amcs: H } = RT(), oe = q == null ? void 0 : q.fallbackLogo, ne = q == null ? void 0 : q.showSchemeLogo, me = t || n ? _n._({
    id: "blGkfC"
  }) : _n._({
    id: "MdXcoT"
  }), fe = kw((Z, se) => {
    const ye = [];
    return Z.forEach((Fe) => {
      e.includes(Fe[se.isin]) && ye.push(Fe);
    }), ye;
  }, [
    e
  ]);
  Gc(() => {
    async function Z() {
      if (!BT(r))
        try {
          h(!0);
          const ye = (await B.fpClient.mf_investment_accounts().fetchAll({
            investor: a ? i : r.pan
          })).data.filter((he) => he.primary_investor === r.id);
          if (!ye.length) {
            P("no_holdings"), h(!1);
            return;
          }
          de(ye[0]);
          const Fe = await B.fpClient.investor_reports().fetchSchemewiseReturns({
            mf_investment_account: ye[0].id
          });
          if (Fe.data.rows.length === 0) {
            P("no_holdings"), h(!1);
            return;
          }
          const xe = {};
          Fe.data.columns.forEach((he, ke) => {
            xe[he] = ke;
          }), await _e(Fe, xe);
          let be;
          e && e.length ? be = fe(Fe.data.rows, xe) : be = Fe.data.rows, z(xe), s(be), M({
            index: 0,
            isin: be[0][xe.isin],
            name: be[0][xe.scheme_name]
          }), h(!1);
        } catch (se) {
          window.debug.error(se), h(!1), P("no_holdings"), W5(se);
        }
    }
    Z();
  }, [
    fe,
    B,
    r,
    e
  ]);
  async function _e(Z, se) {
    var be;
    const ye = {}, Fe = (be = Z.data.rows) == null ? void 0 : be.map((he) => he[se.isin]), xe = [];
    Fe.forEach((he) => {
      const ke = B.fpClient.master_data().fetchScheme(he);
      xe.push(ke);
    }), Promise.all(xe).then((he) => {
      he.forEach((ke) => {
        ye[ke.isin] = {
          ...ke
        };
      }), ee(ye);
    }).catch((he) => {
      window.debug.error(he), h(!1), W5(he);
    });
  }
  async function Re() {
    var Z, se, ye, Fe;
    try {
      R(!0);
      const xe = await B.fpClient.investor_reports().fetchHoldings({
        investment_account_id: ve.old_id
      }), be = await B.fpClient.other_reports().transaction_list({
        pan_number: a ? i : r.pan
      });
      let he, ke;
      ve.folio_defaults.communication_email_address && (he = await B.fpClient.email_addresses().fetch(ve.folio_defaults.communication_email_address)), ve.folio_defaults.communication_mobile_number && (ke = await B.fpClient.phone_numbers().fetch(ve.folio_defaults.communication_mobile_number)), (Z = xe == null ? void 0 : xe.folios) == null || Z.forEach((_t) => {
        _t.schemes.forEach((S) => {
          const b = o.find((w) => w[G.isin] === S.isin);
          b && (S.plan = b[G.plan_type]);
        });
      });
      let De = q == null ? void 0 : q.logo;
      (De == null ? void 0 : De.split(".").pop()) === "svg" && (De = await Bae(De));
      const Qe = await Zg(/* @__PURE__ */ We.jsx(Pae, {
        investorProfile: r,
        holdings: xe,
        transactions: be,
        phone: ke,
        email: he,
        dematAccount: ve.folio_defaults.demat_account,
        tenant: {
          name: (se = q == null ? void 0 : q.fp) == null ? void 0 : se.tenant,
          logo: De,
          email: (ye = q == null ? void 0 : q.contact_info) == null ? void 0 : ye.mail_us
        }
      })).toBlob(), ct = URL.createObjectURL(Qe), pt = document.createElement("a");
      document.body.appendChild(pt), pt.href = ct, pt.setAttribute("download", "Account_Statement_" + ((Fe = Qf(/* @__PURE__ */ new Date(), "dd-MMM-yyyy")) == null ? void 0 : Fe.replaceAll("-", "_"))), pt.click(), URL.revokeObjectURL(ct), R(!1);
    } catch (xe) {
      window.debug.error(xe), R(!1), J("Error while downloading PDF"), W5(xe);
    }
  }
  function Ie() {
    return /* @__PURE__ */ We.jsxs(We.Fragment, {
      children: [
        /* @__PURE__ */ We.jsx(kT, {
          type: "text",
          text: me
        }),
        /* @__PURE__ */ We.jsx("div", {
          className: "mb-28",
          children: /* @__PURE__ */ We.jsx(ST, {
            onChange: (Z) => {
              M({
                index: Number(Z.target.value),
                isin: o[Number(Z.target.value)][G.isin],
                name: o[Number(Z.target.value)][G.scheme_name]
              });
            },
            variant: "selectable",
            selected: N.index,
            children: o.length ? o == null ? void 0 : o.map((Z) => /* @__PURE__ */ We.jsx(CT, {
              children: /* @__PURE__ */ We.jsxs("div", {
                className: "-mr-2 -ml-2 flex flex-wrap",
                children: [
                  /* @__PURE__ */ We.jsx("div", {
                    className: "mb-3 w-full pr-2 pl-2",
                    children: /* @__PURE__ */ We.jsx(Jl, {
                      label: _n._({
                        id: "XTJZw8"
                      }),
                      value: Cw(Z[G.scheme_name]),
                      logo: ne && K ? H[K[Z[G.isin]].amc_id] || oe : ""
                    })
                  }),
                  /* @__PURE__ */ We.jsx("div", {
                    className: "mb-3 basis-1/2 pr-2 pl-2",
                    children: /* @__PURE__ */ We.jsx(Jl, {
                      label: _n._({
                        id: "FsNpOH"
                      }),
                      value: gh(Z[G.plan_type])
                    })
                  }),
                  /* @__PURE__ */ We.jsx("div", {
                    className: "mb-3 basis-1/2 pr-2 pl-2",
                    children: /* @__PURE__ */ We.jsx(Jl, {
                      label: _n._({
                        id: "fezFD7"
                      }),
                      value: Fw(Z[G.investment_option])
                    })
                  }),
                  /* @__PURE__ */ We.jsx("div", {
                    className: "mb-3 basis-1/2 pr-2 pl-2",
                    children: /* @__PURE__ */ We.jsx(Jl, {
                      label: _n._({
                        id: "ez01Pf"
                      }),
                      value: `₹ ${Vu(Z[G.invested_amount], 2)}`
                    })
                  }),
                  /* @__PURE__ */ We.jsx("div", {
                    className: "mb-3 basis-1/2 pr-2 pl-2",
                    children: /* @__PURE__ */ We.jsx(Jl, {
                      label: _n._({
                        id: "S0BC0N"
                      }),
                      value: `₹ ${Vu(Z[G.current_value], 2)}`
                    })
                  }),
                  /* @__PURE__ */ We.jsx("div", {
                    className: "mb-3 basis-1/2 pr-2 pl-2",
                    children: /* @__PURE__ */ We.jsx(Jl, {
                      label: _n._({
                        id: "/glBYd",
                        values: {
                          0: Qf(new Date(Z[G.as_on]), "dd-MMM-yyyy")
                        }
                      }),
                      value: `₹ ${Vu(Z[G.nav], 2)}`
                    })
                  })
                ]
              })
            }, Z[G.isin])) : /* @__PURE__ */ We.jsx(We.Fragment, {})
          })
        }),
        /* @__PURE__ */ We.jsxs(FT, {
          children: [
            /* @__PURE__ */ We.jsxs("div", {
              children: [
                t ? /* @__PURE__ */ We.jsx("div", {
                  className: "mb-4",
                  children: /* @__PURE__ */ We.jsx(T2, {
                    variant: "secondary",
                    fullwidth: !0,
                    onClick: (Z) => {
                      Z.preventDefault(), g(!d);
                    },
                    children: _n._({
                      id: "WuFWzy"
                    })
                  })
                }) : /* @__PURE__ */ We.jsx(We.Fragment, {}),
                n ? /* @__PURE__ */ We.jsx("div", {
                  className: "mb-4",
                  children: /* @__PURE__ */ We.jsx(T2, {
                    variant: o.length ? "primary" : "disabled",
                    fullwidth: !0,
                    onClick: (Z) => {
                      Z.preventDefault(), n && n(N.isin);
                    },
                    children: _n._({
                      id: "BSt4IA"
                    })
                  })
                }) : /* @__PURE__ */ We.jsx(We.Fragment, {})
              ]
            }),
            !n && !t && /* @__PURE__ */ We.jsxs(We.Fragment, {
              children: [
                /* @__PURE__ */ We.jsx(T2, {
                  variant: "secondary",
                  fullwidth: !0,
                  size: "sm",
                  customClass: "mb-2",
                  onClick: (Z) => {
                    Z.preventDefault(), _(!x);
                  },
                  children: _n._({
                    id: "orjHHu"
                  })
                }),
                /* @__PURE__ */ We.jsx(T2, {
                  variant: j ? "disabled" : "secondary",
                  fullwidth: !0,
                  size: "sm",
                  onClick: (Z) => {
                    Z.preventDefault(), Re();
                  },
                  children: j ? _n._({
                    id: "aJkwGC"
                  }) : _n._({
                    id: "NHm10F"
                  })
                }),
                te && /* @__PURE__ */ We.jsx(OT, {
                  type: "error",
                  variant: "field",
                  title: te
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ We.jsx(Xg, {
          customClass: "md:max-w-29",
          variant: "fullPage",
          title: _n._({
            id: "LGPl6N"
          }),
          isOpen: d,
          toggleModal: g,
          contentHeightMax: !1,
          children: /* @__PURE__ */ We.jsx(Kg, {
            investorProfile: r,
            scheme_details: {
              isin: N.isin,
              name: N.name
            },
            handleFolioSelection: (Z) => {
              g(!d), t && t(N.isin, Z);
            },
            isPartner: a,
            assistedWorkflowPAN: i
          })
        }),
        /* @__PURE__ */ We.jsx(Xg, {
          customClass: "md:max-w-29",
          variant: "fullPage",
          title: _n._({
            id: "Isc++9"
          }),
          isOpen: x,
          toggleModal: _,
          contentHeightMax: !0,
          children: /* @__PURE__ */ We.jsx(Kg, {
            investorProfile: r,
            scheme_details: {
              isin: N.isin,
              name: N.name
            },
            allSelectable: !0,
            description: "Scheme and folio wise summary of your investment",
            isPartner: a,
            assistedWorkflowPAN: i
          })
        })
      ]
    });
  }
  function W() {
    switch (k) {
      case "initial":
        return Ie();
      case "no_holdings":
        return /* @__PURE__ */ We.jsx("div", {
          className: "pt-5",
          children: /* @__PURE__ */ We.jsx(LT, {
            title: _n._({
              id: "fS3evk"
            }),
            description: _n._({
              id: "u5PZHP"
            })
          })
        });
      default:
        return Ie();
    }
  }
  return /* @__PURE__ */ We.jsx(We.Fragment, {
    children: c ? /* @__PURE__ */ We.jsx(TT, {
      variant: "fullpage"
    }) : /* @__PURE__ */ We.jsx(We.Fragment, {
      children: W()
    })
  });
}
export {
  Zae as H
};
